var lZ = Object.defineProperty;
var uZ = (e, t, n) => t in e ? lZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var pe = (e, t, n) => (uZ(e, typeof t != "symbol" ? t + "" : t, n), n), b3 = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
};
var C = (e, t, n) => (b3(e, t, "read from private field"), n ? n.call(e) : t.get(e)), re = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, j = (e, t, n, r) => (b3(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
var Rc = (e, t, n, r) => ({
  set _(i) {
    j(e, t, i, n);
  },
  get _() {
    return C(e, t, r);
  }
}), Se = (e, t, n) => (b3(e, t, "access private method"), n);
import * as ye from "react";
import k, { useRef as Le, useEffect as We, createContext as dn, createElement as Hg, useContext as $e, useSyncExternalStore as ev, useState as qe, useMemo as ot, useCallback as Ie, useReducer as Ak, Fragment as Xd, forwardRef as Bc, useLayoutEffect as _f, useInsertionEffect as bF, useId as mu, Component as dZ, cloneElement as rm, Children as Ek, isValidElement as _k, memo as fZ, PureComponent as hZ, useDebugValue as Xc, useImperativeHandle as pZ } from "react";
import { createPortal as AA, unstable_batchedUpdates as mZ } from "react-dom";
import { useConnectModal as gZ, useAccounts as yZ, ConnectProvider as bZ } from "@particle-network/btc-connectkit";
var im = typeof globalThis < "u" ? globalThis : typeof window < "u" || typeof window < "u" ? window : typeof self < "u" ? self : {};
function Sk(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vZ(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var vF = { exports: {} }, f0 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VB;
function wZ() {
  if (VB)
    return f0;
  VB = 1;
  var e = k, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, c, l) {
    var u, d = {}, f = null, p = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (u in c)
      r.call(c, u) && !s.hasOwnProperty(u) && (d[u] = c[u]);
    if (a && a.defaultProps)
      for (u in c = a.defaultProps, c)
        d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: t, type: a, key: f, ref: p, props: d, _owner: i.current };
  }
  return f0.Fragment = n, f0.jsx = o, f0.jsxs = o, f0;
}
vF.exports = wZ();
var D = vF.exports;
const xZ = "2.10.2", AZ = (e) => e, wF = (e) => e, EZ = () => `viem@${xZ}`;
let ze = class W6 extends Error {
  constructor(t, n = {}) {
    var s;
    super(), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ViemError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: EZ()
    });
    const r = n.cause instanceof W6 ? n.cause.details : (s = n.cause) != null && s.message ? n.cause.message : n.details, i = n.cause instanceof W6 && n.cause.docsPath || n.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [
        `Docs: https://viem.sh${i}${n.docsSlug ? `#${n.docsSlug}` : ""}`
      ] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${this.version}`
    ].join(`
`), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return xF(this, t);
  }
};
function xF(e, t) {
  return t != null && t(e) ? e : e && typeof e == "object" && "cause" in e ? xF(e.cause, t) : t ? null : e;
}
class _Z extends ze {
  constructor({ max: t, min: n, signed: r, size: i, value: s }) {
    super(`Number "${s}" is not in safe ${i ? `${i * 8}-bit ${r ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${n} to ${t})` : `(above ${n})`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntegerOutOfRangeError"
    });
  }
}
class SZ extends ze {
  constructor(t) {
    super(`Bytes value "${t}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidBytesBooleanError"
    });
  }
}
class CZ extends ze {
  constructor({ givenSize: t, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${t} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeOverflowError"
    });
  }
}
class AF extends ze {
  constructor({ offset: t, position: n, size: r }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset "${t}" is out-of-bounds (size: ${r}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SliceOffsetOutOfBoundsError"
    });
  }
}
class EF extends ze {
  constructor({ size: t, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (${t}) exceeds padding size (${n}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeExceedsPaddingSizeError"
    });
  }
}
class HB extends ze {
  constructor({ size: t, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} is expected to be ${n} ${r} long, but is ${t} ${r} long.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidBytesLengthError"
    });
  }
}
function qm(e, { dir: t, size: n = 32 } = {}) {
  return typeof e == "string" ? Vl(e, { dir: t, size: n }) : TZ(e, { dir: t, size: n });
}
function Vl(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  const r = e.replace("0x", "");
  if (r.length > n * 2)
    throw new EF({
      size: Math.ceil(r.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${r[t === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function TZ(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  if (e.length > n)
    throw new EF({
      size: e.length,
      targetSize: n,
      type: "bytes"
    });
  const r = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    const s = t === "right";
    r[s ? i : n - i - 1] = e[s ? i : e.length - i - 1];
  }
  return r;
}
function ya(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function Zn(e) {
  return ya(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function $m(e, { dir: t = "left" } = {}) {
  let n = typeof e == "string" ? e.replace("0x", "") : e, r = 0;
  for (let i = 0; i < n.length - 1 && n[t === "left" ? i : n.length - i - 1].toString() === "0"; i++)
    r++;
  return n = t === "left" ? n.slice(r) : n.slice(0, n.length - r), typeof e == "string" ? (n.length === 1 && t === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
const kZ = /* @__PURE__ */ new TextEncoder();
function Yl(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? IZ(e, t) : typeof e == "boolean" ? BZ(e, t) : ya(e) ? Zl(e, t) : uc(e, t);
}
function BZ(e, t = {}) {
  const n = new Uint8Array(1);
  return n[0] = Number(e), typeof t.size == "number" ? (wo(n, { size: t.size }), qm(n, { size: t.size })) : n;
}
const Ia = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function WB(e) {
  if (e >= Ia.zero && e <= Ia.nine)
    return e - Ia.zero;
  if (e >= Ia.A && e <= Ia.F)
    return e - (Ia.A - 10);
  if (e >= Ia.a && e <= Ia.f)
    return e - (Ia.a - 10);
}
function Zl(e, t = {}) {
  let n = e;
  t.size && (wo(n, { size: t.size }), n = qm(n, { dir: "right", size: t.size }));
  let r = n.slice(2);
  r.length % 2 && (r = `0${r}`);
  const i = r.length / 2, s = new Uint8Array(i);
  for (let o = 0, a = 0; o < i; o++) {
    const c = WB(r.charCodeAt(a++)), l = WB(r.charCodeAt(a++));
    if (c === void 0 || l === void 0)
      throw new ze(`Invalid byte sequence ("${r[a - 2]}${r[a - 1]}" in "${r}").`);
    s[o] = c * 16 + l;
  }
  return s;
}
function IZ(e, t) {
  const n = Tt(e, t);
  return Zl(n);
}
function uc(e, t = {}) {
  const n = kZ.encode(e);
  return typeof t.size == "number" ? (wo(n, { size: t.size }), qm(n, { dir: "right", size: t.size })) : n;
}
function wo(e, { size: t }) {
  if (Zn(e) > t)
    throw new CZ({
      givenSize: Zn(e),
      maxSize: t
    });
}
function sm(e, t = {}) {
  const { signed: n } = t;
  t.size && wo(e, { size: t.size });
  const r = BigInt(e);
  if (!n)
    return r;
  const i = (e.length - 2) / 2, s = (1n << BigInt(i) * 8n - 1n) - 1n;
  return r <= s ? r : r - BigInt(`0x${"f".padStart(i * 2, "f")}`) - 1n;
}
function Jl(e, t = {}) {
  return Number(sm(e, t));
}
function PZ(e, t = {}) {
  let n = Zl(e);
  return t.size && (wo(n, { size: t.size }), n = $m(n, { dir: "right" })), new TextDecoder().decode(n);
}
const OZ = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function gu(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Tt(e, t) : typeof e == "string" ? Ck(e, t) : typeof e == "boolean" ? _F(e, t) : Tr(e, t);
}
function _F(e, t = {}) {
  const n = `0x${Number(e)}`;
  return typeof t.size == "number" ? (wo(n, { size: t.size }), qm(n, { size: t.size })) : n;
}
function Tr(e, t = {}) {
  let n = "";
  for (let i = 0; i < e.length; i++)
    n += OZ[e[i]];
  const r = `0x${n}`;
  return typeof t.size == "number" ? (wo(r, { size: t.size }), qm(r, { dir: "right", size: t.size })) : r;
}
function Tt(e, t = {}) {
  const { signed: n, size: r } = t, i = BigInt(e);
  let s;
  r ? n ? s = (1n << BigInt(r) * 8n - 1n) - 1n : s = 2n ** (BigInt(r) * 8n) - 1n : typeof e == "number" && (s = BigInt(Number.MAX_SAFE_INTEGER));
  const o = typeof s == "bigint" && n ? -s - 1n : 0;
  if (s && i > s || i < o) {
    const c = typeof e == "bigint" ? "n" : "";
    throw new _Z({
      max: s ? `${s}${c}` : void 0,
      min: `${o}${c}`,
      signed: n,
      size: r,
      value: `${e}${c}`
    });
  }
  const a = `0x${(n && i < 0 ? (1n << BigInt(r * 8)) + BigInt(i) : i).toString(16)}`;
  return r ? qm(a, { size: r }) : a;
}
const NZ = /* @__PURE__ */ new TextEncoder();
function Ck(e, t = {}) {
  const n = NZ.encode(e);
  return Tr(n, t);
}
function vc(e, { includeName: t = !1 } = {}) {
  if (e.type !== "function" && e.type !== "event" && e.type !== "error")
    throw new qZ(e.type);
  return `${e.name}(${EA(e.inputs, { includeName: t })})`;
}
function EA(e, { includeName: t = !1 } = {}) {
  return e ? e.map((n) => RZ(n, { includeName: t })).join(t ? ", " : ",") : "";
}
function RZ(e, { includeName: t }) {
  return e.type.startsWith("tuple") ? `(${EA(e.components, { includeName: t })})${e.type.slice(5)}` : e.type + (t && e.name ? ` ${e.name}` : "");
}
class MZ extends ze {
  constructor({ docsPath: t }) {
    super([
      "A constructor was not found on the ABI.",
      "Make sure you are using the correct ABI and that the constructor exists on it."
    ].join(`
`), {
      docsPath: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiConstructorNotFoundError"
    });
  }
}
class GB extends ze {
  constructor({ docsPath: t }) {
    super([
      "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
      "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
    ].join(`
`), {
      docsPath: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiConstructorParamsNotFoundError"
    });
  }
}
class SF extends ze {
  constructor({ data: t, params: n, size: r }) {
    super([`Data size of ${r} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${EA(n, { includeName: !0 })})`,
        `Data:   ${t} (${r} bytes)`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t, this.params = n, this.size = r;
  }
}
class _A extends ze {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.'), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiDecodingZeroDataError"
    });
  }
}
class FZ extends ze {
  constructor({ expectedLength: t, givenLength: n, type: r }) {
    super([
      `ABI encoding array length mismatch for type ${r}.`,
      `Expected length: ${t}`,
      `Given length: ${n}`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingArrayLengthMismatchError"
    });
  }
}
class jZ extends ze {
  constructor({ expectedSize: t, value: n }) {
    super(`Size of bytes "${n}" (bytes${Zn(n)}) does not match expected size (bytes${t}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingBytesSizeMismatchError"
    });
  }
}
class DZ extends ze {
  constructor({ expectedLength: t, givenLength: n }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${t}`,
      `Given length (values): ${n}`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEncodingLengthMismatchError"
    });
  }
}
class CF extends ze {
  constructor(t, { docsPath: n }) {
    super([
      `Encoded error signature "${t}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${t}.`
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiErrorSignatureNotFoundError"
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.signature = t;
  }
}
class UZ extends ze {
  constructor({ docsPath: t }) {
    super("Cannot extract event signature from empty topics.", {
      docsPath: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventSignatureEmptyTopicsError"
    });
  }
}
class TF extends ze {
  constructor(t, { docsPath: n }) {
    super([
      `Encoded event signature "${t}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it.",
      `You can look up the signature here: https://openchain.xyz/signatures?query=${t}.`
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventSignatureNotFoundError"
    });
  }
}
class qB extends ze {
  constructor(t, { docsPath: n } = {}) {
    super([
      `Event ${t ? `"${t}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the event exists on it."
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiEventNotFoundError"
    });
  }
}
class vx extends ze {
  constructor(t, { docsPath: n } = {}) {
    super([
      `Function ${t ? `"${t}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiFunctionNotFoundError"
    });
  }
}
class LZ extends ze {
  constructor(t, { docsPath: n }) {
    super([
      `Function "${t}" does not contain any \`outputs\` on ABI.`,
      "Cannot decode function result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiFunctionOutputsNotFoundError"
    });
  }
}
class zZ extends ze {
  constructor(t, n) {
    super("Found ambiguous types in overloaded ABI items.", {
      metaMessages: [
        `\`${t.type}\` in \`${vc(t.abiItem)}\`, and`,
        `\`${n.type}\` in \`${vc(n.abiItem)}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiItemAmbiguityError"
    });
  }
}
class VZ extends ze {
  constructor({ expectedSize: t, givenSize: n }) {
    super(`Expected bytes${t}, got bytes${n}.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BytesSizeMismatchError"
    });
  }
}
class Wg extends ze {
  constructor({ abiItem: t, data: n, params: r, size: i }) {
    super([
      `Data size of ${i} bytes is too small for non-indexed event parameters.`
    ].join(`
`), {
      metaMessages: [
        `Params: (${EA(r, { includeName: !0 })})`,
        `Data:   ${n} (${i} bytes)`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "DecodeLogDataMismatch"
    }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = t, this.data = n, this.params = r, this.size = i;
  }
}
class SA extends ze {
  constructor({ abiItem: t, param: n }) {
    super([
      `Expected a topic for indexed event parameter${n.name ? ` "${n.name}"` : ""} on event "${vc(t, { includeName: !0 })}".`
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "DecodeLogTopicsMismatch"
    }), Object.defineProperty(this, "abiItem", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abiItem = t;
  }
}
class HZ extends ze {
  constructor(t, { docsPath: n }) {
    super([
      `Type "${t}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiEncodingType"
    });
  }
}
class WZ extends ze {
  constructor(t, { docsPath: n }) {
    super([
      `Type "${t}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiDecodingType"
    });
  }
}
class GZ extends ze {
  constructor(t) {
    super([`Value "${t}" is not a valid array.`].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidArrayError"
    });
  }
}
class qZ extends ze {
  constructor(t) {
    super([
      `"${t}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidDefinitionTypeError"
    });
  }
}
function wc(e) {
  return typeof e[0] == "string" ? Tk(e) : $Z(e);
}
function $Z(e) {
  let t = 0;
  for (const i of e)
    t += i.length;
  const n = new Uint8Array(t);
  let r = 0;
  for (const i of e)
    n.set(i, r), r += i.length;
  return n;
}
function Tk(e) {
  return `0x${e.reduce((t, n) => t + n.replace("0x", ""), "")}`;
}
class om extends ze {
  constructor({ address: t }) {
    super(`Address "${t}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAddressError"
    });
  }
}
class QZ extends Map {
  constructor(t) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = t;
  }
  set(t, n) {
    return super.set(t, n), this.maxSize && this.size > this.maxSize && this.delete(this.keys().next().value), this;
  }
}
function wx(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function kk(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function KZ(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  wx(e.outputLen), wx(e.blockLen);
}
function am(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function kF(e, t) {
  kk(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Gv = /* @__PURE__ */ BigInt(2 ** 32 - 1), $B = /* @__PURE__ */ BigInt(32);
function YZ(e, t = !1) {
  return t ? { h: Number(e & Gv), l: Number(e >> $B & Gv) } : { h: Number(e >> $B & Gv) | 0, l: Number(e & Gv) | 0 };
}
function ZZ(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: s, l: o } = YZ(e[i], t);
    [n[i], r[i]] = [s, o];
  }
  return [n, r];
}
const JZ = (e, t, n) => e << n | t >>> 32 - n, XZ = (e, t, n) => t << n | e >>> 32 - n, eJ = (e, t, n) => t << n - 32 | e >>> 64 - n, tJ = (e, t, n) => e << n - 32 | t >>> 64 - n, v3 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const BF = (e) => e instanceof Uint8Array, nJ = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), w3 = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), ko = (e, t) => e << 32 - t | e >>> t, rJ = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!rJ)
  throw new Error("Non little-endian hardware is not supported");
function iJ(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function CA(e) {
  if (typeof e == "string" && (e = iJ(e)), !BF(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
function sJ(...e) {
  const t = new Uint8Array(e.reduce((r, i) => r + i.length, 0));
  let n = 0;
  return e.forEach((r) => {
    if (!BF(r))
      throw new Error("Uint8Array expected");
    t.set(r, n), n += r.length;
  }), t;
}
let Bk = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function IF(e) {
  const t = (r) => e().update(CA(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
function oJ(e = 32) {
  if (v3 && typeof v3.getRandomValues == "function")
    return v3.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
const [PF, OF, NF] = [[], [], []], aJ = /* @__PURE__ */ BigInt(0), h0 = /* @__PURE__ */ BigInt(1), cJ = /* @__PURE__ */ BigInt(2), lJ = /* @__PURE__ */ BigInt(7), uJ = /* @__PURE__ */ BigInt(256), dJ = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = h0, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], PF.push(2 * (5 * r + n)), OF.push((e + 1) * (e + 2) / 2 % 64);
  let i = aJ;
  for (let s = 0; s < 7; s++)
    t = (t << h0 ^ (t >> lJ) * dJ) % uJ, t & cJ && (i ^= h0 << (h0 << /* @__PURE__ */ BigInt(s)) - h0);
  NF.push(i);
}
const [fJ, hJ] = /* @__PURE__ */ ZZ(NF, !0), QB = (e, t, n) => n > 32 ? eJ(e, t, n) : JZ(e, t, n), KB = (e, t, n) => n > 32 ? tJ(e, t, n) : XZ(e, t, n);
function pJ(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      n[o] = e[o] ^ e[o + 10] ^ e[o + 20] ^ e[o + 30] ^ e[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const a = (o + 8) % 10, c = (o + 2) % 10, l = n[c], u = n[c + 1], d = QB(l, u, 1) ^ n[a], f = KB(l, u, 1) ^ n[a + 1];
      for (let p = 0; p < 50; p += 10)
        e[o + p] ^= d, e[o + p + 1] ^= f;
    }
    let i = e[2], s = e[3];
    for (let o = 0; o < 24; o++) {
      const a = OF[o], c = QB(i, s, a), l = KB(i, s, a), u = PF[o];
      i = e[u], s = e[u + 1], e[u] = c, e[u + 1] = l;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let a = 0; a < 10; a++)
        n[a] = e[o + a];
      for (let a = 0; a < 10; a++)
        e[o + a] ^= ~n[(a + 2) % 10] & n[(a + 4) % 10];
    }
    e[0] ^= fJ[r], e[1] ^= hJ[r];
  }
  n.fill(0);
}
let mJ = class RF extends Bk {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, i = !1, s = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, wx(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = nJ(this.state);
  }
  keccak() {
    pJ(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    am(this);
    const { blockLen: n, state: r } = this;
    t = CA(t);
    const i = t.length;
    for (let s = 0; s < i; ) {
      const o = Math.min(n - this.pos, i - s);
      for (let a = 0; a < o; a++)
        r[this.pos++] ^= t[s++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: i } = this;
    t[r] ^= n, n & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    am(this, !1), kk(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, s = t.length; i < s; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, s - i);
      t.set(n.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return wx(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (kF(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: s, enableXOF: o } = this;
    return t || (t = new RF(n, r, i, o, s)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = s, t.suffix = r, t.outputLen = i, t.enableXOF = o, t.destroyed = this.destroyed, t;
  }
};
const gJ = (e, t, n) => IF(() => new mJ(t, e, n)), yJ = /* @__PURE__ */ gJ(1, 136, 256 / 8);
function ki(e, t) {
  const n = t || "hex", r = yJ(ya(e, { strict: !1 }) ? Yl(e) : e);
  return n === "bytes" ? r : gu(r);
}
function Ik(e, t) {
  const n = e.substring(2).toLowerCase(), r = ki(uc(n), "bytes"), i = n.split("");
  for (let s = 0; s < 40; s += 2)
    r[s >> 1] >> 4 >= 8 && i[s] && (i[s] = i[s].toUpperCase()), (r[s >> 1] & 15) >= 8 && i[s + 1] && (i[s + 1] = i[s + 1].toUpperCase());
  return `0x${i.join("")}`;
}
function j0(e, t) {
  if (!xc(e, { strict: !1 }))
    throw new om({ address: e });
  return Ik(e);
}
const bJ = /^0x[a-fA-F0-9]{40}$/, x3 = /* @__PURE__ */ new QZ(8192);
function xc(e, t) {
  const { strict: n = !0 } = t ?? {};
  if (x3.has(e))
    return x3.get(e);
  const r = bJ.test(e) ? e.toLowerCase() === e ? !0 : n ? Ik(e) === e : !0 : !1;
  return x3.set(e, r), r;
}
function xx(e, t, n, { strict: r } = {}) {
  return ya(e, { strict: !1 }) ? vJ(e, t, n, {
    strict: r
  }) : jF(e, t, n, {
    strict: r
  });
}
function MF(e, t) {
  if (typeof t == "number" && t > 0 && t > Zn(e) - 1)
    throw new AF({
      offset: t,
      position: "start",
      size: Zn(e)
    });
}
function FF(e, t, n) {
  if (typeof t == "number" && typeof n == "number" && Zn(e) !== n - t)
    throw new AF({
      offset: n,
      position: "end",
      size: Zn(e)
    });
}
function jF(e, t, n, { strict: r } = {}) {
  MF(e, t);
  const i = e.slice(t, n);
  return r && FF(i, t, n), i;
}
function vJ(e, t, n, { strict: r } = {}) {
  MF(e, t);
  const i = `0x${e.replace("0x", "").slice((t ?? 0) * 2, (n ?? e.length) * 2)}`;
  return r && FF(i, t, n), i;
}
function tv(e, t) {
  if (e.length !== t.length)
    throw new DZ({
      expectedLength: e.length,
      givenLength: t.length
    });
  const n = wJ({
    params: e,
    values: t
  }), r = Ok(n);
  return r.length === 0 ? "0x" : r;
}
function wJ({ params: e, values: t }) {
  const n = [];
  for (let r = 0; r < e.length; r++)
    n.push(Pk({ param: e[r], value: t[r] }));
  return n;
}
function Pk({ param: e, value: t }) {
  const n = Nk(e.type);
  if (n) {
    const [r, i] = n;
    return AJ(t, { length: r, param: { ...e, type: i } });
  }
  if (e.type === "tuple")
    return TJ(t, {
      param: e
    });
  if (e.type === "address")
    return xJ(t);
  if (e.type === "bool")
    return _J(t);
  if (e.type.startsWith("uint") || e.type.startsWith("int")) {
    const r = e.type.startsWith("int");
    return SJ(t, { signed: r });
  }
  if (e.type.startsWith("bytes"))
    return EJ(t, { param: e });
  if (e.type === "string")
    return CJ(t);
  throw new HZ(e.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function Ok(e) {
  let t = 0;
  for (let s = 0; s < e.length; s++) {
    const { dynamic: o, encoded: a } = e[s];
    o ? t += 32 : t += Zn(a);
  }
  const n = [], r = [];
  let i = 0;
  for (let s = 0; s < e.length; s++) {
    const { dynamic: o, encoded: a } = e[s];
    o ? (n.push(Tt(t + i, { size: 32 })), r.push(a), i += Zn(a)) : n.push(a);
  }
  return wc([...n, ...r]);
}
function xJ(e) {
  if (!xc(e))
    throw new om({ address: e });
  return { dynamic: !1, encoded: Vl(e.toLowerCase()) };
}
function AJ(e, { length: t, param: n }) {
  const r = t === null;
  if (!Array.isArray(e))
    throw new GZ(e);
  if (!r && e.length !== t)
    throw new FZ({
      expectedLength: t,
      givenLength: e.length,
      type: `${n.type}[${t}]`
    });
  let i = !1;
  const s = [];
  for (let o = 0; o < e.length; o++) {
    const a = Pk({ param: n, value: e[o] });
    a.dynamic && (i = !0), s.push(a);
  }
  if (r || i) {
    const o = Ok(s);
    if (r) {
      const a = Tt(s.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: s.length > 0 ? wc([a, o]) : a
      };
    }
    if (i)
      return { dynamic: !0, encoded: o };
  }
  return {
    dynamic: !1,
    encoded: wc(s.map(({ encoded: o }) => o))
  };
}
function EJ(e, { param: t }) {
  const [, n] = t.type.split("bytes"), r = Zn(e);
  if (!n) {
    let i = e;
    return r % 32 !== 0 && (i = Vl(i, {
      dir: "right",
      size: Math.ceil((e.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: wc([Vl(Tt(r, { size: 32 })), i])
    };
  }
  if (r !== parseInt(n))
    throw new jZ({
      expectedSize: parseInt(n),
      value: e
    });
  return { dynamic: !1, encoded: Vl(e, { dir: "right" }) };
}
function _J(e) {
  if (typeof e != "boolean")
    throw new ze(`Invalid boolean value: "${e}" (type: ${typeof e}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: Vl(_F(e)) };
}
function SJ(e, { signed: t }) {
  return {
    dynamic: !1,
    encoded: Tt(e, {
      size: 32,
      signed: t
    })
  };
}
function CJ(e) {
  const t = Ck(e), n = Math.ceil(Zn(t) / 32), r = [];
  for (let i = 0; i < n; i++)
    r.push(Vl(xx(t, i * 32, (i + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: wc([
      Vl(Tt(Zn(t), { size: 32 })),
      ...r
    ])
  };
}
function TJ(e, { param: t }) {
  let n = !1;
  const r = [];
  for (let i = 0; i < t.components.length; i++) {
    const s = t.components[i], o = Array.isArray(e) ? i : s.name, a = Pk({
      param: s,
      value: e[o]
    });
    r.push(a), a.dynamic && (n = !0);
  }
  return {
    dynamic: n,
    encoded: n ? Ok(r) : wc(r.map(({ encoded: i }) => i))
  };
}
function Nk(e) {
  const t = e.match(/^(.*)\[(\d+)?\]$/);
  return t ? (
    // Return `null` if the array is dynamic.
    [t[2] ? Number(t[2]) : null, t[1]]
  ) : void 0;
}
const A3 = "/docs/contract/encodeDeployData";
function kJ(e) {
  const { abi: t, args: n, bytecode: r } = e;
  if (!n || n.length === 0)
    return r;
  const i = t.find((o) => "type" in o && o.type === "constructor");
  if (!i)
    throw new MZ({ docsPath: A3 });
  if (!("inputs" in i))
    throw new GB({ docsPath: A3 });
  if (!i.inputs || i.inputs.length === 0)
    throw new GB({ docsPath: A3 });
  const s = tv(i.inputs, n);
  return Tk([r, s]);
}
function Ea(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
class BJ extends ze {
  constructor({ docsPath: t } = {}) {
    super([
      "Could not find an Account to execute with this Action.",
      "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient."
    ].join(`
`), {
      docsPath: t,
      docsSlug: "account"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AccountNotFoundError"
    });
  }
}
class G6 extends ze {
  constructor({ blockNumber: t, chain: n, contract: r }) {
    super(`Chain "${n.name}" does not support contract "${r.name}".`, {
      metaMessages: [
        "This could be due to any of the following:",
        ...t && r.blockCreated && r.blockCreated > t ? [
          `- The contract "${r.name}" was not deployed until block ${r.blockCreated} (current block ${t}).`
        ] : [
          `- The chain does not have the contract "${r.name}" configured.`
        ]
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainDoesNotSupportContract"
    });
  }
}
class DF extends ze {
  constructor() {
    super("No chain was provided to the Client."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ClientChainNotConfiguredError"
    });
  }
}
const IJ = {
  gwei: 9,
  wei: 18
}, PJ = {
  ether: -9,
  wei: 9
}, OJ = {
  ether: -18,
  gwei: -9
};
function TA(e, t) {
  let n = e.toString();
  const r = n.startsWith("-");
  r && (n = n.slice(1)), n = n.padStart(t, "0");
  let [i, s] = [
    n.slice(0, n.length - t),
    n.slice(n.length - t)
  ];
  return s = s.replace(/(0+)$/, ""), `${r ? "-" : ""}${i || "0"}${s ? `.${s}` : ""}`;
}
function lo(e, t = "wei") {
  return TA(e, PJ[t]);
}
class mh extends ze {
  constructor({ cause: t, message: n } = {}) {
    var i;
    const r = (i = n == null ? void 0 : n.replace("execution reverted: ", "")) == null ? void 0 : i.replace("execution reverted", "");
    super(`Execution reverted ${r ? `with reason: ${r}` : "for an unknown reason"}.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(mh, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(mh, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class Ax extends ze {
  constructor({ cause: t, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${lo(n)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooHigh"
    });
  }
}
Object.defineProperty(Ax, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class q6 extends ze {
  constructor({ cause: t, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${lo(n)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooLow"
    });
  }
}
Object.defineProperty(q6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $6 extends ze {
  constructor({ cause: t, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}is higher than the next one expected.`, { cause: t }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceTooHighError"
    });
  }
}
Object.defineProperty($6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class Q6 extends ze {
  constructor({ cause: t, nonce: n } = {}) {
    super([
      `Nonce provided for the transaction ${n ? `(${n}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: t }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceTooLowError"
    });
  }
}
Object.defineProperty(Q6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class K6 extends ze {
  constructor({ cause: t, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}exceeds the maximum allowed nonce.`, { cause: t }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NonceMaxValueError"
    });
  }
}
Object.defineProperty(K6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class Y6 extends ze {
  constructor({ cause: t } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: t,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(Y6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds/
});
class Z6 extends ze {
  constructor({ cause: t, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(Z6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class J6 extends ze {
  constructor({ cause: t, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction is too low.`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(J6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class X6 extends ze {
  constructor({ cause: t }) {
    super("The transaction type is not supported for this chain.", {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(X6, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class Ex extends ze {
  constructor({ cause: t, maxPriorityFeePerGas: n, maxFeePerGas: r } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${n ? ` = ${lo(n)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${r ? ` = ${lo(r)} gwei` : ""}).`
    ].join(`
`), {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(Ex, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class Rk extends ze {
  constructor({ cause: t }) {
    super(`An error occurred while executing: ${t == null ? void 0 : t.shortMessage}`, {
      cause: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownNodeError"
    });
  }
}
function UF(e, t = "wei") {
  return TA(e, IJ[t]);
}
function kA(e) {
  const t = Object.entries(e).map(([r, i]) => i === void 0 || i === !1 ? null : [r, i]).filter(Boolean), n = t.reduce((r, [i]) => Math.max(r, i.length), 0);
  return t.map(([r, i]) => `  ${`${r}:`.padEnd(n + 1)}  ${i}`).join(`
`);
}
class NJ extends ze {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`)), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeConflictError"
    });
  }
}
class RJ extends ze {
  constructor({ transaction: t }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        kA(t),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- a Legacy Transaction with `gasPrice`"
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSerializableTransactionError"
    });
  }
}
class LF extends ze {
  constructor({ blockHash: t, blockNumber: n, blockTag: r, hash: i, index: s }) {
    let o = "Transaction";
    r && s !== void 0 && (o = `Transaction at block time "${r}" at index "${s}"`), t && s !== void 0 && (o = `Transaction at block hash "${t}" at index "${s}"`), n && s !== void 0 && (o = `Transaction at block number "${n}" at index "${s}"`), i && (o = `Transaction with hash "${i}"`), super(`${o} could not be found.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionNotFoundError"
    });
  }
}
class zF extends ze {
  constructor({ hash: t }) {
    super(`Transaction receipt with hash "${t}" could not be found. The Transaction may not be processed on a block yet.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionReceiptNotFoundError"
    });
  }
}
class MJ extends ze {
  constructor({ hash: t }) {
    super(`Timed out while waiting for transaction with hash "${t}" to be confirmed.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WaitForTransactionReceiptTimeoutError"
    });
  }
}
const po = (e, t, n) => JSON.stringify(e, (r, i) => typeof i == "bigint" ? i.toString() : i, n);
class VF extends ze {
  constructor({ body: t, details: n, headers: r, status: i, url: s }) {
    super("HTTP request failed.", {
      details: n,
      metaMessages: [
        i && `Status: ${i}`,
        `URL: ${wF(s)}`,
        t && `Request body: ${po(t)}`
      ].filter(Boolean)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = t, this.headers = r, this.status = i, this.url = s;
  }
}
class FJ extends ze {
  constructor({ body: t, error: n, url: r }) {
    super("RPC Request failed.", {
      cause: n,
      details: n.message,
      metaMessages: [`URL: ${wF(r)}`, `Request body: ${po(t)}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = n.code;
  }
}
const jJ = -1;
let ji = class extends ze {
  constructor(t, { code: n, docsPath: r, metaMessages: i, shortMessage: s }) {
    super(s, {
      cause: t,
      docsPath: r,
      metaMessages: i || (t == null ? void 0 : t.metaMessages)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = t.name, this.code = t instanceof FJ ? t.code : n ?? jJ;
  }
};
class Qm extends ji {
  constructor(t, n) {
    super(t, n), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderRpcError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = n.data;
  }
}
class Gg extends ji {
  constructor(t) {
    super(t, {
      code: Gg.code,
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ParseRpcError"
    });
  }
}
Object.defineProperty(Gg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class qg extends ji {
  constructor(t) {
    super(t, {
      code: qg.code,
      shortMessage: "JSON is not a valid request object."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidRequestRpcError"
    });
  }
}
Object.defineProperty(qg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class $g extends ji {
  constructor(t) {
    super(t, {
      code: $g.code,
      shortMessage: "The method does not exist / is not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotFoundRpcError"
    });
  }
}
Object.defineProperty($g, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class Qg extends ji {
  constructor(t) {
    super(t, {
      code: Qg.code,
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParamsRpcError"
    });
  }
}
Object.defineProperty(Qg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class ef extends ji {
  constructor(t) {
    super(t, {
      code: ef.code,
      shortMessage: "An internal error was received."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InternalRpcError"
    });
  }
}
Object.defineProperty(ef, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class tf extends ji {
  constructor(t) {
    super(t, {
      code: tf.code,
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidInputRpcError"
    });
  }
}
Object.defineProperty(tf, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class Kg extends ji {
  constructor(t) {
    super(t, {
      code: Kg.code,
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(Kg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class Hl extends ji {
  constructor(t) {
    super(t, {
      code: Hl.code,
      shortMessage: "Requested resource not available."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceUnavailableRpcError"
    });
  }
}
Object.defineProperty(Hl, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class Yg extends ji {
  constructor(t) {
    super(t, {
      code: Yg.code,
      shortMessage: "Transaction creation failed."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TransactionRejectedRpcError"
    });
  }
}
Object.defineProperty(Yg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class Zg extends ji {
  constructor(t) {
    super(t, {
      code: Zg.code,
      shortMessage: "Method is not implemented."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MethodNotSupportedRpcError"
    });
  }
}
Object.defineProperty(Zg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class cm extends ji {
  constructor(t) {
    super(t, {
      code: cm.code,
      shortMessage: "Request exceeds defined limit."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "LimitExceededRpcError"
    });
  }
}
Object.defineProperty(cm, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class Jg extends ji {
  constructor(t) {
    super(t, {
      code: Jg.code,
      shortMessage: "Version of JSON-RPC protocol is not supported."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "JsonRpcVersionUnsupportedError"
    });
  }
}
Object.defineProperty(Jg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class Lr extends Qm {
  constructor(t) {
    super(t, {
      code: Lr.code,
      shortMessage: "User rejected the request."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UserRejectedRequestError"
    });
  }
}
Object.defineProperty(Lr, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class Xg extends Qm {
  constructor(t) {
    super(t, {
      code: Xg.code,
      shortMessage: "The requested method and/or account has not been authorized by the user."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnauthorizedProviderError"
    });
  }
}
Object.defineProperty(Xg, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class ey extends Qm {
  constructor(t) {
    super(t, {
      code: ey.code,
      shortMessage: "The Provider does not support the requested method."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnsupportedProviderMethodError"
    });
  }
}
Object.defineProperty(ey, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class ty extends Qm {
  constructor(t) {
    super(t, {
      code: ty.code,
      shortMessage: "The Provider is disconnected from all chains."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderDisconnectedError"
    });
  }
}
Object.defineProperty(ty, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class ny extends Qm {
  constructor(t) {
    super(t, {
      code: ny.code,
      shortMessage: "The Provider is not connected to the requested chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainDisconnectedError"
    });
  }
}
Object.defineProperty(ny, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class nf extends Qm {
  constructor(t) {
    super(t, {
      code: nf.code,
      shortMessage: "An error occurred when attempting to switch chain."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainError"
    });
  }
}
Object.defineProperty(nf, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class DJ extends ji {
  constructor(t) {
    super(t, {
      shortMessage: "An unknown RPC error occurred."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownRpcError"
    });
  }
}
function HF(e, t) {
  const n = (e.details || "").toLowerCase(), r = e instanceof ze ? e.walk((i) => i.code === mh.code) : e;
  return r instanceof ze ? new mh({
    cause: e,
    message: r.details
  }) : mh.nodeMessage.test(n) ? new mh({
    cause: e,
    message: e.details
  }) : Ax.nodeMessage.test(n) ? new Ax({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : q6.nodeMessage.test(n) ? new q6({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : $6.nodeMessage.test(n) ? new $6({ cause: e, nonce: t == null ? void 0 : t.nonce }) : Q6.nodeMessage.test(n) ? new Q6({ cause: e, nonce: t == null ? void 0 : t.nonce }) : K6.nodeMessage.test(n) ? new K6({ cause: e, nonce: t == null ? void 0 : t.nonce }) : Y6.nodeMessage.test(n) ? new Y6({ cause: e }) : Z6.nodeMessage.test(n) ? new Z6({ cause: e, gas: t == null ? void 0 : t.gas }) : J6.nodeMessage.test(n) ? new J6({ cause: e, gas: t == null ? void 0 : t.gas }) : X6.nodeMessage.test(n) ? new X6({ cause: e }) : Ex.nodeMessage.test(n) ? new Ex({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas,
    maxPriorityFeePerGas: t == null ? void 0 : t.maxPriorityFeePerGas
  }) : new Rk({
    cause: e
  });
}
function WF(e, { format: t }) {
  if (!t)
    return {};
  const n = {};
  function r(s) {
    const o = Object.keys(s);
    for (const a of o)
      a in e && (n[a] = e[a]), s[a] && typeof s[a] == "object" && !Array.isArray(s[a]) && r(s[a]);
  }
  const i = t(e || {});
  return r(i), n;
}
const UJ = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3"
};
function GF(e) {
  const t = {};
  return typeof e.accessList < "u" && (t.accessList = e.accessList), typeof e.blobVersionedHashes < "u" && (t.blobVersionedHashes = e.blobVersionedHashes), typeof e.blobs < "u" && (typeof e.blobs[0] != "string" ? t.blobs = e.blobs.map((n) => Tr(n)) : t.blobs = e.blobs), typeof e.data < "u" && (t.data = e.data), typeof e.from < "u" && (t.from = e.from), typeof e.gas < "u" && (t.gas = Tt(e.gas)), typeof e.gasPrice < "u" && (t.gasPrice = Tt(e.gasPrice)), typeof e.maxFeePerBlobGas < "u" && (t.maxFeePerBlobGas = Tt(e.maxFeePerBlobGas)), typeof e.maxFeePerGas < "u" && (t.maxFeePerGas = Tt(e.maxFeePerGas)), typeof e.maxPriorityFeePerGas < "u" && (t.maxPriorityFeePerGas = Tt(e.maxPriorityFeePerGas)), typeof e.nonce < "u" && (t.nonce = Tt(e.nonce)), typeof e.to < "u" && (t.to = e.to), typeof e.type < "u" && (t.type = UJ[e.type]), typeof e.value < "u" && (t.value = Tt(e.value)), t;
}
function vt(e, t, n) {
  return (r) => {
    var i, s;
    return ((i = e[t.name]) == null ? void 0 : i.call(e, r)) ?? ((s = e[n]) == null ? void 0 : s.call(e, r)) ?? t(e, r);
  };
}
function Mk(e) {
  const { account: t, gasPrice: n, maxFeePerGas: r, maxPriorityFeePerGas: i, to: s } = e, o = t ? Ea(t) : void 0;
  if (o && !xc(o.address))
    throw new om({ address: o.address });
  if (s && !xc(s))
    throw new om({ address: s });
  if (typeof n < "u" && (typeof r < "u" || typeof i < "u"))
    throw new NJ();
  if (r && r > 2n ** 256n - 1n)
    throw new Ax({ maxFeePerGas: r });
  if (i && r && i > r)
    throw new Ex({ maxFeePerGas: r, maxPriorityFeePerGas: i });
}
async function qF(e) {
  const t = await e.request({
    method: "eth_chainId"
  });
  return Jl(t);
}
class LJ extends ze {
  constructor() {
    super("`baseFeeMultiplier` must be greater than 1."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseFeeScalarError"
    });
  }
}
class Fk extends ze {
  constructor() {
    super("Chain does not support EIP-1559 fees."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "Eip1559FeesNotSupportedError"
    });
  }
}
class zJ extends ze {
  constructor({ maxPriorityFeePerGas: t }) {
    super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${lo(t)} gwei).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "MaxFeePerGasTooLowError"
    });
  }
}
class $F extends ze {
  constructor({ blockHash: t, blockNumber: n }) {
    let r = "Block";
    t && (r = `Block at hash "${t}"`), n && (r = `Block at number "${n}"`), super(`${r} could not be found.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BlockNotFoundError"
    });
  }
}
const QF = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844"
};
function KF(e) {
  const t = {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    chainId: e.chainId ? Jl(e.chainId) : void 0,
    gas: e.gas ? BigInt(e.gas) : void 0,
    gasPrice: e.gasPrice ? BigInt(e.gasPrice) : void 0,
    maxFeePerBlobGas: e.maxFeePerBlobGas ? BigInt(e.maxFeePerBlobGas) : void 0,
    maxFeePerGas: e.maxFeePerGas ? BigInt(e.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: e.maxPriorityFeePerGas ? BigInt(e.maxPriorityFeePerGas) : void 0,
    nonce: e.nonce ? Jl(e.nonce) : void 0,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    type: e.type ? QF[e.type] : void 0,
    typeHex: e.type ? e.type : void 0,
    value: e.value ? BigInt(e.value) : void 0,
    v: e.v ? BigInt(e.v) : void 0
  };
  return t.yParity = (() => {
    if (e.yParity)
      return Number(e.yParity);
    if (typeof t.v == "bigint") {
      if (t.v === 0n || t.v === 27n)
        return 0;
      if (t.v === 1n || t.v === 28n)
        return 1;
      if (t.v >= 35n)
        return t.v % 2n === 0n ? 1 : 0;
    }
  })(), t.type === "legacy" && (delete t.accessList, delete t.maxFeePerBlobGas, delete t.maxFeePerGas, delete t.maxPriorityFeePerGas, delete t.yParity), t.type === "eip2930" && (delete t.maxFeePerBlobGas, delete t.maxFeePerGas, delete t.maxPriorityFeePerGas), t.type === "eip1559" && delete t.maxFeePerBlobGas, t;
}
function YF(e) {
  var n;
  const t = (n = e.transactions) == null ? void 0 : n.map((r) => typeof r == "string" ? r : KF(r));
  return {
    ...e,
    baseFeePerGas: e.baseFeePerGas ? BigInt(e.baseFeePerGas) : null,
    blobGasUsed: e.blobGasUsed ? BigInt(e.blobGasUsed) : void 0,
    difficulty: e.difficulty ? BigInt(e.difficulty) : void 0,
    excessBlobGas: e.excessBlobGas ? BigInt(e.excessBlobGas) : void 0,
    gasLimit: e.gasLimit ? BigInt(e.gasLimit) : void 0,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : void 0,
    hash: e.hash ? e.hash : null,
    logsBloom: e.logsBloom ? e.logsBloom : null,
    nonce: e.nonce ? e.nonce : null,
    number: e.number ? BigInt(e.number) : null,
    size: e.size ? BigInt(e.size) : void 0,
    timestamp: e.timestamp ? BigInt(e.timestamp) : void 0,
    transactions: t,
    totalDifficulty: e.totalDifficulty ? BigInt(e.totalDifficulty) : null
  };
}
async function Xl(e, { blockHash: t, blockNumber: n, blockTag: r, includeTransactions: i } = {}) {
  var u, d, f;
  const s = r ?? "latest", o = i ?? !1, a = n !== void 0 ? Tt(n) : void 0;
  let c = null;
  if (t ? c = await e.request({
    method: "eth_getBlockByHash",
    params: [t, o]
  }) : c = await e.request({
    method: "eth_getBlockByNumber",
    params: [a || s, o]
  }), !c)
    throw new $F({ blockHash: t, blockNumber: n });
  return (((f = (d = (u = e.chain) == null ? void 0 : u.formatters) == null ? void 0 : d.block) == null ? void 0 : f.format) || YF)(c);
}
async function jk(e) {
  const t = await e.request({
    method: "eth_gasPrice"
  });
  return BigInt(t);
}
async function VJ(e, t) {
  return ZF(e, t);
}
async function ZF(e, t) {
  var s, o, a;
  const { block: n, chain: r = e.chain, request: i } = t || {};
  if (typeof ((s = r == null ? void 0 : r.fees) == null ? void 0 : s.defaultPriorityFee) == "function") {
    const c = n || await vt(e, Xl, "getBlock")({});
    return r.fees.defaultPriorityFee({
      block: c,
      client: e,
      request: i
    });
  }
  if (typeof ((o = r == null ? void 0 : r.fees) == null ? void 0 : o.defaultPriorityFee) < "u")
    return (a = r == null ? void 0 : r.fees) == null ? void 0 : a.defaultPriorityFee;
  try {
    const c = await e.request({
      method: "eth_maxPriorityFeePerGas"
    });
    return sm(c);
  } catch {
    const [c, l] = await Promise.all([
      n ? Promise.resolve(n) : vt(e, Xl, "getBlock")({}),
      vt(e, jk, "getGasPrice")({})
    ]);
    if (typeof c.baseFeePerGas != "bigint")
      throw new Fk();
    const u = l - c.baseFeePerGas;
    return u < 0n ? 0n : u;
  }
}
async function HJ(e, t) {
  return eS(e, t);
}
async function eS(e, t) {
  var f, p;
  const { block: n, chain: r = e.chain, request: i, type: s = "eip1559" } = t || {}, o = await (async () => {
    var m, h;
    return typeof ((m = r == null ? void 0 : r.fees) == null ? void 0 : m.baseFeeMultiplier) == "function" ? r.fees.baseFeeMultiplier({
      block: n,
      client: e,
      request: i
    }) : ((h = r == null ? void 0 : r.fees) == null ? void 0 : h.baseFeeMultiplier) ?? 1.2;
  })();
  if (o < 1)
    throw new LJ();
  const c = 10 ** (((f = o.toString().split(".")[1]) == null ? void 0 : f.length) ?? 0), l = (m) => m * BigInt(Math.ceil(o * c)) / BigInt(c), u = n || await vt(e, Xl, "getBlock")({});
  if (typeof ((p = r == null ? void 0 : r.fees) == null ? void 0 : p.estimateFeesPerGas) == "function") {
    const m = await r.fees.estimateFeesPerGas({
      block: n,
      client: e,
      multiply: l,
      request: i,
      type: s
    });
    if (m !== null)
      return m;
  }
  if (s === "eip1559") {
    if (typeof u.baseFeePerGas != "bigint")
      throw new Fk();
    const m = typeof (i == null ? void 0 : i.maxPriorityFeePerGas) == "bigint" ? i.maxPriorityFeePerGas : await ZF(e, {
      block: u,
      chain: r,
      request: i
    }), h = l(u.baseFeePerGas);
    return {
      maxFeePerGas: (i == null ? void 0 : i.maxFeePerGas) ?? h + m,
      maxPriorityFeePerGas: m
    };
  }
  return {
    gasPrice: (i == null ? void 0 : i.gasPrice) ?? l(await vt(e, jk, "getGasPrice")({}))
  };
}
class WJ extends ze {
  constructor(t, { account: n, docsPath: r, chain: i, data: s, gas: o, gasPrice: a, maxFeePerGas: c, maxPriorityFeePerGas: l, nonce: u, to: d, value: f }) {
    var m;
    const p = kA({
      from: n == null ? void 0 : n.address,
      to: d,
      value: typeof f < "u" && `${UF(f)} ${((m = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : m.symbol) || "ETH"}`,
      data: s,
      gas: o,
      gasPrice: typeof a < "u" && `${lo(a)} gwei`,
      maxFeePerGas: typeof c < "u" && `${lo(c)} gwei`,
      maxPriorityFeePerGas: typeof l < "u" && `${lo(l)} gwei`,
      nonce: u
    });
    super(t.shortMessage, {
      cause: t,
      docsPath: r,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Estimate Gas Arguments:",
        p
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EstimateGasExecutionError"
    }), this.cause = t;
  }
}
function GJ(e, { docsPath: t, ...n }) {
  const r = (() => {
    const i = HF(e, n);
    return i instanceof Rk ? e : i;
  })();
  return new WJ(r, {
    docsPath: t,
    ...n
  });
}
async function Dk(e, t) {
  var i, s, o;
  const n = t.account ?? e.account, r = n ? Ea(n) : void 0;
  try {
    const { accessList: a, blobs: c, blobVersionedHashes: l, blockNumber: u, blockTag: d, data: f, gas: p, gasPrice: m, maxFeePerBlobGas: h, maxFeePerGas: g, maxPriorityFeePerGas: y, nonce: v, to: b, value: w, ...A } = await oj(e, {
      ...t,
      parameters: (
        // Some RPC Providers do not compute versioned hashes from blobs. We will need
        // to compute them.
        (r == null ? void 0 : r.type) === "local" ? void 0 : ["blobVersionedHashes"]
      )
    }), x = (u ? Tt(u) : void 0) || d;
    Mk(t);
    const S = (o = (s = (i = e.chain) == null ? void 0 : i.formatters) == null ? void 0 : s.transactionRequest) == null ? void 0 : o.format, I = (S || GF)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...WF(A, { format: S }),
      from: r == null ? void 0 : r.address,
      accessList: a,
      blobs: c,
      blobVersionedHashes: l,
      data: f,
      gas: p,
      gasPrice: m,
      maxFeePerBlobGas: h,
      maxFeePerGas: g,
      maxPriorityFeePerGas: y,
      nonce: v,
      to: b,
      value: w
    }), R = await e.request({
      method: "eth_estimateGas",
      params: x ? [I, x] : [I]
    });
    return BigInt(R);
  } catch (a) {
    throw GJ(a, {
      ...t,
      account: r,
      chain: e.chain
    });
  }
}
async function JF(e, { address: t, blockTag: n = "latest", blockNumber: r }) {
  const i = await e.request({
    method: "eth_getTransactionCount",
    params: [t, r ? Tt(r) : n]
  });
  return Jl(i);
}
function XF(e) {
  const { kzg: t } = e, n = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), r = typeof e.blobs[0] == "string" ? e.blobs.map((s) => Zl(s)) : e.blobs, i = [];
  for (const s of r)
    i.push(Uint8Array.from(t.blobToKzgCommitment(s)));
  return n === "bytes" ? i : i.map((s) => Tr(s));
}
function ej(e) {
  const { kzg: t } = e, n = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), r = typeof e.blobs[0] == "string" ? e.blobs.map((o) => Zl(o)) : e.blobs, i = typeof e.commitments[0] == "string" ? e.commitments.map((o) => Zl(o)) : e.commitments, s = [];
  for (let o = 0; o < r.length; o++) {
    const a = r[o], c = i[o];
    s.push(Uint8Array.from(t.computeBlobKzgProof(a, c)));
  }
  return n === "bytes" ? s : s.map((o) => Tr(o));
}
function qJ(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), s = BigInt(4294967295), o = Number(n >> i & s), a = Number(n & s), c = r ? 4 : 0, l = r ? 0 : 4;
  e.setUint32(t + c, o, r), e.setUint32(t + l, a, r);
}
let $J = class extends Bk {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = w3(this.buffer);
  }
  update(t) {
    am(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = CA(t);
    const s = t.length;
    for (let o = 0; o < s; ) {
      const a = Math.min(i - this.pos, s - o);
      if (a === i) {
        const c = w3(t);
        for (; i <= s - o; o += i)
          this.process(c, o);
        continue;
      }
      r.set(t.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    am(this), kF(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: s } = this;
    let { pos: o } = this;
    n[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > i - o && (this.process(r, 0), o = 0);
    for (let d = o; d < i; d++)
      n[d] = 0;
    qJ(r, i - 8, BigInt(this.length * 8), s), this.process(r, 0);
    const a = w3(t), c = this.outputLen;
    if (c % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let d = 0; d < l; d++)
      a.setUint32(4 * d, u[d], s);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: s, destroyed: o, pos: a } = this;
    return t.length = i, t.pos = a, t.finished = s, t.destroyed = o, i % n && t.buffer.set(r), t;
  }
};
const QJ = (e, t, n) => e & t ^ ~e & n, KJ = (e, t, n) => e & t ^ e & n ^ t & n, YJ = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Mc = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Fc = /* @__PURE__ */ new Uint32Array(64);
let ZJ = class extends $J {
  constructor() {
    super(64, 32, 8, !1), this.A = Mc[0] | 0, this.B = Mc[1] | 0, this.C = Mc[2] | 0, this.D = Mc[3] | 0, this.E = Mc[4] | 0, this.F = Mc[5] | 0, this.G = Mc[6] | 0, this.H = Mc[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: s, F: o, G: a, H: c } = this;
    return [t, n, r, i, s, o, a, c];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, a, c) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = s | 0, this.F = o | 0, this.G = a | 0, this.H = c | 0;
  }
  process(t, n) {
    for (let d = 0; d < 16; d++, n += 4)
      Fc[d] = t.getUint32(n, !1);
    for (let d = 16; d < 64; d++) {
      const f = Fc[d - 15], p = Fc[d - 2], m = ko(f, 7) ^ ko(f, 18) ^ f >>> 3, h = ko(p, 17) ^ ko(p, 19) ^ p >>> 10;
      Fc[d] = h + Fc[d - 7] + m + Fc[d - 16] | 0;
    }
    let { A: r, B: i, C: s, D: o, E: a, F: c, G: l, H: u } = this;
    for (let d = 0; d < 64; d++) {
      const f = ko(a, 6) ^ ko(a, 11) ^ ko(a, 25), p = u + f + QJ(a, c, l) + YJ[d] + Fc[d] | 0, h = (ko(r, 2) ^ ko(r, 13) ^ ko(r, 22)) + KJ(r, i, s) | 0;
      u = l, l = c, c = a, a = o + p | 0, o = s, s = i, i = r, r = p + h | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, s = s + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(r, i, s, o, a, c, l, u);
  }
  roundClean() {
    Fc.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
const tj = /* @__PURE__ */ IF(() => new ZJ());
function JJ(e, t) {
  return tj(ya(e, { strict: !1 }) ? Yl(e) : e);
}
function XJ(e) {
  const { commitment: t, version: n = 1 } = e, r = e.to ?? (typeof t == "string" ? "hex" : "bytes"), i = JJ(t);
  return i.set([n], 0), r === "bytes" ? i : Tr(i);
}
function eX(e) {
  const { commitments: t, version: n } = e, r = e.to ?? (typeof t[0] == "string" ? "hex" : "bytes"), i = [];
  for (const s of t)
    i.push(XJ({
      commitment: s,
      to: r,
      version: n
    }));
  return i;
}
const YB = 6, nj = 32, Uk = 4096, rj = nj * Uk, ZB = rj * YB - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * Uk * YB;
class tX extends ze {
  constructor({ maxSize: t, size: n }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${t} bytes`, `Given: ${n} bytes`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BlobSizeTooLargeError"
    });
  }
}
class nX extends ze {
  constructor() {
    super("Blob data must not be empty."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EmptyBlobError"
    });
  }
}
class JB extends ze {
  constructor({ offset: t }) {
    super(`Offset \`${t}\` cannot be negative.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NegativeOffsetError"
    });
  }
}
class ij extends ze {
  constructor({ length: t, position: n }) {
    super(`Position \`${n}\` is out of bounds (\`0 < position < ${t}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PositionOutOfBoundsError"
    });
  }
}
class rX extends ze {
  constructor({ count: t, limit: n }) {
    super(`Recursive read limit of \`${n}\` exceeded (recursive read count: \`${t}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RecursiveReadLimitExceededError"
    });
  }
}
const iX = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: 1 / 0,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new rX({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(e) {
    if (e < 0 || e > this.bytes.length - 1)
      throw new ij({
        length: this.bytes.length,
        position: e
      });
  },
  decrementPosition(e) {
    if (e < 0)
      throw new JB({ offset: e });
    const t = this.position - e;
    this.assertPosition(t), this.position = t;
  },
  getReadCount(e) {
    return this.positionReadCount.get(e || this.position) || 0;
  },
  incrementPosition(e) {
    if (e < 0)
      throw new JB({ offset: e });
    const t = this.position + e;
    this.assertPosition(t), this.position = t;
  },
  inspectByte(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectBytes(e, t) {
    const n = t ?? this.position;
    return this.assertPosition(n + e - 1), this.bytes.subarray(n, n + e);
  },
  inspectUint8(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectUint16(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 1), this.dataView.getUint16(t);
  },
  inspectUint24(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 2), (this.dataView.getUint16(t) << 8) + this.dataView.getUint8(t + 2);
  },
  inspectUint32(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 3), this.dataView.getUint32(t);
  },
  pushByte(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushBytes(e) {
    this.assertPosition(this.position + e.length - 1), this.bytes.set(e, this.position), this.position += e.length;
  },
  pushUint8(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushUint16(e) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, e), this.position += 2;
  },
  pushUint24(e) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, e >> 8), this.dataView.setUint8(this.position + 2, e & 255), this.position += 3;
  },
  pushUint32(e) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, e), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectByte();
    return this.position++, e;
  },
  readBytes(e, t) {
    this.assertReadLimit(), this._touch();
    const n = this.inspectBytes(e);
    return this.position += t ?? e, n;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint8();
    return this.position += 1, e;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint16();
    return this.position += 2, e;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint24();
    return this.position += 3, e;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint32();
    return this.position += 4, e;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(e) {
    const t = this.position;
    return this.assertPosition(e), this.position = e, () => this.position = t;
  },
  _touch() {
    if (this.recursiveReadLimit === 1 / 0)
      return;
    const e = this.getReadCount();
    this.positionReadCount.set(this.position, e + 1), e > 0 && this.recursiveReadCount++;
  }
};
function sj(e, { recursiveReadLimit: t = 8192 } = {}) {
  const n = Object.create(iX);
  return n.bytes = e, n.dataView = new DataView(e.buffer, e.byteOffset, e.byteLength), n.positionReadCount = /* @__PURE__ */ new Map(), n.recursiveReadLimit = t, n;
}
function sX(e) {
  const t = e.to ?? (typeof e.data == "string" ? "hex" : "bytes"), n = typeof e.data == "string" ? Zl(e.data) : e.data, r = Zn(n);
  if (!r)
    throw new nX();
  if (r > ZB)
    throw new tX({
      maxSize: ZB,
      size: r
    });
  const i = [];
  let s = !0, o = 0;
  for (; s; ) {
    const a = sj(new Uint8Array(rj));
    let c = 0;
    for (; c < Uk; ) {
      const l = n.slice(o, o + (nj - 1));
      if (a.pushByte(0), a.pushBytes(l), l.length < 31) {
        a.pushByte(128), s = !1;
        break;
      }
      c++, o += 31;
    }
    i.push(a);
  }
  return t === "bytes" ? i.map((a) => a.bytes) : i.map((a) => Tr(a.bytes));
}
function oX(e) {
  const { data: t, kzg: n, to: r } = e, i = e.blobs ?? sX({ data: t, to: r }), s = e.commitments ?? XF({ blobs: i, kzg: n, to: r }), o = e.proofs ?? ej({ blobs: i, commitments: s, kzg: n, to: r }), a = [];
  for (let c = 0; c < i.length; c++)
    a.push({
      blob: i[c],
      commitment: s[c],
      proof: o[c]
    });
  return a;
}
function aX(e) {
  if (e.type)
    return e.type;
  if (typeof e.blobs < "u" || typeof e.blobVersionedHashes < "u" || typeof e.maxFeePerBlobGas < "u" || typeof e.sidecars < "u")
    return "eip4844";
  if (typeof e.maxFeePerGas < "u" || typeof e.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof e.gasPrice < "u")
    return typeof e.accessList < "u" ? "eip2930" : "legacy";
  throw new RJ({ transaction: e });
}
const cX = [
  "blobVersionedHashes",
  "chainId",
  "fees",
  "gas",
  "nonce",
  "type"
];
async function oj(e, t) {
  const { account: n = e.account, blobs: r, chain: i, chainId: s, gas: o, kzg: a, nonce: c, parameters: l = cX, type: u } = t, d = n ? Ea(n) : void 0, f = { ...t, ...d ? { from: d == null ? void 0 : d.address } : {} };
  let p;
  async function m() {
    return p || (p = await vt(e, Xl, "getBlock")({ blockTag: "latest" }), p);
  }
  if ((l.includes("blobVersionedHashes") || l.includes("sidecars")) && r && a) {
    const h = XF({ blobs: r, kzg: a });
    if (l.includes("blobVersionedHashes")) {
      const g = eX({
        commitments: h,
        to: "hex"
      });
      f.blobVersionedHashes = g;
    }
    if (l.includes("sidecars")) {
      const g = ej({ blobs: r, commitments: h, kzg: a }), y = oX({
        blobs: r,
        commitments: h,
        proofs: g,
        to: "hex"
      });
      f.sidecars = y;
    }
  }
  if (l.includes("chainId") && (i ? f.chainId = i.id : typeof s < "u" ? f.chainId = s : f.chainId = await vt(e, qF, "getChainId")({})), l.includes("nonce") && typeof c > "u" && d && (f.nonce = await vt(e, JF, "getTransactionCount")({
    address: d.address,
    blockTag: "pending"
  })), (l.includes("fees") || l.includes("type")) && typeof u > "u")
    try {
      f.type = aX(f);
    } catch {
      const h = await m();
      f.type = typeof (h == null ? void 0 : h.baseFeePerGas) == "bigint" ? "eip1559" : "legacy";
    }
  if (l.includes("fees"))
    if (f.type !== "legacy" && f.type !== "eip2930") {
      if (typeof f.maxFeePerGas > "u" || typeof f.maxPriorityFeePerGas > "u") {
        const h = await m(), { maxFeePerGas: g, maxPriorityFeePerGas: y } = await eS(e, {
          block: h,
          chain: i,
          request: f
        });
        if (typeof t.maxPriorityFeePerGas > "u" && t.maxFeePerGas && t.maxFeePerGas < y)
          throw new zJ({
            maxPriorityFeePerGas: y
          });
        f.maxPriorityFeePerGas = y, f.maxFeePerGas = g;
      }
    } else {
      if (typeof t.maxFeePerGas < "u" || typeof t.maxPriorityFeePerGas < "u")
        throw new Fk();
      const h = await m(), { gasPrice: g } = await eS(e, {
        block: h,
        chain: i,
        request: f,
        type: "legacy"
      });
      f.gasPrice = g;
    }
  return l.includes("gas") && typeof o > "u" && (f.gas = await vt(e, Dk, "estimateGas")({
    ...f,
    account: d ? { address: d.address, type: "json-rpc" } : void 0
  })), Mk(f), delete f.parameters, f;
}
async function lX(e, { serializedTransaction: t }) {
  return e.request({
    method: "eth_sendRawTransaction",
    params: [t]
  }, { retryCount: 0 });
}
const tS = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], aj = [
  {
    inputs: [],
    name: "ResolverNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverWildcardNotSupported",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverNotContract",
    type: "error"
  },
  {
    inputs: [
      {
        name: "returnData",
        type: "bytes"
      }
    ],
    name: "ResolverError",
    type: "error"
  },
  {
    inputs: [
      {
        components: [
          {
            name: "status",
            type: "uint16"
          },
          {
            name: "message",
            type: "string"
          }
        ],
        name: "errors",
        type: "tuple[]"
      }
    ],
    name: "HttpError",
    type: "error"
  }
], cj = [
  ...aj,
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  },
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" },
      { name: "gateways", type: "string[]" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  }
], uX = [
  ...aj,
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [{ type: "bytes", name: "reverseName" }],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  },
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [
      { type: "bytes", name: "reverseName" },
      { type: "string[]", name: "gateways" }
    ],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  }
], XB = [
  {
    name: "text",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "key", type: "string" }
    ],
    outputs: [{ name: "", type: "string" }]
  }
], eI = [
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [{ name: "name", type: "bytes32" }],
    outputs: [{ name: "", type: "address" }]
  },
  {
    name: "addr",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "coinType", type: "uint256" }
    ],
    outputs: [{ name: "", type: "bytes" }]
  }
], dX = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_signer",
        type: "address"
      },
      {
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  }
];
function fX(e, t = {}) {
  typeof t.size < "u" && wo(e, { size: t.size });
  const n = Tr(e, t);
  return sm(n, t);
}
function hX(e, t = {}) {
  let n = e;
  if (typeof t.size < "u" && (wo(n, { size: t.size }), n = $m(n)), n.length > 1 || n[0] > 1)
    throw new SZ(n);
  return !!n[0];
}
function dc(e, t = {}) {
  typeof t.size < "u" && wo(e, { size: t.size });
  const n = Tr(e, t);
  return Jl(n, t);
}
function pX(e, t = {}) {
  let n = e;
  return typeof t.size < "u" && (wo(n, { size: t.size }), n = $m(n, { dir: "right" })), new TextDecoder().decode(n);
}
function BA(e, t) {
  const n = typeof t == "string" ? Zl(t) : t, r = sj(n);
  if (Zn(n) === 0 && e.length > 0)
    throw new _A();
  if (Zn(t) && Zn(t) < 32)
    throw new SF({
      data: typeof t == "string" ? t : Tr(t),
      params: e,
      size: Zn(t)
    });
  let i = 0;
  const s = [];
  for (let o = 0; o < e.length; ++o) {
    const a = e[o];
    r.setPosition(i);
    const [c, l] = Mh(r, a, {
      staticPosition: 0
    });
    i += l, s.push(c);
  }
  return s;
}
function Mh(e, t, { staticPosition: n }) {
  const r = Nk(t.type);
  if (r) {
    const [i, s] = r;
    return gX(e, { ...t, type: s }, { length: i, staticPosition: n });
  }
  if (t.type === "tuple")
    return wX(e, t, { staticPosition: n });
  if (t.type === "address")
    return mX(e);
  if (t.type === "bool")
    return yX(e);
  if (t.type.startsWith("bytes"))
    return bX(e, t, { staticPosition: n });
  if (t.type.startsWith("uint") || t.type.startsWith("int"))
    return vX(e, t);
  if (t.type === "string")
    return xX(e, { staticPosition: n });
  throw new WZ(t.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
const tI = 32, nS = 32;
function mX(e) {
  const t = e.readBytes(32);
  return [Ik(Tr(jF(t, -20))), 32];
}
function gX(e, t, { length: n, staticPosition: r }) {
  if (!n) {
    const o = dc(e.readBytes(nS)), a = r + o, c = a + tI;
    e.setPosition(a);
    const l = dc(e.readBytes(tI)), u = ry(t);
    let d = 0;
    const f = [];
    for (let p = 0; p < l; ++p) {
      e.setPosition(c + (u ? p * 32 : d));
      const [m, h] = Mh(e, t, {
        staticPosition: c
      });
      d += h, f.push(m);
    }
    return e.setPosition(r + 32), [f, 32];
  }
  if (ry(t)) {
    const o = dc(e.readBytes(nS)), a = r + o, c = [];
    for (let l = 0; l < n; ++l) {
      e.setPosition(a + l * 32);
      const [u] = Mh(e, t, {
        staticPosition: a
      });
      c.push(u);
    }
    return e.setPosition(r + 32), [c, 32];
  }
  let i = 0;
  const s = [];
  for (let o = 0; o < n; ++o) {
    const [a, c] = Mh(e, t, {
      staticPosition: r + i
    });
    i += c, s.push(a);
  }
  return [s, i];
}
function yX(e) {
  return [hX(e.readBytes(32), { size: 32 }), 32];
}
function bX(e, t, { staticPosition: n }) {
  const [r, i] = t.type.split("bytes");
  if (!i) {
    const o = dc(e.readBytes(32));
    e.setPosition(n + o);
    const a = dc(e.readBytes(32));
    if (a === 0)
      return e.setPosition(n + 32), ["0x", 32];
    const c = e.readBytes(a);
    return e.setPosition(n + 32), [Tr(c), 32];
  }
  return [Tr(e.readBytes(parseInt(i), 32)), 32];
}
function vX(e, t) {
  const n = t.type.startsWith("int"), r = parseInt(t.type.split("int")[1] || "256"), i = e.readBytes(32);
  return [
    r > 48 ? fX(i, { signed: n }) : dc(i, { signed: n }),
    32
  ];
}
function wX(e, t, { staticPosition: n }) {
  const r = t.components.length === 0 || t.components.some(({ name: o }) => !o), i = r ? [] : {};
  let s = 0;
  if (ry(t)) {
    const o = dc(e.readBytes(nS)), a = n + o;
    for (let c = 0; c < t.components.length; ++c) {
      const l = t.components[c];
      e.setPosition(a + s);
      const [u, d] = Mh(e, l, {
        staticPosition: a
      });
      s += d, i[r ? c : l == null ? void 0 : l.name] = u;
    }
    return e.setPosition(n + 32), [i, 32];
  }
  for (let o = 0; o < t.components.length; ++o) {
    const a = t.components[o], [c, l] = Mh(e, a, {
      staticPosition: n
    });
    i[r ? o : a == null ? void 0 : a.name] = c, s += l;
  }
  return [i, s];
}
function xX(e, { staticPosition: t }) {
  const n = dc(e.readBytes(32)), r = t + n;
  e.setPosition(r);
  const i = dc(e.readBytes(32));
  if (i === 0)
    return e.setPosition(t + 32), ["", 32];
  const s = e.readBytes(i, 32), o = pX($m(s));
  return e.setPosition(t + 32), [o, 32];
}
function ry(e) {
  var r;
  const { type: t } = e;
  if (t === "string" || t === "bytes" || t.endsWith("[]"))
    return !0;
  if (t === "tuple")
    return (r = e.components) == null ? void 0 : r.some(ry);
  const n = Nk(e.type);
  return !!(n && ry({ ...e, type: n[1] }));
}
function AX(e, t) {
  const n = e.exec(t);
  return n == null ? void 0 : n.groups;
}
const nI = /^tuple(?<array>(\[(\d*)\])*)$/;
function rS(e) {
  let t = e.type;
  if (nI.test(e.type) && "components" in e) {
    t = "(";
    const n = e.components.length;
    for (let i = 0; i < n; i++) {
      const s = e.components[i];
      t += rS(s), i < n - 1 && (t += ", ");
    }
    const r = AX(nI, e.type);
    return t += `)${(r == null ? void 0 : r.array) ?? ""}`, rS({
      ...e,
      type: t
    });
  }
  return "indexed" in e && e.indexed && (t = `${t} indexed`), e.name ? `${t} ${e.name}` : t;
}
function p0(e) {
  let t = "";
  const n = e.length;
  for (let r = 0; r < n; r++) {
    const i = e[r];
    t += rS(i), r !== n - 1 && (t += ", ");
  }
  return t;
}
function EX(e) {
  return e.type === "function" ? `function ${e.name}(${p0(e.inputs)})${e.stateMutability && e.stateMutability !== "nonpayable" ? ` ${e.stateMutability}` : ""}${e.outputs.length ? ` returns (${p0(e.outputs)})` : ""}` : e.type === "event" ? `event ${e.name}(${p0(e.inputs)})` : e.type === "error" ? `error ${e.name}(${p0(e.inputs)})` : e.type === "constructor" ? `constructor(${p0(e.inputs)})${e.stateMutability === "payable" ? " payable" : ""}` : e.type === "fallback" ? "fallback()" : "receive() external payable";
}
const _X = (e) => ki(Yl(e));
function SX(e) {
  return _X(e);
}
function CX(e) {
  let t = !0, n = "", r = 0, i = "", s = !1;
  for (let o = 0; o < e.length; o++) {
    const a = e[o];
    if (["(", ")", ","].includes(a) && (t = !0), a === "(" && r++, a === ")" && r--, !!t) {
      if (r === 0) {
        if (a === " " && ["event", "function", ""].includes(i))
          i = "";
        else if (i += a, a === ")") {
          s = !0;
          break;
        }
        continue;
      }
      if (a === " ") {
        e[o - 1] !== "," && n !== "," && n !== ",(" && (n = "", t = !1);
        continue;
      }
      i += a, n += a;
    }
  }
  if (!s)
    throw new ze("Unable to normalize signature.");
  return i;
}
const TX = (e) => {
  const t = typeof e == "string" ? e : EX(e);
  return CX(t);
};
function lj(e) {
  return SX(TX(e));
}
const Lk = lj, zk = (e) => xx(lj(e), 0, 4);
function nv(e) {
  const { abi: t, args: n = [], name: r } = e, i = ya(r, { strict: !1 }), s = t.filter((a) => i ? a.type === "function" ? zk(a) === r : a.type === "event" ? Lk(a) === r : !1 : "name" in a && a.name === r);
  if (s.length === 0)
    return;
  if (s.length === 1)
    return s[0];
  let o;
  for (const a of s) {
    if (!("inputs" in a))
      continue;
    if (!n || n.length === 0) {
      if (!a.inputs || a.inputs.length === 0)
        return a;
      continue;
    }
    if (!a.inputs || a.inputs.length === 0 || a.inputs.length !== n.length)
      continue;
    if (n.every((l, u) => {
      const d = "inputs" in a && a.inputs[u];
      return d ? iS(l, d) : !1;
    })) {
      if (o && "inputs" in o && o.inputs) {
        const l = uj(a.inputs, o.inputs, n);
        if (l)
          throw new zZ({
            abiItem: a,
            type: l[0]
          }, {
            abiItem: o,
            type: l[1]
          });
      }
      o = a;
    }
  }
  return o || s[0];
}
function iS(e, t) {
  const n = typeof e, r = t.type;
  switch (r) {
    case "address":
      return xc(e, { strict: !1 });
    case "bool":
      return n === "boolean";
    case "function":
      return n === "string";
    case "string":
      return n === "string";
    default:
      return r === "tuple" && "components" in t ? Object.values(t.components).every((i, s) => iS(Object.values(e)[s], i)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(r) ? n === "number" || n === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(r) ? n === "string" || e instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(r) ? Array.isArray(e) && e.every((i) => iS(i, {
        ...t,
        // Pop off `[]` or `[M]` from end of type
        type: r.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function uj(e, t, n) {
  for (const r in e) {
    const i = e[r], s = t[r];
    if (i.type === "tuple" && s.type === "tuple" && "components" in i && "components" in s)
      return uj(i.components, s.components, n[r]);
    const o = [i.type, s.type];
    if (o.includes("address") && o.includes("bytes20") ? !0 : o.includes("address") && o.includes("string") ? xc(n[r], { strict: !1 }) : o.includes("address") && o.includes("bytes") ? xc(n[r], { strict: !1 }) : !1)
      return o;
  }
}
const E3 = "/docs/contract/decodeFunctionResult";
function Km(e) {
  const { abi: t, args: n, functionName: r, data: i } = e;
  let s = t[0];
  if (r) {
    const a = nv({ abi: t, args: n, name: r });
    if (!a)
      throw new vx(r, { docsPath: E3 });
    s = a;
  }
  if (s.type !== "function")
    throw new vx(void 0, { docsPath: E3 });
  if (!s.outputs)
    throw new LZ(s.name, { docsPath: E3 });
  const o = BA(s.outputs, i);
  if (o && o.length > 1)
    return o;
  if (o && o.length === 1)
    return o[0];
}
const rI = "/docs/contract/encodeFunctionData";
function kX(e) {
  const { abi: t, args: n, functionName: r } = e;
  let i = t[0];
  if (r) {
    const s = nv({
      abi: t,
      args: n,
      name: r
    });
    if (!s)
      throw new vx(r, { docsPath: rI });
    i = s;
  }
  if (i.type !== "function")
    throw new vx(void 0, { docsPath: rI });
  return {
    abi: [i],
    functionName: zk(vc(i))
  };
}
function Sf(e) {
  const { args: t } = e, { abi: n, functionName: r } = (() => {
    var a;
    return e.abi.length === 1 && ((a = e.functionName) != null && a.startsWith("0x")) ? e : kX(e);
  })(), i = n[0], s = r, o = "inputs" in i && i.inputs ? tv(i.inputs, t ?? []) : void 0;
  return Tk([s, o ?? "0x"]);
}
function Ym({ blockNumber: e, chain: t, contract: n }) {
  var i;
  const r = (i = t == null ? void 0 : t.contracts) == null ? void 0 : i[n];
  if (!r)
    throw new G6({
      chain: t,
      contract: { name: n }
    });
  if (e && r.blockCreated && r.blockCreated > e)
    throw new G6({
      blockNumber: e,
      chain: t,
      contract: {
        name: n,
        blockCreated: r.blockCreated
      }
    });
  return r.address;
}
const dj = {
  1: "An `assert` condition failed.",
  17: "Arithmetic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
}, BX = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
}, IX = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};
function PX(e) {
  const { abi: t, data: n } = e, r = xx(n, 0, 4);
  if (r === "0x")
    throw new _A();
  const s = [...t || [], BX, IX].find((o) => o.type === "error" && r === zk(vc(o)));
  if (!s)
    throw new CF(r, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem: s,
    args: "inputs" in s && s.inputs && s.inputs.length > 0 ? BA(s.inputs, xx(n, 4)) : void 0,
    errorName: s.name
  };
}
function fj({ abiItem: e, args: t, includeFunctionName: n = !0, includeName: r = !1 }) {
  if ("name" in e && "inputs" in e && e.inputs)
    return `${n ? e.name : ""}(${e.inputs.map((i, s) => `${r && i.name ? `${i.name}: ` : ""}${typeof t[s] == "object" ? po(t[s]) : t[s]}`).join(", ")})`;
}
class OX extends ze {
  constructor({ address: t }) {
    super(`State for account "${t}" is set multiple times.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AccountStateConflictError"
    });
  }
}
class NX extends ze {
  constructor() {
    super("state and stateDiff are set on the same account."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "StateAssignmentConflictError"
    });
  }
}
function iI(e) {
  return e.reduce((t, { slot: n, value: r }) => `${t}        ${n}: ${r}
`, "");
}
function RX(e) {
  return e.reduce((t, { address: n, ...r }) => {
    let i = `${t}    ${n}:
`;
    return r.nonce && (i += `      nonce: ${r.nonce}
`), r.balance && (i += `      balance: ${r.balance}
`), r.code && (i += `      code: ${r.code}
`), r.state && (i += `      state:
`, i += iI(r.state)), r.stateDiff && (i += `      stateDiff:
`, i += iI(r.stateDiff)), i;
  }, `  State Override:
`).slice(0, -1);
}
class hj extends ze {
  constructor(t, { account: n, docsPath: r, chain: i, data: s, gas: o, gasPrice: a, maxFeePerGas: c, maxPriorityFeePerGas: l, nonce: u, to: d, value: f, stateOverride: p }) {
    var g;
    const m = n ? Ea(n) : void 0;
    let h = kA({
      from: m == null ? void 0 : m.address,
      to: d,
      value: typeof f < "u" && `${UF(f)} ${((g = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : g.symbol) || "ETH"}`,
      data: s,
      gas: o,
      gasPrice: typeof a < "u" && `${lo(a)} gwei`,
      maxFeePerGas: typeof c < "u" && `${lo(c)} gwei`,
      maxPriorityFeePerGas: typeof l < "u" && `${lo(l)} gwei`,
      nonce: u
    });
    p && (h += `
${RX(p)}`), super(t.shortMessage, {
      cause: t,
      docsPath: r,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Raw Call Arguments:",
        h
      ].filter(Boolean)
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CallExecutionError"
    }), this.cause = t;
  }
}
class Vk extends ze {
  constructor(t, { abi: n, args: r, contractAddress: i, docsPath: s, functionName: o, sender: a }) {
    const c = nv({ abi: n, args: r, name: o }), l = c ? fj({
      abiItem: c,
      args: r,
      includeFunctionName: !1,
      includeName: !1
    }) : void 0, u = c ? vc(c, { includeName: !0 }) : void 0, d = kA({
      address: i && AZ(i),
      function: u,
      args: l && l !== "()" && `${[...Array((o == null ? void 0 : o.length) ?? 0).keys()].map(() => " ").join("")}${l}`,
      sender: a
    });
    super(t.shortMessage || `An unknown error occurred while executing the contract function "${o}".`, {
      cause: t,
      docsPath: s,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Contract Call:",
        d
      ].filter(Boolean)
    }), Object.defineProperty(this, "abi", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "args", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contractAddress", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "formattedArgs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "functionName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sender", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionExecutionError"
    }), this.abi = n, this.args = r, this.cause = t, this.contractAddress = i, this.functionName = o, this.sender = a;
  }
}
class sS extends ze {
  constructor({ abi: t, data: n, functionName: r, message: i }) {
    let s, o, a, c;
    if (n && n !== "0x")
      try {
        o = PX({ abi: t, data: n });
        const { abiItem: u, errorName: d, args: f } = o;
        if (d === "Error")
          c = f[0];
        else if (d === "Panic") {
          const [p] = f;
          c = dj[p];
        } else {
          const p = u ? vc(u, { includeName: !0 }) : void 0, m = u && f ? fj({
            abiItem: u,
            args: f,
            includeFunctionName: !1,
            includeName: !1
          }) : void 0;
          a = [
            p ? `Error: ${p}` : "",
            m && m !== "()" ? `       ${[...Array((d == null ? void 0 : d.length) ?? 0).keys()].map(() => " ").join("")}${m}` : ""
          ];
        }
      } catch (u) {
        s = u;
      }
    else
      i && (c = i);
    let l;
    s instanceof CF && (l = s.signature, a = [
      `Unable to decode signature "${l}" as it was not found on the provided ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${l}.`
    ]), super(c && c !== "execution reverted" || l ? [
      `The contract function "${r}" reverted with the following ${l ? "signature" : "reason"}:`,
      c || l
    ].join(`
`) : `The contract function "${r}" reverted.`, {
      cause: s,
      metaMessages: a
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionRevertedError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "reason", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = o, this.reason = c, this.signature = l;
  }
}
class MX extends ze {
  constructor({ functionName: t }) {
    super(`The contract function "${t}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${t}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ContractFunctionZeroDataError"
    });
  }
}
class Hk extends ze {
  constructor({ data: t, message: n }) {
    super(n || ""), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 3
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RawContractError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t;
  }
}
function Wk(e, t) {
  var r, i, s, o, a, c;
  if (!(e instanceof ze))
    return !1;
  const n = e.walk((l) => l instanceof sS);
  return n instanceof sS ? !!(((r = n.data) == null ? void 0 : r.errorName) === "ResolverNotFound" || ((i = n.data) == null ? void 0 : i.errorName) === "ResolverWildcardNotSupported" || ((s = n.data) == null ? void 0 : s.errorName) === "ResolverNotContract" || ((o = n.data) == null ? void 0 : o.errorName) === "ResolverError" || ((a = n.data) == null ? void 0 : a.errorName) === "HttpError" || (c = n.reason) != null && c.includes("Wildcard on non-extended resolvers is not supported") || t === "reverse" && n.reason === dj[50]) : !1;
}
function pj(e) {
  if (e.length !== 66 || e.indexOf("[") !== 0 || e.indexOf("]") !== 65)
    return null;
  const t = `0x${e.slice(1, 65)}`;
  return ya(t) ? t : null;
}
function aw(e) {
  let t = new Uint8Array(32).fill(0);
  if (!e)
    return Tr(t);
  const n = e.split(".");
  for (let r = n.length - 1; r >= 0; r -= 1) {
    const i = pj(n[r]), s = i ? Yl(i) : ki(uc(n[r]), "bytes");
    t = ki(wc([t, s]), "bytes");
  }
  return Tr(t);
}
function FX(e) {
  return `[${e.slice(2)}]`;
}
function jX(e) {
  const t = new Uint8Array(32).fill(0);
  return e ? pj(e) || ki(uc(e)) : Tr(t);
}
function IA(e) {
  const t = e.replace(/^\.|\.$/gm, "");
  if (t.length === 0)
    return new Uint8Array(1);
  const n = new Uint8Array(uc(t).byteLength + 2);
  let r = 0;
  const i = t.split(".");
  for (let s = 0; s < i.length; s++) {
    let o = uc(i[s]);
    o.byteLength > 255 && (o = uc(FX(jX(i[s])))), n[r] = o.length, n.set(o, r + 1), r += o.length + 1;
  }
  return n.byteLength !== r + 1 ? n.slice(0, r + 1) : n;
}
const DX = 3;
function iy(e, { abi: t, address: n, args: r, docsPath: i, functionName: s, sender: o }) {
  const { code: a, data: c, message: l, shortMessage: u } = e instanceof Hk ? e : e instanceof ze ? e.walk((f) => "data" in f) || e.walk() : {}, d = e instanceof _A ? new MX({ functionName: s }) : [DX, ef.code].includes(a) && (c || l || u) ? new sS({
    abi: t,
    data: typeof c == "object" ? c.data : c,
    functionName: s,
    message: u ?? l
  }) : e;
  return new Vk(d, {
    abi: t,
    args: r,
    contractAddress: n,
    docsPath: i,
    functionName: s,
    sender: o
  });
}
const UX = "0x82ad56cb";
function LX(e, { docsPath: t, ...n }) {
  const r = (() => {
    const i = HF(e, n);
    return i instanceof Rk ? e : i;
  })();
  return new hj(r, {
    docsPath: t,
    ...n
  });
}
const _3 = /* @__PURE__ */ new Map();
function zX({ fn: e, id: t, shouldSplitBatch: n, wait: r = 0, sort: i }) {
  const s = async () => {
    const u = c();
    o();
    const d = u.map(({ args: f }) => f);
    d.length !== 0 && e(d).then((f) => {
      var p;
      i && Array.isArray(f) && f.sort(i);
      for (let m = 0; m < u.length; m++) {
        const { pendingPromise: h } = u[m];
        (p = h.resolve) == null || p.call(h, [f[m], f]);
      }
    }).catch((f) => {
      var p;
      for (let m = 0; m < u.length; m++) {
        const { pendingPromise: h } = u[m];
        (p = h.reject) == null || p.call(h, f);
      }
    });
  }, o = () => _3.delete(t), a = () => c().map(({ args: u }) => u), c = () => _3.get(t) || [], l = (u) => _3.set(t, [...c(), u]);
  return {
    flush: o,
    async schedule(u) {
      const d = {}, f = new Promise((h, g) => {
        d.resolve = h, d.reject = g;
      });
      return (n == null ? void 0 : n([...a(), u])) && s(), c().length > 0 ? (l({ args: u, pendingPromise: d }), f) : (l({ args: u, pendingPromise: d }), setTimeout(s, r), f);
    }
  };
}
async function PA(e, t) {
  var w, A, E, x;
  const { account: n = e.account, batch: r = !!((w = e.batch) != null && w.multicall), blockNumber: i, blockTag: s = "latest", accessList: o, blobs: a, data: c, gas: l, gasPrice: u, maxFeePerBlobGas: d, maxFeePerGas: f, maxPriorityFeePerGas: p, nonce: m, to: h, value: g, stateOverride: y, ...v } = t, b = n ? Ea(n) : void 0;
  try {
    Mk(t);
    const P = (i ? Tt(i) : void 0) || s, I = qX(y), R = (x = (E = (A = e.chain) == null ? void 0 : A.formatters) == null ? void 0 : E.transactionRequest) == null ? void 0 : x.format, J = (R || GF)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...WF(v, { format: R }),
      from: b == null ? void 0 : b.address,
      accessList: o,
      blobs: a,
      data: c,
      gas: l,
      gasPrice: u,
      maxFeePerBlobGas: d,
      maxFeePerGas: f,
      maxPriorityFeePerGas: p,
      nonce: m,
      to: h,
      value: g
    });
    if (r && VX({ request: J }) && !I)
      try {
        return await HX(e, {
          ...J,
          blockNumber: i,
          blockTag: s
        });
      } catch (V) {
        if (!(V instanceof DF) && !(V instanceof G6))
          throw V;
      }
    const we = await e.request({
      method: "eth_call",
      params: I ? [
        J,
        P,
        I
      ] : [J, P]
    });
    return we === "0x" ? { data: void 0 } : { data: we };
  } catch (S) {
    const P = WX(S), { offchainLookup: I, offchainLookupSignature: R } = await import("./ccip-s-a3V5gh.js");
    if (e.ccipRead !== !1 && (P == null ? void 0 : P.slice(0, 10)) === R && h)
      return { data: await I(e, { data: P, to: h }) };
    throw LX(S, {
      ...t,
      account: b,
      chain: e.chain
    });
  }
}
function VX({ request: e }) {
  const { data: t, to: n, ...r } = e;
  return !(!t || t.startsWith(UX) || !n || Object.values(r).filter((i) => typeof i < "u").length > 0);
}
async function HX(e, t) {
  var h;
  const { batchSize: n = 1024, wait: r = 0 } = typeof ((h = e.batch) == null ? void 0 : h.multicall) == "object" ? e.batch.multicall : {}, { blockNumber: i, blockTag: s = "latest", data: o, multicallAddress: a, to: c } = t;
  let l = a;
  if (!l) {
    if (!e.chain)
      throw new DF();
    l = Ym({
      blockNumber: i,
      chain: e.chain,
      contract: "multicall3"
    });
  }
  const d = (i ? Tt(i) : void 0) || s, { schedule: f } = zX({
    id: `${e.uid}.${d}`,
    wait: r,
    shouldSplitBatch(g) {
      return g.reduce((v, { data: b }) => v + (b.length - 2), 0) > n * 2;
    },
    fn: async (g) => {
      const y = g.map((w) => ({
        allowFailure: !0,
        callData: w.data,
        target: w.to
      })), v = Sf({
        abi: tS,
        args: [y],
        functionName: "aggregate3"
      }), b = await e.request({
        method: "eth_call",
        params: [
          {
            data: v,
            to: l
          },
          d
        ]
      });
      return Km({
        abi: tS,
        args: [y],
        functionName: "aggregate3",
        data: b || "0x"
      });
    }
  }), [{ returnData: p, success: m }] = await f({ data: o, to: c });
  if (!m)
    throw new Hk({ data: p });
  return p === "0x" ? { data: void 0 } : { data: p };
}
function WX(e) {
  var n;
  if (!(e instanceof ze))
    return;
  const t = e.walk();
  return typeof (t == null ? void 0 : t.data) == "object" ? (n = t.data) == null ? void 0 : n.data : t.data;
}
function sI(e) {
  if (!(!e || e.length === 0))
    return e.reduce((t, { slot: n, value: r }) => {
      if (n.length !== 66)
        throw new HB({
          size: n.length,
          targetSize: 66,
          type: "hex"
        });
      if (r.length !== 66)
        throw new HB({
          size: r.length,
          targetSize: 66,
          type: "hex"
        });
      return t[n] = r, t;
    }, {});
}
function GX(e) {
  const { balance: t, nonce: n, state: r, stateDiff: i, code: s } = e, o = {};
  if (s !== void 0 && (o.code = s), t !== void 0 && (o.balance = Tt(t)), n !== void 0 && (o.nonce = Tt(n)), r !== void 0 && (o.state = sI(r)), i !== void 0) {
    if (o.state)
      throw new NX();
    o.stateDiff = sI(i);
  }
  return o;
}
function qX(e) {
  if (!e)
    return;
  const t = {};
  for (const { address: n, ...r } of e) {
    if (!xc(n, { strict: !1 }))
      throw new om({ address: n });
    if (t[n])
      throw new OX({ address: n });
    t[n] = GX(r);
  }
  return t;
}
async function Ac(e, t) {
  const { abi: n, address: r, args: i, functionName: s, ...o } = t, a = Sf({
    abi: n,
    args: i,
    functionName: s
  });
  try {
    const { data: c } = await vt(e, PA, "call")({
      ...o,
      data: a,
      to: r
    });
    return Km({
      abi: n,
      args: i,
      functionName: s,
      data: c || "0x"
    });
  } catch (c) {
    throw iy(c, {
      abi: n,
      address: r,
      args: i,
      docsPath: "/docs/contract/readContract",
      functionName: s
    });
  }
}
async function $X(e, { blockNumber: t, blockTag: n, coinType: r, name: i, gatewayUrls: s, strict: o, universalResolverAddress: a }) {
  let c = a;
  if (!c) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    c = Ym({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const l = Sf({
      abi: eI,
      functionName: "addr",
      ...r != null ? { args: [aw(i), BigInt(r)] } : { args: [aw(i)] }
    }), u = {
      address: c,
      abi: cj,
      functionName: "resolve",
      args: [gu(IA(i)), l],
      blockNumber: t,
      blockTag: n
    }, d = vt(e, Ac, "readContract"), f = s ? await d({
      ...u,
      args: [...u.args, s]
    }) : await d(u);
    if (f[0] === "0x")
      return null;
    const p = Km({
      abi: eI,
      args: r != null ? [aw(i), BigInt(r)] : void 0,
      functionName: "addr",
      data: f[0]
    });
    return p === "0x" || $m(p) === "0x00" ? null : p;
  } catch (l) {
    if (o)
      throw l;
    if (Wk(l, "resolve"))
      return null;
    throw l;
  }
}
class QX extends ze {
  constructor({ data: t }) {
    super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
      metaMessages: [
        "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
        "",
        `Provided data: ${JSON.stringify(t)}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarInvalidMetadataError"
    });
  }
}
class m0 extends ze {
  constructor({ reason: t }) {
    super(`ENS NFT avatar URI is invalid. ${t}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarInvalidNftUriError"
    });
  }
}
class Gk extends ze {
  constructor({ uri: t }) {
    super(`Unable to resolve ENS avatar URI "${t}". The URI may be malformed, invalid, or does not respond with a valid image.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarUriResolutionError"
    });
  }
}
class KX extends ze {
  constructor({ namespace: t }) {
    super(`ENS NFT avatar namespace "${t}" is not supported. Must be "erc721" or "erc1155".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EnsAvatarUnsupportedNamespaceError"
    });
  }
}
const YX = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/, ZX = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/, JX = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/, XX = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function eee(e) {
  try {
    const t = await fetch(e, { method: "HEAD" });
    if (t.status === 200) {
      const n = t.headers.get("content-type");
      return n == null ? void 0 : n.startsWith("image/");
    }
    return !1;
  } catch (t) {
    return typeof t == "object" && typeof t.response < "u" || !globalThis.hasOwnProperty("Image") ? !1 : new Promise((n) => {
      const r = new Image();
      r.onload = () => {
        n(!0);
      }, r.onerror = () => {
        n(!1);
      }, r.src = e;
    });
  }
}
function oI(e, t) {
  return e ? e.endsWith("/") ? e.slice(0, -1) : e : t;
}
function mj({ uri: e, gatewayUrls: t }) {
  const n = JX.test(e);
  if (n)
    return { uri: e, isOnChain: !0, isEncoded: n };
  const r = oI(t == null ? void 0 : t.ipfs, "https://ipfs.io"), i = oI(t == null ? void 0 : t.arweave, "https://arweave.net"), s = e.match(YX), { protocol: o, subpath: a, target: c, subtarget: l = "" } = (s == null ? void 0 : s.groups) || {}, u = o === "ipns:/" || a === "ipns/", d = o === "ipfs:/" || a === "ipfs/" || ZX.test(e);
  if (e.startsWith("http") && !u && !d) {
    let p = e;
    return t != null && t.arweave && (p = e.replace(/https:\/\/arweave.net/g, t == null ? void 0 : t.arweave)), { uri: p, isOnChain: !1, isEncoded: !1 };
  }
  if ((u || d) && c)
    return {
      uri: `${r}/${u ? "ipns" : "ipfs"}/${c}${l}`,
      isOnChain: !1,
      isEncoded: !1
    };
  if (o === "ar:/" && c)
    return {
      uri: `${i}/${c}${l || ""}`,
      isOnChain: !1,
      isEncoded: !1
    };
  let f = e.replace(XX, "");
  if (f.startsWith("<svg") && (f = `data:image/svg+xml;base64,${btoa(f)}`), f.startsWith("data:") || f.startsWith("{"))
    return {
      uri: f,
      isOnChain: !0,
      isEncoded: !1
    };
  throw new Gk({ uri: e });
}
function gj(e) {
  if (typeof e != "object" || !("image" in e) && !("image_url" in e) && !("image_data" in e))
    throw new QX({ data: e });
  return e.image || e.image_url || e.image_data;
}
async function tee({ gatewayUrls: e, uri: t }) {
  try {
    const n = await fetch(t).then((i) => i.json());
    return await qk({
      gatewayUrls: e,
      uri: gj(n)
    });
  } catch {
    throw new Gk({ uri: t });
  }
}
async function qk({ gatewayUrls: e, uri: t }) {
  const { uri: n, isOnChain: r } = mj({ uri: t, gatewayUrls: e });
  if (r || await eee(n))
    return n;
  throw new Gk({ uri: t });
}
function nee(e) {
  let t = e;
  t.startsWith("did:nft:") && (t = t.replace("did:nft:", "").replace(/_/g, "/"));
  const [n, r, i] = t.split("/"), [s, o] = n.split(":"), [a, c] = r.split(":");
  if (!s || s.toLowerCase() !== "eip155")
    throw new m0({ reason: "Only EIP-155 supported" });
  if (!o)
    throw new m0({ reason: "Chain ID not found" });
  if (!c)
    throw new m0({
      reason: "Contract address not found"
    });
  if (!i)
    throw new m0({ reason: "Token ID not found" });
  if (!a)
    throw new m0({ reason: "ERC namespace not found" });
  return {
    chainID: parseInt(o),
    namespace: a.toLowerCase(),
    contractAddress: c,
    tokenID: i
  };
}
async function ree(e, { nft: t }) {
  if (t.namespace === "erc721")
    return Ac(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "tokenURI",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "tokenId", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "tokenURI",
      args: [BigInt(t.tokenID)]
    });
  if (t.namespace === "erc1155")
    return Ac(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "uri",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "_id", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "uri",
      args: [BigInt(t.tokenID)]
    });
  throw new KX({ namespace: t.namespace });
}
async function iee(e, { gatewayUrls: t, record: n }) {
  return /eip155:/i.test(n) ? see(e, { gatewayUrls: t, record: n }) : qk({ uri: n, gatewayUrls: t });
}
async function see(e, { gatewayUrls: t, record: n }) {
  const r = nee(n), i = await ree(e, { nft: r }), { uri: s, isOnChain: o, isEncoded: a } = mj({ uri: i, gatewayUrls: t });
  if (o && (s.includes("data:application/json;base64,") || s.startsWith("{"))) {
    const l = a ? (
      // if it is encoded, decode it
      atob(s.replace("data:application/json;base64,", ""))
    ) : (
      // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
      s
    ), u = JSON.parse(l);
    return qk({ uri: gj(u), gatewayUrls: t });
  }
  let c = r.tokenID;
  return r.namespace === "erc1155" && (c = c.replace("0x", "").padStart(64, "0")), tee({
    gatewayUrls: t,
    uri: s.replace(/(?:0x)?{id}/, c)
  });
}
async function yj(e, { blockNumber: t, blockTag: n, name: r, key: i, gatewayUrls: s, strict: o, universalResolverAddress: a }) {
  let c = a;
  if (!c) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    c = Ym({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const l = {
      address: c,
      abi: cj,
      functionName: "resolve",
      args: [
        gu(IA(r)),
        Sf({
          abi: XB,
          functionName: "text",
          args: [aw(r), i]
        })
      ],
      blockNumber: t,
      blockTag: n
    }, u = vt(e, Ac, "readContract"), d = s ? await u({
      ...l,
      args: [...l.args, s]
    }) : await u(l);
    if (d[0] === "0x")
      return null;
    const f = Km({
      abi: XB,
      functionName: "text",
      data: d[0]
    });
    return f === "" ? null : f;
  } catch (l) {
    if (o)
      throw l;
    if (Wk(l, "resolve"))
      return null;
    throw l;
  }
}
async function bj(e, { blockNumber: t, blockTag: n, assetGatewayUrls: r, name: i, gatewayUrls: s, strict: o, universalResolverAddress: a }) {
  const c = await vt(e, yj, "getEnsText")({
    blockNumber: t,
    blockTag: n,
    key: "avatar",
    name: i,
    universalResolverAddress: a,
    gatewayUrls: s,
    strict: o
  });
  if (!c)
    return null;
  try {
    return await iee(e, {
      record: c,
      gatewayUrls: r
    });
  } catch {
    return null;
  }
}
async function vj(e, { address: t, blockNumber: n, blockTag: r, gatewayUrls: i, strict: s, universalResolverAddress: o }) {
  let a = o;
  if (!a) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    a = Ym({
      blockNumber: n,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  const c = `${t.toLowerCase().substring(2)}.addr.reverse`;
  try {
    const l = {
      address: a,
      abi: uX,
      functionName: "reverse",
      args: [gu(IA(c))],
      blockNumber: n,
      blockTag: r
    }, u = vt(e, Ac, "readContract"), [d, f] = i ? await u({
      ...l,
      args: [...l.args, i]
    }) : await u(l);
    return t.toLowerCase() !== f.toLowerCase() ? null : d;
  } catch (l) {
    if (s)
      throw l;
    if (Wk(l, "reverse"))
      return null;
    throw l;
  }
}
async function oee(e, { blockNumber: t, blockTag: n, name: r, universalResolverAddress: i }) {
  let s = i;
  if (!s) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    s = Ym({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  const [o] = await vt(e, Ac, "readContract")({
    address: s,
    abi: [
      {
        inputs: [{ type: "bytes" }],
        name: "findResolver",
        outputs: [{ type: "address" }, { type: "bytes32" }],
        stateMutability: "view",
        type: "function"
      }
    ],
    functionName: "findResolver",
    args: [gu(IA(r))],
    blockNumber: t,
    blockTag: n
  });
  return o;
}
function OA(e, { method: t }) {
  var r, i;
  const n = {};
  return e.transport.type === "fallback" && ((i = (r = e.transport).onResponse) == null || i.call(r, ({ method: s, response: o, status: a, transport: c }) => {
    a === "success" && t === s && (n[o] = c.request);
  })), (s) => n[s] || e.request;
}
async function aee(e) {
  const t = OA(e, {
    method: "eth_newBlockFilter"
  }), n = await e.request({
    method: "eth_newBlockFilter"
  });
  return { id: n, request: t(n), type: "block" };
}
class cee extends ze {
  constructor(t) {
    super(`Filter type "${t}" is not supported.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FilterTypeNotSupportedError"
    });
  }
}
const aI = "/docs/contract/encodeEventTopics";
function rv(e) {
  var c;
  const { abi: t, eventName: n, args: r } = e;
  let i = t[0];
  if (n) {
    const l = nv({ abi: t, name: n });
    if (!l)
      throw new qB(n, { docsPath: aI });
    i = l;
  }
  if (i.type !== "event")
    throw new qB(void 0, { docsPath: aI });
  const s = vc(i), o = Lk(s);
  let a = [];
  if (r && "inputs" in i) {
    const l = (c = i.inputs) == null ? void 0 : c.filter((d) => "indexed" in d && d.indexed), u = Array.isArray(r) ? r : Object.values(r).length > 0 ? (l == null ? void 0 : l.map((d) => r[d.name])) ?? [] : [];
    u.length > 0 && (a = (l == null ? void 0 : l.map((d, f) => Array.isArray(u[f]) ? u[f].map((p, m) => cI({ param: d, value: u[f][m] })) : u[f] ? cI({ param: d, value: u[f] }) : null)) ?? []);
  }
  return [o, ...a];
}
function cI({ param: e, value: t }) {
  if (e.type === "string" || e.type === "bytes")
    return ki(Yl(t));
  if (e.type === "tuple" || e.type.match(/^(.*)\[(\d+)?\]$/))
    throw new cee(e.type);
  return tv([e], [t]);
}
async function wj(e, t) {
  const { address: n, abi: r, args: i, eventName: s, fromBlock: o, strict: a, toBlock: c } = t, l = OA(e, {
    method: "eth_newFilter"
  }), u = s ? rv({
    abi: r,
    args: i,
    eventName: s
  }) : void 0, d = await e.request({
    method: "eth_newFilter",
    params: [
      {
        address: n,
        fromBlock: typeof o == "bigint" ? Tt(o) : o,
        toBlock: typeof c == "bigint" ? Tt(c) : c,
        topics: u
      }
    ]
  });
  return {
    abi: r,
    args: i,
    eventName: s,
    id: d,
    request: l(d),
    strict: !!a,
    type: "event"
  };
}
async function xj(e, { address: t, args: n, event: r, events: i, fromBlock: s, strict: o, toBlock: a } = {}) {
  const c = i ?? (r ? [r] : void 0), l = OA(e, {
    method: "eth_newFilter"
  });
  let u = [];
  c && (u = [
    c.flatMap((f) => rv({
      abi: [f],
      eventName: f.name,
      args: n
    }))
  ], r && (u = u[0]));
  const d = await e.request({
    method: "eth_newFilter",
    params: [
      {
        address: t,
        fromBlock: typeof s == "bigint" ? Tt(s) : s,
        toBlock: typeof a == "bigint" ? Tt(a) : a,
        ...u.length ? { topics: u } : {}
      }
    ]
  });
  return {
    abi: c,
    args: n,
    eventName: r ? r.name : void 0,
    fromBlock: s,
    id: d,
    request: l(d),
    strict: !!o,
    toBlock: a,
    type: "event"
  };
}
async function Aj(e) {
  const t = OA(e, {
    method: "eth_newPendingTransactionFilter"
  }), n = await e.request({
    method: "eth_newPendingTransactionFilter"
  });
  return { id: n, request: t(n), type: "transaction" };
}
async function lee(e, t) {
  const { abi: n, address: r, args: i, functionName: s, ...o } = t, a = Sf({
    abi: n,
    args: i,
    functionName: s
  });
  try {
    return await vt(e, Dk, "estimateGas")({
      data: a,
      to: r,
      ...o
    });
  } catch (c) {
    const l = o.account ? Ea(o.account) : void 0;
    throw iy(c, {
      abi: n,
      address: r,
      args: i,
      docsPath: "/docs/contract/estimateContractGas",
      functionName: s,
      sender: l == null ? void 0 : l.address
    });
  }
}
async function Ej(e, { address: t, blockNumber: n, blockTag: r = "latest" }) {
  const i = n ? Tt(n) : void 0, s = await e.request({
    method: "eth_getBalance",
    params: [t, i || r]
  });
  return BigInt(s);
}
async function uee(e) {
  const t = await e.request({
    method: "eth_blobBaseFee"
  });
  return BigInt(t);
}
const dee = /* @__PURE__ */ new Map(), fee = /* @__PURE__ */ new Map();
function hee(e) {
  const t = (i, s) => ({
    clear: () => s.delete(i),
    get: () => s.get(i),
    set: (o) => s.set(i, o)
  }), n = t(e, dee), r = t(e, fee);
  return {
    clear: () => {
      n.clear(), r.clear();
    },
    promise: n,
    response: r
  };
}
async function pee(e, { cacheKey: t, cacheTime: n = 1 / 0 }) {
  const r = hee(t), i = r.response.get();
  if (i && n > 0 && (/* @__PURE__ */ new Date()).getTime() - i.created.getTime() < n)
    return i.data;
  let s = r.promise.get();
  s || (s = e(), r.promise.set(s));
  try {
    const o = await s;
    return r.response.set({ created: /* @__PURE__ */ new Date(), data: o }), o;
  } finally {
    r.promise.clear();
  }
}
const mee = (e) => `blockNumber.${e}`;
async function iv(e, { cacheTime: t = e.cacheTime } = {}) {
  const n = await pee(() => e.request({
    method: "eth_blockNumber"
  }), { cacheKey: mee(e.uid), cacheTime: t });
  return BigInt(n);
}
async function gee(e, { blockHash: t, blockNumber: n, blockTag: r = "latest" } = {}) {
  const i = n !== void 0 ? Tt(n) : void 0;
  let s;
  return t ? s = await e.request({
    method: "eth_getBlockTransactionCountByHash",
    params: [t]
  }) : s = await e.request({
    method: "eth_getBlockTransactionCountByNumber",
    params: [i || r]
  }), Jl(s);
}
async function yee(e, { address: t, blockNumber: n, blockTag: r = "latest" }) {
  const i = n !== void 0 ? Tt(n) : void 0, s = await e.request({
    method: "eth_getCode",
    params: [t, i || r]
  });
  if (s !== "0x")
    return s;
}
const lI = "/docs/contract/decodeEventLog";
function $k(e) {
  const { abi: t, data: n, strict: r, topics: i } = e, s = r ?? !0, [o, ...a] = i;
  if (!o)
    throw new UZ({ docsPath: lI });
  const c = t.find((h) => h.type === "event" && o === Lk(vc(h)));
  if (!(c && "name" in c) || c.type !== "event")
    throw new TF(o, { docsPath: lI });
  const { name: l, inputs: u } = c, d = u == null ? void 0 : u.some((h) => !("name" in h && h.name));
  let f = d ? [] : {};
  const p = u.filter((h) => "indexed" in h && h.indexed);
  for (let h = 0; h < p.length; h++) {
    const g = p[h], y = a[h];
    if (!y)
      throw new SA({
        abiItem: c,
        param: g
      });
    f[d ? h : g.name || h] = bee({ param: g, value: y });
  }
  const m = u.filter((h) => !("indexed" in h && h.indexed));
  if (m.length > 0) {
    if (n && n !== "0x")
      try {
        const h = BA(m, n);
        if (h)
          if (d)
            f = [...f, ...h];
          else
            for (let g = 0; g < m.length; g++)
              f[m[g].name] = h[g];
      } catch (h) {
        if (s)
          throw h instanceof SF || h instanceof ij ? new Wg({
            abiItem: c,
            data: n,
            params: m,
            size: Zn(n)
          }) : h;
      }
    else if (s)
      throw new Wg({
        abiItem: c,
        data: "0x",
        params: m,
        size: 0
      });
  }
  return {
    eventName: l,
    args: Object.values(f).length > 0 ? f : void 0
  };
}
function bee({ param: e, value: t }) {
  return e.type === "string" || e.type === "bytes" || e.type === "tuple" || e.type.match(/^(.*)\[(\d+)?\]$/) ? t : (BA([e], t) || [])[0];
}
function Qk({ abi: e, eventName: t, logs: n, strict: r = !0 }) {
  return n.map((i) => {
    var s;
    try {
      const o = $k({
        ...i,
        abi: e,
        strict: r
      });
      return t && !t.includes(o.eventName) ? null : { ...o, ...i };
    } catch (o) {
      let a, c;
      if (o instanceof TF)
        return null;
      if (o instanceof Wg || o instanceof SA) {
        if (r)
          return null;
        a = o.abiItem.name, c = (s = o.abiItem.inputs) == null ? void 0 : s.some((l) => !("name" in l && l.name));
      }
      return { ...i, args: c ? [] : {}, eventName: a };
    }
  }).filter(Boolean);
}
function eu(e, { args: t, eventName: n } = {}) {
  return {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    logIndex: e.logIndex ? Number(e.logIndex) : null,
    transactionHash: e.transactionHash ? e.transactionHash : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    ...n ? { args: t, eventName: n } : {}
  };
}
async function Kk(e, { address: t, blockHash: n, fromBlock: r, toBlock: i, event: s, events: o, args: a, strict: c } = {}) {
  const l = c ?? !1, u = o ?? (s ? [s] : void 0);
  let d = [];
  u && (d = [
    u.flatMap((m) => rv({
      abi: [m],
      eventName: m.name,
      args: a
    }))
  ], s && (d = d[0]));
  let f;
  n ? f = await e.request({
    method: "eth_getLogs",
    params: [{ address: t, topics: d, blockHash: n }]
  }) : f = await e.request({
    method: "eth_getLogs",
    params: [
      {
        address: t,
        topics: d,
        fromBlock: typeof r == "bigint" ? Tt(r) : r,
        toBlock: typeof i == "bigint" ? Tt(i) : i
      }
    ]
  });
  const p = f.map((m) => eu(m));
  return u ? Qk({
    abi: u,
    logs: p,
    strict: l
  }) : p;
}
async function _j(e, t) {
  const { abi: n, address: r, args: i, blockHash: s, eventName: o, fromBlock: a, toBlock: c, strict: l } = t, u = o ? nv({ abi: n, name: o }) : void 0, d = u ? void 0 : n.filter((f) => f.type === "event");
  return vt(e, Kk, "getLogs")({
    address: r,
    args: i,
    blockHash: s,
    event: u,
    events: d,
    fromBlock: a,
    toBlock: c,
    strict: l
  });
}
function vee(e) {
  var t;
  return {
    baseFeePerGas: e.baseFeePerGas.map((n) => BigInt(n)),
    gasUsedRatio: e.gasUsedRatio,
    oldestBlock: BigInt(e.oldestBlock),
    reward: (t = e.reward) == null ? void 0 : t.map((n) => n.map((r) => BigInt(r)))
  };
}
async function wee(e, { blockCount: t, blockNumber: n, blockTag: r = "latest", rewardPercentiles: i }) {
  const s = n ? Tt(n) : void 0, o = await e.request({
    method: "eth_feeHistory",
    params: [
      Tt(t),
      s || r,
      i
    ]
  });
  return vee(o);
}
async function NA(e, { filter: t }) {
  const n = "strict" in t && t.strict, r = await t.request({
    method: "eth_getFilterChanges",
    params: [t.id]
  });
  if (typeof r[0] == "string")
    return r;
  const i = r.map((s) => eu(s));
  return !("abi" in t) || !t.abi ? i : Qk({
    abi: t.abi,
    logs: i,
    strict: n
  });
}
async function xee(e, { filter: t }) {
  const n = t.strict ?? !1, i = (await t.request({
    method: "eth_getFilterLogs",
    params: [t.id]
  })).map((s) => eu(s));
  return t.abi ? Qk({
    abi: t.abi,
    logs: i,
    strict: n
  }) : i;
}
async function Aee(e, { address: t, blockNumber: n, blockTag: r = "latest", slot: i }) {
  const s = n !== void 0 ? Tt(n) : void 0;
  return await e.request({
    method: "eth_getStorageAt",
    params: [t, i, s || r]
  });
}
async function Yk(e, { blockHash: t, blockNumber: n, blockTag: r, hash: i, index: s }) {
  var u, d, f;
  const o = r || "latest", a = n !== void 0 ? Tt(n) : void 0;
  let c = null;
  if (i ? c = await e.request({
    method: "eth_getTransactionByHash",
    params: [i]
  }) : t ? c = await e.request({
    method: "eth_getTransactionByBlockHashAndIndex",
    params: [t, Tt(s)]
  }) : (a || o) && (c = await e.request({
    method: "eth_getTransactionByBlockNumberAndIndex",
    params: [a || o, Tt(s)]
  })), !c)
    throw new LF({
      blockHash: t,
      blockNumber: n,
      blockTag: o,
      hash: i,
      index: s
    });
  return (((f = (d = (u = e.chain) == null ? void 0 : u.formatters) == null ? void 0 : d.transaction) == null ? void 0 : f.format) || KF)(c);
}
async function Eee(e, { hash: t, transactionReceipt: n }) {
  const [r, i] = await Promise.all([
    vt(e, iv, "getBlockNumber")({}),
    t ? vt(e, Yk, "getBlockNumber")({ hash: t }) : void 0
  ]), s = (n == null ? void 0 : n.blockNumber) || (i == null ? void 0 : i.blockNumber);
  return s ? r - s + 1n : 0n;
}
const _ee = {
  "0x0": "reverted",
  "0x1": "success"
};
function See(e) {
  const t = {
    ...e,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    contractAddress: e.contractAddress ? e.contractAddress : null,
    cumulativeGasUsed: e.cumulativeGasUsed ? BigInt(e.cumulativeGasUsed) : null,
    effectiveGasPrice: e.effectiveGasPrice ? BigInt(e.effectiveGasPrice) : null,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : null,
    logs: e.logs ? e.logs.map((n) => eu(n)) : null,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? Jl(e.transactionIndex) : null,
    status: e.status ? _ee[e.status] : null,
    type: e.type ? QF[e.type] || e.type : null
  };
  return e.blobGasPrice && (t.blobGasPrice = BigInt(e.blobGasPrice)), e.blobGasUsed && (t.blobGasUsed = BigInt(e.blobGasUsed)), t;
}
async function oS(e, { hash: t }) {
  var i, s, o;
  const n = await e.request({
    method: "eth_getTransactionReceipt",
    params: [t]
  });
  if (!n)
    throw new zF({ hash: t });
  return (((o = (s = (i = e.chain) == null ? void 0 : i.formatters) == null ? void 0 : s.transactionReceipt) == null ? void 0 : o.format) || See)(n);
}
async function Sj(e, t) {
  var g;
  const { allowFailure: n = !0, batchSize: r, blockNumber: i, blockTag: s, multicallAddress: o, stateOverride: a } = t, c = t.contracts, l = r ?? (typeof ((g = e.batch) == null ? void 0 : g.multicall) == "object" && e.batch.multicall.batchSize || 1024);
  let u = o;
  if (!u) {
    if (!e.chain)
      throw new Error("client chain not configured. multicallAddress is required.");
    u = Ym({
      blockNumber: i,
      chain: e.chain,
      contract: "multicall3"
    });
  }
  const d = [[]];
  let f = 0, p = 0;
  for (let y = 0; y < c.length; y++) {
    const { abi: v, address: b, args: w, functionName: A } = c[y];
    try {
      const E = Sf({ abi: v, args: w, functionName: A });
      p += (E.length - 2) / 2, // Check if batching is enabled.
      l > 0 && // Check if the current size of the batch exceeds the size limit.
      p > l && // Check if the current chunk is not already empty.
      d[f].length > 0 && (f++, p = (E.length - 2) / 2, d[f] = []), d[f] = [
        ...d[f],
        {
          allowFailure: !0,
          callData: E,
          target: b
        }
      ];
    } catch (E) {
      const x = iy(E, {
        abi: v,
        address: b,
        args: w,
        docsPath: "/docs/contract/multicall",
        functionName: A
      });
      if (!n)
        throw x;
      d[f] = [
        ...d[f],
        {
          allowFailure: !0,
          callData: "0x",
          target: b
        }
      ];
    }
  }
  const m = await Promise.allSettled(d.map((y) => vt(e, Ac, "readContract")({
    abi: tS,
    address: u,
    args: [y],
    blockNumber: i,
    blockTag: s,
    functionName: "aggregate3",
    stateOverride: a
  }))), h = [];
  for (let y = 0; y < m.length; y++) {
    const v = m[y];
    if (v.status === "rejected") {
      if (!n)
        throw v.reason;
      for (let w = 0; w < d[y].length; w++)
        h.push({
          status: "failure",
          error: v.reason,
          result: void 0
        });
      continue;
    }
    const b = v.value;
    for (let w = 0; w < b.length; w++) {
      const { returnData: A, success: E } = b[w], { callData: x } = d[y][w], { abi: S, address: P, functionName: I, args: R } = c[h.length];
      try {
        if (x === "0x")
          throw new _A();
        if (!E)
          throw new Hk({ data: A });
        const Q = Km({
          abi: S,
          args: R,
          data: A,
          functionName: I
        });
        h.push(n ? { result: Q, status: "success" } : Q);
      } catch (Q) {
        const J = iy(Q, {
          abi: S,
          address: P,
          args: R,
          docsPath: "/docs/contract/multicall",
          functionName: I
        });
        if (!n)
          throw J;
        h.push({ error: J, result: void 0, status: "failure" });
      }
    }
  }
  if (h.length !== c.length)
    throw new ze("multicall results mismatch");
  return h;
}
const S3 = /* @__PURE__ */ new Map(), uI = /* @__PURE__ */ new Map();
let Cee = 0;
function tu(e, t, n) {
  const r = ++Cee, i = () => S3.get(e) || [], s = () => {
    const u = i();
    S3.set(e, u.filter((d) => d.id !== r));
  }, o = () => {
    const u = uI.get(e);
    i().length === 1 && u && u(), s();
  }, a = i();
  if (S3.set(e, [
    ...a,
    { id: r, fns: t }
  ]), a && a.length > 0)
    return o;
  const c = {};
  for (const u in t)
    c[u] = (...d) => {
      var p, m;
      const f = i();
      if (f.length !== 0)
        for (const h of f)
          (m = (p = h.fns)[u]) == null || m.call(p, ...d);
    };
  const l = n(c);
  return typeof l == "function" && uI.set(e, l), o;
}
async function aS(e) {
  return new Promise((t) => setTimeout(t, e));
}
function sv(e, { emitOnBegin: t, initialWaitTime: n, interval: r }) {
  let i = !0;
  const s = () => i = !1;
  return (async () => {
    let a;
    t && (a = await e({ unpoll: s }));
    const c = await (n == null ? void 0 : n(a)) ?? r;
    await aS(c);
    const l = async () => {
      i && (await e({ unpoll: s }), await aS(r), l());
    };
    l();
  })(), s;
}
function Tee(e, { blockTag: t = "latest", emitMissed: n = !1, emitOnBegin: r = !1, onBlock: i, onError: s, includeTransactions: o, poll: a, pollingInterval: c = e.pollingInterval }) {
  const l = typeof a < "u" ? a : !(e.transport.type === "webSocket" || e.transport.type === "fallback" && e.transport.transports[0].config.type === "webSocket"), u = o ?? !1;
  let d;
  return l ? (() => {
    const m = po([
      "watchBlocks",
      e.uid,
      t,
      n,
      r,
      u,
      c
    ]);
    return tu(m, { onBlock: i, onError: s }, (h) => sv(async () => {
      var g;
      try {
        const y = await vt(e, Xl, "getBlock")({
          blockTag: t,
          includeTransactions: u
        });
        if (y.number && (d != null && d.number)) {
          if (y.number === d.number)
            return;
          if (y.number - d.number > 1 && n)
            for (let v = (d == null ? void 0 : d.number) + 1n; v < y.number; v++) {
              const b = await vt(e, Xl, "getBlock")({
                blockNumber: v,
                includeTransactions: u
              });
              h.onBlock(b, d), d = b;
            }
        }
        // If no previous block exists, emit.
        (!(d != null && d.number) || // If the block tag is "pending" with no block number, emit.
        t === "pending" && !(y != null && y.number) || // If the next block number is greater than the previous block number, emit.
        // We don't want to emit blocks in the past.
        y.number && y.number > d.number) && (h.onBlock(y, d), d = y);
      } catch (y) {
        (g = h.onError) == null || g.call(h, y);
      }
    }, {
      emitOnBegin: r,
      interval: c
    }));
  })() : (() => {
    let m = !0, h = () => m = !1;
    return (async () => {
      try {
        const g = (() => {
          if (e.transport.type === "fallback") {
            const v = e.transport.transports.find((b) => b.config.type === "webSocket");
            return v ? v.value : e.transport;
          }
          return e.transport;
        })(), { unsubscribe: y } = await g.subscribe({
          params: ["newHeads"],
          onData(v) {
            var A, E, x;
            if (!m)
              return;
            const w = (((x = (E = (A = e.chain) == null ? void 0 : A.formatters) == null ? void 0 : E.block) == null ? void 0 : x.format) || YF)(v.result);
            i(w, d), d = w;
          },
          onError(v) {
            s == null || s(v);
          }
        });
        h = y, m || h();
      } catch (g) {
        s == null || s(g);
      }
    })(), () => h();
  })();
}
function Cj(e, { emitOnBegin: t = !1, emitMissed: n = !1, onBlockNumber: r, onError: i, poll: s, pollingInterval: o = e.pollingInterval }) {
  const a = typeof s < "u" ? s : !(e.transport.type === "webSocket" || e.transport.type === "fallback" && e.transport.transports[0].config.type === "webSocket");
  let c;
  return a ? (() => {
    const d = po([
      "watchBlockNumber",
      e.uid,
      t,
      n,
      o
    ]);
    return tu(d, { onBlockNumber: r, onError: i }, (f) => sv(async () => {
      var p;
      try {
        const m = await vt(e, iv, "getBlockNumber")({ cacheTime: 0 });
        if (c) {
          if (m === c)
            return;
          if (m - c > 1 && n)
            for (let h = c + 1n; h < m; h++)
              f.onBlockNumber(h, c), c = h;
        }
        (!c || m > c) && (f.onBlockNumber(m, c), c = m);
      } catch (m) {
        (p = f.onError) == null || p.call(f, m);
      }
    }, {
      emitOnBegin: t,
      interval: o
    }));
  })() : (() => {
    const d = po([
      "watchBlockNumber",
      e.uid,
      t,
      n
    ]);
    return tu(d, { onBlockNumber: r, onError: i }, (f) => {
      let p = !0, m = () => p = !1;
      return (async () => {
        try {
          const h = (() => {
            if (e.transport.type === "fallback") {
              const y = e.transport.transports.find((v) => v.config.type === "webSocket");
              return y ? y.value : e.transport;
            }
            return e.transport;
          })(), { unsubscribe: g } = await h.subscribe({
            params: ["newHeads"],
            onData(y) {
              var b;
              if (!p)
                return;
              const v = sm((b = y.result) == null ? void 0 : b.number);
              f.onBlockNumber(v, c), c = v;
            },
            onError(y) {
              var v;
              (v = f.onError) == null || v.call(f, y);
            }
          });
          m = g, p || m();
        } catch (h) {
          i == null || i(h);
        }
      })(), () => m();
    });
  })();
}
async function RA(e, { filter: t }) {
  return t.request({
    method: "eth_uninstallFilter",
    params: [t.id]
  });
}
function kee(e, { address: t, args: n, batch: r = !0, event: i, events: s, fromBlock: o, onError: a, onLogs: c, poll: l, pollingInterval: u = e.pollingInterval, strict: d }) {
  const f = typeof l < "u" ? l : typeof o == "bigint" ? !0 : !(e.transport.type === "webSocket" || e.transport.type === "fallback" && e.transport.transports[0].config.type === "webSocket"), p = d ?? !1;
  return f ? (() => {
    const g = po([
      "watchEvent",
      t,
      n,
      r,
      e.uid,
      i,
      u,
      o
    ]);
    return tu(g, { onLogs: c, onError: a }, (y) => {
      let v;
      o !== void 0 && (v = o - 1n);
      let b, w = !1;
      const A = sv(async () => {
        var E;
        if (!w) {
          try {
            b = await vt(e, xj, "createEventFilter")({
              address: t,
              args: n,
              event: i,
              events: s,
              strict: p,
              fromBlock: o
            });
          } catch {
          }
          w = !0;
          return;
        }
        try {
          let x;
          if (b)
            x = await vt(e, NA, "getFilterChanges")({ filter: b });
          else {
            const S = await vt(e, iv, "getBlockNumber")({});
            v && v !== S ? x = await vt(e, Kk, "getLogs")({
              address: t,
              args: n,
              event: i,
              events: s,
              fromBlock: v + 1n,
              toBlock: S
            }) : x = [], v = S;
          }
          if (x.length === 0)
            return;
          if (r)
            y.onLogs(x);
          else
            for (const S of x)
              y.onLogs([S]);
        } catch (x) {
          b && x instanceof tf && (w = !1), (E = y.onError) == null || E.call(y, x);
        }
      }, {
        emitOnBegin: !0,
        interval: u
      });
      return async () => {
        b && await vt(e, RA, "uninstallFilter")({ filter: b }), A();
      };
    });
  })() : (() => {
    let g = !0, y = () => g = !1;
    return (async () => {
      try {
        const v = (() => {
          if (e.transport.type === "fallback") {
            const E = e.transport.transports.find((x) => x.config.type === "webSocket");
            return E ? E.value : e.transport;
          }
          return e.transport;
        })(), b = s ?? (i ? [i] : void 0);
        let w = [];
        b && (w = [
          b.flatMap((E) => rv({
            abi: [E],
            eventName: E.name,
            args: n
          }))
        ], i && (w = w[0]));
        const { unsubscribe: A } = await v.subscribe({
          params: ["logs", { address: t, topics: w }],
          onData(E) {
            var S;
            if (!g)
              return;
            const x = E.result;
            try {
              const { eventName: P, args: I } = $k({
                abi: b ?? [],
                data: x.data,
                topics: x.topics,
                strict: p
              }), R = eu(x, { args: I, eventName: P });
              c([R]);
            } catch (P) {
              let I, R;
              if (P instanceof Wg || P instanceof SA) {
                if (d)
                  return;
                I = P.abiItem.name, R = (S = P.abiItem.inputs) == null ? void 0 : S.some((J) => !("name" in J && J.name));
              }
              const Q = eu(x, {
                args: R ? [] : {},
                eventName: I
              });
              c([Q]);
            }
          },
          onError(E) {
            a == null || a(E);
          }
        });
        y = A, g || y();
      } catch (v) {
        a == null || a(v);
      }
    })(), () => y();
  })();
}
function Bee(e, { batch: t = !0, onError: n, onTransactions: r, poll: i, pollingInterval: s = e.pollingInterval }) {
  return (typeof i < "u" ? i : e.transport.type !== "webSocket") ? (() => {
    const l = po([
      "watchPendingTransactions",
      e.uid,
      t,
      s
    ]);
    return tu(l, { onTransactions: r, onError: n }, (u) => {
      let d;
      const f = sv(async () => {
        var p;
        try {
          if (!d)
            try {
              d = await vt(e, Aj, "createPendingTransactionFilter")({});
              return;
            } catch (h) {
              throw f(), h;
            }
          const m = await vt(e, NA, "getFilterChanges")({ filter: d });
          if (m.length === 0)
            return;
          if (t)
            u.onTransactions(m);
          else
            for (const h of m)
              u.onTransactions([h]);
        } catch (m) {
          (p = u.onError) == null || p.call(u, m);
        }
      }, {
        emitOnBegin: !0,
        interval: s
      });
      return async () => {
        d && await vt(e, RA, "uninstallFilter")({ filter: d }), f();
      };
    });
  })() : (() => {
    let l = !0, u = () => l = !1;
    return (async () => {
      try {
        const { unsubscribe: d } = await e.transport.subscribe({
          params: ["newPendingTransactions"],
          onData(f) {
            if (!l)
              return;
            const p = f.result;
            r([p]);
          },
          onError(f) {
            n == null || n(f);
          }
        });
        u = d, l || u();
      } catch (d) {
        n == null || n(d);
      }
    })(), () => u();
  })();
}
function _x(e, { delay: t = 100, retryCount: n = 2, shouldRetry: r = () => !0 } = {}) {
  return new Promise((i, s) => {
    const o = async ({ count: a = 0 } = {}) => {
      const c = async ({ error: l }) => {
        const u = typeof t == "function" ? t({ count: a, error: l }) : t;
        u && await aS(u), o({ count: a + 1 });
      };
      try {
        const l = await e();
        i(l);
      } catch (l) {
        if (a < n && await r({ count: a, error: l }))
          return c({ error: l });
        s(l);
      }
    };
    o();
  });
}
function Iee(e, t = {}) {
  return async (n, r = {}) => {
    const { retryDelay: i = 150, retryCount: s = 3 } = {
      ...t,
      ...r
    };
    return _x(async () => {
      try {
        return await e(n);
      } catch (o) {
        const a = o;
        switch (a.code) {
          case Gg.code:
            throw new Gg(a);
          case qg.code:
            throw new qg(a);
          case $g.code:
            throw new $g(a);
          case Qg.code:
            throw new Qg(a);
          case ef.code:
            throw new ef(a);
          case tf.code:
            throw new tf(a);
          case Kg.code:
            throw new Kg(a);
          case Hl.code:
            throw new Hl(a);
          case Yg.code:
            throw new Yg(a);
          case Zg.code:
            throw new Zg(a);
          case cm.code:
            throw new cm(a);
          case Jg.code:
            throw new Jg(a);
          case Lr.code:
            throw new Lr(a);
          case Xg.code:
            throw new Xg(a);
          case ey.code:
            throw new ey(a);
          case ty.code:
            throw new ty(a);
          case ny.code:
            throw new ny(a);
          case nf.code:
            throw new nf(a);
          case 5e3:
            throw new Lr(a);
          default:
            throw o instanceof ze ? o : new DJ(a);
        }
      }
    }, {
      delay: ({ count: o, error: a }) => {
        var c;
        if (a && a instanceof VF) {
          const l = (c = a == null ? void 0 : a.headers) == null ? void 0 : c.get("Retry-After");
          if (l != null && l.match(/\d/))
            return parseInt(l) * 1e3;
        }
        return ~~(1 << o) * i;
      },
      retryCount: s,
      shouldRetry: ({ error: o }) => Pee(o)
    });
  };
}
function Pee(e) {
  return "code" in e && typeof e.code == "number" ? e.code === -1 || e.code === cm.code || e.code === ef.code : e instanceof VF && e.status ? e.status === 403 || e.status === 408 || e.status === 413 || e.status === 429 || e.status === 500 || e.status === 502 || e.status === 503 || e.status === 504 : !0;
}
function Oee(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
const Nee = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, Ree = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
function Mee(e, { errorInstance: t = new Error("timed out"), timeout: n, signal: r }) {
  return new Promise((i, s) => {
    (async () => {
      let o;
      try {
        const a = new AbortController();
        n > 0 && (o = setTimeout(() => {
          r ? a.abort() : s(t);
        }, n)), i(await e({ signal: (a == null ? void 0 : a.signal) || null }));
      } catch (a) {
        a.name === "AbortError" && s(t), s(a);
      } finally {
        clearTimeout(o);
      }
    })();
  });
}
function Fee(e) {
  const { domain: t = {}, message: n, primaryType: r } = e, i = {
    EIP712Domain: zee({ domain: t }),
    ...e.types
  };
  Lee({
    domain: t,
    message: n,
    primaryType: r,
    types: i
  });
  const s = ["0x1901"];
  return t && s.push(jee({
    domain: t,
    types: i
  })), r !== "EIP712Domain" && s.push(Tj({
    data: n,
    primaryType: r,
    types: i
  })), ki(wc(s));
}
function jee({ domain: e, types: t }) {
  return Tj({
    data: e,
    primaryType: "EIP712Domain",
    types: t
  });
}
function Tj({ data: e, primaryType: t, types: n }) {
  const r = kj({
    data: e,
    primaryType: t,
    types: n
  });
  return ki(r);
}
function kj({ data: e, primaryType: t, types: n }) {
  const r = [{ type: "bytes32" }], i = [Dee({ primaryType: t, types: n })];
  for (const s of n[t]) {
    const [o, a] = Ij({
      types: n,
      name: s.name,
      type: s.type,
      value: e[s.name]
    });
    r.push(o), i.push(a);
  }
  return tv(r, i);
}
function Dee({ primaryType: e, types: t }) {
  const n = gu(Uee({ primaryType: e, types: t }));
  return ki(n);
}
function Uee({ primaryType: e, types: t }) {
  let n = "";
  const r = Bj({ primaryType: e, types: t });
  r.delete(e);
  const i = [e, ...Array.from(r).sort()];
  for (const s of i)
    n += `${s}(${t[s].map(({ name: o, type: a }) => `${a} ${o}`).join(",")})`;
  return n;
}
function Bj({ primaryType: e, types: t }, n = /* @__PURE__ */ new Set()) {
  const r = e.match(/^\w*/u), i = r == null ? void 0 : r[0];
  if (n.has(i) || t[i] === void 0)
    return n;
  n.add(i);
  for (const s of t[i])
    Bj({ primaryType: s.type, types: t }, n);
  return n;
}
function Ij({ types: e, name: t, type: n, value: r }) {
  if (e[n] !== void 0)
    return [
      { type: "bytes32" },
      ki(kj({ data: r, primaryType: n, types: e }))
    ];
  if (n === "bytes")
    return r = `0x${(r.length % 2 ? "0" : "") + r.slice(2)}`, [{ type: "bytes32" }, ki(r)];
  if (n === "string")
    return [{ type: "bytes32" }, ki(gu(r))];
  if (n.lastIndexOf("]") === n.length - 1) {
    const i = n.slice(0, n.lastIndexOf("[")), s = r.map((o) => Ij({
      name: t,
      type: i,
      types: e,
      value: o
    }));
    return [
      { type: "bytes32" },
      ki(tv(s.map(([o]) => o), s.map(([, o]) => o)))
    ];
  }
  return [{ type: n }, r];
}
function Lee(e) {
  const { domain: t, message: n, primaryType: r, types: i } = e, s = (o, a) => {
    for (const c of o) {
      const { name: l, type: u } = c, d = a[l], f = u.match(Ree);
      if (f && (typeof d == "number" || typeof d == "bigint")) {
        const [h, g, y] = f;
        Tt(d, {
          signed: g === "int",
          size: parseInt(y) / 8
        });
      }
      if (u === "address" && typeof d == "string" && !xc(d))
        throw new om({ address: d });
      const p = u.match(Nee);
      if (p) {
        const [h, g] = p;
        if (g && Zn(d) !== parseInt(g))
          throw new VZ({
            expectedSize: parseInt(g),
            givenSize: Zn(d)
          });
      }
      const m = i[u];
      m && s(m, d);
    }
  };
  if (i.EIP712Domain && t && s(i.EIP712Domain, t), r !== "EIP712Domain") {
    const o = i[r];
    s(o, n);
  }
}
function zee({ domain: e }) {
  return [
    typeof (e == null ? void 0 : e.name) == "string" && { name: "name", type: "string" },
    (e == null ? void 0 : e.version) && { name: "version", type: "string" },
    typeof (e == null ? void 0 : e.chainId) == "number" && {
      name: "chainId",
      type: "uint256"
    },
    (e == null ? void 0 : e.verifyingContract) && {
      name: "verifyingContract",
      type: "address"
    },
    (e == null ? void 0 : e.salt) && { name: "salt", type: "bytes32" }
  ].filter(Boolean);
}
const Vee = `Ethereum Signed Message:
`;
function Hee(e, t) {
  const n = typeof e == "string" ? uc(e) : e.raw instanceof Uint8Array ? e.raw : Yl(e.raw), r = uc(`${Vee}${n.length}`);
  return ki(wc([r, n]), t);
}
function Wee(e) {
  return e.map((t) => ({
    ...t,
    value: BigInt(t.value)
  }));
}
function Gee(e) {
  return {
    ...e,
    balance: e.balance ? BigInt(e.balance) : void 0,
    nonce: e.nonce ? Jl(e.nonce) : void 0,
    storageProof: e.storageProof ? Wee(e.storageProof) : void 0
  };
}
async function qee(e, { address: t, blockNumber: n, blockTag: r, storageKeys: i }) {
  const s = r ?? "latest", o = n !== void 0 ? Tt(n) : void 0, a = await e.request({
    method: "eth_getProof",
    params: [t, i, o || s]
  });
  return Gee(a);
}
async function $ee(e, {
  confirmations: t = 1,
  hash: n,
  onReplaced: r,
  pollingInterval: i = e.pollingInterval,
  retryCount: s = 6,
  retryDelay: o = ({ count: c }) => ~~(1 << c) * 200,
  // exponential backoff
  timeout: a
}) {
  const c = po(["waitForTransactionReceipt", e.uid, n]);
  let l, u, d, f = !1;
  return new Promise((p, m) => {
    a && setTimeout(() => m(new MJ({ hash: n })), a);
    const h = tu(c, { onReplaced: r, resolve: p, reject: m }, (g) => {
      const y = vt(e, Cj, "watchBlockNumber")({
        emitMissed: !0,
        emitOnBegin: !0,
        poll: !0,
        pollingInterval: i,
        async onBlockNumber(v) {
          if (f)
            return;
          let b = v;
          const w = (A) => {
            y(), A(), h();
          };
          try {
            if (d) {
              if (t > 1 && (!d.blockNumber || b - d.blockNumber + 1n < t))
                return;
              w(() => g.resolve(d));
              return;
            }
            if (l || (f = !0, await _x(async () => {
              l = await vt(e, Yk, "getTransaction")({ hash: n }), l.blockNumber && (b = l.blockNumber);
            }, {
              delay: o,
              retryCount: s
            }), f = !1), d = await vt(e, oS, "getTransactionReceipt")({ hash: n }), t > 1 && (!d.blockNumber || b - d.blockNumber + 1n < t))
              return;
            w(() => g.resolve(d));
          } catch (A) {
            if (A instanceof LF || A instanceof zF) {
              if (!l) {
                f = !1;
                return;
              }
              try {
                u = l, f = !0;
                const E = await _x(() => vt(e, Xl, "getBlock")({
                  blockNumber: b,
                  includeTransactions: !0
                }), {
                  delay: o,
                  retryCount: s,
                  shouldRetry: ({ error: P }) => P instanceof $F
                });
                f = !1;
                const x = E.transactions.find(({ from: P, nonce: I }) => P === u.from && I === u.nonce);
                if (!x || (d = await vt(e, oS, "getTransactionReceipt")({
                  hash: x.hash
                }), t > 1 && (!d.blockNumber || b - d.blockNumber + 1n < t)))
                  return;
                let S = "replaced";
                x.to === u.to && x.value === u.value ? S = "repriced" : x.from === x.to && x.value === 0n && (S = "cancelled"), w(() => {
                  var P;
                  (P = g.onReplaced) == null || P.call(g, {
                    reason: S,
                    replacedTransaction: u,
                    transaction: x,
                    transactionReceipt: d
                  }), g.resolve(d);
                });
              } catch (E) {
                w(() => g.reject(E));
              }
            } else
              w(() => g.reject(A));
          }
        }
      });
    });
  });
}
async function Qee(e, { account: t = e.account, message: n }) {
  if (!t)
    throw new BJ({
      docsPath: "/docs/actions/wallet/signMessage"
    });
  const r = Ea(t);
  if (r.type === "local")
    return r.signMessage({ message: n });
  const i = typeof n == "string" ? Ck(n) : n.raw instanceof Uint8Array ? gu(n.raw) : n.raw;
  return e.request({
    method: "personal_sign",
    params: [i, r.address]
  }, { retryCount: 0 });
}
async function Kee(e, t) {
  const { abi: n, address: r, args: i, dataSuffix: s, functionName: o, ...a } = t, c = a.account ? Ea(a.account) : e.account, l = Sf({ abi: n, args: i, functionName: o });
  try {
    const { data: u } = await vt(e, PA, "call")({
      batch: !1,
      data: `${l}${s ? s.replace("0x", "") : ""}`,
      to: r,
      ...a,
      account: c
    }), d = Km({
      abi: n,
      args: i,
      functionName: o,
      data: u || "0x"
    }), f = n.filter((p) => "name" in p && p.name === t.functionName);
    return {
      result: d,
      request: {
        abi: f,
        address: r,
        args: i,
        dataSuffix: s,
        functionName: o,
        ...a,
        account: c
      }
    };
  } catch (u) {
    throw iy(u, {
      abi: n,
      address: r,
      args: i,
      docsPath: "/docs/contract/simulateContract",
      functionName: o,
      sender: c == null ? void 0 : c.address
    });
  }
}
const Yee = "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";
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Pj = BigInt(0), MA = BigInt(1), Zee = BigInt(2), FA = (e) => e instanceof Uint8Array, Jee = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function lm(e) {
  if (!FA(e))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += Jee[e[n]];
  return t;
}
function Oj(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function Zk(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
function um(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(t / 2);
  for (let r = 0; r < n.length; r++) {
    const i = r * 2, s = e.slice(i, i + 2), o = Number.parseInt(s, 16);
    if (Number.isNaN(o) || o < 0)
      throw new Error("Invalid byte sequence");
    n[r] = o;
  }
  return n;
}
function jd(e) {
  return Zk(lm(e));
}
function Jk(e) {
  if (!FA(e))
    throw new Error("Uint8Array expected");
  return Zk(lm(Uint8Array.from(e).reverse()));
}
function dm(e, t) {
  return um(e.toString(16).padStart(t * 2, "0"));
}
function Xk(e, t) {
  return dm(e, t).reverse();
}
function Xee(e) {
  return um(Oj(e));
}
function Ws(e, t, n) {
  let r;
  if (typeof t == "string")
    try {
      r = um(t);
    } catch (s) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${s}`);
    }
  else if (FA(t))
    r = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const i = r.length;
  if (typeof n == "number" && i !== n)
    throw new Error(`${e} expected ${n} bytes, got ${i}`);
  return r;
}
function sy(...e) {
  const t = new Uint8Array(e.reduce((r, i) => r + i.length, 0));
  let n = 0;
  return e.forEach((r) => {
    if (!FA(r))
      throw new Error("Uint8Array expected");
    t.set(r, n), n += r.length;
  }), t;
}
function Nj(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function ete(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function tte(e) {
  let t;
  for (t = 0; e > Pj; e >>= MA, t += 1)
    ;
  return t;
}
function nte(e, t) {
  return e >> BigInt(t) & MA;
}
const rte = (e, t, n) => e | (n ? MA : Pj) << BigInt(t), e5 = (e) => (Zee << BigInt(e - 1)) - MA, C3 = (e) => new Uint8Array(e), dI = (e) => Uint8Array.from(e);
function Rj(e, t, n) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof n != "function")
    throw new Error("hmacFn must be a function");
  let r = C3(e), i = C3(e), s = 0;
  const o = () => {
    r.fill(1), i.fill(0), s = 0;
  }, a = (...d) => n(i, r, ...d), c = (d = C3()) => {
    i = a(dI([0]), d), r = a(), d.length !== 0 && (i = a(dI([1]), d), r = a());
  }, l = () => {
    if (s++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let d = 0;
    const f = [];
    for (; d < t; ) {
      r = a();
      const p = r.slice();
      f.push(p), d += r.length;
    }
    return sy(...f);
  };
  return (d, f) => {
    o(), c(d);
    let p;
    for (; !(p = f(l())); )
      c();
    return o(), p;
  };
}
const ite = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || e instanceof Uint8Array,
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function ov(e, t, n = {}) {
  const r = (i, s, o) => {
    const a = ite[s];
    if (typeof a != "function")
      throw new Error(`Invalid validator "${s}", expected function`);
    const c = e[i];
    if (!(o && c === void 0) && !a(c, e))
      throw new Error(`Invalid param ${String(i)}=${c} (${typeof c}), expected ${s}`);
  };
  for (const [i, s] of Object.entries(t))
    r(i, s, !1);
  for (const [i, s] of Object.entries(n))
    r(i, s, !0);
  return e;
}
const ste = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: nte,
  bitLen: tte,
  bitMask: e5,
  bitSet: rte,
  bytesToHex: lm,
  bytesToNumberBE: jd,
  bytesToNumberLE: Jk,
  concatBytes: sy,
  createHmacDrbg: Rj,
  ensureBytes: Ws,
  equalBytes: Nj,
  hexToBytes: um,
  hexToNumber: Zk,
  numberToBytesBE: dm,
  numberToBytesLE: Xk,
  numberToHexUnpadded: Oj,
  numberToVarBytesBE: Xee,
  utf8ToBytes: ete,
  validateObject: ov
}, Symbol.toStringTag, { value: "Module" }));
function ote(e, t) {
  const n = ya(e) ? Yl(e) : e, r = ya(t) ? Yl(t) : t;
  return Nj(n, r);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const hr = BigInt(0), Dn = BigInt(1), Du = BigInt(2), ate = BigInt(3), cS = BigInt(4), fI = BigInt(5), hI = BigInt(8);
BigInt(9);
BigInt(16);
function Ei(e, t) {
  const n = e % t;
  return n >= hr ? n : t + n;
}
function cte(e, t, n) {
  if (n <= hr || t < hr)
    throw new Error("Expected power/modulo > 0");
  if (n === Dn)
    return hr;
  let r = Dn;
  for (; t > hr; )
    t & Dn && (r = r * e % n), e = e * e % n, t >>= Dn;
  return r;
}
function is(e, t, n) {
  let r = e;
  for (; t-- > hr; )
    r *= r, r %= n;
  return r;
}
function lS(e, t) {
  if (e === hr || t <= hr)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let n = Ei(e, t), r = t, i = hr, s = Dn;
  for (; n !== hr; ) {
    const a = r / n, c = r % n, l = i - s * a;
    r = n, n = c, i = s, s = l;
  }
  if (r !== Dn)
    throw new Error("invert: does not exist");
  return Ei(i, t);
}
function lte(e) {
  const t = (e - Dn) / Du;
  let n, r, i;
  for (n = e - Dn, r = 0; n % Du === hr; n /= Du, r++)
    ;
  for (i = Du; i < e && cte(i, t, e) !== e - Dn; i++)
    ;
  if (r === 1) {
    const o = (e + Dn) / cS;
    return function(c, l) {
      const u = c.pow(l, o);
      if (!c.eql(c.sqr(u), l))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  const s = (n + Dn) / Du;
  return function(a, c) {
    if (a.pow(c, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = r, u = a.pow(a.mul(a.ONE, i), n), d = a.pow(c, s), f = a.pow(c, n);
    for (; !a.eql(f, a.ONE); ) {
      if (a.eql(f, a.ZERO))
        return a.ZERO;
      let p = 1;
      for (let h = a.sqr(f); p < l && !a.eql(h, a.ONE); p++)
        h = a.sqr(h);
      const m = a.pow(u, Dn << BigInt(l - p - 1));
      u = a.sqr(m), d = a.mul(d, m), f = a.mul(f, u), l = p;
    }
    return d;
  };
}
function ute(e) {
  if (e % cS === ate) {
    const t = (e + Dn) / cS;
    return function(r, i) {
      const s = r.pow(i, t);
      if (!r.eql(r.sqr(s), i))
        throw new Error("Cannot find square root");
      return s;
    };
  }
  if (e % hI === fI) {
    const t = (e - fI) / hI;
    return function(r, i) {
      const s = r.mul(i, Du), o = r.pow(s, t), a = r.mul(i, o), c = r.mul(r.mul(a, Du), o), l = r.mul(a, r.sub(c, r.ONE));
      if (!r.eql(r.sqr(l), i))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return lte(e);
}
const dte = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function fte(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, n = dte.reduce((r, i) => (r[i] = "function", r), t);
  return ov(e, n);
}
function hte(e, t, n) {
  if (n < hr)
    throw new Error("Expected power > 0");
  if (n === hr)
    return e.ONE;
  if (n === Dn)
    return t;
  let r = e.ONE, i = t;
  for (; n > hr; )
    n & Dn && (r = e.mul(r, i)), i = e.sqr(i), n >>= Dn;
  return r;
}
function pte(e, t) {
  const n = new Array(t.length), r = t.reduce((s, o, a) => e.is0(o) ? s : (n[a] = s, e.mul(s, o)), e.ONE), i = e.inv(r);
  return t.reduceRight((s, o, a) => e.is0(o) ? s : (n[a] = e.mul(s, n[a]), e.mul(s, o)), i), n;
}
function Mj(e, t) {
  const n = t !== void 0 ? t : e.toString(2).length, r = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: r };
}
function mte(e, t, n = !1, r = {}) {
  if (e <= hr)
    throw new Error(`Expected Field ORDER > 0, got ${e}`);
  const { nBitLength: i, nByteLength: s } = Mj(e, t);
  if (s > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const o = ute(e), a = Object.freeze({
    ORDER: e,
    BITS: i,
    BYTES: s,
    MASK: e5(i),
    ZERO: hr,
    ONE: Dn,
    create: (c) => Ei(c, e),
    isValid: (c) => {
      if (typeof c != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof c}`);
      return hr <= c && c < e;
    },
    is0: (c) => c === hr,
    isOdd: (c) => (c & Dn) === Dn,
    neg: (c) => Ei(-c, e),
    eql: (c, l) => c === l,
    sqr: (c) => Ei(c * c, e),
    add: (c, l) => Ei(c + l, e),
    sub: (c, l) => Ei(c - l, e),
    mul: (c, l) => Ei(c * l, e),
    pow: (c, l) => hte(a, c, l),
    div: (c, l) => Ei(c * lS(l, e), e),
    // Same as above, but doesn't normalize
    sqrN: (c) => c * c,
    addN: (c, l) => c + l,
    subN: (c, l) => c - l,
    mulN: (c, l) => c * l,
    inv: (c) => lS(c, e),
    sqrt: r.sqrt || ((c) => o(a, c)),
    invertBatch: (c) => pte(a, c),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (c, l, u) => u ? l : c,
    toBytes: (c) => n ? Xk(c, s) : dm(c, s),
    fromBytes: (c) => {
      if (c.length !== s)
        throw new Error(`Fp.fromBytes: expected ${s}, got ${c.length}`);
      return n ? Jk(c) : jd(c);
    }
  });
  return Object.freeze(a);
}
function Fj(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function jj(e) {
  const t = Fj(e);
  return t + Math.ceil(t / 2);
}
function gte(e, t, n = !1) {
  const r = e.length, i = Fj(t), s = jj(t);
  if (r < 16 || r < s || r > 1024)
    throw new Error(`expected ${s}-1024 bytes of input, got ${r}`);
  const o = n ? jd(e) : Jk(e), a = Ei(o, t - Dn) + Dn;
  return n ? Xk(a, i) : dm(a, i);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const yte = BigInt(0), T3 = BigInt(1);
function bte(e, t) {
  const n = (i, s) => {
    const o = s.negate();
    return i ? o : s;
  }, r = (i) => {
    const s = Math.ceil(t / i) + 1, o = 2 ** (i - 1);
    return { windows: s, windowSize: o };
  };
  return {
    constTimeNegate: n,
    // non-const time multiplication ladder
    unsafeLadder(i, s) {
      let o = e.ZERO, a = i;
      for (; s > yte; )
        s & T3 && (o = o.add(a)), a = a.double(), s >>= T3;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(i, s) {
      const { windows: o, windowSize: a } = r(s), c = [];
      let l = i, u = l;
      for (let d = 0; d < o; d++) {
        u = l, c.push(u);
        for (let f = 1; f < a; f++)
          u = u.add(l), c.push(u);
        l = u.double();
      }
      return c;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(i, s, o) {
      const { windows: a, windowSize: c } = r(i);
      let l = e.ZERO, u = e.BASE;
      const d = BigInt(2 ** i - 1), f = 2 ** i, p = BigInt(i);
      for (let m = 0; m < a; m++) {
        const h = m * c;
        let g = Number(o & d);
        o >>= p, g > c && (g -= f, o += T3);
        const y = h, v = h + Math.abs(g) - 1, b = m % 2 !== 0, w = g < 0;
        g === 0 ? u = u.add(n(b, s[y])) : l = l.add(n(w, s[v]));
      }
      return { p: l, f: u };
    },
    wNAFCached(i, s, o, a) {
      const c = i._WINDOW_SIZE || 1;
      let l = s.get(i);
      return l || (l = this.precomputeWindow(i, c), c !== 1 && s.set(i, a(l))), this.wNAF(c, l, o);
    }
  };
}
function Dj(e) {
  return fte(e.Fp), ov(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...Mj(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function vte(e) {
  const t = Dj(e);
  ov(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: n, Fp: r, a: i } = t;
  if (n) {
    if (!r.eql(i, r.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: wte, hexToBytes: xte } = ste, Ku = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(e) {
    const { Err: t } = Ku;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const n = e[1], r = e.subarray(2, n + 2);
    if (!n || r.length !== n)
      throw new t("Invalid signature integer: wrong length");
    if (r[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (r[0] === 0 && !(r[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: wte(r), l: e.subarray(n + 2) };
  },
  toSig(e) {
    const { Err: t } = Ku, n = typeof e == "string" ? xte(e) : e;
    if (!(n instanceof Uint8Array))
      throw new Error("ui8a expected");
    let r = n.length;
    if (r < 2 || n[0] != 48)
      throw new t("Invalid signature tag");
    if (n[1] !== r - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: i, l: s } = Ku._parseInt(n.subarray(2)), { d: o, l: a } = Ku._parseInt(s);
    if (a.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: i, s: o };
  },
  hexFromSig(e) {
    const t = (l) => Number.parseInt(l[0], 16) & 8 ? "00" + l : l, n = (l) => {
      const u = l.toString(16);
      return u.length & 1 ? `0${u}` : u;
    }, r = t(n(e.s)), i = t(n(e.r)), s = r.length / 2, o = i.length / 2, a = n(s), c = n(o);
    return `30${n(o + s + 4)}02${c}${i}02${a}${r}`;
  }
}, ec = BigInt(0), bs = BigInt(1);
BigInt(2);
const pI = BigInt(3);
BigInt(4);
function Ate(e) {
  const t = vte(e), { Fp: n } = t, r = t.toBytes || ((m, h, g) => {
    const y = h.toAffine();
    return sy(Uint8Array.from([4]), n.toBytes(y.x), n.toBytes(y.y));
  }), i = t.fromBytes || ((m) => {
    const h = m.subarray(1), g = n.fromBytes(h.subarray(0, n.BYTES)), y = n.fromBytes(h.subarray(n.BYTES, 2 * n.BYTES));
    return { x: g, y };
  });
  function s(m) {
    const { a: h, b: g } = t, y = n.sqr(m), v = n.mul(y, m);
    return n.add(n.add(v, n.mul(m, h)), g);
  }
  if (!n.eql(n.sqr(t.Gy), s(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function o(m) {
    return typeof m == "bigint" && ec < m && m < t.n;
  }
  function a(m) {
    if (!o(m))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function c(m) {
    const { allowedPrivateKeyLengths: h, nByteLength: g, wrapPrivateKey: y, n: v } = t;
    if (h && typeof m != "bigint") {
      if (m instanceof Uint8Array && (m = lm(m)), typeof m != "string" || !h.includes(m.length))
        throw new Error("Invalid key");
      m = m.padStart(g * 2, "0");
    }
    let b;
    try {
      b = typeof m == "bigint" ? m : jd(Ws("private key", m, g));
    } catch {
      throw new Error(`private key must be ${g} bytes, hex or bigint, not ${typeof m}`);
    }
    return y && (b = Ei(b, v)), a(b), b;
  }
  const l = /* @__PURE__ */ new Map();
  function u(m) {
    if (!(m instanceof d))
      throw new Error("ProjectivePoint expected");
  }
  class d {
    constructor(h, g, y) {
      if (this.px = h, this.py = g, this.pz = y, h == null || !n.isValid(h))
        throw new Error("x required");
      if (g == null || !n.isValid(g))
        throw new Error("y required");
      if (y == null || !n.isValid(y))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(h) {
      const { x: g, y } = h || {};
      if (!h || !n.isValid(g) || !n.isValid(y))
        throw new Error("invalid affine point");
      if (h instanceof d)
        throw new Error("projective point not allowed");
      const v = (b) => n.eql(b, n.ZERO);
      return v(g) && v(y) ? d.ZERO : new d(g, y, n.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(h) {
      const g = n.invertBatch(h.map((y) => y.pz));
      return h.map((y, v) => y.toAffine(g[v])).map(d.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(h) {
      const g = d.fromAffine(i(Ws("pointHex", h)));
      return g.assertValidity(), g;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(h) {
      return d.BASE.multiply(c(h));
    }
    // "Private method", don't use it directly
    _setWindowSize(h) {
      this._WINDOW_SIZE = h, l.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !n.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: h, y: g } = this.toAffine();
      if (!n.isValid(h) || !n.isValid(g))
        throw new Error("bad point: x or y not FE");
      const y = n.sqr(g), v = s(h);
      if (!n.eql(y, v))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: h } = this.toAffine();
      if (n.isOdd)
        return !n.isOdd(h);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(h) {
      u(h);
      const { px: g, py: y, pz: v } = this, { px: b, py: w, pz: A } = h, E = n.eql(n.mul(g, A), n.mul(b, v)), x = n.eql(n.mul(y, A), n.mul(w, v));
      return E && x;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new d(this.px, n.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: h, b: g } = t, y = n.mul(g, pI), { px: v, py: b, pz: w } = this;
      let A = n.ZERO, E = n.ZERO, x = n.ZERO, S = n.mul(v, v), P = n.mul(b, b), I = n.mul(w, w), R = n.mul(v, b);
      return R = n.add(R, R), x = n.mul(v, w), x = n.add(x, x), A = n.mul(h, x), E = n.mul(y, I), E = n.add(A, E), A = n.sub(P, E), E = n.add(P, E), E = n.mul(A, E), A = n.mul(R, A), x = n.mul(y, x), I = n.mul(h, I), R = n.sub(S, I), R = n.mul(h, R), R = n.add(R, x), x = n.add(S, S), S = n.add(x, S), S = n.add(S, I), S = n.mul(S, R), E = n.add(E, S), I = n.mul(b, w), I = n.add(I, I), S = n.mul(I, R), A = n.sub(A, S), x = n.mul(I, P), x = n.add(x, x), x = n.add(x, x), new d(A, E, x);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(h) {
      u(h);
      const { px: g, py: y, pz: v } = this, { px: b, py: w, pz: A } = h;
      let E = n.ZERO, x = n.ZERO, S = n.ZERO;
      const P = t.a, I = n.mul(t.b, pI);
      let R = n.mul(g, b), Q = n.mul(y, w), J = n.mul(v, A), we = n.add(g, y), V = n.add(b, w);
      we = n.mul(we, V), V = n.add(R, Q), we = n.sub(we, V), V = n.add(g, v);
      let L = n.add(b, A);
      return V = n.mul(V, L), L = n.add(R, J), V = n.sub(V, L), L = n.add(y, v), E = n.add(w, A), L = n.mul(L, E), E = n.add(Q, J), L = n.sub(L, E), S = n.mul(P, V), E = n.mul(I, J), S = n.add(E, S), E = n.sub(Q, S), S = n.add(Q, S), x = n.mul(E, S), Q = n.add(R, R), Q = n.add(Q, R), J = n.mul(P, J), V = n.mul(I, V), Q = n.add(Q, J), J = n.sub(R, J), J = n.mul(P, J), V = n.add(V, J), R = n.mul(Q, V), x = n.add(x, R), R = n.mul(L, V), E = n.mul(we, E), E = n.sub(E, R), R = n.mul(we, Q), S = n.mul(L, S), S = n.add(S, R), new d(E, x, S);
    }
    subtract(h) {
      return this.add(h.negate());
    }
    is0() {
      return this.equals(d.ZERO);
    }
    wNAF(h) {
      return p.wNAFCached(this, l, h, (g) => {
        const y = n.invertBatch(g.map((v) => v.pz));
        return g.map((v, b) => v.toAffine(y[b])).map(d.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(h) {
      const g = d.ZERO;
      if (h === ec)
        return g;
      if (a(h), h === bs)
        return this;
      const { endo: y } = t;
      if (!y)
        return p.unsafeLadder(this, h);
      let { k1neg: v, k1: b, k2neg: w, k2: A } = y.splitScalar(h), E = g, x = g, S = this;
      for (; b > ec || A > ec; )
        b & bs && (E = E.add(S)), A & bs && (x = x.add(S)), S = S.double(), b >>= bs, A >>= bs;
      return v && (E = E.negate()), w && (x = x.negate()), x = new d(n.mul(x.px, y.beta), x.py, x.pz), E.add(x);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(h) {
      a(h);
      let g = h, y, v;
      const { endo: b } = t;
      if (b) {
        const { k1neg: w, k1: A, k2neg: E, k2: x } = b.splitScalar(g);
        let { p: S, f: P } = this.wNAF(A), { p: I, f: R } = this.wNAF(x);
        S = p.constTimeNegate(w, S), I = p.constTimeNegate(E, I), I = new d(n.mul(I.px, b.beta), I.py, I.pz), y = S.add(I), v = P.add(R);
      } else {
        const { p: w, f: A } = this.wNAF(g);
        y = w, v = A;
      }
      return d.normalizeZ([y, v])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(h, g, y) {
      const v = d.BASE, b = (A, E) => E === ec || E === bs || !A.equals(v) ? A.multiplyUnsafe(E) : A.multiply(E), w = b(this, g).add(b(h, y));
      return w.is0() ? void 0 : w;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(h) {
      const { px: g, py: y, pz: v } = this, b = this.is0();
      h == null && (h = b ? n.ONE : n.inv(v));
      const w = n.mul(g, h), A = n.mul(y, h), E = n.mul(v, h);
      if (b)
        return { x: n.ZERO, y: n.ZERO };
      if (!n.eql(E, n.ONE))
        throw new Error("invZ was invalid");
      return { x: w, y: A };
    }
    isTorsionFree() {
      const { h, isTorsionFree: g } = t;
      if (h === bs)
        return !0;
      if (g)
        return g(d, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h, clearCofactor: g } = t;
      return h === bs ? this : g ? g(d, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(h = !0) {
      return this.assertValidity(), r(d, this, h);
    }
    toHex(h = !0) {
      return lm(this.toRawBytes(h));
    }
  }
  d.BASE = new d(t.Gx, t.Gy, n.ONE), d.ZERO = new d(n.ZERO, n.ONE, n.ZERO);
  const f = t.nBitLength, p = bte(d, t.endo ? Math.ceil(f / 2) : f);
  return {
    CURVE: t,
    ProjectivePoint: d,
    normPrivateKeyToScalar: c,
    weierstrassEquation: s,
    isWithinCurveOrder: o
  };
}
function Ete(e) {
  const t = Dj(e);
  return ov(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function _te(e) {
  const t = Ete(e), { Fp: n, n: r } = t, i = n.BYTES + 1, s = 2 * n.BYTES + 1;
  function o(V) {
    return ec < V && V < n.ORDER;
  }
  function a(V) {
    return Ei(V, r);
  }
  function c(V) {
    return lS(V, r);
  }
  const { ProjectivePoint: l, normPrivateKeyToScalar: u, weierstrassEquation: d, isWithinCurveOrder: f } = Ate({
    ...t,
    toBytes(V, L, U) {
      const q = L.toAffine(), G = n.toBytes(q.x), ae = sy;
      return U ? ae(Uint8Array.from([L.hasEvenY() ? 2 : 3]), G) : ae(Uint8Array.from([4]), G, n.toBytes(q.y));
    },
    fromBytes(V) {
      const L = V.length, U = V[0], q = V.subarray(1);
      if (L === i && (U === 2 || U === 3)) {
        const G = jd(q);
        if (!o(G))
          throw new Error("Point is not on curve");
        const ae = d(G);
        let ge = n.sqrt(ae);
        const Ae = (ge & bs) === bs;
        return (U & 1) === 1 !== Ae && (ge = n.neg(ge)), { x: G, y: ge };
      } else if (L === s && U === 4) {
        const G = n.fromBytes(q.subarray(0, n.BYTES)), ae = n.fromBytes(q.subarray(n.BYTES, 2 * n.BYTES));
        return { x: G, y: ae };
      } else
        throw new Error(`Point of length ${L} was invalid. Expected ${i} compressed bytes or ${s} uncompressed bytes`);
    }
  }), p = (V) => lm(dm(V, t.nByteLength));
  function m(V) {
    const L = r >> bs;
    return V > L;
  }
  function h(V) {
    return m(V) ? a(-V) : V;
  }
  const g = (V, L, U) => jd(V.slice(L, U));
  class y {
    constructor(L, U, q) {
      this.r = L, this.s = U, this.recovery = q, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(L) {
      const U = t.nByteLength;
      return L = Ws("compactSignature", L, U * 2), new y(g(L, 0, U), g(L, U, 2 * U));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(L) {
      const { r: U, s: q } = Ku.toSig(Ws("DER", L));
      return new y(U, q);
    }
    assertValidity() {
      if (!f(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!f(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(L) {
      return new y(this.r, this.s, L);
    }
    recoverPublicKey(L) {
      const { r: U, s: q, recovery: G } = this, ae = x(Ws("msgHash", L));
      if (G == null || ![0, 1, 2, 3].includes(G))
        throw new Error("recovery id invalid");
      const ge = G === 2 || G === 3 ? U + t.n : U;
      if (ge >= n.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Ae = G & 1 ? "03" : "02", he = l.fromHex(Ae + p(ge)), B = c(ge), be = a(-ae * B), Be = a(q * B), Ne = l.BASE.multiplyAndAddUnsafe(he, be, Be);
      if (!Ne)
        throw new Error("point at infinify");
      return Ne.assertValidity(), Ne;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return m(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new y(this.r, a(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return um(this.toDERHex());
    }
    toDERHex() {
      return Ku.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return um(this.toCompactHex());
    }
    toCompactHex() {
      return p(this.r) + p(this.s);
    }
  }
  const v = {
    isValidPrivateKey(V) {
      try {
        return u(V), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: u,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const V = jj(t.n);
      return gte(t.randomBytes(V), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(V = 8, L = l.BASE) {
      return L._setWindowSize(V), L.multiply(BigInt(3)), L;
    }
  };
  function b(V, L = !0) {
    return l.fromPrivateKey(V).toRawBytes(L);
  }
  function w(V) {
    const L = V instanceof Uint8Array, U = typeof V == "string", q = (L || U) && V.length;
    return L ? q === i || q === s : U ? q === 2 * i || q === 2 * s : V instanceof l;
  }
  function A(V, L, U = !0) {
    if (w(V))
      throw new Error("first arg must be private key");
    if (!w(L))
      throw new Error("second arg must be public key");
    return l.fromHex(L).multiply(u(V)).toRawBytes(U);
  }
  const E = t.bits2int || function(V) {
    const L = jd(V), U = V.length * 8 - t.nBitLength;
    return U > 0 ? L >> BigInt(U) : L;
  }, x = t.bits2int_modN || function(V) {
    return a(E(V));
  }, S = e5(t.nBitLength);
  function P(V) {
    if (typeof V != "bigint")
      throw new Error("bigint expected");
    if (!(ec <= V && V < S))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return dm(V, t.nByteLength);
  }
  function I(V, L, U = R) {
    if (["recovered", "canonical"].some((Ce) => Ce in U))
      throw new Error("sign() legacy options not supported");
    const { hash: q, randomBytes: G } = t;
    let { lowS: ae, prehash: ge, extraEntropy: Ae } = U;
    ae == null && (ae = !0), V = Ws("msgHash", V), ge && (V = Ws("prehashed msgHash", q(V)));
    const he = x(V), B = u(L), be = [P(B), P(he)];
    if (Ae != null) {
      const Ce = Ae === !0 ? G(n.BYTES) : Ae;
      be.push(Ws("extraEntropy", Ce));
    }
    const Be = sy(...be), Ne = he;
    function _e(Ce) {
      const N = E(Ce);
      if (!f(N))
        return;
      const F = c(N), z = l.BASE.multiply(N).toAffine(), ne = a(z.x);
      if (ne === ec)
        return;
      const ee = a(F * a(Ne + ne * B));
      if (ee === ec)
        return;
      let Y = (z.x === ne ? 0 : 2) | Number(z.y & bs), X = ee;
      return ae && m(ee) && (X = h(ee), Y ^= 1), new y(ne, X, Y);
    }
    return { seed: Be, k2sig: _e };
  }
  const R = { lowS: t.lowS, prehash: !1 }, Q = { lowS: t.lowS, prehash: !1 };
  function J(V, L, U = R) {
    const { seed: q, k2sig: G } = I(V, L, U), ae = t;
    return Rj(ae.hash.outputLen, ae.nByteLength, ae.hmac)(q, G);
  }
  l.BASE._setWindowSize(8);
  function we(V, L, U, q = Q) {
    var z;
    const G = V;
    if (L = Ws("msgHash", L), U = Ws("publicKey", U), "strict" in q)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: ae, prehash: ge } = q;
    let Ae, he;
    try {
      if (typeof G == "string" || G instanceof Uint8Array)
        try {
          Ae = y.fromDER(G);
        } catch (ne) {
          if (!(ne instanceof Ku.Err))
            throw ne;
          Ae = y.fromCompact(G);
        }
      else if (typeof G == "object" && typeof G.r == "bigint" && typeof G.s == "bigint") {
        const { r: ne, s: ee } = G;
        Ae = new y(ne, ee);
      } else
        throw new Error("PARSE");
      he = l.fromHex(U);
    } catch (ne) {
      if (ne.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (ae && Ae.hasHighS())
      return !1;
    ge && (L = t.hash(L));
    const { r: B, s: be } = Ae, Be = x(L), Ne = c(be), _e = a(Be * Ne), Ce = a(B * Ne), N = (z = l.BASE.multiplyAndAddUnsafe(he, _e, Ce)) == null ? void 0 : z.toAffine();
    return N ? a(N.x) === B : !1;
  }
  return {
    CURVE: t,
    getPublicKey: b,
    getSharedSecret: A,
    sign: J,
    verify: we,
    ProjectivePoint: l,
    Signature: y,
    utils: v
  };
}
let Uj = class extends Bk {
  constructor(t, n) {
    super(), this.finished = !1, this.destroyed = !1, KZ(t);
    const r = CA(n);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const i = this.blockLen, s = new Uint8Array(i);
    s.set(r.length > i ? t.create().update(r).digest() : r);
    for (let o = 0; o < s.length; o++)
      s[o] ^= 54;
    this.iHash.update(s), this.oHash = t.create();
    for (let o = 0; o < s.length; o++)
      s[o] ^= 106;
    this.oHash.update(s), s.fill(0);
  }
  update(t) {
    return am(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    am(this), kk(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: i, destroyed: s, blockLen: o, outputLen: a } = this;
    return t = t, t.finished = i, t.destroyed = s, t.blockLen = o, t.outputLen = a, t.oHash = n._cloneInto(t.oHash), t.iHash = r._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const Lj = (e, t, n) => new Uj(e, t).update(n).digest();
Lj.create = (e, t) => new Uj(e, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Ste(e) {
  return {
    hash: e,
    hmac: (t, ...n) => Lj(e, t, sJ(...n)),
    randomBytes: oJ
  };
}
function Cte(e, t) {
  const n = (r) => _te({ ...e, ...Ste(r) });
  return Object.freeze({ ...n(t), create: n });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const zj = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), mI = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), Tte = BigInt(1), uS = BigInt(2), gI = (e, t) => (e + t / uS) / t;
function kte(e) {
  const t = zj, n = BigInt(3), r = BigInt(6), i = BigInt(11), s = BigInt(22), o = BigInt(23), a = BigInt(44), c = BigInt(88), l = e * e * e % t, u = l * l * e % t, d = is(u, n, t) * u % t, f = is(d, n, t) * u % t, p = is(f, uS, t) * l % t, m = is(p, i, t) * p % t, h = is(m, s, t) * m % t, g = is(h, a, t) * h % t, y = is(g, c, t) * g % t, v = is(y, a, t) * h % t, b = is(v, n, t) * u % t, w = is(b, o, t) * m % t, A = is(w, r, t) * l % t, E = is(A, uS, t);
  if (!dS.eql(dS.sqr(E), e))
    throw new Error("Cannot find square root");
  return E;
}
const dS = mte(zj, void 0, void 0, { sqrt: kte }), Vj = Cte({
  a: BigInt(0),
  b: BigInt(7),
  Fp: dS,
  n: mI,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = mI, n = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), r = -Tte * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), s = n, o = BigInt("0x100000000000000000000000000000000"), a = gI(s * e, t), c = gI(-r * e, t);
      let l = Ei(e - a * n - c * i, t), u = Ei(-a * r - c * s, t);
      const d = l > o, f = u > o;
      if (d && (l = t - l), f && (u = t - u), l > o || u > o)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: d, k1: l, k2neg: f, k2: u };
    }
  }
}, tj);
BigInt(0);
Vj.ProjectivePoint;
function Bte({ r: e, s: t, v: n, yParity: r }) {
  const i = (() => {
    if (r === 0 || r === 1)
      return r;
    if (n && (n === 27n || n === 28n || n >= 35n))
      return n % 2n === 0n ? 1 : 0;
    throw new Error("Invalid `v` or `yParity` value");
  })();
  return `0x${new Vj.Signature(sm(e), sm(t)).toCompactHex()}${i === 0 ? "1b" : "1c"}`;
}
async function Hj(e, { address: t, hash: n, signature: r, ...i }) {
  const s = ya(r) ? r : typeof r == "object" && "r" in r && "s" in r ? Bte(r) : Tr(r);
  try {
    const { data: o } = await vt(e, PA, "call")({
      data: kJ({
        abi: dX,
        args: [t, n, s],
        bytecode: Yee
      }),
      ...i
    });
    return ote(o ?? "0x0", "0x1");
  } catch (o) {
    if (o instanceof hj)
      return !1;
    throw o;
  }
}
async function Ite(e, { address: t, message: n, signature: r, ...i }) {
  const s = Hee(n);
  return Hj(e, {
    address: t,
    hash: s,
    signature: r,
    ...i
  });
}
async function Pte(e, t) {
  const { address: n, signature: r, message: i, primaryType: s, types: o, domain: a, ...c } = t, l = Fee({ message: i, primaryType: s, types: o, domain: a });
  return Hj(e, {
    address: n,
    hash: l,
    signature: r,
    ...c
  });
}
function Ote(e, t) {
  const { abi: n, address: r, args: i, batch: s = !0, eventName: o, fromBlock: a, onError: c, onLogs: l, poll: u, pollingInterval: d = e.pollingInterval, strict: f } = t;
  return (typeof u < "u" ? u : typeof a == "bigint" ? !0 : !(e.transport.type === "webSocket" || e.transport.type === "fallback" && e.transport.transports[0].config.type === "webSocket")) ? (() => {
    const g = f ?? !1, y = po([
      "watchContractEvent",
      r,
      i,
      s,
      e.uid,
      o,
      d,
      g,
      a
    ]);
    return tu(y, { onLogs: l, onError: c }, (v) => {
      let b;
      a !== void 0 && (b = a - 1n);
      let w, A = !1;
      const E = sv(async () => {
        var x;
        if (!A) {
          try {
            w = await vt(e, wj, "createContractEventFilter")({
              abi: n,
              address: r,
              args: i,
              eventName: o,
              strict: g,
              fromBlock: a
            });
          } catch {
          }
          A = !0;
          return;
        }
        try {
          let S;
          if (w)
            S = await vt(e, NA, "getFilterChanges")({ filter: w });
          else {
            const P = await vt(e, iv, "getBlockNumber")({});
            b && b !== P ? S = await vt(e, _j, "getContractEvents")({
              abi: n,
              address: r,
              args: i,
              eventName: o,
              fromBlock: b + 1n,
              toBlock: P,
              strict: g
            }) : S = [], b = P;
          }
          if (S.length === 0)
            return;
          if (s)
            v.onLogs(S);
          else
            for (const P of S)
              v.onLogs([P]);
        } catch (S) {
          w && S instanceof tf && (A = !1), (x = v.onError) == null || x.call(v, S);
        }
      }, {
        emitOnBegin: !0,
        interval: d
      });
      return async () => {
        w && await vt(e, RA, "uninstallFilter")({ filter: w }), E();
      };
    });
  })() : (() => {
    const g = f ?? !1, y = po([
      "watchContractEvent",
      r,
      i,
      s,
      e.uid,
      o,
      d,
      g
    ]);
    let v = !0, b = () => v = !1;
    return tu(y, { onLogs: l, onError: c }, (w) => ((async () => {
      try {
        const A = (() => {
          if (e.transport.type === "fallback") {
            const S = e.transport.transports.find((P) => P.config.type === "webSocket");
            return S ? S.value : e.transport;
          }
          return e.transport;
        })(), E = o ? rv({
          abi: n,
          eventName: o,
          args: i
        }) : [], { unsubscribe: x } = await A.subscribe({
          params: ["logs", { address: r, topics: E }],
          onData(S) {
            var I;
            if (!v)
              return;
            const P = S.result;
            try {
              const { eventName: R, args: Q } = $k({
                abi: n,
                data: P.data,
                topics: P.topics,
                strict: f
              }), J = eu(P, {
                args: Q,
                eventName: R
              });
              w.onLogs([J]);
            } catch (R) {
              let Q, J;
              if (R instanceof Wg || R instanceof SA) {
                if (f)
                  return;
                Q = R.abiItem.name, J = (I = R.abiItem.inputs) == null ? void 0 : I.some((V) => !("name" in V && V.name));
              }
              const we = eu(P, {
                args: J ? [] : {},
                eventName: Q
              });
              w.onLogs([we]);
            }
          },
          onError(S) {
            var P;
            (P = w.onError) == null || P.call(w, S);
          }
        });
        b = x, v || b();
      } catch (A) {
        c == null || c(A);
      }
    })(), () => b()));
  })();
}
const fS = 256;
let qv = fS, $v;
function Nte(e = 11) {
  if (!$v || qv + e > fS * 2) {
    $v = "", qv = 0;
    for (let t = 0; t < fS; t++)
      $v += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return $v.substring(qv, qv++ + e);
}
function Rte(e) {
  const { batch: t, cacheTime: n = e.pollingInterval ?? 4e3, ccipRead: r, key: i = "base", name: s = "Base Client", pollingInterval: o = 4e3, type: a = "base" } = e, c = e.chain, l = e.account ? Ea(e.account) : void 0, { config: u, request: d, value: f } = e.transport({
    chain: c,
    pollingInterval: o
  }), p = { ...u, ...f }, m = {
    account: l,
    batch: t,
    cacheTime: n,
    ccipRead: r,
    chain: c,
    key: i,
    name: s,
    pollingInterval: o,
    request: d,
    transport: p,
    type: a,
    uid: Nte()
  };
  function h(g) {
    return (y) => {
      const v = y(g);
      for (const w in m)
        delete v[w];
      const b = { ...g, ...v };
      return Object.assign(b, { extend: h(b) });
    };
  }
  return Object.assign(m, { extend: h(m) });
}
function Mte({ key: e, name: t, request: n, retryCount: r = 3, retryDelay: i = 150, timeout: s, type: o }, a) {
  return {
    config: { key: e, name: t, request: n, retryCount: r, retryDelay: i, timeout: s, type: o },
    request: Iee(n, { retryCount: r, retryDelay: i }),
    value: a
  };
}
function Fte(e, t = {}) {
  const { key: n = "custom", name: r = "Custom Provider", retryDelay: i } = t;
  return ({ retryCount: s }) => Mte({
    key: n,
    name: r,
    request: e.request.bind(e),
    retryCount: t.retryCount ?? s,
    retryDelay: i,
    type: "custom"
  });
}
function jte(e) {
  return {
    call: (t) => PA(e, t),
    createBlockFilter: () => aee(e),
    createContractEventFilter: (t) => wj(e, t),
    createEventFilter: (t) => xj(e, t),
    createPendingTransactionFilter: () => Aj(e),
    estimateContractGas: (t) => lee(e, t),
    estimateGas: (t) => Dk(e, t),
    getBalance: (t) => Ej(e, t),
    getBlobBaseFee: () => uee(e),
    getBlock: (t) => Xl(e, t),
    getBlockNumber: (t) => iv(e, t),
    getBlockTransactionCount: (t) => gee(e, t),
    getBytecode: (t) => yee(e, t),
    getChainId: () => qF(e),
    getContractEvents: (t) => _j(e, t),
    getEnsAddress: (t) => $X(e, t),
    getEnsAvatar: (t) => bj(e, t),
    getEnsName: (t) => vj(e, t),
    getEnsResolver: (t) => oee(e, t),
    getEnsText: (t) => yj(e, t),
    getFeeHistory: (t) => wee(e, t),
    estimateFeesPerGas: (t) => HJ(e, t),
    getFilterChanges: (t) => NA(e, t),
    getFilterLogs: (t) => xee(e, t),
    getGasPrice: () => jk(e),
    getLogs: (t) => Kk(e, t),
    getProof: (t) => qee(e, t),
    estimateMaxPriorityFeePerGas: (t) => VJ(e, t),
    getStorageAt: (t) => Aee(e, t),
    getTransaction: (t) => Yk(e, t),
    getTransactionConfirmations: (t) => Eee(e, t),
    getTransactionCount: (t) => JF(e, t),
    getTransactionReceipt: (t) => oS(e, t),
    multicall: (t) => Sj(e, t),
    prepareTransactionRequest: (t) => oj(e, t),
    readContract: (t) => Ac(e, t),
    sendRawTransaction: (t) => lX(e, t),
    simulateContract: (t) => Kee(e, t),
    verifyMessage: (t) => Ite(e, t),
    verifyTypedData: (t) => Pte(e, t),
    uninstallFilter: (t) => RA(e, t),
    waitForTransactionReceipt: (t) => $ee(e, t),
    watchBlocks: (t) => Tee(e, t),
    watchBlockNumber: (t) => Cj(e, t),
    watchContractEvent: (t) => Ote(e, t),
    watchEvent: (t) => kee(e, t),
    watchPendingTransactions: (t) => Bee(e, t)
  };
}
const Dte = "2.9.1", Ute = () => `@wagmi/core@${Dte}`;
var Wj = function(e, t, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, Sx, Gj;
let Cf = class hS extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return Ute();
  }
  constructor(t, n = {}) {
    var s;
    super(), Sx.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const r = n.cause instanceof hS ? n.cause.details : (s = n.cause) != null && s.message ? n.cause.message : n.details, i = n.cause instanceof hS && n.cause.docsPath || n.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [
        `Docs: ${this.docsBaseUrl}${i}.html${n.docsSlug ? `#${n.docsSlug}` : ""}`
      ] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${this.version}`
    ].join(`
`), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return Wj(this, Sx, "m", Gj).call(this, this, t);
  }
};
Sx = /* @__PURE__ */ new WeakSet(), Gj = function e(t, n) {
  return n != null && n(t) ? t : t.cause ? Wj(this, Sx, "m", e).call(this, t.cause, n) : t;
};
class qj extends Cf {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
class Lte extends Cf {
  constructor() {
    super("Connector already connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAlreadyConnectedError"
    });
  }
}
class zte extends Cf {
  constructor() {
    super("Connector not connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotConnectedError"
    });
  }
}
class Vte extends Cf {
  constructor({ address: t, connector: n }) {
    super(`Account "${t}" not found for connector "${n.name}".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAccountNotFoundError"
    });
  }
}
class Df extends Cf {
  constructor() {
    super("Provider not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderNotFoundError"
    });
  }
}
class Hte extends Cf {
  constructor({ connector: t }) {
    super(`"${t.name}" does not support programmatic chain switching.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SwitchChainNotSupportedError"
    });
  }
}
const Wte = /(rabby|trustwallet)/, Gte = {
  coinbaseWallet: {
    id: "coinbaseWallet",
    name: "Coinbase Wallet",
    provider(e) {
      return e != null && e.coinbaseWalletExtension ? e.coinbaseWalletExtension : cw(e, "isCoinbaseWallet");
    }
  },
  metaMask: {
    id: "metaMask",
    name: "MetaMask",
    provider(e) {
      return cw(e, (t) => {
        if (!t.isMetaMask || t.isBraveWallet && !t._events && !t._state)
          return !1;
        const n = [
          "isApexWallet",
          "isAvalanche",
          "isBitKeep",
          "isBlockWallet",
          "isKuCoinWallet",
          "isMathWallet",
          "isOkxWallet",
          "isOKExWallet",
          "isOneInchIOSWallet",
          "isOneInchAndroidWallet",
          "isOpera",
          "isPortal",
          "isRabby",
          "isTokenPocket",
          "isTokenary",
          "isZerion"
        ];
        for (const r of n)
          if (t[r])
            return !1;
        return !0;
      });
    }
  },
  phantom: {
    id: "phantom",
    name: "Phantom",
    provider(e) {
      var t, n;
      return (t = e == null ? void 0 : e.phantom) != null && t.ethereum ? (n = e.phantom) == null ? void 0 : n.ethereum : cw(e, "isPhantom");
    }
  }
};
t5.type = "injected";
function t5(e = {}) {
  const { shimDisconnect: t = !0, unstable_shimAsyncInject: n } = e;
  function r() {
    const c = e.target;
    if (typeof c == "function") {
      const l = c();
      if (l)
        return l;
    }
    return typeof c == "object" ? c : typeof c == "string" ? {
      ...Gte[c] ?? {
        id: c,
        name: `${c[0].toUpperCase()}${c.slice(1)}`,
        provider: `is${c[0].toUpperCase()}${c.slice(1)}`
      }
    } : {
      id: "injected",
      name: "Injected",
      provider(l) {
        return l == null ? void 0 : l.ethereum;
      }
    };
  }
  let i, s, o, a;
  return (c) => ({
    get icon() {
      return r().icon;
    },
    get id() {
      return r().id;
    },
    get name() {
      return r().name;
    },
    get supportsSimulation() {
      return Wte.test(this.id.toLowerCase());
    },
    type: t5.type,
    async setup() {
      const l = await this.getProvider();
      l && e.target && (o || (o = this.onConnect.bind(this), l.on("connect", o)), i || (i = this.onAccountsChanged.bind(this), l.on("accountsChanged", i)));
    },
    async connect({ chainId: l, isReconnecting: u } = {}) {
      var p, m, h, g, y, v;
      const d = await this.getProvider();
      if (!d)
        throw new Df();
      let f = [];
      if (u)
        f = await this.getAccounts().catch(() => []);
      else if (t)
        try {
          f = (g = (h = (m = (p = (await d.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }))[0]) == null ? void 0 : p.caveats) == null ? void 0 : m[0]) == null ? void 0 : h.value) == null ? void 0 : g.map((w) => j0(w));
        } catch (b) {
          const w = b;
          if (w.code === Lr.code)
            throw new Lr(w);
          if (w.code === Hl.code)
            throw w;
        }
      try {
        !(f != null && f.length) && !u && (f = (await d.request({
          method: "eth_requestAccounts"
        })).map((A) => j0(A))), o && (d.removeListener("connect", o), o = void 0), i || (i = this.onAccountsChanged.bind(this), d.on("accountsChanged", i)), s || (s = this.onChainChanged.bind(this), d.on("chainChanged", s)), a || (a = this.onDisconnect.bind(this), d.on("disconnect", a));
        let b = await this.getChainId();
        if (l && b !== l) {
          const w = await this.switchChain({ chainId: l }).catch((A) => {
            if (A.code === Lr.code)
              throw A;
            return { id: b };
          });
          b = (w == null ? void 0 : w.id) ?? b;
        }
        return t && await ((y = c.storage) == null ? void 0 : y.removeItem(`${this.id}.disconnected`)), e.target || await ((v = c.storage) == null ? void 0 : v.setItem("injected.connected", !0)), { accounts: f, chainId: b };
      } catch (b) {
        const w = b;
        throw w.code === Lr.code ? new Lr(w) : w.code === Hl.code ? new Hl(w) : w;
      }
    },
    async disconnect() {
      var u, d;
      const l = await this.getProvider();
      if (!l)
        throw new Df();
      s && (l.removeListener("chainChanged", s), s = void 0), a && (l.removeListener("disconnect", a), a = void 0), o || (o = this.onConnect.bind(this), l.on("connect", o)), t && await ((u = c.storage) == null ? void 0 : u.setItem(`${this.id}.disconnected`, !0)), e.target || await ((d = c.storage) == null ? void 0 : d.removeItem("injected.connected"));
    },
    async getAccounts() {
      const l = await this.getProvider();
      if (!l)
        throw new Df();
      return (await l.request({ method: "eth_accounts" })).map((d) => j0(d));
    },
    async getChainId() {
      const l = await this.getProvider();
      if (!l)
        throw new Df();
      const u = await l.request({ method: "eth_chainId" });
      return Number(u);
    },
    async getProvider() {
      if (typeof window > "u")
        return;
      let l;
      const u = r();
      return typeof u.provider == "function" ? l = u.provider(window) : typeof u.provider == "string" ? l = cw(window, u.provider) : l = u.provider, l && !l.removeListener && ("off" in l && typeof l.off == "function" ? l.removeListener = l.off : l.removeListener = () => {
      }), l;
    },
    async isAuthorized() {
      var l, u;
      try {
        if (t && // If shim exists in storage, connector is disconnected
        await ((l = c.storage) == null ? void 0 : l.getItem(`${this.id}.disconnected`)) || !e.target && !await ((u = c.storage) == null ? void 0 : u.getItem("injected.connected")))
          return !1;
        if (!await this.getProvider()) {
          if (n !== void 0 && n !== !1) {
            const m = async () => (typeof window < "u" && window.removeEventListener("ethereum#initialized", m), !!await this.getProvider()), h = typeof n == "number" ? n : 1e3;
            if (await Promise.race([
              ...typeof window < "u" ? [
                new Promise((y) => window.addEventListener("ethereum#initialized", () => y(m()), { once: !0 }))
              ] : [],
              new Promise((y) => setTimeout(() => y(m()), h))
            ]))
              return !0;
          }
          throw new Df();
        }
        return !!(await _x(() => Mee(() => this.getAccounts(), {
          timeout: 100
        }))).length;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: l, chainId: u }) {
      var p, m, h, g;
      const d = await this.getProvider();
      if (!d)
        throw new Df();
      const f = c.chains.find((y) => y.id === u);
      if (!f)
        throw new nf(new qj());
      try {
        return await Promise.all([
          d.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: Tt(u) }]
          }).then(async () => {
            await this.getChainId() === u && c.emitter.emit("change", { chainId: u });
          }),
          new Promise((y) => c.emitter.once("change", ({ chainId: v }) => {
            v === u && y();
          }))
        ]), f;
      } catch (y) {
        const v = y;
        if (v.code === 4902 || // Unwrapping for MetaMask Mobile
        // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
        ((m = (p = v == null ? void 0 : v.data) == null ? void 0 : p.originalError) == null ? void 0 : m.code) === 4902)
          try {
            const { default: b, ...w } = f.blockExplorers ?? {};
            let A;
            l != null && l.blockExplorerUrls ? A = l.blockExplorerUrls : b && (A = [
              b.url,
              ...Object.values(w).map((P) => P.url)
            ]);
            let E;
            (h = l == null ? void 0 : l.rpcUrls) != null && h.length ? E = l.rpcUrls : E = [((g = f.rpcUrls.default) == null ? void 0 : g.http[0]) ?? ""];
            const x = {
              blockExplorerUrls: A,
              chainId: Tt(u),
              chainName: (l == null ? void 0 : l.chainName) ?? f.name,
              iconUrls: l == null ? void 0 : l.iconUrls,
              nativeCurrency: (l == null ? void 0 : l.nativeCurrency) ?? f.nativeCurrency,
              rpcUrls: E
            };
            if (await d.request({
              method: "wallet_addEthereumChain",
              params: [x]
            }), await this.getChainId() !== u)
              throw new Lr(new Error("User rejected switch after adding network."));
            return f;
          } catch (b) {
            throw new Lr(b);
          }
        throw v.code === Lr.code ? new Lr(v) : new nf(v);
      }
    },
    async onAccountsChanged(l) {
      var u;
      if (l.length === 0)
        this.onDisconnect();
      else if (c.emitter.listenerCount("connect")) {
        const d = (await this.getChainId()).toString();
        this.onConnect({ chainId: d }), t && await ((u = c.storage) == null ? void 0 : u.removeItem(`${this.id}.disconnected`));
      } else
        c.emitter.emit("change", {
          accounts: l.map((d) => j0(d))
        });
    },
    onChainChanged(l) {
      const u = Number(l);
      c.emitter.emit("change", { chainId: u });
    },
    async onConnect(l) {
      const u = await this.getAccounts();
      if (u.length === 0)
        return;
      const d = Number(l.chainId);
      c.emitter.emit("connect", { accounts: u, chainId: d });
      const f = await this.getProvider();
      f && (o && (f.removeListener("connect", o), o = void 0), i || (i = this.onAccountsChanged.bind(this), f.on("accountsChanged", i)), s || (s = this.onChainChanged.bind(this), f.on("chainChanged", s)), a || (a = this.onDisconnect.bind(this), f.on("disconnect", a)));
    },
    async onDisconnect(l) {
      const u = await this.getProvider();
      l && l.code === 1013 && u && (await this.getAccounts()).length || (c.emitter.emit("disconnect"), u && (s && (u.removeListener("chainChanged", s), s = void 0), a && (u.removeListener("disconnect", a), a = void 0), o || (o = this.onConnect.bind(this), u.on("connect", o))));
    }
  });
}
function cw(e, t) {
  function n(i) {
    return typeof t == "function" ? t(i) : typeof t == "string" ? i[t] : !0;
  }
  const r = e.ethereum;
  if (r != null && r.providers)
    return r.providers.find((i) => n(i));
  if (r && n(r))
    return r;
}
function Zm(e, t, n) {
  const r = e[t.name];
  if (typeof r == "function")
    return r;
  const i = e[n];
  return typeof i == "function" ? i : (s) => t(e, s);
}
async function qte(e, t) {
  var r;
  let n;
  if (typeof t.connector == "function" ? n = e._internal.connectors.setup(t.connector) : n = t.connector, n.uid === e.state.current)
    throw new Lte();
  try {
    e.setState((o) => ({ ...o, status: "connecting" })), n.emitter.emit("message", { type: "connecting" });
    const i = await n.connect({ chainId: t.chainId }), s = i.accounts;
    return n.emitter.off("connect", e._internal.events.connect), n.emitter.on("change", e._internal.events.change), n.emitter.on("disconnect", e._internal.events.disconnect), await ((r = e.storage) == null ? void 0 : r.setItem("recentConnectorId", n.id)), e.setState((o) => ({
      ...o,
      connections: new Map(o.connections).set(n.uid, {
        accounts: s,
        chainId: i.chainId,
        connector: n
      }),
      current: n.uid,
      status: "connected"
    })), { accounts: s, chainId: i.chainId };
  } catch (i) {
    throw e.setState((s) => ({
      ...s,
      // Keep existing connector connected in case of error
      status: s.current ? "connected" : "disconnected"
    })), i;
  }
}
async function $te(e, t = {}) {
  var i, s;
  let n;
  if (t.connector)
    n = t.connector;
  else {
    const { connections: o, current: a } = e.state, c = o.get(a);
    n = c == null ? void 0 : c.connector;
  }
  const r = e.state.connections;
  n && (await n.disconnect(), n.emitter.off("change", e._internal.events.change), n.emitter.off("disconnect", e._internal.events.disconnect), n.emitter.on("connect", e._internal.events.connect), r.delete(n.uid)), e.setState((o) => {
    if (r.size === 0)
      return {
        ...o,
        connections: /* @__PURE__ */ new Map(),
        current: null,
        status: "disconnected"
      };
    const a = r.values().next().value;
    return {
      ...o,
      connections: new Map(r),
      current: a.connector.uid
    };
  });
  {
    const o = e.state.current;
    if (!o)
      return;
    const a = (i = e.state.connections.get(o)) == null ? void 0 : i.connector;
    if (!a)
      return;
    await ((s = e.storage) == null ? void 0 : s.setItem("recentConnectorId", a.id));
  }
}
async function Qte(e, t = {}) {
  let n;
  if (t.connector) {
    const { connector: c } = t, [l, u] = await Promise.all([
      c.getAccounts(),
      c.getChainId()
    ]);
    n = {
      accounts: l,
      chainId: u,
      connector: c
    };
  } else
    n = e.state.connections.get(e.state.current);
  if (!n)
    throw new zte();
  const r = t.chainId ?? n.chainId, i = n.connector;
  if (i.getClient)
    return i.getClient({ chainId: r });
  const s = Ea(t.account ?? n.accounts[0]);
  s.address = j0(s.address);
  const o = e.chains.find((c) => c.id === r), a = await n.connector.getProvider({ chainId: r });
  if (t.account && !n.accounts.includes(s.address))
    throw new Vte({
      address: s.address,
      connector: i
    });
  return Rte({
    account: s,
    chain: o,
    name: "Connector Client",
    transport: (c) => Fte(a)({ ...c, retryCount: 0 })
  });
}
function $j(e) {
  return typeof e == "number" ? e : e === "wei" ? 0 : Math.abs(OJ[e]);
}
function Qj(e) {
  const t = e.state.current, n = e.state.connections.get(t), r = n == null ? void 0 : n.accounts, i = r == null ? void 0 : r[0], s = e.chains.find((a) => a.id === (n == null ? void 0 : n.chainId)), o = e.state.status;
  switch (o) {
    case "connected":
      return {
        address: i,
        addresses: r,
        chain: s,
        chainId: n == null ? void 0 : n.chainId,
        connector: n == null ? void 0 : n.connector,
        isConnected: !0,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !1,
        status: o
      };
    case "reconnecting":
      return {
        address: i,
        addresses: r,
        chain: s,
        chainId: n == null ? void 0 : n.chainId,
        connector: n == null ? void 0 : n.connector,
        isConnected: !!i,
        isConnecting: !1,
        isDisconnected: !1,
        isReconnecting: !0,
        status: o
      };
    case "connecting":
      return {
        address: i,
        addresses: r,
        chain: s,
        chainId: n == null ? void 0 : n.chainId,
        connector: n == null ? void 0 : n.connector,
        isConnected: !1,
        isConnecting: !0,
        isDisconnected: !1,
        isReconnecting: !1,
        status: o
      };
    case "disconnected":
      return {
        address: void 0,
        addresses: void 0,
        chain: void 0,
        chainId: void 0,
        connector: void 0,
        isConnected: !1,
        isConnecting: !1,
        isDisconnected: !0,
        isReconnecting: !1,
        status: o
      };
  }
}
async function Kte(e, t) {
  const { allowFailure: n = !0, chainId: r, contracts: i, ...s } = t, o = e.getClient({ chainId: r });
  return Zm(o, Sj, "multicall")({
    allowFailure: n,
    contracts: i,
    ...s
  });
}
function Yte(e, t) {
  const { chainId: n, ...r } = t, i = e.getClient({ chainId: n });
  return Zm(i, Ac, "readContract")(r);
}
async function Zte(e, t) {
  const { allowFailure: n = !0, blockNumber: r, blockTag: i, ...s } = t, o = t.contracts;
  try {
    const a = o.reduce((d, f, p) => {
      const m = f.chainId ?? e.state.chainId;
      return {
        ...d,
        [m]: [...d[m] || [], { contract: f, index: p }]
      };
    }, {}), c = () => Object.entries(a).map(([d, f]) => Kte(e, {
      ...s,
      allowFailure: n,
      blockNumber: r,
      blockTag: i,
      chainId: parseInt(d),
      contracts: f.map(({ contract: p }) => p)
    })), l = (await Promise.all(c())).flat(), u = Object.values(a).flatMap((d) => d.map(({ index: f }) => f));
    return l.reduce((d, f, p) => (d && (d[u[p]] = f), d), []);
  } catch (a) {
    if (a instanceof Vk)
      throw a;
    const c = () => o.map((l) => Yte(e, { ...l, blockNumber: r, blockTag: i }));
    return n ? (await Promise.allSettled(c())).map((l) => l.status === "fulfilled" ? { result: l.value, status: "success" } : { error: l.reason, result: void 0, status: "failure" }) : await Promise.all(c());
  }
}
async function Jte(e, t) {
  const { address: n, blockNumber: r, blockTag: i, chainId: s, token: o, unit: a = "ether" } = t;
  if (o)
    try {
      return yI(e, {
        balanceAddress: n,
        chainId: s,
        symbolType: "string",
        tokenAddress: o
      });
    } catch (f) {
      if (f instanceof Vk) {
        const p = await yI(e, {
          balanceAddress: n,
          chainId: s,
          symbolType: "bytes32",
          tokenAddress: o
        }), m = PZ($m(p.symbol, { dir: "right" }));
        return { ...p, symbol: m };
      }
      throw f;
    }
  const c = e.getClient({ chainId: s }), u = await Zm(c, Ej, "getBalance")(r ? { address: n, blockNumber: r } : { address: n, blockTag: i }), d = e.chains.find((f) => f.id === s) ?? c.chain;
  return {
    decimals: d.nativeCurrency.decimals,
    formatted: TA(u, $j(a)),
    symbol: d.nativeCurrency.symbol,
    value: u
  };
}
async function yI(e, t) {
  const { balanceAddress: n, chainId: r, symbolType: i, tokenAddress: s, unit: o } = t, a = {
    abi: [
      {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [{ type: "address" }],
        outputs: [{ type: "uint256" }]
      },
      {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [{ type: "uint8" }]
      },
      {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [{ type: i }]
      }
    ],
    address: s
  }, [c, l, u] = await Zte(e, {
    allowFailure: !1,
    contracts: [
      {
        ...a,
        functionName: "balanceOf",
        args: [n],
        chainId: r
      },
      { ...a, functionName: "decimals", chainId: r },
      { ...a, functionName: "symbol", chainId: r }
    ]
  }), d = TA(c ?? "0", $j(o ?? l));
  return { decimals: l, formatted: d, symbol: u, value: c };
}
function bI(e) {
  return e.state.chainId;
}
function nu(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    let n, r;
    if (Array.isArray(e) && Array.isArray(t)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!nu(e[r], t[r]))
          return !1;
      return !0;
    }
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const i = Object.keys(e);
    if (n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = i[r];
      if (s && !nu(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
let k3 = [];
function vI(e) {
  const t = e.chains;
  return nu(k3, t) ? k3 : (k3 = t, t);
}
function Xte(e, t = {}) {
  let n;
  try {
    n = e.getClient(t);
  } catch {
  }
  return n;
}
let Qv = [];
function pS(e) {
  const t = [...e.state.connections.values()];
  return e.state.status === "reconnecting" || nu(Qv, t) ? Qv : (Qv = t, t);
}
let B3 = [];
function wI(e) {
  const t = e.connectors;
  return nu(B3, t) ? B3 : (B3 = t, t);
}
function ene(e, t) {
  const { chainId: n, ...r } = t, i = e.getClient({ chainId: n });
  return Zm(i, bj, "getEnsAvatar")(r);
}
function tne(e, t) {
  const { chainId: n, ...r } = t, i = e.getClient({ chainId: n });
  return Zm(i, vj, "getEnsName")(r);
}
function mS(e, t = {}) {
  const n = Xte(e, t);
  return n == null ? void 0 : n.extend(jte);
}
let I3 = !1;
async function nne(e, t = {}) {
  var l, u;
  if (I3)
    return [];
  I3 = !0, e.setState((d) => ({
    ...d,
    status: d.current ? "reconnecting" : "connecting"
  }));
  const n = [];
  if ((l = t.connectors) != null && l.length)
    for (const d of t.connectors) {
      let f;
      typeof d == "function" ? f = e._internal.connectors.setup(d) : f = d, n.push(f);
    }
  else
    n.push(...e.connectors);
  let r;
  try {
    r = await ((u = e.storage) == null ? void 0 : u.getItem("recentConnectorId"));
  } catch {
  }
  const i = {};
  for (const [, d] of e.state.connections)
    i[d.connector.id] = 1;
  r && (i[r] = 0);
  const s = Object.keys(i).length > 0 ? (
    // .toSorted()
    [...n].sort((d, f) => (i[d.id] ?? 10) - (i[f.id] ?? 10))
  ) : n;
  let o = !1;
  const a = [], c = [];
  for (const d of s) {
    const f = await d.getProvider();
    if (!f || c.some((h) => h === f) || !await d.isAuthorized())
      continue;
    const m = await d.connect({ isReconnecting: !0 }).catch(() => null);
    m && (d.emitter.off("connect", e._internal.events.connect), d.emitter.on("change", e._internal.events.change), d.emitter.on("disconnect", e._internal.events.disconnect), e.setState((h) => {
      const g = new Map(o ? h.connections : /* @__PURE__ */ new Map()).set(d.uid, { accounts: m.accounts, chainId: m.chainId, connector: d });
      return {
        ...h,
        current: o ? h.current : d.uid,
        connections: g
      };
    }), a.push({
      accounts: m.accounts,
      chainId: m.chainId,
      connector: d
    }), c.push(f), o = !0);
  }
  return (e.state.status === "reconnecting" || e.state.status === "connecting") && (o ? e.setState((d) => ({ ...d, status: "connected" })) : e.setState((d) => ({
    ...d,
    connections: /* @__PURE__ */ new Map(),
    current: null,
    status: "disconnected"
  }))), I3 = !1, a;
}
async function rne(e, t) {
  const { account: n, connector: r, ...i } = t;
  let s;
  return typeof n == "object" && n.type === "local" ? s = e.getClient() : s = await Qte(e, { account: n, connector: r }), Zm(s, Qee, "signMessage")({
    ...i,
    ...n ? { account: n } : {}
  });
}
async function ine(e, t) {
  var o;
  const { addEthereumChainParameter: n, chainId: r } = t, i = e.state.connections.get(((o = t.connector) == null ? void 0 : o.uid) ?? e.state.current);
  if (i) {
    const a = i.connector;
    if (!a.switchChain)
      throw new Hte({ connector: a });
    return await a.switchChain({
      addEthereumChainParameter: n,
      chainId: r
    });
  }
  const s = e.chains.find((a) => a.id === r);
  if (!s)
    throw new qj();
  return e.setState((a) => ({ ...a, chainId: r })), s;
}
function Kj(e, t) {
  const { onChange: n } = t;
  return e.subscribe(() => Qj(e), n, {
    equalityFn(r, i) {
      const { connector: s, ...o } = r, { connector: a, ...c } = i;
      return nu(o, c) && // check connector separately
      (s == null ? void 0 : s.id) === (a == null ? void 0 : a.id) && (s == null ? void 0 : s.uid) === (a == null ? void 0 : a.uid);
    }
  });
}
function sne(e, t) {
  const { onChange: n } = t;
  return e.subscribe((r) => r.chainId, n);
}
function one(e, t) {
  const { onChange: n } = t;
  return e.subscribe(() => pS(e), n, {
    equalityFn: nu
  });
}
function ane(e, t) {
  const { onChange: n } = t;
  return e._internal.connectors.subscribe((r, i) => {
    n(Object.values(r), i);
  });
}
function cne(e, t) {
  const { onChange: n } = t;
  return e.subscribe(() => mS(e), n, {
    equalityFn(r, i) {
      return (r == null ? void 0 : r.uid) === (i == null ? void 0 : i.uid);
    }
  });
}
function lne(e, t) {
  const { initialState: n, reconnectOnMount: r } = t;
  return n && !e._internal.store.persist.hasHydrated() && e.setState({
    ...n,
    connections: r ? n.connections : /* @__PURE__ */ new Map(),
    status: r ? "reconnecting" : "disconnected"
  }), {
    async onMount() {
      var i;
      if (e._internal.ssr) {
        await e._internal.store.persist.rehydrate();
        const s = (i = e._internal.mipd) == null ? void 0 : i.getProviders().map(e._internal.connectors.providerDetailToConnector).map(e._internal.connectors.setup);
        e._internal.connectors.setState((o) => [
          ...o,
          ...s ?? []
        ]);
      }
      r ? nne(e) : e.storage && e.setState((s) => ({
        ...s,
        connections: /* @__PURE__ */ new Map()
      }));
    }
  };
}
function une(e) {
  const { children: t, config: n, initialState: r, reconnectOnMount: i = !0 } = e, { onMount: s } = lne(n, {
    initialState: r,
    reconnectOnMount: i
  });
  n._internal.ssr || s();
  const o = Le(!0);
  return We(() => {
    if (o.current && n._internal.ssr)
      return s(), () => {
        o.current = !1;
      };
  }, []), t;
}
const Yj = dn(void 0);
function dne(e) {
  const { children: t, config: n } = e, r = { value: n };
  return Hg(une, e, Hg(Yj.Provider, r, t));
}
const fne = "2.8.1", hne = () => `wagmi@${fne}`;
class pne extends Cf {
  constructor() {
    super(...arguments), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiError"
    });
  }
  get docsBaseUrl() {
    return "https://wagmi.sh/react";
  }
  get version() {
    return hne();
  }
}
class mne extends pne {
  constructor() {
    super("`useConfig` must be used within `WagmiProvider`.", {
      docsPath: "/api/WagmiProvider"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiProviderNotFoundError"
    });
  }
}
var Tf = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, fm = typeof window > "u" || "Deno" in globalThis;
function vs() {
}
function gne(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function gS(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function Zj(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function xI(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: s,
    queryKey: o,
    stale: a
  } = e;
  if (o) {
    if (r) {
      if (t.queryHash !== n5(o, t.options))
        return !1;
    } else if (!oy(t.queryKey, o))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof a == "boolean" && t.isStale() !== a || i && i !== t.state.fetchStatus || s && !s(t));
}
function AI(e, t) {
  const { exact: n, status: r, predicate: i, mutationKey: s } = e;
  if (s) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (rf(t.options.mutationKey) !== rf(s))
        return !1;
    } else if (!oy(t.options.mutationKey, s))
      return !1;
  }
  return !(r && t.state.status !== r || i && !i(t));
}
function n5(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || rf)(e);
}
function rf(e) {
  return JSON.stringify(
    e,
    (t, n) => yS(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n
  );
}
function oy(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !oy(e[n], t[n])) : !1;
}
function r5(e, t) {
  if (e === t)
    return e;
  const n = EI(e) && EI(t);
  if (n || yS(e) && yS(t)) {
    const r = n ? e : Object.keys(e), i = r.length, s = n ? t : Object.keys(t), o = s.length, a = n ? [] : {};
    let c = 0;
    for (let l = 0; l < o; l++) {
      const u = n ? l : s[l];
      (!n && r.includes(u) || n) && e[u] === void 0 && t[u] === void 0 ? (a[u] = void 0, c++) : (a[u] = r5(e[u], t[u]), a[u] === e[u] && e[u] !== void 0 && c++);
    }
    return i === o && c === i ? e : a;
  }
  return t;
}
function Cx(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function EI(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function yS(e) {
  if (!_I(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!_I(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function _I(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function yne(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function bS(e, t, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? r5(e, t) : t;
}
function bne(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function vne(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var i5 = Symbol(), sd, fl, tp, aF, wne = (aF = class extends Tf {
  constructor() {
    super();
    re(this, sd, void 0);
    re(this, fl, void 0);
    re(this, tp, void 0);
    j(this, tp, (t) => {
      if (!fm && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    C(this, fl) || this.setEventListener(C(this, tp));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = C(this, fl)) == null || t.call(this), j(this, fl, void 0));
  }
  setEventListener(t) {
    var n;
    j(this, tp, t), (n = C(this, fl)) == null || n.call(this), j(this, fl, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    C(this, sd) !== t && (j(this, sd, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof C(this, sd) == "boolean" ? C(this, sd) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, sd = new WeakMap(), fl = new WeakMap(), tp = new WeakMap(), aF), s5 = new wne(), np, hl, rp, cF, xne = (cF = class extends Tf {
  constructor() {
    super();
    re(this, np, !0);
    re(this, hl, void 0);
    re(this, rp, void 0);
    j(this, rp, (t) => {
      if (!fm && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    C(this, hl) || this.setEventListener(C(this, rp));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = C(this, hl)) == null || t.call(this), j(this, hl, void 0));
  }
  setEventListener(t) {
    var n;
    j(this, rp, t), (n = C(this, hl)) == null || n.call(this), j(this, hl, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    C(this, np) !== t && (j(this, np, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return C(this, np);
  }
}, np = new WeakMap(), hl = new WeakMap(), rp = new WeakMap(), cF), Tx = new xne();
function Ane(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Jj(e) {
  return (e ?? "online") === "online" ? Tx.isOnline() : !0;
}
var Xj = class {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function P3(e) {
  return e instanceof Xj;
}
function eD(e) {
  let t = !1, n = 0, r = !1, i, s, o;
  const a = new Promise((y, v) => {
    s = y, o = v;
  }), c = (y) => {
    var v;
    r || (m(new Xj(y)), (v = e.abort) == null || v.call(e));
  }, l = () => {
    t = !0;
  }, u = () => {
    t = !1;
  }, d = () => s5.isFocused() && (e.networkMode === "always" || Tx.isOnline()) && e.canRun(), f = () => Jj(e.networkMode) && e.canRun(), p = (y) => {
    var v;
    r || (r = !0, (v = e.onSuccess) == null || v.call(e, y), i == null || i(), s(y));
  }, m = (y) => {
    var v;
    r || (r = !0, (v = e.onError) == null || v.call(e, y), i == null || i(), o(y));
  }, h = () => new Promise((y) => {
    var v;
    i = (b) => {
      (r || d()) && y(b);
    }, (v = e.onPause) == null || v.call(e);
  }).then(() => {
    var y;
    i = void 0, r || (y = e.onContinue) == null || y.call(e);
  }), g = () => {
    if (r)
      return;
    let y;
    try {
      y = e.fn();
    } catch (v) {
      y = Promise.reject(v);
    }
    Promise.resolve(y).then(p).catch((v) => {
      var x;
      if (r)
        return;
      const b = e.retry ?? (fm ? 0 : 3), w = e.retryDelay ?? Ane, A = typeof w == "function" ? w(n, v) : w, E = b === !0 || typeof b == "number" && n < b || typeof b == "function" && b(n, v);
      if (t || !E) {
        m(v);
        return;
      }
      n++, (x = e.onFail) == null || x.call(e, n, v), yne(A).then(() => d() ? void 0 : h()).then(() => {
        t ? m(v) : g();
      });
    });
  };
  return {
    promise: a,
    cancel: c,
    continue: () => (i == null || i(), a),
    cancelRetry: l,
    continueRetry: u,
    canStart: f,
    start: () => (f() ? g() : h().then(g), a)
  };
}
function Ene() {
  let e = [], t = 0, n = (f) => {
    f();
  }, r = (f) => {
    f();
  }, i = (f) => setTimeout(f, 0);
  const s = (f) => {
    i = f;
  }, o = (f) => {
    let p;
    t++;
    try {
      p = f();
    } finally {
      t--, t || l();
    }
    return p;
  }, a = (f) => {
    t ? e.push(f) : i(() => {
      n(f);
    });
  }, c = (f) => (...p) => {
    a(() => {
      f(...p);
    });
  }, l = () => {
    const f = e;
    e = [], f.length && i(() => {
      r(() => {
        f.forEach((p) => {
          n(p);
        });
      });
    });
  };
  return {
    batch: o,
    batchCalls: c,
    schedule: a,
    setNotifyFunction: (f) => {
      n = f;
    },
    setBatchNotifyFunction: (f) => {
      r = f;
    },
    setScheduler: s
  };
}
var Rn = Ene(), od, lF, tD = (lF = class {
  constructor() {
    re(this, od, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), gS(this.gcTime) && j(this, od, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (fm ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    C(this, od) && (clearTimeout(C(this, od)), j(this, od, void 0));
  }
}, od = new WeakMap(), lF), ip, sp, hs, Jr, vb, ad, Ks, Na, uF, _ne = (uF = class extends tD {
  constructor(t) {
    super();
    re(this, Ks);
    re(this, ip, void 0);
    re(this, sp, void 0);
    re(this, hs, void 0);
    re(this, Jr, void 0);
    re(this, vb, void 0);
    re(this, ad, void 0);
    j(this, ad, !1), j(this, vb, t.defaultOptions), this.setOptions(t.options), this.observers = [], j(this, hs, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, j(this, ip, t.state || Sne(this.options)), this.state = C(this, ip), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = { ...C(this, vb), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && C(this, hs).remove(this);
  }
  setData(t, n) {
    const r = bS(this.state.data, t, this.options);
    return Se(this, Ks, Na).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    Se(this, Ks, Na).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var r, i;
    const n = (r = C(this, Jr)) == null ? void 0 : r.promise;
    return (i = C(this, Jr)) == null || i.cancel(t), n ? n.then(vs).catch(vs) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(C(this, ip));
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !Zj(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = C(this, Jr)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = C(this, Jr)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), C(this, hs).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (C(this, Jr) && (C(this, ad) ? C(this, Jr).cancel({ revert: !0 }) : C(this, Jr).cancelRetry()), this.scheduleGc()), C(this, hs).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || Se(this, Ks, Na).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var l, u, d;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (C(this, Jr))
        return C(this, Jr).continueRetry(), C(this, Jr).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const f = this.observers.find((p) => p.options.queryFn);
      f && this.setOptions(f.options);
    }
    const r = new AbortController(), i = {
      queryKey: this.queryKey,
      meta: this.meta
    }, s = (f) => {
      Object.defineProperty(f, "signal", {
        enumerable: !0,
        get: () => (j(this, ad, !0), r.signal)
      });
    };
    s(i);
    const o = () => !this.options.queryFn || this.options.queryFn === i5 ? Promise.reject(
      new Error(`Missing queryFn: '${this.options.queryHash}'`)
    ) : (j(this, ad, !1), this.options.persister ? this.options.persister(
      this.options.queryFn,
      i,
      this
    ) : this.options.queryFn(
      i
    )), a = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: o
    };
    s(a), (l = this.options.behavior) == null || l.onFetch(
      a,
      this
    ), j(this, sp, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = a.fetchOptions) == null ? void 0 : u.meta)) && Se(this, Ks, Na).call(this, { type: "fetch", meta: (d = a.fetchOptions) == null ? void 0 : d.meta });
    const c = (f) => {
      var p, m, h, g;
      P3(f) && f.silent || Se(this, Ks, Na).call(this, {
        type: "error",
        error: f
      }), P3(f) || ((m = (p = C(this, hs).config).onError) == null || m.call(
        p,
        f,
        this
      ), (g = (h = C(this, hs).config).onSettled) == null || g.call(
        h,
        this.state.data,
        f,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return j(this, Jr, eD({
      fn: a.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (f) => {
        var p, m, h, g;
        if (f === void 0) {
          c(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(f), (m = (p = C(this, hs).config).onSuccess) == null || m.call(p, f, this), (g = (h = C(this, hs).config).onSettled) == null || g.call(
          h,
          f,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: c,
      onFail: (f, p) => {
        Se(this, Ks, Na).call(this, { type: "failed", failureCount: f, error: p });
      },
      onPause: () => {
        Se(this, Ks, Na).call(this, { type: "pause" });
      },
      onContinue: () => {
        Se(this, Ks, Na).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), C(this, Jr).start();
  }
}, ip = new WeakMap(), sp = new WeakMap(), hs = new WeakMap(), Jr = new WeakMap(), vb = new WeakMap(), ad = new WeakMap(), Ks = new WeakSet(), Na = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...nD(r.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const i = t.error;
        return P3(i) && i.revert && C(this, sp) ? { ...C(this, sp), fetchStatus: "idle" } : {
          ...r,
          error: i,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: i,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...t.state
        };
    }
  };
  this.state = n(this.state), Rn.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), C(this, hs).notify({ query: this, type: "updated", action: t });
  });
}, uF);
function nD(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Jj(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Sne(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Vo, dF, Cne = (dF = class extends Tf {
  constructor(t = {}) {
    super();
    re(this, Vo, void 0);
    this.config = t, j(this, Vo, /* @__PURE__ */ new Map());
  }
  build(t, n, r) {
    const i = n.queryKey, s = n.queryHash ?? n5(i, n);
    let o = this.get(s);
    return o || (o = new _ne({
      cache: this,
      queryKey: i,
      queryHash: s,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(i)
    }), this.add(o)), o;
  }
  add(t) {
    C(this, Vo).has(t.queryHash) || (C(this, Vo).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = C(this, Vo).get(t.queryHash);
    n && (t.destroy(), n === t && C(this, Vo).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    Rn.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return C(this, Vo).get(t);
  }
  getAll() {
    return [...C(this, Vo).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => xI(n, r)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((r) => xI(t, r)) : n;
  }
  notify(t) {
    Rn.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    Rn.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    Rn.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, Vo = new WeakMap(), dF), Ho, Xr, cd, Wo, el, fF, Tne = (fF = class extends tD {
  constructor(t) {
    super();
    re(this, Wo);
    re(this, Ho, void 0);
    re(this, Xr, void 0);
    re(this, cd, void 0);
    this.mutationId = t.mutationId, j(this, Xr, t.mutationCache), j(this, Ho, []), this.state = t.state || rD(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    C(this, Ho).includes(t) || (C(this, Ho).push(t), this.clearGcTimeout(), C(this, Xr).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    j(this, Ho, C(this, Ho).filter((n) => n !== t)), this.scheduleGc(), C(this, Xr).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    C(this, Ho).length || (this.state.status === "pending" ? this.scheduleGc() : C(this, Xr).remove(this));
  }
  continue() {
    var t;
    return ((t = C(this, cd)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var i, s, o, a, c, l, u, d, f, p, m, h, g, y, v, b, w, A, E, x;
    j(this, cd, eD({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (S, P) => {
        Se(this, Wo, el).call(this, { type: "failed", failureCount: S, error: P });
      },
      onPause: () => {
        Se(this, Wo, el).call(this, { type: "pause" });
      },
      onContinue: () => {
        Se(this, Wo, el).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => C(this, Xr).canRun(this)
    }));
    const n = this.state.status === "pending", r = !C(this, cd).canStart();
    try {
      if (!n) {
        Se(this, Wo, el).call(this, { type: "pending", variables: t, isPaused: r }), await ((s = (i = C(this, Xr).config).onMutate) == null ? void 0 : s.call(
          i,
          t,
          this
        ));
        const P = await ((a = (o = this.options).onMutate) == null ? void 0 : a.call(o, t));
        P !== this.state.context && Se(this, Wo, el).call(this, {
          type: "pending",
          context: P,
          variables: t,
          isPaused: r
        });
      }
      const S = await C(this, cd).start();
      return await ((l = (c = C(this, Xr).config).onSuccess) == null ? void 0 : l.call(
        c,
        S,
        t,
        this.state.context,
        this
      )), await ((d = (u = this.options).onSuccess) == null ? void 0 : d.call(u, S, t, this.state.context)), await ((p = (f = C(this, Xr).config).onSettled) == null ? void 0 : p.call(
        f,
        S,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((h = (m = this.options).onSettled) == null ? void 0 : h.call(m, S, null, t, this.state.context)), Se(this, Wo, el).call(this, { type: "success", data: S }), S;
    } catch (S) {
      try {
        throw await ((y = (g = C(this, Xr).config).onError) == null ? void 0 : y.call(
          g,
          S,
          t,
          this.state.context,
          this
        )), await ((b = (v = this.options).onError) == null ? void 0 : b.call(
          v,
          S,
          t,
          this.state.context
        )), await ((A = (w = C(this, Xr).config).onSettled) == null ? void 0 : A.call(
          w,
          void 0,
          S,
          this.state.variables,
          this.state.context,
          this
        )), await ((x = (E = this.options).onSettled) == null ? void 0 : x.call(
          E,
          void 0,
          S,
          t,
          this.state.context
        )), S;
      } finally {
        Se(this, Wo, el).call(this, { type: "error", error: S });
      }
    } finally {
      C(this, Xr).runNext(this);
    }
  }
}, Ho = new WeakMap(), Xr = new WeakMap(), cd = new WeakMap(), Wo = new WeakSet(), el = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), Rn.batch(() => {
    C(this, Ho).forEach((r) => {
      r.onMutationUpdate(t);
    }), C(this, Xr).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, fF);
function rD() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Vi, wb, hF, kne = (hF = class extends Tf {
  constructor(t = {}) {
    super();
    re(this, Vi, void 0);
    re(this, wb, void 0);
    this.config = t, j(this, Vi, /* @__PURE__ */ new Map()), j(this, wb, Date.now());
  }
  build(t, n, r) {
    const i = new Tne({
      mutationCache: this,
      mutationId: ++Rc(this, wb)._,
      options: t.defaultMutationOptions(n),
      state: r
    });
    return this.add(i), i;
  }
  add(t) {
    const n = Kv(t), r = C(this, Vi).get(n) ?? [];
    r.push(t), C(this, Vi).set(n, r), this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    var r;
    const n = Kv(t);
    if (C(this, Vi).has(n)) {
      const i = (r = C(this, Vi).get(n)) == null ? void 0 : r.filter((s) => s !== t);
      i && (i.length === 0 ? C(this, Vi).delete(n) : C(this, Vi).set(n, i));
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    var r;
    const n = (r = C(this, Vi).get(Kv(t))) == null ? void 0 : r.find((i) => i.state.status === "pending");
    return !n || n === t;
  }
  runNext(t) {
    var r;
    const n = (r = C(this, Vi).get(Kv(t))) == null ? void 0 : r.find((i) => i !== t && i.state.isPaused);
    return (n == null ? void 0 : n.continue()) ?? Promise.resolve();
  }
  clear() {
    Rn.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return [...C(this, Vi).values()].flat();
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => AI(n, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((n) => AI(t, n));
  }
  notify(t) {
    Rn.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((n) => n.state.isPaused);
    return Rn.batch(
      () => Promise.all(
        t.map((n) => n.continue().catch(vs))
      )
    );
  }
}, Vi = new WeakMap(), wb = new WeakMap(), hF);
function Kv(e) {
  var t;
  return ((t = e.options.scope) == null ? void 0 : t.id) ?? String(e.mutationId);
}
function Bne(e) {
  return {
    onFetch: (t, n) => {
      const r = async () => {
        var m, h, g, y, v;
        const i = t.options, s = (g = (h = (m = t.fetchOptions) == null ? void 0 : m.meta) == null ? void 0 : h.fetchMore) == null ? void 0 : g.direction, o = ((y = t.state.data) == null ? void 0 : y.pages) || [], a = ((v = t.state.data) == null ? void 0 : v.pageParams) || [], c = { pages: [], pageParams: [] };
        let l = !1;
        const u = (b) => {
          Object.defineProperty(b, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? l = !0 : t.signal.addEventListener("abort", () => {
              l = !0;
            }), t.signal)
          });
        }, d = t.options.queryFn && t.options.queryFn !== i5 ? t.options.queryFn : () => Promise.reject(
          new Error(`Missing queryFn: '${t.options.queryHash}'`)
        ), f = async (b, w, A) => {
          if (l)
            return Promise.reject();
          if (w == null && b.pages.length)
            return Promise.resolve(b);
          const E = {
            queryKey: t.queryKey,
            pageParam: w,
            direction: A ? "backward" : "forward",
            meta: t.options.meta
          };
          u(E);
          const x = await d(
            E
          ), { maxPages: S } = t.options, P = A ? vne : bne;
          return {
            pages: P(b.pages, x, S),
            pageParams: P(b.pageParams, w, S)
          };
        };
        let p;
        if (s && o.length) {
          const b = s === "backward", w = b ? Ine : SI, A = {
            pages: o,
            pageParams: a
          }, E = w(i, A);
          p = await f(A, E, b);
        } else {
          p = await f(
            c,
            a[0] ?? i.initialPageParam
          );
          const b = e ?? o.length;
          for (let w = 1; w < b; w++) {
            const A = SI(i, p);
            p = await f(p, A);
          }
        }
        return p;
      };
      t.options.persister ? t.fetchFn = () => {
        var i, s;
        return (s = (i = t.options).persister) == null ? void 0 : s.call(
          i,
          r,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = r;
    }
  };
}
function SI(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  );
}
function Ine(e, { pages: t, pageParams: n }) {
  var r;
  return (r = e.getPreviousPageParam) == null ? void 0 : r.call(
    e,
    t[0],
    t,
    n[0],
    n
  );
}
var In, pl, ml, op, ap, gl, cp, lp, pF, Pne = (pF = class {
  constructor(e = {}) {
    re(this, In, void 0);
    re(this, pl, void 0);
    re(this, ml, void 0);
    re(this, op, void 0);
    re(this, ap, void 0);
    re(this, gl, void 0);
    re(this, cp, void 0);
    re(this, lp, void 0);
    j(this, In, e.queryCache || new Cne()), j(this, pl, e.mutationCache || new kne()), j(this, ml, e.defaultOptions || {}), j(this, op, /* @__PURE__ */ new Map()), j(this, ap, /* @__PURE__ */ new Map()), j(this, gl, 0);
  }
  mount() {
    Rc(this, gl)._++, C(this, gl) === 1 && (j(this, cp, s5.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), C(this, In).onFocus());
    })), j(this, lp, Tx.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), C(this, In).onOnline());
    })));
  }
  unmount() {
    var e, t;
    Rc(this, gl)._--, C(this, gl) === 0 && ((e = C(this, cp)) == null || e.call(this), j(this, cp, void 0), (t = C(this, lp)) == null || t.call(this), j(this, lp, void 0));
  }
  isFetching(e) {
    return C(this, In).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return C(this, pl).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = C(this, In).get(t.queryHash)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    if (t === void 0)
      return this.fetchQuery(e);
    {
      const n = this.defaultQueryOptions(e), r = C(this, In).build(this, n);
      return e.revalidateIfStale && r.isStaleByTime(n.staleTime) && this.prefetchQuery(n), Promise.resolve(t);
    }
  }
  getQueriesData(e) {
    return C(this, In).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), i = C(this, In).get(
      r.queryHash
    ), s = i == null ? void 0 : i.state.data, o = gne(t, s);
    if (o !== void 0)
      return C(this, In).build(this, r).setData(o, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return Rn.batch(
      () => C(this, In).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = C(this, In).get(t.queryHash)) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const t = C(this, In);
    Rn.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = C(this, In), r = {
      type: "active",
      ...e
    };
    return Rn.batch(() => (n.findAll(e).forEach((i) => {
      i.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, r = Rn.batch(
      () => C(this, In).findAll(e).map((i) => i.cancel(n))
    );
    return Promise.all(r).then(vs).catch(vs);
  }
  invalidateQueries(e = {}, t = {}) {
    return Rn.batch(() => {
      if (C(this, In).findAll(e).forEach((r) => {
        r.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, r = Rn.batch(
      () => C(this, In).findAll(e).filter((i) => !i.isDisabled()).map((i) => {
        let s = i.fetch(void 0, n);
        return n.throwOnError || (s = s.catch(vs)), i.state.fetchStatus === "paused" ? Promise.resolve() : s;
      })
    );
    return Promise.all(r).then(vs);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = C(this, In).build(this, t);
    return n.isStaleByTime(t.staleTime) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(vs).catch(vs);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = Bne(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(vs).catch(vs);
  }
  resumePausedMutations() {
    return Tx.isOnline() ? C(this, pl).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return C(this, In);
  }
  getMutationCache() {
    return C(this, pl);
  }
  getDefaultOptions() {
    return C(this, ml);
  }
  setDefaultOptions(e) {
    j(this, ml, e);
  }
  setQueryDefaults(e, t) {
    C(this, op).set(rf(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...C(this, op).values()];
    let n = {};
    return t.forEach((r) => {
      oy(e, r.queryKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    C(this, ap).set(rf(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...C(this, ap).values()];
    let n = {};
    return t.forEach((r) => {
      oy(e, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...C(this, ml).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = n5(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.enabled !== !0 && t.queryFn === i5 && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...C(this, ml).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    C(this, In).clear(), C(this, pl).clear();
  }
}, In = new WeakMap(), pl = new WeakMap(), ml = new WeakMap(), op = new WeakMap(), ap = new WeakMap(), gl = new WeakMap(), cp = new WeakMap(), lp = new WeakMap(), pF), bi, pn, xb, ei, ld, up, Go, Ab, dp, fp, ud, dd, yl, hp, fd, D0, Eb, vS, _b, wS, Sb, xS, Cb, AS, Tb, ES, kb, _S, Bb, SS, fA, iD, mF, o5 = (mF = class extends Tf {
  constructor(t, n) {
    super();
    re(this, fd);
    re(this, Eb);
    re(this, _b);
    re(this, Sb);
    re(this, Cb);
    re(this, Tb);
    re(this, kb);
    re(this, Bb);
    re(this, fA);
    re(this, bi, void 0);
    re(this, pn, void 0);
    re(this, xb, void 0);
    re(this, ei, void 0);
    re(this, ld, void 0);
    re(this, up, void 0);
    re(this, Go, void 0);
    re(this, Ab, void 0);
    re(this, dp, void 0);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    re(this, fp, void 0);
    re(this, ud, void 0);
    re(this, dd, void 0);
    re(this, yl, void 0);
    re(this, hp, /* @__PURE__ */ new Set());
    this.options = n, j(this, bi, t), j(this, Go, null), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (C(this, pn).addObserver(this), CI(C(this, pn), this.options) ? Se(this, fd, D0).call(this) : this.updateResult(), Se(this, Cb, AS).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return CS(
      C(this, pn),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return CS(
      C(this, pn),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Se(this, Tb, ES).call(this), Se(this, kb, _S).call(this), C(this, pn).removeObserver(this);
  }
  setOptions(t, n) {
    const r = this.options, i = C(this, pn);
    if (this.options = C(this, bi).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    Se(this, Bb, SS).call(this), C(this, pn).setOptions(this.options), r._defaulted && !Cx(this.options, r) && C(this, bi).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: C(this, pn),
      observer: this
    });
    const s = this.hasListeners();
    s && TI(
      C(this, pn),
      i,
      this.options,
      r
    ) && Se(this, fd, D0).call(this), this.updateResult(n), s && (C(this, pn) !== i || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && Se(this, Eb, vS).call(this);
    const o = Se(this, _b, wS).call(this);
    s && (C(this, pn) !== i || this.options.enabled !== r.enabled || o !== C(this, yl)) && Se(this, Sb, xS).call(this, o);
  }
  getOptimisticResult(t) {
    const n = C(this, bi).getQueryCache().build(C(this, bi), t), r = this.createResult(n, t);
    return Nne(this, r) && (j(this, ei, r), j(this, up, this.options), j(this, ld, C(this, pn).state)), r;
  }
  getCurrentResult() {
    return C(this, ei);
  }
  trackResult(t, n) {
    const r = {};
    return Object.keys(t).forEach((i) => {
      Object.defineProperty(r, i, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(i), n == null || n(i), t[i])
      });
    }), r;
  }
  trackProp(t) {
    C(this, hp).add(t);
  }
  getCurrentQuery() {
    return C(this, pn);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = C(this, bi).defaultQueryOptions(t), r = C(this, bi).getQueryCache().build(C(this, bi), n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    return Se(this, fd, D0).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), C(this, ei)));
  }
  createResult(t, n) {
    var x;
    const r = C(this, pn), i = this.options, s = C(this, ei), o = C(this, ld), a = C(this, up), l = t !== r ? t.state : C(this, xb), { state: u } = t;
    let d = { ...u }, f = !1, p;
    if (n._optimisticResults) {
      const S = this.hasListeners(), P = !S && CI(t, n), I = S && TI(t, r, n, i);
      (P || I) && (d = {
        ...d,
        ...nD(u.data, t.options)
      }), n._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: m, errorUpdatedAt: h, status: g } = d;
    if (n.select && d.data !== void 0)
      if (s && d.data === (o == null ? void 0 : o.data) && n.select === C(this, Ab))
        p = C(this, dp);
      else
        try {
          j(this, Ab, n.select), p = n.select(d.data), p = bS(s == null ? void 0 : s.data, p, n), j(this, dp, p), j(this, Go, null);
        } catch (S) {
          j(this, Go, S);
        }
    else
      p = d.data;
    if (n.placeholderData !== void 0 && p === void 0 && g === "pending") {
      let S;
      if (s != null && s.isPlaceholderData && n.placeholderData === (a == null ? void 0 : a.placeholderData))
        S = s.data;
      else if (S = typeof n.placeholderData == "function" ? n.placeholderData(
        (x = C(this, fp)) == null ? void 0 : x.state.data,
        C(this, fp)
      ) : n.placeholderData, n.select && S !== void 0)
        try {
          S = n.select(S), j(this, Go, null);
        } catch (P) {
          j(this, Go, P);
        }
      S !== void 0 && (g = "success", p = bS(
        s == null ? void 0 : s.data,
        S,
        n
      ), f = !0);
    }
    C(this, Go) && (m = C(this, Go), p = C(this, dp), h = Date.now(), g = "error");
    const y = d.fetchStatus === "fetching", v = g === "pending", b = g === "error", w = v && y, A = p !== void 0;
    return {
      status: g,
      fetchStatus: d.fetchStatus,
      isPending: v,
      isSuccess: g === "success",
      isError: b,
      isInitialLoading: w,
      isLoading: w,
      data: p,
      dataUpdatedAt: d.dataUpdatedAt,
      error: m,
      errorUpdatedAt: h,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > l.dataUpdateCount || d.errorUpdateCount > l.errorUpdateCount,
      isFetching: y,
      isRefetching: y && !v,
      isLoadingError: b && !A,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: f,
      isRefetchError: b && A,
      isStale: a5(t, n),
      refetch: this.refetch
    };
  }
  updateResult(t) {
    const n = C(this, ei), r = this.createResult(C(this, pn), this.options);
    if (j(this, ld, C(this, pn).state), j(this, up, this.options), C(this, ld).data !== void 0 && j(this, fp, C(this, pn)), Cx(r, n))
      return;
    j(this, ei, r);
    const i = {}, s = () => {
      if (!n)
        return !0;
      const { notifyOnChangeProps: o } = this.options, a = typeof o == "function" ? o() : o;
      if (a === "all" || !a && !C(this, hp).size)
        return !0;
      const c = new Set(
        a ?? C(this, hp)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(C(this, ei)).some((l) => {
        const u = l;
        return C(this, ei)[u] !== n[u] && c.has(u);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && s() && (i.listeners = !0), Se(this, fA, iD).call(this, { ...i, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && Se(this, Cb, AS).call(this);
  }
}, bi = new WeakMap(), pn = new WeakMap(), xb = new WeakMap(), ei = new WeakMap(), ld = new WeakMap(), up = new WeakMap(), Go = new WeakMap(), Ab = new WeakMap(), dp = new WeakMap(), fp = new WeakMap(), ud = new WeakMap(), dd = new WeakMap(), yl = new WeakMap(), hp = new WeakMap(), fd = new WeakSet(), D0 = function(t) {
  Se(this, Bb, SS).call(this);
  let n = C(this, pn).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch(vs)), n;
}, Eb = new WeakSet(), vS = function() {
  if (Se(this, Tb, ES).call(this), fm || C(this, ei).isStale || !gS(this.options.staleTime))
    return;
  const n = Zj(
    C(this, ei).dataUpdatedAt,
    this.options.staleTime
  ) + 1;
  j(this, ud, setTimeout(() => {
    C(this, ei).isStale || this.updateResult();
  }, n));
}, _b = new WeakSet(), wS = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(C(this, pn)) : this.options.refetchInterval) ?? !1;
}, Sb = new WeakSet(), xS = function(t) {
  Se(this, kb, _S).call(this), j(this, yl, t), !(fm || this.options.enabled === !1 || !gS(C(this, yl)) || C(this, yl) === 0) && j(this, dd, setInterval(() => {
    (this.options.refetchIntervalInBackground || s5.isFocused()) && Se(this, fd, D0).call(this);
  }, C(this, yl)));
}, Cb = new WeakSet(), AS = function() {
  Se(this, Eb, vS).call(this), Se(this, Sb, xS).call(this, Se(this, _b, wS).call(this));
}, Tb = new WeakSet(), ES = function() {
  C(this, ud) && (clearTimeout(C(this, ud)), j(this, ud, void 0));
}, kb = new WeakSet(), _S = function() {
  C(this, dd) && (clearInterval(C(this, dd)), j(this, dd, void 0));
}, Bb = new WeakSet(), SS = function() {
  const t = C(this, bi).getQueryCache().build(C(this, bi), this.options);
  if (t === C(this, pn))
    return;
  const n = C(this, pn);
  j(this, pn, t), j(this, xb, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, fA = new WeakSet(), iD = function(t) {
  Rn.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(C(this, ei));
    }), C(this, bi).getQueryCache().notify({
      query: C(this, pn),
      type: "observerResultsUpdated"
    });
  });
}, mF);
function One(e, t) {
  return t.enabled !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function CI(e, t) {
  return One(e, t) || e.state.data !== void 0 && CS(e, t, t.refetchOnMount);
}
function CS(e, t, n) {
  if (t.enabled !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && a5(e, t);
  }
  return !1;
}
function TI(e, t, n, r) {
  return (e !== t || r.enabled === !1) && (!n.suspense || e.state.status !== "error") && a5(e, n);
}
function a5(e, t) {
  return t.enabled !== !1 && e.isStaleByTime(t.staleTime);
}
function Nne(e, t) {
  return !Cx(e.getCurrentResult(), t);
}
function kI(e, t) {
  return e.filter((n) => !t.includes(n));
}
function Rne(e, t, n) {
  const r = e.slice(0);
  return r[t] = n, r;
}
var hd, Ys, pp, Hi, pd, Ib, Pb, hA, sD, Ob, TS, Nb, kS, Rb, BS, gF, Mne = (gF = class extends Tf {
  constructor(t, n, r) {
    super();
    re(this, hA);
    re(this, Ob);
    re(this, Nb);
    re(this, Rb);
    re(this, hd, void 0);
    re(this, Ys, void 0);
    re(this, pp, void 0);
    re(this, Hi, void 0);
    re(this, pd, void 0);
    re(this, Ib, void 0);
    re(this, Pb, void 0);
    j(this, hd, t), j(this, pp, []), j(this, Hi, []), j(this, Ys, []), this.setQueries(n);
  }
  onSubscribe() {
    this.listeners.size === 1 && C(this, Hi).forEach((t) => {
      t.subscribe((n) => {
        Se(this, Nb, kS).call(this, t, n);
      });
    });
  }
  onUnsubscribe() {
    this.listeners.size || this.destroy();
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), C(this, Hi).forEach((t) => {
      t.destroy();
    });
  }
  setQueries(t, n, r) {
    j(this, pp, t), Rn.batch(() => {
      const i = C(this, Hi), s = Se(this, Ob, TS).call(this, C(this, pp));
      s.forEach(
        (l) => l.observer.setOptions(l.defaultedQueryOptions, r)
      );
      const o = s.map((l) => l.observer), a = o.map(
        (l) => l.getCurrentResult()
      ), c = o.some(
        (l, u) => l !== i[u]
      );
      i.length === o.length && !c || (j(this, Hi, o), j(this, Ys, a), this.hasListeners() && (kI(i, o).forEach((l) => {
        l.destroy();
      }), kI(o, i).forEach((l) => {
        l.subscribe((u) => {
          Se(this, Nb, kS).call(this, l, u);
        });
      }), Se(this, Rb, BS).call(this)));
    });
  }
  getCurrentResult() {
    return C(this, Ys);
  }
  getQueries() {
    return C(this, Hi).map((t) => t.getCurrentQuery());
  }
  getObservers() {
    return C(this, Hi);
  }
  getOptimisticResult(t, n) {
    const r = Se(this, Ob, TS).call(this, t), i = r.map(
      (s) => s.observer.getOptimisticResult(s.defaultedQueryOptions)
    );
    return [
      i,
      (s) => Se(this, hA, sD).call(this, s ?? i, n),
      () => r.map((s, o) => {
        const a = i[o];
        return s.defaultedQueryOptions.notifyOnChangeProps ? a : s.observer.trackResult(a, (c) => {
          r.forEach((l) => {
            l.observer.trackProp(c);
          });
        });
      })
    ];
  }
}, hd = new WeakMap(), Ys = new WeakMap(), pp = new WeakMap(), Hi = new WeakMap(), pd = new WeakMap(), Ib = new WeakMap(), Pb = new WeakMap(), hA = new WeakSet(), sD = function(t, n) {
  return n ? ((!C(this, pd) || C(this, Ys) !== C(this, Pb) || n !== C(this, Ib)) && (j(this, Ib, n), j(this, Pb, C(this, Ys)), j(this, pd, r5(
    C(this, pd),
    n(t)
  ))), C(this, pd)) : t;
}, Ob = new WeakSet(), TS = function(t) {
  const n = C(this, Hi), r = new Map(
    n.map((d) => [d.options.queryHash, d])
  ), i = t.map(
    (d) => C(this, hd).defaultQueryOptions(d)
  ), s = i.flatMap((d) => {
    const f = r.get(d.queryHash);
    return f != null ? [{ defaultedQueryOptions: d, observer: f }] : [];
  }), o = new Set(
    s.map((d) => d.defaultedQueryOptions.queryHash)
  ), a = i.filter(
    (d) => !o.has(d.queryHash)
  ), c = (d) => {
    const f = C(this, hd).defaultQueryOptions(d);
    return C(this, Hi).find(
      (m) => m.options.queryHash === f.queryHash
    ) ?? new o5(C(this, hd), f);
  }, l = a.map((d) => ({
    defaultedQueryOptions: d,
    observer: c(d)
  })), u = (d, f) => i.indexOf(d.defaultedQueryOptions) - i.indexOf(f.defaultedQueryOptions);
  return s.concat(l).sort(u);
}, Nb = new WeakSet(), kS = function(t, n) {
  const r = C(this, Hi).indexOf(t);
  r !== -1 && (j(this, Ys, Rne(C(this, Ys), r, n)), Se(this, Rb, BS).call(this));
}, Rb = new WeakSet(), BS = function() {
  Rn.batch(() => {
    this.listeners.forEach((t) => {
      t(C(this, Ys));
    });
  });
}, gF), bl, vl, vi, za, mp, lw, Mb, IS, yF, Fne = (yF = class extends Tf {
  constructor(n, r) {
    super();
    re(this, mp);
    re(this, Mb);
    re(this, bl, void 0);
    re(this, vl, void 0);
    re(this, vi, void 0);
    re(this, za, void 0);
    j(this, bl, n), this.setOptions(r), this.bindMethods(), Se(this, mp, lw).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(n) {
    var i;
    const r = this.options;
    this.options = C(this, bl).defaultMutationOptions(n), Cx(this.options, r) || C(this, bl).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: C(this, vi),
      observer: this
    }), r != null && r.mutationKey && this.options.mutationKey && rf(r.mutationKey) !== rf(this.options.mutationKey) ? this.reset() : ((i = C(this, vi)) == null ? void 0 : i.state.status) === "pending" && C(this, vi).setOptions(this.options);
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || (n = C(this, vi)) == null || n.removeObserver(this);
  }
  onMutationUpdate(n) {
    Se(this, mp, lw).call(this), Se(this, Mb, IS).call(this, n);
  }
  getCurrentResult() {
    return C(this, vl);
  }
  reset() {
    var n;
    (n = C(this, vi)) == null || n.removeObserver(this), j(this, vi, void 0), Se(this, mp, lw).call(this), Se(this, Mb, IS).call(this);
  }
  mutate(n, r) {
    var i;
    return j(this, za, r), (i = C(this, vi)) == null || i.removeObserver(this), j(this, vi, C(this, bl).getMutationCache().build(C(this, bl), this.options)), C(this, vi).addObserver(this), C(this, vi).execute(n);
  }
}, bl = new WeakMap(), vl = new WeakMap(), vi = new WeakMap(), za = new WeakMap(), mp = new WeakSet(), lw = function() {
  var r;
  const n = ((r = C(this, vi)) == null ? void 0 : r.state) ?? rD();
  j(this, vl, {
    ...n,
    isPending: n.status === "pending",
    isSuccess: n.status === "success",
    isError: n.status === "error",
    isIdle: n.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, Mb = new WeakSet(), IS = function(n) {
  Rn.batch(() => {
    var r, i, s, o, a, c, l, u;
    if (C(this, za) && this.hasListeners()) {
      const d = C(this, vl).variables, f = C(this, vl).context;
      (n == null ? void 0 : n.type) === "success" ? ((i = (r = C(this, za)).onSuccess) == null || i.call(r, n.data, d, f), (o = (s = C(this, za)).onSettled) == null || o.call(s, n.data, null, d, f)) : (n == null ? void 0 : n.type) === "error" && ((c = (a = C(this, za)).onError) == null || c.call(a, n.error, d, f), (u = (l = C(this, za)).onSettled) == null || u.call(
        l,
        void 0,
        n.error,
        d,
        f
      ));
    }
    this.listeners.forEach((d) => {
      d(C(this, vl));
    });
  });
}, yF);
function jne(e) {
  return {
    mutationKey: e.options.mutationKey,
    state: e.state,
    ...e.options.scope && { scope: e.options.scope },
    ...e.meta && { meta: e.meta }
  };
}
function Dne(e) {
  return {
    state: e.state,
    queryKey: e.queryKey,
    queryHash: e.queryHash,
    ...e.meta && { meta: e.meta }
  };
}
function Une(e) {
  return e.state.isPaused;
}
function Lne(e) {
  return e.state.status === "success";
}
function zne(e, t = {}) {
  const n = t.shouldDehydrateMutation ?? Une, r = e.getMutationCache().getAll().flatMap(
    (o) => n(o) ? [jne(o)] : []
  ), i = t.shouldDehydrateQuery ?? Lne, s = e.getQueryCache().getAll().flatMap((o) => i(o) ? [Dne(o)] : []);
  return { mutations: r, queries: s };
}
function Vne(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const r = e.getMutationCache(), i = e.getQueryCache(), s = t.mutations || [], o = t.queries || [];
  s.forEach(({ state: a, ...c }) => {
    var l;
    r.build(
      e,
      {
        ...(l = n == null ? void 0 : n.defaultOptions) == null ? void 0 : l.mutations,
        ...c
      },
      a
    );
  }), o.forEach(({ queryKey: a, state: c, queryHash: l, meta: u }) => {
    var f;
    const d = i.get(l);
    if (d) {
      if (d.state.dataUpdatedAt < c.dataUpdatedAt) {
        const { fetchStatus: p, ...m } = c;
        d.setState(m);
      }
      return;
    }
    i.build(
      e,
      {
        ...(f = n == null ? void 0 : n.defaultOptions) == null ? void 0 : f.queries,
        queryKey: a,
        queryHash: l,
        meta: u
      },
      // Reset fetch status to idle to avoid
      // query being stuck in fetching state upon hydration
      {
        ...c,
        fetchStatus: "idle"
      }
    );
  });
}
var oD = ye.createContext(
  void 0
), c5 = (e) => {
  const t = ye.useContext(oD);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, Hne = ({
  client: e,
  children: t
}) => (ye.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ D.jsx(oD.Provider, { value: e, children: t })), aD = ye.createContext(!1), cD = () => ye.useContext(aD), Wne = aD.Provider;
function Gne() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var qne = ye.createContext(Gne()), lD = () => ye.useContext(qne);
function uD(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
function $ne() {
}
var dD = (e, t) => {
  (e.suspense || e.throwOnError) && (t.isReset() || (e.retryOnMount = !1));
}, fD = (e) => {
  ye.useEffect(() => {
    e.clearReset();
  }, [e]);
}, hD = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && r && uD(n, [e.error, r]), pD = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, Qne = (e, t) => e.isLoading && e.isFetching && !t, PS = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, OS = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function uw({
  queries: e,
  ...t
}, n) {
  const r = c5(), i = cD(), s = lD(), o = ye.useMemo(
    () => e.map((m) => {
      const h = r.defaultQueryOptions(
        m
      );
      return h._optimisticResults = i ? "isRestoring" : "optimistic", h;
    }),
    [e, r, i]
  );
  o.forEach((m) => {
    pD(m), dD(m, s);
  }), fD(s);
  const [a] = ye.useState(
    () => new Mne(
      r,
      o,
      t
    )
  ), [c, l, u] = a.getOptimisticResult(
    o,
    t.combine
  );
  ye.useSyncExternalStore(
    ye.useCallback(
      (m) => i ? () => {
      } : a.subscribe(Rn.batchCalls(m)),
      [a, i]
    ),
    () => a.getCurrentResult(),
    () => a.getCurrentResult()
  ), ye.useEffect(() => {
    a.setQueries(
      o,
      t,
      {
        listeners: !1
      }
    );
  }, [o, t, a]);
  const f = c.some(
    (m, h) => PS(o[h], m)
  ) ? c.flatMap((m, h) => {
    const g = o[h];
    if (g) {
      const y = new o5(r, g);
      if (PS(g, m))
        return OS(g, y, s);
      Qne(m, i) && OS(g, y, s);
    }
    return [];
  }) : [];
  if (f.length > 0)
    throw Promise.all(f);
  const p = c.find(
    (m, h) => {
      const g = o[h];
      return g && hD({
        result: m,
        errorResetBoundary: s,
        throwOnError: g.throwOnError,
        query: r.getQueryCache().get(g.queryHash)
      });
    }
  );
  if (p != null && p.error)
    throw p.error;
  return l(u());
}
function Kne(e, t, n) {
  const r = c5(), i = cD(), s = lD(), o = r.defaultQueryOptions(e);
  o._optimisticResults = i ? "isRestoring" : "optimistic", pD(o), dD(o, s), fD(s);
  const [a] = ye.useState(
    () => new t(
      r,
      o
    )
  ), c = a.getOptimisticResult(o);
  if (ye.useSyncExternalStore(
    ye.useCallback(
      (l) => {
        const u = i ? () => {
        } : a.subscribe(Rn.batchCalls(l));
        return a.updateResult(), u;
      },
      [a, i]
    ),
    () => a.getCurrentResult(),
    () => a.getCurrentResult()
  ), ye.useEffect(() => {
    a.setOptions(o, { listeners: !1 });
  }, [o, a]), PS(o, c))
    throw OS(o, a, s);
  if (hD({
    result: c,
    errorResetBoundary: s,
    throwOnError: o.throwOnError,
    query: r.getQueryCache().get(o.queryHash)
  }))
    throw c.error;
  return o.notifyOnChangeProps ? c : a.trackResult(c);
}
function Yne(e, t) {
  return Kne(e, o5);
}
function jA(e, t) {
  const n = c5(), [r] = ye.useState(
    () => new Fne(
      n,
      e
    )
  );
  ye.useEffect(() => {
    r.setOptions(e);
  }, [r, e]);
  const i = ye.useSyncExternalStore(
    ye.useCallback(
      (o) => r.subscribe(Rn.batchCalls(o)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), s = ye.useCallback(
    (o, a) => {
      r.mutate(o, a).catch($ne);
    },
    [r]
  );
  if (i.error && uD(r.options.throwOnError, [i.error]))
    throw i.error;
  return { ...i, mutate: s, mutateAsync: i.mutate };
}
function Zne(e, t) {
  const { onChange: n } = t;
  return e._internal.chains.subscribe((r, i) => {
    n(r, i);
  });
}
function yr(e = {}) {
  const t = e.config ?? $e(Yj);
  if (!t)
    throw new mne();
  return t;
}
var mD = { exports: {} }, O3 = {}, N3 = { exports: {} }, R3 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BI;
function Jne() {
  if (BI)
    return R3;
  BI = 1;
  var e = k;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, s = e.useLayoutEffect, o = e.useDebugValue;
  function a(d, f) {
    var p = f(), m = r({ inst: { value: p, getSnapshot: f } }), h = m[0].inst, g = m[1];
    return s(function() {
      h.value = p, h.getSnapshot = f, c(h) && g({ inst: h });
    }, [d, p, f]), i(function() {
      return c(h) && g({ inst: h }), d(function() {
        c(h) && g({ inst: h });
      });
    }, [d]), o(p), p;
  }
  function c(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function l(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : a;
  return R3.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, R3;
}
var II;
function Xne() {
  return II || (II = 1, N3.exports = Jne()), N3.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PI;
function ere() {
  if (PI)
    return O3;
  PI = 1;
  var e = k, t = Xne();
  function n(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, s = e.useRef, o = e.useEffect, a = e.useMemo, c = e.useDebugValue;
  return O3.useSyncExternalStoreWithSelector = function(l, u, d, f, p) {
    var m = s(null);
    if (m.current === null) {
      var h = { hasValue: !1, value: null };
      m.current = h;
    } else
      h = m.current;
    m = a(function() {
      function y(E) {
        if (!v) {
          if (v = !0, b = E, E = f(E), p !== void 0 && h.hasValue) {
            var x = h.value;
            if (p(x, E))
              return w = x;
          }
          return w = E;
        }
        if (x = w, r(b, E))
          return x;
        var S = f(E);
        return p !== void 0 && p(x, S) ? x : (b = E, w = S);
      }
      var v = !1, b, w, A = d === void 0 ? null : d;
      return [function() {
        return y(u());
      }, A === null ? void 0 : function() {
        return y(A());
      }];
    }, [u, d, f, p]);
    var g = i(l, m[0], m[1]);
    return o(function() {
      h.hasValue = !0, h.value = g;
    }, [g]), c(g), g;
  }, O3;
}
mD.exports = ere();
var gD = mD.exports;
const M3 = (e) => typeof e == "object" && !Array.isArray(e);
function tre(e, t, n = t, r = nu) {
  const i = Le([]), s = gD.useSyncExternalStoreWithSelector(e, t, n, (o) => o, (o, a) => {
    if (M3(o) && M3(a) && i.current.length) {
      for (const c of i.current)
        if (!r(o[c], a[c]))
          return !1;
      return !0;
    }
    return r(o, a);
  });
  if (M3(s)) {
    const o = { ...s };
    return Object.defineProperties(o, Object.entries(o).reduce((a, [c, l]) => ({
      ...a,
      [c]: {
        configurable: !1,
        enumerable: !0,
        get: () => (i.current.includes(c) || i.current.push(c), l)
      }
    }), {})), o;
  }
  return s;
}
function mi(e = {}) {
  const t = yr(e);
  return tre((n) => Kj(t, { onChange: n }), () => Qj(t));
}
function yD(e = {}) {
  const { onConnect: t, onDisconnect: n } = e, r = yr(e);
  We(() => Kj(r, {
    onChange(i, s) {
      if ((s.status === "reconnecting" || s.status === "connecting" && s.address === void 0) && i.status === "connected") {
        const { address: o, addresses: a, chain: c, chainId: l, connector: u } = i, d = s.status === "reconnecting" || // if `previousAccount.status` is `undefined`, the connector connected immediately.
        s.status === void 0;
        t == null || t({
          address: o,
          addresses: a,
          chain: c,
          chainId: l,
          connector: u,
          isReconnected: d
        });
      } else
        s.status === "connected" && i.status === "disconnected" && (n == null || n());
    }
  }), [r, t, n]);
}
function nre(e) {
  return JSON.stringify(e, (t, n) => rre(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : typeof n == "bigint" ? n.toString() : n);
}
function rre(e) {
  if (!OI(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const n = t.prototype;
  return !(!OI(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function OI(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function l5(e) {
  const {
    // import('@tanstack/query-core').QueryOptions
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    _defaulted: t,
    behavior: n,
    gcTime: r,
    initialData: i,
    initialDataUpdatedAt: s,
    maxPages: o,
    meta: a,
    networkMode: c,
    queryFn: l,
    queryHash: u,
    queryKey: d,
    queryKeyHashFn: f,
    retry: p,
    retryDelay: m,
    structuralSharing: h,
    // import('@tanstack/query-core').InfiniteQueryObserverOptions
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    getPreviousPageParam: g,
    getNextPageParam: y,
    initialPageParam: v,
    // import('@tanstack/react-query').UseQueryOptions
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    _optimisticResults: b,
    enabled: w,
    notifyOnChangeProps: A,
    placeholderData: E,
    refetchInterval: x,
    refetchIntervalInBackground: S,
    refetchOnMount: P,
    refetchOnReconnect: I,
    refetchOnWindowFocus: R,
    retryOnMount: Q,
    select: J,
    staleTime: we,
    suspense: V,
    throwOnError: L,
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // wagmi
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // biome-ignore lint/correctness/noUnusedVariables: remove properties
    config: U,
    connector: q,
    query: G,
    ...ae
  } = e;
  return ae;
}
function ire(e) {
  return {
    mutationFn(t) {
      return qte(e, t);
    },
    mutationKey: ["connect"]
  };
}
function sre(e) {
  return {
    mutationFn(t) {
      return $te(e, t);
    },
    mutationKey: ["disconnect"]
  };
}
function ore(e, t = {}) {
  return {
    async queryFn({ queryKey: n }) {
      const { address: r, scopeKey: i, ...s } = n[1];
      if (!r)
        throw new Error("address is required");
      return await Jte(e, {
        ...s,
        address: r
      }) ?? null;
    },
    queryKey: are(t)
  };
}
function are(e = {}) {
  return ["balance", l5(e)];
}
function cre(e, t = {}) {
  return {
    async queryFn({ queryKey: n }) {
      const { name: r, scopeKey: i, ...s } = n[1];
      if (!r)
        throw new Error("name is required");
      return ene(e, { ...s, name: r });
    },
    queryKey: lre(t)
  };
}
function lre(e = {}) {
  return ["ensAvatar", l5(e)];
}
function ure(e, t = {}) {
  return {
    async queryFn({ queryKey: n }) {
      const { address: r, scopeKey: i, ...s } = n[1];
      if (!r)
        throw new Error("address is required");
      return tne(e, { ...s, address: r });
    },
    queryKey: dre(t)
  };
}
function dre(e = {}) {
  return ["ensName", l5(e)];
}
function fre(e) {
  return {
    mutationFn(t) {
      return rne(e, t);
    },
    mutationKey: ["signMessage"]
  };
}
function hre(e) {
  return {
    mutationFn(t) {
      return ine(e, t);
    },
    mutationKey: ["switchChain"]
  };
}
function u5(e) {
  const t = Yne({
    ...e,
    queryKeyHashFn: nre
    // for bigint support
  });
  return t.queryKey = e.queryKey, t;
}
function d5(e = {}) {
  const t = yr(e);
  return ev((n) => sne(t, { onChange: n }), () => bI(t), () => bI(t));
}
function bD(e = {}) {
  const { address: t, query: n = {} } = e, r = yr(e), i = d5({ config: r }), s = ore(r, {
    ...e,
    chainId: e.chainId ?? i
  }), o = !!(t && (n.enabled ?? !0));
  return u5({ ...n, ...s, enabled: o });
}
function pre(e = {}) {
  const t = yr(e);
  return ev((n) => Zne(t, { onChange: n }), () => vI(t), () => vI(t));
}
function mre(e = {}) {
  const t = yr(e);
  return ev((n) => ane(t, { onChange: n }), () => wI(t), () => wI(t));
}
function vD(e = {}) {
  const { mutation: t } = e, n = yr(e), r = mre({ config: n }), i = ire(n), { mutate: s, mutateAsync: o, ...a } = jA({
    ...t,
    ...i
  });
  return We(() => n.subscribe(({ status: c }) => c, (c, l) => {
    l === "connected" && c === "disconnected" && a.reset();
  }), [n, a]), {
    ...a,
    connect: s,
    connectAsync: o,
    connectors: r
  };
}
function gre(e = {}) {
  const t = yr(e);
  return ev((n) => one(t, { onChange: n }), () => pS(t), () => pS(t));
}
function DA(e = {}) {
  const { mutation: t } = e, n = yr(e), r = sre(n), { mutate: i, mutateAsync: s, ...o } = jA({
    ...t,
    ...r
  });
  return {
    ...o,
    connectors: gre({ config: n }).map((a) => a.connector),
    disconnect: i,
    disconnectAsync: s
  };
}
function yre(e = {}) {
  const { name: t, query: n = {} } = e, r = yr(e), i = d5({ config: r }), s = cre(r, {
    ...e,
    chainId: e.chainId ?? i
  }), o = !!(t && (n.enabled ?? !0));
  return u5({ ...n, ...s, enabled: o });
}
function bre(e = {}) {
  const { address: t, query: n = {} } = e, r = yr(e), i = d5({ config: r }), s = ure(r, {
    ...e,
    chainId: e.chainId ?? i
  }), o = !!(t && (n.enabled ?? !0));
  return u5({ ...n, ...s, enabled: o });
}
function vre(e = {}) {
  const t = yr(e);
  return gD.useSyncExternalStoreWithSelector((n) => cne(t, { onChange: n }), () => mS(t, e), () => mS(t, e), (n) => n, (n, r) => (n == null ? void 0 : n.uid) === (r == null ? void 0 : r.uid));
}
function wre(e = {}) {
  const { mutation: t } = e, n = yr(e), r = fre(n), { mutate: i, mutateAsync: s, ...o } = jA({
    ...t,
    ...r
  });
  return {
    ...o,
    signMessage: i,
    signMessageAsync: s
  };
}
function xre(e = {}) {
  const { mutation: t } = e, n = yr(e), r = hre(n), { mutate: i, mutateAsync: s, ...o } = jA({
    ...t,
    ...r
  });
  return {
    ...o,
    chains: pre({ config: n }),
    switchChain: i,
    switchChainAsync: s
  };
}
var NI = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"', Are = {
  rounded: `SFRounded, ui-rounded, "SF Pro Rounded", ${NI}`,
  system: NI
}, g0 = {
  large: {
    actionButton: "9999px",
    connectButton: "12px",
    modal: "24px",
    modalMobile: "28px"
  },
  medium: {
    actionButton: "10px",
    connectButton: "8px",
    modal: "16px",
    modalMobile: "18px"
  },
  none: {
    actionButton: "0px",
    connectButton: "0px",
    modal: "0px",
    modalMobile: "0px"
  },
  small: {
    actionButton: "4px",
    connectButton: "4px",
    modal: "8px",
    modalMobile: "8px"
  }
}, Ere = {
  large: {
    modalOverlay: "blur(20px)"
  },
  none: {
    modalOverlay: "blur(0px)"
  },
  small: {
    modalOverlay: "blur(4px)"
  }
}, _re = ({
  borderRadius: e = "large",
  fontStack: t = "rounded",
  overlayBlur: n = "none"
}) => ({
  blurs: {
    modalOverlay: Ere[n].modalOverlay
  },
  fonts: {
    body: Are[t]
  },
  radii: {
    actionButton: g0[e].actionButton,
    connectButton: g0[e].connectButton,
    menuButton: g0[e].connectButton,
    modal: g0[e].modal,
    modalMobile: g0[e].modalMobile
  }
}), wD = {
  blue: { accentColor: "#0E76FD", accentColorForeground: "#FFF" },
  green: { accentColor: "#1DB847", accentColorForeground: "#FFF" },
  orange: { accentColor: "#FF801F", accentColorForeground: "#FFF" },
  pink: { accentColor: "#FF5CA0", accentColorForeground: "#FFF" },
  purple: { accentColor: "#5F5AFA", accentColorForeground: "#FFF" },
  red: { accentColor: "#FA423C", accentColorForeground: "#FFF" }
}, RI = wD.blue, xD = ({
  accentColor: e = RI.accentColor,
  accentColorForeground: t = RI.accentColorForeground,
  ...n
} = {}) => ({
  ..._re(n),
  colors: {
    accentColor: e,
    accentColorForeground: t,
    actionButtonBorder: "rgba(0, 0, 0, 0.04)",
    actionButtonBorderMobile: "rgba(0, 0, 0, 0.06)",
    actionButtonSecondaryBackground: "rgba(0, 0, 0, 0.06)",
    closeButton: "rgba(60, 66, 66, 0.8)",
    closeButtonBackground: "rgba(0, 0, 0, 0.06)",
    connectButtonBackground: "#FFF",
    connectButtonBackgroundError: "#FF494A",
    connectButtonInnerBackground: "linear-gradient(0deg, rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.06))",
    connectButtonText: "#25292E",
    connectButtonTextError: "#FFF",
    connectionIndicator: "#30E000",
    downloadBottomCardBackground: "linear-gradient(126deg, rgba(255, 255, 255, 0) 9.49%, rgba(171, 171, 171, 0.04) 71.04%), #FFFFFF",
    downloadTopCardBackground: "linear-gradient(126deg, rgba(171, 171, 171, 0.2) 9.49%, rgba(255, 255, 255, 0) 71.04%), #FFFFFF",
    error: "#FF494A",
    generalBorder: "rgba(0, 0, 0, 0.06)",
    generalBorderDim: "rgba(0, 0, 0, 0.03)",
    menuItemBackground: "rgba(60, 66, 66, 0.1)",
    modalBackdrop: "rgba(0, 0, 0, 0.3)",
    modalBackground: "#FFF",
    modalBorder: "transparent",
    modalText: "#25292E",
    modalTextDim: "rgba(60, 66, 66, 0.3)",
    modalTextSecondary: "rgba(60, 66, 66, 0.6)",
    profileAction: "#FFF",
    profileActionHover: "rgba(255, 255, 255, 0.5)",
    profileForeground: "rgba(60, 66, 66, 0.06)",
    selectedOptionBorder: "rgba(60, 66, 66, 0.1)",
    standby: "#FFD641"
  },
  shadows: {
    connectButton: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    dialog: "0px 8px 32px rgba(0, 0, 0, 0.32)",
    profileDetailsAction: "0px 2px 6px rgba(37, 41, 46, 0.04)",
    selectedOption: "0px 2px 6px rgba(0, 0, 0, 0.24)",
    selectedWallet: "0px 2px 6px rgba(0, 0, 0, 0.12)",
    walletLogo: "0px 2px 16px rgba(0, 0, 0, 0.16)"
  }
});
xD.accentColors = wD;
var MI = `{
  "connect_wallet": {
    "label": "Connect Wallet",
    "wrong_network": {
      "label": "Wrong network"
    }
  },

  "intro": {
    "title": "What is a Wallet?",
    "description": "A wallet is used to send, receive, store, and display digital assets. It's also a new way to log in, without needing to create new accounts and passwords on every website.",
    "digital_asset": {
      "title": "A Home for your Digital Assets",
      "description": "Wallets are used to send, receive, store, and display digital assets like Ethereum and NFTs."
    },
    "login": {
      "title": "A New Way to Log In",
      "description": "Instead of creating new accounts and passwords on every website, just connect your wallet."
    },
    "get": {
      "label": "Get a Wallet"
    },
    "learn_more": {
      "label": "Learn More"
    }
  },

  "sign_in": {
    "label": "Verify your account",
    "description": "To finish connecting, you must sign a message in your wallet to verify that you are the owner of this account.",
    "message": {
      "send": "Sign message",
      "preparing": "Preparing message...",
      "cancel": "Cancel",
      "preparing_error": "Error preparing message, please retry!"
    },
    "signature": {
      "waiting": "Waiting for signature...",
      "verifying": "Verifying signature...",
      "signing_error": "Error signing message, please retry!",
      "verifying_error": "Error verifying signature, please retry!",
      "oops_error": "Oops, something went wrong!"
    }
  },

  "connect": {
    "label": "Connect",
    "title": "Connect a Wallet",
    "new_to_ethereum": {
      "description": "New to Ethereum wallets?",
      "learn_more": {
        "label": "Learn More"
      }
    },
    "learn_more": {
      "label": "Learn more"
    },
    "recent": "Recent",
    "status": {
      "opening": "Opening %{wallet}...",
      "connecting": "Connecting",
      "connect_mobile": "Continue in %{wallet}",
      "not_installed": "%{wallet} is not installed",
      "not_available": "%{wallet} is not available",
      "confirm": "Confirm connection in the extension",
      "confirm_mobile": "Accept connection request in the wallet"
    },
    "secondary_action": {
      "get": {
        "description": "Don't have %{wallet}?",
        "label": "GET"
      },
      "install": {
        "label": "INSTALL"
      },
      "retry": {
        "label": "RETRY"
      }
    },
    "walletconnect": {
      "description": {
        "full": "Need the official WalletConnect modal?",
        "compact": "Need the WalletConnect modal?"
      },
      "open": {
        "label": "OPEN"
      }
    }
  },

  "connect_scan": {
    "title": "Scan with %{wallet}",
    "fallback_title": "Scan with your phone"
  },

  "connector_group": {
    "installed": "Installed",
    "recommended": "Recommended",
    "other": "Other",
    "popular": "Popular",
    "more": "More",
    "others": "Others"
  },

  "get": {
    "title": "Get a Wallet",
    "action": {
      "label": "GET"
    },
    "mobile": {
      "description": "Mobile Wallet"
    },
    "extension": {
      "description": "Browser Extension"
    },
    "mobile_and_extension": {
      "description": "Mobile Wallet and Extension"
    },
    "mobile_and_desktop": {
      "description": "Mobile and Desktop Wallet"
    },
    "looking_for": {
      "title": "Not what you're looking for?",
      "mobile": {
        "description": "Select a wallet on the main screen to get started with a different wallet provider."
      },
      "desktop": {
        "compact_description": "Select a wallet on the main screen to get started with a different wallet provider.",
        "wide_description": "Select a wallet on the left to get started with a different wallet provider."
      }
    }
  },

  "get_options": {
    "title": "Get started with %{wallet}",
    "short_title": "Get %{wallet}",
    "mobile": {
      "title": "%{wallet} for Mobile",
      "description": "Use the mobile wallet to explore the world of Ethereum.",
      "download": {
        "label": "Get the app"
      }
    },
    "extension": {
      "title": "%{wallet} for %{browser}",
      "description": "Access your wallet right from your favorite web browser.",
      "download": {
        "label": "Add to %{browser}"
      }
    },
    "desktop": {
      "title": "%{wallet} for %{platform}",
      "description": "Access your wallet natively from your powerful desktop.",
      "download": {
        "label": "Add to %{platform}"
      }
    }
  },

  "get_mobile": {
    "title": "Install %{wallet}",
    "description": "Scan with your phone to download on iOS or Android",
    "continue": {
      "label": "Continue"
    }
  },

  "get_instructions": {
    "mobile": {
      "connect": {
        "label": "Connect"
      },
      "learn_more": {
        "label": "Learn More"
      }
    },
    "extension": {
      "refresh": {
        "label": "Refresh"
      },
      "learn_more": {
        "label": "Learn More"
      }
    },
    "desktop": {
      "connect": {
        "label": "Connect"
      },
      "learn_more": {
        "label": "Learn More"
      }
    }
  },

  "chains": {
    "title": "Switch Networks",
    "wrong_network": "Wrong network detected, switch or disconnect to continue.",
    "confirm": "Confirm in Wallet",
    "switching_not_supported": "Your wallet does not support switching networks from %{appName}. Try switching networks from within your wallet instead.",
    "switching_not_supported_fallback": "Your wallet does not support switching networks from this app. Try switching networks from within your wallet instead.",
    "disconnect": "Disconnect",
    "connected": "Connected"
  },

  "profile": {
    "disconnect": {
      "label": "Disconnect"
    },
    "copy_address": {
      "label": "Copy Address",
      "copied": "Copied!"
    },
    "explorer": {
      "label": "View more on explorer"
    },
    "transactions": {
      "description": "%{appName} transactions will appear here...",
      "description_fallback": "Your transactions will appear here...",
      "recent": {
        "title": "Recent Transactions"
      },
      "clear": {
        "label": "Clear All"
      }
    }
  },

  "wallet_connectors": {
    "argent": {
      "qr_code": {
        "step1": {
          "description": "Put Argent on your home screen for faster access to your wallet.",
          "title": "Open the Argent app"
        },
        "step2": {
          "description": "Create a wallet and username, or import an existing wallet.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the Scan QR button"
        }
      }
    },

    "bifrost": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Bifrost Wallet on your home screen for quicker access.",
          "title": "Open the Bifrost Wallet app"
        },
        "step2": {
          "description": "Create or import a wallet using your recovery phrase.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the scan button"
        }
      }
    },

    "bitget": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Bitget Wallet on your home screen for quicker access.",
          "title": "Open the Bitget Wallet app"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the scan button"
        }
      },

      "extension": {
        "step1": {
          "description": "We recommend pinning Bitget Wallet to your taskbar for quicker access to your wallet.",
          "title": "Install the Bitget Wallet extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "bitski": {
      "extension": {
        "step1": {
          "description": "We recommend pinning Bitski to your taskbar for quicker access to your wallet.",
          "title": "Install the Bitski extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "bitverse": {
      "qr_code": {
        "step1": {
          "title": "Open the Bitverse Wallet app",
          "description": "Add Bitverse Wallet to your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap the QR icon and scan",
          "description": "Tap the QR icon on your homescreen, scan the code and confirm the prompt to connect."
        }
      }
    },

    "bloom": {
      "desktop": {
        "step1": {
          "title": "Open the Bloom Wallet app",
          "description": "We recommend putting Bloom Wallet on your home screen for quicker access."
        },
        "step2": {
          "description": "Create or import a wallet using your recovery phrase.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you have a wallet, click on Connect to connect via Bloom. A connection prompt in the app will appear for you to confirm the connection.",
          "title": "Click on Connect"
        }
      },
      "qr_code": {
        "step1": {
          "title": "Open the Bloom Wallet app",
          "description": "We recommend putting Bloom Wallet on your home screen for quicker access."
        },
        "step2": {
          "description": "Create or import a wallet using your recovery phrase.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you have a wallet, click on Connect to connect via Bloom. A connection prompt in the app will appear for you to confirm the connection.",
          "title": "Click on Connect"
        }
      }
    },

    "bybit": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Bybit on your home screen for faster access to your wallet.",
          "title": "Open the Bybit app"
        },
        "step2": {
          "description": "You can easily backup your wallet using our backup feature on your phone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the scan button"
        }
      },

      "extension": {
        "step1": {
          "description": "Click at the top right of your browser and pin Bybit Wallet for easy access.",
          "title": "Install the Bybit Wallet extension"
        },
        "step2": {
          "description": "Create a new wallet or import an existing one.",
          "title": "Create or Import a wallet"
        },
        "step3": {
          "description": "Once you set up Bybit Wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "coin98": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Coin98 Wallet on your home screen for faster access to your wallet.",
          "title": "Open the Coin98 Wallet app"
        },
        "step2": {
          "description": "You can easily backup your wallet using our backup feature on your phone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the WalletConnect button"
        }
      },

      "extension": {
        "step1": {
          "description": "Click at the top right of your browser and pin Coin98 Wallet for easy access.",
          "title": "Install the Coin98 Wallet extension"
        },
        "step2": {
          "description": "Create a new wallet or import an existing one.",
          "title": "Create or Import a wallet"
        },
        "step3": {
          "description": "Once you set up Coin98 Wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "coinbase": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Coinbase Wallet on your home screen for quicker access.",
          "title": "Open the Coinbase Wallet app"
        },
        "step2": {
          "description": "You can easily backup your wallet using the cloud backup feature.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the scan button"
        }
      },

      "extension": {
        "step1": {
          "description": "We recommend pinning Coinbase Wallet to your taskbar for quicker access to your wallet.",
          "title": "Install the Coinbase Wallet extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "compass": {
      "extension": {
        "step1": {
          "description": "We recommend pinning Compass Wallet to your taskbar for quicker access to your wallet.",
          "title": "Install the Compass Wallet extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "core": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Core on your home screen for faster access to your wallet.",
          "title": "Open the Core app"
        },
        "step2": {
          "description": "You can easily backup your wallet using our backup feature on your phone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the WalletConnect button"
        }
      },

      "extension": {
        "step1": {
          "description": "We recommend pinning Core to your taskbar for quicker access to your wallet.",
          "title": "Install the Core extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "fox": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting FoxWallet on your home screen for quicker access.",
          "title": "Open the FoxWallet app"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the scan button"
        }
      }
    },

    "frontier": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Frontier Wallet on your home screen for quicker access.",
          "title": "Open the Frontier Wallet app"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the scan button"
        }
      },

      "extension": {
        "step1": {
          "description": "We recommend pinning Frontier Wallet to your taskbar for quicker access to your wallet.",
          "title": "Install the Frontier Wallet extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "im_token": {
      "qr_code": {
        "step1": {
          "title": "Open the imToken app",
          "description": "Put imToken app on your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap Scanner Icon in top right corner",
          "description": "Choose New Connection, then scan the QR code and confirm the prompt to connect."
        }
      }
    },

    "kaikas": {
      "extension": {
        "step1": {
          "description": "We recommend pinning Kaikas to your taskbar for quicker access to your wallet.",
          "title": "Install the Kaikas extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      },
      "qr_code": {
        "step1": {
          "title": "Open the Kaikas app",
          "description": "Put Kaikas app on your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap Scanner Icon in top right corner",
          "description": "Choose New Connection, then scan the QR code and confirm the prompt to connect."
        }
      }
    },

    "kraken": {
      "qr_code": {
        "step1": {
          "title": "Open the Kraken Wallet app",
          "description": "Add Kraken Wallet to your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap the QR icon and scan",
          "description": "Tap the QR icon on your homescreen, scan the code and confirm the prompt to connect."
        }
      }
    },

    "kresus": {
      "qr_code": {
        "step1": {
          "title": "Open the Kresus Wallet app",
          "description": "Add Kresus Wallet to your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap the QR icon and scan",
          "description": "Tap the QR icon on your homescreen, scan the code and confirm the prompt to connect."
        }
      }
    },

    "metamask": {
      "qr_code": {
        "step1": {
          "title": "Open the MetaMask app",
          "description": "We recommend putting MetaMask on your home screen for quicker access."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Tap the scan button",
          "description": "After you scan, a connection prompt will appear for you to connect your wallet."
        }
      },

      "extension": {
        "step1": {
          "title": "Install the MetaMask extension",
          "description": "We recommend pinning MetaMask to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "okx": {
      "qr_code": {
        "step1": {
          "title": "Open the OKX Wallet app",
          "description": "We recommend putting OKX Wallet on your home screen for quicker access."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Tap the scan button",
          "description": "After you scan, a connection prompt will appear for you to connect your wallet."
        }
      },

      "extension": {
        "step1": {
          "title": "Install the OKX Wallet extension",
          "description": "We recommend pinning OKX Wallet to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "omni": {
      "qr_code": {
        "step1": {
          "title": "Open the Omni app",
          "description": "Add Omni to your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap the QR icon and scan",
          "description": "Tap the QR icon on your home screen, scan the code and confirm the prompt to connect."
        }
      }
    },

    "1inch": {
      "qr_code": {
        "step1": {
          "description": "Put 1inch Wallet on your home screen for faster access to your wallet.",
          "title": "Open the 1inch Wallet app"
        },
        "step2": {
          "description": "Create a wallet and username, or import an existing wallet.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the Scan QR button"
        }
      }
    },

    "token_pocket": {
      "qr_code": {
        "step1": {
          "title": "Open the TokenPocket app",
          "description": "We recommend putting TokenPocket on your home screen for quicker access."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Tap the scan button",
          "description": "After you scan, a connection prompt will appear for you to connect your wallet."
        }
      },

      "extension": {
        "step1": {
          "title": "Install the TokenPocket extension",
          "description": "We recommend pinning TokenPocket to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "trust": {
      "qr_code": {
        "step1": {
          "title": "Open the Trust Wallet app",
          "description": "Put Trust Wallet on your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap WalletConnect in Settings",
          "description": "Choose New Connection, then scan the QR code and confirm the prompt to connect."
        }
      },

      "extension": {
        "step1": {
          "title": "Install the Trust Wallet extension",
          "description": "Click at the top right of your browser and pin Trust Wallet for easy access."
        },
        "step2": {
          "title": "Create or Import a wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up Trust Wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "uniswap": {
      "qr_code": {
        "step1": {
          "title": "Open the Uniswap app",
          "description": "Add Uniswap Wallet to your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap the QR icon and scan",
          "description": "Tap the QR icon on your homescreen, scan the code and confirm the prompt to connect."
        }
      }
    },

    "zerion": {
      "qr_code": {
        "step1": {
          "title": "Open the Zerion app",
          "description": "We recommend putting Zerion on your home screen for quicker access."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Tap the scan button",
          "description": "After you scan, a connection prompt will appear for you to connect your wallet."
        }
      },

      "extension": {
        "step1": {
          "title": "Install the Zerion extension",
          "description": "We recommend pinning Zerion to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "rainbow": {
      "qr_code": {
        "step1": {
          "title": "Open the Rainbow app",
          "description": "We recommend putting Rainbow on your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "You can easily backup your wallet using our backup feature on your phone."
        },
        "step3": {
          "title": "Tap the scan button",
          "description": "After you scan, a connection prompt will appear for you to connect your wallet."
        }
      }
    },

    "enkrypt": {
      "extension": {
        "step1": {
          "description": "We recommend pinning Enkrypt Wallet to your taskbar for quicker access to your wallet.",
          "title": "Install the Enkrypt Wallet extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "frame": {
      "extension": {
        "step1": {
          "description": "We recommend pinning Frame to your taskbar for quicker access to your wallet.",
          "title": "Install Frame & the companion extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "one_key": {
      "extension": {
        "step1": {
          "title": "Install the OneKey Wallet extension",
          "description": "We recommend pinning OneKey Wallet to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "phantom": {
      "extension": {
        "step1": {
          "title": "Install the Phantom extension",
          "description": "We recommend pinning Phantom to your taskbar for easier access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret recovery phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "rabby": {
      "extension": {
        "step1": {
          "title": "Install the Rabby extension",
          "description": "We recommend pinning Rabby to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "ronin": {
      "qr_code": {
        "step1": {
          "description": "We recommend putting Ronin Wallet on your home screen for quicker access.",
          "title": "Open the Ronin Wallet app"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "After you scan, a connection prompt will appear for you to connect your wallet.",
          "title": "Tap the scan button"
        }
      },

      "extension": {
        "step1": {
          "description": "We recommend pinning Ronin Wallet to your taskbar for quicker access to your wallet.",
          "title": "Install the Ronin Wallet extension"
        },
        "step2": {
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
          "title": "Create or Import a Wallet"
        },
        "step3": {
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension.",
          "title": "Refresh your browser"
        }
      }
    },

    "ramper": {
      "extension": {
        "step1": {
          "title": "Install the Ramper extension",
          "description": "We recommend pinning Ramper to your taskbar for easier access to your wallet."
        },
        "step2": {
          "title": "Create a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "safeheron": {
      "extension": {
        "step1": {
          "title": "Install the Core extension",
          "description": "We recommend pinning Safeheron to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "taho": {
      "extension": {
        "step1": {
          "title": "Install the Taho extension",
          "description": "We recommend pinning Taho to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "talisman": {
      "extension": {
        "step1": {
          "title": "Install the Talisman extension",
          "description": "We recommend pinning Talisman to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import an Ethereum Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your recovery phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "xdefi": {
      "extension": {
        "step1": {
          "title": "Install the XDEFI Wallet extension",
          "description": "We recommend pinning XDEFI Wallet to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "zeal": {
      "extension": {
        "step1": {
          "title": "Install the Zeal extension",
          "description": "We recommend pinning Zeal to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "safepal": {
      "extension": {
        "step1": {
          "title": "Install the SafePal Wallet extension",
          "description": "Click at the top right of your browser and pin SafePal Wallet for easy access."
        },
        "step2": {
          "title": "Create or Import a wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up SafePal Wallet, click below to refresh the browser and load up the extension."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Open the SafePal Wallet app",
          "description": "Put SafePal Wallet on your home screen for faster access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Create a new wallet or import an existing one."
        },
        "step3": {
          "title": "Tap WalletConnect in Settings",
          "description": "Choose New Connection, then scan the QR code and confirm the prompt to connect."
        }
      }
    },

    "desig": {
      "extension": {
        "step1": {
          "title": "Install the Desig extension",
          "description": "We recommend pinning Desig to your taskbar for easier access to your wallet."
        },
        "step2": {
          "title": "Create a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      }
    },

    "subwallet": {
      "extension": {
        "step1": {
          "title": "Install the SubWallet extension",
          "description": "We recommend pinning SubWallet to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your recovery phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Open the SubWallet app",
          "description": "We recommend putting SubWallet on your home screen for quicker access."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Tap the scan button",
          "description": "After you scan, a connection prompt will appear for you to connect your wallet."
        }
      }
    },

    "clv": {
      "extension": {
        "step1": {
          "title": "Install the CLV Wallet extension",
          "description": "We recommend pinning CLV Wallet to your taskbar for quicker access to your wallet."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Refresh your browser",
          "description": "Once you set up your wallet, click below to refresh the browser and load up the extension."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Open the CLV Wallet app",
          "description": "We recommend putting CLV Wallet on your home screen for quicker access."
        },
        "step2": {
          "title": "Create or Import a Wallet",
          "description": "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
        },
        "step3": {
          "title": "Tap the scan button",
          "description": "After you scan, a connection prompt will appear for you to connect your wallet."
        }
      }
    },

    "okto": {
      "qr_code": {
        "step1": {
          "title": "Open the Okto app",
          "description": "Add Okto to your home screen for quick access"
        },
        "step2": {
          "title": "Create an MPC Wallet",
          "description": "Create an account and generate a wallet"
        },
        "step3": {
          "title": "Tap WalletConnect in Settings",
          "description": "Tap the Scan QR icon at the top right and confirm the prompt to connect."
        }
      }
    },

    "ledger": {
      "desktop": {
        "step1": {
          "title": "Open the Ledger Live app",
          "description": "We recommend putting Ledger Live on your home screen for quicker access."
        },
        "step2": {
          "title": "Set up your Ledger",
          "description": "Set up a new Ledger or connect to an existing one."
        },
        "step3": {
          "title": "Connect",
          "description": "A connection prompt will appear for you to connect your wallet."
        }
      },
      "qr_code": {
        "step1": {
          "title": "Open the Ledger Live app",
          "description": "We recommend putting Ledger Live on your home screen for quicker access."
        },
        "step2": {
          "title": "Set up your Ledger",
          "description": "You can either sync with the desktop app or connect your Ledger."
        },
        "step3": {
          "title": "Scan the code",
          "description": "Tap WalletConnect then Switch to Scanner. After you scan, a connection prompt will appear for you to connect your wallet."
        }
      }
    }
  }
}
`;
function Sre(e, t) {
  return Object.defineProperty(e, "__recipe__", {
    value: t,
    writable: !1
  }), e;
}
var AD = Sre;
function ED(e) {
  var {
    conditions: t
  } = e;
  if (!t)
    throw new Error("Styles have no conditions");
  function n(r) {
    if (typeof r == "string" || typeof r == "number" || typeof r == "boolean") {
      if (!t.defaultCondition)
        throw new Error("No default condition");
      return {
        [t.defaultCondition]: r
      };
    }
    if (Array.isArray(r)) {
      if (!("responsiveArray" in t))
        throw new Error("Responsive arrays are not supported");
      var i = {};
      for (var s in t.responsiveArray)
        r[s] != null && (i[t.responsiveArray[s]] = r[s]);
      return i;
    }
    return r;
  }
  return AD(n, {
    importPath: "@vanilla-extract/sprinkles/createUtils",
    importName: "createNormalizeValueFn",
    args: [{
      conditions: e.conditions
    }]
  });
}
function Cre(e) {
  var {
    conditions: t
  } = e;
  if (!t)
    throw new Error("Styles have no conditions");
  var n = ED(e);
  function r(i, s) {
    if (typeof i == "string" || typeof i == "number" || typeof i == "boolean") {
      if (!t.defaultCondition)
        throw new Error("No default condition");
      return s(i, t.defaultCondition);
    }
    var o = Array.isArray(i) ? n(i) : i, a = {};
    for (var c in o)
      o[c] != null && (a[c] = s(o[c], c));
    return a;
  }
  return AD(r, {
    importPath: "@vanilla-extract/sprinkles/createUtils",
    importName: "createMapValueFn",
    args: [{
      conditions: e.conditions
    }]
  });
}
var F3 = { npm_package_exports___require: "./dist/index.cjs", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.22 npm/? node/v20.15.1 linux x64", CI: "true", npm_package_bugs_url: "https://github.com/bitfinity-network/bitbridge/issues", npm_config_bin_links: "true", npm_node_execpath: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", npm_package_devDependencies_vite: "^5.2.0", npm_config_init_version: "1.0.0", npm_package_peerDependencies_react: "^18.2.0", npm_package_devDependencies__tanstack_react_query_devtools: "^5.24.0", npm_package_dependencies_wagmi: "^2.8.1", npm_package_files_0: "dist", npm_package_publishConfig_access: "public", HOME: "/home/runner", npm_package_devDependencies__typescript_eslint_parser: "^7.2.0", npm_package_dependencies_ethers: "^6.12.1", npm_package_dependencies_framer_motion: "^11.1.9", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_dependencies__rainbow_me_rainbowkit: "^2.0.7", npm_config_version_tag_prefix: "v", npm_package_devDependencies_vite_plugin_dts: "^3.9.1", npm_package_dependencies_react_icons: "^5.2.1", npm_package_devDependencies_eslint_plugin_react_hooks: "^4.6.0", npm_package_dependencies_dotenv: "^16.4.5", npm_package_devDependencies_typescript: "^5.2.2", npm_package_dependencies__dfinity_agent: "^1.2.0", npm_package_description: "The React UI for the Bitfinity EVM bridge", npm_package_readmeFilename: "README.md", npm_package_devDependencies__types_react_dom: "^18.2.22", npm_package_devDependencies_vite_plugin_mix: "^0.4.0", npm_package_types: "./dist/index.d.ts", npm_package_homepage: "https://github.com/bitfinity-network/bitbridge", npm_package_scripts_dev: "vite", npm_package_devDependencies__vitejs_plugin_react: "^4.2.1", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "^0.22.0", npm_package_dependencies__tanstack_query_sync_storage_persister: "^5.22.2", npm_package_dependencies__emotion_react: "^11.11.4", npm_package_module: "./dist/index.js", npm_package_devDependencies__typescript_eslint_eslint_plugin: "^7.2.0", npm_package_scripts_lint: "eslint . --ext ts,tsx --report-unused-disable-directives --max-warnings 0", npm_config_registry: "https://registry.yarnpkg.com", npm_package_devDependencies_eslint_plugin_react_refresh: "^0.4.6", npm_package_exports___import: "./dist/index.js", npm_config_ignore_scripts: "", npm_package_dependencies__bitfinity_network_bitfinitywallet: "^0.3.0", npm_package_author_email: "support@infinityswap.one", PATH: "/tmp/yarn--1722436032859-0.7268831613784328:/home/runner/work/bitbridge/bitbridge/packages/widget/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1722436018550-0.027432302051107138:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin:/snap/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", NODE: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", TURBO_HASH: "4c69888b02b3c09f", npm_package_name: "@bitfinity-network/bridge-widget", npm_package_dependencies_viem: "2.x", npm_package_dependencies__particle_network_btc_connectkit: "^1.0.0-alpha.25", LANG: "C.UTF-8", npm_package_devDependencies_eslint: "^8.57.0", npm_lifecycle_script: "tsc && vite build", npm_package_main: "./dist/index.cjs", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_devDependencies__types_react: "^18.2.66", npm_package_version: "1.3.0", npm_config_argv: '{"remain":[],"cooked":["run","build"],"original":["run","build"]}', npm_package_dependencies__bitfinity_network_bridge: "*", npm_package_scripts_build: "tsc && vite build", npm_package_peerDependencies_react_dom: "^18.2.0", npm_package_dependencies__tanstack_react_query: "^5.35.1", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "MIT", npm_config_strict_ssl: "true", npm_package_dependencies__chakra_ui_react: "^2.8.2", PWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_execpath: "/usr/local/lib/node_modules/yarn/bin/yarn.js", npm_package_dependencies__emotion_styled: "^11.11.5", npm_package_author_url: "https://bitfinity.network/", npm_package_author_name: "Bitfinity", npm_package_dependencies_react_spring_bottom_sheet: "3.5.0-alpha.0", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_scripts_preview: "vite preview", npm_package_dependencies_vite_plugin_svgr: "^4.2.0", INIT_CWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_package_dependencies__tanstack_react_query_persist_client: "^5.22.2", NODE_ENV: "production" };
function Tre(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kre(e) {
  var t = Tre(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function Bre(e, t, n) {
  return t = kre(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function FI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function j3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? FI(Object(n), !0).forEach(function(r) {
      Bre(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : FI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ire = (e) => function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = Object.assign({}, ...n.map((c) => c.styles)), s = Object.keys(i), o = s.filter((c) => "mappings" in i[c]), a = (c) => {
    var l = [], u = {}, d = j3({}, c), f = !1;
    for (var p of o) {
      var m = c[p];
      if (m != null) {
        var h = i[p];
        f = !0;
        for (var g of h.mappings)
          u[g] = m, d[g] == null && delete d[g];
      }
    }
    var y = f ? j3(j3({}, u), d) : c, v = function() {
      var E = y[b], x = i[b];
      try {
        if (x.mappings)
          return "continue";
        if (typeof E == "string" || typeof E == "number")
          F3.NODE_ENV, l.push(x.values[E].defaultClass);
        else if (Array.isArray(E))
          for (var S = 0; S < E.length; S++) {
            var P = E[S];
            if (P != null) {
              var I = x.responsiveArray[S];
              F3.NODE_ENV, l.push(x.values[P].conditions[I]);
            }
          }
        else
          for (var R in E) {
            var Q = E[R];
            Q != null && (F3.NODE_ENV, l.push(x.values[Q].conditions[R]));
          }
      } catch (J) {
        throw J;
      }
    };
    for (var b in y)
      var w = v();
    return e(l.join(" "));
  };
  return Object.assign(a, {
    properties: new Set(s)
  });
}, Pre = (e) => e, Ore = function() {
  return Ire(Pre)(...arguments);
};
function _D(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++)
        e[t] && (n = _D(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function SD() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++)
    (e = arguments[n]) && (t = _D(e)) && (r && (r += " "), r += t);
  return r;
}
var Nre = "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";
const jI = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), DI = 4;
function Rre(e) {
  let t = 0;
  function n() {
    return e[t++] << 8 | e[t++];
  }
  let r = n(), i = 1, s = [0, 1];
  for (let A = 1; A < r; A++)
    s.push(i += n());
  let o = n(), a = t;
  t += o;
  let c = 0, l = 0;
  function u() {
    return c == 0 && (l = l << 8 | e[t++], c = 8), l >> --c & 1;
  }
  const d = 31, f = 2 ** d, p = f >>> 1, m = p >> 1, h = f - 1;
  let g = 0;
  for (let A = 0; A < d; A++)
    g = g << 1 | u();
  let y = [], v = 0, b = f;
  for (; ; ) {
    let A = Math.floor(((g - v + 1) * i - 1) / b), E = 0, x = r;
    for (; x - E > 1; ) {
      let I = E + x >>> 1;
      A < s[I] ? x = I : E = I;
    }
    if (E == 0)
      break;
    y.push(E);
    let S = v + Math.floor(b * s[E] / i), P = v + Math.floor(b * s[E + 1] / i) - 1;
    for (; !((S ^ P) & p); )
      g = g << 1 & h | u(), S = S << 1 & h, P = P << 1 & h | 1;
    for (; S & ~P & m; )
      g = g & p | g << 1 & h >>> 1 | u(), S = S << 1 ^ p, P = (P ^ p) << 1 | p | 1;
    v = S, b = 1 + P - S;
  }
  let w = r - 4;
  return y.map((A) => {
    switch (A - w) {
      case 3:
        return w + 65792 + (e[a++] << 16 | e[a++] << 8 | e[a++]);
      case 2:
        return w + 256 + (e[a++] << 8 | e[a++]);
      case 1:
        return w + e[a++];
      default:
        return A - 1;
    }
  });
}
function Mre(e) {
  let t = 0;
  return () => e[t++];
}
function CD(e) {
  return Mre(Rre(Fre(e)));
}
function Fre(e) {
  let t = [];
  [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((i, s) => t[i.charCodeAt(0)] = s);
  let n = e.length, r = new Uint8Array(6 * n >> 3);
  for (let i = 0, s = 0, o = 0, a = 0; i < n; i++)
    a = a << 6 | t[e.charCodeAt(i)], o += 6, o >= 8 && (r[s++] = a >> (o -= 8));
  return r;
}
function jre(e) {
  return e & 1 ? ~e >> 1 : e >> 1;
}
function Dre(e, t) {
  let n = Array(e);
  for (let r = 0, i = 0; r < e; r++)
    n[r] = i += jre(t());
  return n;
}
function ay(e, t = 0) {
  let n = [];
  for (; ; ) {
    let r = e(), i = e();
    if (!i)
      break;
    t += r;
    for (let s = 0; s < i; s++)
      n.push(t + s);
    t += i + 1;
  }
  return n;
}
function TD(e) {
  return cy(() => {
    let t = ay(e);
    if (t.length)
      return t;
  });
}
function kD(e) {
  let t = [];
  for (; ; ) {
    let n = e();
    if (n == 0)
      break;
    t.push(Ure(n, e));
  }
  for (; ; ) {
    let n = e() - 1;
    if (n < 0)
      break;
    t.push(Lre(n, e));
  }
  return t.flat();
}
function cy(e) {
  let t = [];
  for (; ; ) {
    let n = e(t.length);
    if (!n)
      break;
    t.push(n);
  }
  return t;
}
function BD(e, t, n) {
  let r = Array(e).fill().map(() => []);
  for (let i = 0; i < t; i++)
    Dre(e, n).forEach((s, o) => r[o].push(s));
  return r;
}
function Ure(e, t) {
  let n = 1 + t(), r = t(), i = cy(t);
  return BD(i.length, 1 + e, t).flatMap((o, a) => {
    let [c, ...l] = o;
    return Array(i[a]).fill().map((u, d) => {
      let f = d * r;
      return [c + d * n, l.map((p) => p + f)];
    });
  });
}
function Lre(e, t) {
  let n = 1 + t();
  return BD(n, 1 + e, t).map((i) => [i[0], i.slice(1)]);
}
function zre(e) {
  let t = [], n = ay(e);
  return i(r([]), []), t;
  function r(s) {
    let o = e(), a = cy(() => {
      let c = ay(e).map((l) => n[l]);
      if (c.length)
        return r(c);
    });
    return { S: o, B: a, Q: s };
  }
  function i({ S: s, B: o }, a, c) {
    if (!(s & 4 && c === a[a.length - 1])) {
      s & 2 && (c = a[a.length - 1]), s & 1 && t.push(a);
      for (let l of o)
        for (let u of l.Q)
          i(l, [...a, u], c);
    }
  }
}
function Vre(e) {
  return e.toString(16).toUpperCase().padStart(2, "0");
}
function ID(e) {
  return `{${Vre(e)}}`;
}
function Hre(e) {
  let t = [];
  for (let n = 0, r = e.length; n < r; ) {
    let i = e.codePointAt(n);
    n += i < 65536 ? 1 : 2, t.push(i);
  }
  return t;
}
function hm(e) {
  let n = e.length;
  if (n < 4096)
    return String.fromCodePoint(...e);
  let r = [];
  for (let i = 0; i < n; )
    r.push(String.fromCodePoint(...e.slice(i, i += 4096)));
  return r.join("");
}
function Wre(e, t) {
  let n = e.length, r = n - t.length;
  for (let i = 0; r == 0 && i < n; i++)
    r = e[i] - t[i];
  return r;
}
var Gre = "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";
const ly = 44032, kx = 4352, Bx = 4449, Ix = 4519, PD = 19, OD = 21, pm = 28, Px = OD * pm, qre = PD * Px, $re = ly + qre, Qre = kx + PD, Kre = Bx + OD, Yre = Ix + pm;
function U0(e) {
  return e >> 24 & 255;
}
function ND(e) {
  return e & 16777215;
}
let NS, UI, RS, dw;
function Zre() {
  let e = CD(Gre);
  NS = new Map(TD(e).flatMap((t, n) => t.map((r) => [r, n + 1 << 24]))), UI = new Set(ay(e)), RS = /* @__PURE__ */ new Map(), dw = /* @__PURE__ */ new Map();
  for (let [t, n] of kD(e)) {
    if (!UI.has(t) && n.length == 2) {
      let [r, i] = n, s = dw.get(r);
      s || (s = /* @__PURE__ */ new Map(), dw.set(r, s)), s.set(i, t);
    }
    RS.set(t, n.reverse());
  }
}
function RD(e) {
  return e >= ly && e < $re;
}
function Jre(e, t) {
  if (e >= kx && e < Qre && t >= Bx && t < Kre)
    return ly + (e - kx) * Px + (t - Bx) * pm;
  if (RD(e) && t > Ix && t < Yre && (e - ly) % pm == 0)
    return e + (t - Ix);
  {
    let n = dw.get(e);
    return n && (n = n.get(t), n) ? n : -1;
  }
}
function MD(e) {
  NS || Zre();
  let t = [], n = [], r = !1;
  function i(s) {
    let o = NS.get(s);
    o && (r = !0, s |= o), t.push(s);
  }
  for (let s of e)
    for (; ; ) {
      if (s < 128)
        t.push(s);
      else if (RD(s)) {
        let o = s - ly, a = o / Px | 0, c = o % Px / pm | 0, l = o % pm;
        i(kx + a), i(Bx + c), l > 0 && i(Ix + l);
      } else {
        let o = RS.get(s);
        o ? n.push(...o) : i(s);
      }
      if (!n.length)
        break;
      s = n.pop();
    }
  if (r && t.length > 1) {
    let s = U0(t[0]);
    for (let o = 1; o < t.length; o++) {
      let a = U0(t[o]);
      if (a == 0 || s <= a) {
        s = a;
        continue;
      }
      let c = o - 1;
      for (; ; ) {
        let l = t[c + 1];
        if (t[c + 1] = t[c], t[c] = l, !c || (s = U0(t[--c]), s <= a))
          break;
      }
      s = U0(t[o]);
    }
  }
  return t;
}
function Xre(e) {
  let t = [], n = [], r = -1, i = 0;
  for (let s of e) {
    let o = U0(s), a = ND(s);
    if (r == -1)
      o == 0 ? r = a : t.push(a);
    else if (i > 0 && i >= o)
      o == 0 ? (t.push(r, ...n), n.length = 0, r = a) : n.push(a), i = o;
    else {
      let c = Jre(r, a);
      c >= 0 ? r = c : i == 0 && o == 0 ? (t.push(r), r = a) : (n.push(a), i = o);
    }
  }
  return r >= 0 && t.push(r, ...n), t;
}
function FD(e) {
  return MD(e).map(ND);
}
function eie(e) {
  return Xre(MD(e));
}
const LI = 45, jD = ".", DD = 65039, UD = 1, gh = (e) => Array.from(e);
function uy(e, t) {
  return e.P.has(t) || e.Q.has(t);
}
let tie = class extends Array {
  get is_emoji() {
    return !0;
  }
  // free tagging system
}, MS, LD, Yu, FS, zD, Fh, D3, oh, VD, zI, jS;
function f5() {
  if (MS)
    return;
  let e = CD(Nre);
  const t = () => ay(e), n = () => new Set(t());
  MS = new Map(kD(e)), LD = n(), Yu = t(), FS = new Set(t().map((u) => Yu[u])), Yu = new Set(Yu), zD = n(), n();
  let r = TD(e), i = e();
  const s = () => new Set(t().flatMap((u) => r[u]).concat(t()));
  Fh = cy((u) => {
    let d = cy(e).map((f) => f + 96);
    if (d.length) {
      let f = u >= i;
      d[0] -= 32, d = hm(d), f && (d = `Restricted[${d}]`);
      let p = s(), m = s(), h = !e();
      return { N: d, P: p, Q: m, M: h, R: f };
    }
  }), D3 = n(), oh = /* @__PURE__ */ new Map();
  let o = t().concat(gh(D3)).sort((u, d) => u - d);
  o.forEach((u, d) => {
    let f = e(), p = o[d] = f ? o[d - f] : { V: [], M: /* @__PURE__ */ new Map() };
    p.V.push(u), D3.has(u) || oh.set(u, p);
  });
  for (let { V: u, M: d } of new Set(oh.values())) {
    let f = [];
    for (let m of u) {
      let h = Fh.filter((y) => uy(y, m)), g = f.find(({ G: y }) => h.some((v) => y.has(v)));
      g || (g = { G: /* @__PURE__ */ new Set(), V: [] }, f.push(g)), g.V.push(m), h.forEach((y) => g.G.add(y));
    }
    let p = f.flatMap((m) => gh(m.G));
    for (let { G: m, V: h } of f) {
      let g = new Set(p.filter((y) => !m.has(y)));
      for (let y of h)
        d.set(y, g);
    }
  }
  let a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  const l = (u) => a.has(u) ? c.add(u) : a.add(u);
  for (let u of Fh) {
    for (let d of u.P)
      l(d);
    for (let d of u.Q)
      l(d);
  }
  for (let u of a)
    !oh.has(u) && !c.has(u) && oh.set(u, UD);
  VD = new Set(gh(a).concat(gh(FD(a)))), zI = zre(e).map((u) => tie.from(u)).sort(Wre), jS = /* @__PURE__ */ new Map();
  for (let u of zI) {
    let d = [jS];
    for (let f of u) {
      let p = d.map((m) => {
        let h = m.get(f);
        return h || (h = /* @__PURE__ */ new Map(), m.set(f, h)), h;
      });
      f === DD ? d.push(...p) : d = p;
    }
    for (let f of d)
      f.V = u;
  }
}
function h5(e) {
  return (HD(e) ? "" : `${p5(UA([e]))} `) + ID(e);
}
function p5(e) {
  return `"${e}"‎`;
}
function nie(e) {
  if (e.length >= 4 && e[2] == LI && e[3] == LI)
    throw new Error(`invalid label extension: "${hm(e.slice(0, 4))}"`);
}
function rie(e) {
  for (let n = e.lastIndexOf(95); n > 0; )
    if (e[--n] !== 95)
      throw new Error("underscore allowed only at start");
}
function iie(e) {
  let t = e[0], n = jI.get(t);
  if (n)
    throw lg(`leading ${n}`);
  let r = e.length, i = -1;
  for (let s = 1; s < r; s++) {
    t = e[s];
    let o = jI.get(t);
    if (o) {
      if (i == s)
        throw lg(`${n} + ${o}`);
      i = s + 1, n = o;
    }
  }
  if (i == r)
    throw lg(`trailing ${n}`);
}
function UA(e, t = ID) {
  let n = [];
  sie(e[0]) && n.push("◌");
  let r = 0, i = e.length;
  for (let s = 0; s < i; s++) {
    let o = e[s];
    HD(o) && (n.push(hm(e.slice(r, s))), n.push(t(o)), r = s + 1);
  }
  return n.push(hm(e.slice(r, i))), n.join("");
}
function sie(e) {
  return f5(), Yu.has(e);
}
function HD(e) {
  return f5(), zD.has(e);
}
function oie(e) {
  return uie(aie(e, eie, hie));
}
function aie(e, t, n) {
  if (!e)
    return [];
  f5();
  let r = 0;
  return e.split(jD).map((i) => {
    let s = Hre(i), o = {
      input: s,
      offset: r
      // codepoint, not substring!
    };
    r += s.length + 1;
    try {
      let a = o.tokens = fie(s, t, n), c = a.length, l;
      if (!c)
        throw new Error("empty label");
      let u = o.output = a.flat();
      if (rie(u), !(o.emoji = c > 1 || a[0].is_emoji) && u.every((f) => f < 128))
        nie(u), l = "ASCII";
      else {
        let f = a.flatMap((p) => p.is_emoji ? [] : p);
        if (!f.length)
          l = "Emoji";
        else {
          if (Yu.has(u[0]))
            throw lg("leading combining mark");
          for (let h = 1; h < c; h++) {
            let g = a[h];
            if (!g.is_emoji && Yu.has(g[0]))
              throw lg(`emoji + combining mark: "${hm(a[h - 1])} + ${UA([g[0]])}"`);
          }
          iie(u);
          let p = gh(new Set(f)), [m] = lie(p);
          die(m, f), cie(m, p), l = m.N;
        }
      }
      o.type = l;
    } catch (a) {
      o.error = a;
    }
    return o;
  });
}
function cie(e, t) {
  let n, r = [];
  for (let i of t) {
    let s = oh.get(i);
    if (s === UD)
      return;
    if (s) {
      let o = s.M.get(i);
      if (n = n ? n.filter((a) => o.has(a)) : gh(o), !n.length)
        return;
    } else
      r.push(i);
  }
  if (n) {
    for (let i of n)
      if (r.every((s) => uy(i, s)))
        throw new Error(`whole-script confusable: ${e.N}/${i.N}`);
  }
}
function lie(e) {
  let t = Fh;
  for (let n of e) {
    let r = t.filter((i) => uy(i, n));
    if (!r.length)
      throw Fh.some((i) => uy(i, n)) ? GD(t[0], n) : WD(n);
    if (t = r, r.length == 1)
      break;
  }
  return t;
}
function uie(e) {
  return e.map(({ input: t, error: n, output: r }) => {
    if (n) {
      let i = n.message;
      throw new Error(e.length == 1 ? i : `Invalid label ${p5(UA(t))}: ${i}`);
    }
    return hm(r);
  }).join(jD);
}
function WD(e) {
  return new Error(`disallowed character: ${h5(e)}`);
}
function GD(e, t) {
  let n = h5(t), r = Fh.find((i) => i.P.has(t));
  return r && (n = `${r.N} ${n}`), new Error(`illegal mixture: ${e.N} + ${n}`);
}
function lg(e) {
  return new Error(`illegal placement: ${e}`);
}
function die(e, t) {
  for (let n of t)
    if (!uy(e, n))
      throw GD(e, n);
  if (e.M) {
    let n = FD(t);
    for (let r = 1, i = n.length; r < i; r++)
      if (FS.has(n[r])) {
        let s = r + 1;
        for (let o; s < i && FS.has(o = n[s]); s++)
          for (let a = r; a < s; a++)
            if (n[a] == o)
              throw new Error(`duplicate non-spacing marks: ${h5(o)}`);
        if (s - r > DI)
          throw new Error(`excessive non-spacing marks: ${p5(UA(n.slice(r - 1, s)))} (${s - r}/${DI})`);
        r = s;
      }
  }
}
function fie(e, t, n) {
  let r = [], i = [];
  for (e = e.slice().reverse(); e.length; ) {
    let s = pie(e);
    if (s)
      i.length && (r.push(t(i)), i = []), r.push(n(s));
    else {
      let o = e.pop();
      if (VD.has(o))
        i.push(o);
      else {
        let a = MS.get(o);
        if (a)
          i.push(...a);
        else if (!LD.has(o))
          throw WD(o);
      }
    }
  }
  return i.length && r.push(t(i)), r;
}
function hie(e) {
  return e.filter((t) => t != DD);
}
function pie(e, t) {
  let n = jS, r, i = e.length;
  for (; i && (n = n.get(e[--i]), !!n); ) {
    let { V: s } = n;
    s && (r = s, e.length = i);
  }
  return r;
}
function mie(e) {
  return oie(e);
}
const m5 = /* @__PURE__ */ Oee({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
});
var Vr = function() {
  return Vr = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Vr.apply(this, arguments);
};
function g5(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function qD(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var ug = "right-scroll-bar-position", dg = "width-before-scroll-bar", gie = "with-scroll-bars-hidden", yie = "--removed-body-scroll-bar-size";
function U3(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function bie(e, t) {
  var n = qe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var vie = typeof window < "u" ? ye.useLayoutEffect : ye.useEffect, VI = /* @__PURE__ */ new WeakMap();
function y5(e, t) {
  var n = bie(null, function(r) {
    return e.forEach(function(i) {
      return U3(i, r);
    });
  });
  return vie(function() {
    var r = VI.get(n);
    if (r) {
      var i = new Set(r), s = new Set(e), o = n.current;
      i.forEach(function(a) {
        s.has(a) || U3(a, null);
      }), s.forEach(function(a) {
        i.has(a) || U3(a, o);
      });
    }
    VI.set(n, e);
  }, [e]), n;
}
function $D(e) {
  return e;
}
function QD(e, t) {
  t === void 0 && (t = $D);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var o = t(s, r);
      return n.push(o), function() {
        n = n.filter(function(a) {
          return a !== o;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var o = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), o = n;
      }
      var c = function() {
        var u = o;
        o = [], u.forEach(s);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          o.push(u), l();
        },
        filter: function(u) {
          return o = o.filter(u), n;
        }
      };
    }
  };
  return i;
}
function b5(e, t) {
  return t === void 0 && (t = $D), QD(e, t);
}
function v5(e) {
  e === void 0 && (e = {});
  var t = QD(null);
  return t.options = Vr({ async: !0, ssr: !1 }, e), t;
}
var KD = function(e) {
  var t = e.sideCar, n = g5(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return ye.createElement(r, Vr({}, n));
};
KD.isSideCarExport = !0;
function YD(e, t) {
  return e.useMedium(t), KD;
}
var ZD = v5(), L3 = function() {
}, LA = ye.forwardRef(function(e, t) {
  var n = ye.useRef(null), r = ye.useState({
    onScrollCapture: L3,
    onWheelCapture: L3,
    onTouchMoveCapture: L3
  }), i = r[0], s = r[1], o = e.forwardProps, a = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noIsolation, m = e.inert, h = e.allowPinchZoom, g = e.as, y = g === void 0 ? "div" : g, v = e.gapMode, b = g5(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = f, A = y5([n, t]), E = Vr(Vr({}, b), i);
  return ye.createElement(
    ye.Fragment,
    null,
    u && ye.createElement(w, { sideCar: ZD, removeScrollBar: l, shards: d, noIsolation: p, inert: m, setCallbacks: s, allowPinchZoom: !!h, lockRef: n, gapMode: v }),
    o ? ye.cloneElement(ye.Children.only(a), Vr(Vr({}, E), { ref: A })) : ye.createElement(y, Vr({}, E, { className: c, ref: A }), a)
  );
});
LA.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
LA.classNames = {
  fullWidth: dg,
  zeroRight: ug
};
var wie = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function xie() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = wie();
  return t && e.setAttribute("nonce", t), e;
}
function Aie(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Eie(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var _ie = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = xie()) && (Aie(t, n), Eie(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Sie = function() {
  var e = _ie();
  return function(t, n) {
    ye.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, w5 = function() {
  var e = Sie(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, Cie = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, z3 = function(e) {
  return parseInt(e || "", 10) || 0;
}, Tie = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [z3(n), z3(r), z3(i)];
}, kie = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Cie;
  var t = Tie(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Bie = w5(), jh = "data-scroll-locked", Iie = function(e, t, n, r) {
  var i = e.left, s = e.top, o = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(gie, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(jh, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ug, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(dg, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ug, " .").concat(ug, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(dg, " .").concat(dg, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(jh, `] {
    `).concat(yie, ": ").concat(a, `px;
  }
`);
}, HI = function() {
  var e = parseInt(document.body.getAttribute(jh) || "0", 10);
  return isFinite(e) ? e : 0;
}, Pie = function() {
  ye.useEffect(function() {
    return document.body.setAttribute(jh, (HI() + 1).toString()), function() {
      var e = HI() - 1;
      e <= 0 ? document.body.removeAttribute(jh) : document.body.setAttribute(jh, e.toString());
    };
  }, []);
}, JD = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  Pie();
  var s = ye.useMemo(function() {
    return kie(i);
  }, [i]);
  return ye.createElement(Bie, { styles: Iie(s, !t, i, n ? "" : "!important") });
}, DS = !1;
if (typeof window < "u")
  try {
    var Yv = Object.defineProperty({}, "passive", {
      get: function() {
        return DS = !0, !0;
      }
    });
    window.addEventListener("test", Yv, Yv), window.removeEventListener("test", Yv, Yv);
  } catch {
    DS = !1;
  }
var Uf = DS ? { passive: !1 } : !1, Oie = function(e) {
  return e.tagName === "TEXTAREA";
}, XD = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Oie(e) && n[t] === "visible")
  );
}, Nie = function(e) {
  return XD(e, "overflowY");
}, Rie = function(e) {
  return XD(e, "overflowX");
}, WI = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = eU(e, r);
    if (i) {
      var s = tU(e, r), o = s[1], a = s[2];
      if (o > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Mie = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Fie = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, eU = function(e, t) {
  return e === "v" ? Nie(t) : Rie(t);
}, tU = function(e, t) {
  return e === "v" ? Mie(t) : Fie(t);
}, jie = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Die = function(e, t, n, r, i) {
  var s = jie(e, window.getComputedStyle(t).direction), o = s * r, a = n.target, c = t.contains(a), l = !1, u = o > 0, d = 0, f = 0;
  do {
    var p = tU(e, a), m = p[0], h = p[1], g = p[2], y = h - g - s * m;
    (m || y) && eU(e, a) && (d += y, f += m), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (u && (Math.abs(d) < 1 || !i) || !u && (Math.abs(f) < 1 || !i)) && (l = !0), l;
}, Zv = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, GI = function(e) {
  return [e.deltaX, e.deltaY];
}, qI = function(e) {
  return e && "current" in e ? e.current : e;
}, Uie = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Lie = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, zie = 0, Lf = [];
function Vie(e) {
  var t = ye.useRef([]), n = ye.useRef([0, 0]), r = ye.useRef(), i = ye.useState(zie++)[0], s = ye.useState(w5)[0], o = ye.useRef(e);
  ye.useEffect(function() {
    o.current = e;
  }, [e]), ye.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var h = qD([e.lockRef.current], (e.shards || []).map(qI), !0).filter(Boolean);
      return h.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), h.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = ye.useCallback(function(h, g) {
    if ("touches" in h && h.touches.length === 2)
      return !o.current.allowPinchZoom;
    var y = Zv(h), v = n.current, b = "deltaX" in h ? h.deltaX : v[0] - y[0], w = "deltaY" in h ? h.deltaY : v[1] - y[1], A, E = h.target, x = Math.abs(b) > Math.abs(w) ? "h" : "v";
    if ("touches" in h && x === "h" && E.type === "range")
      return !1;
    var S = WI(x, E);
    if (!S)
      return !0;
    if (S ? A = x : (A = x === "v" ? "h" : "v", S = WI(x, E)), !S)
      return !1;
    if (!r.current && "changedTouches" in h && (b || w) && (r.current = A), !A)
      return !0;
    var P = r.current || A;
    return Die(P, g, h, P === "h" ? b : w, !0);
  }, []), c = ye.useCallback(function(h) {
    var g = h;
    if (!(!Lf.length || Lf[Lf.length - 1] !== s)) {
      var y = "deltaY" in g ? GI(g) : Zv(g), v = t.current.filter(function(A) {
        return A.name === g.type && (A.target === g.target || g.target === A.shadowParent) && Uie(A.delta, y);
      })[0];
      if (v && v.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!v) {
        var b = (o.current.shards || []).map(qI).filter(Boolean).filter(function(A) {
          return A.contains(g.target);
        }), w = b.length > 0 ? a(g, b[0]) : !o.current.noIsolation;
        w && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = ye.useCallback(function(h, g, y, v) {
    var b = { name: h, delta: g, target: y, should: v, shadowParent: Hie(y) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== b;
      });
    }, 1);
  }, []), u = ye.useCallback(function(h) {
    n.current = Zv(h), r.current = void 0;
  }, []), d = ye.useCallback(function(h) {
    l(h.type, GI(h), h.target, a(h, e.lockRef.current));
  }, []), f = ye.useCallback(function(h) {
    l(h.type, Zv(h), h.target, a(h, e.lockRef.current));
  }, []);
  ye.useEffect(function() {
    return Lf.push(s), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, Uf), document.addEventListener("touchmove", c, Uf), document.addEventListener("touchstart", u, Uf), function() {
      Lf = Lf.filter(function(h) {
        return h !== s;
      }), document.removeEventListener("wheel", c, Uf), document.removeEventListener("touchmove", c, Uf), document.removeEventListener("touchstart", u, Uf);
    };
  }, []);
  var p = e.removeScrollBar, m = e.inert;
  return ye.createElement(
    ye.Fragment,
    null,
    m ? ye.createElement(s, { styles: Lie(i) }) : null,
    p ? ye.createElement(JD, { gapMode: e.gapMode }) : null
  );
}
function Hie(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Wie = YD(ZD, Vie);
var nU = ye.forwardRef(function(e, t) {
  return ye.createElement(LA, Vr({}, e, { ref: t, sideCar: Wie }));
});
nU.classNames = LA.classNames;
function $I(e) {
  var t = e.match(/^var\((.*)\)$/);
  return t ? t[1] : e;
}
function Gie(e, t) {
  var n = e;
  for (var r of t) {
    if (!(r in n))
      throw new Error("Path ".concat(t.join(" -> "), " does not exist in object"));
    n = n[r];
  }
  return n;
}
function rU(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = {};
  for (var i in e) {
    var s = e[i], o = [...n, i];
    typeof s == "string" || typeof s == "number" || s == null ? r[i] = t(s, o) : typeof s == "object" && !Array.isArray(s) ? r[i] = rU(s, t, o) : console.warn('Skipping invalid key "'.concat(o.join("."), '". Should be a string, number, null or object. Received: "').concat(Array.isArray(s) ? "Array" : typeof s, '"'));
  }
  return r;
}
function QI(e, t) {
  var n = {};
  if (typeof t == "object") {
    var r = e;
    rU(t, (a, c) => {
      if (a != null) {
        var l = Gie(r, c);
        n[$I(l)] = String(a);
      }
    });
  } else {
    var i = e;
    for (var s in i) {
      var o = i[s];
      o != null && (n[$I(s)] = o);
    }
  }
  return Object.defineProperty(n, "toString", {
    value: function() {
      return Object.keys(this).map((c) => "".concat(c, ":").concat(this[c])).join(";");
    },
    writable: !1
  }), n;
}
var US = { exports: {} };
(function(e, t) {
  (function(n, r) {
    var i = "1.0.37", s = "", o = "?", a = "function", c = "undefined", l = "object", u = "string", d = "major", f = "model", p = "name", m = "type", h = "vendor", g = "version", y = "architecture", v = "console", b = "mobile", w = "tablet", A = "smarttv", E = "wearable", x = "embedded", S = 500, P = "Amazon", I = "Apple", R = "ASUS", Q = "BlackBerry", J = "Browser", we = "Chrome", V = "Edge", L = "Firefox", U = "Google", q = "Huawei", G = "LG", ae = "Microsoft", ge = "Motorola", Ae = "Opera", he = "Samsung", B = "Sharp", be = "Sony", Be = "Xiaomi", Ne = "Zebra", _e = "Facebook", Ce = "Chromium OS", N = "Mac OS", F = function(Oe, De) {
      var Te = {};
      for (var Fe in Oe)
        De[Fe] && De[Fe].length % 2 === 0 ? Te[Fe] = De[Fe].concat(Oe[Fe]) : Te[Fe] = Oe[Fe];
      return Te;
    }, z = function(Oe) {
      for (var De = {}, Te = 0; Te < Oe.length; Te++)
        De[Oe[Te].toUpperCase()] = Oe[Te];
      return De;
    }, ne = function(Oe, De) {
      return typeof Oe === u ? ee(De).indexOf(ee(Oe)) !== -1 : !1;
    }, ee = function(Oe) {
      return Oe.toLowerCase();
    }, Y = function(Oe) {
      return typeof Oe === u ? Oe.replace(/[^\d\.]/g, s).split(".")[0] : r;
    }, X = function(Oe, De) {
      if (typeof Oe === u)
        return Oe = Oe.replace(/^\s\s*/, s), typeof De === c ? Oe : Oe.substring(0, S);
    }, $ = function(Oe, De) {
      for (var Te = 0, Fe, lt, O, _, T, M; Te < De.length && !T; ) {
        var se = De[Te], H = De[Te + 1];
        for (Fe = lt = 0; Fe < se.length && !T && se[Fe]; )
          if (T = se[Fe++].exec(Oe), T)
            for (O = 0; O < H.length; O++)
              M = T[++lt], _ = H[O], typeof _ === l && _.length > 0 ? _.length === 2 ? typeof _[1] == a ? this[_[0]] = _[1].call(this, M) : this[_[0]] = _[1] : _.length === 3 ? typeof _[1] === a && !(_[1].exec && _[1].test) ? this[_[0]] = M ? _[1].call(this, M, _[2]) : r : this[_[0]] = M ? M.replace(_[1], _[2]) : r : _.length === 4 && (this[_[0]] = M ? _[3].call(this, M.replace(_[1], _[2])) : r) : this[_] = M || r;
        Te += 2;
      }
    }, ie = function(Oe, De) {
      for (var Te in De)
        if (typeof De[Te] === l && De[Te].length > 0) {
          for (var Fe = 0; Fe < De[Te].length; Fe++)
            if (ne(De[Te][Fe], Oe))
              return Te === o ? r : Te;
        } else if (ne(De[Te], Oe))
          return Te === o ? r : Te;
      return Oe;
    }, fe = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, oe = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, me = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [g, [p, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [g, [p, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [p, g],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [g, [p, Ae + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [g, [p, Ae]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [g, [p, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [p, g],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [g, [p, "UC" + J]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [g, [p, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [g, [p, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [g, [p, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [g, [p, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [g, [p, "Smart Lenovo " + J]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[p, /(.+)/, "$1 Secure " + J], g],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [g, [p, L + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [g, [p, Ae + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [g, [p, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [g, [p, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [g, [p, Ae + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [g, [p, "MIUI " + J]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [g, [p, L]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[p, "360 " + J]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[p, /(.+)/, "$1 " + J], g],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [g, [p, he + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[p, /_/g, " "], g],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [g, [p, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[p, "Sogou Mobile"], g],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [p, g],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [p],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[p, _e], g],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [p, g],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [g, [p, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [g, [p, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [g, [p, we + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[p, we + " WebView"], g],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [g, [p, "Android " + J]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [p, g],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [g, [p, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [g, p],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [p, [g, ie, fe]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [p, g],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[p, "Netscape"], g],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [g, [p, L + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [p, g],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [p, [g, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[y, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[y, ee]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[y, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[y, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[y, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[y, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[y, /ower/, s, ee]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[y, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[y, ee]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [f, [h, he], [m, w]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [f, [h, he], [m, b]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [f, [h, I], [m, b]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [f, [h, I], [m, w]],
        [
          /(macintosh);/i
        ],
        [f, [h, I]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [f, [h, B], [m, b]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [f, [h, q], [m, w]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [f, [h, q], [m, b]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[f, /_/g, " "], [h, Be], [m, b]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[f, /_/g, " "], [h, Be], [m, w]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [f, [h, "OPPO"], [m, b]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [f, [h, "Vivo"], [m, b]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [f, [h, "Realme"], [m, b]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [f, [h, ge], [m, b]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [f, [h, ge], [m, w]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [f, [h, G], [m, w]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [f, [h, G], [m, b]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [f, [h, "Lenovo"], [m, w]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[f, /_/g, " "], [h, "Nokia"], [m, b]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [f, [h, U], [m, w]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [f, [h, U], [m, b]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [f, [h, be], [m, b]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[f, "Xperia Tablet"], [h, be], [m, w]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [f, [h, "OnePlus"], [m, b]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [f, [h, P], [m, w]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[f, /(.+)/g, "Fire Phone $1"], [h, P], [m, b]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [f, h, [m, w]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [f, [h, Q], [m, b]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [f, [h, R], [m, w]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [f, [h, R], [m, b]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [f, [h, "HTC"], [m, w]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [h, [f, /_/g, " "], [m, b]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [f, [h, "Acer"], [m, w]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [f, [h, "Meizu"], [m, b]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [f, [h, "Ulefone"], [m, b]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [h, f, [m, b]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [h, f, [m, w]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [f, [h, ae], [m, w]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [f, [h, "Fairphone"], [m, b]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [f, [h, "AT&T"], [m, b]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [f, [h, "Siemens"], [m, b]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [f, [h, "RCA"], [m, w]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [f, [h, "Dell"], [m, w]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [f, [h, "Verizon"], [m, w]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [f, [h, "Barnes & Noble"], [m, w]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [f, [h, "NuVision"], [m, w]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [f, [h, "ZTE"], [m, w]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [f, [h, "ZTE"], [m, b]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [f, [h, "Swiss"], [m, b]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [f, [h, "Swiss"], [m, w]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [f, [h, "Zeki"], [m, w]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[h, "Dragon Touch"], f, [m, w]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [f, [h, "Insignia"], [m, w]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [f, [h, "NextBook"], [m, w]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[h, "Voice"], f, [m, b]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[h, "LvTel"], f, [m, b]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [f, [h, "Essential"], [m, b]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [f, [h, "Envizen"], [m, w]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [f, [h, "MachSpeed"], [m, w]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [f, [h, "Rotor"], [m, w]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [f, [h, "Nvidia"], [m, w]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [h, f, [m, b]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[f, /\./g, " "], [h, ae], [m, b]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [f, [h, Ne], [m, w]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [f, [h, Ne], [m, b]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [h, [m, A]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[f, /^/, "SmartTV"], [h, he], [m, A]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[h, G], [m, A]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [h, [f, I + " TV"], [m, A]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[f, we + "cast"], [h, U], [m, A]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [f, [h, P], [m, A]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [f, [h, B], [m, A]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [f, [h, be], [m, A]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [f, [h, Be], [m, A]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [h, f, [m, A]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[h, X], [f, X], [m, A]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[m, A]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [h, f, [m, v]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [f, [h, "Nvidia"], [m, v]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [f, [h, be], [m, v]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [f, [h, ae], [m, v]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [h, f, [m, E]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [f, [h, I], [m, E]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [f, [h, U], [m, E]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [f, [h, Ne], [m, E]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [f, [h, _e], [m, E]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [h, [m, x]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [f, [h, P], [m, x]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [f, [m, b]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [f, [m, w]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[m, w]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[m, b]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [f, [h, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [g, [p, V + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [g, [p, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [p, g],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [g, p]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [p, g],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [p, [g, ie, oe]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[g, ie, oe], [p, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[g, /_/g, "."], [p, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[p, N], [g, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [g, p],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [p, g],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [g, [p, Q]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [g, [p, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [g, [p, L + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [g, [p, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [g, [p, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [g, [p, we + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[p, Ce], g],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [p, g],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[p, "Solaris"], g],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [p, g]
      ]
    }, Me = function(Oe, De) {
      if (typeof Oe === l && (De = Oe, Oe = r), !(this instanceof Me))
        return new Me(Oe, De).getResult();
      var Te = typeof n !== c && n.navigator ? n.navigator : r, Fe = Oe || (Te && Te.userAgent ? Te.userAgent : s), lt = Te && Te.userAgentData ? Te.userAgentData : r, O = De ? F(me, De) : me, _ = Te && Te.userAgent == Fe;
      return this.getBrowser = function() {
        var T = {};
        return T[p] = r, T[g] = r, $.call(T, Fe, O.browser), T[d] = Y(T[g]), _ && Te && Te.brave && typeof Te.brave.isBrave == a && (T[p] = "Brave"), T;
      }, this.getCPU = function() {
        var T = {};
        return T[y] = r, $.call(T, Fe, O.cpu), T;
      }, this.getDevice = function() {
        var T = {};
        return T[h] = r, T[f] = r, T[m] = r, $.call(T, Fe, O.device), _ && !T[m] && lt && lt.mobile && (T[m] = b), _ && T[f] == "Macintosh" && Te && typeof Te.standalone !== c && Te.maxTouchPoints && Te.maxTouchPoints > 2 && (T[f] = "iPad", T[m] = w), T;
      }, this.getEngine = function() {
        var T = {};
        return T[p] = r, T[g] = r, $.call(T, Fe, O.engine), T;
      }, this.getOS = function() {
        var T = {};
        return T[p] = r, T[g] = r, $.call(T, Fe, O.os), _ && !T[p] && lt && lt.platform != "Unknown" && (T[p] = lt.platform.replace(/chrome os/i, Ce).replace(/macos/i, N)), T;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return Fe;
      }, this.setUA = function(T) {
        return Fe = typeof T === u && T.length > S ? X(T, S) : T, this;
      }, this.setUA(Fe), this;
    };
    Me.VERSION = i, Me.BROWSER = z([p, g, d]), Me.CPU = z([y]), Me.DEVICE = z([f, h, m, v, b, A, w, E, x]), Me.ENGINE = Me.OS = z([p, g]), e.exports && (t = e.exports = Me), t.UAParser = Me;
    var je = typeof n !== c && (n.jQuery || n.Zepto);
    if (je && !je.ua) {
      var Ye = new Me();
      je.ua = Ye.getResult(), je.ua.get = function() {
        return Ye.getUA();
      }, je.ua.set = function(Oe) {
        Ye.setUA(Oe);
        var De = Ye.getResult();
        for (var Te in De)
          je.ua[Te] = De[Te];
      };
    }
  })(typeof window == "object" ? window : im);
})(US, US.exports);
var qie = US.exports, av = {}, $ie = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, iU = {}, ns = {};
let x5;
const Qie = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
ns.getSymbolSize = function(t) {
  if (!t)
    throw new Error('"version" cannot be null or undefined');
  if (t < 1 || t > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return t * 4 + 17;
};
ns.getSymbolTotalCodewords = function(t) {
  return Qie[t];
};
ns.getBCHDigit = function(e) {
  let t = 0;
  for (; e !== 0; )
    t++, e >>>= 1;
  return t;
};
ns.setToSJISFunction = function(t) {
  if (typeof t != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  x5 = t;
};
ns.isKanjiModeEnabled = function() {
  return typeof x5 < "u";
};
ns.toSJIS = function(t) {
  return x5(t);
};
var zA = {};
(function(e) {
  e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
  function t(n) {
    if (typeof n != "string")
      throw new Error("Param is not a string");
    switch (n.toLowerCase()) {
      case "l":
      case "low":
        return e.L;
      case "m":
      case "medium":
        return e.M;
      case "q":
      case "quartile":
        return e.Q;
      case "h":
      case "high":
        return e.H;
      default:
        throw new Error("Unknown EC Level: " + n);
    }
  }
  e.isValid = function(r) {
    return r && typeof r.bit < "u" && r.bit >= 0 && r.bit < 4;
  }, e.from = function(r, i) {
    if (e.isValid(r))
      return r;
    try {
      return t(r);
    } catch {
      return i;
    }
  };
})(zA);
function sU() {
  this.buffer = [], this.length = 0;
}
sU.prototype = {
  get: function(e) {
    const t = Math.floor(e / 8);
    return (this.buffer[t] >>> 7 - e % 8 & 1) === 1;
  },
  put: function(e, t) {
    for (let n = 0; n < t; n++)
      this.putBit((e >>> t - n - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(e) {
    const t = Math.floor(this.length / 8);
    this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
  }
};
var Kie = sU;
function cv(e) {
  if (!e || e < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = e, this.data = new Uint8Array(e * e), this.reservedBit = new Uint8Array(e * e);
}
cv.prototype.set = function(e, t, n, r) {
  const i = e * this.size + t;
  this.data[i] = n, r && (this.reservedBit[i] = !0);
};
cv.prototype.get = function(e, t) {
  return this.data[e * this.size + t];
};
cv.prototype.xor = function(e, t, n) {
  this.data[e * this.size + t] ^= n;
};
cv.prototype.isReserved = function(e, t) {
  return this.reservedBit[e * this.size + t];
};
var Yie = cv, oU = {};
(function(e) {
  const t = ns.getSymbolSize;
  e.getRowColCoords = function(r) {
    if (r === 1)
      return [];
    const i = Math.floor(r / 7) + 2, s = t(r), o = s === 145 ? 26 : Math.ceil((s - 13) / (2 * i - 2)) * 2, a = [s - 7];
    for (let c = 1; c < i - 1; c++)
      a[c] = a[c - 1] - o;
    return a.push(6), a.reverse();
  }, e.getPositions = function(r) {
    const i = [], s = e.getRowColCoords(r), o = s.length;
    for (let a = 0; a < o; a++)
      for (let c = 0; c < o; c++)
        a === 0 && c === 0 || // top-left
        a === 0 && c === o - 1 || // bottom-left
        a === o - 1 && c === 0 || i.push([s[a], s[c]]);
    return i;
  };
})(oU);
var aU = {};
const Zie = ns.getSymbolSize, KI = 7;
aU.getPositions = function(t) {
  const n = Zie(t);
  return [
    // top-left
    [0, 0],
    // top-right
    [n - KI, 0],
    // bottom-left
    [0, n - KI]
  ];
};
var cU = {};
(function(e) {
  e.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const t = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  e.isValid = function(i) {
    return i != null && i !== "" && !isNaN(i) && i >= 0 && i <= 7;
  }, e.from = function(i) {
    return e.isValid(i) ? parseInt(i, 10) : void 0;
  }, e.getPenaltyN1 = function(i) {
    const s = i.size;
    let o = 0, a = 0, c = 0, l = null, u = null;
    for (let d = 0; d < s; d++) {
      a = c = 0, l = u = null;
      for (let f = 0; f < s; f++) {
        let p = i.get(d, f);
        p === l ? a++ : (a >= 5 && (o += t.N1 + (a - 5)), l = p, a = 1), p = i.get(f, d), p === u ? c++ : (c >= 5 && (o += t.N1 + (c - 5)), u = p, c = 1);
      }
      a >= 5 && (o += t.N1 + (a - 5)), c >= 5 && (o += t.N1 + (c - 5));
    }
    return o;
  }, e.getPenaltyN2 = function(i) {
    const s = i.size;
    let o = 0;
    for (let a = 0; a < s - 1; a++)
      for (let c = 0; c < s - 1; c++) {
        const l = i.get(a, c) + i.get(a, c + 1) + i.get(a + 1, c) + i.get(a + 1, c + 1);
        (l === 4 || l === 0) && o++;
      }
    return o * t.N2;
  }, e.getPenaltyN3 = function(i) {
    const s = i.size;
    let o = 0, a = 0, c = 0;
    for (let l = 0; l < s; l++) {
      a = c = 0;
      for (let u = 0; u < s; u++)
        a = a << 1 & 2047 | i.get(l, u), u >= 10 && (a === 1488 || a === 93) && o++, c = c << 1 & 2047 | i.get(u, l), u >= 10 && (c === 1488 || c === 93) && o++;
    }
    return o * t.N3;
  }, e.getPenaltyN4 = function(i) {
    let s = 0;
    const o = i.data.length;
    for (let c = 0; c < o; c++)
      s += i.data[c];
    return Math.abs(Math.ceil(s * 100 / o / 5) - 10) * t.N4;
  };
  function n(r, i, s) {
    switch (r) {
      case e.Patterns.PATTERN000:
        return (i + s) % 2 === 0;
      case e.Patterns.PATTERN001:
        return i % 2 === 0;
      case e.Patterns.PATTERN010:
        return s % 3 === 0;
      case e.Patterns.PATTERN011:
        return (i + s) % 3 === 0;
      case e.Patterns.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(s / 3)) % 2 === 0;
      case e.Patterns.PATTERN101:
        return i * s % 2 + i * s % 3 === 0;
      case e.Patterns.PATTERN110:
        return (i * s % 2 + i * s % 3) % 2 === 0;
      case e.Patterns.PATTERN111:
        return (i * s % 3 + (i + s) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + r);
    }
  }
  e.applyMask = function(i, s) {
    const o = s.size;
    for (let a = 0; a < o; a++)
      for (let c = 0; c < o; c++)
        s.isReserved(c, a) || s.xor(c, a, n(i, c, a));
  }, e.getBestMask = function(i, s) {
    const o = Object.keys(e.Patterns).length;
    let a = 0, c = 1 / 0;
    for (let l = 0; l < o; l++) {
      s(l), e.applyMask(l, i);
      const u = e.getPenaltyN1(i) + e.getPenaltyN2(i) + e.getPenaltyN3(i) + e.getPenaltyN4(i);
      e.applyMask(l, i), u < c && (c = u, a = l);
    }
    return a;
  };
})(cU);
var VA = {};
const Dl = zA, Jv = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], Xv = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
VA.getBlocksCount = function(t, n) {
  switch (n) {
    case Dl.L:
      return Jv[(t - 1) * 4 + 0];
    case Dl.M:
      return Jv[(t - 1) * 4 + 1];
    case Dl.Q:
      return Jv[(t - 1) * 4 + 2];
    case Dl.H:
      return Jv[(t - 1) * 4 + 3];
    default:
      return;
  }
};
VA.getTotalCodewordsCount = function(t, n) {
  switch (n) {
    case Dl.L:
      return Xv[(t - 1) * 4 + 0];
    case Dl.M:
      return Xv[(t - 1) * 4 + 1];
    case Dl.Q:
      return Xv[(t - 1) * 4 + 2];
    case Dl.H:
      return Xv[(t - 1) * 4 + 3];
    default:
      return;
  }
};
var lU = {}, HA = {};
const fg = new Uint8Array(512), Ox = new Uint8Array(256);
(function() {
  let t = 1;
  for (let n = 0; n < 255; n++)
    fg[n] = t, Ox[t] = n, t <<= 1, t & 256 && (t ^= 285);
  for (let n = 255; n < 512; n++)
    fg[n] = fg[n - 255];
})();
HA.log = function(t) {
  if (t < 1)
    throw new Error("log(" + t + ")");
  return Ox[t];
};
HA.exp = function(t) {
  return fg[t];
};
HA.mul = function(t, n) {
  return t === 0 || n === 0 ? 0 : fg[Ox[t] + Ox[n]];
};
(function(e) {
  const t = HA;
  e.mul = function(r, i) {
    const s = new Uint8Array(r.length + i.length - 1);
    for (let o = 0; o < r.length; o++)
      for (let a = 0; a < i.length; a++)
        s[o + a] ^= t.mul(r[o], i[a]);
    return s;
  }, e.mod = function(r, i) {
    let s = new Uint8Array(r);
    for (; s.length - i.length >= 0; ) {
      const o = s[0];
      for (let c = 0; c < i.length; c++)
        s[c] ^= t.mul(i[c], o);
      let a = 0;
      for (; a < s.length && s[a] === 0; )
        a++;
      s = s.slice(a);
    }
    return s;
  }, e.generateECPolynomial = function(r) {
    let i = new Uint8Array([1]);
    for (let s = 0; s < r; s++)
      i = e.mul(i, new Uint8Array([1, t.exp(s)]));
    return i;
  };
})(lU);
const uU = lU;
function A5(e) {
  this.genPoly = void 0, this.degree = e, this.degree && this.initialize(this.degree);
}
A5.prototype.initialize = function(t) {
  this.degree = t, this.genPoly = uU.generateECPolynomial(this.degree);
};
A5.prototype.encode = function(t) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const n = new Uint8Array(t.length + this.degree);
  n.set(t);
  const r = uU.mod(n, this.genPoly), i = this.degree - r.length;
  if (i > 0) {
    const s = new Uint8Array(this.degree);
    return s.set(r, i), s;
  }
  return r;
};
var Jie = A5, dU = {}, yu = {}, E5 = {};
E5.isValid = function(t) {
  return !isNaN(t) && t >= 1 && t <= 40;
};
var _a = {};
const fU = "[0-9]+", Xie = "[A-Z $%*+\\-./:]+";
let dy = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
dy = dy.replace(/u/g, "\\u");
const ese = "(?:(?![A-Z0-9 $%*+\\-./:]|" + dy + `)(?:.|[\r
]))+`;
_a.KANJI = new RegExp(dy, "g");
_a.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
_a.BYTE = new RegExp(ese, "g");
_a.NUMERIC = new RegExp(fU, "g");
_a.ALPHANUMERIC = new RegExp(Xie, "g");
const tse = new RegExp("^" + dy + "$"), nse = new RegExp("^" + fU + "$"), rse = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
_a.testKanji = function(t) {
  return tse.test(t);
};
_a.testNumeric = function(t) {
  return nse.test(t);
};
_a.testAlphanumeric = function(t) {
  return rse.test(t);
};
(function(e) {
  const t = E5, n = _a;
  e.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, e.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, e.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, e.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, e.MIXED = {
    bit: -1
  }, e.getCharCountIndicator = function(s, o) {
    if (!s.ccBits)
      throw new Error("Invalid mode: " + s);
    if (!t.isValid(o))
      throw new Error("Invalid version: " + o);
    return o >= 1 && o < 10 ? s.ccBits[0] : o < 27 ? s.ccBits[1] : s.ccBits[2];
  }, e.getBestModeForData = function(s) {
    return n.testNumeric(s) ? e.NUMERIC : n.testAlphanumeric(s) ? e.ALPHANUMERIC : n.testKanji(s) ? e.KANJI : e.BYTE;
  }, e.toString = function(s) {
    if (s && s.id)
      return s.id;
    throw new Error("Invalid mode");
  }, e.isValid = function(s) {
    return s && s.bit && s.ccBits;
  };
  function r(i) {
    if (typeof i != "string")
      throw new Error("Param is not a string");
    switch (i.toLowerCase()) {
      case "numeric":
        return e.NUMERIC;
      case "alphanumeric":
        return e.ALPHANUMERIC;
      case "kanji":
        return e.KANJI;
      case "byte":
        return e.BYTE;
      default:
        throw new Error("Unknown mode: " + i);
    }
  }
  e.from = function(s, o) {
    if (e.isValid(s))
      return s;
    try {
      return r(s);
    } catch {
      return o;
    }
  };
})(yu);
(function(e) {
  const t = ns, n = VA, r = zA, i = yu, s = E5, o = 7973, a = t.getBCHDigit(o);
  function c(f, p, m) {
    for (let h = 1; h <= 40; h++)
      if (p <= e.getCapacity(h, m, f))
        return h;
  }
  function l(f, p) {
    return i.getCharCountIndicator(f, p) + 4;
  }
  function u(f, p) {
    let m = 0;
    return f.forEach(function(h) {
      const g = l(h.mode, p);
      m += g + h.getBitsLength();
    }), m;
  }
  function d(f, p) {
    for (let m = 1; m <= 40; m++)
      if (u(f, m) <= e.getCapacity(m, p, i.MIXED))
        return m;
  }
  e.from = function(p, m) {
    return s.isValid(p) ? parseInt(p, 10) : m;
  }, e.getCapacity = function(p, m, h) {
    if (!s.isValid(p))
      throw new Error("Invalid QR Code version");
    typeof h > "u" && (h = i.BYTE);
    const g = t.getSymbolTotalCodewords(p), y = n.getTotalCodewordsCount(p, m), v = (g - y) * 8;
    if (h === i.MIXED)
      return v;
    const b = v - l(h, p);
    switch (h) {
      case i.NUMERIC:
        return Math.floor(b / 10 * 3);
      case i.ALPHANUMERIC:
        return Math.floor(b / 11 * 2);
      case i.KANJI:
        return Math.floor(b / 13);
      case i.BYTE:
      default:
        return Math.floor(b / 8);
    }
  }, e.getBestVersionForData = function(p, m) {
    let h;
    const g = r.from(m, r.M);
    if (Array.isArray(p)) {
      if (p.length > 1)
        return d(p, g);
      if (p.length === 0)
        return 1;
      h = p[0];
    } else
      h = p;
    return c(h.mode, h.getLength(), g);
  }, e.getEncodedBits = function(p) {
    if (!s.isValid(p) || p < 7)
      throw new Error("Invalid QR Code version");
    let m = p << 12;
    for (; t.getBCHDigit(m) - a >= 0; )
      m ^= o << t.getBCHDigit(m) - a;
    return p << 12 | m;
  };
})(dU);
var hU = {};
const LS = ns, pU = 1335, ise = 21522, YI = LS.getBCHDigit(pU);
hU.getEncodedBits = function(t, n) {
  const r = t.bit << 3 | n;
  let i = r << 10;
  for (; LS.getBCHDigit(i) - YI >= 0; )
    i ^= pU << LS.getBCHDigit(i) - YI;
  return (r << 10 | i) ^ ise;
};
var mU = {};
const sse = yu;
function mm(e) {
  this.mode = sse.NUMERIC, this.data = e.toString();
}
mm.getBitsLength = function(t) {
  return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0);
};
mm.prototype.getLength = function() {
  return this.data.length;
};
mm.prototype.getBitsLength = function() {
  return mm.getBitsLength(this.data.length);
};
mm.prototype.write = function(t) {
  let n, r, i;
  for (n = 0; n + 3 <= this.data.length; n += 3)
    r = this.data.substr(n, 3), i = parseInt(r, 10), t.put(i, 10);
  const s = this.data.length - n;
  s > 0 && (r = this.data.substr(n), i = parseInt(r, 10), t.put(i, s * 3 + 1));
};
var ose = mm;
const ase = yu, V3 = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function gm(e) {
  this.mode = ase.ALPHANUMERIC, this.data = e;
}
gm.getBitsLength = function(t) {
  return 11 * Math.floor(t / 2) + 6 * (t % 2);
};
gm.prototype.getLength = function() {
  return this.data.length;
};
gm.prototype.getBitsLength = function() {
  return gm.getBitsLength(this.data.length);
};
gm.prototype.write = function(t) {
  let n;
  for (n = 0; n + 2 <= this.data.length; n += 2) {
    let r = V3.indexOf(this.data[n]) * 45;
    r += V3.indexOf(this.data[n + 1]), t.put(r, 11);
  }
  this.data.length % 2 && t.put(V3.indexOf(this.data[n]), 6);
};
var cse = gm, lse = function(t) {
  for (var n = [], r = t.length, i = 0; i < r; i++) {
    var s = t.charCodeAt(i);
    if (s >= 55296 && s <= 56319 && r > i + 1) {
      var o = t.charCodeAt(i + 1);
      o >= 56320 && o <= 57343 && (s = (s - 55296) * 1024 + o - 56320 + 65536, i += 1);
    }
    if (s < 128) {
      n.push(s);
      continue;
    }
    if (s < 2048) {
      n.push(s >> 6 | 192), n.push(s & 63 | 128);
      continue;
    }
    if (s < 55296 || s >= 57344 && s < 65536) {
      n.push(s >> 12 | 224), n.push(s >> 6 & 63 | 128), n.push(s & 63 | 128);
      continue;
    }
    if (s >= 65536 && s <= 1114111) {
      n.push(s >> 18 | 240), n.push(s >> 12 & 63 | 128), n.push(s >> 6 & 63 | 128), n.push(s & 63 | 128);
      continue;
    }
    n.push(239, 191, 189);
  }
  return new Uint8Array(n).buffer;
};
const use = lse, dse = yu;
function ym(e) {
  this.mode = dse.BYTE, typeof e == "string" && (e = use(e)), this.data = new Uint8Array(e);
}
ym.getBitsLength = function(t) {
  return t * 8;
};
ym.prototype.getLength = function() {
  return this.data.length;
};
ym.prototype.getBitsLength = function() {
  return ym.getBitsLength(this.data.length);
};
ym.prototype.write = function(e) {
  for (let t = 0, n = this.data.length; t < n; t++)
    e.put(this.data[t], 8);
};
var fse = ym;
const hse = yu, pse = ns;
function bm(e) {
  this.mode = hse.KANJI, this.data = e;
}
bm.getBitsLength = function(t) {
  return t * 13;
};
bm.prototype.getLength = function() {
  return this.data.length;
};
bm.prototype.getBitsLength = function() {
  return bm.getBitsLength(this.data.length);
};
bm.prototype.write = function(e) {
  let t;
  for (t = 0; t < this.data.length; t++) {
    let n = pse.toSJIS(this.data[t]);
    if (n >= 33088 && n <= 40956)
      n -= 33088;
    else if (n >= 57408 && n <= 60351)
      n -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[t] + `
Make sure your charset is UTF-8`
      );
    n = (n >>> 8 & 255) * 192 + (n & 255), e.put(n, 13);
  }
};
var mse = bm, gU = { exports: {} };
(function(e) {
  var t = {
    single_source_shortest_paths: function(n, r, i) {
      var s = {}, o = {};
      o[r] = 0;
      var a = t.PriorityQueue.make();
      a.push(r, 0);
      for (var c, l, u, d, f, p, m, h, g; !a.empty(); ) {
        c = a.pop(), l = c.value, d = c.cost, f = n[l] || {};
        for (u in f)
          f.hasOwnProperty(u) && (p = f[u], m = d + p, h = o[u], g = typeof o[u] > "u", (g || h > m) && (o[u] = m, a.push(u, m), s[u] = l));
      }
      if (typeof i < "u" && typeof o[i] > "u") {
        var y = ["Could not find a path from ", r, " to ", i, "."].join("");
        throw new Error(y);
      }
      return s;
    },
    extract_shortest_path_from_predecessor_list: function(n, r) {
      for (var i = [], s = r; s; )
        i.push(s), n[s], s = n[s];
      return i.reverse(), i;
    },
    find_path: function(n, r, i) {
      var s = t.single_source_shortest_paths(n, r, i);
      return t.extract_shortest_path_from_predecessor_list(
        s,
        i
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(n) {
        var r = t.PriorityQueue, i = {}, s;
        n = n || {};
        for (s in r)
          r.hasOwnProperty(s) && (i[s] = r[s]);
        return i.queue = [], i.sorter = n.sorter || r.default_sorter, i;
      },
      default_sorter: function(n, r) {
        return n.cost - r.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(n, r) {
        var i = { value: n, cost: r };
        this.queue.push(i), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  e.exports = t;
})(gU);
var gse = gU.exports;
(function(e) {
  const t = yu, n = ose, r = cse, i = fse, s = mse, o = _a, a = ns, c = gse;
  function l(y) {
    return unescape(encodeURIComponent(y)).length;
  }
  function u(y, v, b) {
    const w = [];
    let A;
    for (; (A = y.exec(b)) !== null; )
      w.push({
        data: A[0],
        index: A.index,
        mode: v,
        length: A[0].length
      });
    return w;
  }
  function d(y) {
    const v = u(o.NUMERIC, t.NUMERIC, y), b = u(o.ALPHANUMERIC, t.ALPHANUMERIC, y);
    let w, A;
    return a.isKanjiModeEnabled() ? (w = u(o.BYTE, t.BYTE, y), A = u(o.KANJI, t.KANJI, y)) : (w = u(o.BYTE_KANJI, t.BYTE, y), A = []), v.concat(b, w, A).sort(function(x, S) {
      return x.index - S.index;
    }).map(function(x) {
      return {
        data: x.data,
        mode: x.mode,
        length: x.length
      };
    });
  }
  function f(y, v) {
    switch (v) {
      case t.NUMERIC:
        return n.getBitsLength(y);
      case t.ALPHANUMERIC:
        return r.getBitsLength(y);
      case t.KANJI:
        return s.getBitsLength(y);
      case t.BYTE:
        return i.getBitsLength(y);
    }
  }
  function p(y) {
    return y.reduce(function(v, b) {
      const w = v.length - 1 >= 0 ? v[v.length - 1] : null;
      return w && w.mode === b.mode ? (v[v.length - 1].data += b.data, v) : (v.push(b), v);
    }, []);
  }
  function m(y) {
    const v = [];
    for (let b = 0; b < y.length; b++) {
      const w = y[b];
      switch (w.mode) {
        case t.NUMERIC:
          v.push([
            w,
            { data: w.data, mode: t.ALPHANUMERIC, length: w.length },
            { data: w.data, mode: t.BYTE, length: w.length }
          ]);
          break;
        case t.ALPHANUMERIC:
          v.push([
            w,
            { data: w.data, mode: t.BYTE, length: w.length }
          ]);
          break;
        case t.KANJI:
          v.push([
            w,
            { data: w.data, mode: t.BYTE, length: l(w.data) }
          ]);
          break;
        case t.BYTE:
          v.push([
            { data: w.data, mode: t.BYTE, length: l(w.data) }
          ]);
      }
    }
    return v;
  }
  function h(y, v) {
    const b = {}, w = { start: {} };
    let A = ["start"];
    for (let E = 0; E < y.length; E++) {
      const x = y[E], S = [];
      for (let P = 0; P < x.length; P++) {
        const I = x[P], R = "" + E + P;
        S.push(R), b[R] = { node: I, lastCount: 0 }, w[R] = {};
        for (let Q = 0; Q < A.length; Q++) {
          const J = A[Q];
          b[J] && b[J].node.mode === I.mode ? (w[J][R] = f(b[J].lastCount + I.length, I.mode) - f(b[J].lastCount, I.mode), b[J].lastCount += I.length) : (b[J] && (b[J].lastCount = I.length), w[J][R] = f(I.length, I.mode) + 4 + t.getCharCountIndicator(I.mode, v));
        }
      }
      A = S;
    }
    for (let E = 0; E < A.length; E++)
      w[A[E]].end = 0;
    return { map: w, table: b };
  }
  function g(y, v) {
    let b;
    const w = t.getBestModeForData(y);
    if (b = t.from(v, w), b !== t.BYTE && b.bit < w.bit)
      throw new Error('"' + y + '" cannot be encoded with mode ' + t.toString(b) + `.
 Suggested mode is: ` + t.toString(w));
    switch (b === t.KANJI && !a.isKanjiModeEnabled() && (b = t.BYTE), b) {
      case t.NUMERIC:
        return new n(y);
      case t.ALPHANUMERIC:
        return new r(y);
      case t.KANJI:
        return new s(y);
      case t.BYTE:
        return new i(y);
    }
  }
  e.fromArray = function(v) {
    return v.reduce(function(b, w) {
      return typeof w == "string" ? b.push(g(w, null)) : w.data && b.push(g(w.data, w.mode)), b;
    }, []);
  }, e.fromString = function(v, b) {
    const w = d(v, a.isKanjiModeEnabled()), A = m(w), E = h(A, b), x = c.find_path(E.map, "start", "end"), S = [];
    for (let P = 1; P < x.length - 1; P++)
      S.push(E.table[x[P]].node);
    return e.fromArray(p(S));
  }, e.rawSplit = function(v) {
    return e.fromArray(
      d(v, a.isKanjiModeEnabled())
    );
  };
})(mU);
const WA = ns, H3 = zA, yse = Kie, bse = Yie, vse = oU, wse = aU, zS = cU, VS = VA, xse = Jie, Nx = dU, Ase = hU, Ese = yu, W3 = mU;
function _se(e, t) {
  const n = e.size, r = wse.getPositions(t);
  for (let i = 0; i < r.length; i++) {
    const s = r[i][0], o = r[i][1];
    for (let a = -1; a <= 7; a++)
      if (!(s + a <= -1 || n <= s + a))
        for (let c = -1; c <= 7; c++)
          o + c <= -1 || n <= o + c || (a >= 0 && a <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (a === 0 || a === 6) || a >= 2 && a <= 4 && c >= 2 && c <= 4 ? e.set(s + a, o + c, !0, !0) : e.set(s + a, o + c, !1, !0));
  }
}
function Sse(e) {
  const t = e.size;
  for (let n = 8; n < t - 8; n++) {
    const r = n % 2 === 0;
    e.set(n, 6, r, !0), e.set(6, n, r, !0);
  }
}
function Cse(e, t) {
  const n = vse.getPositions(t);
  for (let r = 0; r < n.length; r++) {
    const i = n[r][0], s = n[r][1];
    for (let o = -2; o <= 2; o++)
      for (let a = -2; a <= 2; a++)
        o === -2 || o === 2 || a === -2 || a === 2 || o === 0 && a === 0 ? e.set(i + o, s + a, !0, !0) : e.set(i + o, s + a, !1, !0);
  }
}
function Tse(e, t) {
  const n = e.size, r = Nx.getEncodedBits(t);
  let i, s, o;
  for (let a = 0; a < 18; a++)
    i = Math.floor(a / 3), s = a % 3 + n - 8 - 3, o = (r >> a & 1) === 1, e.set(i, s, o, !0), e.set(s, i, o, !0);
}
function G3(e, t, n) {
  const r = e.size, i = Ase.getEncodedBits(t, n);
  let s, o;
  for (s = 0; s < 15; s++)
    o = (i >> s & 1) === 1, s < 6 ? e.set(s, 8, o, !0) : s < 8 ? e.set(s + 1, 8, o, !0) : e.set(r - 15 + s, 8, o, !0), s < 8 ? e.set(8, r - s - 1, o, !0) : s < 9 ? e.set(8, 15 - s - 1 + 1, o, !0) : e.set(8, 15 - s - 1, o, !0);
  e.set(r - 8, 8, 1, !0);
}
function kse(e, t) {
  const n = e.size;
  let r = -1, i = n - 1, s = 7, o = 0;
  for (let a = n - 1; a > 0; a -= 2)
    for (a === 6 && a--; ; ) {
      for (let c = 0; c < 2; c++)
        if (!e.isReserved(i, a - c)) {
          let l = !1;
          o < t.length && (l = (t[o] >>> s & 1) === 1), e.set(i, a - c, l), s--, s === -1 && (o++, s = 7);
        }
      if (i += r, i < 0 || n <= i) {
        i -= r, r = -r;
        break;
      }
    }
}
function Bse(e, t, n) {
  const r = new yse();
  n.forEach(function(c) {
    r.put(c.mode.bit, 4), r.put(c.getLength(), Ese.getCharCountIndicator(c.mode, e)), c.write(r);
  });
  const i = WA.getSymbolTotalCodewords(e), s = VS.getTotalCodewordsCount(e, t), o = (i - s) * 8;
  for (r.getLengthInBits() + 4 <= o && r.put(0, 4); r.getLengthInBits() % 8 !== 0; )
    r.putBit(0);
  const a = (o - r.getLengthInBits()) / 8;
  for (let c = 0; c < a; c++)
    r.put(c % 2 ? 17 : 236, 8);
  return Ise(r, e, t);
}
function Ise(e, t, n) {
  const r = WA.getSymbolTotalCodewords(t), i = VS.getTotalCodewordsCount(t, n), s = r - i, o = VS.getBlocksCount(t, n), a = r % o, c = o - a, l = Math.floor(r / o), u = Math.floor(s / o), d = u + 1, f = l - u, p = new xse(f);
  let m = 0;
  const h = new Array(o), g = new Array(o);
  let y = 0;
  const v = new Uint8Array(e.buffer);
  for (let x = 0; x < o; x++) {
    const S = x < c ? u : d;
    h[x] = v.slice(m, m + S), g[x] = p.encode(h[x]), m += S, y = Math.max(y, S);
  }
  const b = new Uint8Array(r);
  let w = 0, A, E;
  for (A = 0; A < y; A++)
    for (E = 0; E < o; E++)
      A < h[E].length && (b[w++] = h[E][A]);
  for (A = 0; A < f; A++)
    for (E = 0; E < o; E++)
      b[w++] = g[E][A];
  return b;
}
function Pse(e, t, n, r) {
  let i;
  if (Array.isArray(e))
    i = W3.fromArray(e);
  else if (typeof e == "string") {
    let l = t;
    if (!l) {
      const u = W3.rawSplit(e);
      l = Nx.getBestVersionForData(u, n);
    }
    i = W3.fromString(e, l || 40);
  } else
    throw new Error("Invalid data");
  const s = Nx.getBestVersionForData(i, n);
  if (!s)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!t)
    t = s;
  else if (t < s)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + s + `.
`
    );
  const o = Bse(t, n, i), a = WA.getSymbolSize(t), c = new bse(a);
  return _se(c, t), Sse(c), Cse(c, t), G3(c, n, 0), t >= 7 && Tse(c, t), kse(c, o), isNaN(r) && (r = zS.getBestMask(
    c,
    G3.bind(null, c, n)
  )), zS.applyMask(r, c), G3(c, n, r), {
    modules: c,
    version: t,
    errorCorrectionLevel: n,
    maskPattern: r,
    segments: i
  };
}
iU.create = function(t, n) {
  if (typeof t > "u" || t === "")
    throw new Error("No input text");
  let r = H3.M, i, s;
  return typeof n < "u" && (r = H3.from(n.errorCorrectionLevel, H3.M), i = Nx.from(n.version), s = zS.from(n.maskPattern), n.toSJISFunc && WA.setToSJISFunction(n.toSJISFunc)), Pse(t, i, r, s);
};
var yU = {}, _5 = {};
(function(e) {
  function t(n) {
    if (typeof n == "number" && (n = n.toString()), typeof n != "string")
      throw new Error("Color should be defined as hex string");
    let r = n.slice().replace("#", "").split("");
    if (r.length < 3 || r.length === 5 || r.length > 8)
      throw new Error("Invalid hex color: " + n);
    (r.length === 3 || r.length === 4) && (r = Array.prototype.concat.apply([], r.map(function(s) {
      return [s, s];
    }))), r.length === 6 && r.push("F", "F");
    const i = parseInt(r.join(""), 16);
    return {
      r: i >> 24 & 255,
      g: i >> 16 & 255,
      b: i >> 8 & 255,
      a: i & 255,
      hex: "#" + r.slice(0, 6).join("")
    };
  }
  e.getOptions = function(r) {
    r || (r = {}), r.color || (r.color = {});
    const i = typeof r.margin > "u" || r.margin === null || r.margin < 0 ? 4 : r.margin, s = r.width && r.width >= 21 ? r.width : void 0, o = r.scale || 4;
    return {
      width: s,
      scale: s ? 4 : o,
      margin: i,
      color: {
        dark: t(r.color.dark || "#000000ff"),
        light: t(r.color.light || "#ffffffff")
      },
      type: r.type,
      rendererOpts: r.rendererOpts || {}
    };
  }, e.getScale = function(r, i) {
    return i.width && i.width >= r + i.margin * 2 ? i.width / (r + i.margin * 2) : i.scale;
  }, e.getImageWidth = function(r, i) {
    const s = e.getScale(r, i);
    return Math.floor((r + i.margin * 2) * s);
  }, e.qrToImageData = function(r, i, s) {
    const o = i.modules.size, a = i.modules.data, c = e.getScale(o, s), l = Math.floor((o + s.margin * 2) * c), u = s.margin * c, d = [s.color.light, s.color.dark];
    for (let f = 0; f < l; f++)
      for (let p = 0; p < l; p++) {
        let m = (f * l + p) * 4, h = s.color.light;
        if (f >= u && p >= u && f < l - u && p < l - u) {
          const g = Math.floor((f - u) / c), y = Math.floor((p - u) / c);
          h = d[a[g * o + y] ? 1 : 0];
        }
        r[m++] = h.r, r[m++] = h.g, r[m++] = h.b, r[m] = h.a;
      }
  };
})(_5);
(function(e) {
  const t = _5;
  function n(i, s, o) {
    i.clearRect(0, 0, s.width, s.height), s.style || (s.style = {}), s.height = o, s.width = o, s.style.height = o + "px", s.style.width = o + "px";
  }
  function r() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  e.render = function(s, o, a) {
    let c = a, l = o;
    typeof c > "u" && (!o || !o.getContext) && (c = o, o = void 0), o || (l = r()), c = t.getOptions(c);
    const u = t.getImageWidth(s.modules.size, c), d = l.getContext("2d"), f = d.createImageData(u, u);
    return t.qrToImageData(f.data, s, c), n(d, l, u), d.putImageData(f, 0, 0), l;
  }, e.renderToDataURL = function(s, o, a) {
    let c = a;
    typeof c > "u" && (!o || !o.getContext) && (c = o, o = void 0), c || (c = {});
    const l = e.render(s, o, c), u = c.type || "image/png", d = c.rendererOpts || {};
    return l.toDataURL(u, d.quality);
  };
})(yU);
var bU = {};
const Ose = _5;
function ZI(e, t) {
  const n = e.a / 255, r = t + '="' + e.hex + '"';
  return n < 1 ? r + " " + t + '-opacity="' + n.toFixed(2).slice(1) + '"' : r;
}
function q3(e, t, n) {
  let r = e + t;
  return typeof n < "u" && (r += " " + n), r;
}
function Nse(e, t, n) {
  let r = "", i = 0, s = !1, o = 0;
  for (let a = 0; a < e.length; a++) {
    const c = Math.floor(a % t), l = Math.floor(a / t);
    !c && !s && (s = !0), e[a] ? (o++, a > 0 && c > 0 && e[a - 1] || (r += s ? q3("M", c + n, 0.5 + l + n) : q3("m", i, 0), i = 0, s = !1), c + 1 < t && e[a + 1] || (r += q3("h", o), o = 0)) : i++;
  }
  return r;
}
bU.render = function(t, n, r) {
  const i = Ose.getOptions(n), s = t.modules.size, o = t.modules.data, a = s + i.margin * 2, c = i.color.light.a ? "<path " + ZI(i.color.light, "fill") + ' d="M0 0h' + a + "v" + a + 'H0z"/>' : "", l = "<path " + ZI(i.color.dark, "stroke") + ' d="' + Nse(o, s, i.margin) + '"/>', u = 'viewBox="0 0 ' + a + " " + a + '"', f = '<svg xmlns="http://www.w3.org/2000/svg" ' + (i.width ? 'width="' + i.width + '" height="' + i.width + '" ' : "") + u + ' shape-rendering="crispEdges">' + c + l + `</svg>
`;
  return typeof r == "function" && r(null, f), f;
};
const Rse = $ie, HS = iU, vU = yU, Mse = bU;
function S5(e, t, n, r, i) {
  const s = [].slice.call(arguments, 1), o = s.length, a = typeof s[o - 1] == "function";
  if (!a && !Rse())
    throw new Error("Callback required as last argument");
  if (a) {
    if (o < 2)
      throw new Error("Too few arguments provided");
    o === 2 ? (i = n, n = t, t = r = void 0) : o === 3 && (t.getContext && typeof i > "u" ? (i = r, r = void 0) : (i = r, r = n, n = t, t = void 0));
  } else {
    if (o < 1)
      throw new Error("Too few arguments provided");
    return o === 1 ? (n = t, t = r = void 0) : o === 2 && !t.getContext && (r = n, n = t, t = void 0), new Promise(function(c, l) {
      try {
        const u = HS.create(n, r);
        c(e(u, t, r));
      } catch (u) {
        l(u);
      }
    });
  }
  try {
    const c = HS.create(n, r);
    i(null, e(c, t, r));
  } catch (c) {
    i(c);
  }
}
av.create = HS.create;
av.toCanvas = S5.bind(null, vU.render);
av.toDataURL = S5.bind(null, vU.renderToDataURL);
av.toString = S5.bind(null, function(e, t, n) {
  return Mse.render(e, n);
});
var rr = {}, GA = {};
GA.byteLength = Dse;
GA.toByteArray = Lse;
GA.fromByteArray = Hse;
var ra = [], fs = [], Fse = typeof Uint8Array < "u" ? Uint8Array : Array, $3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var zf = 0, jse = $3.length; zf < jse; ++zf)
  ra[zf] = $3[zf], fs[$3.charCodeAt(zf)] = zf;
fs[45] = 62;
fs[95] = 63;
function wU(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var r = n === t ? 0 : 4 - n % 4;
  return [n, r];
}
function Dse(e) {
  var t = wU(e), n = t[0], r = t[1];
  return (n + r) * 3 / 4 - r;
}
function Use(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function Lse(e) {
  var t, n = wU(e), r = n[0], i = n[1], s = new Fse(Use(e, r, i)), o = 0, a = i > 0 ? r - 4 : r, c;
  for (c = 0; c < a; c += 4)
    t = fs[e.charCodeAt(c)] << 18 | fs[e.charCodeAt(c + 1)] << 12 | fs[e.charCodeAt(c + 2)] << 6 | fs[e.charCodeAt(c + 3)], s[o++] = t >> 16 & 255, s[o++] = t >> 8 & 255, s[o++] = t & 255;
  return i === 2 && (t = fs[e.charCodeAt(c)] << 2 | fs[e.charCodeAt(c + 1)] >> 4, s[o++] = t & 255), i === 1 && (t = fs[e.charCodeAt(c)] << 10 | fs[e.charCodeAt(c + 1)] << 4 | fs[e.charCodeAt(c + 2)] >> 2, s[o++] = t >> 8 & 255, s[o++] = t & 255), s;
}
function zse(e) {
  return ra[e >> 18 & 63] + ra[e >> 12 & 63] + ra[e >> 6 & 63] + ra[e & 63];
}
function Vse(e, t, n) {
  for (var r, i = [], s = t; s < n; s += 3)
    r = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (e[s + 2] & 255), i.push(zse(r));
  return i.join("");
}
function Hse(e) {
  for (var t, n = e.length, r = n % 3, i = [], s = 16383, o = 0, a = n - r; o < a; o += s)
    i.push(Vse(e, o, o + s > a ? a : o + s));
  return r === 1 ? (t = e[n - 1], i.push(
    ra[t >> 2] + ra[t << 4 & 63] + "=="
  )) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i.push(
    ra[t >> 10] + ra[t >> 4 & 63] + ra[t << 2 & 63] + "="
  )), i.join("");
}
var C5 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
C5.read = function(e, t, n, r, i) {
  var s, o, a = i * 8 - r - 1, c = (1 << a) - 1, l = c >> 1, u = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, p = e[t + d];
  for (d += f, s = p & (1 << -u) - 1, p >>= -u, u += a; u > 0; s = s * 256 + e[t + d], d += f, u -= 8)
    ;
  for (o = s & (1 << -u) - 1, s >>= -u, u += r; u > 0; o = o * 256 + e[t + d], d += f, u -= 8)
    ;
  if (s === 0)
    s = 1 - l;
  else {
    if (s === c)
      return o ? NaN : (p ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), s = s - l;
  }
  return (p ? -1 : 1) * o * Math.pow(2, s - r);
};
C5.write = function(e, t, n, r, i, s) {
  var o, a, c, l = s * 8 - i - 1, u = (1 << l) - 1, d = u >> 1, f = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : s - 1, m = r ? 1 : -1, h = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + d >= 1 ? t += f / c : t += f * Math.pow(2, 1 - d), t * c >= 2 && (o++, c /= 2), o + d >= u ? (a = 0, o = u) : o + d >= 1 ? (a = (t * c - 1) * Math.pow(2, i), o = o + d) : (a = t * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + p] = a & 255, p += m, a /= 256, i -= 8)
    ;
  for (o = o << i | a, l += i; l > 0; e[n + p] = o & 255, p += m, o /= 256, l -= 8)
    ;
  e[n + p - m] |= h * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = GA, n = C5, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = u, e.SlowBuffer = A, e.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  e.kMaxLength = i;
  const { Uint8Array: s, ArrayBuffer: o, SharedArrayBuffer: a } = globalThis;
  u.TYPED_ARRAY_SUPPORT = c(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function c() {
    try {
      const O = new s(1), _ = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(_, s.prototype), Object.setPrototypeOf(O, _), O.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function l(O) {
    if (O > i)
      throw new RangeError('The value "' + O + '" is invalid for option "size"');
    const _ = new s(O);
    return Object.setPrototypeOf(_, u.prototype), _;
  }
  function u(O, _, T) {
    if (typeof O == "number") {
      if (typeof _ == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return m(O);
    }
    return d(O, _, T);
  }
  u.poolSize = 8192;
  function d(O, _, T) {
    if (typeof O == "string")
      return h(O, _);
    if (o.isView(O))
      return y(O);
    if (O == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof O
      );
    if (Oe(O, o) || O && Oe(O.buffer, o) || typeof a < "u" && (Oe(O, a) || O && Oe(O.buffer, a)))
      return v(O, _, T);
    if (typeof O == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const M = O.valueOf && O.valueOf();
    if (M != null && M !== O)
      return u.from(M, _, T);
    const se = b(O);
    if (se)
      return se;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof O[Symbol.toPrimitive] == "function")
      return u.from(O[Symbol.toPrimitive]("string"), _, T);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof O
    );
  }
  u.from = function(O, _, T) {
    return d(O, _, T);
  }, Object.setPrototypeOf(u.prototype, s.prototype), Object.setPrototypeOf(u, s);
  function f(O) {
    if (typeof O != "number")
      throw new TypeError('"size" argument must be of type number');
    if (O < 0)
      throw new RangeError('The value "' + O + '" is invalid for option "size"');
  }
  function p(O, _, T) {
    return f(O), O <= 0 ? l(O) : _ !== void 0 ? typeof T == "string" ? l(O).fill(_, T) : l(O).fill(_) : l(O);
  }
  u.alloc = function(O, _, T) {
    return p(O, _, T);
  };
  function m(O) {
    return f(O), l(O < 0 ? 0 : w(O) | 0);
  }
  u.allocUnsafe = function(O) {
    return m(O);
  }, u.allocUnsafeSlow = function(O) {
    return m(O);
  };
  function h(O, _) {
    if ((typeof _ != "string" || _ === "") && (_ = "utf8"), !u.isEncoding(_))
      throw new TypeError("Unknown encoding: " + _);
    const T = E(O, _) | 0;
    let M = l(T);
    const se = M.write(O, _);
    return se !== T && (M = M.slice(0, se)), M;
  }
  function g(O) {
    const _ = O.length < 0 ? 0 : w(O.length) | 0, T = l(_);
    for (let M = 0; M < _; M += 1)
      T[M] = O[M] & 255;
    return T;
  }
  function y(O) {
    if (Oe(O, s)) {
      const _ = new s(O);
      return v(_.buffer, _.byteOffset, _.byteLength);
    }
    return g(O);
  }
  function v(O, _, T) {
    if (_ < 0 || O.byteLength < _)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (O.byteLength < _ + (T || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let M;
    return _ === void 0 && T === void 0 ? M = new s(O) : T === void 0 ? M = new s(O, _) : M = new s(O, _, T), Object.setPrototypeOf(M, u.prototype), M;
  }
  function b(O) {
    if (u.isBuffer(O)) {
      const _ = w(O.length) | 0, T = l(_);
      return T.length === 0 || O.copy(T, 0, 0, _), T;
    }
    if (O.length !== void 0)
      return typeof O.length != "number" || De(O.length) ? l(0) : g(O);
    if (O.type === "Buffer" && Array.isArray(O.data))
      return g(O.data);
  }
  function w(O) {
    if (O >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return O | 0;
  }
  function A(O) {
    return +O != O && (O = 0), u.alloc(+O);
  }
  u.isBuffer = function(_) {
    return _ != null && _._isBuffer === !0 && _ !== u.prototype;
  }, u.compare = function(_, T) {
    if (Oe(_, s) && (_ = u.from(_, _.offset, _.byteLength)), Oe(T, s) && (T = u.from(T, T.offset, T.byteLength)), !u.isBuffer(_) || !u.isBuffer(T))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (_ === T)
      return 0;
    let M = _.length, se = T.length;
    for (let H = 0, ue = Math.min(M, se); H < ue; ++H)
      if (_[H] !== T[H]) {
        M = _[H], se = T[H];
        break;
      }
    return M < se ? -1 : se < M ? 1 : 0;
  }, u.isEncoding = function(_) {
    switch (String(_).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(_, T) {
    if (!Array.isArray(_))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (_.length === 0)
      return u.alloc(0);
    let M;
    if (T === void 0)
      for (T = 0, M = 0; M < _.length; ++M)
        T += _[M].length;
    const se = u.allocUnsafe(T);
    let H = 0;
    for (M = 0; M < _.length; ++M) {
      let ue = _[M];
      if (Oe(ue, s))
        H + ue.length > se.length ? (u.isBuffer(ue) || (ue = u.from(ue)), ue.copy(se, H)) : s.prototype.set.call(
          se,
          ue,
          H
        );
      else if (u.isBuffer(ue))
        ue.copy(se, H);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      H += ue.length;
    }
    return se;
  };
  function E(O, _) {
    if (u.isBuffer(O))
      return O.length;
    if (o.isView(O) || Oe(O, o))
      return O.byteLength;
    if (typeof O != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof O
      );
    const T = O.length, M = arguments.length > 2 && arguments[2] === !0;
    if (!M && T === 0)
      return 0;
    let se = !1;
    for (; ; )
      switch (_) {
        case "ascii":
        case "latin1":
        case "binary":
          return T;
        case "utf8":
        case "utf-8":
          return oe(O).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return T * 2;
        case "hex":
          return T >>> 1;
        case "base64":
          return je(O).length;
        default:
          if (se)
            return M ? -1 : oe(O).length;
          _ = ("" + _).toLowerCase(), se = !0;
      }
  }
  u.byteLength = E;
  function x(O, _, T) {
    let M = !1;
    if ((_ === void 0 || _ < 0) && (_ = 0), _ > this.length || ((T === void 0 || T > this.length) && (T = this.length), T <= 0) || (T >>>= 0, _ >>>= 0, T <= _))
      return "";
    for (O || (O = "utf8"); ; )
      switch (O) {
        case "hex":
          return Ae(this, _, T);
        case "utf8":
        case "utf-8":
          return U(this, _, T);
        case "ascii":
          return ae(this, _, T);
        case "latin1":
        case "binary":
          return ge(this, _, T);
        case "base64":
          return L(this, _, T);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return he(this, _, T);
        default:
          if (M)
            throw new TypeError("Unknown encoding: " + O);
          O = (O + "").toLowerCase(), M = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function S(O, _, T) {
    const M = O[_];
    O[_] = O[T], O[T] = M;
  }
  u.prototype.swap16 = function() {
    const _ = this.length;
    if (_ % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let T = 0; T < _; T += 2)
      S(this, T, T + 1);
    return this;
  }, u.prototype.swap32 = function() {
    const _ = this.length;
    if (_ % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let T = 0; T < _; T += 4)
      S(this, T, T + 3), S(this, T + 1, T + 2);
    return this;
  }, u.prototype.swap64 = function() {
    const _ = this.length;
    if (_ % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let T = 0; T < _; T += 8)
      S(this, T, T + 7), S(this, T + 1, T + 6), S(this, T + 2, T + 5), S(this, T + 3, T + 4);
    return this;
  }, u.prototype.toString = function() {
    const _ = this.length;
    return _ === 0 ? "" : arguments.length === 0 ? U(this, 0, _) : x.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(_) {
    if (!u.isBuffer(_))
      throw new TypeError("Argument must be a Buffer");
    return this === _ ? !0 : u.compare(this, _) === 0;
  }, u.prototype.inspect = function() {
    let _ = "";
    const T = e.INSPECT_MAX_BYTES;
    return _ = this.toString("hex", 0, T).replace(/(.{2})/g, "$1 ").trim(), this.length > T && (_ += " ... "), "<Buffer " + _ + ">";
  }, r && (u.prototype[r] = u.prototype.inspect), u.prototype.compare = function(_, T, M, se, H) {
    if (Oe(_, s) && (_ = u.from(_, _.offset, _.byteLength)), !u.isBuffer(_))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof _
      );
    if (T === void 0 && (T = 0), M === void 0 && (M = _ ? _.length : 0), se === void 0 && (se = 0), H === void 0 && (H = this.length), T < 0 || M > _.length || se < 0 || H > this.length)
      throw new RangeError("out of range index");
    if (se >= H && T >= M)
      return 0;
    if (se >= H)
      return -1;
    if (T >= M)
      return 1;
    if (T >>>= 0, M >>>= 0, se >>>= 0, H >>>= 0, this === _)
      return 0;
    let ue = H - se, Ee = M - T;
    const Xe = Math.min(ue, Ee), Ge = this.slice(se, H), it = _.slice(T, M);
    for (let et = 0; et < Xe; ++et)
      if (Ge[et] !== it[et]) {
        ue = Ge[et], Ee = it[et];
        break;
      }
    return ue < Ee ? -1 : Ee < ue ? 1 : 0;
  };
  function P(O, _, T, M, se) {
    if (O.length === 0)
      return -1;
    if (typeof T == "string" ? (M = T, T = 0) : T > 2147483647 ? T = 2147483647 : T < -2147483648 && (T = -2147483648), T = +T, De(T) && (T = se ? 0 : O.length - 1), T < 0 && (T = O.length + T), T >= O.length) {
      if (se)
        return -1;
      T = O.length - 1;
    } else if (T < 0)
      if (se)
        T = 0;
      else
        return -1;
    if (typeof _ == "string" && (_ = u.from(_, M)), u.isBuffer(_))
      return _.length === 0 ? -1 : I(O, _, T, M, se);
    if (typeof _ == "number")
      return _ = _ & 255, typeof s.prototype.indexOf == "function" ? se ? s.prototype.indexOf.call(O, _, T) : s.prototype.lastIndexOf.call(O, _, T) : I(O, [_], T, M, se);
    throw new TypeError("val must be string, number or Buffer");
  }
  function I(O, _, T, M, se) {
    let H = 1, ue = O.length, Ee = _.length;
    if (M !== void 0 && (M = String(M).toLowerCase(), M === "ucs2" || M === "ucs-2" || M === "utf16le" || M === "utf-16le")) {
      if (O.length < 2 || _.length < 2)
        return -1;
      H = 2, ue /= 2, Ee /= 2, T /= 2;
    }
    function Xe(it, et) {
      return H === 1 ? it[et] : it.readUInt16BE(et * H);
    }
    let Ge;
    if (se) {
      let it = -1;
      for (Ge = T; Ge < ue; Ge++)
        if (Xe(O, Ge) === Xe(_, it === -1 ? 0 : Ge - it)) {
          if (it === -1 && (it = Ge), Ge - it + 1 === Ee)
            return it * H;
        } else
          it !== -1 && (Ge -= Ge - it), it = -1;
    } else
      for (T + Ee > ue && (T = ue - Ee), Ge = T; Ge >= 0; Ge--) {
        let it = !0;
        for (let et = 0; et < Ee; et++)
          if (Xe(O, Ge + et) !== Xe(_, et)) {
            it = !1;
            break;
          }
        if (it)
          return Ge;
      }
    return -1;
  }
  u.prototype.includes = function(_, T, M) {
    return this.indexOf(_, T, M) !== -1;
  }, u.prototype.indexOf = function(_, T, M) {
    return P(this, _, T, M, !0);
  }, u.prototype.lastIndexOf = function(_, T, M) {
    return P(this, _, T, M, !1);
  };
  function R(O, _, T, M) {
    T = Number(T) || 0;
    const se = O.length - T;
    M ? (M = Number(M), M > se && (M = se)) : M = se;
    const H = _.length;
    M > H / 2 && (M = H / 2);
    let ue;
    for (ue = 0; ue < M; ++ue) {
      const Ee = parseInt(_.substr(ue * 2, 2), 16);
      if (De(Ee))
        return ue;
      O[T + ue] = Ee;
    }
    return ue;
  }
  function Q(O, _, T, M) {
    return Ye(oe(_, O.length - T), O, T, M);
  }
  function J(O, _, T, M) {
    return Ye(me(_), O, T, M);
  }
  function we(O, _, T, M) {
    return Ye(je(_), O, T, M);
  }
  function V(O, _, T, M) {
    return Ye(Me(_, O.length - T), O, T, M);
  }
  u.prototype.write = function(_, T, M, se) {
    if (T === void 0)
      se = "utf8", M = this.length, T = 0;
    else if (M === void 0 && typeof T == "string")
      se = T, M = this.length, T = 0;
    else if (isFinite(T))
      T = T >>> 0, isFinite(M) ? (M = M >>> 0, se === void 0 && (se = "utf8")) : (se = M, M = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const H = this.length - T;
    if ((M === void 0 || M > H) && (M = H), _.length > 0 && (M < 0 || T < 0) || T > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    se || (se = "utf8");
    let ue = !1;
    for (; ; )
      switch (se) {
        case "hex":
          return R(this, _, T, M);
        case "utf8":
        case "utf-8":
          return Q(this, _, T, M);
        case "ascii":
        case "latin1":
        case "binary":
          return J(this, _, T, M);
        case "base64":
          return we(this, _, T, M);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return V(this, _, T, M);
        default:
          if (ue)
            throw new TypeError("Unknown encoding: " + se);
          se = ("" + se).toLowerCase(), ue = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function L(O, _, T) {
    return _ === 0 && T === O.length ? t.fromByteArray(O) : t.fromByteArray(O.slice(_, T));
  }
  function U(O, _, T) {
    T = Math.min(O.length, T);
    const M = [];
    let se = _;
    for (; se < T; ) {
      const H = O[se];
      let ue = null, Ee = H > 239 ? 4 : H > 223 ? 3 : H > 191 ? 2 : 1;
      if (se + Ee <= T) {
        let Xe, Ge, it, et;
        switch (Ee) {
          case 1:
            H < 128 && (ue = H);
            break;
          case 2:
            Xe = O[se + 1], (Xe & 192) === 128 && (et = (H & 31) << 6 | Xe & 63, et > 127 && (ue = et));
            break;
          case 3:
            Xe = O[se + 1], Ge = O[se + 2], (Xe & 192) === 128 && (Ge & 192) === 128 && (et = (H & 15) << 12 | (Xe & 63) << 6 | Ge & 63, et > 2047 && (et < 55296 || et > 57343) && (ue = et));
            break;
          case 4:
            Xe = O[se + 1], Ge = O[se + 2], it = O[se + 3], (Xe & 192) === 128 && (Ge & 192) === 128 && (it & 192) === 128 && (et = (H & 15) << 18 | (Xe & 63) << 12 | (Ge & 63) << 6 | it & 63, et > 65535 && et < 1114112 && (ue = et));
        }
      }
      ue === null ? (ue = 65533, Ee = 1) : ue > 65535 && (ue -= 65536, M.push(ue >>> 10 & 1023 | 55296), ue = 56320 | ue & 1023), M.push(ue), se += Ee;
    }
    return G(M);
  }
  const q = 4096;
  function G(O) {
    const _ = O.length;
    if (_ <= q)
      return String.fromCharCode.apply(String, O);
    let T = "", M = 0;
    for (; M < _; )
      T += String.fromCharCode.apply(
        String,
        O.slice(M, M += q)
      );
    return T;
  }
  function ae(O, _, T) {
    let M = "";
    T = Math.min(O.length, T);
    for (let se = _; se < T; ++se)
      M += String.fromCharCode(O[se] & 127);
    return M;
  }
  function ge(O, _, T) {
    let M = "";
    T = Math.min(O.length, T);
    for (let se = _; se < T; ++se)
      M += String.fromCharCode(O[se]);
    return M;
  }
  function Ae(O, _, T) {
    const M = O.length;
    (!_ || _ < 0) && (_ = 0), (!T || T < 0 || T > M) && (T = M);
    let se = "";
    for (let H = _; H < T; ++H)
      se += Te[O[H]];
    return se;
  }
  function he(O, _, T) {
    const M = O.slice(_, T);
    let se = "";
    for (let H = 0; H < M.length - 1; H += 2)
      se += String.fromCharCode(M[H] + M[H + 1] * 256);
    return se;
  }
  u.prototype.slice = function(_, T) {
    const M = this.length;
    _ = ~~_, T = T === void 0 ? M : ~~T, _ < 0 ? (_ += M, _ < 0 && (_ = 0)) : _ > M && (_ = M), T < 0 ? (T += M, T < 0 && (T = 0)) : T > M && (T = M), T < _ && (T = _);
    const se = this.subarray(_, T);
    return Object.setPrototypeOf(se, u.prototype), se;
  };
  function B(O, _, T) {
    if (O % 1 !== 0 || O < 0)
      throw new RangeError("offset is not uint");
    if (O + _ > T)
      throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(_, T, M) {
    _ = _ >>> 0, T = T >>> 0, M || B(_, T, this.length);
    let se = this[_], H = 1, ue = 0;
    for (; ++ue < T && (H *= 256); )
      se += this[_ + ue] * H;
    return se;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(_, T, M) {
    _ = _ >>> 0, T = T >>> 0, M || B(_, T, this.length);
    let se = this[_ + --T], H = 1;
    for (; T > 0 && (H *= 256); )
      se += this[_ + --T] * H;
    return se;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(_, T) {
    return _ = _ >>> 0, T || B(_, 1, this.length), this[_];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 2, this.length), this[_] | this[_ + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 2, this.length), this[_] << 8 | this[_ + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 4, this.length), (this[_] | this[_ + 1] << 8 | this[_ + 2] << 16) + this[_ + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 4, this.length), this[_] * 16777216 + (this[_ + 1] << 16 | this[_ + 2] << 8 | this[_ + 3]);
  }, u.prototype.readBigUInt64LE = Fe(function(_) {
    _ = _ >>> 0, X(_, "offset");
    const T = this[_], M = this[_ + 7];
    (T === void 0 || M === void 0) && $(_, this.length - 8);
    const se = T + this[++_] * 2 ** 8 + this[++_] * 2 ** 16 + this[++_] * 2 ** 24, H = this[++_] + this[++_] * 2 ** 8 + this[++_] * 2 ** 16 + M * 2 ** 24;
    return BigInt(se) + (BigInt(H) << BigInt(32));
  }), u.prototype.readBigUInt64BE = Fe(function(_) {
    _ = _ >>> 0, X(_, "offset");
    const T = this[_], M = this[_ + 7];
    (T === void 0 || M === void 0) && $(_, this.length - 8);
    const se = T * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + this[++_], H = this[++_] * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + M;
    return (BigInt(se) << BigInt(32)) + BigInt(H);
  }), u.prototype.readIntLE = function(_, T, M) {
    _ = _ >>> 0, T = T >>> 0, M || B(_, T, this.length);
    let se = this[_], H = 1, ue = 0;
    for (; ++ue < T && (H *= 256); )
      se += this[_ + ue] * H;
    return H *= 128, se >= H && (se -= Math.pow(2, 8 * T)), se;
  }, u.prototype.readIntBE = function(_, T, M) {
    _ = _ >>> 0, T = T >>> 0, M || B(_, T, this.length);
    let se = T, H = 1, ue = this[_ + --se];
    for (; se > 0 && (H *= 256); )
      ue += this[_ + --se] * H;
    return H *= 128, ue >= H && (ue -= Math.pow(2, 8 * T)), ue;
  }, u.prototype.readInt8 = function(_, T) {
    return _ = _ >>> 0, T || B(_, 1, this.length), this[_] & 128 ? (255 - this[_] + 1) * -1 : this[_];
  }, u.prototype.readInt16LE = function(_, T) {
    _ = _ >>> 0, T || B(_, 2, this.length);
    const M = this[_] | this[_ + 1] << 8;
    return M & 32768 ? M | 4294901760 : M;
  }, u.prototype.readInt16BE = function(_, T) {
    _ = _ >>> 0, T || B(_, 2, this.length);
    const M = this[_ + 1] | this[_] << 8;
    return M & 32768 ? M | 4294901760 : M;
  }, u.prototype.readInt32LE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 4, this.length), this[_] | this[_ + 1] << 8 | this[_ + 2] << 16 | this[_ + 3] << 24;
  }, u.prototype.readInt32BE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 4, this.length), this[_] << 24 | this[_ + 1] << 16 | this[_ + 2] << 8 | this[_ + 3];
  }, u.prototype.readBigInt64LE = Fe(function(_) {
    _ = _ >>> 0, X(_, "offset");
    const T = this[_], M = this[_ + 7];
    (T === void 0 || M === void 0) && $(_, this.length - 8);
    const se = this[_ + 4] + this[_ + 5] * 2 ** 8 + this[_ + 6] * 2 ** 16 + (M << 24);
    return (BigInt(se) << BigInt(32)) + BigInt(T + this[++_] * 2 ** 8 + this[++_] * 2 ** 16 + this[++_] * 2 ** 24);
  }), u.prototype.readBigInt64BE = Fe(function(_) {
    _ = _ >>> 0, X(_, "offset");
    const T = this[_], M = this[_ + 7];
    (T === void 0 || M === void 0) && $(_, this.length - 8);
    const se = (T << 24) + // Overflow
    this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + this[++_];
    return (BigInt(se) << BigInt(32)) + BigInt(this[++_] * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + M);
  }), u.prototype.readFloatLE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 4, this.length), n.read(this, _, !0, 23, 4);
  }, u.prototype.readFloatBE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 4, this.length), n.read(this, _, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 8, this.length), n.read(this, _, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(_, T) {
    return _ = _ >>> 0, T || B(_, 8, this.length), n.read(this, _, !1, 52, 8);
  };
  function be(O, _, T, M, se, H) {
    if (!u.isBuffer(O))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (_ > se || _ < H)
      throw new RangeError('"value" argument is out of bounds');
    if (T + M > O.length)
      throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(_, T, M, se) {
    if (_ = +_, T = T >>> 0, M = M >>> 0, !se) {
      const Ee = Math.pow(2, 8 * M) - 1;
      be(this, _, T, M, Ee, 0);
    }
    let H = 1, ue = 0;
    for (this[T] = _ & 255; ++ue < M && (H *= 256); )
      this[T + ue] = _ / H & 255;
    return T + M;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(_, T, M, se) {
    if (_ = +_, T = T >>> 0, M = M >>> 0, !se) {
      const Ee = Math.pow(2, 8 * M) - 1;
      be(this, _, T, M, Ee, 0);
    }
    let H = M - 1, ue = 1;
    for (this[T + H] = _ & 255; --H >= 0 && (ue *= 256); )
      this[T + H] = _ / ue & 255;
    return T + M;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 1, 255, 0), this[T] = _ & 255, T + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 2, 65535, 0), this[T] = _ & 255, this[T + 1] = _ >>> 8, T + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 2, 65535, 0), this[T] = _ >>> 8, this[T + 1] = _ & 255, T + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 4, 4294967295, 0), this[T + 3] = _ >>> 24, this[T + 2] = _ >>> 16, this[T + 1] = _ >>> 8, this[T] = _ & 255, T + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 4, 4294967295, 0), this[T] = _ >>> 24, this[T + 1] = _ >>> 16, this[T + 2] = _ >>> 8, this[T + 3] = _ & 255, T + 4;
  };
  function Be(O, _, T, M, se) {
    Y(_, M, se, O, T, 7);
    let H = Number(_ & BigInt(4294967295));
    O[T++] = H, H = H >> 8, O[T++] = H, H = H >> 8, O[T++] = H, H = H >> 8, O[T++] = H;
    let ue = Number(_ >> BigInt(32) & BigInt(4294967295));
    return O[T++] = ue, ue = ue >> 8, O[T++] = ue, ue = ue >> 8, O[T++] = ue, ue = ue >> 8, O[T++] = ue, T;
  }
  function Ne(O, _, T, M, se) {
    Y(_, M, se, O, T, 7);
    let H = Number(_ & BigInt(4294967295));
    O[T + 7] = H, H = H >> 8, O[T + 6] = H, H = H >> 8, O[T + 5] = H, H = H >> 8, O[T + 4] = H;
    let ue = Number(_ >> BigInt(32) & BigInt(4294967295));
    return O[T + 3] = ue, ue = ue >> 8, O[T + 2] = ue, ue = ue >> 8, O[T + 1] = ue, ue = ue >> 8, O[T] = ue, T + 8;
  }
  u.prototype.writeBigUInt64LE = Fe(function(_, T = 0) {
    return Be(this, _, T, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeBigUInt64BE = Fe(function(_, T = 0) {
    return Ne(this, _, T, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeIntLE = function(_, T, M, se) {
    if (_ = +_, T = T >>> 0, !se) {
      const Xe = Math.pow(2, 8 * M - 1);
      be(this, _, T, M, Xe - 1, -Xe);
    }
    let H = 0, ue = 1, Ee = 0;
    for (this[T] = _ & 255; ++H < M && (ue *= 256); )
      _ < 0 && Ee === 0 && this[T + H - 1] !== 0 && (Ee = 1), this[T + H] = (_ / ue >> 0) - Ee & 255;
    return T + M;
  }, u.prototype.writeIntBE = function(_, T, M, se) {
    if (_ = +_, T = T >>> 0, !se) {
      const Xe = Math.pow(2, 8 * M - 1);
      be(this, _, T, M, Xe - 1, -Xe);
    }
    let H = M - 1, ue = 1, Ee = 0;
    for (this[T + H] = _ & 255; --H >= 0 && (ue *= 256); )
      _ < 0 && Ee === 0 && this[T + H + 1] !== 0 && (Ee = 1), this[T + H] = (_ / ue >> 0) - Ee & 255;
    return T + M;
  }, u.prototype.writeInt8 = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 1, 127, -128), _ < 0 && (_ = 255 + _ + 1), this[T] = _ & 255, T + 1;
  }, u.prototype.writeInt16LE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 2, 32767, -32768), this[T] = _ & 255, this[T + 1] = _ >>> 8, T + 2;
  }, u.prototype.writeInt16BE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 2, 32767, -32768), this[T] = _ >>> 8, this[T + 1] = _ & 255, T + 2;
  }, u.prototype.writeInt32LE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 4, 2147483647, -2147483648), this[T] = _ & 255, this[T + 1] = _ >>> 8, this[T + 2] = _ >>> 16, this[T + 3] = _ >>> 24, T + 4;
  }, u.prototype.writeInt32BE = function(_, T, M) {
    return _ = +_, T = T >>> 0, M || be(this, _, T, 4, 2147483647, -2147483648), _ < 0 && (_ = 4294967295 + _ + 1), this[T] = _ >>> 24, this[T + 1] = _ >>> 16, this[T + 2] = _ >>> 8, this[T + 3] = _ & 255, T + 4;
  }, u.prototype.writeBigInt64LE = Fe(function(_, T = 0) {
    return Be(this, _, T, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), u.prototype.writeBigInt64BE = Fe(function(_, T = 0) {
    return Ne(this, _, T, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function _e(O, _, T, M, se, H) {
    if (T + M > O.length)
      throw new RangeError("Index out of range");
    if (T < 0)
      throw new RangeError("Index out of range");
  }
  function Ce(O, _, T, M, se) {
    return _ = +_, T = T >>> 0, se || _e(O, _, T, 4), n.write(O, _, T, M, 23, 4), T + 4;
  }
  u.prototype.writeFloatLE = function(_, T, M) {
    return Ce(this, _, T, !0, M);
  }, u.prototype.writeFloatBE = function(_, T, M) {
    return Ce(this, _, T, !1, M);
  };
  function N(O, _, T, M, se) {
    return _ = +_, T = T >>> 0, se || _e(O, _, T, 8), n.write(O, _, T, M, 52, 8), T + 8;
  }
  u.prototype.writeDoubleLE = function(_, T, M) {
    return N(this, _, T, !0, M);
  }, u.prototype.writeDoubleBE = function(_, T, M) {
    return N(this, _, T, !1, M);
  }, u.prototype.copy = function(_, T, M, se) {
    if (!u.isBuffer(_))
      throw new TypeError("argument should be a Buffer");
    if (M || (M = 0), !se && se !== 0 && (se = this.length), T >= _.length && (T = _.length), T || (T = 0), se > 0 && se < M && (se = M), se === M || _.length === 0 || this.length === 0)
      return 0;
    if (T < 0)
      throw new RangeError("targetStart out of bounds");
    if (M < 0 || M >= this.length)
      throw new RangeError("Index out of range");
    if (se < 0)
      throw new RangeError("sourceEnd out of bounds");
    se > this.length && (se = this.length), _.length - T < se - M && (se = _.length - T + M);
    const H = se - M;
    return this === _ && typeof s.prototype.copyWithin == "function" ? this.copyWithin(T, M, se) : s.prototype.set.call(
      _,
      this.subarray(M, se),
      T
    ), H;
  }, u.prototype.fill = function(_, T, M, se) {
    if (typeof _ == "string") {
      if (typeof T == "string" ? (se = T, T = 0, M = this.length) : typeof M == "string" && (se = M, M = this.length), se !== void 0 && typeof se != "string")
        throw new TypeError("encoding must be a string");
      if (typeof se == "string" && !u.isEncoding(se))
        throw new TypeError("Unknown encoding: " + se);
      if (_.length === 1) {
        const ue = _.charCodeAt(0);
        (se === "utf8" && ue < 128 || se === "latin1") && (_ = ue);
      }
    } else
      typeof _ == "number" ? _ = _ & 255 : typeof _ == "boolean" && (_ = Number(_));
    if (T < 0 || this.length < T || this.length < M)
      throw new RangeError("Out of range index");
    if (M <= T)
      return this;
    T = T >>> 0, M = M === void 0 ? this.length : M >>> 0, _ || (_ = 0);
    let H;
    if (typeof _ == "number")
      for (H = T; H < M; ++H)
        this[H] = _;
    else {
      const ue = u.isBuffer(_) ? _ : u.from(_, se), Ee = ue.length;
      if (Ee === 0)
        throw new TypeError('The value "' + _ + '" is invalid for argument "value"');
      for (H = 0; H < M - T; ++H)
        this[H + T] = ue[H % Ee];
    }
    return this;
  };
  const F = {};
  function z(O, _, T) {
    F[O] = class extends T {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: _.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${O}]`, this.stack, delete this.name;
      }
      get code() {
        return O;
      }
      set code(se) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: se,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${O}]: ${this.message}`;
      }
    };
  }
  z(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(O) {
      return O ? `${O} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), z(
    "ERR_INVALID_ARG_TYPE",
    function(O, _) {
      return `The "${O}" argument must be of type number. Received type ${typeof _}`;
    },
    TypeError
  ), z(
    "ERR_OUT_OF_RANGE",
    function(O, _, T) {
      let M = `The value of "${O}" is out of range.`, se = T;
      return Number.isInteger(T) && Math.abs(T) > 2 ** 32 ? se = ne(String(T)) : typeof T == "bigint" && (se = String(T), (T > BigInt(2) ** BigInt(32) || T < -(BigInt(2) ** BigInt(32))) && (se = ne(se)), se += "n"), M += ` It must be ${_}. Received ${se}`, M;
    },
    RangeError
  );
  function ne(O) {
    let _ = "", T = O.length;
    const M = O[0] === "-" ? 1 : 0;
    for (; T >= M + 4; T -= 3)
      _ = `_${O.slice(T - 3, T)}${_}`;
    return `${O.slice(0, T)}${_}`;
  }
  function ee(O, _, T) {
    X(_, "offset"), (O[_] === void 0 || O[_ + T] === void 0) && $(_, O.length - (T + 1));
  }
  function Y(O, _, T, M, se, H) {
    if (O > T || O < _) {
      const ue = typeof _ == "bigint" ? "n" : "";
      let Ee;
      throw _ === 0 || _ === BigInt(0) ? Ee = `>= 0${ue} and < 2${ue} ** ${(H + 1) * 8}${ue}` : Ee = `>= -(2${ue} ** ${(H + 1) * 8 - 1}${ue}) and < 2 ** ${(H + 1) * 8 - 1}${ue}`, new F.ERR_OUT_OF_RANGE("value", Ee, O);
    }
    ee(M, se, H);
  }
  function X(O, _) {
    if (typeof O != "number")
      throw new F.ERR_INVALID_ARG_TYPE(_, "number", O);
  }
  function $(O, _, T) {
    throw Math.floor(O) !== O ? (X(O, T), new F.ERR_OUT_OF_RANGE("offset", "an integer", O)) : _ < 0 ? new F.ERR_BUFFER_OUT_OF_BOUNDS() : new F.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${_}`,
      O
    );
  }
  const ie = /[^+/0-9A-Za-z-_]/g;
  function fe(O) {
    if (O = O.split("=")[0], O = O.trim().replace(ie, ""), O.length < 2)
      return "";
    for (; O.length % 4 !== 0; )
      O = O + "=";
    return O;
  }
  function oe(O, _) {
    _ = _ || 1 / 0;
    let T;
    const M = O.length;
    let se = null;
    const H = [];
    for (let ue = 0; ue < M; ++ue) {
      if (T = O.charCodeAt(ue), T > 55295 && T < 57344) {
        if (!se) {
          if (T > 56319) {
            (_ -= 3) > -1 && H.push(239, 191, 189);
            continue;
          } else if (ue + 1 === M) {
            (_ -= 3) > -1 && H.push(239, 191, 189);
            continue;
          }
          se = T;
          continue;
        }
        if (T < 56320) {
          (_ -= 3) > -1 && H.push(239, 191, 189), se = T;
          continue;
        }
        T = (se - 55296 << 10 | T - 56320) + 65536;
      } else
        se && (_ -= 3) > -1 && H.push(239, 191, 189);
      if (se = null, T < 128) {
        if ((_ -= 1) < 0)
          break;
        H.push(T);
      } else if (T < 2048) {
        if ((_ -= 2) < 0)
          break;
        H.push(
          T >> 6 | 192,
          T & 63 | 128
        );
      } else if (T < 65536) {
        if ((_ -= 3) < 0)
          break;
        H.push(
          T >> 12 | 224,
          T >> 6 & 63 | 128,
          T & 63 | 128
        );
      } else if (T < 1114112) {
        if ((_ -= 4) < 0)
          break;
        H.push(
          T >> 18 | 240,
          T >> 12 & 63 | 128,
          T >> 6 & 63 | 128,
          T & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return H;
  }
  function me(O) {
    const _ = [];
    for (let T = 0; T < O.length; ++T)
      _.push(O.charCodeAt(T) & 255);
    return _;
  }
  function Me(O, _) {
    let T, M, se;
    const H = [];
    for (let ue = 0; ue < O.length && !((_ -= 2) < 0); ++ue)
      T = O.charCodeAt(ue), M = T >> 8, se = T % 256, H.push(se), H.push(M);
    return H;
  }
  function je(O) {
    return t.toByteArray(fe(O));
  }
  function Ye(O, _, T, M) {
    let se;
    for (se = 0; se < M && !(se + T >= _.length || se >= O.length); ++se)
      _[se + T] = O[se];
    return se;
  }
  function Oe(O, _) {
    return O instanceof _ || O != null && O.constructor != null && O.constructor.name != null && O.constructor.name === _.name;
  }
  function De(O) {
    return O !== O;
  }
  const Te = function() {
    const O = "0123456789abcdef", _ = new Array(256);
    for (let T = 0; T < 16; ++T) {
      const M = T * 16;
      for (let se = 0; se < 16; ++se)
        _[M + se] = O[T] + O[se];
    }
    return _;
  }();
  function Fe(O) {
    return typeof BigInt > "u" ? lt : O;
  }
  function lt() {
    throw new Error("BigInt not supported");
  }
})(rr);
const T5 = rr.Buffer, Wse = rr.Blob, Gse = rr.BlobOptions, Qi = rr.Buffer, qse = rr.File, $se = rr.FileOptions, Qse = rr.INSPECT_MAX_BYTES, Kse = rr.SlowBuffer, Yse = rr.TranscodeEncoding, Zse = rr.atob, Jse = rr.btoa, Xse = rr.constants, eoe = rr.isAscii, toe = rr.isUtf8, noe = rr.kMaxLength, roe = rr.kStringMaxLength, ioe = rr.resolveObjectURL, soe = rr.transcode, ooe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Wse,
  BlobOptions: Gse,
  Buffer: Qi,
  File: qse,
  FileOptions: $se,
  INSPECT_MAX_BYTES: Qse,
  SlowBuffer: Kse,
  TranscodeEncoding: Yse,
  atob: Zse,
  btoa: Jse,
  constants: Xse,
  default: T5,
  isAscii: eoe,
  isUtf8: toe,
  kMaxLength: noe,
  kStringMaxLength: roe,
  resolveObjectURL: ioe,
  transcode: soe
}, Symbol.toStringTag, { value: "Module" })), qA = /* @__PURE__ */ vZ(ooe);
var Wn = {}, jo, Do;
function WS() {
  throw new Error("setTimeout has not been defined");
}
function GS() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? jo = setTimeout : jo = WS;
  } catch {
    jo = WS;
  }
  try {
    typeof clearTimeout == "function" ? Do = clearTimeout : Do = GS;
  } catch {
    Do = GS;
  }
})();
function xU(e) {
  if (jo === setTimeout)
    return setTimeout(e, 0);
  if ((jo === WS || !jo) && setTimeout)
    return jo = setTimeout, setTimeout(e, 0);
  try {
    return jo(e, 0);
  } catch {
    try {
      return jo.call(null, e, 0);
    } catch {
      return jo.call(this, e, 0);
    }
  }
}
function aoe(e) {
  if (Do === clearTimeout)
    return clearTimeout(e);
  if ((Do === GS || !Do) && clearTimeout)
    return Do = clearTimeout, clearTimeout(e);
  try {
    return Do(e);
  } catch {
    try {
      return Do.call(null, e);
    } catch {
      return Do.call(this, e);
    }
  }
}
var ic = [], Dh = !1, Zu, fw = -1;
function coe() {
  !Dh || !Zu || (Dh = !1, Zu.length ? ic = Zu.concat(ic) : fw = -1, ic.length && AU());
}
function AU() {
  if (!Dh) {
    var e = xU(coe);
    Dh = !0;
    for (var t = ic.length; t; ) {
      for (Zu = ic, ic = []; ++fw < t; )
        Zu && Zu[fw].run();
      fw = -1, t = ic.length;
    }
    Zu = null, Dh = !1, aoe(e);
  }
}
Wn.nextTick = function(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  ic.push(new EU(e, t)), ic.length === 1 && !Dh && xU(AU);
};
function EU(e, t) {
  this.fun = e, this.array = t;
}
EU.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Wn.title = "browser";
Wn.browser = !0;
Wn.env = {};
Wn.argv = [];
Wn.version = "";
Wn.versions = {};
function Ic() {
}
Wn.on = Ic;
Wn.addListener = Ic;
Wn.once = Ic;
Wn.off = Ic;
Wn.removeListener = Ic;
Wn.removeAllListeners = Ic;
Wn.emit = Ic;
Wn.prependListener = Ic;
Wn.prependOnceListener = Ic;
Wn.listeners = function(e) {
  return [];
};
Wn.binding = function(e) {
  throw new Error("process.binding is not supported");
};
Wn.cwd = function() {
  return "/";
};
Wn.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
Wn.umask = function() {
  return 0;
};
var loe = 768;
Cre({ conditions: { defaultCondition: "smallScreen", conditionNames: ["smallScreen", "largeScreen"], responsiveArray: void 0 } });
var uoe = ED({ conditions: { defaultCondition: "smallScreen", conditionNames: ["smallScreen", "largeScreen"], responsiveArray: void 0 } }), qS = Ore({ conditions: { defaultCondition: "base", conditionNames: ["base", "hover", "active"], responsiveArray: void 0 }, styles: { background: { values: { accentColor: { conditions: { base: "ju367v9i", hover: "ju367v9j", active: "ju367v9k" }, defaultClass: "ju367v9i" }, accentColorForeground: { conditions: { base: "ju367v9l", hover: "ju367v9m", active: "ju367v9n" }, defaultClass: "ju367v9l" }, actionButtonBorder: { conditions: { base: "ju367v9o", hover: "ju367v9p", active: "ju367v9q" }, defaultClass: "ju367v9o" }, actionButtonBorderMobile: { conditions: { base: "ju367v9r", hover: "ju367v9s", active: "ju367v9t" }, defaultClass: "ju367v9r" }, actionButtonSecondaryBackground: { conditions: { base: "ju367v9u", hover: "ju367v9v", active: "ju367v9w" }, defaultClass: "ju367v9u" }, closeButton: { conditions: { base: "ju367v9x", hover: "ju367v9y", active: "ju367v9z" }, defaultClass: "ju367v9x" }, closeButtonBackground: { conditions: { base: "ju367va0", hover: "ju367va1", active: "ju367va2" }, defaultClass: "ju367va0" }, connectButtonBackground: { conditions: { base: "ju367va3", hover: "ju367va4", active: "ju367va5" }, defaultClass: "ju367va3" }, connectButtonBackgroundError: { conditions: { base: "ju367va6", hover: "ju367va7", active: "ju367va8" }, defaultClass: "ju367va6" }, connectButtonInnerBackground: { conditions: { base: "ju367va9", hover: "ju367vaa", active: "ju367vab" }, defaultClass: "ju367va9" }, connectButtonText: { conditions: { base: "ju367vac", hover: "ju367vad", active: "ju367vae" }, defaultClass: "ju367vac" }, connectButtonTextError: { conditions: { base: "ju367vaf", hover: "ju367vag", active: "ju367vah" }, defaultClass: "ju367vaf" }, connectionIndicator: { conditions: { base: "ju367vai", hover: "ju367vaj", active: "ju367vak" }, defaultClass: "ju367vai" }, downloadBottomCardBackground: { conditions: { base: "ju367val", hover: "ju367vam", active: "ju367van" }, defaultClass: "ju367val" }, downloadTopCardBackground: { conditions: { base: "ju367vao", hover: "ju367vap", active: "ju367vaq" }, defaultClass: "ju367vao" }, error: { conditions: { base: "ju367var", hover: "ju367vas", active: "ju367vat" }, defaultClass: "ju367var" }, generalBorder: { conditions: { base: "ju367vau", hover: "ju367vav", active: "ju367vaw" }, defaultClass: "ju367vau" }, generalBorderDim: { conditions: { base: "ju367vax", hover: "ju367vay", active: "ju367vaz" }, defaultClass: "ju367vax" }, menuItemBackground: { conditions: { base: "ju367vb0", hover: "ju367vb1", active: "ju367vb2" }, defaultClass: "ju367vb0" }, modalBackdrop: { conditions: { base: "ju367vb3", hover: "ju367vb4", active: "ju367vb5" }, defaultClass: "ju367vb3" }, modalBackground: { conditions: { base: "ju367vb6", hover: "ju367vb7", active: "ju367vb8" }, defaultClass: "ju367vb6" }, modalBorder: { conditions: { base: "ju367vb9", hover: "ju367vba", active: "ju367vbb" }, defaultClass: "ju367vb9" }, modalText: { conditions: { base: "ju367vbc", hover: "ju367vbd", active: "ju367vbe" }, defaultClass: "ju367vbc" }, modalTextDim: { conditions: { base: "ju367vbf", hover: "ju367vbg", active: "ju367vbh" }, defaultClass: "ju367vbf" }, modalTextSecondary: { conditions: { base: "ju367vbi", hover: "ju367vbj", active: "ju367vbk" }, defaultClass: "ju367vbi" }, profileAction: { conditions: { base: "ju367vbl", hover: "ju367vbm", active: "ju367vbn" }, defaultClass: "ju367vbl" }, profileActionHover: { conditions: { base: "ju367vbo", hover: "ju367vbp", active: "ju367vbq" }, defaultClass: "ju367vbo" }, profileForeground: { conditions: { base: "ju367vbr", hover: "ju367vbs", active: "ju367vbt" }, defaultClass: "ju367vbr" }, selectedOptionBorder: { conditions: { base: "ju367vbu", hover: "ju367vbv", active: "ju367vbw" }, defaultClass: "ju367vbu" }, standby: { conditions: { base: "ju367vbx", hover: "ju367vby", active: "ju367vbz" }, defaultClass: "ju367vbx" } } }, borderColor: { values: { accentColor: { conditions: { base: "ju367vc0", hover: "ju367vc1", active: "ju367vc2" }, defaultClass: "ju367vc0" }, accentColorForeground: { conditions: { base: "ju367vc3", hover: "ju367vc4", active: "ju367vc5" }, defaultClass: "ju367vc3" }, actionButtonBorder: { conditions: { base: "ju367vc6", hover: "ju367vc7", active: "ju367vc8" }, defaultClass: "ju367vc6" }, actionButtonBorderMobile: { conditions: { base: "ju367vc9", hover: "ju367vca", active: "ju367vcb" }, defaultClass: "ju367vc9" }, actionButtonSecondaryBackground: { conditions: { base: "ju367vcc", hover: "ju367vcd", active: "ju367vce" }, defaultClass: "ju367vcc" }, closeButton: { conditions: { base: "ju367vcf", hover: "ju367vcg", active: "ju367vch" }, defaultClass: "ju367vcf" }, closeButtonBackground: { conditions: { base: "ju367vci", hover: "ju367vcj", active: "ju367vck" }, defaultClass: "ju367vci" }, connectButtonBackground: { conditions: { base: "ju367vcl", hover: "ju367vcm", active: "ju367vcn" }, defaultClass: "ju367vcl" }, connectButtonBackgroundError: { conditions: { base: "ju367vco", hover: "ju367vcp", active: "ju367vcq" }, defaultClass: "ju367vco" }, connectButtonInnerBackground: { conditions: { base: "ju367vcr", hover: "ju367vcs", active: "ju367vct" }, defaultClass: "ju367vcr" }, connectButtonText: { conditions: { base: "ju367vcu", hover: "ju367vcv", active: "ju367vcw" }, defaultClass: "ju367vcu" }, connectButtonTextError: { conditions: { base: "ju367vcx", hover: "ju367vcy", active: "ju367vcz" }, defaultClass: "ju367vcx" }, connectionIndicator: { conditions: { base: "ju367vd0", hover: "ju367vd1", active: "ju367vd2" }, defaultClass: "ju367vd0" }, downloadBottomCardBackground: { conditions: { base: "ju367vd3", hover: "ju367vd4", active: "ju367vd5" }, defaultClass: "ju367vd3" }, downloadTopCardBackground: { conditions: { base: "ju367vd6", hover: "ju367vd7", active: "ju367vd8" }, defaultClass: "ju367vd6" }, error: { conditions: { base: "ju367vd9", hover: "ju367vda", active: "ju367vdb" }, defaultClass: "ju367vd9" }, generalBorder: { conditions: { base: "ju367vdc", hover: "ju367vdd", active: "ju367vde" }, defaultClass: "ju367vdc" }, generalBorderDim: { conditions: { base: "ju367vdf", hover: "ju367vdg", active: "ju367vdh" }, defaultClass: "ju367vdf" }, menuItemBackground: { conditions: { base: "ju367vdi", hover: "ju367vdj", active: "ju367vdk" }, defaultClass: "ju367vdi" }, modalBackdrop: { conditions: { base: "ju367vdl", hover: "ju367vdm", active: "ju367vdn" }, defaultClass: "ju367vdl" }, modalBackground: { conditions: { base: "ju367vdo", hover: "ju367vdp", active: "ju367vdq" }, defaultClass: "ju367vdo" }, modalBorder: { conditions: { base: "ju367vdr", hover: "ju367vds", active: "ju367vdt" }, defaultClass: "ju367vdr" }, modalText: { conditions: { base: "ju367vdu", hover: "ju367vdv", active: "ju367vdw" }, defaultClass: "ju367vdu" }, modalTextDim: { conditions: { base: "ju367vdx", hover: "ju367vdy", active: "ju367vdz" }, defaultClass: "ju367vdx" }, modalTextSecondary: { conditions: { base: "ju367ve0", hover: "ju367ve1", active: "ju367ve2" }, defaultClass: "ju367ve0" }, profileAction: { conditions: { base: "ju367ve3", hover: "ju367ve4", active: "ju367ve5" }, defaultClass: "ju367ve3" }, profileActionHover: { conditions: { base: "ju367ve6", hover: "ju367ve7", active: "ju367ve8" }, defaultClass: "ju367ve6" }, profileForeground: { conditions: { base: "ju367ve9", hover: "ju367vea", active: "ju367veb" }, defaultClass: "ju367ve9" }, selectedOptionBorder: { conditions: { base: "ju367vec", hover: "ju367ved", active: "ju367vee" }, defaultClass: "ju367vec" }, standby: { conditions: { base: "ju367vef", hover: "ju367veg", active: "ju367veh" }, defaultClass: "ju367vef" } } }, boxShadow: { values: { connectButton: { conditions: { base: "ju367vei", hover: "ju367vej", active: "ju367vek" }, defaultClass: "ju367vei" }, dialog: { conditions: { base: "ju367vel", hover: "ju367vem", active: "ju367ven" }, defaultClass: "ju367vel" }, profileDetailsAction: { conditions: { base: "ju367veo", hover: "ju367vep", active: "ju367veq" }, defaultClass: "ju367veo" }, selectedOption: { conditions: { base: "ju367ver", hover: "ju367ves", active: "ju367vet" }, defaultClass: "ju367ver" }, selectedWallet: { conditions: { base: "ju367veu", hover: "ju367vev", active: "ju367vew" }, defaultClass: "ju367veu" }, walletLogo: { conditions: { base: "ju367vex", hover: "ju367vey", active: "ju367vez" }, defaultClass: "ju367vex" } } }, color: { values: { accentColor: { conditions: { base: "ju367vf0", hover: "ju367vf1", active: "ju367vf2" }, defaultClass: "ju367vf0" }, accentColorForeground: { conditions: { base: "ju367vf3", hover: "ju367vf4", active: "ju367vf5" }, defaultClass: "ju367vf3" }, actionButtonBorder: { conditions: { base: "ju367vf6", hover: "ju367vf7", active: "ju367vf8" }, defaultClass: "ju367vf6" }, actionButtonBorderMobile: { conditions: { base: "ju367vf9", hover: "ju367vfa", active: "ju367vfb" }, defaultClass: "ju367vf9" }, actionButtonSecondaryBackground: { conditions: { base: "ju367vfc", hover: "ju367vfd", active: "ju367vfe" }, defaultClass: "ju367vfc" }, closeButton: { conditions: { base: "ju367vff", hover: "ju367vfg", active: "ju367vfh" }, defaultClass: "ju367vff" }, closeButtonBackground: { conditions: { base: "ju367vfi", hover: "ju367vfj", active: "ju367vfk" }, defaultClass: "ju367vfi" }, connectButtonBackground: { conditions: { base: "ju367vfl", hover: "ju367vfm", active: "ju367vfn" }, defaultClass: "ju367vfl" }, connectButtonBackgroundError: { conditions: { base: "ju367vfo", hover: "ju367vfp", active: "ju367vfq" }, defaultClass: "ju367vfo" }, connectButtonInnerBackground: { conditions: { base: "ju367vfr", hover: "ju367vfs", active: "ju367vft" }, defaultClass: "ju367vfr" }, connectButtonText: { conditions: { base: "ju367vfu", hover: "ju367vfv", active: "ju367vfw" }, defaultClass: "ju367vfu" }, connectButtonTextError: { conditions: { base: "ju367vfx", hover: "ju367vfy", active: "ju367vfz" }, defaultClass: "ju367vfx" }, connectionIndicator: { conditions: { base: "ju367vg0", hover: "ju367vg1", active: "ju367vg2" }, defaultClass: "ju367vg0" }, downloadBottomCardBackground: { conditions: { base: "ju367vg3", hover: "ju367vg4", active: "ju367vg5" }, defaultClass: "ju367vg3" }, downloadTopCardBackground: { conditions: { base: "ju367vg6", hover: "ju367vg7", active: "ju367vg8" }, defaultClass: "ju367vg6" }, error: { conditions: { base: "ju367vg9", hover: "ju367vga", active: "ju367vgb" }, defaultClass: "ju367vg9" }, generalBorder: { conditions: { base: "ju367vgc", hover: "ju367vgd", active: "ju367vge" }, defaultClass: "ju367vgc" }, generalBorderDim: { conditions: { base: "ju367vgf", hover: "ju367vgg", active: "ju367vgh" }, defaultClass: "ju367vgf" }, menuItemBackground: { conditions: { base: "ju367vgi", hover: "ju367vgj", active: "ju367vgk" }, defaultClass: "ju367vgi" }, modalBackdrop: { conditions: { base: "ju367vgl", hover: "ju367vgm", active: "ju367vgn" }, defaultClass: "ju367vgl" }, modalBackground: { conditions: { base: "ju367vgo", hover: "ju367vgp", active: "ju367vgq" }, defaultClass: "ju367vgo" }, modalBorder: { conditions: { base: "ju367vgr", hover: "ju367vgs", active: "ju367vgt" }, defaultClass: "ju367vgr" }, modalText: { conditions: { base: "ju367vgu", hover: "ju367vgv", active: "ju367vgw" }, defaultClass: "ju367vgu" }, modalTextDim: { conditions: { base: "ju367vgx", hover: "ju367vgy", active: "ju367vgz" }, defaultClass: "ju367vgx" }, modalTextSecondary: { conditions: { base: "ju367vh0", hover: "ju367vh1", active: "ju367vh2" }, defaultClass: "ju367vh0" }, profileAction: { conditions: { base: "ju367vh3", hover: "ju367vh4", active: "ju367vh5" }, defaultClass: "ju367vh3" }, profileActionHover: { conditions: { base: "ju367vh6", hover: "ju367vh7", active: "ju367vh8" }, defaultClass: "ju367vh6" }, profileForeground: { conditions: { base: "ju367vh9", hover: "ju367vha", active: "ju367vhb" }, defaultClass: "ju367vh9" }, selectedOptionBorder: { conditions: { base: "ju367vhc", hover: "ju367vhd", active: "ju367vhe" }, defaultClass: "ju367vhc" }, standby: { conditions: { base: "ju367vhf", hover: "ju367vhg", active: "ju367vhh" }, defaultClass: "ju367vhf" } } } } }, { conditions: { defaultCondition: "smallScreen", conditionNames: ["smallScreen", "largeScreen"], responsiveArray: void 0 }, styles: { alignItems: { values: { "flex-start": { conditions: { smallScreen: "ju367v0", largeScreen: "ju367v1" }, defaultClass: "ju367v0" }, "flex-end": { conditions: { smallScreen: "ju367v2", largeScreen: "ju367v3" }, defaultClass: "ju367v2" }, center: { conditions: { smallScreen: "ju367v4", largeScreen: "ju367v5" }, defaultClass: "ju367v4" } } }, display: { values: { none: { conditions: { smallScreen: "ju367v6", largeScreen: "ju367v7" }, defaultClass: "ju367v6" }, block: { conditions: { smallScreen: "ju367v8", largeScreen: "ju367v9" }, defaultClass: "ju367v8" }, flex: { conditions: { smallScreen: "ju367va", largeScreen: "ju367vb" }, defaultClass: "ju367va" }, inline: { conditions: { smallScreen: "ju367vc", largeScreen: "ju367vd" }, defaultClass: "ju367vc" } } } } }, { conditions: void 0, styles: { margin: { mappings: ["marginTop", "marginBottom", "marginLeft", "marginRight"] }, marginX: { mappings: ["marginLeft", "marginRight"] }, marginY: { mappings: ["marginTop", "marginBottom"] }, padding: { mappings: ["paddingTop", "paddingBottom", "paddingLeft", "paddingRight"] }, paddingX: { mappings: ["paddingLeft", "paddingRight"] }, paddingY: { mappings: ["paddingTop", "paddingBottom"] }, alignSelf: { values: { "flex-start": { defaultClass: "ju367ve" }, "flex-end": { defaultClass: "ju367vf" }, center: { defaultClass: "ju367vg" } } }, backgroundSize: { values: { cover: { defaultClass: "ju367vh" } } }, borderRadius: { values: { 1: { defaultClass: "ju367vi" }, 6: { defaultClass: "ju367vj" }, 10: { defaultClass: "ju367vk" }, 13: { defaultClass: "ju367vl" }, actionButton: { defaultClass: "ju367vm" }, connectButton: { defaultClass: "ju367vn" }, menuButton: { defaultClass: "ju367vo" }, modal: { defaultClass: "ju367vp" }, modalMobile: { defaultClass: "ju367vq" }, "25%": { defaultClass: "ju367vr" }, full: { defaultClass: "ju367vs" } } }, borderStyle: { values: { solid: { defaultClass: "ju367vt" } } }, borderWidth: { values: { 0: { defaultClass: "ju367vu" }, 1: { defaultClass: "ju367vv" }, 2: { defaultClass: "ju367vw" }, 4: { defaultClass: "ju367vx" } } }, cursor: { values: { pointer: { defaultClass: "ju367vy" }, none: { defaultClass: "ju367vz" } } }, pointerEvents: { values: { none: { defaultClass: "ju367v10" }, all: { defaultClass: "ju367v11" } } }, minHeight: { values: { 8: { defaultClass: "ju367v12" }, 44: { defaultClass: "ju367v13" } } }, flexDirection: { values: { row: { defaultClass: "ju367v14" }, column: { defaultClass: "ju367v15" } } }, fontFamily: { values: { body: { defaultClass: "ju367v16" } } }, fontSize: { values: { 12: { defaultClass: "ju367v17" }, 13: { defaultClass: "ju367v18" }, 14: { defaultClass: "ju367v19" }, 16: { defaultClass: "ju367v1a" }, 18: { defaultClass: "ju367v1b" }, 20: { defaultClass: "ju367v1c" }, 23: { defaultClass: "ju367v1d" } } }, fontWeight: { values: { regular: { defaultClass: "ju367v1e" }, medium: { defaultClass: "ju367v1f" }, semibold: { defaultClass: "ju367v1g" }, bold: { defaultClass: "ju367v1h" }, heavy: { defaultClass: "ju367v1i" } } }, gap: { values: { 0: { defaultClass: "ju367v1j" }, 1: { defaultClass: "ju367v1k" }, 2: { defaultClass: "ju367v1l" }, 3: { defaultClass: "ju367v1m" }, 4: { defaultClass: "ju367v1n" }, 5: { defaultClass: "ju367v1o" }, 6: { defaultClass: "ju367v1p" }, 8: { defaultClass: "ju367v1q" }, 10: { defaultClass: "ju367v1r" }, 12: { defaultClass: "ju367v1s" }, 14: { defaultClass: "ju367v1t" }, 16: { defaultClass: "ju367v1u" }, 18: { defaultClass: "ju367v1v" }, 20: { defaultClass: "ju367v1w" }, 24: { defaultClass: "ju367v1x" }, 28: { defaultClass: "ju367v1y" }, 32: { defaultClass: "ju367v1z" }, 36: { defaultClass: "ju367v20" }, 44: { defaultClass: "ju367v21" }, 64: { defaultClass: "ju367v22" }, "-1": { defaultClass: "ju367v23" } } }, height: { values: { 1: { defaultClass: "ju367v24" }, 2: { defaultClass: "ju367v25" }, 4: { defaultClass: "ju367v26" }, 8: { defaultClass: "ju367v27" }, 12: { defaultClass: "ju367v28" }, 20: { defaultClass: "ju367v29" }, 24: { defaultClass: "ju367v2a" }, 28: { defaultClass: "ju367v2b" }, 30: { defaultClass: "ju367v2c" }, 32: { defaultClass: "ju367v2d" }, 34: { defaultClass: "ju367v2e" }, 36: { defaultClass: "ju367v2f" }, 40: { defaultClass: "ju367v2g" }, 44: { defaultClass: "ju367v2h" }, 48: { defaultClass: "ju367v2i" }, 54: { defaultClass: "ju367v2j" }, 60: { defaultClass: "ju367v2k" }, 200: { defaultClass: "ju367v2l" }, full: { defaultClass: "ju367v2m" }, max: { defaultClass: "ju367v2n" } } }, justifyContent: { values: { "flex-start": { defaultClass: "ju367v2o" }, "flex-end": { defaultClass: "ju367v2p" }, center: { defaultClass: "ju367v2q" }, "space-between": { defaultClass: "ju367v2r" }, "space-around": { defaultClass: "ju367v2s" } } }, textAlign: { values: { left: { defaultClass: "ju367v2t" }, center: { defaultClass: "ju367v2u" }, inherit: { defaultClass: "ju367v2v" } } }, marginBottom: { values: { 0: { defaultClass: "ju367v2w" }, 1: { defaultClass: "ju367v2x" }, 2: { defaultClass: "ju367v2y" }, 3: { defaultClass: "ju367v2z" }, 4: { defaultClass: "ju367v30" }, 5: { defaultClass: "ju367v31" }, 6: { defaultClass: "ju367v32" }, 8: { defaultClass: "ju367v33" }, 10: { defaultClass: "ju367v34" }, 12: { defaultClass: "ju367v35" }, 14: { defaultClass: "ju367v36" }, 16: { defaultClass: "ju367v37" }, 18: { defaultClass: "ju367v38" }, 20: { defaultClass: "ju367v39" }, 24: { defaultClass: "ju367v3a" }, 28: { defaultClass: "ju367v3b" }, 32: { defaultClass: "ju367v3c" }, 36: { defaultClass: "ju367v3d" }, 44: { defaultClass: "ju367v3e" }, 64: { defaultClass: "ju367v3f" }, "-1": { defaultClass: "ju367v3g" } } }, marginLeft: { values: { 0: { defaultClass: "ju367v3h" }, 1: { defaultClass: "ju367v3i" }, 2: { defaultClass: "ju367v3j" }, 3: { defaultClass: "ju367v3k" }, 4: { defaultClass: "ju367v3l" }, 5: { defaultClass: "ju367v3m" }, 6: { defaultClass: "ju367v3n" }, 8: { defaultClass: "ju367v3o" }, 10: { defaultClass: "ju367v3p" }, 12: { defaultClass: "ju367v3q" }, 14: { defaultClass: "ju367v3r" }, 16: { defaultClass: "ju367v3s" }, 18: { defaultClass: "ju367v3t" }, 20: { defaultClass: "ju367v3u" }, 24: { defaultClass: "ju367v3v" }, 28: { defaultClass: "ju367v3w" }, 32: { defaultClass: "ju367v3x" }, 36: { defaultClass: "ju367v3y" }, 44: { defaultClass: "ju367v3z" }, 64: { defaultClass: "ju367v40" }, "-1": { defaultClass: "ju367v41" } } }, marginRight: { values: { 0: { defaultClass: "ju367v42" }, 1: { defaultClass: "ju367v43" }, 2: { defaultClass: "ju367v44" }, 3: { defaultClass: "ju367v45" }, 4: { defaultClass: "ju367v46" }, 5: { defaultClass: "ju367v47" }, 6: { defaultClass: "ju367v48" }, 8: { defaultClass: "ju367v49" }, 10: { defaultClass: "ju367v4a" }, 12: { defaultClass: "ju367v4b" }, 14: { defaultClass: "ju367v4c" }, 16: { defaultClass: "ju367v4d" }, 18: { defaultClass: "ju367v4e" }, 20: { defaultClass: "ju367v4f" }, 24: { defaultClass: "ju367v4g" }, 28: { defaultClass: "ju367v4h" }, 32: { defaultClass: "ju367v4i" }, 36: { defaultClass: "ju367v4j" }, 44: { defaultClass: "ju367v4k" }, 64: { defaultClass: "ju367v4l" }, "-1": { defaultClass: "ju367v4m" } } }, marginTop: { values: { 0: { defaultClass: "ju367v4n" }, 1: { defaultClass: "ju367v4o" }, 2: { defaultClass: "ju367v4p" }, 3: { defaultClass: "ju367v4q" }, 4: { defaultClass: "ju367v4r" }, 5: { defaultClass: "ju367v4s" }, 6: { defaultClass: "ju367v4t" }, 8: { defaultClass: "ju367v4u" }, 10: { defaultClass: "ju367v4v" }, 12: { defaultClass: "ju367v4w" }, 14: { defaultClass: "ju367v4x" }, 16: { defaultClass: "ju367v4y" }, 18: { defaultClass: "ju367v4z" }, 20: { defaultClass: "ju367v50" }, 24: { defaultClass: "ju367v51" }, 28: { defaultClass: "ju367v52" }, 32: { defaultClass: "ju367v53" }, 36: { defaultClass: "ju367v54" }, 44: { defaultClass: "ju367v55" }, 64: { defaultClass: "ju367v56" }, "-1": { defaultClass: "ju367v57" } } }, maxWidth: { values: { 1: { defaultClass: "ju367v58" }, 2: { defaultClass: "ju367v59" }, 4: { defaultClass: "ju367v5a" }, 8: { defaultClass: "ju367v5b" }, 12: { defaultClass: "ju367v5c" }, 20: { defaultClass: "ju367v5d" }, 24: { defaultClass: "ju367v5e" }, 28: { defaultClass: "ju367v5f" }, 30: { defaultClass: "ju367v5g" }, 32: { defaultClass: "ju367v5h" }, 34: { defaultClass: "ju367v5i" }, 36: { defaultClass: "ju367v5j" }, 40: { defaultClass: "ju367v5k" }, 44: { defaultClass: "ju367v5l" }, 48: { defaultClass: "ju367v5m" }, 54: { defaultClass: "ju367v5n" }, 60: { defaultClass: "ju367v5o" }, 200: { defaultClass: "ju367v5p" }, full: { defaultClass: "ju367v5q" }, max: { defaultClass: "ju367v5r" } } }, minWidth: { values: { 1: { defaultClass: "ju367v5s" }, 2: { defaultClass: "ju367v5t" }, 4: { defaultClass: "ju367v5u" }, 8: { defaultClass: "ju367v5v" }, 12: { defaultClass: "ju367v5w" }, 20: { defaultClass: "ju367v5x" }, 24: { defaultClass: "ju367v5y" }, 28: { defaultClass: "ju367v5z" }, 30: { defaultClass: "ju367v60" }, 32: { defaultClass: "ju367v61" }, 34: { defaultClass: "ju367v62" }, 36: { defaultClass: "ju367v63" }, 40: { defaultClass: "ju367v64" }, 44: { defaultClass: "ju367v65" }, 48: { defaultClass: "ju367v66" }, 54: { defaultClass: "ju367v67" }, 60: { defaultClass: "ju367v68" }, 200: { defaultClass: "ju367v69" }, full: { defaultClass: "ju367v6a" }, max: { defaultClass: "ju367v6b" } } }, overflow: { values: { hidden: { defaultClass: "ju367v6c" } } }, paddingBottom: { values: { 0: { defaultClass: "ju367v6d" }, 1: { defaultClass: "ju367v6e" }, 2: { defaultClass: "ju367v6f" }, 3: { defaultClass: "ju367v6g" }, 4: { defaultClass: "ju367v6h" }, 5: { defaultClass: "ju367v6i" }, 6: { defaultClass: "ju367v6j" }, 8: { defaultClass: "ju367v6k" }, 10: { defaultClass: "ju367v6l" }, 12: { defaultClass: "ju367v6m" }, 14: { defaultClass: "ju367v6n" }, 16: { defaultClass: "ju367v6o" }, 18: { defaultClass: "ju367v6p" }, 20: { defaultClass: "ju367v6q" }, 24: { defaultClass: "ju367v6r" }, 28: { defaultClass: "ju367v6s" }, 32: { defaultClass: "ju367v6t" }, 36: { defaultClass: "ju367v6u" }, 44: { defaultClass: "ju367v6v" }, 64: { defaultClass: "ju367v6w" }, "-1": { defaultClass: "ju367v6x" } } }, paddingLeft: { values: { 0: { defaultClass: "ju367v6y" }, 1: { defaultClass: "ju367v6z" }, 2: { defaultClass: "ju367v70" }, 3: { defaultClass: "ju367v71" }, 4: { defaultClass: "ju367v72" }, 5: { defaultClass: "ju367v73" }, 6: { defaultClass: "ju367v74" }, 8: { defaultClass: "ju367v75" }, 10: { defaultClass: "ju367v76" }, 12: { defaultClass: "ju367v77" }, 14: { defaultClass: "ju367v78" }, 16: { defaultClass: "ju367v79" }, 18: { defaultClass: "ju367v7a" }, 20: { defaultClass: "ju367v7b" }, 24: { defaultClass: "ju367v7c" }, 28: { defaultClass: "ju367v7d" }, 32: { defaultClass: "ju367v7e" }, 36: { defaultClass: "ju367v7f" }, 44: { defaultClass: "ju367v7g" }, 64: { defaultClass: "ju367v7h" }, "-1": { defaultClass: "ju367v7i" } } }, paddingRight: { values: { 0: { defaultClass: "ju367v7j" }, 1: { defaultClass: "ju367v7k" }, 2: { defaultClass: "ju367v7l" }, 3: { defaultClass: "ju367v7m" }, 4: { defaultClass: "ju367v7n" }, 5: { defaultClass: "ju367v7o" }, 6: { defaultClass: "ju367v7p" }, 8: { defaultClass: "ju367v7q" }, 10: { defaultClass: "ju367v7r" }, 12: { defaultClass: "ju367v7s" }, 14: { defaultClass: "ju367v7t" }, 16: { defaultClass: "ju367v7u" }, 18: { defaultClass: "ju367v7v" }, 20: { defaultClass: "ju367v7w" }, 24: { defaultClass: "ju367v7x" }, 28: { defaultClass: "ju367v7y" }, 32: { defaultClass: "ju367v7z" }, 36: { defaultClass: "ju367v80" }, 44: { defaultClass: "ju367v81" }, 64: { defaultClass: "ju367v82" }, "-1": { defaultClass: "ju367v83" } } }, paddingTop: { values: { 0: { defaultClass: "ju367v84" }, 1: { defaultClass: "ju367v85" }, 2: { defaultClass: "ju367v86" }, 3: { defaultClass: "ju367v87" }, 4: { defaultClass: "ju367v88" }, 5: { defaultClass: "ju367v89" }, 6: { defaultClass: "ju367v8a" }, 8: { defaultClass: "ju367v8b" }, 10: { defaultClass: "ju367v8c" }, 12: { defaultClass: "ju367v8d" }, 14: { defaultClass: "ju367v8e" }, 16: { defaultClass: "ju367v8f" }, 18: { defaultClass: "ju367v8g" }, 20: { defaultClass: "ju367v8h" }, 24: { defaultClass: "ju367v8i" }, 28: { defaultClass: "ju367v8j" }, 32: { defaultClass: "ju367v8k" }, 36: { defaultClass: "ju367v8l" }, 44: { defaultClass: "ju367v8m" }, 64: { defaultClass: "ju367v8n" }, "-1": { defaultClass: "ju367v8o" } } }, position: { values: { absolute: { defaultClass: "ju367v8p" }, fixed: { defaultClass: "ju367v8q" }, relative: { defaultClass: "ju367v8r" } } }, WebkitUserSelect: { values: { none: { defaultClass: "ju367v8s" } } }, right: { values: { 0: { defaultClass: "ju367v8t" } } }, transition: { values: { default: { defaultClass: "ju367v8u" }, transform: { defaultClass: "ju367v8v" } } }, userSelect: { values: { none: { defaultClass: "ju367v8w" } } }, width: { values: { 1: { defaultClass: "ju367v8x" }, 2: { defaultClass: "ju367v8y" }, 4: { defaultClass: "ju367v8z" }, 8: { defaultClass: "ju367v90" }, 12: { defaultClass: "ju367v91" }, 20: { defaultClass: "ju367v92" }, 24: { defaultClass: "ju367v93" }, 28: { defaultClass: "ju367v94" }, 30: { defaultClass: "ju367v95" }, 32: { defaultClass: "ju367v96" }, 34: { defaultClass: "ju367v97" }, 36: { defaultClass: "ju367v98" }, 40: { defaultClass: "ju367v99" }, 44: { defaultClass: "ju367v9a" }, 48: { defaultClass: "ju367v9b" }, 54: { defaultClass: "ju367v9c" }, 60: { defaultClass: "ju367v9d" }, 200: { defaultClass: "ju367v9e" }, full: { defaultClass: "ju367v9f" }, max: { defaultClass: "ju367v9g" } } }, backdropFilter: { values: { modalOverlay: { defaultClass: "ju367v9h" } } } } }), JI = { colors: { accentColor: "var(--rk-colors-accentColor)", accentColorForeground: "var(--rk-colors-accentColorForeground)", actionButtonBorder: "var(--rk-colors-actionButtonBorder)", actionButtonBorderMobile: "var(--rk-colors-actionButtonBorderMobile)", actionButtonSecondaryBackground: "var(--rk-colors-actionButtonSecondaryBackground)", closeButton: "var(--rk-colors-closeButton)", closeButtonBackground: "var(--rk-colors-closeButtonBackground)", connectButtonBackground: "var(--rk-colors-connectButtonBackground)", connectButtonBackgroundError: "var(--rk-colors-connectButtonBackgroundError)", connectButtonInnerBackground: "var(--rk-colors-connectButtonInnerBackground)", connectButtonText: "var(--rk-colors-connectButtonText)", connectButtonTextError: "var(--rk-colors-connectButtonTextError)", connectionIndicator: "var(--rk-colors-connectionIndicator)", downloadBottomCardBackground: "var(--rk-colors-downloadBottomCardBackground)", downloadTopCardBackground: "var(--rk-colors-downloadTopCardBackground)", error: "var(--rk-colors-error)", generalBorder: "var(--rk-colors-generalBorder)", generalBorderDim: "var(--rk-colors-generalBorderDim)", menuItemBackground: "var(--rk-colors-menuItemBackground)", modalBackdrop: "var(--rk-colors-modalBackdrop)", modalBackground: "var(--rk-colors-modalBackground)", modalBorder: "var(--rk-colors-modalBorder)", modalText: "var(--rk-colors-modalText)", modalTextDim: "var(--rk-colors-modalTextDim)", modalTextSecondary: "var(--rk-colors-modalTextSecondary)", profileAction: "var(--rk-colors-profileAction)", profileActionHover: "var(--rk-colors-profileActionHover)", profileForeground: "var(--rk-colors-profileForeground)", selectedOptionBorder: "var(--rk-colors-selectedOptionBorder)", standby: "var(--rk-colors-standby)" }, fonts: { body: "var(--rk-fonts-body)" }, radii: { actionButton: "var(--rk-radii-actionButton)", connectButton: "var(--rk-radii-connectButton)", menuButton: "var(--rk-radii-menuButton)", modal: "var(--rk-radii-modal)", modalMobile: "var(--rk-radii-modalMobile)" }, shadows: { connectButton: "var(--rk-shadows-connectButton)", dialog: "var(--rk-shadows-dialog)", profileDetailsAction: "var(--rk-shadows-profileDetailsAction)", selectedOption: "var(--rk-shadows-selectedOption)", selectedWallet: "var(--rk-shadows-selectedWallet)", walletLogo: "var(--rk-shadows-walletLogo)" }, blurs: { modalOverlay: "var(--rk-blurs-modalOverlay)" } }, doe = { shrink: "_12cbo8i6", shrinkSm: "_12cbo8i7" }, foe = "_12cbo8i3 ju367v8r", hoe = { grow: "_12cbo8i4", growLg: "_12cbo8i5" };
function kr({ active: e, hover: t }) {
  return [foe, t && hoe[t], doe[e]];
}
var _U = dn(null);
function poe() {
  var e;
  const { adapter: t } = (e = $e(_U)) != null ? e : {};
  if (!t)
    throw new Error("No authentication adapter found");
  return t;
}
function $A() {
  var e;
  const t = $e(_U);
  return (e = t == null ? void 0 : t.status) != null ? e : null;
}
function SU() {
  const e = $A(), { isConnected: t } = mi();
  return t ? e && (e === "loading" || e === "unauthenticated") ? e : "connected" : "disconnected";
}
function moe() {
  return typeof navigator < "u" && /android/i.test(navigator.userAgent);
}
function goe() {
  return typeof navigator < "u" && /iPhone|iPod/.test(navigator.userAgent);
}
function yoe() {
  return typeof navigator < "u" && (/iPad/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}
function QA() {
  return goe() || yoe();
}
function Br() {
  return moe() || QA();
}
var boe = "iekbcc0", voe = { a: "iekbcca", blockquote: "iekbcc2", button: "iekbcc9", input: "iekbcc8 iekbcc5 iekbcc4", mark: "iekbcc6", ol: "iekbcc1", q: "iekbcc2", select: "iekbcc7 iekbcc5 iekbcc4", table: "iekbcc3", textarea: "iekbcc5 iekbcc4", ul: "iekbcc1" }, woe = ({ reset: e, ...t }) => {
  if (!e)
    return qS(t);
  const n = voe[e], r = qS(t);
  return SD(boe, n, r);
}, Z = ye.forwardRef(({ as: e = "div", className: t, testId: n, ...r }, i) => {
  const s = {}, o = {};
  for (const c in r)
    qS.properties.has(c) ? s[c] = r[c] : o[c] = r[c];
  const a = woe({
    reset: typeof e == "string" ? e : "div",
    ...s
  });
  return ye.createElement(e, {
    className: SD(a, t),
    ...o,
    "data-testid": n ? `rk-${n.replace(/^rk-/, "")}` : void 0,
    ref: i
  });
});
Z.displayName = "Box";
var CU = /* @__PURE__ */ new Map(), Q3 = /* @__PURE__ */ new Map();
async function TU(e) {
  const t = Q3.get(e);
  if (t)
    return t;
  const n = async () => e().then(async (i) => (CU.set(e, i), i)), r = n().catch((i) => n().catch((s) => {
    Q3.delete(e);
  }));
  return Q3.set(e, r), r;
}
async function ba(...e) {
  return await Promise.all(e.map((t) => typeof t == "function" ? TU(t) : t));
}
function xoe() {
  const [, e] = Ak((t) => t + 1, 0);
  return e;
}
function k5(e) {
  const t = typeof e == "function" ? CU.get(e) : void 0, n = xoe();
  return We(() => {
    typeof e == "function" && !t && TU(e).then(n);
  }, [e, t, n]), typeof e == "function" ? t : e;
}
function gr({
  alt: e,
  background: t,
  borderColor: n,
  borderRadius: r,
  useAsImage: i,
  boxShadow: s,
  height: o,
  src: a,
  width: c,
  testId: l
}) {
  const u = QA(), d = k5(a), f = d && /^http/.test(d), [p, m] = Ak(() => !0, !1);
  return /* @__PURE__ */ k.createElement(Z, {
    "aria-label": e,
    borderRadius: r,
    boxShadow: s,
    height: typeof o == "string" ? o : void 0,
    overflow: "hidden",
    position: "relative",
    role: "img",
    style: {
      background: t,
      height: typeof o == "number" ? o : void 0,
      width: typeof c == "number" ? c : void 0
    },
    width: typeof c == "string" ? c : void 0,
    testId: l
  }, /* @__PURE__ */ k.createElement(Z, {
    ...i ? { "aria-hidden": !0, as: "img", src: d } : f ? {
      "aria-hidden": !0,
      as: "img",
      onLoad: m,
      src: d
    } : {
      backgroundSize: "cover"
    },
    height: "full",
    position: "absolute",
    ...u ? { WebkitUserSelect: "none" } : {},
    style: {
      WebkitTouchCallout: "none",
      transition: "opacity .15s linear",
      userSelect: "none",
      ...i ? {} : f ? {
        opacity: p ? 1 : 0
      } : {
        backgroundImage: d ? `url(${d})` : void 0,
        backgroundRepeat: "no-repeat",
        opacity: d ? 1 : 0
      }
    },
    width: "full"
  }), n ? /* @__PURE__ */ k.createElement(Z, {
    ...typeof n == "object" && "custom" in n ? { style: { borderColor: n.custom } } : { borderColor: n },
    borderRadius: r,
    borderStyle: "solid",
    borderWidth: "1",
    height: "full",
    position: "relative",
    width: "full"
  }) : null);
}
var Aoe = "_1luule42", Eoe = "_1luule43", _oe = (e) => ot(() => `${e}_${Math.round(Math.random() * 1e9)}`, [e]), fy = ({
  height: e = 21,
  width: t = 21
}) => {
  const n = _oe("spinner");
  return /* @__PURE__ */ k.createElement("svg", {
    className: Aoe,
    fill: "none",
    height: e,
    viewBox: "0 0 21 21",
    width: t,
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ k.createElement("title", null, "Loading"), /* @__PURE__ */ k.createElement("clipPath", {
    id: n
  }, /* @__PURE__ */ k.createElement("path", {
    d: "M10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C11.3284 18 12 18.6716 12 19.5C12 20.3284 11.3284 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5C21 11.3284 20.3284 12 19.5 12C18.6716 12 18 11.3284 18 10.5C18 6.35786 14.6421 3 10.5 3Z"
  })), /* @__PURE__ */ k.createElement("foreignObject", {
    clipPath: `url(#${n})`,
    height: "21",
    width: "21",
    x: "0",
    y: "0"
  }, /* @__PURE__ */ k.createElement("div", {
    className: Eoe
  })));
}, Rt = [
  "#FC5C54",
  "#FFD95A",
  "#E95D72",
  "#6A87C8",
  "#5FD0F3",
  "#75C06B",
  "#FFDD86",
  "#5FC6D4",
  "#FF949A",
  "#FF8024",
  "#9BA1A4",
  "#EC66FF",
  "#FF8CBC",
  "#FF9A23",
  "#C5DADB",
  "#A8CE63",
  "#71ABFF",
  "#FFE279",
  "#B6B1B6",
  "#FF6780",
  "#A575FF",
  "#4D82FF",
  "#FFB35A"
], XI = [
  { color: Rt[0], emoji: "🌶" },
  { color: Rt[1], emoji: "🤑" },
  { color: Rt[2], emoji: "🐙" },
  { color: Rt[3], emoji: "🫐" },
  { color: Rt[4], emoji: "🐳" },
  { color: Rt[0], emoji: "🤶" },
  { color: Rt[5], emoji: "🌲" },
  { color: Rt[6], emoji: "🌞" },
  { color: Rt[7], emoji: "🐒" },
  { color: Rt[8], emoji: "🐵" },
  { color: Rt[9], emoji: "🦊" },
  { color: Rt[10], emoji: "🐼" },
  { color: Rt[11], emoji: "🦄" },
  { color: Rt[12], emoji: "🐷" },
  { color: Rt[13], emoji: "🐧" },
  { color: Rt[8], emoji: "🦩" },
  { color: Rt[14], emoji: "👽" },
  { color: Rt[0], emoji: "🎈" },
  { color: Rt[8], emoji: "🍉" },
  { color: Rt[1], emoji: "🎉" },
  { color: Rt[15], emoji: "🐲" },
  { color: Rt[16], emoji: "🌎" },
  { color: Rt[17], emoji: "🍊" },
  { color: Rt[18], emoji: "🐭" },
  { color: Rt[19], emoji: "🍣" },
  { color: Rt[1], emoji: "🐥" },
  { color: Rt[20], emoji: "👾" },
  { color: Rt[15], emoji: "🥦" },
  { color: Rt[0], emoji: "👹" },
  { color: Rt[17], emoji: "🙀" },
  { color: Rt[4], emoji: "⛱" },
  { color: Rt[21], emoji: "⛵️" },
  { color: Rt[17], emoji: "🥳" },
  { color: Rt[8], emoji: "🤯" },
  { color: Rt[22], emoji: "🤠" }
];
function Soe(e) {
  let t = 0;
  if (e.length === 0)
    return t;
  for (let n = 0; n < e.length; n++) {
    const r = e.charCodeAt(n);
    t = (t << 5) - t + r, t |= 0;
  }
  return t;
}
function Coe(e) {
  const n = Math.abs(Soe((typeof e == "string" ? e : "").toLowerCase()) % XI.length);
  return XI[n ?? 0];
}
var Toe = ({ address: e, ensImage: t, size: n }) => {
  const [r, i] = qe(!1);
  We(() => {
    if (t) {
      const a = new Image();
      a.src = t, a.onload = () => i(!0);
    }
  }, [t]);
  const { color: s, emoji: o } = ot(() => Coe(e), [e]);
  return t ? r ? /* @__PURE__ */ k.createElement(Z, {
    backgroundSize: "cover",
    borderRadius: "full",
    position: "absolute",
    style: {
      backgroundImage: `url(${t})`,
      backgroundPosition: "center",
      height: n,
      width: n
    }
  }) : /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    backgroundSize: "cover",
    borderRadius: "full",
    color: "modalText",
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    style: {
      height: n,
      width: n
    }
  }, /* @__PURE__ */ k.createElement(fy, null)) : /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    style: {
      ...!t && { backgroundColor: s },
      height: n,
      width: n
    }
  }, o);
}, kU = Toe, BU = dn(kU);
function koe({ address: e, imageUrl: t, loading: n, size: r }) {
  const i = $e(BU);
  return /* @__PURE__ */ k.createElement(Z, {
    "aria-hidden": !0,
    borderRadius: "full",
    overflow: "hidden",
    position: "relative",
    style: {
      height: `${r}px`,
      width: `${r}px`
    },
    userSelect: "none"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    borderRadius: "full",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    position: "absolute",
    style: {
      fontSize: `${Math.round(r * 0.55)}px`,
      height: `${r}px`,
      transform: n ? "scale(0.72)" : void 0,
      transition: ".25s ease",
      transitionDelay: n ? void 0 : ".1s",
      width: `${r}px`,
      willChange: "transform"
    },
    userSelect: "none"
  }, /* @__PURE__ */ k.createElement(i, {
    address: e,
    ensImage: t,
    size: r
  })), n && /* @__PURE__ */ k.createElement(Z, {
    color: "accentColor",
    display: "flex",
    height: "full",
    position: "absolute",
    width: "full"
  }, /* @__PURE__ */ k.createElement(fy, {
    height: "100%",
    width: "100%"
  })));
}
var eP = {
  defaultLocale: "en",
  locale: "en"
}, Boe = class {
  constructor(e) {
    this.listeners = /* @__PURE__ */ new Set(), this.defaultLocale = eP.defaultLocale, this.enableFallback = !1, this.locale = eP.locale, this.cachedLocales = [], this.translations = {};
    for (const [t, n] of Object.entries(e))
      this.cachedLocales = [...this.cachedLocales, t], this.translations = {
        ...this.translations,
        ...this.flattenTranslation(n, t)
      };
  }
  missingMessage(e) {
    return `[missing: "${this.locale}.${e}" translation]`;
  }
  flattenTranslation(e, t) {
    const n = {}, r = (i, s) => {
      for (const o of Object.keys(i)) {
        const a = `${s}.${o}`, c = i[o];
        typeof c == "object" && c !== null ? r(c, a) : n[a] = c;
      }
    };
    return r(e, t), n;
  }
  translateWithReplacements(e, t = {}) {
    let n = e;
    for (const r in t) {
      const i = t[r];
      n = n.replace(`%{${r}}`, i);
    }
    return n;
  }
  t(e, t, n) {
    const r = `${this.locale}.${e}`, i = this.translations[r];
    if (!i) {
      if (this.enableFallback) {
        const s = `${this.defaultLocale}.${e}`, o = this.translations[s];
        if (o)
          return this.translateWithReplacements(o, t);
      }
      return n != null && n.rawKeyIfTranslationMissing ? e : this.missingMessage(e);
    }
    return this.translateWithReplacements(i, t);
  }
  isLocaleCached(e) {
    return this.cachedLocales.includes(e);
  }
  updateLocale(e) {
    this.locale = e, this.notifyListeners();
  }
  setTranslations(e, t) {
    this.isLocaleCached(e) || (this.cachedLocales = [...this.cachedLocales, e], this.translations = {
      ...this.translations,
      ...this.flattenTranslation(t, e)
    }), this.locale = e, this.notifyListeners();
  }
  notifyListeners() {
    for (const e of this.listeners)
      e();
  }
  onChange(e) {
    return this.listeners.add(e), () => {
      this.listeners.delete(e);
    };
  }
}, _s = new Boe({
  en: JSON.parse(MI),
  "en-US": JSON.parse(MI)
});
_s.defaultLocale = "en-US";
_s.locale = "en-US";
_s.enableFallback = !0;
var Ioe = async (e) => {
  switch (e) {
    case "ar":
    case "ar-AR":
      return (await import("./ar_AR-2FHIOEAO-Dh5CWeQz.js")).default;
    case "en":
    case "en-US":
      return (await import("./en_US-W2WMBJWR-MArCdcn7.js")).default;
    case "es":
    case "es-419":
      return (await import("./es_419-JU5M7ADI-CqGsLlHC.js")).default;
    case "fr":
    case "fr-FR":
      return (await import("./fr_FR-MEVFY2S3-M2jikfCF.js")).default;
    case "hi":
    case "hi-IN":
      return (await import("./hi_IN-QYRORIUD-CKbMN8w4.js")).default;
    case "id":
    case "id-ID":
      return (await import("./id_ID-TUMMBG4U-DQfKTEYP.js")).default;
    case "ja":
    case "ja-JP":
      return (await import("./ja_JP-ZUYW24MT-Dy0jW1ZZ.js")).default;
    case "ko":
    case "ko-KR":
      return (await import("./ko_KR-EN25J5OB-B3FvnrWy.js")).default;
    case "pt":
    case "pt-BR":
      return (await import("./pt_BR-RZPKMOY4-HQjOTAVE.js")).default;
    case "ru":
    case "ru-RU":
      return (await import("./ru_RU-6H6D24G6-DAulYJFe.js")).default;
    case "th":
    case "th-TH":
      return (await import("./th_TH-V7MI6RLE-BST7Gb9_.js")).default;
    case "tr":
    case "tr-TR":
      return (await import("./tr_TR-5VDGWEXM-CyIaZGpz.js")).default;
    case "ua":
    case "uk-UA":
      return (await import("./uk_UA-LQISH4SK-BC5yFnlR.js")).default;
    case "zh":
    case "zh-CN":
      return (await import("./zh_CN-EHEYLG7G-B9BDBj_g.js")).default;
    default:
      return (await import("./en_US-W2WMBJWR-MArCdcn7.js")).default;
  }
};
async function tP(e) {
  if (_s.isLocaleCached(e)) {
    _s.updateLocale(e);
    return;
  }
  const n = await Ioe(e);
  _s.setTranslations(e, JSON.parse(n));
}
var Poe = () => {
  var e;
  if (typeof window < "u" && typeof navigator < "u") {
    if ((e = navigator.languages) != null && e.length)
      return navigator.languages[0];
    if (navigator.language)
      return navigator.language;
  }
}, ir = dn({ i18n: _s }), Ooe = ({ children: e, locale: t }) => {
  const [n, r] = qe(0), i = ot(() => Poe(), []);
  We(() => _s.onChange(() => {
    r((a) => a + 1);
  }), []), We(() => {
    t && t !== _s.locale ? tP(t) : !t && i && i !== _s.locale && tP(i);
  }, [t, i]);
  const s = ot(() => ({ t: (a, c) => _s.t(a, c), i18n: _s }), [n]);
  return /* @__PURE__ */ k.createElement(ir.Provider, {
    value: s
  }, e);
};
function IU(e) {
  return e != null;
}
var K3 = {
  iconBackground: "#96bedc",
  iconUrl: async () => (await import("./arbitrum-LYDBJZP3-6t-hHPwB.js")).default
}, nP = {
  iconBackground: "#e84141",
  iconUrl: async () => (await import("./avalanche-TFPKP544-BGVtQiwf.js")).default
}, Y3 = {
  iconBackground: "#0052ff",
  iconUrl: async () => (await import("./base-3MIUIYGA-prB5iUMa.js")).default
}, rP = {
  iconBackground: "#000000",
  iconUrl: async () => (await import("./blast-2RNL5ZO7-mEQuke8y.js")).default
}, iP = {
  iconBackground: "#ebac0e",
  iconUrl: async () => (await import("./bsc-S2GSW6VX-DFlGpskW.js")).default
}, sP = {
  iconBackground: "#002D74",
  iconUrl: async () => (await import("./cronos-DQKKIEX7-CJC1ad4C.js")).default
}, jc = {
  iconBackground: "#484c50",
  iconUrl: async () => (await import("./ethereum-4FY57XJF-Bjd0baiC.js")).default
}, Noe = {
  iconBackground: "#f9f7ec",
  iconUrl: async () => (await import("./hardhat-ARRFHFKB-Dh_-Y6jz.js")).default
}, oP = {
  iconBackground: "transparent",
  iconUrl: async () => (await import("./klaytn-FZEHB43Q-DaeWcwMf.js")).default
}, e1 = {
  iconBackground: "#ff5a57",
  iconUrl: async () => (await import("./optimism-UUP5Y7TB-BYeNU2v_.js")).default
}, aP = {
  iconBackground: "#9f71ec",
  iconUrl: async () => (await import("./polygon-Z4QITDL7-DQlrZPxN.js")).default
}, cP = {
  iconBackground: "#f9f7ec",
  iconUrl: async () => (await import("./xdc-5UHQ25DW-DQRbRdsc.js")).default
}, lP = {
  iconBackground: "#000000",
  iconUrl: async () => (await import("./zetachain-OUC33IWQ-B_GNQ2Ul.js")).default
}, uP = {
  iconBackground: "#f9f7ec",
  iconUrl: async () => (await import("./zkSync-XRUC4ZHO-iiJtkVeD.js")).default
}, Z3 = {
  iconBackground: "#000000",
  iconUrl: async () => (await import("./zora-KVO7WIOK-BmqsmBkA.js")).default
}, Roe = {
  iconBackground: "#1273EA",
  iconUrl: async () => (await import("./ronin-3JLI3AUN-DBAvTrzq.js")).default
}, Moe = {
  arbitrum: { chainId: 42161, name: "Arbitrum", ...K3 },
  arbitrumGoerli: { chainId: 421613, ...K3 },
  arbitrumSepolia: { chainId: 421614, ...K3 },
  avalanche: { chainId: 43114, ...nP },
  avalancheFuji: { chainId: 43113, ...nP },
  base: { chainId: 8453, name: "Base", ...Y3 },
  baseGoerli: { chainId: 84531, ...Y3 },
  baseSepolia: { chainId: 84532, ...Y3 },
  blast: { chainId: 81457, name: "Blast", ...rP },
  blastSepolia: { chainId: 168587773, ...rP },
  bsc: { chainId: 56, name: "BSC", ...iP },
  bscTestnet: { chainId: 97, ...iP },
  cronos: { chainId: 25, ...sP },
  cronosTestnet: { chainId: 338, ...sP },
  goerli: { chainId: 5, ...jc },
  hardhat: { chainId: 31337, ...Noe },
  holesky: { chainId: 17e3, ...jc },
  kovan: { chainId: 42, ...jc },
  klaytn: { chainId: 8217, name: "Klaytn", ...oP },
  klaytnBaobab: { chainId: 1001, name: "Klaytn Baobab", ...oP },
  localhost: { chainId: 1337, ...jc },
  mainnet: { chainId: 1, name: "Ethereum", ...jc },
  optimism: { chainId: 10, name: "Optimism", ...e1 },
  optimismGoerli: { chainId: 420, ...e1 },
  optimismKovan: { chainId: 69, ...e1 },
  optimismSepolia: { chainId: 11155420, ...e1 },
  polygon: { chainId: 137, name: "Polygon", ...aP },
  polygonMumbai: { chainId: 80001, ...aP },
  rinkeby: { chainId: 4, ...jc },
  ropsten: { chainId: 3, ...jc },
  ronin: { chainId: 2020, ...Roe },
  sepolia: { chainId: 11155111, ...jc },
  xdc: { chainId: 50, name: "XinFin", ...cP },
  xdcTestnet: { chainId: 51, ...cP },
  zetachain: { chainId: 7e3, name: "ZetaChain", ...lP },
  zetachainAthensTestnet: {
    chainId: 7001,
    name: "Zeta Athens",
    ...lP
  },
  zkSync: { chainId: 324, name: "zkSync", ...uP },
  zkSyncTestnet: { chainId: 280, ...uP },
  zora: { chainId: 7777777, name: "Zora", ...Z3 },
  zoraSepolia: { chainId: 999999999, ...Z3 },
  zoraTestnet: { chainId: 999, ...Z3 }
}, Foe = Object.fromEntries(Object.values(Moe).filter(IU).map(({ chainId: e, ...t }) => [e, t])), joe = (e) => e.map((t) => {
  var n, r, i, s;
  const o = (n = Foe[t.id]) != null ? n : {};
  return {
    ...t,
    name: (r = o.name) != null ? r : t.name,
    iconUrl: (i = t.iconUrl) != null ? i : o.iconUrl,
    iconBackground: (s = t.iconBackground) != null ? s : o.iconBackground
  };
}), B5 = dn({
  chains: []
});
function Doe({
  children: e,
  initialChain: t
}) {
  const { chains: n } = yr();
  return /* @__PURE__ */ k.createElement(B5.Provider, {
    value: ot(() => ({
      chains: joe(n),
      initialChainId: typeof t == "number" ? t : t == null ? void 0 : t.id
    }), [n, t])
  }, e);
}
var Jm = () => $e(B5).chains, Uoe = () => $e(B5).initialChainId, Loe = () => {
  const e = Jm();
  return ot(() => {
    const t = {};
    for (const n of e)
      t[n.id] = n;
    return t;
  }, [e]);
}, PU = dn({
  showBalance: void 0,
  setShowBalance: () => {
  }
});
function zoe({ children: e }) {
  const [t, n] = qe();
  return /* @__PURE__ */ k.createElement(PU.Provider, {
    value: { showBalance: t, setShowBalance: n }
  }, e);
}
var Voe = () => $e(PU);
function Hoe() {
  const [e, t] = qe(!1);
  return We(() => (t(!0), () => {
    t(!1);
  }), []), Ie(() => e, [e]);
}
function OU() {
  const e = Jm(), t = m5.id;
  return e.some((r) => r.id === t);
}
function NU(e) {
  const t = OU(), n = (i) => {
    try {
      return mie(i);
    } catch {
    }
  }, { data: r } = yre({
    chainId: m5.id,
    name: e ? n(e) : void 0,
    query: {
      enabled: t
    }
  });
  return r;
}
function RU(e) {
  const t = OU(), { data: n } = bre({
    chainId: m5.id,
    address: e,
    query: {
      enabled: t
    }
  });
  return n;
}
function I5() {
  var e;
  const { chain: t } = mi();
  return (e = t == null ? void 0 : t.id) != null ? e : null;
}
var MU = "rk-transactions";
function Woe(e) {
  try {
    const t = e ? JSON.parse(e) : {};
    return typeof t == "object" ? t : {};
  } catch {
    return {};
  }
}
function dP() {
  return Woe(typeof localStorage < "u" ? localStorage.getItem(MU) : null);
}
var Goe = /^0x([A-Fa-f0-9]{64})$/;
function qoe(e) {
  const t = [];
  return Goe.test(e.hash) || t.push("Invalid transaction hash"), typeof e.description != "string" && t.push("Transaction must have a description"), typeof e.confirmations < "u" && (!Number.isInteger(e.confirmations) || e.confirmations < 1) && t.push("Transaction confirmations must be a positiver integer"), t;
}
function $oe({
  provider: e
}) {
  let t = dP(), n = e;
  const r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
  function s(h) {
    n = h;
  }
  function o(h, g) {
    var y, v;
    return (v = (y = t[h]) == null ? void 0 : y[g]) != null ? v : [];
  }
  function a(h, g, y) {
    const v = qoe(y);
    if (v.length > 0)
      throw new Error(["Unable to add transaction", ...v].join(`
`));
    d(h, g, (b) => [
      { ...y, status: "pending" },
      ...b.filter(({ hash: w }) => w !== y.hash)
    ]);
  }
  function c(h, g) {
    d(h, g, () => []);
  }
  function l(h, g, y, v) {
    d(h, g, (b) => b.map((w) => w.hash === y ? { ...w, status: v } : w));
  }
  async function u(h, g) {
    await Promise.all(o(h, g).filter((y) => y.status === "pending").map(async (y) => {
      const { confirmations: v, hash: b } = y, w = i.get(b);
      if (w)
        return await w;
      const A = n.waitForTransactionReceipt({
        confirmations: v,
        hash: b,
        timeout: 3e5
      }).then(({ status: E }) => {
        i.delete(b), E !== void 0 && l(h, g, b, E === 0 || E === "reverted" ? "failed" : "confirmed");
      }).catch(() => {
        l(h, g, b, "failed");
      });
      return i.set(b, A), await A;
    }));
  }
  function d(h, g, y) {
    var v, b;
    t = dP(), t[h] = (v = t[h]) != null ? v : {};
    let w = 0;
    const A = 10, E = y((b = t[h][g]) != null ? b : []).filter(({ status: x }) => x === "pending" ? !0 : w++ <= A);
    t[h][g] = E.length > 0 ? E : void 0, f(), p(), u(h, g);
  }
  function f() {
    localStorage.setItem(MU, JSON.stringify(t));
  }
  function p() {
    for (const h of r)
      h();
  }
  function m(h) {
    return r.add(h), () => {
      r.delete(h);
    };
  }
  return {
    addTransaction: a,
    clearTransactions: c,
    getTransactions: o,
    onChange: m,
    setProvider: s,
    waitForPendingTransactions: u
  };
}
var J3, FU = dn(null);
function Qoe({
  children: e
}) {
  const t = vre(), { address: n } = mi(), r = I5(), [i] = qe(() => J3 ?? (J3 = $oe({ provider: t })));
  return We(() => {
    i.setProvider(t);
  }, [i, t]), We(() => {
    n && r && i.waitForPendingTransactions(n, r);
  }, [i, n, r]), /* @__PURE__ */ k.createElement(FU.Provider, {
    value: i
  }, e);
}
function jU() {
  const e = $e(FU);
  if (!e)
    throw new Error("Transaction hooks must be used within RainbowKitProvider");
  return e;
}
function DU() {
  const e = jU(), { address: t } = mi(), n = I5(), [r, i] = qe(() => e && t && n ? e.getTransactions(t, n) : []);
  return We(() => {
    if (e && t && n)
      return i(e.getTransactions(t, n)), e.onChange(() => {
        i(e.getTransactions(t, n));
      });
  }, [e, t, n]), r;
}
var fP = (e) => typeof e == "function" ? e() : e;
function Koe(e, { extends: t } = {}) {
  const n = {
    ...QI(JI, fP(e))
  };
  if (!t)
    return n;
  const r = QI(JI, fP(t));
  return Object.fromEntries(Object.entries(n).filter(([s, o]) => o !== r[s]));
}
function hP(e, t = {}) {
  return Object.entries(Koe(e, t)).map(([n, r]) => `${n}:${r.replace(/[:;{}</>]/g, "")};`).join("");
}
var UU = {
  appName: void 0,
  disclaimer: void 0,
  learnMoreUrl: "https://learn.rainbow.me/understanding-web3?utm_source=rainbowkit&utm_campaign=learnmore"
}, lv = dn(UU), LU = dn(!1);
function Yoe(e, t) {
  let n;
  return () => {
    n && clearTimeout(n), n = setTimeout(() => {
      n = null, e();
    }, t);
  };
}
var zU = () => {
  const [e, t] = qe({
    height: void 0,
    width: void 0
  });
  return We(() => {
    const n = Yoe(() => {
      t({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }, 500);
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}, uv = dn({
  connector: null,
  setConnector: () => {
  }
});
function Zoe({ children: e }) {
  const [t, n] = qe(null);
  return /* @__PURE__ */ k.createElement(uv.Provider, {
    value: ot(() => ({
      connector: t,
      setConnector: n
    }), [t])
  }, e);
}
var dv = {
  COMPACT: "compact",
  WIDE: "wide"
}, KA = dn(dv.WIDE);
function Joe({
  children: e,
  modalSize: t
}) {
  const { width: n } = zU(), r = n && n < loe, { connector: i } = $e(uv);
  return /* @__PURE__ */ k.createElement(KA.Provider, {
    value: r || i ? dv.COMPACT : t
  }, e);
}
var P5 = dn(!1), Xoe = "rk-version";
function eae({ version: e }) {
  localStorage.setItem(Xoe, e);
}
function tae() {
  const e = Ie(() => {
    eae({ version: "2.0.7" });
  }, []);
  We(() => {
    e();
  }, [e]);
}
function nae(e, t) {
  const n = {};
  for (const r of e) {
    const i = t(r);
    i && (n[i] = r);
  }
  return n;
}
function O5() {
  return typeof navigator < "u" && /Version\/([0-9._]+).*Safari/.test(navigator.userAgent);
}
function rae() {
  return typeof document < "u" && getComputedStyle(document.body).getPropertyValue("--arc-palette-focus") !== "";
}
function N5() {
  var e;
  if (typeof navigator > "u")
    return "Browser";
  const t = navigator.userAgent.toLowerCase();
  return (e = navigator.brave) != null && e.isBrave ? "Brave" : t.indexOf("edg/") > -1 ? "Edge" : t.indexOf("op") > -1 ? "Opera" : rae() ? "Arc" : t.indexOf("chrome") > -1 ? "Chrome" : t.indexOf("firefox") > -1 ? "Firefox" : O5() ? "Safari" : "Browser";
}
var iae = qie.UAParser(), { os: R5 } = iae;
function sae() {
  return R5.name === "Windows";
}
function oae() {
  return R5.name === "Mac OS";
}
function aae() {
  return ["Ubuntu", "Mint", "Fedora", "Debian", "Arch", "Linux"].includes(R5.name);
}
function M5() {
  return sae() ? "Windows" : oae() ? "macOS" : aae() ? "Linux" : "Desktop";
}
var cae = (e) => {
  var t, n, r, i, s, o, a, c, l, u, d, f;
  const p = N5();
  return (f = {
    Arc: (t = e == null ? void 0 : e.downloadUrls) == null ? void 0 : t.chrome,
    Brave: (n = e == null ? void 0 : e.downloadUrls) == null ? void 0 : n.chrome,
    Chrome: (r = e == null ? void 0 : e.downloadUrls) == null ? void 0 : r.chrome,
    Edge: ((i = e == null ? void 0 : e.downloadUrls) == null ? void 0 : i.edge) || ((s = e == null ? void 0 : e.downloadUrls) == null ? void 0 : s.chrome),
    Firefox: (o = e == null ? void 0 : e.downloadUrls) == null ? void 0 : o.firefox,
    Opera: ((a = e == null ? void 0 : e.downloadUrls) == null ? void 0 : a.opera) || ((c = e == null ? void 0 : e.downloadUrls) == null ? void 0 : c.chrome),
    Safari: (l = e == null ? void 0 : e.downloadUrls) == null ? void 0 : l.safari,
    Browser: (u = e == null ? void 0 : e.downloadUrls) == null ? void 0 : u.browserExtension
  }[p]) != null ? f : (d = e == null ? void 0 : e.downloadUrls) == null ? void 0 : d.browserExtension;
}, lae = (e) => {
  var t, n, r, i;
  return (i = QA() ? (t = e == null ? void 0 : e.downloadUrls) == null ? void 0 : t.ios : (n = e == null ? void 0 : e.downloadUrls) == null ? void 0 : n.android) != null ? i : (r = e == null ? void 0 : e.downloadUrls) == null ? void 0 : r.mobile;
}, uae = (e) => {
  var t, n, r, i, s, o;
  const a = M5();
  return (o = {
    Windows: (t = e == null ? void 0 : e.downloadUrls) == null ? void 0 : t.windows,
    macOS: (n = e == null ? void 0 : e.downloadUrls) == null ? void 0 : n.macos,
    Linux: (r = e == null ? void 0 : e.downloadUrls) == null ? void 0 : r.linux,
    Desktop: (i = e == null ? void 0 : e.downloadUrls) == null ? void 0 : i.desktop
  }[a]) != null ? o : (s = e == null ? void 0 : e.downloadUrls) == null ? void 0 : s.desktop;
}, VU = (e, t) => e.some((n) => n.id === t), dae = (e) => !!e.isRainbowKitConnector, pP = (e) => {
  var t;
  return !!(!e.isRainbowKitConnector && ((t = e.icon) != null && t.startsWith("data:image")) && e.uid && e.name);
}, fae = (e, t) => e.id === "walletConnect" && t ? { ...e, walletConnectModalConnector: t } : e, hae = ({
  wallets: e,
  recentWallets: t
}) => [
  ...t,
  ...e.filter((n) => !VU(t, n.id))
], HU = "rk-recent";
function pae(e) {
  try {
    const t = e ? JSON.parse(e) : [];
    return Array.isArray(t) ? t : [];
  } catch {
    return [];
  }
}
function WU() {
  return typeof localStorage < "u" ? pae(localStorage.getItem(HU)) : [];
}
function mae(e) {
  return [...new Set(e)];
}
function gae(e) {
  const t = mae([e, ...WU()]);
  localStorage.setItem(HU, JSON.stringify(t));
}
function YA(e = !1) {
  var t, n, r, i;
  const s = Jm(), o = Uoe(), { connectAsync: a, connectors: c } = vD(), l = c, { setIsWalletConnectModalOpen: u } = mL(), d = l.map((S) => ({
    ...S,
    ...S.rkDetails || {}
  }));
  async function f(S) {
    var P, I, R;
    const Q = await S.getChainId(), J = await a({
      chainId: (R = o ?? ((P = s.find(({ id: we }) => we === Q)) == null ? void 0 : P.id)) != null ? R : (I = s[0]) == null ? void 0 : I.id,
      connector: S
    });
    return J && gae(S.id), J;
  }
  async function p(S) {
    try {
      u(!0), await f(S), u(!1);
    } catch (P) {
      const I = P.name === "UserRejectedRequestError" || P.message === "Connection request reset. Please try again.";
      if (u(!1), !I)
        throw P;
    }
  }
  const m = async (S, P) => {
    const I = await S.getProvider();
    return S.id === "coinbase" ? I.qrUrl : new Promise((R) => I.once("display_uri", (Q) => {
      R(P(Q));
    }));
  }, h = d.find((S) => S.id === "walletConnect" && S.isWalletConnectModalConnector), g = d.filter(pP).map((S) => ({
    ...S,
    groupIndex: 0
  })), y = d.filter(dae).filter((S) => !S.isWalletConnectModalConnector).filter((S) => e ? !g.some((I) => I.id === S.rdns) : !0).map((S) => fae(S, h)), v = [...g, ...y], b = nae(v, (S) => S.id), A = WU().map((S) => b[S]).filter(Boolean).slice(0, 3), E = [], x = hae({
    wallets: v,
    recentWallets: A
  });
  for (const S of x) {
    if (!S)
      continue;
    const P = pP(S), I = VU(A, S.id);
    if (P) {
      E.push({
        ...S,
        iconUrl: S.icon,
        ready: !0,
        connect: () => f(S),
        groupName: "Installed",
        recent: I
      });
      continue;
    }
    E.push({
      ...S,
      ready: (t = S.installed) != null ? t : !0,
      connect: () => f(S),
      desktopDownloadUrl: uae(S),
      extensionDownloadUrl: cae(S),
      groupName: S.groupName,
      mobileDownloadUrl: lae(S),
      getQrCodeUri: (n = S.qrCode) != null && n.getUri ? () => m(S, S.qrCode.getUri) : void 0,
      getDesktopUri: (r = S.desktop) != null && r.getUri ? () => m(S, S.desktop.getUri) : void 0,
      getMobileUri: (i = S.mobile) != null && i.getUri ? () => {
        var R;
        return m(S, (R = S.mobile) == null ? void 0 : R.getUri);
      } : void 0,
      recent: I,
      showWalletConnectModal: S.walletConnectModalConnector ? () => p(S.walletConnectModalConnector) : void 0
    });
  }
  return E;
}
var GU = async () => (await import("./assets-26YY4GVD-C0_tPwXR.js")).default, yae = () => ba(GU), bae = () => /* @__PURE__ */ k.createElement(gr, {
  background: "#d0d5de",
  borderRadius: "10",
  height: "48",
  src: GU,
  width: "48"
}), qU = async () => (await import("./login-ZSMM5UYL-I9Kp2cMA.js")).default, vae = () => ba(qU), wae = () => /* @__PURE__ */ k.createElement(gr, {
  background: "#d0d5de",
  borderRadius: "10",
  height: "48",
  src: qU,
  width: "48"
}), rt = k.forwardRef(({
  as: e = "div",
  children: t,
  className: n,
  color: r,
  display: i,
  font: s = "body",
  id: o,
  size: a = "16",
  style: c,
  tabIndex: l,
  textAlign: u = "inherit",
  weight: d = "regular",
  testId: f
}, p) => /* @__PURE__ */ k.createElement(Z, {
  as: e,
  className: n,
  color: r,
  display: i,
  fontFamily: s,
  fontSize: a,
  fontWeight: d,
  id: o,
  ref: p,
  style: c,
  tabIndex: l,
  textAlign: u,
  testId: f
}, t));
rt.displayName = "Text";
var xae = {
  large: {
    fontSize: "16",
    paddingX: "24",
    paddingY: "10"
  },
  medium: {
    fontSize: "14",
    height: "28",
    paddingX: "12",
    paddingY: "4"
  },
  small: {
    fontSize: "14",
    paddingX: "10",
    paddingY: "5"
  }
};
function fi({
  disabled: e = !1,
  href: t,
  label: n,
  onClick: r,
  rel: i = "noreferrer noopener",
  size: s = "medium",
  target: o = "_blank",
  testId: a,
  type: c = "primary"
}) {
  const l = c === "primary", u = s !== "large", d = Br(), f = e ? "actionButtonSecondaryBackground" : l ? "accentColor" : u ? "actionButtonSecondaryBackground" : null, { fontSize: p, height: m, paddingX: h, paddingY: g } = xae[s], y = !d || !u;
  return /* @__PURE__ */ k.createElement(Z, {
    ...t ? e ? {} : { as: "a", href: t, rel: i, target: o } : { as: "button", type: "button" },
    onClick: e ? void 0 : r,
    ...y ? {
      borderColor: d && !u && !l ? "actionButtonBorderMobile" : "actionButtonBorder",
      borderStyle: "solid",
      borderWidth: "1"
    } : {},
    borderRadius: "actionButton",
    className: !e && kr({ active: "shrinkSm", hover: "grow" }),
    display: "block",
    paddingX: h,
    paddingY: g,
    style: { willChange: "transform" },
    testId: a,
    textAlign: "center",
    transition: "transform",
    ...f ? { background: f } : {},
    ...m ? { height: m } : {}
  }, /* @__PURE__ */ k.createElement(rt, {
    color: e ? "modalTextSecondary" : l ? "accentColorForeground" : "accentColor",
    size: p,
    weight: "bold"
  }, n));
}
var Aae = () => Br() ? /* @__PURE__ */ k.createElement("svg", {
  "aria-hidden": !0,
  fill: "none",
  height: "11.5",
  viewBox: "0 0 11.5 11.5",
  width: "11.5",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Close"), /* @__PURE__ */ k.createElement("path", {
  d: "M2.13388 0.366117C1.64573 -0.122039 0.854272 -0.122039 0.366117 0.366117C-0.122039 0.854272 -0.122039 1.64573 0.366117 2.13388L3.98223 5.75L0.366117 9.36612C-0.122039 9.85427 -0.122039 10.6457 0.366117 11.1339C0.854272 11.622 1.64573 11.622 2.13388 11.1339L5.75 7.51777L9.36612 11.1339C9.85427 11.622 10.6457 11.622 11.1339 11.1339C11.622 10.6457 11.622 9.85427 11.1339 9.36612L7.51777 5.75L11.1339 2.13388C11.622 1.64573 11.622 0.854272 11.1339 0.366117C10.6457 -0.122039 9.85427 -0.122039 9.36612 0.366117L5.75 3.98223L2.13388 0.366117Z",
  fill: "currentColor"
})) : /* @__PURE__ */ k.createElement("svg", {
  "aria-hidden": !0,
  fill: "none",
  height: "10",
  viewBox: "0 0 10 10",
  width: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Close"), /* @__PURE__ */ k.createElement("path", {
  d: "M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L3.58579 5L0.292893 8.29289C-0.0976311 8.68342 -0.0976311 9.31658 0.292893 9.70711C0.683417 10.0976 1.31658 10.0976 1.70711 9.70711L5 6.41421L8.29289 9.70711C8.68342 10.0976 9.31658 10.0976 9.70711 9.70711C10.0976 9.31658 10.0976 8.68342 9.70711 8.29289L6.41421 5L9.70711 1.70711C10.0976 1.31658 10.0976 0.683417 9.70711 0.292893C9.31658 -0.0976311 8.68342 -0.0976311 8.29289 0.292893L5 3.58579L1.70711 0.292893Z",
  fill: "currentColor"
})), sf = ({
  "aria-label": e = "Close",
  onClose: t
}) => {
  const n = Br();
  return /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    "aria-label": e,
    as: "button",
    background: "closeButtonBackground",
    borderColor: "actionButtonBorder",
    borderRadius: "full",
    borderStyle: "solid",
    borderWidth: n ? "0" : "1",
    className: kr({ active: "shrinkSm", hover: "growLg" }),
    color: "closeButton",
    display: "flex",
    height: n ? "30" : "28",
    justifyContent: "center",
    onClick: t,
    style: { willChange: "transform" },
    transition: "default",
    type: "button",
    width: n ? "30" : "28"
  }, /* @__PURE__ */ k.createElement(Aae, null));
}, $U = async () => (await import("./sign-FZVB2CS6-BQQmgNRT.js")).default;
function Eae({
  onClose: e,
  onCloseModal: t
}) {
  const { i18n: n } = $e(ir), [{ status: r, ...i }, s] = k.useState({ status: "idle" }), o = poe(), a = Ie(async () => {
    try {
      const m = await o.getNonce();
      s((h) => ({ ...h, nonce: m }));
    } catch {
      s((m) => ({
        ...m,
        errorMessage: n.t("sign_in.message.preparing_error"),
        status: "idle"
      }));
    }
  }, [o, n.t]), c = Le(!1);
  k.useEffect(() => {
    c.current || (c.current = !0, a());
  }, [a]);
  const l = Br(), { address: u, chain: d } = mi(), { signMessageAsync: f } = wre(), p = async () => {
    try {
      const m = d == null ? void 0 : d.id, { nonce: h } = i;
      if (!u || !m || !h)
        return;
      s((v) => ({
        ...v,
        errorMessage: void 0,
        status: "signing"
      }));
      const g = o.createMessage({ address: u, chainId: m, nonce: h });
      let y;
      try {
        y = await f({
          message: o.getMessageBody({ message: g })
        });
      } catch (v) {
        return v instanceof Lr ? s((b) => ({
          ...b,
          status: "idle"
        })) : s((b) => ({
          ...b,
          errorMessage: n.t("sign_in.signature.signing_error"),
          status: "idle"
        }));
      }
      s((v) => ({ ...v, status: "verifying" }));
      try {
        if (await o.verify({ message: g, signature: y })) {
          t();
          return;
        }
        throw new Error();
      } catch {
        return s((v) => ({
          ...v,
          errorMessage: n.t("sign_in.signature.verifying_error"),
          status: "idle"
        }));
      }
    } catch {
      s({
        errorMessage: n.t("sign_in.signature.oops_error"),
        status: "idle"
      });
    }
  };
  return /* @__PURE__ */ k.createElement(Z, {
    position: "relative"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    paddingRight: "16",
    paddingTop: "16",
    position: "absolute",
    right: "0"
  }, /* @__PURE__ */ k.createElement(sf, {
    onClose: e
  })), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: l ? "32" : "24",
    padding: "24",
    paddingX: "18",
    style: { paddingTop: l ? "60px" : "36px" }
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: l ? "6" : "4",
    style: { maxWidth: l ? 320 : 280 }
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: l ? "32" : "16"
  }, /* @__PURE__ */ k.createElement(gr, {
    height: 40,
    src: $U,
    width: 40
  }), /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: l ? "20" : "18",
    textAlign: "center",
    weight: "heavy"
  }, n.t("sign_in.label"))), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: l ? "16" : "12"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: l ? "16" : "14",
    textAlign: "center"
  }, n.t("sign_in.description")), r === "idle" && i.errorMessage ? /* @__PURE__ */ k.createElement(rt, {
    color: "error",
    size: l ? "16" : "14",
    textAlign: "center",
    weight: "bold"
  }, i.errorMessage) : null)), /* @__PURE__ */ k.createElement(Z, {
    alignItems: l ? void 0 : "center",
    display: "flex",
    flexDirection: "column",
    gap: "8",
    width: "full"
  }, /* @__PURE__ */ k.createElement(fi, {
    disabled: !i.nonce || r === "signing" || r === "verifying",
    label: i.nonce ? r === "signing" ? n.t("sign_in.signature.waiting") : r === "verifying" ? n.t("sign_in.signature.verifying") : n.t("sign_in.message.send") : n.t("sign_in.message.preparing"),
    onClick: p,
    size: l ? "large" : "medium",
    testId: "auth-message-button"
  }), l ? /* @__PURE__ */ k.createElement(fi, {
    label: "Cancel",
    onClick: e,
    size: "large",
    type: "secondary"
  }) : /* @__PURE__ */ k.createElement(Z, {
    as: "button",
    borderRadius: "full",
    className: kr({ active: "shrink", hover: "grow" }),
    display: "block",
    onClick: e,
    paddingX: "10",
    paddingY: "5",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "closeButton",
    size: l ? "16" : "14",
    weight: "bold"
  }, n.t("sign_in.message.cancel"))))));
}
function _ae() {
  const e = Jm(), t = YA(), n = $A() === "unauthenticated", r = Ie(() => {
    ba(...t.map((i) => i.iconUrl), ...e.map((i) => i.iconUrl).filter(IU)), Br() || (yae(), vae()), n && ba($U);
  }, [t, e, n]);
  We(() => {
    r();
  }, [r]);
}
var QU = "WALLETCONNECT_DEEPLINK_CHOICE";
function Sae({
  mobileUri: e,
  name: t
}) {
  localStorage.setItem(QU, JSON.stringify({
    href: e.split("?")[0],
    name: t
  }));
}
function Cae() {
  localStorage.removeItem(QU);
}
var KU = dn(void 0), $S = "data-rk", YU = (e) => ({ [$S]: e || "" }), Tae = (e) => {
  if (e && !/^[a-zA-Z0-9_]+$/.test(e))
    throw new Error(`Invalid ID: ${e}`);
  return e ? `[${$S}="${e}"]` : `[${$S}]`;
}, kae = () => {
  const e = $e(KU);
  return YU(e);
}, Bae = xD();
function Iae({
  appInfo: e,
  avatar: t,
  children: n,
  coolMode: r = !1,
  id: i,
  initialChain: s,
  locale: o,
  modalSize: a = dv.WIDE,
  showRecentTransactions: c = !1,
  theme: l = Bae
}) {
  if (_ae(), tae(), yD({ onDisconnect: Cae }), typeof l == "function")
    throw new Error('A theme function was provided to the "theme" prop instead of a theme object. You must execute this function to get the resulting theme object.');
  const u = Tae(i), d = {
    ...UU,
    ...e
  }, f = t ?? kU;
  return /* @__PURE__ */ k.createElement(Doe, {
    initialChain: s
  }, /* @__PURE__ */ k.createElement(Zoe, null, /* @__PURE__ */ k.createElement(Ooe, {
    locale: o
  }, /* @__PURE__ */ k.createElement(LU.Provider, {
    value: r
  }, /* @__PURE__ */ k.createElement(Joe, {
    modalSize: a
  }, /* @__PURE__ */ k.createElement(P5.Provider, {
    value: c
  }, /* @__PURE__ */ k.createElement(Qoe, null, /* @__PURE__ */ k.createElement(BU.Provider, {
    value: f
  }, /* @__PURE__ */ k.createElement(lv.Provider, {
    value: d
  }, /* @__PURE__ */ k.createElement(KU.Provider, {
    value: i
  }, /* @__PURE__ */ k.createElement(zoe, null, /* @__PURE__ */ k.createElement(Wce, null, l ? /* @__PURE__ */ k.createElement("div", {
    ...YU(i)
  }, /* @__PURE__ */ k.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: [
        `${u}{${hP("lightMode" in l ? l.lightMode : l)}}`,
        "darkMode" in l ? `@media(prefers-color-scheme:dark){${u}{${hP(l.darkMode, { extends: l.lightMode })}}}` : null
      ].join("")
    }
  }), n) : n))))))))))));
}
var Pae = "_9pm4ki5 ju367va ju367v15 ju367v8r", Oae = "_9pm4ki3 ju367v9h ju367vb3 ju367va ju367v2q ju367v8q", mP = (e, t) => {
  const n = e.querySelectorAll("button:not(:disabled), a[href]");
  n.length !== 0 && n[t === "end" ? n.length - 1 : 0].focus();
};
function Nae(e) {
  const t = Le(null);
  return We(() => {
    const n = document.activeElement;
    return () => {
      var r;
      (r = n.focus) == null || r.call(n);
    };
  }, []), We(() => {
    if (t.current) {
      const n = t.current.querySelector("[data-auto-focus]");
      n ? n.focus() : t.current.focus();
    }
  }, []), /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement("div", {
    onFocus: Ie(() => t.current && mP(t.current, "end"), []),
    tabIndex: 0
  }), /* @__PURE__ */ k.createElement("div", {
    ref: t,
    style: { outline: "none" },
    tabIndex: -1,
    ...e
  }), /* @__PURE__ */ k.createElement("div", {
    onFocus: Ie(() => t.current && mP(t.current, "start"), []),
    tabIndex: 0
  }));
}
var Rae = (e) => e.stopPropagation();
function Rx({ children: e, onClose: t, open: n, titleId: r }) {
  We(() => {
    const l = (u) => n && u.key === "Escape" && t();
    return document.addEventListener("keydown", l), () => document.removeEventListener("keydown", l);
  }, [n, t]);
  const [i, s] = qe(!0);
  We(() => {
    s(getComputedStyle(window.document.body).overflow !== "hidden");
  }, []);
  const o = Ie(() => t(), [t]), a = kae(), c = Br();
  return /* @__PURE__ */ k.createElement(k.Fragment, null, n ? AA(/* @__PURE__ */ k.createElement(nU, {
    enabled: i
  }, /* @__PURE__ */ k.createElement(Z, {
    ...a
  }, /* @__PURE__ */ k.createElement(Z, {
    ...a,
    alignItems: c ? "flex-end" : "center",
    "aria-labelledby": r,
    "aria-modal": !0,
    className: Oae,
    onClick: o,
    position: "fixed",
    role: "dialog"
  }, /* @__PURE__ */ k.createElement(Nae, {
    className: Pae,
    onClick: Rae,
    role: "document"
  }, e)))), document.body) : null);
}
var Mae = "_1ckjpok7", Fae = "_1ckjpok1 ju367vb6 ju367vdr ju367vp ju367vt ju367vv ju367vel ju367va ju367v15 ju367v6c ju367v8r", jae = "_1ckjpok4 _1ckjpok1 ju367vb6 ju367vdr ju367vp ju367vt ju367vv ju367vel ju367va ju367v15 ju367v6c ju367v8r", Dae = "_1ckjpok6 ju367vq", Uae = "_1ckjpok3 _1ckjpok1 ju367vb6 ju367vdr ju367vp ju367vt ju367vv ju367vel ju367va ju367v15 ju367v6c ju367v8r", Lae = "_1ckjpok2 _1ckjpok1 ju367vb6 ju367vdr ju367vp ju367vt ju367vv ju367vel ju367va ju367v15 ju367v6c ju367v8r";
function Mx({
  bottomSheetOnMobile: e = !1,
  children: t,
  marginTop: n,
  padding: r = "16",
  paddingBottom: i,
  wide: s = !1
}) {
  const o = Br(), c = $e(KA) === dv.COMPACT;
  return /* @__PURE__ */ k.createElement(Z, {
    marginTop: n
  }, /* @__PURE__ */ k.createElement(Z, {
    className: [
      s ? o ? Lae : c ? jae : Uae : Fae,
      o ? Dae : null,
      o && e ? Mae : null
    ].join(" ")
  }, /* @__PURE__ */ k.createElement(Z, {
    padding: r,
    paddingBottom: i ?? r
  }, t)));
}
var gP = ["k", "m", "b", "t"];
function t1(e, t = 1) {
  return e.toString().replace(new RegExp(`(.+\\.\\d{${t}})\\d+`), "$1").replace(/(\.[1-9]*)0+$/, "$1").replace(/\.$/, "");
}
function ZU(e) {
  if (e < 1)
    return t1(e, 3);
  if (e < 10 ** 2)
    return t1(e, 2);
  if (e < 10 ** 4)
    return new Intl.NumberFormat().format(parseFloat(t1(e, 1)));
  const t = 10 ** 1;
  let n = String(e);
  for (let r = gP.length - 1; r >= 0; r--) {
    const i = 10 ** ((r + 1) * 3);
    if (i <= e) {
      e = e * t / i / t, n = t1(e, 1) + gP[r];
      break;
    }
  }
  return n;
}
function JU(e) {
  return e.length < 8 ? e : `${e.substring(0, 4)}…${e.substring(e.length - 4)}`;
}
function XU(e) {
  if (!e)
    return "";
  const t = e.split("."), n = t.pop();
  return t.join(".").length > 24 ? `${t.join(".").substring(0, 24)}...` : `${t.join(".")}.${n}`;
}
var zae = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "13",
  viewBox: "0 0 13 13",
  width: "13",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Copied"), /* @__PURE__ */ k.createElement("path", {
  d: "M4.94568 12.2646C5.41052 12.2646 5.77283 12.0869 6.01892 11.7109L12.39 1.96973C12.5677 1.69629 12.6429 1.44336 12.6429 1.2041C12.6429 0.561523 12.1644 0.0966797 11.5082 0.0966797C11.057 0.0966797 10.7767 0.260742 10.5033 0.691406L4.9115 9.50977L2.07458 5.98926C1.82166 5.68848 1.54822 5.55176 1.16541 5.55176C0.502319 5.55176 0.0238037 6.02344 0.0238037 6.66602C0.0238037 6.95312 0.112671 7.20605 0.358765 7.48633L3.88611 11.7588C4.18005 12.1074 4.50818 12.2646 4.94568 12.2646Z",
  fill: "currentColor"
})), Vae = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 17 16",
  width: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Copy"), /* @__PURE__ */ k.createElement("path", {
  d: "M3.04236 12.3027H4.18396V13.3008C4.18396 14.8525 5.03845 15.7002 6.59705 15.7002H13.6244C15.183 15.7002 16.0375 14.8525 16.0375 13.3008V6.24609C16.0375 4.69434 15.183 3.84668 13.6244 3.84668H12.4828V2.8418C12.4828 1.29688 11.6283 0.442383 10.0697 0.442383H3.04236C1.48376 0.442383 0.629272 1.29004 0.629272 2.8418V9.90332C0.629272 11.4551 1.48376 12.3027 3.04236 12.3027ZM3.23376 10.5391C2.68689 10.5391 2.39294 10.2656 2.39294 9.68457V3.06055C2.39294 2.47949 2.68689 2.21289 3.23376 2.21289H9.8783C10.4252 2.21289 10.7191 2.47949 10.7191 3.06055V3.84668H6.59705C5.03845 3.84668 4.18396 4.69434 4.18396 6.24609V10.5391H3.23376ZM6.78845 13.9365C6.24158 13.9365 5.94763 13.6699 5.94763 13.0889V6.45801C5.94763 5.87695 6.24158 5.61035 6.78845 5.61035H13.433C13.9799 5.61035 14.2738 5.87695 14.2738 6.45801V13.0889C14.2738 13.6699 13.9799 13.9365 13.433 13.9365H6.78845Z",
  fill: "currentColor"
})), Hae = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 18 16",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Disconnect"), /* @__PURE__ */ k.createElement("path", {
  d: "M2.67834 15.5908H9.99963C11.5514 15.5908 12.399 14.7432 12.399 13.1777V10.2656H10.6354V12.9863C10.6354 13.5332 10.3688 13.8271 9.78772 13.8271H2.89026C2.3092 13.8271 2.0426 13.5332 2.0426 12.9863V3.15625C2.0426 2.60254 2.3092 2.30859 2.89026 2.30859H9.78772C10.3688 2.30859 10.6354 2.60254 10.6354 3.15625V5.89746H12.399V2.95801C12.399 1.39941 11.5514 0.544922 9.99963 0.544922H2.67834C1.12659 0.544922 0.278931 1.39941 0.278931 2.95801V13.1777C0.278931 14.7432 1.12659 15.5908 2.67834 15.5908ZM7.43616 8.85059H14.0875L15.0924 8.78906L14.566 9.14453L13.6842 9.96484C13.5406 10.1016 13.4586 10.2861 13.4586 10.4844C13.4586 10.8398 13.7321 11.168 14.1217 11.168C14.3199 11.168 14.4635 11.0928 14.6002 10.9561L16.7809 8.68652C16.986 8.48145 17.0543 8.27637 17.0543 8.06445C17.0543 7.85254 16.986 7.64746 16.7809 7.43555L14.6002 5.17285C14.4635 5.03613 14.3199 4.9541 14.1217 4.9541C13.7321 4.9541 13.4586 5.27539 13.4586 5.6377C13.4586 5.83594 13.5406 6.02734 13.6842 6.15723L14.566 6.98438L15.0924 7.33984L14.0875 7.27148H7.43616C7.01917 7.27148 6.65686 7.62012 6.65686 8.06445C6.65686 8.50195 7.01917 8.85059 7.43616 8.85059Z",
  fill: "currentColor"
}));
function Wae() {
  const e = jU(), { address: t } = mi(), n = I5();
  return Ie(() => {
    if (!t || !n)
      throw new Error("No address or chain ID found");
    e.clearTransactions(t, n);
  }, [e, t, n]);
}
var eL = (e) => {
  var t, n;
  return (n = (t = e == null ? void 0 : e.blockExplorers) == null ? void 0 : t.default) == null ? void 0 : n.url;
}, tL = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "19",
  viewBox: "0 0 20 19",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Link"), /* @__PURE__ */ k.createElement("path", {
  d: "M10 18.9443C15.0977 18.9443 19.2812 14.752 19.2812 9.6543C19.2812 4.56543 15.0889 0.373047 10 0.373047C4.90234 0.373047 0.71875 4.56543 0.71875 9.6543C0.71875 14.752 4.91113 18.9443 10 18.9443ZM10 16.6328C6.1416 16.6328 3.03906 13.5215 3.03906 9.6543C3.03906 5.7959 6.13281 2.68457 10 2.68457C13.8584 2.68457 16.9697 5.7959 16.9697 9.6543C16.9785 13.5215 13.8672 16.6328 10 16.6328ZM12.7158 12.1416C13.2432 12.1416 13.5684 11.7549 13.5684 11.1836V7.19336C13.5684 6.44629 13.1377 6.05957 12.417 6.05957H8.40918C7.8291 6.05957 7.45117 6.38477 7.45117 6.91211C7.45117 7.43945 7.8291 7.77344 8.40918 7.77344H9.69238L10.7207 7.63281L9.53418 8.67871L6.73047 11.4912C6.53711 11.6758 6.41406 11.9395 6.41406 12.2031C6.41406 12.7832 6.85352 13.1699 7.39844 13.1699C7.68848 13.1699 7.92578 13.0732 8.1543 12.8623L10.9316 10.0762L11.9775 8.89844L11.8545 9.98828V11.1836C11.8545 11.7725 12.1885 12.1416 12.7158 12.1416Z",
  fill: "currentColor"
})), Gae = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "19",
  viewBox: "0 0 20 19",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Cancel"), /* @__PURE__ */ k.createElement("path", {
  d: "M10 18.9443C15.0977 18.9443 19.2812 14.752 19.2812 9.6543C19.2812 4.56543 15.0889 0.373047 10 0.373047C4.90234 0.373047 0.71875 4.56543 0.71875 9.6543C0.71875 14.752 4.91113 18.9443 10 18.9443ZM10 16.6328C6.1416 16.6328 3.03906 13.5215 3.03906 9.6543C3.03906 5.7959 6.13281 2.68457 10 2.68457C13.8584 2.68457 16.9697 5.7959 16.9697 9.6543C16.9785 13.5215 13.8672 16.6328 10 16.6328ZM7.29297 13.3018C7.58301 13.3018 7.81152 13.2139 7.99609 13.0205L10 11.0166L12.0127 13.0205C12.1973 13.2051 12.4258 13.3018 12.707 13.3018C13.2432 13.3018 13.6562 12.8887 13.6562 12.3525C13.6562 12.0977 13.5508 11.8691 13.3662 11.6934L11.3535 9.67188L13.375 7.6416C13.5596 7.44824 13.6562 7.22852 13.6562 6.98242C13.6562 6.44629 13.2432 6.0332 12.7158 6.0332C12.4346 6.0332 12.2148 6.12109 12.0215 6.31445L10 8.32715L7.9873 6.32324C7.80273 6.12988 7.58301 6.04199 7.29297 6.04199C6.76562 6.04199 6.35254 6.45508 6.35254 6.99121C6.35254 7.2373 6.44922 7.46582 6.63379 7.6416L8.65527 9.67188L6.63379 11.6934C6.44922 11.8691 6.35254 12.1064 6.35254 12.3525C6.35254 12.8887 6.76562 13.3018 7.29297 13.3018Z",
  fill: "currentColor"
})), qae = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Success"), /* @__PURE__ */ k.createElement("path", {
  d: "M10 19.4443C15.0977 19.4443 19.2812 15.252 19.2812 10.1543C19.2812 5.06543 15.0889 0.873047 10 0.873047C4.90234 0.873047 0.71875 5.06543 0.71875 10.1543C0.71875 15.252 4.91113 19.4443 10 19.4443ZM10 17.1328C6.1416 17.1328 3.03906 14.0215 3.03906 10.1543C3.03906 6.2959 6.13281 3.18457 10 3.18457C13.8584 3.18457 16.9697 6.2959 16.9697 10.1543C16.9785 14.0215 13.8672 17.1328 10 17.1328ZM9.07715 14.3379C9.4375 14.3379 9.7627 14.1533 9.97363 13.8369L13.7441 8.00977C13.8848 7.79883 13.9814 7.5791 13.9814 7.36816C13.9814 6.84961 13.5244 6.48926 13.0322 6.48926C12.707 6.48926 12.4258 6.66504 12.2148 7.0166L9.05957 12.0967L7.5918 10.2949C7.37207 10.0225 7.13477 9.9082 6.84473 9.9082C6.33496 9.9082 5.92188 10.3125 5.92188 10.8223C5.92188 11.0684 6.00098 11.2793 6.18555 11.5078L8.1543 13.8545C8.40918 14.1709 8.70801 14.3379 9.07715 14.3379Z",
  fill: "currentColor"
})), $ae = (e) => {
  switch (e) {
    case "pending":
      return fy;
    case "confirmed":
      return qae;
    case "failed":
      return Gae;
    default:
      return fy;
  }
};
function Qae({ tx: e }) {
  const t = Br(), n = $ae(e.status), r = e.status === "failed" ? "error" : "accentColor", { chain: i } = mi(), s = e.status === "confirmed" ? "Confirmed" : e.status === "failed" ? "Failed" : "Pending", o = eL(i);
  return /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    ...o ? {
      as: "a",
      background: { hover: "profileForeground" },
      borderRadius: "menuButton",
      className: kr({ active: "shrink" }),
      href: `${o}/tx/${e.hash}`,
      rel: "noreferrer noopener",
      target: "_blank",
      transition: "default"
    } : {},
    color: "modalText",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "8",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: t ? "16" : "14"
  }, /* @__PURE__ */ k.createElement(Z, {
    color: r
  }, /* @__PURE__ */ k.createElement(n, null)), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: t ? "3" : "1"
  }, /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    font: "body",
    size: t ? "16" : "14",
    weight: "bold"
  }, e == null ? void 0 : e.description)), /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(rt, {
    color: e.status === "pending" ? "modalTextSecondary" : r,
    font: "body",
    size: "14",
    weight: t ? "medium" : "regular"
  }, s)))), o && /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    color: "modalTextDim",
    display: "flex"
  }, /* @__PURE__ */ k.createElement(tL, null))));
}
var Kae = 3;
function Yae({ address: e }) {
  const t = DU(), n = Wae(), { chain: r } = mi(), i = eL(r), s = t.slice(0, Kae), o = s.length > 0, a = Br(), { appName: c } = $e(lv), { i18n: l } = $e(ir);
  return /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "10",
    paddingBottom: "2",
    paddingTop: "16",
    paddingX: a ? "8" : "18"
  }, o && /* @__PURE__ */ k.createElement(Z, {
    paddingBottom: a ? "4" : "0",
    paddingTop: "8",
    paddingX: a ? "12" : "6"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    justifyContent: "space-between"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: a ? "16" : "14",
    weight: "semibold"
  }, l.t("profile.transactions.recent.title")), /* @__PURE__ */ k.createElement(Z, {
    style: {
      marginBottom: -6,
      marginLeft: -10,
      marginRight: -10,
      marginTop: -6
    }
  }, /* @__PURE__ */ k.createElement(Z, {
    as: "button",
    background: {
      hover: "profileForeground"
    },
    borderRadius: "actionButton",
    className: kr({ active: "shrink" }),
    onClick: n,
    paddingX: a ? "8" : "12",
    paddingY: a ? "4" : "5",
    transition: "default",
    type: "button"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: a ? "16" : "14",
    weight: "semibold"
  }, l.t("profile.transactions.clear.label")))))), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, o ? s.map((u) => /* @__PURE__ */ k.createElement(Qae, {
    key: u.hash,
    tx: u
  })) : /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    padding: a ? "12" : "8"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextDim",
    size: a ? "16" : "14",
    weight: a ? "medium" : "bold"
  }, c ? l.t("profile.transactions.description", {
    appName: c
  }) : l.t("profile.transactions.description_fallback"))), a && /* @__PURE__ */ k.createElement(Z, {
    background: "generalBorderDim",
    height: "1",
    marginX: "12",
    marginY: "8"
  })))), i && /* @__PURE__ */ k.createElement(Z, {
    paddingBottom: "18",
    paddingX: a ? "8" : "18"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    as: "a",
    background: { hover: "profileForeground" },
    borderRadius: "menuButton",
    className: kr({ active: "shrink" }),
    color: "modalTextDim",
    display: "flex",
    flexDirection: "row",
    href: `${i}/address/${e}`,
    justifyContent: "space-between",
    paddingX: "8",
    paddingY: "12",
    rel: "noreferrer noopener",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default",
    width: "full",
    ...a ? { paddingLeft: "12" } : {}
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    font: "body",
    size: a ? "16" : "14",
    weight: a ? "semibold" : "bold"
  }, l.t("profile.explorer.label")), /* @__PURE__ */ k.createElement(tL, null))));
}
function yP({
  action: e,
  icon: t,
  label: n,
  testId: r,
  url: i
}) {
  const s = Br();
  return /* @__PURE__ */ k.createElement(Z, {
    ...i ? { as: "a", href: i, rel: "noreferrer noopener", target: "_blank" } : { as: "button", type: "button" },
    background: {
      base: "profileAction",
      ...s ? {} : { hover: "profileActionHover" }
    },
    borderRadius: "menuButton",
    boxShadow: "profileDetailsAction",
    className: kr({
      active: "shrinkSm",
      hover: s ? void 0 : "grow"
    }),
    display: "flex",
    onClick: e,
    padding: s ? "6" : "8",
    style: { willChange: "transform" },
    testId: r,
    transition: "default",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "1",
    justifyContent: "center",
    paddingTop: "2",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    color: "modalText",
    height: "max"
  }, t), /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: s ? "12" : "13",
    weight: "semibold"
  }, n))));
}
function Zae({
  address: e,
  ensAvatar: t,
  ensName: n,
  onClose: r,
  onDisconnect: i
}) {
  const s = $e(P5), { data: o } = bD({
    address: e
  }), [a, c] = qe(!1), l = Ie(() => {
    e && (navigator.clipboard.writeText(e), c(!0));
  }, [e]);
  if (We(() => {
    if (a) {
      const g = setTimeout(() => {
        c(!1);
      }, 1500);
      return () => clearTimeout(g);
    }
  }, [a]), !e)
    return null;
  const u = n ? XU(n) : JU(e), d = o == null ? void 0 : o.formatted, f = d ? ZU(parseFloat(d)) : void 0, p = "rk_profile_title", m = Br(), { i18n: h } = $e(ir);
  return /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column"
  }, /* @__PURE__ */ k.createElement(Z, {
    background: "profileForeground",
    padding: "16"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: m ? "16" : "12",
    justifyContent: "center",
    margin: "8",
    style: { textAlign: "center" }
  }, /* @__PURE__ */ k.createElement(Z, {
    style: {
      position: "absolute",
      right: 16,
      top: 16,
      willChange: "transform"
    }
  }, /* @__PURE__ */ k.createElement(sf, {
    onClose: r
  })), " ", /* @__PURE__ */ k.createElement(Z, {
    marginTop: m ? "24" : "0"
  }, /* @__PURE__ */ k.createElement(koe, {
    address: e,
    imageUrl: t,
    size: m ? 82 : 74
  })), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: m ? "4" : "0",
    textAlign: "center"
  }, /* @__PURE__ */ k.createElement(Z, {
    textAlign: "center"
  }, /* @__PURE__ */ k.createElement(rt, {
    as: "h1",
    color: "modalText",
    id: p,
    size: m ? "20" : "18",
    weight: "heavy"
  }, u)), !!o && /* @__PURE__ */ k.createElement(Z, {
    textAlign: "center"
  }, /* @__PURE__ */ k.createElement(rt, {
    as: "h1",
    color: "modalTextSecondary",
    id: p,
    size: m ? "16" : "14",
    weight: "semibold"
  }, f, " ", o.symbol)))), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "row",
    gap: "8",
    margin: "2",
    marginTop: "16"
  }, /* @__PURE__ */ k.createElement(yP, {
    action: l,
    icon: a ? /* @__PURE__ */ k.createElement(zae, null) : /* @__PURE__ */ k.createElement(Vae, null),
    label: a ? h.t("profile.copy_address.copied") : h.t("profile.copy_address.label")
  }), /* @__PURE__ */ k.createElement(yP, {
    action: i,
    icon: /* @__PURE__ */ k.createElement(Hae, null),
    label: h.t("profile.disconnect.label"),
    testId: "disconnect-button"
  }))), s && /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    background: "generalBorder",
    height: "1",
    marginTop: "-1"
  }), /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(Yae, {
    address: e
  })))));
}
function Jae({ onClose: e, open: t }) {
  const { address: n } = mi(), r = RU(n), i = NU(r), { disconnect: s } = DA();
  return n ? /* @__PURE__ */ k.createElement(k.Fragment, null, n && /* @__PURE__ */ k.createElement(Rx, {
    onClose: e,
    open: t,
    titleId: "rk_account_modal_title"
  }, /* @__PURE__ */ k.createElement(Mx, {
    bottomSheetOnMobile: !0,
    padding: "0"
  }, /* @__PURE__ */ k.createElement(Zae, {
    address: n,
    ensAvatar: i,
    ensName: r,
    onClose: e,
    onDisconnect: s
  })))) : null;
}
var Xae = ({ size: e }) => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: e,
  viewBox: "0 0 28 28",
  width: e,
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Disconnect"), /* @__PURE__ */ k.createElement("path", {
  d: "M6.742 22.195h8.367c1.774 0 2.743-.968 2.743-2.758V16.11h-2.016v3.11c0 .625-.305.96-.969.96H6.984c-.664 0-.968-.335-.968-.96V7.984c0-.632.304-.968.968-.968h7.883c.664 0 .969.336.969.968v3.133h2.016v-3.36c0-1.78-.97-2.757-2.743-2.757H6.742C4.97 5 4 5.977 4 7.758v11.68c0 1.789.969 2.757 2.742 2.757Zm5.438-7.703h7.601l1.149-.07-.602.406-1.008.938a.816.816 0 0 0-.258.593c0 .407.313.782.758.782.227 0 .39-.086.547-.243l2.492-2.593c.235-.235.313-.47.313-.711 0-.242-.078-.477-.313-.719l-2.492-2.586c-.156-.156-.32-.25-.547-.25-.445 0-.758.367-.758.781 0 .227.094.446.258.594l1.008.945.602.407-1.149-.079H12.18a.904.904 0 0 0 0 1.805Z",
  fill: "currentColor"
})), ece = "v9horb0", F5 = k.forwardRef(({
  children: e,
  currentlySelected: t = !1,
  onClick: n,
  testId: r,
  ...i
}, s) => {
  const o = Br();
  return /* @__PURE__ */ k.createElement(Z, {
    as: "button",
    borderRadius: "menuButton",
    disabled: t,
    display: "flex",
    onClick: n,
    ref: s,
    testId: r,
    type: "button"
  }, /* @__PURE__ */ k.createElement(Z, {
    borderRadius: "menuButton",
    className: [
      o ? ece : void 0,
      !t && kr({ active: "shrink" })
    ],
    padding: o ? "8" : "6",
    transition: "default",
    width: "full",
    ...t ? {
      background: "accentColor",
      borderColor: "selectedOptionBorder",
      borderStyle: "solid",
      borderWidth: "1",
      boxShadow: "selectedOption",
      color: "accentColorForeground"
    } : {
      background: { hover: "menuItemBackground" },
      color: "modalText",
      transition: "default"
    },
    ...i
  }, e));
});
F5.displayName = "MenuButton";
var tce = ({
  chainId: e,
  currentChainId: t,
  switchChain: n,
  chainIconSize: r,
  isLoading: i,
  src: s,
  name: o,
  iconBackground: a,
  idx: c
}) => {
  const l = Br(), { i18n: u } = $e(ir), d = Jm(), f = t === e;
  return /* @__PURE__ */ k.createElement(Xd, null, /* @__PURE__ */ k.createElement(F5, {
    currentlySelected: f,
    onClick: f ? void 0 : () => n({ chainId: e }),
    testId: `chain-option-${e}`
  }, /* @__PURE__ */ k.createElement(Z, {
    fontFamily: "body",
    fontSize: "16",
    fontWeight: "bold"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "4",
    height: r
  }, s && /* @__PURE__ */ k.createElement(Z, {
    height: "full",
    marginRight: "8"
  }, /* @__PURE__ */ k.createElement(gr, {
    alt: o,
    background: a,
    borderRadius: "full",
    height: r,
    src: s,
    width: r,
    testId: `chain-option-${e}-icon`
  })), /* @__PURE__ */ k.createElement("div", null, (o != null, o))), f && /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    marginRight: "6"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "accentColorForeground",
    size: "14",
    weight: "medium"
  }, u.t("chains.connected")), /* @__PURE__ */ k.createElement(Z, {
    background: "connectionIndicator",
    borderColor: "selectedOptionBorder",
    borderRadius: "full",
    borderStyle: "solid",
    borderWidth: "1",
    height: "8",
    marginLeft: "8",
    width: "8"
  })), i && /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    marginRight: "6"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "14",
    weight: "medium"
  }, u.t("chains.confirm")), /* @__PURE__ */ k.createElement(Z, {
    background: "standby",
    borderRadius: "full",
    height: "8",
    marginLeft: "8",
    width: "8"
  }))))), l && c < d.length - 1 && /* @__PURE__ */ k.createElement(Z, {
    background: "generalBorderDim",
    height: "1",
    marginX: "8"
  }));
}, nce = tce, rce = "_18dqw9x0", ice = "_18dqw9x1";
function sce({ onClose: e, open: t }) {
  const { chainId: n } = mi(), { chains: r } = yr(), [i, s] = qe(null), { switchChain: o } = xre({
    mutation: {
      onMutate: ({ chainId: m }) => {
        s(m);
      },
      onSuccess: () => {
        i && s(null);
      },
      onError: () => {
        i && s(null);
      },
      onSettled: () => {
        e();
      }
    }
  }), { i18n: a } = $e(ir), { disconnect: c } = DA(), l = "rk_chain_modal_title", u = Br(), d = r.some((m) => m.id === n), f = u ? "36" : "28", p = Jm();
  return n ? /* @__PURE__ */ k.createElement(Rx, {
    onClose: e,
    open: t,
    titleId: l
  }, /* @__PURE__ */ k.createElement(Mx, {
    bottomSheetOnMobile: !0,
    paddingBottom: "0"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "14"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, u && /* @__PURE__ */ k.createElement(Z, {
    width: "30"
  }), /* @__PURE__ */ k.createElement(Z, {
    paddingBottom: "0",
    paddingLeft: "8",
    paddingTop: "4"
  }, /* @__PURE__ */ k.createElement(rt, {
    as: "h1",
    color: "modalText",
    id: l,
    size: u ? "20" : "18",
    weight: "heavy"
  }, a.t("chains.title"))), /* @__PURE__ */ k.createElement(sf, {
    onClose: e
  })), !d && /* @__PURE__ */ k.createElement(Z, {
    marginX: "8",
    textAlign: u ? "center" : "left"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, a.t("chains.wrong_network"))), /* @__PURE__ */ k.createElement(Z, {
    className: u ? ice : rce,
    display: "flex",
    flexDirection: "column",
    gap: "4",
    padding: "2",
    paddingBottom: "16"
  }, p.map(({ iconBackground: m, iconUrl: h, id: g, name: y }, v) => /* @__PURE__ */ k.createElement(nce, {
    key: g,
    chainId: g,
    currentChainId: n,
    switchChain: o,
    chainIconSize: f,
    isLoading: i === g,
    src: h,
    name: y,
    iconBackground: m,
    idx: v
  })), !d && /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    background: "generalBorderDim",
    height: "1",
    marginX: "8"
  }), /* @__PURE__ */ k.createElement(F5, {
    onClick: () => c(),
    testId: "chain-option-disconnect"
  }, /* @__PURE__ */ k.createElement(Z, {
    color: "error",
    fontFamily: "body",
    fontSize: "16",
    fontWeight: "bold"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "4",
    height: f
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    color: "error",
    height: f,
    justifyContent: "center",
    marginRight: "8"
  }, /* @__PURE__ */ k.createElement(Xae, {
    size: Number(f)
  })), /* @__PURE__ */ k.createElement("div", null, a.t("chains.disconnect"))))))))))) : null;
}
function oce(e, t) {
  const n = {};
  for (const r of e) {
    const i = t(r);
    i && (n[i] || (n[i] = []), n[i].push(r));
  }
  return n;
}
var j5 = ({
  children: e,
  href: t
}) => /* @__PURE__ */ k.createElement(Z, {
  as: "a",
  color: "accentColor",
  href: t,
  rel: "noreferrer",
  target: "_blank"
}, e), D5 = ({ children: e }) => /* @__PURE__ */ k.createElement(rt, {
  color: "modalTextSecondary",
  size: "12",
  weight: "medium"
}, e);
function bP({
  compactModeEnabled: e = !1,
  getWallet: t
}) {
  const { disclaimer: n, learnMoreUrl: r } = $e(lv), { i18n: i } = $e(ir);
  return /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    color: "accentColor",
    display: "flex",
    flexDirection: "column",
    height: "full",
    justifyContent: "space-around"
  }, /* @__PURE__ */ k.createElement(Z, {
    marginBottom: "10"
  }, !e && /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "18",
    weight: "heavy"
  }, i.t("intro.title"))), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "32",
    justifyContent: "center",
    marginY: "20",
    style: { maxWidth: 312 }
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "16"
  }, /* @__PURE__ */ k.createElement(Z, {
    borderRadius: "6",
    height: "48",
    minWidth: "48",
    width: "48"
  }, /* @__PURE__ */ k.createElement(bae, null)), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, i.t("intro.digital_asset.title")), /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, i.t("intro.digital_asset.description")))), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "16"
  }, /* @__PURE__ */ k.createElement(Z, {
    borderRadius: "6",
    height: "48",
    minWidth: "48",
    width: "48"
  }, /* @__PURE__ */ k.createElement(wae, null)), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, i.t("intro.login.title")), /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, i.t("intro.login.description"))))), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    margin: "10"
  }, /* @__PURE__ */ k.createElement(fi, {
    label: i.t("intro.get.label"),
    onClick: t
  }), /* @__PURE__ */ k.createElement(Z, {
    as: "a",
    className: kr({ active: "shrink", hover: "grow" }),
    display: "block",
    href: r,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, i.t("intro.learn_more.label")))), n && !e && /* @__PURE__ */ k.createElement(Z, {
    marginBottom: "8",
    marginTop: "12",
    textAlign: "center"
  }, /* @__PURE__ */ k.createElement(n, {
    Link: j5,
    Text: D5
  }))));
}
var nL = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "17",
  viewBox: "0 0 11 17",
  width: "11",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Back"), /* @__PURE__ */ k.createElement("path", {
  d: "M0.99707 8.6543C0.99707 9.08496 1.15527 9.44531 1.51562 9.79688L8.16016 16.3096C8.43262 16.5732 8.74902 16.7051 9.13574 16.7051C9.90918 16.7051 10.5508 16.0811 10.5508 15.3076C10.5508 14.9121 10.3838 14.5605 10.0938 14.2705L4.30176 8.64551L10.0938 3.0293C10.3838 2.74805 10.5508 2.3877 10.5508 2.00098C10.5508 1.23633 9.90918 0.603516 9.13574 0.603516C8.74902 0.603516 8.43262 0.735352 8.16016 0.999023L1.51562 7.51172C1.15527 7.85449 1.00586 8.21484 0.99707 8.6543Z",
  fill: "currentColor"
})), ace = () => /* @__PURE__ */ k.createElement("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 8 12",
  width: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ k.createElement("title", null, "Info"), /* @__PURE__ */ k.createElement("path", {
  d: "M3.64258 7.99609C4.19336 7.99609 4.5625 7.73828 4.68555 7.24609C4.69141 7.21094 4.70312 7.16406 4.70898 7.13477C4.80859 6.60742 5.05469 6.35547 6.04492 5.76367C7.14648 5.10156 7.67969 4.3457 7.67969 3.24414C7.67969 1.39844 6.17383 0.255859 3.95898 0.255859C2.32422 0.255859 1.05859 0.894531 0.548828 1.86719C0.396484 2.14844 0.320312 2.44727 0.320312 2.74023C0.314453 3.37305 0.742188 3.79492 1.42188 3.79492C1.91406 3.79492 2.33594 3.54883 2.53516 3.11523C2.78711 2.47656 3.23242 2.21289 3.83594 2.21289C4.55664 2.21289 5.10742 2.65234 5.10742 3.29102C5.10742 3.9707 4.7793 4.29883 3.81836 4.87891C3.02148 5.36523 2.50586 5.92773 2.50586 6.76562V6.90039C2.50586 7.55664 2.96289 7.99609 3.64258 7.99609ZM3.67188 11.4473C4.42773 11.4473 5.04297 10.8672 5.04297 10.1406C5.04297 9.41406 4.42773 8.83984 3.67188 8.83984C2.91602 8.83984 2.30664 9.41406 2.30664 10.1406C2.30664 10.8672 2.91602 11.4473 3.67188 11.4473Z",
  fill: "currentColor"
})), cce = ({
  "aria-label": e = "Info",
  onClick: t
}) => {
  const n = Br();
  return /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    "aria-label": e,
    as: "button",
    background: "closeButtonBackground",
    borderColor: "actionButtonBorder",
    borderRadius: "full",
    borderStyle: "solid",
    borderWidth: n ? "0" : "1",
    className: kr({ active: "shrinkSm", hover: "growLg" }),
    color: "closeButton",
    display: "flex",
    height: n ? "30" : "28",
    justifyContent: "center",
    onClick: t,
    style: { willChange: "transform" },
    transition: "default",
    type: "button",
    width: n ? "30" : "28"
  }, /* @__PURE__ */ k.createElement(ace, null));
}, rL = (e) => {
  const t = Le(null), n = $e(LU), r = k5(e);
  return We(() => {
    if (n && t.current && r)
      return uce(t.current, r);
  }, [n, r]), t;
}, lce = () => {
  const e = "_rk_coolMode", t = document.getElementById(e);
  if (t)
    return t;
  const n = document.createElement("div");
  return n.setAttribute("id", e), n.setAttribute("style", [
    "overflow:hidden",
    "position:fixed",
    "height:100%",
    "top:0",
    "left:0",
    "right:0",
    "bottom:0",
    "pointer-events:none",
    "z-index:2147483647"
  ].join(";")), document.body.appendChild(n), n;
}, vP = 0;
function uce(e, t) {
  vP++;
  const n = [15, 20, 25, 35, 45], r = 35;
  let i = [], s = !1, o = 0, a = 0;
  const c = lce();
  function l() {
    const w = n[Math.floor(Math.random() * n.length)], A = Math.random() * 10, E = Math.random() * 25, x = Math.random() * 360, S = Math.random() * 35 * (Math.random() <= 0.5 ? -1 : 1), P = a - w / 2, I = o - w / 2, R = Math.random() <= 0.5 ? -1 : 1, Q = document.createElement("div");
    Q.innerHTML = `<img src="${t}" width="${w}" height="${w}" style="border-radius: 25%">`, Q.setAttribute("style", [
      "position:absolute",
      "will-change:transform",
      `top:${P}px`,
      `left:${I}px`,
      `transform:rotate(${x}deg)`
    ].join(";")), c.appendChild(Q), i.push({
      direction: R,
      element: Q,
      left: I,
      size: w,
      speedHorz: A,
      speedUp: E,
      spinSpeed: S,
      spinVal: x,
      top: P
    });
  }
  function u() {
    for (const w of i)
      w.left = w.left - w.speedHorz * w.direction, w.top = w.top - w.speedUp, w.speedUp = Math.min(w.size, w.speedUp - 1), w.spinVal = w.spinVal + w.spinSpeed, w.top >= Math.max(window.innerHeight, document.body.clientHeight) + w.size && (i = i.filter((A) => A !== w), w.element.remove()), w.element.setAttribute("style", [
        "position:absolute",
        "will-change:transform",
        `top:${w.top}px`,
        `left:${w.left}px`,
        `transform:rotate(${w.spinVal}deg)`
      ].join(";"));
  }
  let d;
  function f() {
    s && i.length < r && l(), u(), d = requestAnimationFrame(f);
  }
  f();
  const p = "ontouchstart" in window || navigator.msMaxTouchPoints, m = p ? "touchstart" : "mousedown", h = p ? "touchend" : "mouseup", g = p ? "touchmove" : "mousemove", y = (w) => {
    var A, E;
    "touches" in w ? (o = (A = w.touches) == null ? void 0 : A[0].clientX, a = (E = w.touches) == null ? void 0 : E[0].clientY) : (o = w.clientX, a = w.clientY);
  }, v = (w) => {
    y(w), s = !0;
  }, b = () => {
    s = !1;
  };
  return e.addEventListener(g, y, { passive: !1 }), e.addEventListener(m, v), e.addEventListener(h, b), e.addEventListener("mouseleave", b), () => {
    e.removeEventListener(g, y), e.removeEventListener(m, v), e.removeEventListener(h, b), e.removeEventListener("mouseleave", b);
    const w = setInterval(() => {
      d && i.length === 0 && (cancelAnimationFrame(d), clearInterval(w), --vP === 0 && c.remove());
    }, 500);
  };
}
var dce = "g5kl0l0", iL = ({
  as: e = "button",
  currentlySelected: t = !1,
  iconBackground: n,
  iconUrl: r,
  name: i,
  onClick: s,
  ready: o,
  recent: a,
  testId: c,
  isRainbowKitConnector: l,
  ...u
}) => {
  const d = rL(r), [f, p] = qe(!1), { i18n: m } = $e(ir);
  return /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    onMouseEnter: () => p(!0),
    onMouseLeave: () => p(!1),
    ref: d
  }, /* @__PURE__ */ k.createElement(Z, {
    as: e,
    borderRadius: "menuButton",
    borderStyle: "solid",
    borderWidth: "1",
    className: t ? void 0 : [
      dce,
      kr({
        active: "shrink"
      })
    ],
    disabled: t,
    onClick: s,
    padding: "5",
    style: { willChange: "transform" },
    testId: c,
    transition: "default",
    width: "full",
    ...t ? {
      background: "accentColor",
      borderColor: "selectedOptionBorder",
      boxShadow: "selectedWallet"
    } : {
      background: { hover: "menuItemBackground" }
    },
    ...u
  }, /* @__PURE__ */ k.createElement(Z, {
    color: t ? "accentColorForeground" : "modalText",
    disabled: !o,
    fontFamily: "body",
    fontSize: "16",
    fontWeight: "bold",
    transition: "default"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "12"
  }, /* @__PURE__ */ k.createElement(gr, {
    background: n,
    ...!f && l ? { borderColor: "actionButtonBorder" } : {},
    useAsImage: !l,
    borderRadius: "6",
    height: "28",
    src: r,
    width: "28"
  }), /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(Z, {
    style: { marginTop: a ? -2 : void 0 },
    maxWidth: "200"
  }, i), a && /* @__PURE__ */ k.createElement(rt, {
    color: t ? "accentColorForeground" : "accentColor",
    size: "12",
    style: { lineHeight: 1, marginTop: -1 },
    weight: "medium"
  }, m.t("connect.recent")))))));
};
iL.displayName = "ModalSelection";
var fce = "rk-latest-id";
function hce(e) {
  localStorage.setItem(fce, e);
}
var X3 = (e, t = 1) => {
  let n = e.replace("#", "");
  n.length === 3 && (n = `${n[0]}${n[0]}${n[1]}${n[1]}${n[2]}${n[2]}`);
  const r = parseInt(n.substring(0, 2), 16), i = parseInt(n.substring(2, 4), 16), s = parseInt(n.substring(4, 6), 16);
  return t > 1 && t <= 100 && (t = t / 100), `rgba(${r},${i},${s},${t})`;
}, pce = (e) => e ? [
  X3(e, 0.2),
  X3(e, 0.14),
  X3(e, 0.1)
] : null, sL = async () => (await import("./connect-XNDTNVUH-xhA2Kr1U.js")).default, mce = () => ba(sL), gce = () => /* @__PURE__ */ k.createElement(gr, {
  background: "#515a70",
  borderColor: "generalBorder",
  borderRadius: "10",
  height: "48",
  src: sL,
  width: "48"
}), oL = async () => (await import("./create-PAJXJDV3-BxhC9SAD.js")).default, aL = () => ba(oL), yce = () => /* @__PURE__ */ k.createElement(gr, {
  background: "#e3a5e8",
  borderColor: "generalBorder",
  borderRadius: "10",
  height: "48",
  src: oL,
  width: "48"
}), cL = async () => (await import("./refresh-5KGGHTJP-BjAJJ9Ym.js")).default, bce = () => ba(cL), vce = () => /* @__PURE__ */ k.createElement(gr, {
  background: "#515a70",
  borderColor: "generalBorder",
  borderRadius: "10",
  height: "48",
  src: cL,
  width: "48"
}), lL = async () => (await import("./scan-HZBLXLM4-BkAjxYs6.js")).default, uL = () => ba(lL), wce = () => /* @__PURE__ */ k.createElement(gr, {
  background: "#515a70",
  borderColor: "generalBorder",
  borderRadius: "10",
  height: "48",
  src: lL,
  width: "48"
}), xce = "_1vwt0cg0", Ace = "_1vwt0cg2 ju367v7a ju367v7v", Ece = "_1vwt0cg3", _ce = "_1vwt0cg4", Sce = (e, t) => {
  const n = Array.prototype.slice.call(av.create(e, { errorCorrectionLevel: t }).modules.data, 0), r = Math.sqrt(n.length);
  return n.reduce((i, s, o) => (o % r === 0 ? i.push([s]) : i[i.length - 1].push(s)) && i, []);
};
function dL({
  ecl: e = "M",
  logoBackground: t,
  logoMargin: n = 10,
  logoSize: r = 50,
  logoUrl: i,
  size: s = 200,
  uri: o
}) {
  const a = "20", c = s - parseInt(a, 10) * 2, l = ot(() => {
    const f = [], p = Sce(o, e), m = c / p.length;
    [
      { x: 0, y: 0 },
      { x: 1, y: 0 },
      { x: 0, y: 1 }
    ].forEach(({ x: b, y: w }) => {
      const A = (p.length - 7) * m * b, E = (p.length - 7) * m * w;
      for (let x = 0; x < 3; x++)
        f.push(/* @__PURE__ */ k.createElement("rect", {
          fill: x % 2 !== 0 ? "white" : "black",
          height: m * (7 - x * 2),
          key: `${x}-${b}-${w}`,
          rx: (x - 2) * -5 + (x === 0 ? 2 : 0),
          ry: (x - 2) * -5 + (x === 0 ? 2 : 0),
          width: m * (7 - x * 2),
          x: A + m * x,
          y: E + m * x
        }));
    });
    const g = Math.floor((r + 25) / m), y = p.length / 2 - g / 2, v = p.length / 2 + g / 2 - 1;
    return p.forEach((b, w) => {
      b.forEach((A, E) => {
        p[w][E] && (w < 7 && E < 7 || w > p.length - 8 && E < 7 || w < 7 && E > p.length - 8 || w > y && w < v && E > y && E < v || f.push(/* @__PURE__ */ k.createElement("circle", {
          cx: w * m + m / 2,
          cy: E * m + m / 2,
          fill: "black",
          key: `circle-${w}-${E}`,
          r: m / 3
        })));
      });
    }), f;
  }, [e, r, c, o]), u = c / 2 - r / 2, d = r + n * 2;
  return /* @__PURE__ */ k.createElement(Z, {
    borderColor: "generalBorder",
    borderRadius: "menuButton",
    borderStyle: "solid",
    borderWidth: "1",
    className: xce,
    padding: a,
    width: "max"
  }, /* @__PURE__ */ k.createElement(Z, {
    style: {
      height: c,
      userSelect: "none",
      width: c
    },
    userSelect: "none"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    style: {
      height: 0,
      top: u,
      width: c
    },
    width: "full"
  }, /* @__PURE__ */ k.createElement(gr, {
    background: t,
    borderColor: { custom: "rgba(0, 0, 0, 0.06)" },
    borderRadius: "13",
    height: r,
    src: i,
    width: r
  })), /* @__PURE__ */ k.createElement("svg", {
    height: c,
    style: { all: "revert" },
    width: c
  }, /* @__PURE__ */ k.createElement("title", null, "QR Code"), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", {
    id: "clip-wrapper"
  }, /* @__PURE__ */ k.createElement("rect", {
    height: d,
    width: d
  })), /* @__PURE__ */ k.createElement("clipPath", {
    id: "clip-logo"
  }, /* @__PURE__ */ k.createElement("rect", {
    height: r,
    width: r
  }))), /* @__PURE__ */ k.createElement("rect", {
    fill: "transparent",
    height: c,
    width: c
  }), l)));
}
var fL = async () => {
  switch (N5()) {
    case "Arc":
      return (await import("./Arc-QDJFTGH2-B3qoTb3x.js")).default;
    case "Brave":
      return (await import("./Brave-YATE5BIM-JdIMHIr4.js")).default;
    case "Chrome":
      return (await import("./Chrome-LGF33C3S-D244uvn1.js")).default;
    case "Edge":
      return (await import("./Edge-K2JEGI5S-I8skix0T.js")).default;
    case "Firefox":
      return (await import("./Firefox-NP5SYEK5-Du8OV87p.js")).default;
    case "Opera":
      return (await import("./Opera-KV54PXPA-C6y5Iae1.js")).default;
    case "Safari":
      return (await import("./Safari-2QIYKJ4P-Dot2kOTX.js")).default;
    default:
      return (await import("./Browser-HN7O5MN7-ghPxJi-f.js")).default;
  }
}, Cce = () => ba(fL), hL = async () => {
  switch (M5()) {
    case "Windows":
      return (await import("./Windows-R3CKAIUV-DsD0E-H7.js")).default;
    case "macOS":
      return (await import("./Macos-2KTZ2XLP-DX5CQefg.js")).default;
    case "Linux":
      return (await import("./Linux-NS2LQPT4-poCe8Y5Z.js")).default;
    default:
      return (await import("./Linux-NS2LQPT4-poCe8Y5Z.js")).default;
  }
}, Tce = () => ba(hL);
function kce({
  getWalletDownload: e,
  compactModeEnabled: t
}) {
  const r = YA().filter((s) => s.isRainbowKitConnector).splice(0, 5), { i18n: i } = $e(ir);
  return /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    marginTop: "18",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    width: "full"
  }, r == null ? void 0 : r.filter((s) => {
    var o;
    return s.extensionDownloadUrl || s.desktopDownloadUrl || s.qrCode && ((o = s.downloadUrls) == null ? void 0 : o.qrCode);
  }).map((s) => {
    const { downloadUrls: o, iconBackground: a, iconUrl: c, id: l, name: u, qrCode: d } = s, f = (o == null ? void 0 : o.qrCode) && d, p = !!s.extensionDownloadUrl, m = (o == null ? void 0 : o.qrCode) && p, h = (o == null ? void 0 : o.qrCode) && !!s.desktopDownloadUrl;
    return /* @__PURE__ */ k.createElement(Z, {
      alignItems: "center",
      display: "flex",
      gap: "16",
      justifyContent: "space-between",
      key: s.id,
      width: "full"
    }, /* @__PURE__ */ k.createElement(Z, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16"
    }, /* @__PURE__ */ k.createElement(gr, {
      background: a,
      borderColor: "actionButtonBorder",
      borderRadius: "10",
      height: "48",
      src: c,
      width: "48"
    }), /* @__PURE__ */ k.createElement(Z, {
      display: "flex",
      flexDirection: "column",
      gap: "2"
    }, /* @__PURE__ */ k.createElement(rt, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, u), /* @__PURE__ */ k.createElement(rt, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, m ? i.t("get.mobile_and_extension.description") : h ? i.t("get.mobile_and_desktop.description") : f ? i.t("get.mobile.description") : p ? i.t("get.extension.description") : null))), /* @__PURE__ */ k.createElement(Z, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */ k.createElement(fi, {
      label: i.t("get.action.label"),
      onClick: () => e(l),
      type: "secondary"
    })));
  })), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "column",
    gap: "8",
    justifyContent: "space-between",
    marginBottom: "4",
    paddingY: "8",
    style: { maxWidth: 275, textAlign: "center" }
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, i.t("get.looking_for.title")), /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, t ? i.t("get.looking_for.desktop.compact_description") : i.t("get.looking_for.desktop.wide_description"))));
}
var e_ = "44";
function Bce({
  changeWalletStep: e,
  compactModeEnabled: t,
  connectionError: n,
  onClose: r,
  qrCodeUri: i,
  reconnect: s,
  wallet: o
}) {
  const {
    downloadUrls: a,
    iconBackground: c,
    iconUrl: l,
    name: u,
    qrCode: d,
    ready: f,
    showWalletConnectModal: p,
    getDesktopUri: m
  } = o, h = !!m, g = O5(), { i18n: y } = $e(ir), v = !!o.extensionDownloadUrl, b = (a == null ? void 0 : a.qrCode) && v, w = (a == null ? void 0 : a.qrCode) && !!o.desktopDownloadUrl, A = d && i, E = async () => {
    const I = await (m == null ? void 0 : m());
    window.open(I, g ? "_blank" : "_self");
  }, x = p ? {
    description: t ? y.t("connect.walletconnect.description.compact") : y.t("connect.walletconnect.description.full"),
    label: y.t("connect.walletconnect.open.label"),
    onClick: () => {
      r(), p();
    }
  } : A ? {
    description: y.t("connect.secondary_action.get.description", {
      wallet: u
    }),
    label: y.t("connect.secondary_action.get.label"),
    onClick: () => e(
      b || w ? "DOWNLOAD_OPTIONS" : "DOWNLOAD"
      /* Download */
    )
  } : null, { width: S } = zU(), P = S && S < 768;
  return We(() => {
    Cce(), Tce();
  }, []), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, A ? /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    height: "full",
    justifyContent: "center"
  }, /* @__PURE__ */ k.createElement(dL, {
    logoBackground: c,
    logoSize: t ? 60 : 72,
    logoUrl: l,
    size: t ? 318 : P ? Math.max(280, Math.min(S - 308, 382)) : 382,
    uri: i
  })) : /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "8"
  }, /* @__PURE__ */ k.createElement(Z, {
    borderRadius: "10",
    height: e_,
    overflow: "hidden"
  }, /* @__PURE__ */ k.createElement(gr, {
    useAsImage: !o.isRainbowKitConnector,
    height: e_,
    src: l,
    width: e_
  })), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "4",
    paddingX: "32",
    style: { textAlign: "center" }
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "18",
    weight: "bold"
  }, f ? y.t("connect.status.opening", {
    wallet: u
  }) : v ? y.t("connect.status.not_installed", {
    wallet: u
  }) : y.t("connect.status.not_available", {
    wallet: u
  })), !f && v ? /* @__PURE__ */ k.createElement(Z, {
    paddingTop: "20"
  }, /* @__PURE__ */ k.createElement(fi, {
    href: o.extensionDownloadUrl,
    label: y.t("connect.secondary_action.install.label"),
    type: "secondary"
  })) : null, f && !A && /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    textAlign: "center",
    weight: "medium"
  }, y.t("connect.status.confirm"))), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    color: "modalText",
    display: "flex",
    flexDirection: "row",
    height: "32",
    marginTop: "8"
  }, n ? /* @__PURE__ */ k.createElement(fi, {
    label: y.t("connect.secondary_action.retry.label"),
    onClick: async () => {
      h && E(), s(o);
    }
  }) : /* @__PURE__ */ k.createElement(Z, {
    color: "modalTextSecondary"
  }, /* @__PURE__ */ k.createElement(fy, null))))))), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "row",
    gap: "8",
    height: "28",
    justifyContent: "space-between",
    marginTop: "12"
  }, f && x && /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, x.description), /* @__PURE__ */ k.createElement(fi, {
    label: x.label,
    onClick: x.onClick,
    type: "secondary"
  }))));
}
var t_ = ({
  actionLabel: e,
  description: t,
  iconAccent: n,
  iconBackground: r,
  iconUrl: i,
  isCompact: s,
  onAction: o,
  title: a,
  url: c,
  variant: l
}) => {
  const u = l === "browser", d = !u && n && pce(n);
  return /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    borderRadius: "13",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    paddingX: s ? "18" : "44",
    position: "relative",
    style: { flex: 1, isolation: "isolate" },
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    borderColor: "actionButtonBorder",
    borderRadius: "13",
    borderStyle: "solid",
    borderWidth: "1",
    style: {
      bottom: "0",
      left: "0",
      position: "absolute",
      right: "0",
      top: "0",
      zIndex: 1
    }
  }), u && /* @__PURE__ */ k.createElement(Z, {
    background: "downloadTopCardBackground",
    height: "full",
    position: "absolute",
    style: {
      zIndex: 0
    },
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    style: {
      bottom: "0",
      filter: "blur(20px)",
      left: "0",
      position: "absolute",
      right: "0",
      top: "0",
      transform: "translate3d(0, 0, 0)"
    }
  }, /* @__PURE__ */ k.createElement(Z, {
    style: {
      filter: "blur(100px)",
      marginLeft: -27,
      marginTop: -20,
      opacity: 0.6,
      transform: "translate3d(0, 0, 0)"
    }
  }, /* @__PURE__ */ k.createElement(gr, {
    borderRadius: "full",
    height: "200",
    src: i,
    width: "200"
  })), /* @__PURE__ */ k.createElement(Z, {
    style: {
      filter: "blur(100px)",
      marginRight: 0,
      marginTop: 105,
      opacity: 0.6,
      overflow: "auto",
      transform: "translate3d(0, 0, 0)"
    }
  }, /* @__PURE__ */ k.createElement(gr, {
    borderRadius: "full",
    height: "200",
    src: i,
    width: "200"
  })))), !u && d && /* @__PURE__ */ k.createElement(Z, {
    background: "downloadBottomCardBackground",
    style: {
      bottom: "0",
      left: "0",
      position: "absolute",
      right: "0",
      top: "0"
    }
  }, /* @__PURE__ */ k.createElement(Z, {
    position: "absolute",
    style: {
      background: `radial-gradient(50% 50% at 50% 50%, ${d[0]} 0%, ${d[1]} 25%, rgba(0,0,0,0) 100%)`,
      height: 564,
      left: -215,
      top: -197,
      transform: "translate3d(0, 0, 0)",
      width: 564
    }
  }), /* @__PURE__ */ k.createElement(Z, {
    position: "absolute",
    style: {
      background: `radial-gradient(50% 50% at 50% 50%, ${d[2]} 0%, rgba(0, 0, 0, 0) 100%)`,
      height: 564,
      left: -1,
      top: -76,
      transform: "translate3d(0, 0, 0)",
      width: 564
    }
  })), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    gap: "24",
    height: "max",
    justifyContent: "center",
    style: { zIndex: 1 }
  }, /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(gr, {
    height: "60",
    src: i,
    width: "60",
    ...r ? {
      background: r,
      borderColor: "generalBorder",
      borderRadius: "10"
    } : null
  })), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "4",
    style: { flex: 1 },
    width: "full"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, a), /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, t), /* @__PURE__ */ k.createElement(Z, {
    marginTop: "14",
    width: "max"
  }, /* @__PURE__ */ k.createElement(fi, {
    href: c,
    label: e,
    onClick: o,
    size: "medium"
  })))));
};
function Ice({
  changeWalletStep: e,
  wallet: t
}) {
  const n = N5(), r = M5(), s = $e(KA) === "compact", {
    desktop: o,
    desktopDownloadUrl: a,
    extension: c,
    extensionDownloadUrl: l,
    mobileDownloadUrl: u
  } = t, { i18n: d } = $e(ir);
  return We(() => {
    aL(), uL(), bce(), mce();
  }, []), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "24",
    height: "full",
    marginBottom: "8",
    marginTop: "4",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "8",
    height: "full",
    justifyContent: "center",
    width: "full"
  }, l && /* @__PURE__ */ k.createElement(t_, {
    actionLabel: d.t("get_options.extension.download.label", {
      browser: n
    }),
    description: d.t("get_options.extension.description"),
    iconUrl: fL,
    isCompact: s,
    onAction: () => e(
      c != null && c.instructions ? "INSTRUCTIONS_EXTENSION" : "CONNECT"
      /* Connect */
    ),
    title: d.t("get_options.extension.title", {
      wallet: t.name,
      browser: n
    }),
    url: l,
    variant: "browser"
  }), a && /* @__PURE__ */ k.createElement(t_, {
    actionLabel: d.t("get_options.desktop.download.label", {
      platform: r
    }),
    description: d.t("get_options.desktop.description"),
    iconUrl: hL,
    isCompact: s,
    onAction: () => e(
      o != null && o.instructions ? "INSTRUCTIONS_DESKTOP" : "CONNECT"
      /* Connect */
    ),
    title: d.t("get_options.desktop.title", {
      wallet: t.name,
      platform: r
    }),
    url: a,
    variant: "desktop"
  }), u && /* @__PURE__ */ k.createElement(t_, {
    actionLabel: d.t("get_options.mobile.download.label", {
      wallet: t.name
    }),
    description: d.t("get_options.mobile.description"),
    iconAccent: t.iconAccent,
    iconBackground: t.iconBackground,
    iconUrl: t.iconUrl,
    isCompact: s,
    onAction: () => {
      e(
        "DOWNLOAD"
        /* Download */
      );
    },
    title: d.t("get_options.mobile.title", { wallet: t.name }),
    variant: "app"
  })));
}
function Pce({
  changeWalletStep: e,
  wallet: t
}) {
  const { downloadUrls: n, qrCode: r } = t, { i18n: i } = $e(ir);
  return We(() => {
    aL(), uL();
  }, []), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "24",
    height: "full",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    style: { maxWidth: 220, textAlign: "center" }
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "semibold"
  }, i.t("get_mobile.description"))), /* @__PURE__ */ k.createElement(Z, {
    height: "full"
  }, n != null && n.qrCode ? /* @__PURE__ */ k.createElement(dL, {
    logoSize: 0,
    size: 268,
    uri: n.qrCode
  }) : null), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "row",
    gap: "8",
    height: "34",
    justifyContent: "space-between",
    marginBottom: "12",
    paddingY: "8"
  }, /* @__PURE__ */ k.createElement(fi, {
    label: i.t("get_mobile.continue.label"),
    onClick: () => e(
      r != null && r.instructions ? "INSTRUCTIONS_MOBILE" : "CONNECT"
      /* Connect */
    )
  })));
}
var vm = {
  connect: () => /* @__PURE__ */ k.createElement(gce, null),
  create: () => /* @__PURE__ */ k.createElement(yce, null),
  install: (e) => /* @__PURE__ */ k.createElement(gr, {
    background: e.iconBackground,
    borderColor: "generalBorder",
    borderRadius: "10",
    height: "48",
    src: e.iconUrl,
    width: "48"
  }),
  refresh: () => /* @__PURE__ */ k.createElement(vce, null),
  scan: () => /* @__PURE__ */ k.createElement(wce, null)
};
function Oce({
  connectWallet: e,
  wallet: t
}) {
  var n, r, i, s;
  const { i18n: o } = $e(ir);
  return /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    justifyContent: "center",
    paddingY: "32",
    style: { maxWidth: 320 }
  }, (r = (n = t == null ? void 0 : t.qrCode) == null ? void 0 : n.instructions) == null ? void 0 : r.steps.map((a, c) => {
    var l;
    return /* @__PURE__ */ k.createElement(Z, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16",
      key: c
    }, /* @__PURE__ */ k.createElement(Z, {
      borderRadius: "10",
      height: "48",
      minWidth: "48",
      overflow: "hidden",
      position: "relative",
      width: "48"
    }, (l = vm[a.step]) == null ? void 0 : l.call(vm, t)), /* @__PURE__ */ k.createElement(Z, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */ k.createElement(rt, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, o.t(a.title, void 0, {
      rawKeyIfTranslationMissing: !0
    })), /* @__PURE__ */ k.createElement(rt, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, o.t(a.description, void 0, {
      rawKeyIfTranslationMissing: !0
    }))));
  })), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    marginBottom: "16"
  }, /* @__PURE__ */ k.createElement(fi, {
    label: o.t("get_instructions.mobile.connect.label"),
    onClick: () => e(t)
  }), /* @__PURE__ */ k.createElement(Z, {
    as: "a",
    className: kr({ active: "shrink", hover: "grow" }),
    display: "block",
    href: (s = (i = t == null ? void 0 : t.qrCode) == null ? void 0 : i.instructions) == null ? void 0 : s.learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, o.t("get_instructions.mobile.learn_more.label")))));
}
function Nce({
  wallet: e
}) {
  var t, n, r, i;
  const { i18n: s } = $e(ir);
  return /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    justifyContent: "center",
    paddingY: "32",
    style: { maxWidth: 320 }
  }, (n = (t = e == null ? void 0 : e.extension) == null ? void 0 : t.instructions) == null ? void 0 : n.steps.map((o, a) => {
    var c;
    return /* @__PURE__ */ k.createElement(Z, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16",
      key: a
    }, /* @__PURE__ */ k.createElement(Z, {
      borderRadius: "10",
      height: "48",
      minWidth: "48",
      overflow: "hidden",
      position: "relative",
      width: "48"
    }, (c = vm[o.step]) == null ? void 0 : c.call(vm, e)), /* @__PURE__ */ k.createElement(Z, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */ k.createElement(rt, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, s.t(o.title, void 0, {
      rawKeyIfTranslationMissing: !0
    })), /* @__PURE__ */ k.createElement(rt, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, s.t(o.description, void 0, {
      rawKeyIfTranslationMissing: !0
    }))));
  })), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    marginBottom: "16"
  }, /* @__PURE__ */ k.createElement(fi, {
    label: s.t("get_instructions.extension.refresh.label"),
    onClick: window.location.reload.bind(window.location)
  }), /* @__PURE__ */ k.createElement(Z, {
    as: "a",
    className: kr({ active: "shrink", hover: "grow" }),
    display: "block",
    href: (i = (r = e == null ? void 0 : e.extension) == null ? void 0 : r.instructions) == null ? void 0 : i.learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, s.t("get_instructions.extension.learn_more.label")))));
}
function Rce({
  connectWallet: e,
  wallet: t
}) {
  var n, r, i, s;
  const { i18n: o } = $e(ir);
  return /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    justifyContent: "center",
    paddingY: "32",
    style: { maxWidth: 320 }
  }, (r = (n = t == null ? void 0 : t.desktop) == null ? void 0 : n.instructions) == null ? void 0 : r.steps.map((a, c) => {
    var l;
    return /* @__PURE__ */ k.createElement(Z, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16",
      key: c
    }, /* @__PURE__ */ k.createElement(Z, {
      borderRadius: "10",
      height: "48",
      minWidth: "48",
      overflow: "hidden",
      position: "relative",
      width: "48"
    }, (l = vm[a.step]) == null ? void 0 : l.call(vm, t)), /* @__PURE__ */ k.createElement(Z, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */ k.createElement(rt, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, o.t(a.title, void 0, {
      rawKeyIfTranslationMissing: !0
    })), /* @__PURE__ */ k.createElement(rt, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, o.t(a.description, void 0, {
      rawKeyIfTranslationMissing: !0
    }))));
  })), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    marginBottom: "16"
  }, /* @__PURE__ */ k.createElement(fi, {
    label: o.t("get_instructions.desktop.connect.label"),
    onClick: () => e(t)
  }), /* @__PURE__ */ k.createElement(Z, {
    as: "a",
    className: kr({ active: "shrink", hover: "grow" }),
    display: "block",
    href: (s = (i = t == null ? void 0 : t.desktop) == null ? void 0 : i.instructions) == null ? void 0 : s.learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, o.t("get_instructions.desktop.learn_more.label")))));
}
function Mce({ onClose: e }) {
  const t = "rk_connect_title", [n, r] = qe(), [i, s] = qe(), [o, a] = qe(), c = !!(i != null && i.qrCode) && o, [l, u] = qe(!1), f = $e(KA) === dv.COMPACT, { disclaimer: p } = $e(lv), { i18n: m } = $e(ir), h = O5(), g = Le(!1), { connector: y } = $e(uv), b = YA(!y).filter((he) => he.ready || !!he.extensionDownloadUrl).sort((he, B) => he.groupIndex - B.groupIndex), w = oce(b, (he) => he.groupName), A = [
    "Recommended",
    "Other",
    "Popular",
    "More",
    "Others",
    "Installed"
  ];
  We(() => {
    y && !g.current && (Q(
      "CONNECT"
      /* Connect */
    ), P(y), g.current = !0);
  }, [y]);
  const E = (he) => {
    var B, be;
    u(!1), he.ready && ((be = (B = he == null ? void 0 : he.connect) == null ? void 0 : B.call(he)) == null || be.catch(() => {
      u(!0);
    }));
  }, x = async (he) => {
    const B = b.find((be) => he.id === be.id);
    B != null && B.getDesktopUri && setTimeout(async () => {
      var be;
      const Be = await ((be = B == null ? void 0 : B.getDesktopUri) == null ? void 0 : be.call(B));
      Be && window.open(Be, h ? "_blank" : "_self");
    }, 0);
  }, S = async (he) => {
    var B;
    const be = b.find((Ne) => he.id === Ne.id), Be = await ((B = be == null ? void 0 : be.getQrCodeUri) == null ? void 0 : B.call(be));
    a(Be), setTimeout(() => {
      s(be), Q(
        "CONNECT"
        /* Connect */
      );
    }, Be ? 0 : 50);
  }, P = async (he) => {
    hce(he.id), he.ready && (S(he), x(he)), E(he), r(he.id), he.ready || (s(he), Q(
      he != null && he.extensionDownloadUrl ? "DOWNLOAD_OPTIONS" : "CONNECT"
      /* Connect */
    ));
  }, I = (he) => {
    var B;
    r(he);
    const be = b.find((Ce) => he === Ce.id), Be = (B = be == null ? void 0 : be.downloadUrls) == null ? void 0 : B.qrCode, Ne = !!(be != null && be.desktopDownloadUrl), _e = !!(be != null && be.extensionDownloadUrl);
    s(be), Q(
      Be && (_e || Ne) ? "DOWNLOAD_OPTIONS" : Be ? "DOWNLOAD" : Ne ? "INSTRUCTIONS_DESKTOP" : "INSTRUCTIONS_EXTENSION"
      /* DownloadOptions */
    );
  }, R = () => {
    r(void 0), s(void 0), a(void 0);
  }, Q = (he, B = !1) => {
    B && he === "GET" && J === "GET" ? R() : !B && he === "GET" ? we(
      "GET"
      /* Get */
    ) : !B && he === "CONNECT" && we(
      "CONNECT"
      /* Connect */
    ), L(he);
  }, [J, we] = qe(
    "NONE"
    /* None */
  ), [V, L] = qe(
    "NONE"
    /* None */
  );
  let U = null, q = null, G = null, ae;
  We(() => {
    u(!1);
  }, [V, i]);
  const Ae = !!(!!(i != null && i.extensionDownloadUrl) && (i != null && i.mobileDownloadUrl));
  switch (V) {
    case "NONE":
      U = /* @__PURE__ */ k.createElement(bP, {
        getWallet: () => Q(
          "GET"
          /* Get */
        )
      });
      break;
    case "LEARN_COMPACT":
      U = /* @__PURE__ */ k.createElement(bP, {
        compactModeEnabled: f,
        getWallet: () => Q(
          "GET"
          /* Get */
        )
      }), q = m.t("intro.title"), G = "NONE";
      break;
    case "GET":
      U = /* @__PURE__ */ k.createElement(kce, {
        getWalletDownload: I,
        compactModeEnabled: f
      }), q = m.t("get.title"), G = f ? "LEARN_COMPACT" : "NONE";
      break;
    case "CONNECT":
      U = i && /* @__PURE__ */ k.createElement(Bce, {
        changeWalletStep: Q,
        compactModeEnabled: f,
        connectionError: l,
        onClose: e,
        qrCodeUri: o,
        reconnect: E,
        wallet: i
      }), q = c && (i.name === "WalletConnect" ? m.t("connect_scan.fallback_title") : m.t("connect_scan.title", {
        wallet: i.name
      })), G = f ? y ? null : "NONE" : null, ae = f ? y ? () => {
      } : R : () => {
      };
      break;
    case "DOWNLOAD_OPTIONS":
      U = i && /* @__PURE__ */ k.createElement(Ice, {
        changeWalletStep: Q,
        wallet: i
      }), q = i && m.t("get_options.short_title", { wallet: i.name }), G = y ? "CONNECT" : f ? "NONE" : null;
      break;
    case "DOWNLOAD":
      U = i && /* @__PURE__ */ k.createElement(Pce, {
        changeWalletStep: Q,
        wallet: i
      }), q = i && m.t("get_mobile.title", { wallet: i.name }), G = Ae ? "DOWNLOAD_OPTIONS" : J;
      break;
    case "INSTRUCTIONS_MOBILE":
      U = i && /* @__PURE__ */ k.createElement(Oce, {
        connectWallet: P,
        wallet: i
      }), q = i && m.t("get_options.title", {
        wallet: f && i.shortName || i.name
      }), G = "DOWNLOAD";
      break;
    case "INSTRUCTIONS_EXTENSION":
      U = i && /* @__PURE__ */ k.createElement(Nce, {
        wallet: i
      }), q = i && m.t("get_options.title", {
        wallet: f && i.shortName || i.name
      }), G = "DOWNLOAD_OPTIONS";
      break;
    case "INSTRUCTIONS_DESKTOP":
      U = i && /* @__PURE__ */ k.createElement(Rce, {
        connectWallet: P,
        wallet: i
      }), q = i && m.t("get_options.title", {
        wallet: f && i.shortName || i.name
      }), G = "DOWNLOAD_OPTIONS";
      break;
  }
  return /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "row",
    style: { maxHeight: f ? 468 : 504 }
  }, (f ? V === "NONE" : !0) && /* @__PURE__ */ k.createElement(Z, {
    className: f ? _ce : Ece,
    display: "flex",
    flexDirection: "column",
    marginTop: "16"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    justifyContent: "space-between"
  }, f && p && /* @__PURE__ */ k.createElement(Z, {
    marginLeft: "16",
    width: "28"
  }, /* @__PURE__ */ k.createElement(cce, {
    onClick: () => Q(
      "LEARN_COMPACT"
      /* LearnCompact */
    )
  })), f && !p && /* @__PURE__ */ k.createElement(Z, {
    marginLeft: "16",
    width: "28"
  }), /* @__PURE__ */ k.createElement(Z, {
    marginLeft: f ? "0" : "6",
    paddingBottom: "8",
    paddingTop: "2",
    paddingX: "18"
  }, /* @__PURE__ */ k.createElement(rt, {
    as: "h1",
    color: "modalText",
    id: t,
    size: "18",
    weight: "heavy",
    testId: "connect-header-label"
  }, m.t("connect.title"))), f && /* @__PURE__ */ k.createElement(Z, {
    marginRight: "16"
  }, /* @__PURE__ */ k.createElement(sf, {
    onClose: e
  }))), /* @__PURE__ */ k.createElement(Z, {
    className: Ace,
    paddingBottom: "18"
  }, Object.entries(w).map(([he, B], be) => B.length > 0 && /* @__PURE__ */ k.createElement(Xd, {
    key: be
  }, he ? /* @__PURE__ */ k.createElement(Z, {
    marginBottom: "8",
    marginTop: "16",
    marginX: "6"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: he === "Installed" ? "accentColor" : "modalTextSecondary",
    size: "14",
    weight: "bold"
  }, A.includes(he) ? m.t(`connector_group.${he.toLowerCase()}`) : he)) : null, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, B.map((Be) => /* @__PURE__ */ k.createElement(iL, {
    currentlySelected: Be.id === n,
    iconBackground: Be.iconBackground,
    iconUrl: Be.iconUrl,
    key: Be.id,
    name: Be.name,
    onClick: () => P(Be),
    ready: Be.ready,
    recent: Be.recent,
    testId: `wallet-option-${Be.id}`,
    isRainbowKitConnector: Be.isRainbowKitConnector
  })))))), f && /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Z, {
    background: "generalBorder",
    height: "1",
    marginTop: "-1"
  }), p ? /* @__PURE__ */ k.createElement(Z, {
    paddingX: "24",
    paddingY: "16",
    textAlign: "center"
  }, /* @__PURE__ */ k.createElement(p, {
    Link: j5,
    Text: D5
  })) : /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    paddingX: "24",
    paddingY: "16"
  }, /* @__PURE__ */ k.createElement(Z, {
    paddingY: "4"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, m.t("connect.new_to_ethereum.description"))), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "4",
    justifyContent: "center"
  }, /* @__PURE__ */ k.createElement(Z, {
    className: kr({
      active: "shrink",
      hover: "grow"
    }),
    cursor: "pointer",
    onClick: () => Q(
      "LEARN_COMPACT"
      /* LearnCompact */
    ),
    paddingY: "4",
    style: { willChange: "transform" },
    transition: "default"
  }, /* @__PURE__ */ k.createElement(rt, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, m.t("connect.new_to_ethereum.learn_more.label"))))))), (f ? V !== "NONE" : !0) && /* @__PURE__ */ k.createElement(k.Fragment, null, !f && /* @__PURE__ */ k.createElement(Z, {
    background: "generalBorder",
    minWidth: "1",
    width: "1"
  }), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    margin: "16",
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12"
  }, /* @__PURE__ */ k.createElement(Z, {
    width: "28"
  }, G && /* @__PURE__ */ k.createElement(Z, {
    as: "button",
    className: kr({
      active: "shrinkSm",
      hover: "growLg"
    }),
    color: "accentColor",
    onClick: () => {
      G && Q(G, !0), ae == null || ae();
    },
    paddingX: "8",
    paddingY: "4",
    style: {
      boxSizing: "content-box",
      height: 17,
      willChange: "transform"
    },
    transition: "default",
    type: "button"
  }, /* @__PURE__ */ k.createElement(nL, null))), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    justifyContent: "center",
    style: { flexGrow: 1 }
  }, q && /* @__PURE__ */ k.createElement(rt, {
    color: "modalText",
    size: "18",
    textAlign: "center",
    weight: "heavy"
  }, q)), /* @__PURE__ */ k.createElement(sf, {
    onClose: e
  })), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    style: { minHeight: f ? 396 : 432 }
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "6",
    height: "full",
    justifyContent: "center",
    marginX: "8"
  }, U)))));
}
var Fce = "_1am14412", jce = "_1am14410", Dce = "_1am14413", Uce = ({ wallet: e }) => /* @__PURE__ */ k.createElement("svg", {
  className: Dce,
  viewBox: "0 0 86 86",
  width: "86",
  height: "86"
}, /* @__PURE__ */ k.createElement("title", null, "Loading"), /* @__PURE__ */ k.createElement("rect", {
  x: "3",
  y: "3",
  width: 80,
  height: 80,
  rx: 20,
  ry: 20,
  strokeDasharray: `${160 / 3} ${2 * 160 / 3}`,
  strokeDashoffset: 160,
  className: Fce,
  style: {
    stroke: (e == null ? void 0 : e.iconAccent) || "#0D3887"
  }
}));
function pL({
  onClose: e,
  wallet: t,
  connecting: n
}) {
  const {
    connect: r,
    iconBackground: i,
    iconUrl: s,
    id: o,
    name: a,
    getMobileUri: c,
    ready: l,
    shortName: u,
    showWalletConnectModal: d
  } = t, f = rL(s), p = Le(!1), { i18n: m } = $e(ir), h = Ie(async () => {
    if (o !== "walletConnect" && (async () => {
      const y = await (c == null ? void 0 : c());
      if (y)
        if (y && Sae({ mobileUri: y, name: a }), y.startsWith("http")) {
          const v = document.createElement("a");
          v.href = y, v.target = "_blank", v.rel = "noreferrer noopener", v.click();
        } else
          window.location.href = y;
    })(), d) {
      d(), e == null || e();
      return;
    }
    r == null || r();
  }, [r, c, d, e, a, o]);
  return We(() => {
    n && !p.current && (h(), p.current = !0);
  }, [n, h]), /* @__PURE__ */ k.createElement(Z, {
    as: "button",
    color: l ? "modalText" : "modalTextSecondary",
    disabled: !l,
    fontFamily: "body",
    key: o,
    onClick: h,
    ref: f,
    style: { overflow: "visible", textAlign: "center" },
    testId: `wallet-option-${o}`,
    type: "button",
    width: "full"
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: "8",
    paddingTop: "10",
    position: "relative"
  }, n ? /* @__PURE__ */ k.createElement(Uce, {
    wallet: t
  }) : null, /* @__PURE__ */ k.createElement(gr, {
    background: i,
    borderRadius: "13",
    boxShadow: "walletLogo",
    height: "60",
    src: s,
    width: "60"
  })), n ? null : /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    textAlign: "center"
  }, /* @__PURE__ */ k.createElement(rt, {
    as: "h2",
    color: t.ready ? "modalText" : "modalTextSecondary",
    size: "13",
    weight: "medium"
  }, /* @__PURE__ */ k.createElement(Z, {
    as: "span",
    position: "relative"
  }, u ?? a, !t.ready && " (unsupported)")), t.recent && /* @__PURE__ */ k.createElement(rt, {
    color: "accentColor",
    size: "12",
    weight: "medium"
  }, m.t("connect.recent")))));
}
function Lce({ onClose: e }) {
  var t;
  const n = "rk_connect_title", r = YA().filter((m) => m.isRainbowKitConnector), { disclaimer: i, learnMoreUrl: s } = $e(lv);
  let o = null, a = null, c = !1, l = null;
  const [u, d] = qe(
    "CONNECT"
    /* Connect */
  ), { i18n: f } = $e(ir), p = QA();
  switch (u) {
    case "CONNECT": {
      o = f.t("connect.title"), c = !0, a = /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(Z, {
        background: "profileForeground",
        className: jce,
        display: "flex",
        paddingBottom: "20",
        paddingTop: "6"
      }, /* @__PURE__ */ k.createElement(Z, {
        display: "flex",
        style: { margin: "0 auto" }
      }, r.filter((m) => m.ready).map((m) => /* @__PURE__ */ k.createElement(Z, {
        key: m.id,
        paddingX: "20"
      }, /* @__PURE__ */ k.createElement(Z, {
        width: "60"
      }, /* @__PURE__ */ k.createElement(pL, {
        onClose: e,
        wallet: m
      })))))), /* @__PURE__ */ k.createElement(Z, {
        background: "generalBorder",
        height: "1",
        marginBottom: "32",
        marginTop: "-1"
      }), /* @__PURE__ */ k.createElement(Z, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "32",
        paddingX: "32",
        style: { textAlign: "center" }
      }, /* @__PURE__ */ k.createElement(Z, {
        display: "flex",
        flexDirection: "column",
        gap: "8",
        textAlign: "center"
      }, /* @__PURE__ */ k.createElement(rt, {
        color: "modalText",
        size: "16",
        weight: "bold"
      }, f.t("intro.title")), /* @__PURE__ */ k.createElement(rt, {
        color: "modalTextSecondary",
        size: "16"
      }, f.t("intro.description")))), /* @__PURE__ */ k.createElement(Z, {
        paddingTop: "32",
        paddingX: "20"
      }, /* @__PURE__ */ k.createElement(Z, {
        display: "flex",
        gap: "14",
        justifyContent: "center"
      }, /* @__PURE__ */ k.createElement(fi, {
        label: f.t("intro.get.label"),
        onClick: () => d(
          "GET"
          /* Get */
        ),
        size: "large",
        type: "secondary"
      }), /* @__PURE__ */ k.createElement(fi, {
        href: s,
        label: f.t("intro.learn_more.label"),
        size: "large",
        type: "secondary"
      }))), i && /* @__PURE__ */ k.createElement(Z, {
        marginTop: "28",
        marginX: "32",
        textAlign: "center"
      }, /* @__PURE__ */ k.createElement(i, {
        Link: j5,
        Text: D5
      })));
      break;
    }
    case "GET": {
      o = f.t("get.title"), l = "CONNECT";
      const m = (t = r == null ? void 0 : r.filter((h) => {
        var g, y, v;
        return ((g = h.downloadUrls) == null ? void 0 : g.ios) || ((y = h.downloadUrls) == null ? void 0 : y.android) || ((v = h.downloadUrls) == null ? void 0 : v.mobile);
      })) == null ? void 0 : t.splice(0, 3);
      a = /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(Z, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "full",
        marginBottom: "36",
        marginTop: "5",
        paddingTop: "12",
        width: "full"
      }, m.map((h, g) => {
        const { downloadUrls: y, iconBackground: v, iconUrl: b, name: w } = h;
        return !(y != null && y.ios) && !(y != null && y.android) && !(y != null && y.mobile) ? null : /* @__PURE__ */ k.createElement(Z, {
          display: "flex",
          gap: "16",
          key: h.id,
          paddingX: "20",
          width: "full"
        }, /* @__PURE__ */ k.createElement(Z, {
          style: { minHeight: 48, minWidth: 48 }
        }, /* @__PURE__ */ k.createElement(gr, {
          background: v,
          borderColor: "generalBorder",
          borderRadius: "10",
          height: "48",
          src: b,
          width: "48"
        })), /* @__PURE__ */ k.createElement(Z, {
          display: "flex",
          flexDirection: "column",
          width: "full"
        }, /* @__PURE__ */ k.createElement(Z, {
          alignItems: "center",
          display: "flex",
          height: "48"
        }, /* @__PURE__ */ k.createElement(Z, {
          width: "full"
        }, /* @__PURE__ */ k.createElement(rt, {
          color: "modalText",
          size: "18",
          weight: "bold"
        }, w)), /* @__PURE__ */ k.createElement(fi, {
          href: (p ? y == null ? void 0 : y.ios : y == null ? void 0 : y.android) || (y == null ? void 0 : y.mobile),
          label: f.t("get.action.label"),
          size: "small",
          type: "secondary"
        })), g < m.length - 1 && /* @__PURE__ */ k.createElement(Z, {
          background: "generalBorderDim",
          height: "1",
          marginY: "10",
          width: "full"
        })));
      })), /* @__PURE__ */ k.createElement(Z, {
        style: { marginBottom: "42px" }
      }), /* @__PURE__ */ k.createElement(Z, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "36",
        paddingX: "36",
        style: { textAlign: "center" }
      }, /* @__PURE__ */ k.createElement(Z, {
        display: "flex",
        flexDirection: "column",
        gap: "12",
        textAlign: "center"
      }, /* @__PURE__ */ k.createElement(rt, {
        color: "modalText",
        size: "16",
        weight: "bold"
      }, f.t("get.looking_for.title")), /* @__PURE__ */ k.createElement(rt, {
        color: "modalTextSecondary",
        size: "16"
      }, f.t("get.looking_for.mobile.description")))));
      break;
    }
  }
  return /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "36"
  }, /* @__PURE__ */ k.createElement(Z, {
    background: c ? "profileForeground" : "modalBackground",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "4",
    paddingTop: "14"
  }, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "6",
    paddingX: "20",
    position: "relative"
  }, l && /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    position: "absolute",
    style: {
      left: 0,
      marginBottom: -20,
      marginTop: -20
    }
  }, /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    as: "button",
    className: kr({
      active: "shrinkSm",
      hover: "growLg"
    }),
    color: "accentColor",
    display: "flex",
    marginLeft: "4",
    marginTop: "20",
    onClick: () => d(l),
    padding: "16",
    style: { height: 17, willChange: "transform" },
    transition: "default",
    type: "button"
  }, /* @__PURE__ */ k.createElement(nL, null))), /* @__PURE__ */ k.createElement(Z, {
    marginTop: "4",
    textAlign: "center",
    width: "full"
  }, /* @__PURE__ */ k.createElement(rt, {
    as: "h1",
    color: "modalText",
    id: n,
    size: "20",
    weight: "bold"
  }, o)), /* @__PURE__ */ k.createElement(Z, {
    alignItems: "center",
    display: "flex",
    height: "32",
    paddingRight: "14",
    position: "absolute",
    right: "0"
  }, /* @__PURE__ */ k.createElement(Z, {
    style: { marginBottom: -20, marginTop: -20 }
  }, /* @__PURE__ */ k.createElement(sf, {
    onClose: e
  }))))), /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    flexDirection: "column"
  }, a));
}
var zce = ({ onClose: e }) => {
  const { connector: t } = $e(uv), { i18n: n } = $e(ir), r = (t == null ? void 0 : t.name) || "";
  return /* @__PURE__ */ k.createElement(Z, null, /* @__PURE__ */ k.createElement(Z, {
    display: "flex",
    paddingBottom: "32",
    justifyContent: "center",
    alignItems: "center",
    background: "profileForeground",
    flexDirection: "column"
  }, /* @__PURE__ */ k.createElement(Z, {
    width: "full",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "18",
    marginRight: "24"
  }, /* @__PURE__ */ k.createElement(sf, {
    onClose: e
  })), /* @__PURE__ */ k.createElement(Z, {
    width: "60"
  }, /* @__PURE__ */ k.createElement(pL, {
    onClose: e,
    wallet: t,
    connecting: !0
  })), /* @__PURE__ */ k.createElement(Z, {
    marginTop: "20"
  }, /* @__PURE__ */ k.createElement(rt, {
    textAlign: "center",
    color: "modalText",
    size: "18",
    weight: "semibold"
  }, n.t("connect.status.connect_mobile", {
    wallet: r
  }))), /* @__PURE__ */ k.createElement(Z, {
    maxWidth: "full",
    marginTop: "8"
  }, /* @__PURE__ */ k.createElement(rt, {
    textAlign: "center",
    color: "modalText",
    size: "16",
    weight: "medium"
  }, n.t("connect.status.confirm_mobile", {
    wallet: r
  })))));
};
function Vce({ onClose: e }) {
  const { connector: t } = $e(uv);
  return Br() ? t ? /* @__PURE__ */ k.createElement(zce, {
    onClose: e
  }) : /* @__PURE__ */ k.createElement(Lce, {
    onClose: e
  }) : /* @__PURE__ */ k.createElement(Mce, {
    onClose: e
  });
}
function Hce({ onClose: e, open: t }) {
  const n = "rk_connect_title", r = SU(), { disconnect: i } = DA(), { isConnecting: s } = mi(), o = k.useCallback(() => {
    e(), i();
  }, [e, i]), a = k.useCallback(() => {
    s && i(), e();
  }, [e, i, s]);
  return r === "disconnected" ? /* @__PURE__ */ k.createElement(Rx, {
    onClose: a,
    open: t,
    titleId: n
  }, /* @__PURE__ */ k.createElement(Mx, {
    bottomSheetOnMobile: !0,
    padding: "0",
    wide: !0
  }, /* @__PURE__ */ k.createElement(Vce, {
    onClose: a
  }))) : r === "unauthenticated" ? /* @__PURE__ */ k.createElement(Rx, {
    onClose: o,
    open: t,
    titleId: n
  }, /* @__PURE__ */ k.createElement(Mx, {
    bottomSheetOnMobile: !0,
    padding: "0"
  }, /* @__PURE__ */ k.createElement(Eae, {
    onClose: o,
    onCloseModal: e
  }))) : null;
}
function n_() {
  const [e, t] = qe(!1);
  return {
    closeModal: Ie(() => t(!1), []),
    isModalOpen: e,
    openModal: Ie(() => t(!0), [])
  };
}
var Xm = dn({
  accountModalOpen: !1,
  chainModalOpen: !1,
  connectModalOpen: !1,
  isWalletConnectModalOpen: !1,
  setIsWalletConnectModalOpen: () => {
  }
});
function Wce({ children: e }) {
  const {
    closeModal: t,
    isModalOpen: n,
    openModal: r
  } = n_(), {
    closeModal: i,
    isModalOpen: s,
    openModal: o
  } = n_(), {
    closeModal: a,
    isModalOpen: c,
    openModal: l
  } = n_(), [u, d] = qe(!1), f = SU(), { chainId: p } = mi(), { chains: m } = yr(), h = m.some((v) => v.id === p);
  function g({
    keepConnectModalOpen: v = !1
  } = {}) {
    v || t(), i(), a();
  }
  const y = $A() === "unauthenticated";
  return yD({
    onConnect: () => g({ keepConnectModalOpen: y }),
    onDisconnect: () => g()
  }), We(() => {
    y && g();
  }, [y]), /* @__PURE__ */ k.createElement(Xm.Provider, {
    value: ot(() => ({
      accountModalOpen: s,
      chainModalOpen: c,
      connectModalOpen: n,
      isWalletConnectModalOpen: u,
      openAccountModal: h && f === "connected" ? o : void 0,
      openChainModal: f === "connected" ? l : void 0,
      openConnectModal: f === "disconnected" || f === "unauthenticated" ? r : void 0,
      setIsWalletConnectModalOpen: d
    }), [
      f,
      s,
      c,
      n,
      o,
      l,
      r,
      h,
      u
    ])
  }, e, /* @__PURE__ */ k.createElement(Hce, {
    onClose: t,
    open: n
  }), /* @__PURE__ */ k.createElement(Jae, {
    onClose: i,
    open: s
  }), /* @__PURE__ */ k.createElement(sce, {
    onClose: a,
    open: c
  }));
}
function Gce() {
  const { accountModalOpen: e, chainModalOpen: t, connectModalOpen: n } = $e(Xm);
  return {
    accountModalOpen: e,
    chainModalOpen: t,
    connectModalOpen: n
  };
}
function qce() {
  const { accountModalOpen: e, openAccountModal: t } = $e(Xm);
  return { accountModalOpen: e, openAccountModal: t };
}
function $ce() {
  const { chainModalOpen: e, openChainModal: t } = $e(Xm);
  return { chainModalOpen: e, openChainModal: t };
}
function mL() {
  const { isWalletConnectModalOpen: e, setIsWalletConnectModalOpen: t } = $e(Xm);
  return { isWalletConnectModalOpen: e, setIsWalletConnectModalOpen: t };
}
function gL() {
  const { connectModalOpen: e, openConnectModal: t } = $e(Xm), { isWalletConnectModalOpen: n } = mL();
  return {
    connectModalOpen: e || n,
    openConnectModal: t
  };
}
var r_ = () => {
};
function Qce({
  children: e
}) {
  var t, n, r, i;
  const s = Hoe(), { address: o } = mi(), a = RU(o), c = NU(a), { chainId: l } = mi(), { chains: u } = yr(), d = u.some((L) => L.id === l), f = Loe(), p = (t = $A()) != null ? t : void 0, m = l ? f[l] : void 0, h = (n = m == null ? void 0 : m.name) != null ? n : void 0, g = (r = m == null ? void 0 : m.iconUrl) != null ? r : void 0, y = (i = m == null ? void 0 : m.iconBackground) != null ? i : void 0, v = k5(g), b = $e(P5), w = DU().some(({ status: L }) => L === "pending") && b, { showBalance: A } = Voe(), x = typeof A == "boolean" ? A : A ? uoe(A)[Br() ? "smallScreen" : "largeScreen"] : !0, { data: S } = bD({
    address: x ? o : void 0
  }), P = S ? `${ZU(parseFloat(S.formatted))} ${S.symbol}` : void 0, { openConnectModal: I } = gL(), { openChainModal: R } = $ce(), { openAccountModal: Q } = qce(), { accountModalOpen: J, chainModalOpen: we, connectModalOpen: V } = Gce();
  return /* @__PURE__ */ k.createElement(k.Fragment, null, e({
    account: o ? {
      address: o,
      balanceDecimals: S == null ? void 0 : S.decimals,
      balanceFormatted: S == null ? void 0 : S.formatted,
      balanceSymbol: S == null ? void 0 : S.symbol,
      displayBalance: P,
      displayName: a ? XU(a) : JU(o),
      ensAvatar: c ?? void 0,
      ensName: a ?? void 0,
      hasPendingTransactions: w
    } : void 0,
    accountModalOpen: J,
    authenticationStatus: p,
    chain: l ? {
      hasIcon: !!g,
      iconBackground: y,
      iconUrl: v,
      id: l,
      name: h,
      unsupported: !d
    } : void 0,
    chainModalOpen: we,
    connectModalOpen: V,
    mounted: s(),
    openAccountModal: Q ?? r_,
    openChainModal: R ?? r_,
    openConnectModal: I ?? r_
  }));
}
Qce.displayName = "ConnectButton.Custom";
var Kce = { npm_package_exports___require: "./dist/index.cjs", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.22 npm/? node/v20.15.1 linux x64", CI: "true", npm_package_bugs_url: "https://github.com/bitfinity-network/bitbridge/issues", npm_config_bin_links: "true", npm_node_execpath: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", npm_package_devDependencies_vite: "^5.2.0", npm_config_init_version: "1.0.0", npm_package_peerDependencies_react: "^18.2.0", npm_package_devDependencies__tanstack_react_query_devtools: "^5.24.0", npm_package_dependencies_wagmi: "^2.8.1", npm_package_files_0: "dist", npm_package_publishConfig_access: "public", HOME: "/home/runner", npm_package_devDependencies__typescript_eslint_parser: "^7.2.0", npm_package_dependencies_ethers: "^6.12.1", npm_package_dependencies_framer_motion: "^11.1.9", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_dependencies__rainbow_me_rainbowkit: "^2.0.7", npm_config_version_tag_prefix: "v", npm_package_devDependencies_vite_plugin_dts: "^3.9.1", npm_package_dependencies_react_icons: "^5.2.1", npm_package_devDependencies_eslint_plugin_react_hooks: "^4.6.0", npm_package_dependencies_dotenv: "^16.4.5", npm_package_devDependencies_typescript: "^5.2.2", npm_package_dependencies__dfinity_agent: "^1.2.0", npm_package_description: "The React UI for the Bitfinity EVM bridge", npm_package_readmeFilename: "README.md", npm_package_devDependencies__types_react_dom: "^18.2.22", npm_package_devDependencies_vite_plugin_mix: "^0.4.0", npm_package_types: "./dist/index.d.ts", npm_package_homepage: "https://github.com/bitfinity-network/bitbridge", npm_package_scripts_dev: "vite", npm_package_devDependencies__vitejs_plugin_react: "^4.2.1", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "^0.22.0", npm_package_dependencies__tanstack_query_sync_storage_persister: "^5.22.2", npm_package_dependencies__emotion_react: "^11.11.4", npm_package_module: "./dist/index.js", npm_package_devDependencies__typescript_eslint_eslint_plugin: "^7.2.0", npm_package_scripts_lint: "eslint . --ext ts,tsx --report-unused-disable-directives --max-warnings 0", npm_config_registry: "https://registry.yarnpkg.com", npm_package_devDependencies_eslint_plugin_react_refresh: "^0.4.6", npm_package_exports___import: "./dist/index.js", npm_config_ignore_scripts: "", npm_package_dependencies__bitfinity_network_bitfinitywallet: "^0.3.0", npm_package_author_email: "support@infinityswap.one", PATH: "/tmp/yarn--1722436032859-0.7268831613784328:/home/runner/work/bitbridge/bitbridge/packages/widget/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1722436018550-0.027432302051107138:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin:/snap/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", NODE: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", TURBO_HASH: "4c69888b02b3c09f", npm_package_name: "@bitfinity-network/bridge-widget", npm_package_dependencies_viem: "2.x", npm_package_dependencies__particle_network_btc_connectkit: "^1.0.0-alpha.25", LANG: "C.UTF-8", npm_package_devDependencies_eslint: "^8.57.0", npm_lifecycle_script: "tsc && vite build", npm_package_main: "./dist/index.cjs", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_devDependencies__types_react: "^18.2.66", npm_package_version: "1.3.0", npm_config_argv: '{"remain":[],"cooked":["run","build"],"original":["run","build"]}', npm_package_dependencies__bitfinity_network_bridge: "*", npm_package_scripts_build: "tsc && vite build", npm_package_peerDependencies_react_dom: "^18.2.0", npm_package_dependencies__tanstack_react_query: "^5.35.1", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "MIT", npm_config_strict_ssl: "true", npm_package_dependencies__chakra_ui_react: "^2.8.2", PWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_execpath: "/usr/local/lib/node_modules/yarn/bin/yarn.js", npm_package_dependencies__emotion_styled: "^11.11.5", npm_package_author_url: "https://bitfinity.network/", npm_package_author_name: "Bitfinity", npm_package_dependencies_react_spring_bottom_sheet: "3.5.0-alpha.0", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_scripts_preview: "vite preview", npm_package_dependencies_vite_plugin_svgr: "^4.2.0", INIT_CWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_package_dependencies__tanstack_react_query_persist_client: "^5.22.2", NODE_ENV: "production" };
function Yce(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Zce(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Jce = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var s;
      r.tags.length === 0 ? r.insertionPoint ? s = r.insertionPoint.nextSibling : r.prepend ? s = r.container.firstChild : s = r.before : s = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, s), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? Kce.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Zce(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var s = Yce(i);
      try {
        s.insertRule(r, s.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Nr = "-ms-", Fx = "-moz-", Yt = "-webkit-", yL = "comm", U5 = "rule", L5 = "decl", Xce = "@import", bL = "@keyframes", ele = "@layer", tle = Math.abs, ZA = String.fromCharCode, nle = Object.assign;
function rle(e, t) {
  return _r(e, 0) ^ 45 ? (((t << 2 ^ _r(e, 0)) << 2 ^ _r(e, 1)) << 2 ^ _r(e, 2)) << 2 ^ _r(e, 3) : 0;
}
function vL(e) {
  return e.trim();
}
function ile(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Zt(e, t, n) {
  return e.replace(t, n);
}
function QS(e, t) {
  return e.indexOf(t);
}
function _r(e, t) {
  return e.charCodeAt(t) | 0;
}
function hy(e, t, n) {
  return e.slice(t, n);
}
function ea(e) {
  return e.length;
}
function z5(e) {
  return e.length;
}
function n1(e, t) {
  return t.push(e), e;
}
function sle(e, t) {
  return e.map(t).join("");
}
var JA = 1, wm = 1, wL = 0, Mi = 0, Qn = 0, e0 = "";
function XA(e, t, n, r, i, s, o) {
  return { value: e, root: t, parent: n, type: r, props: i, children: s, line: JA, column: wm, length: o, return: "" };
}
function y0(e, t) {
  return nle(XA("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function ole() {
  return Qn;
}
function ale() {
  return Qn = Mi > 0 ? _r(e0, --Mi) : 0, wm--, Qn === 10 && (wm = 1, JA--), Qn;
}
function Zi() {
  return Qn = Mi < wL ? _r(e0, Mi++) : 0, wm++, Qn === 10 && (wm = 1, JA++), Qn;
}
function da() {
  return _r(e0, Mi);
}
function hw() {
  return Mi;
}
function fv(e, t) {
  return hy(e0, e, t);
}
function py(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function xL(e) {
  return JA = wm = 1, wL = ea(e0 = e), Mi = 0, [];
}
function AL(e) {
  return e0 = "", e;
}
function pw(e) {
  return vL(fv(Mi - 1, KS(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function cle(e) {
  for (; (Qn = da()) && Qn < 33; )
    Zi();
  return py(e) > 2 || py(Qn) > 3 ? "" : " ";
}
function lle(e, t) {
  for (; --t && Zi() && !(Qn < 48 || Qn > 102 || Qn > 57 && Qn < 65 || Qn > 70 && Qn < 97); )
    ;
  return fv(e, hw() + (t < 6 && da() == 32 && Zi() == 32));
}
function KS(e) {
  for (; Zi(); )
    switch (Qn) {
      case e:
        return Mi;
      case 34:
      case 39:
        e !== 34 && e !== 39 && KS(Qn);
        break;
      case 40:
        e === 41 && KS(e);
        break;
      case 92:
        Zi();
        break;
    }
  return Mi;
}
function ule(e, t) {
  for (; Zi() && e + Qn !== 57; )
    if (e + Qn === 84 && da() === 47)
      break;
  return "/*" + fv(t, Mi - 1) + "*" + ZA(e === 47 ? e : Zi());
}
function dle(e) {
  for (; !py(da()); )
    Zi();
  return fv(e, Mi);
}
function fle(e) {
  return AL(mw("", null, null, null, [""], e = xL(e), 0, [0], e));
}
function mw(e, t, n, r, i, s, o, a, c) {
  for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, y = 1, v = 0, b = "", w = i, A = s, E = r, x = b; g; )
    switch (m = v, v = Zi()) {
      case 40:
        if (m != 108 && _r(x, d - 1) == 58) {
          QS(x += Zt(pw(v), "&", "&\f"), "&\f") != -1 && (y = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        x += pw(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        x += cle(m);
        break;
      case 92:
        x += lle(hw() - 1, 7);
        continue;
      case 47:
        switch (da()) {
          case 42:
          case 47:
            n1(hle(ule(Zi(), hw()), t, n), c);
            break;
          default:
            x += "/";
        }
        break;
      case 123 * h:
        a[l++] = ea(x) * y;
      case 125 * h:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            g = 0;
          case 59 + u:
            y == -1 && (x = Zt(x, /\f/g, "")), p > 0 && ea(x) - d && n1(p > 32 ? xP(x + ";", r, n, d - 1) : xP(Zt(x, " ", "") + ";", r, n, d - 2), c);
            break;
          case 59:
            x += ";";
          default:
            if (n1(E = wP(x, t, n, l, u, i, a, b, w = [], A = [], d), s), v === 123)
              if (u === 0)
                mw(x, t, E, E, w, s, d, a, A);
              else
                switch (f === 99 && _r(x, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    mw(e, E, E, r && n1(wP(e, E, E, 0, 0, i, a, b, i, w = [], d), A), i, A, d, a, r ? w : A);
                    break;
                  default:
                    mw(x, E, E, E, [""], A, 0, a, A);
                }
        }
        l = u = p = 0, h = y = 1, b = x = "", d = o;
        break;
      case 58:
        d = 1 + ea(x), p = m;
      default:
        if (h < 1) {
          if (v == 123)
            --h;
          else if (v == 125 && h++ == 0 && ale() == 125)
            continue;
        }
        switch (x += ZA(v), v * h) {
          case 38:
            y = u > 0 ? 1 : (x += "\f", -1);
            break;
          case 44:
            a[l++] = (ea(x) - 1) * y, y = 1;
            break;
          case 64:
            da() === 45 && (x += pw(Zi())), f = da(), u = d = ea(b = x += dle(hw())), v++;
            break;
          case 45:
            m === 45 && ea(x) == 2 && (h = 0);
        }
    }
  return s;
}
function wP(e, t, n, r, i, s, o, a, c, l, u) {
  for (var d = i - 1, f = i === 0 ? s : [""], p = z5(f), m = 0, h = 0, g = 0; m < r; ++m)
    for (var y = 0, v = hy(e, d + 1, d = tle(h = o[m])), b = e; y < p; ++y)
      (b = vL(h > 0 ? f[y] + " " + v : Zt(v, /&\f/g, f[y]))) && (c[g++] = b);
  return XA(e, t, n, i === 0 ? U5 : a, c, l, u);
}
function hle(e, t, n) {
  return XA(e, t, n, yL, ZA(ole()), hy(e, 2, -2), 0);
}
function xP(e, t, n, r) {
  return XA(e, t, n, L5, hy(e, 0, r), hy(e, r + 1, -1), r);
}
function Uh(e, t) {
  for (var n = "", r = z5(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function ple(e, t, n, r) {
  switch (e.type) {
    case ele:
      if (e.children.length)
        break;
    case Xce:
    case L5:
      return e.return = e.return || e.value;
    case yL:
      return "";
    case bL:
      return e.return = e.value + "{" + Uh(e.children, r) + "}";
    case U5:
      e.value = e.props.join(",");
  }
  return ea(n = Uh(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function mle(e) {
  var t = z5(e);
  return function(n, r, i, s) {
    for (var o = "", a = 0; a < t; a++)
      o += e[a](n, r, i, s) || "";
    return o;
  };
}
function gle(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var AP = function(t) {
  var n = /* @__PURE__ */ new WeakMap();
  return function(r) {
    if (n.has(r))
      return n.get(r);
    var i = t(r);
    return n.set(r, i), i;
  };
};
function EL(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var yle = function(t, n, r) {
  for (var i = 0, s = 0; i = s, s = da(), i === 38 && s === 12 && (n[r] = 1), !py(s); )
    Zi();
  return fv(t, Mi);
}, ble = function(t, n) {
  var r = -1, i = 44;
  do
    switch (py(i)) {
      case 0:
        i === 38 && da() === 12 && (n[r] = 1), t[r] += yle(Mi - 1, n, r);
        break;
      case 2:
        t[r] += pw(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = da() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += ZA(i);
    }
  while (i = Zi());
  return t;
}, vle = function(t, n) {
  return AL(ble(xL(t), n));
}, EP = /* @__PURE__ */ new WeakMap(), wle = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !EP.get(r)) && !i) {
      EP.set(t, !0);
      for (var s = [], o = vle(n, s), a = r.props, c = 0, l = 0; c < o.length; c++)
        for (var u = 0; u < a.length; u++, l++)
          t.props[l] = s[c] ? o[c].replace(/&\f/g, a[u]) : a[u] + " " + o[c];
    }
  }
}, xle = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function _L(e, t) {
  switch (rle(e, t)) {
    case 5103:
      return Yt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Yt + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Yt + e + Fx + e + Nr + e + e;
    case 6828:
    case 4268:
      return Yt + e + Nr + e + e;
    case 6165:
      return Yt + e + Nr + "flex-" + e + e;
    case 5187:
      return Yt + e + Zt(e, /(\w+).+(:[^]+)/, Yt + "box-$1$2" + Nr + "flex-$1$2") + e;
    case 5443:
      return Yt + e + Nr + "flex-item-" + Zt(e, /flex-|-self/, "") + e;
    case 4675:
      return Yt + e + Nr + "flex-line-pack" + Zt(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Yt + e + Nr + Zt(e, "shrink", "negative") + e;
    case 5292:
      return Yt + e + Nr + Zt(e, "basis", "preferred-size") + e;
    case 6060:
      return Yt + "box-" + Zt(e, "-grow", "") + Yt + e + Nr + Zt(e, "grow", "positive") + e;
    case 4554:
      return Yt + Zt(e, /([^-])(transform)/g, "$1" + Yt + "$2") + e;
    case 6187:
      return Zt(Zt(Zt(e, /(zoom-|grab)/, Yt + "$1"), /(image-set)/, Yt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Zt(e, /(image-set\([^]*)/, Yt + "$1$`$1");
    case 4968:
      return Zt(Zt(e, /(.+:)(flex-)?(.*)/, Yt + "box-pack:$3" + Nr + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Yt + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Zt(e, /(.+)-inline(.+)/, Yt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ea(e) - 1 - t > 6)
        switch (_r(e, t + 1)) {
          case 109:
            if (_r(e, t + 4) !== 45)
              break;
          case 102:
            return Zt(e, /(.+:)(.+)-([^]+)/, "$1" + Yt + "$2-$3$1" + Fx + (_r(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~QS(e, "stretch") ? _L(Zt(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (_r(e, t + 1) !== 115)
        break;
    case 6444:
      switch (_r(e, ea(e) - 3 - (~QS(e, "!important") && 10))) {
        case 107:
          return Zt(e, ":", ":" + Yt) + e;
        case 101:
          return Zt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Yt + (_r(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Yt + "$2$3$1" + Nr + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (_r(e, t + 11)) {
        case 114:
          return Yt + e + Nr + Zt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Yt + e + Nr + Zt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Yt + e + Nr + Zt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Yt + e + Nr + e + e;
  }
  return e;
}
var Ale = function(t, n, r, i) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case L5:
        t.return = _L(t.value, t.length);
        break;
      case bL:
        return Uh([y0(t, {
          value: Zt(t.value, "@", "@" + Yt)
        })], i);
      case U5:
        if (t.length)
          return sle(t.props, function(s) {
            switch (ile(s, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Uh([y0(t, {
                  props: [Zt(s, /:(read-\w+)/, ":" + Fx + "$1")]
                })], i);
              case "::placeholder":
                return Uh([y0(t, {
                  props: [Zt(s, /:(plac\w+)/, ":" + Yt + "input-$1")]
                }), y0(t, {
                  props: [Zt(s, /:(plac\w+)/, ":" + Fx + "$1")]
                }), y0(t, {
                  props: [Zt(s, /:(plac\w+)/, Nr + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, Ele = [Ale], _le = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(h) {
      var g = h.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || Ele, s = {}, o, a = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(h) {
      for (var g = h.getAttribute("data-emotion").split(" "), y = 1; y < g.length; y++)
        s[g[y]] = !0;
      a.push(h);
    }
  );
  var c, l = [wle, xle];
  {
    var u, d = [ple, gle(function(h) {
      u.insert(h);
    })], f = mle(l.concat(i, d)), p = function(g) {
      return Uh(fle(g), f);
    };
    c = function(g, y, v, b) {
      u = v, p(g ? g + "{" + y.styles + "}" : y.styles), b && (m.inserted[y.name] = !0);
    };
  }
  var m = {
    key: n,
    sheet: new Jce({
      key: n,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: s,
    registered: {},
    insert: c
  };
  return m.sheet.hydrate(a), m;
};
function of() {
  return of = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, of.apply(this, arguments);
}
var SL = { exports: {} }, tn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _P;
function Sle() {
  if (_P)
    return tn;
  _P = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function b(A) {
    if (typeof A == "object" && A !== null) {
      var E = A.$$typeof;
      switch (E) {
        case t:
          switch (A = A.type, A) {
            case c:
            case l:
            case r:
            case s:
            case i:
            case d:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case a:
                case u:
                case m:
                case p:
                case o:
                  return A;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function w(A) {
    return b(A) === l;
  }
  return tn.AsyncMode = c, tn.ConcurrentMode = l, tn.ContextConsumer = a, tn.ContextProvider = o, tn.Element = t, tn.ForwardRef = u, tn.Fragment = r, tn.Lazy = m, tn.Memo = p, tn.Portal = n, tn.Profiler = s, tn.StrictMode = i, tn.Suspense = d, tn.isAsyncMode = function(A) {
    return w(A) || b(A) === c;
  }, tn.isConcurrentMode = w, tn.isContextConsumer = function(A) {
    return b(A) === a;
  }, tn.isContextProvider = function(A) {
    return b(A) === o;
  }, tn.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === t;
  }, tn.isForwardRef = function(A) {
    return b(A) === u;
  }, tn.isFragment = function(A) {
    return b(A) === r;
  }, tn.isLazy = function(A) {
    return b(A) === m;
  }, tn.isMemo = function(A) {
    return b(A) === p;
  }, tn.isPortal = function(A) {
    return b(A) === n;
  }, tn.isProfiler = function(A) {
    return b(A) === s;
  }, tn.isStrictMode = function(A) {
    return b(A) === i;
  }, tn.isSuspense = function(A) {
    return b(A) === d;
  }, tn.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === r || A === l || A === s || A === i || A === d || A === f || typeof A == "object" && A !== null && (A.$$typeof === m || A.$$typeof === p || A.$$typeof === o || A.$$typeof === a || A.$$typeof === u || A.$$typeof === g || A.$$typeof === y || A.$$typeof === v || A.$$typeof === h);
  }, tn.typeOf = b, tn;
}
SL.exports = Sle();
var Cle = SL.exports, CL = Cle, Tle = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, kle = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TL = {};
TL[CL.ForwardRef] = Tle;
TL[CL.Memo] = kle;
var Ble = !0;
function Ile(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : r += i + " ";
  }), r;
}
var kL = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Ble === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, BL = function(t, n, r) {
  kL(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var s = n;
    do
      t.insert(n === s ? "." + i : "", s, t.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function Ple(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Ole = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Nle = { npm_package_exports___require: "./dist/index.cjs", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.22 npm/? node/v20.15.1 linux x64", CI: "true", npm_package_bugs_url: "https://github.com/bitfinity-network/bitbridge/issues", npm_config_bin_links: "true", npm_node_execpath: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", npm_package_devDependencies_vite: "^5.2.0", npm_config_init_version: "1.0.0", npm_package_peerDependencies_react: "^18.2.0", npm_package_devDependencies__tanstack_react_query_devtools: "^5.24.0", npm_package_dependencies_wagmi: "^2.8.1", npm_package_files_0: "dist", npm_package_publishConfig_access: "public", HOME: "/home/runner", npm_package_devDependencies__typescript_eslint_parser: "^7.2.0", npm_package_dependencies_ethers: "^6.12.1", npm_package_dependencies_framer_motion: "^11.1.9", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_dependencies__rainbow_me_rainbowkit: "^2.0.7", npm_config_version_tag_prefix: "v", npm_package_devDependencies_vite_plugin_dts: "^3.9.1", npm_package_dependencies_react_icons: "^5.2.1", npm_package_devDependencies_eslint_plugin_react_hooks: "^4.6.0", npm_package_dependencies_dotenv: "^16.4.5", npm_package_devDependencies_typescript: "^5.2.2", npm_package_dependencies__dfinity_agent: "^1.2.0", npm_package_description: "The React UI for the Bitfinity EVM bridge", npm_package_readmeFilename: "README.md", npm_package_devDependencies__types_react_dom: "^18.2.22", npm_package_devDependencies_vite_plugin_mix: "^0.4.0", npm_package_types: "./dist/index.d.ts", npm_package_homepage: "https://github.com/bitfinity-network/bitbridge", npm_package_scripts_dev: "vite", npm_package_devDependencies__vitejs_plugin_react: "^4.2.1", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "^0.22.0", npm_package_dependencies__tanstack_query_sync_storage_persister: "^5.22.2", npm_package_dependencies__emotion_react: "^11.11.4", npm_package_module: "./dist/index.js", npm_package_devDependencies__typescript_eslint_eslint_plugin: "^7.2.0", npm_package_scripts_lint: "eslint . --ext ts,tsx --report-unused-disable-directives --max-warnings 0", npm_config_registry: "https://registry.yarnpkg.com", npm_package_devDependencies_eslint_plugin_react_refresh: "^0.4.6", npm_package_exports___import: "./dist/index.js", npm_config_ignore_scripts: "", npm_package_dependencies__bitfinity_network_bitfinitywallet: "^0.3.0", npm_package_author_email: "support@infinityswap.one", PATH: "/tmp/yarn--1722436032859-0.7268831613784328:/home/runner/work/bitbridge/bitbridge/packages/widget/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1722436018550-0.027432302051107138:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin:/snap/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", NODE: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", TURBO_HASH: "4c69888b02b3c09f", npm_package_name: "@bitfinity-network/bridge-widget", npm_package_dependencies_viem: "2.x", npm_package_dependencies__particle_network_btc_connectkit: "^1.0.0-alpha.25", LANG: "C.UTF-8", npm_package_devDependencies_eslint: "^8.57.0", npm_lifecycle_script: "tsc && vite build", npm_package_main: "./dist/index.cjs", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_devDependencies__types_react: "^18.2.66", npm_package_version: "1.3.0", npm_config_argv: '{"remain":[],"cooked":["run","build"],"original":["run","build"]}', npm_package_dependencies__bitfinity_network_bridge: "*", npm_package_scripts_build: "tsc && vite build", npm_package_peerDependencies_react_dom: "^18.2.0", npm_package_dependencies__tanstack_react_query: "^5.35.1", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "MIT", npm_config_strict_ssl: "true", npm_package_dependencies__chakra_ui_react: "^2.8.2", PWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_execpath: "/usr/local/lib/node_modules/yarn/bin/yarn.js", npm_package_dependencies__emotion_styled: "^11.11.5", npm_package_author_url: "https://bitfinity.network/", npm_package_author_name: "Bitfinity", npm_package_dependencies_react_spring_bottom_sheet: "3.5.0-alpha.0", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_scripts_preview: "vite preview", npm_package_dependencies_vite_plugin_svgr: "^4.2.0", INIT_CWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_package_dependencies__tanstack_react_query_persist_client: "^5.22.2", NODE_ENV: "production" }, Rle = /[A-Z]|^ms/g, Mle = /_EMO_([^_]+?)_([^]*?)_EMO_/g, IL = function(t) {
  return t.charCodeAt(1) === 45;
}, SP = function(t) {
  return t != null && typeof t != "boolean";
}, i_ = /* @__PURE__ */ EL(function(e) {
  return IL(e) ? e : e.replace(Rle, "-$&").toLowerCase();
}), CP = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Mle, function(r, i, s) {
          return ta = {
            name: i,
            styles: s,
            next: ta
          }, i;
        });
  }
  return Ole[t] !== 1 && !IL(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Fle = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function my(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return ta = {
          name: n.name,
          styles: n.styles,
          next: ta
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            ta = {
              name: r.name,
              styles: r.styles,
              next: ta
            }, r = r.next;
        var i = n.styles + ";";
        return i;
      }
      return jle(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var s = ta, o = n(e);
        return ta = s, my(e, t, o);
      }
      break;
    }
  }
  if (t == null)
    return n;
  var a = t[n];
  return a !== void 0 ? a : n;
}
function jle(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += my(e, t, n[i]) + ";";
  else
    for (var s in n) {
      var o = n[s];
      if (typeof o != "object")
        t != null && t[o] !== void 0 ? r += s + "{" + t[o] + "}" : SP(o) && (r += i_(s) + ":" + CP(s, o) + ";");
      else {
        if (s === "NO_COMPONENT_SELECTOR" && Nle.NODE_ENV !== "production")
          throw new Error(Fle);
        if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0))
          for (var a = 0; a < o.length; a++)
            SP(o[a]) && (r += i_(s) + ":" + CP(s, o[a]) + ";");
        else {
          var c = my(e, t, o);
          switch (s) {
            case "animation":
            case "animationName": {
              r += i_(s) + ":" + c + ";";
              break;
            }
            default:
              r += s + "{" + c + "}";
          }
        }
      }
    }
  return r;
}
var TP = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ta, V5 = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var i = !0, s = "";
  ta = void 0;
  var o = t[0];
  o == null || o.raw === void 0 ? (i = !1, s += my(r, n, o)) : s += o[0];
  for (var a = 1; a < t.length; a++)
    s += my(r, n, t[a]), i && (s += o[a]);
  TP.lastIndex = 0;
  for (var c = "", l; (l = TP.exec(s)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    l[1];
  var u = Ple(s) + c;
  return {
    name: u,
    styles: s,
    next: ta
  };
}, Dle = function(t) {
  return t();
}, PL = ye.useInsertionEffect ? ye.useInsertionEffect : !1, Ule = PL || Dle, kP = PL || ye.useLayoutEffect, OL = /* @__PURE__ */ ye.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ _le({
    key: "css"
  }) : null
);
OL.Provider;
var NL = function(t) {
  return /* @__PURE__ */ Bc(function(n, r) {
    var i = $e(OL);
    return t(n, i, r);
  });
}, gy = /* @__PURE__ */ ye.createContext({}), Lle = function(t, n) {
  if (typeof n == "function") {
    var r = n(t);
    return r;
  }
  return of({}, t, n);
}, zle = /* @__PURE__ */ AP(function(e) {
  return AP(function(t) {
    return Lle(e, t);
  });
}), Vle = function(t) {
  var n = ye.useContext(gy);
  return t.theme !== n && (n = zle(n)(t.theme)), /* @__PURE__ */ ye.createElement(gy.Provider, {
    value: n
  }, t.children);
}, eE = /* @__PURE__ */ NL(function(e, t) {
  var n = e.styles, r = V5([n], void 0, ye.useContext(gy)), i = ye.useRef();
  return kP(function() {
    var s = t.key + "-global", o = new t.sheet.constructor({
      key: s,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), a = !1, c = document.querySelector('style[data-emotion="' + s + " " + r.name + '"]');
    return t.sheet.tags.length && (o.before = t.sheet.tags[0]), c !== null && (a = !0, c.setAttribute("data-emotion", s), o.hydrate([c])), i.current = [o, a], function() {
      o.flush();
    };
  }, [t]), kP(function() {
    var s = i.current, o = s[0], a = s[1];
    if (a) {
      s[1] = !1;
      return;
    }
    if (r.next !== void 0 && BL(t, r.next, !0), o.tags.length) {
      var c = o.tags[o.tags.length - 1].nextElementSibling;
      o.before = c, o.flush();
    }
    t.insert("", r, o, !1);
  }, [t, r.name]), null;
});
function Hle() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return V5(t);
}
var Wle = function() {
  var t = Hle.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, RL = String.raw, ML = RL`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`, Gle = () => /* @__PURE__ */ D.jsx(eE, { styles: ML }), qle = ({ scope: e = "" }) => /* @__PURE__ */ D.jsx(
  eE,
  {
    styles: RL`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${e} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${e} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${e} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${e} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${e} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${e} :where(b, strong) {
        font-weight: bold;
      }

      ${e} small {
        font-size: 80%;
      }

      ${e} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${e} sub {
        bottom: -0.25em;
      }

      ${e} sup {
        top: -0.5em;
      }

      ${e} img {
        border-style: none;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${e} :where(button, input) {
        overflow: visible;
      }

      ${e} :where(button, select) {
        text-transform: none;
      }

      ${e} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${e} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${e} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${e} progress {
        vertical-align: baseline;
      }

      ${e} textarea {
        overflow: auto;
      }

      ${e} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${e} input[type="number"]::-webkit-inner-spin-button,
      ${e} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${e} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${e} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${e} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${e} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${e} details {
        display: block;
      }

      ${e} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${e} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${e} button {
        background: transparent;
        padding: 0;
      }

      ${e} fieldset {
        margin: 0;
        padding: 0;
      }

      ${e} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${e} textarea {
        resize: vertical;
      }

      ${e} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${e} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${e} table {
        border-collapse: collapse;
      }

      ${e} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${e} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${e} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${e} select::-ms-expand {
        display: none;
      }

      ${ML}
    `
  }
);
function $le(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function Ir(e = {}) {
  const {
    name: t,
    strict: n = !0,
    hookName: r = "useContext",
    providerName: i = "Provider",
    errorMessage: s,
    defaultValue: o
  } = e, a = dn(o);
  a.displayName = t;
  function c() {
    var l;
    const u = $e(a);
    if (!u && n) {
      const d = new Error(
        s ?? $le(r, i)
      );
      throw d.name = "ContextError", (l = Error.captureStackTrace) == null || l.call(Error, d, c), d;
    }
    return u;
  }
  return [a.Provider, c, a];
}
var [Qle, Kle] = Ir({
  strict: !1,
  name: "PortalManagerContext"
});
function FL(e) {
  const { children: t, zIndex: n } = e;
  return /* @__PURE__ */ D.jsx(Qle, { value: { zIndex: n }, children: t });
}
FL.displayName = "PortalManager";
var ru = globalThis != null && globalThis.document ? _f : We, [jL, Yle] = Ir({
  strict: !1,
  name: "PortalContext"
}), H5 = "chakra-portal", Zle = ".chakra-portal", Jle = (e) => /* @__PURE__ */ D.jsx(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: e.zIndex,
      top: 0,
      left: 0,
      right: 0
      // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201
    },
    children: e.children
  }
), Xle = (e) => {
  const { appendToParentPortal: t, children: n } = e, [r, i] = qe(null), s = Le(null), [, o] = qe({});
  We(() => o({}), []);
  const a = Yle(), c = Kle();
  ru(() => {
    if (!r)
      return;
    const u = r.ownerDocument, d = t ? a ?? u.body : u.body;
    if (!d)
      return;
    s.current = u.createElement("div"), s.current.className = H5, d.appendChild(s.current), o({});
    const f = s.current;
    return () => {
      d.contains(f) && d.removeChild(f);
    };
  }, [r]);
  const l = c != null && c.zIndex ? /* @__PURE__ */ D.jsx(Jle, { zIndex: c == null ? void 0 : c.zIndex, children: n }) : n;
  return s.current ? AA(
    /* @__PURE__ */ D.jsx(jL, { value: s.current, children: l }),
    s.current
  ) : /* @__PURE__ */ D.jsx(
    "span",
    {
      ref: (u) => {
        u && i(u);
      }
    }
  );
}, eue = (e) => {
  const { children: t, containerRef: n, appendToParentPortal: r } = e, i = n.current, s = i ?? (typeof window < "u" ? document.body : void 0), o = ot(() => {
    const c = i == null ? void 0 : i.ownerDocument.createElement("div");
    return c && (c.className = H5), c;
  }, [i]), [, a] = qe({});
  return ru(() => a({}), []), ru(() => {
    if (!(!o || !s))
      return s.appendChild(o), () => {
        s.removeChild(o);
      };
  }, [o, s]), s && o ? AA(
    /* @__PURE__ */ D.jsx(jL, { value: r ? o : null, children: t }),
    o
  ) : null;
};
function hv(e) {
  const t = {
    appendToParentPortal: !0,
    ...e
  }, { containerRef: n, ...r } = t;
  return n ? /* @__PURE__ */ D.jsx(eue, { containerRef: n, ...r }) : /* @__PURE__ */ D.jsx(Xle, { ...r });
}
hv.className = H5;
hv.selector = Zle;
hv.displayName = "Portal";
function tE() {
  const e = $e(
    gy
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
var W5 = dn({});
W5.displayName = "ColorModeContext";
function G5() {
  const e = $e(W5);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
var r1 = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function tue(e = {}) {
  const { preventTransition: t = !0 } = e, n = {
    setDataset: (r) => {
      const i = t ? n.preventTransition() : void 0;
      document.documentElement.dataset.theme = r, document.documentElement.style.colorScheme = r, i == null || i();
    },
    setClassName(r) {
      document.body.classList.add(r ? r1.dark : r1.light), document.body.classList.remove(r ? r1.light : r1.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(r) {
      var i;
      return ((i = n.query().matches) != null ? i : r === "dark") ? "dark" : "light";
    },
    addListener(r) {
      const i = n.query(), s = (o) => {
        r(o.matches ? "dark" : "light");
      };
      return typeof i.addListener == "function" ? i.addListener(s) : i.addEventListener("change", s), () => {
        typeof i.removeListener == "function" ? i.removeListener(s) : i.removeEventListener("change", s);
      };
    },
    preventTransition() {
      const r = document.createElement("style");
      return r.appendChild(
        document.createTextNode(
          "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
        )
      ), document.head.appendChild(r), () => {
        window.getComputedStyle(document.body), requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(r);
          });
        });
      };
    }
  };
  return n;
}
var nue = "chakra-ui-color-mode";
function rue(e) {
  return {
    ssr: !1,
    type: "localStorage",
    get(t) {
      if (!(globalThis != null && globalThis.document))
        return t;
      let n;
      try {
        n = localStorage.getItem(e) || t;
      } catch {
      }
      return n || t;
    },
    set(t) {
      try {
        localStorage.setItem(e, t);
      } catch {
      }
    }
  };
}
var iue = rue(nue), BP = () => {
};
function IP(e, t) {
  return e.type === "cookie" && e.ssr ? e.get(t) : t;
}
function DL(e) {
  const {
    value: t,
    children: n,
    options: {
      useSystemColorMode: r,
      initialColorMode: i,
      disableTransitionOnChange: s
    } = {},
    colorModeManager: o = iue
  } = e, a = i === "dark" ? "dark" : "light", [c, l] = qe(
    () => IP(o, a)
  ), [u, d] = qe(
    () => IP(o)
  ), { getSystemTheme: f, setClassName: p, setDataset: m, addListener: h } = ot(
    () => tue({ preventTransition: s }),
    [s]
  ), g = i === "system" && !c ? u : c, y = Ie(
    (w) => {
      const A = w === "system" ? f() : w;
      l(A), p(A === "dark"), m(A), o.set(A);
    },
    [o, f, p, m]
  );
  ru(() => {
    i === "system" && d(f());
  }, []), We(() => {
    const w = o.get();
    if (w) {
      y(w);
      return;
    }
    if (i === "system") {
      y("system");
      return;
    }
    y(a);
  }, [o, a, i, y]);
  const v = Ie(() => {
    y(g === "dark" ? "light" : "dark");
  }, [g, y]);
  We(() => {
    if (r)
      return h(y);
  }, [r, h, y]);
  const b = ot(
    () => ({
      colorMode: t ?? g,
      toggleColorMode: t ? BP : v,
      setColorMode: t ? BP : y,
      forced: t !== void 0
    }),
    [g, v, y, t]
  );
  return /* @__PURE__ */ D.jsx(W5.Provider, { value: b, children: n });
}
DL.displayName = "ColorModeProvider";
function UL() {
  const e = G5(), t = tE();
  return { ...e, theme: t };
}
var Wt = (...e) => e.filter(Boolean).join(" ");
function Ii(e) {
  const t = typeof e;
  return e != null && (t === "object" || t === "function") && !Array.isArray(e);
}
function oo(e, ...t) {
  return sue(e) ? e(...t) : e;
}
var sue = (e) => typeof e == "function", Gs = (e) => e ? "" : void 0, s_ = (e) => e ? !0 : void 0;
function Xn(...e) {
  return function(n) {
    e.some((r) => (r == null || r(n), n == null ? void 0 : n.defaultPrevented));
  };
}
function oue(...e) {
  return function(n) {
    e.forEach((r) => {
      r == null || r(n);
    });
  };
}
var jx = { exports: {} };
jx.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", i = 800, s = 16, o = 9007199254740991, a = "[object Arguments]", c = "[object Array]", l = "[object AsyncFunction]", u = "[object Boolean]", d = "[object Date]", f = "[object Error]", p = "[object Function]", m = "[object GeneratorFunction]", h = "[object Map]", g = "[object Number]", y = "[object Null]", v = "[object Object]", b = "[object Proxy]", w = "[object RegExp]", A = "[object Set]", E = "[object String]", x = "[object Undefined]", S = "[object WeakMap]", P = "[object ArrayBuffer]", I = "[object DataView]", R = "[object Float32Array]", Q = "[object Float64Array]", J = "[object Int8Array]", we = "[object Int16Array]", V = "[object Int32Array]", L = "[object Uint8Array]", U = "[object Uint8ClampedArray]", q = "[object Uint16Array]", G = "[object Uint32Array]", ae = /[\\^$.*+?()[\]{}|]/g, ge = /^\[object .+?Constructor\]$/, Ae = /^(?:0|[1-9]\d*)$/, he = {};
  he[R] = he[Q] = he[J] = he[we] = he[V] = he[L] = he[U] = he[q] = he[G] = !0, he[a] = he[c] = he[P] = he[u] = he[I] = he[d] = he[f] = he[p] = he[h] = he[g] = he[v] = he[w] = he[A] = he[E] = he[S] = !1;
  var B = typeof window == "object" && window && window.Object === Object && window, be = typeof self == "object" && self && self.Object === Object && self, Be = B || be || Function("return this")(), Ne = t && !t.nodeType && t, _e = Ne && !0 && e && !e.nodeType && e, Ce = _e && _e.exports === Ne, N = Ce && B.process, F = function() {
    try {
      var W = _e && _e.require && _e.require("util").types;
      return W || N && N.binding && N.binding("util");
    } catch {
    }
  }(), z = F && F.isTypedArray;
  function ne(W, le, ve) {
    switch (ve.length) {
      case 0:
        return W.call(le);
      case 1:
        return W.call(le, ve[0]);
      case 2:
        return W.call(le, ve[0], ve[1]);
      case 3:
        return W.call(le, ve[0], ve[1], ve[2]);
    }
    return W.apply(le, ve);
  }
  function ee(W, le) {
    for (var ve = -1, tt = Array(W); ++ve < W; )
      tt[ve] = le(ve);
    return tt;
  }
  function Y(W) {
    return function(le) {
      return W(le);
    };
  }
  function X(W, le) {
    return W == null ? void 0 : W[le];
  }
  function $(W, le) {
    return function(ve) {
      return W(le(ve));
    };
  }
  var ie = Array.prototype, fe = Function.prototype, oe = Object.prototype, me = Be["__core-js_shared__"], Me = fe.toString, je = oe.hasOwnProperty, Ye = function() {
    var W = /[^.]+$/.exec(me && me.keys && me.keys.IE_PROTO || "");
    return W ? "Symbol(src)_1." + W : "";
  }(), Oe = oe.toString, De = Me.call(Object), Te = RegExp(
    "^" + Me.call(je).replace(ae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Fe = Ce ? Be.Buffer : void 0, lt = Be.Symbol, O = Be.Uint8Array;
  Fe && Fe.allocUnsafe;
  var _ = $(Object.getPrototypeOf, Object), T = Object.create, M = oe.propertyIsEnumerable, se = ie.splice, H = lt ? lt.toStringTag : void 0, ue = function() {
    try {
      var W = u3(Object, "defineProperty");
      return W({}, "", {}), W;
    } catch {
    }
  }(), Ee = Fe ? Fe.isBuffer : void 0, Xe = Math.max, Ge = Date.now, it = u3(Be, "Map"), et = u3(Object, "create"), rn = /* @__PURE__ */ function() {
    function W() {
    }
    return function(le) {
      if (!Tu(le))
        return {};
      if (T)
        return T(le);
      W.prototype = le;
      var ve = new W();
      return W.prototype = void 0, ve;
    };
  }();
  function Vt(W) {
    var le = -1, ve = W == null ? 0 : W.length;
    for (this.clear(); ++le < ve; ) {
      var tt = W[le];
      this.set(tt[0], tt[1]);
    }
  }
  function xt() {
    this.__data__ = et ? et(null) : {}, this.size = 0;
  }
  function Bt(W) {
    var le = this.has(W) && delete this.__data__[W];
    return this.size -= le ? 1 : 0, le;
  }
  function Kr(W) {
    var le = this.__data__;
    if (et) {
      var ve = le[W];
      return ve === r ? void 0 : ve;
    }
    return je.call(le, W) ? le[W] : void 0;
  }
  function Ta(W) {
    var le = this.__data__;
    return et ? le[W] !== void 0 : je.call(le, W);
  }
  function yi(W, le) {
    var ve = this.__data__;
    return this.size += this.has(W) ? 0 : 1, ve[W] = et && le === void 0 ? r : le, this;
  }
  Vt.prototype.clear = xt, Vt.prototype.delete = Bt, Vt.prototype.get = Kr, Vt.prototype.has = Ta, Vt.prototype.set = yi;
  function an(W) {
    var le = -1, ve = W == null ? 0 : W.length;
    for (this.clear(); ++le < ve; ) {
      var tt = W[le];
      this.set(tt[0], tt[1]);
    }
  }
  function Gt() {
    this.__data__ = [], this.size = 0;
  }
  function rs(W) {
    var le = this.__data__, ve = te(le, W);
    if (ve < 0)
      return !1;
    var tt = le.length - 1;
    return ve == tt ? le.pop() : se.call(le, ve, 1), --this.size, !0;
  }
  function ar(W) {
    var le = this.__data__, ve = te(le, W);
    return ve < 0 ? void 0 : le[ve][1];
  }
  function _o(W) {
    return te(this.__data__, W) > -1;
  }
  function So(W, le) {
    var ve = this.__data__, tt = te(ve, W);
    return tt < 0 ? (++this.size, ve.push([W, le])) : ve[tt][1] = le, this;
  }
  an.prototype.clear = Gt, an.prototype.delete = rs, an.prototype.get = ar, an.prototype.has = _o, an.prototype.set = So;
  function Gn(W) {
    var le = -1, ve = W == null ? 0 : W.length;
    for (this.clear(); ++le < ve; ) {
      var tt = W[le];
      this.set(tt[0], tt[1]);
    }
  }
  function ka() {
    this.size = 0, this.__data__ = {
      hash: new Vt(),
      map: new (it || an)(),
      string: new Vt()
    };
  }
  function Nc(W) {
    var le = Hv(this, W).delete(W);
    return this.size -= le ? 1 : 0, le;
  }
  function yn(W) {
    return Hv(this, W).get(W);
  }
  function Nf(W) {
    return Hv(this, W).has(W);
  }
  function _u(W, le) {
    var ve = Hv(this, W), tt = ve.size;
    return ve.set(W, le), this.size += ve.size == tt ? 0 : 1, this;
  }
  Gn.prototype.clear = ka, Gn.prototype.delete = Nc, Gn.prototype.get = yn, Gn.prototype.has = Nf, Gn.prototype.set = _u;
  function js(W) {
    var le = this.__data__ = new an(W);
    this.size = le.size;
  }
  function Su() {
    this.__data__ = new an(), this.size = 0;
  }
  function Rf(W) {
    var le = this.__data__, ve = le.delete(W);
    return this.size = le.size, ve;
  }
  function Mf(W) {
    return this.__data__.get(W);
  }
  function Ba(W) {
    return this.__data__.has(W);
  }
  function Ff(W, le) {
    var ve = this.__data__;
    if (ve instanceof an) {
      var tt = ve.__data__;
      if (!it || tt.length < n - 1)
        return tt.push([W, le]), this.size = ++ve.size, this;
      ve = this.__data__ = new Gn(tt);
    }
    return ve.set(W, le), this.size = ve.size, this;
  }
  js.prototype.clear = Su, js.prototype.delete = Rf, js.prototype.get = Mf, js.prototype.has = Ba, js.prototype.set = Ff;
  function Dt(W, le) {
    var ve = h3(W), tt = !ve && f3(W), Ut = !ve && !tt && FB(W), fn = !ve && !tt && !Ut && DB(W), xn = ve || tt || Ut || fn, Qt = xn ? ee(W.length, String) : [], An = Qt.length;
    for (var Ds in W)
      xn && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Ds == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      Ut && (Ds == "offset" || Ds == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      fn && (Ds == "buffer" || Ds == "byteLength" || Ds == "byteOffset") || // Skip index properties.
      RB(Ds, An)) || Qt.push(Ds);
    return Qt;
  }
  function Co(W, le, ve) {
    (ve !== void 0 && !Wv(W[le], ve) || ve === void 0 && !(le in W)) && bt(W, le, ve);
  }
  function jf(W, le, ve) {
    var tt = W[le];
    (!(je.call(W, le) && Wv(tt, ve)) || ve === void 0 && !(le in W)) && bt(W, le, ve);
  }
  function te(W, le) {
    for (var ve = W.length; ve--; )
      if (Wv(W[ve][0], le))
        return ve;
    return -1;
  }
  function bt(W, le, ve) {
    le == "__proto__" && ue ? ue(W, le, {
      configurable: !0,
      enumerable: !0,
      value: ve,
      writable: !0
    }) : W[le] = ve;
  }
  var It = GY();
  function mt(W) {
    return W == null ? W === void 0 ? x : y : H && H in Object(W) ? qY(W) : JY(W);
  }
  function To(W) {
    return u0(W) && mt(W) == a;
  }
  function Cu(W) {
    if (!Tu(W) || YY(W))
      return !1;
    var le = m3(W) ? Te : ge;
    return le.test(nZ(W));
  }
  function OB(W) {
    return u0(W) && jB(W.length) && !!he[mt(W)];
  }
  function MY(W) {
    if (!Tu(W))
      return ZY(W);
    var le = MB(W), ve = [];
    for (var tt in W)
      tt == "constructor" && (le || !je.call(W, tt)) || ve.push(tt);
    return ve;
  }
  function NB(W, le, ve, tt, Ut) {
    W !== le && It(le, function(fn, xn) {
      if (Ut || (Ut = new js()), Tu(fn))
        FY(W, le, xn, ve, NB, tt, Ut);
      else {
        var Qt = tt ? tt(d3(W, xn), fn, xn + "", W, le, Ut) : void 0;
        Qt === void 0 && (Qt = fn), Co(W, xn, Qt);
      }
    }, UB);
  }
  function FY(W, le, ve, tt, Ut, fn, xn) {
    var Qt = d3(W, ve), An = d3(le, ve), Ds = xn.get(An);
    if (Ds) {
      Co(W, ve, Ds);
      return;
    }
    var Di = fn ? fn(Qt, An, ve + "", W, le, xn) : void 0, d0 = Di === void 0;
    if (d0) {
      var g3 = h3(An), y3 = !g3 && FB(An), zB = !g3 && !y3 && DB(An);
      Di = An, g3 || y3 || zB ? h3(Qt) ? Di = Qt : rZ(Qt) ? Di = VY(Qt) : y3 ? (d0 = !1, Di = UY(An)) : zB ? (d0 = !1, Di = zY(An)) : Di = [] : iZ(An) || f3(An) ? (Di = Qt, f3(Qt) ? Di = sZ(Qt) : (!Tu(Qt) || m3(Qt)) && (Di = $Y(An))) : d0 = !1;
    }
    d0 && (xn.set(An, Di), Ut(Di, An, tt, fn, xn), xn.delete(An)), Co(W, ve, Di);
  }
  function jY(W, le) {
    return eZ(XY(W, le, LB), W + "");
  }
  var DY = ue ? function(W, le) {
    return ue(W, "toString", {
      configurable: !0,
      enumerable: !1,
      value: aZ(le),
      writable: !0
    });
  } : LB;
  function UY(W, le) {
    return W.slice();
  }
  function LY(W) {
    var le = new W.constructor(W.byteLength);
    return new O(le).set(new O(W)), le;
  }
  function zY(W, le) {
    var ve = LY(W.buffer);
    return new W.constructor(ve, W.byteOffset, W.length);
  }
  function VY(W, le) {
    var ve = -1, tt = W.length;
    for (le || (le = Array(tt)); ++ve < tt; )
      le[ve] = W[ve];
    return le;
  }
  function HY(W, le, ve, tt) {
    var Ut = !ve;
    ve || (ve = {});
    for (var fn = -1, xn = le.length; ++fn < xn; ) {
      var Qt = le[fn], An = void 0;
      An === void 0 && (An = W[Qt]), Ut ? bt(ve, Qt, An) : jf(ve, Qt, An);
    }
    return ve;
  }
  function WY(W) {
    return jY(function(le, ve) {
      var tt = -1, Ut = ve.length, fn = Ut > 1 ? ve[Ut - 1] : void 0, xn = Ut > 2 ? ve[2] : void 0;
      for (fn = W.length > 3 && typeof fn == "function" ? (Ut--, fn) : void 0, xn && QY(ve[0], ve[1], xn) && (fn = Ut < 3 ? void 0 : fn, Ut = 1), le = Object(le); ++tt < Ut; ) {
        var Qt = ve[tt];
        Qt && W(le, Qt, tt, fn);
      }
      return le;
    });
  }
  function GY(W) {
    return function(le, ve, tt) {
      for (var Ut = -1, fn = Object(le), xn = tt(le), Qt = xn.length; Qt--; ) {
        var An = xn[++Ut];
        if (ve(fn[An], An, fn) === !1)
          break;
      }
      return le;
    };
  }
  function Hv(W, le) {
    var ve = W.__data__;
    return KY(le) ? ve[typeof le == "string" ? "string" : "hash"] : ve.map;
  }
  function u3(W, le) {
    var ve = X(W, le);
    return Cu(ve) ? ve : void 0;
  }
  function qY(W) {
    var le = je.call(W, H), ve = W[H];
    try {
      W[H] = void 0;
      var tt = !0;
    } catch {
    }
    var Ut = Oe.call(W);
    return tt && (le ? W[H] = ve : delete W[H]), Ut;
  }
  function $Y(W) {
    return typeof W.constructor == "function" && !MB(W) ? rn(_(W)) : {};
  }
  function RB(W, le) {
    var ve = typeof W;
    return le = le ?? o, !!le && (ve == "number" || ve != "symbol" && Ae.test(W)) && W > -1 && W % 1 == 0 && W < le;
  }
  function QY(W, le, ve) {
    if (!Tu(ve))
      return !1;
    var tt = typeof le;
    return (tt == "number" ? p3(ve) && RB(le, ve.length) : tt == "string" && le in ve) ? Wv(ve[le], W) : !1;
  }
  function KY(W) {
    var le = typeof W;
    return le == "string" || le == "number" || le == "symbol" || le == "boolean" ? W !== "__proto__" : W === null;
  }
  function YY(W) {
    return !!Ye && Ye in W;
  }
  function MB(W) {
    var le = W && W.constructor, ve = typeof le == "function" && le.prototype || oe;
    return W === ve;
  }
  function ZY(W) {
    var le = [];
    if (W != null)
      for (var ve in Object(W))
        le.push(ve);
    return le;
  }
  function JY(W) {
    return Oe.call(W);
  }
  function XY(W, le, ve) {
    return le = Xe(le === void 0 ? W.length - 1 : le, 0), function() {
      for (var tt = arguments, Ut = -1, fn = Xe(tt.length - le, 0), xn = Array(fn); ++Ut < fn; )
        xn[Ut] = tt[le + Ut];
      Ut = -1;
      for (var Qt = Array(le + 1); ++Ut < le; )
        Qt[Ut] = tt[Ut];
      return Qt[le] = ve(xn), ne(W, this, Qt);
    };
  }
  function d3(W, le) {
    if (!(le === "constructor" && typeof W[le] == "function") && le != "__proto__")
      return W[le];
  }
  var eZ = tZ(DY);
  function tZ(W) {
    var le = 0, ve = 0;
    return function() {
      var tt = Ge(), Ut = s - (tt - ve);
      if (ve = tt, Ut > 0) {
        if (++le >= i)
          return arguments[0];
      } else
        le = 0;
      return W.apply(void 0, arguments);
    };
  }
  function nZ(W) {
    if (W != null) {
      try {
        return Me.call(W);
      } catch {
      }
      try {
        return W + "";
      } catch {
      }
    }
    return "";
  }
  function Wv(W, le) {
    return W === le || W !== W && le !== le;
  }
  var f3 = To(/* @__PURE__ */ function() {
    return arguments;
  }()) ? To : function(W) {
    return u0(W) && je.call(W, "callee") && !M.call(W, "callee");
  }, h3 = Array.isArray;
  function p3(W) {
    return W != null && jB(W.length) && !m3(W);
  }
  function rZ(W) {
    return u0(W) && p3(W);
  }
  var FB = Ee || cZ;
  function m3(W) {
    if (!Tu(W))
      return !1;
    var le = mt(W);
    return le == p || le == m || le == l || le == b;
  }
  function jB(W) {
    return typeof W == "number" && W > -1 && W % 1 == 0 && W <= o;
  }
  function Tu(W) {
    var le = typeof W;
    return W != null && (le == "object" || le == "function");
  }
  function u0(W) {
    return W != null && typeof W == "object";
  }
  function iZ(W) {
    if (!u0(W) || mt(W) != v)
      return !1;
    var le = _(W);
    if (le === null)
      return !0;
    var ve = je.call(le, "constructor") && le.constructor;
    return typeof ve == "function" && ve instanceof ve && Me.call(ve) == De;
  }
  var DB = z ? Y(z) : OB;
  function sZ(W) {
    return HY(W, UB(W));
  }
  function UB(W) {
    return p3(W) ? Dt(W) : MY(W);
  }
  var oZ = WY(function(W, le, ve, tt) {
    NB(W, le, ve, tt);
  });
  function aZ(W) {
    return function() {
      return W;
    };
  }
  function LB(W) {
    return W;
  }
  function cZ() {
    return !1;
  }
  e.exports = oZ;
})(jx, jx.exports);
var aue = jx.exports;
const Ts = /* @__PURE__ */ Sk(aue);
var cue = (e) => /!(important)?$/.test(e), PP = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, lue = (e, t) => (n) => {
  const r = String(t), i = cue(r), s = PP(r), o = e ? `${e}.${s}` : s;
  let a = Ii(n.__cssMap) && o in n.__cssMap ? n.__cssMap[o].varRef : t;
  return a = PP(a), i ? `${a} !important` : a;
};
function q5(e) {
  const { scale: t, transform: n, compose: r } = e;
  return (s, o) => {
    var a;
    const c = lue(t, s)(o);
    let l = (a = n == null ? void 0 : n(c, o)) != null ? a : c;
    return r && (l = r(l, o)), l;
  };
}
var i1 = (...e) => (t) => e.reduce((n, r) => r(n), t);
function ss(e, t) {
  return (n) => {
    const r = { property: n, scale: e };
    return r.transform = q5({
      scale: e,
      transform: t
    }), r;
  };
}
var uue = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function due(e) {
  const { property: t, scale: n, transform: r } = e;
  return {
    scale: n,
    property: uue(t),
    transform: n ? q5({
      scale: n,
      compose: r
    }) : r
  };
}
var LL = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function fue() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...LL
  ].join(" ");
}
function hue() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...LL
  ].join(" ");
}
var pue = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, mue = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function gue(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var yue = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, YS = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, bue = new Set(Object.values(YS)), ZS = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), vue = (e) => e.trim();
function wue(e, t) {
  if (e == null || ZS.has(e))
    return e;
  if (!(JS(e) || ZS.has(e)))
    return `url('${e}')`;
  const i = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), s = i == null ? void 0 : i[1], o = i == null ? void 0 : i[2];
  if (!s || !o)
    return e;
  const a = s.includes("-gradient") ? s : `${s}-gradient`, [c, ...l] = o.split(",").map(vue).filter(Boolean);
  if ((l == null ? void 0 : l.length) === 0)
    return e;
  const u = c in YS ? YS[c] : c;
  l.unshift(u);
  const d = l.map((f) => {
    if (bue.has(f))
      return f;
    const p = f.indexOf(" "), [m, h] = p !== -1 ? [f.substr(0, p), f.substr(p + 1)] : [f], g = JS(h) ? h : h && h.split(" "), y = `colors.${m}`, v = y in t.__cssMap ? t.__cssMap[y].varRef : m;
    return g ? [
      v,
      ...Array.isArray(g) ? g : [g]
    ].join(" ") : v;
  });
  return `${a}(${d.join(", ")})`;
}
var JS = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), xue = (e, t) => wue(e, t ?? {});
function Aue(e) {
  return /^var\(--.+\)$/.test(e);
}
var Eue = (e) => {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}, Bo = (e) => (t) => `${e}(${t})`, Mt = {
  filter(e) {
    return e !== "auto" ? e : pue;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : mue;
  },
  ring(e) {
    return gue(Mt.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? fue() : e === "auto-gpu" ? hue() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = Eue(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const n = { left: "right", right: "left" };
    return t.direction === "rtl" ? n[e] : e;
  },
  degree(e) {
    if (Aue(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: xue,
  blur: Bo("blur"),
  opacity: Bo("opacity"),
  brightness: Bo("brightness"),
  contrast: Bo("contrast"),
  dropShadow: Bo("drop-shadow"),
  grayscale: Bo("grayscale"),
  hueRotate: (e) => Bo("hue-rotate")(Mt.degree(e)),
  invert: Bo("invert"),
  saturate: Bo("saturate"),
  sepia: Bo("sepia"),
  bgImage(e) {
    return e == null || JS(e) || ZS.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    var t;
    const { space: n, divide: r } = (t = yue[e]) != null ? t : {}, i = { flexDirection: e };
    return n && (i[n] = 1), r && (i[r] = 1), i;
  }
}, ce = {
  borderWidths: ss("borderWidths"),
  borderStyles: ss("borderStyles"),
  colors: ss("colors"),
  borders: ss("borders"),
  gradients: ss("gradients", Mt.gradient),
  radii: ss("radii", Mt.px),
  space: ss("space", i1(Mt.vh, Mt.px)),
  spaceT: ss("space", i1(Mt.vh, Mt.px)),
  degreeT(e) {
    return { property: e, transform: Mt.degree };
  },
  prop(e, t, n) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: q5({ scale: t, transform: n })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: ss("sizes", i1(Mt.vh, Mt.px)),
  sizesT: ss("sizes", i1(Mt.vh, Mt.fraction)),
  shadows: ss("shadows"),
  logical: due,
  blur: ss("blur", Mt.blur)
}, gw = {
  background: ce.colors("background"),
  backgroundColor: ce.colors("backgroundColor"),
  backgroundImage: ce.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: Mt.bgClip },
  bgSize: ce.prop("backgroundSize"),
  bgPosition: ce.prop("backgroundPosition"),
  bg: ce.colors("background"),
  bgColor: ce.colors("backgroundColor"),
  bgPos: ce.prop("backgroundPosition"),
  bgRepeat: ce.prop("backgroundRepeat"),
  bgAttachment: ce.prop("backgroundAttachment"),
  bgGradient: ce.gradients("backgroundImage"),
  bgClip: { transform: Mt.bgClip }
};
Object.assign(gw, {
  bgImage: gw.backgroundImage,
  bgImg: gw.backgroundImage
});
var Kt = {
  border: ce.borders("border"),
  borderWidth: ce.borderWidths("borderWidth"),
  borderStyle: ce.borderStyles("borderStyle"),
  borderColor: ce.colors("borderColor"),
  borderRadius: ce.radii("borderRadius"),
  borderTop: ce.borders("borderTop"),
  borderBlockStart: ce.borders("borderBlockStart"),
  borderTopLeftRadius: ce.radii("borderTopLeftRadius"),
  borderStartStartRadius: ce.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: ce.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: ce.radii("borderTopRightRadius"),
  borderStartEndRadius: ce.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: ce.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: ce.borders("borderRight"),
  borderInlineEnd: ce.borders("borderInlineEnd"),
  borderBottom: ce.borders("borderBottom"),
  borderBlockEnd: ce.borders("borderBlockEnd"),
  borderBottomLeftRadius: ce.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: ce.radii("borderBottomRightRadius"),
  borderLeft: ce.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: ce.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: ce.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: ce.borders(["borderLeft", "borderRight"]),
  borderInline: ce.borders("borderInline"),
  borderY: ce.borders(["borderTop", "borderBottom"]),
  borderBlock: ce.borders("borderBlock"),
  borderTopWidth: ce.borderWidths("borderTopWidth"),
  borderBlockStartWidth: ce.borderWidths("borderBlockStartWidth"),
  borderTopColor: ce.colors("borderTopColor"),
  borderBlockStartColor: ce.colors("borderBlockStartColor"),
  borderTopStyle: ce.borderStyles("borderTopStyle"),
  borderBlockStartStyle: ce.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: ce.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: ce.borderWidths("borderBlockEndWidth"),
  borderBottomColor: ce.colors("borderBottomColor"),
  borderBlockEndColor: ce.colors("borderBlockEndColor"),
  borderBottomStyle: ce.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: ce.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: ce.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: ce.borderWidths("borderInlineStartWidth"),
  borderLeftColor: ce.colors("borderLeftColor"),
  borderInlineStartColor: ce.colors("borderInlineStartColor"),
  borderLeftStyle: ce.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: ce.borderStyles("borderInlineStartStyle"),
  borderRightWidth: ce.borderWidths("borderRightWidth"),
  borderInlineEndWidth: ce.borderWidths("borderInlineEndWidth"),
  borderRightColor: ce.colors("borderRightColor"),
  borderInlineEndColor: ce.colors("borderInlineEndColor"),
  borderRightStyle: ce.borderStyles("borderRightStyle"),
  borderInlineEndStyle: ce.borderStyles("borderInlineEndStyle"),
  borderTopRadius: ce.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: ce.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: ce.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: ce.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(Kt, {
  rounded: Kt.borderRadius,
  roundedTop: Kt.borderTopRadius,
  roundedTopLeft: Kt.borderTopLeftRadius,
  roundedTopRight: Kt.borderTopRightRadius,
  roundedTopStart: Kt.borderStartStartRadius,
  roundedTopEnd: Kt.borderStartEndRadius,
  roundedBottom: Kt.borderBottomRadius,
  roundedBottomLeft: Kt.borderBottomLeftRadius,
  roundedBottomRight: Kt.borderBottomRightRadius,
  roundedBottomStart: Kt.borderEndStartRadius,
  roundedBottomEnd: Kt.borderEndEndRadius,
  roundedLeft: Kt.borderLeftRadius,
  roundedRight: Kt.borderRightRadius,
  roundedStart: Kt.borderInlineStartRadius,
  roundedEnd: Kt.borderInlineEndRadius,
  borderStart: Kt.borderInlineStart,
  borderEnd: Kt.borderInlineEnd,
  borderTopStartRadius: Kt.borderStartStartRadius,
  borderTopEndRadius: Kt.borderStartEndRadius,
  borderBottomStartRadius: Kt.borderEndStartRadius,
  borderBottomEndRadius: Kt.borderEndEndRadius,
  borderStartRadius: Kt.borderInlineStartRadius,
  borderEndRadius: Kt.borderInlineEndRadius,
  borderStartWidth: Kt.borderInlineStartWidth,
  borderEndWidth: Kt.borderInlineEndWidth,
  borderStartColor: Kt.borderInlineStartColor,
  borderEndColor: Kt.borderInlineEndColor,
  borderStartStyle: Kt.borderInlineStartStyle,
  borderEndStyle: Kt.borderInlineEndStyle
});
var _ue = {
  color: ce.colors("color"),
  textColor: ce.colors("color"),
  fill: ce.colors("fill"),
  stroke: ce.colors("stroke")
}, XS = {
  boxShadow: ce.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: ce.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: ce.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(XS, {
  shadow: XS.boxShadow
});
var Sue = {
  filter: { transform: Mt.filter },
  blur: ce.blur("--chakra-blur"),
  brightness: ce.propT("--chakra-brightness", Mt.brightness),
  contrast: ce.propT("--chakra-contrast", Mt.contrast),
  hueRotate: ce.propT("--chakra-hue-rotate", Mt.hueRotate),
  invert: ce.propT("--chakra-invert", Mt.invert),
  saturate: ce.propT("--chakra-saturate", Mt.saturate),
  dropShadow: ce.propT("--chakra-drop-shadow", Mt.dropShadow),
  backdropFilter: { transform: Mt.backdropFilter },
  backdropBlur: ce.blur("--chakra-backdrop-blur"),
  backdropBrightness: ce.propT(
    "--chakra-backdrop-brightness",
    Mt.brightness
  ),
  backdropContrast: ce.propT("--chakra-backdrop-contrast", Mt.contrast),
  backdropHueRotate: ce.propT(
    "--chakra-backdrop-hue-rotate",
    Mt.hueRotate
  ),
  backdropInvert: ce.propT("--chakra-backdrop-invert", Mt.invert),
  backdropSaturate: ce.propT("--chakra-backdrop-saturate", Mt.saturate)
}, Dx = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: Mt.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: ce.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: ce.space("gap"),
  rowGap: ce.space("rowGap"),
  columnGap: ce.space("columnGap")
};
Object.assign(Dx, {
  flexDir: Dx.flexDirection
});
var zL = {
  gridGap: ce.space("gridGap"),
  gridColumnGap: ce.space("gridColumnGap"),
  gridRowGap: ce.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, Cue = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: Mt.outline },
  outlineOffset: !0,
  outlineColor: ce.colors("outlineColor")
}, cs = {
  width: ce.sizesT("width"),
  inlineSize: ce.sizesT("inlineSize"),
  height: ce.sizes("height"),
  blockSize: ce.sizes("blockSize"),
  boxSize: ce.sizes(["width", "height"]),
  minWidth: ce.sizes("minWidth"),
  minInlineSize: ce.sizes("minInlineSize"),
  minHeight: ce.sizes("minHeight"),
  minBlockSize: ce.sizes("minBlockSize"),
  maxWidth: ce.sizes("maxWidth"),
  maxInlineSize: ce.sizes("maxInlineSize"),
  maxHeight: ce.sizes("maxHeight"),
  maxBlockSize: ce.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var n, r, i;
      return { [`@media screen and (min-width: ${(i = (r = (n = t.__breakpoints) == null ? void 0 : n.get(e)) == null ? void 0 : r.minW) != null ? i : e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var n, r, i;
      return { [`@media screen and (max-width: ${(i = (r = (n = t.__breakpoints) == null ? void 0 : n.get(e)) == null ? void 0 : r._minW) != null ? i : e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: ce.propT("float", Mt.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(cs, {
  w: cs.width,
  h: cs.height,
  minW: cs.minWidth,
  maxW: cs.maxWidth,
  minH: cs.minHeight,
  maxH: cs.maxHeight,
  overscroll: cs.overscrollBehavior,
  overscrollX: cs.overscrollBehaviorX,
  overscrollY: cs.overscrollBehaviorY
});
var Tue = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: ce.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: ce.prop("listStyleImage")
};
function kue(e, t, n, r) {
  const i = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < i.length && e; r += 1)
    e = e[i[r]];
  return e === void 0 ? n : e;
}
var Bue = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, i, s, o) => {
    if (typeof r > "u")
      return e(r, i, s);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const a = t.get(r);
    if (a.has(i))
      return a.get(i);
    const c = e(r, i, s, o);
    return a.set(i, c), c;
  };
}, Iue = Bue(kue), Pue = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, Oue = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, o_ = (e, t, n) => {
  const r = {}, i = Iue(e, t, {});
  for (const s in i)
    s in n && n[s] != null || (r[s] = i[s]);
  return r;
}, Nue = {
  srOnly: {
    transform(e) {
      return e === !0 ? Pue : e === "focusable" ? Oue : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, n) => o_(t, `layerStyles.${e}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, n) => o_(t, `textStyles.${e}`, n)
  },
  apply: {
    processResult: !0,
    transform: (e, t, n) => o_(t, e, n)
  }
}, hg = {
  position: !0,
  pos: ce.prop("position"),
  zIndex: ce.prop("zIndex", "zIndices"),
  inset: ce.spaceT("inset"),
  insetX: ce.spaceT(["left", "right"]),
  insetInline: ce.spaceT("insetInline"),
  insetY: ce.spaceT(["top", "bottom"]),
  insetBlock: ce.spaceT("insetBlock"),
  top: ce.spaceT("top"),
  insetBlockStart: ce.spaceT("insetBlockStart"),
  bottom: ce.spaceT("bottom"),
  insetBlockEnd: ce.spaceT("insetBlockEnd"),
  left: ce.spaceT("left"),
  insetInlineStart: ce.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: ce.spaceT("right"),
  insetInlineEnd: ce.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(hg, {
  insetStart: hg.insetInlineStart,
  insetEnd: hg.insetInlineEnd
});
var Rue = {
  ring: { transform: Mt.ring },
  ringColor: ce.colors("--chakra-ring-color"),
  ringOffset: ce.prop("--chakra-ring-offset-width"),
  ringOffsetColor: ce.colors("--chakra-ring-offset-color"),
  ringInset: ce.prop("--chakra-ring-inset")
}, bn = {
  margin: ce.spaceT("margin"),
  marginTop: ce.spaceT("marginTop"),
  marginBlockStart: ce.spaceT("marginBlockStart"),
  marginRight: ce.spaceT("marginRight"),
  marginInlineEnd: ce.spaceT("marginInlineEnd"),
  marginBottom: ce.spaceT("marginBottom"),
  marginBlockEnd: ce.spaceT("marginBlockEnd"),
  marginLeft: ce.spaceT("marginLeft"),
  marginInlineStart: ce.spaceT("marginInlineStart"),
  marginX: ce.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: ce.spaceT("marginInline"),
  marginY: ce.spaceT(["marginTop", "marginBottom"]),
  marginBlock: ce.spaceT("marginBlock"),
  padding: ce.space("padding"),
  paddingTop: ce.space("paddingTop"),
  paddingBlockStart: ce.space("paddingBlockStart"),
  paddingRight: ce.space("paddingRight"),
  paddingBottom: ce.space("paddingBottom"),
  paddingBlockEnd: ce.space("paddingBlockEnd"),
  paddingLeft: ce.space("paddingLeft"),
  paddingInlineStart: ce.space("paddingInlineStart"),
  paddingInlineEnd: ce.space("paddingInlineEnd"),
  paddingX: ce.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: ce.space("paddingInline"),
  paddingY: ce.space(["paddingTop", "paddingBottom"]),
  paddingBlock: ce.space("paddingBlock")
};
Object.assign(bn, {
  m: bn.margin,
  mt: bn.marginTop,
  mr: bn.marginRight,
  me: bn.marginInlineEnd,
  marginEnd: bn.marginInlineEnd,
  mb: bn.marginBottom,
  ml: bn.marginLeft,
  ms: bn.marginInlineStart,
  marginStart: bn.marginInlineStart,
  mx: bn.marginX,
  my: bn.marginY,
  p: bn.padding,
  pt: bn.paddingTop,
  py: bn.paddingY,
  px: bn.paddingX,
  pb: bn.paddingBottom,
  pl: bn.paddingLeft,
  ps: bn.paddingInlineStart,
  paddingStart: bn.paddingInlineStart,
  pr: bn.paddingRight,
  pe: bn.paddingInlineEnd,
  paddingEnd: bn.paddingInlineEnd
});
var Mue = {
  textDecorationColor: ce.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: ce.shadows("textShadow")
}, Fue = {
  clipPath: !0,
  transform: ce.propT("transform", Mt.transform),
  transformOrigin: !0,
  translateX: ce.spaceT("--chakra-translate-x"),
  translateY: ce.spaceT("--chakra-translate-y"),
  skewX: ce.degreeT("--chakra-skew-x"),
  skewY: ce.degreeT("--chakra-skew-y"),
  scaleX: ce.prop("--chakra-scale-x"),
  scaleY: ce.prop("--chakra-scale-y"),
  scale: ce.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: ce.degreeT("--chakra-rotate")
}, jue = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: ce.prop("transitionDuration", "transition.duration"),
  transitionProperty: ce.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: ce.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, Due = {
  fontFamily: ce.prop("fontFamily", "fonts"),
  fontSize: ce.prop("fontSize", "fontSizes", Mt.px),
  fontWeight: ce.prop("fontWeight", "fontWeights"),
  lineHeight: ce.prop("lineHeight", "lineHeights"),
  letterSpacing: ce.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, Uue = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: ce.spaceT("scrollMargin"),
  scrollMarginTop: ce.spaceT("scrollMarginTop"),
  scrollMarginBottom: ce.spaceT("scrollMarginBottom"),
  scrollMarginLeft: ce.spaceT("scrollMarginLeft"),
  scrollMarginRight: ce.spaceT("scrollMarginRight"),
  scrollMarginX: ce.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: ce.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: ce.spaceT("scrollPadding"),
  scrollPaddingTop: ce.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: ce.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: ce.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: ce.spaceT("scrollPaddingRight"),
  scrollPaddingX: ce.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: ce.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function VL(e) {
  return Ii(e) && e.reference ? e.reference : String(e);
}
var nE = (e, ...t) => t.map(VL).join(` ${e} `).replace(/calc/g, ""), OP = (...e) => `calc(${nE("+", ...e)})`, NP = (...e) => `calc(${nE("-", ...e)})`, eC = (...e) => `calc(${nE("*", ...e)})`, RP = (...e) => `calc(${nE("/", ...e)})`, MP = (e) => {
  const t = VL(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : eC(t, -1);
}, Uu = Object.assign(
  (e) => ({
    add: (...t) => Uu(OP(e, ...t)),
    subtract: (...t) => Uu(NP(e, ...t)),
    multiply: (...t) => Uu(eC(e, ...t)),
    divide: (...t) => Uu(RP(e, ...t)),
    negate: () => Uu(MP(e)),
    toString: () => e.toString()
  }),
  {
    add: OP,
    subtract: NP,
    multiply: eC,
    divide: RP,
    negate: MP
  }
);
function Lue(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function zue(e) {
  const t = Lue(e.toString());
  return Hue(Vue(t));
}
function Vue(e) {
  return e.includes("\\.") ? e : !Number.isInteger(parseFloat(e.toString())) ? e.replace(".", "\\.") : e;
}
function Hue(e) {
  return e.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function Wue(e, t = "") {
  return [t, e].filter(Boolean).join("-");
}
function Gue(e, t) {
  return `var(${e}${t ? `, ${t}` : ""})`;
}
function que(e, t = "") {
  return zue(`--${Wue(e, t)}`);
}
function ct(e, t, n) {
  const r = que(e, n);
  return {
    variable: r,
    reference: Gue(r, t)
  };
}
function $ue(e, t) {
  const n = {};
  for (const r of t) {
    if (Array.isArray(r)) {
      const [i, s] = r;
      n[i] = ct(`${e}-${i}`, s);
      continue;
    }
    n[r] = ct(`${e}-${r}`);
  }
  return n;
}
function Que(e) {
  const t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function Kue(e) {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}
function tC(e) {
  if (e == null)
    return e;
  const { unitless: t } = Kue(e);
  return t || typeof e == "number" ? `${e}px` : e;
}
var HL = (e, t) => parseInt(e[1], 10) > parseInt(t[1], 10) ? 1 : -1, $5 = (e) => Object.fromEntries(Object.entries(e).sort(HL));
function FP(e) {
  const t = $5(e);
  return Object.assign(Object.values(t), t);
}
function Yue(e) {
  const t = Object.keys($5(e));
  return new Set(t);
}
function jP(e) {
  var t;
  if (!e)
    return e;
  e = (t = tC(e)) != null ? t : e;
  const n = -0.02;
  return typeof e == "number" ? `${e + n}` : e.replace(/(\d+\.?\d*)/u, (r) => `${parseFloat(r) + n}`);
}
function L0(e, t) {
  const n = ["@media screen"];
  return e && n.push("and", `(min-width: ${tC(e)})`), t && n.push("and", `(max-width: ${tC(t)})`), n.join(" ");
}
function Zue(e) {
  var t;
  if (!e)
    return null;
  e.base = (t = e.base) != null ? t : "0px";
  const n = FP(e), r = Object.entries(e).sort(HL).map(([o, a], c, l) => {
    var u;
    let [, d] = (u = l[c + 1]) != null ? u : [];
    return d = parseFloat(d) > 0 ? jP(d) : void 0, {
      _minW: jP(a),
      breakpoint: o,
      minW: a,
      maxW: d,
      maxWQuery: L0(null, d),
      minWQuery: L0(a),
      minMaxQuery: L0(a, d)
    };
  }), i = Yue(e), s = Array.from(i.values());
  return {
    keys: i,
    normalized: n,
    isResponsive(o) {
      const a = Object.keys(o);
      return a.length > 0 && a.every((c) => i.has(c));
    },
    asObject: $5(e),
    asArray: FP(e),
    details: r,
    get(o) {
      return r.find((a) => a.breakpoint === o);
    },
    media: [
      null,
      ...n.map((o) => L0(o)).slice(1)
    ],
    /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */
    toArrayValue(o) {
      if (!Ii(o))
        throw new Error("toArrayValue: value must be an object");
      const a = s.map((c) => {
        var l;
        return (l = o[c]) != null ? l : null;
      });
      for (; Que(a) === null; )
        a.pop();
      return a;
    },
    /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */
    toObjectValue(o) {
      if (!Array.isArray(o))
        throw new Error("toObjectValue: value must be an array");
      return o.reduce((a, c, l) => {
        const u = s[l];
        return u != null && c != null && (a[u] = c), a;
      }, {});
    }
  };
}
var br = {
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, Dc = (e) => WL((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), Pa = (e) => WL((t) => e(t, "~ &"), "[data-peer]", ".peer"), WL = (e, ...t) => t.map(e).join(", "), rE = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: Dc(br.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: Pa(br.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: Dc(br.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: Pa(br.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: Dc(br.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: Pa(br.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: Dc(br.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: Pa(br.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: Dc(br.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: Pa(br.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: Dc(br.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: Pa(br.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: Dc(br.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: Pa(br.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: Dc(br.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: Pa(br.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: Pa(br.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]"
}, GL = Object.keys(
  rE
);
function DP(e, t) {
  return ct(String(e).replace(/\./g, "-"), void 0, t);
}
function Jue(e, t) {
  let n = {};
  const r = {};
  for (const [i, s] of Object.entries(e)) {
    const { isSemantic: o, value: a } = s, { variable: c, reference: l } = DP(i, t == null ? void 0 : t.cssVarPrefix);
    if (!o) {
      if (i.startsWith("space")) {
        const f = i.split("."), [p, ...m] = f, h = `${p}.-${m.join(".")}`, g = Uu.negate(a), y = Uu.negate(l);
        r[h] = {
          value: g,
          var: c,
          varRef: y
        };
      }
      n[c] = a, r[i] = {
        value: a,
        var: c,
        varRef: l
      };
      continue;
    }
    const u = (f) => {
      const m = [String(i).split(".")[0], f].join(".");
      if (!e[m])
        return f;
      const { reference: g } = DP(m, t == null ? void 0 : t.cssVarPrefix);
      return g;
    }, d = Ii(a) ? a : { default: a };
    n = Ts(
      n,
      Object.entries(d).reduce(
        (f, [p, m]) => {
          var h, g;
          if (!m)
            return f;
          const y = u(`${m}`);
          if (p === "default")
            return f[c] = y, f;
          const v = (g = (h = rE) == null ? void 0 : h[p]) != null ? g : p;
          return f[v] = { [c]: y }, f;
        },
        {}
      )
    ), r[i] = {
      value: l,
      var: c,
      varRef: l
    };
  }
  return {
    cssVars: n,
    cssMap: r
  };
}
function Xue(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
function ede(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
function tde(e) {
  return typeof e == "object" && e != null && !Array.isArray(e);
}
function UP(e, t, n = {}) {
  const { stop: r, getKey: i } = n;
  function s(o, a = []) {
    var c;
    if (tde(o) || Array.isArray(o)) {
      const l = {};
      for (const [u, d] of Object.entries(o)) {
        const f = (c = i == null ? void 0 : i(u)) != null ? c : u, p = [...a, f];
        if (r != null && r(o, p))
          return t(o, a);
        l[f] = s(d, p);
      }
      return l;
    }
    return t(o, a);
  }
  return s(e);
}
var nde = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function rde(e) {
  return ede(e, nde);
}
function ide(e) {
  return e.semanticTokens;
}
function sde(e) {
  const { __cssMap: t, __cssVars: n, __breakpoints: r, ...i } = e;
  return i;
}
var ode = (e) => GL.includes(e) || e === "default";
function ade({
  tokens: e,
  semanticTokens: t
}) {
  const n = {};
  return UP(e, (r, i) => {
    r != null && (n[i.join(".")] = { isSemantic: !1, value: r });
  }), UP(
    t,
    (r, i) => {
      r != null && (n[i.join(".")] = { isSemantic: !0, value: r });
    },
    {
      stop: (r) => Object.keys(r).every(ode)
    }
  ), n;
}
function cde(e) {
  var t;
  const n = sde(e), r = rde(n), i = ide(n), s = ade({ tokens: r, semanticTokens: i }), o = (t = n.config) == null ? void 0 : t.cssVarPrefix, {
    /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */
    cssMap: a,
    /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */
    cssVars: c
  } = Jue(s, { cssVarPrefix: o });
  return Object.assign(n, {
    __cssVars: { ...{
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    }, ...c },
    __cssMap: a,
    __breakpoints: Zue(n.breakpoints)
  }), n;
}
var Q5 = Ts(
  {},
  gw,
  Kt,
  _ue,
  Dx,
  cs,
  Sue,
  Rue,
  Cue,
  zL,
  Nue,
  hg,
  XS,
  bn,
  Uue,
  Due,
  Mue,
  Fue,
  Tue,
  jue
);
Object.assign({}, bn, cs, Dx, zL, hg);
var lde = [...Object.keys(Q5), ...GL], ude = { ...Q5, ...rE }, dde = (e) => e in ude, fde = (e) => (t) => {
  if (!t.__breakpoints)
    return e;
  const { isResponsive: n, toArrayValue: r, media: i } = t.__breakpoints, s = {};
  for (const o in e) {
    let a = oo(e[o], t);
    if (a == null)
      continue;
    if (a = Ii(a) && n(a) ? r(a) : a, !Array.isArray(a)) {
      s[o] = a;
      continue;
    }
    const c = a.slice(0, i.length).length;
    for (let l = 0; l < c; l += 1) {
      const u = i == null ? void 0 : i[l];
      if (!u) {
        s[o] = a[l];
        continue;
      }
      s[u] = s[u] || {}, a[l] != null && (s[u][o] = a[l]);
    }
  }
  return s;
};
function hde(e) {
  const t = [];
  let n = "", r = !1;
  for (let i = 0; i < e.length; i++) {
    const s = e[i];
    s === "(" ? (r = !0, n += s) : s === ")" ? (r = !1, n += s) : s === "," && !r ? (t.push(n), n = "") : n += s;
  }
  return n = n.trim(), n && t.push(n), t;
}
function pde(e) {
  return /^var\(--.+\)$/.test(e);
}
var mde = (e, t) => e.startsWith("--") && typeof t == "string" && !pde(t), gde = (e, t) => {
  var n, r;
  if (t == null)
    return t;
  const i = (c) => {
    var l, u;
    return (u = (l = e.__cssMap) == null ? void 0 : l[c]) == null ? void 0 : u.varRef;
  }, s = (c) => {
    var l;
    return (l = i(c)) != null ? l : c;
  }, [o, a] = hde(t);
  return t = (r = (n = i(o)) != null ? n : s(a)) != null ? r : s(t), t;
};
function yde(e) {
  const { configs: t = {}, pseudos: n = {}, theme: r } = e, i = (s, o = !1) => {
    var a, c, l;
    const u = oo(s, r), d = fde(u)(r);
    let f = {};
    for (let p in d) {
      const m = d[p];
      let h = oo(m, r);
      p in n && (p = n[p]), mde(p, h) && (h = gde(r, h));
      let g = t[p];
      if (g === !0 && (g = { property: p }), Ii(h)) {
        f[p] = (a = f[p]) != null ? a : {}, f[p] = Ts(
          {},
          f[p],
          i(h, !0)
        );
        continue;
      }
      let y = (l = (c = g == null ? void 0 : g.transform) == null ? void 0 : c.call(g, h, r, u)) != null ? l : h;
      y = g != null && g.processResult ? i(y, !0) : y;
      const v = oo(g == null ? void 0 : g.property, r);
      if (!o && (g != null && g.static)) {
        const b = oo(g.static, r);
        f = Ts({}, f, b);
      }
      if (v && Array.isArray(v)) {
        for (const b of v)
          f[b] = y;
        continue;
      }
      if (v) {
        v === "&" && Ii(y) ? f = Ts({}, f, y) : f[v] = y;
        continue;
      }
      if (Ii(y)) {
        f = Ts({}, f, y);
        continue;
      }
      f[p] = y;
    }
    return f;
  };
  return i;
}
var qL = (e) => (t) => yde({
  theme: t,
  pseudos: rE,
  configs: Q5
})(e);
function gn(e) {
  return {
    definePartsStyle(t) {
      return t;
    },
    defineMultiStyleConfig(t) {
      return { parts: e, ...t };
    }
  };
}
function bde(e, t) {
  if (Array.isArray(e))
    return e;
  if (Ii(e))
    return t(e);
  if (e != null)
    return [e];
}
function vde(e, t) {
  for (let n = t + 1; n < e.length; n++)
    if (e[n] != null)
      return n;
  return -1;
}
function wde(e) {
  const t = e.__breakpoints;
  return function(r, i, s, o) {
    var a, c;
    if (!t)
      return;
    const l = {}, u = bde(s, t.toArrayValue);
    if (!u)
      return l;
    const d = u.length, f = d === 1, p = !!r.parts;
    for (let m = 0; m < d; m++) {
      const h = t.details[m], g = t.details[vde(u, m)], y = L0(h.minW, g == null ? void 0 : g._minW), v = oo((a = r[i]) == null ? void 0 : a[u[m]], o);
      if (v) {
        if (p) {
          (c = r.parts) == null || c.forEach((b) => {
            Ts(l, {
              [b]: f ? v[b] : { [y]: v[b] }
            });
          });
          continue;
        }
        if (!p) {
          f ? Ts(l, v) : l[y] = v;
          continue;
        }
        l[y] = v;
      }
    }
    return l;
  };
}
function xde(e) {
  return (t) => {
    var n;
    const { variant: r, size: i, theme: s } = t, o = wde(s);
    return Ts(
      {},
      oo((n = e.baseStyle) != null ? n : {}, t),
      o(e, "sizes", i, t),
      o(e, "variants", r, t)
    );
  };
}
function xo(e) {
  return Xue(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
var Ade = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function Ede(e) {
  return Ii(e) ? Ade.every(
    (t) => Object.prototype.hasOwnProperty.call(e, t)
  ) : !1;
}
var _de = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, Sde = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, Cde = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, Tde = {
  property: _de,
  easing: Sde,
  duration: Cde
}, kde = Tde, Bde = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, Ide = Bde, Pde = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, Ode = Pde, Nde = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}, Rde = Nde, Mde = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, Fde = Mde, jde = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, Dde = jde, Ude = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, Lde = Ude, zde = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, Vde = zde, Hde = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, $L = Hde, QL = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, Wde = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
}, Gde = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, qde = {
  ...QL,
  ...Wde,
  container: Gde
}, KL = qde, $de = {
  breakpoints: Rde,
  zIndices: Ide,
  radii: Dde,
  blur: Vde,
  colors: Fde,
  ...$L,
  sizes: KL,
  shadows: Lde,
  space: QL,
  borders: Ode,
  transition: kde
}, { defineMultiStyleConfig: Qde, definePartsStyle: z0 } = gn([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), tc = ct("stepper-indicator-size"), yh = ct("stepper-icon-size"), bh = ct("stepper-title-font-size"), V0 = ct("stepper-description-font-size"), b0 = ct("stepper-accent-color"), Kde = z0(({ colorScheme: e }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [b0.variable]: `colors.${e}.500`,
    _dark: {
      [b0.variable]: `colors.${e}.200`
    }
  },
  title: {
    fontSize: bh.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: V0.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: bh.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: yh.reference,
    height: yh.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: tc.reference,
    height: tc.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: b0.reference
    },
    "&[data-status=complete]": {
      bg: b0.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: b0.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${tc.reference} - 8px)`,
      top: `calc(${tc.reference} + 4px)`,
      insetStart: `calc(${tc.reference} / 2 - 1px)`
    }
  }
})), Yde = Qde({
  baseStyle: Kde,
  sizes: {
    xs: z0({
      stepper: {
        [tc.variable]: "sizes.4",
        [yh.variable]: "sizes.3",
        [bh.variable]: "fontSizes.xs",
        [V0.variable]: "fontSizes.xs"
      }
    }),
    sm: z0({
      stepper: {
        [tc.variable]: "sizes.6",
        [yh.variable]: "sizes.4",
        [bh.variable]: "fontSizes.sm",
        [V0.variable]: "fontSizes.xs"
      }
    }),
    md: z0({
      stepper: {
        [tc.variable]: "sizes.8",
        [yh.variable]: "sizes.5",
        [bh.variable]: "fontSizes.md",
        [V0.variable]: "fontSizes.sm"
      }
    }),
    lg: z0({
      stepper: {
        [tc.variable]: "sizes.10",
        [yh.variable]: "sizes.6",
        [bh.variable]: "fontSizes.lg",
        [V0.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
function en(e, t = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function i(...u) {
    r();
    for (const d of u)
      t[d] = c(d);
    return en(e, t);
  }
  function s(...u) {
    for (const d of u)
      d in t || (t[d] = c(d));
    return en(e, t);
  }
  function o() {
    return Object.fromEntries(
      Object.entries(t).map(([d, f]) => [d, f.selector])
    );
  }
  function a() {
    return Object.fromEntries(
      Object.entries(t).map(([d, f]) => [d, f.className])
    );
  }
  function c(u) {
    const p = `chakra-${(["container", "root"].includes(u ?? "") ? [e] : [e, u]).filter(Boolean).join("__")}`;
    return {
      className: p,
      selector: `.${p}`,
      toString: () => u
    };
  }
  return {
    parts: i,
    toPart: c,
    extend: s,
    selectors: o,
    classnames: a,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
var Zde = en("accordion").parts("root", "container", "button", "panel").extend("icon"), Jde = en("alert").parts("title", "description", "container").extend("icon", "spinner"), Xde = en("avatar").parts("label", "badge", "container").extend("excessLabel", "group"), efe = en("breadcrumb").parts("link", "item", "container").extend("separator");
en("button").parts();
var tfe = en("checkbox").parts("control", "icon", "container").extend("label");
en("progress").parts("track", "filledTrack").extend("label");
var nfe = en("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), rfe = en("editable").parts(
  "preview",
  "input",
  "textarea"
), ife = en("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
), sfe = en("formError").parts("text", "icon"), ofe = en("input").parts(
  "addon",
  "field",
  "element",
  "group"
), afe = en("list").parts("container", "item", "icon"), cfe = en("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider"), lfe = en("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), ufe = en("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
en("pininput").parts("field");
var dfe = en("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton"), ffe = en("progress").parts(
  "label",
  "filledTrack",
  "track"
), hfe = en("radio").parts(
  "container",
  "control",
  "label"
), pfe = en("select").parts("field", "icon"), mfe = en("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
), gfe = en("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
), yfe = en("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
), bfe = en("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
), vfe = en("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
), wfe = en("tag").parts(
  "container",
  "label",
  "closeButton"
), xfe = en("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
en("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
);
function Ju(e, t, n) {
  return Math.min(Math.max(e, n), t);
}
class Afe extends Error {
  constructor(t) {
    super(`Failed to parse color: "${t}"`);
  }
}
var H0 = Afe;
function K5(e) {
  if (typeof e != "string")
    throw new H0(e);
  if (e.trim().toLowerCase() === "transparent")
    return [0, 0, 0, 0];
  let t = e.trim();
  t = Ife.test(e) ? Sfe(e) : e;
  const n = Cfe.exec(t);
  if (n) {
    const o = Array.from(n).slice(1);
    return [...o.slice(0, 3).map((a) => parseInt(yy(a, 2), 16)), parseInt(yy(o[3] || "f", 2), 16) / 255];
  }
  const r = Tfe.exec(t);
  if (r) {
    const o = Array.from(r).slice(1);
    return [...o.slice(0, 3).map((a) => parseInt(a, 16)), parseInt(o[3] || "ff", 16) / 255];
  }
  const i = kfe.exec(t);
  if (i) {
    const o = Array.from(i).slice(1);
    return [...o.slice(0, 3).map((a) => parseInt(a, 10)), parseFloat(o[3] || "1")];
  }
  const s = Bfe.exec(t);
  if (s) {
    const [o, a, c, l] = Array.from(s).slice(1).map(parseFloat);
    if (Ju(0, 100, a) !== a)
      throw new H0(e);
    if (Ju(0, 100, c) !== c)
      throw new H0(e);
    return [...Pfe(o, a, c), Number.isNaN(l) ? 1 : l];
  }
  throw new H0(e);
}
function Efe(e) {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return (t >>> 0) % 2341;
}
const LP = (e) => parseInt(e.replace(/_/g, ""), 36), _fe = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((e, t) => {
  const n = LP(t.substring(0, 3)), r = LP(t.substring(3)).toString(16);
  let i = "";
  for (let s = 0; s < 6 - r.length; s++)
    i += "0";
  return e[n] = `${i}${r}`, e;
}, {});
function Sfe(e) {
  const t = e.toLowerCase().trim(), n = _fe[Efe(t)];
  if (!n)
    throw new H0(e);
  return `#${n}`;
}
const yy = (e, t) => Array.from(Array(t)).map(() => e).join(""), Cfe = new RegExp(`^#${yy("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), Tfe = new RegExp(`^#${yy("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), kfe = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${yy(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), Bfe = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, Ife = /^[a-z]+$/i, zP = (e) => Math.round(e * 255), Pfe = (e, t, n) => {
  let r = n / 100;
  if (t === 0)
    return [r, r, r].map(zP);
  const i = (e % 360 + 360) % 360 / 60, s = (1 - Math.abs(2 * r - 1)) * (t / 100), o = s * (1 - Math.abs(i % 2 - 1));
  let a = 0, c = 0, l = 0;
  i >= 0 && i < 1 ? (a = s, c = o) : i >= 1 && i < 2 ? (a = o, c = s) : i >= 2 && i < 3 ? (c = s, l = o) : i >= 3 && i < 4 ? (c = o, l = s) : i >= 4 && i < 5 ? (a = o, l = s) : i >= 5 && i < 6 && (a = s, l = o);
  const u = r - s / 2, d = a + u, f = c + u, p = l + u;
  return [d, f, p].map(zP);
};
function Ofe(e, t, n, r) {
  return `rgba(${Ju(0, 255, e).toFixed()}, ${Ju(0, 255, t).toFixed()}, ${Ju(0, 255, n).toFixed()}, ${parseFloat(Ju(0, 1, r).toFixed(3))})`;
}
function Nfe(e, t) {
  const [n, r, i, s] = K5(e);
  return Ofe(n, r, i, s - t);
}
function Rfe(e) {
  const [t, n, r, i] = K5(e);
  let s = (o) => {
    const a = Ju(0, 255, o).toString(16);
    return a.length === 1 ? `0${a}` : a;
  };
  return `#${s(t)}${s(n)}${s(r)}${i < 1 ? s(Math.round(i * 255)) : ""}`;
}
function Mfe(e, t, n, r, i) {
  for (t = t.split ? t.split(".") : t, r = 0; r < t.length; r++)
    e = e ? e[t[r]] : i;
  return e === i ? n : e;
}
var Ffe = (e) => Object.keys(e).length === 0, oi = (e, t, n) => {
  const r = Mfe(e, `colors.${t}`, t);
  try {
    return Rfe(r), r;
  } catch {
    return n ?? "#000000";
  }
}, jfe = (e) => {
  const [t, n, r] = K5(e);
  return (t * 299 + n * 587 + r * 114) / 1e3;
}, Dfe = (e) => (t) => {
  const n = oi(t, e);
  return jfe(n) < 128 ? "dark" : "light";
}, Ufe = (e) => (t) => Dfe(e)(t) === "dark", xm = (e, t) => (n) => {
  const r = oi(n, e);
  return Nfe(r, 1 - t);
};
function VP(e = "1rem", t = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${t} 25%,
    transparent 25%,
    transparent 50%,
    ${t} 50%,
    ${t} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${e} ${e}`
  };
}
var Lfe = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function zfe(e) {
  const t = Lfe();
  return !e || Ffe(e) ? t : e.string && e.colors ? Hfe(e.string, e.colors) : e.string && !e.colors ? Vfe(e.string) : e.colors && !e.string ? Wfe(e.colors) : t;
}
function Vfe(e) {
  let t = 0;
  if (e.length === 0)
    return t.toString();
  for (let r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t), t = t & t;
  let n = "#";
  for (let r = 0; r < 3; r += 1) {
    const i = t >> r * 8 & 255;
    n += `00${i.toString(16)}`.substr(-2);
  }
  return n;
}
function Hfe(e, t) {
  let n = 0;
  if (e.length === 0)
    return t[0];
  for (let r = 0; r < e.length; r += 1)
    n = e.charCodeAt(r) + ((n << 5) - n), n = n & n;
  return n = (n % t.length + t.length) % t.length, t[n];
}
function Wfe(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function at(e, t) {
  return (n) => n.colorMode === "dark" ? t : e;
}
function Y5(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t ? t === "vertical" ? n : r : {};
}
function YL(e) {
  return Ii(e) && e.reference ? e.reference : String(e);
}
var iE = (e, ...t) => t.map(YL).join(` ${e} `).replace(/calc/g, ""), HP = (...e) => `calc(${iE("+", ...e)})`, WP = (...e) => `calc(${iE("-", ...e)})`, nC = (...e) => `calc(${iE("*", ...e)})`, GP = (...e) => `calc(${iE("/", ...e)})`, qP = (e) => {
  const t = YL(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : nC(t, -1);
}, nc = Object.assign(
  (e) => ({
    add: (...t) => nc(HP(e, ...t)),
    subtract: (...t) => nc(WP(e, ...t)),
    multiply: (...t) => nc(nC(e, ...t)),
    divide: (...t) => nc(GP(e, ...t)),
    negate: () => nc(qP(e)),
    toString: () => e.toString()
  }),
  {
    add: HP,
    subtract: WP,
    multiply: nC,
    divide: GP,
    negate: qP
  }
);
function Gfe(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function qfe(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function ZL(e) {
  const t = qfe(e.toString());
  return t.includes("\\.") ? e : Gfe(e) ? t.replace(".", "\\.") : e;
}
function $fe(e, t = "") {
  return [t, ZL(e)].filter(Boolean).join("-");
}
function Qfe(e, t) {
  return `var(${ZL(e)}${t ? `, ${t}` : ""})`;
}
function Kfe(e, t = "") {
  return `--${$fe(e, t)}`;
}
function sr(e, t) {
  const n = Kfe(e, void 0);
  return {
    variable: n,
    reference: Qfe(n, Yfe(void 0))
  };
}
function Yfe(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
var { defineMultiStyleConfig: Zfe, definePartsStyle: yw } = gn(yfe.keys), pg = sr("switch-track-width"), Dd = sr("switch-track-height"), a_ = sr("switch-track-diff"), Jfe = nc.subtract(pg, Dd), rC = sr("switch-thumb-x"), v0 = sr("switch-bg"), Xfe = (e) => {
  const { colorScheme: t } = e;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [pg.reference],
    height: [Dd.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [v0.variable]: "colors.gray.300",
    _dark: {
      [v0.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [v0.variable]: `colors.${t}.500`,
      _dark: {
        [v0.variable]: `colors.${t}.200`
      }
    },
    bg: v0.reference
  };
}, ehe = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Dd.reference],
  height: [Dd.reference],
  _checked: {
    transform: `translateX(${rC.reference})`
  }
}, the = yw((e) => ({
  container: {
    [a_.variable]: Jfe,
    [rC.variable]: a_.reference,
    _rtl: {
      [rC.variable]: nc(a_).negate().toString()
    }
  },
  track: Xfe(e),
  thumb: ehe
})), nhe = {
  sm: yw({
    container: {
      [pg.variable]: "1.375rem",
      [Dd.variable]: "sizes.3"
    }
  }),
  md: yw({
    container: {
      [pg.variable]: "1.875rem",
      [Dd.variable]: "sizes.4"
    }
  }),
  lg: yw({
    container: {
      [pg.variable]: "2.875rem",
      [Dd.variable]: "sizes.6"
    }
  })
}, rhe = Zfe({
  baseStyle: the,
  sizes: nhe,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: ihe, definePartsStyle: Lh } = gn(bfe.keys), she = Lh({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}), Ux = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, ohe = Lh((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: at("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: at(`${t}.100`, `${t}.700`)(e),
      ...Ux
    },
    td: {
      borderBottom: "1px",
      borderColor: at(`${t}.100`, `${t}.700`)(e),
      ...Ux
    },
    caption: {
      color: at("gray.600", "gray.100")(e)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), ahe = Lh((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: at("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: at(`${t}.100`, `${t}.700`)(e),
      ...Ux
    },
    td: {
      borderBottom: "1px",
      borderColor: at(`${t}.100`, `${t}.700`)(e),
      ...Ux
    },
    caption: {
      color: at("gray.600", "gray.100")(e)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: at(`${t}.100`, `${t}.700`)(e)
          },
          td: {
            background: at(`${t}.100`, `${t}.700`)(e)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), che = {
  simple: ohe,
  striped: ahe,
  unstyled: {}
}, lhe = {
  sm: Lh({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: Lh({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: Lh({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
}, uhe = ihe({
  baseStyle: she,
  variants: che,
  sizes: lhe,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
}), Ti = ct("tabs-color"), ro = ct("tabs-bg"), s1 = ct("tabs-border-color"), { defineMultiStyleConfig: dhe, definePartsStyle: fa } = gn(vfe.keys), fhe = (e) => {
  const { orientation: t } = e;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, hhe = (e) => {
  const { isFitted: t } = e;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}, phe = (e) => {
  const { align: t = "start", orientation: n } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[t],
    flexDirection: n === "vertical" ? "column" : "row"
  };
}, mhe = {
  p: 4
}, ghe = fa((e) => ({
  root: fhe(e),
  tab: hhe(e),
  tablist: phe(e),
  tabpanel: mhe
})), yhe = {
  sm: fa({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: fa({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: fa({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
}, bhe = fa((e) => {
  const { colorScheme: t, orientation: n } = e, r = n === "vertical", i = r ? "borderStart" : "borderBottom", s = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [i]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [i]: "2px solid",
      borderColor: "transparent",
      [s]: "-2px",
      _selected: {
        [Ti.variable]: `colors.${t}.600`,
        _dark: {
          [Ti.variable]: `colors.${t}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [ro.variable]: "colors.gray.200",
        _dark: {
          [ro.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: Ti.reference,
      bg: ro.reference
    }
  };
}), vhe = fa((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [s1.variable]: "transparent",
      _selected: {
        [Ti.variable]: `colors.${t}.600`,
        [s1.variable]: "colors.white",
        _dark: {
          [Ti.variable]: `colors.${t}.300`,
          [s1.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: s1.reference
      },
      color: Ti.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), whe = fa((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [ro.variable]: "colors.gray.50",
      _dark: {
        [ro.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [ro.variable]: "colors.white",
        [Ti.variable]: `colors.${t}.600`,
        _dark: {
          [ro.variable]: "colors.gray.800",
          [Ti.variable]: `colors.${t}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: Ti.reference,
      bg: ro.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), xhe = fa((e) => {
  const { colorScheme: t, theme: n } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: oi(n, `${t}.700`),
        bg: oi(n, `${t}.100`)
      }
    }
  };
}), Ahe = fa((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [Ti.variable]: "colors.gray.600",
      _dark: {
        [Ti.variable]: "inherit"
      },
      _selected: {
        [Ti.variable]: "colors.white",
        [ro.variable]: `colors.${t}.600`,
        _dark: {
          [Ti.variable]: "colors.gray.800",
          [ro.variable]: `colors.${t}.300`
        }
      },
      color: Ti.reference,
      bg: ro.reference
    }
  };
}), Ehe = fa({}), _he = {
  line: bhe,
  enclosed: vhe,
  "enclosed-colored": whe,
  "soft-rounded": xhe,
  "solid-rounded": Ahe,
  unstyled: Ehe
}, She = dhe({
  baseStyle: ghe,
  sizes: yhe,
  variants: _he,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), zn = $ue("badge", ["bg", "color", "shadow"]), Che = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: zn.bg.reference,
  color: zn.color.reference,
  boxShadow: zn.shadow.reference
}, The = (e) => {
  const { colorScheme: t, theme: n } = e, r = xm(`${t}.500`, 0.6)(n);
  return {
    [zn.bg.variable]: `colors.${t}.500`,
    [zn.color.variable]: "colors.white",
    _dark: {
      [zn.bg.variable]: r,
      [zn.color.variable]: "colors.whiteAlpha.800"
    }
  };
}, khe = (e) => {
  const { colorScheme: t, theme: n } = e, r = xm(`${t}.200`, 0.16)(n);
  return {
    [zn.bg.variable]: `colors.${t}.100`,
    [zn.color.variable]: `colors.${t}.800`,
    _dark: {
      [zn.bg.variable]: r,
      [zn.color.variable]: `colors.${t}.200`
    }
  };
}, Bhe = (e) => {
  const { colorScheme: t, theme: n } = e, r = xm(`${t}.200`, 0.8)(n);
  return {
    [zn.color.variable]: `colors.${t}.500`,
    _dark: {
      [zn.color.variable]: r
    },
    [zn.shadow.variable]: `inset 0 0 0px 1px ${zn.color.reference}`
  };
}, Ihe = {
  solid: The,
  subtle: khe,
  outline: Bhe
}, mg = {
  baseStyle: Che,
  variants: Ihe,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}, { defineMultiStyleConfig: Phe, definePartsStyle: Ud } = gn(wfe.keys), $P = ct("tag-bg"), QP = ct("tag-color"), c_ = ct("tag-shadow"), bw = ct("tag-min-height"), vw = ct("tag-min-width"), ww = ct("tag-font-size"), xw = ct("tag-padding-inline"), Ohe = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [QP.variable]: zn.color.reference,
  [$P.variable]: zn.bg.reference,
  [c_.variable]: zn.shadow.reference,
  color: QP.reference,
  bg: $P.reference,
  boxShadow: c_.reference,
  borderRadius: "md",
  minH: bw.reference,
  minW: vw.reference,
  fontSize: ww.reference,
  px: xw.reference,
  _focusVisible: {
    [c_.variable]: "shadows.outline"
  }
}, Nhe = {
  lineHeight: 1.2,
  overflow: "visible"
}, Rhe = {
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, Mhe = Ud({
  container: Ohe,
  label: Nhe,
  closeButton: Rhe
}), Fhe = {
  sm: Ud({
    container: {
      [bw.variable]: "sizes.5",
      [vw.variable]: "sizes.5",
      [ww.variable]: "fontSizes.xs",
      [xw.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: Ud({
    container: {
      [bw.variable]: "sizes.6",
      [vw.variable]: "sizes.6",
      [ww.variable]: "fontSizes.sm",
      [xw.variable]: "space.2"
    }
  }),
  lg: Ud({
    container: {
      [bw.variable]: "sizes.8",
      [vw.variable]: "sizes.8",
      [ww.variable]: "fontSizes.md",
      [xw.variable]: "space.3"
    }
  })
}, jhe = {
  subtle: Ud((e) => {
    var t;
    return {
      container: (t = mg.variants) == null ? void 0 : t.subtle(e)
    };
  }),
  solid: Ud((e) => {
    var t;
    return {
      container: (t = mg.variants) == null ? void 0 : t.solid(e)
    };
  }),
  outline: Ud((e) => {
    var t;
    return {
      container: (t = mg.variants) == null ? void 0 : t.outline(e)
    };
  })
}, Dhe = Phe({
  variants: jhe,
  baseStyle: Mhe,
  sizes: Fhe,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
}), { definePartsStyle: sc, defineMultiStyleConfig: Uhe } = gn(ofe.keys), vh = ct("input-height"), wh = ct("input-font-size"), xh = ct("input-padding"), Ah = ct("input-border-radius"), Lhe = sc({
  addon: {
    height: vh.reference,
    fontSize: wh.reference,
    px: xh.reference,
    borderRadius: Ah.reference
  },
  field: {
    width: "100%",
    height: vh.reference,
    fontSize: wh.reference,
    px: xh.reference,
    borderRadius: Ah.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), Uc = {
  lg: {
    [wh.variable]: "fontSizes.lg",
    [xh.variable]: "space.4",
    [Ah.variable]: "radii.md",
    [vh.variable]: "sizes.12"
  },
  md: {
    [wh.variable]: "fontSizes.md",
    [xh.variable]: "space.4",
    [Ah.variable]: "radii.md",
    [vh.variable]: "sizes.10"
  },
  sm: {
    [wh.variable]: "fontSizes.sm",
    [xh.variable]: "space.3",
    [Ah.variable]: "radii.sm",
    [vh.variable]: "sizes.8"
  },
  xs: {
    [wh.variable]: "fontSizes.xs",
    [xh.variable]: "space.2",
    [Ah.variable]: "radii.sm",
    [vh.variable]: "sizes.6"
  }
}, zhe = {
  lg: sc({
    field: Uc.lg,
    group: Uc.lg
  }),
  md: sc({
    field: Uc.md,
    group: Uc.md
  }),
  sm: sc({
    field: Uc.sm,
    group: Uc.sm
  }),
  xs: sc({
    field: Uc.xs,
    group: Uc.xs
  })
};
function Z5(e) {
  const { focusBorderColor: t, errorBorderColor: n } = e;
  return {
    focusBorderColor: t || at("blue.500", "blue.300")(e),
    errorBorderColor: n || at("red.500", "red.300")(e)
  };
}
var Vhe = sc((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = Z5(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: at("gray.300", "whiteAlpha.400")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: oi(t, r),
        boxShadow: `0 0 0 1px ${oi(t, r)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: oi(t, n),
        boxShadow: `0 0 0 1px ${oi(t, n)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: at("inherit", "whiteAlpha.50")(e),
      bg: at("gray.100", "whiteAlpha.300")(e)
    }
  };
}), Hhe = sc((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = Z5(e);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: at("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: at("gray.200", "whiteAlpha.100")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: oi(t, r)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: oi(t, n)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: at("gray.100", "whiteAlpha.50")(e)
    }
  };
}), Whe = sc((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = Z5(e);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: oi(t, r),
        boxShadow: `0px 1px 0px 0px ${oi(t, r)}`
      },
      _focusVisible: {
        borderColor: oi(t, n),
        boxShadow: `0px 1px 0px 0px ${oi(t, n)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), Ghe = sc({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), qhe = {
  outline: Vhe,
  filled: Hhe,
  flushed: Whe,
  unstyled: Ghe
}, Jt = Uhe({
  baseStyle: Lhe,
  sizes: zhe,
  variants: qhe,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), KP, $he = {
  ...(KP = Jt.baseStyle) == null ? void 0 : KP.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
}, YP, ZP, Qhe = {
  outline: (e) => {
    var t, n;
    return (n = (t = Jt.variants) == null ? void 0 : t.outline(e).field) != null ? n : {};
  },
  flushed: (e) => {
    var t, n;
    return (n = (t = Jt.variants) == null ? void 0 : t.flushed(e).field) != null ? n : {};
  },
  filled: (e) => {
    var t, n;
    return (n = (t = Jt.variants) == null ? void 0 : t.filled(e).field) != null ? n : {};
  },
  unstyled: (ZP = (YP = Jt.variants) == null ? void 0 : YP.unstyled.field) != null ? ZP : {}
}, JP, XP, eO, tO, nO, rO, iO, sO, Khe = {
  xs: (XP = (JP = Jt.sizes) == null ? void 0 : JP.xs.field) != null ? XP : {},
  sm: (tO = (eO = Jt.sizes) == null ? void 0 : eO.sm.field) != null ? tO : {},
  md: (rO = (nO = Jt.sizes) == null ? void 0 : nO.md.field) != null ? rO : {},
  lg: (sO = (iO = Jt.sizes) == null ? void 0 : iO.lg.field) != null ? sO : {}
}, Yhe = {
  baseStyle: $he,
  sizes: Khe,
  variants: Qhe,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, o1 = sr("tooltip-bg"), l_ = sr("tooltip-fg"), Zhe = sr("popper-arrow-bg"), Jhe = {
  bg: o1.reference,
  color: l_.reference,
  [o1.variable]: "colors.gray.700",
  [l_.variable]: "colors.whiteAlpha.900",
  _dark: {
    [o1.variable]: "colors.gray.300",
    [l_.variable]: "colors.gray.900"
  },
  [Zhe.variable]: o1.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
}, Xhe = {
  baseStyle: Jhe
}, { defineMultiStyleConfig: epe, definePartsStyle: W0 } = gn(ffe.keys), tpe = (e) => {
  const { colorScheme: t, theme: n, isIndeterminate: r, hasStripe: i } = e, s = at(
    VP(),
    VP("1rem", "rgba(0,0,0,0.1)")
  )(e), o = at(`${t}.500`, `${t}.200`)(e), a = `linear-gradient(
    to right,
    transparent 0%,
    ${oi(n, o)} 50%,
    transparent 100%
  )`;
  return {
    ...!r && i && s,
    ...r ? { bgImage: a } : { bgColor: o }
  };
}, npe = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, rpe = (e) => ({
  bg: at("gray.100", "whiteAlpha.300")(e)
}), ipe = (e) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...tpe(e)
}), spe = W0((e) => ({
  label: npe,
  filledTrack: ipe(e),
  track: rpe(e)
})), ope = {
  xs: W0({
    track: { h: "1" }
  }),
  sm: W0({
    track: { h: "2" }
  }),
  md: W0({
    track: { h: "3" }
  }),
  lg: W0({
    track: { h: "4" }
  })
}, ape = epe({
  sizes: ope,
  baseStyle: spe,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), cpe = (e) => typeof e == "function";
function hi(e, ...t) {
  return cpe(e) ? e(...t) : e;
}
var { definePartsStyle: Aw, defineMultiStyleConfig: lpe } = gn(tfe.keys), gg = ct("checkbox-size"), upe = (e) => {
  const { colorScheme: t } = e;
  return {
    w: gg.reference,
    h: gg.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: at(`${t}.500`, `${t}.200`)(e),
      borderColor: at(`${t}.500`, `${t}.200`)(e),
      color: at("white", "gray.900")(e),
      _hover: {
        bg: at(`${t}.600`, `${t}.300`)(e),
        borderColor: at(`${t}.600`, `${t}.300`)(e)
      },
      _disabled: {
        borderColor: at("gray.200", "transparent")(e),
        bg: at("gray.200", "whiteAlpha.300")(e),
        color: at("gray.500", "whiteAlpha.500")(e)
      }
    },
    _indeterminate: {
      bg: at(`${t}.500`, `${t}.200`)(e),
      borderColor: at(`${t}.500`, `${t}.200`)(e),
      color: at("white", "gray.900")(e)
    },
    _disabled: {
      bg: at("gray.100", "whiteAlpha.100")(e),
      borderColor: at("gray.100", "transparent")(e)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: at("red.500", "red.300")(e)
    }
  };
}, dpe = {
  _disabled: { cursor: "not-allowed" }
}, fpe = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
}, hpe = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, ppe = Aw((e) => ({
  icon: hpe,
  container: dpe,
  control: hi(upe, e),
  label: fpe
})), mpe = {
  sm: Aw({
    control: { [gg.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: Aw({
    control: { [gg.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: Aw({
    control: { [gg.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, Lx = lpe({
  baseStyle: ppe,
  sizes: mpe,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: gpe, definePartsStyle: Ew } = gn(hfe.keys), ype = (e) => {
  var t;
  const n = (t = hi(Lx.baseStyle, e)) == null ? void 0 : t.control;
  return {
    ...n,
    borderRadius: "full",
    _checked: {
      ...n == null ? void 0 : n._checked,
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
}, bpe = Ew((e) => {
  var t, n, r, i;
  return {
    label: (n = (t = Lx).baseStyle) == null ? void 0 : n.call(t, e).label,
    container: (i = (r = Lx).baseStyle) == null ? void 0 : i.call(r, e).container,
    control: ype(e)
  };
}), vpe = {
  md: Ew({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: Ew({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: Ew({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
}, wpe = gpe({
  baseStyle: bpe,
  sizes: vpe,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: xpe, definePartsStyle: Ape } = gn(pfe.keys), a1 = ct("select-bg"), oO, Epe = {
  ...(oO = Jt.baseStyle) == null ? void 0 : oO.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: a1.reference,
  [a1.variable]: "colors.white",
  _dark: {
    [a1.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: a1.reference
  }
}, _pe = {
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
}, Spe = Ape({
  field: Epe,
  icon: _pe
}), c1 = {
  paddingInlineEnd: "8"
}, aO, cO, lO, uO, dO, fO, hO, pO, Cpe = {
  lg: {
    ...(aO = Jt.sizes) == null ? void 0 : aO.lg,
    field: {
      ...(cO = Jt.sizes) == null ? void 0 : cO.lg.field,
      ...c1
    }
  },
  md: {
    ...(lO = Jt.sizes) == null ? void 0 : lO.md,
    field: {
      ...(uO = Jt.sizes) == null ? void 0 : uO.md.field,
      ...c1
    }
  },
  sm: {
    ...(dO = Jt.sizes) == null ? void 0 : dO.sm,
    field: {
      ...(fO = Jt.sizes) == null ? void 0 : fO.sm.field,
      ...c1
    }
  },
  xs: {
    ...(hO = Jt.sizes) == null ? void 0 : hO.xs,
    field: {
      ...(pO = Jt.sizes) == null ? void 0 : pO.xs.field,
      ...c1
    },
    icon: {
      insetEnd: "1"
    }
  }
}, Tpe = xpe({
  baseStyle: Spe,
  sizes: Cpe,
  variants: Jt.variants,
  defaultProps: Jt.defaultProps
}), u_ = ct("skeleton-start-color"), d_ = ct("skeleton-end-color"), kpe = {
  [u_.variable]: "colors.gray.100",
  [d_.variable]: "colors.gray.400",
  _dark: {
    [u_.variable]: "colors.gray.800",
    [d_.variable]: "colors.gray.600"
  },
  background: u_.reference,
  borderColor: d_.reference,
  opacity: 0.7,
  borderRadius: "sm"
}, Bpe = {
  baseStyle: kpe
}, f_ = ct("skip-link-bg"), Ipe = {
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [f_.variable]: "colors.white",
    _dark: {
      [f_.variable]: "colors.gray.700"
    },
    bg: f_.reference
  }
}, Ppe = {
  baseStyle: Ipe
}, { defineMultiStyleConfig: Ope, definePartsStyle: sE } = gn(mfe.keys), by = ct("slider-thumb-size"), vy = ct("slider-track-size"), al = ct("slider-bg"), Npe = (e) => {
  const { orientation: t } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...Y5({
      orientation: t,
      vertical: { h: "100%" },
      horizontal: { w: "100%" }
    })
  };
}, Rpe = (e) => ({
  ...Y5({
    orientation: e.orientation,
    horizontal: { h: vy.reference },
    vertical: { w: vy.reference }
  }),
  overflow: "hidden",
  borderRadius: "sm",
  [al.variable]: "colors.gray.200",
  _dark: {
    [al.variable]: "colors.whiteAlpha.200"
  },
  _disabled: {
    [al.variable]: "colors.gray.300",
    _dark: {
      [al.variable]: "colors.whiteAlpha.300"
    }
  },
  bg: al.reference
}), Mpe = (e) => {
  const { orientation: t } = e;
  return {
    ...Y5({
      orientation: t,
      vertical: {
        left: "50%",
        transform: "translateX(-50%)",
        _active: {
          transform: "translateX(-50%) scale(1.15)"
        }
      },
      horizontal: {
        top: "50%",
        transform: "translateY(-50%)",
        _active: {
          transform: "translateY(-50%) scale(1.15)"
        }
      }
    }),
    w: by.reference,
    h: by.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
}, Fpe = (e) => {
  const { colorScheme: t } = e;
  return {
    width: "inherit",
    height: "inherit",
    [al.variable]: `colors.${t}.500`,
    _dark: {
      [al.variable]: `colors.${t}.200`
    },
    bg: al.reference
  };
}, jpe = sE((e) => ({
  container: Npe(e),
  track: Rpe(e),
  thumb: Mpe(e),
  filledTrack: Fpe(e)
})), Dpe = sE({
  container: {
    [by.variable]: "sizes.4",
    [vy.variable]: "sizes.1"
  }
}), Upe = sE({
  container: {
    [by.variable]: "sizes.3.5",
    [vy.variable]: "sizes.1"
  }
}), Lpe = sE({
  container: {
    [by.variable]: "sizes.2.5",
    [vy.variable]: "sizes.0.5"
  }
}), zpe = {
  lg: Dpe,
  md: Upe,
  sm: Lpe
}, Vpe = Ope({
  baseStyle: jpe,
  sizes: zpe,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), Lu = sr("spinner-size"), Hpe = {
  width: [Lu.reference],
  height: [Lu.reference]
}, Wpe = {
  xs: {
    [Lu.variable]: "sizes.3"
  },
  sm: {
    [Lu.variable]: "sizes.4"
  },
  md: {
    [Lu.variable]: "sizes.6"
  },
  lg: {
    [Lu.variable]: "sizes.8"
  },
  xl: {
    [Lu.variable]: "sizes.12"
  }
}, Gpe = {
  baseStyle: Hpe,
  sizes: Wpe,
  defaultProps: {
    size: "md"
  }
}, { defineMultiStyleConfig: qpe, definePartsStyle: JL } = gn(gfe.keys), $pe = {
  fontWeight: "medium"
}, Qpe = {
  opacity: 0.8,
  marginBottom: "2"
}, Kpe = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, Ype = {
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
}, Zpe = JL({
  container: {},
  label: $pe,
  helpText: Qpe,
  number: Kpe,
  icon: Ype
}), Jpe = {
  md: JL({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
}, Xpe = qpe({
  baseStyle: Zpe,
  sizes: Jpe,
  defaultProps: {
    size: "md"
  }
}), h_ = ct("kbd-bg"), eme = {
  [h_.variable]: "colors.gray.100",
  _dark: {
    [h_.variable]: "colors.whiteAlpha.100"
  },
  bg: h_.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
}, tme = {
  baseStyle: eme
}, nme = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
}, rme = {
  baseStyle: nme
}, { defineMultiStyleConfig: ime, definePartsStyle: sme } = gn(afe.keys), ome = {
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}, ame = sme({
  icon: ome
}), cme = ime({
  baseStyle: ame
}), { defineMultiStyleConfig: lme, definePartsStyle: ume } = gn(cfe.keys), Uo = ct("menu-bg"), p_ = ct("menu-shadow"), dme = {
  [Uo.variable]: "#fff",
  [p_.variable]: "shadows.sm",
  _dark: {
    [Uo.variable]: "colors.gray.700",
    [p_.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: 1,
  borderRadius: "md",
  borderWidth: "1px",
  bg: Uo.reference,
  boxShadow: p_.reference
}, fme = {
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [Uo.variable]: "colors.gray.100",
    _dark: {
      [Uo.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [Uo.variable]: "colors.gray.200",
    _dark: {
      [Uo.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [Uo.variable]: "colors.gray.100",
    _dark: {
      [Uo.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: Uo.reference
}, hme = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, pme = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}, mme = {
  opacity: 0.6
}, gme = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}, yme = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, bme = ume({
  button: yme,
  list: dme,
  item: fme,
  groupTitle: hme,
  icon: pme,
  command: mme,
  divider: gme
}), vme = lme({
  baseStyle: bme
}), { defineMultiStyleConfig: wme, definePartsStyle: iC } = gn(lfe.keys), m_ = ct("modal-bg"), g_ = ct("modal-shadow"), xme = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, Ame = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, Eme = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    borderRadius: "md",
    color: "inherit",
    my: t ? "auto" : "16",
    mx: t ? "auto" : void 0,
    zIndex: "modal",
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [m_.variable]: "colors.white",
    [g_.variable]: "shadows.lg",
    _dark: {
      [m_.variable]: "colors.gray.700",
      [g_.variable]: "shadows.dark-lg"
    },
    bg: m_.reference,
    boxShadow: g_.reference
  };
}, _me = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, Sme = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, Cme = (e) => {
  const { scrollBehavior: t } = e;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: t === "inside" ? "auto" : void 0
  };
}, Tme = {
  px: "6",
  py: "4"
}, kme = iC((e) => ({
  overlay: xme,
  dialogContainer: hi(Ame, e),
  dialog: hi(Eme, e),
  header: _me,
  closeButton: Sme,
  body: hi(Cme, e),
  footer: Tme
}));
function Us(e) {
  return iC(e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: e }
  });
}
var Bme = {
  xs: Us("xs"),
  sm: Us("sm"),
  md: Us("md"),
  lg: Us("lg"),
  xl: Us("xl"),
  "2xl": Us("2xl"),
  "3xl": Us("3xl"),
  "4xl": Us("4xl"),
  "5xl": Us("5xl"),
  "6xl": Us("6xl"),
  full: Us("full")
}, Ime = wme({
  baseStyle: kme,
  sizes: Bme,
  defaultProps: { size: "md" }
}), { defineMultiStyleConfig: Pme, definePartsStyle: XL } = gn(ufe.keys), J5 = sr("number-input-stepper-width"), ez = sr("number-input-input-padding"), Ome = nc(J5).add("0.5rem").toString(), y_ = sr("number-input-bg"), b_ = sr("number-input-color"), v_ = sr("number-input-border-color"), Nme = {
  [J5.variable]: "sizes.6",
  [ez.variable]: Ome
}, Rme = (e) => {
  var t, n;
  return (n = (t = hi(Jt.baseStyle, e)) == null ? void 0 : t.field) != null ? n : {};
}, Mme = {
  width: J5.reference
}, Fme = {
  borderStart: "1px solid",
  borderStartColor: v_.reference,
  color: b_.reference,
  bg: y_.reference,
  [b_.variable]: "colors.chakra-body-text",
  [v_.variable]: "colors.chakra-border-color",
  _dark: {
    [b_.variable]: "colors.whiteAlpha.800",
    [v_.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [y_.variable]: "colors.gray.200",
    _dark: {
      [y_.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}, jme = XL((e) => {
  var t;
  return {
    root: Nme,
    field: (t = hi(Rme, e)) != null ? t : {},
    stepperGroup: Mme,
    stepper: Fme
  };
});
function l1(e) {
  var t, n, r;
  const i = (t = Jt.sizes) == null ? void 0 : t[e], s = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, o = (r = (n = i.field) == null ? void 0 : n.fontSize) != null ? r : "md", a = $L.fontSizes[o];
  return XL({
    field: {
      ...i.field,
      paddingInlineEnd: ez.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: nc(a).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: s[e]
      },
      _last: {
        borderBottomEndRadius: s[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
var Dme = {
  xs: l1("xs"),
  sm: l1("sm"),
  md: l1("md"),
  lg: l1("lg")
}, Ume = Pme({
  baseStyle: jme,
  sizes: Dme,
  variants: Jt.variants,
  defaultProps: Jt.defaultProps
}), mO, Lme = {
  ...(mO = Jt.baseStyle) == null ? void 0 : mO.field,
  textAlign: "center"
}, zme = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
}, gO, yO, Vme = {
  outline: (e) => {
    var t, n, r;
    return (r = (n = hi((t = Jt.variants) == null ? void 0 : t.outline, e)) == null ? void 0 : n.field) != null ? r : {};
  },
  flushed: (e) => {
    var t, n, r;
    return (r = (n = hi((t = Jt.variants) == null ? void 0 : t.flushed, e)) == null ? void 0 : n.field) != null ? r : {};
  },
  filled: (e) => {
    var t, n, r;
    return (r = (n = hi((t = Jt.variants) == null ? void 0 : t.filled, e)) == null ? void 0 : n.field) != null ? r : {};
  },
  unstyled: (yO = (gO = Jt.variants) == null ? void 0 : gO.unstyled.field) != null ? yO : {}
}, Hme = {
  baseStyle: Lme,
  sizes: zme,
  variants: Vme,
  defaultProps: Jt.defaultProps
}, { defineMultiStyleConfig: Wme, definePartsStyle: Gme } = gn(dfe.keys), u1 = sr("popper-bg"), qme = sr("popper-arrow-bg"), bO = sr("popper-arrow-shadow-color"), $me = { zIndex: 10 }, Qme = {
  [u1.variable]: "colors.white",
  bg: u1.reference,
  [qme.variable]: u1.reference,
  [bO.variable]: "colors.gray.200",
  _dark: {
    [u1.variable]: "colors.gray.700",
    [bO.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}, Kme = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, Yme = {
  px: 3,
  py: 2
}, Zme = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, Jme = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, Xme = Gme({
  popper: $me,
  content: Qme,
  header: Kme,
  body: Yme,
  footer: Zme,
  closeButton: Jme
}), e0e = Wme({
  baseStyle: Xme
}), { definePartsStyle: sC, defineMultiStyleConfig: t0e } = gn(nfe.keys), w_ = ct("drawer-bg"), x_ = ct("drawer-box-shadow");
function Vf(e) {
  return sC(e === "full" ? {
    dialog: { maxW: "100vw", h: "100vh" }
  } : {
    dialog: { maxW: e }
  });
}
var n0e = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, r0e = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, i0e = (e) => {
  const { isFullHeight: t } = e;
  return {
    ...t && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [w_.variable]: "colors.white",
    [x_.variable]: "shadows.lg",
    _dark: {
      [w_.variable]: "colors.gray.700",
      [x_.variable]: "shadows.dark-lg"
    },
    bg: w_.reference,
    boxShadow: x_.reference
  };
}, s0e = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, o0e = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, a0e = {
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
}, c0e = {
  px: "6",
  py: "4"
}, l0e = sC((e) => ({
  overlay: n0e,
  dialogContainer: r0e,
  dialog: hi(i0e, e),
  header: s0e,
  closeButton: o0e,
  body: a0e,
  footer: c0e
})), u0e = {
  xs: Vf("xs"),
  sm: Vf("md"),
  md: Vf("lg"),
  lg: Vf("2xl"),
  xl: Vf("4xl"),
  full: Vf("full")
}, d0e = t0e({
  baseStyle: l0e,
  sizes: u0e,
  defaultProps: {
    size: "xs"
  }
}), { definePartsStyle: f0e, defineMultiStyleConfig: h0e } = gn(rfe.keys), p0e = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
}, m0e = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, g0e = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, y0e = f0e({
  preview: p0e,
  input: m0e,
  textarea: g0e
}), b0e = h0e({
  baseStyle: y0e
}), { definePartsStyle: v0e, defineMultiStyleConfig: w0e } = gn(ife.keys), zh = ct("form-control-color"), x0e = {
  marginStart: "1",
  [zh.variable]: "colors.red.500",
  _dark: {
    [zh.variable]: "colors.red.300"
  },
  color: zh.reference
}, A0e = {
  mt: "2",
  [zh.variable]: "colors.gray.600",
  _dark: {
    [zh.variable]: "colors.whiteAlpha.600"
  },
  color: zh.reference,
  lineHeight: "normal",
  fontSize: "sm"
}, E0e = v0e({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: x0e,
  helperText: A0e
}), _0e = w0e({
  baseStyle: E0e
}), { definePartsStyle: S0e, defineMultiStyleConfig: C0e } = gn(sfe.keys), Vh = ct("form-error-color"), T0e = {
  [Vh.variable]: "colors.red.500",
  _dark: {
    [Vh.variable]: "colors.red.300"
  },
  color: Vh.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
}, k0e = {
  marginEnd: "0.5em",
  [Vh.variable]: "colors.red.500",
  _dark: {
    [Vh.variable]: "colors.red.300"
  },
  color: Vh.reference
}, B0e = S0e({
  text: T0e,
  icon: k0e
}), I0e = C0e({
  baseStyle: B0e
}), P0e = {
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, O0e = {
  baseStyle: P0e
}, N0e = {
  fontFamily: "heading",
  fontWeight: "bold"
}, R0e = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, M0e = {
  baseStyle: N0e,
  sizes: R0e,
  defaultProps: {
    size: "xl"
  }
}, { defineMultiStyleConfig: F0e, definePartsStyle: j0e } = gn(efe.keys), A_ = ct("breadcrumb-link-decor"), D0e = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: A_.reference,
  [A_.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [A_.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
}, U0e = j0e({
  link: D0e
}), L0e = F0e({
  baseStyle: U0e
}), z0e = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, tz = (e) => {
  const { colorScheme: t, theme: n } = e;
  if (t === "gray")
    return {
      color: at("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: at("gray.100", "whiteAlpha.200")(e)
      },
      _active: { bg: at("gray.200", "whiteAlpha.300")(e) }
    };
  const r = xm(`${t}.200`, 0.12)(n), i = xm(`${t}.200`, 0.24)(n);
  return {
    color: at(`${t}.600`, `${t}.200`)(e),
    bg: "transparent",
    _hover: {
      bg: at(`${t}.50`, r)(e)
    },
    _active: {
      bg: at(`${t}.100`, i)(e)
    }
  };
}, V0e = (e) => {
  const { colorScheme: t } = e, n = at("gray.200", "whiteAlpha.300")(e);
  return {
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...hi(tz, e)
  };
}, H0e = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, W0e = (e) => {
  var t;
  const { colorScheme: n } = e;
  if (n === "gray") {
    const c = at("gray.100", "whiteAlpha.200")(e);
    return {
      bg: c,
      color: at("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: at("gray.200", "whiteAlpha.300")(e),
        _disabled: {
          bg: c
        }
      },
      _active: { bg: at("gray.300", "whiteAlpha.400")(e) }
    };
  }
  const {
    bg: r = `${n}.500`,
    color: i = "white",
    hoverBg: s = `${n}.600`,
    activeBg: o = `${n}.700`
  } = (t = H0e[n]) != null ? t : {}, a = at(r, `${n}.200`)(e);
  return {
    bg: a,
    color: at(i, "gray.800")(e),
    _hover: {
      bg: at(s, `${n}.300`)(e),
      _disabled: {
        bg: a
      }
    },
    _active: { bg: at(o, `${n}.400`)(e) }
  };
}, G0e = (e) => {
  const { colorScheme: t } = e;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: at(`${t}.500`, `${t}.200`)(e),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: at(`${t}.700`, `${t}.500`)(e)
    }
  };
}, q0e = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}, $0e = {
  ghost: tz,
  outline: V0e,
  solid: W0e,
  link: G0e,
  unstyled: q0e
}, Q0e = {
  lg: {
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  },
  md: {
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  },
  sm: {
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  },
  xs: {
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  }
}, K0e = {
  baseStyle: z0e,
  variants: $0e,
  sizes: Q0e,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
}, { definePartsStyle: Ld, defineMultiStyleConfig: Y0e } = gn(xfe.keys), zx = ct("card-bg"), fc = ct("card-padding"), nz = ct("card-shadow"), _w = ct("card-radius"), rz = ct("card-border-width", "0"), iz = ct("card-border-color"), Z0e = Ld({
  container: {
    [zx.variable]: "colors.chakra-body-bg",
    backgroundColor: zx.reference,
    boxShadow: nz.reference,
    borderRadius: _w.reference,
    color: "chakra-body-text",
    borderWidth: rz.reference,
    borderColor: iz.reference
  },
  body: {
    padding: fc.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: fc.reference
  },
  footer: {
    padding: fc.reference
  }
}), J0e = {
  sm: Ld({
    container: {
      [_w.variable]: "radii.base",
      [fc.variable]: "space.3"
    }
  }),
  md: Ld({
    container: {
      [_w.variable]: "radii.md",
      [fc.variable]: "space.5"
    }
  }),
  lg: Ld({
    container: {
      [_w.variable]: "radii.xl",
      [fc.variable]: "space.7"
    }
  })
}, X0e = {
  elevated: Ld({
    container: {
      [nz.variable]: "shadows.base",
      _dark: {
        [zx.variable]: "colors.gray.700"
      }
    }
  }),
  outline: Ld({
    container: {
      [rz.variable]: "1px",
      [iz.variable]: "colors.chakra-border-color"
    }
  }),
  filled: Ld({
    container: {
      [zx.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [fc.variable]: 0
    },
    header: {
      [fc.variable]: 0
    },
    footer: {
      [fc.variable]: 0
    }
  }
}, ege = Y0e({
  baseStyle: Z0e,
  variants: X0e,
  sizes: J0e,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
}), yg = sr("close-button-size"), w0 = sr("close-button-bg"), tge = {
  w: [yg.reference],
  h: [yg.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [w0.variable]: "colors.blackAlpha.100",
    _dark: {
      [w0.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [w0.variable]: "colors.blackAlpha.200",
    _dark: {
      [w0.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: w0.reference
}, nge = {
  lg: {
    [yg.variable]: "sizes.10",
    fontSize: "md"
  },
  md: {
    [yg.variable]: "sizes.8",
    fontSize: "xs"
  },
  sm: {
    [yg.variable]: "sizes.6",
    fontSize: "2xs"
  }
}, rge = {
  baseStyle: tge,
  sizes: nge,
  defaultProps: {
    size: "md"
  }
}, { variants: ige, defaultProps: sge } = mg, oge = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: zn.bg.reference,
  color: zn.color.reference,
  boxShadow: zn.shadow.reference
}, age = {
  baseStyle: oge,
  variants: ige,
  defaultProps: sge
}, cge = {
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
}, lge = {
  baseStyle: cge
}, uge = {
  opacity: 0.6,
  borderColor: "inherit"
}, dge = {
  borderStyle: "solid"
}, fge = {
  borderStyle: "dashed"
}, hge = {
  solid: dge,
  dashed: fge
}, pge = {
  baseStyle: uge,
  variants: hge,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: mge, defineMultiStyleConfig: gge } = gn(Zde.keys), yge = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, bge = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
}, vge = {
  pt: "2",
  px: "4",
  pb: "5"
}, wge = {
  fontSize: "1.25em"
}, xge = mge({
  container: yge,
  button: bge,
  panel: vge,
  icon: wge
}), Age = gge({ baseStyle: xge }), { definePartsStyle: pv, defineMultiStyleConfig: Ege } = gn(Jde.keys), Ji = ct("alert-fg"), Ec = ct("alert-bg"), _ge = pv({
  container: {
    bg: Ec.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: Ji.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: Ji.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function X5(e) {
  const { theme: t, colorScheme: n } = e, r = xm(`${n}.200`, 0.16)(t);
  return {
    light: `colors.${n}.100`,
    dark: r
  };
}
var Sge = pv((e) => {
  const { colorScheme: t } = e, n = X5(e);
  return {
    container: {
      [Ji.variable]: `colors.${t}.600`,
      [Ec.variable]: n.light,
      _dark: {
        [Ji.variable]: `colors.${t}.200`,
        [Ec.variable]: n.dark
      }
    }
  };
}), Cge = pv((e) => {
  const { colorScheme: t } = e, n = X5(e);
  return {
    container: {
      [Ji.variable]: `colors.${t}.600`,
      [Ec.variable]: n.light,
      _dark: {
        [Ji.variable]: `colors.${t}.200`,
        [Ec.variable]: n.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: Ji.reference
    }
  };
}), Tge = pv((e) => {
  const { colorScheme: t } = e, n = X5(e);
  return {
    container: {
      [Ji.variable]: `colors.${t}.600`,
      [Ec.variable]: n.light,
      _dark: {
        [Ji.variable]: `colors.${t}.200`,
        [Ec.variable]: n.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: Ji.reference
    }
  };
}), kge = pv((e) => {
  const { colorScheme: t } = e;
  return {
    container: {
      [Ji.variable]: "colors.white",
      [Ec.variable]: `colors.${t}.600`,
      _dark: {
        [Ji.variable]: "colors.gray.900",
        [Ec.variable]: `colors.${t}.200`
      },
      color: Ji.reference
    }
  };
}), Bge = {
  subtle: Sge,
  "left-accent": Cge,
  "top-accent": Tge,
  solid: kge
}, Ige = Ege({
  baseStyle: _ge,
  variants: Bge,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
}), { definePartsStyle: sz, defineMultiStyleConfig: Pge } = gn(Xde.keys), Hh = ct("avatar-border-color"), bg = ct("avatar-bg"), wy = ct("avatar-font-size"), Am = ct("avatar-size"), Oge = {
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: Hh.reference,
  [Hh.variable]: "white",
  _dark: {
    [Hh.variable]: "colors.gray.800"
  }
}, Nge = {
  bg: bg.reference,
  fontSize: wy.reference,
  width: Am.reference,
  height: Am.reference,
  lineHeight: "1",
  [bg.variable]: "colors.gray.200",
  _dark: {
    [bg.variable]: "colors.whiteAlpha.400"
  }
}, Rge = (e) => {
  const { name: t, theme: n } = e, r = t ? zfe({ string: t }) : "colors.gray.400", i = Ufe(r)(n);
  let s = "white";
  return i || (s = "gray.800"), {
    bg: bg.reference,
    fontSize: wy.reference,
    color: s,
    borderColor: Hh.reference,
    verticalAlign: "top",
    width: Am.reference,
    height: Am.reference,
    "&:not([data-loaded])": {
      [bg.variable]: r
    },
    [Hh.variable]: "colors.white",
    _dark: {
      [Hh.variable]: "colors.gray.800"
    }
  };
}, Mge = {
  fontSize: wy.reference,
  lineHeight: "1"
}, Fge = sz((e) => ({
  badge: hi(Oge, e),
  excessLabel: hi(Nge, e),
  container: hi(Rge, e),
  label: Mge
}));
function Lc(e) {
  const t = e !== "100%" ? KL[e] : void 0;
  return sz({
    container: {
      [Am.variable]: t ?? e,
      [wy.variable]: `calc(${t ?? e} / 2.5)`
    },
    excessLabel: {
      [Am.variable]: t ?? e,
      [wy.variable]: `calc(${t ?? e} / 2.5)`
    }
  });
}
var jge = {
  "2xs": Lc(4),
  xs: Lc(6),
  sm: Lc(8),
  md: Lc(12),
  lg: Lc(16),
  xl: Lc(24),
  "2xl": Lc(32),
  full: Lc("100%")
}, Dge = Pge({
  baseStyle: Fge,
  sizes: jge,
  defaultProps: {
    size: "md"
  }
}), Uge = {
  Accordion: Age,
  Alert: Ige,
  Avatar: Dge,
  Badge: mg,
  Breadcrumb: L0e,
  Button: K0e,
  Checkbox: Lx,
  CloseButton: rge,
  Code: age,
  Container: lge,
  Divider: pge,
  Drawer: d0e,
  Editable: b0e,
  Form: _0e,
  FormError: I0e,
  FormLabel: O0e,
  Heading: M0e,
  Input: Jt,
  Kbd: tme,
  Link: rme,
  List: cme,
  Menu: vme,
  Modal: Ime,
  NumberInput: Ume,
  PinInput: Hme,
  Popover: e0e,
  Progress: ape,
  Radio: wpe,
  Select: Tpe,
  Skeleton: Bpe,
  SkipLink: Ppe,
  Slider: Vpe,
  Spinner: Gpe,
  Stat: Xpe,
  Switch: rhe,
  Table: uhe,
  Tabs: She,
  Tag: Dhe,
  Textarea: Yhe,
  Tooltip: Xhe,
  Card: ege,
  Stepper: Yde
}, Lge = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
}, zge = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
}, Vge = "ltr", Hge = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, oz = {
  semanticTokens: Lge,
  direction: Vge,
  ...$de,
  components: Uge,
  styles: zge,
  config: Hge
};
function G0(e) {
  return typeof e == "function";
}
function Wge(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
var Gge = (e) => function(...n) {
  let r = [...n], i = n[n.length - 1];
  return Ede(i) && // this ensures backward compatibility
  // previously only `extendTheme(override, activeTheme?)` was allowed
  r.length > 1 ? r = r.slice(0, r.length - 1) : i = e, Wge(
    ...r.map(
      (s) => (o) => G0(s) ? s(o) : qge(o, s)
    )
  )(i);
}, az = Gge(oz);
function qge(...e) {
  return Ts({}, ...e, cz);
}
function cz(e, t, n, r) {
  if ((G0(e) || G0(t)) && Object.prototype.hasOwnProperty.call(r, n))
    return (...i) => {
      const s = G0(e) ? e(...i) : e, o = G0(t) ? t(...i) : t;
      return Ts({}, s, o, cz);
    };
}
function $ge(e, t) {
  const n = {};
  return Object.keys(e).forEach((r) => {
    t.includes(r) || (n[r] = e[r]);
  }), n;
}
function Qge(e, t, n, r) {
  const i = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < i.length && e; r += 1)
    e = e[i[r]];
  return e === void 0 ? n : e;
}
var Kge = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, i, s, o) => {
    if (typeof r > "u")
      return e(r, i, s);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const a = t.get(r);
    if (a.has(i))
      return a.get(i);
    const c = e(r, i, s, o);
    return a.set(i, c), c;
  };
}, lz = Kge(Qge);
function uz(e, t) {
  const n = {};
  return Object.keys(e).forEach((r) => {
    const i = e[r];
    t(i, r, e) && (n[r] = i);
  }), n;
}
var dz = (e) => uz(e, (t) => t != null);
function Yge(e) {
  return typeof e == "function";
}
function fz(e, ...t) {
  return Yge(e) ? e(...t) : e;
}
var Zge = typeof Element < "u", Jge = typeof Map == "function", Xge = typeof Set == "function", eye = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Sw(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Sw(e[r], t[r]))
          return !1;
      return !0;
    }
    var s;
    if (Jge && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!Sw(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (Xge && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (eye && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r]))
        return !1;
    if (Zge && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((i[r] === "_owner" || i[r] === "__v" || i[r] === "__o") && e.$$typeof) && !Sw(e[i[r]], t[i[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var tye = function(t, n) {
  try {
    return Sw(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const nye = /* @__PURE__ */ Sk(tye);
function hz(e, t = {}) {
  var n;
  const { styleConfig: r, ...i } = t, { theme: s, colorMode: o } = UL(), a = e ? lz(s, `components.${e}`) : void 0, c = r || a, l = Ts(
    { theme: s, colorMode: o },
    (n = c == null ? void 0 : c.defaultProps) != null ? n : {},
    dz($ge(i, ["children"]))
  ), u = Le({});
  if (c) {
    const f = xde(c)(l);
    nye(u.current, f) || (u.current = f);
  }
  return u.current;
}
function t0(e, t = {}) {
  return hz(e, t);
}
function kf(e, t = {}) {
  return hz(e, t);
}
var rye = /* @__PURE__ */ new Set([
  ...lde,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), iye = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function sye(e) {
  return iye.has(e) || !rye.has(e);
}
function oye(e, ...t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const n = { ...e };
  for (const r of t)
    if (r != null)
      for (const i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (i in n && delete n[i], n[i] = r[i]);
  return n;
}
function pz(e) {
  const t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
var aye = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, cye = /* @__PURE__ */ EL(
  function(e) {
    return aye.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), lye = { npm_package_exports___require: "./dist/index.cjs", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.22 npm/? node/v20.15.1 linux x64", CI: "true", npm_package_bugs_url: "https://github.com/bitfinity-network/bitbridge/issues", npm_config_bin_links: "true", npm_node_execpath: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", npm_package_devDependencies_vite: "^5.2.0", npm_config_init_version: "1.0.0", npm_package_peerDependencies_react: "^18.2.0", npm_package_devDependencies__tanstack_react_query_devtools: "^5.24.0", npm_package_dependencies_wagmi: "^2.8.1", npm_package_files_0: "dist", npm_package_publishConfig_access: "public", HOME: "/home/runner", npm_package_devDependencies__typescript_eslint_parser: "^7.2.0", npm_package_dependencies_ethers: "^6.12.1", npm_package_dependencies_framer_motion: "^11.1.9", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_dependencies__rainbow_me_rainbowkit: "^2.0.7", npm_config_version_tag_prefix: "v", npm_package_devDependencies_vite_plugin_dts: "^3.9.1", npm_package_dependencies_react_icons: "^5.2.1", npm_package_devDependencies_eslint_plugin_react_hooks: "^4.6.0", npm_package_dependencies_dotenv: "^16.4.5", npm_package_devDependencies_typescript: "^5.2.2", npm_package_dependencies__dfinity_agent: "^1.2.0", npm_package_description: "The React UI for the Bitfinity EVM bridge", npm_package_readmeFilename: "README.md", npm_package_devDependencies__types_react_dom: "^18.2.22", npm_package_devDependencies_vite_plugin_mix: "^0.4.0", npm_package_types: "./dist/index.d.ts", npm_package_homepage: "https://github.com/bitfinity-network/bitbridge", npm_package_scripts_dev: "vite", npm_package_devDependencies__vitejs_plugin_react: "^4.2.1", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "^0.22.0", npm_package_dependencies__tanstack_query_sync_storage_persister: "^5.22.2", npm_package_dependencies__emotion_react: "^11.11.4", npm_package_module: "./dist/index.js", npm_package_devDependencies__typescript_eslint_eslint_plugin: "^7.2.0", npm_package_scripts_lint: "eslint . --ext ts,tsx --report-unused-disable-directives --max-warnings 0", npm_config_registry: "https://registry.yarnpkg.com", npm_package_devDependencies_eslint_plugin_react_refresh: "^0.4.6", npm_package_exports___import: "./dist/index.js", npm_config_ignore_scripts: "", npm_package_dependencies__bitfinity_network_bitfinitywallet: "^0.3.0", npm_package_author_email: "support@infinityswap.one", PATH: "/tmp/yarn--1722436032859-0.7268831613784328:/home/runner/work/bitbridge/bitbridge/packages/widget/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1722436018550-0.027432302051107138:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin:/snap/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", NODE: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", TURBO_HASH: "4c69888b02b3c09f", npm_package_name: "@bitfinity-network/bridge-widget", npm_package_dependencies_viem: "2.x", npm_package_dependencies__particle_network_btc_connectkit: "^1.0.0-alpha.25", LANG: "C.UTF-8", npm_package_devDependencies_eslint: "^8.57.0", npm_lifecycle_script: "tsc && vite build", npm_package_main: "./dist/index.cjs", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_devDependencies__types_react: "^18.2.66", npm_package_version: "1.3.0", npm_config_argv: '{"remain":[],"cooked":["run","build"],"original":["run","build"]}', npm_package_dependencies__bitfinity_network_bridge: "*", npm_package_scripts_build: "tsc && vite build", npm_package_peerDependencies_react_dom: "^18.2.0", npm_package_dependencies__tanstack_react_query: "^5.35.1", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "MIT", npm_config_strict_ssl: "true", npm_package_dependencies__chakra_ui_react: "^2.8.2", PWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_execpath: "/usr/local/lib/node_modules/yarn/bin/yarn.js", npm_package_dependencies__emotion_styled: "^11.11.5", npm_package_author_url: "https://bitfinity.network/", npm_package_author_name: "Bitfinity", npm_package_dependencies_react_spring_bottom_sheet: "3.5.0-alpha.0", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_scripts_preview: "vite preview", npm_package_dependencies_vite_plugin_svgr: "^4.2.0", INIT_CWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_package_dependencies__tanstack_react_query_persist_client: "^5.22.2", NODE_ENV: "production" }, uye = cye, dye = function(t) {
  return t !== "theme";
}, vO = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? uye : dye;
}, wO = function(t, n, r) {
  var i;
  if (n) {
    var s = n.shouldForwardProp;
    i = t.__emotion_forwardProp && s ? function(o) {
      return t.__emotion_forwardProp(o) && s(o);
    } : s;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, fye = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return kL(n, r, i), Ule(function() {
    return BL(n, r, i);
  }), null;
}, hye = function e(t, n) {
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, s, o;
  n !== void 0 && (s = n.label, o = n.target);
  var a = wO(t, n, r), c = a || vO(i), l = !c("as");
  return function() {
    var u = arguments, d = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (s !== void 0 && d.push("label:" + s + ";"), u[0] == null || u[0].raw === void 0)
      d.push.apply(d, u);
    else {
      d.push(u[0][0]);
      for (var f = u.length, p = 1; p < f; p++)
        d.push(u[p], u[0][p]);
    }
    var m = NL(function(h, g, y) {
      var v = l && h.as || i, b = "", w = [], A = h;
      if (h.theme == null) {
        A = {};
        for (var E in h)
          A[E] = h[E];
        A.theme = ye.useContext(gy);
      }
      typeof h.className == "string" ? b = Ile(g.registered, w, h.className) : h.className != null && (b = h.className + " ");
      var x = V5(d.concat(w), g.registered, A);
      b += g.key + "-" + x.name, o !== void 0 && (b += " " + o);
      var S = l && a === void 0 ? vO(v) : c, P = {};
      for (var I in h)
        l && I === "as" || // $FlowFixMe
        S(I) && (P[I] = h[I]);
      return P.className = b, P.ref = y, /* @__PURE__ */ ye.createElement(ye.Fragment, null, /* @__PURE__ */ ye.createElement(fye, {
        cache: g,
        serialized: x,
        isStringTag: typeof v == "string"
      }), /* @__PURE__ */ ye.createElement(v, P));
    });
    return m.displayName = s !== void 0 ? s : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", m.defaultProps = t.defaultProps, m.__emotion_real = m, m.__emotion_base = i, m.__emotion_styles = d, m.__emotion_forwardProp = a, Object.defineProperty(m, "toString", {
      value: function() {
        return o === void 0 && lye.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + o;
      }
    }), m.withComponent = function(h, g) {
      return e(h, of({}, n, g, {
        shouldForwardProp: wO(m, g, !0)
      })).apply(void 0, d);
    }, m;
  };
}, pye = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Vx = hye.bind();
pye.forEach(function(e) {
  Vx[e] = Vx(e);
});
var xO, mye = (xO = Vx.default) != null ? xO : Vx, gye = ({ baseStyle: e }) => (t) => {
  const { theme: n, css: r, __css: i, sx: s, ...o } = t, a = uz(o, (d, f) => dde(f)), c = fz(e, t), l = oye(
    {},
    i,
    c,
    dz(a),
    s
  ), u = qL(l)(t.theme);
  return r ? [u, r] : u;
};
function E_(e, t) {
  const { baseStyle: n, ...r } = t ?? {};
  r.shouldForwardProp || (r.shouldForwardProp = sye);
  const i = gye({ baseStyle: n }), s = mye(
    e,
    r
  )(i);
  return k.forwardRef(function(c, l) {
    const { colorMode: u, forced: d } = G5();
    return k.createElement(s, {
      ref: l,
      "data-theme": d ? u : void 0,
      ...c
    });
  });
}
function yye() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(E_, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(t, n, r) {
      return E_(...r);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(t, n) {
      return e.has(n) || e.set(n, E_(n)), e.get(n);
    }
  });
}
var yt = yye();
function Nt(e) {
  return Bc(e);
}
function bye(e = {}) {
  const {
    strict: t = !0,
    errorMessage: n = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: r
  } = e, i = dn(void 0);
  i.displayName = r;
  function s() {
    var o;
    const a = $e(i);
    if (!a && t) {
      const c = new Error(n);
      throw c.name = "ContextError", (o = Error.captureStackTrace) == null || o.call(Error, c, s), c;
    }
    return a;
  }
  return [
    i.Provider,
    s,
    i
  ];
}
function vye(e) {
  const { cssVarsRoot: t, theme: n, children: r } = e, i = ot(() => cde(n), [n]);
  return /* @__PURE__ */ D.jsxs(Vle, { theme: i, children: [
    /* @__PURE__ */ D.jsx(wye, { root: t }),
    r
  ] });
}
function wye({ root: e = ":host, :root" }) {
  const t = [e, "[data-theme]"].join(",");
  return /* @__PURE__ */ D.jsx(eE, { styles: (n) => ({ [t]: n.__cssVars }) });
}
bye({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function xye() {
  const { colorMode: e } = G5();
  return /* @__PURE__ */ D.jsx(
    eE,
    {
      styles: (t) => {
        const n = lz(t, "styles.global"), r = fz(n, { theme: t, colorMode: e });
        return r ? qL(r)(t) : void 0;
      }
    }
  );
}
var e4 = dn({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
e4.displayName = "EnvironmentContext";
function Aye({ defer: e } = {}) {
  const [, t] = Ak((n) => n + 1, 0);
  return ru(() => {
    e && t();
  }, [e]), $e(e4);
}
function mz(e) {
  const { children: t, environment: n, disabled: r } = e, i = Le(null), s = ot(() => n || {
    getDocument: () => {
      var a, c;
      return (c = (a = i.current) == null ? void 0 : a.ownerDocument) != null ? c : document;
    },
    getWindow: () => {
      var a, c;
      return (c = (a = i.current) == null ? void 0 : a.ownerDocument.defaultView) != null ? c : window;
    }
  }, [n]), o = !r || !n;
  return /* @__PURE__ */ D.jsxs(e4.Provider, { value: s, children: [
    t,
    o && /* @__PURE__ */ D.jsx("span", { id: "__chakra_env", hidden: !0, ref: i })
  ] });
}
mz.displayName = "EnvironmentProvider";
var Eye = (e) => {
  const {
    children: t,
    colorModeManager: n,
    portalZIndex: r,
    resetScope: i,
    resetCSS: s = !0,
    theme: o = {},
    environment: a,
    cssVarsRoot: c,
    disableEnvironment: l,
    disableGlobalStyle: u
  } = e, d = /* @__PURE__ */ D.jsx(
    mz,
    {
      environment: a,
      disabled: l,
      children: t
    }
  );
  return /* @__PURE__ */ D.jsx(vye, { theme: o, cssVarsRoot: c, children: /* @__PURE__ */ D.jsxs(
    DL,
    {
      colorModeManager: n,
      options: o.config,
      children: [
        s ? /* @__PURE__ */ D.jsx(qle, { scope: i }) : /* @__PURE__ */ D.jsx(Gle, {}),
        !u && /* @__PURE__ */ D.jsx(xye, {}),
        r ? /* @__PURE__ */ D.jsx(FL, { zIndex: r, children: d }) : d
      ]
    }
  ) });
}, _ye = (e, t) => e.find((n) => n.id === t);
function AO(e, t) {
  const n = gz(e, t), r = n ? e[n].findIndex((i) => i.id === t) : -1;
  return {
    position: n,
    index: r
  };
}
function gz(e, t) {
  for (const [n, r] of Object.entries(e))
    if (_ye(r, t))
      return n;
}
function Sye(e) {
  const t = e.includes("right"), n = e.includes("left");
  let r = "center";
  return t && (r = "flex-end"), n && (r = "flex-start"), {
    display: "flex",
    flexDirection: "column",
    alignItems: r
  };
}
function Cye(e) {
  const n = e === "top" || e === "bottom" ? "0 auto" : void 0, r = e.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0, i = e.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0, s = e.includes("left") ? void 0 : "env(safe-area-inset-right, 0px)", o = e.includes("right") ? void 0 : "env(safe-area-inset-left, 0px)";
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: n,
    top: r,
    bottom: i,
    right: s,
    left: o
  };
}
function zd(e, t = []) {
  const n = Le(e);
  return We(() => {
    n.current = e;
  }), Ie((...r) => {
    var i;
    return (i = n.current) == null ? void 0 : i.call(n, ...r);
  }, t);
}
function Tye(e, t) {
  const n = zd(e);
  We(() => {
    if (t == null)
      return;
    let r = null;
    return r = window.setTimeout(() => {
      n();
    }, t), () => {
      r && window.clearTimeout(r);
    };
  }, [t, n]);
}
function Hx(e, t) {
  const n = Le(!1), r = Le(!1);
  We(() => {
    if (n.current && r.current)
      return e();
    r.current = !0;
  }, t), We(() => (n.current = !0, () => {
    n.current = !1;
  }), []);
}
const t4 = dn({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), oE = dn({}), mv = dn(null), n4 = typeof document < "u", r4 = n4 ? _f : We, yz = dn({ strict: !1 }), i4 = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), kye = "framerAppearId", bz = "data-" + i4(kye), Bye = {
  skipAnimations: !1,
  useManualTiming: !1
};
class EO {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(t) {
    if (!this.scheduled.has(t))
      return this.scheduled.add(t), this.order.push(t), !0;
  }
  remove(t) {
    const n = this.order.indexOf(t);
    n !== -1 && (this.order.splice(n, 1), this.scheduled.delete(t));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function Iye(e) {
  let t = new EO(), n = new EO(), r = 0, i = !1, s = !1;
  const o = /* @__PURE__ */ new WeakSet(), a = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, l = !1, u = !1) => {
      const d = u && i, f = d ? t : n;
      return l && o.add(c), f.add(c) && d && i && (r = t.order.length), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.remove(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (i) {
        s = !0;
        return;
      }
      if (i = !0, [t, n] = [n, t], n.clear(), r = t.order.length, r)
        for (let l = 0; l < r; l++) {
          const u = t.order[l];
          o.has(u) && (a.schedule(u), e()), u(c);
        }
      i = !1, s && (s = !1, a.process(c));
    }
  };
  return a;
}
const d1 = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Pye = 40;
function vz(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = d1.reduce((d, f) => (d[f] = Iye(() => n = !0), d), {}), o = (d) => {
    s[d].process(i);
  }, a = () => {
    const d = performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(d - i.timestamp, Pye), 1), i.timestamp = d, i.isProcessing = !0, d1.forEach(o), i.isProcessing = !1, n && t && (r = !1, e(a));
  }, c = () => {
    n = !0, r = !0, i.isProcessing || e(a);
  };
  return { schedule: d1.reduce((d, f) => {
    const p = s[f];
    return d[f] = (m, h = !1, g = !1) => (n || c(), p.schedule(m, h, g)), d;
  }, {}), cancel: (d) => d1.forEach((f) => s[f].cancel(d)), state: i, steps: s };
}
const { schedule: s4, cancel: AFe } = vz(queueMicrotask, !1);
function Oye(e, t, n, r) {
  const { visualElement: i } = $e(oE), s = $e(yz), o = $e(mv), a = $e(t4).reducedMotion, c = Le();
  r = r || s.renderer, !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: i,
    props: n,
    presenceContext: o,
    blockInitialAnimation: o ? o.initial === !1 : !1,
    reducedMotionConfig: a
  }));
  const l = c.current;
  bF(() => {
    l && l.update(n, o);
  });
  const u = Le(!!(n[bz] && !window.HandoffComplete));
  return r4(() => {
    l && (s4.render(l.render), u.current && l.animationState && l.animationState.animateChanges());
  }), We(() => {
    l && (l.updateFeatures(), !u.current && l.animationState && l.animationState.animateChanges(), u.current && (u.current = !1, window.HandoffComplete = !0));
  }), l;
}
function Eh(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function Nye(e, t, n) {
  return Ie(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Eh(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function xy(e) {
  return typeof e == "string" || Array.isArray(e);
}
function aE(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const o4 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], a4 = ["initial", ...o4];
function cE(e) {
  return aE(e.animate) || a4.some((t) => xy(e[t]));
}
function wz(e) {
  return !!(cE(e) || e.variants);
}
function Rye(e, t) {
  if (cE(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || xy(n) ? n : void 0,
      animate: xy(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Mye(e) {
  const { initial: t, animate: n } = Rye(e, $e(oE));
  return ot(() => ({ initial: t, animate: n }), [_O(t), _O(n)]);
}
function _O(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const SO = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Ay = {};
for (const e in SO)
  Ay[e] = {
    isEnabled: (t) => SO[e].some((n) => !!t[n])
  };
function Fye(e) {
  for (const t in e)
    Ay[t] = {
      ...Ay[t],
      ...e[t]
    };
}
const c4 = dn({}), xz = dn({}), jye = Symbol.for("motionComponentSymbol");
function Dye({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  e && Fye(e);
  function s(a, c) {
    let l;
    const u = {
      ...$e(t4),
      ...a,
      layoutId: Uye(a)
    }, { isStatic: d } = u, f = Mye(a), p = r(a, d);
    if (!d && n4) {
      f.visualElement = Oye(i, p, u, t);
      const m = $e(xz), h = $e(yz).strict;
      f.visualElement && (l = f.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        u,
        h,
        e,
        m
      ));
    }
    return D.jsxs(oE.Provider, { value: f, children: [l && f.visualElement ? D.jsx(l, { visualElement: f.visualElement, ...u }) : null, n(i, a, Nye(p, f.visualElement, c), p, d, f.visualElement)] });
  }
  const o = Bc(s);
  return o[jye] = i, o;
}
function Uye({ layoutId: e }) {
  const t = $e(c4).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function Lye(e) {
  function t(r, i = {}) {
    return Dye(e(r, i));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => (n.has(i) || n.set(i, t(i)), n.get(i))
  });
}
const zye = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function l4(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(zye.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
const Wx = {};
function Vye(e) {
  Object.assign(Wx, e);
}
const gv = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Bf = new Set(gv);
function Az(e, { layout: t, layoutId: n }) {
  return Bf.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Wx[e] || e === "opacity");
}
const Hr = (e) => !!(e && e.getVelocity), Hye = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Wye = gv.length;
function Gye(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, r, i) {
  let s = "";
  for (let o = 0; o < Wye; o++) {
    const a = gv[o];
    if (e[a] !== void 0) {
      const c = Hye[a] || a;
      s += `${c}(${e[a]}) `;
    }
  }
  return t && !e.z && (s += "translateZ(0)"), s = s.trim(), i ? s = i(e, r ? "" : s) : n && r && (s = "none"), s;
}
const Ez = (e) => (t) => typeof t == "string" && t.startsWith(e), _z = Ez("--"), qye = Ez("var(--"), u4 = (e) => qye(e) ? $ye.test(e.split("/*")[0].trim()) : !1, $ye = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Qye = (e, t) => t && typeof e == "number" ? t.transform(e) : e, iu = (e, t, n) => n > t ? t : n < e ? e : n, n0 = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, vg = {
  ...n0,
  transform: (e) => iu(0, 1, e)
}, f1 = {
  ...n0,
  default: 1
}, wg = (e) => Math.round(e * 1e5) / 1e5, d4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu, Kye = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu, Yye = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function yv(e) {
  return typeof e == "string";
}
const bv = (e) => ({
  test: (t) => yv(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), tl = bv("deg"), ha = bv("%"), ut = bv("px"), Zye = bv("vh"), Jye = bv("vw"), CO = {
  ...ha,
  parse: (e) => ha.parse(e) / 100,
  transform: (e) => ha.transform(e * 100)
}, TO = {
  ...n0,
  transform: Math.round
}, Sz = {
  // Border props
  borderWidth: ut,
  borderTopWidth: ut,
  borderRightWidth: ut,
  borderBottomWidth: ut,
  borderLeftWidth: ut,
  borderRadius: ut,
  radius: ut,
  borderTopLeftRadius: ut,
  borderTopRightRadius: ut,
  borderBottomRightRadius: ut,
  borderBottomLeftRadius: ut,
  // Positioning props
  width: ut,
  maxWidth: ut,
  height: ut,
  maxHeight: ut,
  size: ut,
  top: ut,
  right: ut,
  bottom: ut,
  left: ut,
  // Spacing props
  padding: ut,
  paddingTop: ut,
  paddingRight: ut,
  paddingBottom: ut,
  paddingLeft: ut,
  margin: ut,
  marginTop: ut,
  marginRight: ut,
  marginBottom: ut,
  marginLeft: ut,
  // Transform props
  rotate: tl,
  rotateX: tl,
  rotateY: tl,
  rotateZ: tl,
  scale: f1,
  scaleX: f1,
  scaleY: f1,
  scaleZ: f1,
  skew: tl,
  skewX: tl,
  skewY: tl,
  distance: ut,
  translateX: ut,
  translateY: ut,
  translateZ: ut,
  x: ut,
  y: ut,
  z: ut,
  perspective: ut,
  transformPerspective: ut,
  opacity: vg,
  originX: CO,
  originY: CO,
  originZ: ut,
  // Misc
  zIndex: TO,
  backgroundPositionX: ut,
  backgroundPositionY: ut,
  // SVG
  fillOpacity: vg,
  strokeOpacity: vg,
  numOctaves: TO
};
function f4(e, t, n, r) {
  const { style: i, vars: s, transform: o, transformOrigin: a } = e;
  let c = !1, l = !1, u = !0;
  for (const d in t) {
    const f = t[d];
    if (_z(d)) {
      s[d] = f;
      continue;
    }
    const p = Sz[d], m = Qye(f, p);
    if (Bf.has(d)) {
      if (c = !0, o[d] = m, !u)
        continue;
      f !== (p.default || 0) && (u = !1);
    } else
      d.startsWith("origin") ? (l = !0, a[d] = m) : i[d] = m;
  }
  if (t.transform || (c || r ? i.transform = Gye(e.transform, n, u, r) : i.transform && (i.transform = "none")), l) {
    const { originX: d = "50%", originY: f = "50%", originZ: p = 0 } = a;
    i.transformOrigin = `${d} ${f} ${p}`;
  }
}
const h4 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Cz(e, t, n) {
  for (const r in t)
    !Hr(t[r]) && !Az(r, n) && (e[r] = t[r]);
}
function Xye({ transformTemplate: e }, t, n) {
  return ot(() => {
    const r = h4();
    return f4(r, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, r.vars, r.style);
  }, [t]);
}
function ebe(e, t, n) {
  const r = e.style || {}, i = {};
  return Cz(i, r, e), Object.assign(i, Xye(e, t, n)), i;
}
function tbe(e, t, n) {
  const r = {}, i = ebe(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = i, r;
}
const nbe = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Gx(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || nbe.has(e);
}
let Tz = (e) => !Gx(e);
function rbe(e) {
  e && (Tz = (t) => t.startsWith("on") ? !Gx(t) : e(t));
}
try {
  rbe(require("@emotion/is-prop-valid").default);
} catch {
}
function ibe(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (Tz(i) || n === !0 && Gx(i) || !t && !Gx(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function kO(e, t, n) {
  return typeof e == "string" ? e : ut.transform(t + n * e);
}
function sbe(e, t, n) {
  const r = kO(t, e.x, e.width), i = kO(n, e.y, e.height);
  return `${r} ${i}`;
}
const obe = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, abe = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function cbe(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const s = i ? obe : abe;
  e[s.offset] = ut.transform(-r);
  const o = ut.transform(t), a = ut.transform(n);
  e[s.array] = `${o} ${a}`;
}
function p4(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: s,
  pathLength: o,
  pathSpacing: a = 1,
  pathOffset: c = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, u, d, f) {
  if (f4(e, l, u, f), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: m, dimensions: h } = e;
  p.transform && (h && (m.transform = p.transform), delete p.transform), h && (i !== void 0 || s !== void 0 || m.transform) && (m.transformOrigin = sbe(h, i !== void 0 ? i : 0.5, s !== void 0 ? s : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), r !== void 0 && (p.scale = r), o !== void 0 && cbe(p, o, a, c, !1);
}
const kz = () => ({
  ...h4(),
  attrs: {}
}), m4 = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function lbe(e, t, n, r) {
  const i = ot(() => {
    const s = kz();
    return p4(s, t, { enableHardwareAcceleration: !1 }, m4(r), e.transformTemplate), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [t]);
  if (e.style) {
    const s = {};
    Cz(s, e.style, e), i.style = { ...s, ...i.style };
  }
  return i;
}
function ube(e = !1) {
  return (n, r, i, { latestValues: s }, o) => {
    const c = (l4(n) ? lbe : tbe)(r, s, o, n), l = ibe(r, typeof n == "string", e), u = n !== Xd ? { ...l, ...c, ref: i } : {}, { children: d } = r, f = ot(() => Hr(d) ? d.get() : d, [d]);
    return Hg(n, {
      ...u,
      children: f
    });
  };
}
function Bz(e, { style: t, vars: n }, r, i) {
  Object.assign(e.style, t, i && i.getProjectionStyles(r));
  for (const s in n)
    e.style.setProperty(s, n[s]);
}
const Iz = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Pz(e, t, n, r) {
  Bz(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(Iz.has(i) ? i : i4(i), t.attrs[i]);
}
function g4(e, t, n) {
  var r;
  const { style: i } = e, s = {};
  for (const o in i)
    (Hr(i[o]) || t.style && Hr(t.style[o]) || Az(o, e) || ((r = n == null ? void 0 : n.getValue(o)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (s[o] = i[o]);
  return s;
}
function Oz(e, t, n) {
  const r = g4(e, t, n);
  for (const i in e)
    if (Hr(e[i]) || Hr(t[i])) {
      const s = gv.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[s] = e[i];
    }
  return r;
}
function BO(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function y4(e, t, n, r) {
  if (typeof t == "function") {
    const [i, s] = BO(r);
    t = t(n !== void 0 ? n : e.custom, i, s);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, s] = BO(r);
    t = t(n !== void 0 ? n : e.custom, i, s);
  }
  return t;
}
function Nz(e) {
  const t = Le(null);
  return t.current === null && (t.current = e()), t.current;
}
const oC = (e) => Array.isArray(e), dbe = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), fbe = (e) => oC(e) ? e[e.length - 1] || 0 : e;
function Cw(e) {
  const t = Hr(e) ? e.get() : e;
  return dbe(t) ? t.toValue() : t;
}
function hbe({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, i, s) {
  const o = {
    latestValues: pbe(r, i, s, e),
    renderState: t()
  };
  return n && (o.mount = (a) => n(r, a, o)), o;
}
const Rz = (e) => (t, n) => {
  const r = $e(oE), i = $e(mv), s = () => hbe(e, t, r, i);
  return n ? s() : Nz(s);
};
function pbe(e, t, n, r) {
  const i = {}, s = r(e, {});
  for (const f in s)
    i[f] = Cw(s[f]);
  let { initial: o, animate: a } = e;
  const c = cE(e), l = wz(e);
  t && l && !c && e.inherit !== !1 && (o === void 0 && (o = t.initial), a === void 0 && (a = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || o === !1;
  const d = u ? a : o;
  return d && typeof d != "boolean" && !aE(d) && (Array.isArray(d) ? d : [d]).forEach((p) => {
    const m = y4(e, p);
    if (!m)
      return;
    const { transitionEnd: h, transition: g, ...y } = m;
    for (const v in y) {
      let b = y[v];
      if (Array.isArray(b)) {
        const w = u ? b.length - 1 : 0;
        b = b[w];
      }
      b !== null && (i[v] = b);
    }
    for (const v in h)
      i[v] = h[v];
  }), i;
}
const Gr = (e) => e, { schedule: on, cancel: _c, state: Ar, steps: __ } = vz(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Gr, !0), mbe = {
  useVisualState: Rz({
    scrapeMotionValuesFromProps: Oz,
    createRenderState: kz,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      on.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), on.render(() => {
        p4(n, r, { enableHardwareAcceleration: !1 }, m4(t.tagName), e.transformTemplate), Pz(t, n);
      });
    }
  })
}, gbe = {
  useVisualState: Rz({
    scrapeMotionValuesFromProps: g4,
    createRenderState: h4
  })
};
function ybe(e, { forwardMotionProps: t = !1 }, n, r) {
  return {
    ...l4(e) ? mbe : gbe,
    preloadedFeatures: n,
    useRender: ube(t),
    createVisualElement: r,
    Component: e
  };
}
function oc(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const Mz = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function lE(e, t = "page") {
  return {
    point: {
      x: e[`${t}X`],
      y: e[`${t}Y`]
    }
  };
}
const bbe = (e) => (t) => Mz(t) && e(t, lE(t));
function hc(e, t, n, r) {
  return oc(e, t, bbe(n), r);
}
const vbe = (e, t) => (n) => t(e(n)), pc = (...e) => e.reduce(vbe);
function Fz(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const IO = Fz("dragHorizontal"), PO = Fz("dragVertical");
function jz(e) {
  let t = !1;
  if (e === "y")
    t = PO();
  else if (e === "x")
    t = IO();
  else {
    const n = IO(), r = PO();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function Dz() {
  const e = jz(!0);
  return e ? (e(), !1) : !0;
}
class bu {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function OO(e, t) {
  const n = t ? "pointerenter" : "pointerleave", r = t ? "onHoverStart" : "onHoverEnd", i = (s, o) => {
    if (s.pointerType === "touch" || Dz())
      return;
    const a = e.getProps();
    e.animationState && a.whileHover && e.animationState.setActive("whileHover", t);
    const c = a[r];
    c && on.postRender(() => c(s, o));
  };
  return hc(e.current, n, i, {
    passive: !e.getProps()[r]
  });
}
class wbe extends bu {
  mount() {
    this.unmount = pc(OO(this.node, !0), OO(this.node, !1));
  }
  unmount() {
  }
}
class xbe extends bu {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = pc(oc(this.node.current, "focus", () => this.onFocus()), oc(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const Uz = (e, t) => t ? e === t ? !0 : Uz(e, t.parentElement) : !1;
function S_(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, lE(n));
}
class Abe extends bu {
  constructor() {
    super(...arguments), this.removeStartListeners = Gr, this.removeEndListeners = Gr, this.removeAccessibleListeners = Gr, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), s = hc(window, "pointerup", (a, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: l, onTapCancel: u, globalTapTarget: d } = this.node.getProps(), f = !d && !Uz(this.node.current, a.target) ? u : l;
        f && on.update(() => f(a, c));
      }, {
        passive: !(r.onTap || r.onPointerUp)
      }), o = hc(window, "pointercancel", (a, c) => this.cancelPress(a, c), {
        passive: !(r.onTapCancel || r.onPointerCancel)
      });
      this.removeEndListeners = pc(s, o), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (s) => {
        if (s.key !== "Enter" || this.isPressing)
          return;
        const o = (a) => {
          a.key !== "Enter" || !this.checkPressEnd() || S_("up", (c, l) => {
            const { onTap: u } = this.node.getProps();
            u && on.postRender(() => u(c, l));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = oc(this.node.current, "keyup", o), S_("down", (a, c) => {
          this.startPress(a, c);
        });
      }, n = oc(this.node.current, "keydown", t), r = () => {
        this.isPressing && S_("cancel", (s, o) => this.cancelPress(s, o));
      }, i = oc(this.node.current, "blur", r);
      this.removeAccessibleListeners = pc(n, i);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: i } = this.node.getProps();
    i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && on.postRender(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !Dz();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && on.postRender(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = hc(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(t.onTapStart || t.onPointerStart)
    }), r = oc(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pc(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const aC = /* @__PURE__ */ new WeakMap(), C_ = /* @__PURE__ */ new WeakMap(), Ebe = (e) => {
  const t = aC.get(e.target);
  t && t(e);
}, _be = (e) => {
  e.forEach(Ebe);
};
function Sbe({ root: e, ...t }) {
  const n = e || document;
  C_.has(n) || C_.set(n, {});
  const r = C_.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(_be, { root: e, ...t })), r[i];
}
function Cbe(e, t, n) {
  const r = Sbe(t);
  return aC.set(e, n), r.observe(e), () => {
    aC.delete(e), r.unobserve(e);
  };
}
const Tbe = {
  some: 0,
  all: 1
};
class kbe extends bu {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: s } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : Tbe[i]
    }, a = (c) => {
      const { isIntersecting: l } = c;
      if (this.isInView === l || (this.isInView = l, s && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), f = l ? u : d;
      f && f(c);
    };
    return Cbe(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Bbe(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Bbe({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const Ibe = {
  inView: {
    Feature: kbe
  },
  tap: {
    Feature: Abe
  },
  focus: {
    Feature: xbe
  },
  hover: {
    Feature: wbe
  }
};
function Lz(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function uE(e, t, n) {
  const r = e.getProps();
  return y4(r, t, n !== void 0 ? n : r.custom, e);
}
const Wl = (e) => e * 1e3, mc = (e) => e / 1e3, Pbe = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Obe = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Nbe = {
  type: "keyframes",
  duration: 0.8
}, Rbe = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Mbe = (e, { keyframes: t }) => t.length > 2 ? Nbe : Bf.has(e) ? e.startsWith("scale") ? Obe(t[1]) : Pbe : Rbe;
function Fbe({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: s, repeatType: o, repeatDelay: a, from: c, elapsed: l, ...u }) {
  return !!Object.keys(u).length;
}
function b4(e, t) {
  return e[t] || e.default || e;
}
const jbe = (e) => e !== null;
function dE(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(jbe), s = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !s || r === void 0 ? i[s] : r;
}
let Tw;
function Dbe() {
  Tw = void 0;
}
const Gl = {
  now: () => (Tw === void 0 && Gl.set(Ar.isProcessing || Bye.useManualTiming ? Ar.timestamp : performance.now()), Tw),
  set: (e) => {
    Tw = e, queueMicrotask(Dbe);
  }
}, zz = (e) => /^0[^.\s]+$/u.test(e);
function Ube(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || zz(e) : !0;
}
let cC = Gr;
const Vz = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Lbe = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function zbe(e) {
  const t = Lbe.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
function Hz(e, t, n = 1) {
  const [r, i] = zbe(e);
  if (!r)
    return;
  const s = window.getComputedStyle(t).getPropertyValue(r);
  if (s) {
    const o = s.trim();
    return Vz(o) ? parseFloat(o) : o;
  }
  return u4(i) ? Hz(i, t, n + 1) : i;
}
const Vbe = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), NO = (e) => e === n0 || e === ut, RO = (e, t) => parseFloat(e.split(", ")[t]), MO = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const i = r.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return RO(i[1], t);
  {
    const s = r.match(/^matrix\((.+)\)$/u);
    return s ? RO(s[1], e) : 0;
  }
}, Hbe = /* @__PURE__ */ new Set(["x", "y", "z"]), Wbe = gv.filter((e) => !Hbe.has(e));
function Gbe(e) {
  const t = [];
  return Wbe.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Em = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: MO(4, 13),
  y: MO(5, 14)
};
Em.translateX = Em.x;
Em.translateY = Em.y;
const Wz = (e) => (t) => t.test(e), qbe = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Gz = [n0, ut, ha, tl, Jye, Zye, qbe], FO = (e) => Gz.find(Wz(e)), Vd = /* @__PURE__ */ new Set();
let lC = !1, uC = !1;
function qz() {
  if (uC) {
    const e = Array.from(Vd).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = Gbe(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([s, o]) => {
        var a;
        (a = r.getValue(s)) === null || a === void 0 || a.set(o);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  uC = !1, lC = !1, Vd.forEach((e) => e.complete()), Vd.clear();
}
function $z() {
  Vd.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (uC = !0);
  });
}
function $be() {
  $z(), qz();
}
class v4 {
  constructor(t, n, r, i, s, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = s, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Vd.add(this), lC || (lC = !0, on.read($z), on.resolveKeyframes(qz))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    for (let s = 0; s < t.length; s++)
      if (t[s] === null)
        if (s === 0) {
          const o = i == null ? void 0 : i.get(), a = t[t.length - 1];
          if (o !== void 0)
            t[0] = o;
          else if (r && n) {
            const c = r.readValue(n, a);
            c != null && (t[0] = c);
          }
          t[0] === void 0 && (t[0] = a), i && o === void 0 && i.set(t[0]);
        } else
          t[s] = t[s - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Vd.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Vd.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const w4 = (e, t) => (n) => !!(yv(n) && Yye.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), Qz = (e, t, n) => (r) => {
  if (!yv(r))
    return r;
  const [i, s, o, a] = r.match(d4);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(s),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, Qbe = (e) => iu(0, 255, e), T_ = {
  ...n0,
  transform: (e) => Math.round(Qbe(e))
}, Xu = {
  test: w4("rgb", "red"),
  parse: Qz("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + T_.transform(e) + ", " + T_.transform(t) + ", " + T_.transform(n) + ", " + wg(vg.transform(r)) + ")"
};
function Kbe(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const dC = {
  test: w4("#"),
  parse: Kbe,
  transform: Xu.transform
}, _h = {
  test: w4("hsl", "hue"),
  parse: Qz("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + ha.transform(wg(t)) + ", " + ha.transform(wg(n)) + ", " + wg(vg.transform(r)) + ")"
}, Dr = {
  test: (e) => Xu.test(e) || dC.test(e) || _h.test(e),
  parse: (e) => Xu.test(e) ? Xu.parse(e) : _h.test(e) ? _h.parse(e) : dC.parse(e),
  transform: (e) => yv(e) ? e : e.hasOwnProperty("red") ? Xu.transform(e) : _h.transform(e)
};
function Ybe(e) {
  var t, n;
  return isNaN(e) && yv(e) && (((t = e.match(d4)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(Kye)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const Kz = "number", Yz = "color", Zbe = "var", Jbe = "var(", jO = "${}", Xbe = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Ey(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let s = 0;
  const a = t.replace(Xbe, (c) => (Dr.test(c) ? (r.color.push(s), i.push(Yz), n.push(Dr.parse(c))) : c.startsWith(Jbe) ? (r.var.push(s), i.push(Zbe), n.push(c)) : (r.number.push(s), i.push(Kz), n.push(parseFloat(c))), ++s, jO)).split(jO);
  return { values: n, split: a, indexes: r, types: i };
}
function Zz(e) {
  return Ey(e).values;
}
function Jz(e) {
  const { split: t, types: n } = Ey(e), r = t.length;
  return (i) => {
    let s = "";
    for (let o = 0; o < r; o++)
      if (s += t[o], i[o] !== void 0) {
        const a = n[o];
        a === Kz ? s += wg(i[o]) : a === Yz ? s += Dr.transform(i[o]) : s += i[o];
      }
    return s;
  };
}
const eve = (e) => typeof e == "number" ? 0 : e;
function tve(e) {
  const t = Zz(e);
  return Jz(e)(t.map(eve));
}
const su = {
  test: Ybe,
  parse: Zz,
  createTransformer: Jz,
  getAnimatableNone: tve
}, nve = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function rve(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(d4) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let s = nve.has(t) ? 1 : 0;
  return r !== n && (s *= 100), t + "(" + s + i + ")";
}
const ive = /\b([a-z-]*)\(.*?\)/gu, fC = {
  ...su,
  getAnimatableNone: (e) => {
    const t = e.match(ive);
    return t ? t.map(rve).join(" ") : e;
  }
}, sve = {
  ...Sz,
  // Color props
  color: Dr,
  backgroundColor: Dr,
  outlineColor: Dr,
  fill: Dr,
  stroke: Dr,
  // Border props
  borderColor: Dr,
  borderTopColor: Dr,
  borderRightColor: Dr,
  borderBottomColor: Dr,
  borderLeftColor: Dr,
  filter: fC,
  WebkitFilter: fC
}, x4 = (e) => sve[e];
function Xz(e, t) {
  let n = x4(e);
  return n !== fC && (n = su), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const ove = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function ave(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const s = e[r];
    typeof s == "string" && !ove.has(s) && Ey(s).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const s of t)
      e[s] = Xz(n, i);
}
class eV extends v4 {
  constructor(t, n, r, i) {
    super(t, n, r, i, i == null ? void 0 : i.owner, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < t.length; c++) {
      let l = t[c];
      if (typeof l == "string" && (l = l.trim(), u4(l))) {
        const u = Hz(l, n.current);
        u !== void 0 && (t[c] = u), c === t.length - 1 && (this.finalKeyframe = l);
      }
    }
    if (this.resolveNoneKeyframes(), !Vbe.has(r) || t.length !== 2)
      return;
    const [i, s] = t, o = FO(i), a = FO(s);
    if (o !== a)
      if (NO(o) && NO(a))
        for (let c = 0; c < t.length; c++) {
          const l = t[c];
          typeof l == "string" && (t[c] = parseFloat(l));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      Ube(t[i]) && r.push(i);
    r.length && ave(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Em[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var t;
    const { element: n, name: r, unresolvedKeyframes: i } = this;
    if (!n.current)
      return;
    const s = n.getValue(r);
    s && s.jump(this.measuredOrigin, !1);
    const o = i.length - 1, a = i[o];
    i[o] = Em[r](n.measureViewportBox(), window.getComputedStyle(n.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([c, l]) => {
      n.getValue(c).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function tV(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const DO = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(su.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function cve(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function lve(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const s = e[e.length - 1], o = DO(i, t), a = DO(s, t);
  return !o || !a ? !1 : cve(e) || n === "spring" && r;
}
class nV {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: s = 0, repeatType: o = "loop", ...a }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: s,
      repeatType: o,
      ...a
    }, this.updateFinishedPromise();
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && $be(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.hasAttemptedResolve = !0;
    const { name: r, type: i, velocity: s, delay: o, onComplete: a, onUpdate: c, isGenerator: l } = this.options;
    if (!l && !lve(t, r, i, s))
      if (o)
        this.options.duration = 0;
      else {
        c == null || c(dE(t, this.options, n)), a == null || a(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(t, n);
    u !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
function rV(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const uve = 5;
function iV(e, t, n) {
  const r = Math.max(t - uve, 0);
  return rV(n - e(r), t - r);
}
const k_ = 1e-3, dve = 0.01, fve = 10, hve = 0.05, pve = 1;
function mve({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, s, o = 1 - t;
  o = iu(hve, pve, o), e = iu(dve, fve, mc(e)), o < 1 ? (i = (l) => {
    const u = l * o, d = u * e, f = u - n, p = hC(l, o), m = Math.exp(-d);
    return k_ - f / p * m;
  }, s = (l) => {
    const d = l * o * e, f = d * n + n, p = Math.pow(o, 2) * Math.pow(l, 2) * e, m = Math.exp(-d), h = hC(Math.pow(l, 2), o);
    return (-i(l) + k_ > 0 ? -1 : 1) * ((f - p) * m) / h;
  }) : (i = (l) => {
    const u = Math.exp(-l * e), d = (l - n) * e + 1;
    return -k_ + u * d;
  }, s = (l) => {
    const u = Math.exp(-l * e), d = (n - l) * (e * e);
    return u * d;
  });
  const a = 5 / e, c = yve(i, s, a);
  if (e = Wl(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const l = Math.pow(c, 2) * r;
    return {
      stiffness: l,
      damping: o * 2 * Math.sqrt(r * l),
      duration: e
    };
  }
}
const gve = 12;
function yve(e, t, n) {
  let r = n;
  for (let i = 1; i < gve; i++)
    r = r - e(r) / t(r);
  return r;
}
function hC(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const bve = ["duration", "bounce"], vve = ["stiffness", "damping", "mass"];
function UO(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function wve(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!UO(e, vve) && UO(e, bve)) {
    const n = mve(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function sV({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const i = e[0], s = e[e.length - 1], o = { done: !1, value: i }, { stiffness: a, damping: c, mass: l, duration: u, velocity: d, isResolvedFromDuration: f } = wve({
    ...r,
    velocity: -mc(r.velocity || 0)
  }), p = d || 0, m = c / (2 * Math.sqrt(a * l)), h = s - i, g = mc(Math.sqrt(a / l)), y = Math.abs(h) < 5;
  n || (n = y ? 0.01 : 2), t || (t = y ? 5e-3 : 0.5);
  let v;
  if (m < 1) {
    const b = hC(g, m);
    v = (w) => {
      const A = Math.exp(-m * g * w);
      return s - A * ((p + m * g * h) / b * Math.sin(b * w) + h * Math.cos(b * w));
    };
  } else if (m === 1)
    v = (b) => s - Math.exp(-g * b) * (h + (p + g * h) * b);
  else {
    const b = g * Math.sqrt(m * m - 1);
    v = (w) => {
      const A = Math.exp(-m * g * w), E = Math.min(b * w, 300);
      return s - A * ((p + m * g * h) * Math.sinh(E) + b * h * Math.cosh(E)) / b;
    };
  }
  return {
    calculatedDuration: f && u || null,
    next: (b) => {
      const w = v(b);
      if (f)
        o.done = b >= u;
      else {
        let A = p;
        b !== 0 && (m < 1 ? A = iV(v, b, w) : A = 0);
        const E = Math.abs(A) <= n, x = Math.abs(s - w) <= t;
        o.done = E && x;
      }
      return o.value = o.done ? s : w, o;
    }
  };
}
function LO({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: s = 500, modifyTarget: o, min: a, max: c, restDelta: l = 0.5, restSpeed: u }) {
  const d = e[0], f = {
    done: !1,
    value: d
  }, p = (S) => a !== void 0 && S < a || c !== void 0 && S > c, m = (S) => a === void 0 ? c : c === void 0 || Math.abs(a - S) < Math.abs(c - S) ? a : c;
  let h = n * t;
  const g = d + h, y = o === void 0 ? g : o(g);
  y !== g && (h = y - d);
  const v = (S) => -h * Math.exp(-S / r), b = (S) => y + v(S), w = (S) => {
    const P = v(S), I = b(S);
    f.done = Math.abs(P) <= l, f.value = f.done ? y : I;
  };
  let A, E;
  const x = (S) => {
    p(f.value) && (A = S, E = sV({
      keyframes: [f.value, m(f.value)],
      velocity: iV(b, S, f.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: s,
      restDelta: l,
      restSpeed: u
    }));
  };
  return x(0), {
    calculatedDuration: null,
    next: (S) => {
      let P = !1;
      return !E && A === void 0 && (P = !0, w(S), x(S)), A !== void 0 && S >= A ? E.next(S - A) : (!P && w(S), f);
    }
  };
}
const oV = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, xve = 1e-7, Ave = 12;
function Eve(e, t, n, r, i) {
  let s, o, a = 0;
  do
    o = t + (n - t) / 2, s = oV(o, r, i) - e, s > 0 ? n = o : t = o;
  while (Math.abs(s) > xve && ++a < Ave);
  return o;
}
function vv(e, t, n, r) {
  if (e === t && n === r)
    return Gr;
  const i = (s) => Eve(s, 0, 1, e, n);
  return (s) => s === 0 || s === 1 ? s : oV(i(s), t, r);
}
const _ve = vv(0.42, 0, 1, 1), Sve = vv(0, 0, 0.58, 1), aV = vv(0.42, 0, 0.58, 1), Cve = (e) => Array.isArray(e) && typeof e[0] != "number", cV = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, lV = (e) => (t) => 1 - e(1 - t), A4 = (e) => 1 - Math.sin(Math.acos(e)), uV = lV(A4), Tve = cV(A4), dV = vv(0.33, 1.53, 0.69, 0.99), E4 = lV(dV), kve = cV(E4), Bve = (e) => (e *= 2) < 1 ? 0.5 * E4(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), zO = {
  linear: Gr,
  easeIn: _ve,
  easeInOut: aV,
  easeOut: Sve,
  circIn: A4,
  circInOut: Tve,
  circOut: uV,
  backIn: E4,
  backInOut: kve,
  backOut: dV,
  anticipate: Bve
}, VO = (e) => {
  if (Array.isArray(e)) {
    cC(e.length === 4);
    const [t, n, r, i] = e;
    return vv(t, n, r, i);
  } else if (typeof e == "string")
    return cC(zO[e] !== void 0), zO[e];
  return e;
}, _y = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Tn = (e, t, n) => e + (t - e) * n;
function B_(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Ive({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, s = 0, o = 0;
  if (!t)
    i = s = o = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - a;
    i = B_(c, a, e + 1 / 3), s = B_(c, a, e), o = B_(c, a, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function qx(e, t) {
  return (n) => n > 0 ? t : e;
}
const I_ = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, Pve = [dC, Xu, _h], Ove = (e) => Pve.find((t) => t.test(e));
function HO(e) {
  const t = Ove(e);
  if (!t)
    return !1;
  let n = t.parse(e);
  return t === _h && (n = Ive(n)), n;
}
const WO = (e, t) => {
  const n = HO(e), r = HO(t);
  if (!n || !r)
    return qx(e, t);
  const i = { ...n };
  return (s) => (i.red = I_(n.red, r.red, s), i.green = I_(n.green, r.green, s), i.blue = I_(n.blue, r.blue, s), i.alpha = Tn(n.alpha, r.alpha, s), Xu.transform(i));
}, pC = /* @__PURE__ */ new Set(["none", "hidden"]);
function Nve(e, t) {
  return pC.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function Rve(e, t) {
  return (n) => Tn(e, t, n);
}
function _4(e) {
  return typeof e == "number" ? Rve : typeof e == "string" ? u4(e) ? qx : Dr.test(e) ? WO : jve : Array.isArray(e) ? fV : typeof e == "object" ? Dr.test(e) ? WO : Mve : qx;
}
function fV(e, t) {
  const n = [...e], r = n.length, i = e.map((s, o) => _4(s)(s, t[o]));
  return (s) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](s);
    return n;
  };
}
function Mve(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = _4(e[i])(e[i], t[i]));
  return (i) => {
    for (const s in r)
      n[s] = r[s](i);
    return n;
  };
}
function Fve(e, t) {
  var n;
  const r = [], i = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < t.values.length; s++) {
    const o = t.types[s], a = e.indexes[o][i[o]], c = (n = e.values[a]) !== null && n !== void 0 ? n : 0;
    r[s] = c, i[o]++;
  }
  return r;
}
const jve = (e, t) => {
  const n = su.createTransformer(t), r = Ey(e), i = Ey(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? pC.has(e) && !i.values.length || pC.has(t) && !r.values.length ? Nve(e, t) : pc(fV(Fve(r, i), i.values), n) : qx(e, t);
};
function hV(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Tn(e, t, n) : _4(e)(e, t);
}
function Dve(e, t, n) {
  const r = [], i = n || hV, s = e.length - 1;
  for (let o = 0; o < s; o++) {
    let a = i(e[o], e[o + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[o] || Gr : t;
      a = pc(c, a);
    }
    r.push(a);
  }
  return r;
}
function Uve(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const s = e.length;
  if (cC(s === t.length), s === 1)
    return () => t[0];
  if (s === 2 && e[0] === e[1])
    return () => t[1];
  e[0] > e[s - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const o = Dve(t, r, i), a = o.length, c = (l) => {
    let u = 0;
    if (a > 1)
      for (; u < e.length - 2 && !(l < e[u + 1]); u++)
        ;
    const d = _y(e[u], e[u + 1], l);
    return o[u](d);
  };
  return n ? (l) => c(iu(e[0], e[s - 1], l)) : c;
}
function Lve(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = _y(0, t, r);
    e.push(Tn(n, 1, i));
  }
}
function zve(e) {
  const t = [0];
  return Lve(t, e.length - 1), t;
}
function Vve(e, t) {
  return e.map((n) => n * t);
}
function Hve(e, t) {
  return e.map(() => t || aV).splice(0, e.length - 1);
}
function $x({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = Cve(r) ? r.map(VO) : VO(r), s = {
    done: !1,
    value: t[0]
  }, o = Vve(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : zve(t),
    e
  ), a = Uve(o, t, {
    ease: Array.isArray(i) ? i : Hve(t, i)
  });
  return {
    calculatedDuration: e,
    next: (c) => (s.value = a(c), s.done = c >= e, s)
  };
}
const GO = 2e4;
function Wve(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < GO; )
    t += n, r = e.next(t);
  return t >= GO ? 1 / 0 : t;
}
const Gve = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => on.update(t, !0),
    stop: () => _c(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Ar.isProcessing ? Ar.timestamp : Gl.now()
  };
}, qve = {
  decay: LO,
  inertia: LO,
  tween: $x,
  keyframes: $x,
  spring: sV
}, $ve = (e) => e / 100;
class S4 extends nV {
  constructor({ KeyframeResolver: t = v4, ...n }) {
    super(n), this.holdTime = null, this.startTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: a } = this.options;
      a && a();
    };
    const { name: r, motionValue: i, keyframes: s } = this.options, o = (a, c) => this.onKeyframesResolved(a, c);
    r && i && i.owner ? this.resolver = i.owner.resolveKeyframes(s, o, r, i) : this.resolver = new t(s, o, r, i), this.resolver.scheduleResolve();
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: s, velocity: o = 0 } = this.options, a = qve[n] || $x;
    let c, l;
    a !== $x && typeof t[0] != "number" && (c = pc($ve, hV(t[0], t[1])), t = [0, 100]);
    const u = a({ ...this.options, keyframes: t });
    s === "mirror" && (l = a({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = Wve(u));
    const { calculatedDuration: d } = u, f = d + i, p = f * (r + 1) - i;
    return {
      generator: u,
      mirroredGenerator: l,
      mapPercentToKeyframes: c,
      calculatedDuration: d,
      resolvedDuration: f,
      totalDuration: p
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: S } = this.options;
      return { done: !0, value: S[S.length - 1] };
    }
    const { finalKeyframe: i, generator: s, mirroredGenerator: o, mapPercentToKeyframes: a, keyframes: c, calculatedDuration: l, totalDuration: u, resolvedDuration: d } = r;
    if (this.startTime === null)
      return s.next(0);
    const { delay: f, repeat: p, repeatType: m, repeatDelay: h, onUpdate: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - u / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const y = this.currentTime - f * (this.speed >= 0 ? 1 : -1), v = this.speed >= 0 ? y < 0 : y > u;
    this.currentTime = Math.max(y, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let b = this.currentTime, w = s;
    if (p) {
      const S = Math.min(this.currentTime, u) / d;
      let P = Math.floor(S), I = S % 1;
      !I && S >= 1 && (I = 1), I === 1 && P--, P = Math.min(P, p + 1), !!(P % 2) && (m === "reverse" ? (I = 1 - I, h && (I -= h / d)) : m === "mirror" && (w = o)), b = iu(0, 1, I) * d;
    }
    const A = v ? { done: !1, value: c[0] } : w.next(b);
    a && (A.value = a(A.value));
    let { done: E } = A;
    !v && l !== null && (E = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const x = this.holdTime === null && (this.state === "finished" || this.state === "running" && E);
    return x && i !== void 0 && (A.value = dE(c, this.options, i)), g && g(A.value), x && this.finish(), A;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? mc(t.calculatedDuration) : 0;
  }
  get time() {
    return mc(this.currentTime);
  }
  set time(t) {
    t = Wl(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = mc(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = Gve, onPlay: n } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), n && n();
    const r = this.driver.now();
    this.holdTime !== null ? this.startTime = r - this.holdTime : (!this.startTime || this.state === "finished") && (this.startTime = r), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const pV = (e) => Array.isArray(e) && typeof e[0] == "number";
function mV(e) {
  return !!(!e || typeof e == "string" && e in C4 || pV(e) || Array.isArray(e) && e.every(mV));
}
const q0 = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, C4 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: q0([0, 0.65, 0.55, 1]),
  circOut: q0([0.55, 0, 1, 0.45]),
  backIn: q0([0.31, 0.01, 0.66, -0.59]),
  backOut: q0([0.33, 1.53, 0.69, 0.99])
};
function Qve(e) {
  return gV(e) || C4.easeOut;
}
function gV(e) {
  if (e)
    return pV(e) ? q0(e) : Array.isArray(e) ? e.map(Qve) : C4[e];
}
function Kve(e, t, n, { delay: r = 0, duration: i = 300, repeat: s = 0, repeatType: o = "loop", ease: a, times: c } = {}) {
  const l = { [t]: n };
  c && (l.offset = c);
  const u = gV(a);
  return Array.isArray(u) && (l.easing = u), e.animate(l, {
    delay: r,
    duration: i,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: s + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const Yve = tV(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Zve = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), Qx = 10, Jve = 2e4;
function Xve(e) {
  return e.type === "spring" || e.name === "backgroundColor" || !mV(e.ease);
}
function e1e(e, t) {
  const n = new S4({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const i = [];
  let s = 0;
  for (; !r.done && s < Jve; )
    r = n.sample(s), i.push(r.value), s += Qx;
  return {
    times: void 0,
    keyframes: i,
    duration: s - Qx,
    ease: "linear"
  };
}
class qO extends nV {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, keyframes: i } = this.options;
    this.resolver = new eV(i, (s, o) => this.onKeyframesResolved(s, o), n, r), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    var r;
    let { duration: i = 300, times: s, ease: o, type: a, motionValue: c, name: l } = this.options;
    if (!(!((r = c.owner) === null || r === void 0) && r.current))
      return !1;
    if (Xve(this.options)) {
      const { onComplete: d, onUpdate: f, motionValue: p, ...m } = this.options, h = e1e(t, m);
      t = h.keyframes, t.length === 1 && (t[1] = t[0]), i = h.duration, s = h.times, o = h.ease, a = "keyframes";
    }
    const u = Kve(c.owner.current, l, t, { ...this.options, duration: i, times: s, ease: o });
    return u.startTime = Gl.now(), this.pendingTimeline ? (u.timeline = this.pendingTimeline, this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: d } = this.options;
      c.set(dE(t, this.options, n)), d && d(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: i,
      times: s,
      type: a,
      ease: o,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return mc(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return mc(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = Wl(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return Gr;
      const { animation: r } = n;
      r.timeline = t, r.onfinish = null;
    }
    return Gr;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: i, type: s, ease: o, times: a } = t;
    if (!(n.playState === "idle" || n.playState === "finished")) {
      if (this.time) {
        const { motionValue: c, onUpdate: l, onComplete: u, ...d } = this.options, f = new S4({
          ...d,
          keyframes: r,
          duration: i,
          type: s,
          ease: o,
          times: a,
          isGenerator: !0
        }), p = Wl(this.time);
        c.setWithVelocity(f.sample(p - Qx).value, f.sample(p).value, Qx);
      }
      this.cancel();
    }
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: i, repeatType: s, damping: o, type: a } = t;
    return Yve() && r && Zve.has(r) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !i && s !== "mirror" && o !== 0 && a !== "inertia";
  }
}
function t1e(e, t) {
  let n;
  const r = () => {
    const { currentTime: i } = t, o = (i === null ? 0 : i.value) / 100;
    n !== o && e(o), n = o;
  };
  return on.update(r, !0), () => _c(r);
}
const n1e = tV(() => window.ScrollTimeline !== void 0);
class r1e {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t) {
    const n = this.animations.map((r) => {
      if (n1e() && r.attachTimeline)
        r.attachTimeline(t);
      else
        return r.pause(), t1e((i) => {
          r.time = r.duration * i;
        }, t);
    });
    return () => {
      n.forEach((r, i) => {
        r && r(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
const T4 = (e, t, n, r = {}, i, s) => (o) => {
  const a = b4(r, e) || {}, c = a.delay || r.delay || 0;
  let { elapsed: l = 0 } = r;
  l = l - Wl(c);
  let u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -l,
    onUpdate: (f) => {
      t.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: s ? void 0 : i
  };
  Fbe(a) || (u = {
    ...u,
    ...Mbe(e, u)
  }), u.duration && (u.duration = Wl(u.duration)), u.repeatDelay && (u.repeatDelay = Wl(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let d = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (d = !0)), d && !s && t.get() !== void 0) {
    const f = dE(u.keyframes, a);
    if (f !== void 0)
      return on.update(() => {
        u.onUpdate(f), u.onComplete();
      }), new r1e([]);
  }
  return !s && qO.supports(u) ? new qO(u) : new S4(u);
};
function Kx(e) {
  return !!(Hr(e) && e.add);
}
function k4(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function B4(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class I4 {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return k4(this.subscriptions, t), () => B4(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let s = 0; s < i; s++) {
          const o = this.subscriptions[s];
          o && o(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const $O = 30, i1e = (e) => !isNaN(parseFloat(e));
class s1e {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "11.2.10", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      const s = Gl.now();
      this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Gl.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = i1e(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new I4());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), on.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Gl.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > $O)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, $O);
    return rV(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Sy(e, t) {
  return new s1e(e, t);
}
function o1e(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Sy(n));
}
function a1e(e, t) {
  const n = uE(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...s } = n || {};
  s = { ...s, ...r };
  for (const o in s) {
    const a = fbe(s[o]);
    o1e(e, o, a);
  }
}
function yV(e) {
  return e.getProps()[bz];
}
function c1e({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function bV(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  var s;
  let { transition: o = e.getDefaultTransition(), transitionEnd: a, ...c } = t;
  const l = e.getValue("willChange");
  r && (o = r);
  const u = [], d = i && e.animationState && e.animationState.getState()[i];
  for (const f in c) {
    const p = e.getValue(f, (s = e.latestValues[f]) !== null && s !== void 0 ? s : null), m = c[f];
    if (m === void 0 || d && c1e(d, f))
      continue;
    const h = {
      delay: n,
      elapsed: 0,
      ...b4(o || {}, f)
    };
    let g = !1;
    if (window.HandoffAppearAnimations) {
      const v = yV(e);
      if (v) {
        const b = window.HandoffAppearAnimations(v, f, p, on);
        b !== null && (h.elapsed = b, g = !0);
      }
    }
    p.start(T4(f, p, m, e.shouldReduceMotion && Bf.has(f) ? { type: !1 } : h, e, g));
    const y = p.animation;
    y && (Kx(l) && (l.add(f), y.then(() => l.remove(f))), u.push(y));
  }
  return a && Promise.all(u).then(() => {
    on.update(() => {
      a && a1e(e, a);
    });
  }), u;
}
function mC(e, t, n = {}) {
  var r;
  const i = uE(e, t, n.type === "exit" ? (r = e.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: s = e.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (s = n.transitionOverride);
  const o = i ? () => Promise.all(bV(e, i, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (l = 0) => {
    const { delayChildren: u = 0, staggerChildren: d, staggerDirection: f } = s;
    return l1e(e, t, u + l, d, f, n);
  } : () => Promise.resolve(), { when: c } = s;
  if (c) {
    const [l, u] = c === "beforeChildren" ? [o, a] : [a, o];
    return l().then(() => u());
  } else
    return Promise.all([o(), a(n.delay)]);
}
function l1e(e, t, n = 0, r = 0, i = 1, s) {
  const o = [], a = (e.variantChildren.size - 1) * r, c = i === 1 ? (l = 0) => l * r : (l = 0) => a - l * r;
  return Array.from(e.variantChildren).sort(u1e).forEach((l, u) => {
    l.notify("AnimationStart", t), o.push(mC(l, t, {
      ...s,
      delay: n + c(u)
    }).then(() => l.notify("AnimationComplete", t)));
  }), Promise.all(o);
}
function u1e(e, t) {
  return e.sortNodePosition(t);
}
function d1e(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((s) => mC(e, s, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = mC(e, t, n);
  else {
    const i = typeof t == "function" ? uE(e, t, n.custom) : t;
    r = Promise.all(bV(e, i, n));
  }
  return r.then(() => {
    on.postRender(() => {
      e.notify("AnimationComplete", t);
    });
  });
}
const f1e = [...o4].reverse(), h1e = o4.length;
function p1e(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => d1e(e, n, r)));
}
function m1e(e) {
  let t = p1e(e);
  const n = y1e();
  let r = !0;
  const i = (c) => (l, u) => {
    var d;
    const f = uE(e, u, c === "exit" ? (d = e.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (f) {
      const { transition: p, transitionEnd: m, ...h } = f;
      l = { ...l, ...h, ...m };
    }
    return l;
  };
  function s(c) {
    t = c(e);
  }
  function o(c) {
    const l = e.getProps(), u = e.getVariantContext(!0) || {}, d = [], f = /* @__PURE__ */ new Set();
    let p = {}, m = 1 / 0;
    for (let g = 0; g < h1e; g++) {
      const y = f1e[g], v = n[y], b = l[y] !== void 0 ? l[y] : u[y], w = xy(b), A = y === c ? v.isActive : null;
      A === !1 && (m = g);
      let E = b === u[y] && b !== l[y] && w;
      if (E && r && e.manuallyAnimateOnMount && (E = !1), v.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !v.isActive && A === null || // If we didn't and don't have any defined prop for this animation type
      !b && !v.prevProp || // Or if the prop doesn't define an animation
      aE(b) || typeof b == "boolean")
        continue;
      let S = g1e(v.prevProp, b) || // If we're making this variant active, we want to always make it active
      y === c && v.isActive && !E && w || // If we removed a higher-priority variant (i is in reverse order)
      g > m && w, P = !1;
      const I = Array.isArray(b) ? b : [b];
      let R = I.reduce(i(y), {});
      A === !1 && (R = {});
      const { prevResolvedValues: Q = {} } = v, J = {
        ...Q,
        ...R
      }, we = (V) => {
        S = !0, f.has(V) && (P = !0, f.delete(V)), v.needsAnimating[V] = !0;
        const L = e.getValue(V);
        L && (L.liveStyle = !1);
      };
      for (const V in J) {
        const L = R[V], U = Q[V];
        if (p.hasOwnProperty(V))
          continue;
        let q = !1;
        oC(L) && oC(U) ? q = !Lz(L, U) : q = L !== U, q ? L != null ? we(V) : f.add(V) : L !== void 0 && f.has(V) ? we(V) : v.protectedKeys[V] = !0;
      }
      v.prevProp = b, v.prevResolvedValues = R, v.isActive && (p = { ...p, ...R }), r && e.blockInitialAnimation && (S = !1), S && (!E || P) && d.push(...I.map((V) => ({
        animation: V,
        options: { type: y }
      })));
    }
    if (f.size) {
      const g = {};
      f.forEach((y) => {
        const v = e.getBaseTarget(y), b = e.getValue(y);
        b && (b.liveStyle = !0), g[y] = v ?? null;
      }), d.push({ animation: g });
    }
    let h = !!d.length;
    return r && (l.initial === !1 || l.initial === l.animate) && !e.manuallyAnimateOnMount && (h = !1), r = !1, h ? t(d) : Promise.resolve();
  }
  function a(c, l) {
    var u;
    if (n[c].isActive === l)
      return Promise.resolve();
    (u = e.variantChildren) === null || u === void 0 || u.forEach((f) => {
      var p;
      return (p = f.animationState) === null || p === void 0 ? void 0 : p.setActive(c, l);
    }), n[c].isActive = l;
    const d = o(c);
    for (const f in n)
      n[f].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: o,
    setActive: a,
    setAnimateFunction: s,
    getState: () => n
  };
}
function g1e(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Lz(t, e) : !1;
}
function ku(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function y1e() {
  return {
    animate: ku(!0),
    whileInView: ku(),
    whileHover: ku(),
    whileTap: ku(),
    whileDrag: ku(),
    whileFocus: ku(),
    exit: ku()
  };
}
class b1e extends bu {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = m1e(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), aE(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let v1e = 0;
class w1e extends bu {
  constructor() {
    super(...arguments), this.id = v1e++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const x1e = {
  animation: {
    Feature: b1e
  },
  exit: {
    Feature: w1e
  }
}, QO = (e, t) => Math.abs(e - t);
function A1e(e, t) {
  const n = QO(e.x, t.x), r = QO(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class vV {
  constructor(t, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: s = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = O_(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, p = A1e(d.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !p)
        return;
      const { point: m } = d, { timestamp: h } = Ar;
      this.history.push({ ...m, timestamp: h });
      const { onStart: g, onMove: y } = this.handlers;
      f || (g && g(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), y && y(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, f) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = P_(f, this.transformPagePoint), on.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, f) => {
      this.end();
      const { onEnd: p, onSessionEnd: m, resumeAnimation: h } = this.handlers;
      if (this.dragSnapToOrigin && h && h(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = O_(d.type === "pointercancel" ? this.lastMoveEventInfo : P_(f, this.transformPagePoint), this.history);
      this.startEvent && p && p(d, g), m && m(d, g);
    }, !Mz(t))
      return;
    this.dragSnapToOrigin = s, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const o = lE(t), a = P_(o, this.transformPagePoint), { point: c } = a, { timestamp: l } = Ar;
    this.history = [{ ...c, timestamp: l }];
    const { onSessionStart: u } = n;
    u && u(t, O_(a, this.history)), this.removeListeners = pc(hc(this.contextWindow, "pointermove", this.handlePointerMove), hc(this.contextWindow, "pointerup", this.handlePointerUp), hc(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), _c(this.updatePoint);
  }
}
function P_(e, t) {
  return t ? { point: t(e.point) } : e;
}
function KO(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function O_({ point: e }, t) {
  return {
    point: e,
    delta: KO(e, wV(t)),
    offset: KO(e, E1e(t)),
    velocity: _1e(t, 0.1)
  };
}
function E1e(e) {
  return e[0];
}
function wV(e) {
  return e[e.length - 1];
}
function _1e(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = wV(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > Wl(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const s = mc(i.timestamp - r.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / s,
    y: (i.y - r.y) / s
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function es(e) {
  return e.max - e.min;
}
function gC(e, t = 0, n = 0.01) {
  return Math.abs(e - t) <= n;
}
function YO(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Tn(t.min, t.max, e.origin), e.scale = es(n) / es(t), (gC(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Tn(n.min, n.max, e.origin) - e.originPoint, (gC(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function xg(e, t, n, r) {
  YO(e.x, t.x, n.x, r ? r.originX : void 0), YO(e.y, t.y, n.y, r ? r.originY : void 0);
}
function ZO(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + es(t);
}
function S1e(e, t, n) {
  ZO(e.x, t.x, n.x), ZO(e.y, t.y, n.y);
}
function JO(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + es(t);
}
function Ag(e, t, n) {
  JO(e.x, t.x, n.x), JO(e.y, t.y, n.y);
}
function C1e(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Tn(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Tn(n, e, r.max) : Math.min(e, n)), e;
}
function XO(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function T1e(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: XO(e.x, n, i),
    y: XO(e.y, t, r)
  };
}
function e7(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function k1e(e, t) {
  return {
    x: e7(e.x, t.x),
    y: e7(e.y, t.y)
  };
}
function B1e(e, t) {
  let n = 0.5;
  const r = es(e), i = es(t);
  return i > r ? n = _y(t.min, t.max - r, e.min) : r > i && (n = _y(e.min, e.max - i, t.min)), iu(0, 1, n);
}
function I1e(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const yC = 0.35;
function P1e(e = yC) {
  return e === !1 ? e = 0 : e === !0 && (e = yC), {
    x: t7(e, "left", "right"),
    y: t7(e, "top", "bottom")
  };
}
function t7(e, t, n) {
  return {
    min: n7(e, t),
    max: n7(e, n)
  };
}
function n7(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const r7 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Sh = () => ({
  x: r7(),
  y: r7()
}), i7 = () => ({ min: 0, max: 0 }), Fn = () => ({
  x: i7(),
  y: i7()
});
function ls(e) {
  return [e("x"), e("y")];
}
function xV({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function O1e({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function N1e(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function N_(e) {
  return e === void 0 || e === 1;
}
function bC({ scale: e, scaleX: t, scaleY: n }) {
  return !N_(e) || !N_(t) || !N_(n);
}
function Bu(e) {
  return bC(e) || AV(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function AV(e) {
  return s7(e.x) || s7(e.y);
}
function s7(e) {
  return e && e !== "0%";
}
function Yx(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function o7(e, t, n, r, i) {
  return i !== void 0 && (e = Yx(e, i, r)), Yx(e, n, r) + t;
}
function vC(e, t = 0, n = 1, r, i) {
  e.min = o7(e.min, t, n, r, i), e.max = o7(e.max, t, n, r, i);
}
function EV(e, { x: t, y: n }) {
  vC(e.x, t.translate, t.scale, t.originPoint), vC(e.y, n.translate, n.scale, n.originPoint);
}
function R1e(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let s, o;
  for (let a = 0; a < i; a++) {
    s = n[a], o = s.projectionDelta;
    const c = s.instance;
    c && c.style && c.style.display === "contents" || (r && s.options.layoutScroll && s.scroll && s !== s.root && Ch(e, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), o && (t.x *= o.x.scale, t.y *= o.y.scale, EV(e, o)), r && Bu(s.latestValues) && Ch(e, s.latestValues));
  }
  t.x = a7(t.x), t.y = a7(t.y);
}
function a7(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function sl(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function c7(e, t, [n, r, i]) {
  const s = t[i] !== void 0 ? t[i] : 0.5, o = Tn(e.min, e.max, s);
  vC(e, t[n], t[r], o, t.scale);
}
const M1e = ["x", "scaleX", "originX"], F1e = ["y", "scaleY", "originY"];
function Ch(e, t) {
  c7(e.x, t, M1e), c7(e.y, t, F1e);
}
function _V(e, t) {
  return xV(N1e(e.getBoundingClientRect(), t));
}
function j1e(e, t, n) {
  const r = _V(e, n), { scroll: i } = t;
  return i && (sl(r.x, i.offset.x), sl(r.y, i.offset.y)), r;
}
const SV = ({ current: e }) => e ? e.ownerDocument.defaultView : null, D1e = /* @__PURE__ */ new WeakMap();
class U1e {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Fn(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (u) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(lE(u, "page").point);
    }, s = (u, d) => {
      const { drag: f, dragPropagation: p, onDragStart: m } = this.getProps();
      if (f && !p && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = jz(f), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ls((g) => {
        let y = this.getAxisMotionValue(g).get() || 0;
        if (ha.test(y)) {
          const { projection: v } = this.visualElement;
          if (v && v.layout) {
            const b = v.layout.layoutBox[g];
            b && (y = es(b) * (parseFloat(y) / 100));
          }
        }
        this.originPoint[g] = y;
      }), m && on.postRender(() => m(u, d));
      const { animationState: h } = this.visualElement;
      h && h.setActive("whileDrag", !0);
    }, o = (u, d) => {
      const { dragPropagation: f, dragDirectionLock: p, onDirectionLock: m, onDrag: h } = this.getProps();
      if (!f && !this.openGlobalLock)
        return;
      const { offset: g } = d;
      if (p && this.currentDirection === null) {
        this.currentDirection = L1e(g), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, g), this.updateAxis("y", d.point, g), this.visualElement.render(), h && h(u, d);
    }, a = (u, d) => this.stop(u, d), c = () => ls((u) => {
      var d;
      return this.getAnimationState(u) === "paused" && ((d = this.getAxisMotionValue(u).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: l } = this.getProps();
    this.panSession = new vV(t, {
      onSessionStart: i,
      onStart: s,
      onMove: o,
      onSessionEnd: a,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: l,
      contextWindow: SV(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: s } = this.getProps();
    s && on.postRender(() => s(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !h1(t, i, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (o = C1e(o, this.constraints[t], this.elastic[t])), s.set(o);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, s = this.constraints;
    n && Eh(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = T1e(i.layoutBox, n) : this.constraints = !1, this.elastic = P1e(r), s !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && ls((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = I1e(i.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Eh(t))
      return !1;
    const r = t.current, { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const s = j1e(r, i.root, this.visualElement.getTransformPagePoint());
    let o = k1e(i.layout.layoutBox, s);
    if (n) {
      const a = n(O1e(o));
      this.hasMutatedConstraints = !!a, a && (o = xV(a));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: s, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), c = this.constraints || {}, l = ls((u) => {
      if (!h1(u, n, this.currentDirection))
        return;
      let d = c && c[u] || {};
      o && (d = { min: 0, max: 0 });
      const f = i ? 200 : 1e6, p = i ? 40 : 1e7, m = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: f,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...d
      };
      return this.startAxisValueAnimation(u, m);
    });
    return Promise.all(l).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return r.start(T4(t, r, 0, n, this.visualElement));
  }
  stopAnimation() {
    ls((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    ls((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    ls((n) => {
      const { drag: r } = this.getProps();
      if (!h1(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, s = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: o, max: a } = i.layout.layoutBox[n];
        s.set(t[n] - Tn(o, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Eh(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    ls((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const c = a.get();
        i[o] = B1e({ min: c, max: c }, this.constraints[o]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ls((o) => {
      if (!h1(o, t, null))
        return;
      const a = this.getAxisMotionValue(o), { min: c, max: l } = this.constraints[o];
      a.set(Tn(c, l, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    D1e.set(this.visualElement, this);
    const t = this.visualElement.current, n = hc(t, "pointerdown", (c) => {
      const { drag: l, dragListener: u = !0 } = this.getProps();
      l && u && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      Eh(c) && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, s = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), r();
    const o = oc(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: l }) => {
      this.isDragging && l && (ls((u) => {
        const d = this.getAxisMotionValue(u);
        d && (this.originPoint[u] += c[u].translate, d.set(d.get() + c[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), s(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: s = !1, dragElastic: o = yC, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: s,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function h1(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function L1e(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class z1e extends bu {
  constructor(t) {
    super(t), this.removeGroupControls = Gr, this.removeListeners = Gr, this.controls = new U1e(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Gr;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const l7 = (e) => (t, n) => {
  e && on.postRender(() => e(t, n));
};
class V1e extends bu {
  constructor() {
    super(...arguments), this.removePointerDownListener = Gr;
  }
  onPointerDown(t) {
    this.session = new vV(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: SV(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: l7(t),
      onStart: l7(n),
      onMove: r,
      onEnd: (s, o) => {
        delete this.session, i && on.postRender(() => i(s, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = hc(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function CV() {
  const e = $e(mv);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, i = mu();
  return We(() => r(i), []), !t && n ? [!1, () => n && n(i)] : [!0];
}
function H1e() {
  return W1e($e(mv));
}
function W1e(e) {
  return e === null ? !0 : e.isPresent;
}
const kw = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function u7(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const x0 = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ut.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = u7(e, t.target.x), r = u7(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, G1e = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = su.parse(e);
    if (i.length > 5)
      return r;
    const s = su.createTransformer(e), o = typeof i[0] != "number" ? 1 : 0, a = n.x.scale * t.x, c = n.y.scale * t.y;
    i[0 + o] /= a, i[1 + o] /= c;
    const l = Tn(a, c, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= l), typeof i[3 + o] == "number" && (i[3 + o] /= l), s(i);
  }
};
class q1e extends dZ {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: s } = t;
    Vye($1e), s && (n.group && n.group.add(s), r && r.register && i && r.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      onExitComplete: () => this.safeToRemove()
    })), kw.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: s } = this.props, o = r.projection;
    return o && (o.isPresent = s, i || t.layoutDependency !== n || n === void 0 ? o.willUpdate() : this.safeToRemove(), t.isPresent !== s && (s ? o.promote() : o.relegate() || on.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), s4.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function TV(e) {
  const [t, n] = CV(), r = $e(c4);
  return D.jsx(q1e, { ...e, layoutGroup: r, switchLayoutGroup: $e(xz), isPresent: t, safeToRemove: n });
}
const $1e = {
  borderRadius: {
    ...x0,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: x0,
  borderTopRightRadius: x0,
  borderBottomLeftRadius: x0,
  borderBottomRightRadius: x0,
  boxShadow: G1e
}, kV = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Q1e = kV.length, d7 = (e) => typeof e == "string" ? parseFloat(e) : e, f7 = (e) => typeof e == "number" || ut.test(e);
function K1e(e, t, n, r, i, s) {
  i ? (e.opacity = Tn(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    Y1e(r)
  ), e.opacityExit = Tn(t.opacity !== void 0 ? t.opacity : 1, 0, Z1e(r))) : s && (e.opacity = Tn(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let o = 0; o < Q1e; o++) {
    const a = `border${kV[o]}Radius`;
    let c = h7(t, a), l = h7(n, a);
    if (c === void 0 && l === void 0)
      continue;
    c || (c = 0), l || (l = 0), c === 0 || l === 0 || f7(c) === f7(l) ? (e[a] = Math.max(Tn(d7(c), d7(l), r), 0), (ha.test(l) || ha.test(c)) && (e[a] += "%")) : e[a] = l;
  }
  (t.rotate || n.rotate) && (e.rotate = Tn(t.rotate || 0, n.rotate || 0, r));
}
function h7(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const Y1e = BV(0, 0.5, uV), Z1e = BV(0.5, 0.95, Gr);
function BV(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(_y(e, t, r));
}
function p7(e, t) {
  e.min = t.min, e.max = t.max;
}
function os(e, t) {
  p7(e.x, t.x), p7(e.y, t.y);
}
function m7(e, t, n, r, i) {
  return e -= t, e = Yx(e, 1 / n, r), i !== void 0 && (e = Yx(e, 1 / i, r)), e;
}
function J1e(e, t = 0, n = 1, r = 0.5, i, s = e, o = e) {
  if (ha.test(t) && (t = parseFloat(t), t = Tn(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let a = Tn(s.min, s.max, r);
  e === s && (a -= t), e.min = m7(e.min, t, n, a, i), e.max = m7(e.max, t, n, a, i);
}
function g7(e, t, [n, r, i], s, o) {
  J1e(e, t[n], t[r], t[i], t.scale, s, o);
}
const X1e = ["x", "scaleX", "originX"], ewe = ["y", "scaleY", "originY"];
function y7(e, t, n, r) {
  g7(e.x, t, X1e, n ? n.x : void 0, r ? r.x : void 0), g7(e.y, t, ewe, n ? n.y : void 0, r ? r.y : void 0);
}
function b7(e) {
  return e.translate === 0 && e.scale === 1;
}
function IV(e) {
  return b7(e.x) && b7(e.y);
}
function twe(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function PV(e, t) {
  return Math.round(e.x.min) === Math.round(t.x.min) && Math.round(e.x.max) === Math.round(t.x.max) && Math.round(e.y.min) === Math.round(t.y.min) && Math.round(e.y.max) === Math.round(t.y.max);
}
function v7(e) {
  return es(e.x) / es(e.y);
}
class nwe {
  constructor() {
    this.members = [];
  }
  add(t) {
    k4(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (B4(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((i) => t === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const s = this.members[i];
      if (s.isPresent !== !1) {
        r = s;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: i } = t.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function w7(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, s = e.y.translate / t.y, o = (n == null ? void 0 : n.z) || 0;
  if ((i || s || o) && (r = `translate3d(${i}px, ${s}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: l, rotate: u, rotateX: d, rotateY: f, skewX: p, skewY: m } = n;
    l && (r = `perspective(${l}px) ${r}`), u && (r += `rotate(${u}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `), p && (r += `skewX(${p}deg) `), m && (r += `skewY(${m}deg) `);
  }
  const a = e.x.scale * t.x, c = e.y.scale * t.y;
  return (a !== 1 || c !== 1) && (r += `scale(${a}, ${c})`), r || "none";
}
const rwe = (e, t) => e.depth - t.depth;
class iwe {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    k4(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    B4(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(rwe), this.isDirty = !1, this.children.forEach(t);
  }
}
function swe(e, t) {
  const n = Gl.now(), r = ({ timestamp: i }) => {
    const s = i - n;
    s >= t && (_c(r), e(s - t));
  };
  return on.read(r, !0), () => _c(r);
}
function owe(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function awe(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function cwe(e, t, n) {
  const r = Hr(e) ? e : Sy(e);
  return r.start(T4("", r, t, n)), r.animation;
}
const R_ = ["", "X", "Y", "Z"], lwe = { visibility: "hidden" }, x7 = 1e3;
let uwe = 0;
const Iu = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function M_(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function OV(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return !1;
  const { visualElement: t } = e.options;
  return t ? yV(t) ? !0 : e.parent && !e.parent.hasCheckedOptimisedAppear ? OV(e.parent) : !1 : !1;
}
function NV({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(o = {}, a = t == null ? void 0 : t()) {
      this.id = uwe++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Iu.totalNodes = Iu.resolvedTargetDeltas = Iu.recalculatedProjection = 0, this.nodes.forEach(hwe), this.nodes.forEach(bwe), this.nodes.forEach(vwe), this.nodes.forEach(pwe), owe(Iu);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new iwe());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new I4()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const c = this.eventHandlers.get(o);
      c && c.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = awe(o), this.instance = o;
      const { layoutId: c, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (l || c) && (this.isLayoutDirty = !0), e) {
        let d;
        const f = () => this.root.updateBlockedByResize = !1;
        e(o, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = swe(f, 250), kw.hasAnimatedSinceResize && (kw.hasAnimatedSinceResize = !1, this.nodes.forEach(E7));
        });
      }
      c && this.root.registerSharedNode(c, this), this.options.animate !== !1 && u && (c || l) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: f, hasRelativeTargetChanged: p, layout: m }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const h = this.options.transition || u.getDefaultTransition() || _we, { onLayoutAnimationStart: g, onLayoutAnimationComplete: y } = u.getProps(), v = !this.targetLayout || !PV(this.targetLayout, m) || p, b = !f && p;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || b || f && (v || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, b);
          const w = {
            ...b4(h, "layout"),
            onPlay: g,
            onComplete: y
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (w.delay = 0, w.type = !1), this.startAnimation(w);
        } else
          f || E7(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = m;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, _c(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(wwe), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.HandoffCancelAllAnimations && OV(this) && window.HandoffCancelAllAnimations(), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: c } = this.options;
      if (a === void 0 && !c)
        return;
      const l = this.getTransformTemplate();
      this.prevTransformTemplateValue = l ? l(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(A7);
        return;
      }
      this.isUpdating || this.nodes.forEach(gwe), this.isUpdating = !1, this.nodes.forEach(ywe), this.nodes.forEach(dwe), this.nodes.forEach(fwe), this.clearAllSnapshots();
      const a = Gl.now();
      Ar.delta = iu(0, 1e3 / 60, a - Ar.timestamp), Ar.timestamp = a, Ar.isProcessing = !0, __.update.process(Ar), __.preRender.process(Ar), __.render.process(Ar), Ar.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, s4.read(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(mwe), this.sharedNodes.forEach(xwe);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, on.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      on.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Fn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && (this.scroll = {
        animationId: this.root.animationId,
        phase: o,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform, a = this.projectionDelta && !IV(this.projectionDelta), c = this.getTransformTemplate(), l = c ? c(this.latestValues, "") : void 0, u = l !== this.prevTransformTemplateValue;
      o && (a || Bu(this.latestValues) || u) && (i(this.instance, l), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let c = this.removeElementScroll(a);
      return o && (c = this.removeTransform(c)), Swe(c), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: o } = this.options;
      if (!o)
        return Fn();
      const a = o.measureViewportBox(), { scroll: c } = this.root;
      return c && (sl(a.x, c.offset.x), sl(a.y, c.offset.y)), a;
    }
    removeElementScroll(o) {
      const a = Fn();
      os(a, o);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c], { scroll: u, options: d } = l;
        if (l !== this.root && u && d.layoutScroll) {
          if (u.isRoot) {
            os(a, o);
            const { scroll: f } = this.root;
            f && (sl(a.x, -f.offset.x), sl(a.y, -f.offset.y));
          }
          sl(a.x, u.offset.x), sl(a.y, u.offset.y);
        }
      }
      return a;
    }
    applyTransform(o, a = !1) {
      const c = Fn();
      os(c, o);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        !a && u.options.layoutScroll && u.scroll && u !== u.root && Ch(c, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), Bu(u.latestValues) && Ch(c, u.latestValues);
      }
      return Bu(this.latestValues) && Ch(c, this.latestValues), c;
    }
    removeTransform(o) {
      const a = Fn();
      os(a, o);
      for (let c = 0; c < this.path.length; c++) {
        const l = this.path[c];
        if (!l.instance || !Bu(l.latestValues))
          continue;
        bC(l.latestValues) && l.updateSnapshot();
        const u = Fn(), d = l.measurePageBox();
        os(u, d), y7(a, l.latestValues, l.snapshot ? l.snapshot.layoutBox : void 0, u);
      }
      return Bu(this.latestValues) && y7(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Ar.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var a;
      const c = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = c.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = c.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = c.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== c;
      if (!(o || l && this.isSharedProjectionDirty || this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: d, layoutId: f } = this.options;
      if (!(!this.layout || !(d || f))) {
        if (this.resolvedRelativeTargetAt = Ar.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Fn(), this.relativeTargetOrigin = Fn(), Ag(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), os(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Fn(), this.targetWithTransforms = Fn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), S1e(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : os(this.target, this.layout.layoutBox), EV(this.target, this.targetDelta)) : os(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const p = this.getClosestProjectingParent();
            p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Fn(), this.relativeTargetOrigin = Fn(), Ag(this.relativeTargetOrigin, this.target, p.target), os(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Iu.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || bC(this.parent.latestValues) || AV(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var o;
      const a = this.getLead(), c = !!this.resumingFrom || this !== a;
      let l = !0;
      if ((this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty) && (l = !1), c && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === Ar.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d))
        return;
      os(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, p = this.treeScale.y;
      R1e(this.layoutCorrected, this.treeScale, this.path, c), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = Fn());
      const { target: m } = a;
      if (!m) {
        this.projectionTransform && (this.projectionDelta = Sh(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = Sh(), this.projectionDeltaWithTransform = Sh());
      const h = this.projectionTransform;
      xg(this.projectionDelta, this.layoutCorrected, m, this.latestValues), this.projectionTransform = w7(this.projectionDelta, this.treeScale), (this.projectionTransform !== h || this.treeScale.x !== f || this.treeScale.y !== p) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", m)), Iu.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), o) {
        const a = this.getStack();
        a && a.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(o, a = !1) {
      const c = this.snapshot, l = c ? c.latestValues : {}, u = { ...this.latestValues }, d = Sh();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = Fn(), p = c ? c.source : void 0, m = this.layout ? this.layout.source : void 0, h = p !== m, g = this.getStack(), y = !g || g.members.length <= 1, v = !!(h && !y && this.options.crossfade === !0 && !this.path.some(Ewe));
      this.animationProgress = 0;
      let b;
      this.mixTargetDelta = (w) => {
        const A = w / 1e3;
        _7(d.x, o.x, A), _7(d.y, o.y, A), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Ag(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Awe(this.relativeTarget, this.relativeTargetOrigin, f, A), b && twe(this.relativeTarget, b) && (this.isProjectionDirty = !1), b || (b = Fn()), os(b, this.relativeTarget)), h && (this.animationValues = u, K1e(u, l, this.latestValues, A, v, y)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = A;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (_c(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = on.update(() => {
        kw.hasAnimatedSinceResize = !0, this.currentAnimation = cwe(0, x7, {
          ...o,
          onUpdate: (a) => {
            this.mixTargetDelta(a), o.onUpdate && o.onUpdate(a);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(x7), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: c, layout: l, latestValues: u } = o;
      if (!(!a || !c || !l)) {
        if (this !== o && this.layout && l && RV(this.options.animationType, this.layout.layoutBox, l.layoutBox)) {
          c = this.target || Fn();
          const d = es(this.layout.layoutBox.x);
          c.x.min = o.target.x.min, c.x.max = c.x.min + d;
          const f = es(this.layout.layoutBox.y);
          c.y.min = o.target.y.min, c.y.max = c.y.min + f;
        }
        os(a, c), Ch(a, u), xg(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new nwe()), this.sharedNodes.get(o).add(a);
      const l = a.options.initialPromotionConfig;
      a.promote({
        transition: l ? l.transition : void 0,
        preserveFollowOpacity: l && l.shouldPreserveFollowOpacity ? l.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var o;
      const { layoutId: a } = this.options;
      return a ? ((o = this.getStack()) === null || o === void 0 ? void 0 : o.lead) || this : this;
    }
    getPrevLead() {
      var o;
      const { layoutId: a } = this.options;
      return a ? (o = this.getStack()) === null || o === void 0 ? void 0 : o.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: c } = {}) {
      const l = this.getStack();
      l && l.promote(this, c), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: c } = o;
      if ((c.z || c.rotate || c.rotateX || c.rotateY || c.rotateZ || c.skewX || c.skewY) && (a = !0), !a)
        return;
      const l = {};
      c.z && M_("z", o, l, this.animationValues);
      for (let u = 0; u < R_.length; u++)
        M_(`rotate${R_[u]}`, o, l, this.animationValues), M_(`skew${R_[u]}`, o, l, this.animationValues);
      o.render();
      for (const u in l)
        o.setStaticValue(u, l[u]), this.animationValues && (this.animationValues[u] = l[u]);
      o.scheduleRender();
    }
    getProjectionStyles(o) {
      var a, c;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return lwe;
      const l = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, l.opacity = "", l.pointerEvents = Cw(o == null ? void 0 : o.pointerEvents) || "", l.transform = u ? u(this.latestValues, "") : "none", l;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const h = {};
        return this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = Cw(o == null ? void 0 : o.pointerEvents) || ""), this.hasProjected && !Bu(this.latestValues) && (h.transform = u ? u({}, "") : "none", this.hasProjected = !1), h;
      }
      const f = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), l.transform = w7(this.projectionDeltaWithTransform, this.treeScale, f), u && (l.transform = u(f, l.transform));
      const { x: p, y: m } = this.projectionDelta;
      l.transformOrigin = `${p.origin * 100}% ${m.origin * 100}% 0`, d.animationValues ? l.opacity = d === this ? (c = (a = f.opacity) !== null && a !== void 0 ? a : this.latestValues.opacity) !== null && c !== void 0 ? c : 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : l.opacity = d === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const h in Wx) {
        if (f[h] === void 0)
          continue;
        const { correct: g, applyTo: y } = Wx[h], v = l.transform === "none" ? f[h] : g(f[h], d);
        if (y) {
          const b = y.length;
          for (let w = 0; w < b; w++)
            l[y[w]] = v;
        } else
          l[h] = v;
      }
      return this.options.layoutId && (l.pointerEvents = d === this ? Cw(o == null ? void 0 : o.pointerEvents) || "" : "none"), l;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) === null || a === void 0 ? void 0 : a.stop();
      }), this.root.nodes.forEach(A7), this.root.sharedNodes.clear();
    }
  };
}
function dwe(e) {
  e.updateLayout();
}
function fwe(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = e.layout, { animationType: s } = e.options, o = n.source !== e.layout.source;
    s === "size" ? ls((d) => {
      const f = o ? n.measuredBox[d] : n.layoutBox[d], p = es(f);
      f.min = r[d].min, f.max = f.min + p;
    }) : RV(s, n.layoutBox, r) && ls((d) => {
      const f = o ? n.measuredBox[d] : n.layoutBox[d], p = es(r[d]);
      f.max = f.min + p, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + p);
    });
    const a = Sh();
    xg(a, r, n.layoutBox);
    const c = Sh();
    o ? xg(c, e.applyTransform(i, !0), n.measuredBox) : xg(c, r, n.layoutBox);
    const l = !IV(a);
    let u = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: f, layout: p } = d;
        if (f && p) {
          const m = Fn();
          Ag(m, n.layoutBox, f.layoutBox);
          const h = Fn();
          Ag(h, r, p.layoutBox), PV(m, h) || (u = !0), d.options.layoutRoot && (e.relativeTarget = h, e.relativeTargetOrigin = m, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: c,
      layoutDelta: a,
      hasLayoutChanged: l,
      hasRelativeTargetChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function hwe(e) {
  Iu.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function pwe(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function mwe(e) {
  e.clearSnapshot();
}
function A7(e) {
  e.clearMeasurements();
}
function gwe(e) {
  e.isLayoutDirty = !1;
}
function ywe(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function E7(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function bwe(e) {
  e.resolveTargetDelta();
}
function vwe(e) {
  e.calcProjection();
}
function wwe(e) {
  e.resetSkewAndRotation();
}
function xwe(e) {
  e.removeLeadSnapshot();
}
function _7(e, t, n) {
  e.translate = Tn(t.translate, 0, n), e.scale = Tn(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function S7(e, t, n, r) {
  e.min = Tn(t.min, n.min, r), e.max = Tn(t.max, n.max, r);
}
function Awe(e, t, n, r) {
  S7(e.x, t.x, n.x, r), S7(e.y, t.y, n.y, r);
}
function Ewe(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const _we = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, C7 = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), T7 = C7("applewebkit/") && !C7("chrome/") ? Math.round : Gr;
function k7(e) {
  e.min = T7(e.min), e.max = T7(e.max);
}
function Swe(e) {
  k7(e.x), k7(e.y);
}
function RV(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !gC(v7(t), v7(n), 0.2);
}
const Cwe = NV({
  attachResizeListener: (e, t) => oc(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), F_ = {
  current: void 0
}, MV = NV({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!F_.current) {
      const e = new Cwe({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), F_.current = e;
    }
    return F_.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Twe = {
  pan: {
    Feature: V1e
  },
  drag: {
    Feature: z1e,
    ProjectionNode: MV,
    MeasureLayout: TV
  }
}, wC = { current: null }, FV = { current: !1 };
function kwe() {
  if (FV.current = !0, !!n4)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => wC.current = e.matches;
      e.addListener(t), t();
    } else
      wC.current = !1;
}
function Bwe(e, t, n) {
  const { willChange: r } = t;
  for (const i in t) {
    const s = t[i], o = n[i];
    if (Hr(s))
      e.addValue(i, s), Kx(r) && r.add(i);
    else if (Hr(o))
      e.addValue(i, Sy(s, { owner: e })), Kx(r) && r.remove(i);
    else if (o !== s)
      if (e.hasValue(i)) {
        const a = e.getValue(i);
        a.liveStyle === !0 ? a.jump(s) : a.hasAnimated || a.set(s);
      } else {
        const a = e.getStaticValue(i);
        e.addValue(i, Sy(a !== void 0 ? a : s, { owner: e }));
      }
  }
  for (const i in n)
    t[i] === void 0 && e.removeValue(i);
  return t;
}
const B7 = /* @__PURE__ */ new WeakMap(), Iwe = [...Gz, Dr, su], Pwe = (e) => Iwe.find(Wz(e)), jV = Object.keys(Ay), Owe = jV.length, I7 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], Nwe = a4.length;
function DV(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : DV(e.parent);
}
class Rwe {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: s, visualState: o }, a = {}) {
    this.resolveKeyframes = (f, p, m, h) => new this.KeyframeResolver(f, p, m, h, this), this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = v4, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => on.render(this.render, !1, !0);
    const { latestValues: c, renderState: l } = o;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = n.initial ? { ...c } : {}, this.renderState = l, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!s, this.isControllingVariants = cE(n), this.isVariantNode = wz(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: u, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in d) {
      const p = d[f];
      c[f] !== void 0 && Hr(p) && (p.set(c[f], !1), Kx(u) && u.add(f));
    }
  }
  mount(t) {
    this.current = t, B7.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), FV.current || kwe(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : wC.current, this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var t;
    B7.delete(this.current), this.projection && this.projection.unmount(), _c(this.notifyUpdate), _c(this.render), this.valueSubscriptions.forEach((n) => n()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features)
      (t = this.features[n]) === null || t === void 0 || t.unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const r = Bf.has(t), i = n.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && on.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), s = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      i(), s(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, r, i, s) {
    let o, a;
    for (let c = 0; c < Owe; c++) {
      const l = jV[c], { isEnabled: u, Feature: d, ProjectionNode: f, MeasureLayout: p } = Ay[l];
      f && (o = f), u(n) && (!this.features[l] && d && (this.features[l] = new d(this)), p && (a = p));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && o) {
      const { layoutId: c, layout: l, drag: u, dragConstraints: d, layoutScroll: f, layoutRoot: p } = n;
      this.projection = new o(this.latestValues, n["data-framer-portal-id"] ? void 0 : DV(this.parent)), this.projection.setOptions({
        layoutId: c,
        layout: l,
        alwaysMeasureLayout: !!u || d && Eh(d),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof l == "string" ? l : "both",
        initialPromotionConfig: s,
        layoutScroll: f,
        layoutRoot: p
      });
    }
    return a;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Fn();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < I7.length; r++) {
      const i = I7[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const s = "on" + i, o = t[s];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = Bwe(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < Nwe; r++) {
      const i = a4[r], s = this.props[i];
      (xy(s) || s === !1) && (n[i] = s);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Sy(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    var r;
    let i = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return i != null && (typeof i == "string" && (Vz(i) || zz(i)) ? i = parseFloat(i) : !Pwe(i) && su.test(n) && (i = Xz(t, n)), this.setBaseTarget(t, Hr(i) ? i.get() : i)), Hr(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props;
    let i;
    if (typeof r == "string" || typeof r == "object") {
      const o = y4(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      o && (i = o[t]);
    }
    if (r && i !== void 0)
      return i;
    const s = this.getBaseTargetFromProps(this.props, t);
    return s !== void 0 && !Hr(s) ? s : this.initialValues[t] !== void 0 && i === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new I4()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class UV extends Rwe {
  constructor() {
    super(...arguments), this.KeyframeResolver = eV;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
}
function Mwe(e) {
  return window.getComputedStyle(e);
}
class Fwe extends UV {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(t, n) {
    if (Bf.has(n)) {
      const r = x4(n);
      return r && r.default || 0;
    } else {
      const r = Mwe(t), i = (_z(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return _V(t, n);
  }
  build(t, n, r, i) {
    f4(t, n, r, i.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return g4(t, n, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Hr(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, r, i) {
    Bz(t, n, r, i);
  }
}
class jwe extends UV {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Bf.has(n)) {
      const r = x4(n);
      return r && r.default || 0;
    }
    return n = Iz.has(n) ? n : i4(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return Fn();
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Oz(t, n, r);
  }
  build(t, n, r, i) {
    p4(t, n, r, this.isSVGTag, i.transformTemplate);
  }
  renderInstance(t, n, r, i) {
    Pz(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = m4(t.tagName), super.mount(t);
  }
}
const Dwe = (e, t) => l4(e) ? new jwe(t, { enableHardwareAcceleration: !1 }) : new Fwe(t, {
  allowProjection: e !== Xd,
  enableHardwareAcceleration: !0
}), Uwe = {
  layout: {
    ProjectionNode: MV,
    MeasureLayout: TV
  }
}, Lwe = {
  ...x1e,
  ...Ibe,
  ...Twe,
  ...Uwe
}, If = /* @__PURE__ */ Lye((e, t) => ybe(e, t, Lwe, Dwe));
function LV() {
  const e = Le(!1);
  return r4(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function zwe() {
  const e = LV(), [t, n] = qe(0), r = Ie(() => {
    e.current && n(t + 1);
  }, [t]);
  return [Ie(() => on.postRender(r), [r]), t];
}
class Vwe extends ye.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Hwe({ children: e, isPresent: t }) {
  const n = mu(), r = Le(null), i = Le({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: s } = $e(t4);
  return bF(() => {
    const { width: o, height: a, top: c, left: l } = i.current;
    if (t || !r.current || !o || !a)
      return;
    r.current.dataset.motionPopId = n;
    const u = document.createElement("style");
    return s && (u.nonce = s), document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${o}px !important;
            height: ${a}px !important;
            top: ${c}px !important;
            left: ${l}px !important;
          }
        `), () => {
      document.head.removeChild(u);
    };
  }, [t]), D.jsx(Vwe, { isPresent: t, childRef: r, sizeRef: i, children: ye.cloneElement(e, { ref: r }) });
}
const j_ = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: s, mode: o }) => {
  const a = Nz(Wwe), c = mu(), l = ot(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: i,
      onExitComplete: (u) => {
        a.set(u, !0);
        for (const d of a.values())
          if (!d)
            return;
        r && r();
      },
      register: (u) => (a.set(u, !1), () => a.delete(u))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    s ? [Math.random()] : [n]
  );
  return ot(() => {
    a.forEach((u, d) => a.set(d, !1));
  }, [n]), ye.useEffect(() => {
    !n && !a.size && r && r();
  }, [n]), o === "popLayout" && (e = D.jsx(Hwe, { isPresent: n, children: e })), D.jsx(mv.Provider, { value: l, children: e });
};
function Wwe() {
  return /* @__PURE__ */ new Map();
}
function Gwe(e) {
  return We(() => () => e(), []);
}
const Pu = (e) => e.key || "";
function qwe(e, t) {
  e.forEach((n) => {
    const r = Pu(n);
    t.set(r, n);
  });
}
function $we(e) {
  const t = [];
  return Ek.forEach(e, (n) => {
    _k(n) && t.push(n);
  }), t;
}
const wv = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, exitBeforeEnter: i, presenceAffectsLayout: s = !0, mode: o = "sync" }) => {
  const a = $e(c4).forceRender || zwe()[0], c = LV(), l = $we(e);
  let u = l;
  const d = Le(/* @__PURE__ */ new Map()).current, f = Le(u), p = Le(/* @__PURE__ */ new Map()).current, m = Le(!0);
  if (r4(() => {
    m.current = !1, qwe(l, p), f.current = u;
  }), Gwe(() => {
    m.current = !0, p.clear(), d.clear();
  }), m.current)
    return D.jsx(D.Fragment, { children: u.map((v) => D.jsx(j_, { isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: s, mode: o, children: v }, Pu(v))) });
  u = [...u];
  const h = f.current.map(Pu), g = l.map(Pu), y = h.length;
  for (let v = 0; v < y; v++) {
    const b = h[v];
    g.indexOf(b) === -1 && !d.has(b) && d.set(b, void 0);
  }
  return o === "wait" && d.size && (u = []), d.forEach((v, b) => {
    if (g.indexOf(b) !== -1)
      return;
    const w = p.get(b);
    if (!w)
      return;
    const A = h.indexOf(b);
    let E = v;
    if (!E) {
      const x = () => {
        d.delete(b);
        const S = Array.from(p.keys()).filter((P) => !g.includes(P));
        if (S.forEach((P) => p.delete(P)), f.current = l.filter((P) => {
          const I = Pu(P);
          return (
            // filter out the node exiting
            I === b || // filter out the leftover children
            S.includes(I)
          );
        }), !d.size) {
          if (c.current === !1)
            return;
          a(), r && r();
        }
      };
      E = D.jsx(j_, { isPresent: !1, onExitComplete: x, custom: t, presenceAffectsLayout: s, mode: o, children: w }, Pu(w)), d.set(b, E);
    }
    u.splice(A, 0, E);
  }), u = u.map((v) => {
    const b = v.key;
    return d.has(b) ? v : D.jsx(j_, { isPresent: !0, presenceAffectsLayout: s, mode: o, children: v }, Pu(v));
  }), D.jsx(D.Fragment, { children: d.size ? u : u.map((v) => rm(v)) });
};
var Qwe = {
  initial: (e) => {
    const { position: t } = e, n = ["top", "bottom"].includes(t) ? "y" : "x";
    let r = ["top-right", "bottom-right"].includes(t) ? 1 : -1;
    return t === "bottom" && (r = 1), {
      opacity: 0,
      [n]: r * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
}, zV = fZ((e) => {
  const {
    id: t,
    message: n,
    onCloseComplete: r,
    onRequestRemove: i,
    requestClose: s = !1,
    position: o = "bottom",
    duration: a = 5e3,
    containerStyle: c,
    motionVariants: l = Qwe,
    toastSpacing: u = "0.5rem"
  } = e, [d, f] = qe(a), p = H1e();
  Hx(() => {
    p || r == null || r();
  }, [p]), Hx(() => {
    f(a);
  }, [a]);
  const m = () => f(null), h = () => f(a), g = () => {
    p && i();
  };
  We(() => {
    p && s && i();
  }, [p, s, i]), Tye(g, d);
  const y = ot(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: u,
      ...c
    }),
    [c, u]
  ), v = ot(() => Sye(o), [o]);
  return /* @__PURE__ */ D.jsx(
    If.div,
    {
      layout: !0,
      className: "chakra-toast",
      variants: l,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: m,
      onHoverEnd: h,
      custom: { position: o },
      style: v,
      children: /* @__PURE__ */ D.jsx(
        yt.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: y,
          children: oo(n, { id: t, onClose: g })
        }
      )
    }
  );
});
zV.displayName = "ToastComponent";
function Kwe(e, t) {
  var n;
  const r = e ?? "bottom", s = {
    "top-start": { ltr: "top-left", rtl: "top-right" },
    "top-end": { ltr: "top-right", rtl: "top-left" },
    "bottom-start": { ltr: "bottom-left", rtl: "bottom-right" },
    "bottom-end": { ltr: "bottom-right", rtl: "bottom-left" }
  }[r];
  return (n = s == null ? void 0 : s[t]) != null ? n : r;
}
var P7 = {
  path: /* @__PURE__ */ D.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ D.jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ D.jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ D.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, Pi = Nt((e, t) => {
  const {
    as: n,
    viewBox: r,
    color: i = "currentColor",
    focusable: s = !1,
    children: o,
    className: a,
    __css: c,
    ...l
  } = e, u = Wt("chakra-icon", a), d = t0("Icon", e), f = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: i,
    ...c,
    ...d
  }, p = {
    ref: t,
    focusable: s,
    className: u,
    __css: f
  }, m = r ?? P7.viewBox;
  if (n && typeof n != "string")
    return /* @__PURE__ */ D.jsx(yt.svg, { as: n, ...p, ...l });
  const h = o ?? P7.path;
  return /* @__PURE__ */ D.jsx(yt.svg, { verticalAlign: "middle", viewBox: m, ...p, ...l, children: h });
});
Pi.displayName = "Icon";
function Ywe(e) {
  return /* @__PURE__ */ D.jsx(Pi, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ D.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function Zwe(e) {
  return /* @__PURE__ */ D.jsx(Pi, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ D.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function O7(e) {
  return /* @__PURE__ */ D.jsx(Pi, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ D.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}
var Jwe = Wle({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), fE = Nt((e, t) => {
  const n = t0("Spinner", e), {
    label: r = "Loading...",
    thickness: i = "2px",
    speed: s = "0.45s",
    emptyColor: o = "transparent",
    className: a,
    ...c
  } = xo(e), l = Wt("chakra-spinner", a), u = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: i,
    borderBottomColor: o,
    borderLeftColor: o,
    animation: `${Jwe} ${s} linear infinite`,
    ...n
  };
  return /* @__PURE__ */ D.jsx(
    yt.div,
    {
      ref: t,
      __css: u,
      className: l,
      ...c,
      children: r && /* @__PURE__ */ D.jsx(yt.span, { srOnly: !0, children: r })
    }
  );
});
fE.displayName = "Spinner";
var [Xwe, P4] = Ir({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}), [exe, O4] = Ir({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}), VV = {
  info: { icon: Zwe, colorScheme: "blue" },
  warning: { icon: O7, colorScheme: "orange" },
  success: { icon: Ywe, colorScheme: "green" },
  error: { icon: O7, colorScheme: "red" },
  loading: { icon: fE, colorScheme: "blue" }
};
function txe(e) {
  return VV[e].colorScheme;
}
function nxe(e) {
  return VV[e].icon;
}
var HV = Nt(
  function(t, n) {
    const r = O4(), { status: i } = P4(), s = {
      display: "inline",
      ...r.description
    };
    return /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ref: n,
        "data-status": i,
        ...t,
        className: Wt("chakra-alert__desc", t.className),
        __css: s
      }
    );
  }
);
HV.displayName = "AlertDescription";
function WV(e) {
  const { status: t } = P4(), n = nxe(t), r = O4(), i = t === "loading" ? r.spinner : r.icon;
  return /* @__PURE__ */ D.jsx(
    yt.span,
    {
      display: "inherit",
      "data-status": t,
      ...e,
      className: Wt("chakra-alert__icon", e.className),
      __css: i,
      children: e.children || /* @__PURE__ */ D.jsx(n, { h: "100%", w: "100%" })
    }
  );
}
WV.displayName = "AlertIcon";
var GV = Nt(
  function(t, n) {
    const r = O4(), { status: i } = P4();
    return /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ref: n,
        "data-status": i,
        ...t,
        className: Wt("chakra-alert__title", t.className),
        __css: r.title
      }
    );
  }
);
GV.displayName = "AlertTitle";
var qV = Nt(function(t, n) {
  var r;
  const { status: i = "info", addRole: s = !0, ...o } = xo(t), a = (r = t.colorScheme) != null ? r : txe(i), c = kf("Alert", { ...t, colorScheme: a }), l = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...c.container
  };
  return /* @__PURE__ */ D.jsx(Xwe, { value: { status: i }, children: /* @__PURE__ */ D.jsx(exe, { value: c, children: /* @__PURE__ */ D.jsx(
    yt.div,
    {
      "data-status": i,
      role: s ? "alert" : void 0,
      ref: n,
      ...o,
      className: Wt("chakra-alert", t.className),
      __css: l
    }
  ) }) });
});
qV.displayName = "Alert";
function rxe(e) {
  return /* @__PURE__ */ D.jsx(Pi, { focusable: "false", "aria-hidden": !0, ...e, children: /* @__PURE__ */ D.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
var $V = Nt(
  function(t, n) {
    const r = t0("CloseButton", t), { children: i, isDisabled: s, __css: o, ...a } = xo(t), c = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ D.jsx(
      yt.button,
      {
        type: "button",
        "aria-label": "Close",
        ref: n,
        disabled: s,
        __css: {
          ...c,
          ...r,
          ...o
        },
        ...a,
        children: i || /* @__PURE__ */ D.jsx(rxe, { width: "1em", height: "1em" })
      }
    );
  }
);
$V.displayName = "CloseButton";
var ixe = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
}, ia = sxe(ixe);
function sxe(e) {
  let t = e;
  const n = /* @__PURE__ */ new Set(), r = (i) => {
    t = i(t), n.forEach((s) => s());
  };
  return {
    getState: () => t,
    subscribe: (i) => (n.add(i), () => {
      r(() => e), n.delete(i);
    }),
    /**
     * Delete a toast record at its position
     */
    removeToast: (i, s) => {
      r((o) => ({
        ...o,
        // id may be string or number
        // eslint-disable-next-line eqeqeq
        [s]: o[s].filter((a) => a.id != i)
      }));
    },
    notify: (i, s) => {
      const o = oxe(i, s), { position: a, id: c } = o;
      return r((l) => {
        var u, d;
        const p = a.includes("top") ? [o, ...(u = l[a]) != null ? u : []] : [...(d = l[a]) != null ? d : [], o];
        return {
          ...l,
          [a]: p
        };
      }), c;
    },
    update: (i, s) => {
      i && r((o) => {
        const a = { ...o }, { position: c, index: l } = AO(a, i);
        return c && l !== -1 && (a[c][l] = {
          ...a[c][l],
          ...s,
          message: QV(s)
        }), a;
      });
    },
    closeAll: ({ positions: i } = {}) => {
      r((s) => (i ?? [
        "bottom",
        "bottom-right",
        "bottom-left",
        "top",
        "top-left",
        "top-right"
      ]).reduce(
        (c, l) => (c[l] = s[l].map((u) => ({
          ...u,
          requestClose: !0
        })), c),
        { ...s }
      ));
    },
    close: (i) => {
      r((s) => {
        const o = gz(s, i);
        return o ? {
          ...s,
          [o]: s[o].map((a) => a.id == i ? {
            ...a,
            requestClose: !0
          } : a)
        } : s;
      });
    },
    isActive: (i) => !!AO(ia.getState(), i).position
  };
}
var N7 = 0;
function oxe(e, t = {}) {
  var n, r;
  N7 += 1;
  const i = (n = t.id) != null ? n : N7, s = (r = t.position) != null ? r : "bottom";
  return {
    id: i,
    message: e,
    position: s,
    duration: t.duration,
    onCloseComplete: t.onCloseComplete,
    onRequestRemove: () => ia.removeToast(String(i), s),
    status: t.status,
    requestClose: !1,
    containerStyle: t.containerStyle
  };
}
var axe = (e) => {
  const {
    status: t,
    variant: n = "solid",
    id: r,
    title: i,
    isClosable: s,
    onClose: o,
    description: a,
    colorScheme: c,
    icon: l
  } = e, u = r ? {
    root: `toast-${r}`,
    title: `toast-${r}-title`,
    description: `toast-${r}-description`
  } : void 0;
  return /* @__PURE__ */ D.jsxs(
    qV,
    {
      addRole: !1,
      status: t,
      variant: n,
      id: u == null ? void 0 : u.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme: c,
      children: [
        /* @__PURE__ */ D.jsx(WV, { children: l }),
        /* @__PURE__ */ D.jsxs(yt.div, { flex: "1", maxWidth: "100%", children: [
          i && /* @__PURE__ */ D.jsx(GV, { id: u == null ? void 0 : u.title, children: i }),
          a && /* @__PURE__ */ D.jsx(HV, { id: u == null ? void 0 : u.description, display: "block", children: a })
        ] }),
        s && /* @__PURE__ */ D.jsx(
          $V,
          {
            size: "sm",
            onClick: o,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function QV(e = {}) {
  const { render: t, toastComponent: n = axe } = e;
  return (i) => typeof t == "function" ? t({ ...i, ...e }) : /* @__PURE__ */ D.jsx(n, { ...i, ...e });
}
function cxe(e, t) {
  const n = (i) => {
    var s;
    return {
      ...t,
      ...i,
      position: Kwe(
        (s = i == null ? void 0 : i.position) != null ? s : t == null ? void 0 : t.position,
        e
      )
    };
  }, r = (i) => {
    const s = n(i), o = QV(s);
    return ia.notify(o, s);
  };
  return r.update = (i, s) => {
    ia.update(i, n(s));
  }, r.promise = (i, s) => {
    const o = r({
      ...s.loading,
      status: "loading",
      duration: null
    });
    i.then(
      (a) => r.update(o, {
        status: "success",
        duration: 5e3,
        ...oo(s.success, a)
      })
    ).catch(
      (a) => r.update(o, {
        status: "error",
        duration: 5e3,
        ...oo(s.error, a)
      })
    );
  }, r.closeAll = ia.closeAll, r.close = ia.close, r.isActive = ia.isActive, r;
}
var [lxe, uxe] = Ir({
  name: "ToastOptionsContext",
  strict: !1
}), dxe = (e) => {
  const t = ev(
    ia.subscribe,
    ia.getState,
    ia.getState
  ), {
    motionVariants: n,
    component: r = zV,
    portalProps: i
  } = e, o = Object.keys(t).map((a) => {
    const c = t[a];
    return /* @__PURE__ */ D.jsx(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        "aria-label": `Notifications-${a}`,
        id: `chakra-toast-manager-${a}`,
        style: Cye(a),
        children: /* @__PURE__ */ D.jsx(wv, { initial: !1, children: c.map((l) => /* @__PURE__ */ D.jsx(
          r,
          {
            motionVariants: n,
            ...l
          },
          l.id
        )) })
      },
      a
    );
  });
  return /* @__PURE__ */ D.jsx(hv, { ...i, children: o });
};
function fxe(e) {
  const { theme: t } = UL(), n = uxe();
  return ot(
    () => cxe(t.direction, {
      ...n,
      ...e
    }),
    [e, t.direction, n]
  );
}
var hxe = (e) => function({
  children: n,
  theme: r = e,
  toastOptions: i,
  ...s
}) {
  return /* @__PURE__ */ D.jsxs(Eye, { theme: r, ...s, children: [
    /* @__PURE__ */ D.jsx(lxe, { value: i == null ? void 0 : i.defaultOptions, children: n }),
    /* @__PURE__ */ D.jsx(dxe, { ...i })
  ] });
}, pxe = hxe(oz), mxe = Object.defineProperty, gxe = (e, t, n) => t in e ? mxe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Bn = (e, t, n) => (gxe(e, typeof t != "symbol" ? t + "" : t, n), n);
function R7(e) {
  return e.sort((t, n) => {
    const r = t.compareDocumentPosition(n);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
var yxe = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function M7(e, t, n) {
  let r = e + 1;
  return n && r >= t && (r = 0), r;
}
function F7(e, t, n) {
  let r = e - 1;
  return n && r < 0 && (r = t), r;
}
var xC = typeof window < "u" ? _f : We, Zx = (e) => e, bxe = class {
  constructor() {
    Bn(this, "descendants", /* @__PURE__ */ new Map()), Bn(this, "register", (e) => {
      if (e != null)
        return yxe(e) ? this.registerNode(e) : (t) => {
          this.registerNode(t, e);
        };
    }), Bn(this, "unregister", (e) => {
      this.descendants.delete(e);
      const t = R7(Array.from(this.descendants.keys()));
      this.assignIndex(t);
    }), Bn(this, "destroy", () => {
      this.descendants.clear();
    }), Bn(this, "assignIndex", (e) => {
      this.descendants.forEach((t) => {
        const n = e.indexOf(t.node);
        t.index = n, t.node.dataset.index = t.index.toString();
      });
    }), Bn(this, "count", () => this.descendants.size), Bn(this, "enabledCount", () => this.enabledValues().length), Bn(this, "values", () => Array.from(this.descendants.values()).sort((t, n) => t.index - n.index)), Bn(this, "enabledValues", () => this.values().filter((e) => !e.disabled)), Bn(this, "item", (e) => {
      if (this.count() !== 0)
        return this.values()[e];
    }), Bn(this, "enabledItem", (e) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[e];
    }), Bn(this, "first", () => this.item(0)), Bn(this, "firstEnabled", () => this.enabledItem(0)), Bn(this, "last", () => this.item(this.descendants.size - 1)), Bn(this, "lastEnabled", () => {
      const e = this.enabledValues().length - 1;
      return this.enabledItem(e);
    }), Bn(this, "indexOf", (e) => {
      var t, n;
      return e && (n = (t = this.descendants.get(e)) == null ? void 0 : t.index) != null ? n : -1;
    }), Bn(this, "enabledIndexOf", (e) => e == null ? -1 : this.enabledValues().findIndex((t) => t.node.isSameNode(e))), Bn(this, "next", (e, t = !0) => {
      const n = M7(e, this.count(), t);
      return this.item(n);
    }), Bn(this, "nextEnabled", (e, t = !0) => {
      const n = this.item(e);
      if (!n)
        return;
      const r = this.enabledIndexOf(n.node), i = M7(
        r,
        this.enabledCount(),
        t
      );
      return this.enabledItem(i);
    }), Bn(this, "prev", (e, t = !0) => {
      const n = F7(e, this.count() - 1, t);
      return this.item(n);
    }), Bn(this, "prevEnabled", (e, t = !0) => {
      const n = this.item(e);
      if (!n)
        return;
      const r = this.enabledIndexOf(n.node), i = F7(
        r,
        this.enabledCount() - 1,
        t
      );
      return this.enabledItem(i);
    }), Bn(this, "registerNode", (e, t) => {
      if (!e || this.descendants.has(e))
        return;
      const n = Array.from(this.descendants.keys()).concat(e), r = R7(n);
      t != null && t.disabled && (t.disabled = !!t.disabled);
      const i = { node: e, index: -1, ...t };
      this.descendants.set(e, i), this.assignIndex(r);
    });
  }
};
function vxe(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function ii(...e) {
  return (t) => {
    e.forEach((n) => {
      vxe(n, t);
    });
  };
}
function wxe(...e) {
  return ot(() => ii(...e), e);
}
function xxe() {
  const e = Le(new bxe());
  return xC(() => () => e.current.destroy()), e.current;
}
var [Axe, KV] = Ir({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function Exe(e) {
  const t = KV(), [n, r] = qe(-1), i = Le(null);
  xC(() => () => {
    i.current && t.unregister(i.current);
  }, []), xC(() => {
    if (!i.current)
      return;
    const o = Number(i.current.dataset.index);
    n != o && !Number.isNaN(o) && r(o);
  });
  const s = Zx(e ? t.register(e) : t.register);
  return {
    descendants: t,
    index: n,
    enabledIndex: t.enabledIndexOf(i.current),
    register: ii(s, i)
  };
}
function _xe() {
  return [
    Zx(Axe),
    () => Zx(KV()),
    () => xxe(),
    (i) => Exe(i)
  ];
}
function Sxe(e) {
  const {
    value: t,
    defaultValue: n,
    onChange: r,
    shouldUpdate: i = (f, p) => f !== p
  } = e, s = zd(r), o = zd(i), [a, c] = qe(n), l = t !== void 0, u = l ? t : a, d = zd(
    (f) => {
      const m = typeof f == "function" ? f(u) : f;
      o(u, m) && (l || c(m), s(m));
    },
    [l, s, u, o]
  );
  return [u, d];
}
var j7 = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, Hd = {
  enter: {
    duration: 0.2,
    ease: j7.easeOut
  },
  exit: {
    duration: 0.1,
    ease: j7.easeIn
  }
}, Wd = {
  enter: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.enter
  }),
  exit: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.exit
  })
}, Cxe = {
  enter: ({ transition: e, transitionEnd: t, delay: n } = {}) => {
    var r;
    return {
      opacity: 1,
      transition: (r = e == null ? void 0 : e.enter) != null ? r : Wd.enter(Hd.enter, n),
      transitionEnd: t == null ? void 0 : t.enter
    };
  },
  exit: ({ transition: e, transitionEnd: t, delay: n } = {}) => {
    var r;
    return {
      opacity: 0,
      transition: (r = e == null ? void 0 : e.exit) != null ? r : Wd.exit(Hd.exit, n),
      transitionEnd: t == null ? void 0 : t.exit
    };
  }
}, YV = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: Cxe
}, Txe = Bc(function(t, n) {
  const {
    unmountOnExit: r,
    in: i,
    className: s,
    transition: o,
    transitionEnd: a,
    delay: c,
    ...l
  } = t, u = i || r ? "enter" : "exit", d = r ? i && r : !0, f = { transition: o, transitionEnd: a, delay: c };
  return /* @__PURE__ */ D.jsx(wv, { custom: f, children: d && /* @__PURE__ */ D.jsx(
    If.div,
    {
      ref: n,
      className: Wt("chakra-fade", s),
      custom: f,
      ...YV,
      animate: u,
      ...l
    }
  ) });
});
Txe.displayName = "Fade";
var kxe = {
  exit: ({ reverse: e, initialScale: t, transition: n, transitionEnd: r, delay: i }) => {
    var s;
    return {
      opacity: 0,
      ...e ? { scale: t, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { scale: t, ...r == null ? void 0 : r.exit } },
      transition: (s = n == null ? void 0 : n.exit) != null ? s : Wd.exit(Hd.exit, i)
    };
  },
  enter: ({ transitionEnd: e, transition: t, delay: n }) => {
    var r;
    return {
      opacity: 1,
      scale: 1,
      transition: (r = t == null ? void 0 : t.enter) != null ? r : Wd.enter(Hd.enter, n),
      transitionEnd: e == null ? void 0 : e.enter
    };
  }
}, ZV = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: kxe
}, Bxe = Bc(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: i,
      reverse: s = !0,
      initialScale: o = 0.95,
      className: a,
      transition: c,
      transitionEnd: l,
      delay: u,
      ...d
    } = t, f = r ? i && r : !0, p = i || r ? "enter" : "exit", m = { initialScale: o, reverse: s, transition: c, transitionEnd: l, delay: u };
    return /* @__PURE__ */ D.jsx(wv, { custom: m, children: f && /* @__PURE__ */ D.jsx(
      If.div,
      {
        ref: n,
        className: Wt("chakra-offset-slide", a),
        ...ZV,
        animate: p,
        custom: m,
        ...d
      }
    ) });
  }
);
Bxe.displayName = "ScaleFade";
var Ixe = {
  initial: ({ offsetX: e, offsetY: t, transition: n, transitionEnd: r, delay: i }) => {
    var s;
    return {
      opacity: 0,
      x: e,
      y: t,
      transition: (s = n == null ? void 0 : n.exit) != null ? s : Wd.exit(Hd.exit, i),
      transitionEnd: r == null ? void 0 : r.exit
    };
  },
  enter: ({ transition: e, transitionEnd: t, delay: n }) => {
    var r;
    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (r = e == null ? void 0 : e.enter) != null ? r : Wd.enter(Hd.enter, n),
      transitionEnd: t == null ? void 0 : t.enter
    };
  },
  exit: ({ offsetY: e, offsetX: t, transition: n, transitionEnd: r, reverse: i, delay: s }) => {
    var o;
    const a = { x: t, y: e };
    return {
      opacity: 0,
      transition: (o = n == null ? void 0 : n.exit) != null ? o : Wd.exit(Hd.exit, s),
      ...i ? { ...a, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { ...a, ...r == null ? void 0 : r.exit } }
    };
  }
}, $0 = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: Ixe
}, Pxe = Bc(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: i,
      reverse: s = !0,
      className: o,
      offsetX: a = 0,
      offsetY: c = 8,
      transition: l,
      transitionEnd: u,
      delay: d,
      ...f
    } = t, p = r ? i && r : !0, m = i || r ? "enter" : "exit", h = {
      offsetX: a,
      offsetY: c,
      reverse: s,
      transition: l,
      transitionEnd: u,
      delay: d
    };
    return /* @__PURE__ */ D.jsx(wv, { custom: h, children: p && /* @__PURE__ */ D.jsx(
      If.div,
      {
        ref: n,
        className: Wt("chakra-offset-slide", o),
        custom: h,
        ...$0,
        animate: m,
        ...f
      }
    ) });
  }
);
Pxe.displayName = "SlideFade";
var AC = Nt(function(t, n) {
  const { htmlWidth: r, htmlHeight: i, alt: s, ...o } = t;
  return /* @__PURE__ */ D.jsx("img", { width: r, height: i, ref: n, alt: s, ...o });
});
AC.displayName = "NativeImage";
function Oxe(e) {
  const {
    loading: t,
    src: n,
    srcSet: r,
    onLoad: i,
    onError: s,
    crossOrigin: o,
    sizes: a,
    ignoreFallback: c
  } = e, [l, u] = qe("pending");
  We(() => {
    u(n ? "loading" : "pending");
  }, [n]);
  const d = Le(), f = Ie(() => {
    if (!n)
      return;
    p();
    const m = new Image();
    m.src = n, o && (m.crossOrigin = o), r && (m.srcset = r), a && (m.sizes = a), t && (m.loading = t), m.onload = (h) => {
      p(), u("loaded"), i == null || i(h);
    }, m.onerror = (h) => {
      p(), u("failed"), s == null || s(h);
    }, d.current = m;
  }, [n, o, r, a, i, s, t]), p = () => {
    d.current && (d.current.onload = null, d.current.onerror = null, d.current = null);
  };
  return ru(() => {
    if (!c)
      return l === "loading" && f(), () => {
        p();
      };
  }, [l, f, c]), c ? "loaded" : l;
}
var Nxe = (e, t) => e !== "loaded" && t === "beforeLoadOrError" || e === "failed" && t === "onError";
function Rxe(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
var ou = Nt(function(t, n) {
  const {
    fallbackSrc: r,
    fallback: i,
    src: s,
    srcSet: o,
    align: a,
    fit: c,
    loading: l,
    ignoreFallback: u,
    crossOrigin: d,
    fallbackStrategy: f = "beforeLoadOrError",
    referrerPolicy: p,
    ...m
  } = t, h = r !== void 0 || i !== void 0, g = l != null || // use can opt out of fallback image
  u || // if the user doesn't provide any kind of fallback we should ignore it
  !h, y = Oxe({
    ...t,
    crossOrigin: d,
    ignoreFallback: g
  }), v = Nxe(y, f), b = {
    ref: n,
    objectFit: c,
    objectPosition: a,
    ...g ? m : Rxe(m, ["onError", "onLoad"])
  };
  return v ? i || /* @__PURE__ */ D.jsx(
    yt.img,
    {
      as: AC,
      className: "chakra-image__placeholder",
      src: r,
      ...b
    }
  ) : /* @__PURE__ */ D.jsx(
    yt.img,
    {
      as: AC,
      src: s,
      srcSet: o,
      crossOrigin: d,
      loading: l,
      referrerPolicy: p,
      className: "chakra-image",
      ...b
    }
  );
});
ou.displayName = "Image";
function N4(e) {
  return Ek.toArray(e).filter(
    (t) => _k(t)
  );
}
var [_Fe, Mxe] = Ir({
  strict: !1,
  name: "ButtonGroupContext"
});
function Fxe(e) {
  const [t, n] = qe(!e);
  return { ref: Ie((s) => {
    s && n(s.tagName === "BUTTON");
  }, []), type: t ? "button" : void 0 };
}
function EC(e) {
  const { children: t, className: n, ...r } = e, i = _k(t) ? rm(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, s = Wt("chakra-button__icon", n);
  return /* @__PURE__ */ D.jsx(
    yt.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...r,
      className: s,
      children: i
    }
  );
}
EC.displayName = "ButtonIcon";
function _C(e) {
  const {
    label: t,
    placement: n,
    spacing: r = "0.5rem",
    children: i = /* @__PURE__ */ D.jsx(fE, { color: "currentColor", width: "1em", height: "1em" }),
    className: s,
    __css: o,
    ...a
  } = e, c = Wt("chakra-button__spinner", s), l = n === "start" ? "marginEnd" : "marginStart", u = ot(
    () => ({
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute",
      [l]: t ? r : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...o
    }),
    [o, t, l, r]
  );
  return /* @__PURE__ */ D.jsx(yt.div, { className: c, ...a, __css: u, children: i });
}
_C.displayName = "ButtonSpinner";
var _m = Nt((e, t) => {
  const n = Mxe(), r = t0("Button", { ...n, ...e }), {
    isDisabled: i = n == null ? void 0 : n.isDisabled,
    isLoading: s,
    isActive: o,
    children: a,
    leftIcon: c,
    rightIcon: l,
    loadingText: u,
    iconSpacing: d = "0.5rem",
    type: f,
    spinner: p,
    spinnerPlacement: m = "start",
    className: h,
    as: g,
    ...y
  } = xo(e), v = ot(() => {
    const E = { ...r == null ? void 0 : r._focus, zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...r,
      ...!!n && { _focus: E }
    };
  }, [r, n]), { ref: b, type: w } = Fxe(g), A = { rightIcon: l, leftIcon: c, iconSpacing: d, children: a };
  return /* @__PURE__ */ D.jsxs(
    yt.button,
    {
      ref: wxe(t, b),
      as: g,
      type: f ?? w,
      "data-active": Gs(o),
      "data-loading": Gs(s),
      __css: v,
      className: Wt("chakra-button", h),
      ...y,
      disabled: i || s,
      children: [
        s && m === "start" && /* @__PURE__ */ D.jsx(
          _C,
          {
            className: "chakra-button__spinner--start",
            label: u,
            placement: "start",
            spacing: d,
            children: p
          }
        ),
        s ? u || /* @__PURE__ */ D.jsx(yt.span, { opacity: 0, children: /* @__PURE__ */ D.jsx(D7, { ...A }) }) : /* @__PURE__ */ D.jsx(D7, { ...A }),
        s && m === "end" && /* @__PURE__ */ D.jsx(
          _C,
          {
            className: "chakra-button__spinner--end",
            label: u,
            placement: "end",
            spacing: d,
            children: p
          }
        )
      ]
    }
  );
});
_m.displayName = "Button";
function D7(e) {
  const { leftIcon: t, rightIcon: n, children: r, iconSpacing: i } = e;
  return /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    t && /* @__PURE__ */ D.jsx(EC, { marginEnd: i, children: t }),
    r,
    n && /* @__PURE__ */ D.jsx(EC, { marginStart: i, children: n })
  ] });
}
var [jxe, Dxe] = Ir({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [Uxe, JV] = Ir({
  strict: !1,
  name: "FormControlContext"
});
function Lxe(e) {
  const {
    id: t,
    isRequired: n,
    isInvalid: r,
    isDisabled: i,
    isReadOnly: s,
    ...o
  } = e, a = mu(), c = t || `field-${a}`, l = `${c}-label`, u = `${c}-feedback`, d = `${c}-helptext`, [f, p] = qe(!1), [m, h] = qe(!1), [g, y] = qe(!1), v = Ie(
    (x = {}, S = null) => ({
      id: d,
      ...x,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: ii(S, (P) => {
        P && h(!0);
      })
    }),
    [d]
  ), b = Ie(
    (x = {}, S = null) => ({
      ...x,
      ref: S,
      "data-focus": Gs(g),
      "data-disabled": Gs(i),
      "data-invalid": Gs(r),
      "data-readonly": Gs(s),
      id: x.id !== void 0 ? x.id : l,
      htmlFor: x.htmlFor !== void 0 ? x.htmlFor : c
    }),
    [c, i, g, r, s, l]
  ), w = Ie(
    (x = {}, S = null) => ({
      id: u,
      ...x,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: ii(S, (P) => {
        P && p(!0);
      }),
      "aria-live": "polite"
    }),
    [u]
  ), A = Ie(
    (x = {}, S = null) => ({
      ...x,
      ...o,
      ref: S,
      role: "group",
      "data-focus": Gs(g),
      "data-disabled": Gs(i),
      "data-invalid": Gs(r),
      "data-readonly": Gs(s)
    }),
    [o, i, g, r, s]
  ), E = Ie(
    (x = {}, S = null) => ({
      ...x,
      ref: S,
      role: "presentation",
      "aria-hidden": !0,
      children: x.children || "*"
    }),
    []
  );
  return {
    isRequired: !!n,
    isInvalid: !!r,
    isReadOnly: !!s,
    isDisabled: !!i,
    isFocused: !!g,
    onFocus: () => y(!0),
    onBlur: () => y(!1),
    hasFeedbackText: f,
    setHasFeedbackText: p,
    hasHelpText: m,
    setHasHelpText: h,
    id: c,
    labelId: l,
    feedbackId: u,
    helpTextId: d,
    htmlProps: o,
    getHelpTextProps: v,
    getErrorMessageProps: w,
    getRootProps: A,
    getLabelProps: b,
    getRequiredIndicatorProps: E
  };
}
var XV = Nt(
  function(t, n) {
    const r = kf("Form", t), i = xo(t), {
      getRootProps: s,
      htmlProps: o,
      ...a
    } = Lxe(i), c = Wt("chakra-form-control", t.className);
    return /* @__PURE__ */ D.jsx(Uxe, { value: a, children: /* @__PURE__ */ D.jsx(jxe, { value: r, children: /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ...s({}, n),
        className: c,
        __css: r.container
      }
    ) }) });
  }
);
XV.displayName = "FormControl";
var zxe = Nt(
  function(t, n) {
    const r = JV(), i = Dxe(), s = Wt("chakra-form__helper-text", t.className);
    return /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ...r == null ? void 0 : r.getHelpTextProps(t, n),
        __css: i.helperText,
        className: s
      }
    );
  }
);
zxe.displayName = "FormHelperText";
function Vxe(e) {
  const { isDisabled: t, isInvalid: n, isReadOnly: r, isRequired: i, ...s } = Hxe(e);
  return {
    ...s,
    disabled: t,
    readOnly: r,
    required: i,
    "aria-invalid": s_(n),
    "aria-required": s_(i),
    "aria-readonly": s_(r)
  };
}
function Hxe(e) {
  var t, n, r;
  const i = JV(), {
    id: s,
    disabled: o,
    readOnly: a,
    required: c,
    isRequired: l,
    isInvalid: u,
    isReadOnly: d,
    isDisabled: f,
    onFocus: p,
    onBlur: m,
    ...h
  } = e, g = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return i != null && i.hasFeedbackText && (i != null && i.isInvalid) && g.push(i.feedbackId), i != null && i.hasHelpText && g.push(i.helpTextId), {
    ...h,
    "aria-describedby": g.join(" ") || void 0,
    id: s ?? (i == null ? void 0 : i.id),
    isDisabled: (t = o ?? f) != null ? t : i == null ? void 0 : i.isDisabled,
    isReadOnly: (n = a ?? d) != null ? n : i == null ? void 0 : i.isReadOnly,
    isRequired: (r = c ?? l) != null ? r : i == null ? void 0 : i.isRequired,
    isInvalid: u ?? (i == null ? void 0 : i.isInvalid),
    onFocus: Xn(i == null ? void 0 : i.onFocus, p),
    onBlur: Xn(i == null ? void 0 : i.onBlur, m)
  };
}
function R4(e, t, n, r) {
  const i = zd(n);
  return We(() => {
    const s = typeof e == "function" ? e() : e ?? document;
    if (!(!n || !s))
      return s.addEventListener(t, i, r), () => {
        s.removeEventListener(t, i, r);
      };
  }, [t, e, r, i, n]), () => {
    const s = typeof e == "function" ? e() : e ?? document;
    s == null || s.removeEventListener(t, i, r);
  };
}
function Wxe(e) {
  return "current" in e;
}
var eH = () => typeof window < "u";
function Gxe() {
  var e;
  const t = navigator.userAgentData;
  return (e = t == null ? void 0 : t.platform) != null ? e : navigator.platform;
}
var qxe = (e) => eH() && e.test(navigator.vendor), $xe = (e) => eH() && e.test(Gxe()), Qxe = () => $xe(/mac|iphone|ipad|ipod/i), Kxe = () => Qxe() && qxe(/apple/i);
function Yxe(e) {
  const { ref: t, elements: n, enabled: r } = e, i = () => {
    var s, o;
    return (o = (s = t.current) == null ? void 0 : s.ownerDocument) != null ? o : document;
  };
  R4(i, "pointerdown", (s) => {
    if (!Kxe() || !r)
      return;
    const o = s.target, c = (n ?? [t]).some((l) => {
      const u = Wxe(l) ? l.current : l;
      return (u == null ? void 0 : u.contains(o)) || u === o;
    });
    i().activeElement !== o && c && (s.preventDefault(), o.focus());
  });
}
function Zxe(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
var SC = "data-focus-lock", tH = "data-focus-lock-disabled", Jxe = "data-no-focus-lock", Xxe = "data-autofocus-inside", e2e = "data-no-autofocus", D_ = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
}, nH = b5({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), rH = b5(), t2e = b5(), n2e = v5({
  async: !0,
  ssr: typeof document < "u"
}), r2e = /* @__PURE__ */ dn(void 0), i2e = [], M4 = /* @__PURE__ */ ye.forwardRef(function(t, n) {
  var r, i = ye.useState(), s = i[0], o = i[1], a = ye.useRef(), c = ye.useRef(!1), l = ye.useRef(null), u = ye.useState({}), d = u[1], f = t.children, p = t.disabled, m = p === void 0 ? !1 : p, h = t.noFocusGuards, g = h === void 0 ? !1 : h, y = t.persistentFocus, v = y === void 0 ? !1 : y, b = t.crossFrame, w = b === void 0 ? !0 : b, A = t.autoFocus, E = A === void 0 ? !0 : A;
  t.allowTextSelection;
  var x = t.group, S = t.className, P = t.whiteList, I = t.hasPositiveIndices, R = t.shards, Q = R === void 0 ? i2e : R, J = t.as, we = J === void 0 ? "div" : J, V = t.lockProps, L = V === void 0 ? {} : V, U = t.sideCar, q = t.returnFocus, G = q === void 0 ? !1 : q, ae = t.focusOptions, ge = t.onActivation, Ae = t.onDeactivation, he = ye.useState({}), B = he[0], be = ye.useCallback(function(X) {
    var $ = X.captureFocusRestore;
    if (!l.current) {
      var ie, fe = (ie = document) == null ? void 0 : ie.activeElement;
      l.current = fe, fe !== document.body && (l.current = $(fe));
    }
    a.current && ge && ge(a.current), c.current = !0, d();
  }, [ge]), Be = ye.useCallback(function() {
    c.current = !1, Ae && Ae(a.current), d();
  }, [Ae]), Ne = ye.useCallback(function(X) {
    var $ = l.current;
    if ($) {
      var ie = (typeof $ == "function" ? $() : $) || document.body, fe = typeof G == "function" ? G(ie) : G;
      if (fe) {
        var oe = typeof fe == "object" ? fe : void 0;
        l.current = null, X ? Promise.resolve().then(function() {
          return ie.focus(oe);
        }) : ie.focus(oe);
      }
    }
  }, [G]), _e = ye.useCallback(function(X) {
    c.current && nH.useMedium(X);
  }, []), Ce = rH.useMedium, N = ye.useCallback(function(X) {
    a.current !== X && (a.current = X, o(X));
  }, []), F = of((r = {}, r[tH] = m && "disabled", r[SC] = x, r), L), z = g !== !0, ne = z && g !== "tail", ee = y5([n, N]), Y = ye.useMemo(function() {
    return {
      observed: a,
      shards: Q,
      enabled: !m,
      active: c.current
    };
  }, [m, c.current, Q, s]);
  return /* @__PURE__ */ ye.createElement(ye.Fragment, null, z && [
    /* @__PURE__ */ ye.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: m ? -1 : 0,
      style: D_
    }),
    I ? /* @__PURE__ */ ye.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: m ? -1 : 1,
      style: D_
    }) : null
  ], !m && /* @__PURE__ */ ye.createElement(U, {
    id: B,
    sideCar: n2e,
    observed: s,
    disabled: m,
    persistentFocus: v,
    crossFrame: w,
    autoFocus: E,
    whiteList: P,
    shards: Q,
    onActivation: be,
    onDeactivation: Be,
    returnFocus: Ne,
    focusOptions: ae
  }), /* @__PURE__ */ ye.createElement(we, of({
    ref: ee
  }, F, {
    className: S,
    onBlur: Ce,
    onFocus: _e
  }), /* @__PURE__ */ ye.createElement(r2e.Provider, {
    value: Y
  }, f)), ne && /* @__PURE__ */ ye.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: m ? -1 : 0,
    style: D_
  }));
});
M4.propTypes = {};
function CC(e, t) {
  return CC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, CC(e, t);
}
function s2e(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, CC(e, t);
}
function Cy(e) {
  "@babel/helpers - typeof";
  return Cy = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cy(e);
}
function o2e(e, t) {
  if (Cy(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Cy(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function a2e(e) {
  var t = o2e(e, "string");
  return Cy(t) == "symbol" ? t : t + "";
}
function c2e(e, t, n) {
  return t = a2e(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function l2e(e, t) {
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(i) {
    var s = [], o;
    function a() {
      o = e(s.map(function(l) {
        return l.props;
      })), t(o);
    }
    var c = /* @__PURE__ */ function(l) {
      s2e(u, l);
      function u() {
        return l.apply(this, arguments) || this;
      }
      u.peek = function() {
        return o;
      };
      var d = u.prototype;
      return d.componentDidMount = function() {
        s.push(this), a();
      }, d.componentDidUpdate = function() {
        a();
      }, d.componentWillUnmount = function() {
        var p = s.indexOf(this);
        s.splice(p, 1), a();
      }, d.render = function() {
        return /* @__PURE__ */ k.createElement(i, this.props);
      }, u;
    }(hZ);
    return c2e(c, "displayName", "SideEffect(" + n(i) + ")"), c;
  };
}
var Sa = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, af = function(e) {
  return Array.isArray(e) ? e : [e];
}, iH = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, u2e = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, sH = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, oH = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, d2e = function(e) {
  return e.hasAttribute("inert");
}, f2e = function(e, t) {
  return !e || oH(e) || !u2e(e) && !d2e(e) && t(sH(e));
}, aH = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = f2e(t, aH.bind(void 0, e));
  return e.set(t, r), r;
}, h2e = function(e, t) {
  return e && !oH(e) ? g2e(e) ? t(sH(e)) : !1 : !0;
}, cH = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = h2e(t, cH.bind(void 0, e));
  return e.set(t, r), r;
}, lH = function(e) {
  return e.dataset;
}, p2e = function(e) {
  return e.tagName === "BUTTON";
}, uH = function(e) {
  return e.tagName === "INPUT";
}, dH = function(e) {
  return uH(e) && e.type === "radio";
}, m2e = function(e) {
  return !((uH(e) || p2e(e)) && (e.type === "hidden" || e.disabled));
}, g2e = function(e) {
  var t = e.getAttribute(e2e);
  return ![!0, "true", ""].includes(t);
}, F4 = function(e) {
  var t;
  return !!(e && (!((t = lH(e)) === null || t === void 0) && t.focusGuard));
}, TC = function(e) {
  return !F4(e);
}, y2e = function(e) {
  return !!e;
}, b2e = function(e, t) {
  var n = Math.max(0, e.tabIndex), r = Math.max(0, t.tabIndex), i = n - r, s = e.index - t.index;
  if (i) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return i || s;
}, v2e = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, j4 = function(e, t, n) {
  return Sa(e).map(function(r, i) {
    var s = v2e(r);
    return {
      node: r,
      index: i,
      tabIndex: n && s === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : s
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(b2e);
}, w2e = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], D4 = w2e.join(","), x2e = "".concat(D4, ", [data-focus-guard]"), fH = function(e, t) {
  return Sa((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? x2e : D4) ? [r] : [], fH(r));
  }, []);
}, A2e = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? Sm([e.contentDocument.body], t) : [e];
}, Sm = function(e, t) {
  return e.reduce(function(n, r) {
    var i, s = fH(r, t), o = (i = []).concat.apply(i, s.map(function(a) {
      return A2e(a, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      o,
      // add if node is tabbable itself
      r.parentNode ? Sa(r.parentNode.querySelectorAll(D4)).filter(function(a) {
        return a === r;
      }) : []
    );
  }, []);
}, E2e = function(e) {
  var t = e.querySelectorAll("[".concat(Xxe, "]"));
  return Sa(t).map(function(n) {
    return Sm([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, U4 = function(e, t) {
  return Sa(e).filter(function(n) {
    return aH(t, n);
  }).filter(function(n) {
    return m2e(n);
  });
}, U7 = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), Sa(e).filter(function(n) {
    return cH(t, n);
  });
}, L4 = function(e, t, n) {
  return j4(U4(Sm(e, n), t), !0, n);
}, Jx = function(e, t) {
  return j4(U4(Sm(e), t), !1);
}, _2e = function(e, t) {
  return U4(E2e(e), t);
}, Gd = function(e, t) {
  return e.shadowRoot ? Gd(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : Sa(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var i = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return i ? Gd(i, t) : !1;
    }
    return Gd(n, t);
  });
}, S2e = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var i = r + 1; i < n; i += 1) {
      var s = e[r].compareDocumentPosition(e[i]);
      (s & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(i), (s & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(o, a) {
    return !t.has(a);
  });
}, hH = function(e) {
  return e.parentNode ? hH(e.parentNode) : e;
}, z4 = function(e) {
  var t = af(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var i = r.getAttribute(SC);
    return n.push.apply(n, i ? S2e(Sa(hH(r).querySelectorAll("[".concat(SC, '="').concat(i, '"]:not([').concat(tH, '="disabled"])')))) : [r]), n;
  }, []);
}, C2e = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, Ty = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? Ty(t.shadowRoot) : t instanceof HTMLIFrameElement && C2e(function() {
      return t.contentWindow.document;
    }) ? Ty(t.contentWindow.document) : t;
  }
}, T2e = function(e, t) {
  return e === t;
}, k2e = function(e, t) {
  return !!Sa(e.querySelectorAll("iframe")).some(function(n) {
    return T2e(n, t);
  });
}, pH = function(e, t) {
  return t === void 0 && (t = Ty(iH(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : z4(e).some(function(n) {
    return Gd(n, t) || k2e(n, t);
  });
}, B2e = function(e) {
  e === void 0 && (e = document);
  var t = Ty(e);
  return t ? Sa(e.querySelectorAll("[".concat(Jxe, "]"))).some(function(n) {
    return Gd(n, t);
  }) : !1;
}, I2e = function(e, t) {
  return t.filter(dH).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, V4 = function(e, t) {
  return dH(e) && e.name ? I2e(e, t) : e;
}, P2e = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(V4(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, L7 = function(e) {
  return e[0] && e.length > 1 ? V4(e[0], e) : e[0];
}, z7 = function(e, t) {
  return e.indexOf(V4(t, e));
}, kC = "NEW_FOCUS", O2e = function(e, t, n, r, i) {
  var s = e.length, o = e[0], a = e[s - 1], c = F4(r);
  if (!(r && e.indexOf(r) >= 0)) {
    var l = r !== void 0 ? n.indexOf(r) : -1, u = i ? n.indexOf(i) : l, d = i ? e.indexOf(i) : -1;
    if (l === -1)
      return d !== -1 ? d : kC;
    if (d === -1)
      return kC;
    var f = l - u, p = n.indexOf(o), m = n.indexOf(a), h = P2e(n), g = r !== void 0 ? h.indexOf(r) : -1, y = g - (i ? h.indexOf(i) : l);
    if (!f && d >= 0 || t.length === 0)
      return d;
    var v = z7(e, t[0]), b = z7(e, t[t.length - 1]);
    if (l <= p && c && Math.abs(f) > 1)
      return b;
    if (l >= m && c && Math.abs(f) > 1)
      return v;
    if (f && Math.abs(y) > 1)
      return d;
    if (l <= p)
      return b;
    if (l > m)
      return v;
    if (f)
      return Math.abs(f) > 1 ? d : (s + d + f) % s;
  }
}, N2e = function(e) {
  return function(t) {
    var n, r = (n = lH(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, V7 = function(e, t, n) {
  var r = e.map(function(s) {
    var o = s.node;
    return o;
  }), i = U7(r.filter(N2e(n)));
  return i && i.length ? L7(i) : L7(U7(t));
}, BC = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && BC(e.parentNode.host || e.parentNode, t), t;
}, U_ = function(e, t) {
  for (var n = BC(e), r = BC(t), i = 0; i < n.length; i += 1) {
    var s = n[i];
    if (r.indexOf(s) >= 0)
      return s;
  }
  return !1;
}, mH = function(e, t, n) {
  var r = af(e), i = af(t), s = r[0], o = !1;
  return i.filter(Boolean).forEach(function(a) {
    o = U_(o || a, a) || o, n.filter(Boolean).forEach(function(c) {
      var l = U_(s, c);
      l && (!o || Gd(l, o) ? o = l : o = U_(l, o));
    });
  }), o;
}, H7 = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(_2e(r, t));
  }, []);
}, R2e = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(y2e);
}, M2e = function(e, t) {
  var n = Ty(af(e).length > 0 ? document : iH(e).ownerDocument), r = z4(e).filter(TC), i = mH(n || e, e, r), s = /* @__PURE__ */ new Map(), o = Jx(r, s), a = o.filter(function(m) {
    var h = m.node;
    return TC(h);
  });
  if (a[0]) {
    var c = Jx([i], s).map(function(m) {
      var h = m.node;
      return h;
    }), l = R2e(c, a), u = l.map(function(m) {
      var h = m.node;
      return h;
    }), d = l.filter(function(m) {
      var h = m.tabIndex;
      return h >= 0;
    }).map(function(m) {
      var h = m.node;
      return h;
    }), f = O2e(u, d, c, n, t);
    if (f === kC) {
      var p = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        V7(o, d, H7(r, s)) || V7(o, u, H7(r, s))
      );
      if (p)
        return { node: p };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return f === void 0 ? f : l[f];
  }
}, F2e = function(e) {
  var t = z4(e).filter(TC), n = mH(e, e, t), r = j4(Sm([n], !0), !0, !0), i = Sm(t, !1);
  return r.map(function(s) {
    var o = s.node, a = s.index;
    return {
      node: o,
      index: a,
      lockItem: i.indexOf(o) >= 0,
      guard: F4(o)
    };
  });
}, H4 = function(e, t) {
  e && ("focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, L_ = 0, z_ = !1, gH = function(e, t, n) {
  n === void 0 && (n = {});
  var r = M2e(e, t);
  if (!z_ && r) {
    if (L_ > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), z_ = !0, setTimeout(function() {
        z_ = !1;
      }, 1);
      return;
    }
    L_++, H4(r.node, n.focusOptions), L_--;
  }
};
function A0(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var t = e ? new WeakRef(e) : null;
  return function() {
    return (t == null ? void 0 : t.deref()) || null;
  };
}
var j2e = function(e) {
  if (!e)
    return null;
  for (var t = [], n = e; n && n !== document.body; )
    t.push({
      current: A0(n),
      parent: A0(n.parentElement),
      left: A0(n.previousElementSibling),
      right: A0(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: A0(e),
    stack: t,
    ownerDocument: e.ownerDocument
  };
}, D2e = function(e) {
  var t, n, r, i, s;
  if (e)
    for (var o = e.stack, a = e.ownerDocument, c = /* @__PURE__ */ new Map(), l = 0, u = o; l < u.length; l++) {
      var d = u[l], f = (t = d.parent) === null || t === void 0 ? void 0 : t.call(d);
      if (f && a.contains(f)) {
        for (var p = (n = d.left) === null || n === void 0 ? void 0 : n.call(d), m = d.current(), h = f.contains(m) ? m : void 0, g = (r = d.right) === null || r === void 0 ? void 0 : r.call(d), y = L4([f], c), v = (
          // that is element itself
          (s = (i = h ?? // or something in it's place
          (p == null ? void 0 : p.nextElementSibling)) !== null && i !== void 0 ? i : (
            // or somebody to the right, still close enough
            g
          )) !== null && s !== void 0 ? s : (
            // or somebody to the left, something?
            p
          )
        ); v; ) {
          for (var b = 0, w = y; b < w.length; b++) {
            var A = w[b];
            if (v != null && v.contains(A.node))
              return A.node;
          }
          v = v.nextElementSibling;
        }
        if (y.length)
          return y[0].node;
      }
    }
}, U2e = function(e) {
  var t = j2e(e);
  return function() {
    return D2e(t);
  };
}, L2e = function(e, t, n) {
  if (!e || !t)
    return console.error("no element or scope given"), {};
  var r = af(t);
  if (r.every(function(o) {
    return !Gd(o, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var i = n ? L4(r, /* @__PURE__ */ new Map()) : Jx(r, /* @__PURE__ */ new Map()), s = i.findIndex(function(o) {
    var a = o.node;
    return a === e;
  });
  if (s !== -1)
    return {
      prev: i[s - 1],
      next: i[s + 1],
      first: i[0],
      last: i[i.length - 1]
    };
}, z2e = function(e, t) {
  var n = t ? L4(af(e), /* @__PURE__ */ new Map()) : Jx(af(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, V2e = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, yH = function(e, t, n) {
  t === void 0 && (t = {});
  var r = V2e(t), i = L2e(e, r.scope, r.onlyTabbable);
  if (i) {
    var s = n(i, r.cycle);
    s && H4(s.node, r.focusOptions);
  }
}, H2e = function(e, t) {
  t === void 0 && (t = {}), yH(e, t, function(n, r) {
    var i = n.next, s = n.first;
    return i || r && s;
  });
}, W2e = function(e, t) {
  t === void 0 && (t = {}), yH(e, t, function(n, r) {
    var i = n.prev, s = n.last;
    return i || r && s;
  });
}, bH = function(e, t, n) {
  var r, i = z2e(e, (r = t.onlyTabbable) !== null && r !== void 0 ? r : !0), s = i[n];
  s && H4(s.node, t.focusOptions);
}, G2e = function(e, t) {
  t === void 0 && (t = {}), bH(e, t, "first");
}, q2e = function(e, t) {
  t === void 0 && (t = {}), bH(e, t, "last");
};
function W4(e) {
  setTimeout(e, 1);
}
var $2e = function(t) {
  return t && "current" in t ? t.current : t;
}, Q2e = function() {
  return document && document.activeElement === document.body;
}, K2e = function() {
  return Q2e() || B2e();
}, Wh = null, Th = null, Gh = null, ky = !1, Y2e = function() {
  return !0;
}, Z2e = function(t) {
  return (Wh.whiteList || Y2e)(t);
}, J2e = function(t, n) {
  Gh = {
    observerNode: t,
    portaledElement: n
  };
}, X2e = function(t) {
  return Gh && Gh.portaledElement === t;
};
function W7(e, t, n, r) {
  var i = null, s = e;
  do {
    var o = r[s];
    if (o.guard)
      o.node.dataset.focusAutoGuard && (i = o);
    else if (o.lockItem) {
      if (s !== e)
        return;
      i = null;
    } else
      break;
  } while ((s += n) !== t);
  i && (i.node.tabIndex = 0);
}
var eAe = function(t) {
  return t ? !!ky : ky === "meanwhile";
}, tAe = function e(t, n, r) {
  return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, nAe = function(t, n) {
  return n.some(function(r) {
    return tAe(t, r, r);
  });
}, Xx = function() {
  var t = !1;
  if (Wh) {
    var n = Wh, r = n.observed, i = n.persistentFocus, s = n.autoFocus, o = n.shards, a = n.crossFrame, c = n.focusOptions, l = r || Gh && Gh.portaledElement, u = document && document.activeElement;
    if (l) {
      var d = [l].concat(o.map($2e).filter(Boolean));
      if ((!u || Z2e(u)) && (i || eAe(a) || !K2e() || !Th && s) && (l && !(pH(d) || u && nAe(u, d) || X2e(u)) && (document && !Th && u && !s ? (u.blur && u.blur(), document.body.focus()) : (t = gH(d, Th, {
        focusOptions: c
      }), Gh = {})), ky = !1, Th = document && document.activeElement), document && u !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var f = document && document.activeElement, p = F2e(d), m = p.map(function(h) {
          var g = h.node;
          return g;
        }).indexOf(f);
        m > -1 && (p.filter(function(h) {
          var g = h.guard, y = h.node;
          return g && y.dataset.focusAutoGuard;
        }).forEach(function(h) {
          var g = h.node;
          return g.removeAttribute("tabIndex");
        }), W7(m, p.length, 1, p), W7(m, -1, -1, p));
      }
    }
  }
  return t;
}, vH = function(t) {
  Xx() && t && (t.stopPropagation(), t.preventDefault());
}, G4 = function() {
  return W4(Xx);
}, rAe = function(t) {
  var n = t.target, r = t.currentTarget;
  r.contains(n) || J2e(r, n);
}, iAe = function() {
  return null;
}, wH = function() {
  ky = "just", W4(function() {
    ky = "meanwhile";
  });
}, sAe = function() {
  document.addEventListener("focusin", vH), document.addEventListener("focusout", G4), window.addEventListener("blur", wH);
}, oAe = function() {
  document.removeEventListener("focusin", vH), document.removeEventListener("focusout", G4), window.removeEventListener("blur", wH);
};
function aAe(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
var xH = {
  moveFocusInside: gH,
  focusInside: pH,
  focusNextElement: H2e,
  focusPrevElement: W2e,
  focusFirstElement: G2e,
  focusLastElement: q2e,
  captureFocusRestore: U2e
};
function cAe(e) {
  var t = e.slice(-1)[0];
  t && !Wh && sAe();
  var n = Wh, r = n && t && t.id === n.id;
  Wh = t, n && !r && (n.onDeactivation(), e.filter(function(i) {
    var s = i.id;
    return s === n.id;
  }).length || n.returnFocus(!t)), t ? (Th = null, (!r || n.observed !== t.observed) && t.onActivation(xH), Xx(), W4(Xx)) : (oAe(), Th = null);
}
nH.assignSyncMedium(rAe);
rH.assignMedium(G4);
t2e.assignMedium(function(e) {
  return e(xH);
});
const lAe = l2e(aAe, cAe)(iAe);
var IC = /* @__PURE__ */ ye.forwardRef(function(t, n) {
  return /* @__PURE__ */ ye.createElement(M4, of({
    sideCar: lAe,
    ref: n
  }, t));
}), AH = M4.propTypes || {};
AH.sideCar;
Zxe(AH, ["sideCar"]);
IC.propTypes = {};
function EH(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function _H(e) {
  var t;
  if (!EH(e))
    return !1;
  const n = (t = e.ownerDocument.defaultView) != null ? t : window;
  return e instanceof n.HTMLElement;
}
function uAe(e) {
  var t, n;
  return (n = (t = SH(e)) == null ? void 0 : t.defaultView) != null ? n : window;
}
function SH(e) {
  return EH(e) ? e.ownerDocument : document;
}
function dAe(e) {
  return SH(e).activeElement;
}
var CH = (e) => e.hasAttribute("tabindex"), fAe = (e) => CH(e) && e.tabIndex === -1;
function hAe(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function TH(e) {
  return e.parentElement && TH(e.parentElement) ? !0 : e.hidden;
}
function pAe(e) {
  const t = e.getAttribute("contenteditable");
  return t !== "false" && t != null;
}
function kH(e) {
  if (!_H(e) || TH(e) || hAe(e))
    return !1;
  const { localName: t } = e;
  if (["input", "select", "textarea", "button"].indexOf(t) >= 0)
    return !0;
  const r = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return t in r ? r[t]() : pAe(e) ? !0 : CH(e);
}
function mAe(e) {
  return e ? _H(e) && kH(e) && !fAe(e) : !1;
}
var gAe = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
], yAe = gAe.join(), bAe = (e) => e.offsetWidth > 0 && e.offsetHeight > 0;
function BH(e) {
  const t = Array.from(
    e.querySelectorAll(yAe)
  );
  return t.unshift(e), t.filter((n) => kH(n) && bAe(n));
}
var G7, vAe = (G7 = IC.default) != null ? G7 : IC, IH = (e) => {
  const {
    initialFocusRef: t,
    finalFocusRef: n,
    contentRef: r,
    restoreFocus: i,
    children: s,
    isDisabled: o,
    autoFocus: a,
    persistentFocus: c,
    lockFocusAcrossFrames: l
  } = e, u = Ie(() => {
    t != null && t.current ? t.current.focus() : r != null && r.current && BH(r.current).length === 0 && requestAnimationFrame(() => {
      var m;
      (m = r.current) == null || m.focus();
    });
  }, [t, r]), d = Ie(() => {
    var p;
    (p = n == null ? void 0 : n.current) == null || p.focus();
  }, [n]), f = i && !n;
  return /* @__PURE__ */ D.jsx(
    vAe,
    {
      crossFrame: l,
      persistentFocus: c,
      autoFocus: a,
      disabled: o,
      onActivation: u,
      onDeactivation: d,
      returnFocus: f,
      children: s
    }
  );
};
IH.displayName = "FocusLock";
var [wAe, xAe] = Ir({
  name: "InputGroupStylesContext",
  errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
}), PH = Nt(
  function(t, n) {
    const r = kf("Input", t), { children: i, className: s, ...o } = xo(t), a = Wt("chakra-input__group", s), c = {}, l = N4(i), u = r.field;
    l.forEach((f) => {
      var p, m;
      r && (u && f.type.id === "InputLeftElement" && (c.paddingStart = (p = u.height) != null ? p : u.h), u && f.type.id === "InputRightElement" && (c.paddingEnd = (m = u.height) != null ? m : u.h), f.type.id === "InputRightAddon" && (c.borderEndRadius = 0), f.type.id === "InputLeftAddon" && (c.borderStartRadius = 0));
    });
    const d = l.map((f) => {
      var p, m;
      const h = pz({
        size: ((p = f.props) == null ? void 0 : p.size) || t.size,
        variant: ((m = f.props) == null ? void 0 : m.variant) || t.variant
      });
      return f.type.id !== "Input" ? rm(f, h) : rm(f, Object.assign(h, c, f.props));
    });
    return /* @__PURE__ */ D.jsx(
      yt.div,
      {
        className: a,
        ref: n,
        __css: {
          width: "100%",
          display: "flex",
          position: "relative",
          // Parts of inputs override z-index to ensure that they stack correctly on each other
          // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
          isolation: "isolate",
          ...r.group
        },
        "data-group": !0,
        ...o,
        children: /* @__PURE__ */ D.jsx(wAe, { value: r, children: d })
      }
    );
  }
);
PH.displayName = "InputGroup";
var AAe = yt("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), hE = Nt(function(t, n) {
  var r, i;
  const { placement: s = "left", ...o } = t, a = xAe(), c = a.field, u = {
    [s === "left" ? "insetStart" : "insetEnd"]: "0",
    width: (r = c == null ? void 0 : c.height) != null ? r : c == null ? void 0 : c.h,
    height: (i = c == null ? void 0 : c.height) != null ? i : c == null ? void 0 : c.h,
    fontSize: c == null ? void 0 : c.fontSize,
    ...a.element
  };
  return /* @__PURE__ */ D.jsx(AAe, { ref: n, __css: u, ...o });
});
hE.id = "InputElement";
hE.displayName = "InputElement";
var q4 = Nt(
  function(t, n) {
    const { className: r, ...i } = t, s = Wt("chakra-input__left-element", r);
    return /* @__PURE__ */ D.jsx(
      hE,
      {
        ref: n,
        placement: "left",
        className: s,
        ...i
      }
    );
  }
);
q4.id = "InputLeftElement";
q4.displayName = "InputLeftElement";
var OH = Nt(
  function(t, n) {
    const { className: r, ...i } = t, s = Wt("chakra-input__right-element", r);
    return /* @__PURE__ */ D.jsx(
      hE,
      {
        ref: n,
        placement: "right",
        className: s,
        ...i
      }
    );
  }
);
OH.id = "InputRightElement";
OH.displayName = "InputRightElement";
var pE = Nt(function(t, n) {
  const { htmlSize: r, ...i } = t, s = kf("Input", i), o = xo(i), a = Vxe(o), c = Wt("chakra-input", t.className);
  return /* @__PURE__ */ D.jsx(
    yt.input,
    {
      size: r,
      ...a,
      __css: s.field,
      ref: n,
      className: c
    }
  );
});
pE.displayName = "Input";
pE.id = "Input";
var NH = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function EAe(e, t) {
  return Array.isArray(e) ? e.map((n) => n === null ? null : t(n)) : Ii(e) ? Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {}) : e != null ? t(e) : null;
}
function _Ae(e, t = NH) {
  const n = {};
  return e.forEach((r, i) => {
    const s = t[i];
    r != null && (n[s] = r);
  }), n;
}
var pi = Nt(function(t, n) {
  const r = t0("Text", t), { className: i, align: s, decoration: o, casing: a, ...c } = xo(t), l = pz({
    textAlign: t.align,
    textDecoration: t.decoration,
    textTransform: t.casing
  });
  return /* @__PURE__ */ D.jsx(
    yt.p,
    {
      ref: n,
      className: Wt("chakra-text", t.className),
      ...l,
      ...c,
      __css: r
    }
  );
});
pi.displayName = "Text";
var RH = (e) => /* @__PURE__ */ D.jsx(
  yt.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
RH.displayName = "StackItem";
function SAe(e) {
  const { spacing: t, direction: n } = e, r = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": EAe(
      n,
      (i) => r[i]
    )
  };
}
var $4 = Nt((e, t) => {
  const {
    isInline: n,
    direction: r,
    align: i,
    justify: s,
    spacing: o = "0.5rem",
    wrap: a,
    children: c,
    divider: l,
    className: u,
    shouldWrapChildren: d,
    ...f
  } = e, p = n ? "row" : r ?? "column", m = ot(
    () => SAe({ spacing: o, direction: p }),
    [o, p]
  ), h = !!l, g = !d && !h, y = ot(() => {
    const b = N4(c);
    return g ? b : b.map((w, A) => {
      const E = typeof w.key < "u" ? w.key : A, x = A + 1 === b.length, P = d ? /* @__PURE__ */ D.jsx(RH, { children: w }, E) : w;
      if (!h)
        return P;
      const I = rm(
        l,
        {
          __css: m
        }
      ), R = x ? null : I;
      return /* @__PURE__ */ D.jsxs(Xd, { children: [
        P,
        R
      ] }, E);
    });
  }, [
    l,
    m,
    h,
    g,
    d,
    c
  ]), v = Wt("chakra-stack", u);
  return /* @__PURE__ */ D.jsx(
    yt.div,
    {
      ref: t,
      display: "flex",
      alignItems: i,
      justifyContent: s,
      flexDirection: p,
      flexWrap: a,
      gap: h ? void 0 : o,
      className: v,
      ...f,
      children: y
    }
  );
});
$4.displayName = "Stack";
var au = Nt((e, t) => /* @__PURE__ */ D.jsx($4, { align: "center", ...e, direction: "column", ref: t }));
au.displayName = "VStack";
var kn = Nt((e, t) => /* @__PURE__ */ D.jsx($4, { align: "center", ...e, direction: "row", ref: t }));
kn.displayName = "HStack";
var ks = yt("div");
ks.displayName = "Box";
var MH = Nt(function(t, n) {
  const { size: r, centerContent: i = !0, ...s } = t, o = i ? { display: "flex", alignItems: "center", justifyContent: "center" } : {};
  return /* @__PURE__ */ D.jsx(
    ks,
    {
      ref: n,
      boxSize: r,
      __css: {
        ...o,
        flexShrink: 0,
        flexGrow: 0
      },
      ...s
    }
  );
});
MH.displayName = "Square";
var CAe = Nt(function(t, n) {
  const { size: r, ...i } = t;
  return /* @__PURE__ */ D.jsx(MH, { size: r, ref: n, borderRadius: "9999px", ...i });
});
CAe.displayName = "Circle";
var FH = Nt(function(t, n) {
  const {
    borderLeftWidth: r,
    borderBottomWidth: i,
    borderTopWidth: s,
    borderRightWidth: o,
    borderWidth: a,
    borderStyle: c,
    borderColor: l,
    ...u
  } = t0("Divider", t), {
    className: d,
    orientation: f = "horizontal",
    __css: p,
    ...m
  } = xo(t), h = {
    vertical: {
      borderLeftWidth: r || o || a || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: i || s || a || "1px",
      width: "100%"
    }
  };
  return /* @__PURE__ */ D.jsx(
    yt.hr,
    {
      ref: n,
      "aria-orientation": f,
      ...m,
      __css: {
        ...u,
        border: "0",
        borderColor: l,
        borderStyle: c,
        ...h[f],
        ...p
      },
      className: Wt("chakra-divider", d)
    }
  );
});
FH.displayName = "Divider";
var Q4 = Nt(function(t, n) {
  const { direction: r, align: i, justify: s, wrap: o, basis: a, grow: c, shrink: l, ...u } = t, d = {
    display: "flex",
    flexDirection: r,
    alignItems: i,
    justifyContent: s,
    flexWrap: o,
    flexBasis: a,
    flexGrow: c,
    flexShrink: l
  };
  return /* @__PURE__ */ D.jsx(yt.div, { ref: n, __css: d, ...u });
});
Q4.displayName = "Flex";
function TAe(e, t = {}) {
  const { ssr: n = !0, fallback: r } = t, { getWindow: i } = Aye(), s = Array.isArray(e) ? e : [e];
  let o = Array.isArray(r) ? r : [r];
  o = o.filter((l) => l != null);
  const [a, c] = qe(() => s.map((l, u) => ({
    media: l,
    matches: n ? !!o[u] : i().matchMedia(l).matches
  })));
  return We(() => {
    const l = i();
    c(
      s.map((f) => ({
        media: f,
        matches: l.matchMedia(f).matches
      }))
    );
    const u = s.map((f) => l.matchMedia(f)), d = (f) => {
      c((p) => p.slice().map((m) => m.media === f.media ? { ...m, matches: f.matches } : m));
    };
    return u.forEach((f) => {
      typeof f.addListener == "function" ? f.addListener(d) : f.addEventListener("change", d);
    }), () => {
      u.forEach((f) => {
        typeof f.removeListener == "function" ? f.removeListener(d) : f.removeEventListener("change", d);
      });
    };
  }, [i]), a.map((l) => l.matches);
}
function kAe(e, t, n = NH) {
  let r = Object.keys(e).indexOf(t);
  if (r !== -1)
    return e[t];
  let i = n.indexOf(t);
  for (; i >= 0; ) {
    const s = n[i];
    if (e.hasOwnProperty(s)) {
      r = i;
      break;
    }
    i -= 1;
  }
  if (r !== -1) {
    const s = n[r];
    return e[s];
  }
}
function BAe(e) {
  var t, n;
  const r = Ii(e) ? e : { fallback: e ?? "base" }, s = tE().__breakpoints.details.map(
    ({ minMaxQuery: l, breakpoint: u }) => ({
      breakpoint: u,
      query: l.replace("@media screen and ", "")
    })
  ), o = s.map((l) => l.breakpoint === r.fallback), c = TAe(
    s.map((l) => l.query),
    { fallback: o, ssr: r.ssr }
  ).findIndex((l) => l == !0);
  return (n = (t = s[c]) == null ? void 0 : t.breakpoint) != null ? n : r.fallback;
}
function IAe(e, t) {
  var n;
  const r = Ii(t) ? t : { fallback: "base" }, i = BAe(r), s = tE();
  if (!i)
    return;
  const o = Array.from(((n = s.__breakpoints) == null ? void 0 : n.keys) || []), a = Array.isArray(e) ? Object.fromEntries(
    Object.entries(_Ae(e, o)).map(
      ([c, l]) => [c, l]
    )
  ) : e;
  return kAe(a, i, o);
}
function PAe() {
  const e = Le(/* @__PURE__ */ new Map()), t = e.current, n = Ie((i, s, o, a) => {
    e.current.set(o, { type: s, el: i, options: a }), i.addEventListener(s, o, a);
  }, []), r = Ie(
    (i, s, o, a) => {
      i.removeEventListener(s, o, a), e.current.delete(o);
    },
    []
  );
  return We(
    () => () => {
      t.forEach((i, s) => {
        r(i.el, i.type, s, i.options);
      });
    },
    [r, t]
  ), { add: n, remove: r };
}
function V_(e) {
  const t = e.target, { tagName: n, isContentEditable: r } = t;
  return n !== "INPUT" && n !== "TEXTAREA" && r !== !0;
}
function OAe(e = {}) {
  const {
    ref: t,
    isDisabled: n,
    isFocusable: r,
    clickOnEnter: i = !0,
    clickOnSpace: s = !0,
    onMouseDown: o,
    onMouseUp: a,
    onClick: c,
    onKeyDown: l,
    onKeyUp: u,
    tabIndex: d,
    onMouseOver: f,
    onMouseLeave: p,
    ...m
  } = e, [h, g] = qe(!0), [y, v] = qe(!1), b = PAe(), w = (U) => {
    U && U.tagName !== "BUTTON" && g(!1);
  }, A = h ? d : d || 0, E = n && !r, x = Ie(
    (U) => {
      if (n) {
        U.stopPropagation(), U.preventDefault();
        return;
      }
      U.currentTarget.focus(), c == null || c(U);
    },
    [n, c]
  ), S = Ie(
    (U) => {
      y && V_(U) && (U.preventDefault(), U.stopPropagation(), v(!1), b.remove(document, "keyup", S, !1));
    },
    [y, b]
  ), P = Ie(
    (U) => {
      if (l == null || l(U), n || U.defaultPrevented || U.metaKey || !V_(U.nativeEvent) || h)
        return;
      const q = i && U.key === "Enter";
      s && U.key === " " && (U.preventDefault(), v(!0)), q && (U.preventDefault(), U.currentTarget.click()), b.add(document, "keyup", S, !1);
    },
    [
      n,
      h,
      l,
      i,
      s,
      b,
      S
    ]
  ), I = Ie(
    (U) => {
      if (u == null || u(U), n || U.defaultPrevented || U.metaKey || !V_(U.nativeEvent) || h)
        return;
      s && U.key === " " && (U.preventDefault(), v(!1), U.currentTarget.click());
    },
    [s, h, n, u]
  ), R = Ie(
    (U) => {
      U.button === 0 && (v(!1), b.remove(document, "mouseup", R, !1));
    },
    [b]
  ), Q = Ie(
    (U) => {
      if (U.button !== 0)
        return;
      if (n) {
        U.stopPropagation(), U.preventDefault();
        return;
      }
      h || v(!0), U.currentTarget.focus({ preventScroll: !0 }), b.add(document, "mouseup", R, !1), o == null || o(U);
    },
    [n, h, o, b, R]
  ), J = Ie(
    (U) => {
      U.button === 0 && (h || v(!1), a == null || a(U));
    },
    [a, h]
  ), we = Ie(
    (U) => {
      if (n) {
        U.preventDefault();
        return;
      }
      f == null || f(U);
    },
    [n, f]
  ), V = Ie(
    (U) => {
      y && (U.preventDefault(), v(!1)), p == null || p(U);
    },
    [y, p]
  ), L = ii(t, w);
  return h ? {
    ...m,
    ref: L,
    type: "button",
    "aria-disabled": E ? void 0 : n,
    disabled: E,
    onClick: x,
    onMouseDown: o,
    onMouseUp: a,
    onKeyUp: u,
    onKeyDown: l,
    onMouseOver: f,
    onMouseLeave: p
  } : {
    ...m,
    ref: L,
    role: "button",
    "data-active": Gs(y),
    "aria-disabled": n ? "true" : void 0,
    tabIndex: E ? void 0 : A,
    onClick: x,
    onMouseDown: Q,
    onMouseUp: J,
    onKeyUp: I,
    onKeyDown: P,
    onMouseOver: we,
    onMouseLeave: V
  };
}
function NAe(e) {
  const t = e.current;
  if (!t)
    return !1;
  const n = dAe(t);
  return !n || t.contains(n) ? !1 : !!mAe(n);
}
function RAe(e, t) {
  const { shouldFocus: n, visible: r, focusRef: i } = t, s = n && !r;
  Hx(() => {
    if (!s || NAe(e))
      return;
    const o = (i == null ? void 0 : i.current) || e.current;
    let a;
    if (o)
      return a = requestAnimationFrame(() => {
        o.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(a);
      };
  }, [s, e, i]);
}
var MAe = {
  preventScroll: !0,
  shouldFocus: !1
};
function FAe(e, t = MAe) {
  const { focusRef: n, preventScroll: r, shouldFocus: i, visible: s } = t, o = jAe(e) ? e.current : e, a = i && s, c = Le(a), l = Le(s);
  ru(() => {
    !l.current && s && (c.current = a), l.current = s;
  }, [s, a]);
  const u = Ie(() => {
    if (!(!s || !o || !c.current) && (c.current = !1, !o.contains(document.activeElement)))
      if (n != null && n.current)
        requestAnimationFrame(() => {
          var d;
          (d = n.current) == null || d.focus({ preventScroll: r });
        });
      else {
        const d = BH(o);
        d.length > 0 && requestAnimationFrame(() => {
          d[0].focus({ preventScroll: r });
        });
      }
  }, [s, r, o, n]);
  Hx(() => {
    u();
  }, [u]), R4(o, "transitionend", u);
}
function jAe(e) {
  return "current" in e;
}
var Hf = (e, t) => ({
  var: e,
  varRef: t ? `var(${e}, ${t})` : `var(${e})`
}), zr = {
  arrowShadowColor: Hf("--popper-arrow-shadow-color"),
  arrowSize: Hf("--popper-arrow-size", "8px"),
  arrowSizeHalf: Hf("--popper-arrow-size-half"),
  arrowBg: Hf("--popper-arrow-bg"),
  transformOrigin: Hf("--popper-transform-origin"),
  arrowOffset: Hf("--popper-arrow-offset")
};
function DAe(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
var UAe = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, LAe = (e) => UAe[e], q7 = {
  scroll: !0,
  resize: !0
};
function zAe(e) {
  let t;
  return typeof e == "object" ? t = {
    enabled: !0,
    options: { ...q7, ...e }
  } : t = {
    enabled: e,
    options: q7
  }, t;
}
var VAe = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const t = e.elements.reference;
    e.elements.popper.style.width = `${t.offsetWidth}px`;
  }
}, HAe = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    $7(e);
  },
  effect: ({ state: e }) => () => {
    $7(e);
  }
}, $7 = (e) => {
  e.elements.popper.style.setProperty(
    zr.transformOrigin.var,
    LAe(e.placement)
  );
}, WAe = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    GAe(e);
  }
}, GAe = (e) => {
  var t;
  if (!e.placement)
    return;
  const n = qAe(e.placement);
  if ((t = e.elements) != null && t.arrow && n) {
    Object.assign(e.elements.arrow.style, {
      [n.property]: n.value,
      width: zr.arrowSize.varRef,
      height: zr.arrowSize.varRef,
      zIndex: -1
    });
    const r = {
      [zr.arrowSizeHalf.var]: `calc(${zr.arrowSize.varRef} / 2 - 1px)`,
      [zr.arrowOffset.var]: `calc(${zr.arrowSizeHalf.varRef} * -1)`
    };
    for (const i in r)
      e.elements.arrow.style.setProperty(i, r[i]);
  }
}, qAe = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: zr.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: zr.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: zr.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: zr.arrowOffset.varRef };
}, $Ae = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    Q7(e);
  },
  effect: ({ state: e }) => () => {
    Q7(e);
  }
}, Q7 = (e) => {
  if (!e.elements.arrow)
    return;
  const t = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!t)
    return;
  const n = DAe(e.placement);
  n && t.style.setProperty("--popper-arrow-default-shadow", n), Object.assign(t.style, {
    transform: "rotate(45deg)",
    background: zr.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, QAe = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, KAe = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function YAe(e, t = "ltr") {
  var n, r;
  const i = ((n = QAe[e]) == null ? void 0 : n[t]) || e;
  return t === "ltr" ? i : (r = KAe[e]) != null ? r : i;
}
var Oi = "top", Ps = "bottom", Os = "right", Ni = "left", K4 = "auto", xv = [Oi, Ps, Os, Ni], Cm = "start", By = "end", ZAe = "clippingParents", jH = "viewport", E0 = "popper", JAe = "reference", K7 = /* @__PURE__ */ xv.reduce(function(e, t) {
  return e.concat([t + "-" + Cm, t + "-" + By]);
}, []), DH = /* @__PURE__ */ [].concat(xv, [K4]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Cm, t + "-" + By]);
}, []), XAe = "beforeRead", eEe = "read", tEe = "afterRead", nEe = "beforeMain", rEe = "main", iEe = "afterMain", sEe = "beforeWrite", oEe = "write", aEe = "afterWrite", cEe = [XAe, eEe, tEe, nEe, rEe, iEe, sEe, oEe, aEe];
function va(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ts(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function cf(e) {
  var t = ts(e).Element;
  return e instanceof t || e instanceof Element;
}
function Bs(e) {
  var t = ts(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Y4(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = ts(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function lEe(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, s = t.elements[n];
    !Bs(s) || !va(s) || (Object.assign(s.style, r), Object.keys(i).forEach(function(o) {
      var a = i[o];
      a === !1 ? s.removeAttribute(o) : s.setAttribute(o, a === !0 ? "" : a);
    }));
  });
}
function uEe(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], s = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), a = o.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !Bs(i) || !va(i) || (Object.assign(i.style, a), Object.keys(s).forEach(function(c) {
        i.removeAttribute(c);
      }));
    });
  };
}
const dEe = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: lEe,
  effect: uEe,
  requires: ["computeStyles"]
};
function pa(e) {
  return e.split("-")[0];
}
var qd = Math.max, e2 = Math.min, Tm = Math.round;
function PC() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function UH() {
  return !/^((?!chrome|android).)*safari/i.test(PC());
}
function km(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, s = 1;
  t && Bs(e) && (i = e.offsetWidth > 0 && Tm(r.width) / e.offsetWidth || 1, s = e.offsetHeight > 0 && Tm(r.height) / e.offsetHeight || 1);
  var o = cf(e) ? ts(e) : window, a = o.visualViewport, c = !UH() && n, l = (r.left + (c && a ? a.offsetLeft : 0)) / i, u = (r.top + (c && a ? a.offsetTop : 0)) / s, d = r.width / i, f = r.height / s;
  return {
    width: d,
    height: f,
    top: u,
    right: l + d,
    bottom: u + f,
    left: l,
    x: l,
    y: u
  };
}
function Z4(e) {
  var t = km(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function LH(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Y4(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Sc(e) {
  return ts(e).getComputedStyle(e);
}
function fEe(e) {
  return ["table", "td", "th"].indexOf(va(e)) >= 0;
}
function vu(e) {
  return ((cf(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function mE(e) {
  return va(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Y4(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    vu(e)
  );
}
function Y7(e) {
  return !Bs(e) || // https://github.com/popperjs/popper-core/issues/837
  Sc(e).position === "fixed" ? null : e.offsetParent;
}
function hEe(e) {
  var t = /firefox/i.test(PC()), n = /Trident/i.test(PC());
  if (n && Bs(e)) {
    var r = Sc(e);
    if (r.position === "fixed")
      return null;
  }
  var i = mE(e);
  for (Y4(i) && (i = i.host); Bs(i) && ["html", "body"].indexOf(va(i)) < 0; ) {
    var s = Sc(i);
    if (s.transform !== "none" || s.perspective !== "none" || s.contain === "paint" || ["transform", "perspective"].indexOf(s.willChange) !== -1 || t && s.willChange === "filter" || t && s.filter && s.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Av(e) {
  for (var t = ts(e), n = Y7(e); n && fEe(n) && Sc(n).position === "static"; )
    n = Y7(n);
  return n && (va(n) === "html" || va(n) === "body" && Sc(n).position === "static") ? t : n || hEe(e) || t;
}
function J4(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Eg(e, t, n) {
  return qd(e, e2(t, n));
}
function pEe(e, t, n) {
  var r = Eg(e, t, n);
  return r > n ? n : r;
}
function zH() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function VH(e) {
  return Object.assign({}, zH(), e);
}
function HH(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var mEe = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, VH(typeof t != "number" ? t : HH(t, xv));
};
function gEe(e) {
  var t, n = e.state, r = e.name, i = e.options, s = n.elements.arrow, o = n.modifiersData.popperOffsets, a = pa(n.placement), c = J4(a), l = [Ni, Os].indexOf(a) >= 0, u = l ? "height" : "width";
  if (!(!s || !o)) {
    var d = mEe(i.padding, n), f = Z4(s), p = c === "y" ? Oi : Ni, m = c === "y" ? Ps : Os, h = n.rects.reference[u] + n.rects.reference[c] - o[c] - n.rects.popper[u], g = o[c] - n.rects.reference[c], y = Av(s), v = y ? c === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, b = h / 2 - g / 2, w = d[p], A = v - f[u] - d[m], E = v / 2 - f[u] / 2 + b, x = Eg(w, E, A), S = c;
    n.modifiersData[r] = (t = {}, t[S] = x, t.centerOffset = x - E, t);
  }
}
function yEe(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || LH(t.elements.popper, i) && (t.elements.arrow = i));
}
const bEe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: gEe,
  effect: yEe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Bm(e) {
  return e.split("-")[1];
}
var vEe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function wEe(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: Tm(n * i) / i || 0,
    y: Tm(r * i) / i || 0
  };
}
function Z7(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, s = e.variation, o = e.offsets, a = e.position, c = e.gpuAcceleration, l = e.adaptive, u = e.roundOffsets, d = e.isFixed, f = o.x, p = f === void 0 ? 0 : f, m = o.y, h = m === void 0 ? 0 : m, g = typeof u == "function" ? u({
    x: p,
    y: h
  }) : {
    x: p,
    y: h
  };
  p = g.x, h = g.y;
  var y = o.hasOwnProperty("x"), v = o.hasOwnProperty("y"), b = Ni, w = Oi, A = window;
  if (l) {
    var E = Av(n), x = "clientHeight", S = "clientWidth";
    if (E === ts(n) && (E = vu(n), Sc(E).position !== "static" && a === "absolute" && (x = "scrollHeight", S = "scrollWidth")), E = E, i === Oi || (i === Ni || i === Os) && s === By) {
      w = Ps;
      var P = d && E === A && A.visualViewport ? A.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        E[x]
      );
      h -= P - r.height, h *= c ? 1 : -1;
    }
    if (i === Ni || (i === Oi || i === Ps) && s === By) {
      b = Os;
      var I = d && E === A && A.visualViewport ? A.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        E[S]
      );
      p -= I - r.width, p *= c ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: a
  }, l && vEe), Q = u === !0 ? wEe({
    x: p,
    y: h
  }, ts(n)) : {
    x: p,
    y: h
  };
  if (p = Q.x, h = Q.y, c) {
    var J;
    return Object.assign({}, R, (J = {}, J[w] = v ? "0" : "", J[b] = y ? "0" : "", J.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + h + "px)" : "translate3d(" + p + "px, " + h + "px, 0)", J));
  }
  return Object.assign({}, R, (t = {}, t[w] = v ? h + "px" : "", t[b] = y ? p + "px" : "", t.transform = "", t));
}
function xEe(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, s = n.adaptive, o = s === void 0 ? !0 : s, a = n.roundOffsets, c = a === void 0 ? !0 : a, l = {
    placement: pa(t.placement),
    variation: Bm(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Z7(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Z7(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const AEe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: xEe,
  data: {}
};
var p1 = {
  passive: !0
};
function EEe(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, s = i === void 0 ? !0 : i, o = r.resize, a = o === void 0 ? !0 : o, c = ts(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return s && l.forEach(function(u) {
    u.addEventListener("scroll", n.update, p1);
  }), a && c.addEventListener("resize", n.update, p1), function() {
    s && l.forEach(function(u) {
      u.removeEventListener("scroll", n.update, p1);
    }), a && c.removeEventListener("resize", n.update, p1);
  };
}
const _Ee = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: EEe,
  data: {}
};
var SEe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Bw(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return SEe[t];
  });
}
var CEe = {
  start: "end",
  end: "start"
};
function J7(e) {
  return e.replace(/start|end/g, function(t) {
    return CEe[t];
  });
}
function X4(e) {
  var t = ts(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function e8(e) {
  return km(vu(e)).left + X4(e).scrollLeft;
}
function TEe(e, t) {
  var n = ts(e), r = vu(e), i = n.visualViewport, s = r.clientWidth, o = r.clientHeight, a = 0, c = 0;
  if (i) {
    s = i.width, o = i.height;
    var l = UH();
    (l || !l && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a + e8(e),
    y: c
  };
}
function kEe(e) {
  var t, n = vu(e), r = X4(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, s = qd(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = qd(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -r.scrollLeft + e8(e), c = -r.scrollTop;
  return Sc(i || n).direction === "rtl" && (a += qd(n.clientWidth, i ? i.clientWidth : 0) - s), {
    width: s,
    height: o,
    x: a,
    y: c
  };
}
function t8(e) {
  var t = Sc(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function WH(e) {
  return ["html", "body", "#document"].indexOf(va(e)) >= 0 ? e.ownerDocument.body : Bs(e) && t8(e) ? e : WH(mE(e));
}
function _g(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = WH(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = ts(r), o = i ? [s].concat(s.visualViewport || [], t8(r) ? r : []) : r, a = t.concat(o);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(_g(mE(o)))
  );
}
function OC(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function BEe(e, t) {
  var n = km(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function X7(e, t, n) {
  return t === jH ? OC(TEe(e, n)) : cf(t) ? BEe(t, n) : OC(kEe(vu(e)));
}
function IEe(e) {
  var t = _g(mE(e)), n = ["absolute", "fixed"].indexOf(Sc(e).position) >= 0, r = n && Bs(e) ? Av(e) : e;
  return cf(r) ? t.filter(function(i) {
    return cf(i) && LH(i, r) && va(i) !== "body";
  }) : [];
}
function PEe(e, t, n, r) {
  var i = t === "clippingParents" ? IEe(e) : [].concat(t), s = [].concat(i, [n]), o = s[0], a = s.reduce(function(c, l) {
    var u = X7(e, l, r);
    return c.top = qd(u.top, c.top), c.right = e2(u.right, c.right), c.bottom = e2(u.bottom, c.bottom), c.left = qd(u.left, c.left), c;
  }, X7(e, o, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function GH(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? pa(r) : null, s = r ? Bm(r) : null, o = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, c;
  switch (i) {
    case Oi:
      c = {
        x: o,
        y: t.y - n.height
      };
      break;
    case Ps:
      c = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Os:
      c = {
        x: t.x + t.width,
        y: a
      };
      break;
    case Ni:
      c = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var l = i ? J4(i) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (s) {
      case Cm:
        c[l] = c[l] - (t[u] / 2 - n[u] / 2);
        break;
      case By:
        c[l] = c[l] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return c;
}
function Iy(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, s = n.strategy, o = s === void 0 ? e.strategy : s, a = n.boundary, c = a === void 0 ? ZAe : a, l = n.rootBoundary, u = l === void 0 ? jH : l, d = n.elementContext, f = d === void 0 ? E0 : d, p = n.altBoundary, m = p === void 0 ? !1 : p, h = n.padding, g = h === void 0 ? 0 : h, y = VH(typeof g != "number" ? g : HH(g, xv)), v = f === E0 ? JAe : E0, b = e.rects.popper, w = e.elements[m ? v : f], A = PEe(cf(w) ? w : w.contextElement || vu(e.elements.popper), c, u, o), E = km(e.elements.reference), x = GH({
    reference: E,
    element: b,
    strategy: "absolute",
    placement: i
  }), S = OC(Object.assign({}, b, x)), P = f === E0 ? S : E, I = {
    top: A.top - P.top + y.top,
    bottom: P.bottom - A.bottom + y.bottom,
    left: A.left - P.left + y.left,
    right: P.right - A.right + y.right
  }, R = e.modifiersData.offset;
  if (f === E0 && R) {
    var Q = R[i];
    Object.keys(I).forEach(function(J) {
      var we = [Os, Ps].indexOf(J) >= 0 ? 1 : -1, V = [Oi, Ps].indexOf(J) >= 0 ? "y" : "x";
      I[J] += Q[V] * we;
    });
  }
  return I;
}
function OEe(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, s = n.rootBoundary, o = n.padding, a = n.flipVariations, c = n.allowedAutoPlacements, l = c === void 0 ? DH : c, u = Bm(r), d = u ? a ? K7 : K7.filter(function(m) {
    return Bm(m) === u;
  }) : xv, f = d.filter(function(m) {
    return l.indexOf(m) >= 0;
  });
  f.length === 0 && (f = d);
  var p = f.reduce(function(m, h) {
    return m[h] = Iy(e, {
      placement: h,
      boundary: i,
      rootBoundary: s,
      padding: o
    })[pa(h)], m;
  }, {});
  return Object.keys(p).sort(function(m, h) {
    return p[m] - p[h];
  });
}
function NEe(e) {
  if (pa(e) === K4)
    return [];
  var t = Bw(e);
  return [J7(e), t, J7(t)];
}
function REe(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, s = i === void 0 ? !0 : i, o = n.altAxis, a = o === void 0 ? !0 : o, c = n.fallbackPlacements, l = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.flipVariations, m = p === void 0 ? !0 : p, h = n.allowedAutoPlacements, g = t.options.placement, y = pa(g), v = y === g, b = c || (v || !m ? [Bw(g)] : NEe(g)), w = [g].concat(b).reduce(function(B, be) {
      return B.concat(pa(be) === K4 ? OEe(t, {
        placement: be,
        boundary: u,
        rootBoundary: d,
        padding: l,
        flipVariations: m,
        allowedAutoPlacements: h
      }) : be);
    }, []), A = t.rects.reference, E = t.rects.popper, x = /* @__PURE__ */ new Map(), S = !0, P = w[0], I = 0; I < w.length; I++) {
      var R = w[I], Q = pa(R), J = Bm(R) === Cm, we = [Oi, Ps].indexOf(Q) >= 0, V = we ? "width" : "height", L = Iy(t, {
        placement: R,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: l
      }), U = we ? J ? Os : Ni : J ? Ps : Oi;
      A[V] > E[V] && (U = Bw(U));
      var q = Bw(U), G = [];
      if (s && G.push(L[Q] <= 0), a && G.push(L[U] <= 0, L[q] <= 0), G.every(function(B) {
        return B;
      })) {
        P = R, S = !1;
        break;
      }
      x.set(R, G);
    }
    if (S)
      for (var ae = m ? 3 : 1, ge = function(be) {
        var Be = w.find(function(Ne) {
          var _e = x.get(Ne);
          if (_e)
            return _e.slice(0, be).every(function(Ce) {
              return Ce;
            });
        });
        if (Be)
          return P = Be, "break";
      }, Ae = ae; Ae > 0; Ae--) {
        var he = ge(Ae);
        if (he === "break")
          break;
      }
    t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
  }
}
const MEe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: REe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function eN(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function tN(e) {
  return [Oi, Os, Ps, Ni].some(function(t) {
    return e[t] >= 0;
  });
}
function FEe(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, s = t.modifiersData.preventOverflow, o = Iy(t, {
    elementContext: "reference"
  }), a = Iy(t, {
    altBoundary: !0
  }), c = eN(o, r), l = eN(a, i, s), u = tN(c), d = tN(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const jEe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: FEe
};
function DEe(e, t, n) {
  var r = pa(e), i = [Ni, Oi].indexOf(r) >= 0 ? -1 : 1, s = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = s[0], a = s[1];
  return o = o || 0, a = (a || 0) * i, [Ni, Os].indexOf(r) >= 0 ? {
    x: a,
    y: o
  } : {
    x: o,
    y: a
  };
}
function UEe(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, s = i === void 0 ? [0, 0] : i, o = DH.reduce(function(u, d) {
    return u[d] = DEe(d, t.rects, s), u;
  }, {}), a = o[t.placement], c = a.x, l = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = o;
}
const LEe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: UEe
};
function zEe(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = GH({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const VEe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: zEe,
  data: {}
};
function HEe(e) {
  return e === "x" ? "y" : "x";
}
function WEe(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, s = i === void 0 ? !0 : i, o = n.altAxis, a = o === void 0 ? !1 : o, c = n.boundary, l = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, p = f === void 0 ? !0 : f, m = n.tetherOffset, h = m === void 0 ? 0 : m, g = Iy(t, {
    boundary: c,
    rootBoundary: l,
    padding: d,
    altBoundary: u
  }), y = pa(t.placement), v = Bm(t.placement), b = !v, w = J4(y), A = HEe(w), E = t.modifiersData.popperOffsets, x = t.rects.reference, S = t.rects.popper, P = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, I = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), R = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, Q = {
    x: 0,
    y: 0
  };
  if (E) {
    if (s) {
      var J, we = w === "y" ? Oi : Ni, V = w === "y" ? Ps : Os, L = w === "y" ? "height" : "width", U = E[w], q = U + g[we], G = U - g[V], ae = p ? -S[L] / 2 : 0, ge = v === Cm ? x[L] : S[L], Ae = v === Cm ? -S[L] : -x[L], he = t.elements.arrow, B = p && he ? Z4(he) : {
        width: 0,
        height: 0
      }, be = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : zH(), Be = be[we], Ne = be[V], _e = Eg(0, x[L], B[L]), Ce = b ? x[L] / 2 - ae - _e - Be - I.mainAxis : ge - _e - Be - I.mainAxis, N = b ? -x[L] / 2 + ae + _e + Ne + I.mainAxis : Ae + _e + Ne + I.mainAxis, F = t.elements.arrow && Av(t.elements.arrow), z = F ? w === "y" ? F.clientTop || 0 : F.clientLeft || 0 : 0, ne = (J = R == null ? void 0 : R[w]) != null ? J : 0, ee = U + Ce - ne - z, Y = U + N - ne, X = Eg(p ? e2(q, ee) : q, U, p ? qd(G, Y) : G);
      E[w] = X, Q[w] = X - U;
    }
    if (a) {
      var $, ie = w === "x" ? Oi : Ni, fe = w === "x" ? Ps : Os, oe = E[A], me = A === "y" ? "height" : "width", Me = oe + g[ie], je = oe - g[fe], Ye = [Oi, Ni].indexOf(y) !== -1, Oe = ($ = R == null ? void 0 : R[A]) != null ? $ : 0, De = Ye ? Me : oe - x[me] - S[me] - Oe + I.altAxis, Te = Ye ? oe + x[me] + S[me] - Oe - I.altAxis : je, Fe = p && Ye ? pEe(De, oe, Te) : Eg(p ? De : Me, oe, p ? Te : je);
      E[A] = Fe, Q[A] = Fe - oe;
    }
    t.modifiersData[r] = Q;
  }
}
const GEe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: WEe,
  requiresIfExists: ["offset"]
};
function qEe(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function $Ee(e) {
  return e === ts(e) || !Bs(e) ? X4(e) : qEe(e);
}
function QEe(e) {
  var t = e.getBoundingClientRect(), n = Tm(t.width) / e.offsetWidth || 1, r = Tm(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function KEe(e, t, n) {
  n === void 0 && (n = !1);
  var r = Bs(t), i = Bs(t) && QEe(t), s = vu(t), o = km(e, i, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((va(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  t8(s)) && (a = $Ee(t)), Bs(t) ? (c = km(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : s && (c.x = e8(s))), {
    x: o.left + a.scrollLeft - c.x,
    y: o.top + a.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function YEe(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(s) {
    t.set(s.name, s);
  });
  function i(s) {
    n.add(s.name);
    var o = [].concat(s.requires || [], s.requiresIfExists || []);
    o.forEach(function(a) {
      if (!n.has(a)) {
        var c = t.get(a);
        c && i(c);
      }
    }), r.push(s);
  }
  return e.forEach(function(s) {
    n.has(s.name) || i(s);
  }), r;
}
function ZEe(e) {
  var t = YEe(e);
  return cEe.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function JEe(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function XEe(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var nN = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function rN() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function e3e(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, s = i === void 0 ? nN : i;
  return function(a, c, l) {
    l === void 0 && (l = s);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, nN, s),
      modifiersData: {},
      elements: {
        reference: a,
        popper: c
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, p = {
      state: u,
      setOptions: function(y) {
        var v = typeof y == "function" ? y(u.options) : y;
        h(), u.options = Object.assign({}, s, u.options, v), u.scrollParents = {
          reference: cf(a) ? _g(a) : a.contextElement ? _g(a.contextElement) : [],
          popper: _g(c)
        };
        var b = ZEe(XEe([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = b.filter(function(w) {
          return w.enabled;
        }), m(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var y = u.elements, v = y.reference, b = y.popper;
          if (rN(v, b)) {
            u.rects = {
              reference: KEe(v, Av(b), u.options.strategy === "fixed"),
              popper: Z4(b)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(I) {
              return u.modifiersData[I.name] = Object.assign({}, I.data);
            });
            for (var w = 0; w < u.orderedModifiers.length; w++) {
              if (u.reset === !0) {
                u.reset = !1, w = -1;
                continue;
              }
              var A = u.orderedModifiers[w], E = A.fn, x = A.options, S = x === void 0 ? {} : x, P = A.name;
              typeof E == "function" && (u = E({
                state: u,
                options: S,
                name: P,
                instance: p
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: JEe(function() {
        return new Promise(function(g) {
          p.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        h(), f = !0;
      }
    };
    if (!rN(a, c))
      return p;
    p.setOptions(l).then(function(g) {
      !f && l.onFirstUpdate && l.onFirstUpdate(g);
    });
    function m() {
      u.orderedModifiers.forEach(function(g) {
        var y = g.name, v = g.options, b = v === void 0 ? {} : v, w = g.effect;
        if (typeof w == "function") {
          var A = w({
            state: u,
            name: y,
            instance: p,
            options: b
          }), E = function() {
          };
          d.push(A || E);
        }
      });
    }
    function h() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return p;
  };
}
var t3e = [_Ee, VEe, AEe, dEe, LEe, MEe, GEe, bEe, jEe], n3e = /* @__PURE__ */ e3e({
  defaultModifiers: t3e
});
function r3e(e = {}) {
  const {
    enabled: t = !0,
    modifiers: n,
    placement: r = "bottom",
    strategy: i = "absolute",
    arrowPadding: s = 8,
    eventListeners: o = !0,
    offset: a,
    gutter: c = 8,
    flip: l = !0,
    boundary: u = "clippingParents",
    preventOverflow: d = !0,
    matchWidth: f,
    direction: p = "ltr"
  } = e, m = Le(null), h = Le(null), g = Le(null), y = YAe(r, p), v = Le(() => {
  }), b = Ie(() => {
    var I;
    !t || !m.current || !h.current || ((I = v.current) == null || I.call(v), g.current = n3e(m.current, h.current, {
      placement: y,
      modifiers: [
        $Ae,
        WAe,
        HAe,
        {
          ...VAe,
          enabled: !!f
        },
        {
          name: "eventListeners",
          ...zAe(o)
        },
        {
          name: "arrow",
          options: { padding: s }
        },
        {
          name: "offset",
          options: {
            offset: a ?? [0, c]
          }
        },
        {
          name: "flip",
          enabled: !!l,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!d,
          options: { boundary: u }
        },
        // allow users override internal modifiers
        ...n ?? []
      ],
      strategy: i
    }), g.current.forceUpdate(), v.current = g.current.destroy);
  }, [
    y,
    t,
    n,
    f,
    o,
    s,
    a,
    c,
    l,
    d,
    u,
    i
  ]);
  We(() => () => {
    var I;
    !m.current && !h.current && ((I = g.current) == null || I.destroy(), g.current = null);
  }, []);
  const w = Ie(
    (I) => {
      m.current = I, b();
    },
    [b]
  ), A = Ie(
    (I = {}, R = null) => ({
      ...I,
      ref: ii(w, R)
    }),
    [w]
  ), E = Ie(
    (I) => {
      h.current = I, b();
    },
    [b]
  ), x = Ie(
    (I = {}, R = null) => ({
      ...I,
      ref: ii(E, R),
      style: {
        ...I.style,
        position: i,
        minWidth: f ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [i, E, f]
  ), S = Ie((I = {}, R = null) => {
    const { size: Q, shadowColor: J, bg: we, style: V, ...L } = I;
    return {
      ...L,
      ref: R,
      "data-popper-arrow": "",
      style: i3e(I)
    };
  }, []), P = Ie(
    (I = {}, R = null) => ({
      ...I,
      ref: R,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var I;
      (I = g.current) == null || I.update();
    },
    forceUpdate() {
      var I;
      (I = g.current) == null || I.forceUpdate();
    },
    transformOrigin: zr.transformOrigin.varRef,
    referenceRef: w,
    popperRef: E,
    getPopperProps: x,
    getArrowProps: S,
    getArrowInnerProps: P,
    getReferenceProps: A
  };
}
function i3e(e) {
  const { size: t, shadowColor: n, bg: r, style: i } = e, s = { ...i, position: "absolute" };
  return t && (s["--popper-arrow-size"] = t), n && (s["--popper-arrow-shadow-color"] = n), r && (s["--popper-arrow-bg"] = r), s;
}
function s3e(e = {}) {
  const {
    onClose: t,
    onOpen: n,
    isOpen: r,
    id: i
  } = e, s = zd(n), o = zd(t), [a, c] = qe(e.defaultIsOpen || !1), l = r !== void 0 ? r : a, u = r !== void 0, d = mu(), f = i ?? `disclosure-${d}`, p = Ie(() => {
    u || c(!1), o == null || o();
  }, [u, o]), m = Ie(() => {
    u || c(!0), s == null || s();
  }, [u, s]), h = Ie(() => {
    l ? p() : m();
  }, [l, m, p]);
  function g(v = {}) {
    return {
      ...v,
      "aria-expanded": l,
      "aria-controls": f,
      onClick(b) {
        var w;
        (w = v.onClick) == null || w.call(v, b), h();
      }
    };
  }
  function y(v = {}) {
    return {
      ...v,
      hidden: !l,
      id: f
    };
  }
  return {
    isOpen: l,
    onOpen: m,
    onClose: p,
    onToggle: h,
    isControlled: u,
    getButtonProps: g,
    getDisclosureProps: y
  };
}
function o3e(e) {
  const { isOpen: t, ref: n } = e, [r, i] = qe(t), [s, o] = qe(!1);
  return We(() => {
    s || (i(t), o(!0));
  }, [t, s, r]), R4(
    () => n.current,
    "animationend",
    () => {
      i(t);
    }
  ), {
    present: !(t ? !1 : !r),
    onComplete() {
      var c;
      const l = uAe(n.current), u = new l.CustomEvent("animationend", { bubbles: !0 });
      (c = n.current) == null || c.dispatchEvent(u);
    }
  };
}
function qH(e) {
  const { wasSelected: t, enabled: n, isSelected: r, mode: i = "unmount" } = e;
  return !!(!n || r || i === "keepMounted" && t);
}
var a3e = {
  slideInBottom: {
    ...$0,
    custom: { offsetY: 16, reverse: !0 }
  },
  slideInRight: {
    ...$0,
    custom: { offsetX: 16, reverse: !0 }
  },
  slideInTop: {
    ...$0,
    custom: { offsetY: -16, reverse: !0 }
  },
  slideInLeft: {
    ...$0,
    custom: { offsetX: -16, reverse: !0 }
  },
  scale: {
    ...ZV,
    custom: { initialScale: 0.95, reverse: !0 }
  },
  none: {}
}, c3e = yt(If.section), l3e = (e) => a3e[e || "none"], $H = Bc(
  (e, t) => {
    const { preset: n, motionProps: r = l3e(n), ...i } = e;
    return /* @__PURE__ */ D.jsx(c3e, { ref: t, ...r, ...i });
  }
);
$H.displayName = "ModalTransition";
var u3e = Object.defineProperty, d3e = (e, t, n) => t in e ? u3e(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, f3e = (e, t, n) => (d3e(e, t + "", n), n), h3e = class {
  constructor() {
    f3e(this, "modals"), this.modals = /* @__PURE__ */ new Map();
  }
  add(e) {
    return this.modals.set(e, this.modals.size + 1), this.modals.size;
  }
  remove(e) {
    this.modals.delete(e);
  }
  isTopModal(e) {
    return e ? this.modals.get(e) === this.modals.size : !1;
  }
}, NC = new h3e();
function QH(e, t) {
  const [n, r] = qe(0);
  return We(() => {
    const i = e.current;
    if (i) {
      if (t) {
        const s = NC.add(i);
        r(s);
      }
      return () => {
        NC.remove(i), r(0);
      };
    }
  }, [t, e]), n;
}
var p3e = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Wf = /* @__PURE__ */ new WeakMap(), m1 = /* @__PURE__ */ new WeakMap(), g1 = {}, H_ = 0, KH = function(e) {
  return e && (e.host || KH(e.parentNode));
}, m3e = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = KH(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, g3e = function(e, t, n, r) {
  var i = m3e(t, Array.isArray(e) ? e : [e]);
  g1[n] || (g1[n] = /* @__PURE__ */ new WeakMap());
  var s = g1[n], o = [], a = /* @__PURE__ */ new Set(), c = new Set(i), l = function(d) {
    !d || a.has(d) || (a.add(d), l(d.parentNode));
  };
  i.forEach(l);
  var u = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var p = f.getAttribute(r), m = p !== null && p !== "false", h = (Wf.get(f) || 0) + 1, g = (s.get(f) || 0) + 1;
          Wf.set(f, h), s.set(f, g), o.push(f), h === 1 && m && m1.set(f, !0), g === 1 && f.setAttribute(n, "true"), m || f.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", f, y);
        }
    });
  };
  return u(t), a.clear(), H_++, function() {
    o.forEach(function(d) {
      var f = Wf.get(d) - 1, p = s.get(d) - 1;
      Wf.set(d, f), s.set(d, p), f || (m1.has(d) || d.removeAttribute(r), m1.delete(d)), p || d.removeAttribute(n);
    }), H_--, H_ || (Wf = /* @__PURE__ */ new WeakMap(), Wf = /* @__PURE__ */ new WeakMap(), m1 = /* @__PURE__ */ new WeakMap(), g1 = {});
  };
}, y3e = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = p3e(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), g3e(r, i, n, "aria-hidden")) : function() {
    return null;
  };
};
function b3e(e) {
  const {
    isOpen: t,
    onClose: n,
    id: r,
    closeOnOverlayClick: i = !0,
    closeOnEsc: s = !0,
    useInert: o = !0,
    onOverlayClick: a,
    onEsc: c
  } = e, l = Le(null), u = Le(null), [d, f, p] = w3e(
    r,
    "chakra-modal",
    "chakra-modal--header",
    "chakra-modal--body"
  );
  v3e(l, t && o);
  const m = QH(l, t), h = Le(null), g = Ie((P) => {
    h.current = P.target;
  }, []), y = Ie(
    (P) => {
      P.key === "Escape" && (P.stopPropagation(), s && (n == null || n()), c == null || c());
    },
    [s, n, c]
  ), [v, b] = qe(!1), [w, A] = qe(!1), E = Ie(
    (P = {}, I = null) => ({
      role: "dialog",
      ...P,
      ref: ii(I, l),
      id: d,
      tabIndex: -1,
      "aria-modal": !0,
      "aria-labelledby": v ? f : void 0,
      "aria-describedby": w ? p : void 0,
      onClick: Xn(
        P.onClick,
        (R) => R.stopPropagation()
      )
    }),
    [p, w, d, f, v]
  ), x = Ie(
    (P) => {
      P.stopPropagation(), h.current === P.target && NC.isTopModal(l.current) && (i && (n == null || n()), a == null || a());
    },
    [n, i, a]
  ), S = Ie(
    (P = {}, I = null) => ({
      ...P,
      ref: ii(I, u),
      onClick: Xn(P.onClick, x),
      onKeyDown: Xn(P.onKeyDown, y),
      onMouseDown: Xn(P.onMouseDown, g)
    }),
    [y, g, x]
  );
  return {
    isOpen: t,
    onClose: n,
    headerId: f,
    bodyId: p,
    setBodyMounted: A,
    setHeaderMounted: b,
    dialogRef: l,
    overlayRef: u,
    getDialogProps: E,
    getDialogContainerProps: S,
    index: m
  };
}
function v3e(e, t) {
  const n = e.current;
  We(() => {
    if (!(!e.current || !t))
      return y3e(e.current);
  }, [t, e, n]);
}
function w3e(e, ...t) {
  const n = mu(), r = e || n;
  return ot(() => t.map((i) => `${i}-${r}`), [r, t]);
}
var [x3e, n8] = Ir({
  name: "ModalStylesContext",
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
}), [A3e, Py] = Ir({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
}), YH = (e) => {
  const t = {
    scrollBehavior: "outside",
    autoFocus: !0,
    trapFocus: !0,
    returnFocusOnClose: !0,
    blockScrollOnMount: !0,
    allowPinchZoom: !1,
    motionPreset: "scale",
    lockFocusAcrossFrames: !0,
    ...e
  }, {
    portalProps: n,
    children: r,
    autoFocus: i,
    trapFocus: s,
    initialFocusRef: o,
    finalFocusRef: a,
    returnFocusOnClose: c,
    blockScrollOnMount: l,
    allowPinchZoom: u,
    preserveScrollBarGap: d,
    motionPreset: f,
    lockFocusAcrossFrames: p,
    onCloseComplete: m
  } = t, h = kf("Modal", t), y = {
    ...b3e(t),
    autoFocus: i,
    trapFocus: s,
    initialFocusRef: o,
    finalFocusRef: a,
    returnFocusOnClose: c,
    blockScrollOnMount: l,
    allowPinchZoom: u,
    preserveScrollBarGap: d,
    motionPreset: f,
    lockFocusAcrossFrames: p
  };
  return /* @__PURE__ */ D.jsx(A3e, { value: y, children: /* @__PURE__ */ D.jsx(x3e, { value: h, children: /* @__PURE__ */ D.jsx(wv, { onExitComplete: m, children: y.isOpen && /* @__PURE__ */ D.jsx(hv, { ...n, children: r }) }) }) });
};
YH.displayName = "Modal";
var ZH = v5(), W_ = function() {
}, gE = ye.forwardRef(function(e, t) {
  var n = ye.useRef(null), r = ye.useState({
    onScrollCapture: W_,
    onWheelCapture: W_,
    onTouchMoveCapture: W_
  }), i = r[0], s = r[1], o = e.forwardProps, a = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noIsolation, m = e.inert, h = e.allowPinchZoom, g = e.as, y = g === void 0 ? "div" : g, v = e.gapMode, b = g5(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = f, A = y5([n, t]), E = Vr(Vr({}, b), i);
  return ye.createElement(
    ye.Fragment,
    null,
    u && ye.createElement(w, { sideCar: ZH, removeScrollBar: l, shards: d, noIsolation: p, inert: m, setCallbacks: s, allowPinchZoom: !!h, lockRef: n, gapMode: v }),
    o ? ye.cloneElement(ye.Children.only(a), Vr(Vr({}, E), { ref: A })) : ye.createElement(y, Vr({}, E, { className: c, ref: A }), a)
  );
});
gE.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
gE.classNames = {
  fullWidth: dg,
  zeroRight: ug
};
var RC = !1;
if (typeof window < "u")
  try {
    var y1 = Object.defineProperty({}, "passive", {
      get: function() {
        return RC = !0, !0;
      }
    });
    window.addEventListener("test", y1, y1), window.removeEventListener("test", y1, y1);
  } catch {
    RC = !1;
  }
var Gf = RC ? { passive: !1 } : !1, E3e = function(e) {
  return e.tagName === "TEXTAREA";
}, JH = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !E3e(e) && n[t] === "visible")
  );
}, _3e = function(e) {
  return JH(e, "overflowY");
}, S3e = function(e) {
  return JH(e, "overflowX");
}, iN = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = XH(e, r);
    if (i) {
      var s = eW(e, r), o = s[1], a = s[2];
      if (o > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, C3e = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, T3e = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, XH = function(e, t) {
  return e === "v" ? _3e(t) : S3e(t);
}, eW = function(e, t) {
  return e === "v" ? C3e(t) : T3e(t);
}, k3e = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, B3e = function(e, t, n, r, i) {
  var s = k3e(e, window.getComputedStyle(t).direction), o = s * r, a = n.target, c = t.contains(a), l = !1, u = o > 0, d = 0, f = 0;
  do {
    var p = eW(e, a), m = p[0], h = p[1], g = p[2], y = h - g - s * m;
    (m || y) && XH(e, a) && (d += y, f += m), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (u && (Math.abs(d) < 1 || !i) || !u && (Math.abs(f) < 1 || !i)) && (l = !0), l;
}, b1 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, sN = function(e) {
  return [e.deltaX, e.deltaY];
}, oN = function(e) {
  return e && "current" in e ? e.current : e;
}, I3e = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, P3e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, O3e = 0, qf = [];
function N3e(e) {
  var t = ye.useRef([]), n = ye.useRef([0, 0]), r = ye.useRef(), i = ye.useState(O3e++)[0], s = ye.useState(w5)[0], o = ye.useRef(e);
  ye.useEffect(function() {
    o.current = e;
  }, [e]), ye.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var h = qD([e.lockRef.current], (e.shards || []).map(oN), !0).filter(Boolean);
      return h.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), h.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = ye.useCallback(function(h, g) {
    if ("touches" in h && h.touches.length === 2)
      return !o.current.allowPinchZoom;
    var y = b1(h), v = n.current, b = "deltaX" in h ? h.deltaX : v[0] - y[0], w = "deltaY" in h ? h.deltaY : v[1] - y[1], A, E = h.target, x = Math.abs(b) > Math.abs(w) ? "h" : "v";
    if ("touches" in h && x === "h" && E.type === "range")
      return !1;
    var S = iN(x, E);
    if (!S)
      return !0;
    if (S ? A = x : (A = x === "v" ? "h" : "v", S = iN(x, E)), !S)
      return !1;
    if (!r.current && "changedTouches" in h && (b || w) && (r.current = A), !A)
      return !0;
    var P = r.current || A;
    return B3e(P, g, h, P === "h" ? b : w, !0);
  }, []), c = ye.useCallback(function(h) {
    var g = h;
    if (!(!qf.length || qf[qf.length - 1] !== s)) {
      var y = "deltaY" in g ? sN(g) : b1(g), v = t.current.filter(function(A) {
        return A.name === g.type && (A.target === g.target || g.target === A.shadowParent) && I3e(A.delta, y);
      })[0];
      if (v && v.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!v) {
        var b = (o.current.shards || []).map(oN).filter(Boolean).filter(function(A) {
          return A.contains(g.target);
        }), w = b.length > 0 ? a(g, b[0]) : !o.current.noIsolation;
        w && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = ye.useCallback(function(h, g, y, v) {
    var b = { name: h, delta: g, target: y, should: v, shadowParent: R3e(y) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== b;
      });
    }, 1);
  }, []), u = ye.useCallback(function(h) {
    n.current = b1(h), r.current = void 0;
  }, []), d = ye.useCallback(function(h) {
    l(h.type, sN(h), h.target, a(h, e.lockRef.current));
  }, []), f = ye.useCallback(function(h) {
    l(h.type, b1(h), h.target, a(h, e.lockRef.current));
  }, []);
  ye.useEffect(function() {
    return qf.push(s), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, Gf), document.addEventListener("touchmove", c, Gf), document.addEventListener("touchstart", u, Gf), function() {
      qf = qf.filter(function(h) {
        return h !== s;
      }), document.removeEventListener("wheel", c, Gf), document.removeEventListener("touchmove", c, Gf), document.removeEventListener("touchstart", u, Gf);
    };
  }, []);
  var p = e.removeScrollBar, m = e.inert;
  return ye.createElement(
    ye.Fragment,
    null,
    m ? ye.createElement(s, { styles: P3e(i) }) : null,
    p ? ye.createElement(JD, { gapMode: e.gapMode }) : null
  );
}
function R3e(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const M3e = YD(ZH, N3e);
var tW = ye.forwardRef(function(e, t) {
  return ye.createElement(gE, Vr({}, e, { ref: t, sideCar: M3e }));
});
tW.classNames = gE.classNames;
function F3e(e) {
  const {
    autoFocus: t,
    trapFocus: n,
    dialogRef: r,
    initialFocusRef: i,
    blockScrollOnMount: s,
    allowPinchZoom: o,
    finalFocusRef: a,
    returnFocusOnClose: c,
    preserveScrollBarGap: l,
    lockFocusAcrossFrames: u,
    isOpen: d
  } = Py(), [f, p] = CV();
  We(() => {
    !f && p && setTimeout(p);
  }, [f, p]);
  const m = QH(r, d);
  return /* @__PURE__ */ D.jsx(
    IH,
    {
      autoFocus: t,
      isDisabled: !n,
      initialFocusRef: i,
      finalFocusRef: a,
      restoreFocus: c,
      contentRef: r,
      lockFocusAcrossFrames: u,
      children: /* @__PURE__ */ D.jsx(
        tW,
        {
          removeScrollBar: !l,
          allowPinchZoom: o,
          enabled: m === 1 && s,
          forwardProps: !0,
          children: e.children
        }
      )
    }
  );
}
var nW = Nt(
  (e, t) => {
    const {
      className: n,
      children: r,
      containerProps: i,
      motionProps: s,
      ...o
    } = e, { getDialogProps: a, getDialogContainerProps: c } = Py(), l = a(o, t), u = c(i), d = Wt("chakra-modal__content", n), f = n8(), p = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...f.dialog
    }, m = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...f.dialogContainer
    }, { motionPreset: h } = Py();
    return /* @__PURE__ */ D.jsx(F3e, { children: /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ...u,
        className: "chakra-modal__content-container",
        tabIndex: -1,
        __css: m,
        children: /* @__PURE__ */ D.jsx(
          $H,
          {
            preset: h,
            motionProps: s,
            className: d,
            ...l,
            __css: p,
            children: r
          }
        )
      }
    ) });
  }
);
nW.displayName = "ModalContent";
var j3e = yt(If.div), rW = Nt(
  (e, t) => {
    const { className: n, transition: r, motionProps: i, ...s } = e, o = Wt("chakra-modal__overlay", n), c = {
      pos: "fixed",
      left: "0",
      top: "0",
      w: "100vw",
      h: "100vh",
      ...n8().overlay
    }, { motionPreset: l } = Py(), d = i || (l === "none" ? {} : YV);
    return /* @__PURE__ */ D.jsx(
      j3e,
      {
        ...d,
        __css: c,
        ref: t,
        className: o,
        ...s
      }
    );
  }
);
rW.displayName = "ModalOverlay";
var iW = Nt((e, t) => {
  const { className: n, ...r } = e, { bodyId: i, setBodyMounted: s } = Py();
  We(() => (s(!0), () => s(!1)), [s]);
  const o = Wt("chakra-modal__body", n), a = n8();
  return /* @__PURE__ */ D.jsx(
    yt.div,
    {
      ref: t,
      className: o,
      id: i,
      ...r,
      __css: a.body
    }
  );
});
iW.displayName = "ModalBody";
var [D3e, Ev] = Ir({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
}), [U3e, r8] = Ir({
  name: "PopoverStylesContext",
  errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
});
function sW(e) {
  const t = Ek.only(e.children), { getTriggerProps: n } = Ev();
  return rm(t, n(t.props, t.ref));
}
sW.displayName = "PopoverTrigger";
var $f = {
  click: "click",
  hover: "hover"
};
function L3e(e = {}) {
  const {
    closeOnBlur: t = !0,
    closeOnEsc: n = !0,
    initialFocusRef: r,
    id: i,
    returnFocusOnClose: s = !0,
    autoFocus: o = !0,
    arrowSize: a,
    arrowShadowColor: c,
    trigger: l = $f.click,
    openDelay: u = 200,
    closeDelay: d = 200,
    isLazy: f,
    lazyBehavior: p = "unmount",
    computePositionOnMount: m,
    ...h
  } = e, { isOpen: g, onClose: y, onOpen: v, onToggle: b } = s3e(e), w = Le(null), A = Le(null), E = Le(null), x = Le(!1), S = Le(!1);
  g && (S.current = !0);
  const [P, I] = qe(!1), [R, Q] = qe(!1), J = mu(), we = i ?? J, [V, L, U, q] = [
    "popover-trigger",
    "popover-content",
    "popover-header",
    "popover-body"
  ].map((Y) => `${Y}-${we}`), {
    referenceRef: G,
    getArrowProps: ae,
    getPopperProps: ge,
    getArrowInnerProps: Ae,
    forceUpdate: he
  } = r3e({
    ...h,
    enabled: g || !!m
  }), B = o3e({ isOpen: g, ref: E });
  Yxe({
    enabled: g,
    ref: A
  }), RAe(E, {
    focusRef: A,
    visible: g,
    shouldFocus: s && l === $f.click
  }), FAe(E, {
    focusRef: r,
    visible: g,
    shouldFocus: o && l === $f.click
  });
  const be = qH({
    wasSelected: S.current,
    enabled: f,
    mode: p,
    isSelected: B.present
  }), Be = Ie(
    (Y = {}, X = null) => {
      const $ = {
        ...Y,
        style: {
          ...Y.style,
          transformOrigin: zr.transformOrigin.varRef,
          [zr.arrowSize.var]: a ? `${a}px` : void 0,
          [zr.arrowShadowColor.var]: c
        },
        ref: ii(E, X),
        children: be ? Y.children : null,
        id: L,
        tabIndex: -1,
        role: "dialog",
        onKeyDown: Xn(Y.onKeyDown, (ie) => {
          n && ie.key === "Escape" && y();
        }),
        onBlur: Xn(Y.onBlur, (ie) => {
          const fe = aN(ie), oe = G_(E.current, fe), me = G_(A.current, fe);
          g && t && (!oe && !me) && y();
        }),
        "aria-labelledby": P ? U : void 0,
        "aria-describedby": R ? q : void 0
      };
      return l === $f.hover && ($.role = "tooltip", $.onMouseEnter = Xn(Y.onMouseEnter, () => {
        x.current = !0;
      }), $.onMouseLeave = Xn(
        Y.onMouseLeave,
        (ie) => {
          ie.nativeEvent.relatedTarget !== null && (x.current = !1, setTimeout(() => y(), d));
        }
      )), $;
    },
    [
      be,
      L,
      P,
      U,
      R,
      q,
      l,
      n,
      y,
      g,
      t,
      d,
      c,
      a
    ]
  ), Ne = Ie(
    (Y = {}, X = null) => ge(
      {
        ...Y,
        style: {
          visibility: g ? "visible" : "hidden",
          ...Y.style
        }
      },
      X
    ),
    [g, ge]
  ), _e = Ie(
    (Y, X = null) => ({
      ...Y,
      // If anchor is rendered, it is used as reference.
      ref: ii(X, w, G)
    }),
    [w, G]
  ), Ce = Le(), N = Le(), F = Ie(
    (Y) => {
      w.current == null && G(Y);
    },
    [G]
  ), z = Ie(
    (Y = {}, X = null) => {
      const $ = {
        ...Y,
        ref: ii(A, X, F),
        id: V,
        "aria-haspopup": "dialog",
        "aria-expanded": g,
        "aria-controls": L
      };
      return l === $f.click && ($.onClick = Xn(Y.onClick, b)), l === $f.hover && ($.onFocus = Xn(Y.onFocus, () => {
        Ce.current === void 0 && v();
      }), $.onBlur = Xn(Y.onBlur, (ie) => {
        const fe = aN(ie), oe = !G_(E.current, fe);
        g && t && oe && y();
      }), $.onKeyDown = Xn(Y.onKeyDown, (ie) => {
        ie.key === "Escape" && y();
      }), $.onMouseEnter = Xn(Y.onMouseEnter, () => {
        x.current = !0, Ce.current = window.setTimeout(() => v(), u);
      }), $.onMouseLeave = Xn(Y.onMouseLeave, () => {
        x.current = !1, Ce.current && (clearTimeout(Ce.current), Ce.current = void 0), N.current = window.setTimeout(() => {
          x.current === !1 && y();
        }, d);
      })), $;
    },
    [
      V,
      g,
      L,
      l,
      F,
      b,
      v,
      t,
      y,
      u,
      d
    ]
  );
  We(() => () => {
    Ce.current && clearTimeout(Ce.current), N.current && clearTimeout(N.current);
  }, []);
  const ne = Ie(
    (Y = {}, X = null) => ({
      ...Y,
      id: U,
      ref: ii(X, ($) => {
        I(!!$);
      })
    }),
    [U]
  ), ee = Ie(
    (Y = {}, X = null) => ({
      ...Y,
      id: q,
      ref: ii(X, ($) => {
        Q(!!$);
      })
    }),
    [q]
  );
  return {
    forceUpdate: he,
    isOpen: g,
    onAnimationComplete: B.onComplete,
    onClose: y,
    getAnchorProps: _e,
    getArrowProps: ae,
    getArrowInnerProps: Ae,
    getPopoverPositionerProps: Ne,
    getPopoverProps: Be,
    getTriggerProps: z,
    getHeaderProps: ne,
    getBodyProps: ee
  };
}
function G_(e, t) {
  return e === t || (e == null ? void 0 : e.contains(t));
}
function aN(e) {
  var t;
  const n = e.currentTarget.ownerDocument.activeElement;
  return (t = e.relatedTarget) != null ? t : n;
}
function oW(e) {
  const t = kf("Popover", e), { children: n, ...r } = xo(e), i = tE(), s = L3e({ ...r, direction: i.direction });
  return /* @__PURE__ */ D.jsx(D3e, { value: s, children: /* @__PURE__ */ D.jsx(U3e, { value: t, children: oo(n, {
    isOpen: s.isOpen,
    onClose: s.onClose,
    forceUpdate: s.forceUpdate
  }) }) });
}
oW.displayName = "Popover";
var q_ = (e, t) => t ? `${e}.${t}, ${t}` : void 0;
function aW(e) {
  var t;
  const { bg: n, bgColor: r, backgroundColor: i, shadow: s, boxShadow: o, shadowColor: a } = e, { getArrowProps: c, getArrowInnerProps: l } = Ev(), u = r8(), d = (t = n ?? r) != null ? t : i, f = s ?? o;
  return /* @__PURE__ */ D.jsx(
    yt.div,
    {
      ...c(),
      className: "chakra-popover__arrow-positioner",
      children: /* @__PURE__ */ D.jsx(
        yt.div,
        {
          className: Wt("chakra-popover__arrow", e.className),
          ...l(e),
          __css: {
            "--popper-arrow-shadow-color": q_("colors", a),
            "--popper-arrow-bg": q_("colors", d),
            "--popper-arrow-shadow": q_("shadows", f),
            ...u.arrow
          }
        }
      )
    }
  );
}
aW.displayName = "PopoverArrow";
var cW = Nt(
  function(t, n) {
    const { getBodyProps: r } = Ev(), i = r8();
    return /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ...r(t, n),
        className: Wt("chakra-popover__body", t.className),
        __css: i.body
      }
    );
  }
);
cW.displayName = "PopoverBody";
function z3e(e) {
  if (e)
    return {
      enter: {
        ...e.enter,
        visibility: "visible"
      },
      exit: {
        ...e.exit,
        transitionEnd: {
          visibility: "hidden"
        }
      }
    };
}
var V3e = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
}, H3e = yt(If.section), lW = Nt(function(t, n) {
  const { variants: r = V3e, ...i } = t, { isOpen: s } = Ev();
  return /* @__PURE__ */ D.jsx(
    H3e,
    {
      ref: n,
      variants: z3e(r),
      initial: !1,
      animate: s ? "enter" : "exit",
      ...i
    }
  );
});
lW.displayName = "PopoverTransition";
var uW = Nt(
  function(t, n) {
    const { rootProps: r, motionProps: i, ...s } = t, { getPopoverProps: o, getPopoverPositionerProps: a, onAnimationComplete: c } = Ev(), l = r8(), u = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      ...l.content
    };
    return /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ...a(r),
        __css: l.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ D.jsx(
          lW,
          {
            ...i,
            ...o(s, n),
            onAnimationComplete: oue(
              c,
              s.onAnimationComplete
            ),
            className: Wt("chakra-popover__content", t.className),
            __css: u
          }
        )
      }
    );
  }
);
uW.displayName = "PopoverContent";
var [
  W3e,
  dW,
  G3e,
  q3e
] = _xe();
function $3e(e) {
  var t;
  const {
    defaultIndex: n,
    onChange: r,
    index: i,
    isManual: s,
    isLazy: o,
    lazyBehavior: a = "unmount",
    orientation: c = "horizontal",
    direction: l = "ltr",
    ...u
  } = e, [d, f] = qe(n ?? 0), [p, m] = Sxe({
    defaultValue: n ?? 0,
    value: i,
    onChange: r
  });
  We(() => {
    i != null && f(i);
  }, [i]);
  const h = G3e(), g = mu();
  return {
    id: `tabs-${(t = e.id) != null ? t : g}`,
    selectedIndex: p,
    focusedIndex: d,
    setSelectedIndex: m,
    setFocusedIndex: f,
    isManual: s,
    isLazy: o,
    lazyBehavior: a,
    orientation: c,
    descendants: h,
    direction: l,
    htmlProps: u
  };
}
var [Q3e, _v] = Ir({
  name: "TabsContext",
  errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
});
function K3e(e) {
  const { focusedIndex: t, orientation: n, direction: r } = _v(), i = dW(), s = Ie(
    (o) => {
      const a = () => {
        var v;
        const b = i.nextEnabled(t);
        b && ((v = b.node) == null || v.focus());
      }, c = () => {
        var v;
        const b = i.prevEnabled(t);
        b && ((v = b.node) == null || v.focus());
      }, l = () => {
        var v;
        const b = i.firstEnabled();
        b && ((v = b.node) == null || v.focus());
      }, u = () => {
        var v;
        const b = i.lastEnabled();
        b && ((v = b.node) == null || v.focus());
      }, d = n === "horizontal", f = n === "vertical", p = o.key, m = r === "ltr" ? "ArrowLeft" : "ArrowRight", h = r === "ltr" ? "ArrowRight" : "ArrowLeft", y = {
        [m]: () => d && c(),
        [h]: () => d && a(),
        ArrowDown: () => f && a(),
        ArrowUp: () => f && c(),
        Home: l,
        End: u
      }[p];
      y && (o.preventDefault(), y(o));
    },
    [i, t, n, r]
  );
  return {
    ...e,
    role: "tablist",
    "aria-orientation": n,
    onKeyDown: Xn(e.onKeyDown, s)
  };
}
function Y3e(e) {
  const { isDisabled: t = !1, isFocusable: n = !1, ...r } = e, { setSelectedIndex: i, isManual: s, id: o, setFocusedIndex: a, selectedIndex: c } = _v(), { index: l, register: u } = q3e({
    disabled: t && !n
  }), d = l === c, f = () => {
    i(l);
  }, p = () => {
    a(l), !s && !(t && n) && i(l);
  };
  return {
    ...OAe({
      ...r,
      ref: ii(u, e.ref),
      isDisabled: t,
      isFocusable: n,
      onClick: Xn(e.onClick, f)
    }),
    id: fW(o, l),
    role: "tab",
    tabIndex: d ? 0 : -1,
    type: "button",
    "aria-selected": d,
    "aria-controls": hW(o, l),
    onFocus: t ? void 0 : Xn(e.onFocus, p)
  };
}
var [Z3e, J3e] = Ir({});
function X3e(e) {
  const t = _v(), { id: n, selectedIndex: r } = t, s = N4(e.children).map(
    (o, a) => Hg(
      Z3e,
      {
        key: a,
        value: {
          isSelected: a === r,
          id: hW(n, a),
          tabId: fW(n, a),
          selectedIndex: r
        }
      },
      o
    )
  );
  return { ...e, children: s };
}
function e_e(e) {
  const { children: t, ...n } = e, { isLazy: r, lazyBehavior: i } = _v(), { isSelected: s, id: o, tabId: a } = J3e(), c = Le(!1);
  s && (c.current = !0);
  const l = qH({
    wasSelected: c.current,
    isSelected: s,
    enabled: r,
    mode: i
  });
  return {
    // Puts the tabpanel in the page `Tab` sequence.
    tabIndex: 0,
    ...n,
    children: l ? t : null,
    role: "tabpanel",
    "aria-labelledby": a,
    hidden: !s,
    id: o
  };
}
function t_e() {
  const e = _v(), t = dW(), { selectedIndex: n, orientation: r } = e, i = r === "horizontal", s = r === "vertical", [o, a] = qe(() => {
    if (i)
      return { left: 0, width: 0 };
    if (s)
      return { top: 0, height: 0 };
  }), [c, l] = qe(!1);
  return ru(() => {
    if (n == null)
      return;
    const u = t.item(n);
    if (u == null)
      return;
    i && a({ left: u.node.offsetLeft, width: u.node.offsetWidth }), s && a({ top: u.node.offsetTop, height: u.node.offsetHeight });
    const d = requestAnimationFrame(() => {
      l(!0);
    });
    return () => {
      d && cancelAnimationFrame(d);
    };
  }, [n, i, s, t]), {
    position: "absolute",
    transitionProperty: "left, right, top, bottom, height, width",
    transitionDuration: c ? "200ms" : "0ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    ...o
  };
}
function fW(e, t) {
  return `${e}--tab-${t}`;
}
function hW(e, t) {
  return `${e}--tabpanel-${t}`;
}
var [n_e, Sv] = Ir({
  name: "TabsStylesContext",
  errorMessage: `useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tabs />" `
}), pW = Nt(function(t, n) {
  const r = kf("Tabs", t), { children: i, className: s, ...o } = xo(t), { htmlProps: a, descendants: c, ...l } = $3e(o), u = ot(() => l, [l]), { isFitted: d, ...f } = a, p = {
    position: "relative",
    ...r.root
  };
  return /* @__PURE__ */ D.jsx(W3e, { value: c, children: /* @__PURE__ */ D.jsx(Q3e, { value: u, children: /* @__PURE__ */ D.jsx(n_e, { value: r, children: /* @__PURE__ */ D.jsx(
    yt.div,
    {
      className: Wt("chakra-tabs", s),
      ref: n,
      ...f,
      __css: p,
      children: i
    }
  ) }) }) });
});
pW.displayName = "Tabs";
var mW = Nt(
  function(t, n) {
    const r = t_e(), i = {
      ...t.style,
      ...r
    }, s = Sv();
    return /* @__PURE__ */ D.jsx(
      yt.div,
      {
        ref: n,
        ...t,
        className: Wt("chakra-tabs__tab-indicator", t.className),
        style: i,
        __css: s.indicator
      }
    );
  }
);
mW.displayName = "TabIndicator";
var gW = Nt(function(t, n) {
  const r = K3e({ ...t, ref: n }), s = {
    display: "flex",
    ...Sv().tablist
  };
  return /* @__PURE__ */ D.jsx(
    yt.div,
    {
      ...r,
      className: Wt("chakra-tabs__tablist", t.className),
      __css: s
    }
  );
});
gW.displayName = "TabList";
var yW = Nt(function(t, n) {
  const r = e_e({ ...t, ref: n }), i = Sv();
  return /* @__PURE__ */ D.jsx(
    yt.div,
    {
      outline: "0",
      ...r,
      className: Wt("chakra-tabs__tab-panel", t.className),
      __css: i.tabpanel
    }
  );
});
yW.displayName = "TabPanel";
var bW = Nt(function(t, n) {
  const r = X3e(t), i = Sv();
  return /* @__PURE__ */ D.jsx(
    yt.div,
    {
      ...r,
      width: "100%",
      ref: n,
      className: Wt("chakra-tabs__tab-panels", t.className),
      __css: i.tabpanels
    }
  );
});
bW.displayName = "TabPanels";
var vW = Nt(function(t, n) {
  const r = Sv(), i = Y3e({ ...t, ref: n }), s = {
    outline: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...r.tab
  };
  return /* @__PURE__ */ D.jsx(
    yt.button,
    {
      ...i,
      className: Wt("chakra-tabs__tab", t.className),
      __css: s
    }
  );
});
vW.displayName = "Tab";
var wW = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, cN = k.createContext && /* @__PURE__ */ k.createContext(wW), r_e = ["attr", "size", "title"];
function i_e(e, t) {
  if (e == null)
    return {};
  var n = s_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (i = 0; i < s.length; i++)
      r = s[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function s_e(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
function t2() {
  return t2 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t2.apply(this, arguments);
}
function lN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function n2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lN(Object(n), !0).forEach(function(r) {
      o_e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function o_e(e, t, n) {
  return t = a_e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function a_e(e) {
  var t = c_e(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function c_e(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xW(e) {
  return e && e.map((t, n) => /* @__PURE__ */ k.createElement(t.tag, n2({
    key: n
  }, t.attr), xW(t.child)));
}
function wu(e) {
  return (t) => /* @__PURE__ */ k.createElement(l_e, t2({
    attr: n2({}, e.attr)
  }, t), xW(e.child));
}
function l_e(e) {
  var t = (n) => {
    var {
      attr: r,
      size: i,
      title: s
    } = e, o = i_e(e, r_e), a = i || n.size || "1em", c;
    return n.className && (c = n.className), e.className && (c = (c ? c + " " : "") + e.className), /* @__PURE__ */ k.createElement("svg", t2({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, o, {
      className: c,
      style: n2(n2({
        color: e.color || n.color
      }, n.style), e.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), s && /* @__PURE__ */ k.createElement("title", null, s), e.children);
  };
  return cN !== void 0 ? /* @__PURE__ */ k.createElement(cN.Consumer, null, (n) => t(n)) : t(wW);
}
function u_e(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }, child: [] }, { tag: "path", attr: { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" }, child: [] }] })(e);
}
function uN(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" }, child: [] }, { tag: "circle", attr: { cx: "12", cy: "12", r: "3" }, child: [] }] })(e);
}
function dN(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M21 12V7H5a2 2 0 0 1 0-4h14v4" }, child: [] }, { tag: "path", attr: { d: "M3 5v14a2 2 0 0 0 2 2h16v-5" }, child: [] }, { tag: "path", attr: { d: "M18 12a2 2 0 0 0 0 4h4v-4Z" }, child: [] }] })(e);
}
function d_e(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" }, child: [] }] })(e);
}
function f_e(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" }, child: [] }] })(e);
}
var h_e = /* @__PURE__ */ p_e() ? _f : We;
function p_e() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function m_e() {
  var e = qe(/* @__PURE__ */ Object.create(null)), t = e[1];
  return Ie(function() {
    t(/* @__PURE__ */ Object.create(null));
  }, []);
}
var g_e = function(t) {
  var n = t.children, r = t.type, i = r === void 0 ? "reach-portal" : r, s = Le(null), o = Le(null), a = m_e();
  return h_e(function() {
    if (s.current) {
      var c = s.current.ownerDocument;
      return o.current = c == null ? void 0 : c.createElement(i), c.body.appendChild(o.current), a(), function() {
        o.current && o.current.ownerDocument && o.current.ownerDocument.body.removeChild(o.current);
      };
    }
  }, [i, a]), o.current ? /* @__PURE__ */ AA(n, o.current) : /* @__PURE__ */ Hg("span", {
    ref: s
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var He = function() {
  return He = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, He.apply(this, arguments);
};
function i8(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function Ft(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $t(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}
function vn(e, t, n) {
  if (arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var un;
(function(e) {
  e.Start = "xstate.start", e.Stop = "xstate.stop", e.Raise = "xstate.raise", e.Send = "xstate.send", e.Cancel = "xstate.cancel", e.NullEvent = "", e.Assign = "xstate.assign", e.After = "xstate.after", e.DoneState = "done.state", e.DoneInvoke = "done.invoke", e.Log = "xstate.log", e.Init = "xstate.init", e.Invoke = "xstate.invoke", e.ErrorExecution = "error.execution", e.ErrorCommunication = "error.communication", e.ErrorPlatform = "error.platform", e.ErrorCustom = "xstate.error", e.Update = "xstate.update", e.Pure = "xstate.pure", e.Choose = "xstate.choose";
})(un || (un = {}));
var Im;
(function(e) {
  e.Parent = "#_parent", e.Internal = "#_internal";
})(Im || (Im = {}));
var MC = un.Start, s8 = un.Stop, Cv = un.Raise, yE = un.Send, AW = un.Cancel, y_e = un.NullEvent, o8 = un.Assign;
un.After;
un.DoneState;
var EW = un.Log, b_e = un.Init, FC = un.Invoke;
un.ErrorExecution;
var fN = un.ErrorPlatform, v_e = un.ErrorCustom, _W = un.Update, w_e = un.Choose, x_e = un.Pure, SW = ".", hN = {}, jC = "xstate.guard", A_e = "", v1;
function a8(e, t, n) {
  n === void 0 && (n = SW);
  var r = Sg(e, n), i = Sg(t, n);
  return nn(i) ? nn(r) ? i === r : !1 : nn(r) ? r in i : Object.keys(r).every(function(s) {
    return s in i ? a8(r[s], i[s]) : !1;
  });
}
function CW(e) {
  try {
    return nn(e) || typeof e == "number" ? "".concat(e) : e.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function DC(e, t) {
  try {
    return r0(e) ? e : e.toString().split(t);
  } catch {
    throw new Error("'".concat(e, "' is not a valid state path."));
  }
}
function E_e(e) {
  return typeof e == "object" && "value" in e && "context" in e && "event" in e && "_event" in e;
}
function Sg(e, t) {
  if (E_e(e))
    return e.value;
  if (r0(e))
    return r2(e);
  if (typeof e != "string")
    return e;
  var n = DC(e, t);
  return r2(n);
}
function r2(e) {
  if (e.length === 1)
    return e[0];
  for (var t = {}, n = t, r = 0; r < e.length - 1; r++)
    r === e.length - 2 ? n[e[r]] = e[r + 1] : (n[e[r]] = {}, n = n[e[r]]);
  return t;
}
function Q0(e, t) {
  for (var n = {}, r = Object.keys(e), i = 0; i < r.length; i++) {
    var s = r[i];
    n[s] = t(e[s], s, e, i);
  }
  return n;
}
function pN(e, t, n) {
  var r, i, s = {};
  try {
    for (var o = Ft(Object.keys(e)), a = o.next(); !a.done; a = o.next()) {
      var c = a.value, l = e[c];
      n(l) && (s[c] = t(l, c, e));
    }
  } catch (u) {
    r = {
      error: u
    };
  } finally {
    try {
      a && !a.done && (i = o.return) && i.call(o);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return s;
}
var __e = function(e) {
  return function(t) {
    var n, r, i = t;
    try {
      for (var s = Ft(e), o = s.next(); !o.done; o = s.next()) {
        var a = o.value;
        i = i[a];
      }
    } catch (c) {
      n = {
        error: c
      };
    } finally {
      try {
        o && !o.done && (r = s.return) && r.call(s);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return i;
  };
};
function S_e(e, t) {
  return function(n) {
    var r, i, s = n;
    try {
      for (var o = Ft(e), a = o.next(); !a.done; a = o.next()) {
        var c = a.value;
        s = s[t][c];
      }
    } catch (l) {
      r = {
        error: l
      };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return s;
  };
}
function Iw(e) {
  if (!e)
    return [[]];
  if (nn(e))
    return [[e]];
  var t = En(Object.keys(e).map(function(n) {
    var r = e[n];
    return typeof r != "string" && (!r || !Object.keys(r).length) ? [[n]] : Iw(e[n]).map(function(i) {
      return [n].concat(i);
    });
  }));
  return t;
}
function En(e) {
  var t;
  return (t = []).concat.apply(t, vn([], $t(e), !1));
}
function TW(e) {
  return r0(e) ? e : [e];
}
function qs(e) {
  return e === void 0 ? [] : TW(e);
}
function i2(e, t, n) {
  var r, i;
  if (Xt(e))
    return e(t, n.data);
  var s = {};
  try {
    for (var o = Ft(Object.keys(e)), a = o.next(); !a.done; a = o.next()) {
      var c = a.value, l = e[c];
      Xt(l) ? s[c] = l(t, n.data) : s[c] = l;
    }
  } catch (u) {
    r = {
      error: u
    };
  } finally {
    try {
      a && !a.done && (i = o.return) && i.call(o);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return s;
}
function C_e(e) {
  return /^(done|error)\./.test(e);
}
function mN(e) {
  return !!(e instanceof Promise || e !== null && (Xt(e) || typeof e == "object") && Xt(e.then));
}
function T_e(e) {
  return e !== null && typeof e == "object" && "transition" in e && typeof e.transition == "function";
}
function k_e(e, t) {
  var n, r, i = $t([[], []], 2), s = i[0], o = i[1];
  try {
    for (var a = Ft(e), c = a.next(); !c.done; c = a.next()) {
      var l = c.value;
      t(l) ? s.push(l) : o.push(l);
    }
  } catch (u) {
    n = {
      error: u
    };
  } finally {
    try {
      c && !c.done && (r = a.return) && r.call(a);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return [s, o];
}
function kW(e, t) {
  return Q0(e.states, function(n, r) {
    if (n) {
      var i = (nn(t) ? void 0 : t[r]) || (n ? n.current : void 0);
      if (i)
        return {
          current: i,
          states: kW(n, i)
        };
    }
  });
}
function B_e(e, t) {
  return {
    current: t,
    states: kW(e, t)
  };
}
function gN(e, t, n, r) {
  var i = e && n.reduce(function(s, o) {
    var a, c, l = o.assignment, u = {
      state: r,
      action: o,
      _event: t
    }, d = {};
    if (Xt(l))
      d = l(s, t.data, u);
    else
      try {
        for (var f = Ft(Object.keys(l)), p = f.next(); !p.done; p = f.next()) {
          var m = p.value, h = l[m];
          d[m] = Xt(h) ? h(s, t.data, u) : h;
        }
      } catch (g) {
        a = {
          error: g
        };
      } finally {
        try {
          p && !p.done && (c = f.return) && c.call(f);
        } finally {
          if (a)
            throw a.error;
        }
      }
    return Object.assign({}, s, d);
  }, e);
  return i;
}
var I_e = function() {
};
function r0(e) {
  return Array.isArray(e);
}
function Xt(e) {
  return typeof e == "function";
}
function nn(e) {
  return typeof e == "string";
}
function BW(e, t) {
  if (e)
    return nn(e) ? {
      type: jC,
      name: e,
      predicate: t ? t[e] : void 0
    } : Xt(e) ? {
      type: jC,
      name: e.name,
      predicate: e
    } : e;
}
function P_e(e) {
  try {
    return "subscribe" in e && Xt(e.subscribe);
  } catch {
    return !1;
  }
}
var cl = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
v1 = {}, v1[cl] = function() {
  return this;
}, v1[Symbol.observable] = function() {
  return this;
};
function Pm(e) {
  return !!e && "__xstatenode" in e;
}
function O_e(e) {
  return !!e && typeof e.send == "function";
}
function bE(e, t) {
  return nn(e) || typeof e == "number" ? He({
    type: e
  }, t) : e;
}
function xr(e, t) {
  if (!nn(e) && "$$type" in e && e.$$type === "scxml")
    return e;
  var n = bE(e);
  return He({
    name: n.type,
    data: n,
    $$type: "scxml",
    type: "external"
  }, t);
}
function Qf(e, t) {
  var n = TW(t).map(function(r) {
    return typeof r > "u" || typeof r == "string" || Pm(r) ? {
      target: r,
      event: e
    } : He(He({}, r), {
      event: e
    });
  });
  return n;
}
function N_e(e) {
  if (!(e === void 0 || e === A_e))
    return qs(e);
}
function IW(e, t, n, r, i) {
  var s = e.options.guards, o = {
    state: i,
    cond: t,
    _event: r
  };
  if (t.type === jC)
    return ((s == null ? void 0 : s[t.name]) || t.predicate)(n, r.data, o);
  var a = s == null ? void 0 : s[t.type];
  if (!a)
    throw new Error("Guard '".concat(t.type, "' is not implemented on machine '").concat(e.id, "'."));
  return a(n, r.data, o);
}
function PW(e) {
  return typeof e == "string" ? {
    type: e
  } : e;
}
function Pw(e, t, n) {
  var r = function() {
  }, i = typeof e == "object", s = i ? e : null;
  return {
    next: ((i ? e.next : e) || r).bind(s),
    error: ((i ? e.error : t) || r).bind(s),
    complete: ((i ? e.complete : n) || r).bind(s)
  };
}
function w1(e, t) {
  return "".concat(e, ":invocation[").concat(t, "]");
}
function UC(e) {
  return (e.type === Cv || e.type === yE && e.to === Im.Internal) && typeof e.delay != "number";
}
var qh = /* @__PURE__ */ xr({
  type: b_e
});
function LC(e, t) {
  return t && t[e] || void 0;
}
function Oy(e, t) {
  var n;
  if (nn(e) || typeof e == "number") {
    var r = LC(e, t);
    Xt(r) ? n = {
      type: e,
      exec: r
    } : r ? n = r : n = {
      type: e,
      exec: void 0
    };
  } else if (Xt(e))
    n = {
      // Convert action to string if unnamed
      type: e.name || e.toString(),
      exec: e
    };
  else {
    var r = LC(e.type, t);
    if (Xt(r))
      n = He(He({}, e), {
        exec: r
      });
    else if (r) {
      var i = r.type || e.type;
      n = He(He(He({}, r), e), {
        type: i
      });
    } else
      n = e;
  }
  return n;
}
var ll = function(e, t) {
  if (!e)
    return [];
  var n = r0(e) ? e : [e];
  return n.map(function(r) {
    return Oy(r, t);
  });
};
function c8(e) {
  var t = Oy(e);
  return He(He({
    id: nn(e) ? e : t.id
  }, t), {
    type: t.type
  });
}
function R_e(e, t) {
  return {
    type: Cv,
    event: typeof e == "function" ? e : bE(e),
    delay: t ? t.delay : void 0,
    id: t == null ? void 0 : t.id
  };
}
function M_e(e, t, n, r) {
  var i = {
    _event: n
  }, s = xr(Xt(e.event) ? e.event(t, n.data, i) : e.event), o;
  if (nn(e.delay)) {
    var a = r && r[e.delay];
    o = Xt(a) ? a(t, n.data, i) : a;
  } else
    o = Xt(e.delay) ? e.delay(t, n.data, i) : e.delay;
  return He(He({}, e), {
    type: Cv,
    _event: s,
    delay: o
  });
}
function F_e(e, t) {
  return {
    to: t ? t.to : void 0,
    type: yE,
    event: Xt(e) ? e : bE(e),
    delay: t ? t.delay : void 0,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: t && t.id !== void 0 ? t.id : Xt(e) ? e.name : CW(e)
  };
}
function j_e(e, t, n, r) {
  var i = {
    _event: n
  }, s = xr(Xt(e.event) ? e.event(t, n.data, i) : e.event), o;
  if (nn(e.delay)) {
    var a = r && r[e.delay];
    o = Xt(a) ? a(t, n.data, i) : a;
  } else
    o = Xt(e.delay) ? e.delay(t, n.data, i) : e.delay;
  var c = Xt(e.to) ? e.to(t, n.data, i) : e.to;
  return He(He({}, e), {
    to: c,
    _event: s,
    event: s.data,
    delay: o
  });
}
var D_e = function(e, t, n) {
  return He(He({}, e), {
    value: nn(e.expr) ? e.expr : e.expr(t, n.data, {
      _event: n
    })
  });
}, U_e = function(e) {
  return {
    type: AW,
    sendId: e
  };
};
function L_e(e) {
  var t = c8(e);
  return {
    type: un.Start,
    activity: t,
    exec: void 0
  };
}
function z_e(e) {
  var t = Xt(e) ? e : c8(e);
  return {
    type: un.Stop,
    activity: t,
    exec: void 0
  };
}
function V_e(e, t, n) {
  var r = Xt(e.activity) ? e.activity(t, n.data) : e.activity, i = typeof r == "string" ? {
    id: r
  } : r, s = {
    type: un.Stop,
    activity: i
  };
  return s;
}
var H_e = function(e) {
  return {
    type: o8,
    assignment: e
  };
};
function W_e(e, t) {
  var n = t ? "#".concat(t) : "";
  return "".concat(un.After, "(").concat(e, ")").concat(n);
}
function x1(e, t) {
  var n = "".concat(un.DoneState, ".").concat(e), r = {
    type: n,
    data: t
  };
  return r.toString = function() {
    return n;
  }, r;
}
function Ow(e, t) {
  var n = "".concat(un.DoneInvoke, ".").concat(e), r = {
    type: n,
    data: t
  };
  return r.toString = function() {
    return n;
  }, r;
}
function K0(e, t) {
  var n = "".concat(un.ErrorPlatform, ".").concat(e), r = {
    type: n,
    data: t
  };
  return r.toString = function() {
    return n;
  }, r;
}
var G_e = function(e) {
  var t, n, r = [];
  try {
    for (var i = Ft(e), s = i.next(); !s.done; s = i.next())
      for (var o = s.value, a = 0; a < o.actions.length; ) {
        if (o.actions[a].type === o8) {
          r.push(o.actions[a]), o.actions.splice(a, 1);
          continue;
        }
        a++;
      }
  } catch (c) {
    t = {
      error: c
    };
  } finally {
    try {
      s && !s.done && (n = i.return) && n.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return r;
};
function s2(e, t, n, r, i, s, o) {
  o === void 0 && (o = !1);
  var a = o ? [] : G_e(i), c = a.length ? gN(n, r, a, t) : n, l = o ? [n] : void 0, u = [];
  function d(m, h) {
    var g;
    switch (h.type) {
      case Cv: {
        var y = M_e(h, c, r, e.options.delays);
        return s && typeof y.delay == "number" && s(y, c, r), y;
      }
      case yE:
        var v = j_e(h, c, r, e.options.delays);
        return s && v.to !== Im.Internal && (m === "entry" ? u.push(v) : s(v, c, r)), v;
      case EW: {
        var b = D_e(h, c, r);
        return s == null || s(b, c, r), b;
      }
      case w_e: {
        var w = h, A = (g = w.conds.find(function(L) {
          var U = BW(L.cond, e.options.guards);
          return !U || IW(e, U, c, r, s ? void 0 : t);
        })) === null || g === void 0 ? void 0 : g.actions;
        if (!A)
          return [];
        var E = $t(s2(e, t, c, r, [{
          type: m,
          actions: ll(qs(A), e.options.actions)
        }], s, o), 2), x = E[0], S = E[1];
        return c = S, l == null || l.push(c), x;
      }
      case x_e: {
        var A = h.get(c, r.data);
        if (!A)
          return [];
        var P = $t(s2(e, t, c, r, [{
          type: m,
          actions: ll(qs(A), e.options.actions)
        }], s, o), 2), I = P[0], R = P[1];
        return c = R, l == null || l.push(c), I;
      }
      case s8: {
        var b = V_e(h, c, r);
        return s == null || s(b, n, r), b;
      }
      case o8: {
        c = gN(c, r, [h], s ? void 0 : t), l == null || l.push(c);
        break;
      }
      default:
        var Q = Oy(h, e.options.actions), J = Q.exec;
        if (s)
          s(Q, c, r);
        else if (J && l) {
          var we = l.length - 1, V = He(He({}, Q), {
            exec: function(L) {
              for (var U = [], q = 1; q < arguments.length; q++)
                U[q - 1] = arguments[q];
              J.apply(void 0, vn([l[we]], $t(U), !1));
            }
          });
          Q = V;
        }
        return Q;
    }
  }
  function f(m) {
    var h, g, y = [];
    try {
      for (var v = Ft(m.actions), b = v.next(); !b.done; b = v.next()) {
        var w = b.value, A = d(m.type, w);
        A && (y = y.concat(A));
      }
    } catch (E) {
      h = {
        error: E
      };
    } finally {
      try {
        b && !b.done && (g = v.return) && g.call(v);
      } finally {
        if (h)
          throw h.error;
      }
    }
    return u.forEach(function(E) {
      s(E, c, r);
    }), u.length = 0, y;
  }
  var p = En(i.map(f));
  return [p, c];
}
var ah = function(e, t) {
  var n = t(e);
  return n;
};
function OW(e) {
  var t;
  return t = {
    id: e,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: e
      };
    }
  }, t[cl] = function() {
    return this;
  }, t;
}
function q_e(e, t, n, r) {
  var i, s = PW(e.src), o = (i = t == null ? void 0 : t.options.services) === null || i === void 0 ? void 0 : i[s.type], a = e.data ? i2(e.data, n, r) : void 0, c = o ? NW(o, e.id, a) : OW(e.id);
  return c.meta = e, c;
}
function NW(e, t, n) {
  var r = OW(t);
  if (r.deferred = !0, Pm(e)) {
    var i = r.state = ah(void 0, function() {
      return (n ? e.withContext(n) : e).initialState;
    });
    r.getSnapshot = function() {
      return i;
    };
  }
  return r;
}
function $_e(e) {
  try {
    return typeof e.send == "function";
  } catch {
    return !1;
  }
}
function Q_e(e) {
  return $_e(e) && "id" in e;
}
function K_e(e) {
  var t;
  return He((t = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, t[cl] = function() {
    return this;
  }, t), e);
}
var o2 = function(e) {
  return e.type === "atomic" || e.type === "final";
};
function RW(e) {
  return Object.keys(e.states).map(function(t) {
    return e.states[t];
  });
}
function Ny(e) {
  return RW(e).filter(function(t) {
    return t.type !== "history";
  });
}
function MW(e) {
  var t = [e];
  return o2(e) ? t : t.concat(En(Ny(e).map(MW)));
}
function Y0(e, t) {
  var n, r, i, s, o, a, c, l, u = new Set(e), d = zC(u), f = new Set(t);
  try {
    for (var p = Ft(f), m = p.next(); !m.done; m = p.next())
      for (var h = m.value, g = h.parent; g && !f.has(g); )
        f.add(g), g = g.parent;
  } catch (P) {
    n = {
      error: P
    };
  } finally {
    try {
      m && !m.done && (r = p.return) && r.call(p);
    } finally {
      if (n)
        throw n.error;
    }
  }
  var y = zC(f);
  try {
    for (var v = Ft(f), b = v.next(); !b.done; b = v.next()) {
      var h = b.value;
      if (h.type === "compound" && (!y.get(h) || !y.get(h).length))
        d.get(h) ? d.get(h).forEach(function(I) {
          return f.add(I);
        }) : h.initialStateNodes.forEach(function(I) {
          return f.add(I);
        });
      else if (h.type === "parallel")
        try {
          for (var w = (o = void 0, Ft(Ny(h))), A = w.next(); !A.done; A = w.next()) {
            var E = A.value;
            f.has(E) || (f.add(E), d.get(E) ? d.get(E).forEach(function(I) {
              return f.add(I);
            }) : E.initialStateNodes.forEach(function(I) {
              return f.add(I);
            }));
          }
        } catch (I) {
          o = {
            error: I
          };
        } finally {
          try {
            A && !A.done && (a = w.return) && a.call(w);
          } finally {
            if (o)
              throw o.error;
          }
        }
    }
  } catch (P) {
    i = {
      error: P
    };
  } finally {
    try {
      b && !b.done && (s = v.return) && s.call(v);
    } finally {
      if (i)
        throw i.error;
    }
  }
  try {
    for (var x = Ft(f), S = x.next(); !S.done; S = x.next())
      for (var h = S.value, g = h.parent; g && !f.has(g); )
        f.add(g), g = g.parent;
  } catch (P) {
    c = {
      error: P
    };
  } finally {
    try {
      S && !S.done && (l = x.return) && l.call(x);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return f;
}
function FW(e, t) {
  var n = t.get(e);
  if (!n)
    return {};
  if (e.type === "compound") {
    var r = n[0];
    if (r) {
      if (o2(r))
        return r.key;
    } else
      return {};
  }
  var i = {};
  return n.forEach(function(s) {
    i[s.key] = FW(s, t);
  }), i;
}
function zC(e) {
  var t, n, r = /* @__PURE__ */ new Map();
  try {
    for (var i = Ft(e), s = i.next(); !s.done; s = i.next()) {
      var o = s.value;
      r.has(o) || r.set(o, []), o.parent && (r.has(o.parent) || r.set(o.parent, []), r.get(o.parent).push(o));
    }
  } catch (a) {
    t = {
      error: a
    };
  } finally {
    try {
      s && !s.done && (n = i.return) && n.call(i);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return r;
}
function Y_e(e, t) {
  var n = Y0([e], t);
  return FW(e, zC(n));
}
function Z0(e, t) {
  return Array.isArray(e) ? e.some(function(n) {
    return n === t;
  }) : e instanceof Set ? e.has(t) : !1;
}
function Z_e(e) {
  return vn([], $t(new Set(En(vn([], $t(e.map(function(t) {
    return t.ownEvents;
  })), !1)))), !1);
}
function Nw(e, t) {
  return t.type === "compound" ? Ny(t).some(function(n) {
    return n.type === "final" && Z0(e, n);
  }) : t.type === "parallel" ? Ny(t).every(function(n) {
    return Nw(e, n);
  }) : !1;
}
function J_e(e) {
  return e === void 0 && (e = []), e.reduce(function(t, n) {
    return n.meta !== void 0 && (t[n.id] = n.meta), t;
  }, {});
}
function yN(e) {
  return new Set(En(e.map(function(t) {
    return t.tags;
  })));
}
function jW(e, t) {
  if (e === t)
    return !0;
  if (e === void 0 || t === void 0)
    return !1;
  if (nn(e) || nn(t))
    return e === t;
  var n = Object.keys(e), r = Object.keys(t);
  return n.length === r.length && n.every(function(i) {
    return jW(e[i], t[i]);
  });
}
function X_e(e) {
  return typeof e != "object" || e === null ? !1 : "value" in e && "_event" in e;
}
function e6e(e, t) {
  var n = e.exec, r = He(He({}, e), {
    exec: n !== void 0 ? function() {
      return n(t.context, t.event, {
        action: e,
        state: t,
        _event: t._event
      });
    } : void 0
  });
  return r;
}
var ws = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var n = this, r;
      this.actions = [], this.activities = hN, this.meta = {}, this.events = [], this.value = t.value, this.context = t.context, this._event = t._event, this._sessionid = t._sessionid, this.event = this._event.data, this.historyValue = t.historyValue, this.history = t.history, this.actions = t.actions || [], this.activities = t.activities || hN, this.meta = J_e(t.configuration), this.events = t.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = t.configuration, this.transitions = t.transitions, this.children = t.children, this.done = !!t.done, this.tags = (r = Array.isArray(t.tags) ? new Set(t.tags) : t.tags) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set(), this.machine = t.machine, Object.defineProperty(this, "nextEvents", {
        get: function() {
          return Z_e(n.configuration);
        }
      });
    }
    return e.from = function(t, n) {
      if (t instanceof e)
        return t.context !== n ? new e({
          value: t.value,
          context: n,
          _event: t._event,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          actions: [],
          activities: t.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        }) : t;
      var r = qh;
      return new e({
        value: t,
        context: n,
        _event: r,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        meta: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, e.create = function(t) {
      return new e(t);
    }, e.inert = function(t, n) {
      if (t instanceof e) {
        if (!t.actions.length)
          return t;
        var r = qh;
        return new e({
          value: t.value,
          context: n,
          _event: r,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          activities: t.activities,
          configuration: t.configuration,
          transitions: [],
          children: {}
        });
      }
      return e.from(t, n);
    }, e.prototype.toStrings = function(t, n) {
      var r = this;
      if (t === void 0 && (t = this.value), n === void 0 && (n = "."), nn(t))
        return [t];
      var i = Object.keys(t);
      return i.concat.apply(i, vn([], $t(i.map(function(s) {
        return r.toStrings(t[s], n).map(function(o) {
          return s + n + o;
        });
      })), !1));
    }, e.prototype.toJSON = function() {
      var t = this;
      t.configuration, t.transitions;
      var n = t.tags;
      t.machine;
      var r = i8(t, ["configuration", "transitions", "tags", "machine"]);
      return He(He({}, r), {
        tags: Array.from(n)
      });
    }, e.prototype.matches = function(t) {
      return a8(t, this.value);
    }, e.prototype.hasTag = function(t) {
      return this.tags.has(t);
    }, e.prototype.can = function(t) {
      var n;
      I_e(!!this.machine);
      var r = (n = this.machine) === null || n === void 0 ? void 0 : n.getTransitionData(this, t);
      return !!(r != null && r.transitions.length) && // Check that at least one transition is not forbidden
      r.transitions.some(function(i) {
        return i.target !== void 0 || i.actions.length;
      });
    }, e;
  }()
), t6e = {
  deferEvents: !1
}, bN = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = He(He({}, t6e), t);
    }
    return e.prototype.initialize = function(t) {
      if (this.initialized = !0, t) {
        if (!this.options.deferEvents) {
          this.schedule(t);
          return;
        }
        this.process(t);
      }
      this.flushEvents();
    }, e.prototype.schedule = function(t) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(t);
        return;
      }
      if (this.queue.length !== 0)
        throw new Error("Event queue should be empty when it is not processing events");
      this.process(t), this.flushEvents();
    }, e.prototype.clear = function() {
      this.queue = [];
    }, e.prototype.flushEvents = function() {
      for (var t = this.queue.shift(); t; )
        this.process(t), t = this.queue.shift();
    }, e.prototype.process = function(t) {
      this.processingEvent = !0;
      try {
        t();
      } catch (n) {
        throw this.clear(), n;
      } finally {
        this.processingEvent = !1;
      }
    }, e;
  }()
), $_ = /* @__PURE__ */ new Map(), n6e = 0, _0 = {
  bookId: function() {
    return "x:".concat(n6e++);
  },
  register: function(e, t) {
    return $_.set(e, t), e;
  },
  get: function(e) {
    return $_.get(e);
  },
  free: function(e) {
    $_.delete(e);
  }
};
function l8() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u" || typeof window < "u")
    return window;
}
function r6e() {
  var e = l8();
  if (e && "__xstate__" in e)
    return e.__xstate__;
}
function i6e(e) {
  if (l8()) {
    var t = r6e();
    t && t.register(e);
  }
}
function s6e(e, t) {
  t === void 0 && (t = {});
  var n = e.initialState, r = /* @__PURE__ */ new Set(), i = [], s = !1, o = function() {
    if (!s) {
      for (s = !0; i.length > 0; ) {
        var l = i.shift();
        n = e.transition(n, l, c), r.forEach(function(u) {
          return u.next(n);
        });
      }
      s = !1;
    }
  }, a = K_e({
    id: t.id,
    send: function(l) {
      i.push(l), o();
    },
    getSnapshot: function() {
      return n;
    },
    subscribe: function(l, u, d) {
      var f = Pw(l, u, d);
      return r.add(f), f.next(n), {
        unsubscribe: function() {
          r.delete(f);
        }
      };
    }
  }), c = {
    parent: t.parent,
    self: a,
    id: t.id || "anonymous",
    observers: r
  };
  return n = e.start ? e.start(c) : n, a;
}
var o6e = {
  sync: !1,
  autoForward: !1
}, cr;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(cr || (cr = {}));
var a6e = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      n === void 0 && (n = e.defaultOptions);
      var r = this;
      this.machine = t, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = !1, this.status = cr.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this._outgoingQueue = [], this.init = this.start, this.send = function(u, d) {
        if (r0(u))
          return r.batch(u), r.state;
        var f = xr(bE(u, d));
        if (r.status === cr.Stopped)
          return r.state;
        if (r.status !== cr.Running && !r.options.deferEvents)
          throw new Error('Event "'.concat(f.name, '" was sent to uninitialized service "').concat(
            r.machine.id,
            `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
          ).concat(JSON.stringify(f.data)));
        return r.scheduler.schedule(function() {
          r.forward(f);
          var p = r._nextState(f);
          r.update(p, f);
        }), r._state;
      }, this.sendTo = function(u, d, f) {
        var p = r.parent && (d === Im.Parent || r.parent.id === d), m = p ? r.parent : nn(d) ? d === Im.Internal ? r : r.children.get(d) || _0.get(d) : O_e(d) ? d : void 0;
        if (!m) {
          if (!p)
            throw new Error("Unable to send event to child '".concat(d, "' from service '").concat(r.id, "'."));
          return;
        }
        if ("machine" in m) {
          if (r.status !== cr.Stopped || r.parent !== m || // we need to send events to the parent from exit handlers of a machine that reached its final state
          r.state.done) {
            var h = He(He({}, u), {
              name: u.name === v_e ? "".concat(K0(r.id)) : u.name,
              origin: r.sessionId
            });
            !f && r.machine.config.predictableActionArguments ? r._outgoingQueue.push([m, h]) : m.send(h);
          }
        } else
          !f && r.machine.config.predictableActionArguments ? r._outgoingQueue.push([m, u.data]) : m.send(u.data);
      }, this._exec = function(u, d, f, p) {
        p === void 0 && (p = r.machine.options.actions);
        var m = u.exec || LC(u.type, p), h = Xt(m) ? m : m ? m.exec : u.exec;
        if (h)
          try {
            return h(d, f.data, r.machine.config.predictableActionArguments ? {
              action: u,
              _event: f
            } : {
              action: u,
              state: r.state,
              _event: f
            });
          } catch (we) {
            throw r.parent && r.parent.send({
              type: "xstate.error",
              data: we
            }), we;
          }
        switch (u.type) {
          case Cv: {
            var g = u;
            r.defer(g);
            break;
          }
          case yE:
            var y = u;
            if (typeof y.delay == "number") {
              r.defer(y);
              return;
            } else
              y.to ? r.sendTo(y._event, y.to, f === qh) : r.send(y._event);
            break;
          case AW:
            r.cancel(u.sendId);
            break;
          case MC: {
            if (r.status !== cr.Running)
              return;
            var v = u.activity;
            if (
              // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
              !r.machine.config.predictableActionArguments && !r.state.activities[v.id || v.type]
            )
              break;
            if (v.type === un.Invoke) {
              var b = PW(v.src), w = r.machine.options.services ? r.machine.options.services[b.type] : void 0, A = v.id, E = v.data, x = "autoForward" in v ? v.autoForward : !!v.forward;
              if (!w)
                return;
              var S = E ? i2(E, d, f) : void 0;
              if (typeof w == "string")
                return;
              var P = Xt(w) ? w(d, f.data, {
                data: S,
                src: b,
                meta: v.meta
              }) : w;
              if (!P)
                return;
              var I = void 0;
              Pm(P) && (P = S ? P.withContext(S) : P, I = {
                autoForward: x
              }), r.spawn(P, A, I);
            } else
              r.spawnActivity(v);
            break;
          }
          case s8: {
            r.stopChild(u.activity.id);
            break;
          }
          case EW:
            var R = u, Q = R.label, J = R.value;
            Q ? r.logger(Q, J) : r.logger(J);
            break;
        }
      };
      var i = He(He({}, e.defaultOptions), n), s = i.clock, o = i.logger, a = i.parent, c = i.id, l = c !== void 0 ? c : t.id;
      this.id = l, this.logger = o, this.clock = s, this.parent = a, this.options = i, this.scheduler = new bN({
        deferEvents: this.options.deferEvents
      }), this.sessionId = _0.bookId();
    }
    return Object.defineProperty(e.prototype, "initialState", {
      get: function() {
        var t = this;
        return this._initialState ? this._initialState : ah(this, function() {
          return t._initialState = t.machine.initialState, t._initialState;
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "state", {
      /**
       * @deprecated Use `.getSnapshot()` instead.
       */
      get: function() {
        return this._state;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.execute = function(t, n) {
      var r, i;
      try {
        for (var s = Ft(t.actions), o = s.next(); !o.done; o = s.next()) {
          var a = o.value;
          this.exec(a, t, n);
        }
      } catch (c) {
        r = {
          error: c
        };
      } finally {
        try {
          o && !o.done && (i = s.return) && i.call(s);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }, e.prototype.update = function(t, n) {
      var r, i, s, o, a, c, l, u, d = this;
      if (t._sessionid = this.sessionId, this._state = t, (!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
      // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
      n === qh) && this.options.execute)
        this.execute(this.state);
      else
        for (var f = void 0; f = this._outgoingQueue.shift(); )
          f[0].send(f[1]);
      if (this.children.forEach(function(P) {
        d.state.children[P.id] = P;
      }), this.devTools && this.devTools.send(n.data, t), t.event)
        try {
          for (var p = Ft(this.eventListeners), m = p.next(); !m.done; m = p.next()) {
            var h = m.value;
            h(t.event);
          }
        } catch (P) {
          r = {
            error: P
          };
        } finally {
          try {
            m && !m.done && (i = p.return) && i.call(p);
          } finally {
            if (r)
              throw r.error;
          }
        }
      try {
        for (var g = Ft(this.listeners), y = g.next(); !y.done; y = g.next()) {
          var h = y.value;
          h(t, t.event);
        }
      } catch (P) {
        s = {
          error: P
        };
      } finally {
        try {
          y && !y.done && (o = g.return) && o.call(g);
        } finally {
          if (s)
            throw s.error;
        }
      }
      try {
        for (var v = Ft(this.contextListeners), b = v.next(); !b.done; b = v.next()) {
          var w = b.value;
          w(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (P) {
        a = {
          error: P
        };
      } finally {
        try {
          b && !b.done && (c = v.return) && c.call(v);
        } finally {
          if (a)
            throw a.error;
        }
      }
      if (this.state.done) {
        var A = t.configuration.find(function(P) {
          return P.type === "final" && P.parent === d.machine;
        }), E = A && A.doneData ? i2(A.doneData, t.context, n) : void 0;
        this._doneEvent = Ow(this.id, E);
        try {
          for (var x = Ft(this.doneListeners), S = x.next(); !S.done; S = x.next()) {
            var h = S.value;
            h(this._doneEvent);
          }
        } catch (P) {
          l = {
            error: P
          };
        } finally {
          try {
            S && !S.done && (u = x.return) && u.call(x);
          } finally {
            if (l)
              throw l.error;
          }
        }
        this._stop(), this._stopChildren(), _0.free(this.sessionId);
      }
    }, e.prototype.onTransition = function(t) {
      return this.listeners.add(t), this.status === cr.Running && t(this.state, this.state.event), this;
    }, e.prototype.subscribe = function(t, n, r) {
      var i = this, s = Pw(t, n, r);
      this.listeners.add(s.next), this.status !== cr.NotStarted && s.next(this.state);
      var o = function() {
        i.doneListeners.delete(o), i.stopListeners.delete(o), s.complete();
      };
      return this.status === cr.Stopped ? s.complete() : (this.onDone(o), this.onStop(o)), {
        unsubscribe: function() {
          i.listeners.delete(s.next), i.doneListeners.delete(o), i.stopListeners.delete(o);
        }
      };
    }, e.prototype.onEvent = function(t) {
      return this.eventListeners.add(t), this;
    }, e.prototype.onSend = function(t) {
      return this.sendListeners.add(t), this;
    }, e.prototype.onChange = function(t) {
      return this.contextListeners.add(t), this;
    }, e.prototype.onStop = function(t) {
      return this.stopListeners.add(t), this;
    }, e.prototype.onDone = function(t) {
      return this.status === cr.Stopped && this._doneEvent ? t(this._doneEvent) : this.doneListeners.add(t), this;
    }, e.prototype.off = function(t) {
      return this.listeners.delete(t), this.eventListeners.delete(t), this.sendListeners.delete(t), this.stopListeners.delete(t), this.doneListeners.delete(t), this.contextListeners.delete(t), this;
    }, e.prototype.start = function(t) {
      var n = this;
      if (this.status === cr.Running)
        return this;
      this.machine._init(), _0.register(this.sessionId, this), this.initialized = !0, this.status = cr.Running;
      var r = t === void 0 ? this.initialState : ah(this, function() {
        return X_e(t) ? n.machine.resolveState(t) : n.machine.resolveState(ws.from(t, n.machine.context));
      });
      return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
        n.update(r, qh);
      }), this;
    }, e.prototype._stopChildren = function() {
      this.children.forEach(function(t) {
        Xt(t.stop) && t.stop();
      }), this.children.clear();
    }, e.prototype._stop = function() {
      var t, n, r, i, s, o, a, c, l, u;
      try {
        for (var d = Ft(this.listeners), f = d.next(); !f.done; f = d.next()) {
          var p = f.value;
          this.listeners.delete(p);
        }
      } catch (x) {
        t = {
          error: x
        };
      } finally {
        try {
          f && !f.done && (n = d.return) && n.call(d);
        } finally {
          if (t)
            throw t.error;
        }
      }
      try {
        for (var m = Ft(this.stopListeners), h = m.next(); !h.done; h = m.next()) {
          var p = h.value;
          p(), this.stopListeners.delete(p);
        }
      } catch (x) {
        r = {
          error: x
        };
      } finally {
        try {
          h && !h.done && (i = m.return) && i.call(m);
        } finally {
          if (r)
            throw r.error;
        }
      }
      try {
        for (var g = Ft(this.contextListeners), y = g.next(); !y.done; y = g.next()) {
          var p = y.value;
          this.contextListeners.delete(p);
        }
      } catch (x) {
        s = {
          error: x
        };
      } finally {
        try {
          y && !y.done && (o = g.return) && o.call(g);
        } finally {
          if (s)
            throw s.error;
        }
      }
      try {
        for (var v = Ft(this.doneListeners), b = v.next(); !b.done; b = v.next()) {
          var p = b.value;
          this.doneListeners.delete(p);
        }
      } catch (x) {
        a = {
          error: x
        };
      } finally {
        try {
          b && !b.done && (c = v.return) && c.call(v);
        } finally {
          if (a)
            throw a.error;
        }
      }
      if (!this.initialized)
        return this;
      this.initialized = !1, this.status = cr.Stopped, this._initialState = void 0;
      try {
        for (var w = Ft(Object.keys(this.delayedEventsMap)), A = w.next(); !A.done; A = w.next()) {
          var E = A.value;
          this.clock.clearTimeout(this.delayedEventsMap[E]);
        }
      } catch (x) {
        l = {
          error: x
        };
      } finally {
        try {
          A && !A.done && (u = w.return) && u.call(w);
        } finally {
          if (l)
            throw l.error;
        }
      }
      this.scheduler.clear(), this.scheduler = new bN({
        deferEvents: this.options.deferEvents
      });
    }, e.prototype.stop = function() {
      var t = this, n = this.scheduler;
      return this._stop(), n.schedule(function() {
        var r;
        if (!(!((r = t._state) === null || r === void 0) && r.done)) {
          var i = xr({
            type: "xstate.stop"
          }), s = ah(t, function() {
            var o = En(vn([], $t(t.state.configuration), !1).sort(function(d, f) {
              return f.order - d.order;
            }).map(function(d) {
              return ll(d.onExit, t.machine.options.actions);
            })), a = $t(s2(t.machine, t.state, t.state.context, i, [{
              type: "exit",
              actions: o
            }], t.machine.config.predictableActionArguments ? t._exec : void 0, t.machine.config.predictableActionArguments || t.machine.config.preserveActionOrder), 2), c = a[0], l = a[1], u = new ws({
              value: t.state.value,
              context: l,
              _event: i,
              _sessionid: t.sessionId,
              historyValue: void 0,
              history: t.state,
              actions: c.filter(function(d) {
                return !UC(d);
              }),
              activities: {},
              events: [],
              configuration: [],
              transitions: [],
              children: {},
              done: t.state.done,
              tags: t.state.tags,
              machine: t.machine
            });
            return u.changed = !0, u;
          });
          t.update(s, i), t._stopChildren(), _0.free(t.sessionId);
        }
      }), this;
    }, e.prototype.batch = function(t) {
      var n = this;
      if (!(this.status === cr.NotStarted && this.options.deferEvents)) {
        if (this.status !== cr.Running)
          throw new Error(
            // tslint:disable-next-line:max-line-length
            "".concat(t.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
          );
      }
      if (t.length) {
        var r = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
          var i, s, o = n.state, a = !1, c = [], l = function(p) {
            var m = xr(p);
            n.forward(m), o = ah(n, function() {
              return n.machine.transition(o, m, void 0, r || void 0);
            }), c.push.apply(c, vn([], $t(n.machine.config.predictableActionArguments ? o.actions : o.actions.map(function(h) {
              return e6e(h, o);
            })), !1)), a = a || !!o.changed;
          };
          try {
            for (var u = Ft(t), d = u.next(); !d.done; d = u.next()) {
              var f = d.value;
              l(f);
            }
          } catch (p) {
            i = {
              error: p
            };
          } finally {
            try {
              d && !d.done && (s = u.return) && s.call(u);
            } finally {
              if (i)
                throw i.error;
            }
          }
          o.changed = a, o.actions = c, n.update(o, xr(t[t.length - 1]));
        });
      }
    }, e.prototype.sender = function(t) {
      return this.send.bind(this, t);
    }, e.prototype._nextState = function(t, n) {
      var r = this;
      n === void 0 && (n = !!this.machine.config.predictableActionArguments && this._exec);
      var i = xr(t);
      if (i.name.indexOf(fN) === 0 && !this.state.nextEvents.some(function(o) {
        return o.indexOf(fN) === 0;
      }))
        throw i.data.data;
      var s = ah(this, function() {
        return r.machine.transition(r.state, i, void 0, n || void 0);
      });
      return s;
    }, e.prototype.nextState = function(t) {
      return this._nextState(t, !1);
    }, e.prototype.forward = function(t) {
      var n, r;
      try {
        for (var i = Ft(this.forwardTo), s = i.next(); !s.done; s = i.next()) {
          var o = s.value, a = this.children.get(o);
          if (!a)
            throw new Error("Unable to forward event '".concat(t, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(o, "'."));
          a.send(t);
        }
      } catch (c) {
        n = {
          error: c
        };
      } finally {
        try {
          s && !s.done && (r = i.return) && r.call(i);
        } finally {
          if (n)
            throw n.error;
        }
      }
    }, e.prototype.defer = function(t) {
      var n = this, r = this.clock.setTimeout(function() {
        "to" in t && t.to ? n.sendTo(t._event, t.to, !0) : n.send(t._event);
      }, t.delay);
      t.id && (this.delayedEventsMap[t.id] = r);
    }, e.prototype.cancel = function(t) {
      this.clock.clearTimeout(this.delayedEventsMap[t]), delete this.delayedEventsMap[t];
    }, e.prototype.exec = function(t, n, r) {
      r === void 0 && (r = this.machine.options.actions), this._exec(t, n.context, n._event, r);
    }, e.prototype.removeChild = function(t) {
      var n;
      this.children.delete(t), this.forwardTo.delete(t), (n = this.state) === null || n === void 0 || delete n.children[t];
    }, e.prototype.stopChild = function(t) {
      var n = this.children.get(t);
      n && (this.removeChild(t), Xt(n.stop) && n.stop());
    }, e.prototype.spawn = function(t, n, r) {
      if (this.status !== cr.Running)
        return NW(t, n);
      if (mN(t))
        return this.spawnPromise(Promise.resolve(t), n);
      if (Xt(t))
        return this.spawnCallback(t, n);
      if (Q_e(t))
        return this.spawnActor(t, n);
      if (P_e(t))
        return this.spawnObservable(t, n);
      if (Pm(t))
        return this.spawnMachine(t, He(He({}, r), {
          id: n
        }));
      if (T_e(t))
        return this.spawnBehavior(t, n);
      throw new Error('Unable to spawn entity "'.concat(n, '" of type "').concat(typeof t, '".'));
    }, e.prototype.spawnMachine = function(t, n) {
      var r = this;
      n === void 0 && (n = {});
      var i = new e(t, He(He({}, this.options), {
        parent: this,
        id: n.id || t.id
      })), s = He(He({}, o6e), n);
      s.sync && i.onTransition(function(a) {
        r.send(_W, {
          state: a,
          id: i.id
        });
      });
      var o = i;
      return this.children.set(i.id, o), s.autoForward && this.forwardTo.add(i.id), i.onDone(function(a) {
        r.removeChild(i.id), r.send(xr(a, {
          origin: i.id
        }));
      }).start(), o;
    }, e.prototype.spawnBehavior = function(t, n) {
      var r = s6e(t, {
        id: n,
        parent: this
      });
      return this.children.set(n, r), r;
    }, e.prototype.spawnPromise = function(t, n) {
      var r, i = this, s = !1, o;
      t.then(function(c) {
        s || (o = c, i.removeChild(n), i.send(xr(Ow(n, c), {
          origin: n
        })));
      }, function(c) {
        if (!s) {
          i.removeChild(n);
          var l = K0(n, c);
          try {
            i.send(xr(l, {
              origin: n
            }));
          } catch {
            i.devTools && i.devTools.send(l, i.state), i.machine.strict && i.stop();
          }
        }
      });
      var a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, l, u) {
          var d = Pw(c, l, u), f = !1;
          return t.then(function(p) {
            f || (d.next(p), !f && d.complete());
          }, function(p) {
            f || d.error(p);
          }), {
            unsubscribe: function() {
              return f = !0;
            }
          };
        },
        stop: function() {
          s = !0;
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return o;
        }
      }, r[cl] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, e.prototype.spawnCallback = function(t, n) {
      var r, i = this, s = !1, o = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), c, l = function(f) {
        c = f, a.forEach(function(p) {
          return p(f);
        }), !s && i.send(xr(f, {
          origin: n
        }));
      }, u;
      try {
        u = t(l, function(f) {
          o.add(f);
        });
      } catch (f) {
        this.send(K0(n, f));
      }
      if (mN(u))
        return this.spawnPromise(u, n);
      var d = (r = {
        id: n,
        send: function(f) {
          return o.forEach(function(p) {
            return p(f);
          });
        },
        subscribe: function(f) {
          var p = Pw(f);
          return a.add(p.next), {
            unsubscribe: function() {
              a.delete(p.next);
            }
          };
        },
        stop: function() {
          s = !0, Xt(u) && u();
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return c;
        }
      }, r[cl] = function() {
        return this;
      }, r);
      return this.children.set(n, d), d;
    }, e.prototype.spawnObservable = function(t, n) {
      var r, i = this, s, o = t.subscribe(function(c) {
        s = c, i.send(xr(c, {
          origin: n
        }));
      }, function(c) {
        i.removeChild(n), i.send(xr(K0(n, c), {
          origin: n
        }));
      }, function() {
        i.removeChild(n), i.send(xr(Ow(n), {
          origin: n
        }));
      }), a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, l, u) {
          return t.subscribe(c, l, u);
        },
        stop: function() {
          return o.unsubscribe();
        },
        getSnapshot: function() {
          return s;
        },
        toJSON: function() {
          return {
            id: n
          };
        }
      }, r[cl] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, e.prototype.spawnActor = function(t, n) {
      return this.children.set(n, t), t;
    }, e.prototype.spawnActivity = function(t) {
      var n = this.machine.options && this.machine.options.activities ? this.machine.options.activities[t.type] : void 0;
      if (n) {
        var r = n(this.state.context, t);
        this.spawnEffect(t.id, r);
      }
    }, e.prototype.spawnEffect = function(t, n) {
      var r;
      this.children.set(t, (r = {
        id: t,
        send: function() {
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
            }
          };
        },
        stop: n || void 0,
        getSnapshot: function() {
        },
        toJSON: function() {
          return {
            id: t
          };
        }
      }, r[cl] = function() {
        return this;
      }, r));
    }, e.prototype.attachDev = function() {
      var t = l8();
      if (this.options.devTools && t) {
        if (t.__REDUX_DEVTOOLS_EXTENSION__) {
          var n = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
          this.devTools = t.__REDUX_DEVTOOLS_EXTENSION__.connect(He(He({
            name: this.id,
            autoPause: !0,
            stateSanitizer: function(r) {
              return {
                value: r.value,
                context: r.context,
                actions: r.actions
              };
            }
          }, n), {
            features: He({
              jump: !1,
              skip: !1
            }, n ? n.features : void 0)
          }), this.machine), this.devTools.init(this.state);
        }
        i6e(this);
      }
    }, e.prototype.toJSON = function() {
      return {
        id: this.id
      };
    }, e.prototype[cl] = function() {
      return this;
    }, e.prototype.getSnapshot = function() {
      return this.status === cr.NotStarted ? this.initialState : this._state;
    }, e.defaultOptions = {
      execute: !0,
      deferEvents: !0,
      clock: {
        setTimeout: function(t, n) {
          return setTimeout(t, n);
        },
        clearTimeout: function(t) {
          return clearTimeout(t);
        }
      },
      logger: /* @__PURE__ */ console.log.bind(console),
      devTools: !1
    }, e.interpret = DW, e;
  }()
);
function DW(e, t) {
  var n = new a6e(e, t);
  return n;
}
function c6e(e) {
  if (typeof e == "string") {
    var t = {
      type: e
    };
    return t.toString = function() {
      return e;
    }, t;
  }
  return e;
}
function A1(e) {
  return He(He({
    type: FC
  }, e), {
    toJSON: function() {
      e.onDone, e.onError;
      var t = i8(e, ["onDone", "onError"]);
      return He(He({}, t), {
        type: FC,
        src: c6e(e.src)
      });
    }
  });
}
var E1 = "", VC = "#", Q_ = "*", Kf = {}, Yf = function(e) {
  return e[0] === VC;
}, l6e = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
}, u6e = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n, r, i) {
      r === void 0 && (r = "context" in t ? t.context : void 0);
      var s = this, o;
      this.config = t, this._context = r, this.order = -1, this.__xstatenode = !0, this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign(l6e(), n), this.parent = i == null ? void 0 : i.parent, this.key = this.config.key || (i == null ? void 0 : i.key) || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : SW), this.id = this.config.id || vn([this.machine.key], $t(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (o = this.config.schema) !== null && o !== void 0 ? o : {}, this.description = this.config.description, this.initial = this.config.initial, this.states = this.config.states ? Q0(this.config.states, function(l, u) {
        var d, f = new e(l, {}, void 0, {
          parent: s,
          key: u
        });
        return Object.assign(s.idMap, He((d = {}, d[f.id] = f, d), f.idMap)), f;
      }) : Kf;
      var a = 0;
      function c(l) {
        var u, d;
        l.order = a++;
        try {
          for (var f = Ft(RW(l)), p = f.next(); !p.done; p = f.next()) {
            var m = p.value;
            c(m);
          }
        } catch (h) {
          u = {
            error: h
          };
        } finally {
          try {
            p && !p.done && (d = f.return) && d.call(f);
          } finally {
            if (u)
              throw u.error;
          }
        }
      }
      c(this), this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(l) {
        var u = l.event;
        return u === E1;
      }) : E1 in this.config.on : !1), this.strict = !!this.config.strict, this.onEntry = qs(this.config.entry || this.config.onEntry).map(function(l) {
        return Oy(l);
      }), this.onExit = qs(this.config.exit || this.config.onExit).map(function(l) {
        return Oy(l);
      }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = qs(this.config.invoke).map(function(l, u) {
        var d, f;
        if (Pm(l)) {
          var p = w1(s.id, u);
          return s.machine.options.services = He((d = {}, d[p] = l, d), s.machine.options.services), A1({
            src: p,
            id: p
          });
        } else if (nn(l.src)) {
          var p = l.id || w1(s.id, u);
          return A1(He(He({}, l), {
            id: p,
            src: l.src
          }));
        } else if (Pm(l.src) || Xt(l.src)) {
          var p = l.id || w1(s.id, u);
          return s.machine.options.services = He((f = {}, f[p] = l.src, f), s.machine.options.services), A1(He(He({
            id: p
          }, l), {
            src: p
          }));
        } else {
          var m = l.src;
          return A1(He(He({
            id: w1(s.id, u)
          }, l), {
            src: m
          }));
        }
      }), this.activities = qs(this.config.activities).concat(this.invoke).map(function(l) {
        return c8(l);
      }), this.transition = this.transition.bind(this), this.tags = qs(this.config.tags);
    }
    return e.prototype._init = function() {
      this.__cache.transitions || MW(this).forEach(function(t) {
        return t.on;
      });
    }, e.prototype.withConfig = function(t, n) {
      var r = this.options, i = r.actions, s = r.activities, o = r.guards, a = r.services, c = r.delays;
      return new e(this.config, {
        actions: He(He({}, i), t.actions),
        activities: He(He({}, s), t.activities),
        guards: He(He({}, o), t.guards),
        services: He(He({}, a), t.services),
        delays: He(He({}, c), t.delays)
      }, n ?? this.context);
    }, e.prototype.withContext = function(t) {
      return new e(this.config, this.options, t);
    }, Object.defineProperty(e.prototype, "context", {
      get: function() {
        return Xt(this._context) ? this._context() : this._context;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: Q0(this.states, function(t) {
            return t.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toJSON = function() {
      return this.definition;
    }, Object.defineProperty(e.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on)
          return this.__cache.on;
        var t = this.transitions;
        return this.__cache.on = t.reduce(function(n, r) {
          return n[r.eventType] = n[r.eventType] || [], n[r.eventType].push(r), n;
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getCandidates = function(t) {
      if (this.__cache.candidates[t])
        return this.__cache.candidates[t];
      var n = t === E1, r = this.transitions.filter(function(i) {
        var s = i.eventType === t;
        return n ? s : s || i.eventType === Q_;
      });
      return this.__cache.candidates[t] = r, r;
    }, e.prototype.getDelayedTransitions = function() {
      var t = this, n = this.config.after;
      if (!n)
        return [];
      var r = function(s, o) {
        var a = Xt(s) ? "".concat(t.id, ":delay[").concat(o, "]") : s, c = W_e(a, t.id);
        return t.onEntry.push(F_e(c, {
          delay: s
        })), t.onExit.push(U_e(c)), c;
      }, i = r0(n) ? n.map(function(s, o) {
        var a = r(s.delay, o);
        return He(He({}, s), {
          event: a
        });
      }) : En(Object.keys(n).map(function(s, o) {
        var a = n[s], c = nn(a) ? {
          target: a
        } : a, l = isNaN(+s) ? s : +s, u = r(l, o);
        return qs(c).map(function(d) {
          return He(He({}, d), {
            event: u,
            delay: l
          });
        });
      }));
      return i.map(function(s) {
        var o = s.delay;
        return He(He({}, t.formatTransition(s)), {
          delay: o
        });
      });
    }, e.prototype.getStateNodes = function(t) {
      var n, r = this;
      if (!t)
        return [];
      var i = t instanceof ws ? t.value : Sg(t, this.delimiter);
      if (nn(i)) {
        var s = this.getStateNode(i).initial;
        return s !== void 0 ? this.getStateNodes((n = {}, n[i] = s, n)) : [this, this.states[i]];
      }
      var o = Object.keys(i), a = [this];
      return a.push.apply(a, vn([], $t(En(o.map(function(c) {
        return r.getStateNode(c).getStateNodes(i[c]);
      }))), !1)), a;
    }, e.prototype.handles = function(t) {
      var n = CW(t);
      return this.events.includes(n);
    }, e.prototype.resolveState = function(t) {
      var n = t instanceof ws ? t : ws.create(t), r = Array.from(Y0([], this.getStateNodes(n.value)));
      return new ws(He(He({}, n), {
        value: this.resolve(n.value),
        configuration: r,
        done: Nw(r, this),
        tags: yN(r),
        machine: this.machine
      }));
    }, e.prototype.transitionLeafNode = function(t, n, r) {
      var i = this.getStateNode(t), s = i.next(n, r);
      return !s || !s.transitions.length ? this.next(n, r) : s;
    }, e.prototype.transitionCompoundNode = function(t, n, r) {
      var i = Object.keys(t), s = this.getStateNode(i[0]), o = s._transition(t[i[0]], n, r);
      return !o || !o.transitions.length ? this.next(n, r) : o;
    }, e.prototype.transitionParallelNode = function(t, n, r) {
      var i, s, o = {};
      try {
        for (var a = Ft(Object.keys(t)), c = a.next(); !c.done; c = a.next()) {
          var l = c.value, u = t[l];
          if (u) {
            var d = this.getStateNode(l), f = d._transition(u, n, r);
            f && (o[l] = f);
          }
        }
      } catch (y) {
        i = {
          error: y
        };
      } finally {
        try {
          c && !c.done && (s = a.return) && s.call(a);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var p = Object.keys(o).map(function(y) {
        return o[y];
      }), m = En(p.map(function(y) {
        return y.transitions;
      })), h = p.some(function(y) {
        return y.transitions.length > 0;
      });
      if (!h)
        return this.next(n, r);
      var g = En(Object.keys(o).map(function(y) {
        return o[y].configuration;
      }));
      return {
        transitions: m,
        exitSet: En(p.map(function(y) {
          return y.exitSet;
        })),
        configuration: g,
        source: n,
        actions: En(Object.keys(o).map(function(y) {
          return o[y].actions;
        }))
      };
    }, e.prototype._transition = function(t, n, r) {
      return nn(t) ? this.transitionLeafNode(t, n, r) : Object.keys(t).length === 1 ? this.transitionCompoundNode(t, n, r) : this.transitionParallelNode(t, n, r);
    }, e.prototype.getTransitionData = function(t, n) {
      return this._transition(t.value, t, xr(n));
    }, e.prototype.next = function(t, n) {
      var r, i, s = this, o = n.name, a = [], c = [], l;
      try {
        for (var u = Ft(this.getCandidates(o)), d = u.next(); !d.done; d = u.next()) {
          var f = d.value, p = f.cond, m = f.in, h = t.context, g = m ? nn(m) && Yf(m) ? (
            // Check if in state by ID
            t.matches(Sg(this.getStateNodeById(m).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            a8(Sg(m, this.delimiter), __e(this.path.slice(0, -2))(t.value))
          ) : !0, y = !1;
          try {
            y = !p || IW(this.machine, p, h, n, t);
          } catch (w) {
            throw new Error("Unable to evaluate guard '".concat(p.name || p.type, "' in transition for event '").concat(o, "' in state node '").concat(this.id, `':
`).concat(w.message));
          }
          if (y && g) {
            f.target !== void 0 && (c = f.target), a.push.apply(a, vn([], $t(f.actions), !1)), l = f;
            break;
          }
        }
      } catch (w) {
        r = {
          error: w
        };
      } finally {
        try {
          d && !d.done && (i = u.return) && i.call(u);
        } finally {
          if (r)
            throw r.error;
        }
      }
      if (l) {
        if (!c.length)
          return {
            transitions: [l],
            exitSet: [],
            configuration: t.value ? [this] : [],
            source: t,
            actions: a
          };
        var v = En(c.map(function(w) {
          return s.getRelativeStateNodes(w, t.historyValue);
        })), b = !!l.internal;
        return {
          transitions: [l],
          exitSet: b ? [] : En(c.map(function(w) {
            return s.getPotentiallyReenteringNodes(w);
          })),
          configuration: v,
          source: t,
          actions: a
        };
      }
    }, e.prototype.getPotentiallyReenteringNodes = function(t) {
      if (this.order < t.order)
        return [this];
      for (var n = [], r = this, i = t; r && r !== i; )
        n.push(r), r = r.parent;
      return r !== i ? [] : (n.push(i), n);
    }, e.prototype.getActions = function(t, n, r, i, s, o, a) {
      var c, l, u, d, f = this, p = o ? Y0([], this.getStateNodes(o.value)) : [], m = /* @__PURE__ */ new Set();
      try {
        for (var h = Ft(Array.from(t).sort(function(R, Q) {
          return R.order - Q.order;
        })), g = h.next(); !g.done; g = h.next()) {
          var y = g.value;
          (!Z0(p, y) || Z0(r.exitSet, y) || y.parent && m.has(y.parent)) && m.add(y);
        }
      } catch (R) {
        c = {
          error: R
        };
      } finally {
        try {
          g && !g.done && (l = h.return) && l.call(h);
        } finally {
          if (c)
            throw c.error;
        }
      }
      try {
        for (var v = Ft(p), b = v.next(); !b.done; b = v.next()) {
          var y = b.value;
          (!Z0(t, y) || Z0(r.exitSet, y.parent)) && r.exitSet.push(y);
        }
      } catch (R) {
        u = {
          error: R
        };
      } finally {
        try {
          b && !b.done && (d = v.return) && d.call(v);
        } finally {
          if (u)
            throw u.error;
        }
      }
      r.exitSet.sort(function(R, Q) {
        return Q.order - R.order;
      });
      var w = Array.from(m).sort(function(R, Q) {
        return R.order - Q.order;
      }), A = new Set(r.exitSet), E = En(w.map(function(R) {
        var Q = [];
        if (R.type !== "final")
          return Q;
        var J = R.parent;
        if (!J.parent)
          return Q;
        Q.push(
          x1(R.id, R.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          x1(J.id, R.doneData ? i2(R.doneData, i, s) : void 0)
        );
        var we = J.parent;
        return we.type === "parallel" && Ny(we).every(function(V) {
          return Nw(r.configuration, V);
        }) && Q.push(x1(we.id)), Q;
      })), x = w.map(function(R) {
        var Q = R.onEntry, J = R.activities.map(function(we) {
          return L_e(we);
        });
        return {
          type: "entry",
          actions: ll(a ? vn(vn([], $t(Q), !1), $t(J), !1) : vn(vn([], $t(J), !1), $t(Q), !1), f.machine.options.actions)
        };
      }).concat({
        type: "state_done",
        actions: E.map(function(R) {
          return R_e(R);
        })
      }), S = Array.from(A).map(function(R) {
        return {
          type: "exit",
          actions: ll(vn(vn([], $t(R.onExit), !1), $t(R.activities.map(function(Q) {
            return z_e(Q);
          })), !1), f.machine.options.actions)
        };
      }), P = S.concat({
        type: "transition",
        actions: ll(r.actions, this.machine.options.actions)
      }).concat(x);
      if (n) {
        var I = ll(En(vn([], $t(t), !1).sort(function(R, Q) {
          return Q.order - R.order;
        }).map(function(R) {
          return R.onExit;
        })), this.machine.options.actions).filter(function(R) {
          return !UC(R);
        });
        return P.concat({
          type: "stop",
          actions: I
        });
      }
      return P;
    }, e.prototype.transition = function(t, n, r, i) {
      t === void 0 && (t = this.initialState);
      var s = xr(n), o;
      if (t instanceof ws)
        o = r === void 0 ? t : this.resolveState(ws.from(t, r));
      else {
        var a = nn(t) ? this.resolve(r2(this.getResolvedPath(t))) : this.resolve(t), c = r ?? this.machine.context;
        o = this.resolveState(ws.from(a, c));
      }
      if (this.strict && !this.events.includes(s.name) && !C_e(s.name))
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(s.name, "'"));
      var l = this._transition(o.value, o, s) || {
        transitions: [],
        configuration: [],
        exitSet: [],
        source: o,
        actions: []
      }, u = Y0([], this.getStateNodes(o.value)), d = l.configuration.length ? Y0(u, l.configuration) : u;
      return l.configuration = vn([], $t(d), !1), this.resolveTransition(l, o, o.context, i, s);
    }, e.prototype.resolveRaisedTransition = function(t, n, r, i) {
      var s, o = t.actions;
      return t = this.transition(t, n, void 0, i), t._event = r, t.event = r.data, (s = t.actions).unshift.apply(s, vn([], $t(o), !1)), t;
    }, e.prototype.resolveTransition = function(t, n, r, i, s) {
      var o, a, c, l, u = this;
      s === void 0 && (s = qh);
      var d = t.configuration, f = !n || t.transitions.length > 0, p = f ? t.configuration : n ? n.configuration : [], m = Nw(p, this), h = f ? Y_e(this.machine, d) : void 0, g = n ? n.historyValue ? n.historyValue : t.source ? this.machine.historyValue(n.value) : void 0 : void 0, y = this.getActions(new Set(p), m, t, r, s, n, i), v = n ? He({}, n.activities) : {};
      try {
        for (var b = Ft(y), w = b.next(); !w.done; w = b.next()) {
          var A = w.value;
          try {
            for (var E = (c = void 0, Ft(A.actions)), x = E.next(); !x.done; x = E.next()) {
              var S = x.value;
              S.type === MC ? v[S.activity.id || S.activity.type] = S : S.type === s8 && (v[S.activity.id || S.activity.type] = !1);
            }
          } catch (B) {
            c = {
              error: B
            };
          } finally {
            try {
              x && !x.done && (l = E.return) && l.call(E);
            } finally {
              if (c)
                throw c.error;
            }
          }
        }
      } catch (B) {
        o = {
          error: B
        };
      } finally {
        try {
          w && !w.done && (a = b.return) && a.call(b);
        } finally {
          if (o)
            throw o.error;
        }
      }
      var P = $t(s2(this, n, r, s, y, i, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), I = P[0], R = P[1], Q = $t(k_e(I, UC), 2), J = Q[0], we = Q[1], V = I.filter(function(B) {
        var be;
        return B.type === MC && ((be = B.activity) === null || be === void 0 ? void 0 : be.type) === FC;
      }), L = V.reduce(function(B, be) {
        return B[be.activity.id] = q_e(be.activity, u.machine, R, s), B;
      }, n ? He({}, n.children) : {}), U = new ws({
        value: h || n.value,
        context: R,
        _event: s,
        // Persist _sessionid between states
        _sessionid: n ? n._sessionid : null,
        historyValue: h ? g ? B_e(g, h) : void 0 : n ? n.historyValue : void 0,
        history: !h || t.source ? n : void 0,
        actions: h ? we : [],
        activities: h ? v : n ? n.activities : {},
        events: [],
        configuration: p,
        transitions: t.transitions,
        children: L,
        done: m,
        tags: yN(p),
        machine: this
      }), q = r !== R;
      U.changed = s.name === _W || q;
      var G = U.history;
      G && delete G.history;
      var ae = !m && (this._transient || d.some(function(B) {
        return B._transient;
      }));
      if (!f && (!ae || s.name === E1))
        return U;
      var ge = U;
      if (!m)
        for (ae && (ge = this.resolveRaisedTransition(ge, {
          type: y_e
        }, s, i)); J.length; ) {
          var Ae = J.shift();
          ge = this.resolveRaisedTransition(ge, Ae._event, s, i);
        }
      var he = ge.changed || (G ? !!ge.actions.length || q || typeof G.value != typeof ge.value || !jW(ge.value, G.value) : void 0);
      return ge.changed = he, ge.history = G, ge;
    }, e.prototype.getStateNode = function(t) {
      if (Yf(t))
        return this.machine.getStateNodeById(t);
      if (!this.states)
        throw new Error("Unable to retrieve child state '".concat(t, "' from '").concat(this.id, "'; no child states exist."));
      var n = this.states[t];
      if (!n)
        throw new Error("Child state '".concat(t, "' does not exist on '").concat(this.id, "'"));
      return n;
    }, e.prototype.getStateNodeById = function(t) {
      var n = Yf(t) ? t.slice(VC.length) : t;
      if (n === this.id)
        return this;
      var r = this.machine.idMap[n];
      if (!r)
        throw new Error("Child state node '#".concat(n, "' does not exist on machine '").concat(this.id, "'"));
      return r;
    }, e.prototype.getStateNodeByPath = function(t) {
      if (typeof t == "string" && Yf(t))
        try {
          return this.getStateNodeById(t.slice(1));
        } catch {
        }
      for (var n = DC(t, this.delimiter).slice(), r = this; n.length; ) {
        var i = n.shift();
        if (!i.length)
          break;
        r = r.getStateNode(i);
      }
      return r;
    }, e.prototype.resolve = function(t) {
      var n, r = this;
      if (!t)
        return this.initialStateValue || Kf;
      switch (this.type) {
        case "parallel":
          return Q0(this.initialStateValue, function(s, o) {
            return s ? r.getStateNode(o).resolve(t[o] || s) : Kf;
          });
        case "compound":
          if (nn(t)) {
            var i = this.getStateNode(t);
            return i.type === "parallel" || i.type === "compound" ? (n = {}, n[t] = i.initialStateValue, n) : t;
          }
          return Object.keys(t).length ? Q0(t, function(s, o) {
            return s ? r.getStateNode(o).resolve(s) : Kf;
          }) : this.initialStateValue || {};
        default:
          return t || Kf;
      }
    }, e.prototype.getResolvedPath = function(t) {
      if (Yf(t)) {
        var n = this.machine.idMap[t.slice(VC.length)];
        if (!n)
          throw new Error("Unable to find state node '".concat(t, "'"));
        return n.path;
      }
      return DC(t, this.delimiter);
    }, Object.defineProperty(e.prototype, "initialStateValue", {
      get: function() {
        var t;
        if (this.__cache.initialStateValue)
          return this.__cache.initialStateValue;
        var n;
        if (this.type === "parallel")
          n = pN(this.states, function(r) {
            return r.initialStateValue || Kf;
          }, function(r) {
            return r.type !== "history";
          });
        else if (this.initial !== void 0) {
          if (!this.states[this.initial])
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          n = o2(this.states[this.initial]) ? this.initial : (t = {}, t[this.initial] = this.states[this.initial].initialStateValue, t);
        } else
          n = {};
        return this.__cache.initialStateValue = n, this.__cache.initialStateValue;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getInitialState = function(t, n) {
      this._init();
      var r = this.getStateNodes(t);
      return this.resolveTransition({
        configuration: r,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, n ?? this.machine.context, void 0);
    }, Object.defineProperty(e.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var t = this.initialStateValue;
        if (!t)
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var t;
        if (this.type === "history") {
          var n = this.config;
          nn(n.target) ? t = Yf(n.target) ? r2(this.machine.getStateNodeById(n.target).path.slice(this.path.length - 1)) : n.target : t = n.target;
        }
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getRelativeStateNodes = function(t, n, r) {
      return r === void 0 && (r = !0), r ? t.type === "history" ? t.resolveHistory(n) : t.initialStateNodes : [t];
    }, Object.defineProperty(e.prototype, "initialStateNodes", {
      get: function() {
        var t = this;
        if (o2(this))
          return [this];
        if (this.type === "compound" && !this.initial)
          return [this];
        var n = Iw(this.initialStateValue);
        return En(n.map(function(r) {
          return t.getFromRelativePath(r);
        }));
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getFromRelativePath = function(t) {
      if (!t.length)
        return [this];
      var n = $t(t), r = n[0], i = n.slice(1);
      if (!this.states)
        throw new Error("Cannot retrieve subPath '".concat(r, "' from node with no states"));
      var s = this.getStateNode(r);
      if (s.type === "history")
        return s.resolveHistory();
      if (!this.states[r])
        throw new Error("Child state '".concat(r, "' does not exist on '").concat(this.id, "'"));
      return this.states[r].getFromRelativePath(i);
    }, e.prototype.historyValue = function(t) {
      if (Object.keys(this.states).length)
        return {
          current: t || this.initialStateValue,
          states: pN(this.states, function(n, r) {
            if (!t)
              return n.historyValue();
            var i = nn(t) ? void 0 : t[r];
            return n.historyValue(i || n.initialStateValue);
          }, function(n) {
            return !n.history;
          })
        };
    }, e.prototype.resolveHistory = function(t) {
      var n = this;
      if (this.type !== "history")
        return [this];
      var r = this.parent;
      if (!t) {
        var i = this.target;
        return i ? En(Iw(i).map(function(o) {
          return r.getFromRelativePath(o);
        })) : r.initialStateNodes;
      }
      var s = S_e(r.path, "states")(t).current;
      return nn(s) ? [r.getStateNode(s)] : En(Iw(s).map(function(o) {
        return n.history === "deep" ? r.getFromRelativePath(o) : [r.states[o[0]]];
      }));
    }, Object.defineProperty(e.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var t = this, n = En(Object.keys(this.states).map(function(r) {
          return t.states[r].stateIds;
        }));
        return [this.id].concat(n);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var t, n, r, i;
        if (this.__cache.events)
          return this.__cache.events;
        var s = this.states, o = new Set(this.ownEvents);
        if (s)
          try {
            for (var a = Ft(Object.keys(s)), c = a.next(); !c.done; c = a.next()) {
              var l = c.value, u = s[l];
              if (u.states)
                try {
                  for (var d = (r = void 0, Ft(u.events)), f = d.next(); !f.done; f = d.next()) {
                    var p = f.value;
                    o.add("".concat(p));
                  }
                } catch (m) {
                  r = {
                    error: m
                  };
                } finally {
                  try {
                    f && !f.done && (i = d.return) && i.call(d);
                  } finally {
                    if (r)
                      throw r.error;
                  }
                }
            }
          } catch (m) {
            t = {
              error: m
            };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        return this.__cache.events = Array.from(o);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var t = new Set(this.transitions.filter(function(n) {
          return !(!n.target && !n.actions.length && n.internal);
        }).map(function(n) {
          return n.eventType;
        }));
        return Array.from(t);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolveTarget = function(t) {
      var n = this;
      if (t !== void 0)
        return t.map(function(r) {
          if (!nn(r))
            return r;
          var i = r[0] === n.delimiter;
          if (i && !n.parent)
            return n.getStateNodeByPath(r.slice(1));
          var s = i ? n.key + r : r;
          if (n.parent)
            try {
              var o = n.parent.getStateNodeByPath(s);
              return o;
            } catch (a) {
              throw new Error("Invalid transition definition for state node '".concat(n.id, `':
`).concat(a.message));
            }
          else
            return n.getStateNodeByPath(s);
        });
    }, e.prototype.formatTransition = function(t) {
      var n = this, r = N_e(t.target), i = "internal" in t ? t.internal : r ? r.some(function(c) {
        return nn(c) && c[0] === n.delimiter;
      }) : !0, s = this.machine.options.guards, o = this.resolveTarget(r), a = He(He({}, t), {
        actions: ll(qs(t.actions)),
        cond: BW(t.cond, s),
        target: o,
        source: this,
        internal: i,
        eventType: t.event,
        toJSON: function() {
          return He(He({}, a), {
            target: a.target ? a.target.map(function(c) {
              return "#".concat(c.id);
            }) : void 0,
            source: "#".concat(n.id)
          });
        }
      });
      return a;
    }, e.prototype.formatTransitions = function() {
      var t, n, r = this, i;
      if (!this.config.on)
        i = [];
      else if (Array.isArray(this.config.on))
        i = this.config.on;
      else {
        var s = this.config.on, o = Q_, a = s[o], c = a === void 0 ? [] : a, l = i8(s, [typeof o == "symbol" ? o : o + ""]);
        i = En(Object.keys(l).map(function(v) {
          var b = Qf(v, l[v]);
          return b;
        }).concat(Qf(Q_, c)));
      }
      var u = this.config.always ? Qf("", this.config.always) : [], d = this.config.onDone ? Qf(String(x1(this.id)), this.config.onDone) : [], f = En(this.invoke.map(function(v) {
        var b = [];
        return v.onDone && b.push.apply(b, vn([], $t(Qf(String(Ow(v.id)), v.onDone)), !1)), v.onError && b.push.apply(b, vn([], $t(Qf(String(K0(v.id)), v.onError)), !1)), b;
      })), p = this.after, m = En(vn(vn(vn(vn([], $t(d), !1), $t(f), !1), $t(i), !1), $t(u), !1).map(function(v) {
        return qs(v).map(function(b) {
          return r.formatTransition(b);
        });
      }));
      try {
        for (var h = Ft(p), g = h.next(); !g.done; g = h.next()) {
          var y = g.value;
          m.push(y);
        }
      } catch (v) {
        t = {
          error: v
        };
      } finally {
        try {
          g && !g.done && (n = h.return) && n.call(h);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return m;
    }, e;
  }()
);
function d6e(e, t, n) {
  return n === void 0 && (n = e.context), new u6e(e, t, n);
}
var f6e = H_e, HC;
(function(e) {
  e[e.Effect = 1] = "Effect", e[e.LayoutEffect = 2] = "LayoutEffect";
})(HC || (HC = {}));
var Cg = _f;
function vN(e) {
  var t = ye.useRef();
  return t.current || (t.current = { v: e() }), t.current.v;
}
var h6e = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}, p6e = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function m6e(e, t) {
  var n, r, i = h6e([[], []], 2), s = i[0], o = i[1];
  try {
    for (var a = p6e(e), c = a.next(); !c.done; c = a.next()) {
      var l = c.value;
      t(l) ? s.push(l) : o.push(l);
    }
  } catch (u) {
    n = { error: u };
  } finally {
    try {
      c && !c.done && (r = a.return) && r.call(a);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return [s, o];
}
var S0 = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}, wN = function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function xN(e, t) {
  var n = e.exec, r = n(t.context, t._event.data, {
    action: e,
    state: t,
    _event: t._event
  });
  r();
}
function g6e(e) {
  var t = Le([]), n = Le([]);
  Cg(function() {
    var r = e.subscribe(function(i) {
      var s, o;
      if (i.actions.length) {
        var a = i.actions.filter(function(d) {
          return typeof d.exec == "function" && "__effect" in d.exec;
        }), c = S0(m6e(a, function(d) {
          return d.exec.__effect === HC.Effect;
        }), 2), l = c[0], u = c[1];
        (s = t.current).push.apply(s, wN([], S0(l.map(function(d) {
          return [d, i];
        })), !1)), (o = n.current).push.apply(o, wN([], S0(u.map(function(d) {
          return [d, i];
        })), !1));
      }
    });
    return function() {
      r.unsubscribe();
    };
  }, []), Cg(function() {
    for (; n.current.length; ) {
      var r = S0(n.current.shift(), 2), i = r[0], s = r[1];
      xN(i, s);
    }
  }), We(function() {
    for (; t.current.length; ) {
      var r = S0(t.current.shift(), 2), i = r[0], s = r[1];
      xN(i, s);
    }
  });
}
var Tg = function() {
  return Tg = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Tg.apply(this, arguments);
}, y6e = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function b6e(e, t, n) {
  if (typeof e == "object")
    return e;
  var r = function() {
  };
  return {
    next: e,
    error: t || r,
    complete: n || r
  };
}
function v6e(e, t, n) {
  t === void 0 && (t = {});
  var r = vN(function() {
    return typeof e == "function" ? e() : e;
  }), i = t.context, s = t.guards, o = t.actions, a = t.activities, c = t.services, l = t.delays, u = t.state, d = y6e(t, ["context", "guards", "actions", "activities", "services", "delays", "state"]), f = vN(function() {
    var p = {
      context: i,
      guards: s,
      actions: o,
      activities: a,
      services: c,
      delays: l
    }, m = r.withConfig(p, function() {
      return Tg(Tg({}, r.context), i);
    });
    return DW(m, Tg({ deferEvents: !0 }, d));
  });
  return Cg(function() {
    var p;
    return n && (p = f.subscribe(b6e(n))), function() {
      p == null || p.unsubscribe();
    };
  }, [n]), Cg(function() {
    return f.start(u ? ws.create(u) : void 0), function() {
      f.stop();
    };
  }, []), Cg(function() {
    Object.assign(f.machine.options.actions, o), Object.assign(f.machine.options.guards, s), Object.assign(f.machine.options.activities, a), Object.assign(f.machine.options.services, c), Object.assign(f.machine.options.delays, l);
  }, [o, s, a, c, l]), g6e(f), f;
}
var w6e = function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
};
function x6e(e, t) {
  t === void 0 && (t = {});
  var n = Ie(function(a) {
    var c = a.changed === void 0 && Object.keys(a.children).length;
    (a.changed || c) && o(a);
  }, []), r = v6e(e, t, n), i = w6e(qe(function() {
    var a = r.machine.initialState;
    return t.state ? ws.create(t.state) : a;
  }), 2), s = i[0], o = i[1];
  return [s, r.send, r];
}
var A6e = Object.defineProperty, E6e = (e, t) => {
  for (var n in t)
    A6e(e, n, { get: t[n], enumerable: !0 });
}, mo = {};
E6e(mo, {
  assign: () => C6e,
  colors: () => ql,
  createStringInterpolator: () => g8,
  skipAnimation: () => GW,
  to: () => WW,
  willAdvance: () => y8
});
var u8 = kv(), wt = (e) => Tv(e, u8), d8 = kv();
wt.write = (e) => Tv(e, d8);
var vE = kv();
wt.onStart = (e) => Tv(e, vE);
var f8 = kv();
wt.onFrame = (e) => Tv(e, f8);
var h8 = kv();
wt.onFinish = (e) => Tv(e, h8);
var $h = [];
wt.setTimeout = (e, t) => {
  const n = wt.now() + t, r = () => {
    const s = $h.findIndex((o) => o.cancel == r);
    ~s && $h.splice(s, 1), Ll -= ~s ? 1 : 0;
  }, i = { time: n, handler: e, cancel: r };
  return $h.splice(UW(n), 0, i), Ll += 1, LW(), i;
};
var UW = (e) => ~(~$h.findIndex((t) => t.time > e) || ~$h.length);
wt.cancel = (e) => {
  vE.delete(e), f8.delete(e), h8.delete(e), u8.delete(e), d8.delete(e);
};
wt.sync = (e) => {
  WC = !0, wt.batchedUpdates(e), WC = !1;
};
wt.throttle = (e) => {
  let t;
  function n() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function r(...i) {
    t = i, wt.onStart(n);
  }
  return r.handler = e, r.cancel = () => {
    vE.delete(n), t = null;
  }, r;
};
var p8 = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
wt.use = (e) => p8 = e;
wt.now = typeof performance < "u" ? () => performance.now() : Date.now;
wt.batchedUpdates = (e) => e();
wt.catch = console.error;
wt.frameLoop = "always";
wt.advance = () => {
  wt.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : VW();
};
var Ul = -1, Ll = 0, WC = !1;
function Tv(e, t) {
  WC ? (t.delete(e), e(0)) : (t.add(e), LW());
}
function LW() {
  Ul < 0 && (Ul = 0, wt.frameLoop !== "demand" && p8(zW));
}
function _6e() {
  Ul = -1;
}
function zW() {
  ~Ul && (p8(zW), wt.batchedUpdates(VW));
}
function VW() {
  const e = Ul;
  Ul = wt.now();
  const t = UW(Ul);
  if (t && (HW($h.splice(0, t), (n) => n.handler()), Ll -= t), !Ll) {
    _6e();
    return;
  }
  vE.flush(), u8.flush(e ? Math.min(64, Ul - e) : 16.667), f8.flush(), d8.flush(), h8.flush();
}
function kv() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(n) {
      Ll += t == e && !e.has(n) ? 1 : 0, e.add(n);
    },
    delete(n) {
      return Ll -= t == e && e.has(n) ? 1 : 0, e.delete(n);
    },
    flush(n) {
      t.size && (e = /* @__PURE__ */ new Set(), Ll -= t.size, HW(t, (r) => r(n) && e.add(r)), Ll += e.size, t = e);
    }
  };
}
function HW(e, t) {
  e.forEach((n) => {
    try {
      t(n);
    } catch (r) {
      wt.catch(r);
    }
  });
}
function GC() {
}
var S6e = (e, t, n) => Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 }), Ue = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function Ma(e, t) {
  if (Ue.arr(e)) {
    if (!Ue.arr(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  return e === t;
}
var jt = (e, t) => e.forEach(t);
function wa(e, t, n) {
  if (Ue.arr(e)) {
    for (let r = 0; r < e.length; r++)
      t.call(n, e[r], `${r}`);
    return;
  }
  for (const r in e)
    e.hasOwnProperty(r) && t.call(n, e[r], r);
}
var Yi = (e) => Ue.und(e) ? [] : Ue.arr(e) ? e : [e];
function kg(e, t) {
  if (e.size) {
    const n = Array.from(e);
    e.clear(), jt(n, t);
  }
}
var J0 = (e, ...t) => kg(e, (n) => n(...t)), m8 = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), g8, WW, ql = null, GW = !1, y8 = GC, C6e = (e) => {
  e.to && (WW = e.to), e.now && (wt.now = e.now), e.colors !== void 0 && (ql = e.colors), e.skipAnimation != null && (GW = e.skipAnimation), e.createStringInterpolator && (g8 = e.createStringInterpolator), e.requestAnimationFrame && wt.use(e.requestAnimationFrame), e.batchedUpdates && (wt.batchedUpdates = e.batchedUpdates), e.willAdvance && (y8 = e.willAdvance), e.frameLoop && (wt.frameLoop = e.frameLoop);
}, Bg = /* @__PURE__ */ new Set(), Ss = [], K_ = [], a2 = 0, wE = {
  get idle() {
    return !Bg.size && !Ss.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    a2 > e.priority ? (Bg.add(e), wt.onStart(T6e)) : (qW(e), wt(qC));
  },
  /** Advance all animations by the given time. */
  advance: qC,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (a2)
      wt.onFrame(() => wE.sort(e));
    else {
      const t = Ss.indexOf(e);
      ~t && (Ss.splice(t, 1), $W(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    Ss = [], Bg.clear();
  }
};
function T6e() {
  Bg.forEach(qW), Bg.clear(), wt(qC);
}
function qW(e) {
  Ss.includes(e) || $W(e);
}
function $W(e) {
  Ss.splice(
    k6e(Ss, (t) => t.priority > e.priority),
    0,
    e
  );
}
function qC(e) {
  const t = K_;
  for (let n = 0; n < Ss.length; n++) {
    const r = Ss[n];
    a2 = r.priority, r.idle || (y8(r), r.advance(e), r.idle || t.push(r));
  }
  return a2 = 0, K_ = Ss, K_.length = 0, Ss = t, Ss.length > 0;
}
function k6e(e, t) {
  const n = e.findIndex(t);
  return n < 0 ? e.length : n;
}
var B6e = (e, t, n) => Math.min(Math.max(n, e), t), I6e = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, ao = "[-+]?\\d*\\.?\\d+", c2 = ao + "%";
function xE(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var P6e = new RegExp("rgb" + xE(ao, ao, ao)), O6e = new RegExp("rgba" + xE(ao, ao, ao, ao)), N6e = new RegExp("hsl" + xE(ao, c2, c2)), R6e = new RegExp(
  "hsla" + xE(ao, c2, c2, ao)
), M6e = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, F6e = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, j6e = /^#([0-9a-fA-F]{6})$/, D6e = /^#([0-9a-fA-F]{8})$/;
function U6e(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = j6e.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : ql && ql[e] !== void 0 ? ql[e] : (t = P6e.exec(e)) ? (Zf(t[1]) << 24 | // r
  Zf(t[2]) << 16 | // g
  Zf(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = O6e.exec(e)) ? (Zf(t[1]) << 24 | // r
  Zf(t[2]) << 16 | // g
  Zf(t[3]) << 8 | // b
  _N(t[4])) >>> // a
  0 : (t = M6e.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = D6e.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = F6e.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = N6e.exec(e)) ? (AN(
    EN(t[1]),
    // h
    _1(t[2]),
    // s
    _1(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = R6e.exec(e)) ? (AN(
    EN(t[1]),
    // h
    _1(t[2]),
    // s
    _1(t[3])
    // l
  ) | _N(t[4])) >>> // a
  0 : null;
}
function Y_(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function AN(e, t, n) {
  const r = n < 0.5 ? n * (1 + t) : n + t - n * t, i = 2 * n - r, s = Y_(i, r, e + 1 / 3), o = Y_(i, r, e), a = Y_(i, r, e - 1 / 3);
  return Math.round(s * 255) << 24 | Math.round(o * 255) << 16 | Math.round(a * 255) << 8;
}
function Zf(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function EN(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function _N(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function _1(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function SN(e) {
  let t = U6e(e);
  if (t === null)
    return e;
  t = t || 0;
  const n = (t & 4278190080) >>> 24, r = (t & 16711680) >>> 16, i = (t & 65280) >>> 8, s = (t & 255) / 255;
  return `rgba(${n}, ${r}, ${i}, ${s})`;
}
var Ry = (e, t, n) => {
  if (Ue.fun(e))
    return e;
  if (Ue.arr(e))
    return Ry({
      range: e,
      output: t,
      extrapolate: n
    });
  if (Ue.str(e.output[0]))
    return g8(e);
  const r = e, i = r.output, s = r.range || [0, 1], o = r.extrapolateLeft || r.extrapolate || "extend", a = r.extrapolateRight || r.extrapolate || "extend", c = r.easing || ((l) => l);
  return (l) => {
    const u = z6e(l, s);
    return L6e(
      l,
      s[u],
      s[u + 1],
      i[u],
      i[u + 1],
      c,
      o,
      a,
      r.map
    );
  };
};
function L6e(e, t, n, r, i, s, o, a, c) {
  let l = c ? c(e) : e;
  if (l < t) {
    if (o === "identity")
      return l;
    o === "clamp" && (l = t);
  }
  if (l > n) {
    if (a === "identity")
      return l;
    a === "clamp" && (l = n);
  }
  return r === i ? r : t === n ? e <= t ? r : i : (t === -1 / 0 ? l = -l : n === 1 / 0 ? l = l - t : l = (l - t) / (n - t), l = s(l), r === -1 / 0 ? l = -l : i === 1 / 0 ? l = l + r : l = l * (i - r) + r, l);
}
function z6e(e, t) {
  for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n)
    ;
  return n - 1;
}
var V6e = (e, t = "end") => (n) => {
  n = t === "end" ? Math.min(n, 0.999) : Math.max(n, 1e-3);
  const r = n * e, i = t === "end" ? Math.floor(r) : Math.ceil(r);
  return B6e(0, 1, i / e);
}, l2 = 1.70158, S1 = l2 * 1.525, CN = l2 + 1, TN = 2 * Math.PI / 3, kN = 2 * Math.PI / 4.5, C1 = (e) => e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375, H6e = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => 1 - (1 - e) * (1 - e),
  easeInOutQuad: (e) => e < 0.5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2,
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => 1 - Math.pow(1 - e, 3),
  easeInOutCubic: (e) => e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2,
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => 1 - Math.pow(1 - e, 4),
  easeInOutQuart: (e) => e < 0.5 ? 8 * e * e * e * e : 1 - Math.pow(-2 * e + 2, 4) / 2,
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => 1 - Math.pow(1 - e, 5),
  easeInOutQuint: (e) => e < 0.5 ? 16 * e * e * e * e * e : 1 - Math.pow(-2 * e + 2, 5) / 2,
  easeInSine: (e) => 1 - Math.cos(e * Math.PI / 2),
  easeOutSine: (e) => Math.sin(e * Math.PI / 2),
  easeInOutSine: (e) => -(Math.cos(Math.PI * e) - 1) / 2,
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * e - 10),
  easeOutExpo: (e) => e === 1 ? 1 : 1 - Math.pow(2, -10 * e),
  easeInOutExpo: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2,
  easeInCirc: (e) => 1 - Math.sqrt(1 - Math.pow(e, 2)),
  easeOutCirc: (e) => Math.sqrt(1 - Math.pow(e - 1, 2)),
  easeInOutCirc: (e) => e < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * e, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * e + 2, 2)) + 1) / 2,
  easeInBack: (e) => CN * e * e * e - l2 * e * e,
  easeOutBack: (e) => 1 + CN * Math.pow(e - 1, 3) + l2 * Math.pow(e - 1, 2),
  easeInOutBack: (e) => e < 0.5 ? Math.pow(2 * e, 2) * ((S1 + 1) * 2 * e - S1) / 2 : (Math.pow(2 * e - 2, 2) * ((S1 + 1) * (e * 2 - 2) + S1) + 2) / 2,
  easeInElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : -Math.pow(2, 10 * e - 10) * Math.sin((e * 10 - 10.75) * TN),
  easeOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : Math.pow(2, -10 * e) * Math.sin((e * 10 - 0.75) * TN) + 1,
  easeInOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? -(Math.pow(2, 20 * e - 10) * Math.sin((20 * e - 11.125) * kN)) / 2 : Math.pow(2, -20 * e + 10) * Math.sin((20 * e - 11.125) * kN) / 2 + 1,
  easeInBounce: (e) => 1 - C1(1 - e),
  easeOutBounce: C1,
  easeInOutBounce: (e) => e < 0.5 ? (1 - C1(1 - 2 * e)) / 2 : (1 + C1(2 * e - 1)) / 2,
  steps: V6e
}, My = Symbol.for("FluidValue.get"), Om = Symbol.for("FluidValue.observers"), Es = (e) => !!(e && e[My]), _i = (e) => e && e[My] ? e[My]() : e, BN = (e) => e[Om] || null;
function W6e(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function Fy(e, t) {
  const n = e[Om];
  n && n.forEach((r) => {
    W6e(r, t);
  });
}
var QW = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    G6e(this, e);
  }
}, G6e = (e, t) => KW(e, My, t);
function i0(e, t) {
  if (e[My]) {
    let n = e[Om];
    n || KW(e, Om, n = /* @__PURE__ */ new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
  }
  return t;
}
function jy(e, t) {
  const n = e[Om];
  if (n && n.has(t)) {
    const r = n.size - 1;
    r ? n.delete(t) : e[Om] = null, e.observerRemoved && e.observerRemoved(r, t);
  }
}
var KW = (e, t, n) => Object.defineProperty(e, t, {
  value: n,
  writable: !0,
  configurable: !0
}), Rw = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, q6e = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, IN = new RegExp(`(${Rw.source})(%|[a-z]+)`, "i"), $6e = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, AE = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, YW = (e) => {
  const [t, n] = Q6e(e);
  if (!t || m8())
    return e;
  const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (r)
    return r.trim();
  if (n && n.startsWith("--")) {
    const i = window.getComputedStyle(document.documentElement).getPropertyValue(n);
    return i || e;
  } else {
    if (n && AE.test(n))
      return YW(n);
    if (n)
      return n;
  }
  return e;
}, Q6e = (e) => {
  const t = AE.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}, Z_, K6e = (e, t, n, r, i) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${i})`, ZW = (e) => {
  Z_ || (Z_ = ql ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(ql).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((s) => _i(s).replace(AE, YW).replace(q6e, SN).replace(Z_, SN)), n = t.map((s) => s.match(Rw).map(Number)), i = n[0].map(
    (s, o) => n.map((a) => {
      if (!(o in a))
        throw Error('The arity of each "output" value must be equal');
      return a[o];
    })
  ).map(
    (s) => Ry({ ...e, output: s })
  );
  return (s) => {
    var c;
    const o = !IN.test(t[0]) && ((c = t.find((l) => IN.test(l))) == null ? void 0 : c.replace(Rw, ""));
    let a = 0;
    return t[0].replace(
      Rw,
      () => `${i[a++](s)}${o || ""}`
    ).replace($6e, K6e);
  };
}, b8 = "react-spring: ", JW = (e) => {
  const t = e;
  let n = !1;
  if (typeof t != "function")
    throw new TypeError(`${b8}once requires a function parameter`);
  return (...r) => {
    n || (t(...r), n = !0);
  };
}, Y6e = JW(console.warn);
function XW() {
  Y6e(
    `${b8}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var Z6e = JW(console.warn);
function J6e() {
  Z6e(
    `${b8}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function EE(e) {
  return Ue.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !m8() && AE.test(e) || e in (ql || {}));
}
var v8 = m8() ? We : _f, X6e = () => {
  const e = Le(!1);
  return v8(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function eG() {
  const e = qe()[1], t = X6e();
  return () => {
    t.current && e(Math.random());
  };
}
function eSe(e, t) {
  const [n] = qe(
    () => ({
      inputs: t,
      result: e()
    })
  ), r = Le(), i = r.current;
  let s = i;
  return s ? t && s.inputs && tSe(t, s.inputs) || (s = {
    inputs: t,
    result: e()
  }) : s = n, We(() => {
    r.current = s, i == n && (n.inputs = n.result = void 0);
  }, [s]), s.result;
}
function tSe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var tG = (e) => We(e, nSe), nSe = [];
function PN(e) {
  const t = Le();
  return We(() => {
    t.current = e;
  }), t.current;
}
var Dy = Symbol.for("Animated:node"), rSe = (e) => !!e && e[Dy] === e, Lo = (e) => e && e[Dy], w8 = (e, t) => S6e(e, Dy, t), _E = (e) => e && e[Dy] && e[Dy].getPayload(), nG = class {
  constructor() {
    w8(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, Bv = class extends nG {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, Ue.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new Bv(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return Ue.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, Ue.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, Uy = class extends Bv {
  constructor(e) {
    super(0), this._string = null, this._toString = Ry({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new Uy(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (Ue.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = Ry({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, u2 = { dependencies: null }, SE = class extends nG {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return wa(this.source, (n, r) => {
      rSe(n) ? t[r] = n.getValue(e) : Es(n) ? t[r] = _i(n) : e || (t[r] = n);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && jt(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return wa(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    u2.dependencies && Es(e) && u2.dependencies.add(e);
    const t = _E(e);
    t && jt(t, (n) => this.add(n));
  }
}, rG = class extends SE {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new rG(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((n, r) => n.setValue(e[r])).some(Boolean) : (super.setValue(e.map(iSe)), !0);
  }
};
function iSe(e) {
  return (EE(e) ? Uy : Bv).create(e);
}
function $C(e) {
  const t = Lo(e);
  return t ? t.constructor : Ue.arr(e) ? rG : EE(e) ? Uy : Bv;
}
var ON = (e, t) => {
  const n = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !Ue.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return Bc((r, i) => {
    const s = Le(null), o = n && // eslint-disable-next-line react-hooks/rules-of-hooks
    Ie(
      (m) => {
        s.current = aSe(i, m);
      },
      [i]
    ), [a, c] = oSe(r, t), l = eG(), u = () => {
      const m = s.current;
      if (n && !m)
        return;
      (m ? t.applyAnimatedValues(m, a.getValue(!0)) : !1) === !1 && l();
    }, d = new sSe(u, c), f = Le();
    v8(() => (f.current = d, jt(c, (m) => i0(m, d)), () => {
      f.current && (jt(
        f.current.deps,
        (m) => jy(m, f.current)
      ), wt.cancel(f.current.update));
    })), We(u, []), tG(() => () => {
      const m = f.current;
      jt(m.deps, (h) => jy(h, m));
    });
    const p = t.getComponentProps(a.getValue());
    return /* @__PURE__ */ ye.createElement(e, { ...p, ref: o });
  });
}, sSe = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && wt.write(this.update);
  }
};
function oSe(e, t) {
  const n = /* @__PURE__ */ new Set();
  return u2.dependencies = n, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new SE(e), u2.dependencies = null, [e, n];
}
function aSe(e, t) {
  return e && (Ue.fun(e) ? e(t) : e.current = t), t;
}
var NN = Symbol.for("AnimatedComponent"), cSe = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: n = (i) => new SE(i),
  getComponentProps: r = (i) => i
} = {}) => {
  const i = {
    applyAnimatedValues: t,
    createAnimatedStyle: n,
    getComponentProps: r
  }, s = (o) => {
    const a = RN(o) || "Anonymous";
    return Ue.str(o) ? o = s[o] || (s[o] = ON(o, i)) : o = o[NN] || (o[NN] = ON(o, i)), o.displayName = `Animated(${a})`, o;
  };
  return wa(e, (o, a) => {
    Ue.arr(e) && (a = RN(o)), s[a] = s(o);
  }), {
    animated: s
  };
}, RN = (e) => Ue.str(e) ? e : e && Ue.str(e.displayName) ? e.displayName : Ue.fun(e) && e.name || null;
function zu(e, ...t) {
  return Ue.fun(e) ? e(...t) : e;
}
var Ig = (e, t) => e === !0 || !!(t && e && (Ue.fun(e) ? e(t) : Yi(e).includes(t))), iG = (e, t) => Ue.obj(e) ? t && e[t] : e, sG = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, lSe = (e) => e, x8 = (e, t = lSe) => {
  let n = uSe;
  e.default && e.default !== !0 && (e = e.default, n = Object.keys(e));
  const r = {};
  for (const i of n) {
    const s = t(e[i], i);
    Ue.und(s) || (r[i] = s);
  }
  return r;
}, uSe = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], dSe = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function fSe(e) {
  const t = {};
  let n = 0;
  if (wa(e, (r, i) => {
    dSe[i] || (t[i] = r, n++);
  }), n)
    return t;
}
function oG(e) {
  const t = fSe(e);
  if (t) {
    const n = { to: t };
    return wa(e, (r, i) => i in t || (n[i] = r)), n;
  }
  return { ...e };
}
function Ly(e) {
  return e = _i(e), Ue.arr(e) ? e.map(Ly) : EE(e) ? mo.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function hSe(e) {
  for (const t in e)
    return !0;
  return !1;
}
function QC(e) {
  return Ue.fun(e) || Ue.arr(e) && Ue.obj(e[0]);
}
function pSe(e, t) {
  var n;
  (n = e.ref) == null || n.delete(e), t == null || t.delete(e);
}
function mSe(e, t) {
  var n;
  t && e.ref !== t && ((n = e.ref) == null || n.delete(e), t.add(e), e.ref = t);
}
var aG = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, KC = {
  ...aG.default,
  mass: 1,
  damping: 1,
  easing: H6e.linear,
  clamp: !1
}, gSe = class {
  constructor() {
    this.velocity = 0, Object.assign(this, KC);
  }
};
function ySe(e, t, n) {
  n && (n = { ...n }, MN(n, t), t = { ...n, ...t }), MN(e, t), Object.assign(e, t);
  for (const o in KC)
    e[o] == null && (e[o] = KC[o]);
  let { frequency: r, damping: i } = e;
  const { mass: s } = e;
  return Ue.und(r) || (r < 0.01 && (r = 0.01), i < 0 && (i = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * s, e.friction = 4 * Math.PI * i * s / r), e;
}
function MN(e, t) {
  if (!Ue.und(t.decay))
    e.duration = void 0;
  else {
    const n = !Ue.und(t.tension) || !Ue.und(t.friction);
    (n || !Ue.und(t.frequency) || !Ue.und(t.damping) || !Ue.und(t.mass)) && (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
  }
}
var FN = [], bSe = class {
  constructor() {
    this.changed = !1, this.values = FN, this.toValues = null, this.fromValues = FN, this.config = new gSe(), this.immediate = !1;
  }
};
function cG(e, { key: t, props: n, defaultProps: r, state: i, actions: s }) {
  return new Promise((o, a) => {
    let c, l, u = Ig(n.cancel ?? (r == null ? void 0 : r.cancel), t);
    if (u)
      p();
    else {
      Ue.und(n.pause) || (i.paused = Ig(n.pause, t));
      let m = r == null ? void 0 : r.pause;
      m !== !0 && (m = i.paused || Ig(m, t)), c = zu(n.delay || 0, t), m ? (i.resumeQueue.add(f), s.pause()) : (s.resume(), f());
    }
    function d() {
      i.resumeQueue.add(f), i.timeouts.delete(l), l.cancel(), c = l.time - wt.now();
    }
    function f() {
      c > 0 && !mo.skipAnimation ? (i.delayed = !0, l = wt.setTimeout(p, c), i.pauseQueue.add(d), i.timeouts.add(l)) : p();
    }
    function p() {
      i.delayed && (i.delayed = !1), i.pauseQueue.delete(d), i.timeouts.delete(l), e <= (i.cancelId || 0) && (u = !0);
      try {
        s.start({ ...n, callId: e, cancel: u }, o);
      } catch (m) {
        a(m);
      }
    }
  });
}
var A8 = (e, t) => t.length == 1 ? t[0] : t.some((n) => n.cancelled) ? Qh(e.get()) : t.every((n) => n.noop) ? lG(e.get()) : no(
  e.get(),
  t.every((n) => n.finished)
), lG = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), no = (e, t, n = !1) => ({
  value: e,
  finished: t,
  cancelled: n
}), Qh = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function uG(e, t, n, r) {
  const { callId: i, parentId: s, onRest: o } = t, { asyncTo: a, promise: c } = n;
  return !s && e === a && !t.reset ? c : n.promise = (async () => {
    n.asyncId = i, n.asyncTo = e;
    const l = x8(
      t,
      (g, y) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        y === "onRest" ? void 0 : g
      )
    );
    let u, d;
    const f = new Promise(
      (g, y) => (u = g, d = y)
    ), p = (g) => {
      const y = (
        // The `cancel` prop or `stop` method was used.
        i <= (n.cancelId || 0) && Qh(r) || // The async `to` prop was replaced.
        i !== n.asyncId && no(r, !1)
      );
      if (y)
        throw g.result = y, d(g), g;
    }, m = (g, y) => {
      const v = new jN(), b = new DN();
      return (async () => {
        if (mo.skipAnimation)
          throw zy(n), b.result = no(r, !1), d(b), b;
        p(v);
        const w = Ue.obj(g) ? { ...g } : { ...y, to: g };
        w.parentId = i, wa(l, (E, x) => {
          Ue.und(w[x]) && (w[x] = E);
        });
        const A = await r.start(w);
        return p(v), n.paused && await new Promise((E) => {
          n.resumeQueue.add(E);
        }), A;
      })();
    };
    let h;
    if (mo.skipAnimation)
      return zy(n), no(r, !1);
    try {
      let g;
      Ue.arr(e) ? g = (async (y) => {
        for (const v of y)
          await m(v);
      })(e) : g = Promise.resolve(e(m, r.stop.bind(r))), await Promise.all([g.then(u), f]), h = no(r.get(), !0, !1);
    } catch (g) {
      if (g instanceof jN)
        h = g.result;
      else if (g instanceof DN)
        h = g.result;
      else
        throw g;
    } finally {
      i == n.asyncId && (n.asyncId = s, n.asyncTo = s ? a : void 0, n.promise = s ? c : void 0);
    }
    return Ue.fun(o) && wt.batchedUpdates(() => {
      o(h, r, r.item);
    }), h;
  })();
}
function zy(e, t) {
  kg(e.timeouts, (n) => n.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var jN = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, DN = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, YC = (e) => e instanceof E8, vSe = 1, E8 = class extends QW {
  constructor() {
    super(...arguments), this.id = vSe++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = Lo(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return mo.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return XW(), mo.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    Fy(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || wE.sort(this), Fy(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, lf = Symbol.for("SpringPhase"), dG = 1, ZC = 2, JC = 4, J_ = (e) => (e[lf] & dG) > 0, zc = (e) => (e[lf] & ZC) > 0, C0 = (e) => (e[lf] & JC) > 0, UN = (e, t) => t ? e[lf] |= ZC | dG : e[lf] &= ~ZC, LN = (e, t) => t ? e[lf] |= JC : e[lf] &= ~JC, wSe = class extends E8 {
  constructor(e, t) {
    if (super(), this.animation = new bSe(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !Ue.und(e) || !Ue.und(t)) {
      const n = Ue.obj(e) ? { ...e } : { ...t, from: e };
      Ue.und(n.default) && (n.default = !0), this.start(n);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(zc(this) || this._state.asyncTo) || C0(this);
  }
  get goal() {
    return _i(this.animation.to);
  }
  get velocity() {
    const e = Lo(this);
    return e instanceof Bv ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return J_(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return zc(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return C0(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, n = !1;
    const r = this.animation;
    let { toValues: i } = r;
    const { config: s } = r, o = _E(r.to);
    !o && Es(r.to) && (i = Yi(_i(r.to))), r.values.forEach((l, u) => {
      if (l.done)
        return;
      const d = (
        // Animated strings always go from 0 to 1.
        l.constructor == Uy ? 1 : o ? o[u].lastPosition : i[u]
      );
      let f = r.immediate, p = d;
      if (!f) {
        if (p = l.lastPosition, s.tension <= 0) {
          l.done = !0;
          return;
        }
        let m = l.elapsedTime += e;
        const h = r.fromValues[u], g = l.v0 != null ? l.v0 : l.v0 = Ue.arr(s.velocity) ? s.velocity[u] : s.velocity;
        let y;
        const v = s.precision || (h == d ? 5e-3 : Math.min(1, Math.abs(d - h) * 1e-3));
        if (Ue.und(s.duration))
          if (s.decay) {
            const b = s.decay === !0 ? 0.998 : s.decay, w = Math.exp(-(1 - b) * m);
            p = h + g / (1 - b) * (1 - w), f = Math.abs(l.lastPosition - p) <= v, y = g * w;
          } else {
            y = l.lastVelocity == null ? g : l.lastVelocity;
            const b = s.restVelocity || v / 10, w = s.clamp ? 0 : s.bounce, A = !Ue.und(w), E = h == d ? l.v0 > 0 : h < d;
            let x, S = !1;
            const P = 1, I = Math.ceil(e / P);
            for (let R = 0; R < I && (x = Math.abs(y) > b, !(!x && (f = Math.abs(d - p) <= v, f))); ++R) {
              A && (S = p == d || p > d == E, S && (y = -y * w, p = d));
              const Q = -s.tension * 1e-6 * (p - d), J = -s.friction * 1e-3 * y, we = (Q + J) / s.mass;
              y = y + we * P, p = p + y * P;
            }
          }
        else {
          let b = 1;
          s.duration > 0 && (this._memoizedDuration !== s.duration && (this._memoizedDuration = s.duration, l.durationProgress > 0 && (l.elapsedTime = s.duration * l.durationProgress, m = l.elapsedTime += e)), b = (s.progress || 0) + m / this._memoizedDuration, b = b > 1 ? 1 : b < 0 ? 0 : b, l.durationProgress = b), p = h + s.easing(b) * (d - h), y = (p - l.lastPosition) / e, f = b == 1;
        }
        l.lastVelocity = y, Number.isNaN(p) && (console.warn("Got NaN while animating:", this), f = !0);
      }
      o && !o[u].done && (f = !1), f ? l.done = !0 : t = !1, l.setValue(p, s.round) && (n = !0);
    });
    const a = Lo(this), c = a.getValue();
    if (t) {
      const l = _i(r.to);
      (c !== l || n) && !s.decay ? (a.setValue(l), this._onChange(l)) : n && s.decay && this._onChange(c), this._stop();
    } else
      n && this._onChange(c);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return wt.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (zc(this)) {
      const { to: e, config: t } = this.animation;
      wt.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let n;
    return Ue.und(e) ? (n = this.queue || [], this.queue = []) : n = [Ue.obj(e) ? e : { ...t, to: e }], Promise.all(
      n.map((r) => this._update(r))
    ).then((r) => A8(this, r));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), zy(this._state, e && this._lastCallId), wt.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: n, from: r } = e;
    n = Ue.obj(n) ? n[t] : n, (n == null || QC(n)) && (n = void 0), r = Ue.obj(r) ? r[t] : r, r == null && (r = void 0);
    const i = { to: n, from: r };
    return J_(this) || (e.reverse && ([n, r] = [r, n]), r = _i(r), Ue.und(r) ? Lo(this) || this._set(n) : this._set(r)), i;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: n, defaultProps: r } = this;
    e.default && Object.assign(
      r,
      x8(
        e,
        (o, a) => /^on/.test(a) ? iG(o, n) : o
      )
    ), VN(this, e, "onProps"), k0(this, "onProps", e, this);
    const i = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const s = this._state;
    return cG(++this._lastCallId, {
      key: n,
      props: e,
      defaultProps: r,
      state: s,
      actions: {
        pause: () => {
          C0(this) || (LN(this, !0), J0(s.pauseQueue), k0(
            this,
            "onPause",
            no(this, T0(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          C0(this) && (LN(this, !1), zc(this) && this._resume(), J0(s.resumeQueue), k0(
            this,
            "onResume",
            no(this, T0(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, i)
      }
    }).then((o) => {
      if (e.loop && o.finished && !(t && o.noop)) {
        const a = fG(e);
        if (a)
          return this._update(a, !0);
      }
      return o;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, n) {
    if (t.cancel)
      return this.stop(!0), n(Qh(this));
    const r = !Ue.und(e.to), i = !Ue.und(e.from);
    if (r || i)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return n(Qh(this));
    const { key: s, defaultProps: o, animation: a } = this, { to: c, from: l } = a;
    let { to: u = c, from: d = l } = e;
    i && !r && (!t.default || Ue.und(u)) && (u = d), t.reverse && ([u, d] = [d, u]);
    const f = !Ma(d, l);
    f && (a.from = d), d = _i(d);
    const p = !Ma(u, c);
    p && this._focus(u);
    const m = QC(t.to), { config: h } = a, { decay: g, velocity: y } = h;
    (r || i) && (h.velocity = 0), t.config && !m && ySe(
      h,
      zu(t.config, s),
      // Avoid calling the same "config" prop twice.
      t.config !== o.config ? zu(o.config, s) : void 0
    );
    let v = Lo(this);
    if (!v || Ue.und(u))
      return n(no(this, !0));
    const b = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      Ue.und(t.reset) ? i && !t.default : !Ue.und(d) && Ig(t.reset, s)
    ), w = b ? d : this.get(), A = Ly(u), E = Ue.num(A) || Ue.arr(A) || EE(A), x = !m && (!E || Ig(o.immediate || t.immediate, s));
    if (p) {
      const R = $C(u);
      if (R !== v.constructor)
        if (x)
          v = this._set(A);
        else
          throw Error(
            `Cannot animate between ${v.constructor.name} and ${R.name}, as the "to" prop suggests`
          );
    }
    const S = v.constructor;
    let P = Es(u), I = !1;
    if (!P) {
      const R = b || !J_(this) && f;
      (p || R) && (I = Ma(Ly(w), A), P = !I), (!Ma(a.immediate, x) && !x || !Ma(h.decay, g) || !Ma(h.velocity, y)) && (P = !0);
    }
    if (I && zc(this) && (a.changed && !b ? P = !0 : P || this._stop(c)), !m && ((P || Es(c)) && (a.values = v.getPayload(), a.toValues = Es(u) ? null : S == Uy ? [1] : Yi(A)), a.immediate != x && (a.immediate = x, !x && !b && this._set(c)), P)) {
      const { onRest: R } = a;
      jt(ASe, (J) => VN(this, t, J));
      const Q = no(this, T0(this, c));
      J0(this._pendingCalls, Q), this._pendingCalls.add(n), a.changed && wt.batchedUpdates(() => {
        var J;
        a.changed = !b, R == null || R(Q, this), b ? zu(o.onRest, Q) : (J = a.onStart) == null || J.call(a, Q, this);
      });
    }
    b && this._set(w), m ? n(uG(t.to, t, this._state, this)) : P ? this._start() : zc(this) && !p ? this._pendingCalls.add(n) : n(lG(w));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (BN(this) && this._detach(), t.to = e, BN(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    Es(t) && (i0(t, this), YC(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    Es(e) && jy(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const n = _i(e);
    if (!Ue.und(n)) {
      const r = Lo(this);
      if (!r || !Ma(n, r.getValue())) {
        const i = $C(n);
        !r || r.constructor != i ? w8(this, i.create(n)) : r.setValue(n), r && wt.batchedUpdates(() => {
          this._onChange(n, t);
        });
      }
    }
    return Lo(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, k0(
      this,
      "onStart",
      no(this, T0(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), zu(this.animation.onChange, e, this)), zu(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    Lo(this).reset(_i(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), zc(this) || (UN(this, !0), C0(this) || this._resume());
  }
  _resume() {
    mo.skipAnimation ? this.finish() : wE.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (zc(this)) {
      UN(this, !1);
      const n = this.animation;
      jt(n.values, (i) => {
        i.done = !0;
      }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), Fy(this, {
        type: "idle",
        parent: this
      });
      const r = t ? Qh(this.get()) : no(this.get(), T0(this, e ?? n.to));
      J0(this._pendingCalls, r), n.changed && (n.changed = !1, k0(this, "onRest", r, this));
    }
  }
};
function T0(e, t) {
  const n = Ly(t), r = Ly(e.get());
  return Ma(r, n);
}
function fG(e, t = e.loop, n = e.to) {
  const r = zu(t);
  if (r) {
    const i = r !== !0 && oG(r), s = (i || e).reverse, o = !i || i.reset;
    return Vy({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !s || QC(n) ? n : void 0,
      // Ignore the "from" prop except on reset.
      from: o ? e.from : void 0,
      reset: o,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...i
    });
  }
}
function Vy(e) {
  const { to: t, from: n } = e = oG(e), r = /* @__PURE__ */ new Set();
  return Ue.obj(t) && zN(t, r), Ue.obj(n) && zN(n, r), e.keys = r.size ? Array.from(r) : null, e;
}
function xSe(e) {
  const t = Vy(e);
  return Ue.und(t.default) && (t.default = x8(t)), t;
}
function zN(e, t) {
  wa(e, (n, r) => n != null && t.add(r));
}
var ASe = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function VN(e, t, n) {
  e.animation[n] = t[n] !== sG(t, n) ? iG(t[n], e.key) : void 0;
}
function k0(e, t, ...n) {
  var r, i, s, o;
  (i = (r = e.animation)[t]) == null || i.call(r, ...n), (o = (s = e.defaultProps)[t]) == null || o.call(s, ...n);
}
var ESe = ["onStart", "onChange", "onRest"], _Se = 1, SSe = class {
  constructor(t, n) {
    this.id = _Se++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), n && (this._flush = n), t && this.start({ default: !0, ...t });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((t) => t.idle && !t.isDelayed && !t.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(t) {
    this._item = t;
  }
  /** Get the current values of our springs */
  get() {
    const t = {};
    return this.each((n, r) => t[r] = n.get()), t;
  }
  /** Set the current values without animating. */
  set(t) {
    for (const n in t) {
      const r = t[n];
      Ue.und(r) || this.springs[n].set(r);
    }
  }
  /** Push an update onto the queue of each value. */
  update(t) {
    return t && this.queue.push(Vy(t)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(t) {
    let { queue: n } = this;
    return t ? n = Yi(t).map(Vy) : this.queue = [], this._flush ? this._flush(this, n) : (yG(this, n), XC(this, n));
  }
  /** @internal */
  stop(t, n) {
    if (t !== !!t && (n = t), n) {
      const r = this.springs;
      jt(Yi(n), (i) => r[i].stop(!!t));
    } else
      zy(this._state, this._lastAsyncId), this.each((r) => r.stop(!!t));
    return this;
  }
  /** Freeze the active animation in time */
  pause(t) {
    if (Ue.und(t))
      this.start({ pause: !0 });
    else {
      const n = this.springs;
      jt(Yi(t), (r) => n[r].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(t) {
    if (Ue.und(t))
      this.start({ pause: !1 });
    else {
      const n = this.springs;
      jt(Yi(t), (r) => n[r].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(t) {
    wa(this.springs, t);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: t, onChange: n, onRest: r } = this._events, i = this._active.size > 0, s = this._changed.size > 0;
    (i && !this._started || s && !this._started) && (this._started = !0, kg(t, ([c, l]) => {
      l.value = this.get(), c(l, this, this._item);
    }));
    const o = !i && this._started, a = s || o && r.size ? this.get() : null;
    s && n.size && kg(n, ([c, l]) => {
      l.value = a, c(l, this, this._item);
    }), o && (this._started = !1, kg(r, ([c, l]) => {
      l.value = a, c(l, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(t) {
    if (t.type == "change")
      this._changed.add(t.parent), t.idle || this._active.add(t.parent);
    else if (t.type == "idle")
      this._active.delete(t.parent);
    else
      return;
    wt.onFrame(this._onFrame);
  }
};
function XC(e, t) {
  return Promise.all(t.map((n) => hG(e, n))).then(
    (n) => A8(e, n)
  );
}
async function hG(e, t, n) {
  const { keys: r, to: i, from: s, loop: o, onRest: a, onResolve: c } = t, l = Ue.obj(t.default) && t.default;
  o && (t.loop = !1), i === !1 && (t.to = null), s === !1 && (t.from = null);
  const u = Ue.arr(i) || Ue.fun(i) ? i : void 0;
  u ? (t.to = void 0, t.onRest = void 0, l && (l.onRest = void 0)) : jt(ESe, (h) => {
    const g = t[h];
    if (Ue.fun(g)) {
      const y = e._events[h];
      t[h] = ({ finished: v, cancelled: b }) => {
        const w = y.get(g);
        w ? (v || (w.finished = !1), b && (w.cancelled = !0)) : y.set(g, {
          value: null,
          finished: v || !1,
          cancelled: b || !1
        });
      }, l && (l[h] = t[h]);
    }
  });
  const d = e._state;
  t.pause === !d.paused ? (d.paused = t.pause, J0(t.pause ? d.pauseQueue : d.resumeQueue)) : d.paused && (t.pause = !0);
  const f = (r || Object.keys(e.springs)).map(
    (h) => e.springs[h].start(t)
  ), p = t.cancel === !0 || sG(t, "cancel") === !0;
  (u || p && d.asyncId) && f.push(
    cG(++e._lastAsyncId, {
      props: t,
      state: d,
      actions: {
        pause: GC,
        resume: GC,
        start(h, g) {
          p ? (zy(d, e._lastAsyncId), g(Qh(e))) : (h.onRest = a, g(
            uG(
              u,
              h,
              d,
              e
            )
          ));
        }
      }
    })
  ), d.paused && await new Promise((h) => {
    d.resumeQueue.add(h);
  });
  const m = A8(e, await Promise.all(f));
  if (o && m.finished && !(n && m.noop)) {
    const h = fG(t, o, i);
    if (h)
      return yG(e, [h]), hG(e, h, !0);
  }
  return c && wt.batchedUpdates(() => c(m, e, e.item)), m;
}
function HN(e, t) {
  const n = { ...e.springs };
  return t && jt(Yi(t), (r) => {
    Ue.und(r.keys) && (r = Vy(r)), Ue.obj(r.to) || (r = { ...r, to: void 0 }), gG(n, r, (i) => mG(i));
  }), pG(e, n), n;
}
function pG(e, t) {
  wa(t, (n, r) => {
    e.springs[r] || (e.springs[r] = n, i0(n, e));
  });
}
function mG(e, t) {
  const n = new wSe();
  return n.key = e, t && i0(n, t), n;
}
function gG(e, t, n) {
  t.keys && jt(t.keys, (r) => {
    (e[r] || (e[r] = n(r)))._prepareNode(t);
  });
}
function yG(e, t) {
  jt(t, (n) => {
    gG(e.springs, n, (r) => mG(r, e));
  });
}
var CE = ({
  children: e,
  ...t
}) => {
  const n = $e(d2), r = t.pause || !!n.pause, i = t.immediate || !!n.immediate;
  t = eSe(() => ({ pause: r, immediate: i }), [r, i]);
  const { Provider: s } = d2;
  return /* @__PURE__ */ ye.createElement(s, { value: t }, e);
}, d2 = CSe(CE, {});
CE.Provider = d2.Provider;
CE.Consumer = d2.Consumer;
function CSe(e, t) {
  return Object.assign(e, ye.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var TSe = () => {
  const e = [], t = function(r) {
    J6e();
    const i = [];
    return jt(e, (s, o) => {
      if (Ue.und(r))
        i.push(s.start());
      else {
        const a = n(r, s, o);
        a && i.push(s.start(a));
      }
    }), i;
  };
  t.current = e, t.add = function(r) {
    e.includes(r) || e.push(r);
  }, t.delete = function(r) {
    const i = e.indexOf(r);
    ~i && e.splice(i, 1);
  }, t.pause = function() {
    return jt(e, (r) => r.pause(...arguments)), this;
  }, t.resume = function() {
    return jt(e, (r) => r.resume(...arguments)), this;
  }, t.set = function(r) {
    jt(e, (i, s) => {
      const o = Ue.fun(r) ? r(s, i) : r;
      o && i.set(o);
    });
  }, t.start = function(r) {
    const i = [];
    return jt(e, (s, o) => {
      if (Ue.und(r))
        i.push(s.start());
      else {
        const a = this._getProps(r, s, o);
        a && i.push(s.start(a));
      }
    }), i;
  }, t.stop = function() {
    return jt(e, (r) => r.stop(...arguments)), this;
  }, t.update = function(r) {
    return jt(e, (i, s) => i.update(this._getProps(r, i, s))), this;
  };
  const n = function(r, i, s) {
    return Ue.fun(r) ? r(s, i) : r;
  };
  return t._getProps = n, t;
};
function kSe(e, t, n) {
  const r = Ue.fun(t) && t;
  r && !n && (n = []);
  const i = ot(
    () => r || arguments.length == 3 ? TSe() : void 0,
    []
  ), s = Le(0), o = eG(), a = ot(
    () => ({
      ctrls: [],
      queue: [],
      flush(y, v) {
        const b = HN(y, v);
        return s.current > 0 && !a.queue.length && !Object.keys(b).some((A) => !y.springs[A]) ? XC(y, v) : new Promise((A) => {
          pG(y, b), a.queue.push(() => {
            A(XC(y, v));
          }), o();
        });
      }
    }),
    []
  ), c = Le([...a.ctrls]), l = [], u = PN(e) || 0;
  ot(() => {
    jt(c.current.slice(e, u), (y) => {
      pSe(y, i), y.stop(!0);
    }), c.current.length = e, d(u, e);
  }, [e]), ot(() => {
    d(0, Math.min(u, e));
  }, n);
  function d(y, v) {
    for (let b = y; b < v; b++) {
      const w = c.current[b] || (c.current[b] = new SSe(null, a.flush)), A = r ? r(b, w) : t[b];
      A && (l[b] = xSe(A));
    }
  }
  const f = c.current.map((y, v) => HN(y, l[v])), p = $e(CE), m = PN(p), h = p !== m && hSe(p);
  v8(() => {
    s.current++, a.ctrls = c.current;
    const { queue: y } = a;
    y.length && (a.queue = [], jt(y, (v) => v())), jt(c.current, (v, b) => {
      i == null || i.add(v), h && v.start({ default: p });
      const w = l[b];
      w && (mSe(v, w.ref), v.ref ? v.queue.push(w) : v.start(w));
    });
  }), tG(() => () => {
    jt(a.ctrls, (y) => y.stop(!0));
  });
  const g = f.map((y) => ({ ...y }));
  return i ? [g, i] : g;
}
function BSe(e, t) {
  const n = Ue.fun(e), [[r], i] = kSe(
    1,
    n ? e : [e],
    n ? [] : t
  );
  return n || arguments.length == 2 ? [r, i] : r;
}
var bG = class extends E8 {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = Ry(...t);
    const n = this._get(), r = $C(n);
    w8(this, r.create(n));
  }
  advance(e) {
    const t = this._get(), n = this.get();
    Ma(t, n) || (Lo(this).setValue(t), this._onChange(t, this.idle)), !this.idle && WN(this._active) && X_(this);
  }
  _get() {
    const e = Ue.arr(this.source) ? this.source.map(_i) : Yi(_i(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !WN(this._active) && (this.idle = !1, jt(_E(this), (e) => {
      e.done = !1;
    }), mo.skipAnimation ? (wt.batchedUpdates(() => this.advance()), X_(this)) : wE.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    jt(Yi(this.source), (t) => {
      Es(t) && i0(t, this), YC(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    jt(Yi(this.source), (e) => {
      Es(e) && jy(e, this);
    }), this._active.clear(), X_(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = Yi(this.source).reduce(
      (t, n) => Math.max(t, (YC(n) ? n.priority : 0) + 1),
      0
    ));
  }
};
function ISe(e) {
  return e.idle !== !1;
}
function WN(e) {
  return !e.size || Array.from(e).every(ISe);
}
function X_(e) {
  e.idle || (e.idle = !0, jt(_E(e), (t) => {
    t.done = !0;
  }), Fy(e, {
    type: "idle",
    parent: e
  }));
}
var Jf = (e, ...t) => (XW(), new bG(e, t));
mo.assign({
  createStringInterpolator: ZW,
  to: (e, t) => new bG(e, t)
});
var vG = /^--/;
function PSe(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !vG.test(e) && !(Pg.hasOwnProperty(e) && Pg[e]) ? t + "px" : ("" + t).trim();
}
var GN = {};
function OSe(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const n = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", { style: r, children: i, scrollTop: s, scrollLeft: o, viewBox: a, ...c } = t, l = Object.values(c), u = Object.keys(c).map(
    (d) => n || e.hasAttribute(d) ? d : GN[d] || (GN[d] = d.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (f) => "-" + f.toLowerCase()
    ))
  );
  i !== void 0 && (e.textContent = i);
  for (const d in r)
    if (r.hasOwnProperty(d)) {
      const f = PSe(d, r[d]);
      vG.test(d) ? e.style.setProperty(d, f) : e.style[d] = f;
    }
  u.forEach((d, f) => {
    e.setAttribute(d, l[f]);
  }), s !== void 0 && (e.scrollTop = s), o !== void 0 && (e.scrollLeft = o), a !== void 0 && e.setAttribute("viewBox", a);
}
var Pg = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, NSe = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), RSe = ["Webkit", "Ms", "Moz", "O"];
Pg = Object.keys(Pg).reduce((e, t) => (RSe.forEach((n) => e[NSe(n, t)] = e[t]), e), Pg);
var MSe = /^(matrix|translate|scale|rotate|skew)/, FSe = /^(translate)/, jSe = /^(rotate|skew)/, e6 = (e, t) => Ue.num(e) && e !== 0 ? e + t : e, Mw = (e, t) => Ue.arr(e) ? e.every((n) => Mw(n, t)) : Ue.num(e) ? e === t : parseFloat(e) === t, DSe = class extends SE {
  constructor({ x: e, y: t, z: n, ...r }) {
    const i = [], s = [];
    (e || t || n) && (i.push([e || 0, t || 0, n || 0]), s.push((o) => [
      `translate3d(${o.map((a) => e6(a, "px")).join(",")})`,
      // prettier-ignore
      Mw(o, 0)
    ])), wa(r, (o, a) => {
      if (a === "transform")
        i.push([o || ""]), s.push((c) => [c, c === ""]);
      else if (MSe.test(a)) {
        if (delete r[a], Ue.und(o))
          return;
        const c = FSe.test(a) ? "px" : jSe.test(a) ? "deg" : "";
        i.push(Yi(o)), s.push(
          a === "rotate3d" ? ([l, u, d, f]) => [
            `rotate3d(${l},${u},${d},${e6(f, c)})`,
            Mw(f, 0)
          ] : (l) => [
            `${a}(${l.map((u) => e6(u, c)).join(",")})`,
            Mw(l, a.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), i.length && (r.transform = new USe(i, s)), super(r);
  }
}, USe = class extends QW {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return jt(this.inputs, (n, r) => {
      const i = _i(n[0]), [s, o] = this.transforms[r](
        Ue.arr(i) ? i : n.map(_i)
      );
      e += " " + s, t = t && o;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && jt(
      this.inputs,
      (t) => jt(
        t,
        (n) => Es(n) && i0(n, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && jt(
      this.inputs,
      (t) => jt(
        t,
        (n) => Es(n) && jy(n, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), Fy(this, e);
  }
}, LSe = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
mo.assign({
  batchedUpdates: mZ,
  createStringInterpolator: ZW,
  colors: I6e
});
var zSe = cSe(LSe, {
  applyAnimatedValues: OSe,
  createAnimatedStyle: (e) => new DSe(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...n }) => n
}), VSe = zSe.animated;
function qN(e, t) {
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function wG(e, t) {
  return e.map(function(n, r) {
    return n - t[r];
  });
}
function eT(e) {
  return Math.hypot.apply(Math, e);
}
function HSe(e, t, n) {
  var r = eT(t), i = r === 0 ? 0 : 1 / r, s = n === 0 ? 0 : 1 / n, o = s * r, a = t.map(function(u) {
    return s * u;
  }), c = t.map(function(u) {
    return i * u;
  }), l = eT(e);
  return {
    velocities: a,
    velocity: o,
    distance: l,
    direction: c
  };
}
function tT(e) {
  return Math.sign ? Math.sign(e) : +(e > 0) - +(e < 0) || +e;
}
function WSe(e, t, n) {
  return Math.max(t, Math.min(e, n));
}
function GSe(e, t) {
  return Math.pow(e, t * 5);
}
function $N(e, t, n) {
  return t === 0 || Math.abs(t) === 1 / 0 ? GSe(e, n) : e * t * n / (t + n * e);
}
function Og(e, t, n, r) {
  return r === void 0 && (r = 0.15), r === 0 ? WSe(e, t, n) : e < t ? -$N(t - e, n - t, r) + t : e > n ? +$N(e - n, n - t, r) + n : e;
}
function qSe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function $Se(e, t, n) {
  return t && qSe(e.prototype, t), e;
}
function ai() {
  return ai = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ai.apply(this, arguments);
}
function xG(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function QSe(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function T1(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function KSe(e, t) {
  if (e) {
    if (typeof e == "string")
      return QN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return QN(e, t);
  }
}
function QN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function TE(e, t) {
  var n;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (n = KSe(e)) || t) {
      n && (e = n);
      var r = 0;
      return function() {
        return r >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[r++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return n = e[Symbol.iterator](), n.next.bind(n);
}
function AG() {
}
function EG() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? AG : t.length === 1 ? t[0] : function() {
    for (var r, i = TE(t), s; !(s = i()).done; ) {
      var o = s.value;
      r = o.apply(this, arguments) || r;
    }
    return r;
  };
}
function ul(e, t) {
  if (e === void 0) {
    if (t === void 0)
      throw new Error("Must define fallback value if undefined is expected");
    e = t;
  }
  return Array.isArray(e) ? e : [e, e];
}
function k1(e) {
  if (typeof e == "function") {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    return e.apply(void 0, n);
  } else
    return e;
}
function _8(e, t) {
  e === void 0 && (e = {});
  for (var n = {}, r = 0, i = Object.entries(t); r < i.length; r++) {
    var s = i[r], o = s[0], a = s[1];
    switch (typeof a) {
      case "function":
        n[o] = a.call(n, e[o], o, e);
        break;
      case "object":
        n[o] = _8(e[o], a);
        break;
      case "boolean":
        a && (n[o] = e[o]);
        break;
    }
  }
  return n;
}
var YSe = 180, ZSe = 0.15, JSe = 0.5, XSe = 60, eCe = {
  threshold: function(t) {
    return t === void 0 && (t = 0), ul(t);
  },
  rubberband: function(t) {
    switch (t === void 0 && (t = 0), t) {
      case !0:
        return ul(ZSe);
      case !1:
        return ul(0);
      default:
        return ul(t);
    }
  },
  enabled: function(t) {
    return t === void 0 && (t = !0), t;
  },
  triggerAllEvents: function(t) {
    return t === void 0 && (t = !1), t;
  },
  initial: function(t) {
    return t === void 0 && (t = 0), typeof t == "function" ? t : ul(t);
  }
}, _G = /* @__PURE__ */ ai({}, eCe, {
  axis: !0,
  lockDirection: function(t) {
    return t === void 0 && (t = !1), t;
  },
  bounds: function(t) {
    if (t === void 0 && (t = {}), typeof t == "function")
      return function(d) {
        return _G.bounds(t(d));
      };
    var n = t, r = n.left, i = r === void 0 ? -1 / 0 : r, s = n.right, o = s === void 0 ? 1 / 0 : s, a = n.top, c = a === void 0 ? -1 / 0 : a, l = n.bottom, u = l === void 0 ? 1 / 0 : l;
    return [[i, o], [c, u]];
  }
}), tCe = typeof window < "u" && window.document && window.document.createElement, nCe = {
  enabled: function(t) {
    return t === void 0 && (t = !0), t;
  },
  domTarget: !0,
  window: /* @__PURE__ */ function(e) {
    function t(n) {
      return e.apply(this, arguments);
    }
    return t.toString = function() {
      return e.toString();
    }, t;
  }(function(e) {
    return e === void 0 && (e = tCe ? window : void 0), e;
  }),
  eventOptions: function(t) {
    var n = t === void 0 ? {} : t, r = n.passive, i = r === void 0 ? !0 : r, s = n.capture, o = s === void 0 ? !1 : s;
    return {
      passive: i,
      capture: o
    };
  }
}, rCe = /* @__PURE__ */ ai({}, _G, {
  threshold: function(t, n, r) {
    var i = r.filterTaps, s = i === void 0 ? !1 : i, o = r.lockDirection, a = o === void 0 ? !1 : o, c = r.axis, l = c === void 0 ? void 0 : c, u = ul(t, s ? 3 : a || l ? 1 : 0);
    return this.filterTaps = s || u[0] + u[1] > 0, u;
  },
  swipeVelocity: function(t) {
    return t === void 0 && (t = JSe), ul(t);
  },
  swipeDistance: function(t) {
    return t === void 0 && (t = XSe), ul(t);
  },
  delay: function(t) {
    switch (t === void 0 && (t = 0), t) {
      case !0:
        return YSe;
      case !1:
        return 0;
      default:
        return t;
    }
  }
});
function iCe(e) {
  return e === void 0 && (e = {}), _8(e, nCe);
}
function sCe(e) {
  return e === void 0 && (e = {}), _8(e, rCe);
}
function oCe(e) {
  var t = e.domTarget, n = e.eventOptions, r = e.window, i = e.enabled, s = QSe(e, ["domTarget", "eventOptions", "window", "enabled"]), o = iCe({
    domTarget: t,
    eventOptions: n,
    window: r,
    enabled: i
  });
  return o.drag = sCe(s), o;
}
function B0(e) {
  return ai({
    _active: !1,
    _blocked: !1,
    _intentional: [!1, !1],
    _movement: [0, 0],
    _initial: [0, 0],
    _bounds: [[-1 / 0, 1 / 0], [-1 / 0, 1 / 0]],
    _lastEventType: void 0,
    event: void 0,
    // currentTarget: undefined,
    // pointerId: undefined,
    intentional: !1,
    values: [0, 0],
    velocities: [0, 0],
    delta: [0, 0],
    movement: [0, 0],
    offset: [0, 0],
    lastOffset: [0, 0],
    direction: [0, 0],
    initial: [0, 0],
    previous: [0, 0],
    first: !1,
    last: !1,
    active: !1,
    timeStamp: 0,
    startTime: 0,
    elapsedTime: 0,
    cancel: AG,
    canceled: !1,
    memo: void 0,
    args: void 0
  }, e);
}
function SG() {
  var e = {
    hovering: !1,
    scrolling: !1,
    wheeling: !1,
    dragging: !1,
    moving: !1,
    pinching: !1,
    touches: 0,
    buttons: 0,
    down: !1,
    shiftKey: !1,
    altKey: !1,
    metaKey: !1,
    ctrlKey: !1
  }, t = B0({
    axis: void 0,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0,
    _isTap: !0,
    _delayedEvent: !1,
    _pointerId: void 0,
    tap: !1,
    swipe: [0, 0]
  }), n = B0({
    da: [0, 0],
    vdva: [0, 0],
    // @ts-ignore origin can never be passed as undefined in userland
    origin: void 0,
    turns: 0
  }), r = B0({
    axis: void 0,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0
  }), i = B0({
    axis: void 0,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0
  }), s = B0({
    axis: void 0,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0
  });
  return {
    shared: e,
    drag: t,
    pinch: n,
    wheel: r,
    move: i,
    scroll: s
  };
}
var Ou = /* @__PURE__ */ new Map(), aCe = /* @__PURE__ */ function() {
  function e(n, r) {
    var i = this;
    r === void 0 && (r = []), this.controller = n, this.args = r, this.debounced = !0, this.setTimeout = function(s, o) {
      var a;
      o === void 0 && (o = 140), clearTimeout(i.controller.timeouts[i.stateKey]);
      for (var c = arguments.length, l = new Array(c > 2 ? c - 2 : 0), u = 2; u < c; u++)
        l[u - 2] = arguments[u];
      i.controller.timeouts[i.stateKey] = (a = window).setTimeout.apply(a, [s, o].concat(l));
    }, this.clearTimeout = function() {
      clearTimeout(i.controller.timeouts[i.stateKey]);
    }, this.fireGestureHandler = function(s) {
      if (s === void 0 && (s = !1), i.state._blocked)
        return i.debounced || (i.state._active = !1, i.clean()), null;
      if (!s && !i.state.intentional && !i.config.triggerAllEvents)
        return null;
      if (i.state.intentional) {
        var o = i.state.active, a = i.state._active;
        i.state.active = a, i.state.first = a && !o, i.state.last = o && !a, i.controller.state.shared[i.ingKey] = a;
      }
      var c = ai({}, i.controller.state.shared, i.state, i.mapStateValues(i.state)), l = i.handler(c);
      return i.state.memo = l !== void 0 ? l : i.state.memo, i.state._active || i.clean(), c;
    };
  }
  var t = e.prototype;
  return t.updateSharedState = function(r) {
    Object.assign(this.controller.state.shared, r);
  }, t.updateGestureState = function(r) {
    Object.assign(this.state, r);
  }, t.checkIntentionality = function(r, i) {
    return {
      _intentional: r,
      _blocked: !1
    };
  }, t.getMovement = function(r) {
    var i = this.config, s = i.initial, o = i.bounds, a = i.rubberband, c = i.threshold, l = this.state, u = l._bounds, d = l._initial, f = l._active, p = l._intentional, m = l.lastOffset, h = l.movement, g = this.getInternalMovement(r, this.state), y = p[0] === !1 ? KN(g[0], c[0]) : p[0], v = p[1] === !1 ? KN(g[1], c[1]) : p[1], b = this.checkIntentionality([y, v], g);
    if (b._blocked)
      return ai({}, b, {
        _movement: g,
        delta: [0, 0]
      });
    var w = b._intentional, A = g, E, x;
    if (w[0] !== !1 && p[0] === !1 && (x = k1(s, this.state), E = k1(o, this.state), d[0] = x[0], u[0] = E[0]), w[1] !== !1 && p[1] === !1) {
      var S, P;
      x = (S = x) != null ? S : k1(s, this.state), E = (P = E) != null ? P : k1(o, this.state), d[1] = x[1], u[1] = E[1];
    }
    var I = [w[0] !== !1 ? g[0] - w[0] : d[0], w[1] !== !1 ? g[1] - w[1] : d[1]], R = qN(I, m), Q = f ? a : [0, 0];
    return I = YN(u, qN(I, d), Q), ai({}, b, {
      intentional: w[0] !== !1 || w[1] !== !1,
      _initial: d,
      _movement: A,
      movement: I,
      values: r,
      offset: YN(u, R, Q),
      delta: wG(I, h)
    });
  }, t.clean = function() {
    this.clearTimeout();
  }, $Se(e, [{
    key: "config",
    get: function() {
      return this.controller.config[this.stateKey];
    }
    // Is the gesture enabled
  }, {
    key: "enabled",
    get: function() {
      return this.controller.config.enabled && this.config.enabled;
    }
    // Returns the controller state for a given gesture
  }, {
    key: "state",
    get: function() {
      return this.controller.state[this.stateKey];
    }
    // Returns the gesture handler
  }, {
    key: "handler",
    get: function() {
      return this.controller.handlers[this.stateKey];
    }
  }]), e;
}();
function KN(e, t) {
  return Math.abs(e) >= t ? tT(e) * t : !1;
}
function YN(e, t, n) {
  var r = t[0], i = t[1], s = n[0], o = n[1], a = e[0], c = a[0], l = a[1], u = e[1], d = u[0], f = u[1];
  return [Og(r, c, l, s), Og(i, d, f, o)];
}
function t6(e, t, n) {
  var r = e.state, i = e.args, s = t.timeStamp, o = t.type, a = r.values, c = n ? 0 : s - r.startTime;
  return {
    _lastEventType: o,
    event: t,
    timeStamp: s,
    elapsedTime: c,
    args: i,
    previous: a
  };
}
function cCe(e, t, n) {
  var r = e.state.offset, i = n.timeStamp;
  return ai({}, SG()[e.stateKey], {
    _active: !0,
    values: t,
    initial: t,
    offset: r,
    lastOffset: r,
    startTime: i
  });
}
function lCe(e, t) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      i[s - 1] = arguments[s];
    return e.call.apply(e, [this, ai({}, t, {
      event: n
    })].concat(i));
  };
}
var uCe = function(t) {
  var n = this;
  this.classes = t, this.bind = function() {
    for (var r = {}, i = arguments.length, s = new Array(i), o = 0; o < i; o++)
      s[o] = arguments[o];
    for (var a = TE(n.classes), c; !(c = a()).done; ) {
      var l = c.value;
      new l(n, s).addBindings(r);
    }
    for (var u = 0, d = Object.entries(n.nativeRefs); u < d.length; u++) {
      var f = d[u], p = f[0], m = f[1];
      nT(r, p, lCe(m, ai({}, n.state.shared, {
        args: s
      })));
    }
    return n.config.domTarget ? pCe(n, r) : mCe(n, r);
  }, this.effect = function() {
    return n.config.domTarget && n.bind(), n.clean;
  }, this.clean = function() {
    var r = TG(n.config), i = n.config.eventOptions;
    r && Iv(r, CG(n.domListeners), i), Object.values(n.timeouts).forEach(clearTimeout), dCe(n);
  }, this.state = SG(), this.timeouts = {}, this.domListeners = [], this.windowListeners = {};
};
function dCe(e) {
  var t = e.config, n = t.window, r = t.eventOptions, i = e.windowListeners;
  if (n) {
    for (var s in i) {
      var o = i[s];
      Iv(n, o, r);
    }
    e.windowListeners = {};
  }
}
function fCe(e, t) {
  var n = e.config, r = e.windowListeners;
  n.window && (Iv(n.window, r[t], n.eventOptions), delete r[t]);
}
function hCe(e, t, n) {
  var r = e.config, i = e.windowListeners;
  n === void 0 && (n = []), r.window && (Iv(r.window, i[t], r.eventOptions), kG(r.window, i[t] = n, r.eventOptions));
}
function pCe(e, t) {
  var n = e.config, r = e.domListeners, i = TG(n);
  if (!i)
    throw new Error("domTarget must be defined");
  var s = n.eventOptions;
  Iv(i, CG(r), s);
  for (var o = 0, a = Object.entries(t); o < a.length; o++) {
    var c = a[o], l = c[0], u = c[1], d = l.slice(2).toLowerCase();
    r.push([d, EG.apply(void 0, u)]);
  }
  kG(i, r, s);
}
function mCe(e, t) {
  for (var n = e.config, r = {}, i = n.eventOptions.capture ? "Capture" : "", s = 0, o = Object.entries(t); s < o.length; s++) {
    var a = o[s], c = a[0], l = a[1], u = Array.isArray(l) ? l : [l], d = c + i;
    r[d] = EG.apply(void 0, u);
  }
  return r;
}
function CG(e) {
  return e === void 0 && (e = []), e.splice(0, e.length);
}
function TG(e) {
  var t = e.domTarget;
  return t && "current" in t ? t.current : t;
}
function nT(e, t, n) {
  e[t] || (e[t] = []), e[t].push(n);
}
function kG(e, t, n) {
  t === void 0 && (t = []), n === void 0 && (n = {});
  for (var r = TE(t), i; !(i = r()).done; ) {
    var s = i.value, o = s[0], a = s[1];
    e.addEventListener(o, a, n);
  }
}
function Iv(e, t, n) {
  t === void 0 && (t = []), n === void 0 && (n = {});
  for (var r = TE(t), i; !(i = r()).done; ) {
    var s = i.value, o = s[0], a = s[1];
    e.removeEventListener(o, a, n);
  }
}
function gCe(e, t, n) {
  n === void 0 && (n = {});
  var r = bCe(e), i = k.useMemo(function() {
    return new uCe(r);
  }, []);
  return i.config = t, i.handlers = e, i.nativeRefs = n, k.useEffect(i.effect, []), i.config.domTarget ? yCe : i.bind;
}
function yCe() {
}
function bCe(e) {
  var t = /* @__PURE__ */ new Set();
  return e.drag && t.add(Ou.get("drag")), e.wheel && t.add(Ou.get("wheel")), e.scroll && t.add(Ou.get("scroll")), e.move && t.add(Ou.get("move")), e.pinch && t.add(Ou.get("pinch")), e.hover && t.add(Ou.get("hover")), t;
}
var vCe = /* @__PURE__ */ function(e) {
  xG(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.getInternalMovement = function(i, s) {
    return wG(i, s.initial);
  }, n.checkIntentionality = function(i, s) {
    if (i[0] === !1 && i[1] === !1)
      return {
        _intentional: i,
        axis: this.state.axis
      };
    var o = s.map(Math.abs), a = o[0], c = o[1], l = this.state.axis || (a > c ? "x" : a < c ? "y" : void 0);
    return !this.config.axis && !this.config.lockDirection ? {
      _intentional: i,
      _blocked: !1,
      axis: l
    } : l ? this.config.axis && l !== this.config.axis ? {
      _intentional: i,
      _blocked: !0,
      axis: l
    } : (i[l === "x" ? 1 : 0] = !1, {
      _intentional: i,
      _blocked: !1,
      axis: l
    }) : {
      _intentional: [!1, !1],
      _blocked: !1,
      axis: l
    };
  }, n.getKinematics = function(i, s) {
    var o = this.getMovement(i);
    if (!o._blocked) {
      var a = s.timeStamp - this.state.timeStamp;
      Object.assign(o, HSe(o.movement, o.delta, a));
    }
    return o;
  }, n.mapStateValues = function(i) {
    return {
      xy: i.values,
      vxvy: i.velocities
    };
  }, t;
}(aCe);
function BG(e) {
  if ("touches" in e) {
    var t = e.targetTouches, n = e.changedTouches;
    return t.length > 0 ? t : n;
  }
  return null;
}
function ZN(e) {
  var t = "buttons" in e ? e.buttons : 0, n = BG(e), r = n && n.length || 0, i = r > 0 || t > 0, s = e.shiftKey, o = e.altKey, a = e.metaKey, c = e.ctrlKey;
  return {
    touches: r,
    down: i,
    buttons: t,
    shiftKey: s,
    altKey: o,
    metaKey: a,
    ctrlKey: c
  };
}
function JN(e) {
  var t = BG(e), n = t ? t[0] : e, r = n.clientX, i = n.clientY;
  return [r, i];
}
var wCe = 3, xCe = 220, ACe = /* @__PURE__ */ function(e) {
  xG(t, e);
  function t() {
    var r;
    return r = e.apply(this, arguments) || this, r.ingKey = "dragging", r.stateKey = "drag", r.onDragStart = function(i) {
      !r.enabled || r.state._active || (hCe(r.controller, r.stateKey, [["pointermove", r.onDragChange], ["pointerup", r.onDragEnd], ["pointercancel", r.onDragEnd]]), r.updateGestureState({
        _pointerId: i.pointerId
      }), r.config.delay > 0 ? (r.state._delayedEvent = !0, "persist" in i && typeof i.persist == "function" && i.persist(), r.setTimeout(r.startDrag.bind(T1(r)), r.config.delay, i)) : r.startDrag(i));
    }, r.onDragChange = function(i) {
      if (!r.state.canceled && i.pointerId === r.state._pointerId) {
        if (!r.state._active) {
          r.state._delayedEvent && (r.clearTimeout(), r.startDrag(i));
          return;
        }
        var s = ZN(i);
        if (!s.down) {
          r.onDragEnd(i);
          return;
        }
        r.updateSharedState(s);
        var o = JN(i), a = r.getKinematics(o, i), c = t6(T1(r), i), l = r.state._isTap, u = eT(a._movement);
        l && u >= wCe && (l = !1), r.updateGestureState(ai({}, c, a, {
          _isTap: l
        })), r.fireGestureHandler();
      }
    }, r.onDragEnd = function(i) {
      if (i.pointerId === r.state._pointerId) {
        r.state._active = !1, r.updateSharedState({
          down: !1,
          buttons: 0,
          touches: 0
        });
        var s = r.state._isTap, o = r.state.velocities, a = o[0], c = o[1], l = r.state.movement, u = l[0], d = l[1], f = r.state._intentional, p = f[0], m = f[1], h = r.config.swipeVelocity, g = h[0], y = h[1], v = r.config.swipeDistance, b = v[0], w = v[1], A = ai({}, t6(T1(r), i), r.getMovement(r.state.values)), E = [0, 0];
        A.elapsedTime < xCe && (p !== !1 && Math.abs(a) > g && Math.abs(u) > b && (E[0] = tT(a)), m !== !1 && Math.abs(c) > y && Math.abs(d) > w && (E[1] = tT(c))), r.updateGestureState(ai({}, A, {
          tap: s,
          swipe: E
        })), r.fireGestureHandler(s === !0);
      }
    }, r.clean = function() {
      e.prototype.clean.call(T1(r)), r.state._delayedEvent = !1, fCe(r.controller, r.stateKey);
    }, r.onCancel = function() {
      r.state.canceled || (r.updateGestureState({
        canceled: !0
      }), r.state._active = !1, r.updateSharedState({
        down: !1,
        buttons: 0,
        touches: 0
      }), requestAnimationFrame(function() {
        return r.fireGestureHandler();
      }));
    }, r.onClick = function(i) {
      r.state._isTap || i.stopPropagation();
    }, r;
  }
  var n = t.prototype;
  return n.startDrag = function(i) {
    var s = JN(i);
    this.updateSharedState(ZN(i)), this.updateGestureState(ai({}, cCe(this, s, i), t6(this, i, !0), {
      _pointerId: i.pointerId,
      cancel: this.onCancel
    })), this.updateGestureState(this.getMovement(s)), this.fireGestureHandler();
  }, n.addBindings = function(i) {
    if (nT(i, "onPointerDown", this.onDragStart), this.config.filterTaps) {
      var s = this.controller.config.eventOptions.capture ? "onClick" : "onClickCapture";
      nT(i, s, this.onClick);
    }
  }, t;
}(vCe);
function ECe(e, t) {
  var n, r = [], i, s = !1;
  function o() {
    for (var a = arguments.length, c = new Array(a), l = 0; l < a; l++)
      c[l] = arguments[l];
    return s && n === this && t(c, r) || (i = e.apply(this, c), s = !0, n = this, r = c), i;
  }
  return o;
}
function Fw(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, i;
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Fw(e[r], t[r]))
          return !1;
      return !0;
    }
    var s;
    if (typeof Map == "function" && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!Fw(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (typeof Set == "function" && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (s = e.entries(); !(r = s.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r]))
        return !1;
    if (typeof Element < "u" && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!(i[r] === "_owner" && e.$$typeof) && !Fw(e[i[r]], t[i[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
function _Ce(e, t) {
  try {
    return Fw(e, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
}
function SCe(e, t) {
  t === void 0 && (t = {}), Ou.set("drag", ACe);
  var n = Le();
  return n.current || (n.current = ECe(oCe, _Ce)), gCe({
    drag: e
  }, n.current(t));
}
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var IG = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], f2 = /* @__PURE__ */ IG.join(","), PG = typeof Element > "u", uf = PG ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, rT = !PG && Element.prototype.getRootNode ? function(e) {
  return e.getRootNode();
} : function(e) {
  return e.ownerDocument;
}, OG = function(t, n, r) {
  var i = Array.prototype.slice.apply(t.querySelectorAll(f2));
  return n && uf.call(t, f2) && i.unshift(t), i = i.filter(r), i;
}, NG = function e(t, n, r) {
  for (var i = [], s = Array.from(t); s.length; ) {
    var o = s.shift();
    if (o.tagName === "SLOT") {
      var a = o.assignedElements(), c = a.length ? a : o.children, l = e(c, !0, r);
      r.flatten ? i.push.apply(i, l) : i.push({
        scope: o,
        candidates: l
      });
    } else {
      var u = uf.call(o, f2);
      u && r.filter(o) && (n || !t.includes(o)) && i.push(o);
      var d = o.shadowRoot || // check for an undisclosed shadow
      typeof r.getShadowRoot == "function" && r.getShadowRoot(o), f = !r.shadowRootFilter || r.shadowRootFilter(o);
      if (d && f) {
        var p = e(d === !0 ? o.children : d.children, !0, r);
        r.flatten ? i.push.apply(i, p) : i.push({
          scope: o,
          candidates: p
        });
      } else
        s.unshift.apply(s, o.children);
    }
  }
  return i;
}, RG = function(t, n) {
  return t.tabIndex < 0 && (n || /^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || t.isContentEditable) && isNaN(parseInt(t.getAttribute("tabindex"), 10)) ? 0 : t.tabIndex;
}, CCe = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, MG = function(t) {
  return t.tagName === "INPUT";
}, TCe = function(t) {
  return MG(t) && t.type === "hidden";
}, kCe = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, BCe = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, ICe = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || rT(t), r = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var s = BCe(i, t.form);
  return !s || s === t;
}, PCe = function(t) {
  return MG(t) && t.type === "radio";
}, OCe = function(t) {
  return PCe(t) && !ICe(t);
}, XN = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, NCe = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var s = uf.call(t, "details>summary:first-of-type"), o = s ? t.parentElement : t;
  if (uf.call(o, "details:not([open]) *"))
    return !0;
  var a = rT(t).host, c = (a == null ? void 0 : a.ownerDocument.contains(a)) || t.ownerDocument.contains(t);
  if (!r || r === "full") {
    if (typeof i == "function") {
      for (var l = t; t; ) {
        var u = t.parentElement, d = rT(t);
        if (u && !u.shadowRoot && i(u) === !0)
          return XN(t);
        t.assignedSlot ? t = t.assignedSlot : !u && d !== t.ownerDocument ? t = d.host : t = u;
      }
      t = l;
    }
    if (c)
      return !t.getClientRects().length;
  } else if (r === "non-zero-area")
    return XN(t);
  return !1;
}, RCe = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return uf.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, h2 = function(t, n) {
  return !(n.disabled || TCe(n) || NCe(n, t) || // For a details element with a summary, the summary element gets the focus
  kCe(n) || RCe(n));
}, iT = function(t, n) {
  return !(OCe(n) || RG(n) < 0 || !h2(t, n));
}, MCe = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, FCe = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, s) {
    var o = !!i.scope, a = o ? i.scope : i, c = RG(a, o), l = o ? e(i.candidates) : a;
    c === 0 ? o ? n.push.apply(n, l) : n.push(a) : r.push({
      documentOrder: s,
      tabIndex: c,
      item: i,
      isScope: o,
      content: l
    });
  }), r.sort(CCe).reduce(function(i, s) {
    return s.isScope ? i.push.apply(i, s.content) : i.push(s.content), i;
  }, []).concat(n);
}, jCe = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = NG([t], n.includeContainer, {
    filter: iT.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: MCe
  }) : r = OG(t, n.includeContainer, iT.bind(null, n)), FCe(r);
}, DCe = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = NG([t], n.includeContainer, {
    filter: h2.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = OG(t, n.includeContainer, h2.bind(null, n)), r;
}, B1 = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return uf.call(t, f2) === !1 ? !1 : iT(n, t);
}, UCe = /* @__PURE__ */ IG.concat("iframe").join(","), n6 = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return uf.call(t, UCe) === !1 ? !1 : h2(n, t);
};
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function eR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tR(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eR(Object(n), !0).forEach(function(r) {
      LCe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : eR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function LCe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var nR = /* @__PURE__ */ function() {
  var e = [];
  return {
    activateTrap: function(n) {
      if (e.length > 0) {
        var r = e[e.length - 1];
        r !== n && r.pause();
      }
      var i = e.indexOf(n);
      i === -1 || e.splice(i, 1), e.push(n);
    },
    deactivateTrap: function(n) {
      var r = e.indexOf(n);
      r !== -1 && e.splice(r, 1), e.length > 0 && e[e.length - 1].unpause();
    }
  };
}(), zCe = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, VCe = function(t) {
  return t.key === "Escape" || t.key === "Esc" || t.keyCode === 27;
}, HCe = function(t) {
  return t.key === "Tab" || t.keyCode === 9;
}, rR = function(t) {
  return setTimeout(t, 0);
}, iR = function(t, n) {
  var r = -1;
  return t.every(function(i, s) {
    return n(i) ? (r = s, !1) : !0;
  }), r;
}, I0 = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, I1 = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, WCe = function(t, n) {
  var r = (n == null ? void 0 : n.document) || document, i = tR({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0
  }, n), s = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  }, o, a = function(E, x, S) {
    return E && E[x] !== void 0 ? E[x] : i[S || x];
  }, c = function(E) {
    return s.containerGroups.findIndex(function(x) {
      var S = x.container, P = x.tabbableNodes;
      return S.contains(E) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      P.find(function(I) {
        return I === E;
      });
    });
  }, l = function(E) {
    var x = i[E];
    if (typeof x == "function") {
      for (var S = arguments.length, P = new Array(S > 1 ? S - 1 : 0), I = 1; I < S; I++)
        P[I - 1] = arguments[I];
      x = x.apply(void 0, P);
    }
    if (x === !0 && (x = void 0), !x) {
      if (x === void 0 || x === !1)
        return x;
      throw new Error("`".concat(E, "` was specified but was not a node, or did not return a node"));
    }
    var R = x;
    if (typeof x == "string" && (R = r.querySelector(x), !R))
      throw new Error("`".concat(E, "` as selector refers to no known node"));
    return R;
  }, u = function() {
    var E = l("initialFocus");
    if (E === !1)
      return !1;
    if (E === void 0)
      if (c(r.activeElement) >= 0)
        E = r.activeElement;
      else {
        var x = s.tabbableGroups[0], S = x && x.firstTabbableNode;
        E = S || l("fallbackFocus");
      }
    if (!E)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return E;
  }, d = function() {
    if (s.containerGroups = s.containers.map(function(E) {
      var x = jCe(E, i.tabbableOptions), S = DCe(E, i.tabbableOptions);
      return {
        container: E,
        tabbableNodes: x,
        focusableNodes: S,
        firstTabbableNode: x.length > 0 ? x[0] : null,
        lastTabbableNode: x.length > 0 ? x[x.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(I) {
          var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Q = S.findIndex(function(J) {
            return J === I;
          });
          if (!(Q < 0))
            return R ? S.slice(Q + 1).find(function(J) {
              return B1(J, i.tabbableOptions);
            }) : S.slice(0, Q).reverse().find(function(J) {
              return B1(J, i.tabbableOptions);
            });
        }
      };
    }), s.tabbableGroups = s.containerGroups.filter(function(E) {
      return E.tabbableNodes.length > 0;
    }), s.tabbableGroups.length <= 0 && !l("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
  }, f = function A(E) {
    if (E !== !1 && E !== r.activeElement) {
      if (!E || !E.focus) {
        A(u());
        return;
      }
      E.focus({
        preventScroll: !!i.preventScroll
      }), s.mostRecentlyFocusedNode = E, zCe(E) && E.select();
    }
  }, p = function(E) {
    var x = l("setReturnFocus", E);
    return x || (x === !1 ? !1 : E);
  }, m = function(E) {
    var x = I1(E);
    if (!(c(x) >= 0)) {
      if (I0(i.clickOutsideDeactivates, E)) {
        o.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: i.returnFocusOnDeactivate && !n6(x, i.tabbableOptions)
        });
        return;
      }
      I0(i.allowOutsideClick, E) || E.preventDefault();
    }
  }, h = function(E) {
    var x = I1(E), S = c(x) >= 0;
    S || x instanceof Document ? S && (s.mostRecentlyFocusedNode = x) : (E.stopImmediatePropagation(), f(s.mostRecentlyFocusedNode || u()));
  }, g = function(E) {
    var x = I1(E);
    d();
    var S = null;
    if (s.tabbableGroups.length > 0) {
      var P = c(x), I = P >= 0 ? s.containerGroups[P] : void 0;
      if (P < 0)
        E.shiftKey ? S = s.tabbableGroups[s.tabbableGroups.length - 1].lastTabbableNode : S = s.tabbableGroups[0].firstTabbableNode;
      else if (E.shiftKey) {
        var R = iR(s.tabbableGroups, function(U) {
          var q = U.firstTabbableNode;
          return x === q;
        });
        if (R < 0 && (I.container === x || n6(x, i.tabbableOptions) && !B1(x, i.tabbableOptions) && !I.nextTabbableNode(x, !1)) && (R = P), R >= 0) {
          var Q = R === 0 ? s.tabbableGroups.length - 1 : R - 1, J = s.tabbableGroups[Q];
          S = J.lastTabbableNode;
        }
      } else {
        var we = iR(s.tabbableGroups, function(U) {
          var q = U.lastTabbableNode;
          return x === q;
        });
        if (we < 0 && (I.container === x || n6(x, i.tabbableOptions) && !B1(x, i.tabbableOptions) && !I.nextTabbableNode(x)) && (we = P), we >= 0) {
          var V = we === s.tabbableGroups.length - 1 ? 0 : we + 1, L = s.tabbableGroups[V];
          S = L.firstTabbableNode;
        }
      }
    } else
      S = l("fallbackFocus");
    S && (E.preventDefault(), f(S));
  }, y = function(E) {
    if (VCe(E) && I0(i.escapeDeactivates, E) !== !1) {
      E.preventDefault(), o.deactivate();
      return;
    }
    if (HCe(E)) {
      g(E);
      return;
    }
  }, v = function(E) {
    var x = I1(E);
    c(x) >= 0 || I0(i.clickOutsideDeactivates, E) || I0(i.allowOutsideClick, E) || (E.preventDefault(), E.stopImmediatePropagation());
  }, b = function() {
    if (s.active)
      return nR.activateTrap(o), s.delayInitialFocusTimer = i.delayInitialFocus ? rR(function() {
        f(u());
      }) : f(u()), r.addEventListener("focusin", h, !0), r.addEventListener("mousedown", m, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", m, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", v, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", y, {
        capture: !0,
        passive: !1
      }), o;
  }, w = function() {
    if (s.active)
      return r.removeEventListener("focusin", h, !0), r.removeEventListener("mousedown", m, !0), r.removeEventListener("touchstart", m, !0), r.removeEventListener("click", v, !0), r.removeEventListener("keydown", y, !0), o;
  };
  return o = {
    get active() {
      return s.active;
    },
    get paused() {
      return s.paused;
    },
    activate: function(E) {
      if (s.active)
        return this;
      var x = a(E, "onActivate"), S = a(E, "onPostActivate"), P = a(E, "checkCanFocusTrap");
      P || d(), s.active = !0, s.paused = !1, s.nodeFocusedBeforeActivation = r.activeElement, x && x();
      var I = function() {
        P && d(), b(), S && S();
      };
      return P ? (P(s.containers.concat()).then(I, I), this) : (I(), this);
    },
    deactivate: function(E) {
      if (!s.active)
        return this;
      var x = tR({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, E);
      clearTimeout(s.delayInitialFocusTimer), s.delayInitialFocusTimer = void 0, w(), s.active = !1, s.paused = !1, nR.deactivateTrap(o);
      var S = a(x, "onDeactivate"), P = a(x, "onPostDeactivate"), I = a(x, "checkCanReturnFocus"), R = a(x, "returnFocus", "returnFocusOnDeactivate");
      S && S();
      var Q = function() {
        rR(function() {
          R && f(p(s.nodeFocusedBeforeActivation)), P && P();
        });
      };
      return R && I ? (I(p(s.nodeFocusedBeforeActivation)).then(Q, Q), this) : (Q(), this);
    },
    pause: function() {
      return s.paused || !s.active ? this : (s.paused = !0, w(), this);
    },
    unpause: function() {
      return !s.paused || !s.active ? this : (s.paused = !1, d(), b(), this);
    },
    updateContainerElements: function(E) {
      var x = [].concat(E).filter(Boolean);
      return s.containers = x.map(function(S) {
        return typeof S == "string" ? r.querySelector(S) : S;
      }), s.active && d(), this;
    }
  }, o.updateContainerElements(t), o;
};
function GCe(e) {
  if (Array.isArray(e)) {
    for (var t = 0, n = Array(e.length); t < e.length; t++)
      n[t] = e[t];
    return n;
  } else
    return Array.from(e);
}
var S8 = !1;
if (typeof window < "u") {
  var sR = {
    get passive() {
      S8 = !0;
    }
  };
  window.addEventListener("testPassive", null, sR), window.removeEventListener("testPassive", null, sR);
}
var FG = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), zl = [], p2 = !1, jG = -1, Ng = void 0, Rg = void 0, DG = function(t) {
  return zl.some(function(n) {
    return !!(n.options.allowTouchMove && n.options.allowTouchMove(t));
  });
}, m2 = function(t) {
  var n = t || window.event;
  return DG(n.target) || n.touches.length > 1 ? !0 : (n.preventDefault && n.preventDefault(), !1);
}, qCe = function(t) {
  if (Rg === void 0) {
    var n = !!t && t.reserveScrollBarGap === !0, r = window.innerWidth - document.documentElement.clientWidth;
    n && r > 0 && (Rg = document.body.style.paddingRight, document.body.style.paddingRight = r + "px");
  }
  Ng === void 0 && (Ng = document.body.style.overflow, document.body.style.overflow = "hidden");
}, $Ce = function() {
  Rg !== void 0 && (document.body.style.paddingRight = Rg, Rg = void 0), Ng !== void 0 && (document.body.style.overflow = Ng, Ng = void 0);
}, QCe = function(t) {
  return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
}, KCe = function(t, n) {
  var r = t.targetTouches[0].clientY - jG;
  return DG(t.target) ? !1 : n && n.scrollTop === 0 && r > 0 || QCe(n) && r < 0 ? m2(t) : (t.stopPropagation(), !0);
}, YCe = function(t, n) {
  if (!t) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!zl.some(function(i) {
    return i.targetElement === t;
  })) {
    var r = {
      targetElement: t,
      options: n || {}
    };
    zl = [].concat(GCe(zl), [r]), FG ? (t.ontouchstart = function(i) {
      i.targetTouches.length === 1 && (jG = i.targetTouches[0].clientY);
    }, t.ontouchmove = function(i) {
      i.targetTouches.length === 1 && KCe(i, t);
    }, p2 || (document.addEventListener("touchmove", m2, S8 ? { passive: !1 } : void 0), p2 = !0)) : qCe(n);
  }
}, ZCe = function(t) {
  if (!t) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  zl = zl.filter(function(n) {
    return n.targetElement !== t;
  }), FG ? (t.ontouchstart = null, t.ontouchmove = null, p2 && zl.length === 0 && (document.removeEventListener("touchmove", m2, S8 ? { passive: !1 } : void 0), p2 = !1)) : zl.length || $Ce();
}, $d = [], JCe = function() {
  return $d.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, XCe = function() {
  return $d.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, oR = "ResizeObserver loop completed with undelivered notifications.", eTe = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: oR
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = oR), window.dispatchEvent(e);
}, Hy;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Hy || (Hy = {}));
var Qd = function(e) {
  return Object.freeze(e);
}, tTe = /* @__PURE__ */ function() {
  function e(t, n) {
    this.inlineSize = t, this.blockSize = n, Qd(this);
  }
  return e;
}(), UG = function() {
  function e(t, n, r, i) {
    return this.x = t, this.y = n, this.width = r, this.height = i, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Qd(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, n = t.x, r = t.y, i = t.top, s = t.right, o = t.bottom, a = t.left, c = t.width, l = t.height;
    return { x: n, y: r, top: i, right: s, bottom: o, left: a, width: c, height: l };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), C8 = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, LG = function(e) {
  if (C8(e)) {
    var t = e.getBBox(), n = t.width, r = t.height;
    return !n && !r;
  }
  var i = e, s = i.offsetWidth, o = i.offsetHeight;
  return !(s || o || e.getClientRects().length);
}, aR = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var n = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(n && e instanceof n.Element);
}, nTe = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, Mg = typeof window < "u" ? window : {}, P1 = /* @__PURE__ */ new WeakMap(), cR = /auto|scroll/, rTe = /^tb|vertical/, iTe = /msie|trident/i.test(Mg.navigator && Mg.navigator.userAgent), Io = function(e) {
  return parseFloat(e || "0");
}, Kh = function(e, t, n) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new tTe((n ? t : e) || 0, (n ? e : t) || 0);
}, lR = Qd({
  devicePixelContentBoxSize: Kh(),
  borderBoxSize: Kh(),
  contentBoxSize: Kh(),
  contentRect: new UG(0, 0, 0, 0)
}), zG = function(e, t) {
  if (t === void 0 && (t = !1), P1.has(e) && !t)
    return P1.get(e);
  if (LG(e))
    return P1.set(e, lR), lR;
  var n = getComputedStyle(e), r = C8(e) && e.ownerSVGElement && e.getBBox(), i = !iTe && n.boxSizing === "border-box", s = rTe.test(n.writingMode || ""), o = !r && cR.test(n.overflowY || ""), a = !r && cR.test(n.overflowX || ""), c = r ? 0 : Io(n.paddingTop), l = r ? 0 : Io(n.paddingRight), u = r ? 0 : Io(n.paddingBottom), d = r ? 0 : Io(n.paddingLeft), f = r ? 0 : Io(n.borderTopWidth), p = r ? 0 : Io(n.borderRightWidth), m = r ? 0 : Io(n.borderBottomWidth), h = r ? 0 : Io(n.borderLeftWidth), g = d + l, y = c + u, v = h + p, b = f + m, w = a ? e.offsetHeight - b - e.clientHeight : 0, A = o ? e.offsetWidth - v - e.clientWidth : 0, E = i ? g + v : 0, x = i ? y + b : 0, S = r ? r.width : Io(n.width) - E - A, P = r ? r.height : Io(n.height) - x - w, I = S + g + A + v, R = P + y + w + b, Q = Qd({
    devicePixelContentBoxSize: Kh(Math.round(S * devicePixelRatio), Math.round(P * devicePixelRatio), s),
    borderBoxSize: Kh(I, R, s),
    contentBoxSize: Kh(S, P, s),
    contentRect: new UG(d, c, S, P)
  });
  return P1.set(e, Q), Q;
}, VG = function(e, t, n) {
  var r = zG(e, n), i = r.borderBoxSize, s = r.contentBoxSize, o = r.devicePixelContentBoxSize;
  switch (t) {
    case Hy.DEVICE_PIXEL_CONTENT_BOX:
      return o;
    case Hy.BORDER_BOX:
      return i;
    default:
      return s;
  }
}, sTe = /* @__PURE__ */ function() {
  function e(t) {
    var n = zG(t);
    this.target = t, this.contentRect = n.contentRect, this.borderBoxSize = Qd([n.borderBoxSize]), this.contentBoxSize = Qd([n.contentBoxSize]), this.devicePixelContentBoxSize = Qd([n.devicePixelContentBoxSize]);
  }
  return e;
}(), HG = function(e) {
  if (LG(e))
    return 1 / 0;
  for (var t = 0, n = e.parentNode; n; )
    t += 1, n = n.parentNode;
  return t;
}, oTe = function() {
  var e = 1 / 0, t = [];
  $d.forEach(function(o) {
    if (o.activeTargets.length !== 0) {
      var a = [];
      o.activeTargets.forEach(function(l) {
        var u = new sTe(l.target), d = HG(l.target);
        a.push(u), l.lastReportedSize = VG(l.target, l.observedBox), d < e && (e = d);
      }), t.push(function() {
        o.callback.call(o.observer, a, o.observer);
      }), o.activeTargets.splice(0, o.activeTargets.length);
    }
  });
  for (var n = 0, r = t; n < r.length; n++) {
    var i = r[n];
    i();
  }
  return e;
}, uR = function(e) {
  $d.forEach(function(n) {
    n.activeTargets.splice(0, n.activeTargets.length), n.skippedTargets.splice(0, n.skippedTargets.length), n.observationTargets.forEach(function(i) {
      i.isActive() && (HG(i.target) > e ? n.activeTargets.push(i) : n.skippedTargets.push(i));
    });
  });
}, aTe = function() {
  var e = 0;
  for (uR(e); JCe(); )
    e = oTe(), uR(e);
  return XCe() && eTe(), e > 0;
}, r6, WG = [], cTe = function() {
  return WG.splice(0).forEach(function(e) {
    return e();
  });
}, lTe = function(e) {
  if (!r6) {
    var t = 0, n = document.createTextNode(""), r = { characterData: !0 };
    new MutationObserver(function() {
      return cTe();
    }).observe(n, r), r6 = function() {
      n.textContent = "".concat(t ? t-- : t++);
    };
  }
  WG.push(e), r6();
}, uTe = function(e) {
  lTe(function() {
    requestAnimationFrame(e);
  });
}, jw = 0, dTe = function() {
  return !!jw;
}, fTe = 250, hTe = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, dR = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], fR = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, i6 = !1, pTe = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var n = this;
    if (t === void 0 && (t = fTe), !i6) {
      i6 = !0;
      var r = fR(t);
      uTe(function() {
        var i = !1;
        try {
          i = aTe();
        } finally {
          if (i6 = !1, t = r - fR(), !dTe())
            return;
          i ? n.run(1e3) : t > 0 ? n.run(t) : n.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, n = function() {
      return t.observer && t.observer.observe(document.body, hTe);
    };
    document.body ? n() : Mg.addEventListener("DOMContentLoaded", n);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), dR.forEach(function(n) {
      return Mg.addEventListener(n, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), dR.forEach(function(n) {
      return Mg.removeEventListener(n, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), sT = new pTe(), hR = function(e) {
  !jw && e > 0 && sT.start(), jw += e, !jw && sT.stop();
}, mTe = function(e) {
  return !C8(e) && !nTe(e) && getComputedStyle(e).display === "inline";
}, gTe = function() {
  function e(t, n) {
    this.target = t, this.observedBox = n || Hy.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = VG(this.target, this.observedBox, !0);
    return mTe(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), yTe = /* @__PURE__ */ function() {
  function e(t, n) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = n;
  }
  return e;
}(), O1 = /* @__PURE__ */ new WeakMap(), pR = function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n].target === t)
      return n;
  return -1;
}, N1 = function() {
  function e() {
  }
  return e.connect = function(t, n) {
    var r = new yTe(t, n);
    O1.set(t, r);
  }, e.observe = function(t, n, r) {
    var i = O1.get(t), s = i.observationTargets.length === 0;
    pR(i.observationTargets, n) < 0 && (s && $d.push(i), i.observationTargets.push(new gTe(n, r && r.box)), hR(1), sT.schedule());
  }, e.unobserve = function(t, n) {
    var r = O1.get(t), i = pR(r.observationTargets, n), s = r.observationTargets.length === 1;
    i >= 0 && (s && $d.splice($d.indexOf(r), 1), r.observationTargets.splice(i, 1), hR(-1));
  }, e.disconnect = function(t) {
    var n = this, r = O1.get(t);
    r.observationTargets.slice().forEach(function(i) {
      return n.unobserve(t, i.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, e;
}(), bTe = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    N1.connect(this, t);
  }
  return e.prototype.observe = function(t, n) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!aR(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    N1.observe(this, t, n);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!aR(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    N1.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    N1.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}();
function Ur() {
  return Ur = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ur.apply(this, arguments);
}
function Dw(e, t) {
  if (e == null)
    return {};
  var n, r, i = {}, s = Object.keys(e);
  for (r = 0; r < s.length; r++)
    t.indexOf(n = s[r]) >= 0 || (i[n] = e[n]);
  return i;
}
var Fg = typeof window < "u" ? _f : We;
function P0(e, t, n) {
  return t = (t = +t) == t ? t : 0, n = (n = +n) == n ? n : 0, (e = +e) == e && (e = (e = e <= n ? e : n) >= t ? e : t), e;
}
function R1(e) {
  var t = Math.round(e);
  if (Number.isNaN(e))
    throw new TypeError("Found a NaN! Check your snapPoints / defaultSnap / snapTo ");
  return t;
}
var vTe = { box: "border-box" };
function s6(e, t) {
  var n = t.label, r = t.enabled, i = t.resizeSourceRef, s = qe(0), o = s[0], a = s[1];
  Xc(n + ": " + o);
  var c = Ie(function(l) {
    a(l[0].borderBoxSize[0].blockSize), i.current = "element";
  }, [i]);
  return Fg(function() {
    if (e.current && r) {
      var l = new bTe(c);
      return l.observe(e.current, vTe), function() {
        l.disconnect();
      };
    }
  }, [e, c, r]), r ? o : 0;
}
function Pr(e) {
  return e === void 0 && (e = 1e3), new Promise(function(t) {
    return setTimeout(t, e);
  });
}
var mR = { DRAG: { target: "#overlay.dragging", actions: "onOpenEnd" } }, gR = { RESIZE: { target: "#overlay.resizing", actions: "onOpenEnd" } }, wTe = d6e({ id: "overlay", initial: "closed", context: { initialState: "CLOSED" }, states: { closed: { on: { OPEN: "opening", CLOSE: void 0 } }, opening: { initial: "start", states: { start: { invoke: { src: "onOpenStart", onDone: "transition" } }, transition: { always: [{ target: "immediately", cond: "initiallyOpen" }, { target: "smoothly", cond: "initiallyClosed" }] }, immediately: { initial: "open", states: { open: { invoke: { src: "openImmediately", onDone: "activating" } }, activating: { invoke: { src: "activate", onDone: "#overlay.opening.end" }, on: Ur({}, mR, gR) } } }, smoothly: { initial: "visuallyHidden", states: { visuallyHidden: { invoke: { src: "renderVisuallyHidden", onDone: "activating" } }, activating: { invoke: { src: "activate", onDone: "open" } }, open: { invoke: { src: "openSmoothly", onDone: "#overlay.opening.end" }, on: Ur({}, mR, gR) } } }, end: { invoke: { src: "onOpenEnd", onDone: "done" }, on: { CLOSE: "#overlay.closing", DRAG: "#overlay.dragging" } }, done: { type: "final" } }, on: Ur({}, { CLOSE: { target: "#overlay.closing", actions: "onOpenCancel" } }), onDone: "open" }, open: { on: { DRAG: "#overlay.dragging", SNAP: "snapping", RESIZE: "resizing" } }, dragging: { on: { SNAP: "snapping" } }, snapping: { initial: "start", states: { start: { invoke: { src: "onSnapStart", onDone: "snappingSmoothly" }, entry: [f6e({ y: function(e, t) {
  return t.payload.y;
}, velocity: function(e, t) {
  return t.payload.velocity;
}, snapSource: function(e, t) {
  var n = t.payload.source;
  return n === void 0 ? "custom" : n;
} })] }, snappingSmoothly: { invoke: { src: "snapSmoothly", onDone: "end" } }, end: { invoke: { src: "onSnapEnd", onDone: "done" }, on: { RESIZE: "#overlay.resizing", SNAP: "#overlay.snapping", CLOSE: "#overlay.closing", DRAG: "#overlay.dragging" } }, done: { type: "final" } }, on: { SNAP: { target: "snapping", actions: "onSnapEnd" }, RESIZE: { target: "#overlay.resizing", actions: "onSnapCancel" }, DRAG: { target: "#overlay.dragging", actions: "onSnapCancel" }, CLOSE: { target: "#overlay.closing", actions: "onSnapCancel" } }, onDone: "open" }, resizing: { initial: "start", states: { start: { invoke: { src: "onResizeStart", onDone: "resizingSmoothly" } }, resizingSmoothly: { invoke: { src: "resizeSmoothly", onDone: "end" } }, end: { invoke: { src: "onResizeEnd", onDone: "done" }, on: { SNAP: "#overlay.snapping", CLOSE: "#overlay.closing", DRAG: "#overlay.dragging" } }, done: { type: "final" } }, on: { RESIZE: { target: "resizing", actions: "onResizeEnd" }, SNAP: { target: "snapping", actions: "onResizeCancel" }, DRAG: { target: "#overlay.dragging", actions: "onResizeCancel" }, CLOSE: { target: "#overlay.closing", actions: "onResizeCancel" } }, onDone: "open" }, closing: { initial: "start", states: { start: { invoke: { src: "onCloseStart", onDone: "deactivating" }, on: { OPEN: { target: "#overlay.open", actions: "onCloseCancel" } } }, deactivating: { invoke: { src: "deactivate", onDone: "closingSmoothly" } }, closingSmoothly: { invoke: { src: "closeSmoothly", onDone: "end" } }, end: { invoke: { src: "onCloseEnd", onDone: "done" }, on: { OPEN: { target: "#overlay.opening", actions: "onCloseCancel" } } }, done: { type: "final" } }, on: { CLOSE: void 0, OPEN: { target: "#overlay.opening", actions: "onCloseCancel" } }, onDone: "closed" } }, on: { CLOSE: "closing" } }, { actions: { onOpenCancel: function(e, t) {
}, onSnapCancel: function(e, t) {
}, onResizeCancel: function(e, t) {
}, onCloseCancel: function(e, t) {
}, onOpenEnd: function(e, t) {
}, onSnapEnd: function(e, t) {
}, onRezizeEnd: function(e, t) {
} }, services: { onSnapStart: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, onOpenStart: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, onCloseStart: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, onResizeStart: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, onSnapEnd: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, onOpenEnd: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, onCloseEnd: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, onResizeEnd: function() {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (e) {
    return Promise.reject(e);
  }
}, renderVisuallyHidden: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
}, activate: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
}, deactivate: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
}, openSmoothly: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
}, openImmediately: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
}, snapSmoothly: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
}, resizeSmoothly: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
}, closeSmoothly: function(e, t) {
  try {
    return Promise.resolve(Pr()).then(function() {
    });
  } catch (n) {
    return Promise.reject(n);
  }
} }, guards: { initiallyClosed: function(e) {
  return e.initialState === "CLOSED";
}, initiallyOpen: function(e) {
  return e.initialState === "OPEN";
} } }), xTe = ["children", "sibling", "className", "footer", "header", "open", "initialState", "lastSnapRef", "initialFocusRef", "onDismiss", "maxHeight", "defaultSnap", "snapPoints", "blocking", "scrollLocking", "style", "onSpringStart", "onSpringCancel", "onSpringEnd", "reserveScrollBarGap", "expandOnContentDrag"], ATe = ["velocity"], ETe = ["onRest", "config"], GG = aG.default, _Te = GG.tension, M1 = GG.friction, STe = k.forwardRef(function(e, t) {
  var n = e.children, r = e.sibling, i = e.className, s = e.footer, o = e.header, a = e.open, c = e.initialState, l = e.lastSnapRef, u = e.initialFocusRef, d = e.onDismiss, f = e.maxHeight, p = e.defaultSnap, m = p === void 0 ? TTe : p, h = e.snapPoints, g = h === void 0 ? kTe : h, y = e.blocking, v = y === void 0 || y, b = e.scrollLocking, w = b === void 0 || b, A = e.style, E = e.onSpringStart, x = e.onSpringCancel, S = e.onSpringEnd, P = e.reserveScrollBarGap, I = P === void 0 ? v : P, R = e.expandOnContentDrag, Q = R !== void 0 && R, J = Dw(e, xTe), we = function() {
    var H = qe(!1), ue = H[0], Ee = H[1], Xe = qe({}), Ge = Xe[0], it = Xe[1], et = Ie(function(rn) {
      return it(function(Vt) {
        var xt;
        return Ur({}, Vt, ((xt = {})[rn] = !1, xt));
      }), function() {
        it(function(Vt) {
          var xt;
          return Ur({}, Vt, ((xt = {})[rn] = !0, xt));
        });
      };
    }, []);
    return We(function() {
      var rn = Object.values(Ge);
      rn.length !== 0 && rn.every(Boolean) && Ee(!0);
    }, [Ge]), { ready: ue, registerReady: et };
  }(), V = we.ready, L = we.registerReady, U = Le(!1), q = Le(E), G = Le(x), ae = Le(S);
  We(function() {
    q.current = E, G.current = x, ae.current = S;
  }, [x, E, S]);
  var ge, Ae, he = BSe(function() {
    return { y: 0, ready: 0, maxHeight: 0, minSnap: 0, maxSnap: 0 };
  }), B = he[0], be = he[1], Be = Le(null), Ne = Le(null), _e = Le(null), Ce = Le(null), N = Le(null), F = Le(null), z = Le(0), ne = Le(), ee = Le(!1), Y = (ge = ot(function() {
    return typeof window < "u" ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  }, []), Ae = Le(ge == null ? void 0 : ge.matches), Xc(Ae.current ? "reduce" : "no-preference"), We(function() {
    var H = function(ue) {
      Ae.current = ue.matches;
    };
    return ge == null || ge.addListener(H), function() {
      return ge == null ? void 0 : ge.removeListener(H);
    };
  }, [ge]), Ae), X = function(H) {
    var ue = H.targetRef, Ee = H.enabled, Xe = H.reserveScrollBarGap, Ge = Le({ activate: function() {
      throw new TypeError("Tried to activate scroll lock too early");
    }, deactivate: function() {
    } });
    return Xc(Ee ? "Enabled" : "Disabled"), We(function() {
      if (!Ee)
        return Ge.current.deactivate(), void (Ge.current = { activate: function() {
        }, deactivate: function() {
        } });
      var it = ue.current, et = !1;
      Ge.current = { activate: function() {
        et || (et = !0, YCe(it, { allowTouchMove: function(rn) {
          return rn.closest("[data-body-scroll-lock-ignore]");
        }, reserveScrollBarGap: Xe }));
      }, deactivate: function() {
        et && (et = !1, ZCe(it));
      } };
    }, [Ee, ue, Xe]), Ge;
  }({ targetRef: Ne, enabled: V && w, reserveScrollBarGap: I }), $ = function(H) {
    var ue = H.targetRef, Ee = H.enabled, Xe = Le({ activate: function() {
      throw new TypeError("Tried to activate aria hider too early");
    }, deactivate: function() {
    } });
    return Xc(Ee ? "Enabled" : "Disabled"), We(function() {
      if (!Ee)
        return Xe.current.deactivate(), void (Xe.current = { activate: function() {
        }, deactivate: function() {
        } });
      var Ge = ue.current, it = !1, et = [], rn = [];
      Xe.current = { activate: function() {
        if (!it) {
          it = !0;
          var Vt = Ge.parentNode;
          document.querySelectorAll("body > *").forEach(function(xt) {
            if (xt !== Vt) {
              var Bt = xt.getAttribute("aria-hidden");
              Bt !== null && Bt !== "false" || (et.push(Bt), rn.push(xt), xt.setAttribute("aria-hidden", "true"));
            }
          });
        }
      }, deactivate: function() {
        it && (it = !1, rn.forEach(function(Vt, xt) {
          var Bt = et[xt];
          Bt === null ? Vt.removeAttribute("aria-hidden") : Vt.setAttribute("aria-hidden", Bt);
        }), et = [], rn = []);
      } };
    }, [ue, Ee]), Xe;
  }({ targetRef: Be, enabled: V && v }), ie = function(H) {
    var ue = H.targetRef, Ee = H.fallbackRef, Xe = H.initialFocusRef, Ge = H.enabled, it = Le({ activate: function() {
      throw new TypeError("Tried to activate focus trap too early");
    }, deactivate: function() {
    } });
    return Xc(Ge ? "Enabled" : "Disabled"), We(function() {
      if (!Ge)
        return it.current.deactivate(), void (it.current = { activate: function() {
        }, deactivate: function() {
        } });
      var et = Ee.current, rn = WCe(ue.current, { onActivate: void 0, initialFocus: Xe ? function() {
        return (Xe == null ? void 0 : Xe.current) || et;
      } : void 0, fallbackFocus: et, escapeDeactivates: !1, clickOutsideDeactivates: !1 }), Vt = !1;
      it.current = { activate: function() {
        try {
          return Vt ? Promise.resolve() : (Vt = !0, Promise.resolve(rn.activate()).then(function() {
            return Promise.resolve(new Promise(function(xt) {
              return setTimeout(function() {
                return xt(void 0);
              }, 0);
            })).then(function() {
            });
          }));
        } catch (xt) {
          return Promise.reject(xt);
        }
      }, deactivate: function() {
        Vt && (Vt = !1, rn.deactivate());
      } };
    }, [Ge, Ee, Xe, ue]), it;
  }({ targetRef: Be, fallbackRef: F, initialFocusRef: u || void 0, enabled: V && v && u !== !1 }), fe = function(H) {
    var ue = H.getSnapPoints, Ee = H.heightRef, Xe = H.lastSnapRef, Ge = H.ready, it = function(an) {
      var Gt = an.contentRef, rs = an.controlledMaxHeight, ar = an.footerEnabled, _o = an.footerRef, So = an.headerEnabled, Gn = an.headerRef, ka = an.registerReady, Nc = an.resizeSourceRef, yn = ot(function() {
        return ka("contentHeight");
      }, [ka]), Nf = function(Ba, Ff, Dt) {
        var Co = ot(function() {
          return Ff("maxHeight");
        }, [Ff]), jf = qe(function() {
          return R1(Ba) || typeof window < "u" ? window.innerHeight : 0;
        }), te = jf[0], bt = jf[1], It = te > 0, mt = Le(0);
        return Xc(Ba ? "controlled" : "auto"), We(function() {
          It && Co();
        }, [It, Co]), Fg(function() {
          if (Ba)
            return bt(R1(Ba)), void (Dt.current = "maxheightprop");
          var To = function() {
            mt.current || (mt.current = requestAnimationFrame(function() {
              bt(window.innerHeight), Dt.current = "window", mt.current = 0;
            }));
          };
          return window.addEventListener("resize", To), bt(window.innerHeight), Dt.current = "window", Co(), function() {
            window.removeEventListener("resize", To), cancelAnimationFrame(mt.current);
          };
        }, [Ba, Co, Dt]), te;
      }(rs, ka, Nc), _u = s6(Gn, { label: "headerHeight", enabled: So, resizeSourceRef: Nc }), js = s6(Gt, { label: "contentHeight", enabled: !0, resizeSourceRef: Nc }), Su = s6(_o, { label: "footerHeight", enabled: ar, resizeSourceRef: Nc }), Rf = Math.min(Nf - _u - Su, js) + _u + Su;
      Xc("minHeight: " + Rf);
      var Mf = js > 0;
      return We(function() {
        Mf && yn();
      }, [Mf, yn]), { maxHeight: Nf, minHeight: Rf, headerHeight: _u, footerHeight: Su };
    }({ contentRef: H.contentRef, controlledMaxHeight: H.controlledMaxHeight, footerEnabled: H.footerEnabled, footerRef: H.footerRef, headerEnabled: H.headerEnabled, headerRef: H.headerRef, registerReady: H.registerReady, resizeSourceRef: H.resizeSourceRef }), et = it.maxHeight, rn = it.minHeight, Vt = it.headerHeight, xt = it.footerHeight, Bt = function(an, Gt) {
      var rs = [].concat(an).map(R1).reduce(function(Gn, ka) {
        return Gn.add(P0(ka, 0, Gt)), Gn;
      }, /* @__PURE__ */ new Set()), ar = Array.from(rs), _o = Math.min.apply(Math, ar);
      if (Number.isNaN(_o))
        throw new TypeError("minSnap is NaN");
      var So = Math.max.apply(Math, ar);
      if (Number.isNaN(So))
        throw new TypeError("maxSnap is NaN");
      return { snapPoints: ar, minSnap: _o, maxSnap: So };
    }(Ge ? ue({ height: Ee.current, footerHeight: xt, headerHeight: Vt, minHeight: rn, maxHeight: et }) : [0], et), Kr = Bt.snapPoints, Ta = Bt.minSnap, yi = Bt.maxSnap;
    return Xc("minSnap: " + Ta + ", maxSnap:" + yi), { minSnap: Ta, maxSnap: yi, findSnap: function(an) {
      var Gt = R1(typeof an == "function" ? an({ footerHeight: xt, headerHeight: Vt, height: Ee.current, minHeight: rn, maxHeight: et, snapPoints: Kr, lastSnap: Xe.current }) : an);
      return Kr.reduce(function(rs, ar) {
        return Math.abs(ar - Gt) < Math.abs(rs - Gt) ? ar : rs;
      }, Ta);
    }, maxHeight: et };
  }({ contentRef: _e, controlledMaxHeight: f, footerEnabled: !!s, footerRef: N, getSnapPoints: g, headerEnabled: o !== !1, headerRef: Ce, heightRef: z, lastSnapRef: l, ready: V, registerReady: L, resizeSourceRef: ne }), oe = fe.minSnap, me = fe.maxSnap, Me = fe.maxHeight, je = fe.findSnap, Ye = Le(Me), Oe = Le(oe), De = Le(me), Te = Le(je), Fe = Le(0);
  Fg(function() {
    Ye.current = Me, De.current = me, Oe.current = oe, Te.current = je, Fe.current = je(m);
  }, [je, m, Me, me, oe]);
  var lt = Ie(function(H) {
    var ue = H.onRest, Ee = H.config, Xe = (Ee = Ee === void 0 ? {} : Ee).velocity, Ge = Xe === void 0 ? 1 : Xe, it = Dw(Ee, ATe), et = Dw(H, ETe);
    return new Promise(function(rn) {
      return be(Ur({}, et, { config: Ur({ velocity: Ge }, it, { mass: 1, tension: _Te, friction: Math.max(M1, M1 + (M1 - M1 * Ge)) }), onRest: function() {
        var Vt = [].slice.call(arguments);
        rn.apply(void 0, Vt), ue == null || ue.apply(void 0, Vt);
      } }));
    });
  }, [be]), O = x6e(wTe, { devTools: !1, actions: { onOpenCancel: Ie(function() {
    return G.current == null ? void 0 : G.current({ type: "OPEN" });
  }, []), onSnapCancel: Ie(function(H) {
    return G.current == null ? void 0 : G.current({ type: "SNAP", source: H.snapSource });
  }, []), onCloseCancel: Ie(function() {
    return G.current == null ? void 0 : G.current({ type: "CLOSE" });
  }, []), onResizeCancel: Ie(function() {
    return G.current == null ? void 0 : G.current({ type: "RESIZE", source: ne.current });
  }, []), onOpenEnd: Ie(function() {
    return ae.current == null ? void 0 : ae.current({ type: "OPEN" });
  }, []), onSnapEnd: Ie(function(H, ue) {
    return ae.current == null ? void 0 : ae.current({ type: "SNAP", source: H.snapSource });
  }, []), onResizeEnd: Ie(function() {
    return ae.current == null ? void 0 : ae.current({ type: "RESIZE", source: ne.current });
  }, []) }, context: { initialState: c }, services: { onSnapStart: Ie(function(H, ue) {
    try {
      return Promise.resolve(q.current == null ? void 0 : q.current({ type: "SNAP", source: ue.payload.source || "custom" }));
    } catch (Ee) {
      return Promise.reject(Ee);
    }
  }, []), onOpenStart: Ie(function() {
    try {
      return Promise.resolve(q.current == null ? void 0 : q.current({ type: "OPEN" }));
    } catch (H) {
      return Promise.reject(H);
    }
  }, []), onCloseStart: Ie(function() {
    try {
      return Promise.resolve(q.current == null ? void 0 : q.current({ type: "CLOSE" }));
    } catch (H) {
      return Promise.reject(H);
    }
  }, []), onResizeStart: Ie(function() {
    try {
      return Promise.resolve(q.current == null ? void 0 : q.current({ type: "RESIZE", source: ne.current }));
    } catch (H) {
      return Promise.reject(H);
    }
  }, []), onSnapEnd: Ie(function(H, ue) {
    try {
      return Promise.resolve(ae.current == null ? void 0 : ae.current({ type: "SNAP", source: H.snapSource }));
    } catch (Ee) {
      return Promise.reject(Ee);
    }
  }, []), onOpenEnd: Ie(function() {
    try {
      return Promise.resolve(ae.current == null ? void 0 : ae.current({ type: "OPEN" }));
    } catch (H) {
      return Promise.reject(H);
    }
  }, []), onCloseEnd: Ie(function() {
    try {
      return Promise.resolve(ae.current == null ? void 0 : ae.current({ type: "CLOSE" }));
    } catch (H) {
      return Promise.reject(H);
    }
  }, []), onResizeEnd: Ie(function() {
    try {
      return Promise.resolve(ae.current == null ? void 0 : ae.current({ type: "RESIZE", source: ne.current }));
    } catch (H) {
      return Promise.reject(H);
    }
  }, []), renderVisuallyHidden: Ie(function(H, ue) {
    try {
      return Promise.resolve(lt({ y: Fe.current, ready: 0, maxHeight: Ye.current, maxSnap: De.current, minSnap: Fe.current, immediate: !0 })).then(function() {
      });
    } catch (Ee) {
      return Promise.reject(Ee);
    }
  }, [lt]), activate: Ie(function(H, ue) {
    try {
      return U.current = !0, Promise.resolve(Promise.all([X.current.activate(), ie.current.activate(), $.current.activate()])).then(function() {
      });
    } catch (Ee) {
      return Promise.reject(Ee);
    }
  }, [$, ie, X]), deactivate: Ie(function() {
    try {
      return X.current.deactivate(), ie.current.deactivate(), $.current.deactivate(), U.current = !1, Promise.resolve();
    } catch (H) {
      return Promise.reject(H);
    }
  }, [$, ie, X]), openImmediately: Ie(function() {
    try {
      return z.current = Fe.current, Promise.resolve(lt({ y: Fe.current, ready: 1, maxHeight: Ye.current, maxSnap: De.current, minSnap: Fe.current, immediate: !0 })).then(function() {
      });
    } catch (H) {
      return Promise.reject(H);
    }
  }, [lt]), openSmoothly: Ie(function() {
    try {
      return Promise.resolve(lt({ y: 0, ready: 1, maxHeight: Ye.current, maxSnap: De.current, minSnap: Fe.current, immediate: !0 })).then(function() {
        return z.current = Fe.current, Promise.resolve(lt({ y: Fe.current, ready: 1, maxHeight: Ye.current, maxSnap: De.current, minSnap: Fe.current, immediate: Y.current })).then(function() {
        });
      });
    } catch (H) {
      return Promise.reject(H);
    }
  }, [lt, Y]), snapSmoothly: Ie(function(H, ue) {
    try {
      var Ee = Te.current(H.y);
      return z.current = Ee, l.current = Ee, Promise.resolve(lt({ y: Ee, ready: 1, maxHeight: Ye.current, maxSnap: De.current, minSnap: Oe.current, immediate: Y.current, config: { velocity: H.velocity } })).then(function() {
      });
    } catch (Xe) {
      return Promise.reject(Xe);
    }
  }, [lt, l, Y]), resizeSmoothly: Ie(function() {
    try {
      var H = Te.current(z.current);
      return z.current = H, l.current = H, Promise.resolve(lt({ y: H, ready: 1, maxHeight: Ye.current, maxSnap: De.current, minSnap: Oe.current, immediate: ne.current !== "element" || Y.current })).then(function() {
      });
    } catch (ue) {
      return Promise.reject(ue);
    }
  }, [lt, l, Y]), closeSmoothly: Ie(function(H, ue) {
    try {
      return lt({ minSnap: z.current, immediate: !0 }), z.current = 0, Promise.resolve(lt({ y: 0, maxHeight: Ye.current, maxSnap: De.current, immediate: Y.current })).then(function() {
        return Promise.resolve(lt({ ready: 0, immediate: !0 })).then(function() {
        });
      });
    } catch (Ee) {
      return Promise.reject(Ee);
    }
  }, [lt, Y]) } }), _ = O[0], T = O[1];
  We(function() {
    V && T(a ? "OPEN" : "CLOSE");
  }, [a, T, V]), Fg(function() {
    (Me || me || oe) && T("RESIZE");
  }, [Me, me, oe, T]), We(function() {
    return function() {
      X.current.deactivate(), ie.current.deactivate(), $.current.deactivate();
    };
  }, [$, ie, X]), pZ(t, function() {
    return { snapTo: function(H, ue) {
      var Ee = ue === void 0 ? {} : ue, Xe = Ee.velocity, Ge = Xe === void 0 ? 1 : Xe, it = Ee.source, et = it === void 0 ? "custom" : it;
      T("SNAP", { payload: { y: Te.current(H), velocity: Ge, source: et } });
    }, get height() {
      return z.current;
    } };
  }, [T]), We(function() {
    var H = Ne.current, ue = function(Xe) {
      ee.current && Xe.preventDefault();
    }, Ee = function(Xe) {
      H.scrollTop < 0 && (requestAnimationFrame(function() {
        H.style.overflow = "hidden", H.scrollTop = 0, H.style.removeProperty("overflow");
      }), Xe.preventDefault());
    };
    return Q && (H.addEventListener("scroll", ue), H.addEventListener("touchmove", ue), H.addEventListener("touchstart", Ee)), function() {
      H.removeEventListener("scroll", ue), H.removeEventListener("touchmove", ue), H.removeEventListener("touchstart", Ee);
    };
  }, [Q, Ne]);
  var M = SCe(function(H) {
    var ue = H.args, Ee = (ue = ue === void 0 ? [] : ue)[0], Xe = (Ee = Ee === void 0 ? {} : Ee).closeOnTap, Ge = Xe !== void 0 && Xe, it = Ee.isContentDragging, et = it !== void 0 && it, rn = H.cancel, Vt = H.direction[1], xt = H.down, Bt = H.first, Kr = H.last, Ta = H.memo, yi = Ta === void 0 ? B.y.get() : Ta, an = H.tap, Gt = H.velocity, rs = -1 * H.movement[1];
    if (!U.current)
      return rn(), yi;
    if (d && Ge && an)
      return rn(), setTimeout(function() {
        return d();
      }, 0), yi;
    if (an)
      return yi;
    var ar = yi + rs, _o = rs * Gt, So = Math.max(Oe.current, Math.min(De.current, ar + 2 * _o));
    if (!xt && d && Vt > 0 && ar + _o < Oe.current / 2)
      return rn(), d(), yi;
    var Gn = xt ? d || Oe.current !== De.current ? Og(ar, d ? 0 : Oe.current, De.current, 0.55) : ar < Oe.current ? Og(ar, Oe.current, 2 * De.current, 0.55) : Og(ar, Oe.current / 2, De.current, 0.55) : So;
    return Q && et ? (Gn >= De.current && (Gn = De.current), yi === De.current && Ne.current.scrollTop > 0 && (Gn = De.current), ee.current = Gn < De.current) : ee.current = !1, Bt && T("DRAG"), Kr ? (T("SNAP", { payload: { y: Gn, velocity: Gt > 0.05 ? Gt : 1, source: "dragging" } }), yi) : (be({ y: Gn, ready: 1, maxHeight: Ye.current, maxSnap: De.current, minSnap: Oe.current, immediate: !0, config: { velocity: Gt } }), yi);
  }, { filterTaps: !0 });
  if (Number.isNaN(De.current))
    throw new TypeError("maxSnapRef is NaN!!");
  if (Number.isNaN(Oe.current))
    throw new TypeError("minSnapRef is NaN!!");
  var se = function(H) {
    var ue, Ee = H.spring, Xe = Jf([Ee.y, Ee.maxHeight], function(xt, Bt) {
      return Math.round(P0(Bt - xt, 0, 16)) + "px";
    }), Ge = Jf([Ee.y, Ee.minSnap, Ee.maxSnap], function(xt, Bt, Kr) {
      return P0(xt, Bt, Kr) + "px";
    }), it = Jf([Ee.y, Ee.minSnap, Ee.maxSnap], function(xt, Bt, Kr) {
      return xt < Bt ? Bt - xt + "px" : xt > Kr ? Kr - xt + "px" : "0px";
    }), et = Jf([Ee.y, Ee.maxSnap], function(xt, Bt) {
      return xt >= Bt ? Math.ceil(xt - Bt) : 0;
    }), rn = Jf([Ee.y, Ee.minSnap], function(xt, Bt) {
      if (!Bt)
        return 0;
      var Kr = Math.max(Bt / 2 - 45, 0);
      return P0((xt - Kr) * (1 / (Math.min(Bt / 2 + 45, Bt) - Kr) + 0), 0, 1);
    }), Vt = Jf([Ee.y, Ee.minSnap], function(xt, Bt) {
      return Bt ? P0(xt / Bt, 0, 1) : 0;
    });
    return (ue = {})["--rsbs-content-opacity"] = rn, ue["--rsbs-backdrop-opacity"] = Vt, ue["--rsbs-antigap-scale-y"] = et, ue["--rsbs-overlay-translate-y"] = it, ue["--rsbs-overlay-rounded"] = Xe, ue["--rsbs-overlay-h"] = Ge, ue;
  }({ spring: B });
  return k.createElement(VSe.div, Ur({}, J, { "data-rsbs-root": !0, "data-rsbs-state": CTe.find(_.matches), "data-rsbs-is-blocking": v, "data-rsbs-is-dismissable": !!d, "data-rsbs-has-header": !!o, "data-rsbs-has-footer": !!s, className: i, ref: Be, style: Ur({}, se, A, { opacity: B.ready }) }), r, v && /* @__PURE__ */ k.createElement("div", Ur({ key: "backdrop", "data-rsbs-backdrop": !0 }, M({ closeOnTap: !0 }))), /* @__PURE__ */ k.createElement("div", { key: "overlay", "aria-modal": "true", role: "dialog", "data-rsbs-overlay": !0, tabIndex: -1, ref: F, onKeyDown: function(H) {
    H.key === "Escape" && (H.stopPropagation(), d && d());
  } }, o !== !1 && /* @__PURE__ */ k.createElement("div", Ur({ key: "header", "data-rsbs-header": !0, ref: Ce }, M()), o), /* @__PURE__ */ k.createElement("div", Ur({ key: "scroll", "data-rsbs-scroll": !0, ref: Ne }, Q ? M({ isContentDragging: !0 }) : {}), /* @__PURE__ */ k.createElement("div", { "data-rsbs-content": !0, ref: _e }, n)), s && /* @__PURE__ */ k.createElement("div", Ur({ key: "footer", ref: N, "data-rsbs-footer": !0 }, M()), s)));
}), CTe = ["closed", "opening", "open", "closing", "dragging", "snapping", "resizing"];
function TTe(e) {
  var t = e.lastSnap;
  return t ?? Math.min.apply(Math, e.snapPoints);
}
function kTe(e) {
  return e.minHeight;
}
var BTe = ["onSpringStart", "onSpringEnd", "skipInitialTransition"], ITe = Bc(function(e, t) {
  var n = e.onSpringStart, r = e.onSpringEnd, i = e.skipInitialTransition, s = Dw(e, BTe), o = qe(!1), a = o[0], c = o[1], l = Le(), u = Le(null), d = Le(i && s.open ? "OPEN" : "CLOSED");
  Fg(function() {
    if (s.open)
      return cancelAnimationFrame(l.current), c(!0), function() {
        d.current = "CLOSED";
      };
  }, [s.open]);
  var f = Ie(function(m) {
    return Promise.resolve(n == null ? void 0 : n(m)).then(function() {
      m.type === "OPEN" && cancelAnimationFrame(l.current);
    });
  }, [n]), p = Ie(function(m) {
    return Promise.resolve(r == null ? void 0 : r(m)).then(function() {
      m.type === "CLOSE" && (l.current = requestAnimationFrame(function() {
        return c(!1);
      }));
    });
  }, [r]);
  return a ? /* @__PURE__ */ k.createElement(g_e, { "data-rsbs-portal": !0 }, /* @__PURE__ */ k.createElement(STe, Ur({}, s, { lastSnapRef: u, ref: t, initialState: d.current, onSpringStart: f, onSpringEnd: p }))) : null;
});
function PTe(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z" }, child: [] }] })(e);
}
function OTe(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M456.69 421.39 362.6 327.3a173.81 173.81 0 0 0 34.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 0 0 327.3 362.6l94.09 94.09a25 25 0 0 0 35.3-35.3zM97.92 222.72a124.8 124.8 0 1 1 124.8 124.8 124.95 124.95 0 0 1-124.8-124.8z" }, child: [] }] })(e);
}
const yR = ({
  title: e,
  onClose: t,
  disableClose: n = !1,
  iconPrefix: r = [],
  onIconPrefixClick: i = [],
  iconSuffix: s = [],
  onIconSuffixClick: o = [],
  showCloseIcon: a = !0
}) => e ? /* @__PURE__ */ D.jsxs(kn, { justifyContent: "space-between", children: [
  r.length > 0 && /* @__PURE__ */ D.jsxs(kn, { p: 2, gap: "16px", children: [
    r.map((c, l) => /* @__PURE__ */ D.jsx(
      Pi,
      {
        color: "misc.icon.main",
        height: "24px",
        width: "24px",
        onClick: i[l],
        cursor: "pointer",
        size: "48px",
        as: c,
        _hover: {
          color: "misc.icon.hover"
        }
      },
      l
    )),
    !a && /* @__PURE__ */ D.jsx(pi, { color: "brand.100", fontWeight: 600, fontSize: "20px", children: e })
  ] }),
  a && /* @__PURE__ */ D.jsx(pi, { color: "brand.100", fontWeight: 600, fontSize: "20px", children: e }),
  /* @__PURE__ */ D.jsx(kn, { gap: "16px", children: /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    s.length > 0 && /* @__PURE__ */ D.jsx(kn, { gap: "16px", children: s.map((c, l) => /* @__PURE__ */ D.jsx(
      Pi,
      {
        color: "misc.icon.main",
        height: "24px",
        width: "24px",
        onClick: o[l],
        cursor: "pointer",
        size: "48px",
        as: c,
        _hover: {
          color: "misc.icon.hover"
        }
      },
      l
    )) }),
    s.length > 0 && /* @__PURE__ */ D.jsx(
      ks,
      {
        height: "24px",
        borderLeft: "1.5px solid",
        borderColor: "misc.icon.hover"
      }
    ),
    a && /* @__PURE__ */ D.jsx(
      Pi,
      {
        color: "misc.icon.main",
        h: "28px",
        w: "28px",
        onClick: n ? void 0 : t,
        cursor: n ? "default" : "pointer",
        size: "48px",
        as: PTe,
        _hover: {
          color: "misc.icon.hover"
        }
      }
    )
  ] }) })
] }) : null, kE = ({
  isOpen: e,
  onClose: t,
  children: n,
  modalContentProps: r,
  modalHeaderProps: {
    title: i,
    disableClose: s = !1,
    iconPrefix: o = [],
    onIconPrefixClick: a = [],
    iconSuffix: c = [],
    onIconSuffixClick: l = [],
    showCloseIcon: u
  } = {},
  ...d
}) => IAe({ base: "base", md: "md", lg: "lg" }) === "base" ? /* @__PURE__ */ D.jsx(
  ITe,
  {
    open: e,
    onDismiss: t,
    style: { background: "none" },
    children: /* @__PURE__ */ D.jsxs(ks, { bg: "bg.300", p: 6, children: [
      i && /* @__PURE__ */ D.jsx(
        yR,
        {
          title: i,
          onClose: t,
          disableClose: s,
          iconPrefix: o,
          onIconPrefixClick: a,
          iconSuffix: c,
          onIconSuffixClick: l,
          showCloseIcon: u
        }
      ),
      n
    ] })
  }
) : /* @__PURE__ */ D.jsxs(YH, { size: "sm", isOpen: e, onClose: t, isCentered: !0, ...d, children: [
  /* @__PURE__ */ D.jsx(rW, { bg: "" }),
  /* @__PURE__ */ D.jsxs(
    nW,
    {
      boxShadow: "0 20px 40px 0 rgba(0, 0, 0, 0.24)",
      p: 4,
      bg: "bg.main",
      backdropFilter: "blur(40px)",
      borderRadius: "8px",
      ...r,
      children: [
        i && /* @__PURE__ */ D.jsx(
          yR,
          {
            onClose: t,
            title: i,
            disableClose: s,
            iconPrefix: o,
            onIconPrefixClick: a,
            iconSuffix: c,
            onIconSuffixClick: l,
            showCloseIcon: u
          }
        ),
        /* @__PURE__ */ D.jsx(iW, { p: 0, children: n })
      ]
    }
  )
] }), NTe = ({ ...e }) => {
  const t = [2, 2, 4];
  return /* @__PURE__ */ D.jsxs(
    PH,
    {
      borderColor: "secondary.alpha60",
      _placeholder: {
        color: "secondary.alpha4",
        fontWeight: "600"
      },
      _hover: {
        borderWidth: 0
      },
      _focus: {
        boxShadow: "none",
        borderWidth: 0,
        borderColor: "secondary.alpha4"
      },
      _active: { borderColor: "secondary.alpha4" },
      children: [
        /* @__PURE__ */ D.jsx(q4, { pointerEvents: "none", py: t, children: /* @__PURE__ */ D.jsx(Pi, { h: "16px", w: "16px", color: "misc.icon.main", as: OTe }) }),
        /* @__PURE__ */ D.jsx(pE, { py: t, fontSize: "16px", ...e })
      ]
    }
  );
}, RTe = yt(XV, {
  baseStyle: {
    width: "100%",
    borderRadius: "12px",
    bg: "bg.module",
    padding: 2,
    marginY: 4
  }
});
function MTe(e) {
  return wu({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M427 234.625H167.296l119.702-119.702L256 85 85 256l171 171 29.922-29.924-118.626-119.701H427v-42.75z" }, child: [] }] })(e);
}
var oT;
(function(e) {
  e[e.SysFatal = 1] = "SysFatal", e[e.SysTransient = 2] = "SysTransient", e[e.DestinationInvalid = 3] = "DestinationInvalid", e[e.CanisterReject = 4] = "CanisterReject", e[e.CanisterError = 5] = "CanisterError";
})(oT || (oT = {}));
const g2 = "abcdefghijklmnopqrstuvwxyz234567", Nm = /* @__PURE__ */ Object.create(null);
for (let e = 0; e < g2.length; e++)
  Nm[g2[e]] = e;
Nm[0] = Nm.o;
Nm[1] = Nm.i;
function FTe(e) {
  let t = 0, n = 0, r = "";
  function i(s) {
    return t < 0 ? n |= s >> -t : n = s << t & 248, t > 3 ? (t -= 8, 1) : (t < 4 && (r += g2[n >> 3], t += 5), 0);
  }
  for (let s = 0; s < e.length; )
    s += i(e[s]);
  return r + (t < 0 ? g2[n >> 3] : "");
}
function jTe(e) {
  let t = 0, n = 0;
  const r = new Uint8Array(e.length * 4 / 3 | 0);
  let i = 0;
  function s(o) {
    let a = Nm[o.toLowerCase()];
    if (a === void 0)
      throw new Error(`Invalid character: ${JSON.stringify(o)}`);
    a <<= 3, n |= a >>> t, t += 5, t >= 8 && (r[i++] = n, t -= 8, t > 0 ? n = a << 5 - t & 255 : n = 0);
  }
  for (const o of e)
    s(o);
  return r.slice(0, i);
}
const DTe = new Uint32Array([
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
]);
function UTe(e) {
  const t = new Uint8Array(e);
  let n = -1;
  for (let r = 0; r < t.length; r++) {
    const s = (t[r] ^ n) & 255;
    n = DTe[s] ^ n >>> 8;
  }
  return (n ^ -1) >>> 0;
}
function LTe(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function T8(e, ...t) {
  if (!LTe(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function bR(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function zTe(e, t) {
  T8(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const o6 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const a6 = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Po = (e, t) => e << 32 - t | e >>> t;
new Uint8Array(new Uint32Array([287454020]).buffer)[0];
function qG(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function $G(e) {
  return typeof e == "string" && (e = qG(e)), T8(e), e;
}
function VTe(...e) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    T8(i), t += i.length;
  }
  const n = new Uint8Array(t);
  for (let r = 0, i = 0; r < e.length; r++) {
    const s = e[r];
    n.set(s, i), i += s.length;
  }
  return n;
}
let HTe = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function k8(e) {
  const t = (r) => e().update($G(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
function QG(e = 32) {
  if (o6 && typeof o6.getRandomValues == "function")
    return o6.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
function WTe(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), s = BigInt(4294967295), o = Number(n >> i & s), a = Number(n & s), c = r ? 4 : 0, l = r ? 0 : 4;
  e.setUint32(t + c, o, r), e.setUint32(t + l, a, r);
}
const GTe = (e, t, n) => e & t ^ ~e & n, qTe = (e, t, n) => e & t ^ e & n ^ t & n;
class KG extends HTe {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = a6(this.buffer);
  }
  update(t) {
    bR(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = $G(t);
    const s = t.length;
    for (let o = 0; o < s; ) {
      const a = Math.min(i - this.pos, s - o);
      if (a === i) {
        const c = a6(t);
        for (; i <= s - o; o += i)
          this.process(c, o);
        continue;
      }
      r.set(t.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    bR(this), zTe(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: s } = this;
    let { pos: o } = this;
    n[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > i - o && (this.process(r, 0), o = 0);
    for (let d = o; d < i; d++)
      n[d] = 0;
    WTe(r, i - 8, BigInt(this.length * 8), s), this.process(r, 0);
    const a = a6(t), c = this.outputLen;
    if (c % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let d = 0; d < l; d++)
      a.setUint32(4 * d, u[d], s);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: s, destroyed: o, pos: a } = this;
    return t.length = i, t.pos = a, t.finished = s, t.destroyed = o, i % n && t.buffer.set(r), t;
  }
}
const $Te = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Vc = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Hc = /* @__PURE__ */ new Uint32Array(64);
let YG = class extends KG {
  constructor() {
    super(64, 32, 8, !1), this.A = Vc[0] | 0, this.B = Vc[1] | 0, this.C = Vc[2] | 0, this.D = Vc[3] | 0, this.E = Vc[4] | 0, this.F = Vc[5] | 0, this.G = Vc[6] | 0, this.H = Vc[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: s, F: o, G: a, H: c } = this;
    return [t, n, r, i, s, o, a, c];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, a, c) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = s | 0, this.F = o | 0, this.G = a | 0, this.H = c | 0;
  }
  process(t, n) {
    for (let d = 0; d < 16; d++, n += 4)
      Hc[d] = t.getUint32(n, !1);
    for (let d = 16; d < 64; d++) {
      const f = Hc[d - 15], p = Hc[d - 2], m = Po(f, 7) ^ Po(f, 18) ^ f >>> 3, h = Po(p, 17) ^ Po(p, 19) ^ p >>> 10;
      Hc[d] = h + Hc[d - 7] + m + Hc[d - 16] | 0;
    }
    let { A: r, B: i, C: s, D: o, E: a, F: c, G: l, H: u } = this;
    for (let d = 0; d < 64; d++) {
      const f = Po(a, 6) ^ Po(a, 11) ^ Po(a, 25), p = u + f + GTe(a, c, l) + $Te[d] + Hc[d] | 0, h = (Po(r, 2) ^ Po(r, 13) ^ Po(r, 22)) + qTe(r, i, s) | 0;
      u = l, l = c, c = a, a = o + p | 0, o = s, s = i, i = r, r = p + h | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, s = s + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(r, i, s, o, a, c, l, u);
  }
  roundClean() {
    Hc.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
class QTe extends YG {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
const B8 = /* @__PURE__ */ k8(() => new YG()), KTe = /* @__PURE__ */ k8(() => new QTe());
function YTe(e) {
  return KTe.create().update(new Uint8Array(e)).digest();
}
const F1 = "__principal__", ZTe = 2, vR = 4, JTe = "aaaaa-aa", XTe = (e) => {
  var t;
  return new Uint8Array(((t = e.match(/.{1,2}/g)) !== null && t !== void 0 ? t : []).map((n) => parseInt(n, 16)));
}, eke = (e) => e.reduce((t, n) => t + n.toString(16).padStart(2, "0"), "");
let gt = class Uw {
  constructor(t) {
    this._arr = t, this._isPrincipal = !0;
  }
  static anonymous() {
    return new this(new Uint8Array([vR]));
  }
  /**
   * Utility method, returning the principal representing the management canister, decoded from the hex string `'aaaaa-aa'`
   * @returns {Principal} principal of the management canister
   */
  static managementCanister() {
    return this.fromHex(JTe);
  }
  static selfAuthenticating(t) {
    const n = YTe(t);
    return new this(new Uint8Array([...n, ZTe]));
  }
  static from(t) {
    if (typeof t == "string")
      return Uw.fromText(t);
    if (Object.getPrototypeOf(t) === Uint8Array.prototype)
      return new Uw(t);
    if (typeof t == "object" && t !== null && t._isPrincipal === !0)
      return new Uw(t._arr);
    throw new Error(`Impossible to convert ${JSON.stringify(t)} to Principal.`);
  }
  static fromHex(t) {
    return new this(XTe(t));
  }
  static fromText(t) {
    let n = t;
    if (t.includes(F1)) {
      const o = JSON.parse(t);
      F1 in o && (n = o[F1]);
    }
    const r = n.toLowerCase().replace(/-/g, "");
    let i = jTe(r);
    i = i.slice(4, i.length);
    const s = new this(i);
    if (s.toText() !== n)
      throw new Error(`Principal "${s.toText()}" does not have a valid checksum (original value "${n}" may not be a valid Principal ID).`);
    return s;
  }
  static fromUint8Array(t) {
    return new this(t);
  }
  isAnonymous() {
    return this._arr.byteLength === 1 && this._arr[0] === vR;
  }
  toUint8Array() {
    return this._arr;
  }
  toHex() {
    return eke(this._arr).toUpperCase();
  }
  toText() {
    const t = new ArrayBuffer(4);
    new DataView(t).setUint32(0, UTe(this._arr));
    const r = new Uint8Array(t), i = Uint8Array.from(this._arr), s = new Uint8Array([...r, ...i]), a = FTe(s).match(/.{1,5}/g);
    if (!a)
      throw new Error();
    return a.join("-");
  }
  toString() {
    return this.toText();
  }
  /**
   * Serializes to JSON
   * @returns {JsonnablePrincipal} a JSON object with a single key, {@link JSON_KEY_PRINCIPAL}, whose value is the principal as a string
   */
  toJSON() {
    return { [F1]: this.toText() };
  }
  /**
   * Utility method taking a Principal to compare against. Used for determining canister ranges in certificate verification
   * @param {Principal} other - a {@link Principal} to compare
   * @returns {'lt' | 'eq' | 'gt'} `'lt' | 'eq' | 'gt'` a string, representing less than, equal to, or greater than
   */
  compareTo(t) {
    for (let n = 0; n < Math.min(this._arr.length, t._arr.length); n++) {
      if (this._arr[n] < t._arr[n])
        return "lt";
      if (this._arr[n] > t._arr[n])
        return "gt";
    }
    return this._arr.length < t._arr.length ? "lt" : this._arr.length > t._arr.length ? "gt" : "eq";
  }
  /**
   * Utility method checking whether a provided Principal is less than or equal to the current one using the {@link Principal.compareTo} method
   * @param other a {@link Principal} to compare
   * @returns {boolean} boolean
   */
  ltEq(t) {
    const n = this.compareTo(t);
    return n == "lt" || n == "eq";
  }
  /**
   * Utility method checking whether a provided Principal is greater than or equal to the current one using the {@link Principal.compareTo} method
   * @param other a {@link Principal} to compare
   * @returns {boolean} boolean
   */
  gtEq(t) {
    const n = this.compareTo(t);
    return n == "gt" || n == "eq";
  }
};
class Bi extends Error {
  constructor(t) {
    super(t), this.message = t, Object.setPrototypeOf(this, Bi.prototype);
  }
}
function sn(...e) {
  const t = new Uint8Array(e.reduce((r, i) => r + i.byteLength, 0));
  let n = 0;
  for (const r of e)
    t.set(new Uint8Array(r), n), n += r.byteLength;
  return t;
}
function tke(e) {
  var t;
  return new Uint8Array(((t = e.match(/.{1,2}/g)) !== null && t !== void 0 ? t : []).map((n) => parseInt(n, 16)));
}
class s0 {
  /**
   * Creates a new instance of a pipe
   * @param buffer an optional buffer to start with
   * @param length an optional amount of bytes to use for the length.
   */
  constructor(t, n = (t == null ? void 0 : t.byteLength) || 0) {
    this._buffer = aT(t || new ArrayBuffer(0)), this._view = new Uint8Array(this._buffer, 0, n);
  }
  get buffer() {
    return aT(this._view.slice());
  }
  get byteLength() {
    return this._view.byteLength;
  }
  /**
   * Read `num` number of bytes from the front of the pipe.
   * @param num The number of bytes to read.
   */
  read(t) {
    const n = this._view.subarray(0, t);
    return this._view = this._view.subarray(t), n.slice().buffer;
  }
  readUint8() {
    const t = this._view[0];
    return this._view = this._view.subarray(1), t;
  }
  /**
   * Write a buffer to the end of the pipe.
   * @param buf The bytes to write.
   */
  write(t) {
    const n = new Uint8Array(t), r = this._view.byteLength;
    this._view.byteOffset + this._view.byteLength + n.byteLength >= this._buffer.byteLength ? this.alloc(n.byteLength) : this._view = new Uint8Array(this._buffer, this._view.byteOffset, this._view.byteLength + n.byteLength), this._view.set(n, r);
  }
  /**
   * Whether or not there is more data to read from the buffer
   */
  get end() {
    return this._view.byteLength === 0;
  }
  /**
   * Allocate a fixed amount of memory in the buffer. This does not affect the view.
   * @param amount A number of bytes to add to the buffer.
   */
  alloc(t) {
    const n = new ArrayBuffer((this._buffer.byteLength + t) * 1.2 | 0), r = new Uint8Array(n, 0, this._view.byteLength + t);
    r.set(this._view), this._buffer = n, this._view = r;
  }
}
function c6(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength).buffer;
}
function aT(e) {
  return e instanceof Uint8Array ? c6(e) : e instanceof ArrayBuffer ? e : Array.isArray(e) ? c6(new Uint8Array(e)) : "buffer" in e ? aT(e.buffer) : c6(new Uint8Array(e));
}
function nke(e) {
  const n = new TextEncoder().encode(e);
  let r = 0;
  for (const i of n)
    r = (r * 223 + i) % 2 ** 32;
  return r;
}
function sa(e) {
  if (/^_\d+_$/.test(e) || /^_0x[0-9a-fA-F]+_$/.test(e)) {
    const t = +e.slice(1, -1);
    if (Number.isSafeInteger(t) && t >= 0 && t < 2 ** 32)
      return t;
  }
  return nke(e);
}
function ZG() {
  throw new Error("unexpected end of buffer");
}
function df(e, t) {
  return e.byteLength < t && ZG(), e.read(t);
}
function ff(e) {
  const t = e.readUint8();
  return t === void 0 && ZG(), t;
}
function Mn(e) {
  if (typeof e == "number" && (e = BigInt(e)), e < BigInt(0))
    throw new Error("Cannot leb encode negative values.");
  const t = (e === BigInt(0) ? 0 : Math.ceil(Math.log2(Number(e)))) + 1, n = new s0(new ArrayBuffer(t), 0);
  for (; ; ) {
    const r = Number(e & BigInt(127));
    if (e /= BigInt(128), e === BigInt(0)) {
      n.write(new Uint8Array([r]));
      break;
    } else
      n.write(new Uint8Array([r | 128]));
  }
  return n.buffer;
}
function ur(e) {
  let t = BigInt(1), n = BigInt(0), r;
  do
    r = ff(e), n += BigInt(r & 127).valueOf() * t, t *= BigInt(128);
  while (r >= 128);
  return n;
}
function tr(e) {
  typeof e == "number" && (e = BigInt(e));
  const t = e < BigInt(0);
  t && (e = -e - BigInt(1));
  const n = (e === BigInt(0) ? 0 : Math.ceil(Math.log2(Number(e)))) + 1, r = new s0(new ArrayBuffer(n), 0);
  for (; ; ) {
    const s = i(e);
    if (e /= BigInt(128), t && e === BigInt(0) && s & 64 || !t && e === BigInt(0) && !(s & 64)) {
      r.write(new Uint8Array([s]));
      break;
    } else
      r.write(new Uint8Array([s | 128]));
  }
  function i(s) {
    const o = s % BigInt(128);
    return Number(t ? BigInt(128) - o - BigInt(1) : o);
  }
  return r.buffer;
}
function nl(e) {
  const t = new Uint8Array(e.buffer);
  let n = 0;
  for (; n < t.byteLength; n++)
    if (t[n] < 128) {
      if (!(t[n] & 64))
        return ur(e);
      break;
    }
  const r = new Uint8Array(df(e, n + 1));
  let i = BigInt(0);
  for (let s = r.byteLength - 1; s >= 0; s--)
    i = i * BigInt(128) + BigInt(128 - (r[s] & 127) - 1);
  return -i - BigInt(1);
}
function rke(e, t) {
  if (BigInt(e) < BigInt(0))
    throw new Error("Cannot write negative values.");
  return JG(e, t);
}
function JG(e, t) {
  e = BigInt(e);
  const n = new s0(new ArrayBuffer(Math.min(1, t)), 0);
  let r = 0, i = BigInt(256), s = BigInt(0), o = Number(e % i);
  for (n.write(new Uint8Array([o])); ++r < t; )
    e < 0 && s === BigInt(0) && o !== 0 && (s = BigInt(1)), o = Number((e / i - s) % BigInt(256)), n.write(new Uint8Array([o])), i *= BigInt(256);
  return n.buffer;
}
function XG(e, t) {
  let n = BigInt(ff(e)), r = BigInt(1), i = 0;
  for (; ++i < t; ) {
    r *= BigInt(256);
    const s = BigInt(ff(e));
    n = n + r * s;
  }
  return n;
}
function ike(e, t) {
  let n = XG(e, t);
  const r = BigInt(2) ** (BigInt(8) * BigInt(t - 1) + BigInt(7));
  return n >= r && (n -= r * BigInt(2)), n;
}
function cT(e) {
  const t = BigInt(e);
  if (e < 0)
    throw new RangeError("Input must be non-negative");
  return BigInt(1) << t;
}
const Lw = "DIDL", wR = 400;
function Wy(e, t, n) {
  return e.map((r, i) => n(r, t[i]));
}
class ske {
  constructor() {
    this._typs = [], this._idx = /* @__PURE__ */ new Map();
  }
  has(t) {
    return this._idx.has(t.name);
  }
  add(t, n) {
    const r = this._typs.length;
    this._idx.set(t.name, r), this._typs.push(n);
  }
  merge(t, n) {
    const r = this._idx.get(t.name), i = this._idx.get(n);
    if (r === void 0)
      throw new Error("Missing type index for " + t);
    if (i === void 0)
      throw new Error("Missing type index for " + n);
    this._typs[r] = this._typs[i], this._typs.splice(i, 1), this._idx.delete(n);
  }
  encode() {
    const t = Mn(this._typs.length), n = sn(...this._typs);
    return sn(t, n);
  }
  indexOf(t) {
    if (!this._idx.has(t))
      throw new Error("Missing type index for " + t);
    return tr(this._idx.get(t) || 0);
  }
}
class oke {
  visitType(t, n) {
    throw new Error("Not implemented");
  }
  visitPrimitive(t, n) {
    return this.visitType(t, n);
  }
  visitEmpty(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitBool(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitNull(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitReserved(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitText(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitNumber(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitInt(t, n) {
    return this.visitNumber(t, n);
  }
  visitNat(t, n) {
    return this.visitNumber(t, n);
  }
  visitFloat(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitFixedInt(t, n) {
    return this.visitNumber(t, n);
  }
  visitFixedNat(t, n) {
    return this.visitNumber(t, n);
  }
  visitPrincipal(t, n) {
    return this.visitPrimitive(t, n);
  }
  visitConstruct(t, n) {
    return this.visitType(t, n);
  }
  visitVec(t, n, r) {
    return this.visitConstruct(t, r);
  }
  visitOpt(t, n, r) {
    return this.visitConstruct(t, r);
  }
  visitRecord(t, n, r) {
    return this.visitConstruct(t, r);
  }
  visitTuple(t, n, r) {
    const i = n.map((s, o) => [`_${o}_`, s]);
    return this.visitRecord(t, i, r);
  }
  visitVariant(t, n, r) {
    return this.visitConstruct(t, r);
  }
  visitRec(t, n, r) {
    return this.visitConstruct(n, r);
  }
  visitFunc(t, n) {
    return this.visitConstruct(t, n);
  }
  visitService(t, n) {
    return this.visitConstruct(t, n);
  }
}
class BE {
  /* Display type name */
  display() {
    return this.name;
  }
  valueToString(t) {
    return Hn(t);
  }
  /* Implement `T` in the IDL spec, only needed for non-primitive types */
  buildTypeTable(t) {
    t.has(this) || this._buildTypeTableImpl(t);
  }
}
class Ns extends BE {
  checkType(t) {
    if (this.name !== t.name)
      throw new Error(`type mismatch: type on the wire ${t.name}, expect type ${this.name}`);
    return t;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _buildTypeTableImpl(t) {
  }
}
class xu extends BE {
  checkType(t) {
    if (t instanceof Au) {
      const n = t.getType();
      if (typeof n > "u")
        throw new Error("type mismatch with uninitialized type");
      return n;
    }
    throw new Error(`type mismatch: type on the wire ${t.name}, expect type ${this.name}`);
  }
  encodeType(t) {
    return t.indexOf(this.name);
  }
}
class eq extends Ns {
  accept(t, n) {
    return t.visitEmpty(this, n);
  }
  covariant(t) {
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue() {
    throw new Error("Empty cannot appear as a function argument");
  }
  valueToString() {
    throw new Error("Empty cannot appear as a value");
  }
  encodeType() {
    return tr(
      -17
      /* IDLTypeIds.Empty */
    );
  }
  decodeValue() {
    throw new Error("Empty cannot appear as an output");
  }
  get name() {
    return "empty";
  }
}
class tq extends BE {
  checkType(t) {
    throw new Error("Method not implemented for unknown.");
  }
  accept(t, n) {
    throw t.visitType(this, n);
  }
  covariant(t) {
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue() {
    throw new Error("Unknown cannot appear as a function argument");
  }
  valueToString() {
    throw new Error("Unknown cannot appear as a value");
  }
  encodeType() {
    throw new Error("Unknown cannot be serialized");
  }
  decodeValue(t, n) {
    let r = n.decodeValue(t, n);
    Object(r) !== r && (r = Object(r));
    let i;
    return n instanceof Au ? i = () => n.getType() : i = () => n, Object.defineProperty(r, "type", {
      value: i,
      writable: !0,
      enumerable: !1,
      configurable: !0
    }), r;
  }
  _buildTypeTableImpl() {
    throw new Error("Unknown cannot be serialized");
  }
  get name() {
    return "Unknown";
  }
}
class nq extends Ns {
  accept(t, n) {
    return t.visitBool(this, n);
  }
  covariant(t) {
    if (typeof t == "boolean")
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    return new Uint8Array([t ? 1 : 0]);
  }
  encodeType() {
    return tr(
      -2
      /* IDLTypeIds.Bool */
    );
  }
  decodeValue(t, n) {
    switch (this.checkType(n), ff(t)) {
      case 0:
        return !1;
      case 1:
        return !0;
      default:
        throw new Error("Boolean value out of range");
    }
  }
  get name() {
    return "bool";
  }
}
class rq extends Ns {
  accept(t, n) {
    return t.visitNull(this, n);
  }
  covariant(t) {
    if (t === null)
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue() {
    return new ArrayBuffer(0);
  }
  encodeType() {
    return tr(
      -1
      /* IDLTypeIds.Null */
    );
  }
  decodeValue(t, n) {
    return this.checkType(n), null;
  }
  get name() {
    return "null";
  }
}
class y2 extends Ns {
  accept(t, n) {
    return t.visitReserved(this, n);
  }
  covariant(t) {
    return !0;
  }
  encodeValue() {
    return new ArrayBuffer(0);
  }
  encodeType() {
    return tr(
      -16
      /* IDLTypeIds.Reserved */
    );
  }
  decodeValue(t, n) {
    return n.name !== this.name && n.decodeValue(t, n), null;
  }
  get name() {
    return "reserved";
  }
}
class iq extends Ns {
  accept(t, n) {
    return t.visitText(this, n);
  }
  covariant(t) {
    if (typeof t == "string")
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    const n = new TextEncoder().encode(t), r = Mn(n.byteLength);
    return sn(r, n);
  }
  encodeType() {
    return tr(
      -15
      /* IDLTypeIds.Text */
    );
  }
  decodeValue(t, n) {
    this.checkType(n);
    const r = ur(t), i = df(t, Number(r));
    return new TextDecoder("utf8", { fatal: !0 }).decode(i);
  }
  get name() {
    return "text";
  }
  valueToString(t) {
    return '"' + t + '"';
  }
}
class sq extends Ns {
  accept(t, n) {
    return t.visitInt(this, n);
  }
  covariant(t) {
    if (typeof t == "bigint" || Number.isInteger(t))
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    return tr(t);
  }
  encodeType() {
    return tr(
      -4
      /* IDLTypeIds.Int */
    );
  }
  decodeValue(t, n) {
    return this.checkType(n), nl(t);
  }
  get name() {
    return "int";
  }
  valueToString(t) {
    return t.toString();
  }
}
class oq extends Ns {
  accept(t, n) {
    return t.visitNat(this, n);
  }
  covariant(t) {
    if (typeof t == "bigint" && t >= BigInt(0) || Number.isInteger(t) && t >= 0)
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    return Mn(t);
  }
  encodeType() {
    return tr(
      -3
      /* IDLTypeIds.Nat */
    );
  }
  decodeValue(t, n) {
    return this.checkType(n), ur(t);
  }
  get name() {
    return "nat";
  }
  valueToString(t) {
    return t.toString();
  }
}
class I8 extends Ns {
  constructor(t) {
    if (super(), this._bits = t, t !== 32 && t !== 64)
      throw new Error("not a valid float type");
  }
  accept(t, n) {
    return t.visitFloat(this, n);
  }
  covariant(t) {
    if (typeof t == "number" || t instanceof Number)
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    const n = new ArrayBuffer(this._bits / 8), r = new DataView(n);
    return this._bits === 32 ? r.setFloat32(0, t, !0) : r.setFloat64(0, t, !0), n;
  }
  encodeType() {
    const t = this._bits === 32 ? -13 : -14;
    return tr(t);
  }
  decodeValue(t, n) {
    this.checkType(n);
    const r = df(t, this._bits / 8), i = new DataView(r);
    return this._bits === 32 ? i.getFloat32(0, !0) : i.getFloat64(0, !0);
  }
  get name() {
    return "float" + this._bits;
  }
  valueToString(t) {
    return t.toString();
  }
}
class hf extends Ns {
  constructor(t) {
    super(), this._bits = t;
  }
  accept(t, n) {
    return t.visitFixedInt(this, n);
  }
  covariant(t) {
    const n = cT(this._bits - 1) * BigInt(-1), r = cT(this._bits - 1) - BigInt(1);
    let i = !1;
    if (typeof t == "bigint")
      i = t >= n && t <= r;
    else if (Number.isInteger(t)) {
      const s = BigInt(t);
      i = s >= n && s <= r;
    } else
      i = !1;
    if (i)
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    return JG(t, this._bits / 8);
  }
  encodeType() {
    const t = Math.log2(this._bits) - 3;
    return tr(-9 - t);
  }
  decodeValue(t, n) {
    this.checkType(n);
    const r = ike(t, this._bits / 8);
    return this._bits <= 32 ? Number(r) : r;
  }
  get name() {
    return `int${this._bits}`;
  }
  valueToString(t) {
    return t.toString();
  }
}
class $l extends Ns {
  constructor(t) {
    super(), this._bits = t;
  }
  accept(t, n) {
    return t.visitFixedNat(this, n);
  }
  covariant(t) {
    const n = cT(this._bits);
    let r = !1;
    if (typeof t == "bigint" && t >= BigInt(0) ? r = t < n : Number.isInteger(t) && t >= 0 ? r = BigInt(t) < n : r = !1, r)
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    return rke(t, this._bits / 8);
  }
  encodeType() {
    const t = Math.log2(this._bits) - 3;
    return tr(-5 - t);
  }
  decodeValue(t, n) {
    this.checkType(n);
    const r = XG(t, this._bits / 8);
    return this._bits <= 32 ? Number(r) : r;
  }
  get name() {
    return `nat${this._bits}`;
  }
  valueToString(t) {
    return t.toString();
  }
}
class IE extends xu {
  constructor(t) {
    super(), this._type = t, this._blobOptimization = !1, t instanceof $l && t._bits === 8 && (this._blobOptimization = !0);
  }
  accept(t, n) {
    return t.visitVec(this, this._type, n);
  }
  covariant(t) {
    const n = this._type instanceof $l ? this._type._bits : this._type instanceof hf ? this._type._bits : 0;
    if (ArrayBuffer.isView(t) && n == t.BYTES_PER_ELEMENT * 8 || Array.isArray(t) && t.every((r, i) => {
      try {
        return this._type.covariant(r);
      } catch (s) {
        throw new Error(`Invalid ${this.display()} argument: 

index ${i} -> ${s.message}`);
      }
    }))
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    const n = Mn(t.length);
    if (this._blobOptimization)
      return sn(n, new Uint8Array(t));
    if (ArrayBuffer.isView(t))
      return sn(n, new Uint8Array(t.buffer));
    const r = new s0(new ArrayBuffer(n.byteLength + t.length), 0);
    r.write(n);
    for (const i of t) {
      const s = this._type.encodeValue(i);
      r.write(new Uint8Array(s));
    }
    return r.buffer;
  }
  _buildTypeTableImpl(t) {
    this._type.buildTypeTable(t);
    const n = tr(
      -19
      /* IDLTypeIds.Vector */
    ), r = this._type.encodeType(t);
    t.add(this, sn(n, r));
  }
  decodeValue(t, n) {
    const r = this.checkType(n);
    if (!(r instanceof IE))
      throw new Error("Not a vector type");
    const i = Number(ur(t));
    if (this._type instanceof $l) {
      if (this._type._bits == 8)
        return new Uint8Array(t.read(i));
      if (this._type._bits == 16)
        return new Uint16Array(t.read(i * 2));
      if (this._type._bits == 32)
        return new Uint32Array(t.read(i * 4));
      if (this._type._bits == 64)
        return new BigUint64Array(t.read(i * 8));
    }
    if (this._type instanceof hf) {
      if (this._type._bits == 8)
        return new Int8Array(t.read(i));
      if (this._type._bits == 16)
        return new Int16Array(t.read(i * 2));
      if (this._type._bits == 32)
        return new Int32Array(t.read(i * 4));
      if (this._type._bits == 64)
        return new BigInt64Array(t.read(i * 8));
    }
    const s = [];
    for (let o = 0; o < i; o++)
      s.push(this._type.decodeValue(t, r._type));
    return s;
  }
  get name() {
    return `vec ${this._type.name}`;
  }
  display() {
    return `vec ${this._type.display()}`;
  }
  valueToString(t) {
    return "vec {" + t.map((r) => this._type.valueToString(r)).join("; ") + "}";
  }
}
class Rm extends xu {
  constructor(t) {
    super(), this._type = t;
  }
  accept(t, n) {
    return t.visitOpt(this, this._type, n);
  }
  covariant(t) {
    try {
      if (Array.isArray(t) && (t.length === 0 || t.length === 1 && this._type.covariant(t[0])))
        return !0;
    } catch (n) {
      throw new Error(`Invalid ${this.display()} argument: ${Hn(t)} 

-> ${n.message}`);
    }
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    return t.length === 0 ? new Uint8Array([0]) : sn(new Uint8Array([1]), this._type.encodeValue(t[0]));
  }
  _buildTypeTableImpl(t) {
    this._type.buildTypeTable(t);
    const n = tr(
      -18
      /* IDLTypeIds.Opt */
    ), r = this._type.encodeType(t);
    t.add(this, sn(n, r));
  }
  decodeValue(t, n) {
    const r = this.checkType(n);
    if (!(r instanceof Rm))
      throw new Error("Not an option type");
    switch (ff(t)) {
      case 0:
        return [];
      case 1:
        return [this._type.decodeValue(t, r._type)];
      default:
        throw new Error("Not an option value");
    }
  }
  get name() {
    return `opt ${this._type.name}`;
  }
  display() {
    return `opt ${this._type.display()}`;
  }
  valueToString(t) {
    return t.length === 0 ? "null" : `opt ${this._type.valueToString(t[0])}`;
  }
}
class Pv extends xu {
  constructor(t = {}) {
    super(), this._fields = Object.entries(t).sort((n, r) => sa(n[0]) - sa(r[0]));
  }
  accept(t, n) {
    return t.visitRecord(this, this._fields, n);
  }
  tryAsTuple() {
    const t = [];
    for (let n = 0; n < this._fields.length; n++) {
      const [r, i] = this._fields[n];
      if (r !== `_${n}_`)
        return null;
      t.push(i);
    }
    return t;
  }
  covariant(t) {
    if (typeof t == "object" && this._fields.every(([n, r]) => {
      if (!t.hasOwnProperty(n))
        throw new Error(`Record is missing key "${n}".`);
      try {
        return r.covariant(t[n]);
      } catch (i) {
        throw new Error(`Invalid ${this.display()} argument: 

field ${n} -> ${i.message}`);
      }
    }))
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    const n = this._fields.map(([i]) => t[i]), r = Wy(this._fields, n, ([, i], s) => i.encodeValue(s));
    return sn(...r);
  }
  _buildTypeTableImpl(t) {
    this._fields.forEach(([s, o]) => o.buildTypeTable(t));
    const n = tr(
      -20
      /* IDLTypeIds.Record */
    ), r = Mn(this._fields.length), i = this._fields.map(([s, o]) => sn(Mn(sa(s)), o.encodeType(t)));
    t.add(this, sn(n, r, sn(...i)));
  }
  decodeValue(t, n) {
    const r = this.checkType(n);
    if (!(r instanceof Pv))
      throw new Error("Not a record type");
    const i = {};
    let s = 0, o = 0;
    for (; o < r._fields.length; ) {
      const [a, c] = r._fields[o];
      if (s >= this._fields.length) {
        c.decodeValue(t, c), o++;
        continue;
      }
      const [l, u] = this._fields[s], d = sa(this._fields[s][0]), f = sa(a);
      if (d === f)
        i[l] = u.decodeValue(t, c), s++, o++;
      else if (f > d)
        if (u instanceof Rm || u instanceof y2)
          i[l] = [], s++;
        else
          throw new Error("Cannot find required field " + l);
      else
        c.decodeValue(t, c), o++;
    }
    for (const [a, c] of this._fields.slice(s))
      if (c instanceof Rm || c instanceof y2)
        i[a] = [];
      else
        throw new Error("Cannot find required field " + a);
    return i;
  }
  get name() {
    return `record {${this._fields.map(([n, r]) => n + ":" + r.name).join("; ")}}`;
  }
  display() {
    return `record {${this._fields.map(([n, r]) => n + ":" + r.display()).join("; ")}}`;
  }
  valueToString(t) {
    const n = this._fields.map(([i]) => t[i]);
    return `record {${Wy(this._fields, n, ([i, s], o) => i + "=" + s.valueToString(o)).join("; ")}}`;
  }
}
class PE extends Pv {
  constructor(t) {
    const n = {};
    t.forEach((r, i) => n["_" + i + "_"] = r), super(n), this._components = t;
  }
  accept(t, n) {
    return t.visitTuple(this, this._components, n);
  }
  covariant(t) {
    if (Array.isArray(t) && t.length >= this._fields.length && this._components.every((n, r) => {
      try {
        return n.covariant(t[r]);
      } catch (i) {
        throw new Error(`Invalid ${this.display()} argument: 

index ${r} -> ${i.message}`);
      }
    }))
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    const n = Wy(this._components, t, (r, i) => r.encodeValue(i));
    return sn(...n);
  }
  decodeValue(t, n) {
    const r = this.checkType(n);
    if (!(r instanceof PE))
      throw new Error("not a tuple type");
    if (r._components.length < this._components.length)
      throw new Error("tuple mismatch");
    const i = [];
    for (const [s, o] of r._components.entries())
      s >= this._components.length ? o.decodeValue(t, o) : i.push(this._components[s].decodeValue(t, o));
    return i;
  }
  display() {
    return `record {${this._components.map((n) => n.display()).join("; ")}}`;
  }
  valueToString(t) {
    return `record {${Wy(this._components, t, (r, i) => r.valueToString(i)).join("; ")}}`;
  }
}
class OE extends xu {
  constructor(t = {}) {
    super(), this._fields = Object.entries(t).sort((n, r) => sa(n[0]) - sa(r[0]));
  }
  accept(t, n) {
    return t.visitVariant(this, this._fields, n);
  }
  covariant(t) {
    if (typeof t == "object" && Object.entries(t).length === 1 && this._fields.every(([n, r]) => {
      try {
        return !t.hasOwnProperty(n) || r.covariant(t[n]);
      } catch (i) {
        throw new Error(`Invalid ${this.display()} argument: 

variant ${n} -> ${i.message}`);
      }
    }))
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    for (let n = 0; n < this._fields.length; n++) {
      const [r, i] = this._fields[n];
      if (t.hasOwnProperty(r)) {
        const s = Mn(n), o = i.encodeValue(t[r]);
        return sn(s, o);
      }
    }
    throw Error("Variant has no data: " + t);
  }
  _buildTypeTableImpl(t) {
    this._fields.forEach(([, s]) => {
      s.buildTypeTable(t);
    });
    const n = tr(
      -21
      /* IDLTypeIds.Variant */
    ), r = Mn(this._fields.length), i = this._fields.map(([s, o]) => sn(Mn(sa(s)), o.encodeType(t)));
    t.add(this, sn(n, r, ...i));
  }
  decodeValue(t, n) {
    const r = this.checkType(n);
    if (!(r instanceof OE))
      throw new Error("Not a variant type");
    const i = Number(ur(t));
    if (i >= r._fields.length)
      throw Error("Invalid variant index: " + i);
    const [s, o] = r._fields[i];
    for (const [a, c] of this._fields)
      if (sa(s) === sa(a)) {
        const l = c.decodeValue(t, o);
        return { [a]: l };
      }
    throw new Error("Cannot find field hash " + s);
  }
  get name() {
    return `variant {${this._fields.map(([n, r]) => n + ":" + r.name).join("; ")}}`;
  }
  display() {
    return `variant {${this._fields.map(([n, r]) => n + (r.name === "null" ? "" : `:${r.display()}`)).join("; ")}}`;
  }
  valueToString(t) {
    for (const [n, r] of this._fields)
      if (t.hasOwnProperty(n)) {
        const i = r.valueToString(t[n]);
        return i === "null" ? `variant {${n}}` : `variant {${n}=${i}}`;
      }
    throw new Error("Variant has no data: " + t);
  }
}
class Au extends xu {
  constructor() {
    super(...arguments), this._id = Au._counter++, this._type = void 0;
  }
  accept(t, n) {
    if (!this._type)
      throw Error("Recursive type uninitialized.");
    return t.visitRec(this, this._type, n);
  }
  fill(t) {
    this._type = t;
  }
  getType() {
    return this._type;
  }
  covariant(t) {
    if (this._type && this._type.covariant(t))
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    if (!this._type)
      throw Error("Recursive type uninitialized.");
    return this._type.encodeValue(t);
  }
  _buildTypeTableImpl(t) {
    if (!this._type)
      throw Error("Recursive type uninitialized.");
    t.add(this, new Uint8Array([])), this._type.buildTypeTable(t), t.merge(this, this._type.name);
  }
  decodeValue(t, n) {
    if (!this._type)
      throw Error("Recursive type uninitialized.");
    return this._type.decodeValue(t, n);
  }
  get name() {
    return `rec_${this._id}`;
  }
  display() {
    if (!this._type)
      throw Error("Recursive type uninitialized.");
    return `μ${this.name}.${this._type.name}`;
  }
  valueToString(t) {
    if (!this._type)
      throw Error("Recursive type uninitialized.");
    return this._type.valueToString(t);
  }
}
Au._counter = 0;
function P8(e) {
  if (ff(e) !== 1)
    throw new Error("Cannot decode principal");
  const n = Number(ur(e));
  return gt.fromUint8Array(new Uint8Array(df(e, n)));
}
class aq extends Ns {
  accept(t, n) {
    return t.visitPrincipal(this, n);
  }
  covariant(t) {
    if (t && t._isPrincipal)
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    const n = t.toUint8Array(), r = Mn(n.byteLength);
    return sn(new Uint8Array([1]), r, n);
  }
  encodeType() {
    return tr(
      -24
      /* IDLTypeIds.Principal */
    );
  }
  decodeValue(t, n) {
    return this.checkType(n), P8(t);
  }
  get name() {
    return "principal";
  }
  valueToString(t) {
    return `${this.name} "${t.toText()}"`;
  }
}
class O8 extends xu {
  constructor(t, n, r = []) {
    super(), this.argTypes = t, this.retTypes = n, this.annotations = r;
  }
  static argsToString(t, n) {
    if (t.length !== n.length)
      throw new Error("arity mismatch");
    return "(" + t.map((r, i) => r.valueToString(n[i])).join(", ") + ")";
  }
  accept(t, n) {
    return t.visitFunc(this, n);
  }
  covariant(t) {
    if (Array.isArray(t) && t.length === 2 && t[0] && t[0]._isPrincipal && typeof t[1] == "string")
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue([t, n]) {
    const r = t.toUint8Array(), i = Mn(r.byteLength), s = sn(new Uint8Array([1]), i, r), o = new TextEncoder().encode(n), a = Mn(o.byteLength);
    return sn(new Uint8Array([1]), s, a, o);
  }
  _buildTypeTableImpl(t) {
    this.argTypes.forEach((l) => l.buildTypeTable(t)), this.retTypes.forEach((l) => l.buildTypeTable(t));
    const n = tr(
      -22
      /* IDLTypeIds.Func */
    ), r = Mn(this.argTypes.length), i = sn(...this.argTypes.map((l) => l.encodeType(t))), s = Mn(this.retTypes.length), o = sn(...this.retTypes.map((l) => l.encodeType(t))), a = Mn(this.annotations.length), c = sn(...this.annotations.map((l) => this.encodeAnnotation(l)));
    t.add(this, sn(n, r, i, s, o, a, c));
  }
  decodeValue(t) {
    if (ff(t) !== 1)
      throw new Error("Cannot decode function reference");
    const r = P8(t), i = Number(ur(t)), s = df(t, i), a = new TextDecoder("utf8", { fatal: !0 }).decode(s);
    return [r, a];
  }
  get name() {
    const t = this.argTypes.map((i) => i.name).join(", "), n = this.retTypes.map((i) => i.name).join(", "), r = " " + this.annotations.join(" ");
    return `(${t}) -> (${n})${r}`;
  }
  valueToString([t, n]) {
    return `func "${t.toText()}".${n}`;
  }
  display() {
    const t = this.argTypes.map((i) => i.display()).join(", "), n = this.retTypes.map((i) => i.display()).join(", "), r = " " + this.annotations.join(" ");
    return `(${t}) → (${n})${r}`;
  }
  encodeAnnotation(t) {
    if (t === "query")
      return new Uint8Array([1]);
    if (t === "oneway")
      return new Uint8Array([2]);
    if (t === "composite_query")
      return new Uint8Array([3]);
    throw new Error("Illegal function annotation");
  }
}
class cq extends xu {
  constructor(t) {
    super(), this._fields = Object.entries(t).sort((n, r) => n[0] < r[0] ? -1 : n[0] > r[0] ? 1 : 0);
  }
  accept(t, n) {
    return t.visitService(this, n);
  }
  covariant(t) {
    if (t && t._isPrincipal)
      return !0;
    throw new Error(`Invalid ${this.display()} argument: ${Hn(t)}`);
  }
  encodeValue(t) {
    const n = t.toUint8Array(), r = Mn(n.length);
    return sn(new Uint8Array([1]), r, n);
  }
  _buildTypeTableImpl(t) {
    this._fields.forEach(([s, o]) => o.buildTypeTable(t));
    const n = tr(
      -23
      /* IDLTypeIds.Service */
    ), r = Mn(this._fields.length), i = this._fields.map(([s, o]) => {
      const a = new TextEncoder().encode(s), c = Mn(a.length);
      return sn(c, a, o.encodeType(t));
    });
    t.add(this, sn(n, r, ...i));
  }
  decodeValue(t) {
    return P8(t);
  }
  get name() {
    return `service {${this._fields.map(([n, r]) => n + ":" + r.name).join("; ")}}`;
  }
  valueToString(t) {
    return `service "${t.toText()}"`;
  }
}
function Hn(e) {
  const t = JSON.stringify(e, (n, r) => typeof r == "bigint" ? `BigInt(${r})` : r);
  return t && t.length > wR ? t.substring(0, wR - 3) + "..." : t;
}
function b2(e, t) {
  if (t.length < e.length)
    throw Error("Wrong number of message arguments");
  const n = new ske();
  e.forEach((c) => c.buildTypeTable(n));
  const r = new TextEncoder().encode(Lw), i = n.encode(), s = Mn(t.length), o = sn(...e.map((c) => c.encodeType(n))), a = sn(...Wy(e, t, (c, l) => {
    try {
      c.covariant(l);
    } catch (u) {
      throw new Error(u.message + `

`);
    }
    return c.encodeValue(l);
  }));
  return sn(r, i, s, o, a);
}
function lq(e, t) {
  const n = new s0(t);
  if (t.byteLength < Lw.length)
    throw new Error("Message length smaller than magic number");
  const r = df(n, Lw.length), i = new TextDecoder().decode(r);
  if (i !== Lw)
    throw new Error("Wrong magic number: " + JSON.stringify(i));
  function s(p) {
    const m = [], h = Number(ur(p));
    for (let v = 0; v < h; v++) {
      const b = Number(nl(p));
      switch (b) {
        case -18:
        case -19: {
          const w = Number(nl(p));
          m.push([b, w]);
          break;
        }
        case -20:
        case -21: {
          const w = [];
          let A = Number(ur(p)), E;
          for (; A--; ) {
            const x = Number(ur(p));
            if (x >= Math.pow(2, 32))
              throw new Error("field id out of 32-bit range");
            if (typeof E == "number" && E >= x)
              throw new Error("field id collision or not sorted");
            E = x;
            const S = Number(nl(p));
            w.push([x, S]);
          }
          m.push([b, w]);
          break;
        }
        case -22: {
          const w = [];
          let A = Number(ur(p));
          for (; A--; )
            w.push(Number(nl(p)));
          const E = [];
          let x = Number(ur(p));
          for (; x--; )
            E.push(Number(nl(p)));
          const S = [];
          let P = Number(ur(p));
          for (; P--; )
            switch (Number(ur(p))) {
              case 1: {
                S.push("query");
                break;
              }
              case 2: {
                S.push("oneway");
                break;
              }
              case 3: {
                S.push("composite_query");
                break;
              }
              default:
                throw new Error("unknown annotation");
            }
          m.push([b, [w, E, S]]);
          break;
        }
        case -23: {
          let w = Number(ur(p));
          const A = [];
          for (; w--; ) {
            const E = Number(ur(p)), x = new TextDecoder().decode(df(p, E)), S = nl(p);
            A.push([x, S]);
          }
          m.push([b, A]);
          break;
        }
        default:
          throw new Error("Illegal op_code: " + b);
      }
    }
    const g = [], y = Number(ur(p));
    for (let v = 0; v < y; v++)
      g.push(Number(nl(p)));
    return [m, g];
  }
  const [o, a] = s(n);
  if (a.length < e.length)
    throw new Error("Wrong number of return values");
  const c = o.map((p) => Tq());
  function l(p) {
    if (p < -24)
      throw new Error("future value not supported");
    if (p < 0)
      switch (p) {
        case -1:
          return hq;
        case -2:
          return fq;
        case -3:
          return mq;
        case -4:
          return pq;
        case -5:
          return v2;
        case -6:
          return Aq;
        case -7:
          return Eq;
        case -8:
          return _q;
        case -9:
          return bq;
        case -10:
          return vq;
        case -11:
          return wq;
        case -12:
          return xq;
        case -13:
          return gq;
        case -14:
          return yq;
        case -15:
          return kh;
        case -16:
          return dq;
        case -17:
          return uq;
        case -24:
          return w2;
        default:
          throw new Error("Illegal op_code: " + p);
      }
    if (p >= o.length)
      throw new Error("type index out of range");
    return c[p];
  }
  function u(p) {
    switch (p[0]) {
      case -19: {
        const m = l(p[1]);
        return x2(m);
      }
      case -18: {
        const m = l(p[1]);
        return jg(m);
      }
      case -20: {
        const m = {};
        for (const [y, v] of p[1]) {
          const b = `_${y}_`;
          m[b] = l(v);
        }
        const h = N8(m), g = h.tryAsTuple();
        return Array.isArray(g) ? Sq(...g) : h;
      }
      case -21: {
        const m = {};
        for (const [h, g] of p[1]) {
          const y = `_${h}_`;
          m[y] = l(g);
        }
        return Cq(m);
      }
      case -22: {
        const [m, h, g] = p[1];
        return kq(m.map((y) => l(y)), h.map((y) => l(y)), g);
      }
      case -23: {
        const m = {}, h = p[1];
        for (const [g, y] of h) {
          let v = l(y);
          if (v instanceof Au && (v = v.getType()), !(v instanceof O8))
            throw new Error("Illegal service definition: services can only contain functions");
          m[g] = v;
        }
        return Bq(m);
      }
      default:
        throw new Error("Illegal op_code: " + p[0]);
    }
  }
  o.forEach((p, m) => {
    if (p[0] === -22) {
      const h = u(p);
      c[m].fill(h);
    }
  }), o.forEach((p, m) => {
    if (p[0] !== -22) {
      const h = u(p);
      c[m].fill(h);
    }
  });
  const d = a.map((p) => l(p)), f = e.map((p, m) => p.decodeValue(n, d[m]));
  for (let p = e.length; p < d.length; p++)
    d[p].decodeValue(n, d[p]);
  if (n.byteLength > 0)
    throw new Error("decode: Left-over bytes");
  return f;
}
const uq = new eq(), dq = new y2(), ake = new tq(), fq = new nq(), hq = new rq(), kh = new iq(), pq = new sq(), mq = new oq(), gq = new I8(32), yq = new I8(64), bq = new hf(8), vq = new hf(16), wq = new hf(32), xq = new hf(64), v2 = new $l(8), Aq = new $l(16), Eq = new $l(32), _q = new $l(64), w2 = new aq();
function Sq(...e) {
  return new PE(e);
}
function x2(e) {
  return new IE(e);
}
function jg(e) {
  return new Rm(e);
}
function N8(e) {
  return new Pv(e);
}
function Cq(e) {
  return new OE(e);
}
function Tq() {
  return new Au();
}
function kq(e, t, n = []) {
  return new O8(e, t, n);
}
function Bq(e) {
  return new cq(e);
}
const cke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Bool: fq,
  BoolClass: nq,
  ConstructType: xu,
  Empty: uq,
  EmptyClass: eq,
  FixedIntClass: hf,
  FixedNatClass: $l,
  Float32: gq,
  Float64: yq,
  FloatClass: I8,
  Func: kq,
  FuncClass: O8,
  Int: pq,
  Int16: vq,
  Int32: wq,
  Int64: xq,
  Int8: bq,
  IntClass: sq,
  Nat: mq,
  Nat16: Aq,
  Nat32: Eq,
  Nat64: _q,
  Nat8: v2,
  NatClass: oq,
  Null: hq,
  NullClass: rq,
  Opt: jg,
  OptClass: Rm,
  PrimitiveType: Ns,
  Principal: w2,
  PrincipalClass: aq,
  Rec: Tq,
  RecClass: Au,
  Record: N8,
  RecordClass: Pv,
  Reserved: dq,
  ReservedClass: y2,
  Service: Bq,
  ServiceClass: cq,
  Text: kh,
  TextClass: iq,
  Tuple: Sq,
  TupleClass: PE,
  Type: BE,
  Unknown: ake,
  UnknownClass: tq,
  Variant: Cq,
  VariantClass: OE,
  Vec: x2,
  VecClass: IE,
  Visitor: oke,
  decode: lq,
  encode: b2
}, Symbol.toStringTag, { value: "Module" }));
var Iq = {}, R8 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
R8.read = function(e, t, n, r, i) {
  var s, o, a = i * 8 - r - 1, c = (1 << a) - 1, l = c >> 1, u = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, p = e[t + d];
  for (d += f, s = p & (1 << -u) - 1, p >>= -u, u += a; u > 0; s = s * 256 + e[t + d], d += f, u -= 8)
    ;
  for (o = s & (1 << -u) - 1, s >>= -u, u += r; u > 0; o = o * 256 + e[t + d], d += f, u -= 8)
    ;
  if (s === 0)
    s = 1 - l;
  else {
    if (s === c)
      return o ? NaN : (p ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), s = s - l;
  }
  return (p ? -1 : 1) * o * Math.pow(2, s - r);
};
R8.write = function(e, t, n, r, i, s) {
  var o, a, c, l = s * 8 - i - 1, u = (1 << l) - 1, d = u >> 1, f = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : s - 1, m = r ? 1 : -1, h = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + d >= 1 ? t += f / c : t += f * Math.pow(2, 1 - d), t * c >= 2 && (o++, c /= 2), o + d >= u ? (a = 0, o = u) : o + d >= 1 ? (a = (t * c - 1) * Math.pow(2, i), o = o + d) : (a = t * Math.pow(2, d - 1) * Math.pow(2, i), o = 0)); i >= 8; e[n + p] = a & 255, p += m, a /= 256, i -= 8)
    ;
  for (o = o << i | a, l += i; l > 0; e[n + p] = o & 255, p += m, o /= 256, l -= 8)
    ;
  e[n + p - m] |= h * 128;
};
var Pq = { exports: {} };
(function(e) {
  (function(t) {
    var n, r = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, i = Math.ceil, s = Math.floor, o = "[BigNumber Error] ", a = o + "Number primitive has more than 15 significant digits: ", c = 1e14, l = 14, u = 9007199254740991, d = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], f = 1e7, p = 1e9;
    function m(E) {
      var x, S, P, I = B.prototype = { constructor: B, toString: null, valueOf: null }, R = new B(1), Q = 20, J = 4, we = -7, V = 21, L = -1e7, U = 1e7, q = !1, G = 1, ae = 0, ge = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: " ",
        // non-breaking space
        suffix: ""
      }, Ae = "0123456789abcdefghijklmnopqrstuvwxyz", he = !0;
      function B(N, F) {
        var z, ne, ee, Y, X, $, ie, fe, oe = this;
        if (!(oe instanceof B))
          return new B(N, F);
        if (F == null) {
          if (N && N._isBigNumber === !0) {
            oe.s = N.s, !N.c || N.e > U ? oe.c = oe.e = null : N.e < L ? oe.c = [oe.e = 0] : (oe.e = N.e, oe.c = N.c.slice());
            return;
          }
          if (($ = typeof N == "number") && N * 0 == 0) {
            if (oe.s = 1 / N < 0 ? (N = -N, -1) : 1, N === ~~N) {
              for (Y = 0, X = N; X >= 10; X /= 10, Y++)
                ;
              Y > U ? oe.c = oe.e = null : (oe.e = Y, oe.c = [N]);
              return;
            }
            fe = String(N);
          } else {
            if (!r.test(fe = String(N)))
              return P(oe, fe, $);
            oe.s = fe.charCodeAt(0) == 45 ? (fe = fe.slice(1), -1) : 1;
          }
          (Y = fe.indexOf(".")) > -1 && (fe = fe.replace(".", "")), (X = fe.search(/e/i)) > 0 ? (Y < 0 && (Y = X), Y += +fe.slice(X + 1), fe = fe.substring(0, X)) : Y < 0 && (Y = fe.length);
        } else {
          if (v(F, 2, Ae.length, "Base"), F == 10 && he)
            return oe = new B(N), _e(oe, Q + oe.e + 1, J);
          if (fe = String(N), $ = typeof N == "number") {
            if (N * 0 != 0)
              return P(oe, fe, $, F);
            if (oe.s = 1 / N < 0 ? (fe = fe.slice(1), -1) : 1, B.DEBUG && fe.replace(/^0\.0*|\./, "").length > 15)
              throw Error(a + N);
          } else
            oe.s = fe.charCodeAt(0) === 45 ? (fe = fe.slice(1), -1) : 1;
          for (z = Ae.slice(0, F), Y = X = 0, ie = fe.length; X < ie; X++)
            if (z.indexOf(ne = fe.charAt(X)) < 0) {
              if (ne == ".") {
                if (X > Y) {
                  Y = ie;
                  continue;
                }
              } else if (!ee && (fe == fe.toUpperCase() && (fe = fe.toLowerCase()) || fe == fe.toLowerCase() && (fe = fe.toUpperCase()))) {
                ee = !0, X = -1, Y = 0;
                continue;
              }
              return P(oe, String(N), $, F);
            }
          $ = !1, fe = S(fe, F, 10, oe.s), (Y = fe.indexOf(".")) > -1 ? fe = fe.replace(".", "") : Y = fe.length;
        }
        for (X = 0; fe.charCodeAt(X) === 48; X++)
          ;
        for (ie = fe.length; fe.charCodeAt(--ie) === 48; )
          ;
        if (fe = fe.slice(X, ++ie)) {
          if (ie -= X, $ && B.DEBUG && ie > 15 && (N > u || N !== s(N)))
            throw Error(a + oe.s * N);
          if ((Y = Y - X - 1) > U)
            oe.c = oe.e = null;
          else if (Y < L)
            oe.c = [oe.e = 0];
          else {
            if (oe.e = Y, oe.c = [], X = (Y + 1) % l, Y < 0 && (X += l), X < ie) {
              for (X && oe.c.push(+fe.slice(0, X)), ie -= l; X < ie; )
                oe.c.push(+fe.slice(X, X += l));
              X = l - (fe = fe.slice(X)).length;
            } else
              X -= ie;
            for (; X--; fe += "0")
              ;
            oe.c.push(+fe);
          }
        } else
          oe.c = [oe.e = 0];
      }
      B.clone = m, B.ROUND_UP = 0, B.ROUND_DOWN = 1, B.ROUND_CEIL = 2, B.ROUND_FLOOR = 3, B.ROUND_HALF_UP = 4, B.ROUND_HALF_DOWN = 5, B.ROUND_HALF_EVEN = 6, B.ROUND_HALF_CEIL = 7, B.ROUND_HALF_FLOOR = 8, B.EUCLID = 9, B.config = B.set = function(N) {
        var F, z;
        if (N != null)
          if (typeof N == "object") {
            if (N.hasOwnProperty(F = "DECIMAL_PLACES") && (z = N[F], v(z, 0, p, F), Q = z), N.hasOwnProperty(F = "ROUNDING_MODE") && (z = N[F], v(z, 0, 8, F), J = z), N.hasOwnProperty(F = "EXPONENTIAL_AT") && (z = N[F], z && z.pop ? (v(z[0], -p, 0, F), v(z[1], 0, p, F), we = z[0], V = z[1]) : (v(z, -p, p, F), we = -(V = z < 0 ? -z : z))), N.hasOwnProperty(F = "RANGE"))
              if (z = N[F], z && z.pop)
                v(z[0], -p, -1, F), v(z[1], 1, p, F), L = z[0], U = z[1];
              else if (v(z, -p, p, F), z)
                L = -(U = z < 0 ? -z : z);
              else
                throw Error(o + F + " cannot be zero: " + z);
            if (N.hasOwnProperty(F = "CRYPTO"))
              if (z = N[F], z === !!z)
                if (z)
                  if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                    q = z;
                  else
                    throw q = !z, Error(o + "crypto unavailable");
                else
                  q = z;
              else
                throw Error(o + F + " not true or false: " + z);
            if (N.hasOwnProperty(F = "MODULO_MODE") && (z = N[F], v(z, 0, 9, F), G = z), N.hasOwnProperty(F = "POW_PRECISION") && (z = N[F], v(z, 0, p, F), ae = z), N.hasOwnProperty(F = "FORMAT"))
              if (z = N[F], typeof z == "object")
                ge = z;
              else
                throw Error(o + F + " not an object: " + z);
            if (N.hasOwnProperty(F = "ALPHABET"))
              if (z = N[F], typeof z == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(z))
                he = z.slice(0, 10) == "0123456789", Ae = z;
              else
                throw Error(o + F + " invalid: " + z);
          } else
            throw Error(o + "Object expected: " + N);
        return {
          DECIMAL_PLACES: Q,
          ROUNDING_MODE: J,
          EXPONENTIAL_AT: [we, V],
          RANGE: [L, U],
          CRYPTO: q,
          MODULO_MODE: G,
          POW_PRECISION: ae,
          FORMAT: ge,
          ALPHABET: Ae
        };
      }, B.isBigNumber = function(N) {
        if (!N || N._isBigNumber !== !0)
          return !1;
        if (!B.DEBUG)
          return !0;
        var F, z, ne = N.c, ee = N.e, Y = N.s;
        e:
          if ({}.toString.call(ne) == "[object Array]") {
            if ((Y === 1 || Y === -1) && ee >= -p && ee <= p && ee === s(ee)) {
              if (ne[0] === 0) {
                if (ee === 0 && ne.length === 1)
                  return !0;
                break e;
              }
              if (F = (ee + 1) % l, F < 1 && (F += l), String(ne[0]).length == F) {
                for (F = 0; F < ne.length; F++)
                  if (z = ne[F], z < 0 || z >= c || z !== s(z))
                    break e;
                if (z !== 0)
                  return !0;
              }
            }
          } else if (ne === null && ee === null && (Y === null || Y === 1 || Y === -1))
            return !0;
        throw Error(o + "Invalid BigNumber: " + N);
      }, B.maximum = B.max = function() {
        return Be(arguments, -1);
      }, B.minimum = B.min = function() {
        return Be(arguments, 1);
      }, B.random = function() {
        var N = 9007199254740992, F = Math.random() * N & 2097151 ? function() {
          return s(Math.random() * N);
        } : function() {
          return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
        };
        return function(z) {
          var ne, ee, Y, X, $, ie = 0, fe = [], oe = new B(R);
          if (z == null ? z = Q : v(z, 0, p), X = i(z / l), q)
            if (crypto.getRandomValues) {
              for (ne = crypto.getRandomValues(new Uint32Array(X *= 2)); ie < X; )
                $ = ne[ie] * 131072 + (ne[ie + 1] >>> 11), $ >= 9e15 ? (ee = crypto.getRandomValues(new Uint32Array(2)), ne[ie] = ee[0], ne[ie + 1] = ee[1]) : (fe.push($ % 1e14), ie += 2);
              ie = X / 2;
            } else if (crypto.randomBytes) {
              for (ne = crypto.randomBytes(X *= 7); ie < X; )
                $ = (ne[ie] & 31) * 281474976710656 + ne[ie + 1] * 1099511627776 + ne[ie + 2] * 4294967296 + ne[ie + 3] * 16777216 + (ne[ie + 4] << 16) + (ne[ie + 5] << 8) + ne[ie + 6], $ >= 9e15 ? crypto.randomBytes(7).copy(ne, ie) : (fe.push($ % 1e14), ie += 7);
              ie = X / 7;
            } else
              throw q = !1, Error(o + "crypto unavailable");
          if (!q)
            for (; ie < X; )
              $ = F(), $ < 9e15 && (fe[ie++] = $ % 1e14);
          for (X = fe[--ie], z %= l, X && z && ($ = d[l - z], fe[ie] = s(X / $) * $); fe[ie] === 0; fe.pop(), ie--)
            ;
          if (ie < 0)
            fe = [Y = 0];
          else {
            for (Y = -1; fe[0] === 0; fe.splice(0, 1), Y -= l)
              ;
            for (ie = 1, $ = fe[0]; $ >= 10; $ /= 10, ie++)
              ;
            ie < l && (Y -= l - ie);
          }
          return oe.e = Y, oe.c = fe, oe;
        };
      }(), B.sum = function() {
        for (var N = 1, F = arguments, z = new B(F[0]); N < F.length; )
          z = z.plus(F[N++]);
        return z;
      }, S = /* @__PURE__ */ function() {
        var N = "0123456789";
        function F(z, ne, ee, Y) {
          for (var X, $ = [0], ie, fe = 0, oe = z.length; fe < oe; ) {
            for (ie = $.length; ie--; $[ie] *= ne)
              ;
            for ($[0] += Y.indexOf(z.charAt(fe++)), X = 0; X < $.length; X++)
              $[X] > ee - 1 && ($[X + 1] == null && ($[X + 1] = 0), $[X + 1] += $[X] / ee | 0, $[X] %= ee);
          }
          return $.reverse();
        }
        return function(z, ne, ee, Y, X) {
          var $, ie, fe, oe, me, Me, je, Ye, Oe = z.indexOf("."), De = Q, Te = J;
          for (Oe >= 0 && (oe = ae, ae = 0, z = z.replace(".", ""), Ye = new B(ne), Me = Ye.pow(z.length - Oe), ae = oe, Ye.c = F(
            A(g(Me.c), Me.e, "0"),
            10,
            ee,
            N
          ), Ye.e = Ye.c.length), je = F(z, ne, ee, X ? ($ = Ae, N) : ($ = N, Ae)), fe = oe = je.length; je[--oe] == 0; je.pop())
            ;
          if (!je[0])
            return $.charAt(0);
          if (Oe < 0 ? --fe : (Me.c = je, Me.e = fe, Me.s = Y, Me = x(Me, Ye, De, Te, ee), je = Me.c, me = Me.r, fe = Me.e), ie = fe + De + 1, Oe = je[ie], oe = ee / 2, me = me || ie < 0 || je[ie + 1] != null, me = Te < 4 ? (Oe != null || me) && (Te == 0 || Te == (Me.s < 0 ? 3 : 2)) : Oe > oe || Oe == oe && (Te == 4 || me || Te == 6 && je[ie - 1] & 1 || Te == (Me.s < 0 ? 8 : 7)), ie < 1 || !je[0])
            z = me ? A($.charAt(1), -De, $.charAt(0)) : $.charAt(0);
          else {
            if (je.length = ie, me)
              for (--ee; ++je[--ie] > ee; )
                je[ie] = 0, ie || (++fe, je = [1].concat(je));
            for (oe = je.length; !je[--oe]; )
              ;
            for (Oe = 0, z = ""; Oe <= oe; z += $.charAt(je[Oe++]))
              ;
            z = A(z, fe, $.charAt(0));
          }
          return z;
        };
      }(), x = /* @__PURE__ */ function() {
        function N(ne, ee, Y) {
          var X, $, ie, fe, oe = 0, me = ne.length, Me = ee % f, je = ee / f | 0;
          for (ne = ne.slice(); me--; )
            ie = ne[me] % f, fe = ne[me] / f | 0, X = je * ie + fe * Me, $ = Me * ie + X % f * f + oe, oe = ($ / Y | 0) + (X / f | 0) + je * fe, ne[me] = $ % Y;
          return oe && (ne = [oe].concat(ne)), ne;
        }
        function F(ne, ee, Y, X) {
          var $, ie;
          if (Y != X)
            ie = Y > X ? 1 : -1;
          else
            for ($ = ie = 0; $ < Y; $++)
              if (ne[$] != ee[$]) {
                ie = ne[$] > ee[$] ? 1 : -1;
                break;
              }
          return ie;
        }
        function z(ne, ee, Y, X) {
          for (var $ = 0; Y--; )
            ne[Y] -= $, $ = ne[Y] < ee[Y] ? 1 : 0, ne[Y] = $ * X + ne[Y] - ee[Y];
          for (; !ne[0] && ne.length > 1; ne.splice(0, 1))
            ;
        }
        return function(ne, ee, Y, X, $) {
          var ie, fe, oe, me, Me, je, Ye, Oe, De, Te, Fe, lt, O, _, T, M, se, H = ne.s == ee.s ? 1 : -1, ue = ne.c, Ee = ee.c;
          if (!ue || !ue[0] || !Ee || !Ee[0])
            return new B(
              // Return NaN if either NaN, or both Infinity or 0.
              !ne.s || !ee.s || (ue ? Ee && ue[0] == Ee[0] : !Ee) ? NaN : (
                // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                ue && ue[0] == 0 || !Ee ? H * 0 : H / 0
              )
            );
          for (Oe = new B(H), De = Oe.c = [], fe = ne.e - ee.e, H = Y + fe + 1, $ || ($ = c, fe = h(ne.e / l) - h(ee.e / l), H = H / l | 0), oe = 0; Ee[oe] == (ue[oe] || 0); oe++)
            ;
          if (Ee[oe] > (ue[oe] || 0) && fe--, H < 0)
            De.push(1), me = !0;
          else {
            for (_ = ue.length, M = Ee.length, oe = 0, H += 2, Me = s($ / (Ee[0] + 1)), Me > 1 && (Ee = N(Ee, Me, $), ue = N(ue, Me, $), M = Ee.length, _ = ue.length), O = M, Te = ue.slice(0, M), Fe = Te.length; Fe < M; Te[Fe++] = 0)
              ;
            se = Ee.slice(), se = [0].concat(se), T = Ee[0], Ee[1] >= $ / 2 && T++;
            do {
              if (Me = 0, ie = F(Ee, Te, M, Fe), ie < 0) {
                if (lt = Te[0], M != Fe && (lt = lt * $ + (Te[1] || 0)), Me = s(lt / T), Me > 1)
                  for (Me >= $ && (Me = $ - 1), je = N(Ee, Me, $), Ye = je.length, Fe = Te.length; F(je, Te, Ye, Fe) == 1; )
                    Me--, z(je, M < Ye ? se : Ee, Ye, $), Ye = je.length, ie = 1;
                else
                  Me == 0 && (ie = Me = 1), je = Ee.slice(), Ye = je.length;
                if (Ye < Fe && (je = [0].concat(je)), z(Te, je, Fe, $), Fe = Te.length, ie == -1)
                  for (; F(Ee, Te, M, Fe) < 1; )
                    Me++, z(Te, M < Fe ? se : Ee, Fe, $), Fe = Te.length;
              } else
                ie === 0 && (Me++, Te = [0]);
              De[oe++] = Me, Te[0] ? Te[Fe++] = ue[O] || 0 : (Te = [ue[O]], Fe = 1);
            } while ((O++ < _ || Te[0] != null) && H--);
            me = Te[0] != null, De[0] || De.splice(0, 1);
          }
          if ($ == c) {
            for (oe = 1, H = De[0]; H >= 10; H /= 10, oe++)
              ;
            _e(Oe, Y + (Oe.e = oe + fe * l - 1) + 1, X, me);
          } else
            Oe.e = fe, Oe.r = +me;
          return Oe;
        };
      }();
      function be(N, F, z, ne) {
        var ee, Y, X, $, ie;
        if (z == null ? z = J : v(z, 0, 8), !N.c)
          return N.toString();
        if (ee = N.c[0], X = N.e, F == null)
          ie = g(N.c), ie = ne == 1 || ne == 2 && (X <= we || X >= V) ? w(ie, X) : A(ie, X, "0");
        else if (N = _e(new B(N), F, z), Y = N.e, ie = g(N.c), $ = ie.length, ne == 1 || ne == 2 && (F <= Y || Y <= we)) {
          for (; $ < F; ie += "0", $++)
            ;
          ie = w(ie, Y);
        } else if (F -= X, ie = A(ie, Y, "0"), Y + 1 > $) {
          if (--F > 0)
            for (ie += "."; F--; ie += "0")
              ;
        } else if (F += Y - $, F > 0)
          for (Y + 1 == $ && (ie += "."); F--; ie += "0")
            ;
        return N.s < 0 && ee ? "-" + ie : ie;
      }
      function Be(N, F) {
        for (var z, ne, ee = 1, Y = new B(N[0]); ee < N.length; ee++)
          ne = new B(N[ee]), (!ne.s || (z = y(Y, ne)) === F || z === 0 && Y.s === F) && (Y = ne);
        return Y;
      }
      function Ne(N, F, z) {
        for (var ne = 1, ee = F.length; !F[--ee]; F.pop())
          ;
        for (ee = F[0]; ee >= 10; ee /= 10, ne++)
          ;
        return (z = ne + z * l - 1) > U ? N.c = N.e = null : z < L ? N.c = [N.e = 0] : (N.e = z, N.c = F), N;
      }
      P = /* @__PURE__ */ function() {
        var N = /^(-?)0([xbo])(?=\w[\w.]*$)/i, F = /^([^.]+)\.$/, z = /^\.([^.]+)$/, ne = /^-?(Infinity|NaN)$/, ee = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(Y, X, $, ie) {
          var fe, oe = $ ? X : X.replace(ee, "");
          if (ne.test(oe))
            Y.s = isNaN(oe) ? null : oe < 0 ? -1 : 1;
          else {
            if (!$ && (oe = oe.replace(N, function(me, Me, je) {
              return fe = (je = je.toLowerCase()) == "x" ? 16 : je == "b" ? 2 : 8, !ie || ie == fe ? Me : me;
            }), ie && (fe = ie, oe = oe.replace(F, "$1").replace(z, "0.$1")), X != oe))
              return new B(oe, fe);
            if (B.DEBUG)
              throw Error(o + "Not a" + (ie ? " base " + ie : "") + " number: " + X);
            Y.s = null;
          }
          Y.c = Y.e = null;
        };
      }();
      function _e(N, F, z, ne) {
        var ee, Y, X, $, ie, fe, oe, me = N.c, Me = d;
        if (me) {
          e: {
            for (ee = 1, $ = me[0]; $ >= 10; $ /= 10, ee++)
              ;
            if (Y = F - ee, Y < 0)
              Y += l, X = F, ie = me[fe = 0], oe = s(ie / Me[ee - X - 1] % 10);
            else if (fe = i((Y + 1) / l), fe >= me.length)
              if (ne) {
                for (; me.length <= fe; me.push(0))
                  ;
                ie = oe = 0, ee = 1, Y %= l, X = Y - l + 1;
              } else
                break e;
            else {
              for (ie = $ = me[fe], ee = 1; $ >= 10; $ /= 10, ee++)
                ;
              Y %= l, X = Y - l + ee, oe = X < 0 ? 0 : s(ie / Me[ee - X - 1] % 10);
            }
            if (ne = ne || F < 0 || // Are there any non-zero digits after the rounding digit?
            // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
            // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
            me[fe + 1] != null || (X < 0 ? ie : ie % Me[ee - X - 1]), ne = z < 4 ? (oe || ne) && (z == 0 || z == (N.s < 0 ? 3 : 2)) : oe > 5 || oe == 5 && (z == 4 || ne || z == 6 && // Check whether the digit to the left of the rounding digit is odd.
            (Y > 0 ? X > 0 ? ie / Me[ee - X] : 0 : me[fe - 1]) % 10 & 1 || z == (N.s < 0 ? 8 : 7)), F < 1 || !me[0])
              return me.length = 0, ne ? (F -= N.e + 1, me[0] = Me[(l - F % l) % l], N.e = -F || 0) : me[0] = N.e = 0, N;
            if (Y == 0 ? (me.length = fe, $ = 1, fe--) : (me.length = fe + 1, $ = Me[l - Y], me[fe] = X > 0 ? s(ie / Me[ee - X] % Me[X]) * $ : 0), ne)
              for (; ; )
                if (fe == 0) {
                  for (Y = 1, X = me[0]; X >= 10; X /= 10, Y++)
                    ;
                  for (X = me[0] += $, $ = 1; X >= 10; X /= 10, $++)
                    ;
                  Y != $ && (N.e++, me[0] == c && (me[0] = 1));
                  break;
                } else {
                  if (me[fe] += $, me[fe] != c)
                    break;
                  me[fe--] = 0, $ = 1;
                }
            for (Y = me.length; me[--Y] === 0; me.pop())
              ;
          }
          N.e > U ? N.c = N.e = null : N.e < L && (N.c = [N.e = 0]);
        }
        return N;
      }
      function Ce(N) {
        var F, z = N.e;
        return z === null ? N.toString() : (F = g(N.c), F = z <= we || z >= V ? w(F, z) : A(F, z, "0"), N.s < 0 ? "-" + F : F);
      }
      return I.absoluteValue = I.abs = function() {
        var N = new B(this);
        return N.s < 0 && (N.s = 1), N;
      }, I.comparedTo = function(N, F) {
        return y(this, new B(N, F));
      }, I.decimalPlaces = I.dp = function(N, F) {
        var z, ne, ee, Y = this;
        if (N != null)
          return v(N, 0, p), F == null ? F = J : v(F, 0, 8), _e(new B(Y), N + Y.e + 1, F);
        if (!(z = Y.c))
          return null;
        if (ne = ((ee = z.length - 1) - h(this.e / l)) * l, ee = z[ee])
          for (; ee % 10 == 0; ee /= 10, ne--)
            ;
        return ne < 0 && (ne = 0), ne;
      }, I.dividedBy = I.div = function(N, F) {
        return x(this, new B(N, F), Q, J);
      }, I.dividedToIntegerBy = I.idiv = function(N, F) {
        return x(this, new B(N, F), 0, 1);
      }, I.exponentiatedBy = I.pow = function(N, F) {
        var z, ne, ee, Y, X, $, ie, fe, oe, me = this;
        if (N = new B(N), N.c && !N.isInteger())
          throw Error(o + "Exponent not an integer: " + Ce(N));
        if (F != null && (F = new B(F)), $ = N.e > 14, !me.c || !me.c[0] || me.c[0] == 1 && !me.e && me.c.length == 1 || !N.c || !N.c[0])
          return oe = new B(Math.pow(+Ce(me), $ ? N.s * (2 - b(N)) : +Ce(N))), F ? oe.mod(F) : oe;
        if (ie = N.s < 0, F) {
          if (F.c ? !F.c[0] : !F.s)
            return new B(NaN);
          ne = !ie && me.isInteger() && F.isInteger(), ne && (me = me.mod(F));
        } else {
          if (N.e > 9 && (me.e > 0 || me.e < -1 || (me.e == 0 ? me.c[0] > 1 || $ && me.c[1] >= 24e7 : me.c[0] < 8e13 || $ && me.c[0] <= 9999975e7)))
            return Y = me.s < 0 && b(N) ? -0 : 0, me.e > -1 && (Y = 1 / Y), new B(ie ? 1 / Y : Y);
          ae && (Y = i(ae / l + 2));
        }
        for ($ ? (z = new B(0.5), ie && (N.s = 1), fe = b(N)) : (ee = Math.abs(+Ce(N)), fe = ee % 2), oe = new B(R); ; ) {
          if (fe) {
            if (oe = oe.times(me), !oe.c)
              break;
            Y ? oe.c.length > Y && (oe.c.length = Y) : ne && (oe = oe.mod(F));
          }
          if (ee) {
            if (ee = s(ee / 2), ee === 0)
              break;
            fe = ee % 2;
          } else if (N = N.times(z), _e(N, N.e + 1, 1), N.e > 14)
            fe = b(N);
          else {
            if (ee = +Ce(N), ee === 0)
              break;
            fe = ee % 2;
          }
          me = me.times(me), Y ? me.c && me.c.length > Y && (me.c.length = Y) : ne && (me = me.mod(F));
        }
        return ne ? oe : (ie && (oe = R.div(oe)), F ? oe.mod(F) : Y ? _e(oe, ae, J, X) : oe);
      }, I.integerValue = function(N) {
        var F = new B(this);
        return N == null ? N = J : v(N, 0, 8), _e(F, F.e + 1, N);
      }, I.isEqualTo = I.eq = function(N, F) {
        return y(this, new B(N, F)) === 0;
      }, I.isFinite = function() {
        return !!this.c;
      }, I.isGreaterThan = I.gt = function(N, F) {
        return y(this, new B(N, F)) > 0;
      }, I.isGreaterThanOrEqualTo = I.gte = function(N, F) {
        return (F = y(this, new B(N, F))) === 1 || F === 0;
      }, I.isInteger = function() {
        return !!this.c && h(this.e / l) > this.c.length - 2;
      }, I.isLessThan = I.lt = function(N, F) {
        return y(this, new B(N, F)) < 0;
      }, I.isLessThanOrEqualTo = I.lte = function(N, F) {
        return (F = y(this, new B(N, F))) === -1 || F === 0;
      }, I.isNaN = function() {
        return !this.s;
      }, I.isNegative = function() {
        return this.s < 0;
      }, I.isPositive = function() {
        return this.s > 0;
      }, I.isZero = function() {
        return !!this.c && this.c[0] == 0;
      }, I.minus = function(N, F) {
        var z, ne, ee, Y, X = this, $ = X.s;
        if (N = new B(N, F), F = N.s, !$ || !F)
          return new B(NaN);
        if ($ != F)
          return N.s = -F, X.plus(N);
        var ie = X.e / l, fe = N.e / l, oe = X.c, me = N.c;
        if (!ie || !fe) {
          if (!oe || !me)
            return oe ? (N.s = -F, N) : new B(me ? X : NaN);
          if (!oe[0] || !me[0])
            return me[0] ? (N.s = -F, N) : new B(oe[0] ? X : (
              // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
              J == 3 ? -0 : 0
            ));
        }
        if (ie = h(ie), fe = h(fe), oe = oe.slice(), $ = ie - fe) {
          for ((Y = $ < 0) ? ($ = -$, ee = oe) : (fe = ie, ee = me), ee.reverse(), F = $; F--; ee.push(0))
            ;
          ee.reverse();
        } else
          for (ne = (Y = ($ = oe.length) < (F = me.length)) ? $ : F, $ = F = 0; F < ne; F++)
            if (oe[F] != me[F]) {
              Y = oe[F] < me[F];
              break;
            }
        if (Y && (ee = oe, oe = me, me = ee, N.s = -N.s), F = (ne = me.length) - (z = oe.length), F > 0)
          for (; F--; oe[z++] = 0)
            ;
        for (F = c - 1; ne > $; ) {
          if (oe[--ne] < me[ne]) {
            for (z = ne; z && !oe[--z]; oe[z] = F)
              ;
            --oe[z], oe[ne] += c;
          }
          oe[ne] -= me[ne];
        }
        for (; oe[0] == 0; oe.splice(0, 1), --fe)
          ;
        return oe[0] ? Ne(N, oe, fe) : (N.s = J == 3 ? -1 : 1, N.c = [N.e = 0], N);
      }, I.modulo = I.mod = function(N, F) {
        var z, ne, ee = this;
        return N = new B(N, F), !ee.c || !N.s || N.c && !N.c[0] ? new B(NaN) : !N.c || ee.c && !ee.c[0] ? new B(ee) : (G == 9 ? (ne = N.s, N.s = 1, z = x(ee, N, 0, 3), N.s = ne, z.s *= ne) : z = x(ee, N, 0, G), N = ee.minus(z.times(N)), !N.c[0] && G == 1 && (N.s = ee.s), N);
      }, I.multipliedBy = I.times = function(N, F) {
        var z, ne, ee, Y, X, $, ie, fe, oe, me, Me, je, Ye, Oe, De, Te = this, Fe = Te.c, lt = (N = new B(N, F)).c;
        if (!Fe || !lt || !Fe[0] || !lt[0])
          return !Te.s || !N.s || Fe && !Fe[0] && !lt || lt && !lt[0] && !Fe ? N.c = N.e = N.s = null : (N.s *= Te.s, !Fe || !lt ? N.c = N.e = null : (N.c = [0], N.e = 0)), N;
        for (ne = h(Te.e / l) + h(N.e / l), N.s *= Te.s, ie = Fe.length, me = lt.length, ie < me && (Ye = Fe, Fe = lt, lt = Ye, ee = ie, ie = me, me = ee), ee = ie + me, Ye = []; ee--; Ye.push(0))
          ;
        for (Oe = c, De = f, ee = me; --ee >= 0; ) {
          for (z = 0, Me = lt[ee] % De, je = lt[ee] / De | 0, X = ie, Y = ee + X; Y > ee; )
            fe = Fe[--X] % De, oe = Fe[X] / De | 0, $ = je * fe + oe * Me, fe = Me * fe + $ % De * De + Ye[Y] + z, z = (fe / Oe | 0) + ($ / De | 0) + je * oe, Ye[Y--] = fe % Oe;
          Ye[Y] = z;
        }
        return z ? ++ne : Ye.splice(0, 1), Ne(N, Ye, ne);
      }, I.negated = function() {
        var N = new B(this);
        return N.s = -N.s || null, N;
      }, I.plus = function(N, F) {
        var z, ne = this, ee = ne.s;
        if (N = new B(N, F), F = N.s, !ee || !F)
          return new B(NaN);
        if (ee != F)
          return N.s = -F, ne.minus(N);
        var Y = ne.e / l, X = N.e / l, $ = ne.c, ie = N.c;
        if (!Y || !X) {
          if (!$ || !ie)
            return new B(ee / 0);
          if (!$[0] || !ie[0])
            return ie[0] ? N : new B($[0] ? ne : ee * 0);
        }
        if (Y = h(Y), X = h(X), $ = $.slice(), ee = Y - X) {
          for (ee > 0 ? (X = Y, z = ie) : (ee = -ee, z = $), z.reverse(); ee--; z.push(0))
            ;
          z.reverse();
        }
        for (ee = $.length, F = ie.length, ee - F < 0 && (z = ie, ie = $, $ = z, F = ee), ee = 0; F; )
          ee = ($[--F] = $[F] + ie[F] + ee) / c | 0, $[F] = c === $[F] ? 0 : $[F] % c;
        return ee && ($ = [ee].concat($), ++X), Ne(N, $, X);
      }, I.precision = I.sd = function(N, F) {
        var z, ne, ee, Y = this;
        if (N != null && N !== !!N)
          return v(N, 1, p), F == null ? F = J : v(F, 0, 8), _e(new B(Y), N, F);
        if (!(z = Y.c))
          return null;
        if (ee = z.length - 1, ne = ee * l + 1, ee = z[ee]) {
          for (; ee % 10 == 0; ee /= 10, ne--)
            ;
          for (ee = z[0]; ee >= 10; ee /= 10, ne++)
            ;
        }
        return N && Y.e + 1 > ne && (ne = Y.e + 1), ne;
      }, I.shiftedBy = function(N) {
        return v(N, -u, u), this.times("1e" + N);
      }, I.squareRoot = I.sqrt = function() {
        var N, F, z, ne, ee, Y = this, X = Y.c, $ = Y.s, ie = Y.e, fe = Q + 4, oe = new B("0.5");
        if ($ !== 1 || !X || !X[0])
          return new B(!$ || $ < 0 && (!X || X[0]) ? NaN : X ? Y : 1 / 0);
        if ($ = Math.sqrt(+Ce(Y)), $ == 0 || $ == 1 / 0 ? (F = g(X), (F.length + ie) % 2 == 0 && (F += "0"), $ = Math.sqrt(+F), ie = h((ie + 1) / 2) - (ie < 0 || ie % 2), $ == 1 / 0 ? F = "5e" + ie : (F = $.toExponential(), F = F.slice(0, F.indexOf("e") + 1) + ie), z = new B(F)) : z = new B($ + ""), z.c[0]) {
          for (ie = z.e, $ = ie + fe, $ < 3 && ($ = 0); ; )
            if (ee = z, z = oe.times(ee.plus(x(Y, ee, fe, 1))), g(ee.c).slice(0, $) === (F = g(z.c)).slice(0, $))
              if (z.e < ie && --$, F = F.slice($ - 3, $ + 1), F == "9999" || !ne && F == "4999") {
                if (!ne && (_e(ee, ee.e + Q + 2, 0), ee.times(ee).eq(Y))) {
                  z = ee;
                  break;
                }
                fe += 4, $ += 4, ne = 1;
              } else {
                (!+F || !+F.slice(1) && F.charAt(0) == "5") && (_e(z, z.e + Q + 2, 1), N = !z.times(z).eq(Y));
                break;
              }
        }
        return _e(z, z.e + Q + 1, J, N);
      }, I.toExponential = function(N, F) {
        return N != null && (v(N, 0, p), N++), be(this, N, F, 1);
      }, I.toFixed = function(N, F) {
        return N != null && (v(N, 0, p), N = N + this.e + 1), be(this, N, F);
      }, I.toFormat = function(N, F, z) {
        var ne, ee = this;
        if (z == null)
          N != null && F && typeof F == "object" ? (z = F, F = null) : N && typeof N == "object" ? (z = N, N = F = null) : z = ge;
        else if (typeof z != "object")
          throw Error(o + "Argument not an object: " + z);
        if (ne = ee.toFixed(N, F), ee.c) {
          var Y, X = ne.split("."), $ = +z.groupSize, ie = +z.secondaryGroupSize, fe = z.groupSeparator || "", oe = X[0], me = X[1], Me = ee.s < 0, je = Me ? oe.slice(1) : oe, Ye = je.length;
          if (ie && (Y = $, $ = ie, ie = Y, Ye -= Y), $ > 0 && Ye > 0) {
            for (Y = Ye % $ || $, oe = je.substr(0, Y); Y < Ye; Y += $)
              oe += fe + je.substr(Y, $);
            ie > 0 && (oe += fe + je.slice(Y)), Me && (oe = "-" + oe);
          }
          ne = me ? oe + (z.decimalSeparator || "") + ((ie = +z.fractionGroupSize) ? me.replace(
            new RegExp("\\d{" + ie + "}\\B", "g"),
            "$&" + (z.fractionGroupSeparator || "")
          ) : me) : oe;
        }
        return (z.prefix || "") + ne + (z.suffix || "");
      }, I.toFraction = function(N) {
        var F, z, ne, ee, Y, X, $, ie, fe, oe, me, Me, je = this, Ye = je.c;
        if (N != null && ($ = new B(N), !$.isInteger() && ($.c || $.s !== 1) || $.lt(R)))
          throw Error(o + "Argument " + ($.isInteger() ? "out of range: " : "not an integer: ") + Ce($));
        if (!Ye)
          return new B(je);
        for (F = new B(R), fe = z = new B(R), ne = ie = new B(R), Me = g(Ye), Y = F.e = Me.length - je.e - 1, F.c[0] = d[(X = Y % l) < 0 ? l + X : X], N = !N || $.comparedTo(F) > 0 ? Y > 0 ? F : fe : $, X = U, U = 1 / 0, $ = new B(Me), ie.c[0] = 0; oe = x($, F, 0, 1), ee = z.plus(oe.times(ne)), ee.comparedTo(N) != 1; )
          z = ne, ne = ee, fe = ie.plus(oe.times(ee = fe)), ie = ee, F = $.minus(oe.times(ee = F)), $ = ee;
        return ee = x(N.minus(z), ne, 0, 1), ie = ie.plus(ee.times(fe)), z = z.plus(ee.times(ne)), ie.s = fe.s = je.s, Y = Y * 2, me = x(fe, ne, Y, J).minus(je).abs().comparedTo(
          x(ie, z, Y, J).minus(je).abs()
        ) < 1 ? [fe, ne] : [ie, z], U = X, me;
      }, I.toNumber = function() {
        return +Ce(this);
      }, I.toPrecision = function(N, F) {
        return N != null && v(N, 1, p), be(this, N, F, 2);
      }, I.toString = function(N) {
        var F, z = this, ne = z.s, ee = z.e;
        return ee === null ? ne ? (F = "Infinity", ne < 0 && (F = "-" + F)) : F = "NaN" : (N == null ? F = ee <= we || ee >= V ? w(g(z.c), ee) : A(g(z.c), ee, "0") : N === 10 && he ? (z = _e(new B(z), Q + ee + 1, J), F = A(g(z.c), z.e, "0")) : (v(N, 2, Ae.length, "Base"), F = S(A(g(z.c), ee, "0"), 10, N, ne, !0)), ne < 0 && z.c[0] && (F = "-" + F)), F;
      }, I.valueOf = I.toJSON = function() {
        return Ce(this);
      }, I._isBigNumber = !0, E != null && B.set(E), B;
    }
    function h(E) {
      var x = E | 0;
      return E > 0 || E === x ? x : x - 1;
    }
    function g(E) {
      for (var x, S, P = 1, I = E.length, R = E[0] + ""; P < I; ) {
        for (x = E[P++] + "", S = l - x.length; S--; x = "0" + x)
          ;
        R += x;
      }
      for (I = R.length; R.charCodeAt(--I) === 48; )
        ;
      return R.slice(0, I + 1 || 1);
    }
    function y(E, x) {
      var S, P, I = E.c, R = x.c, Q = E.s, J = x.s, we = E.e, V = x.e;
      if (!Q || !J)
        return null;
      if (S = I && !I[0], P = R && !R[0], S || P)
        return S ? P ? 0 : -J : Q;
      if (Q != J)
        return Q;
      if (S = Q < 0, P = we == V, !I || !R)
        return P ? 0 : !I ^ S ? 1 : -1;
      if (!P)
        return we > V ^ S ? 1 : -1;
      for (J = (we = I.length) < (V = R.length) ? we : V, Q = 0; Q < J; Q++)
        if (I[Q] != R[Q])
          return I[Q] > R[Q] ^ S ? 1 : -1;
      return we == V ? 0 : we > V ^ S ? 1 : -1;
    }
    function v(E, x, S, P) {
      if (E < x || E > S || E !== s(E))
        throw Error(o + (P || "Argument") + (typeof E == "number" ? E < x || E > S ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(E));
    }
    function b(E) {
      var x = E.c.length - 1;
      return h(E.e / l) == x && E.c[x] % 2 != 0;
    }
    function w(E, x) {
      return (E.length > 1 ? E.charAt(0) + "." + E.slice(1) : E) + (x < 0 ? "e" : "e+") + x;
    }
    function A(E, x, S) {
      var P, I;
      if (x < 0) {
        for (I = S + "."; ++x; I += S)
          ;
        E = I + E;
      } else if (P = E.length, ++x > P) {
        for (I = S, x -= P; --x; I += S)
          ;
        E += I;
      } else
        x < P && (E = E.slice(0, x) + "." + E.slice(x));
      return E;
    }
    n = m(), n.default = n.BigNumber = n, e.exports ? e.exports = n : (t || (t = typeof self < "u" && self ? self : window), t.BigNumber = n);
  })(im);
})(Pq);
var NE = Pq.exports, lke = function(t, n, r) {
  var i = new t.Uint8Array(r), s = n.pushInt, o = n.pushInt32, a = n.pushInt32Neg, c = n.pushInt64, l = n.pushInt64Neg, u = n.pushFloat, d = n.pushFloatSingle, f = n.pushFloatDouble, p = n.pushTrue, m = n.pushFalse, h = n.pushUndefined, g = n.pushNull, y = n.pushInfinity, v = n.pushInfinityNeg, b = n.pushNaN, w = n.pushNaNNeg, A = n.pushArrayStart, E = n.pushArrayStartFixed, x = n.pushArrayStartFixed32, S = n.pushArrayStartFixed64, P = n.pushObjectStart, I = n.pushObjectStartFixed, R = n.pushObjectStartFixed32, Q = n.pushObjectStartFixed64, J = n.pushByteString, we = n.pushByteStringStart, V = n.pushUtf8String, L = n.pushUtf8StringStart, U = n.pushSimpleUnassigned, q = n.pushTagStart, G = n.pushTagStart4, ae = n.pushTagStart8, ge = n.pushTagUnassigned, Ae = n.pushBreak, he = t.Math.pow, B = 0, be = 0, Be = 0;
  function Ne(te) {
    for (te = te | 0, B = 0, be = te; (B | 0) < (be | 0) && (Be = jf[i[B] & 255](i[B] | 0) | 0, !((Be | 0) > 0)); )
      ;
    return Be | 0;
  }
  function _e(te) {
    return te = te | 0, ((B | 0) + (te | 0) | 0) < (be | 0) ? 0 : 1;
  }
  function Ce(te) {
    return te = te | 0, i[te | 0] << 8 | i[te + 1 | 0] | 0;
  }
  function N(te) {
    return te = te | 0, i[te | 0] << 24 | i[te + 1 | 0] << 16 | i[te + 2 | 0] << 8 | i[te + 3 | 0] | 0;
  }
  function F(te) {
    return te = te | 0, s(te | 0), B = B + 1 | 0, 0;
  }
  function z(te) {
    return te = te | 0, _e(1) | 0 ? 1 : (s(i[B + 1 | 0] | 0), B = B + 2 | 0, 0);
  }
  function ne(te) {
    return te = te | 0, _e(2) | 0 ? 1 : (s(
      Ce(B + 1 | 0) | 0
    ), B = B + 3 | 0, 0);
  }
  function ee(te) {
    return te = te | 0, _e(4) | 0 ? 1 : (o(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0
    ), B = B + 5 | 0, 0);
  }
  function Y(te) {
    return te = te | 0, _e(8) | 0 ? 1 : (c(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0,
      Ce(B + 5 | 0) | 0,
      Ce(B + 7 | 0) | 0
    ), B = B + 9 | 0, 0);
  }
  function X(te) {
    return te = te | 0, s(-1 - (te - 32 | 0) | 0), B = B + 1 | 0, 0;
  }
  function $(te) {
    return te = te | 0, _e(1) | 0 ? 1 : (s(
      -1 - (i[B + 1 | 0] | 0) | 0
    ), B = B + 2 | 0, 0);
  }
  function ie(te) {
    te = te | 0;
    var bt = 0;
    return _e(2) | 0 ? 1 : (bt = Ce(B + 1 | 0) | 0, s(-1 - (bt | 0) | 0), B = B + 3 | 0, 0);
  }
  function fe(te) {
    return te = te | 0, _e(4) | 0 ? 1 : (a(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0
    ), B = B + 5 | 0, 0);
  }
  function oe(te) {
    return te = te | 0, _e(8) | 0 ? 1 : (l(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0,
      Ce(B + 5 | 0) | 0,
      Ce(B + 7 | 0) | 0
    ), B = B + 9 | 0, 0);
  }
  function me(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return mt = te - 64 | 0, _e(mt | 0) | 0 ? 1 : (bt = B + 1 | 0, It = (B + 1 | 0) + (mt | 0) | 0, J(bt | 0, It | 0), B = It | 0, 0);
  }
  function Me(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return _e(1) | 0 || (mt = i[B + 1 | 0] | 0, bt = B + 2 | 0, It = (B + 2 | 0) + (mt | 0) | 0, _e(mt + 1 | 0) | 0) ? 1 : (J(bt | 0, It | 0), B = It | 0, 0);
  }
  function je(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return _e(2) | 0 || (mt = Ce(B + 1 | 0) | 0, bt = B + 3 | 0, It = (B + 3 | 0) + (mt | 0) | 0, _e(mt + 2 | 0) | 0) ? 1 : (J(bt | 0, It | 0), B = It | 0, 0);
  }
  function Ye(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return _e(4) | 0 || (mt = N(B + 1 | 0) | 0, bt = B + 5 | 0, It = (B + 5 | 0) + (mt | 0) | 0, _e(mt + 4 | 0) | 0) ? 1 : (J(bt | 0, It | 0), B = It | 0, 0);
  }
  function Oe(te) {
    return te = te | 0, 1;
  }
  function De(te) {
    return te = te | 0, we(), B = B + 1 | 0, 0;
  }
  function Te(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return mt = te - 96 | 0, _e(mt | 0) | 0 ? 1 : (bt = B + 1 | 0, It = (B + 1 | 0) + (mt | 0) | 0, V(bt | 0, It | 0), B = It | 0, 0);
  }
  function Fe(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return _e(1) | 0 || (mt = i[B + 1 | 0] | 0, bt = B + 2 | 0, It = (B + 2 | 0) + (mt | 0) | 0, _e(mt + 1 | 0) | 0) ? 1 : (V(bt | 0, It | 0), B = It | 0, 0);
  }
  function lt(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return _e(2) | 0 || (mt = Ce(B + 1 | 0) | 0, bt = B + 3 | 0, It = (B + 3 | 0) + (mt | 0) | 0, _e(mt + 2 | 0) | 0) ? 1 : (V(bt | 0, It | 0), B = It | 0, 0);
  }
  function O(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 0;
    return _e(4) | 0 || (mt = N(B + 1 | 0) | 0, bt = B + 5 | 0, It = (B + 5 | 0) + (mt | 0) | 0, _e(mt + 4 | 0) | 0) ? 1 : (V(bt | 0, It | 0), B = It | 0, 0);
  }
  function _(te) {
    return te = te | 0, 1;
  }
  function T(te) {
    return te = te | 0, L(), B = B + 1 | 0, 0;
  }
  function M(te) {
    return te = te | 0, E(te - 128 | 0), B = B + 1 | 0, 0;
  }
  function se(te) {
    return te = te | 0, _e(1) | 0 ? 1 : (E(i[B + 1 | 0] | 0), B = B + 2 | 0, 0);
  }
  function H(te) {
    return te = te | 0, _e(2) | 0 ? 1 : (E(
      Ce(B + 1 | 0) | 0
    ), B = B + 3 | 0, 0);
  }
  function ue(te) {
    return te = te | 0, _e(4) | 0 ? 1 : (x(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0
    ), B = B + 5 | 0, 0);
  }
  function Ee(te) {
    return te = te | 0, _e(8) | 0 ? 1 : (S(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0,
      Ce(B + 5 | 0) | 0,
      Ce(B + 7 | 0) | 0
    ), B = B + 9 | 0, 0);
  }
  function Xe(te) {
    return te = te | 0, A(), B = B + 1 | 0, 0;
  }
  function Ge(te) {
    te = te | 0;
    var bt = 0;
    return bt = te - 160 | 0, _e(bt | 0) | 0 ? 1 : (I(bt | 0), B = B + 1 | 0, 0);
  }
  function it(te) {
    return te = te | 0, _e(1) | 0 ? 1 : (I(i[B + 1 | 0] | 0), B = B + 2 | 0, 0);
  }
  function et(te) {
    return te = te | 0, _e(2) | 0 ? 1 : (I(
      Ce(B + 1 | 0) | 0
    ), B = B + 3 | 0, 0);
  }
  function rn(te) {
    return te = te | 0, _e(4) | 0 ? 1 : (R(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0
    ), B = B + 5 | 0, 0);
  }
  function Vt(te) {
    return te = te | 0, _e(8) | 0 ? 1 : (Q(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0,
      Ce(B + 5 | 0) | 0,
      Ce(B + 7 | 0) | 0
    ), B = B + 9 | 0, 0);
  }
  function xt(te) {
    return te = te | 0, P(), B = B + 1 | 0, 0;
  }
  function Bt(te) {
    return te = te | 0, q(te - 192 | 0 | 0), B = B + 1 | 0, 0;
  }
  function Kr(te) {
    return te = te | 0, q(te | 0), B = B + 1 | 0, 0;
  }
  function Ta(te) {
    return te = te | 0, q(te | 0), B = B + 1 | 0, 0;
  }
  function yi(te) {
    return te = te | 0, q(te | 0), B = B + 1 | 0, 0;
  }
  function an(te) {
    return te = te | 0, q(te | 0), B = B + 1 | 0, 0;
  }
  function Gt(te) {
    return te = te | 0, q(te - 192 | 0 | 0), B = B + 1 | 0, 0;
  }
  function rs(te) {
    return te = te | 0, q(te | 0), B = B + 1 | 0, 0;
  }
  function ar(te) {
    return te = te | 0, q(te | 0), B = B + 1 | 0, 0;
  }
  function _o(te) {
    return te = te | 0, q(te | 0), B = B + 1 | 0, 0;
  }
  function So(te) {
    return te = te | 0, _e(1) | 0 ? 1 : (q(i[B + 1 | 0] | 0), B = B + 2 | 0, 0);
  }
  function Gn(te) {
    return te = te | 0, _e(2) | 0 ? 1 : (q(
      Ce(B + 1 | 0) | 0
    ), B = B + 3 | 0, 0);
  }
  function ka(te) {
    return te = te | 0, _e(4) | 0 ? 1 : (G(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0
    ), B = B + 5 | 0, 0);
  }
  function Nc(te) {
    return te = te | 0, _e(8) | 0 ? 1 : (ae(
      Ce(B + 1 | 0) | 0,
      Ce(B + 3 | 0) | 0,
      Ce(B + 5 | 0) | 0,
      Ce(B + 7 | 0) | 0
    ), B = B + 9 | 0, 0);
  }
  function yn(te) {
    return te = te | 0, U((te | 0) - 224 | 0), B = B + 1 | 0, 0;
  }
  function Nf(te) {
    return te = te | 0, m(), B = B + 1 | 0, 0;
  }
  function _u(te) {
    return te = te | 0, p(), B = B + 1 | 0, 0;
  }
  function js(te) {
    return te = te | 0, g(), B = B + 1 | 0, 0;
  }
  function Su(te) {
    return te = te | 0, h(), B = B + 1 | 0, 0;
  }
  function Rf(te) {
    return te = te | 0, _e(1) | 0 ? 1 : (U(i[B + 1 | 0] | 0), B = B + 2 | 0, 0);
  }
  function Mf(te) {
    te = te | 0;
    var bt = 0, It = 0, mt = 1, To = 0, Cu = 0, OB = 0;
    return _e(2) | 0 ? 1 : (bt = i[B + 1 | 0] | 0, It = i[B + 2 | 0] | 0, (bt | 0) & 128 && (mt = -1), To = +(((bt | 0) & 124) >> 2), Cu = +(((bt | 0) & 3) << 8 | It), +To == 0 ? u(+(+mt * 5960464477539063e-23 * +Cu)) : +To == 31 ? +mt == 1 ? +Cu > 0 ? b() : y() : +Cu > 0 ? w() : v() : u(+(+mt * he(2, +(+To - 25)) * +(1024 + Cu))), B = B + 3 | 0, 0);
  }
  function Ba(te) {
    return te = te | 0, _e(4) | 0 ? 1 : (d(
      i[B + 1 | 0] | 0,
      i[B + 2 | 0] | 0,
      i[B + 3 | 0] | 0,
      i[B + 4 | 0] | 0
    ), B = B + 5 | 0, 0);
  }
  function Ff(te) {
    return te = te | 0, _e(8) | 0 ? 1 : (f(
      i[B + 1 | 0] | 0,
      i[B + 2 | 0] | 0,
      i[B + 3 | 0] | 0,
      i[B + 4 | 0] | 0,
      i[B + 5 | 0] | 0,
      i[B + 6 | 0] | 0,
      i[B + 7 | 0] | 0,
      i[B + 8 | 0] | 0
    ), B = B + 9 | 0, 0);
  }
  function Dt(te) {
    return te = te | 0, 1;
  }
  function Co(te) {
    return te = te | 0, Ae(), B = B + 1 | 0, 0;
  }
  var jf = [
    // Integer 0x00..0x17 (0..23)
    F,
    // 0x00
    F,
    // 0x01
    F,
    // 0x02
    F,
    // 0x03
    F,
    // 0x04
    F,
    // 0x05
    F,
    // 0x06
    F,
    // 0x07
    F,
    // 0x08
    F,
    // 0x09
    F,
    // 0x0A
    F,
    // 0x0B
    F,
    // 0x0C
    F,
    // 0x0D
    F,
    // 0x0E
    F,
    // 0x0F
    F,
    // 0x10
    F,
    // 0x11
    F,
    // 0x12
    F,
    // 0x13
    F,
    // 0x14
    F,
    // 0x15
    F,
    // 0x16
    F,
    // 0x17
    // Unsigned integer (one-byte uint8_t follows)
    z,
    // 0x18
    // Unsigned integer (two-byte uint16_t follows)
    ne,
    // 0x19
    // Unsigned integer (four-byte uint32_t follows)
    ee,
    // 0x1a
    // Unsigned integer (eight-byte uint64_t follows)
    Y,
    // 0x1b
    Dt,
    // 0x1c
    Dt,
    // 0x1d
    Dt,
    // 0x1e
    Dt,
    // 0x1f
    // Negative integer -1-0x00..-1-0x17 (-1..-24)
    X,
    // 0x20
    X,
    // 0x21
    X,
    // 0x22
    X,
    // 0x23
    X,
    // 0x24
    X,
    // 0x25
    X,
    // 0x26
    X,
    // 0x27
    X,
    // 0x28
    X,
    // 0x29
    X,
    // 0x2A
    X,
    // 0x2B
    X,
    // 0x2C
    X,
    // 0x2D
    X,
    // 0x2E
    X,
    // 0x2F
    X,
    // 0x30
    X,
    // 0x31
    X,
    // 0x32
    X,
    // 0x33
    X,
    // 0x34
    X,
    // 0x35
    X,
    // 0x36
    X,
    // 0x37
    // Negative integer -1-n (one-byte uint8_t for n follows)
    $,
    // 0x38
    // Negative integer -1-n (two-byte uint16_t for n follows)
    ie,
    // 0x39
    // Negative integer -1-n (four-byte uint32_t for nfollows)
    fe,
    // 0x3a
    // Negative integer -1-n (eight-byte uint64_t for n follows)
    oe,
    // 0x3b
    Dt,
    // 0x3c
    Dt,
    // 0x3d
    Dt,
    // 0x3e
    Dt,
    // 0x3f
    // byte string (0x00..0x17 bytes follow)
    me,
    // 0x40
    me,
    // 0x41
    me,
    // 0x42
    me,
    // 0x43
    me,
    // 0x44
    me,
    // 0x45
    me,
    // 0x46
    me,
    // 0x47
    me,
    // 0x48
    me,
    // 0x49
    me,
    // 0x4A
    me,
    // 0x4B
    me,
    // 0x4C
    me,
    // 0x4D
    me,
    // 0x4E
    me,
    // 0x4F
    me,
    // 0x50
    me,
    // 0x51
    me,
    // 0x52
    me,
    // 0x53
    me,
    // 0x54
    me,
    // 0x55
    me,
    // 0x56
    me,
    // 0x57
    // byte string (one-byte uint8_t for n, and then n bytes follow)
    Me,
    // 0x58
    // byte string (two-byte uint16_t for n, and then n bytes follow)
    je,
    // 0x59
    // byte string (four-byte uint32_t for n, and then n bytes follow)
    Ye,
    // 0x5a
    // byte string (eight-byte uint64_t for n, and then n bytes follow)
    Oe,
    // 0x5b
    Dt,
    // 0x5c
    Dt,
    // 0x5d
    Dt,
    // 0x5e
    // byte string, byte strings follow, terminated by "break"
    De,
    // 0x5f
    // UTF-8 string (0x00..0x17 bytes follow)
    Te,
    // 0x60
    Te,
    // 0x61
    Te,
    // 0x62
    Te,
    // 0x63
    Te,
    // 0x64
    Te,
    // 0x65
    Te,
    // 0x66
    Te,
    // 0x67
    Te,
    // 0x68
    Te,
    // 0x69
    Te,
    // 0x6A
    Te,
    // 0x6B
    Te,
    // 0x6C
    Te,
    // 0x6D
    Te,
    // 0x6E
    Te,
    // 0x6F
    Te,
    // 0x70
    Te,
    // 0x71
    Te,
    // 0x72
    Te,
    // 0x73
    Te,
    // 0x74
    Te,
    // 0x75
    Te,
    // 0x76
    Te,
    // 0x77
    // UTF-8 string (one-byte uint8_t for n, and then n bytes follow)
    Fe,
    // 0x78
    // UTF-8 string (two-byte uint16_t for n, and then n bytes follow)
    lt,
    // 0x79
    // UTF-8 string (four-byte uint32_t for n, and then n bytes follow)
    O,
    // 0x7a
    // UTF-8 string (eight-byte uint64_t for n, and then n bytes follow)
    _,
    // 0x7b
    // UTF-8 string, UTF-8 strings follow, terminated by "break"
    Dt,
    // 0x7c
    Dt,
    // 0x7d
    Dt,
    // 0x7e
    T,
    // 0x7f
    // array (0x00..0x17 data items follow)
    M,
    // 0x80
    M,
    // 0x81
    M,
    // 0x82
    M,
    // 0x83
    M,
    // 0x84
    M,
    // 0x85
    M,
    // 0x86
    M,
    // 0x87
    M,
    // 0x88
    M,
    // 0x89
    M,
    // 0x8A
    M,
    // 0x8B
    M,
    // 0x8C
    M,
    // 0x8D
    M,
    // 0x8E
    M,
    // 0x8F
    M,
    // 0x90
    M,
    // 0x91
    M,
    // 0x92
    M,
    // 0x93
    M,
    // 0x94
    M,
    // 0x95
    M,
    // 0x96
    M,
    // 0x97
    // array (one-byte uint8_t fo, and then n data items follow)
    se,
    // 0x98
    // array (two-byte uint16_t for n, and then n data items follow)
    H,
    // 0x99
    // array (four-byte uint32_t for n, and then n data items follow)
    ue,
    // 0x9a
    // array (eight-byte uint64_t for n, and then n data items follow)
    Ee,
    // 0x9b
    // array, data items follow, terminated by "break"
    Dt,
    // 0x9c
    Dt,
    // 0x9d
    Dt,
    // 0x9e
    Xe,
    // 0x9f
    // map (0x00..0x17 pairs of data items follow)
    Ge,
    // 0xa0
    Ge,
    // 0xa1
    Ge,
    // 0xa2
    Ge,
    // 0xa3
    Ge,
    // 0xa4
    Ge,
    // 0xa5
    Ge,
    // 0xa6
    Ge,
    // 0xa7
    Ge,
    // 0xa8
    Ge,
    // 0xa9
    Ge,
    // 0xaA
    Ge,
    // 0xaB
    Ge,
    // 0xaC
    Ge,
    // 0xaD
    Ge,
    // 0xaE
    Ge,
    // 0xaF
    Ge,
    // 0xb0
    Ge,
    // 0xb1
    Ge,
    // 0xb2
    Ge,
    // 0xb3
    Ge,
    // 0xb4
    Ge,
    // 0xb5
    Ge,
    // 0xb6
    Ge,
    // 0xb7
    // map (one-byte uint8_t for n, and then n pairs of data items follow)
    it,
    // 0xb8
    // map (two-byte uint16_t for n, and then n pairs of data items follow)
    et,
    // 0xb9
    // map (four-byte uint32_t for n, and then n pairs of data items follow)
    rn,
    // 0xba
    // map (eight-byte uint64_t for n, and then n pairs of data items follow)
    Vt,
    // 0xbb
    Dt,
    // 0xbc
    Dt,
    // 0xbd
    Dt,
    // 0xbe
    // map, pairs of data items follow, terminated by "break"
    xt,
    // 0xbf
    // Text-based date/time (data item follows; see Section 2.4.1)
    Bt,
    // 0xc0
    // Epoch-based date/time (data item follows; see Section 2.4.1)
    Bt,
    // 0xc1
    // Positive bignum (data item "byte string" follows)
    Bt,
    // 0xc2
    // Negative bignum (data item "byte string" follows)
    Bt,
    // 0xc3
    // Decimal Fraction (data item "array" follows; see Section 2.4.3)
    Bt,
    // 0xc4
    // Bigfloat (data item "array" follows; see Section 2.4.3)
    Bt,
    // 0xc5
    // (tagged item)
    Gt,
    // 0xc6
    Gt,
    // 0xc7
    Gt,
    // 0xc8
    Gt,
    // 0xc9
    Gt,
    // 0xca
    Gt,
    // 0xcb
    Gt,
    // 0xcc
    Gt,
    // 0xcd
    Gt,
    // 0xce
    Gt,
    // 0xcf
    Gt,
    // 0xd0
    Gt,
    // 0xd1
    Gt,
    // 0xd2
    Gt,
    // 0xd3
    Gt,
    // 0xd4
    // Expected Conversion (data item follows; see Section 2.4.4.2)
    Gt,
    // 0xd5
    Gt,
    // 0xd6
    Gt,
    // 0xd7
    // (more tagged items, 1/2/4/8 bytes and then a data item follow)
    So,
    // 0xd8
    Gn,
    // 0xd9
    ka,
    // 0xda
    Nc,
    // 0xdb
    Dt,
    // 0xdc
    Dt,
    // 0xdd
    Dt,
    // 0xde
    Dt,
    // 0xdf
    // (simple value)
    yn,
    // 0xe0
    yn,
    // 0xe1
    yn,
    // 0xe2
    yn,
    // 0xe3
    yn,
    // 0xe4
    yn,
    // 0xe5
    yn,
    // 0xe6
    yn,
    // 0xe7
    yn,
    // 0xe8
    yn,
    // 0xe9
    yn,
    // 0xea
    yn,
    // 0xeb
    yn,
    // 0xec
    yn,
    // 0xed
    yn,
    // 0xee
    yn,
    // 0xef
    yn,
    // 0xf0
    yn,
    // 0xf1
    yn,
    // 0xf2
    yn,
    // 0xf3
    // False
    Nf,
    // 0xf4
    // True
    _u,
    // 0xf5
    // Null
    js,
    // 0xf6
    // Undefined
    Su,
    // 0xf7
    // (simple value, one byte follows)
    Rf,
    // 0xf8
    // Half-Precision Float (two-byte IEEE 754)
    Mf,
    // 0xf9
    // Single-Precision Float (four-byte IEEE 754)
    Ba,
    // 0xfa
    // Double-Precision Float (eight-byte IEEE 754)
    Ff,
    // 0xfb
    Dt,
    // 0xfc
    Dt,
    // 0xfd
    Dt,
    // 0xfe
    // "break" stop code
    Co
    // 0xff
  ];
  return {
    parse: Ne
  };
}, RE = {}, Qr = {};
const M8 = NE.BigNumber;
Qr.MT = {
  POS_INT: 0,
  NEG_INT: 1,
  BYTE_STRING: 2,
  UTF8_STRING: 3,
  ARRAY: 4,
  MAP: 5,
  TAG: 6,
  SIMPLE_FLOAT: 7
};
Qr.TAG = {
  DATE_STRING: 0,
  DATE_EPOCH: 1,
  POS_BIGINT: 2,
  NEG_BIGINT: 3,
  DECIMAL_FRAC: 4,
  BIGFLOAT: 5,
  BASE64URL_EXPECTED: 21,
  BASE64_EXPECTED: 22,
  BASE16_EXPECTED: 23,
  CBOR: 24,
  URI: 32,
  BASE64URL: 33,
  BASE64: 34,
  REGEXP: 35,
  MIME: 36
};
Qr.NUMBYTES = {
  ZERO: 0,
  ONE: 24,
  TWO: 25,
  FOUR: 26,
  EIGHT: 27,
  INDEFINITE: 31
};
Qr.SIMPLE = {
  FALSE: 20,
  TRUE: 21,
  NULL: 22,
  UNDEFINED: 23
};
Qr.SYMS = {
  NULL: Symbol("null"),
  UNDEFINED: Symbol("undef"),
  PARENT: Symbol("parent"),
  BREAK: Symbol("break"),
  STREAM: Symbol("stream")
};
Qr.SHIFT32 = Math.pow(2, 32);
Qr.SHIFT16 = Math.pow(2, 16);
Qr.MAX_SAFE_HIGH = 2097151;
Qr.NEG_ONE = new M8(-1);
Qr.TEN = new M8(10);
Qr.TWO = new M8(2);
Qr.PARENT = {
  ARRAY: 0,
  OBJECT: 1,
  MAP: 2,
  TAG: 3,
  BYTE_STRING: 4,
  UTF8_STRING: 5
};
(function(e) {
  const { Buffer: t } = qA, n = NE.BigNumber, r = Qr, i = r.SHIFT32, s = r.SHIFT16, o = 2097151;
  e.parseHalf = function(l) {
    var u, d, f;
    return f = l[0] & 128 ? -1 : 1, u = (l[0] & 124) >> 2, d = (l[0] & 3) << 8 | l[1], u ? u === 31 ? f * (d ? NaN : 1 / 0) : f * Math.pow(2, u - 25) * (1024 + d) : f * 5960464477539063e-23 * d;
  };
  function a(c) {
    return c < 16 ? "0" + c.toString(16) : c.toString(16);
  }
  e.arrayBufferToBignumber = function(c) {
    const l = c.byteLength;
    let u = "";
    for (let d = 0; d < l; d++)
      u += a(c[d]);
    return new n(u, 16);
  }, e.buildMap = (c) => {
    const l = /* @__PURE__ */ new Map(), u = Object.keys(c), d = u.length;
    for (let f = 0; f < d; f++)
      l.set(u[f], c[u[f]]);
    return l;
  }, e.buildInt32 = (c, l) => c * s + l, e.buildInt64 = (c, l, u, d) => {
    const f = e.buildInt32(c, l), p = e.buildInt32(u, d);
    return f > o ? new n(f).times(i).plus(p) : f * i + p;
  }, e.writeHalf = function(l, u) {
    const d = t.allocUnsafe(4);
    d.writeFloatBE(u, 0);
    const f = d.readUInt32BE(0);
    if (f & 8191)
      return !1;
    var p = f >> 16 & 32768;
    const m = f >> 23 & 255, h = f & 8388607;
    if (m >= 113 && m <= 142)
      p += (m - 112 << 10) + (h >> 13);
    else if (m >= 103 && m < 113) {
      if (h & (1 << 126 - m) - 1)
        return !1;
      p += h + 8388608 >> 126 - m;
    } else
      return !1;
    return l.writeUInt16BE(p, 0), !0;
  }, e.keySorter = function(c, l) {
    var u = c[0].byteLength, d = l[0].byteLength;
    return u > d ? 1 : d > u ? -1 : c[0].compare(l[0]);
  }, e.isNegativeZero = (c) => c === 0 && 1 / c < 0, e.nextPowerOf2 = (c) => {
    let l = 0;
    if (c && !(c & c - 1))
      return c;
    for (; c !== 0; )
      c >>= 1, l += 1;
    return 1 << l;
  };
})(RE);
const F8 = Qr, uke = F8.MT, j1 = F8.SIMPLE, l6 = F8.SYMS;
let dke = class lT {
  /**
   * Creates an instance of Simple.
   *
   * @param {integer} value - the simple value's integer value
   */
  constructor(t) {
    if (typeof t != "number")
      throw new Error("Invalid Simple type: " + typeof t);
    if (t < 0 || t > 255 || (t | 0) !== t)
      throw new Error("value must be a small positive integer: " + t);
    this.value = t;
  }
  /**
   * Debug string for simple value
   *
   * @returns {string} simple(value)
   */
  toString() {
    return "simple(" + this.value + ")";
  }
  /**
   * Debug string for simple value
   *
   * @returns {string} simple(value)
   */
  inspect() {
    return "simple(" + this.value + ")";
  }
  /**
   * Push the simple value onto the CBOR stream
   *
   * @param {cbor.Encoder} gen The generator to push onto
   * @returns {number}
   */
  encodeCBOR(t) {
    return t._pushInt(this.value, uke.SIMPLE_FLOAT);
  }
  /**
   * Is the given object a Simple?
   *
   * @param {any} obj - object to test
   * @returns {bool} - is it Simple?
   */
  static isSimple(t) {
    return t instanceof lT;
  }
  /**
   * Decode from the CBOR additional information into a JavaScript value.
   * If the CBOR item has no parent, return a "safe" symbol instead of
   * `null` or `undefined`, so that the value can be passed through a
   * stream in object mode.
   *
   * @param {Number} val - the CBOR additional info to convert
   * @param {bool} hasParent - Does the CBOR item have a parent?
   * @returns {(null|undefined|Boolean|Symbol)} - the decoded value
   */
  static decode(t, n) {
    switch (n == null && (n = !0), t) {
      case j1.FALSE:
        return !1;
      case j1.TRUE:
        return !0;
      case j1.NULL:
        return n ? null : l6.NULL;
      case j1.UNDEFINED:
        return n ? void 0 : l6.UNDEFINED;
      case -1:
        if (!n)
          throw new Error("Invalid BREAK");
        return l6.BREAK;
      default:
        return new lT(t);
    }
  }
};
var Oq = dke;
let fke = class uT {
  /**
   * Creates an instance of Tagged.
   *
   * @param {Number} tag - the number of the tag
   * @param {any} value - the value inside the tag
   * @param {Error} err - the error that was thrown parsing the tag, or null
   */
  constructor(t, n, r) {
    if (this.tag = t, this.value = n, this.err = r, typeof this.tag != "number")
      throw new Error("Invalid tag type (" + typeof this.tag + ")");
    if (this.tag < 0 || (this.tag | 0) !== this.tag)
      throw new Error("Tag must be a positive integer: " + this.tag);
  }
  /**
   * Convert to a String
   *
   * @returns {String} string of the form '1(2)'
   */
  toString() {
    return `${this.tag}(${JSON.stringify(this.value)})`;
  }
  /**
   * Push the simple value onto the CBOR stream
   *
   * @param {cbor.Encoder} gen The generator to push onto
   * @returns {number}
   */
  encodeCBOR(t) {
    return t._pushTag(this.tag), t.pushAny(this.value);
  }
  /**
   * If we have a converter for this type, do the conversion.  Some converters
   * are built-in.  Additional ones can be passed in.  If you want to remove
   * a built-in converter, pass a converter in whose value is 'null' instead
   * of a function.
   *
   * @param {Object} converters - keys in the object are a tag number, the value
   *   is a function that takes the decoded CBOR and returns a JavaScript value
   *   of the appropriate type.  Throw an exception in the function on errors.
   * @returns {any} - the converted item
   */
  convert(t) {
    var n, r;
    if (r = t != null ? t[this.tag] : void 0, typeof r != "function" && (r = uT["_tag" + this.tag], typeof r != "function"))
      return this;
    try {
      return r.call(uT, this.value);
    } catch (i) {
      return n = i, this.err = n, this;
    }
  }
};
var Nq = fke;
const Rq = self.location ? self.location.protocol + "//" + self.location.host : "", dT = self.URL;
let hke = class {
  constructor(t = "", n = Rq) {
    this.super = new dT(t, n), this.path = this.pathname + this.search, this.auth = this.username && this.password ? this.username + ":" + this.password : null, this.query = this.search && this.search.startsWith("?") ? this.search.slice(1) : null;
  }
  get hash() {
    return this.super.hash;
  }
  get host() {
    return this.super.host;
  }
  get hostname() {
    return this.super.hostname;
  }
  get href() {
    return this.super.href;
  }
  get origin() {
    return this.super.origin;
  }
  get password() {
    return this.super.password;
  }
  get pathname() {
    return this.super.pathname;
  }
  get port() {
    return this.super.port;
  }
  get protocol() {
    return this.super.protocol;
  }
  get search() {
    return this.super.search;
  }
  get searchParams() {
    return this.super.searchParams;
  }
  get username() {
    return this.super.username;
  }
  set hash(t) {
    this.super.hash = t;
  }
  set host(t) {
    this.super.host = t;
  }
  set hostname(t) {
    this.super.hostname = t;
  }
  set href(t) {
    this.super.href = t;
  }
  set origin(t) {
    this.super.origin = t;
  }
  set password(t) {
    this.super.password = t;
  }
  set pathname(t) {
    this.super.pathname = t;
  }
  set port(t) {
    this.super.port = t;
  }
  set protocol(t) {
    this.super.protocol = t;
  }
  set search(t) {
    this.super.search = t;
  }
  set searchParams(t) {
    this.super.searchParams = t;
  }
  set username(t) {
    this.super.username = t;
  }
  createObjectURL(t) {
    return this.super.createObjectURL(t);
  }
  revokeObjectURL(t) {
    this.super.revokeObjectURL(t);
  }
  toJSON() {
    return this.super.toJSON();
  }
  toString() {
    return this.super.toString();
  }
  format() {
    return this.toString();
  }
};
function pke(e) {
  if (typeof e == "string")
    return new dT(e).toString();
  if (!(e instanceof dT)) {
    const t = e.username && e.password ? `${e.username}:${e.password}@` : "", n = e.auth ? e.auth + "@" : "", r = e.port ? ":" + e.port : "", i = e.protocol ? e.protocol + "//" : "", s = e.host || "", o = e.hostname || "", a = e.search || (e.query ? "?" + e.query : ""), c = e.hash || "", l = e.pathname || "", u = e.path || l + a;
    return `${i}${t || n}${s || o + r}${u}${c}`;
  }
}
var Mq = {
  URLWithLegacySupport: hke,
  URLSearchParams: self.URLSearchParams,
  defaultBase: Rq,
  format: pke
};
const { URLWithLegacySupport: xR, format: mke } = Mq;
var gke = (e, t = {}, n = {}, r) => {
  let i = t.protocol ? t.protocol.replace(":", "") : "http";
  i = (n[i] || r || i) + ":";
  let s;
  try {
    s = new xR(e);
  } catch {
    s = {};
  }
  const o = Object.assign({}, t, {
    protocol: i || s.protocol,
    host: t.host || s.host
  });
  return new xR(e, mke(o)).toString();
};
const {
  URLWithLegacySupport: yke,
  format: bke,
  URLSearchParams: vke,
  defaultBase: wke
} = Mq, xke = gke;
var Fq = {
  URL: yke,
  URLSearchParams: vke,
  format: bke,
  relative: xke,
  defaultBase: wke
};
const { Buffer: Xf } = qA, AR = R8, Ake = NE.BigNumber, Eke = lke, Yr = RE, cn = Qr, _ke = Oq, Ske = Nq, { URL: Cke } = Fq;
let fT = class hT {
  /**
   * @param {Object} [opts={}]
   * @param {number} [opts.size=65536] - Size of the allocated heap.
   */
  constructor(t) {
    t = t || {}, !t.size || t.size < 65536 ? t.size = 65536 : t.size = Yr.nextPowerOf2(t.size), this._heap = new ArrayBuffer(t.size), this._heap8 = new Uint8Array(this._heap), this._buffer = Xf.from(this._heap), this._reset(), this._knownTags = Object.assign({
      0: (n) => new Date(n),
      1: (n) => new Date(n * 1e3),
      2: (n) => Yr.arrayBufferToBignumber(n),
      3: (n) => cn.NEG_ONE.minus(Yr.arrayBufferToBignumber(n)),
      4: (n) => cn.TEN.pow(n[0]).times(n[1]),
      5: (n) => cn.TWO.pow(n[0]).times(n[1]),
      32: (n) => new Cke(n),
      35: (n) => new RegExp(n)
    }, t.tags), this.parser = Eke(window, {
      // eslint-disable-next-line no-console
      log: console.log.bind(console),
      pushInt: this.pushInt.bind(this),
      pushInt32: this.pushInt32.bind(this),
      pushInt32Neg: this.pushInt32Neg.bind(this),
      pushInt64: this.pushInt64.bind(this),
      pushInt64Neg: this.pushInt64Neg.bind(this),
      pushFloat: this.pushFloat.bind(this),
      pushFloatSingle: this.pushFloatSingle.bind(this),
      pushFloatDouble: this.pushFloatDouble.bind(this),
      pushTrue: this.pushTrue.bind(this),
      pushFalse: this.pushFalse.bind(this),
      pushUndefined: this.pushUndefined.bind(this),
      pushNull: this.pushNull.bind(this),
      pushInfinity: this.pushInfinity.bind(this),
      pushInfinityNeg: this.pushInfinityNeg.bind(this),
      pushNaN: this.pushNaN.bind(this),
      pushNaNNeg: this.pushNaNNeg.bind(this),
      pushArrayStart: this.pushArrayStart.bind(this),
      pushArrayStartFixed: this.pushArrayStartFixed.bind(this),
      pushArrayStartFixed32: this.pushArrayStartFixed32.bind(this),
      pushArrayStartFixed64: this.pushArrayStartFixed64.bind(this),
      pushObjectStart: this.pushObjectStart.bind(this),
      pushObjectStartFixed: this.pushObjectStartFixed.bind(this),
      pushObjectStartFixed32: this.pushObjectStartFixed32.bind(this),
      pushObjectStartFixed64: this.pushObjectStartFixed64.bind(this),
      pushByteString: this.pushByteString.bind(this),
      pushByteStringStart: this.pushByteStringStart.bind(this),
      pushUtf8String: this.pushUtf8String.bind(this),
      pushUtf8StringStart: this.pushUtf8StringStart.bind(this),
      pushSimpleUnassigned: this.pushSimpleUnassigned.bind(this),
      pushTagUnassigned: this.pushTagUnassigned.bind(this),
      pushTagStart: this.pushTagStart.bind(this),
      pushTagStart4: this.pushTagStart4.bind(this),
      pushTagStart8: this.pushTagStart8.bind(this),
      pushBreak: this.pushBreak.bind(this)
    }, this._heap);
  }
  get _depth() {
    return this._parents.length;
  }
  get _currentParent() {
    return this._parents[this._depth - 1];
  }
  get _ref() {
    return this._currentParent.ref;
  }
  // Finish the current parent
  _closeParent() {
    var t = this._parents.pop();
    if (t.length > 0)
      throw new Error(`Missing ${t.length} elements`);
    switch (t.type) {
      case cn.PARENT.TAG:
        this._push(
          this.createTag(t.ref[0], t.ref[1])
        );
        break;
      case cn.PARENT.BYTE_STRING:
        this._push(this.createByteString(t.ref, t.length));
        break;
      case cn.PARENT.UTF8_STRING:
        this._push(this.createUtf8String(t.ref, t.length));
        break;
      case cn.PARENT.MAP:
        if (t.values % 2 > 0)
          throw new Error("Odd number of elements in the map");
        this._push(this.createMap(t.ref, t.length));
        break;
      case cn.PARENT.OBJECT:
        if (t.values % 2 > 0)
          throw new Error("Odd number of elements in the map");
        this._push(this.createObject(t.ref, t.length));
        break;
      case cn.PARENT.ARRAY:
        this._push(this.createArray(t.ref, t.length));
        break;
    }
    this._currentParent && this._currentParent.type === cn.PARENT.TAG && this._dec();
  }
  // Reduce the expected length of the current parent by one
  _dec() {
    const t = this._currentParent;
    t.length < 0 || (t.length--, t.length === 0 && this._closeParent());
  }
  // Push any value to the current parent
  _push(t, n) {
    const r = this._currentParent;
    switch (r.values++, r.type) {
      case cn.PARENT.ARRAY:
      case cn.PARENT.BYTE_STRING:
      case cn.PARENT.UTF8_STRING:
        r.length > -1 ? this._ref[this._ref.length - r.length] = t : this._ref.push(t), this._dec();
        break;
      case cn.PARENT.OBJECT:
        r.tmpKey != null ? (this._ref[r.tmpKey] = t, r.tmpKey = null, this._dec()) : (r.tmpKey = t, typeof r.tmpKey != "string" && (r.type = cn.PARENT.MAP, r.ref = Yr.buildMap(r.ref)));
        break;
      case cn.PARENT.MAP:
        r.tmpKey != null ? (this._ref.set(r.tmpKey, t), r.tmpKey = null, this._dec()) : r.tmpKey = t;
        break;
      case cn.PARENT.TAG:
        this._ref.push(t), n || this._dec();
        break;
      default:
        throw new Error("Unknown parent type");
    }
  }
  // Create a new parent in the parents list
  _createParent(t, n, r) {
    this._parents[this._depth] = {
      type: n,
      length: r,
      ref: t,
      values: 0,
      tmpKey: null
    };
  }
  // Reset all state back to the beginning, also used for initiatlization
  _reset() {
    this._res = [], this._parents = [{
      type: cn.PARENT.ARRAY,
      length: -1,
      ref: this._res,
      values: 0,
      tmpKey: null
    }];
  }
  // -- Interface to customize deoding behaviour
  createTag(t, n) {
    const r = this._knownTags[t];
    return r ? r(n) : new Ske(t, n);
  }
  createMap(t, n) {
    return t;
  }
  createObject(t, n) {
    return t;
  }
  createArray(t, n) {
    return t;
  }
  createByteString(t, n) {
    return Xf.concat(t);
  }
  createByteStringFromHeap(t, n) {
    return t === n ? Xf.alloc(0) : Xf.from(this._heap.slice(t, n));
  }
  createInt(t) {
    return t;
  }
  createInt32(t, n) {
    return Yr.buildInt32(t, n);
  }
  createInt64(t, n, r, i) {
    return Yr.buildInt64(t, n, r, i);
  }
  createFloat(t) {
    return t;
  }
  createFloatSingle(t, n, r, i) {
    return AR.read([t, n, r, i], 0, !1, 23, 4);
  }
  createFloatDouble(t, n, r, i, s, o, a, c) {
    return AR.read([t, n, r, i, s, o, a, c], 0, !1, 52, 8);
  }
  createInt32Neg(t, n) {
    return -1 - Yr.buildInt32(t, n);
  }
  createInt64Neg(t, n, r, i) {
    const s = Yr.buildInt32(t, n), o = Yr.buildInt32(r, i);
    return s > cn.MAX_SAFE_HIGH ? cn.NEG_ONE.minus(new Ake(s).times(cn.SHIFT32).plus(o)) : -1 - (s * cn.SHIFT32 + o);
  }
  createTrue() {
    return !0;
  }
  createFalse() {
    return !1;
  }
  createNull() {
    return null;
  }
  createUndefined() {
  }
  createInfinity() {
    return 1 / 0;
  }
  createInfinityNeg() {
    return -1 / 0;
  }
  createNaN() {
    return NaN;
  }
  createNaNNeg() {
    return NaN;
  }
  createUtf8String(t, n) {
    return t.join("");
  }
  createUtf8StringFromHeap(t, n) {
    return t === n ? "" : this._buffer.toString("utf8", t, n);
  }
  createSimpleUnassigned(t) {
    return new _ke(t);
  }
  // -- Interface for decoder.asm.js
  pushInt(t) {
    this._push(this.createInt(t));
  }
  pushInt32(t, n) {
    this._push(this.createInt32(t, n));
  }
  pushInt64(t, n, r, i) {
    this._push(this.createInt64(t, n, r, i));
  }
  pushFloat(t) {
    this._push(this.createFloat(t));
  }
  pushFloatSingle(t, n, r, i) {
    this._push(this.createFloatSingle(t, n, r, i));
  }
  pushFloatDouble(t, n, r, i, s, o, a, c) {
    this._push(this.createFloatDouble(t, n, r, i, s, o, a, c));
  }
  pushInt32Neg(t, n) {
    this._push(this.createInt32Neg(t, n));
  }
  pushInt64Neg(t, n, r, i) {
    this._push(this.createInt64Neg(t, n, r, i));
  }
  pushTrue() {
    this._push(this.createTrue());
  }
  pushFalse() {
    this._push(this.createFalse());
  }
  pushNull() {
    this._push(this.createNull());
  }
  pushUndefined() {
    this._push(this.createUndefined());
  }
  pushInfinity() {
    this._push(this.createInfinity());
  }
  pushInfinityNeg() {
    this._push(this.createInfinityNeg());
  }
  pushNaN() {
    this._push(this.createNaN());
  }
  pushNaNNeg() {
    this._push(this.createNaNNeg());
  }
  pushArrayStart() {
    this._createParent([], cn.PARENT.ARRAY, -1);
  }
  pushArrayStartFixed(t) {
    this._createArrayStartFixed(t);
  }
  pushArrayStartFixed32(t, n) {
    const r = Yr.buildInt32(t, n);
    this._createArrayStartFixed(r);
  }
  pushArrayStartFixed64(t, n, r, i) {
    const s = Yr.buildInt64(t, n, r, i);
    this._createArrayStartFixed(s);
  }
  pushObjectStart() {
    this._createObjectStartFixed(-1);
  }
  pushObjectStartFixed(t) {
    this._createObjectStartFixed(t);
  }
  pushObjectStartFixed32(t, n) {
    const r = Yr.buildInt32(t, n);
    this._createObjectStartFixed(r);
  }
  pushObjectStartFixed64(t, n, r, i) {
    const s = Yr.buildInt64(t, n, r, i);
    this._createObjectStartFixed(s);
  }
  pushByteStringStart() {
    this._parents[this._depth] = {
      type: cn.PARENT.BYTE_STRING,
      length: -1,
      ref: [],
      values: 0,
      tmpKey: null
    };
  }
  pushByteString(t, n) {
    this._push(this.createByteStringFromHeap(t, n));
  }
  pushUtf8StringStart() {
    this._parents[this._depth] = {
      type: cn.PARENT.UTF8_STRING,
      length: -1,
      ref: [],
      values: 0,
      tmpKey: null
    };
  }
  pushUtf8String(t, n) {
    this._push(this.createUtf8StringFromHeap(t, n));
  }
  pushSimpleUnassigned(t) {
    this._push(this.createSimpleUnassigned(t));
  }
  pushTagStart(t) {
    this._parents[this._depth] = {
      type: cn.PARENT.TAG,
      length: 1,
      ref: [t]
    };
  }
  pushTagStart4(t, n) {
    this.pushTagStart(Yr.buildInt32(t, n));
  }
  pushTagStart8(t, n, r, i) {
    this.pushTagStart(Yr.buildInt64(t, n, r, i));
  }
  pushTagUnassigned(t) {
    this._push(this.createTag(t));
  }
  pushBreak() {
    if (this._currentParent.length > -1)
      throw new Error("Unexpected break");
    this._closeParent();
  }
  _createObjectStartFixed(t) {
    if (t === 0) {
      this._push(this.createObject({}));
      return;
    }
    this._createParent({}, cn.PARENT.OBJECT, t);
  }
  _createArrayStartFixed(t) {
    if (t === 0) {
      this._push(this.createArray([]));
      return;
    }
    this._createParent(new Array(t), cn.PARENT.ARRAY, t);
  }
  _decode(t) {
    if (t.byteLength === 0)
      throw new Error("Input too short");
    this._reset(), this._heap8.set(t);
    const n = this.parser.parse(t.byteLength);
    if (this._depth > 1) {
      for (; this._currentParent.length === 0; )
        this._closeParent();
      if (this._depth > 1)
        throw new Error("Undeterminated nesting");
    }
    if (n > 0)
      throw new Error("Failed to parse");
    if (this._res.length === 0)
      throw new Error("No valid result");
  }
  // -- Public Interface
  decodeFirst(t) {
    return this._decode(t), this._res[0];
  }
  decodeAll(t) {
    return this._decode(t), this._res;
  }
  /**
   * Decode the first cbor object.
   *
   * @param {Buffer|string} input
   * @param {string} [enc='hex'] - Encoding used if a string is passed.
   * @returns {*}
   */
  static decode(t, n) {
    return typeof t == "string" && (t = Xf.from(t, n || "hex")), new hT({ size: t.length }).decodeFirst(t);
  }
  /**
   * Decode all cbor objects.
   *
   * @param {Buffer|string} input
   * @param {string} [enc='hex'] - Encoding used if a string is passed.
   * @returns {Array<*>}
   */
  static decodeAll(t, n) {
    return typeof t == "string" && (t = Xf.from(t, n || "hex")), new hT({ size: t.length }).decodeAll(t);
  }
};
fT.decodeFirst = fT.decode;
var jq = fT;
const { Buffer: u6 } = qA, Tke = jq, kke = RE;
class j8 extends Tke {
  createTag(t, n) {
    return `${t}(${n})`;
  }
  createInt(t) {
    return super.createInt(t).toString();
  }
  createInt32(t, n) {
    return super.createInt32(t, n).toString();
  }
  createInt64(t, n, r, i) {
    return super.createInt64(t, n, r, i).toString();
  }
  createInt32Neg(t, n) {
    return super.createInt32Neg(t, n).toString();
  }
  createInt64Neg(t, n, r, i) {
    return super.createInt64Neg(t, n, r, i).toString();
  }
  createTrue() {
    return "true";
  }
  createFalse() {
    return "false";
  }
  createFloat(t) {
    const n = super.createFloat(t);
    return kke.isNegativeZero(t) ? "-0_1" : `${n}_1`;
  }
  createFloatSingle(t, n, r, i) {
    return `${super.createFloatSingle(t, n, r, i)}_2`;
  }
  createFloatDouble(t, n, r, i, s, o, a, c) {
    return `${super.createFloatDouble(t, n, r, i, s, o, a, c)}_3`;
  }
  createByteString(t, n) {
    const r = t.join(", ");
    return n === -1 ? `(_ ${r})` : `h'${r}`;
  }
  createByteStringFromHeap(t, n) {
    return `h'${u6.from(
      super.createByteStringFromHeap(t, n)
    ).toString("hex")}'`;
  }
  createInfinity() {
    return "Infinity_1";
  }
  createInfinityNeg() {
    return "-Infinity_1";
  }
  createNaN() {
    return "NaN_1";
  }
  createNaNNeg() {
    return "-NaN_1";
  }
  createNull() {
    return "null";
  }
  createUndefined() {
    return "undefined";
  }
  createSimpleUnassigned(t) {
    return `simple(${t})`;
  }
  createArray(t, n) {
    const r = super.createArray(t, n);
    return n === -1 ? `[_ ${r.join(", ")}]` : `[${r.join(", ")}]`;
  }
  createMap(t, n) {
    const r = super.createMap(t), i = Array.from(r.keys()).reduce(ER(r), "");
    return n === -1 ? `{_ ${i}}` : `{${i}}`;
  }
  createObject(t, n) {
    const r = super.createObject(t), i = Object.keys(r).reduce(ER(r), "");
    return n === -1 ? `{_ ${i}}` : `{${i}}`;
  }
  createUtf8String(t, n) {
    const r = t.join(", ");
    return n === -1 ? `(_ ${r})` : `"${r}"`;
  }
  createUtf8StringFromHeap(t, n) {
    return `"${u6.from(
      super.createUtf8StringFromHeap(t, n)
    ).toString("utf8")}"`;
  }
  static diagnose(t, n) {
    return typeof t == "string" && (t = u6.from(t, n || "hex")), new j8().decodeFirst(t);
  }
}
var Bke = j8;
function ER(e) {
  return (t, n) => t ? `${t}, ${n}: ${e[n]}` : `${n}: ${e[n]}`;
}
const { Buffer: zo } = qA, { URL: Ike } = Fq, pT = NE.BigNumber, d6 = RE, nr = Qr, Ls = nr.MT, D1 = nr.NUMBYTES, _R = nr.SHIFT32, SR = nr.SYMS, eh = nr.TAG, Pke = nr.MT.SIMPLE_FLOAT << 5 | nr.NUMBYTES.TWO, Oke = nr.MT.SIMPLE_FLOAT << 5 | nr.NUMBYTES.FOUR, Nke = nr.MT.SIMPLE_FLOAT << 5 | nr.NUMBYTES.EIGHT, Rke = nr.MT.SIMPLE_FLOAT << 5 | nr.SIMPLE.TRUE, Mke = nr.MT.SIMPLE_FLOAT << 5 | nr.SIMPLE.FALSE, Fke = nr.MT.SIMPLE_FLOAT << 5 | nr.SIMPLE.UNDEFINED, CR = nr.MT.SIMPLE_FLOAT << 5 | nr.SIMPLE.NULL, jke = new pT("0x20000000000000"), Dke = zo.from("f97e00", "hex"), Uke = zo.from("f9fc00", "hex"), Lke = zo.from("f97c00", "hex");
function zke(e) {
  return {}.toString.call(e).slice(8, -1);
}
class A2 {
  /**
   * @param {Object} [options={}]
   * @param {function(Buffer)} options.stream
   */
  constructor(t) {
    t = t || {}, this.streaming = typeof t.stream == "function", this.onData = t.stream, this.semanticTypes = [
      [Ike, this._pushUrl],
      [pT, this._pushBigNumber]
    ];
    const n = t.genTypes || [], r = n.length;
    for (let i = 0; i < r; i++)
      this.addSemanticType(
        n[i][0],
        n[i][1]
      );
    this._reset();
  }
  addSemanticType(t, n) {
    const r = this.semanticTypes.length;
    for (let i = 0; i < r; i++)
      if (this.semanticTypes[i][0] === t) {
        const o = this.semanticTypes[i][1];
        return this.semanticTypes[i][1] = n, o;
      }
    return this.semanticTypes.push([t, n]), null;
  }
  push(t) {
    return t && (this.result[this.offset] = t, this.resultMethod[this.offset] = 0, this.resultLength[this.offset] = t.length, this.offset++, this.streaming && this.onData(this.finalize())), !0;
  }
  pushWrite(t, n, r) {
    return this.result[this.offset] = t, this.resultMethod[this.offset] = n, this.resultLength[this.offset] = r, this.offset++, this.streaming && this.onData(this.finalize()), !0;
  }
  _pushUInt8(t) {
    return this.pushWrite(t, 1, 1);
  }
  _pushUInt16BE(t) {
    return this.pushWrite(t, 2, 2);
  }
  _pushUInt32BE(t) {
    return this.pushWrite(t, 3, 4);
  }
  _pushDoubleBE(t) {
    return this.pushWrite(t, 4, 8);
  }
  _pushNaN() {
    return this.push(Dke);
  }
  _pushInfinity(t) {
    const n = t < 0 ? Uke : Lke;
    return this.push(n);
  }
  _pushFloat(t) {
    const n = zo.allocUnsafe(2);
    if (d6.writeHalf(n, t) && d6.parseHalf(n) === t)
      return this._pushUInt8(Pke) && this.push(n);
    const r = zo.allocUnsafe(4);
    return r.writeFloatBE(t, 0), r.readFloatBE(0) === t ? this._pushUInt8(Oke) && this.push(r) : this._pushUInt8(Nke) && this._pushDoubleBE(t);
  }
  _pushInt(t, n, r) {
    const i = n << 5;
    return t < 24 ? this._pushUInt8(i | t) : t <= 255 ? this._pushUInt8(i | D1.ONE) && this._pushUInt8(t) : t <= 65535 ? this._pushUInt8(i | D1.TWO) && this._pushUInt16BE(t) : t <= 4294967295 ? this._pushUInt8(i | D1.FOUR) && this._pushUInt32BE(t) : t <= Number.MAX_SAFE_INTEGER ? this._pushUInt8(i | D1.EIGHT) && this._pushUInt32BE(Math.floor(t / _R)) && this._pushUInt32BE(t % _R) : n === Ls.NEG_INT ? this._pushFloat(r) : this._pushFloat(t);
  }
  _pushIntNum(t) {
    return t < 0 ? this._pushInt(-t - 1, Ls.NEG_INT, t) : this._pushInt(t, Ls.POS_INT);
  }
  _pushNumber(t) {
    switch (!1) {
      case t === t:
        return this._pushNaN(t);
      case isFinite(t):
        return this._pushInfinity(t);
      case t % 1 !== 0:
        return this._pushIntNum(t);
      default:
        return this._pushFloat(t);
    }
  }
  _pushString(t) {
    const n = zo.byteLength(t, "utf8");
    return this._pushInt(n, Ls.UTF8_STRING) && this.pushWrite(t, 5, n);
  }
  _pushBoolean(t) {
    return this._pushUInt8(t ? Rke : Mke);
  }
  _pushUndefined(t) {
    return this._pushUInt8(Fke);
  }
  _pushArray(t, n) {
    const r = n.length;
    if (!t._pushInt(r, Ls.ARRAY))
      return !1;
    for (let i = 0; i < r; i++)
      if (!t.pushAny(n[i]))
        return !1;
    return !0;
  }
  _pushTag(t) {
    return this._pushInt(t, Ls.TAG);
  }
  _pushDate(t, n) {
    return t._pushTag(eh.DATE_EPOCH) && t.pushAny(Math.round(n / 1e3));
  }
  _pushBuffer(t, n) {
    return t._pushInt(n.length, Ls.BYTE_STRING) && t.push(n);
  }
  _pushNoFilter(t, n) {
    return t._pushBuffer(t, n.slice());
  }
  _pushRegexp(t, n) {
    return t._pushTag(eh.REGEXP) && t.pushAny(n.source);
  }
  _pushSet(t, n) {
    if (!t._pushInt(n.size, Ls.ARRAY))
      return !1;
    for (const r of n)
      if (!t.pushAny(r))
        return !1;
    return !0;
  }
  _pushUrl(t, n) {
    return t._pushTag(eh.URI) && t.pushAny(n.format());
  }
  _pushBigint(t) {
    let n = eh.POS_BIGINT;
    t.isNegative() && (t = t.negated().minus(1), n = eh.NEG_BIGINT);
    let r = t.toString(16);
    r.length % 2 && (r = "0" + r);
    const i = zo.from(r, "hex");
    return this._pushTag(n) && this._pushBuffer(this, i);
  }
  _pushBigNumber(t, n) {
    if (n.isNaN())
      return t._pushNaN();
    if (!n.isFinite())
      return t._pushInfinity(n.isNegative() ? -1 / 0 : 1 / 0);
    if (n.isInteger())
      return t._pushBigint(n);
    if (!(t._pushTag(eh.DECIMAL_FRAC) && t._pushInt(2, Ls.ARRAY)))
      return !1;
    const r = n.decimalPlaces(), i = n.multipliedBy(new pT(10).pow(r));
    return t._pushIntNum(-r) ? i.abs().isLessThan(jke) ? t._pushIntNum(i.toNumber()) : t._pushBigint(i) : !1;
  }
  _pushMap(t, n) {
    return t._pushInt(n.size, Ls.MAP) ? this._pushRawMap(
      n.size,
      Array.from(n)
    ) : !1;
  }
  _pushObject(t) {
    if (!t)
      return this._pushUInt8(CR);
    for (var n = this.semanticTypes.length, r = 0; r < n; r++)
      if (t instanceof this.semanticTypes[r][0])
        return this.semanticTypes[r][1].call(t, this, t);
    var i = t.encodeCBOR;
    if (typeof i == "function")
      return i.call(t, this);
    var s = Object.keys(t), o = s.length;
    return this._pushInt(o, Ls.MAP) ? this._pushRawMap(
      o,
      s.map((a) => [a, t[a]])
    ) : !1;
  }
  _pushRawMap(t, n) {
    n = n.map(function(i) {
      return i[0] = A2.encode(i[0]), i;
    }).sort(d6.keySorter);
    for (var r = 0; r < t; r++)
      if (!this.push(n[r][0]) || !this.pushAny(n[r][1]))
        return !1;
    return !0;
  }
  /**
   * Alias for `.pushAny`
   *
   * @param {*} obj
   * @returns {boolean} true on success
   */
  write(t) {
    return this.pushAny(t);
  }
  /**
   * Push any supported type onto the encoded stream
   *
   * @param {any} obj
   * @returns {boolean} true on success
   */
  pushAny(t) {
    var n = zke(t);
    switch (n) {
      case "Number":
        return this._pushNumber(t);
      case "String":
        return this._pushString(t);
      case "Boolean":
        return this._pushBoolean(t);
      case "Object":
        return this._pushObject(t);
      case "Array":
        return this._pushArray(this, t);
      case "Uint8Array":
        return this._pushBuffer(this, zo.isBuffer(t) ? t : zo.from(t));
      case "Null":
        return this._pushUInt8(CR);
      case "Undefined":
        return this._pushUndefined(t);
      case "Map":
        return this._pushMap(this, t);
      case "Set":
        return this._pushSet(this, t);
      case "URL":
        return this._pushUrl(this, t);
      case "BigNumber":
        return this._pushBigNumber(this, t);
      case "Date":
        return this._pushDate(this, t);
      case "RegExp":
        return this._pushRegexp(this, t);
      case "Symbol":
        switch (t) {
          case SR.NULL:
            return this._pushObject(null);
          case SR.UNDEFINED:
            return this._pushUndefined(void 0);
          default:
            throw new Error("Unknown symbol: " + t.toString());
        }
      default:
        throw new Error("Unknown type: " + typeof t + ", " + (t ? t.toString() : ""));
    }
  }
  finalize() {
    if (this.offset === 0)
      return null;
    for (var t = this.result, n = this.resultLength, r = this.resultMethod, i = this.offset, s = 0, o = 0; o < i; o++)
      s += n[o];
    var a = zo.allocUnsafe(s), c = 0, l = 0;
    for (o = 0; o < i; o++) {
      switch (l = n[o], r[o]) {
        case 0:
          t[o].copy(a, c);
          break;
        case 1:
          a.writeUInt8(t[o], c, !0);
          break;
        case 2:
          a.writeUInt16BE(t[o], c, !0);
          break;
        case 3:
          a.writeUInt32BE(t[o], c, !0);
          break;
        case 4:
          a.writeDoubleBE(t[o], c, !0);
          break;
        case 5:
          a.write(t[o], c, l, "utf8");
          break;
        default:
          throw new Error("unkown method");
      }
      c += l;
    }
    var u = a;
    return this._reset(), u;
  }
  _reset() {
    this.result = [], this.resultMethod = [], this.resultLength = [], this.offset = 0;
  }
  /**
   * Encode the given value
   * @param {*} o
   * @returns {Buffer}
   */
  static encode(t) {
    const n = new A2();
    if (!n.pushAny(t))
      throw new Error("Failed to encode input");
    return n.finalize();
  }
}
var Vke = A2;
(function(e) {
  e.Diagnose = Bke, e.Decoder = jq, e.Encoder = Vke, e.Simple = Oq, e.Tagged = Nq, e.decodeAll = e.Decoder.decodeAll, e.decodeFirst = e.Decoder.decodeFirst, e.diagnose = e.Diagnose.diagnose, e.encode = e.Encoder.encode, e.decode = e.Decoder.decode, e.leveldb = {
    decode: e.Decoder.decodeAll,
    encode: e.Encoder.encode,
    buffer: !0,
    name: "cbor"
  };
})(Iq);
const Dq = /* @__PURE__ */ Sk(Iq);
function ma(...e) {
  const t = new Uint8Array(e.reduce((r, i) => r + i.byteLength, 0));
  let n = 0;
  for (const r of e)
    t.set(new Uint8Array(r), n), n += r.byteLength;
  return t.buffer;
}
function uo(e) {
  return [...new Uint8Array(e)].map((t) => t.toString(16).padStart(2, "0")).join("");
}
const Hke = new RegExp(/^[0-9a-fA-F]+$/);
function E2(e) {
  if (!Hke.test(e))
    throw new Error("Invalid hexadecimal string.");
  const t = [...e].reduce((n, r, i) => (n[i / 2 | 0] = (n[i / 2 | 0] || "") + r, n), []).map((n) => Number.parseInt(n, 16));
  return new Uint8Array(t).buffer;
}
function Uq(e, t) {
  if (e.byteLength !== t.byteLength)
    return e.byteLength - t.byteLength;
  const n = new Uint8Array(e), r = new Uint8Array(t);
  for (let i = 0; i < n.length; i++)
    if (n[i] !== r[i])
      return n[i] - r[i];
  return 0;
}
function Wke(e, t) {
  return Uq(e, t) === 0;
}
function zw(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength).buffer;
}
function Lq(e) {
  return e instanceof Uint8Array ? zw(e) : e instanceof ArrayBuffer ? e : Array.isArray(e) ? zw(new Uint8Array(e)) : "buffer" in e ? Lq(e.buffer) : zw(new Uint8Array(e));
}
function io(e) {
  return zw(B8.create().update(new Uint8Array(e)).digest());
}
function Vw(e) {
  if (e instanceof Dq.Tagged)
    return Vw(e.value);
  if (typeof e == "string")
    return zq(e);
  if (typeof e == "number")
    return io(Mn(e));
  if (e instanceof ArrayBuffer || ArrayBuffer.isView(e))
    return io(e);
  if (Array.isArray(e)) {
    const t = e.map(Vw);
    return io(ma(...t));
  } else {
    if (e && typeof e == "object" && e._isPrincipal)
      return io(e.toUint8Array());
    if (typeof e == "object" && e !== null && typeof e.toHash == "function")
      return Vw(e.toHash());
    if (typeof e == "object")
      return _2(e);
    if (typeof e == "bigint")
      return io(Mn(e));
  }
  throw Object.assign(new Error(`Attempt to hash a value of unsupported type: ${e}`), {
    // include so logs/callers can understand the confusing value.
    // (when stringified in error message, prototype info is lost)
    value: e
  });
}
const zq = (e) => {
  const t = new TextEncoder().encode(e);
  return io(t);
};
function TR(e) {
  return _2(e);
}
function _2(e) {
  const r = Object.entries(e).filter(([, o]) => o !== void 0).map(([o, a]) => {
    const c = zq(o), l = Vw(a);
    return [c, l];
  }).sort(([o], [a]) => Uq(o, a)), i = ma(...r.map((o) => ma(...o)));
  return io(i);
}
new TextEncoder().encode(`
ic-request`);
class Gke {
  getPrincipal() {
    return gt.anonymous();
  }
  async transformRequest(t) {
    return Object.assign(Object.assign({}, t), { body: { content: t.body } });
  }
}
var ac = {}, o0 = {}, hn = {};
Object.defineProperty(hn, "__esModule", { value: !0 });
const qke = 9007199254740992;
function Cc(e, ...t) {
  const n = new Uint8Array(e.byteLength + t.reduce((i, s) => i + s.byteLength, 0));
  n.set(new Uint8Array(e), 0);
  let r = e.byteLength;
  for (const i of t)
    n.set(new Uint8Array(i), r), r += i.byteLength;
  return n.buffer;
}
function go(e, t, n) {
  n = n.replace(/[^0-9a-fA-F]/g, "");
  const r = 2 ** (t - 24);
  n = n.slice(-r * 2).padStart(r * 2, "0");
  const i = [(e << 5) + t].concat(n.match(/../g).map((s) => parseInt(s, 16)));
  return new Uint8Array(i).buffer;
}
function ME(e, t) {
  if (t < 24)
    return new Uint8Array([(e << 5) + t]).buffer;
  {
    const n = t <= 255 ? 24 : t <= 65535 ? 25 : t <= 4294967295 ? 26 : 27;
    return go(e, n, t.toString(16));
  }
}
function Vq(e) {
  const t = [];
  for (let n = 0; n < e.length; n++) {
    let r = e.charCodeAt(n);
    r < 128 ? t.push(r) : r < 2048 ? t.push(192 | r >> 6, 128 | r & 63) : r < 55296 || r >= 57344 ? t.push(224 | r >> 12, 128 | r >> 6 & 63, 128 | r & 63) : (n++, r = (r & 1023) << 10 | e.charCodeAt(n) & 1023, t.push(240 | r >> 18, 128 | r >> 12 & 63, 128 | r >> 6 & 63, 128 | r & 63));
  }
  return Cc(new Uint8Array(ME(3, e.length)), new Uint8Array(t));
}
function $ke(e, t) {
  if (e == 14277111)
    return Cc(new Uint8Array([217, 217, 247]), t);
  if (e < 24)
    return Cc(new Uint8Array([192 + e]), t);
  {
    const n = e <= 255 ? 24 : e <= 65535 ? 25 : e <= 4294967295 ? 26 : 27, r = 2 ** (n - 24), i = e.toString(16).slice(-r * 2).padStart(r * 2, "0"), s = [192 + n].concat(i.match(/../g).map((o) => parseInt(o, 16)));
    return new Uint8Array(s).buffer;
  }
}
hn.tagged = $ke;
function Ov(e) {
  return new Uint8Array(e).buffer;
}
hn.raw = Ov;
function D8(e) {
  if (isNaN(e))
    throw new RangeError("Invalid number.");
  e = Math.min(Math.max(0, e), 23);
  const t = [0 + e];
  return new Uint8Array(t).buffer;
}
hn.uSmall = D8;
function Hq(e, t) {
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, e), 255), e = e.toString(16), go(0, 24, e);
}
hn.u8 = Hq;
function Wq(e, t) {
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, e), 65535), e = e.toString(16), go(0, 25, e);
}
hn.u16 = Wq;
function Gq(e, t) {
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, e), 4294967295), e = e.toString(16), go(0, 26, e);
}
hn.u32 = Gq;
function U8(e, t) {
  if (typeof e == "string" && t == 16) {
    if (e.match(/[^0-9a-fA-F]/))
      throw new RangeError("Invalid number.");
    return go(0, 27, e);
  }
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, e), qke), e = e.toString(16), go(0, 27, e);
}
hn.u64 = U8;
function qq(e) {
  if (isNaN(e))
    throw new RangeError("Invalid number.");
  if (e === 0)
    return D8(0);
  e = Math.min(Math.max(0, -e), 24) - 1;
  const t = [32 + e];
  return new Uint8Array(t).buffer;
}
hn.iSmall = qq;
function $q(e, t) {
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, -e - 1), 255), e = e.toString(16), go(1, 24, e);
}
hn.i8 = $q;
function Qq(e, t) {
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, -e - 1), 65535), e = e.toString(16), go(1, 25, e);
}
hn.i16 = Qq;
function Kq(e, t) {
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, -e - 1), 4294967295), e = e.toString(16), go(1, 26, e);
}
hn.i32 = Kq;
function Yq(e, t) {
  if (typeof e == "string" && t == 16) {
    if (e.startsWith("-") ? e = e.slice(1) : e = "0", e.match(/[^0-9a-fA-F]/) || e.length > 16)
      throw new RangeError("Invalid number.");
    let n = !1, r = e.split("").reduceRight((i, s) => {
      if (n)
        return s + i;
      let o = parseInt(s, 16) - 1;
      return o >= 0 ? (n = !0, o.toString(16) + i) : "f" + i;
    }, "");
    return n ? go(1, 27, r) : U8(0);
  }
  if (e = parseInt("" + e, t), isNaN(e))
    throw new RangeError("Invalid number.");
  return e = Math.min(Math.max(0, -e - 1), 9007199254740992), e = e.toString(16), go(1, 27, e);
}
hn.i64 = Yq;
function Qke(e) {
  return e >= 0 ? e < 24 ? D8(e) : e <= 255 ? Hq(e) : e <= 65535 ? Wq(e) : e <= 4294967295 ? Gq(e) : U8(e) : e >= -24 ? qq(e) : e >= -255 ? $q(e) : e >= -65535 ? Qq(e) : e >= -4294967295 ? Kq(e) : Yq(e);
}
hn.number = Qke;
function Kke(e) {
  return Cc(ME(2, e.byteLength), e);
}
hn.bytes = Kke;
function Yke(e) {
  return Vq(e);
}
hn.string = Yke;
function Zke(e) {
  return Cc(ME(4, e.length), ...e);
}
hn.array = Zke;
function Jke(e, t = !1) {
  e instanceof Map || (e = new Map(Object.entries(e)));
  let n = Array.from(e.entries());
  return t && (n = n.sort(([r], [i]) => r.localeCompare(i))), Cc(ME(5, e.size), ...n.map(([r, i]) => Cc(Vq(r), i)));
}
hn.map = Jke;
function Xke(e) {
  const t = new Float32Array([e]);
  return Cc(new Uint8Array([250]), new Uint8Array(t.buffer));
}
hn.singleFloat = Xke;
function e5e(e) {
  const t = new Float64Array([e]);
  return Cc(new Uint8Array([251]), new Uint8Array(t.buffer));
}
hn.doubleFloat = e5e;
function t5e(e) {
  return e ? Zq() : Jq();
}
hn.bool = t5e;
function Zq() {
  return Ov(new Uint8Array([245]));
}
hn.true_ = Zq;
function Jq() {
  return Ov(new Uint8Array([244]));
}
hn.false_ = Jq;
function n5e() {
  return Ov(new Uint8Array([246]));
}
hn.null_ = n5e;
function r5e() {
  return Ov(new Uint8Array([247]));
}
hn.undefined_ = r5e;
var i5e = im && im.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t.default = e, t;
};
Object.defineProperty(o0, "__esModule", { value: !0 });
const Vs = i5e(hn), s5e = [
  ArrayBuffer,
  Uint8Array,
  Uint16Array,
  Uint32Array,
  Int8Array,
  Int16Array,
  Int32Array,
  Float32Array,
  Float64Array
];
class Xq {
  // @param _serializer The CBOR Serializer to use.
  // @param _stable Whether or not keys from objects should be sorted (stable). This is
  //     particularly useful when testing encodings between JSON objects.
  constructor(t, n = !1) {
    this._serializer = t, this._stable = n, this.name = "jsonDefault", this.priority = -100;
  }
  match(t) {
    return ["undefined", "boolean", "number", "string", "object"].indexOf(typeof t) != -1;
  }
  encode(t) {
    switch (typeof t) {
      case "undefined":
        return Vs.undefined_();
      case "boolean":
        return Vs.bool(t);
      case "number":
        return Math.floor(t) === t ? Vs.number(t) : Vs.doubleFloat(t);
      case "string":
        return Vs.string(t);
      case "object":
        if (t === null)
          return Vs.null_();
        if (Array.isArray(t))
          return Vs.array(t.map((n) => this._serializer.serializeValue(n)));
        if (s5e.find((n) => t instanceof n))
          return Vs.bytes(t.buffer);
        if (Object.getOwnPropertyNames(t).indexOf("toJSON") !== -1)
          return this.encode(t.toJSON());
        if (t instanceof Map) {
          const n = /* @__PURE__ */ new Map();
          for (const [r, i] of t.entries())
            n.set(r, this._serializer.serializeValue(i));
          return Vs.map(n, this._stable);
        } else {
          const n = /* @__PURE__ */ new Map();
          for (const [r, i] of Object.entries(t))
            n.set(r, this._serializer.serializeValue(i));
          return Vs.map(n, this._stable);
        }
      default:
        throw new Error("Invalid value.");
    }
  }
}
o0.JsonDefaultCborEncoder = Xq;
class e$ {
  constructor() {
    this.name = "cborEncoder", this.priority = -90;
  }
  match(t) {
    return typeof t == "object" && typeof t.toCBOR == "function";
  }
  encode(t) {
    return t.toCBOR();
  }
}
o0.ToCborEncoder = e$;
class t$ {
  constructor() {
    this._encoders = /* @__PURE__ */ new Set();
  }
  static withDefaultEncoders(t = !1) {
    const n = new this();
    return n.addEncoder(new Xq(n, t)), n.addEncoder(new e$()), n;
  }
  removeEncoder(t) {
    for (const n of this._encoders.values())
      n.name == t && this._encoders.delete(n);
  }
  addEncoder(t) {
    this._encoders.add(t);
  }
  getEncoderFor(t) {
    let n = null;
    for (const r of this._encoders)
      (!n || r.priority > n.priority) && r.match(t) && (n = r);
    if (n === null)
      throw new Error("Could not find an encoder for value.");
    return n;
  }
  serializeValue(t) {
    return this.getEncoderFor(t).encode(t);
  }
  serialize(t) {
    return this.serializeValue(t);
  }
}
o0.CborSerializer = t$;
class o5e extends t$ {
  serialize(t) {
    return Vs.raw(new Uint8Array([
      // Self describe CBOR.
      ...new Uint8Array([217, 217, 247]),
      ...new Uint8Array(super.serializeValue(t))
    ]));
  }
}
o0.SelfDescribeCborSerializer = o5e;
(function(e) {
  function t(i) {
    for (var s in i)
      e.hasOwnProperty(s) || (e[s] = i[s]);
  }
  var n = im && im.__importStar || function(i) {
    if (i && i.__esModule)
      return i;
    var s = {};
    if (i != null)
      for (var o in i)
        Object.hasOwnProperty.call(i, o) && (s[o] = i[o]);
    return s.default = i, s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), t(o0);
  const r = n(hn);
  e.value = r;
})(ac);
class a5e {
  get name() {
    return "Principal";
  }
  get priority() {
    return 0;
  }
  match(t) {
    return t && t._isPrincipal === !0;
  }
  encode(t) {
    return ac.value.bytes(t.toUint8Array());
  }
}
class c5e {
  get name() {
    return "Buffer";
  }
  get priority() {
    return 1;
  }
  match(t) {
    return t instanceof ArrayBuffer || ArrayBuffer.isView(t);
  }
  encode(t) {
    return ac.value.bytes(new Uint8Array(t));
  }
}
class l5e {
  get name() {
    return "BigInt";
  }
  get priority() {
    return 1;
  }
  match(t) {
    return typeof t == "bigint";
  }
  encode(t) {
    return t > BigInt(0) ? ac.value.tagged(2, ac.value.bytes(E2(t.toString(16)))) : ac.value.tagged(3, ac.value.bytes(E2((BigInt("-1") * t).toString(16))));
  }
}
const FE = ac.SelfDescribeCborSerializer.withDefaultEncoders(!0);
FE.addEncoder(new a5e());
FE.addEncoder(new c5e());
FE.addEncoder(new l5e());
var mT;
(function(e) {
  e[e.Uint64LittleEndian = 71] = "Uint64LittleEndian", e[e.Semantic = 55799] = "Semantic";
})(mT || (mT = {}));
function f6(e) {
  return FE.serialize(e);
}
function kR(e) {
  const t = e.byteLength;
  let n = BigInt(0);
  for (let r = 0; r < t; r++)
    n = n * BigInt(256) + BigInt(e[r]);
  return n;
}
class u5e extends Dq.Decoder {
  createByteString(t) {
    return ma(...t);
  }
  createByteStringFromHeap(t, n) {
    return t === n ? new ArrayBuffer(0) : new Uint8Array(this._heap.slice(t, n));
  }
}
function cc(e) {
  const t = new Uint8Array(e), n = new u5e({
    size: t.byteLength,
    tags: {
      // Override tags 2 and 3 for BigInt support (borc supports only BigNumber).
      2: (r) => kR(r),
      3: (r) => -kR(r),
      [mT.Semantic]: (r) => r
    }
  });
  try {
    return n.decodeFirst(t);
  } catch (r) {
    throw new Error(`Failed to decode CBOR: ${r}, input: ${uo(t)}`);
  }
}
const U1 = () => {
  if (typeof window < "u" && window.crypto && window.crypto.getRandomValues) {
    const e = new Uint32Array(1);
    return window.crypto.getRandomValues(e), e[0];
  }
  if (typeof crypto < "u" && crypto.getRandomValues) {
    const e = new Uint32Array(1);
    return crypto.getRandomValues(e), e[0];
  }
  return typeof crypto < "u" && crypto.randomInt ? crypto.randomInt(0, 4294967295) : Math.floor(Math.random() * 4294967295);
};
var gT;
(function(e) {
  e.Call = "call";
})(gT || (gT = {}));
function yT() {
  const e = new ArrayBuffer(16), t = new DataView(e), n = U1(), r = U1(), i = U1(), s = U1();
  return t.setUint32(0, n), t.setUint32(4, r), t.setUint32(8, i), t.setUint32(12, s), e;
}
const d5e = BigInt(1e6), f5e = 60 * 1e3;
class L1 {
  constructor(t) {
    const s = BigInt(Math.floor(Date.now() + t - f5e)) * d5e / BigInt(1e9) / BigInt(60) * BigInt(60) * BigInt(1e9);
    this._value = s;
  }
  toCBOR() {
    return ac.value.u64(this._value.toString(16), 16);
  }
  toHash() {
    return Mn(this._value);
  }
}
function BR(e = yT) {
  return async (t) => {
    const n = t.request.headers;
    t.request.headers = n, t.endpoint === "call" && (t.body.nonce = e());
  };
}
function Hw(e) {
  const t = [];
  return e.forEach((n, r) => {
    t.push([r, n]);
  }), t;
}
class IR extends Bi {
  constructor(t, n) {
    super(t), this.response = n, this.name = this.constructor.name, Object.setPrototypeOf(this, new.target.prototype);
  }
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const h5e = BigInt(0), L8 = BigInt(1), p5e = BigInt(2);
function jE(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function cu(e) {
  if (!jE(e))
    throw new Error("Uint8Array expected");
}
const m5e = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function pf(e) {
  cu(e);
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += m5e[e[n]];
  return t;
}
function n$(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
const Oa = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function PR(e) {
  if (e >= Oa._0 && e <= Oa._9)
    return e - Oa._0;
  if (e >= Oa._A && e <= Oa._F)
    return e - (Oa._A - 10);
  if (e >= Oa._a && e <= Oa._f)
    return e - (Oa._a - 10);
}
function r$(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, n = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const r = new Uint8Array(n);
  for (let i = 0, s = 0; i < n; i++, s += 2) {
    const o = PR(e.charCodeAt(s)), a = PR(e.charCodeAt(s + 1));
    if (o === void 0 || a === void 0) {
      const c = e[s] + e[s + 1];
      throw new Error('hex string expected, got non-hex character "' + c + '" at index ' + s);
    }
    r[i] = o * 16 + a;
  }
  return r;
}
function to(e) {
  return n$(pf(e));
}
function Dg(e) {
  return cu(e), n$(pf(Uint8Array.from(e).reverse()));
}
function Er(e, t) {
  return r$(e.toString(16).padStart(t * 2, "0"));
}
function S2(e, t) {
  return Er(e, t).reverse();
}
function Ai(e, t, n) {
  let r;
  if (typeof t == "string")
    try {
      r = r$(t);
    } catch (s) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${s}`);
    }
  else if (jE(t))
    r = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const i = r.length;
  if (typeof n == "number" && i !== n)
    throw new Error(`${e} expected ${n} bytes, got ${i}`);
  return r;
}
function Kn(...e) {
  let t = 0;
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    cu(i), t += i.length;
  }
  const n = new Uint8Array(t);
  for (let r = 0, i = 0; r < e.length; r++) {
    const s = e[r];
    n.set(s, i), i += s.length;
  }
  return n;
}
function z8(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function Ug(e) {
  let t;
  for (t = 0; e > h5e; e >>= L8, t += 1)
    ;
  return t;
}
function bT(e, t) {
  return e >> BigInt(t) & L8;
}
const DE = (e) => (p5e << BigInt(e - 1)) - L8, g5e = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || jE(e),
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function Nv(e, t, n = {}) {
  const r = (i, s, o) => {
    const a = g5e[s];
    if (typeof a != "function")
      throw new Error(`Invalid validator "${s}", expected function`);
    const c = e[i];
    if (!(o && c === void 0) && !a(c, e))
      throw new Error(`Invalid param ${String(i)}=${c} (${typeof c}), expected ${s}`);
  };
  for (const [i, s] of Object.entries(t))
    r(i, s, !1);
  for (const [i, s] of Object.entries(n))
    r(i, s, !0);
  return e;
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const pr = BigInt(0), Sn = BigInt(1), Vu = BigInt(2), y5e = BigInt(3), vT = BigInt(4), OR = BigInt(5), NR = BigInt(8);
BigInt(9);
BigInt(16);
function Nn(e, t) {
  const n = e % t;
  return n >= pr ? n : t + n;
}
function b5e(e, t, n) {
  if (n <= pr || t < pr)
    throw new Error("Expected power/modulo > 0");
  if (n === Sn)
    return pr;
  let r = Sn;
  for (; t > pr; )
    t & Sn && (r = r * e % n), e = e * e % n, t >>= Sn;
  return r;
}
function Oo(e, t, n) {
  let r = e;
  for (; t-- > pr; )
    r *= r, r %= n;
  return r;
}
function RR(e, t) {
  if (e === pr || t <= pr)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let n = Nn(e, t), r = t, i = pr, s = Sn;
  for (; n !== pr; ) {
    const a = r / n, c = r % n, l = i - s * a;
    r = n, n = c, i = s, s = l;
  }
  if (r !== Sn)
    throw new Error("invert: does not exist");
  return Nn(i, t);
}
function v5e(e) {
  const t = (e - Sn) / Vu;
  let n, r, i;
  for (n = e - Sn, r = 0; n % Vu === pr; n /= Vu, r++)
    ;
  for (i = Vu; i < e && b5e(i, t, e) !== e - Sn; i++)
    ;
  if (r === 1) {
    const o = (e + Sn) / vT;
    return function(c, l) {
      const u = c.pow(l, o);
      if (!c.eql(c.sqr(u), l))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  const s = (n + Sn) / Vu;
  return function(a, c) {
    if (a.pow(c, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = r, u = a.pow(a.mul(a.ONE, i), n), d = a.pow(c, s), f = a.pow(c, n);
    for (; !a.eql(f, a.ONE); ) {
      if (a.eql(f, a.ZERO))
        return a.ZERO;
      let p = 1;
      for (let h = a.sqr(f); p < l && !a.eql(h, a.ONE); p++)
        h = a.sqr(h);
      const m = a.pow(u, Sn << BigInt(l - p - 1));
      u = a.sqr(m), d = a.mul(d, m), f = a.mul(f, u), l = p;
    }
    return d;
  };
}
function w5e(e) {
  if (e % vT === y5e) {
    const t = (e + Sn) / vT;
    return function(r, i) {
      const s = r.pow(i, t);
      if (!r.eql(r.sqr(s), i))
        throw new Error("Cannot find square root");
      return s;
    };
  }
  if (e % NR === OR) {
    const t = (e - OR) / NR;
    return function(r, i) {
      const s = r.mul(i, Vu), o = r.pow(s, t), a = r.mul(i, o), c = r.mul(r.mul(a, Vu), o), l = r.mul(a, r.sub(c, r.ONE));
      if (!r.eql(r.sqr(l), i))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return v5e(e);
}
const x5e = (e, t) => (Nn(e, t) & Sn) === Sn, A5e = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function i$(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, n = A5e.reduce((r, i) => (r[i] = "function", r), t);
  return Nv(e, n);
}
function UE(e, t, n) {
  if (n < pr)
    throw new Error("Expected power > 0");
  if (n === pr)
    return e.ONE;
  if (n === Sn)
    return t;
  let r = e.ONE, i = t;
  for (; n > pr; )
    n & Sn && (r = e.mul(r, i)), i = e.sqr(i), n >>= Sn;
  return r;
}
function LE(e, t) {
  const n = new Array(t.length), r = t.reduce((s, o, a) => e.is0(o) ? s : (n[a] = s, e.mul(s, o)), e.ONE), i = e.inv(r);
  return t.reduceRight((s, o, a) => e.is0(o) ? s : (n[a] = e.mul(s, n[a]), e.mul(s, o)), i), n;
}
function s$(e, t) {
  const n = t !== void 0 ? t : e.toString(2).length, r = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: r };
}
function V8(e, t, n = !1, r = {}) {
  if (e <= pr)
    throw new Error(`Expected Field ORDER > 0, got ${e}`);
  const { nBitLength: i, nByteLength: s } = s$(e, t);
  if (s > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const o = w5e(e), a = Object.freeze({
    ORDER: e,
    BITS: i,
    BYTES: s,
    MASK: DE(i),
    ZERO: pr,
    ONE: Sn,
    create: (c) => Nn(c, e),
    isValid: (c) => {
      if (typeof c != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof c}`);
      return pr <= c && c < e;
    },
    is0: (c) => c === pr,
    isOdd: (c) => (c & Sn) === Sn,
    neg: (c) => Nn(-c, e),
    eql: (c, l) => c === l,
    sqr: (c) => Nn(c * c, e),
    add: (c, l) => Nn(c + l, e),
    sub: (c, l) => Nn(c - l, e),
    mul: (c, l) => Nn(c * l, e),
    pow: (c, l) => UE(a, c, l),
    div: (c, l) => Nn(c * RR(l, e), e),
    // Same as above, but doesn't normalize
    sqrN: (c) => c * c,
    addN: (c, l) => c + l,
    subN: (c, l) => c - l,
    mulN: (c, l) => c * l,
    inv: (c) => RR(c, e),
    sqrt: r.sqrt || ((c) => o(a, c)),
    invertBatch: (c) => LE(a, c),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (c, l, u) => u ? l : c,
    toBytes: (c) => n ? S2(c, s) : Er(c, s),
    fromBytes: (c) => {
      if (c.length !== s)
        throw new Error(`Fp.fromBytes: expected ${s}, got ${c.length}`);
      return n ? Dg(c) : to(c);
    }
  });
  return Object.freeze(a);
}
function E5e(e, t) {
  if (!e.isOdd)
    throw new Error("Field doesn't have isOdd");
  const n = e.sqrt(t);
  return e.isOdd(n) ? e.neg(n) : n;
}
function o$(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function a$(e) {
  const t = o$(e);
  return t + Math.ceil(t / 2);
}
function _5e(e, t, n = !1) {
  const r = e.length, i = o$(t), s = a$(t);
  if (r < 16 || r < s || r > 1024)
    throw new Error(`expected ${s}-1024 bytes of input, got ${r}`);
  const o = n ? to(e) : Dg(e), a = Nn(o, t - Sn) + Sn;
  return n ? S2(a, i) : Er(a, i);
}
const S5e = to;
function ol(e, t) {
  if (e < 0 || e >= 1 << 8 * t)
    throw new Error(`bad I2OSP call: value=${e} length=${t}`);
  const n = Array.from({ length: t }).fill(0);
  for (let r = t - 1; r >= 0; r--)
    n[r] = e & 255, e >>>= 8;
  return new Uint8Array(n);
}
function C5e(e, t) {
  const n = new Uint8Array(e.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r] ^ t[r];
  return n;
}
function H8(e) {
  if (!Number.isSafeInteger(e))
    throw new Error("number expected");
}
function T5e(e, t, n, r) {
  cu(e), cu(t), H8(n), t.length > 255 && (t = r(Kn(z8("H2C-OVERSIZE-DST-"), t)));
  const { outputLen: i, blockLen: s } = r, o = Math.ceil(n / i);
  if (o > 255)
    throw new Error("Invalid xmd length");
  const a = Kn(t, ol(t.length, 1)), c = ol(0, s), l = ol(n, 2), u = new Array(o), d = r(Kn(c, e, l, ol(0, 1), a));
  u[0] = r(Kn(d, ol(1, 1), a));
  for (let p = 1; p <= o; p++) {
    const m = [C5e(d, u[p - 1]), ol(p + 1, 1), a];
    u[p] = r(Kn(...m));
  }
  return Kn(...u).slice(0, n);
}
function k5e(e, t, n, r, i) {
  if (cu(e), cu(t), H8(n), t.length > 255) {
    const s = Math.ceil(2 * r / 8);
    t = i.create({ dkLen: s }).update(z8("H2C-OVERSIZE-DST-")).update(t).digest();
  }
  if (n > 65535 || t.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return i.create({ dkLen: n }).update(e).update(ol(n, 2)).update(t).update(ol(t.length, 1)).digest();
}
function MR(e, t, n) {
  Nv(n, {
    DST: "stringOrUint8Array",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p: r, k: i, m: s, hash: o, expand: a, DST: c } = n;
  cu(e), H8(t);
  const l = typeof c == "string" ? z8(c) : c, u = r.toString(2).length, d = Math.ceil((u + i) / 8), f = t * s * d;
  let p;
  if (a === "xmd")
    p = T5e(e, l, f, o);
  else if (a === "xof")
    p = k5e(e, l, f, i, o);
  else if (a === "_internal_pass")
    p = e;
  else
    throw new Error('expand must be "xmd" or "xof"');
  const m = new Array(t);
  for (let h = 0; h < t; h++) {
    const g = new Array(s);
    for (let y = 0; y < s; y++) {
      const v = d * (y + h * s), b = p.subarray(v, v + d);
      g[y] = Nn(S5e(b), r);
    }
    m[h] = g;
  }
  return m;
}
function c$(e, t) {
  const n = t.map((r) => Array.from(r).reverse());
  return (r, i) => {
    const [s, o, a, c] = n.map((l) => l.reduce((u, d) => e.add(e.mul(u, r), d)));
    return r = e.div(s, o), i = e.mul(i, e.div(a, c)), { x: r, y: i };
  };
}
function FR(e, t, n) {
  if (typeof t != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    // Encodes byte string to elliptic curve.
    // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    hashToCurve(r, i) {
      const s = MR(r, 2, { ...n, DST: n.DST, ...i }), o = e.fromAffine(t(s[0])), a = e.fromAffine(t(s[1])), c = o.add(a).clearCofactor();
      return c.assertValidity(), c;
    },
    // Encodes byte string to elliptic curve.
    // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
    encodeToCurve(r, i) {
      const s = MR(r, 1, { ...n, DST: n.encodeDST, ...i }), o = e.fromAffine(t(s[0])).clearCofactor();
      return o.assertValidity(), o;
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const B5e = BigInt(0), h6 = BigInt(1);
function l$(e, t) {
  const n = (i, s) => {
    const o = s.negate();
    return i ? o : s;
  }, r = (i) => {
    const s = Math.ceil(t / i) + 1, o = 2 ** (i - 1);
    return { windows: s, windowSize: o };
  };
  return {
    constTimeNegate: n,
    // non-const time multiplication ladder
    unsafeLadder(i, s) {
      let o = e.ZERO, a = i;
      for (; s > B5e; )
        s & h6 && (o = o.add(a)), a = a.double(), s >>= h6;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(i, s) {
      const { windows: o, windowSize: a } = r(s), c = [];
      let l = i, u = l;
      for (let d = 0; d < o; d++) {
        u = l, c.push(u);
        for (let f = 1; f < a; f++)
          u = u.add(l), c.push(u);
        l = u.double();
      }
      return c;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(i, s, o) {
      const { windows: a, windowSize: c } = r(i);
      let l = e.ZERO, u = e.BASE;
      const d = BigInt(2 ** i - 1), f = 2 ** i, p = BigInt(i);
      for (let m = 0; m < a; m++) {
        const h = m * c;
        let g = Number(o & d);
        o >>= p, g > c && (g -= f, o += h6);
        const y = h, v = h + Math.abs(g) - 1, b = m % 2 !== 0, w = g < 0;
        g === 0 ? u = u.add(n(b, s[y])) : l = l.add(n(w, s[v]));
      }
      return { p: l, f: u };
    },
    wNAFCached(i, s, o, a) {
      const c = i._WINDOW_SIZE || 1;
      let l = s.get(i);
      return l || (l = this.precomputeWindow(i, c), c !== 1 && s.set(i, a(l))), this.wNAF(c, l, o);
    }
  };
}
function u$(e) {
  return i$(e.Fp), Nv(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...s$(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function I5e(e) {
  const t = u$(e);
  Nv(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: n, Fp: r, a: i } = t;
  if (n) {
    if (!r.eql(i, r.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const Hu = BigInt(0), dr = BigInt(1), Wc = BigInt(2), C2 = BigInt(3), jR = BigInt(4);
function DR(e) {
  const t = I5e(e), { Fp: n } = t, r = t.toBytes || ((m, h, g) => {
    const y = h.toAffine();
    return Kn(Uint8Array.from([4]), n.toBytes(y.x), n.toBytes(y.y));
  }), i = t.fromBytes || ((m) => {
    const h = m.subarray(1), g = n.fromBytes(h.subarray(0, n.BYTES)), y = n.fromBytes(h.subarray(n.BYTES, 2 * n.BYTES));
    return { x: g, y };
  });
  function s(m) {
    const { a: h, b: g } = t, y = n.sqr(m), v = n.mul(y, m);
    return n.add(n.add(v, n.mul(m, h)), g);
  }
  if (!n.eql(n.sqr(t.Gy), s(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function o(m) {
    return typeof m == "bigint" && Hu < m && m < t.n;
  }
  function a(m) {
    if (!o(m))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function c(m) {
    const { allowedPrivateKeyLengths: h, nByteLength: g, wrapPrivateKey: y, n: v } = t;
    if (h && typeof m != "bigint") {
      if (jE(m) && (m = pf(m)), typeof m != "string" || !h.includes(m.length))
        throw new Error("Invalid key");
      m = m.padStart(g * 2, "0");
    }
    let b;
    try {
      b = typeof m == "bigint" ? m : to(Ai("private key", m, g));
    } catch {
      throw new Error(`private key must be ${g} bytes, hex or bigint, not ${typeof m}`);
    }
    return y && (b = Nn(b, v)), a(b), b;
  }
  const l = /* @__PURE__ */ new Map();
  function u(m) {
    if (!(m instanceof d))
      throw new Error("ProjectivePoint expected");
  }
  class d {
    constructor(h, g, y) {
      if (this.px = h, this.py = g, this.pz = y, h == null || !n.isValid(h))
        throw new Error("x required");
      if (g == null || !n.isValid(g))
        throw new Error("y required");
      if (y == null || !n.isValid(y))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(h) {
      const { x: g, y } = h || {};
      if (!h || !n.isValid(g) || !n.isValid(y))
        throw new Error("invalid affine point");
      if (h instanceof d)
        throw new Error("projective point not allowed");
      const v = (b) => n.eql(b, n.ZERO);
      return v(g) && v(y) ? d.ZERO : new d(g, y, n.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(h) {
      const g = n.invertBatch(h.map((y) => y.pz));
      return h.map((y, v) => y.toAffine(g[v])).map(d.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(h) {
      const g = d.fromAffine(i(Ai("pointHex", h)));
      return g.assertValidity(), g;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(h) {
      return d.BASE.multiply(c(h));
    }
    // "Private method", don't use it directly
    _setWindowSize(h) {
      this._WINDOW_SIZE = h, l.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !n.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: h, y: g } = this.toAffine();
      if (!n.isValid(h) || !n.isValid(g))
        throw new Error("bad point: x or y not FE");
      const y = n.sqr(g), v = s(h);
      if (!n.eql(y, v))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: h } = this.toAffine();
      if (n.isOdd)
        return !n.isOdd(h);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(h) {
      u(h);
      const { px: g, py: y, pz: v } = this, { px: b, py: w, pz: A } = h, E = n.eql(n.mul(g, A), n.mul(b, v)), x = n.eql(n.mul(y, A), n.mul(w, v));
      return E && x;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new d(this.px, n.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: h, b: g } = t, y = n.mul(g, C2), { px: v, py: b, pz: w } = this;
      let A = n.ZERO, E = n.ZERO, x = n.ZERO, S = n.mul(v, v), P = n.mul(b, b), I = n.mul(w, w), R = n.mul(v, b);
      return R = n.add(R, R), x = n.mul(v, w), x = n.add(x, x), A = n.mul(h, x), E = n.mul(y, I), E = n.add(A, E), A = n.sub(P, E), E = n.add(P, E), E = n.mul(A, E), A = n.mul(R, A), x = n.mul(y, x), I = n.mul(h, I), R = n.sub(S, I), R = n.mul(h, R), R = n.add(R, x), x = n.add(S, S), S = n.add(x, S), S = n.add(S, I), S = n.mul(S, R), E = n.add(E, S), I = n.mul(b, w), I = n.add(I, I), S = n.mul(I, R), A = n.sub(A, S), x = n.mul(I, P), x = n.add(x, x), x = n.add(x, x), new d(A, E, x);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(h) {
      u(h);
      const { px: g, py: y, pz: v } = this, { px: b, py: w, pz: A } = h;
      let E = n.ZERO, x = n.ZERO, S = n.ZERO;
      const P = t.a, I = n.mul(t.b, C2);
      let R = n.mul(g, b), Q = n.mul(y, w), J = n.mul(v, A), we = n.add(g, y), V = n.add(b, w);
      we = n.mul(we, V), V = n.add(R, Q), we = n.sub(we, V), V = n.add(g, v);
      let L = n.add(b, A);
      return V = n.mul(V, L), L = n.add(R, J), V = n.sub(V, L), L = n.add(y, v), E = n.add(w, A), L = n.mul(L, E), E = n.add(Q, J), L = n.sub(L, E), S = n.mul(P, V), E = n.mul(I, J), S = n.add(E, S), E = n.sub(Q, S), S = n.add(Q, S), x = n.mul(E, S), Q = n.add(R, R), Q = n.add(Q, R), J = n.mul(P, J), V = n.mul(I, V), Q = n.add(Q, J), J = n.sub(R, J), J = n.mul(P, J), V = n.add(V, J), R = n.mul(Q, V), x = n.add(x, R), R = n.mul(L, V), E = n.mul(we, E), E = n.sub(E, R), R = n.mul(we, Q), S = n.mul(L, S), S = n.add(S, R), new d(E, x, S);
    }
    subtract(h) {
      return this.add(h.negate());
    }
    is0() {
      return this.equals(d.ZERO);
    }
    wNAF(h) {
      return p.wNAFCached(this, l, h, (g) => {
        const y = n.invertBatch(g.map((v) => v.pz));
        return g.map((v, b) => v.toAffine(y[b])).map(d.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(h) {
      const g = d.ZERO;
      if (h === Hu)
        return g;
      if (a(h), h === dr)
        return this;
      const { endo: y } = t;
      if (!y)
        return p.unsafeLadder(this, h);
      let { k1neg: v, k1: b, k2neg: w, k2: A } = y.splitScalar(h), E = g, x = g, S = this;
      for (; b > Hu || A > Hu; )
        b & dr && (E = E.add(S)), A & dr && (x = x.add(S)), S = S.double(), b >>= dr, A >>= dr;
      return v && (E = E.negate()), w && (x = x.negate()), x = new d(n.mul(x.px, y.beta), x.py, x.pz), E.add(x);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(h) {
      a(h);
      let g = h, y, v;
      const { endo: b } = t;
      if (b) {
        const { k1neg: w, k1: A, k2neg: E, k2: x } = b.splitScalar(g);
        let { p: S, f: P } = this.wNAF(A), { p: I, f: R } = this.wNAF(x);
        S = p.constTimeNegate(w, S), I = p.constTimeNegate(E, I), I = new d(n.mul(I.px, b.beta), I.py, I.pz), y = S.add(I), v = P.add(R);
      } else {
        const { p: w, f: A } = this.wNAF(g);
        y = w, v = A;
      }
      return d.normalizeZ([y, v])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(h, g, y) {
      const v = d.BASE, b = (A, E) => E === Hu || E === dr || !A.equals(v) ? A.multiplyUnsafe(E) : A.multiply(E), w = b(this, g).add(b(h, y));
      return w.is0() ? void 0 : w;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(h) {
      const { px: g, py: y, pz: v } = this, b = this.is0();
      h == null && (h = b ? n.ONE : n.inv(v));
      const w = n.mul(g, h), A = n.mul(y, h), E = n.mul(v, h);
      if (b)
        return { x: n.ZERO, y: n.ZERO };
      if (!n.eql(E, n.ONE))
        throw new Error("invZ was invalid");
      return { x: w, y: A };
    }
    isTorsionFree() {
      const { h, isTorsionFree: g } = t;
      if (h === dr)
        return !0;
      if (g)
        return g(d, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h, clearCofactor: g } = t;
      return h === dr ? this : g ? g(d, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(h = !0) {
      return this.assertValidity(), r(d, this, h);
    }
    toHex(h = !0) {
      return pf(this.toRawBytes(h));
    }
  }
  d.BASE = new d(t.Gx, t.Gy, n.ONE), d.ZERO = new d(n.ZERO, n.ONE, n.ZERO);
  const f = t.nBitLength, p = l$(d, t.endo ? Math.ceil(f / 2) : f);
  return {
    CURVE: t,
    ProjectivePoint: d,
    normPrivateKeyToScalar: c,
    weierstrassEquation: s,
    isWithinCurveOrder: o
  };
}
function P5e(e, t) {
  const n = e.ORDER;
  let r = Hu;
  for (let m = n - dr; m % Wc === Hu; m /= Wc)
    r += dr;
  const i = r, s = Wc << i - dr - dr, o = s * Wc, a = (n - dr) / o, c = (a - dr) / Wc, l = o - dr, u = s, d = e.pow(t, a), f = e.pow(t, (a + dr) / Wc);
  let p = (m, h) => {
    let g = d, y = e.pow(h, l), v = e.sqr(y);
    v = e.mul(v, h);
    let b = e.mul(m, v);
    b = e.pow(b, c), b = e.mul(b, y), y = e.mul(b, h), v = e.mul(b, m);
    let w = e.mul(v, y);
    b = e.pow(w, u);
    let A = e.eql(b, e.ONE);
    y = e.mul(v, f), b = e.mul(w, g), v = e.cmov(y, v, A), w = e.cmov(b, w, A);
    for (let E = i; E > dr; E--) {
      let x = E - Wc;
      x = Wc << x - dr;
      let S = e.pow(w, x);
      const P = e.eql(S, e.ONE);
      y = e.mul(v, g), g = e.mul(g, g), S = e.mul(w, g), v = e.cmov(y, v, P), w = e.cmov(S, w, P);
    }
    return { isValid: A, value: v };
  };
  if (e.ORDER % jR === C2) {
    const m = (e.ORDER - C2) / jR, h = e.sqrt(e.neg(t));
    p = (g, y) => {
      let v = e.sqr(y);
      const b = e.mul(g, y);
      v = e.mul(v, b);
      let w = e.pow(v, m);
      w = e.mul(w, b);
      const A = e.mul(w, h), E = e.mul(e.sqr(w), y), x = e.eql(E, g);
      let S = e.cmov(A, w, x);
      return { isValid: x, value: S };
    };
  }
  return p;
}
function d$(e, t) {
  if (i$(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z))
    throw new Error("mapToCurveSimpleSWU: invalid opts");
  const n = P5e(e, t.Z);
  if (!e.isOdd)
    throw new Error("Fp.isOdd is not implemented!");
  return (r) => {
    let i, s, o, a, c, l, u, d;
    i = e.sqr(r), i = e.mul(i, t.Z), s = e.sqr(i), s = e.add(s, i), o = e.add(s, e.ONE), o = e.mul(o, t.B), a = e.cmov(t.Z, e.neg(s), !e.eql(s, e.ZERO)), a = e.mul(a, t.A), s = e.sqr(o), l = e.sqr(a), c = e.mul(l, t.A), s = e.add(s, c), s = e.mul(s, o), l = e.mul(l, a), c = e.mul(l, t.B), s = e.add(s, c), u = e.mul(i, o);
    const { isValid: f, value: p } = n(s, l);
    d = e.mul(i, r), d = e.mul(d, p), u = e.cmov(u, o, f), d = e.cmov(d, p, f);
    const m = e.isOdd(r) === e.isOdd(d);
    return d = e.cmov(e.neg(d), d, m), u = e.div(u, a), { x: u, y: d };
  };
}
const p6 = BigInt(2), z1 = BigInt(3);
function O5e(e) {
  const { Fp: t, Fr: n, Fp2: r, Fp6: i, Fp12: s } = e.fields, o = Ug(e.params.x);
  function a(L) {
    const { x: U, y: q } = L, G = U, ae = q, ge = r.ONE;
    let Ae = G, he = ae, B = ge, be = [];
    for (let Be = o - 2; Be >= 0; Be--) {
      let Ne = r.sqr(he), _e = r.sqr(B), Ce = r.multiplyByB(r.mul(_e, z1)), N = r.mul(Ce, z1), F = r.sub(r.sub(r.sqr(r.add(he, B)), _e), Ne);
      if (be.push([
        r.sub(Ce, Ne),
        // T2 - T0
        r.mul(r.sqr(Ae), z1),
        // 3 * Rx²
        r.neg(F)
        // -T4
      ]), Ae = r.div(r.mul(r.mul(r.sub(Ne, N), Ae), he), p6), he = r.sub(r.sqr(r.div(r.add(Ne, N), p6)), r.mul(r.sqr(Ce), z1)), B = r.mul(Ne, F), bT(e.params.x, Be)) {
        let z = r.sub(he, r.mul(ae, B)), ne = r.sub(Ae, r.mul(G, B));
        be.push([
          r.sub(r.mul(z, G), r.mul(ne, ae)),
          // T0 * Qx - T1 * Qy
          r.neg(z),
          // -T0
          ne
          // T1
        ]);
        let ee = r.sqr(ne), Y = r.mul(ee, ne), X = r.mul(ee, Ae), $ = r.add(r.sub(Y, r.mul(X, p6)), r.mul(r.sqr(z), B));
        Ae = r.mul(ne, $), he = r.sub(r.mul(r.sub(X, $), z), r.mul(Y, he)), B = r.mul(B, Y);
      }
    }
    return be;
  }
  function c(L, U) {
    const { x: q } = e.params, G = U[0], ae = U[1];
    let ge = s.ONE;
    for (let Ae = 0, he = o - 2; he >= 0; he--, Ae++) {
      const B = L[Ae];
      if (ge = s.multiplyBy014(ge, B[0], r.mul(B[1], G), r.mul(B[2], ae)), bT(q, he)) {
        Ae += 1;
        const be = L[Ae];
        ge = s.multiplyBy014(ge, be[0], r.mul(be[1], G), r.mul(be[2], ae));
      }
      he !== 0 && (ge = s.sqr(ge));
    }
    return s.conjugate(ge);
  }
  const l = {
    randomPrivateKey: () => {
      const L = a$(n.ORDER);
      return _5e(e.randomBytes(L), n.ORDER);
    },
    calcPairingPrecomputes: a
  }, u = DR({ n: n.ORDER, ...e.G1 }), d = Object.assign(u, FR(u.ProjectivePoint, e.G1.mapToCurve, {
    ...e.htfDefaults,
    ...e.G1.htfDefaults
  }));
  function f(L) {
    const U = L;
    return U._PPRECOMPUTES || (U._PPRECOMPUTES = a(L.toAffine())), U._PPRECOMPUTES;
  }
  const p = DR({ n: n.ORDER, ...e.G2 }), m = Object.assign(p, FR(p.ProjectivePoint, e.G2.mapToCurve, {
    ...e.htfDefaults,
    ...e.G2.htfDefaults
  })), { ShortSignature: h } = e.G1, { Signature: g } = e.G2;
  function y(L, U, q = !0) {
    if (L.equals(d.ProjectivePoint.ZERO) || U.equals(m.ProjectivePoint.ZERO))
      throw new Error("pairing is not available for ZERO point");
    L.assertValidity(), U.assertValidity();
    const G = L.toAffine(), ae = c(f(U), [G.x, G.y]);
    return q ? s.finalExponentiate(ae) : ae;
  }
  function v(L) {
    return L instanceof d.ProjectivePoint ? L : d.ProjectivePoint.fromHex(L);
  }
  function b(L, U) {
    return L instanceof d.ProjectivePoint ? L : d.hashToCurve(Ai("point", L), U);
  }
  function w(L) {
    return L instanceof m.ProjectivePoint ? L : g.fromHex(L);
  }
  function A(L, U) {
    return L instanceof m.ProjectivePoint ? L : m.hashToCurve(Ai("point", L), U);
  }
  function E(L) {
    return d.ProjectivePoint.fromPrivateKey(L).toRawBytes(!0);
  }
  function x(L) {
    return m.ProjectivePoint.fromPrivateKey(L).toRawBytes(!0);
  }
  function S(L, U, q) {
    const G = A(L, q);
    G.assertValidity();
    const ae = G.multiply(d.normPrivateKeyToScalar(U));
    return L instanceof m.ProjectivePoint ? ae : g.toRawBytes(ae);
  }
  function P(L, U, q) {
    const G = b(L, q);
    G.assertValidity();
    const ae = G.multiply(d.normPrivateKeyToScalar(U));
    return L instanceof d.ProjectivePoint ? ae : h.toRawBytes(ae);
  }
  function I(L, U, q, G) {
    const ae = v(q), ge = A(U, G), Ae = d.ProjectivePoint.BASE, he = w(L), B = y(ae.negate(), ge, !1), be = y(Ae, he, !1), Be = s.finalExponentiate(s.mul(be, B));
    return s.eql(Be, s.ONE);
  }
  function R(L, U, q, G) {
    const ae = w(q), ge = b(U, G), Ae = m.ProjectivePoint.BASE, he = v(L), B = y(ge, ae, !1), be = y(he, Ae.negate(), !1), Be = s.finalExponentiate(s.mul(be, B));
    return s.eql(Be, s.ONE);
  }
  function Q(L) {
    if (!L.length)
      throw new Error("Expected non-empty array");
    const q = L.map(v).reduce((G, ae) => G.add(ae), d.ProjectivePoint.ZERO);
    return L[0] instanceof d.ProjectivePoint ? (q.assertValidity(), q) : q.toRawBytes(!0);
  }
  function J(L) {
    if (!L.length)
      throw new Error("Expected non-empty array");
    const q = L.map(w).reduce((G, ae) => G.add(ae), m.ProjectivePoint.ZERO);
    return L[0] instanceof m.ProjectivePoint ? (q.assertValidity(), q) : g.toRawBytes(q);
  }
  function we(L) {
    if (!L.length)
      throw new Error("Expected non-empty array");
    const q = L.map(v).reduce((G, ae) => G.add(ae), d.ProjectivePoint.ZERO);
    return L[0] instanceof d.ProjectivePoint ? (q.assertValidity(), q) : h.toRawBytes(q);
  }
  function V(L, U, q, G) {
    if (!U.length)
      throw new Error("Expected non-empty messages array");
    if (q.length !== U.length)
      throw new Error("Pubkey count should equal msg count");
    const ae = w(L), ge = U.map((he) => A(he, G)), Ae = q.map(v);
    try {
      const he = [];
      for (const Be of new Set(ge)) {
        const Ne = ge.reduce((_e, Ce, N) => Ce === Be ? _e.add(Ae[N]) : _e, d.ProjectivePoint.ZERO);
        he.push(y(Ne, Be, !1));
      }
      he.push(y(d.ProjectivePoint.BASE.negate(), ae, !1));
      const B = he.reduce((Be, Ne) => s.mul(Be, Ne), s.ONE), be = s.finalExponentiate(B);
      return s.eql(be, s.ONE);
    } catch {
      return !1;
    }
  }
  return d.ProjectivePoint.BASE._setWindowSize(4), {
    getPublicKey: E,
    getPublicKeyForShortSignatures: x,
    sign: S,
    signShortSignature: P,
    verify: I,
    verifyBatch: V,
    verifyShortSignature: R,
    aggregatePublicKeys: Q,
    aggregateSignatures: J,
    aggregateShortSignatures: we,
    millerLoop: c,
    pairing: y,
    G1: d,
    G2: m,
    Signature: g,
    ShortSignature: h,
    fields: {
      Fr: n,
      Fp: t,
      Fp2: r,
      Fp6: i,
      Fp12: s
    },
    params: {
      x: e.params.x,
      r: e.params.r,
      G1b: e.G1.b,
      G2b: e.G2.b
    },
    utils: l
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const $n = BigInt(0), ed = BigInt(1), On = BigInt(2), V1 = BigInt(3), Lg = BigInt(4), N5e = BigInt(8), R5e = BigInt(16), wT = BigInt("0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab"), ke = V8(wT), UR = V8(BigInt("0x73eda753299d7d483339d80809a1d80553bda402fffe5bfeffffffff00000001")), LR = ({ c0: e, c1: t }, { c0: n, c1: r }) => ({
  c0: ke.add(e, n),
  c1: ke.add(t, r)
}), zR = ({ c0: e, c1: t }, { c0: n, c1: r }) => ({
  c0: ke.sub(e, n),
  c1: ke.sub(t, r)
}), VR = ({ c0: e, c1: t }, n) => {
  if (typeof n == "bigint")
    return { c0: ke.mul(e, n), c1: ke.mul(t, n) };
  const { c0: r, c1: i } = n;
  let s = ke.mul(e, r), o = ke.mul(t, i);
  const a = ke.sub(s, o), c = ke.sub(ke.mul(ke.add(e, t), ke.add(r, i)), ke.add(s, o));
  return { c0: a, c1: c };
}, HR = ({ c0: e, c1: t }) => {
  const n = ke.add(e, t), r = ke.sub(e, t), i = ke.add(e, e);
  return { c0: ke.mul(n, r), c1: ke.mul(i, t) };
}, H1 = wT * wT, K = {
  ORDER: H1,
  BITS: Ug(H1),
  BYTES: Math.ceil(Ug(H1) / 8),
  MASK: DE(Ug(H1)),
  ZERO: { c0: ke.ZERO, c1: ke.ZERO },
  ONE: { c0: ke.ONE, c1: ke.ZERO },
  create: (e) => e,
  isValid: ({ c0: e, c1: t }) => typeof e == "bigint" && typeof t == "bigint",
  is0: ({ c0: e, c1: t }) => ke.is0(e) && ke.is0(t),
  eql: ({ c0: e, c1: t }, { c0: n, c1: r }) => ke.eql(e, n) && ke.eql(t, r),
  neg: ({ c0: e, c1: t }) => ({ c0: ke.neg(e), c1: ke.neg(t) }),
  pow: (e, t) => UE(K, e, t),
  invertBatch: (e) => LE(K, e),
  // Normalized
  add: LR,
  sub: zR,
  mul: VR,
  sqr: HR,
  // NonNormalized stuff
  addN: LR,
  subN: zR,
  mulN: VR,
  sqrN: HR,
  // Why inversion for bigint inside Fp instead of Fp2? it is even used in that context?
  div: (e, t) => K.mul(e, typeof t == "bigint" ? ke.inv(ke.create(t)) : K.inv(t)),
  inv: ({ c0: e, c1: t }) => {
    const n = ke.inv(ke.create(e * e + t * t));
    return { c0: ke.mul(n, ke.create(e)), c1: ke.mul(n, ke.create(-t)) };
  },
  sqrt: (e) => {
    if (K.eql(e, K.ZERO))
      return K.ZERO;
    const t = K.pow(e, (K.ORDER + N5e) / R5e), n = K.div(K.sqr(t), e), r = F5e, i = [r[0], r[2], r[4], r[6]].find((p) => K.eql(p, n));
    if (!i)
      throw new Error("No root");
    const s = r.indexOf(i), o = r[s / 2];
    if (!o)
      throw new Error("Invalid root");
    const a = K.div(t, o), c = K.neg(a), { re: l, im: u } = K.reim(a), { re: d, im: f } = K.reim(c);
    return u > f || u === f && l > d ? a : c;
  },
  // Same as sgn0_m_eq_2 in RFC 9380
  isOdd: (e) => {
    const { re: t, im: n } = K.reim(e), r = t % On, i = t === $n, s = n % On;
    return BigInt(r || i && s) == ed;
  },
  // Bytes util
  fromBytes(e) {
    if (e.length !== K.BYTES)
      throw new Error(`fromBytes wrong length=${e.length}`);
    return { c0: ke.fromBytes(e.subarray(0, ke.BYTES)), c1: ke.fromBytes(e.subarray(ke.BYTES)) };
  },
  toBytes: ({ c0: e, c1: t }) => Kn(ke.toBytes(e), ke.toBytes(t)),
  cmov: ({ c0: e, c1: t }, { c0: n, c1: r }, i) => ({
    c0: ke.cmov(e, n, i),
    c1: ke.cmov(t, r, i)
  }),
  // Specific utils
  // toString() {
  //   return `Fp2(${this.c0} + ${this.c1}×i)`;
  // }
  reim: ({ c0: e, c1: t }) => ({ re: e, im: t }),
  // multiply by u + 1
  mulByNonresidue: ({ c0: e, c1: t }) => ({ c0: ke.sub(e, t), c1: ke.add(e, t) }),
  multiplyByB: ({ c0: e, c1: t }) => {
    let n = ke.mul(e, Lg), r = ke.mul(t, Lg);
    return { c0: ke.sub(n, r), c1: ke.add(n, r) };
  },
  fromBigTuple: (e) => {
    if (e.length !== 2)
      throw new Error("Invalid tuple");
    const t = e.map((n) => ke.create(n));
    return { c0: t[0], c1: t[1] };
  },
  frobeniusMap: ({ c0: e, c1: t }, n) => ({
    c0: e,
    c1: ke.mul(t, M5e[n % 2])
  })
}, M5e = [
  BigInt("0x1"),
  BigInt("0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa")
].map((e) => ke.create(e)), Gc = BigInt("0x6af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09"), F5e = [
  [ed, $n],
  [Gc, -Gc],
  [$n, ed],
  [Gc, Gc],
  [-ed, $n],
  [-Gc, Gc],
  [$n, -ed],
  [-Gc, -Gc]
].map((e) => K.fromBigTuple(e)), WR = ({ c0: e, c1: t, c2: n }, { c0: r, c1: i, c2: s }) => ({
  c0: K.add(e, r),
  c1: K.add(t, i),
  c2: K.add(n, s)
}), GR = ({ c0: e, c1: t, c2: n }, { c0: r, c1: i, c2: s }) => ({
  c0: K.sub(e, r),
  c1: K.sub(t, i),
  c2: K.sub(n, s)
}), qR = ({ c0: e, c1: t, c2: n }, r) => {
  if (typeof r == "bigint")
    return {
      c0: K.mul(e, r),
      c1: K.mul(t, r),
      c2: K.mul(n, r)
    };
  const { c0: i, c1: s, c2: o } = r, a = K.mul(e, i), c = K.mul(t, s), l = K.mul(n, o);
  return {
    // t0 + (c1 + c2) * (r1 * r2) - (T1 + T2) * (u + 1)
    c0: K.add(a, K.mulByNonresidue(K.sub(K.mul(K.add(t, n), K.add(s, o)), K.add(c, l)))),
    // (c0 + c1) * (r0 + r1) - (T0 + T1) + T2 * (u + 1)
    c1: K.add(K.sub(K.mul(K.add(e, t), K.add(i, s)), K.add(a, c)), K.mulByNonresidue(l)),
    // T1 + (c0 + c2) * (r0 + r2) - T0 + T2
    c2: K.sub(K.add(c, K.mul(K.add(e, n), K.add(i, o))), K.add(a, l))
  };
}, $R = ({ c0: e, c1: t, c2: n }) => {
  let r = K.sqr(e), i = K.mul(K.mul(e, t), On), s = K.mul(K.mul(t, n), On), o = K.sqr(n);
  return {
    c0: K.add(K.mulByNonresidue(s), r),
    // T3 * (u + 1) + T0
    c1: K.add(K.mulByNonresidue(o), i),
    // T4 * (u + 1) + T1
    // T1 + (c0 - c1 + c2)² + T3 - T0 - T4
    c2: K.sub(K.sub(K.add(K.add(i, K.sqr(K.add(K.sub(e, t), n))), s), r), o)
  };
}, Ve = {
  ORDER: K.ORDER,
  // TODO: unused, but need to verify
  BITS: 3 * K.BITS,
  BYTES: 3 * K.BYTES,
  MASK: DE(3 * K.BITS),
  ZERO: { c0: K.ZERO, c1: K.ZERO, c2: K.ZERO },
  ONE: { c0: K.ONE, c1: K.ZERO, c2: K.ZERO },
  create: (e) => e,
  isValid: ({ c0: e, c1: t, c2: n }) => K.isValid(e) && K.isValid(t) && K.isValid(n),
  is0: ({ c0: e, c1: t, c2: n }) => K.is0(e) && K.is0(t) && K.is0(n),
  neg: ({ c0: e, c1: t, c2: n }) => ({ c0: K.neg(e), c1: K.neg(t), c2: K.neg(n) }),
  eql: ({ c0: e, c1: t, c2: n }, { c0: r, c1: i, c2: s }) => K.eql(e, r) && K.eql(t, i) && K.eql(n, s),
  sqrt: () => {
    throw new Error("Not implemented");
  },
  // Do we need division by bigint at all? Should be done via order:
  div: (e, t) => Ve.mul(e, typeof t == "bigint" ? ke.inv(ke.create(t)) : Ve.inv(t)),
  pow: (e, t) => UE(Ve, e, t),
  invertBatch: (e) => LE(Ve, e),
  // Normalized
  add: WR,
  sub: GR,
  mul: qR,
  sqr: $R,
  // NonNormalized stuff
  addN: WR,
  subN: GR,
  mulN: qR,
  sqrN: $R,
  inv: ({ c0: e, c1: t, c2: n }) => {
    let r = K.sub(K.sqr(e), K.mulByNonresidue(K.mul(n, t))), i = K.sub(K.mulByNonresidue(K.sqr(n)), K.mul(e, t)), s = K.sub(K.sqr(t), K.mul(e, n)), o = K.inv(K.add(K.mulByNonresidue(K.add(K.mul(n, i), K.mul(t, s))), K.mul(e, r)));
    return { c0: K.mul(o, r), c1: K.mul(o, i), c2: K.mul(o, s) };
  },
  // Bytes utils
  fromBytes: (e) => {
    if (e.length !== Ve.BYTES)
      throw new Error(`fromBytes wrong length=${e.length}`);
    return {
      c0: K.fromBytes(e.subarray(0, K.BYTES)),
      c1: K.fromBytes(e.subarray(K.BYTES, 2 * K.BYTES)),
      c2: K.fromBytes(e.subarray(2 * K.BYTES))
    };
  },
  toBytes: ({ c0: e, c1: t, c2: n }) => Kn(K.toBytes(e), K.toBytes(t), K.toBytes(n)),
  cmov: ({ c0: e, c1: t, c2: n }, { c0: r, c1: i, c2: s }, o) => ({
    c0: K.cmov(e, r, o),
    c1: K.cmov(t, i, o),
    c2: K.cmov(n, s, o)
  }),
  // Utils
  //   fromTriple(triple: [Fp2, Fp2, Fp2]) {
  //     return new Fp6(...triple);
  //   }
  //   toString() {
  //     return `Fp6(${this.c0} + ${this.c1} * v, ${this.c2} * v^2)`;
  //   }
  fromBigSix: (e) => {
    if (!Array.isArray(e) || e.length !== 6)
      throw new Error("Invalid Fp6 usage");
    return {
      c0: K.fromBigTuple(e.slice(0, 2)),
      c1: K.fromBigTuple(e.slice(2, 4)),
      c2: K.fromBigTuple(e.slice(4, 6))
    };
  },
  frobeniusMap: ({ c0: e, c1: t, c2: n }, r) => ({
    c0: K.frobeniusMap(e, r),
    c1: K.mul(K.frobeniusMap(t, r), j5e[r % 6]),
    c2: K.mul(K.frobeniusMap(n, r), D5e[r % 6])
  }),
  mulByNonresidue: ({ c0: e, c1: t, c2: n }) => ({ c0: K.mulByNonresidue(n), c1: e, c2: t }),
  // Sparse multiplication
  multiplyBy1: ({ c0: e, c1: t, c2: n }, r) => ({
    c0: K.mulByNonresidue(K.mul(n, r)),
    c1: K.mul(e, r),
    c2: K.mul(t, r)
  }),
  // Sparse multiplication
  multiplyBy01({ c0: e, c1: t, c2: n }, r, i) {
    let s = K.mul(e, r), o = K.mul(t, i);
    return {
      // ((c1 + c2) * b1 - T1) * (u + 1) + T0
      c0: K.add(K.mulByNonresidue(K.sub(K.mul(K.add(t, n), i), o)), s),
      // (b0 + b1) * (c0 + c1) - T0 - T1
      c1: K.sub(K.sub(K.mul(K.add(r, i), K.add(e, t)), s), o),
      // (c0 + c2) * b0 - T0 + T1
      c2: K.add(K.sub(K.mul(K.add(e, n), r), s), o)
    };
  },
  multiplyByFp2: ({ c0: e, c1: t, c2: n }, r) => ({
    c0: K.mul(e, r),
    c1: K.mul(t, r),
    c2: K.mul(n, r)
  })
}, j5e = [
  [BigInt("0x1"), BigInt("0x0")],
  [
    BigInt("0x0"),
    BigInt("0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac")
  ],
  [
    BigInt("0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe"),
    BigInt("0x0")
  ],
  [BigInt("0x0"), BigInt("0x1")],
  [
    BigInt("0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac"),
    BigInt("0x0")
  ],
  [
    BigInt("0x0"),
    BigInt("0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe")
  ]
].map((e) => K.fromBigTuple(e)), D5e = [
  [BigInt("0x1"), BigInt("0x0")],
  [
    BigInt("0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaad"),
    BigInt("0x0")
  ],
  [
    BigInt("0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac"),
    BigInt("0x0")
  ],
  [
    BigInt("0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa"),
    BigInt("0x0")
  ],
  [
    BigInt("0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe"),
    BigInt("0x0")
  ],
  [
    BigInt("0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffeffff"),
    BigInt("0x0")
  ]
].map((e) => K.fromBigTuple(e)), W8 = BigInt("0xd201000000010000"), U5e = Ug(W8), QR = ({ c0: e, c1: t }, { c0: n, c1: r }) => ({
  c0: Ve.add(e, n),
  c1: Ve.add(t, r)
}), KR = ({ c0: e, c1: t }, { c0: n, c1: r }) => ({
  c0: Ve.sub(e, n),
  c1: Ve.sub(t, r)
}), YR = ({ c0: e, c1: t }, n) => {
  if (typeof n == "bigint")
    return { c0: Ve.mul(e, n), c1: Ve.mul(t, n) };
  let { c0: r, c1: i } = n, s = Ve.mul(e, r), o = Ve.mul(t, i);
  return {
    c0: Ve.add(s, Ve.mulByNonresidue(o)),
    // T1 + T2 * v
    // (c0 + c1) * (r0 + r1) - (T1 + T2)
    c1: Ve.sub(Ve.mul(Ve.add(e, t), Ve.add(r, i)), Ve.add(s, o))
  };
}, ZR = ({ c0: e, c1: t }) => {
  let n = Ve.mul(e, t);
  return {
    // (c1 * v + c0) * (c0 + c1) - AB - AB * v
    c0: Ve.sub(Ve.sub(Ve.mul(Ve.add(Ve.mulByNonresidue(t), e), Ve.add(e, t)), n), Ve.mulByNonresidue(n)),
    c1: Ve.add(n, n)
  };
};
function m6(e, t) {
  const n = K.sqr(e), r = K.sqr(t);
  return {
    first: K.add(K.mulByNonresidue(r), n),
    // b² * Nonresidue + a²
    second: K.sub(K.sub(K.sqr(K.add(e, t)), n), r)
    // (a + b)² - a² - b²
  };
}
const dt = {
  ORDER: K.ORDER,
  // TODO: unused, but need to verify
  BITS: 2 * K.BITS,
  BYTES: 2 * K.BYTES,
  MASK: DE(2 * K.BITS),
  ZERO: { c0: Ve.ZERO, c1: Ve.ZERO },
  ONE: { c0: Ve.ONE, c1: Ve.ZERO },
  create: (e) => e,
  isValid: ({ c0: e, c1: t }) => Ve.isValid(e) && Ve.isValid(t),
  is0: ({ c0: e, c1: t }) => Ve.is0(e) && Ve.is0(t),
  neg: ({ c0: e, c1: t }) => ({ c0: Ve.neg(e), c1: Ve.neg(t) }),
  eql: ({ c0: e, c1: t }, { c0: n, c1: r }) => Ve.eql(e, n) && Ve.eql(t, r),
  sqrt: () => {
    throw new Error("Not implemented");
  },
  inv: ({ c0: e, c1: t }) => {
    let n = Ve.inv(Ve.sub(Ve.sqr(e), Ve.mulByNonresidue(Ve.sqr(t))));
    return { c0: Ve.mul(e, n), c1: Ve.neg(Ve.mul(t, n)) };
  },
  div: (e, t) => dt.mul(e, typeof t == "bigint" ? ke.inv(ke.create(t)) : dt.inv(t)),
  pow: (e, t) => UE(dt, e, t),
  invertBatch: (e) => LE(dt, e),
  // Normalized
  add: QR,
  sub: KR,
  mul: YR,
  sqr: ZR,
  // NonNormalized stuff
  addN: QR,
  subN: KR,
  mulN: YR,
  sqrN: ZR,
  // Bytes utils
  fromBytes: (e) => {
    if (e.length !== dt.BYTES)
      throw new Error(`fromBytes wrong length=${e.length}`);
    return {
      c0: Ve.fromBytes(e.subarray(0, Ve.BYTES)),
      c1: Ve.fromBytes(e.subarray(Ve.BYTES))
    };
  },
  toBytes: ({ c0: e, c1: t }) => Kn(Ve.toBytes(e), Ve.toBytes(t)),
  cmov: ({ c0: e, c1: t }, { c0: n, c1: r }, i) => ({
    c0: Ve.cmov(e, n, i),
    c1: Ve.cmov(t, r, i)
  }),
  // Utils
  // toString() {
  //   return `Fp12(${this.c0} + ${this.c1} * w)`;
  // },
  // fromTuple(c: [Fp6, Fp6]) {
  //   return new Fp12(...c);
  // }
  fromBigTwelve: (e) => ({
    c0: Ve.fromBigSix(e.slice(0, 6)),
    c1: Ve.fromBigSix(e.slice(6, 12))
  }),
  // Raises to q**i -th power
  frobeniusMap(e, t) {
    const n = Ve.frobeniusMap(e.c0, t), { c0: r, c1: i, c2: s } = Ve.frobeniusMap(e.c1, t), o = L5e[t % 12];
    return {
      c0: n,
      c1: Ve.create({
        c0: K.mul(r, o),
        c1: K.mul(i, o),
        c2: K.mul(s, o)
      })
    };
  },
  // Sparse multiplication
  multiplyBy014: ({ c0: e, c1: t }, n, r, i) => {
    let s = Ve.multiplyBy01(e, n, r), o = Ve.multiplyBy1(t, i);
    return {
      c0: Ve.add(Ve.mulByNonresidue(o), s),
      // T1 * v + T0
      // (c1 + c0) * [o0, o1+o4] - T0 - T1
      c1: Ve.sub(Ve.sub(Ve.multiplyBy01(Ve.add(t, e), n, K.add(r, i)), s), o)
    };
  },
  multiplyByFp2: ({ c0: e, c1: t }, n) => ({
    c0: Ve.multiplyByFp2(e, n),
    c1: Ve.multiplyByFp2(t, n)
  }),
  conjugate: ({ c0: e, c1: t }) => ({ c0: e, c1: Ve.neg(t) }),
  // A cyclotomic group is a subgroup of Fp^n defined by
  //   GΦₙ(p) = {α ∈ Fpⁿ : α^Φₙ(p) = 1}
  // The result of any pairing is in a cyclotomic subgroup
  // https://eprint.iacr.org/2009/565.pdf
  _cyclotomicSquare: ({ c0: e, c1: t }) => {
    const { c0: n, c1: r, c2: i } = e, { c0: s, c1: o, c2: a } = t, { first: c, second: l } = m6(n, o), { first: u, second: d } = m6(s, i), { first: f, second: p } = m6(r, a);
    let m = K.mulByNonresidue(p);
    return {
      c0: Ve.create({
        c0: K.add(K.mul(K.sub(c, n), On), c),
        // 2 * (T3 - c0c0)  + T3
        c1: K.add(K.mul(K.sub(u, r), On), u),
        // 2 * (T5 - c0c1)  + T5
        c2: K.add(K.mul(K.sub(f, i), On), f)
      }),
      // 2 * (T7 - c0c2)  + T7
      c1: Ve.create({
        c0: K.add(K.mul(K.add(m, s), On), m),
        // 2 * (T9 + c1c0) + T9
        c1: K.add(K.mul(K.add(l, o), On), l),
        // 2 * (T4 + c1c1) + T4
        c2: K.add(K.mul(K.add(d, a), On), d)
      })
    };
  },
  _cyclotomicExp(e, t) {
    let n = dt.ONE;
    for (let r = U5e - 1; r >= 0; r--)
      n = dt._cyclotomicSquare(n), bT(t, r) && (n = dt.mul(n, e));
    return n;
  },
  // https://eprint.iacr.org/2010/354.pdf
  // https://eprint.iacr.org/2009/565.pdf
  finalExponentiate: (e) => {
    const t = W8, n = dt.div(dt.frobeniusMap(e, 6), e), r = dt.mul(dt.frobeniusMap(n, 2), n), i = dt.conjugate(dt._cyclotomicExp(r, t)), s = dt.mul(dt.conjugate(dt._cyclotomicSquare(r)), i), o = dt.conjugate(dt._cyclotomicExp(s, t)), a = dt.conjugate(dt._cyclotomicExp(o, t)), c = dt.mul(dt.conjugate(dt._cyclotomicExp(a, t)), dt._cyclotomicSquare(i)), l = dt.conjugate(dt._cyclotomicExp(c, t)), u = dt.frobeniusMap(dt.mul(i, a), 2), d = dt.frobeniusMap(dt.mul(o, r), 3), f = dt.frobeniusMap(dt.mul(c, dt.conjugate(r)), 1), p = dt.mul(dt.mul(l, dt.conjugate(s)), r);
    return dt.mul(dt.mul(dt.mul(u, d), f), p);
  }
}, L5e = [
  [BigInt("0x1"), BigInt("0x0")],
  [
    BigInt("0x1904d3bf02bb0667c231beb4202c0d1f0fd603fd3cbd5f4f7b2443d784bab9c4f67ea53d63e7813d8d0775ed92235fb8"),
    BigInt("0x00fc3e2b36c4e03288e9e902231f9fb854a14787b6c7b36fec0c8ec971f63c5f282d5ac14d6c7ec22cf78a126ddc4af3")
  ],
  [
    BigInt("0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffeffff"),
    BigInt("0x0")
  ],
  [
    BigInt("0x135203e60180a68ee2e9c448d77a2cd91c3dedd930b1cf60ef396489f61eb45e304466cf3e67fa0af1ee7b04121bdea2"),
    BigInt("0x06af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09")
  ],
  [
    BigInt("0x00000000000000005f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe"),
    BigInt("0x0")
  ],
  [
    BigInt("0x144e4211384586c16bd3ad4afa99cc9170df3560e77982d0db45f3536814f0bd5871c1908bd478cd1ee605167ff82995"),
    BigInt("0x05b2cfd9013a5fd8df47fa6b48b1e045f39816240c0b8fee8beadf4d8e9c0566c63a3e6e257f87329b18fae980078116")
  ],
  [
    BigInt("0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaaa"),
    BigInt("0x0")
  ],
  [
    BigInt("0x00fc3e2b36c4e03288e9e902231f9fb854a14787b6c7b36fec0c8ec971f63c5f282d5ac14d6c7ec22cf78a126ddc4af3"),
    BigInt("0x1904d3bf02bb0667c231beb4202c0d1f0fd603fd3cbd5f4f7b2443d784bab9c4f67ea53d63e7813d8d0775ed92235fb8")
  ],
  [
    BigInt("0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac"),
    BigInt("0x0")
  ],
  [
    BigInt("0x06af0e0437ff400b6831e36d6bd17ffe48395dabc2d3435e77f76e17009241c5ee67992f72ec05f4c81084fbede3cc09"),
    BigInt("0x135203e60180a68ee2e9c448d77a2cd91c3dedd930b1cf60ef396489f61eb45e304466cf3e67fa0af1ee7b04121bdea2")
  ],
  [
    BigInt("0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaad"),
    BigInt("0x0")
  ],
  [
    BigInt("0x05b2cfd9013a5fd8df47fa6b48b1e045f39816240c0b8fee8beadf4d8e9c0566c63a3e6e257f87329b18fae980078116"),
    BigInt("0x144e4211384586c16bd3ad4afa99cc9170df3560e77982d0db45f3536814f0bd5871c1908bd478cd1ee605167ff82995")
  ]
].map((e) => K.fromBigTuple(e)), z5e = c$(K, [
  // xNum
  [
    [
      "0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97d6",
      "0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97d6"
    ],
    [
      "0x0",
      "0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71a"
    ],
    [
      "0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71e",
      "0x8ab05f8bdd54cde190937e76bc3e447cc27c3d6fbd7063fcd104635a790520c0a395554e5c6aaaa9354ffffffffe38d"
    ],
    [
      "0x171d6541fa38ccfaed6dea691f5fb614cb14b4e7f4e810aa22d6108f142b85757098e38d0f671c7188e2aaaaaaaa5ed1",
      "0x0"
    ]
  ],
  // xDen
  [
    [
      "0x0",
      "0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa63"
    ],
    [
      "0xc",
      "0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa9f"
    ],
    ["0x1", "0x0"]
    // LAST 1
  ],
  // yNum
  [
    [
      "0x1530477c7ab4113b59a4c18b076d11930f7da5d4a07f649bf54439d87d27e500fc8c25ebf8c92f6812cfc71c71c6d706",
      "0x1530477c7ab4113b59a4c18b076d11930f7da5d4a07f649bf54439d87d27e500fc8c25ebf8c92f6812cfc71c71c6d706"
    ],
    [
      "0x0",
      "0x5c759507e8e333ebb5b7a9a47d7ed8532c52d39fd3a042a88b58423c50ae15d5c2638e343d9c71c6238aaaaaaaa97be"
    ],
    [
      "0x11560bf17baa99bc32126fced787c88f984f87adf7ae0c7f9a208c6b4f20a4181472aaa9cb8d555526a9ffffffffc71c",
      "0x8ab05f8bdd54cde190937e76bc3e447cc27c3d6fbd7063fcd104635a790520c0a395554e5c6aaaa9354ffffffffe38f"
    ],
    [
      "0x124c9ad43b6cf79bfbf7043de3811ad0761b0f37a1e26286b0e977c69aa274524e79097a56dc4bd9e1b371c71c718b10",
      "0x0"
    ]
  ],
  // yDen
  [
    [
      "0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa8fb",
      "0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa8fb"
    ],
    [
      "0x0",
      "0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffa9d3"
    ],
    [
      "0x12",
      "0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaa99"
    ],
    ["0x1", "0x0"]
    // LAST 1
  ]
].map((e) => e.map((t) => K.fromBigTuple(t.map(BigInt))))), V5e = c$(ke, [
  // xNum
  [
    "0x11a05f2b1e833340b809101dd99815856b303e88a2d7005ff2627b56cdb4e2c85610c2d5f2e62d6eaeac1662734649b7",
    "0x17294ed3e943ab2f0588bab22147a81c7c17e75b2f6a8417f565e33c70d1e86b4838f2a6f318c356e834eef1b3cb83bb",
    "0xd54005db97678ec1d1048c5d10a9a1bce032473295983e56878e501ec68e25c958c3e3d2a09729fe0179f9dac9edcb0",
    "0x1778e7166fcc6db74e0609d307e55412d7f5e4656a8dbf25f1b33289f1b330835336e25ce3107193c5b388641d9b6861",
    "0xe99726a3199f4436642b4b3e4118e5499db995a1257fb3f086eeb65982fac18985a286f301e77c451154ce9ac8895d9",
    "0x1630c3250d7313ff01d1201bf7a74ab5db3cb17dd952799b9ed3ab9097e68f90a0870d2dcae73d19cd13c1c66f652983",
    "0xd6ed6553fe44d296a3726c38ae652bfb11586264f0f8ce19008e218f9c86b2a8da25128c1052ecaddd7f225a139ed84",
    "0x17b81e7701abdbe2e8743884d1117e53356de5ab275b4db1a682c62ef0f2753339b7c8f8c8f475af9ccb5618e3f0c88e",
    "0x80d3cf1f9a78fc47b90b33563be990dc43b756ce79f5574a2c596c928c5d1de4fa295f296b74e956d71986a8497e317",
    "0x169b1f8e1bcfa7c42e0c37515d138f22dd2ecb803a0c5c99676314baf4bb1b7fa3190b2edc0327797f241067be390c9e",
    "0x10321da079ce07e272d8ec09d2565b0dfa7dccdde6787f96d50af36003b14866f69b771f8c285decca67df3f1605fb7b",
    "0x6e08c248e260e70bd1e962381edee3d31d79d7e22c837bc23c0bf1bc24c6b68c24b1b80b64d391fa9c8ba2e8ba2d229"
  ],
  // xDen
  [
    "0x8ca8d548cff19ae18b2e62f4bd3fa6f01d5ef4ba35b48ba9c9588617fc8ac62b558d681be343df8993cf9fa40d21b1c",
    "0x12561a5deb559c4348b4711298e536367041e8ca0cf0800c0126c2588c48bf5713daa8846cb026e9e5c8276ec82b3bff",
    "0xb2962fe57a3225e8137e629bff2991f6f89416f5a718cd1fca64e00b11aceacd6a3d0967c94fedcfcc239ba5cb83e19",
    "0x3425581a58ae2fec83aafef7c40eb545b08243f16b1655154cca8abc28d6fd04976d5243eecf5c4130de8938dc62cd8",
    "0x13a8e162022914a80a6f1d5f43e7a07dffdfc759a12062bb8d6b44e833b306da9bd29ba81f35781d539d395b3532a21e",
    "0xe7355f8e4e667b955390f7f0506c6e9395735e9ce9cad4d0a43bcef24b8982f7400d24bc4228f11c02df9a29f6304a5",
    "0x772caacf16936190f3e0c63e0596721570f5799af53a1894e2e073062aede9cea73b3538f0de06cec2574496ee84a3a",
    "0x14a7ac2a9d64a8b230b3f5b074cf01996e7f63c21bca68a81996e1cdf9822c580fa5b9489d11e2d311f7d99bbdcc5a5e",
    "0xa10ecf6ada54f825e920b3dafc7a3cce07f8d1d7161366b74100da67f39883503826692abba43704776ec3a79a1d641",
    "0x95fc13ab9e92ad4476d6e3eb3a56680f682b4ee96f7d03776df533978f31c1593174e4b4b7865002d6384d168ecdd0a",
    "0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ],
  // yNum
  [
    "0x90d97c81ba24ee0259d1f094980dcfa11ad138e48a869522b52af6c956543d3cd0c7aee9b3ba3c2be9845719707bb33",
    "0x134996a104ee5811d51036d776fb46831223e96c254f383d0f906343eb67ad34d6c56711962fa8bfe097e75a2e41c696",
    "0xcc786baa966e66f4a384c86a3b49942552e2d658a31ce2c344be4b91400da7d26d521628b00523b8dfe240c72de1f6",
    "0x1f86376e8981c217898751ad8746757d42aa7b90eeb791c09e4a3ec03251cf9de405aba9ec61deca6355c77b0e5f4cb",
    "0x8cc03fdefe0ff135caf4fe2a21529c4195536fbe3ce50b879833fd221351adc2ee7f8dc099040a841b6daecf2e8fedb",
    "0x16603fca40634b6a2211e11db8f0a6a074a7d0d4afadb7bd76505c3d3ad5544e203f6326c95a807299b23ab13633a5f0",
    "0x4ab0b9bcfac1bbcb2c977d027796b3ce75bb8ca2be184cb5231413c4d634f3747a87ac2460f415ec961f8855fe9d6f2",
    "0x987c8d5333ab86fde9926bd2ca6c674170a05bfe3bdd81ffd038da6c26c842642f64550fedfe935a15e4ca31870fb29",
    "0x9fc4018bd96684be88c9e221e4da1bb8f3abd16679dc26c1e8b6e6a1f20cabe69d65201c78607a360370e577bdba587",
    "0xe1bba7a1186bdb5223abde7ada14a23c42a0ca7915af6fe06985e7ed1e4d43b9b3f7055dd4eba6f2bafaaebca731c30",
    "0x19713e47937cd1be0dfd0b8f1d43fb93cd2fcbcb6caf493fd1183e416389e61031bf3a5cce3fbafce813711ad011c132",
    "0x18b46a908f36f6deb918c143fed2edcc523559b8aaf0c2462e6bfe7f911f643249d9cdf41b44d606ce07c8a4d0074d8e",
    "0xb182cac101b9399d155096004f53f447aa7b12a3426b08ec02710e807b4633f06c851c1919211f20d4c04f00b971ef8",
    "0x245a394ad1eca9b72fc00ae7be315dc757b3b080d4c158013e6632d3c40659cc6cf90ad1c232a6442d9d3f5db980133",
    "0x5c129645e44cf1102a159f748c4a3fc5e673d81d7e86568d9ab0f5d396a7ce46ba1049b6579afb7866b1e715475224b",
    "0x15e6be4e990f03ce4ea50b3b42df2eb5cb181d8f84965a3957add4fa95af01b2b665027efec01c7704b456be69c8b604"
  ],
  // yDen
  [
    "0x16112c4c3a9c98b252181140fad0eae9601a6de578980be6eec3232b5be72e7a07f3688ef60c206d01479253b03663c1",
    "0x1962d75c2381201e1a0cbd6c43c348b885c84ff731c4d59ca4a10356f453e01f78a4260763529e3532f6102c2e49a03d",
    "0x58df3306640da276faaae7d6e8eb15778c4855551ae7f310c35a5dd279cd2eca6757cd636f96f891e2538b53dbf67f2",
    "0x16b7d288798e5395f20d23bf89edb4d1d115c5dbddbcd30e123da489e726af41727364f2c28297ada8d26d98445f5416",
    "0xbe0e079545f43e4b00cc912f8228ddcc6d19c9f0f69bbb0542eda0fc9dec916a20b15dc0fd2ededda39142311a5001d",
    "0x8d9e5297186db2d9fb266eaac783182b70152c65550d881c5ecd87b6f0f5a6449f38db9dfa9cce202c6477faaf9b7ac",
    "0x166007c08a99db2fc3ba8734ace9824b5eecfdfa8d0cf8ef5dd365bc400a0051d5fa9c01a58b1fb93d1a1399126a775c",
    "0x16a3ef08be3ea7ea03bcddfabba6ff6ee5a4375efa1f4fd7feb34fd206357132b920f5b00801dee460ee415a15812ed9",
    "0x1866c8ed336c61231a1be54fd1d74cc4f9fb0ce4c6af5920abc5750c4bf39b4852cfe2f7bb9248836b233d9d55535d4a",
    "0x167a55cda70a6e1cea820597d94a84903216f763e13d87bb5308592e7ea7d4fbc7385ea3d529b35e346ef48bb8913f55",
    "0x4d2f259eea405bd48f010a01ad2911d9c6dd039bb61a6290e591b36e636a5c871a5c29f4f83060400f8b49cba8f6aa8",
    "0xaccbb67481d033ff5852c1e48c50c477f94ff8aefce42d28c0f9a88cea7913516f968986f7ebbea9684b529e2561092",
    "0xad6b9514c767fe3c3613144b45f1496543346d98adf02267d5ceef9a00d9b8693000763e3b90ac11e99b138573345cc",
    "0x2660400eb2e4f3b628bdd0d53cd76f2bf565b94e72927c1cb748df27942480e420517bd8714cc80d1fadc1326ed06f7",
    "0xe0fa1d816ddc03e6b24255e0d7819c171c40f65e273b853324efcd6356caa205ca2f570f13497804415473a1d634b8f",
    "0x000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001"
    // LAST 1
  ]
].map((e) => e.map((t) => BigInt(t)))), H5e = d$(K, {
  A: K.create({ c0: ke.create($n), c1: ke.create(BigInt(240)) }),
  // A' = 240 * I
  B: K.create({ c0: ke.create(BigInt(1012)), c1: ke.create(BigInt(1012)) }),
  // B' = 1012 * (1 + I)
  Z: K.create({ c0: ke.create(BigInt(-2)), c1: ke.create(BigInt(-1)) })
  // Z: -(2 + I)
}), W5e = d$(ke, {
  A: ke.create(BigInt("0x144698a3b8e9433d693a02c96d4982b0ea985383ee66a8d8e8981aefd881ac98936f8da0e0f97f5cf428082d584c1d")),
  B: ke.create(BigInt("0x12e2908d11688030018b12e8753eee3b2016c1f0f24f4070a0b9c14fcef35ef55a23215a316ceaa5d1cc48e98e172be0")),
  Z: ke.create(BigInt(11))
}), f$ = Ve.create({ c0: K.ZERO, c1: K.ONE, c2: K.ZERO }), h$ = dt.create({ c0: f$, c1: Ve.ZERO }), p$ = dt.create({ c0: Ve.ZERO, c1: f$ }), [G5e, q5e] = dt.invertBatch([h$, p$]);
function $5e(e, t) {
  const n = dt.mul(dt.frobeniusMap(dt.multiplyByFp2(G5e, e), 1), h$).c0.c0, r = dt.mul(dt.frobeniusMap(dt.multiplyByFp2(q5e, t), 1), p$).c0.c0;
  return [n, r];
}
function JR(e, t) {
  const n = t.toAffine(), r = $5e(n.x, n.y);
  return new e(r[0], r[1], K.ONE);
}
const Q5e = BigInt("0x1a0111ea397fe699ec02408663d4de85aa0d857d89759ad4897d29650fb85f9b409427eb4f49fffd8bfd00000000aaac");
function K5e(e, t) {
  return [K.mul(e, Q5e), K.neg(t)];
}
function Y5e(e, t) {
  const n = t.toAffine(), r = K5e(n.x, n.y);
  return new e(r[0], r[1], K.ONE);
}
const g6 = Object.freeze({
  // DST: a domain separation tag
  // defined in section 2.2.5
  // Use utils.getDSTLabel(), utils.setDSTLabel(value)
  DST: "BLS_SIG_BLS12381G2_XMD:SHA-256_SSWU_RO_NUL_",
  encodeDST: "BLS_SIG_BLS12381G2_XMD:SHA-256_SSWU_RO_NUL_",
  // p: the characteristic of F
  //    where F is a finite field of characteristic p and order q = p^m
  p: ke.ORDER,
  // m: the extension degree of F, m >= 1
  //     where F is a finite field of characteristic p and order q = p^m
  m: 2,
  // k: the target security level for the suite in bits
  // defined in section 5.1
  k: 128,
  // option to use a message that has already been processed by
  // expand_message_xmd
  expand: "xmd",
  // Hash functions for: expand_message_xmd is appropriate for use with a
  // wide range of hash functions, including SHA-2, SHA-3, BLAKE2, and others.
  // BBS+ uses blake2: https://github.com/hyperledger/aries-framework-go/issues/2247
  hash: B8
}), T2 = Gy(ke.toBytes($n), { infinity: !0, compressed: !0 });
function W1(e) {
  e = e.slice();
  const t = e[0] & 224, n = !!(t >> 7 & 1), r = !!(t >> 6 & 1), i = !!(t >> 5 & 1);
  return e[0] &= 31, { compressed: n, infinity: r, sort: i, value: e };
}
function Gy(e, t) {
  if (e[0] & 224)
    throw new Error("setMask: non-empty mask");
  return t.compressed && (e[0] |= 128), t.infinity && (e[0] |= 64), t.sort && (e[0] |= 32), e;
}
function XR(e) {
  e.assertValidity();
  const t = e.equals(vr.G1.ProjectivePoint.ZERO), { x: n, y: r } = e.toAffine();
  if (t)
    return T2.slice();
  const i = ke.ORDER, s = !!(r * On / i);
  return Gy(Er(n, ke.BYTES), { compressed: !0, sort: s });
}
function e9(e) {
  e.assertValidity();
  const t = ke.BYTES;
  if (e.equals(vr.G2.ProjectivePoint.ZERO))
    return Kn(T2, Er($n, t));
  const { x: n, y: r } = e.toAffine(), { re: i, im: s } = K.reim(n), { re: o, im: a } = K.reim(r), l = !!((a > $n ? a * On : o * On) / ke.ORDER & ed), u = i;
  return Kn(Gy(Er(s, t), { sort: l, compressed: !0 }), Er(u, t));
}
const vr = O5e({
  // Fields
  fields: {
    Fp: ke,
    Fp2: K,
    Fp6: Ve,
    Fp12: dt,
    Fr: UR
  },
  // G1 is the order-q subgroup of E1(Fp) : y² = x³ + 4, #E1(Fp) = h1q, where
  // characteristic; z + (z⁴ - z² + 1)(z - 1)²/3
  G1: {
    Fp: ke,
    // cofactor; (z - 1)²/3
    h: BigInt("0x396c8c005555e1568c00aaab0000aaab"),
    // generator's coordinates
    // x = 3685416753713387016781088315183077757961620795782546409894578378688607592378376318836054947676345821548104185464507
    // y = 1339506544944476473020471379941921221584933875938349620426543736416511423956333506472724655353366534992391756441569
    Gx: BigInt("0x17f1d3a73197d7942695638c4fa9ac0fc3688c4f9774b905a14e3a3f171bac586c55e83ff97a1aeffb3af00adb22c6bb"),
    Gy: BigInt("0x08b3f481e3aaa0f1a09e30ed741d8ae4fcf5e095d5d00af600db18cb2c04b3edd03cc744a2888ae40caa232946c5e7e1"),
    a: ke.ZERO,
    b: Lg,
    htfDefaults: { ...g6, m: 1, DST: "BLS_SIG_BLS12381G1_XMD:SHA-256_SSWU_RO_NUL_" },
    wrapPrivateKey: !0,
    allowInfinityPoint: !0,
    // Checks is the point resides in prime-order subgroup.
    // point.isTorsionFree() should return true for valid points
    // It returns false for shitty points.
    // https://eprint.iacr.org/2021/1130.pdf
    isTorsionFree: (e, t) => {
      const n = BigInt("0x5f19672fdf76ce51ba69c6076a0f77eaddb3a93be6f89688de17d813620a00022e01fffffffefffe"), r = new e(ke.mul(t.px, n), t.py, t.pz);
      return t.multiplyUnsafe(vr.params.x).negate().multiplyUnsafe(vr.params.x).equals(r);
    },
    // Clear cofactor of G1
    // https://eprint.iacr.org/2019/403
    clearCofactor: (e, t) => t.multiplyUnsafe(vr.params.x).add(t),
    mapToCurve: (e) => {
      const { x: t, y: n } = W5e(ke.create(e[0]));
      return V5e(t, n);
    },
    fromBytes: (e) => {
      const { compressed: t, infinity: n, sort: r, value: i } = W1(e);
      if (i.length === 48 && t) {
        const s = ke.ORDER, o = to(i), a = ke.create(o & ke.MASK);
        if (n) {
          if (a !== $n)
            throw new Error("G1: non-empty compressed point at infinity");
          return { x: $n, y: $n };
        }
        const c = ke.add(ke.pow(a, V1), ke.create(vr.params.G1b));
        let l = ke.sqrt(c);
        if (!l)
          throw new Error("Invalid compressed G1 point");
        return l * On / s !== BigInt(r) && (l = ke.neg(l)), { x: ke.create(a), y: ke.create(l) };
      } else if (i.length === 96 && !t) {
        const s = to(i.subarray(0, ke.BYTES)), o = to(i.subarray(ke.BYTES));
        if (n) {
          if (s !== $n || o !== $n)
            throw new Error("G1: non-empty point at infinity");
          return vr.G1.ProjectivePoint.ZERO.toAffine();
        }
        return { x: ke.create(s), y: ke.create(o) };
      } else
        throw new Error("Invalid point G1, expected 48/96 bytes");
    },
    toBytes: (e, t, n) => {
      const r = t.equals(e.ZERO), { x: i, y: s } = t.toAffine();
      if (n) {
        if (r)
          return T2.slice();
        const o = ke.ORDER, a = !!(s * On / o);
        return Gy(Er(i, ke.BYTES), { compressed: !0, sort: a });
      } else
        return r ? Kn(new Uint8Array([64]), new Uint8Array(2 * ke.BYTES - 1)) : Kn(Er(i, ke.BYTES), Er(s, ke.BYTES));
    },
    ShortSignature: {
      fromHex(e) {
        const { infinity: t, sort: n, value: r } = W1(Ai("signatureHex", e, 48)), i = ke.ORDER, s = to(r);
        if (t)
          return vr.G1.ProjectivePoint.ZERO;
        const o = ke.create(s & ke.MASK), a = ke.add(ke.pow(o, V1), ke.create(vr.params.G1b));
        let c = ke.sqrt(a);
        if (!c)
          throw new Error("Invalid compressed G1 point");
        const l = BigInt(n);
        c * On / i !== l && (c = ke.neg(c));
        const u = vr.G1.ProjectivePoint.fromAffine({ x: o, y: c });
        return u.assertValidity(), u;
      },
      toRawBytes(e) {
        return XR(e);
      },
      toHex(e) {
        return pf(XR(e));
      }
    }
  },
  // G2 is the order-q subgroup of E2(Fp²) : y² = x³+4(1+√−1),
  // where Fp2 is Fp[√−1]/(x2+1). #E2(Fp2 ) = h2q, where
  // G² - 1
  // h2q
  G2: {
    Fp: K,
    // cofactor
    h: BigInt("0x5d543a95414e7f1091d50792876a202cd91de4547085abaa68a205b2e5a7ddfa628f1cb4d9e82ef21537e293a6691ae1616ec6e786f0c70cf1c38e31c7238e5"),
    Gx: K.fromBigTuple([
      BigInt("0x024aa2b2f08f0a91260805272dc51051c6e47ad4fa403b02b4510b647ae3d1770bac0326a805bbefd48056c8c121bdb8"),
      BigInt("0x13e02b6052719f607dacd3a088274f65596bd0d09920b61ab5da61bbdc7f5049334cf11213945d57e5ac7d055d042b7e")
    ]),
    // y =
    // 927553665492332455747201965776037880757740193453592970025027978793976877002675564980949289727957565575433344219582,
    // 1985150602287291935568054521177171638300868978215655730859378665066344726373823718423869104263333984641494340347905
    Gy: K.fromBigTuple([
      BigInt("0x0ce5d527727d6e118cc9cdc6da2e351aadfd9baa8cbdd3a76d429a695160d12c923ac9cc3baca289e193548608b82801"),
      BigInt("0x0606c4a02ea734cc32acd2b02bc28b99cb3e287e85a763af267492ab572e99ab3f370d275cec1da1aaa9075ff05f79be")
    ]),
    a: K.ZERO,
    b: K.fromBigTuple([Lg, Lg]),
    hEff: BigInt("0xbc69f08f2ee75b3584c6a0ea91b352888e2a8e9145ad7689986ff031508ffe1329c2f178731db956d82bf015d1212b02ec0ec69d7477c1ae954cbc06689f6a359894c0adebbf6b4e8020005aaa95551"),
    htfDefaults: { ...g6 },
    wrapPrivateKey: !0,
    allowInfinityPoint: !0,
    mapToCurve: (e) => {
      const { x: t, y: n } = H5e(K.fromBigTuple(e));
      return z5e(t, n);
    },
    // Checks is the point resides in prime-order subgroup.
    // point.isTorsionFree() should return true for valid points
    // It returns false for shitty points.
    // https://eprint.iacr.org/2021/1130.pdf
    isTorsionFree: (e, t) => t.multiplyUnsafe(vr.params.x).negate().equals(JR(e, t)),
    // Maps the point into the prime-order subgroup G2.
    // clear_cofactor_bls12381_g2 from cfrg-hash-to-curve-11
    // https://eprint.iacr.org/2017/419.pdf
    // prettier-ignore
    clearCofactor: (e, t) => {
      const n = vr.params.x;
      let r = t.multiplyUnsafe(n).negate(), i = JR(e, t), s = t.double();
      return s = Y5e(e, s), s = s.subtract(i), i = r.add(i), i = i.multiplyUnsafe(n).negate(), s = s.add(i), s = s.subtract(r), s.subtract(t);
    },
    fromBytes: (e) => {
      const { compressed: t, infinity: n, sort: r, value: i } = W1(e);
      if (!t && !n && r || // 00100000
      !t && n && r || // 01100000
      r && n && t)
        throw new Error("Invalid encoding flag: " + (e[0] & 224));
      const s = ke.BYTES, o = (a, c, l) => to(a.slice(c, l));
      if (i.length === 96 && t) {
        const a = vr.params.G2b, c = ke.ORDER;
        if (n) {
          if (i.reduce((h, g) => h !== 0 ? g + 1 : g, 0) > 0)
            throw new Error("Invalid compressed G2 point");
          return { x: K.ZERO, y: K.ZERO };
        }
        const l = o(i, 0, s), u = o(i, s, 2 * s), d = K.create({ c0: ke.create(u), c1: ke.create(l) }), f = K.add(K.pow(d, V1), a);
        let p = K.sqrt(f);
        const m = p.c1 === $n ? p.c0 * On / c : p.c1 * On / c ? ed : $n;
        return p = r && m > 0 ? p : K.neg(p), { x: d, y: p };
      } else if (i.length === 192 && !t) {
        if (n) {
          if (i.reduce((d, f) => d !== 0 ? f + 1 : f, 0) > 0)
            throw new Error("Invalid uncompressed G2 point");
          return { x: K.ZERO, y: K.ZERO };
        }
        const a = o(i, 0, s), c = o(i, s, 2 * s), l = o(i, 2 * s, 3 * s), u = o(i, 3 * s, 4 * s);
        return { x: K.fromBigTuple([c, a]), y: K.fromBigTuple([u, l]) };
      } else
        throw new Error("Invalid point G2, expected 96/192 bytes");
    },
    toBytes: (e, t, n) => {
      const { BYTES: r, ORDER: i } = ke, s = t.equals(e.ZERO), { x: o, y: a } = t.toAffine();
      if (n) {
        if (s)
          return Kn(T2, Er($n, r));
        const c = !!(a.c1 === $n ? a.c0 * On / i : a.c1 * On / i);
        return Kn(Gy(Er(o.c1, r), { compressed: !0, sort: c }), Er(o.c0, r));
      } else {
        if (s)
          return Kn(new Uint8Array([64]), new Uint8Array(4 * r - 1));
        const { re: c, im: l } = K.reim(o), { re: u, im: d } = K.reim(a);
        return Kn(Er(l, r), Er(c, r), Er(d, r), Er(u, r));
      }
    },
    Signature: {
      // TODO: Optimize, it's very slow because of sqrt.
      fromHex(e) {
        const { infinity: t, sort: n, value: r } = W1(Ai("signatureHex", e)), i = ke.ORDER, s = r.length / 2;
        if (s !== 48 && s !== 96)
          throw new Error("Invalid compressed signature length, must be 96 or 192");
        const o = to(r.slice(0, s)), a = to(r.slice(s));
        if (t)
          return vr.G2.ProjectivePoint.ZERO;
        const c = ke.create(o & ke.MASK), l = ke.create(a), u = K.create({ c0: l, c1: c }), d = K.add(K.pow(u, V1), vr.params.G2b);
        let f = K.sqrt(d);
        if (!f)
          throw new Error("Failed to find a square root");
        const { re: p, im: m } = K.reim(f), h = BigInt(n), g = m > $n && m * On / i !== h, y = m === $n && p * On / i !== h;
        (g || y) && (f = K.neg(f));
        const v = vr.G2.ProjectivePoint.fromAffine({ x: u, y: f });
        return v.assertValidity(), v;
      },
      toRawBytes(e) {
        return e9(e);
      },
      toHex(e) {
        return pf(e9(e));
      }
    }
  },
  params: {
    x: W8,
    // The BLS parameter x for BLS12-381
    r: UR.ORDER
    // order; z⁴ − z² + 1; CURVE.n from other curves
  },
  htfDefaults: g6,
  hash: B8,
  randomBytes: QG
});
function Z5e(e, t, n) {
  const r = typeof e == "string" ? e : uo(e), i = typeof t == "string" ? t : uo(t), s = typeof n == "string" ? n : uo(n);
  return vr.verifyShortSignature(i, s, r);
}
const m$ = (e) => ur(new s0(e)), G8 = (e) => {
  const t = m$(e);
  return new Date(Number(t) / 1e6);
};
class na extends Bi {
  constructor(t) {
    super(`Invalid certificate: ${t}`);
  }
}
const oa = {
  Empty: 0,
  Fork: 1,
  Labeled: 2,
  Leaf: 3,
  Pruned: 4
};
function g$(e, t) {
  if (e.byteLength !== t.byteLength)
    return !1;
  const n = new Uint8Array(e), r = new Uint8Array(t);
  for (let i = 0; i < n.length; i++)
    if (n[i] !== r[i])
      return !1;
  return !0;
}
class Yh {
  constructor(t, n, r, i, s = 5) {
    this._rootKey = n, this._canisterId = r, this._blsVerify = i, this._maxAgeInMinutes = s, this.cert = cc(new Uint8Array(t));
  }
  /**
   * Create a new instance of a certificate, automatically verifying it. Throws a
   * CertificateVerificationError if the certificate cannot be verified.
   * @constructs  Certificate
   * @param {CreateCertificateOptions} options {@link CreateCertificateOptions}
   * @param {ArrayBuffer} options.certificate The bytes of the certificate
   * @param {ArrayBuffer} options.rootKey The root key to verify against
   * @param {Principal} options.canisterId The effective or signing canister ID
   * @param {number} options.maxAgeInMinutes The maximum age of the certificate in minutes. Default is 5 minutes.
   * @throws {CertificateVerificationError}
   */
  static async create(t) {
    const n = Yh.createUnverified(t);
    return await n.verify(), n;
  }
  static createUnverified(t) {
    let n = t.blsVerify;
    return n || (n = Z5e), new Yh(t.certificate, t.rootKey, t.canisterId, n, t.maxAgeInMinutes);
  }
  lookup(t) {
    return y$(Mm(t, this.cert.tree));
  }
  lookup_label(t) {
    return this.lookup([t]);
  }
  async verify() {
    const t = await Ww(this.cert.tree), n = await this._checkDelegationAndGetKey(this.cert.delegation), r = this.cert.signature, i = X5e(n), s = ma(X0("ic-state-root"), t);
    let o = !1;
    const a = this.lookup(["time"]);
    if (!a)
      throw new na("Certificate does not contain a time");
    const c = 5 * 60 * 1e3, l = this._maxAgeInMinutes * 60 * 1e3, u = Date.now(), d = u - l, f = u + c, p = G8(a);
    if (p.getTime() < d)
      throw new na(`Certificate is signed more than ${this._maxAgeInMinutes} minutes in the past. Certificate time: ` + p.toISOString() + " Current time: " + new Date(u).toISOString());
    if (p.getTime() > f)
      throw new na("Certificate is signed more than 5 minutes in the future. Certificate time: " + p.toISOString() + " Current time: " + new Date(u).toISOString());
    try {
      o = await this._blsVerify(new Uint8Array(i), new Uint8Array(r), new Uint8Array(s));
    } catch {
      o = !1;
    }
    if (!o)
      throw new na("Signature verification failed");
  }
  async _checkDelegationAndGetKey(t) {
    if (!t)
      return this._rootKey;
    const n = await Yh.createUnverified({
      certificate: t.certificate,
      rootKey: this._rootKey,
      canisterId: this._canisterId,
      blsVerify: this._blsVerify,
      // Do not check max age for delegation certificates
      maxAgeInMinutes: 1 / 0
    });
    if (n.cert.delegation)
      throw new na("Delegation certificates cannot be nested");
    if (await n.verify(), !b$({
      canisterId: this._canisterId,
      subnetId: gt.fromUint8Array(new Uint8Array(t.subnet_id)),
      tree: n.cert.tree
    }))
      throw new na(`Canister ${this._canisterId} not in range of delegations for subnet 0x${uo(t.subnet_id)}`);
    const i = n.lookup(["subnet", t.subnet_id, "public_key"]);
    if (!i)
      throw new Error(`Could not find subnet key for subnet 0x${uo(t.subnet_id)}`);
    return i;
  }
}
const O0 = E2("308182301d060d2b0601040182dc7c0503010201060c2b0601040182dc7c05030201036100"), J5e = 96;
function X5e(e) {
  const t = O0.byteLength + J5e;
  if (e.byteLength !== t)
    throw new TypeError(`BLS DER-encoded public key must be ${t} bytes long`);
  const n = e.slice(0, O0.byteLength);
  if (!g$(n, O0))
    throw new TypeError(`BLS DER-encoded public key is invalid. Expect the following prefix: ${O0}, but get ${n}`);
  return e.slice(O0.byteLength);
}
function y$(e) {
  if (e instanceof ArrayBuffer)
    return e;
  if (e instanceof Uint8Array)
    return e.buffer;
}
async function Ww(e) {
  switch (e[0]) {
    case oa.Empty:
      return io(X0("ic-hashtree-empty"));
    case oa.Pruned:
      return e[1];
    case oa.Leaf:
      return io(ma(X0("ic-hashtree-leaf"), e[1]));
    case oa.Labeled:
      return io(ma(X0("ic-hashtree-labeled"), e[1], await Ww(e[2])));
    case oa.Fork:
      return io(ma(X0("ic-hashtree-fork"), await Ww(e[1]), await Ww(e[2])));
    default:
      throw new Error("unreachable");
  }
}
function X0(e) {
  const t = new Uint8Array([e.length]), n = new TextEncoder().encode(e);
  return ma(t, n);
}
function Mm(e, t) {
  if (e.length === 0)
    switch (t[0]) {
      case oa.Leaf: {
        if (!t[1])
          throw new Error("Invalid tree structure for leaf");
        return t[1] instanceof ArrayBuffer ? t[1] : t[1] instanceof Uint8Array ? t[1].buffer : t[1];
      }
      case oa.Fork:
        return t;
      default:
        return t;
    }
  const n = typeof e[0] == "string" ? new TextEncoder().encode(e[0]) : e[0], r = e4e(n, k2(t));
  if (r)
    return Mm(e.slice(1), r);
}
function k2(e) {
  switch (e[0]) {
    case oa.Empty:
      return [];
    case oa.Fork:
      return k2(e[1]).concat(k2(e[2]));
    default:
      return [e];
  }
}
function e4e(e, t) {
  if (t.length !== 0) {
    for (const n of t)
      if (n[0] === oa.Labeled) {
        const r = n[1];
        if (g$(e, r))
          return n[2];
      }
  }
}
function b$(e) {
  const { canisterId: t, subnetId: n, tree: r } = e, i = Mm(["subnet", n.toUint8Array(), "canister_ranges"], r);
  if (!i || !(i instanceof ArrayBuffer))
    throw new Error(`Could not find canister ranges for subnet ${n}`);
  return cc(i).map((c) => [
    gt.fromUint8Array(c[0]),
    gt.fromUint8Array(c[1])
  ]).some((c) => c[0].ltEq(t) && c[1].gtEq(t));
}
class t4e {
  constructor(t, n, r) {
    this.key = t, this.path = n, this.decodeStrategy = r;
  }
}
const v$ = async (e) => {
  const { agent: t, paths: n } = e, r = gt.from(e.canisterId), i = [...new Set(n)], s = i.map((c) => xT(c, r)), o = /* @__PURE__ */ new Map(), a = i.map((c, l) => (async () => {
    var u;
    try {
      const d = await t.readState(r, {
        paths: [s[l]]
      }), f = await Yh.create({
        certificate: d.certificate,
        rootKey: t.rootKey,
        canisterId: r
      }), p = (g, y) => {
        if (y === "subnet") {
          const v = w$(d.certificate, r, t.rootKey);
          return {
            path: y,
            data: v
          };
        } else
          return {
            path: y,
            data: y$(g.lookup(xT(y, r)))
          };
      }, { path: m, data: h } = p(f, i[l]);
      if (!h)
        console.warn(`Expected to find result for path ${m}, but instead found nothing.`), typeof m == "string" ? o.set(m, null) : o.set(m.key, null);
      else
        switch (m) {
          case "time": {
            o.set(m, G8(h));
            break;
          }
          case "controllers": {
            o.set(m, r4e(h));
            break;
          }
          case "module_hash": {
            o.set(m, t9(h));
            break;
          }
          case "subnet": {
            o.set(m, h);
            break;
          }
          case "candid": {
            o.set(m, new TextDecoder().decode(h));
            break;
          }
          default:
            if (typeof m != "string" && "key" in m && "path" in m)
              switch (m.decodeStrategy) {
                case "raw":
                  o.set(m.key, h);
                  break;
                case "leb128": {
                  o.set(m.key, m$(h));
                  break;
                }
                case "cbor": {
                  o.set(m.key, x$(h));
                  break;
                }
                case "hex": {
                  o.set(m.key, t9(h));
                  break;
                }
                case "utf-8":
                  o.set(m.key, n4e(h));
              }
        }
    } catch (d) {
      if (!((u = d == null ? void 0 : d.message) === null || u === void 0) && u.includes("Invalid certificate"))
        throw new Bi(d.message);
      typeof c != "string" && "key" in c && "path" in c ? o.set(c.key, null) : o.set(c, null), console.group(), console.warn(`Expected to find result for path ${c}, but instead found nothing.`), console.warn(d), console.groupEnd();
    }
  })());
  return await Promise.all(a), o;
}, w$ = (e, t, n) => {
  if (!t._isPrincipal)
    throw new Error("Invalid canisterId");
  const r = cc(new Uint8Array(e)), i = r.tree;
  let s = r.delegation, o;
  if (s && s.subnet_id ? o = gt.fromUint8Array(new Uint8Array(s.subnet_id)) : !s && typeof n < "u" ? (o = gt.selfAuthenticating(new Uint8Array(n)), s = {
    subnet_id: o.toUint8Array(),
    certificate: new ArrayBuffer(0)
  }) : (o = gt.selfAuthenticating(gt.fromText("tdb26-jop6k-aogll-7ltgs-eruif-6kk7m-qpktf-gdiqx-mxtrf-vb5e6-eqe").toUint8Array()), s = {
    subnet_id: o.toUint8Array(),
    certificate: new ArrayBuffer(0)
  }), !b$({ canisterId: t, subnetId: o, tree: i }))
    throw new Error("Canister not in range");
  const c = Mm(["subnet", s == null ? void 0 : s.subnet_id, "node"], i), l = k2(c);
  l.length;
  const u = /* @__PURE__ */ new Map();
  return l.forEach((d) => {
    Object.getPrototypeOf(new Uint8Array(d[1]));
    const f = gt.from(new Uint8Array(d[1])).toText(), p = Mm(["public_key"], d[2]);
    if (p.byteLength !== 44)
      throw new Error("Invalid public key length");
    u.set(f, p);
  }), {
    subnetId: gt.fromUint8Array(new Uint8Array(s.subnet_id)).toText(),
    nodeKeys: u
  };
}, xT = (e, t) => {
  const n = new TextEncoder(), r = (s) => new DataView(n.encode(s).buffer).buffer, i = new DataView(t.toUint8Array().buffer).buffer;
  switch (e) {
    case "time":
      return [r("time")];
    case "controllers":
      return [r("canister"), i, r("controllers")];
    case "module_hash":
      return [r("canister"), i, r("module_hash")];
    case "subnet":
      return [r("subnet")];
    case "candid":
      return [r("canister"), i, r("metadata"), r("candid:service")];
    default:
      if ("key" in e && "path" in e)
        if (typeof e.path == "string" || e.path instanceof ArrayBuffer) {
          const s = e.path, o = typeof s == "string" ? r(s) : s;
          return [r("canister"), i, r("metadata"), o];
        } else
          return e.path;
  }
  throw new Error(`An unexpeected error was encountered while encoding your path for canister status. Please ensure that your path, ${e} was formatted correctly.`);
}, t9 = (e) => uo(e), x$ = (e) => cc(e), n4e = (e) => new TextDecoder().decode(e), r4e = (e) => x$(e).map((n) => gt.fromUint8Array(new Uint8Array(n))), i4e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CustomPath: t4e,
  encodePath: xT,
  fetchNodeKeys: w$,
  request: v$
}, Symbol.toStringTag, { value: "Module" })), G1 = /* @__PURE__ */ BigInt(2 ** 32 - 1), AT = /* @__PURE__ */ BigInt(32);
function A$(e, t = !1) {
  return t ? { h: Number(e & G1), l: Number(e >> AT & G1) } : { h: Number(e >> AT & G1) | 0, l: Number(e & G1) | 0 };
}
function s4e(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: s, l: o } = A$(e[i], t);
    [n[i], r[i]] = [s, o];
  }
  return [n, r];
}
const o4e = (e, t) => BigInt(e >>> 0) << AT | BigInt(t >>> 0), a4e = (e, t, n) => e >>> n, c4e = (e, t, n) => e << 32 - n | t >>> n, l4e = (e, t, n) => e >>> n | t << 32 - n, u4e = (e, t, n) => e << 32 - n | t >>> n, d4e = (e, t, n) => e << 64 - n | t >>> n - 32, f4e = (e, t, n) => e >>> n - 32 | t << 64 - n, h4e = (e, t) => t, p4e = (e, t) => e, m4e = (e, t, n) => e << n | t >>> 32 - n, g4e = (e, t, n) => t << n | e >>> 32 - n, y4e = (e, t, n) => t << n - 32 | e >>> 64 - n, b4e = (e, t, n) => e << n - 32 | t >>> 64 - n;
function v4e(e, t, n, r) {
  const i = (t >>> 0) + (r >>> 0);
  return { h: e + n + (i / 2 ** 32 | 0) | 0, l: i | 0 };
}
const w4e = (e, t, n) => (e >>> 0) + (t >>> 0) + (n >>> 0), x4e = (e, t, n, r) => t + n + r + (e / 2 ** 32 | 0) | 0, A4e = (e, t, n, r) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0), E4e = (e, t, n, r, i) => t + n + r + i + (e / 2 ** 32 | 0) | 0, _4e = (e, t, n, r, i) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0) + (i >>> 0), S4e = (e, t, n, r, i, s) => t + n + r + i + s + (e / 2 ** 32 | 0) | 0, _t = {
  fromBig: A$,
  split: s4e,
  toBig: o4e,
  shrSH: a4e,
  shrSL: c4e,
  rotrSH: l4e,
  rotrSL: u4e,
  rotrBH: d4e,
  rotrBL: f4e,
  rotr32H: h4e,
  rotr32L: p4e,
  rotlSH: m4e,
  rotlSL: g4e,
  rotlBH: y4e,
  rotlBL: b4e,
  add: v4e,
  add3L: w4e,
  add3H: x4e,
  add4L: A4e,
  add4H: E4e,
  add5H: S4e,
  add5L: _4e
}, [C4e, T4e] = _t.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), qc = /* @__PURE__ */ new Uint32Array(80), $c = /* @__PURE__ */ new Uint32Array(80);
let k4e = class extends KG {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: n, Bh: r, Bl: i, Ch: s, Cl: o, Dh: a, Dl: c, Eh: l, El: u, Fh: d, Fl: f, Gh: p, Gl: m, Hh: h, Hl: g } = this;
    return [t, n, r, i, s, o, a, c, l, u, d, f, p, m, h, g];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, a, c, l, u, d, f, p, m, h, g) {
    this.Ah = t | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = i | 0, this.Ch = s | 0, this.Cl = o | 0, this.Dh = a | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = d | 0, this.Fl = f | 0, this.Gh = p | 0, this.Gl = m | 0, this.Hh = h | 0, this.Hl = g | 0;
  }
  process(t, n) {
    for (let b = 0; b < 16; b++, n += 4)
      qc[b] = t.getUint32(n), $c[b] = t.getUint32(n += 4);
    for (let b = 16; b < 80; b++) {
      const w = qc[b - 15] | 0, A = $c[b - 15] | 0, E = _t.rotrSH(w, A, 1) ^ _t.rotrSH(w, A, 8) ^ _t.shrSH(w, A, 7), x = _t.rotrSL(w, A, 1) ^ _t.rotrSL(w, A, 8) ^ _t.shrSL(w, A, 7), S = qc[b - 2] | 0, P = $c[b - 2] | 0, I = _t.rotrSH(S, P, 19) ^ _t.rotrBH(S, P, 61) ^ _t.shrSH(S, P, 6), R = _t.rotrSL(S, P, 19) ^ _t.rotrBL(S, P, 61) ^ _t.shrSL(S, P, 6), Q = _t.add4L(x, R, $c[b - 7], $c[b - 16]), J = _t.add4H(Q, E, I, qc[b - 7], qc[b - 16]);
      qc[b] = J | 0, $c[b] = Q | 0;
    }
    let { Ah: r, Al: i, Bh: s, Bl: o, Ch: a, Cl: c, Dh: l, Dl: u, Eh: d, El: f, Fh: p, Fl: m, Gh: h, Gl: g, Hh: y, Hl: v } = this;
    for (let b = 0; b < 80; b++) {
      const w = _t.rotrSH(d, f, 14) ^ _t.rotrSH(d, f, 18) ^ _t.rotrBH(d, f, 41), A = _t.rotrSL(d, f, 14) ^ _t.rotrSL(d, f, 18) ^ _t.rotrBL(d, f, 41), E = d & p ^ ~d & h, x = f & m ^ ~f & g, S = _t.add5L(v, A, x, T4e[b], $c[b]), P = _t.add5H(S, y, w, E, C4e[b], qc[b]), I = S | 0, R = _t.rotrSH(r, i, 28) ^ _t.rotrBH(r, i, 34) ^ _t.rotrBH(r, i, 39), Q = _t.rotrSL(r, i, 28) ^ _t.rotrBL(r, i, 34) ^ _t.rotrBL(r, i, 39), J = r & s ^ r & a ^ s & a, we = i & o ^ i & c ^ o & c;
      y = h | 0, v = g | 0, h = p | 0, g = m | 0, p = d | 0, m = f | 0, { h: d, l: f } = _t.add(l | 0, u | 0, P | 0, I | 0), l = a | 0, u = c | 0, a = s | 0, c = o | 0, s = r | 0, o = i | 0;
      const V = _t.add3L(I, Q, we);
      r = _t.add3H(V, P, R, J), i = V | 0;
    }
    ({ h: r, l: i } = _t.add(this.Ah | 0, this.Al | 0, r | 0, i | 0)), { h: s, l: o } = _t.add(this.Bh | 0, this.Bl | 0, s | 0, o | 0), { h: a, l: c } = _t.add(this.Ch | 0, this.Cl | 0, a | 0, c | 0), { h: l, l: u } = _t.add(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h: d, l: f } = _t.add(this.Eh | 0, this.El | 0, d | 0, f | 0), { h: p, l: m } = _t.add(this.Fh | 0, this.Fl | 0, p | 0, m | 0), { h, l: g } = _t.add(this.Gh | 0, this.Gl | 0, h | 0, g | 0), { h: y, l: v } = _t.add(this.Hh | 0, this.Hl | 0, y | 0, v | 0), this.set(r, i, s, o, a, c, l, u, d, f, p, m, h, g, y, v);
  }
  roundClean() {
    qc.fill(0), $c.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
const E$ = /* @__PURE__ */ k8(() => new k4e());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const zs = BigInt(0), Ui = BigInt(1), q1 = BigInt(2), B4e = BigInt(8), I4e = { zip215: !0 };
function P4e(e) {
  const t = u$(e);
  return Nv(e, {
    hash: "function",
    a: "bigint",
    d: "bigint",
    randomBytes: "function"
  }, {
    adjustScalarBytes: "function",
    domain: "function",
    uvRatio: "function",
    mapToCurve: "function"
  }), Object.freeze({ ...t });
}
function q8(e) {
  const t = P4e(e), { Fp: n, n: r, prehash: i, hash: s, randomBytes: o, nByteLength: a, h: c } = t, l = q1 << BigInt(a * 8) - Ui, u = n.create, d = t.uvRatio || ((q, G) => {
    try {
      return { isValid: !0, value: n.sqrt(q * n.inv(G)) };
    } catch {
      return { isValid: !1, value: zs };
    }
  }), f = t.adjustScalarBytes || ((q) => q), p = t.domain || ((q, G, ae) => {
    if (G.length || ae)
      throw new Error("Contexts/pre-hash are not supported");
    return q;
  }), m = (q) => typeof q == "bigint" && zs < q, h = (q, G) => m(q) && m(G) && q < G, g = (q) => q === zs || h(q, l);
  function y(q, G) {
    if (h(q, G))
      return q;
    throw new Error(`Expected valid scalar < ${G}, got ${typeof q} ${q}`);
  }
  function v(q) {
    return q === zs ? q : y(q, r);
  }
  const b = /* @__PURE__ */ new Map();
  function w(q) {
    if (!(q instanceof A))
      throw new Error("ExtendedPoint expected");
  }
  class A {
    constructor(G, ae, ge, Ae) {
      if (this.ex = G, this.ey = ae, this.ez = ge, this.et = Ae, !g(G))
        throw new Error("x required");
      if (!g(ae))
        throw new Error("y required");
      if (!g(ge))
        throw new Error("z required");
      if (!g(Ae))
        throw new Error("t required");
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(G) {
      if (G instanceof A)
        throw new Error("extended point not allowed");
      const { x: ae, y: ge } = G || {};
      if (!g(ae) || !g(ge))
        throw new Error("invalid affine point");
      return new A(ae, ge, Ui, u(ae * ge));
    }
    static normalizeZ(G) {
      const ae = n.invertBatch(G.map((ge) => ge.ez));
      return G.map((ge, Ae) => ge.toAffine(ae[Ae])).map(A.fromAffine);
    }
    // "Private method", don't use it directly
    _setWindowSize(G) {
      this._WINDOW_SIZE = G, b.delete(this);
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      const { a: G, d: ae } = t;
      if (this.is0())
        throw new Error("bad point: ZERO");
      const { ex: ge, ey: Ae, ez: he, et: B } = this, be = u(ge * ge), Be = u(Ae * Ae), Ne = u(he * he), _e = u(Ne * Ne), Ce = u(be * G), N = u(Ne * u(Ce + Be)), F = u(_e + u(ae * u(be * Be)));
      if (N !== F)
        throw new Error("bad point: equation left != right (1)");
      const z = u(ge * Ae), ne = u(he * B);
      if (z !== ne)
        throw new Error("bad point: equation left != right (2)");
    }
    // Compare one point to another.
    equals(G) {
      w(G);
      const { ex: ae, ey: ge, ez: Ae } = this, { ex: he, ey: B, ez: be } = G, Be = u(ae * be), Ne = u(he * Ae), _e = u(ge * be), Ce = u(B * Ae);
      return Be === Ne && _e === Ce;
    }
    is0() {
      return this.equals(A.ZERO);
    }
    negate() {
      return new A(u(-this.ex), this.ey, this.ez, u(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: G } = t, { ex: ae, ey: ge, ez: Ae } = this, he = u(ae * ae), B = u(ge * ge), be = u(q1 * u(Ae * Ae)), Be = u(G * he), Ne = ae + ge, _e = u(u(Ne * Ne) - he - B), Ce = Be + B, N = Ce - be, F = Be - B, z = u(_e * N), ne = u(Ce * F), ee = u(_e * F), Y = u(N * Ce);
      return new A(z, ne, Y, ee);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(G) {
      w(G);
      const { a: ae, d: ge } = t, { ex: Ae, ey: he, ez: B, et: be } = this, { ex: Be, ey: Ne, ez: _e, et: Ce } = G;
      if (ae === BigInt(-1)) {
        const Me = u((he - Ae) * (Ne + Be)), je = u((he + Ae) * (Ne - Be)), Ye = u(je - Me);
        if (Ye === zs)
          return this.double();
        const Oe = u(B * q1 * Ce), De = u(be * q1 * _e), Te = De + Oe, Fe = je + Me, lt = De - Oe, O = u(Te * Ye), _ = u(Fe * lt), T = u(Te * lt), M = u(Ye * Fe);
        return new A(O, _, M, T);
      }
      const N = u(Ae * Be), F = u(he * Ne), z = u(be * ge * Ce), ne = u(B * _e), ee = u((Ae + he) * (Be + Ne) - N - F), Y = ne - z, X = ne + z, $ = u(F - ae * N), ie = u(ee * Y), fe = u(X * $), oe = u(ee * $), me = u(Y * X);
      return new A(ie, fe, me, oe);
    }
    subtract(G) {
      return this.add(G.negate());
    }
    wNAF(G) {
      return S.wNAFCached(this, b, G, A.normalizeZ);
    }
    // Constant-time multiplication.
    multiply(G) {
      const { p: ae, f: ge } = this.wNAF(y(G, r));
      return A.normalizeZ([ae, ge])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    multiplyUnsafe(G) {
      let ae = v(G);
      return ae === zs ? x : this.equals(x) || ae === Ui ? this : this.equals(E) ? this.wNAF(ae).p : S.unsafeLadder(this, ae);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(c).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return S.unsafeLadder(this, r).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(G) {
      const { ex: ae, ey: ge, ez: Ae } = this, he = this.is0();
      G == null && (G = he ? B4e : n.inv(Ae));
      const B = u(ae * G), be = u(ge * G), Be = u(Ae * G);
      if (he)
        return { x: zs, y: Ui };
      if (Be !== Ui)
        throw new Error("invZ was invalid");
      return { x: B, y: be };
    }
    clearCofactor() {
      const { h: G } = t;
      return G === Ui ? this : this.multiplyUnsafe(G);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(G, ae = !1) {
      const { d: ge, a: Ae } = t, he = n.BYTES;
      G = Ai("pointHex", G, he);
      const B = G.slice(), be = G[he - 1];
      B[he - 1] = be & -129;
      const Be = Dg(B);
      Be === zs || (ae ? y(Be, l) : y(Be, n.ORDER));
      const Ne = u(Be * Be), _e = u(Ne - Ui), Ce = u(ge * Ne - Ae);
      let { isValid: N, value: F } = d(_e, Ce);
      if (!N)
        throw new Error("Point.fromHex: invalid y coordinate");
      const z = (F & Ui) === Ui, ne = (be & 128) !== 0;
      if (!ae && F === zs && ne)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return ne !== z && (F = u(-F)), A.fromAffine({ x: F, y: Be });
    }
    static fromPrivateKey(G) {
      return R(G).point;
    }
    toRawBytes() {
      const { x: G, y: ae } = this.toAffine(), ge = S2(ae, n.BYTES);
      return ge[ge.length - 1] |= G & Ui ? 128 : 0, ge;
    }
    toHex() {
      return pf(this.toRawBytes());
    }
  }
  A.BASE = new A(t.Gx, t.Gy, Ui, u(t.Gx * t.Gy)), A.ZERO = new A(zs, Ui, Ui, zs);
  const { BASE: E, ZERO: x } = A, S = l$(A, a * 8);
  function P(q) {
    return Nn(q, r);
  }
  function I(q) {
    return P(Dg(q));
  }
  function R(q) {
    const G = a;
    q = Ai("private key", q, G);
    const ae = Ai("hashed private key", s(q), 2 * G), ge = f(ae.slice(0, G)), Ae = ae.slice(G, 2 * G), he = I(ge), B = E.multiply(he), be = B.toRawBytes();
    return { head: ge, prefix: Ae, scalar: he, point: B, pointBytes: be };
  }
  function Q(q) {
    return R(q).pointBytes;
  }
  function J(q = new Uint8Array(), ...G) {
    const ae = Kn(...G);
    return I(s(p(ae, Ai("context", q), !!i)));
  }
  function we(q, G, ae = {}) {
    q = Ai("message", q), i && (q = i(q));
    const { prefix: ge, scalar: Ae, pointBytes: he } = R(G), B = J(ae.context, ge, q), be = E.multiply(B).toRawBytes(), Be = J(ae.context, be, he, q), Ne = P(B + Be * Ae);
    v(Ne);
    const _e = Kn(be, S2(Ne, n.BYTES));
    return Ai("result", _e, a * 2);
  }
  const V = I4e;
  function L(q, G, ae, ge = V) {
    const { context: Ae, zip215: he } = ge, B = n.BYTES;
    q = Ai("signature", q, 2 * B), G = Ai("message", G), i && (G = i(G));
    const be = Dg(q.slice(B, 2 * B));
    let Be, Ne, _e;
    try {
      Be = A.fromHex(ae, he), Ne = A.fromHex(q.slice(0, B), he), _e = E.multiplyUnsafe(be);
    } catch {
      return !1;
    }
    if (!he && Be.isSmallOrder())
      return !1;
    const Ce = J(Ae, Ne.toRawBytes(), Be.toRawBytes(), G);
    return Ne.add(Be.multiplyUnsafe(Ce)).subtract(_e).clearCofactor().equals(A.ZERO);
  }
  return E._setWindowSize(8), {
    CURVE: t,
    getPublicKey: Q,
    sign: we,
    verify: L,
    ExtendedPoint: A,
    utils: {
      getExtendedPublicKey: R,
      // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
      randomPrivateKey: () => o(n.BYTES),
      /**
       * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
       * values. This slows down first getPublicKey() by milliseconds (see Speed section),
       * but allows to speed-up subsequent getPublicKey() calls up to 20x.
       * @param windowSize 2, 4, 8, 16
       */
      precompute(q = 8, G = A.BASE) {
        return G._setWindowSize(q), G.multiply(BigInt(3)), G;
      }
    }
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const $8 = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"), n9 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt(0);
const O4e = BigInt(1), ET = BigInt(2), N4e = BigInt(5), r9 = BigInt(10), R4e = BigInt(20), M4e = BigInt(40), i9 = BigInt(80);
function F4e(e) {
  const t = $8, r = e * e % t * e % t, i = Oo(r, ET, t) * r % t, s = Oo(i, O4e, t) * e % t, o = Oo(s, N4e, t) * s % t, a = Oo(o, r9, t) * o % t, c = Oo(a, R4e, t) * a % t, l = Oo(c, M4e, t) * c % t, u = Oo(l, i9, t) * l % t, d = Oo(u, i9, t) * l % t, f = Oo(d, r9, t) * o % t;
  return { pow_p_5_8: Oo(f, ET, t) * e % t, b2: r };
}
function j4e(e) {
  return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
}
function D4e(e, t) {
  const n = $8, r = Nn(t * t * t, n), i = Nn(r * r * t, n), s = F4e(e * i).pow_p_5_8;
  let o = Nn(e * r * s, n);
  const a = Nn(t * o * o, n), c = o, l = Nn(o * n9, n), u = a === e, d = a === Nn(-e, n), f = a === Nn(-e * n9, n);
  return u && (o = c), (d || f) && (o = l), x5e(o, n) && (o = Nn(-o, n)), { isValid: u || d, value: o };
}
const gc = V8($8, void 0, !0), Q8 = {
  // Param: a
  a: BigInt(-1),
  // Fp.create(-1) is proper; our way still works and is faster
  // d is equal to -121665/121666 over finite field.
  // Negative number is P - number, and division is invert(number, P)
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
  Fp: gc,
  // Subgroup order: how many points curve has
  // 2n**252n + 27742317777372353535851937790883648493n;
  n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
  // Cofactor
  h: BigInt(8),
  // Base point (x, y) aka generator point
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
  hash: E$,
  randomBytes: QG,
  adjustScalarBytes: j4e,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: D4e
}, U4e = /* @__PURE__ */ q8(Q8);
function _$(e, t, n) {
  if (t.length > 255)
    throw new Error("Context is too big");
  return VTe(qG("SigEd25519 no Ed25519 collisions"), new Uint8Array([n ? 1 : 0, t.length]), t, e);
}
({
  ...Q8
});
({
  ...Q8
});
const L4e = (gc.ORDER + BigInt(3)) / BigInt(8);
gc.pow(ET, L4e);
gc.sqrt(gc.neg(gc.ONE));
(gc.ORDER - BigInt(5)) / BigInt(8);
BigInt(486662);
E5e(gc, gc.neg(BigInt(486664)));
BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
var s9 = function(e, t, n, r, i) {
  if (r === "m")
    throw new TypeError("Private method is not writable");
  if (r === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !i : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}, Zr = function(e, t, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, Rr, eg, S$, C$;
class z4e {
  /**
   * Create a new ExpirableMap.
   * @param {ExpirableMapOptions<any, any>} options - options for the map.
   * @param {Iterable<[any, any]>} options.source - an optional source of entries to initialize the map with.
   * @param {number} options.expirationTime - the time in milliseconds after which entries will expire.
   */
  constructor(t = {}) {
    Rr.set(this, void 0), eg.set(this, void 0), this[S$] = this.entries.bind(this), this[C$] = "ExpirableMap";
    const { source: n = [], expirationTime: r = 10 * 60 * 1e3 } = t, i = Date.now();
    s9(this, Rr, new Map([...n].map(([s, o]) => [s, { value: o, timestamp: i }])), "f"), s9(this, eg, r, "f");
  }
  /**
   * Prune removes all expired entries.
   */
  prune() {
    const t = Date.now();
    for (const [n, r] of Zr(this, Rr, "f").entries())
      t - r.timestamp > Zr(this, eg, "f") && Zr(this, Rr, "f").delete(n);
    return this;
  }
  // Implementing the Map interface
  /**
   * Set the value for the given key. Prunes expired entries.
   * @param key for the entry
   * @param value of the entry
   * @returns this
   */
  set(t, n) {
    this.prune();
    const r = {
      value: n,
      timestamp: Date.now()
    };
    return Zr(this, Rr, "f").set(t, r), this;
  }
  /**
   * Get the value associated with the key, if it exists and has not expired.
   * @param key K
   * @returns the value associated with the key, or undefined if the key is not present or has expired.
   */
  get(t) {
    const n = Zr(this, Rr, "f").get(t);
    if (n !== void 0) {
      if (Date.now() - n.timestamp > Zr(this, eg, "f")) {
        Zr(this, Rr, "f").delete(t);
        return;
      }
      return n.value;
    }
  }
  /**
   * Clear all entries.
   */
  clear() {
    Zr(this, Rr, "f").clear();
  }
  /**
   * Entries returns the entries of the map, without the expiration time.
   * @returns an iterator over the entries of the map.
   */
  entries() {
    const t = Zr(this, Rr, "f").entries();
    return function* () {
      for (const [r, i] of t)
        yield [r, i.value];
    }();
  }
  /**
   * Values returns the values of the map, without the expiration time.
   * @returns an iterator over the values of the map.
   */
  values() {
    const t = Zr(this, Rr, "f").values();
    return function* () {
      for (const r of t)
        yield r.value;
    }();
  }
  /**
   * Keys returns the keys of the map
   * @returns an iterator over the keys of the map.
   */
  keys() {
    return Zr(this, Rr, "f").keys();
  }
  /**
   * forEach calls the callbackfn on each entry of the map.
   * @param callbackfn to call on each entry
   * @param thisArg to use as this when calling the callbackfn
   */
  forEach(t, n) {
    for (const [r, i] of Zr(this, Rr, "f").entries())
      t.call(n, i.value, r, this);
  }
  /**
   * has returns true if the key exists and has not expired.
   * @param key K
   * @returns true if the key exists and has not expired.
   */
  has(t) {
    return Zr(this, Rr, "f").has(t);
  }
  /**
   * delete the entry for the given key.
   * @param key K
   * @returns true if the key existed and has been deleted.
   */
  delete(t) {
    return Zr(this, Rr, "f").delete(t);
  }
  /**
   * get size of the map.
   * @returns the size of the map.
   */
  get size() {
    return Zr(this, Rr, "f").size;
  }
}
Rr = /* @__PURE__ */ new WeakMap(), eg = /* @__PURE__ */ new WeakMap(), S$ = Symbol.iterator, C$ = Symbol.toStringTag;
const o9 = (e) => {
  if (e <= 127)
    return 1;
  if (e <= 255)
    return 2;
  if (e <= 65535)
    return 3;
  if (e <= 16777215)
    return 4;
  throw new Error("Length too long (> 4 bytes)");
}, a9 = (e, t, n) => {
  if (n <= 127)
    return e[t] = n, 1;
  if (n <= 255)
    return e[t] = 129, e[t + 1] = n, 2;
  if (n <= 65535)
    return e[t] = 130, e[t + 1] = n >> 8, e[t + 2] = n, 3;
  if (n <= 16777215)
    return e[t] = 131, e[t + 1] = n >> 16, e[t + 2] = n >> 8, e[t + 3] = n, 4;
  throw new Error("Length too long (> 4 bytes)");
}, _T = (e, t) => {
  if (e[t] < 128)
    return 1;
  if (e[t] === 128)
    throw new Error("Invalid length 0");
  if (e[t] === 129)
    return 2;
  if (e[t] === 130)
    return 3;
  if (e[t] === 131)
    return 4;
  throw new Error("Length too long (> 4 bytes)");
}, V4e = (e, t) => {
  const n = _T(e, t);
  if (n === 1)
    return e[t];
  if (n === 2)
    return e[t + 1];
  if (n === 3)
    return (e[t + 1] << 8) + e[t + 2];
  if (n === 4)
    return (e[t + 1] << 16) + (e[t + 2] << 8) + e[t + 3];
  throw new Error("Length too long (> 4 bytes)");
};
Uint8Array.from([
  48,
  12,
  6,
  10,
  43,
  6,
  1,
  4,
  1,
  131,
  184,
  67,
  1,
  1
  // DER encoded COSE
]);
const c9 = Uint8Array.from([
  48,
  5,
  6,
  3,
  43,
  101,
  112
  // id-Ed25519 OID
]);
Uint8Array.from([
  48,
  16,
  6,
  7,
  42,
  134,
  72,
  206,
  61,
  2,
  1,
  6,
  5,
  43,
  129,
  4,
  0,
  10
  // OID secp256k1
]);
function H4e(e, t) {
  const n = 2 + o9(e.byteLength + 1), r = t.byteLength + n + e.byteLength;
  let i = 0;
  const s = new Uint8Array(1 + o9(r) + r);
  return s[i++] = 48, i += a9(s, i, r), s.set(t, i), i += t.byteLength, s[i++] = 3, i += a9(s, i, e.byteLength + 1), s[i++] = 0, s.set(new Uint8Array(e), i), s;
}
const W4e = (e, t) => {
  let n = 0;
  const r = (a, c) => {
    if (i[n++] !== a)
      throw new Error("Expected: " + c);
  }, i = new Uint8Array(e);
  if (r(48, "sequence"), n += _T(i, n), !Wke(i.slice(n, n + t.byteLength), t))
    throw new Error("Not the expected OID.");
  n += t.byteLength, r(3, "bit string");
  const s = V4e(i, n) - 1;
  n += _T(i, n), r(0, "0 padding");
  const o = i.slice(n);
  if (s !== o.length)
    throw new Error(`DER payload mismatch: Expected length ${s} actual length ${o.length}`);
  return o;
};
var l9 = function(e, t, n, r, i) {
  if (r === "m")
    throw new TypeError("Private method is not writable");
  if (r === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !i : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}, u9 = function(e, t, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, Gw, qw;
class td {
  // `fromRaw` and `fromDer` should be used for instantiation, not this constructor.
  constructor(t) {
    if (Gw.set(this, void 0), qw.set(this, void 0), t.byteLength !== td.RAW_KEY_LENGTH)
      throw new Error("An Ed25519 public key must be exactly 32bytes long");
    l9(this, Gw, t, "f"), l9(this, qw, td.derEncode(t), "f");
  }
  static from(t) {
    return this.fromDer(t.toDer());
  }
  static fromRaw(t) {
    return new td(t);
  }
  static fromDer(t) {
    return new td(this.derDecode(t));
  }
  static derEncode(t) {
    return H4e(t, c9).buffer;
  }
  static derDecode(t) {
    const n = W4e(t, c9);
    if (n.length !== this.RAW_KEY_LENGTH)
      throw new Error("An Ed25519 public key must be exactly 32bytes long");
    return n;
  }
  get rawKey() {
    return u9(this, Gw, "f");
  }
  get derKey() {
    return u9(this, qw, "f");
  }
  toDer() {
    return this.derKey;
  }
  toRaw() {
    return this.rawKey;
  }
}
Gw = /* @__PURE__ */ new WeakMap(), qw = /* @__PURE__ */ new WeakMap();
td.RAW_KEY_LENGTH = 32;
var T$ = function(e, t, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, ST, k$, CT, B$;
class G4e extends Function {
  constructor() {
    return super(), ST.add(this), this.observers = [], new Proxy(this, {
      apply: (t, n, r) => T$(t, ST, "m", k$).call(t, r[0], ...r.slice(1))
    });
  }
  subscribe(t) {
    this.observers.push(t);
  }
  unsubscribe(t) {
    this.observers = this.observers.filter((n) => n !== t);
  }
  notify(t, ...n) {
    this.observers.forEach((r) => r(t, ...n));
  }
}
ST = /* @__PURE__ */ new WeakSet(), k$ = function(t, ...n) {
  this.notify(t, ...n);
};
class q4e extends G4e {
  constructor() {
    return super(), CT.add(this), new Proxy(this, {
      apply: (t, n, r) => T$(t, CT, "m", B$).call(t, r[0], ...r.slice(1))
    });
  }
  log(t, ...n) {
    this.notify({ message: t, level: "info" }, ...n);
  }
  warn(t, ...n) {
    this.notify({ message: t, level: "warn" }, ...n);
  }
  error(t, n, ...r) {
    this.notify({ message: t, level: "error", error: n }, ...r);
  }
}
CT = /* @__PURE__ */ new WeakSet(), B$ = function(t, ...n) {
  this.log(t, ...n);
};
var No = function(e, t, n, r, i) {
  if (r === "m")
    throw new TypeError("Private method is not writable");
  if (r === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !i : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}, Or = function(e, t, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, Fo, $w, Qw, Kw, Yw, Zw, Jw, Xw, ch;
const I$ = 0.5, P$ = 1.5, O$ = 500, N$ = 6e4, R$ = 9e5, M$ = 10;
class zE {
  constructor(t = zE.default) {
    Fo.set(this, void 0), $w.set(this, void 0), Qw.set(this, void 0), Kw.set(this, void 0), Yw.set(this, void 0), Zw.set(this, void 0), Jw.set(this, void 0), Xw.set(this, void 0), ch.set(this, 0);
    const { initialInterval: n = O$, randomizationFactor: r = I$, multiplier: i = P$, maxInterval: s = N$, maxElapsedTime: o = R$, maxIterations: a = M$, date: c = Date } = t;
    No(this, Fo, n, "f"), No(this, $w, r, "f"), No(this, Qw, i, "f"), No(this, Kw, s, "f"), No(this, Xw, c, "f"), No(this, Yw, c.now(), "f"), No(this, Zw, o, "f"), No(this, Jw, a, "f");
  }
  get ellapsedTimeInMsec() {
    return Or(this, Xw, "f").now() - Or(this, Yw, "f");
  }
  get currentInterval() {
    return Or(this, Fo, "f");
  }
  get count() {
    return Or(this, ch, "f");
  }
  get randomValueFromInterval() {
    const t = Or(this, $w, "f") * Or(this, Fo, "f"), n = Or(this, Fo, "f") - t, r = Or(this, Fo, "f") + t;
    return Math.random() * (r - n) + n;
  }
  incrementCurrentInterval() {
    var t;
    return No(this, Fo, Math.min(Or(this, Fo, "f") * Or(this, Qw, "f"), Or(this, Kw, "f")), "f"), No(this, ch, (t = Or(this, ch, "f"), t++, t), "f"), Or(this, Fo, "f");
  }
  next() {
    return this.ellapsedTimeInMsec >= Or(this, Zw, "f") || Or(this, ch, "f") >= Or(this, Jw, "f") ? null : (this.incrementCurrentInterval(), this.randomValueFromInterval);
  }
}
Fo = /* @__PURE__ */ new WeakMap(), $w = /* @__PURE__ */ new WeakMap(), Qw = /* @__PURE__ */ new WeakMap(), Kw = /* @__PURE__ */ new WeakMap(), Yw = /* @__PURE__ */ new WeakMap(), Zw = /* @__PURE__ */ new WeakMap(), Jw = /* @__PURE__ */ new WeakMap(), Xw = /* @__PURE__ */ new WeakMap(), ch = /* @__PURE__ */ new WeakMap();
zE.default = {
  initialInterval: O$,
  randomizationFactor: I$,
  multiplier: P$,
  maxInterval: N$,
  // 1 minute
  maxElapsedTime: R$,
  maxIterations: M$,
  date: Date
};
var $1 = function(e, t, n, r, i) {
  if (typeof t == "function" ? e !== t || !i : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, n), n;
}, Ct = function(e, t, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, aa, $s, Nu, ex, lh, uh, Ru, Wu, F$, tx, nx, Fa;
(function(e) {
  e.Received = "received", e.Processing = "processing", e.Replied = "replied", e.Rejected = "rejected", e.Unknown = "unknown", e.Done = "done";
})(Fa || (Fa = {}));
const Q1 = 5 * 60 * 1e3, $4e = "308182301d060d2b0601040182dc7c0503010201060c2b0601040182dc7c05030201036100814c0e6ec71fab583b08bd81373c255c3c371b2e84863c98a4f1e08b74235d14fb5d9c0cd546d9685f913a0c0b2cc5341583bf4b4392e467db96d65b9bb4cb717112f8472e0d5a4d14505ffd7484b01291091c5f87b98883463f98091a0baaae", Q4e = "ic0.app", K4e = ".ic0.app", Y4e = "icp0.io", Z4e = ".icp0.io", J4e = "icp-api.io", X4e = ".icp-api.io";
class y6 extends Bi {
  constructor(t) {
    super(t), this.message = t;
  }
}
class K1 extends Bi {
  constructor(t) {
    super(t), this.message = t;
  }
}
function e8e() {
  let e;
  if (typeof window < "u")
    if (window.fetch)
      e = window.fetch.bind(window);
    else
      throw new y6("Fetch implementation was not available. You appear to be in a browser context, but window.fetch was not present.");
  else if (typeof window < "u")
    if (window.fetch)
      e = window.fetch.bind(window);
    else
      throw new y6("Fetch implementation was not available. You appear to be in a Node.js context, but global.fetch was not available.");
  else
    typeof self < "u" && self.fetch && (e = self.fetch.bind(self));
  if (e)
    return e;
  throw new y6("Fetch implementation was not available. Please provide fetch to the HttpAgent constructor, or ensure it is available in the window or global context.");
}
class Pf {
  constructor(t = {}) {
    var n;
    if (aa.add(this), this.rootKey = E2($4e), this._timeDiffMsecs = 0, this._rootKeyFetched = !1, $s.set(this, void 0), Nu.set(this, void 0), this._isAgent = !0, ex.set(this, 0), this.log = new q4e(), lh.set(this, []), uh.set(this, []), Ru.set(this, new z4e({
      expirationTime: 5 * 60 * 1e3
      // 5 minutes
    })), Wu.set(this, !0), nx.set(this, (i, s) => {
      if (Ct(this, Wu, "f") === !1)
        return i;
      if (!s)
        throw new na("Invalid signature from replica signed query: no matching node key found.");
      const { status: o, signatures: a = [], requestId: c } = i, l = new TextEncoder().encode("\vic-response");
      for (const u of a) {
        const { timestamp: d, identity: f } = u, p = gt.fromUint8Array(f).toText();
        let m;
        if (o === "replied") {
          const { reply: b } = i;
          m = _2({
            status: o,
            reply: b,
            timestamp: BigInt(d),
            request_id: c
          });
        } else if (o === "rejected") {
          const { reject_code: b, reject_message: w, error_code: A } = i;
          m = _2({
            status: o,
            reject_code: b,
            reject_message: w,
            error_code: A,
            timestamp: BigInt(d),
            request_id: c
          });
        } else
          throw new Error(`Unknown status: ${o}`);
        const h = ma(l, new Uint8Array(m)), g = s == null ? void 0 : s.nodeKeys.get(p);
        if (!g)
          throw new na("Invalid signature from replica signed query: no matching node key found.");
        const y = td.fromDer(g).rawKey;
        if (U4e.verify(u.signature, new Uint8Array(h), new Uint8Array(y)))
          return i;
        throw new na(`Invalid signature from replica ${p} signed query.`);
      }
      return i;
    }), t.source) {
      if (!(t.source instanceof Pf))
        throw new Error("An Agent's source can only be another HttpAgent");
      this._identity = t.source._identity, this._fetch = t.source._fetch, this._host = t.source._host, this._credentials = t.source._credentials;
    } else
      this._fetch = t.fetch || e8e() || fetch.bind(window), this._fetchOptions = t.fetchOptions, this._callOptions = t.callOptions;
    if (t.host !== void 0)
      !t.host.match(/^[a-z]+:/) && typeof window < "u" ? this._host = new URL(window.location.protocol + "//" + t.host) : this._host = new URL(t.host);
    else if (t.source !== void 0)
      this._host = t.source._host;
    else {
      const i = typeof window < "u" ? window.location : void 0;
      i || (this._host = new URL("https://icp-api.io"), this.log.warn("Could not infer host from window.location, defaulting to mainnet gateway of https://icp-api.io. Please provide a host to the HttpAgent constructor to avoid this warning."));
      const s = ["ic0.app", "icp0.io", "127.0.0.1", "localhost"], o = [".github.dev", ".gitpod.io"], a = i == null ? void 0 : i.hostname;
      let c;
      a && typeof a == "string" && (o.some((l) => a.endsWith(l)) ? c = a : c = s.find((l) => a.endsWith(l))), i && c ? this._host = new URL(`${i.protocol}//${c}${i.port ? ":" + i.port : ""}`) : (this._host = new URL("https://icp-api.io"), this.log.warn("Could not infer host from window.location, defaulting to mainnet gateway of https://icp-api.io. Please provide a host to the HttpAgent constructor to avoid this warning."));
    }
    t.verifyQuerySignatures !== void 0 && $1(this, Wu, t.verifyQuerySignatures), $1(this, $s, (n = t.retryTimes) !== null && n !== void 0 ? n : 3);
    const r = () => new zE({
      maxIterations: Ct(this, $s, "f")
    });
    if ($1(this, Nu, t.backoffStrategy || r), this._host.hostname.endsWith(K4e) ? this._host.hostname = Q4e : this._host.hostname.endsWith(Z4e) ? this._host.hostname = Y4e : this._host.hostname.endsWith(X4e) && (this._host.hostname = J4e), t.credentials) {
      const { name: i, password: s } = t.credentials;
      this._credentials = `${i}${s ? ":" + s : ""}`;
    }
    this._identity = Promise.resolve(t.identity || new Gke()), this.addTransform("update", BR(yT)), t.useQueryNonces && this.addTransform("query", BR(yT)), t.logToConsole && this.log.subscribe((i) => {
      i.level === "error" ? console.error(i.message) : i.level === "warn" ? console.warn(i.message) : console.log(i.message);
    });
  }
  get waterMark() {
    return Ct(this, ex, "f");
  }
  isLocal() {
    const t = this._host.hostname;
    return t === "127.0.0.1" || t.endsWith("127.0.0.1");
  }
  addTransform(t, n, r = n.priority || 0) {
    if (t === "update") {
      const i = Ct(this, uh, "f").findIndex((s) => (s.priority || 0) < r);
      Ct(this, uh, "f").splice(i >= 0 ? i : Ct(this, uh, "f").length, 0, Object.assign(n, { priority: r }));
    } else if (t === "query") {
      const i = Ct(this, lh, "f").findIndex((s) => (s.priority || 0) < r);
      Ct(this, lh, "f").splice(i >= 0 ? i : Ct(this, lh, "f").length, 0, Object.assign(n, { priority: r }));
    }
  }
  async getPrincipal() {
    if (!this._identity)
      throw new K1("This identity has expired due this application's security policy. Please refresh your authentication.");
    return (await this._identity).getPrincipal();
  }
  async call(t, n, r) {
    const i = await (r !== void 0 ? await r : await this._identity);
    if (!i)
      throw new K1("This identity has expired due this application's security policy. Please refresh your authentication.");
    const s = gt.from(t), o = n.effectiveCanisterId ? gt.from(n.effectiveCanisterId) : s, a = i.getPrincipal() || gt.anonymous();
    let c = new L1(Q1);
    Math.abs(this._timeDiffMsecs) > 1e3 * 30 && (c = new L1(Q1 + this._timeDiffMsecs));
    const l = {
      request_type: gT.Call,
      canister_id: s,
      method_name: n.methodName,
      arg: n.arg,
      sender: a,
      ingress_expiry: c
    };
    let u = await this._transform({
      request: {
        body: null,
        method: "POST",
        headers: Object.assign({ "Content-Type": "application/cbor" }, this._credentials ? { Authorization: "Basic " + btoa(this._credentials) } : {})
      },
      endpoint: "call",
      body: l
    });
    u = await i.transformRequest(u);
    const d = f6(u.body);
    this.log(`fetching "/api/v2/canister/${o.toText()}/call" with request:`, u);
    const f = Ct(this, Nu, "f").call(this), p = Ct(this, aa, "m", tx).call(this, {
      request: () => this._fetch("" + new URL(`/api/v2/canister/${o.toText()}/call`, this._host), Object.assign(Object.assign(Object.assign({}, this._callOptions), u.request), { body: d })),
      backoff: f,
      tries: 0
    }), [m, h] = await Promise.all([p, TR(l)]), g = await m.arrayBuffer(), y = m.status === 200 && g.byteLength > 0 ? cc(g) : null;
    return {
      requestId: h,
      response: {
        ok: m.ok,
        status: m.status,
        statusText: m.statusText,
        body: y,
        headers: Hw(m.headers)
      }
    };
  }
  async query(t, n, r) {
    const i = Ct(this, Nu, "f").call(this), s = n.effectiveCanisterId ? gt.from(n.effectiveCanisterId) : gt.from(t);
    this.log(`ecid ${s.toString()}`), this.log(`canisterId ${t.toString()}`);
    const o = async () => {
      const u = await (r !== void 0 ? await r : await this._identity);
      if (!u)
        throw new K1("This identity has expired due this application's security policy. Please refresh your authentication.");
      const d = gt.from(t), f = (u == null ? void 0 : u.getPrincipal()) || gt.anonymous(), p = {
        request_type: "query",
        canister_id: d,
        method_name: n.methodName,
        arg: n.arg,
        sender: f,
        ingress_expiry: new L1(Q1)
      }, m = await TR(p);
      let h = await this._transform({
        request: {
          method: "POST",
          headers: Object.assign({ "Content-Type": "application/cbor" }, this._credentials ? { Authorization: "Basic " + btoa(this._credentials) } : {})
        },
        endpoint: "read",
        body: p
      });
      h = await (u == null ? void 0 : u.transformRequest(h));
      const g = f6(h.body), y = {
        canister: d.toText(),
        ecid: s,
        transformedRequest: h,
        body: g,
        requestId: m,
        backoff: i,
        tries: 0
      };
      return await Ct(this, aa, "m", F$).call(this, y);
    }, a = async () => {
      if (!Ct(this, Wu, "f"))
        return;
      const u = Ct(this, Ru, "f").get(s.toString());
      return u || (await this.fetchSubnetKeys(s.toString()), Ct(this, Ru, "f").get(s.toString()));
    }, [c, l] = await Promise.all([o(), a()]);
    if (this.log("Query response:", c), !Ct(this, Wu, "f"))
      return c;
    try {
      return Ct(this, nx, "f").call(this, c, l);
    } catch {
      this.log.warn("Query response verification failed. Retrying with fresh subnet keys."), Ct(this, Ru, "f").delete(t.toString()), await this.fetchSubnetKeys(s.toString());
      const d = Ct(this, Ru, "f").get(t.toString());
      if (!d)
        throw new na("Invalid signature from replica signed query: no matching node key found.");
      return Ct(this, nx, "f").call(this, c, d);
    }
  }
  async createReadStateRequest(t, n) {
    const r = await (n !== void 0 ? await n : await this._identity);
    if (!r)
      throw new K1("This identity has expired due this application's security policy. Please refresh your authentication.");
    const i = (r == null ? void 0 : r.getPrincipal()) || gt.anonymous(), s = await this._transform({
      request: {
        method: "POST",
        headers: Object.assign({ "Content-Type": "application/cbor" }, this._credentials ? { Authorization: "Basic " + btoa(this._credentials) } : {})
      },
      endpoint: "read_state",
      body: {
        request_type: "read_state",
        paths: t.paths,
        sender: i,
        ingress_expiry: new L1(Q1)
      }
    });
    return r == null ? void 0 : r.transformRequest(s);
  }
  async readState(t, n, r, i) {
    const s = typeof t == "string" ? gt.fromText(t) : t, o = i ?? await this.createReadStateRequest(n, r), a = f6(o.body);
    this.log(`fetching "/api/v2/canister/${s}/read_state" with request:`, o);
    const c = Ct(this, Nu, "f").call(this), l = await Ct(this, aa, "m", tx).call(this, {
      request: () => this._fetch("" + new URL(`/api/v2/canister/${s.toString()}/read_state`, this._host), Object.assign(Object.assign(Object.assign({}, this._fetchOptions), o.request), { body: a })),
      backoff: c,
      tries: 0
    });
    if (!l.ok)
      throw new Error(`Server returned an error:
  Code: ${l.status} (${l.statusText})
  Body: ${await l.text()}
`);
    const u = cc(await l.arrayBuffer());
    this.log("Read state response:", u);
    const d = await this.parseTimeFromResponse(u);
    return d > 0 && (this.log("Read state response time:", d), $1(this, ex, d)), u;
  }
  async parseTimeFromResponse(t) {
    let n;
    if (t.certificate) {
      const r = cc(t.certificate);
      if (r && "tree" in r)
        n = r.tree;
      else
        throw new Error("Could not decode time from response");
      const i = Mm(["time"], n);
      if (!i)
        throw new Error("Time was not found in the response or was not in its expected format.");
      if (!(i instanceof ArrayBuffer) && !ArrayBuffer.isView(i))
        throw new Error("Time was not found in the response or was not in its expected format.");
      const s = G8(Lq(i));
      return this.log("Time from response:", s), this.log("Time from response in milliseconds:", Number(s)), Number(s);
    } else
      this.log.warn("No certificate found in response");
    return 0;
  }
  /**
   * Allows agent to sync its time with the network. Can be called during intialization or mid-lifecycle if the device's clock has drifted away from the network time. This is necessary to set the Expiry for a request
   * @param {Principal} canisterId - Pass a canister ID if you need to sync the time with a particular replica. Uses the management canister by default
   */
  async syncTime(t) {
    const n = await Promise.resolve().then(() => i4e), r = Date.now();
    try {
      t || this.log("Syncing time with the IC. No canisterId provided, so falling back to ryjl3-tyaaa-aaaaa-aaaba-cai");
      const s = (await n.request({
        // Fall back with canisterId of the ICP Ledger
        canisterId: t ?? gt.from("ryjl3-tyaaa-aaaaa-aaaba-cai"),
        agent: this,
        paths: ["time"]
      })).get("time");
      s && (this._timeDiffMsecs = Number(s) - Number(r));
    } catch (i) {
      this.log.error("Caught exception while attempting to sync time", i);
    }
  }
  async status() {
    const t = this._credentials ? {
      Authorization: "Basic " + btoa(this._credentials)
    } : {};
    this.log('fetching "/api/v2/status"');
    const n = Ct(this, Nu, "f").call(this), r = await Ct(this, aa, "m", tx).call(this, {
      backoff: n,
      request: () => this._fetch("" + new URL("/api/v2/status", this._host), Object.assign({ headers: t }, this._fetchOptions)),
      tries: 0
    });
    return cc(await r.arrayBuffer());
  }
  async fetchRootKey() {
    return this._rootKeyFetched || (this.rootKey = (await this.status()).root_key, this._rootKeyFetched = !0), this.rootKey;
  }
  invalidateIdentity() {
    this._identity = null;
  }
  replaceIdentity(t) {
    this._identity = Promise.resolve(t);
  }
  async fetchSubnetKeys(t) {
    const n = gt.from(t), i = (await v$({
      canisterId: n,
      paths: ["subnet"],
      agent: this
    })).get("subnet");
    if (i && typeof i == "object" && "nodeKeys" in i)
      return Ct(this, Ru, "f").set(n.toText(), i), i;
  }
  _transform(t) {
    let n = Promise.resolve(t);
    if (t.endpoint === "call")
      for (const r of Ct(this, uh, "f"))
        n = n.then((i) => r(i).then((s) => s || i));
    else
      for (const r of Ct(this, lh, "f"))
        n = n.then((i) => r(i).then((s) => s || i));
    return n;
  }
}
$s = /* @__PURE__ */ new WeakMap(), Nu = /* @__PURE__ */ new WeakMap(), ex = /* @__PURE__ */ new WeakMap(), lh = /* @__PURE__ */ new WeakMap(), uh = /* @__PURE__ */ new WeakMap(), Ru = /* @__PURE__ */ new WeakMap(), Wu = /* @__PURE__ */ new WeakMap(), nx = /* @__PURE__ */ new WeakMap(), aa = /* @__PURE__ */ new WeakSet(), F$ = async function e(t) {
  var n, r;
  const { ecid: i, transformedRequest: s, body: o, requestId: a, backoff: c, tries: l } = t, u = l === 0 ? 0 : c.next();
  if (this.log(`fetching "/api/v2/canister/${i.toString()}/query" with tries:`, {
    tries: l,
    backoff: c,
    delay: u
  }), u === null)
    throw new Bi(`Timestamp failed to pass the watermark after retrying the configured ${Ct(this, $s, "f")} times. We cannot guarantee the integrity of the response since it could be a replay attack.`);
  u > 0 && await new Promise((m) => setTimeout(m, u));
  let d;
  try {
    this.log(`fetching "/api/v2/canister/${i.toString()}/query" with request:`, s);
    const m = await this._fetch("" + new URL(`/api/v2/canister/${i.toString()}/query`, this._host), Object.assign(Object.assign(Object.assign({}, this._fetchOptions), s.request), { body: o }));
    if (m.status === 200) {
      const h = cc(await m.arrayBuffer());
      d = Object.assign(Object.assign({}, h), { httpDetails: {
        ok: m.ok,
        status: m.status,
        statusText: m.statusText,
        headers: Hw(m.headers)
      }, requestId: a });
    } else
      throw new IR(`Server returned an error:
  Code: ${m.status} (${m.statusText})
  Body: ${await m.text()}
`, {
        ok: m.ok,
        status: m.status,
        statusText: m.statusText,
        headers: Hw(m.headers)
      });
  } catch (m) {
    if (l < Ct(this, $s, "f"))
      return this.log.warn(`Caught exception while attempting to make query:
  ${m}
  Retrying query.`), await Ct(this, aa, "m", e).call(this, Object.assign(Object.assign({}, t), { tries: l + 1 }));
    throw m;
  }
  const f = (r = (n = d.signatures) === null || n === void 0 ? void 0 : n[0]) === null || r === void 0 ? void 0 : r.timestamp;
  if (!Ct(this, Wu, "f"))
    return d;
  if (!f)
    throw new Error("Timestamp not found in query response. This suggests a malformed or malicious response.");
  const p = Number(BigInt(f) / BigInt(1e6));
  if (this.log("watermark and timestamp", {
    waterMark: this.waterMark,
    timestamp: p
  }), Number(this.waterMark) > p) {
    const m = new Bi("Timestamp is below the watermark. Retrying query.");
    if (this.log.error("Timestamp is below", m, {
      timestamp: f,
      waterMark: this.waterMark
    }), l < Ct(this, $s, "f"))
      return await Ct(this, aa, "m", e).call(this, Object.assign(Object.assign({}, t), { tries: l + 1 }));
    throw new Bi(`Timestamp failed to pass the watermark after retrying the configured ${Ct(this, $s, "f")} times. We cannot guarantee the integrity of the response since it could be a replay attack.`);
  }
  return d;
}, tx = async function e(t) {
  const { request: n, backoff: r, tries: i } = t, s = i === 0 ? 0 : r.next();
  if (s === null)
    throw new Bi(`Timestamp failed to pass the watermark after retrying the configured ${Ct(this, $s, "f")} times. We cannot guarantee the integrity of the response since it could be a replay attack.`);
  s > 0 && await new Promise((l) => setTimeout(l, s));
  let o;
  try {
    o = await n();
  } catch (l) {
    if (Ct(this, $s, "f") > i)
      return this.log.warn(`Caught exception while attempting to make request:
  ${l}
  Retrying request.`), await Ct(this, aa, "m", e).call(this, { request: n, backoff: r, tries: i + 1 });
    throw l;
  }
  if (o.ok)
    return o;
  const a = await o.clone().text(), c = `Server returned an error:
  Code: ${o.status} (${o.statusText})
  Body: ${a}
`;
  if (i < Ct(this, $s, "f"))
    return await Ct(this, aa, "m", e).call(this, { request: n, backoff: r, tries: i + 1 });
  throw new IR(c, {
    ok: o.ok,
    status: o.status,
    statusText: o.statusText,
    headers: Hw(o.headers)
  });
};
var d9;
(function(e) {
  e.Error = "err", e.GetPrincipal = "gp", e.GetPrincipalResponse = "gpr", e.Query = "q", e.QueryResponse = "qr", e.Call = "c", e.CallResponse = "cr", e.ReadState = "rs", e.ReadStateResponse = "rsr", e.Status = "s", e.StatusResponse = "sr";
})(d9 || (d9 = {}));
function f9() {
  const e = typeof window > "u" && typeof window > "u" ? typeof self > "u" ? void 0 : self.ic.agent : window.ic.agent;
  if (!e)
    throw new Error("No Agent could be found.");
  return e;
}
const t8e = 5 * 60 * 1e3;
function n8e() {
  return a8e(i8e(r8e(), 1e3), o8e(1e3, 1.2), s8e(t8e));
}
function r8e() {
  let e = !0;
  return async () => e ? (e = !1, !0) : !1;
}
function i8e(e, t) {
  return async (n, r, i) => {
    if (await e(n, r, i))
      return new Promise((s) => setTimeout(s, t));
  };
}
function s8e(e) {
  const t = Date.now() + e;
  return async (n, r, i) => {
    if (Date.now() > t)
      throw new Error(`Request timed out after ${e} msec:
  Request ID: ${uo(r)}
  Request status: ${i}
`);
  };
}
function o8e(e, t) {
  let n = e;
  return () => new Promise((r) => setTimeout(() => {
    n *= t, r();
  }, n));
}
function a8e(...e) {
  return async (t, n, r) => {
    for (const i of e)
      await i(t, n, r);
  };
}
async function j$(e, t, n, r, i, s) {
  var o;
  const a = [new TextEncoder().encode("request_status"), n], c = i ?? await ((o = e.createReadStateRequest) === null || o === void 0 ? void 0 : o.call(e, { paths: [a] })), l = await e.readState(t, { paths: [a] }, void 0, c);
  if (e.rootKey == null)
    throw new Error("Agent root key not initialized before polling");
  const u = await Yh.create({
    certificate: l.certificate,
    rootKey: e.rootKey,
    canisterId: t,
    blsVerify: s
  }), d = u.lookup([...a, new TextEncoder().encode("status")]);
  let f;
  switch (typeof d > "u" ? f = Fa.Unknown : f = new TextDecoder().decode(d), f) {
    case Fa.Replied:
      return u.lookup([...a, "reply"]);
    case Fa.Received:
    case Fa.Unknown:
    case Fa.Processing:
      return await r(t, n, f), j$(e, t, n, r, c);
    case Fa.Rejected: {
      const p = new Uint8Array(u.lookup([...a, "reject_code"]))[0], m = new TextDecoder().decode(u.lookup([...a, "reject_message"]));
      throw new Error(`Call was rejected:
  Request ID: ${uo(n)}
  Reject code: ${p}
  Reject text: ${m}
`);
    }
    case Fa.Done:
      throw new Error(`Call was marked as done but we never saw the reply:
  Request ID: ${uo(n)}
`);
  }
  throw new Error("unreachable");
}
const c8e = ({ IDL: e }) => {
  const t = e.Variant({
    mainnet: e.Null,
    testnet: e.Null
  }), n = e.Text, r = e.Record({
    network: t,
    address: n,
    min_confirmations: e.Opt(e.Nat32)
  }), i = e.Nat64, s = i, o = e.Record({
    network: t,
    address: n,
    min_confirmations: e.Opt(e.Nat32)
  }), a = i, c = e.Record({
    network: t
  }), l = e.Nat64, u = e.Vec(l), d = e.Record({
    network: t,
    filter: e.Opt(e.Variant({
      page: e.Vec(e.Nat8),
      min_confirmations: e.Nat32
    })),
    address: n
  }), f = e.Vec(e.Nat8), p = e.Record({
    txid: e.Vec(e.Nat8),
    vout: e.Nat32
  }), m = e.Record({
    height: e.Nat32,
    value: i,
    outpoint: p
  }), h = e.Record({
    next_page: e.Opt(e.Vec(e.Nat8)),
    tip_height: e.Nat32,
    tip_block_hash: f,
    utxos: e.Vec(m)
  }), g = e.Record({
    network: t,
    filter: e.Opt(e.Variant({
      page: e.Vec(e.Nat8),
      min_confirmations: e.Nat32
    })),
    address: n
  }), y = e.Record({
    next_page: e.Opt(e.Vec(e.Nat8)),
    tip_height: e.Nat32,
    tip_block_hash: f,
    utxos: e.Vec(m)
  }), v = e.Record({
    transaction: e.Vec(e.Nat8),
    network: t
  }), b = e.Principal, w = e.Record({
    canister_id: b,
    num_requested_changes: e.Opt(e.Nat64)
  }), A = e.Variant({
    from_user: e.Record({ user_id: e.Principal }),
    from_canister: e.Record({
      canister_version: e.Opt(e.Nat64),
      canister_id: e.Principal
    })
  }), E = e.Variant({
    creation: e.Record({ controllers: e.Vec(e.Principal) }),
    code_deployment: e.Record({
      mode: e.Variant({
        reinstall: e.Null,
        upgrade: e.Null,
        install: e.Null
      }),
      module_hash: e.Vec(e.Nat8)
    }),
    controllers_change: e.Record({
      controllers: e.Vec(e.Principal)
    }),
    code_uninstall: e.Null
  }), x = e.Record({
    timestamp_nanos: e.Nat64,
    canister_version: e.Nat64,
    origin: A,
    details: E
  }), S = e.Record({
    controllers: e.Vec(e.Principal),
    module_hash: e.Opt(e.Vec(e.Nat8)),
    recent_changes: e.Vec(x),
    total_num_changes: e.Nat64
  }), P = e.Record({ canister_id: b }), I = e.Variant({
    controllers: e.Null,
    public: e.Null
  }), R = e.Record({
    freezing_threshold: e.Nat,
    controllers: e.Vec(e.Principal),
    reserved_cycles_limit: e.Nat,
    log_visibility: I,
    memory_allocation: e.Nat,
    compute_allocation: e.Nat
  }), Q = e.Record({
    status: e.Variant({
      stopped: e.Null,
      stopping: e.Null,
      running: e.Null
    }),
    memory_size: e.Nat,
    cycles: e.Nat,
    settings: R,
    idle_cycles_burned_per_day: e.Nat,
    module_hash: e.Opt(e.Vec(e.Nat8)),
    reserved_cycles: e.Nat
  }), J = e.Record({ canister_id: b }), we = e.Record({
    freezing_threshold: e.Opt(e.Nat),
    controllers: e.Opt(e.Vec(e.Principal)),
    reserved_cycles_limit: e.Opt(e.Nat),
    log_visibility: e.Opt(I),
    memory_allocation: e.Opt(e.Nat),
    compute_allocation: e.Opt(e.Nat)
  }), V = e.Record({
    settings: e.Opt(we),
    sender_canister_version: e.Opt(e.Nat64)
  }), L = e.Record({ canister_id: b }), U = e.Record({ canister_id: b }), q = e.Record({ canister_id: b }), G = e.Variant({ secp256k1: e.Null }), ae = e.Record({
    key_id: e.Record({ name: e.Text, curve: G }),
    canister_id: e.Opt(b),
    derivation_path: e.Vec(e.Vec(e.Nat8))
  }), ge = e.Record({
    public_key: e.Vec(e.Nat8),
    chain_code: e.Vec(e.Nat8)
  }), Ae = e.Record({ canister_id: b }), he = e.Record({
    idx: e.Nat64,
    timestamp_nanos: e.Nat64,
    content: e.Vec(e.Nat8)
  }), B = e.Record({
    canister_log_records: e.Vec(he)
  }), be = e.Record({ value: e.Text, name: e.Text }), Be = e.Record({
    status: e.Nat,
    body: e.Vec(e.Nat8),
    headers: e.Vec(be)
  }), Ne = e.Record({
    url: e.Text,
    method: e.Variant({
      get: e.Null,
      head: e.Null,
      post: e.Null
    }),
    max_response_bytes: e.Opt(e.Nat64),
    body: e.Opt(e.Vec(e.Nat8)),
    transform: e.Opt(e.Record({
      function: e.Func([
        e.Record({
          context: e.Vec(e.Nat8),
          response: Be
        })
      ], [Be], ["query"]),
      context: e.Vec(e.Nat8)
    })),
    headers: e.Vec(be)
  }), _e = e.Vec(e.Nat8), Ce = e.Record({
    arg: e.Vec(e.Nat8),
    wasm_module_hash: e.Vec(e.Nat8),
    mode: e.Variant({
      reinstall: e.Null,
      upgrade: e.Opt(e.Record({ skip_pre_upgrade: e.Opt(e.Bool) })),
      install: e.Null
    }),
    chunk_hashes_list: e.Vec(_e),
    target_canister: b,
    sender_canister_version: e.Opt(e.Nat64),
    storage_canister: e.Opt(b)
  }), N = e.Vec(e.Nat8), F = e.Record({
    arg: e.Vec(e.Nat8),
    wasm_module: N,
    mode: e.Variant({
      reinstall: e.Null,
      upgrade: e.Opt(e.Record({ skip_pre_upgrade: e.Opt(e.Bool) })),
      install: e.Null
    }),
    canister_id: b,
    sender_canister_version: e.Opt(e.Nat64)
  }), z = e.Record({
    start_at_timestamp_nanos: e.Nat64,
    subnet_id: e.Principal
  }), ne = e.Record({
    num_block_failures_total: e.Nat64,
    node_id: e.Principal,
    num_blocks_total: e.Nat64
  }), ee = e.Vec(e.Record({
    timestamp_nanos: e.Nat64,
    node_metrics: e.Vec(ne)
  })), Y = e.Record({
    settings: e.Opt(we),
    specified_id: e.Opt(b),
    amount: e.Opt(e.Nat),
    sender_canister_version: e.Opt(e.Nat64)
  }), X = e.Record({
    canister_id: b
  }), $ = e.Record({
    canister_id: b,
    amount: e.Nat
  }), ie = e.Vec(e.Nat8), fe = e.Record({
    key_id: e.Record({ name: e.Text, curve: G }),
    derivation_path: e.Vec(e.Vec(e.Nat8)),
    message_hash: e.Vec(e.Nat8)
  }), oe = e.Record({
    signature: e.Vec(e.Nat8)
  }), me = e.Record({ canister_id: b }), Me = e.Record({ canister_id: b }), je = e.Record({ canister_id: b }), Ye = e.Vec(_e), Oe = e.Record({
    canister_id: b,
    sender_canister_version: e.Opt(e.Nat64)
  }), De = e.Record({
    canister_id: e.Principal,
    settings: we,
    sender_canister_version: e.Opt(e.Nat64)
  }), Te = e.Record({
    chunk: e.Vec(e.Nat8),
    canister_id: e.Principal
  }), Fe = _e;
  return e.Service({
    bitcoin_get_balance: e.Func([r], [s], []),
    bitcoin_get_balance_query: e.Func([o], [a], ["query"]),
    bitcoin_get_current_fee_percentiles: e.Func([c], [u], []),
    bitcoin_get_utxos: e.Func([d], [h], []),
    bitcoin_get_utxos_query: e.Func([g], [y], ["query"]),
    bitcoin_send_transaction: e.Func([v], [], []),
    canister_info: e.Func([w], [S], []),
    canister_status: e.Func([P], [Q], []),
    clear_chunk_store: e.Func([J], [], []),
    create_canister: e.Func([V], [L], []),
    delete_canister: e.Func([U], [], []),
    deposit_cycles: e.Func([q], [], []),
    ecdsa_public_key: e.Func([ae], [ge], []),
    fetch_canister_logs: e.Func([Ae], [B], ["query"]),
    http_request: e.Func([Ne], [Be], []),
    install_chunked_code: e.Func([Ce], [], []),
    install_code: e.Func([F], [], []),
    node_metrics_history: e.Func([z], [ee], []),
    provisional_create_canister_with_cycles: e.Func([Y], [X], []),
    provisional_top_up_canister: e.Func([$], [], []),
    raw_rand: e.Func([], [ie], []),
    sign_with_ecdsa: e.Func([fe], [oe], []),
    start_canister: e.Func([me], [], []),
    stop_canister: e.Func([Me], [], []),
    stored_chunks: e.Func([je], [Ye], []),
    uninstall_code: e.Func([Oe], [], []),
    update_settings: e.Func([De], [], []),
    upload_chunk: e.Func([Te], [Fe], [])
  });
};
class D$ extends Bi {
  constructor(t, n, r, i) {
    super([
      "Call failed:",
      `  Canister: ${t.toText()}`,
      `  Method: ${n} (${r})`,
      ...Object.getOwnPropertyNames(i).map((s) => `  "${s}": ${JSON.stringify(i[s])}`)
    ].join(`
`)), this.canisterId = t, this.methodName = n, this.type = r, this.props = i;
  }
}
class l8e extends D$ {
  constructor(t, n, r) {
    var i;
    super(t, n, "query", {
      Status: r.status,
      Code: (i = oT[r.reject_code]) !== null && i !== void 0 ? i : `Unknown Code "${r.reject_code}"`,
      Message: r.reject_message
    }), this.result = r;
  }
}
class u8e extends D$ {
  constructor(t, n, r, i) {
    super(t, n, "update", Object.assign({ "Request ID": uo(r) }, i.body ? Object.assign(Object.assign({}, i.body.error_code ? {
      "Error code": i.body.error_code
    } : {}), { "Reject code": String(i.body.reject_code), "Reject message": i.body.reject_message }) : {
      "HTTP status code": i.status.toString(),
      "HTTP status text": i.statusText
    })), this.requestId = r, this.response = i;
  }
}
const xs = Symbol.for("ic-agent-metadata");
class Pc {
  constructor(t) {
    this[xs] = Object.freeze(t);
  }
  /**
   * Get the Agent class this Actor would call, or undefined if the Actor would use
   * the default agent (global.ic.agent).
   * @param actor The actor to get the agent of.
   */
  static agentOf(t) {
    return t[xs].config.agent;
  }
  /**
   * Get the interface of an actor, in the form of an instance of a Service.
   * @param actor The actor to get the interface of.
   */
  static interfaceOf(t) {
    return t[xs].service;
  }
  static canisterIdOf(t) {
    return gt.from(t[xs].config.canisterId);
  }
  static async install(t, n) {
    const r = t.mode === void 0 ? { install: null } : t.mode, i = t.arg ? [...new Uint8Array(t.arg)] : [], s = [...new Uint8Array(t.module)], o = typeof n.canisterId == "string" ? gt.fromText(n.canisterId) : n.canisterId;
    await h9(n).install_code({
      mode: r,
      arg: i,
      wasm_module: s,
      canister_id: o,
      sender_canister_version: []
    });
  }
  static async createCanister(t, n) {
    function r(s) {
      return [
        {
          controllers: s.controllers ? [s.controllers] : [],
          compute_allocation: s.compute_allocation ? [s.compute_allocation] : [],
          freezing_threshold: s.freezing_threshold ? [s.freezing_threshold] : [],
          memory_allocation: s.memory_allocation ? [s.memory_allocation] : [],
          reserved_cycles_limit: [],
          log_visibility: []
        }
      ];
    }
    const { canister_id: i } = await h9(t || {}).provisional_create_canister_with_cycles({
      amount: [],
      settings: r(n || {}),
      specified_id: [],
      sender_canister_version: []
    });
    return i;
  }
  static async createAndInstallCanister(t, n, r) {
    const i = await this.createCanister(r);
    return await this.install(Object.assign({}, n), Object.assign(Object.assign({}, r), { canisterId: i })), this.createActor(t, Object.assign(Object.assign({}, r), { canisterId: i }));
  }
  static createActorClass(t, n) {
    const r = t({ IDL: cke });
    class i extends Pc {
      constructor(o) {
        if (!o.canisterId)
          throw new Bi(`Canister ID is required, but received ${typeof o.canisterId} instead. If you are using automatically generated declarations, this may be because your application is not setting the canister ID in process.env correctly.`);
        const a = typeof o.canisterId == "string" ? gt.fromText(o.canisterId) : o.canisterId;
        super({
          config: Object.assign(Object.assign(Object.assign({}, U$), o), { canisterId: a }),
          service: r
        });
        for (const [c, l] of r._fields)
          n != null && n.httpDetails && l.annotations.push(TT), this[c] = d8e(this, c, l, o.blsVerify);
      }
    }
    return i;
  }
  static createActor(t, n) {
    if (!n.canisterId)
      throw new Bi(`Canister ID is required, but received ${typeof n.canisterId} instead. If you are using automatically generated declarations, this may be because your application is not setting the canister ID in process.env correctly.`);
    return new (this.createActorClass(t))(n);
  }
  static createActorWithHttpDetails(t, n) {
    return new (this.createActorClass(t, { httpDetails: !0 }))(n);
  }
}
function Y1(e, t) {
  const n = lq(e, Qi.from(t));
  switch (n.length) {
    case 0:
      return;
    case 1:
      return n[0];
    default:
      return n;
  }
}
const U$ = {
  pollingStrategyFactory: n8e
}, TT = "http-details";
function d8e(e, t, n, r) {
  let i;
  n.annotations.includes("query") || n.annotations.includes("composite_query") ? i = async (o, ...a) => {
    var c, l;
    o = Object.assign(Object.assign({}, o), (l = (c = e[xs].config).queryTransform) === null || l === void 0 ? void 0 : l.call(c, t, a, Object.assign(Object.assign({}, e[xs].config), o)));
    const u = o.agent || e[xs].config.agent || f9(), d = gt.from(o.canisterId || e[xs].config.canisterId), f = b2(n.argTypes, a), p = await u.query(d, {
      methodName: t,
      arg: f,
      effectiveCanisterId: o.effectiveCanisterId
    });
    switch (p.status) {
      case "rejected":
        throw new l8e(d, t, p);
      case "replied":
        return n.annotations.includes(TT) ? {
          httpDetails: p.httpDetails,
          result: Y1(n.retTypes, p.reply.arg)
        } : Y1(n.retTypes, p.reply.arg);
    }
  } : i = async (o, ...a) => {
    var c, l;
    o = Object.assign(Object.assign({}, o), (l = (c = e[xs].config).callTransform) === null || l === void 0 ? void 0 : l.call(c, t, a, Object.assign(Object.assign({}, e[xs].config), o)));
    const u = o.agent || e[xs].config.agent || f9(), { canisterId: d, effectiveCanisterId: f, pollingStrategyFactory: p } = Object.assign(Object.assign(Object.assign({}, U$), e[xs].config), o), m = gt.from(d), h = f !== void 0 ? gt.from(f) : m, g = b2(n.argTypes, a), { requestId: y, response: v } = await u.call(m, {
      methodName: t,
      arg: g,
      effectiveCanisterId: h
    });
    if (!v.ok || v.body)
      throw new u8e(m, t, y, v);
    const b = p(), w = await j$(u, h, y, b, r), A = n.annotations.includes(TT);
    if (w !== void 0)
      return A ? {
        httpDetails: v,
        result: Y1(n.retTypes, w)
      } : Y1(n.retTypes, w);
    if (n.retTypes.length === 0)
      return A ? {
        httpDetails: v,
        result: void 0
      } : void 0;
    throw new Error(`Call was returned undefined, but type [${n.retTypes.join(",")}].`);
  };
  const s = (...o) => i({}, ...o);
  return s.withOptions = (o) => (...a) => i(o, ...a), s;
}
function h9(e) {
  function t(n, r) {
    if (e.effectiveCanisterId)
      return { effectiveCanisterId: gt.from(e.effectiveCanisterId) };
    const i = r[0];
    let s = gt.fromHex("");
    return i && typeof i == "object" && i.canister_id && (s = gt.from(i.canister_id)), { effectiveCanisterId: s };
  }
  return Pc.createActor(c8e, Object.assign(Object.assign(Object.assign({}, e), { canisterId: gt.fromHex("") }), {
    callTransform: t,
    queryTransform: t
  }));
}
var zt;
(function(e) {
  e.assertEqual = (i) => i;
  function t(i) {
  }
  e.assertIs = t;
  function n(i) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (i) => {
    const s = {};
    for (const o of i)
      s[o] = o;
    return s;
  }, e.getValidEnumValues = (i) => {
    const s = e.objectKeys(i).filter((a) => typeof i[i[a]] != "number"), o = {};
    for (const a of s)
      o[a] = i[a];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(s) {
    return i[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const s = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && s.push(o);
    return s;
  }, e.find = (i, s) => {
    for (const o of i)
      if (s(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, s = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(s);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (i, s) => typeof s == "bigint" ? s.toString() : s;
})(zt || (zt = {}));
var kT;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(kT || (kT = {}));
const Ke = zt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), dl = (e) => {
  switch (typeof e) {
    case "undefined":
      return Ke.undefined;
    case "string":
      return Ke.string;
    case "number":
      return isNaN(e) ? Ke.nan : Ke.number;
    case "boolean":
      return Ke.boolean;
    case "function":
      return Ke.function;
    case "bigint":
      return Ke.bigint;
    case "symbol":
      return Ke.symbol;
    case "object":
      return Array.isArray(e) ? Ke.array : e === null ? Ke.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Ke.promise : typeof Map < "u" && e instanceof Map ? Ke.map : typeof Set < "u" && e instanceof Set ? Ke.set : typeof Date < "u" && e instanceof Date ? Ke.date : Ke.object;
    default:
      return Ke.unknown;
  }
}, Re = zt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), f8e = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class Xi extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const n = t || function(s) {
      return s.message;
    }, r = { _errors: [] }, i = (s) => {
      for (const o of s.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(n(o));
        else {
          let a = r, c = 0;
          for (; c < o.path.length; ) {
            const l = o.path[c];
            c === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(n(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], c++;
          }
        }
    };
    return i(this), r;
  }
  static assert(t) {
    if (!(t instanceof Xi))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, zt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Xi.create = (e) => new Xi(e);
const Fm = (e, t) => {
  let n;
  switch (e.code) {
    case Re.invalid_type:
      e.received === Ke.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case Re.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, zt.jsonStringifyReplacer)}`;
      break;
    case Re.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${zt.joinValues(e.keys, ", ")}`;
      break;
    case Re.invalid_union:
      n = "Invalid input";
      break;
    case Re.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${zt.joinValues(e.options)}`;
      break;
    case Re.invalid_enum_value:
      n = `Invalid enum value. Expected ${zt.joinValues(e.options)}, received '${e.received}'`;
      break;
    case Re.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case Re.invalid_return_type:
      n = "Invalid function return type";
      break;
    case Re.invalid_date:
      n = "Invalid date";
      break;
    case Re.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : zt.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case Re.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case Re.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case Re.custom:
      n = "Invalid input";
      break;
    case Re.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case Re.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case Re.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, zt.assertNever(e);
  }
  return { message: n };
};
let L$ = Fm;
function h8e(e) {
  L$ = e;
}
function B2() {
  return L$;
}
const I2 = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: i } = e, s = [...n, ...i.path || []], o = {
    ...i,
    path: s
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: s,
      message: i.message
    };
  let a = "";
  const c = r.filter((l) => !!l).slice().reverse();
  for (const l of c)
    a = l(o, { data: t, defaultError: a }).message;
  return {
    ...i,
    path: s,
    message: a
  };
}, p8e = [];
function Qe(e, t) {
  const n = B2(), r = I2({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      n,
      n === Fm ? void 0 : Fm
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(r);
}
class $r {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return pt;
      i.status === "dirty" && t.dirty(), r.push(i.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const i of n) {
      const s = await i.key, o = await i.value;
      r.push({
        key: s,
        value: o
      });
    }
    return $r.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const i of n) {
      const { key: s, value: o } = i;
      if (s.status === "aborted" || o.status === "aborted")
        return pt;
      s.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (r[s.value] = o.value);
    }
    return { status: t.value, value: r };
  }
}
const pt = Object.freeze({
  status: "aborted"
}), Bh = (e) => ({ status: "dirty", value: e }), gi = (e) => ({ status: "valid", value: e }), BT = (e) => e.status === "aborted", IT = (e) => e.status === "dirty", qy = (e) => e.status === "valid", $y = (e) => typeof Promise < "u" && e instanceof Promise;
function P2(e, t, n, r) {
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function z$(e, t, n, r, i) {
  if (typeof t == "function" ? e !== t || !i : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, n), n;
}
var st;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(st || (st = {}));
var tg, ng;
class xa {
  constructor(t, n, r, i) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const p9 = (e, t) => {
  if (qy(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Xi(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Et(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (o, a) => {
    var c, l;
    const { message: u } = e;
    return o.code === "invalid_enum_value" ? { message: u ?? a.defaultError } : typeof a.data > "u" ? { message: (c = u ?? r) !== null && c !== void 0 ? c : a.defaultError } : o.code !== "invalid_type" ? { message: a.defaultError } : { message: (l = u ?? n) !== null && l !== void 0 ? l : a.defaultError };
  }, description: i };
}
class kt {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return dl(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: dl(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new $r(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: dl(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if ($y(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: dl(t)
    }, s = this._parseSync({ data: t, path: i.path, parent: i });
    return p9(i, s);
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: dl(t)
    }, i = this._parse({ data: t, path: r.path, parent: r }), s = await ($y(i) ? i : Promise.resolve(i));
    return p9(r, s);
  }
  refine(t, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, s) => {
      const o = t(i), a = () => s.addIssue({
        code: Re.custom,
        ...r(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((c) => c ? !0 : (a(), !1)) : o ? !0 : (a(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, i) => t(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(t) {
    return new yo({
      schema: this,
      typeName: ht.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return ga.create(this, this._def);
  }
  nullable() {
    return fu.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return fo.create(this, this._def);
  }
  promise() {
    return Dm.create(this, this._def);
  }
  or(t) {
    return Zy.create([this, t], this._def);
  }
  and(t) {
    return Jy.create(this, t, this._def);
  }
  transform(t) {
    return new yo({
      ...Et(this._def),
      schema: this,
      typeName: ht.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new rb({
      ...Et(this._def),
      innerType: this,
      defaultValue: n,
      typeName: ht.ZodDefault
    });
  }
  brand() {
    return new K8({
      typeName: ht.ZodBranded,
      type: this,
      ...Et(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new ib({
      ...Et(this._def),
      innerType: this,
      catchValue: n,
      typeName: ht.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Rv.create(this, t);
  }
  readonly() {
    return sb.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const m8e = /^c[^\s-]{8,}$/i, g8e = /^[0-9a-z]+$/, y8e = /^[0-9A-HJKMNP-TV-Z]{26}$/, b8e = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, v8e = /^[a-z0-9_-]{21}$/i, w8e = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, x8e = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, A8e = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let b6;
const E8e = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, _8e = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, S8e = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, V$ = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", C8e = new RegExp(`^${V$}$`);
function H$(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function T8e(e) {
  return new RegExp(`^${H$(e)}$`);
}
function W$(e) {
  let t = `${V$}T${H$(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function k8e(e, t) {
  return !!((t === "v4" || !t) && E8e.test(e) || (t === "v6" || !t) && _8e.test(e));
}
class co extends kt {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Ke.string) {
      const s = this._getOrReturnCtx(t);
      return Qe(s, {
        code: Re.invalid_type,
        expected: Ke.string,
        received: s.parsedType
      }), pt;
    }
    const r = new $r();
    let i;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "length") {
        const o = t.data.length > s.value, a = t.data.length < s.value;
        (o || a) && (i = this._getOrReturnCtx(t, i), o ? Qe(i, {
          code: Re.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : a && Qe(i, {
          code: Re.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), r.dirty());
      } else if (s.kind === "email")
        x8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "email",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "emoji")
        b6 || (b6 = new RegExp(A8e, "u")), b6.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "emoji",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "uuid")
        b8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "uuid",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "nanoid")
        v8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "nanoid",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid")
        m8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "cuid",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid2")
        g8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "cuid2",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "ulid")
        y8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "ulid",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          i = this._getOrReturnCtx(t, i), Qe(i, {
            validation: "url",
            code: Re.invalid_string,
            message: s.message
          }), r.dirty();
        }
      else
        s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "regex",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.invalid_string,
          validation: { includes: s.value, position: s.position },
          message: s.message
        }), r.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.invalid_string,
          validation: { startsWith: s.value },
          message: s.message
        }), r.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.invalid_string,
          validation: { endsWith: s.value },
          message: s.message
        }), r.dirty()) : s.kind === "datetime" ? W$(s).test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.invalid_string,
          validation: "datetime",
          message: s.message
        }), r.dirty()) : s.kind === "date" ? C8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.invalid_string,
          validation: "date",
          message: s.message
        }), r.dirty()) : s.kind === "time" ? T8e(s).test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          code: Re.invalid_string,
          validation: "time",
          message: s.message
        }), r.dirty()) : s.kind === "duration" ? w8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "duration",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty()) : s.kind === "ip" ? k8e(t.data, s.version) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "ip",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty()) : s.kind === "base64" ? S8e.test(t.data) || (i = this._getOrReturnCtx(t, i), Qe(i, {
          validation: "base64",
          code: Re.invalid_string,
          message: s.message
        }), r.dirty()) : zt.assertNever(s);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((i) => t.test(i), {
      validation: n,
      code: Re.invalid_string,
      ...st.errToObj(r)
    });
  }
  _addCheck(t) {
    return new co({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...st.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...st.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...st.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...st.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...st.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...st.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...st.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...st.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...st.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...st.errToObj(t) });
  }
  datetime(t) {
    var n, r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      local: (r = t == null ? void 0 : t.local) !== null && r !== void 0 ? r : !1,
      ...st.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...st.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...st.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...st.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...st.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...st.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...st.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...st.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...st.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...st.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, st.errToObj(t));
  }
  trim() {
    return new co({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new co({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new co({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
co.create = (e) => {
  var t;
  return new co({
    checks: [],
    typeName: ht.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Et(e)
  });
};
function B8e(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r, s = parseInt(e.toFixed(i).replace(".", "")), o = parseInt(t.toFixed(i).replace(".", ""));
  return s % o / Math.pow(10, i);
}
class lu extends kt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Ke.number) {
      const s = this._getOrReturnCtx(t);
      return Qe(s, {
        code: Re.invalid_type,
        expected: Ke.number,
        received: s.parsedType
      }), pt;
    }
    let r;
    const i = new $r();
    for (const s of this._def.checks)
      s.kind === "int" ? zt.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), i.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), i.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), i.dirty()) : s.kind === "multipleOf" ? B8e(t.data, s.value) !== 0 && (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), i.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.not_finite,
        message: s.message
      }), i.dirty()) : zt.assertNever(s);
    return { status: i.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, st.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, st.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, st.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, st.toString(n));
  }
  setLimit(t, n, r, i) {
    return new lu({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: st.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new lu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: st.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: st.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: st.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: st.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: st.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: st.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: st.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: st.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: st.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && zt.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
lu.create = (e) => new lu({
  checks: [],
  typeName: ht.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Et(e)
});
class uu extends kt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== Ke.bigint) {
      const s = this._getOrReturnCtx(t);
      return Qe(s, {
        code: Re.invalid_type,
        expected: Ke.bigint,
        received: s.parsedType
      }), pt;
    }
    let r;
    const i = new $r();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), i.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), i.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), Qe(r, {
        code: Re.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), i.dirty()) : zt.assertNever(s);
    return { status: i.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, st.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, st.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, st.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, st.toString(n));
  }
  setLimit(t, n, r, i) {
    return new uu({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: st.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new uu({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: st.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: st.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: st.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: st.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: st.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
uu.create = (e) => {
  var t;
  return new uu({
    checks: [],
    typeName: ht.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Et(e)
  });
};
class Qy extends kt {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Ke.boolean) {
      const r = this._getOrReturnCtx(t);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.boolean,
        received: r.parsedType
      }), pt;
    }
    return gi(t.data);
  }
}
Qy.create = (e) => new Qy({
  typeName: ht.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Et(e)
});
class mf extends kt {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Ke.date) {
      const s = this._getOrReturnCtx(t);
      return Qe(s, {
        code: Re.invalid_type,
        expected: Ke.date,
        received: s.parsedType
      }), pt;
    }
    if (isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return Qe(s, {
        code: Re.invalid_date
      }), pt;
    }
    const r = new $r();
    let i;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (i = this._getOrReturnCtx(t, i), Qe(i, {
        code: Re.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), r.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (i = this._getOrReturnCtx(t, i), Qe(i, {
        code: Re.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), r.dirty()) : zt.assertNever(s);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new mf({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: st.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: st.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
mf.create = (e) => new mf({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: ht.ZodDate,
  ...Et(e)
});
class O2 extends kt {
  _parse(t) {
    if (this._getType(t) !== Ke.symbol) {
      const r = this._getOrReturnCtx(t);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.symbol,
        received: r.parsedType
      }), pt;
    }
    return gi(t.data);
  }
}
O2.create = (e) => new O2({
  typeName: ht.ZodSymbol,
  ...Et(e)
});
class Ky extends kt {
  _parse(t) {
    if (this._getType(t) !== Ke.undefined) {
      const r = this._getOrReturnCtx(t);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.undefined,
        received: r.parsedType
      }), pt;
    }
    return gi(t.data);
  }
}
Ky.create = (e) => new Ky({
  typeName: ht.ZodUndefined,
  ...Et(e)
});
class Yy extends kt {
  _parse(t) {
    if (this._getType(t) !== Ke.null) {
      const r = this._getOrReturnCtx(t);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.null,
        received: r.parsedType
      }), pt;
    }
    return gi(t.data);
  }
}
Yy.create = (e) => new Yy({
  typeName: ht.ZodNull,
  ...Et(e)
});
class jm extends kt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return gi(t.data);
  }
}
jm.create = (e) => new jm({
  typeName: ht.ZodAny,
  ...Et(e)
});
class Kd extends kt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return gi(t.data);
  }
}
Kd.create = (e) => new Kd({
  typeName: ht.ZodUnknown,
  ...Et(e)
});
class Tc extends kt {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return Qe(n, {
      code: Re.invalid_type,
      expected: Ke.never,
      received: n.parsedType
    }), pt;
  }
}
Tc.create = (e) => new Tc({
  typeName: ht.ZodNever,
  ...Et(e)
});
class N2 extends kt {
  _parse(t) {
    if (this._getType(t) !== Ke.undefined) {
      const r = this._getOrReturnCtx(t);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.void,
        received: r.parsedType
      }), pt;
    }
    return gi(t.data);
  }
}
N2.create = (e) => new N2({
  typeName: ht.ZodVoid,
  ...Et(e)
});
class fo extends kt {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), i = this._def;
    if (n.parsedType !== Ke.array)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ke.array,
        received: n.parsedType
      }), pt;
    if (i.exactLength !== null) {
      const o = n.data.length > i.exactLength.value, a = n.data.length < i.exactLength.value;
      (o || a) && (Qe(n, {
        code: o ? Re.too_big : Re.too_small,
        minimum: a ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (Qe(n, {
      code: Re.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (Qe(n, {
      code: Re.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((o, a) => i.type._parseAsync(new xa(n, o, n.path, a)))).then((o) => $r.mergeArray(r, o));
    const s = [...n.data].map((o, a) => i.type._parseSync(new xa(n, o, n.path, a)));
    return $r.mergeArray(r, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new fo({
      ...this._def,
      minLength: { value: t, message: st.toString(n) }
    });
  }
  max(t, n) {
    return new fo({
      ...this._def,
      maxLength: { value: t, message: st.toString(n) }
    });
  }
  length(t, n) {
    return new fo({
      ...this._def,
      exactLength: { value: t, message: st.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
fo.create = (e, t) => new fo({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ht.ZodArray,
  ...Et(t)
});
function dh(e) {
  if (e instanceof _n) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = ga.create(dh(r));
    }
    return new _n({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof fo ? new fo({
      ...e._def,
      type: dh(e.element)
    }) : e instanceof ga ? ga.create(dh(e.unwrap())) : e instanceof fu ? fu.create(dh(e.unwrap())) : e instanceof Aa ? Aa.create(e.items.map((t) => dh(t))) : e;
}
class _n extends kt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = zt.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== Ke.object) {
      const l = this._getOrReturnCtx(t);
      return Qe(l, {
        code: Re.invalid_type,
        expected: Ke.object,
        received: l.parsedType
      }), pt;
    }
    const { status: r, ctx: i } = this._processInputParams(t), { shape: s, keys: o } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof Tc && this._def.unknownKeys === "strip"))
      for (const l in i.data)
        o.includes(l) || a.push(l);
    const c = [];
    for (const l of o) {
      const u = s[l], d = i.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: u._parse(new xa(i, d, i.path, l)),
        alwaysSet: l in i.data
      });
    }
    if (this._def.catchall instanceof Tc) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const u of a)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: i.data[u] }
          });
      else if (l === "strict")
        a.length > 0 && (Qe(i, {
          code: Re.unrecognized_keys,
          keys: a
        }), r.dirty());
      else if (l !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const u of a) {
        const d = i.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: l._parse(
            new xa(i, d, i.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const u of c) {
        const d = await u.key, f = await u.value;
        l.push({
          key: d,
          value: f,
          alwaysSet: u.alwaysSet
        });
      }
      return l;
    }).then((l) => $r.mergeObjectSync(r, l)) : $r.mergeObjectSync(r, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return st.errToObj, new _n({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var i, s, o, a;
          const c = (o = (s = (i = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(i, n, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (a = st.errToObj(t).message) !== null && a !== void 0 ? a : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new _n({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new _n({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new _n({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new _n({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: ht.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new _n({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return zt.objectKeys(t).forEach((r) => {
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new _n({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return zt.objectKeys(this.shape).forEach((r) => {
      t[r] || (n[r] = this.shape[r]);
    }), new _n({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return dh(this);
  }
  partial(t) {
    const n = {};
    return zt.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      t && !t[r] ? n[r] = i : n[r] = i.optional();
    }), new _n({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return zt.objectKeys(this.shape).forEach((r) => {
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let s = this.shape[r];
        for (; s instanceof ga; )
          s = s._def.innerType;
        n[r] = s;
      }
    }), new _n({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return G$(zt.objectKeys(this.shape));
  }
}
_n.create = (e, t) => new _n({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Tc.create(),
  typeName: ht.ZodObject,
  ...Et(t)
});
_n.strictCreate = (e, t) => new _n({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Tc.create(),
  typeName: ht.ZodObject,
  ...Et(t)
});
_n.lazycreate = (e, t) => new _n({
  shape: e,
  unknownKeys: "strip",
  catchall: Tc.create(),
  typeName: ht.ZodObject,
  ...Et(t)
});
class Zy extends kt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function i(s) {
      for (const a of s)
        if (a.result.status === "valid")
          return a.result;
      for (const a of s)
        if (a.result.status === "dirty")
          return n.common.issues.push(...a.ctx.common.issues), a.result;
      const o = s.map((a) => new Xi(a.ctx.common.issues));
      return Qe(n, {
        code: Re.invalid_union,
        unionErrors: o
      }), pt;
    }
    if (n.common.async)
      return Promise.all(r.map(async (s) => {
        const o = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: n.data,
            path: n.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let s;
      const o = [];
      for (const c of r) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !s && (s = { result: u, ctx: l }), l.common.issues.length && o.push(l.common.issues);
      }
      if (s)
        return n.common.issues.push(...s.ctx.common.issues), s.result;
      const a = o.map((c) => new Xi(c));
      return Qe(n, {
        code: Re.invalid_union,
        unionErrors: a
      }), pt;
    }
  }
  get options() {
    return this._def.options;
  }
}
Zy.create = (e, t) => new Zy({
  options: e,
  typeName: ht.ZodUnion,
  ...Et(t)
});
const Ra = (e) => e instanceof eb ? Ra(e.schema) : e instanceof yo ? Ra(e.innerType()) : e instanceof tb ? [e.value] : e instanceof du ? e.options : e instanceof nb ? zt.objectValues(e.enum) : e instanceof rb ? Ra(e._def.innerType) : e instanceof Ky ? [void 0] : e instanceof Yy ? [null] : e instanceof ga ? [void 0, ...Ra(e.unwrap())] : e instanceof fu ? [null, ...Ra(e.unwrap())] : e instanceof K8 || e instanceof sb ? Ra(e.unwrap()) : e instanceof ib ? Ra(e._def.innerType) : [];
class VE extends kt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ke.object)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ke.object,
        received: n.parsedType
      }), pt;
    const r = this.discriminator, i = n.data[r], s = this.optionsMap.get(i);
    return s ? n.common.async ? s._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : s._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (Qe(n, {
      code: Re.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), pt);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const s of n) {
      const o = Ra(s.shape[t]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const a of o) {
        if (i.has(a))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(a)}`);
        i.set(a, s);
      }
    }
    return new VE({
      typeName: ht.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: i,
      ...Et(r)
    });
  }
}
function PT(e, t) {
  const n = dl(e), r = dl(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === Ke.object && r === Ke.object) {
    const i = zt.objectKeys(t), s = zt.objectKeys(e).filter((a) => i.indexOf(a) !== -1), o = { ...e, ...t };
    for (const a of s) {
      const c = PT(e[a], t[a]);
      if (!c.valid)
        return { valid: !1 };
      o[a] = c.data;
    }
    return { valid: !0, data: o };
  } else if (n === Ke.array && r === Ke.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let s = 0; s < e.length; s++) {
      const o = e[s], a = t[s], c = PT(o, a);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else
    return n === Ke.date && r === Ke.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Jy extends kt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = (s, o) => {
      if (BT(s) || BT(o))
        return pt;
      const a = PT(s.value, o.value);
      return a.valid ? ((IT(s) || IT(o)) && n.dirty(), { status: n.value, value: a.data }) : (Qe(r, {
        code: Re.invalid_intersection_types
      }), pt);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([s, o]) => i(s, o)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Jy.create = (e, t, n) => new Jy({
  left: e,
  right: t,
  typeName: ht.ZodIntersection,
  ...Et(n)
});
class Aa extends kt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ke.array)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.array,
        received: r.parsedType
      }), pt;
    if (r.data.length < this._def.items.length)
      return Qe(r, {
        code: Re.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), pt;
    !this._def.rest && r.data.length > this._def.items.length && (Qe(r, {
      code: Re.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const s = [...r.data].map((o, a) => {
      const c = this._def.items[a] || this._def.rest;
      return c ? c._parse(new xa(r, o, r.path, a)) : null;
    }).filter((o) => !!o);
    return r.common.async ? Promise.all(s).then((o) => $r.mergeArray(n, o)) : $r.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Aa({
      ...this._def,
      rest: t
    });
  }
}
Aa.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Aa({
    items: e,
    typeName: ht.ZodTuple,
    rest: null,
    ...Et(t)
  });
};
class Xy extends kt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ke.object)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.object,
        received: r.parsedType
      }), pt;
    const i = [], s = this._def.keyType, o = this._def.valueType;
    for (const a in r.data)
      i.push({
        key: s._parse(new xa(r, a, r.path, a)),
        value: o._parse(new xa(r, r.data[a], r.path, a)),
        alwaysSet: a in r.data
      });
    return r.common.async ? $r.mergeObjectAsync(n, i) : $r.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof kt ? new Xy({
      keyType: t,
      valueType: n,
      typeName: ht.ZodRecord,
      ...Et(r)
    }) : new Xy({
      keyType: co.create(),
      valueType: t,
      typeName: ht.ZodRecord,
      ...Et(n)
    });
  }
}
class R2 extends kt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ke.map)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.map,
        received: r.parsedType
      }), pt;
    const i = this._def.keyType, s = this._def.valueType, o = [...r.data.entries()].map(([a, c], l) => ({
      key: i._parse(new xa(r, a, r.path, [l, "key"])),
      value: s._parse(new xa(r, c, r.path, [l, "value"]))
    }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of o) {
          const l = await c.key, u = await c.value;
          if (l.status === "aborted" || u.status === "aborted")
            return pt;
          (l.status === "dirty" || u.status === "dirty") && n.dirty(), a.set(l.value, u.value);
        }
        return { status: n.value, value: a };
      });
    } else {
      const a = /* @__PURE__ */ new Map();
      for (const c of o) {
        const l = c.key, u = c.value;
        if (l.status === "aborted" || u.status === "aborted")
          return pt;
        (l.status === "dirty" || u.status === "dirty") && n.dirty(), a.set(l.value, u.value);
      }
      return { status: n.value, value: a };
    }
  }
}
R2.create = (e, t, n) => new R2({
  valueType: t,
  keyType: e,
  typeName: ht.ZodMap,
  ...Et(n)
});
class gf extends kt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Ke.set)
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.set,
        received: r.parsedType
      }), pt;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (Qe(r, {
      code: Re.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (Qe(r, {
      code: Re.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const s = this._def.valueType;
    function o(c) {
      const l = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return pt;
        u.status === "dirty" && n.dirty(), l.add(u.value);
      }
      return { status: n.value, value: l };
    }
    const a = [...r.data.values()].map((c, l) => s._parse(new xa(r, c, r.path, l)));
    return r.common.async ? Promise.all(a).then((c) => o(c)) : o(a);
  }
  min(t, n) {
    return new gf({
      ...this._def,
      minSize: { value: t, message: st.toString(n) }
    });
  }
  max(t, n) {
    return new gf({
      ...this._def,
      maxSize: { value: t, message: st.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
gf.create = (e, t) => new gf({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: ht.ZodSet,
  ...Et(t)
});
class Zh extends kt {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ke.function)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ke.function,
        received: n.parsedType
      }), pt;
    function r(a, c) {
      return I2({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          B2(),
          Fm
        ].filter((l) => !!l),
        issueData: {
          code: Re.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(a, c) {
      return I2({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          B2(),
          Fm
        ].filter((l) => !!l),
        issueData: {
          code: Re.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const s = { errorMap: n.common.contextualErrorMap }, o = n.data;
    if (this._def.returns instanceof Dm) {
      const a = this;
      return gi(async function(...c) {
        const l = new Xi([]), u = await a._def.args.parseAsync(c, s).catch((p) => {
          throw l.addIssue(r(c, p)), l;
        }), d = await Reflect.apply(o, this, u);
        return await a._def.returns._def.type.parseAsync(d, s).catch((p) => {
          throw l.addIssue(i(d, p)), l;
        });
      });
    } else {
      const a = this;
      return gi(function(...c) {
        const l = a._def.args.safeParse(c, s);
        if (!l.success)
          throw new Xi([r(c, l.error)]);
        const u = Reflect.apply(o, this, l.data), d = a._def.returns.safeParse(u, s);
        if (!d.success)
          throw new Xi([i(u, d.error)]);
        return d.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Zh({
      ...this._def,
      args: Aa.create(t).rest(Kd.create())
    });
  }
  returns(t) {
    return new Zh({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, r) {
    return new Zh({
      args: t || Aa.create([]).rest(Kd.create()),
      returns: n || Kd.create(),
      typeName: ht.ZodFunction,
      ...Et(r)
    });
  }
}
class eb extends kt {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
eb.create = (e, t) => new eb({
  getter: e,
  typeName: ht.ZodLazy,
  ...Et(t)
});
class tb extends kt {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return Qe(n, {
        received: n.data,
        code: Re.invalid_literal,
        expected: this._def.value
      }), pt;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
tb.create = (e, t) => new tb({
  value: e,
  typeName: ht.ZodLiteral,
  ...Et(t)
});
function G$(e, t) {
  return new du({
    values: e,
    typeName: ht.ZodEnum,
    ...Et(t)
  });
}
class du extends kt {
  constructor() {
    super(...arguments), tg.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return Qe(n, {
        expected: zt.joinValues(r),
        received: n.parsedType,
        code: Re.invalid_type
      }), pt;
    }
    if (P2(this, tg) || z$(this, tg, new Set(this._def.values)), !P2(this, tg).has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return Qe(n, {
        received: n.data,
        code: Re.invalid_enum_value,
        options: r
      }), pt;
    }
    return gi(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return du.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return du.create(this.options.filter((r) => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
tg = /* @__PURE__ */ new WeakMap();
du.create = G$;
class nb extends kt {
  constructor() {
    super(...arguments), ng.set(this, void 0);
  }
  _parse(t) {
    const n = zt.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== Ke.string && r.parsedType !== Ke.number) {
      const i = zt.objectValues(n);
      return Qe(r, {
        expected: zt.joinValues(i),
        received: r.parsedType,
        code: Re.invalid_type
      }), pt;
    }
    if (P2(this, ng) || z$(this, ng, new Set(zt.getValidEnumValues(this._def.values))), !P2(this, ng).has(t.data)) {
      const i = zt.objectValues(n);
      return Qe(r, {
        received: r.data,
        code: Re.invalid_enum_value,
        options: i
      }), pt;
    }
    return gi(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
ng = /* @__PURE__ */ new WeakMap();
nb.create = (e, t) => new nb({
  values: e,
  typeName: ht.ZodNativeEnum,
  ...Et(t)
});
class Dm extends kt {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Ke.promise && n.common.async === !1)
      return Qe(n, {
        code: Re.invalid_type,
        expected: Ke.promise,
        received: n.parsedType
      }), pt;
    const r = n.parsedType === Ke.promise ? n.data : Promise.resolve(n.data);
    return gi(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Dm.create = (e, t) => new Dm({
  type: e,
  typeName: ht.ZodPromise,
  ...Et(t)
});
class yo extends kt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ht.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = this._def.effect || null, s = {
      addIssue: (o) => {
        Qe(r, o), o.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), i.type === "preprocess") {
      const o = i.transform(r.data, s);
      if (r.common.async)
        return Promise.resolve(o).then(async (a) => {
          if (n.value === "aborted")
            return pt;
          const c = await this._def.schema._parseAsync({
            data: a,
            path: r.path,
            parent: r
          });
          return c.status === "aborted" ? pt : c.status === "dirty" || n.value === "dirty" ? Bh(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return pt;
        const a = this._def.schema._parseSync({
          data: o,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? pt : a.status === "dirty" || n.value === "dirty" ? Bh(a.value) : a;
      }
    }
    if (i.type === "refinement") {
      const o = (a) => {
        const c = i.refinement(a, s);
        if (r.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? pt : (a.status === "dirty" && n.dirty(), o(a.value), { status: n.value, value: a.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? pt : (a.status === "dirty" && n.dirty(), o(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!qy(o))
          return o;
        const a = i.transform(o.value, s);
        if (a instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => qy(o) ? Promise.resolve(i.transform(o.value, s)).then((a) => ({ status: n.value, value: a })) : o);
    zt.assertNever(i);
  }
}
yo.create = (e, t, n) => new yo({
  schema: e,
  typeName: ht.ZodEffects,
  effect: t,
  ...Et(n)
});
yo.createWithPreprocess = (e, t, n) => new yo({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: ht.ZodEffects,
  ...Et(n)
});
class ga extends kt {
  _parse(t) {
    return this._getType(t) === Ke.undefined ? gi(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ga.create = (e, t) => new ga({
  innerType: e,
  typeName: ht.ZodOptional,
  ...Et(t)
});
class fu extends kt {
  _parse(t) {
    return this._getType(t) === Ke.null ? gi(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
fu.create = (e, t) => new fu({
  innerType: e,
  typeName: ht.ZodNullable,
  ...Et(t)
});
class rb extends kt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === Ke.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
rb.create = (e, t) => new rb({
  innerType: e,
  typeName: ht.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Et(t)
});
class ib extends kt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return $y(i) ? i.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Xi(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Xi(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ib.create = (e, t) => new ib({
  innerType: e,
  typeName: ht.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Et(t)
});
class M2 extends kt {
  _parse(t) {
    if (this._getType(t) !== Ke.nan) {
      const r = this._getOrReturnCtx(t);
      return Qe(r, {
        code: Re.invalid_type,
        expected: Ke.nan,
        received: r.parsedType
      }), pt;
    }
    return { status: "valid", value: t.data };
  }
}
M2.create = (e) => new M2({
  typeName: ht.ZodNaN,
  ...Et(e)
});
const I8e = Symbol("zod_brand");
class K8 extends kt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Rv extends kt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? pt : s.status === "dirty" ? (n.dirty(), Bh(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? pt : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new Rv({
      in: t,
      out: n,
      typeName: ht.ZodPipeline
    });
  }
}
class sb extends kt {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (i) => (qy(i) && (i.value = Object.freeze(i.value)), i);
    return $y(n) ? n.then((i) => r(i)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
sb.create = (e, t) => new sb({
  innerType: e,
  typeName: ht.ZodReadonly,
  ...Et(t)
});
function q$(e, t = {}, n) {
  return e ? jm.create().superRefine((r, i) => {
    var s, o;
    if (!e(r)) {
      const a = typeof t == "function" ? t(r) : typeof t == "string" ? { message: t } : t, c = (o = (s = a.fatal) !== null && s !== void 0 ? s : n) !== null && o !== void 0 ? o : !0, l = typeof a == "string" ? { message: a } : a;
      i.addIssue({ code: "custom", ...l, fatal: c });
    }
  }) : jm.create();
}
const P8e = {
  object: _n.lazycreate
};
var ht;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(ht || (ht = {}));
const O8e = (e, t = {
  message: `Input not instance of ${e.name}`
}) => q$((n) => n instanceof e, t), $$ = co.create, Q$ = lu.create, N8e = M2.create, R8e = uu.create, K$ = Qy.create, M8e = mf.create, F8e = O2.create, j8e = Ky.create, D8e = Yy.create, U8e = jm.create, L8e = Kd.create, z8e = Tc.create, V8e = N2.create, H8e = fo.create, W8e = _n.create, G8e = _n.strictCreate, q8e = Zy.create, $8e = VE.create, Q8e = Jy.create, K8e = Aa.create, Y8e = Xy.create, Z8e = R2.create, J8e = gf.create, X8e = Zh.create, eBe = eb.create, tBe = tb.create, nBe = du.create, rBe = nb.create, iBe = Dm.create, m9 = yo.create, sBe = ga.create, oBe = fu.create, aBe = yo.createWithPreprocess, cBe = Rv.create, lBe = () => $$().optional(), uBe = () => Q$().optional(), dBe = () => K$().optional(), fBe = {
  string: (e) => co.create({ ...e, coerce: !0 }),
  number: (e) => lu.create({ ...e, coerce: !0 }),
  boolean: (e) => Qy.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => uu.create({ ...e, coerce: !0 }),
  date: (e) => mf.create({ ...e, coerce: !0 })
}, hBe = pt;
var Pt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Fm,
  setErrorMap: h8e,
  getErrorMap: B2,
  makeIssue: I2,
  EMPTY_PATH: p8e,
  addIssueToContext: Qe,
  ParseStatus: $r,
  INVALID: pt,
  DIRTY: Bh,
  OK: gi,
  isAborted: BT,
  isDirty: IT,
  isValid: qy,
  isAsync: $y,
  get util() {
    return zt;
  },
  get objectUtil() {
    return kT;
  },
  ZodParsedType: Ke,
  getParsedType: dl,
  ZodType: kt,
  datetimeRegex: W$,
  ZodString: co,
  ZodNumber: lu,
  ZodBigInt: uu,
  ZodBoolean: Qy,
  ZodDate: mf,
  ZodSymbol: O2,
  ZodUndefined: Ky,
  ZodNull: Yy,
  ZodAny: jm,
  ZodUnknown: Kd,
  ZodNever: Tc,
  ZodVoid: N2,
  ZodArray: fo,
  ZodObject: _n,
  ZodUnion: Zy,
  ZodDiscriminatedUnion: VE,
  ZodIntersection: Jy,
  ZodTuple: Aa,
  ZodRecord: Xy,
  ZodMap: R2,
  ZodSet: gf,
  ZodFunction: Zh,
  ZodLazy: eb,
  ZodLiteral: tb,
  ZodEnum: du,
  ZodNativeEnum: nb,
  ZodPromise: Dm,
  ZodEffects: yo,
  ZodTransformer: yo,
  ZodOptional: ga,
  ZodNullable: fu,
  ZodDefault: rb,
  ZodCatch: ib,
  ZodNaN: M2,
  BRAND: I8e,
  ZodBranded: K8,
  ZodPipeline: Rv,
  ZodReadonly: sb,
  custom: q$,
  Schema: kt,
  ZodSchema: kt,
  late: P8e,
  get ZodFirstPartyTypeKind() {
    return ht;
  },
  coerce: fBe,
  any: U8e,
  array: H8e,
  bigint: R8e,
  boolean: K$,
  date: M8e,
  discriminatedUnion: $8e,
  effect: m9,
  enum: nBe,
  function: X8e,
  instanceof: O8e,
  intersection: Q8e,
  lazy: eBe,
  literal: tBe,
  map: Z8e,
  nan: N8e,
  nativeEnum: rBe,
  never: z8e,
  null: D8e,
  nullable: oBe,
  number: Q$,
  object: W8e,
  oboolean: dBe,
  onumber: uBe,
  optional: sBe,
  ostring: lBe,
  pipeline: cBe,
  preprocess: aBe,
  promise: iBe,
  record: Y8e,
  set: J8e,
  strictObject: G8e,
  string: $$,
  symbol: F8e,
  transformer: m9,
  tuple: K8e,
  undefined: j8e,
  union: q8e,
  unknown: L8e,
  void: V8e,
  NEVER: hBe,
  ZodIssueCode: Re,
  quotelessJson: f8e,
  ZodError: Xi
});
function Y$(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: pBe } = Object.prototype, { getPrototypeOf: Y8 } = Object, HE = /* @__PURE__ */ ((e) => (t) => {
  const n = pBe.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ao = (e) => (e = e.toLowerCase(), (t) => HE(t) === e), WE = (e) => (t) => typeof t === e, { isArray: a0 } = Array, ob = WE("undefined");
function mBe(e) {
  return e !== null && !ob(e) && e.constructor !== null && !ob(e.constructor) && Is(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Z$ = Ao("ArrayBuffer");
function gBe(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Z$(e.buffer), t;
}
const yBe = WE("string"), Is = WE("function"), J$ = WE("number"), GE = (e) => e !== null && typeof e == "object", bBe = (e) => e === !0 || e === !1, rx = (e) => {
  if (HE(e) !== "object")
    return !1;
  const t = Y8(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, vBe = Ao("Date"), wBe = Ao("File"), xBe = Ao("Blob"), ABe = Ao("FileList"), EBe = (e) => GE(e) && Is(e.pipe), _Be = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Is(e.append) && ((t = HE(e)) === "formdata" || // detect form-data instance
  t === "object" && Is(e.toString) && e.toString() === "[object FormData]"));
}, SBe = Ao("URLSearchParams"), [CBe, TBe, kBe, BBe] = ["ReadableStream", "Request", "Response", "Headers"].map(Ao), IBe = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Mv(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), a0(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    const s = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = s.length;
    let a;
    for (r = 0; r < o; r++)
      a = s[r], t.call(null, e[a], a, e);
  }
}
function X$(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const eQ = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : window, tQ = (e) => !ob(e) && e !== eQ;
function OT() {
  const { caseless: e } = tQ(this) && this || {}, t = {}, n = (r, i) => {
    const s = e && X$(t, i) || i;
    rx(t[s]) && rx(r) ? t[s] = OT(t[s], r) : rx(r) ? t[s] = OT({}, r) : a0(r) ? t[s] = r.slice() : t[s] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Mv(arguments[r], n);
  return t;
}
const PBe = (e, t, n, { allOwnKeys: r } = {}) => (Mv(t, (i, s) => {
  n && Is(i) ? e[s] = Y$(i, n) : e[s] = i;
}, { allOwnKeys: r }), e), OBe = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), NBe = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, RBe = (e, t, n, r) => {
  let i, s, o;
  const a = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (i = Object.getOwnPropertyNames(e), s = i.length; s-- > 0; )
      o = i[s], (!r || r(o, e, t)) && !a[o] && (t[o] = e[o], a[o] = !0);
    e = n !== !1 && Y8(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, MBe = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, FBe = (e) => {
  if (!e)
    return null;
  if (a0(e))
    return e;
  let t = e.length;
  if (!J$(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, jBe = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Y8(Uint8Array)), DBe = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const s = i.value;
    t.call(e, s[0], s[1]);
  }
}, UBe = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, LBe = Ao("HTMLFormElement"), zBe = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), g9 = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), VBe = Ao("RegExp"), nQ = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Mv(n, (i, s) => {
    let o;
    (o = t(i, s, e)) !== !1 && (r[s] = o || i);
  }), Object.defineProperties(e, r);
}, HBe = (e) => {
  nQ(e, (t, n) => {
    if (Is(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Is(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, WBe = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((s) => {
      n[s] = !0;
    });
  };
  return a0(e) ? r(e) : r(String(e).split(t)), n;
}, GBe = () => {
}, qBe = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, v6 = "abcdefghijklmnopqrstuvwxyz", y9 = "0123456789", rQ = {
  DIGIT: y9,
  ALPHA: v6,
  ALPHA_DIGIT: v6 + v6.toUpperCase() + y9
}, $Be = (e = 16, t = rQ.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function QBe(e) {
  return !!(e && Is(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const KBe = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (GE(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[i] = r;
        const s = a0(r) ? [] : {};
        return Mv(r, (o, a) => {
          const c = n(o, i + 1);
          !ob(c) && (s[a] = c);
        }), t[i] = void 0, s;
      }
    }
    return r;
  };
  return n(e, 0);
}, YBe = Ao("AsyncFunction"), ZBe = (e) => e && (GE(e) || Is(e)) && Is(e.then) && Is(e.catch), xe = {
  isArray: a0,
  isArrayBuffer: Z$,
  isBuffer: mBe,
  isFormData: _Be,
  isArrayBufferView: gBe,
  isString: yBe,
  isNumber: J$,
  isBoolean: bBe,
  isObject: GE,
  isPlainObject: rx,
  isReadableStream: CBe,
  isRequest: TBe,
  isResponse: kBe,
  isHeaders: BBe,
  isUndefined: ob,
  isDate: vBe,
  isFile: wBe,
  isBlob: xBe,
  isRegExp: VBe,
  isFunction: Is,
  isStream: EBe,
  isURLSearchParams: SBe,
  isTypedArray: jBe,
  isFileList: ABe,
  forEach: Mv,
  merge: OT,
  extend: PBe,
  trim: IBe,
  stripBOM: OBe,
  inherits: NBe,
  toFlatObject: RBe,
  kindOf: HE,
  kindOfTest: Ao,
  endsWith: MBe,
  toArray: FBe,
  forEachEntry: DBe,
  matchAll: UBe,
  isHTMLForm: LBe,
  hasOwnProperty: g9,
  hasOwnProp: g9,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: nQ,
  freezeMethods: HBe,
  toObjectSet: WBe,
  toCamelCase: zBe,
  noop: GBe,
  toFiniteNumber: qBe,
  findKey: X$,
  global: eQ,
  isContextDefined: tQ,
  ALPHABET: rQ,
  generateString: $Be,
  isSpecCompliantForm: QBe,
  toJSONObject: KBe,
  isAsyncFn: YBe,
  isThenable: ZBe
};
function At(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
xe.inherits(At, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: xe.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const iQ = At.prototype, sQ = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  sQ[e] = { value: e };
});
Object.defineProperties(At, sQ);
Object.defineProperty(iQ, "isAxiosError", { value: !0 });
At.from = (e, t, n, r, i, s) => {
  const o = Object.create(iQ);
  return xe.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (a) => a !== "isAxiosError"), At.call(o, e.message, t, n, r, i), o.cause = e, o.name = e.name, s && Object.assign(o, s), o;
};
const JBe = null;
function NT(e) {
  return xe.isPlainObject(e) || xe.isArray(e);
}
function oQ(e) {
  return xe.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function b9(e, t, n) {
  return e ? e.concat(t).map(function(i, s) {
    return i = oQ(i), !n && s ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function XBe(e) {
  return xe.isArray(e) && !e.some(NT);
}
const eIe = xe.toFlatObject(xe, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function qE(e, t, n) {
  if (!xe.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = xe.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, g) {
    return !xe.isUndefined(g[h]);
  });
  const r = n.metaTokens, i = n.visitor || u, s = n.dots, o = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && xe.isSpecCompliantForm(t);
  if (!xe.isFunction(i))
    throw new TypeError("visitor must be a function");
  function l(m) {
    if (m === null)
      return "";
    if (xe.isDate(m))
      return m.toISOString();
    if (!c && xe.isBlob(m))
      throw new At("Blob is not supported. Use a Buffer instead.");
    return xe.isArrayBuffer(m) || xe.isTypedArray(m) ? c && typeof Blob == "function" ? new Blob([m]) : T5.from(m) : m;
  }
  function u(m, h, g) {
    let y = m;
    if (m && !g && typeof m == "object") {
      if (xe.endsWith(h, "{}"))
        h = r ? h : h.slice(0, -2), m = JSON.stringify(m);
      else if (xe.isArray(m) && XBe(m) || (xe.isFileList(m) || xe.endsWith(h, "[]")) && (y = xe.toArray(m)))
        return h = oQ(h), y.forEach(function(b, w) {
          !(xe.isUndefined(b) || b === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? b9([h], w, s) : o === null ? h : h + "[]",
            l(b)
          );
        }), !1;
    }
    return NT(m) ? !0 : (t.append(b9(g, h, s), l(m)), !1);
  }
  const d = [], f = Object.assign(eIe, {
    defaultVisitor: u,
    convertValue: l,
    isVisitable: NT
  });
  function p(m, h) {
    if (!xe.isUndefined(m)) {
      if (d.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      d.push(m), xe.forEach(m, function(y, v) {
        (!(xe.isUndefined(y) || y === null) && i.call(
          t,
          y,
          xe.isString(v) ? v.trim() : v,
          h,
          f
        )) === !0 && p(y, h ? h.concat(v) : [v]);
      }), d.pop();
    }
  }
  if (!xe.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function v9(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Z8(e, t) {
  this._pairs = [], e && qE(e, this, t);
}
const aQ = Z8.prototype;
aQ.append = function(t, n) {
  this._pairs.push([t, n]);
};
aQ.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, v9);
  } : v9;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function tIe(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function cQ(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || tIe, i = n && n.serialize;
  let s;
  if (i ? s = i(t, n) : s = xe.isURLSearchParams(t) ? t.toString() : new Z8(t, n).toString(r), s) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class w9 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    xe.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const lQ = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, nIe = typeof URLSearchParams < "u" ? URLSearchParams : Z8, rIe = typeof FormData < "u" ? FormData : null, iIe = typeof Blob < "u" ? Blob : null, sIe = {
  isBrowser: !0,
  classes: {
    URLSearchParams: nIe,
    FormData: rIe,
    Blob: iIe
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, J8 = typeof window < "u" && typeof document < "u", oIe = ((e) => J8 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), aIe = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", cIe = J8 && window.location.href || "http://localhost", lIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: J8,
  hasStandardBrowserEnv: oIe,
  hasStandardBrowserWebWorkerEnv: aIe,
  origin: cIe
}, Symbol.toStringTag, { value: "Module" })), ho = {
  ...lIe,
  ...sIe
};
function uIe(e, t) {
  return qE(e, new ho.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, s) {
      return ho.isNode && xe.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function dIe(e) {
  return xe.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function fIe(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let s;
  for (r = 0; r < i; r++)
    s = n[r], t[s] = e[s];
  return t;
}
function uQ(e) {
  function t(n, r, i, s) {
    let o = n[s++];
    if (o === "__proto__")
      return !0;
    const a = Number.isFinite(+o), c = s >= n.length;
    return o = !o && xe.isArray(i) ? i.length : o, c ? (xe.hasOwnProp(i, o) ? i[o] = [i[o], r] : i[o] = r, !a) : ((!i[o] || !xe.isObject(i[o])) && (i[o] = []), t(n, r, i[o], s) && xe.isArray(i[o]) && (i[o] = fIe(i[o])), !a);
  }
  if (xe.isFormData(e) && xe.isFunction(e.entries)) {
    const n = {};
    return xe.forEachEntry(e, (r, i) => {
      t(dIe(r), i, n, 0);
    }), n;
  }
  return null;
}
function hIe(e, t, n) {
  if (xe.isString(e))
    try {
      return (t || JSON.parse)(e), xe.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Fv = {
  transitional: lQ,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, s = xe.isObject(t);
    if (s && xe.isHTMLForm(t) && (t = new FormData(t)), xe.isFormData(t))
      return i ? JSON.stringify(uQ(t)) : t;
    if (xe.isArrayBuffer(t) || xe.isBuffer(t) || xe.isStream(t) || xe.isFile(t) || xe.isBlob(t) || xe.isReadableStream(t))
      return t;
    if (xe.isArrayBufferView(t))
      return t.buffer;
    if (xe.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return uIe(t, this.formSerializer).toString();
      if ((a = xe.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return qE(
          a ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return s || i ? (n.setContentType("application/json", !1), hIe(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Fv.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (xe.isResponse(t) || xe.isReadableStream(t))
      return t;
    if (t && xe.isString(t) && (r && !this.responseType || i)) {
      const o = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? At.from(a, At.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ho.classes.FormData,
    Blob: ho.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
xe.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Fv.headers[e] = {};
});
const pIe = xe.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), mIe = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(o) {
    i = o.indexOf(":"), n = o.substring(0, i).trim().toLowerCase(), r = o.substring(i + 1).trim(), !(!n || t[n] && pIe[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, x9 = Symbol("internals");
function N0(e) {
  return e && String(e).trim().toLowerCase();
}
function ix(e) {
  return e === !1 || e == null ? e : xe.isArray(e) ? e.map(ix) : String(e);
}
function gIe(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const yIe = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function w6(e, t, n, r, i) {
  if (xe.isFunction(r))
    return r.call(this, t, n);
  if (i && (t = n), !!xe.isString(t)) {
    if (xe.isString(r))
      return t.indexOf(r) !== -1;
    if (xe.isRegExp(r))
      return r.test(t);
  }
}
function bIe(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function vIe(e, t) {
  const n = xe.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, s, o) {
        return this[r].call(this, t, i, s, o);
      },
      configurable: !0
    });
  });
}
class Ri {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function s(a, c, l) {
      const u = N0(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = xe.findKey(i, u);
      (!d || i[d] === void 0 || l === !0 || l === void 0 && i[d] !== !1) && (i[d || c] = ix(a));
    }
    const o = (a, c) => xe.forEach(a, (l, u) => s(l, u, c));
    if (xe.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (xe.isString(t) && (t = t.trim()) && !yIe(t))
      o(mIe(t), n);
    else if (xe.isHeaders(t))
      for (const [a, c] of t.entries())
        s(c, a, r);
    else
      t != null && s(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = N0(t), t) {
      const r = xe.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return gIe(i);
        if (xe.isFunction(n))
          return n.call(this, i, r);
        if (xe.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = N0(t), t) {
      const r = xe.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || w6(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function s(o) {
      if (o = N0(o), o) {
        const a = xe.findKey(r, o);
        a && (!n || w6(r, r[a], a, n)) && (delete r[a], i = !0);
      }
    }
    return xe.isArray(t) ? t.forEach(s) : s(t), i;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const s = n[r];
      (!t || w6(this, this[s], s, t, !0)) && (delete this[s], i = !0);
    }
    return i;
  }
  normalize(t) {
    const n = this, r = {};
    return xe.forEach(this, (i, s) => {
      const o = xe.findKey(r, s);
      if (o) {
        n[o] = ix(i), delete n[s];
        return;
      }
      const a = t ? bIe(s) : String(s).trim();
      a !== s && delete n[s], n[a] = ix(i), r[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return xe.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && xe.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[x9] = this[x9] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function s(o) {
      const a = N0(o);
      r[a] || (vIe(i, o), r[a] = !0);
    }
    return xe.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
Ri.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
xe.reduceDescriptors(Ri.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
xe.freezeMethods(Ri);
function x6(e, t) {
  const n = this || Fv, r = t || n, i = Ri.from(r.headers);
  let s = r.data;
  return xe.forEach(e, function(a) {
    s = a.call(n, s, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), s;
}
function dQ(e) {
  return !!(e && e.__CANCEL__);
}
function c0(e, t, n) {
  At.call(this, e ?? "canceled", At.ERR_CANCELED, t, n), this.name = "CanceledError";
}
xe.inherits(c0, At, {
  __CANCEL__: !0
});
function fQ(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new At(
    "Request failed with status code " + n.status,
    [At.ERR_BAD_REQUEST, At.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function wIe(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function xIe(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, s = 0, o;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const l = Date.now(), u = r[s];
    o || (o = l), n[i] = c, r[i] = l;
    let d = s, f = 0;
    for (; d !== i; )
      f += n[d++], d = d % e;
    if (i = (i + 1) % e, i === s && (s = (s + 1) % e), l - o < t)
      return;
    const p = u && l - u;
    return p ? Math.round(f * 1e3 / p) : void 0;
  };
}
function AIe(e, t) {
  let n = 0;
  const r = 1e3 / t;
  let i = null;
  return function() {
    const o = this === !0, a = Date.now();
    if (o || a - n > r)
      return i && (clearTimeout(i), i = null), n = a, e.apply(null, arguments);
    i || (i = setTimeout(() => (i = null, n = Date.now(), e.apply(null, arguments)), r - (a - n)));
  };
}
const F2 = (e, t, n = 3) => {
  let r = 0;
  const i = xIe(50, 250);
  return AIe((s) => {
    const o = s.loaded, a = s.lengthComputable ? s.total : void 0, c = o - r, l = i(c), u = o <= a;
    r = o;
    const d = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: c,
      rate: l || void 0,
      estimated: l && a && u ? (a - o) / l : void 0,
      event: s,
      lengthComputable: a != null
    };
    d[t ? "download" : "upload"] = !0, e(d);
  }, n);
}, EIe = ho.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function i(s) {
      let o = s;
      return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = i(window.location.href), function(o) {
      const a = xe.isString(o) ? i(o) : o;
      return a.protocol === r.protocol && a.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), _Ie = ho.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, i, s) {
      const o = [e + "=" + encodeURIComponent(t)];
      xe.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), xe.isString(r) && o.push("path=" + r), xe.isString(i) && o.push("domain=" + i), s === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function SIe(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function CIe(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function hQ(e, t) {
  return e && !SIe(t) ? CIe(e, t) : t;
}
const A9 = (e) => e instanceof Ri ? { ...e } : e;
function yf(e, t) {
  t = t || {};
  const n = {};
  function r(l, u, d) {
    return xe.isPlainObject(l) && xe.isPlainObject(u) ? xe.merge.call({ caseless: d }, l, u) : xe.isPlainObject(u) ? xe.merge({}, u) : xe.isArray(u) ? u.slice() : u;
  }
  function i(l, u, d) {
    if (xe.isUndefined(u)) {
      if (!xe.isUndefined(l))
        return r(void 0, l, d);
    } else
      return r(l, u, d);
  }
  function s(l, u) {
    if (!xe.isUndefined(u))
      return r(void 0, u);
  }
  function o(l, u) {
    if (xe.isUndefined(u)) {
      if (!xe.isUndefined(l))
        return r(void 0, l);
    } else
      return r(void 0, u);
  }
  function a(l, u, d) {
    if (d in t)
      return r(l, u);
    if (d in e)
      return r(void 0, l);
  }
  const c = {
    url: s,
    method: s,
    data: s,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (l, u) => i(A9(l), A9(u), !0)
  };
  return xe.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = c[u] || i, f = d(e[u], t[u], u);
    xe.isUndefined(f) && d !== a || (n[u] = f);
  }), n;
}
const pQ = (e) => {
  const t = yf({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: i, xsrfCookieName: s, headers: o, auth: a } = t;
  t.headers = o = Ri.from(o), t.url = cQ(hQ(t.baseURL, t.url), e.params, e.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let c;
  if (xe.isFormData(n)) {
    if (ho.hasStandardBrowserEnv || ho.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((c = o.getContentType()) !== !1) {
      const [l, ...u] = c ? c.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([l || "multipart/form-data", ...u].join("; "));
    }
  }
  if (ho.hasStandardBrowserEnv && (r && xe.isFunction(r) && (r = r(t)), r || r !== !1 && EIe(t.url))) {
    const l = i && s && _Ie.read(s);
    l && o.set(i, l);
  }
  return t;
}, TIe = typeof XMLHttpRequest < "u", kIe = TIe && function(e) {
  return new Promise(function(n, r) {
    const i = pQ(e);
    let s = i.data;
    const o = Ri.from(i.headers).normalize();
    let { responseType: a } = i, c;
    function l() {
      i.cancelToken && i.cancelToken.unsubscribe(c), i.signal && i.signal.removeEventListener("abort", c);
    }
    let u = new XMLHttpRequest();
    u.open(i.method.toUpperCase(), i.url, !0), u.timeout = i.timeout;
    function d() {
      if (!u)
        return;
      const p = Ri.from(
        "getAllResponseHeaders" in u && u.getAllResponseHeaders()
      ), h = {
        data: !a || a === "text" || a === "json" ? u.responseText : u.response,
        status: u.status,
        statusText: u.statusText,
        headers: p,
        config: e,
        request: u
      };
      fQ(function(y) {
        n(y), l();
      }, function(y) {
        r(y), l();
      }, h), u = null;
    }
    "onloadend" in u ? u.onloadend = d : u.onreadystatechange = function() {
      !u || u.readyState !== 4 || u.status === 0 && !(u.responseURL && u.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, u.onabort = function() {
      u && (r(new At("Request aborted", At.ECONNABORTED, i, u)), u = null);
    }, u.onerror = function() {
      r(new At("Network Error", At.ERR_NETWORK, i, u)), u = null;
    }, u.ontimeout = function() {
      let m = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const h = i.transitional || lQ;
      i.timeoutErrorMessage && (m = i.timeoutErrorMessage), r(new At(
        m,
        h.clarifyTimeoutError ? At.ETIMEDOUT : At.ECONNABORTED,
        i,
        u
      )), u = null;
    }, s === void 0 && o.setContentType(null), "setRequestHeader" in u && xe.forEach(o.toJSON(), function(m, h) {
      u.setRequestHeader(h, m);
    }), xe.isUndefined(i.withCredentials) || (u.withCredentials = !!i.withCredentials), a && a !== "json" && (u.responseType = i.responseType), typeof i.onDownloadProgress == "function" && u.addEventListener("progress", F2(i.onDownloadProgress, !0)), typeof i.onUploadProgress == "function" && u.upload && u.upload.addEventListener("progress", F2(i.onUploadProgress)), (i.cancelToken || i.signal) && (c = (p) => {
      u && (r(!p || p.type ? new c0(null, e, u) : p), u.abort(), u = null);
    }, i.cancelToken && i.cancelToken.subscribe(c), i.signal && (i.signal.aborted ? c() : i.signal.addEventListener("abort", c)));
    const f = wIe(i.url);
    if (f && ho.protocols.indexOf(f) === -1) {
      r(new At("Unsupported protocol " + f + ":", At.ERR_BAD_REQUEST, e));
      return;
    }
    u.send(s || null);
  });
}, BIe = (e, t) => {
  let n = new AbortController(), r;
  const i = function(c) {
    if (!r) {
      r = !0, o();
      const l = c instanceof Error ? c : this.reason;
      n.abort(l instanceof At ? l : new c0(l instanceof Error ? l.message : l));
    }
  };
  let s = t && setTimeout(() => {
    i(new At(`timeout ${t} of ms exceeded`, At.ETIMEDOUT));
  }, t);
  const o = () => {
    e && (s && clearTimeout(s), s = null, e.forEach((c) => {
      c && (c.removeEventListener ? c.removeEventListener("abort", i) : c.unsubscribe(i));
    }), e = null);
  };
  e.forEach((c) => c && c.addEventListener && c.addEventListener("abort", i));
  const { signal: a } = n;
  return a.unsubscribe = o, [a, () => {
    s && clearTimeout(s), s = null;
  }];
}, IIe = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, i;
  for (; r < n; )
    i = r + t, yield e.slice(r, i), r = i;
}, PIe = async function* (e, t, n) {
  for await (const r of e)
    yield* IIe(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, E9 = (e, t, n, r, i) => {
  const s = PIe(e, t, i);
  let o = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(a) {
      const { done: c, value: l } = await s.next();
      if (c) {
        a.close(), r();
        return;
      }
      let u = l.byteLength;
      n && n(o += u), a.enqueue(new Uint8Array(l));
    },
    cancel(a) {
      return r(a), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, _9 = (e, t) => {
  const n = e != null;
  return (r) => setTimeout(() => t({
    lengthComputable: n,
    total: e,
    loaded: r
  }));
}, $E = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", mQ = $E && typeof ReadableStream == "function", RT = $E && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), OIe = mQ && (() => {
  let e = !1;
  const t = new Request(ho.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
})(), S9 = 64 * 1024, MT = mQ && !!(() => {
  try {
    return xe.isReadableStream(new Response("").body);
  } catch {
  }
})(), j2 = {
  stream: MT && ((e) => e.body)
};
$E && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !j2[t] && (j2[t] = xe.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new At(`Response type '${t}' is not supported`, At.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const NIe = async (e) => {
  if (e == null)
    return 0;
  if (xe.isBlob(e))
    return e.size;
  if (xe.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (xe.isArrayBufferView(e))
    return e.byteLength;
  if (xe.isURLSearchParams(e) && (e = e + ""), xe.isString(e))
    return (await RT(e)).byteLength;
}, RIe = async (e, t) => {
  const n = xe.toFiniteNumber(e.getContentLength());
  return n ?? NIe(t);
}, MIe = $E && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: i,
    cancelToken: s,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: c,
    responseType: l,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = pQ(e);
  l = l ? (l + "").toLowerCase() : "text";
  let [p, m] = i || s || o ? BIe([i, s], o) : [], h, g;
  const y = () => {
    !h && setTimeout(() => {
      p && p.unsubscribe();
    }), h = !0;
  };
  let v;
  try {
    if (c && OIe && n !== "get" && n !== "head" && (v = await RIe(u, r)) !== 0) {
      let E = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), x;
      xe.isFormData(r) && (x = E.headers.get("content-type")) && u.setContentType(x), E.body && (r = E9(E.body, S9, _9(
        v,
        F2(c)
      ), null, RT));
    }
    xe.isString(d) || (d = d ? "cors" : "omit"), g = new Request(t, {
      ...f,
      signal: p,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      withCredentials: d
    });
    let b = await fetch(g);
    const w = MT && (l === "stream" || l === "response");
    if (MT && (a || w)) {
      const E = {};
      ["status", "statusText", "headers"].forEach((S) => {
        E[S] = b[S];
      });
      const x = xe.toFiniteNumber(b.headers.get("content-length"));
      b = new Response(
        E9(b.body, S9, a && _9(
          x,
          F2(a, !0)
        ), w && y, RT),
        E
      );
    }
    l = l || "text";
    let A = await j2[xe.findKey(j2, l) || "text"](b, e);
    return !w && y(), m && m(), await new Promise((E, x) => {
      fQ(E, x, {
        data: A,
        headers: Ri.from(b.headers),
        status: b.status,
        statusText: b.statusText,
        config: e,
        request: g
      });
    });
  } catch (b) {
    throw y(), b && b.name === "TypeError" && /fetch/i.test(b.message) ? Object.assign(
      new At("Network Error", At.ERR_NETWORK, e, g),
      {
        cause: b.cause || b
      }
    ) : At.from(b, b && b.code, e, g);
  }
}), FT = {
  http: JBe,
  xhr: kIe,
  fetch: MIe
};
xe.forEach(FT, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const C9 = (e) => `- ${e}`, FIe = (e) => xe.isFunction(e) || e === null || e === !1, gQ = {
  getAdapter: (e) => {
    e = xe.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const i = {};
    for (let s = 0; s < t; s++) {
      n = e[s];
      let o;
      if (r = n, !FIe(n) && (r = FT[(o = String(n)).toLowerCase()], r === void 0))
        throw new At(`Unknown adapter '${o}'`);
      if (r)
        break;
      i[o || "#" + s] = r;
    }
    if (!r) {
      const s = Object.entries(i).map(
        ([a, c]) => `adapter ${a} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? s.length > 1 ? `since :
` + s.map(C9).join(`
`) : " " + C9(s[0]) : "as no adapter specified";
      throw new At(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: FT
};
function A6(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new c0(null, e);
}
function T9(e) {
  return A6(e), e.headers = Ri.from(e.headers), e.data = x6.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), gQ.getAdapter(e.adapter || Fv.adapter)(e).then(function(r) {
    return A6(e), r.data = x6.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Ri.from(r.headers), r;
  }, function(r) {
    return dQ(r) || (A6(e), r && r.response && (r.response.data = x6.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Ri.from(r.response.headers))), Promise.reject(r);
  });
}
const yQ = "1.7.2", X8 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  X8[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const k9 = {};
X8.transitional = function(t, n, r) {
  function i(s, o) {
    return "[Axios v" + yQ + "] Transitional option '" + s + "'" + o + (r ? ". " + r : "");
  }
  return (s, o, a) => {
    if (t === !1)
      throw new At(
        i(o, " has been removed" + (n ? " in " + n : "")),
        At.ERR_DEPRECATED
      );
    return n && !k9[o] && (k9[o] = !0, console.warn(
      i(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(s, o, a) : !0;
  };
};
function jIe(e, t, n) {
  if (typeof e != "object")
    throw new At("options must be an object", At.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const s = r[i], o = t[s];
    if (o) {
      const a = e[s], c = a === void 0 || o(a, s, e);
      if (c !== !0)
        throw new At("option " + s + " must be " + c, At.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new At("Unknown option " + s, At.ERR_BAD_OPTION);
  }
}
const jT = {
  assertOptions: jIe,
  validators: X8
}, Qc = jT.validators;
class Yd {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new w9(),
      response: new w9()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let i;
        Error.captureStackTrace ? Error.captureStackTrace(i = {}) : i = new Error();
        const s = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = yf(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: s } = n;
    r !== void 0 && jT.assertOptions(r, {
      silentJSONParsing: Qc.transitional(Qc.boolean),
      forcedJSONParsing: Qc.transitional(Qc.boolean),
      clarifyTimeoutError: Qc.transitional(Qc.boolean)
    }, !1), i != null && (xe.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : jT.assertOptions(i, {
      encode: Qc.function,
      serialize: Qc.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = s && xe.merge(
      s.common,
      s[n.method]
    );
    s && xe.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete s[m];
      }
    ), n.headers = Ri.concat(o, s);
    const a = [];
    let c = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(n) === !1 || (c = c && h.synchronous, a.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let u, d = 0, f;
    if (!c) {
      const m = [T9.bind(this), void 0];
      for (m.unshift.apply(m, a), m.push.apply(m, l), f = m.length, u = Promise.resolve(n); d < f; )
        u = u.then(m[d++], m[d++]);
      return u;
    }
    f = a.length;
    let p = n;
    for (d = 0; d < f; ) {
      const m = a[d++], h = a[d++];
      try {
        p = m(p);
      } catch (g) {
        h.call(this, g);
        break;
      }
    }
    try {
      u = T9.call(this, p);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, f = l.length; d < f; )
      u = u.then(l[d++], l[d++]);
    return u;
  }
  getUri(t) {
    t = yf(this.defaults, t);
    const n = hQ(t.baseURL, t.url);
    return cQ(n, t.params, t.paramsSerializer);
  }
}
xe.forEach(["delete", "get", "head", "options"], function(t) {
  Yd.prototype[t] = function(n, r) {
    return this.request(yf(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
xe.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(s, o, a) {
      return this.request(yf(a || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: o
      }));
    };
  }
  Yd.prototype[t] = n(), Yd.prototype[t + "Form"] = n(!0);
});
class eB {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners)
        return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let s;
      const o = new Promise((a) => {
        r.subscribe(a), s = a;
      }).then(i);
      return o.cancel = function() {
        r.unsubscribe(s);
      }, o;
    }, t(function(s, o, a) {
      r.reason || (r.reason = new c0(s, o, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new eB(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
}
function DIe(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function UIe(e) {
  return xe.isObject(e) && e.isAxiosError === !0;
}
const DT = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(DT).forEach(([e, t]) => {
  DT[t] = e;
});
function bQ(e) {
  const t = new Yd(e), n = Y$(Yd.prototype.request, t);
  return xe.extend(n, Yd.prototype, t, { allOwnKeys: !0 }), xe.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return bQ(yf(e, i));
  }, n;
}
const Jn = bQ(Fv);
Jn.Axios = Yd;
Jn.CanceledError = c0;
Jn.CancelToken = eB;
Jn.isCancel = dQ;
Jn.VERSION = yQ;
Jn.toFormData = qE;
Jn.AxiosError = At;
Jn.Cancel = Jn.CanceledError;
Jn.all = function(t) {
  return Promise.all(t);
};
Jn.spread = DIe;
Jn.isAxiosError = UIe;
Jn.mergeConfig = yf;
Jn.AxiosHeaders = Ri;
Jn.formToJSON = (e) => uQ(xe.isHTMLForm(e) ? new FormData(e) : e);
Jn.getAdapter = gQ.getAdapter;
Jn.HttpStatusCode = DT;
Jn.default = Jn;
var LIe = Symbol("cache-parser");
function B9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function th(e) {
  return (typeof e == "string" || typeof e == "number") && (e = Number(e)) >= 0 && e < 1 / 0;
}
function Ro(e) {
  return e === !0 || typeof e == "number" || typeof e == "string" && e !== "false";
}
var nh = Number;
function vQ(e) {
  var t = Object.defineProperty({}, LIe, { enumerable: !1, value: 1 });
  if (!e || typeof e != "string")
    return t;
  var n = function(l) {
    for (var u, d = {}, f = function(h, g) {
      var y = typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
      if (y)
        return (y = y.call(h)).next.bind(y);
      if (Array.isArray(h) || (y = function(b, w) {
        if (b) {
          if (typeof b == "string")
            return B9(b, w);
          var A = Object.prototype.toString.call(b).slice(8, -1);
          return A === "Object" && b.constructor && (A = b.constructor.name), A === "Map" || A === "Set" ? Array.from(b) : A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A) ? B9(b, w) : void 0;
        }
      }(h))) {
        y && (h = y);
        var v = 0;
        return function() {
          return v >= h.length ? { done: !0 } : { done: !1, value: h[v++] };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }(l.toLowerCase().replace(/\s+/g, "").split(",")); !(u = f()).done; ) {
      var p, m = u.value.split("=", 2);
      d[m[0]] = (p = m[1]) == null || p;
    }
    return d;
  }(e), r = n["max-age"], i = n["max-stale"], s = n["min-fresh"], o = n["s-maxage"], a = n["stale-if-error"], c = n["stale-while-revalidate"];
  return Ro(n.immutable) && (t.immutable = !0), th(r) && (t.maxAge = nh(r)), th(i) && (t.maxStale = nh(i)), th(s) && (t.minFresh = nh(s)), Ro(n["must-revalidate"]) && (t.mustRevalidate = !0), Ro(n["must-understand"]) && (t.mustUnderstand = !0), Ro(n["no-cache"]) && (t.noCache = !0), Ro(n["no-store"]) && (t.noStore = !0), Ro(n["no-transform"]) && (t.noTransform = !0), Ro(n["only-if-cached"]) && (t.onlyIfCached = !0), Ro(n.private) && (t.private = !0), Ro(n["proxy-revalidate"]) && (t.proxyRevalidate = !0), Ro(n.public) && (t.public = !0), th(o) && (t.sMaxAge = nh(o)), th(a) && (t.staleIfError = nh(a)), th(c) && (t.staleWhileRevalidate = nh(c)), t;
}
var zIe = Symbol();
function VIe() {
  var e, t, n = new Promise(function(r, i) {
    e = r, t = i;
  });
  return n.resolve = e, n.reject = t, n[zIe] = 1, n;
}
function HIe(e, t) {
  return e > t ? 1 : -1;
}
function sx(e, t) {
  var n = 5381;
  if (typeof e == "object" && e !== null && (e.toString === Object.prototype.toString || e.toString === Array.prototype.toString)) {
    t || (t = /* @__PURE__ */ new WeakSet());
    for (var r = Object.keys(e).sort(HIe), i = 0; i < r.length; i++) {
      var s = r[i], o = e[s];
      if (n = 33 * n ^ sx(s, t), typeof o == "object" && o !== null && (e.toString === Object.prototype.toString || e.toString === Array.prototype.toString)) {
        if (t.has(o))
          continue;
        t.add(o);
      }
      n = 33 * n ^ sx(o, t);
    }
    return 33 * n ^ sx(e.constructor, t);
  }
  var a = typeof e;
  try {
    e instanceof Date ? a += e.getTime() : a += String(e);
  } catch {
    a += String(Object.assign({}, e));
  }
  for (var c = 0; c < a.length; c++)
    n = 33 * n ^ a.charCodeAt(c);
  return n;
}
/*!
 * Axios Cache Interceptor 1.5.3
 * (c) 2021-present Arthur Fiorette & Contributors
 * Released under the MIT License.
 */
const er = Object.freeze({
  /**
   * ```txt
   * If-Modified-Since: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Modified-Since
   */
  IfModifiedSince: "if-modified-since",
  /**
   * ```txt
   * Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Last-Modified
   */
  LastModified: "last-modified",
  /**
   * ```txt
   * If-None-Match: "<etag_value>"
   * If-None-Match: "<etag_value>", "<etag_value>", …
   * If-None-Match: *
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-None-Match
   */
  IfNoneMatch: "if-none-match",
  /**
   * ```txt
   * Cache-Control: max-age=604800
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control
   */
  CacheControl: "cache-control",
  /**
   * ```txt
   * Pragma: no - cache;
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Pragma
   */
  Pragma: "pragma",
  /**
   * ```txt
   * ETag: W / '<etag_value>';
   * ETag: '<etag_value>';
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/ETag
   */
  ETag: "etag",
  /**
   * ```txt
   * Expires: <http-date>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Expires
   */
  Expires: "expires",
  /**
   * ```txt
   * Age: <delta-seconds>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Age
   */
  Age: "age",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state Contains a string of ASCII characters that can be used as ETag for
   * `If-Match` header Provided by user using `cache.etag` value.
   *
   * ```txt
   * X-Axios-Cache-Etag: "<etag_value>"
   * ```
   */
  XAxiosCacheEtag: "x-axios-cache-etag",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state may contain `'use-cache-timestamp'` if `cache.modifiedSince` is
   * `true`, otherwise will contain a date from `cache.modifiedSince`. If a date is
   * provided, it can be used for `If-Modified-Since` header, otherwise the cache
   * timestamp can be used for `If-Modified-Since` header.
   *
   * ```txt
   * X-Axios-Cache-Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * X-Axios-Cache-Last-Modified: use-cache-timestamp
   * ```
   */
  XAxiosCacheLastModified: "x-axios-cache-last-modified",
  /**
   * Used internally as metadata to mark the cache item able to be used if the server
   * returns an error. The stale-if-error response directive indicates that the cache can
   * reuse a stale response when any error occurs.
   *
   * ```txt
   * XAxiosCacheStaleIfError: <seconds>
   * ```
   */
  XAxiosCacheStaleIfError: "x-axios-cache-stale-if-error"
}), WIe = (e) => {
  if (!e)
    return "not enough headers";
  const t = e[er.CacheControl];
  if (t) {
    const {
      noCache: r,
      noStore: i,
      maxAge: s,
      maxStale: o,
      immutable: a,
      staleWhileRevalidate: c
    } = vQ(String(t));
    if (r || i)
      return "dont cache";
    if (a)
      return {
        cache: 1e3 * 60 * 60 * 24 * 365
      };
    if (s !== void 0) {
      const l = e[er.Age];
      return {
        cache: l ? (
          // If age is present, we must subtract it from maxAge
          (s - Number(l)) * 1e3
        ) : s * 1e3,
        // Already out of date, must be requested again
        stale: (
          // I couldn't find any documentation about who should be used, as they
          // are not meant to overlap each other. But, as we cannot request in the
          // background, as the stale-while-revalidate says, and we just increase
          // its staleTtl when its present, max-stale is being preferred over
          // stale-while-revalidate.
          o !== void 0 ? o * 1e3 : c !== void 0 ? c * 1e3 : void 0
        )
      };
    }
  }
  const n = e[er.Expires];
  if (n) {
    const r = Date.parse(String(n)) - Date.now();
    return r >= 0 ? {
      cache: r
    } : "dont cache";
  }
  return "not enough headers";
};
function ab() {
  return ab = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ab.apply(this, arguments);
}
function GIe(e) {
  return e ? (t) => e(t) || t === 304 : (t) => t >= 200 && t < 300 || t === 304;
}
function UT(e = "get", t = []) {
  return e = e.toLowerCase(), t.some((n) => n === e);
}
function qIe(e, t) {
  t.headers || (t.headers = {});
  const {
    etag: n,
    modifiedSince: r
  } = t.cache;
  if (n) {
    var i;
    const s = n === !0 ? (i = e.data) == null ? void 0 : i.headers[er.ETag] : n;
    s && (t.headers[er.IfNoneMatch] = s);
  }
  r && (t.headers[er.IfModifiedSince] = r === !0 ? (
    // If last-modified is not present, use the createdAt timestamp
    e.data.headers[er.LastModified] || new Date(e.createdAt).toUTCString()
  ) : r.toUTCString());
}
function $Ie(e, t) {
  return e.status === 304 && t ? (e.cached = !0, e.data = t.data, e.status = t.status, e.statusText = t.statusText, e.headers = ab({}, t.headers, e.headers), t) : {
    data: e.data,
    status: e.status,
    statusText: e.statusText,
    headers: e.headers
  };
}
function QIe(e) {
  const t = async (n) => {
    if (n.id = e.generateKey(n), n.cache === !1)
      return n;
    if (n.cache = ab({}, e.defaults.cache, n.cache), typeof n.cache.cachePredicate == "object" && n.cache.cachePredicate.ignoreUrls && n.url) {
      for (const h of n.cache.cachePredicate.ignoreUrls)
        if (h instanceof RegExp ? (
          // Handles stateful regexes
          // biome-ignore lint: reduces the number of checks
          (h.lastIndex = 0, h.test(n.url))
        ) : n.url.includes(h))
          return n;
    }
    if (n.cache.cacheTakeover) {
      var r, i, s, o, a, c, l, u, d;
      (s = (r = n.headers)[i = er.CacheControl]) != null || (r[i] = "no-cache"), (c = (o = n.headers)[a = er.Pragma]) != null || (o[a] = "no-cache"), (d = (l = n.headers)[u = er.Expires]) != null || (l[u] = "0");
    }
    if (!UT(n.method, n.cache.methods))
      return n;
    let f = await e.storage.get(n.id, n);
    const p = n.cache.override;
    e:
      if (f.state === "empty" || f.state === "stale" || f.state === "must-revalidate" || p) {
        if (e.waiting[n.id] && !p && (f = await e.storage.get(n.id, n), f.state !== "empty" && f.state !== "must-revalidate"))
          break e;
        return e.waiting[n.id] = VIe(), e.waiting[n.id].catch(() => {
        }), await e.storage.set(n.id, {
          state: "loading",
          previous: p ? (
            // Simply determine if the request is stale or not
            // based if it had previous data or not
            f.data ? "stale" : "empty"
          ) : (
            // Typescript doesn't know that cache.state here can only be 'empty' or 'stale'
            f.state
          ),
          data: f.data,
          // If the cache is empty and asked to override it, use the current timestamp
          createdAt: p && !f.createdAt ? Date.now() : f.createdAt
        }, n), (f.state === "stale" || f.state === "must-revalidate") && qIe(f, n), n.validateStatus = GIe(n.validateStatus), (f.state === "stale" || f.data && f.state !== "must-revalidate") && await (n.cache.hydrate == null ? void 0 : n.cache.hydrate(f)), n;
      }
    let m;
    if (f.state === "loading") {
      const h = e.waiting[n.id];
      if (!h)
        return f.data && await (n.cache.hydrate == null ? void 0 : n.cache.hydrate(f)), n;
      try {
        m = await h;
      } catch {
        return f.data && await (n.cache.hydrate == null ? void 0 : n.cache.hydrate(f)), t(n);
      }
    } else
      m = f.data;
    return n.transformResponse = void 0, n.adapter = function() {
      return Promise.resolve({
        config: n,
        data: m.data,
        headers: m.headers,
        status: m.status,
        statusText: m.statusText,
        cached: !0,
        id: n.id
      });
    }, n;
  };
  return {
    onFulfilled: t,
    apply: () => e.interceptors.request.use(t)
  };
}
async function KIe(e, t) {
  if (typeof t == "function")
    return t(e);
  const {
    statusCheck: n,
    responseMatch: r,
    containsHeaders: i
  } = t;
  if (n && !await n(e.status) || r && !await r(e))
    return !1;
  if (i)
    for (const [o, a] of Object.entries(i)) {
      var s;
      if (!await a(
        // Avoid bugs in case the header is not in lower case
        (s = e.headers[o.toLowerCase()]) != null ? s : e.headers[o]
      ))
        return !1;
    }
  return !0;
}
async function YIe(e, t, n) {
  if (typeof n == "function")
    return n(t);
  for (const [r, i] of Object.entries(n)) {
    if (i === "delete") {
      await e.remove(r, t.config);
      continue;
    }
    const s = await e.get(r, t.config);
    if (s.state === "loading")
      continue;
    const o = await i(s, t);
    if (o === "delete") {
      await e.remove(r, t.config);
      continue;
    }
    o !== "ignore" && await e.set(r, o, t.config);
  }
}
function ZIe(e) {
  const t = async (i, s) => {
    var o;
    await e.storage.remove(i, s), (o = e.waiting[i]) == null || o.reject(), delete e.waiting[i];
  }, n = async (i) => {
    var s;
    if (!(i != null && i.config))
      throw i;
    i.id = i.config.id, (s = i.cached) != null || (i.cached = !1);
    const o = i.config, a = o.cache;
    if (i.cached)
      return i;
    if (!a)
      return i.cached = !1, i;
    if (a.update && await YIe(e.storage, i, a.update), !UT(o.method, a.methods))
      return i;
    const c = await e.storage.get(i.id, o);
    if (
      // If the request interceptor had a problem or it wasn't cached
      c.state !== "loading"
    )
      return i;
    if (
      // For 'loading' values (previous: stale), this check already ran in the past.
      !c.data && !await KIe(i, a.cachePredicate)
    )
      return await t(i.id, o), i;
    for (const m of Object.keys(i.headers))
      m.startsWith("x-axios-cache") && delete i.headers[m];
    a.etag && a.etag !== !0 && (i.headers[er.XAxiosCacheEtag] = a.etag), a.modifiedSince && (i.headers[er.XAxiosCacheLastModified] = a.modifiedSince === !0 ? "use-cache-timestamp" : a.modifiedSince.toUTCString());
    let l = a.ttl || -1, u;
    if (a.interpretHeader) {
      const m = e.headerInterpreter(i.headers);
      if (m === "dont cache")
        return await t(i.id, o), i;
      m !== "not enough headers" && (typeof m == "number" ? l = m : (l = m.cache, u = m.stale));
    }
    const d = $Ie(i, c.data);
    typeof l == "function" && (l = await l(i)), a.staleIfError && (i.headers[er.XAxiosCacheStaleIfError] = String(l));
    const f = {
      state: "cached",
      ttl: l,
      staleTtl: u,
      createdAt: Date.now(),
      data: d
    }, p = e.waiting[i.id];
    return p && (p.resolve(f.data), delete e.waiting[i.id]), await e.storage.set(i.id, f, o), i;
  }, r = async (i) => {
    if (!i.isAxiosError || !i.config)
      throw i;
    const s = i.config, o = s.id, a = s.cache, c = i.response;
    if (!a || !o)
      throw i;
    if (!UT(s.method, a.methods))
      throw await t(o, s), i;
    const l = await e.storage.get(o, s);
    if (
      // This will only not be loading if the interceptor broke
      l.state !== "loading" || l.previous !== "stale"
    )
      throw await t(o, s), i;
    if (a.staleIfError) {
      const d = String(c == null ? void 0 : c.headers[er.CacheControl]), f = d && vQ(d).staleIfError, p = typeof a.staleIfError == "function" ? await a.staleIfError(c, l, i) : a.staleIfError === !0 && f ? f * 1e3 : a.staleIfError;
      if (p === !0 || // staleIfError is the number of seconds that stale is allowed to be used
      typeof p == "number" && l.createdAt + p > Date.now()) {
        var u;
        return (u = e.waiting[o]) == null || u.resolve(l.data), delete e.waiting[o], await e.storage.set(o, {
          state: "stale",
          createdAt: Date.now(),
          data: l.data
        }, s), {
          cached: !0,
          config: s,
          id: o,
          data: l.data.data,
          headers: l.data.headers,
          status: l.data.status,
          statusText: l.data.statusText
        };
      }
    }
    throw await t(o, s), i;
  };
  return {
    onFulfilled: n,
    onRejected: r,
    apply: () => e.interceptors.response.use(n, r)
  };
}
const JIe = (e) => !!e && !!e["is-storage"];
function wQ(e) {
  const t = e.data.headers;
  return er.ETag in t || er.LastModified in t || er.XAxiosCacheEtag in t || er.XAxiosCacheLastModified in t;
}
function XIe(e) {
  return String(e.data.headers[er.CacheControl]).includes("must-revalidate");
}
function tB(e) {
  return wQ(e) ? !0 : e.state === "cached" && e.staleTtl !== void 0 && // Only allow stale values after the ttl is already in the past and the staleTtl is in the future.
  // In cases that just createdAt + ttl > Date.now(), isn't enough because the staleTtl could be <= 0.
  // This logic only returns true when Date.now() is between the (createdAt + ttl) and (createdAt + ttl + staleTtl).
  // Following the example below:
  // |--createdAt--:--ttl--:---staleTtl--->
  // [        past        ][now is in here]
  Math.abs(Date.now() - (e.createdAt + e.ttl)) <= e.staleTtl;
}
function D2(e) {
  return e.ttl !== void 0 && e.createdAt + e.ttl <= Date.now();
}
function xQ({
  set: e,
  find: t,
  remove: n
}) {
  return {
    //@ts-expect-error - we don't want to expose this
    "is-storage": 1,
    set: e,
    remove: n,
    get: async (r, i) => {
      let s = await t(r, i);
      if (!s)
        return {
          state: "empty"
        };
      if (s.state === "empty" || s.state === "loading" || s.state === "must-revalidate")
        return s;
      if (s.state === "cached") {
        if (!D2(s))
          return s;
        if (!tB(s))
          return await n(r, i), {
            state: "empty"
          };
        if (s = {
          state: "stale",
          createdAt: s.createdAt,
          data: s.data,
          ttl: s.staleTtl !== void 0 ? s.staleTtl + s.ttl : void 0
        }, await e(r, s, i), XIe(s))
          return ab({}, s, {
            state: "must-revalidate"
          });
      }
      return !D2(s) || wQ(s) ? s : (await n(r, i), {
        state: "empty"
      });
    }
  };
}
function AQ(e = !1, t = !1, n = !1) {
  const r = xQ({
    set: (i, s) => {
      if (n) {
        let o = Object.keys(r.data);
        if (o.length >= n)
          for (r.cleanup(), o = Object.keys(r.data); o.length >= n; )
            delete r.data[o.shift()];
      }
      r.data[i] = // Clone the value before storing to prevent future mutations
      // from affecting cached data.
      e === "double" ? (
        /* c8 ignore next 3 */
        typeof structuredClone == "function" ? structuredClone(s) : JSON.parse(JSON.stringify(s))
      ) : s;
    },
    remove: (i) => {
      delete r.data[i];
    },
    find: (i) => {
      const s = r.data[i];
      return e && s !== void 0 ? typeof structuredClone == "function" ? structuredClone(s) : JSON.parse(JSON.stringify(s)) : s;
    }
  });
  return r.data = /* @__PURE__ */ Object.create(null), r.cleanup = () => {
    const i = Object.keys(r.data);
    let s = -1, o, a;
    for (; ++s < i.length; ) {
      if (a = i[s], o = r.data[a], o.state === "empty") {
        r.remove(a);
        continue;
      }
      o.state === "cached" && D2(o) && !tB(o) && r.remove(a);
    }
  }, t && (r.cleaner = setInterval(r.cleanup, t)), r;
}
const I9 = /^\/|\/$/g;
function ePe(e) {
  return (t) => {
    if (t.id)
      return t.id;
    const n = e(t);
    return typeof n == "string" || typeof n == "number" ? `${n}` : `${sx(n)}`;
  };
}
const tPe = ePe(({
  baseURL: e,
  url: t,
  method: n,
  params: r,
  data: i
}) => (e !== void 0 ? e = e.replace(I9, "") : e = "", t !== void 0 ? t = t.replace(I9, "") : t = "", n !== void 0 ? n = n.toLowerCase() : n = "get", {
  url: e + (e && t ? "/" : "") + t,
  params: r,
  method: n,
  data: i
}));
function nPe(e, t = {}) {
  var n, r, i, s, o, a, c, l;
  const u = e;
  if (u.defaults.cache)
    throw new Error("setupCache() should be called only once");
  if (u.storage = t.storage || AQ(), !JIe(u.storage))
    throw new Error("Use buildStorage() function");
  return u.waiting = t.waiting || {}, u.generateKey = t.generateKey || tPe, u.headerInterpreter = t.headerInterpreter || WIe, u.requestInterceptor = t.requestInterceptor || QIe(u), u.responseInterceptor = t.responseInterceptor || ZIe(u), u.debug = t.debug || function() {
  }, u.defaults.cache = {
    update: t.update || {},
    ttl: (n = t.ttl) != null ? n : 1e3 * 60 * 5,
    // Although RFC 7231 also marks POST as cacheable, most users don't know that
    // and may have problems about why their "create X" route not working.
    methods: t.methods || ["get", "head"],
    cachePredicate: t.cachePredicate || {
      // All cacheable status codes defined in RFC 7231
      statusCheck: (d) => [200, 203, 300, 301, 302, 404, 405, 410, 414, 501].includes(d)
    },
    etag: (r = t.etag) != null ? r : !0,
    // This option is going to be ignored by servers when ETag is enabled
    // Checks strict equality to false to avoid undefined-ish values
    modifiedSince: (i = t.modifiedSince) != null ? i : t.etag === !1,
    interpretHeader: (s = t.interpretHeader) != null ? s : !0,
    cacheTakeover: (o = t.cacheTakeover) != null ? o : !0,
    staleIfError: (a = t.staleIfError) != null ? a : !0,
    override: (c = t.override) != null ? c : !1,
    hydrate: (l = t.hydrate) != null ? l : void 0
  }, u.requestInterceptor.apply(), u.responseInterceptor.apply(), u;
}
function rPe(e, t = "axios-cache-") {
  return xQ({
    find: (n) => {
      const r = e.getItem(t + n);
      return r ? JSON.parse(r) : void 0;
    },
    remove: (n) => {
      e.removeItem(t + n);
    },
    set: (n, r) => {
      const i = () => e.setItem(t + n, JSON.stringify(r));
      try {
        return i();
      } catch {
        const o = Object.entries(e).filter((a) => a[0].startsWith(t)).map((a) => [a[0], JSON.parse(a[1])]);
        for (const a of o)
          a[1].state === "cached" && D2(a[1]) && !tB(a[1]) && e.removeItem(a[0]);
        try {
          return i();
        } catch {
          const c = o.sort((l, u) => (l[1].createdAt || 0) - (u[1].createdAt || 0));
          for (const l of c) {
            e.removeItem(l[0]);
            try {
              return i();
            } catch {
            }
          }
        }
        e.removeItem(t + n);
      }
    }
  });
}
const iPe = "6.12.1";
function sPe(e, t, n) {
  const r = t.split("|").map((s) => s.trim());
  for (let s = 0; s < r.length; s++)
    switch (t) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof e === t)
          return;
    }
  const i = new Error(`invalid value for type ${t}`);
  throw i.code = "INVALID_ARGUMENT", i.argument = `value.${n}`, i.value = e, i;
}
async function ri(e) {
  const t = Object.keys(e);
  return (await Promise.all(t.map((r) => Promise.resolve(e[r])))).reduce((r, i, s) => (r[t[s]] = i, r), {});
}
function ft(e, t, n) {
  for (let r in t) {
    let i = t[r];
    const s = n ? n[r] : null;
    s && sPe(i, s, r), Object.defineProperty(e, r, { enumerable: !0, value: i, writable: !1 });
  }
}
function Ih(e) {
  if (e == null)
    return "null";
  if (Array.isArray(e))
    return "[ " + e.map(Ih).join(", ") + " ]";
  if (e instanceof Uint8Array) {
    const t = "0123456789abcdef";
    let n = "0x";
    for (let r = 0; r < e.length; r++)
      n += t[e[r] >> 4], n += t[e[r] & 15];
    return n;
  }
  if (typeof e == "object" && typeof e.toJSON == "function")
    return Ih(e.toJSON());
  switch (typeof e) {
    case "boolean":
    case "symbol":
      return e.toString();
    case "bigint":
      return BigInt(e).toString();
    case "number":
      return e.toString();
    case "string":
      return JSON.stringify(e);
    case "object": {
      const t = Object.keys(e);
      return t.sort(), "{ " + t.map((n) => `${Ih(n)}: ${Ih(e[n])}`).join(", ") + " }";
    }
  }
  return "[ COULD NOT SERIALIZE ]";
}
function Wr(e, t) {
  return e && e.code === t;
}
function nB(e) {
  return Wr(e, "CALL_EXCEPTION");
}
function qn(e, t, n) {
  let r = e;
  {
    const s = [];
    if (n) {
      if ("message" in n || "code" in n || "name" in n)
        throw new Error(`value will overwrite populated values: ${Ih(n)}`);
      for (const o in n) {
        if (o === "shortMessage")
          continue;
        const a = n[o];
        s.push(o + "=" + Ih(a));
      }
    }
    s.push(`code=${t}`), s.push(`version=${iPe}`), s.length && (e += " (" + s.join(", ") + ")");
  }
  let i;
  switch (t) {
    case "INVALID_ARGUMENT":
      i = new TypeError(e);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      i = new RangeError(e);
      break;
    default:
      i = new Error(e);
  }
  return ft(i, { code: t }), n && Object.assign(i, n), i.shortMessage == null && ft(i, { shortMessage: r }), i;
}
function Pe(e, t, n, r) {
  if (!e)
    throw qn(t, n, r);
}
function de(e, t, n, r) {
  Pe(e, t, "INVALID_ARGUMENT", { argument: n, value: r });
}
function EQ(e, t, n) {
  n == null && (n = ""), n && (n = ": " + n), Pe(e >= t, "missing arguemnt" + n, "MISSING_ARGUMENT", {
    count: e,
    expectedCount: t
  }), Pe(e <= t, "too many arguments" + n, "UNEXPECTED_ARGUMENT", {
    count: e,
    expectedCount: t
  });
}
["NFD", "NFC", "NFKD", "NFKC"].reduce((e, t) => {
  try {
    if ("test".normalize(t) !== "test")
      throw new Error("bad");
    if (t === "NFD" && "é".normalize("NFD") !== "é")
      throw new Error("broken");
    e.push(t);
  } catch {
  }
  return e;
}, []);
function QE(e, t, n) {
  if (n == null && (n = ""), e !== t) {
    let r = n, i = "new";
    n && (r += ".", i += " " + n), Pe(!1, `private constructor; use ${r}from* methods`, "UNSUPPORTED_OPERATION", {
      operation: i
    });
  }
}
function _Q(e, t, n) {
  if (e instanceof Uint8Array)
    return n ? new Uint8Array(e) : e;
  if (typeof e == "string" && e.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
    const r = new Uint8Array((e.length - 2) / 2);
    let i = 2;
    for (let s = 0; s < r.length; s++)
      r[s] = parseInt(e.substring(i, i + 2), 16), i += 2;
    return r;
  }
  de(!1, "invalid BytesLike value", t || "value", e);
}
function Ht(e, t) {
  return _Q(e, t, !1);
}
function si(e, t) {
  return _Q(e, t, !0);
}
function mn(e, t) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/) || typeof t == "number" && e.length !== 2 + 2 * t || t === !0 && e.length % 2 !== 0);
}
function rB(e) {
  return mn(e, !0) || e instanceof Uint8Array;
}
const P9 = "0123456789abcdef";
function Je(e) {
  const t = Ht(e);
  let n = "0x";
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    n += P9[(i & 240) >> 4] + P9[i & 15];
  }
  return n;
}
function Vn(e) {
  return "0x" + e.map((t) => Je(t).substring(2)).join("");
}
function Jh(e) {
  return mn(e, !0) ? (e.length - 2) / 2 : Ht(e).length;
}
function Pn(e, t, n) {
  const r = Ht(e);
  return n != null && n > r.length && Pe(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
    buffer: r,
    length: r.length,
    offset: n
  }), Je(r.slice(t ?? 0, n ?? r.length));
}
function SQ(e, t, n) {
  const r = Ht(e);
  Pe(t >= r.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array(r),
    length: t,
    offset: t + 1
  });
  const i = new Uint8Array(t);
  return i.fill(0), n ? i.set(r, t - r.length) : i.set(r, 0), Je(i);
}
function bf(e, t) {
  return SQ(e, t, !0);
}
function oPe(e, t) {
  return SQ(e, t, !1);
}
const KE = BigInt(0), so = BigInt(1), Ph = 9007199254740991;
function aPe(e, t) {
  const n = YE(e, "value"), r = BigInt(Ot(t, "width"));
  if (Pe(n >> r === KE, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: e
  }), n >> r - so) {
    const i = (so << r) - so;
    return -((~n & i) + so);
  }
  return n;
}
function CQ(e, t) {
  let n = nt(e, "value");
  const r = BigInt(Ot(t, "width")), i = so << r - so;
  if (n < KE) {
    n = -n, Pe(n <= i, "too low", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: e
    });
    const s = (so << r) - so;
    return (~n & s) + so;
  } else
    Pe(n < i, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: e
    });
  return n;
}
function rg(e, t) {
  const n = YE(e, "value"), r = BigInt(Ot(t, "bits"));
  return n & (so << r) - so;
}
function nt(e, t) {
  switch (typeof e) {
    case "bigint":
      return e;
    case "number":
      return de(Number.isInteger(e), "underflow", t || "value", e), de(e >= -Ph && e <= Ph, "overflow", t || "value", e), BigInt(e);
    case "string":
      try {
        if (e === "")
          throw new Error("empty string");
        return e[0] === "-" && e[1] !== "-" ? -BigInt(e.substring(1)) : BigInt(e);
      } catch (n) {
        de(!1, `invalid BigNumberish string: ${n.message}`, t || "value", e);
      }
  }
  de(!1, "invalid BigNumberish value", t || "value", e);
}
function YE(e, t) {
  const n = nt(e, t);
  return Pe(n >= KE, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value: e
  }), n;
}
const O9 = "0123456789abcdef";
function iB(e) {
  if (e instanceof Uint8Array) {
    let t = "0x0";
    for (const n of e)
      t += O9[n >> 4], t += O9[n & 15];
    return BigInt(t);
  }
  return nt(e);
}
function Ot(e, t) {
  switch (typeof e) {
    case "bigint":
      return de(e >= -Ph && e <= Ph, "overflow", t || "value", e), Number(e);
    case "number":
      return de(Number.isInteger(e), "underflow", t || "value", e), de(e >= -Ph && e <= Ph, "overflow", t || "value", e), e;
    case "string":
      try {
        if (e === "")
          throw new Error("empty string");
        return Ot(BigInt(e), t);
      } catch (n) {
        de(!1, `invalid numeric string: ${n.message}`, t || "value", e);
      }
  }
  de(!1, "invalid numeric value", t || "value", e);
}
function cPe(e) {
  return Ot(iB(e));
}
function hu(e, t) {
  let r = YE(e, "value").toString(16);
  if (t == null)
    r.length % 2 && (r = "0" + r);
  else {
    const i = Ot(t, "width");
    for (Pe(i * 2 >= r.length, `value exceeds width (${i} bytes)`, "NUMERIC_FAULT", {
      operation: "toBeHex",
      fault: "overflow",
      value: e
    }); r.length < i * 2; )
      r = "0" + r;
  }
  return "0x" + r;
}
function ci(e) {
  const t = YE(e, "value");
  if (t === KE)
    return new Uint8Array([]);
  let n = t.toString(16);
  n.length % 2 && (n = "0" + n);
  const r = new Uint8Array(n.length / 2);
  for (let i = 0; i < r.length; i++) {
    const s = i * 2;
    r[i] = parseInt(n.substring(s, s + 2), 16);
  }
  return r;
}
function Oh(e) {
  let t = Je(rB(e) ? e : ci(e)).substring(2);
  for (; t.startsWith("0"); )
    t = t.substring(1);
  return t === "" && (t = "0"), "0x" + t;
}
const N9 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
BigInt(0);
const R9 = BigInt(58);
function lPe(e) {
  const t = Ht(e);
  let n = iB(t), r = "";
  for (; n; )
    r = N9[Number(n % R9)] + r, n /= R9;
  for (let i = 0; i < t.length && !t[i]; i++)
    r = N9[0] + r;
  return r;
}
function uPe(e) {
  e = atob(e);
  const t = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    t[n] = e.charCodeAt(n);
  return Ht(t);
}
function dPe(e) {
  const t = Ht(e);
  let n = "";
  for (let r = 0; r < t.length; r++)
    n += String.fromCharCode(t[r]);
  return btoa(n);
}
var gp;
class TQ {
  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  constructor(t, n, r) {
    /**
     *  The event filter.
     */
    pe(this, "filter");
    /**
     *  The **EventEmitterable**.
     */
    pe(this, "emitter");
    re(this, gp, void 0);
    j(this, gp, n), ft(this, { emitter: t, filter: r });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  async removeListener() {
    C(this, gp) != null && await this.emitter.off(this.filter, C(this, gp));
  }
}
gp = new WeakMap();
function fPe(e, t, n, r, i) {
  de(!1, `invalid codepoint at offset ${t}; ${e}`, "bytes", n);
}
function kQ(e, t, n, r, i) {
  if (e === "BAD_PREFIX" || e === "UNEXPECTED_CONTINUE") {
    let s = 0;
    for (let o = t + 1; o < n.length && n[o] >> 6 === 2; o++)
      s++;
    return s;
  }
  return e === "OVERRUN" ? n.length - t - 1 : 0;
}
function hPe(e, t, n, r, i) {
  return e === "OVERLONG" ? (de(typeof i == "number", "invalid bad code point for replacement", "badCodepoint", i), r.push(i), 0) : (r.push(65533), kQ(e, t, n));
}
const pPe = Object.freeze({
  error: fPe,
  ignore: kQ,
  replace: hPe
});
function mPe(e, t) {
  t == null && (t = pPe.error);
  const n = Ht(e, "bytes"), r = [];
  let i = 0;
  for (; i < n.length; ) {
    const s = n[i++];
    if (!(s >> 7)) {
      r.push(s);
      continue;
    }
    let o = null, a = null;
    if ((s & 224) === 192)
      o = 1, a = 127;
    else if ((s & 240) === 224)
      o = 2, a = 2047;
    else if ((s & 248) === 240)
      o = 3, a = 65535;
    else {
      (s & 192) === 128 ? i += t("UNEXPECTED_CONTINUE", i - 1, n, r) : i += t("BAD_PREFIX", i - 1, n, r);
      continue;
    }
    if (i - 1 + o >= n.length) {
      i += t("OVERRUN", i - 1, n, r);
      continue;
    }
    let c = s & (1 << 8 - o - 1) - 1;
    for (let l = 0; l < o; l++) {
      let u = n[i];
      if ((u & 192) != 128) {
        i += t("MISSING_CONTINUE", i, n, r), c = null;
        break;
      }
      c = c << 6 | u & 63, i++;
    }
    if (c !== null) {
      if (c > 1114111) {
        i += t("OUT_OF_RANGE", i - 1 - o, n, r, c);
        continue;
      }
      if (c >= 55296 && c <= 57343) {
        i += t("UTF16_SURROGATE", i - 1 - o, n, r, c);
        continue;
      }
      if (c <= a) {
        i += t("OVERLONG", i - 1 - o, n, r, c);
        continue;
      }
      r.push(c);
    }
  }
  return r;
}
function yc(e, t) {
  de(typeof e == "string", "invalid string value", "str", e);
  let n = [];
  for (let r = 0; r < e.length; r++) {
    const i = e.charCodeAt(r);
    if (i < 128)
      n.push(i);
    else if (i < 2048)
      n.push(i >> 6 | 192), n.push(i & 63 | 128);
    else if ((i & 64512) == 55296) {
      r++;
      const s = e.charCodeAt(r);
      de(r < e.length && (s & 64512) === 56320, "invalid surrogate pair", "str", e);
      const o = 65536 + ((i & 1023) << 10) + (s & 1023);
      n.push(o >> 18 | 240), n.push(o >> 12 & 63 | 128), n.push(o >> 6 & 63 | 128), n.push(o & 63 | 128);
    } else
      n.push(i >> 12 | 224), n.push(i >> 6 & 63 | 128), n.push(i & 63 | 128);
  }
  return new Uint8Array(n);
}
function gPe(e) {
  return e.map((t) => t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10 & 1023) + 55296, (t & 1023) + 56320))).join("");
}
function U2(e, t) {
  return gPe(mPe(e, t));
}
function BQ(e) {
  async function t(n, r) {
    const i = n.url.split(":")[0].toLowerCase();
    Pe(i === "http" || i === "https", `unsupported protocol ${i}`, "UNSUPPORTED_OPERATION", {
      info: { protocol: i },
      operation: "request"
    }), Pe(i === "https" || !n.credentials || n.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
      operation: "request"
    });
    let s;
    if (r) {
      const d = new AbortController();
      s = d.signal, r.addListener(() => {
        d.abort();
      });
    }
    const o = {
      method: n.method,
      headers: new Headers(Array.from(n)),
      body: n.body || void 0,
      signal: s
    }, a = await fetch(n.url, o), c = {};
    a.headers.forEach((d, f) => {
      c[f.toLowerCase()] = d;
    });
    const l = await a.arrayBuffer(), u = l == null ? null : new Uint8Array(l);
    return {
      statusCode: a.status,
      statusMessage: a.statusText,
      headers: c,
      body: u
    };
  }
  return t;
}
const yPe = 12, bPe = 250;
let M9 = BQ();
const vPe = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), wPe = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
let E6 = !1;
async function IQ(e, t) {
  try {
    const n = e.match(vPe);
    if (!n)
      throw new Error("invalid data");
    return new Ql(200, "OK", {
      "content-type": n[1] || "text/plain"
    }, n[2] ? uPe(n[3]) : APe(n[3]));
  } catch {
    return new Ql(599, "BAD REQUEST (invalid data: URI)", {}, null, new pu(e));
  }
}
function PQ(e) {
  async function t(n, r) {
    try {
      const i = n.match(wPe);
      if (!i)
        throw new Error("invalid link");
      return new pu(`${e}${i[2]}`);
    } catch {
      return new Ql(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new pu(n));
    }
  }
  return t;
}
const Z1 = {
  data: IQ,
  ipfs: PQ("https://gateway.ipfs.io/ipfs/")
}, OQ = /* @__PURE__ */ new WeakMap();
var md, wl;
class xPe {
  constructor(t) {
    re(this, md, void 0);
    re(this, wl, void 0);
    j(this, md, []), j(this, wl, !1), OQ.set(t, () => {
      if (!C(this, wl)) {
        j(this, wl, !0);
        for (const n of C(this, md))
          setTimeout(() => {
            n();
          }, 0);
        j(this, md, []);
      }
    });
  }
  addListener(t) {
    Pe(!C(this, wl), "singal already cancelled", "UNSUPPORTED_OPERATION", {
      operation: "fetchCancelSignal.addCancelListener"
    }), C(this, md).push(t);
  }
  get cancelled() {
    return C(this, wl);
  }
  checkSignal() {
    Pe(!this.cancelled, "cancelled", "CANCELLED", {});
  }
}
md = new WeakMap(), wl = new WeakMap();
function J1(e) {
  if (e == null)
    throw new Error("missing signal; should not happen");
  return e.checkSignal(), e;
}
var yp, bp, Zs, Va, vp, wp, lr, Wi, Ha, gd, yd, bd, qo, Js, xl, vd, ig;
const pA = class pA {
  /**
   *  Create a new FetchRequest instance with default values.
   *
   *  Once created, each property may be set before issuing a
   *  ``.send()`` to make the request.
   */
  constructor(t) {
    re(this, vd);
    re(this, yp, void 0);
    re(this, bp, void 0);
    re(this, Zs, void 0);
    re(this, Va, void 0);
    re(this, vp, void 0);
    re(this, wp, void 0);
    re(this, lr, void 0);
    re(this, Wi, void 0);
    re(this, Ha, void 0);
    // Hooks
    re(this, gd, void 0);
    re(this, yd, void 0);
    re(this, bd, void 0);
    re(this, qo, void 0);
    re(this, Js, void 0);
    re(this, xl, void 0);
    j(this, wp, String(t)), j(this, yp, !1), j(this, bp, !0), j(this, Zs, {}), j(this, Va, ""), j(this, vp, 3e5), j(this, Js, {
      slotInterval: bPe,
      maxAttempts: yPe
    }), j(this, xl, null);
  }
  /**
   *  The fetch URL to request.
   */
  get url() {
    return C(this, wp);
  }
  set url(t) {
    j(this, wp, String(t));
  }
  /**
   *  The fetch body, if any, to send as the request body. //(default: null)//
   *
   *  When setting a body, the intrinsic ``Content-Type`` is automatically
   *  set and will be used if **not overridden** by setting a custom
   *  header.
   *
   *  If %%body%% is null, the body is cleared (along with the
   *  intrinsic ``Content-Type``).
   *
   *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
   *  ``text/plain``.
   *
   *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
   *  ``application/octet-stream``.
   *
   *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
   *  set to ``application/json``.
   */
  get body() {
    return C(this, lr) == null ? null : new Uint8Array(C(this, lr));
  }
  set body(t) {
    if (t == null)
      j(this, lr, void 0), j(this, Wi, void 0);
    else if (typeof t == "string")
      j(this, lr, yc(t)), j(this, Wi, "text/plain");
    else if (t instanceof Uint8Array)
      j(this, lr, t), j(this, Wi, "application/octet-stream");
    else if (typeof t == "object")
      j(this, lr, yc(JSON.stringify(t))), j(this, Wi, "application/json");
    else
      throw new Error("invalid body");
  }
  /**
   *  Returns true if the request has a body.
   */
  hasBody() {
    return C(this, lr) != null;
  }
  /**
   *  The HTTP method to use when requesting the URI. If no method
   *  has been explicitly set, then ``GET`` is used if the body is
   *  null and ``POST`` otherwise.
   */
  get method() {
    return C(this, Va) ? C(this, Va) : this.hasBody() ? "POST" : "GET";
  }
  set method(t) {
    t == null && (t = ""), j(this, Va, String(t).toUpperCase());
  }
  /**
   *  The headers that will be used when requesting the URI. All
   *  keys are lower-case.
   *
   *  This object is a copy, so any changes will **NOT** be reflected
   *  in the ``FetchRequest``.
   *
   *  To set a header entry, use the ``setHeader`` method.
   */
  get headers() {
    const t = Object.assign({}, C(this, Zs));
    return C(this, Ha) && (t.authorization = `Basic ${dPe(yc(C(this, Ha)))}`), this.allowGzip && (t["accept-encoding"] = "gzip"), t["content-type"] == null && C(this, Wi) && (t["content-type"] = C(this, Wi)), this.body && (t["content-length"] = String(this.body.length)), t;
  }
  /**
   *  Get the header for %%key%%, ignoring case.
   */
  getHeader(t) {
    return this.headers[t.toLowerCase()];
  }
  /**
   *  Set the header for %%key%% to %%value%%. All values are coerced
   *  to a string.
   */
  setHeader(t, n) {
    C(this, Zs)[String(t).toLowerCase()] = String(n);
  }
  /**
   *  Clear all headers, resetting all intrinsic headers.
   */
  clearHeaders() {
    j(this, Zs, {});
  }
  [Symbol.iterator]() {
    const t = this.headers, n = Object.keys(t);
    let r = 0;
    return {
      next: () => {
        if (r < n.length) {
          const i = n[r++];
          return {
            value: [i, t[i]],
            done: !1
          };
        }
        return { value: void 0, done: !0 };
      }
    };
  }
  /**
   *  The value that will be sent for the ``Authorization`` header.
   *
   *  To set the credentials, use the ``setCredentials`` method.
   */
  get credentials() {
    return C(this, Ha) || null;
  }
  /**
   *  Sets an ``Authorization`` for %%username%% with %%password%%.
   */
  setCredentials(t, n) {
    de(!t.match(/:/), "invalid basic authentication username", "username", "[REDACTED]"), j(this, Ha, `${t}:${n}`);
  }
  /**
   *  Enable and request gzip-encoded responses. The response will
   *  automatically be decompressed. //(default: true)//
   */
  get allowGzip() {
    return C(this, bp);
  }
  set allowGzip(t) {
    j(this, bp, !!t);
  }
  /**
   *  Allow ``Authentication`` credentials to be sent over insecure
   *  channels. //(default: false)//
   */
  get allowInsecureAuthentication() {
    return !!C(this, yp);
  }
  set allowInsecureAuthentication(t) {
    j(this, yp, !!t);
  }
  /**
   *  The timeout (in milliseconds) to wait for a complete response.
   *  //(default: 5 minutes)//
   */
  get timeout() {
    return C(this, vp);
  }
  set timeout(t) {
    de(t >= 0, "timeout must be non-zero", "timeout", t), j(this, vp, t);
  }
  /**
   *  This function is called prior to each request, for example
   *  during a redirection or retry in case of server throttling.
   *
   *  This offers an opportunity to populate headers or update
   *  content before sending a request.
   */
  get preflightFunc() {
    return C(this, gd) || null;
  }
  set preflightFunc(t) {
    j(this, gd, t);
  }
  /**
   *  This function is called after each response, offering an
   *  opportunity to provide client-level throttling or updating
   *  response data.
   *
   *  Any error thrown in this causes the ``send()`` to throw.
   *
   *  To schedule a retry attempt (assuming the maximum retry limit
   *  has not been reached), use [[response.throwThrottleError]].
   */
  get processFunc() {
    return C(this, yd) || null;
  }
  set processFunc(t) {
    j(this, yd, t);
  }
  /**
   *  This function is called on each retry attempt.
   */
  get retryFunc() {
    return C(this, bd) || null;
  }
  set retryFunc(t) {
    j(this, bd, t);
  }
  /**
   *  This function is called to fetch content from HTTP and
   *  HTTPS URLs and is platform specific (e.g. nodejs vs
   *  browsers).
   *
   *  This is by default the currently registered global getUrl
   *  function, which can be changed using [[registerGetUrl]].
   *  If this has been set, setting is to ``null`` will cause
   *  this FetchRequest (and any future clones) to revert back to
   *  using the currently registered global getUrl function.
   *
   *  Setting this is generally not necessary, but may be useful
   *  for developers that wish to intercept requests or to
   *  configurege a proxy or other agent.
   */
  get getUrlFunc() {
    return C(this, xl) || M9;
  }
  set getUrlFunc(t) {
    j(this, xl, t);
  }
  toString() {
    return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${C(this, lr) ? Je(C(this, lr)) : "null"}>`;
  }
  /**
   *  Update the throttle parameters used to determine maximum
   *  attempts and exponential-backoff properties.
   */
  setThrottleParams(t) {
    t.slotInterval != null && (C(this, Js).slotInterval = t.slotInterval), t.maxAttempts != null && (C(this, Js).maxAttempts = t.maxAttempts);
  }
  /**
   *  Resolves to the response by sending the request.
   */
  send() {
    return Pe(C(this, qo) == null, "request already sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.send" }), j(this, qo, new xPe(this)), Se(this, vd, ig).call(this, 0, F9() + this.timeout, 0, this, new Ql(0, "", {}, null, this));
  }
  /**
   *  Cancels the inflight response, causing a ``CANCELLED``
   *  error to be rejected from the [[send]].
   */
  cancel() {
    Pe(C(this, qo) != null, "request has not been sent", "UNSUPPORTED_OPERATION", { operation: "fetchRequest.cancel" });
    const t = OQ.get(this);
    if (!t)
      throw new Error("missing signal; should not happen");
    t();
  }
  /**
   *  Returns a new [[FetchRequest]] that represents the redirection
   *  to %%location%%.
   */
  redirect(t) {
    const n = this.url.split(":")[0].toLowerCase(), r = t.split(":")[0].toLowerCase();
    Pe(this.method === "GET" && (n !== "https" || r !== "http") && t.match(/^https?:/), "unsupported redirect", "UNSUPPORTED_OPERATION", {
      operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(t)})`
    });
    const i = new pA(t);
    return i.method = "GET", i.allowGzip = this.allowGzip, i.timeout = this.timeout, j(i, Zs, Object.assign({}, C(this, Zs))), C(this, lr) && j(i, lr, new Uint8Array(C(this, lr))), j(i, Wi, C(this, Wi)), i;
  }
  /**
   *  Create a new copy of this request.
   */
  clone() {
    const t = new pA(this.url);
    return j(t, Va, C(this, Va)), C(this, lr) && j(t, lr, C(this, lr)), j(t, Wi, C(this, Wi)), j(t, Zs, Object.assign({}, C(this, Zs))), j(t, Ha, C(this, Ha)), this.allowGzip && (t.allowGzip = !0), t.timeout = this.timeout, this.allowInsecureAuthentication && (t.allowInsecureAuthentication = !0), j(t, gd, C(this, gd)), j(t, yd, C(this, yd)), j(t, bd, C(this, bd)), j(t, Js, Object.assign({}, C(this, Js))), j(t, xl, C(this, xl)), t;
  }
  /**
   *  Locks all static configuration for gateways and FetchGetUrlFunc
   *  registration.
   */
  static lockConfig() {
    E6 = !0;
  }
  /**
   *  Get the current Gateway function for %%scheme%%.
   */
  static getGateway(t) {
    return Z1[t.toLowerCase()] || null;
  }
  /**
   *  Use the %%func%% when fetching URIs using %%scheme%%.
   *
   *  This method affects all requests globally.
   *
   *  If [[lockConfig]] has been called, no change is made and this
   *  throws.
   */
  static registerGateway(t, n) {
    if (t = t.toLowerCase(), t === "http" || t === "https")
      throw new Error(`cannot intercept ${t}; use registerGetUrl`);
    if (E6)
      throw new Error("gateways locked");
    Z1[t] = n;
  }
  /**
   *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
   *
   *  This method affects all requests globally.
   *
   *  If [[lockConfig]] has been called, no change is made and this
   *  throws.
   */
  static registerGetUrl(t) {
    if (E6)
      throw new Error("gateways locked");
    M9 = t;
  }
  /**
   *  Creates a getUrl function that fetches content from HTTP and
   *  HTTPS URLs.
   *
   *  The available %%options%% are dependent on the platform
   *  implementation of the default getUrl function.
   *
   *  This is not generally something that is needed, but is useful
   *  when trying to customize simple behaviour when fetching HTTP
   *  content.
   */
  static createGetUrlFunc(t) {
    return BQ();
  }
  /**
   *  Creates a function that can "fetch" data URIs.
   *
   *  Note that this is automatically done internally to support
   *  data URIs, so it is not necessary to register it.
   *
   *  This is not generally something that is needed, but may
   *  be useful in a wrapper to perfom custom data URI functionality.
   */
  static createDataGateway() {
    return IQ;
  }
  /**
   *  Creates a function that will fetch IPFS (unvalidated) from
   *  a custom gateway baseUrl.
   *
   *  The default IPFS gateway used internally is
   *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
   */
  static createIpfsGatewayFunc(t) {
    return PQ(t);
  }
};
yp = new WeakMap(), bp = new WeakMap(), Zs = new WeakMap(), Va = new WeakMap(), vp = new WeakMap(), wp = new WeakMap(), lr = new WeakMap(), Wi = new WeakMap(), Ha = new WeakMap(), gd = new WeakMap(), yd = new WeakMap(), bd = new WeakMap(), qo = new WeakMap(), Js = new WeakMap(), xl = new WeakMap(), vd = new WeakSet(), ig = async function(t, n, r, i, s) {
  var u, d, f;
  if (t >= C(this, Js).maxAttempts)
    return s.makeServerError("exceeded maximum retry limit");
  Pe(F9() <= n, "timeout", "TIMEOUT", {
    operation: "request.send",
    reason: "timeout",
    request: i
  }), r > 0 && await EPe(r);
  let o = this.clone();
  const a = (o.url.split(":")[0] || "").toLowerCase();
  if (a in Z1) {
    const p = await Z1[a](o.url, J1(C(i, qo)));
    if (p instanceof Ql) {
      let m = p;
      if (this.processFunc) {
        J1(C(i, qo));
        try {
          m = await this.processFunc(o, m);
        } catch (h) {
          (h.throttle == null || typeof h.stall != "number") && m.makeServerError("error in post-processing function", h).assertOk();
        }
      }
      return m;
    }
    o = p;
  }
  this.preflightFunc && (o = await this.preflightFunc(o));
  const c = await this.getUrlFunc(o, J1(C(i, qo)));
  let l = new Ql(c.statusCode, c.statusMessage, c.headers, c.body, i);
  if (l.statusCode === 301 || l.statusCode === 302) {
    try {
      const p = l.headers.location || "";
      return Se(u = o.redirect(p), vd, ig).call(u, t + 1, n, 0, i, l);
    } catch {
    }
    return l;
  } else if (l.statusCode === 429 && (this.retryFunc == null || await this.retryFunc(o, l, t))) {
    const p = l.headers["retry-after"];
    let m = C(this, Js).slotInterval * Math.trunc(Math.random() * Math.pow(2, t));
    return typeof p == "string" && p.match(/^[1-9][0-9]*$/) && (m = parseInt(p)), Se(d = o.clone(), vd, ig).call(d, t + 1, n, m, i, l);
  }
  if (this.processFunc) {
    J1(C(i, qo));
    try {
      l = await this.processFunc(o, l);
    } catch (p) {
      (p.throttle == null || typeof p.stall != "number") && l.makeServerError("error in post-processing function", p).assertOk();
      let m = C(this, Js).slotInterval * Math.trunc(Math.random() * Math.pow(2, t));
      return p.stall >= 0 && (m = p.stall), Se(f = o.clone(), vd, ig).call(f, t + 1, n, m, i, l);
    }
  }
  return l;
};
let pu = pA;
var Fb, jb, Db, Gi, xp, wd;
const BB = class BB {
  constructor(t, n, r, i, s) {
    re(this, Fb, void 0);
    re(this, jb, void 0);
    re(this, Db, void 0);
    re(this, Gi, void 0);
    re(this, xp, void 0);
    re(this, wd, void 0);
    j(this, Fb, t), j(this, jb, n), j(this, Db, Object.keys(r).reduce((o, a) => (o[a.toLowerCase()] = String(r[a]), o), {})), j(this, Gi, i == null ? null : new Uint8Array(i)), j(this, xp, s || null), j(this, wd, { message: "" });
  }
  toString() {
    return `<FetchResponse status=${this.statusCode} body=${C(this, Gi) ? Je(C(this, Gi)) : "null"}>`;
  }
  /**
   *  The response status code.
   */
  get statusCode() {
    return C(this, Fb);
  }
  /**
   *  The response status message.
   */
  get statusMessage() {
    return C(this, jb);
  }
  /**
   *  The response headers. All keys are lower-case.
   */
  get headers() {
    return Object.assign({}, C(this, Db));
  }
  /**
   *  The response body, or ``null`` if there was no body.
   */
  get body() {
    return C(this, Gi) == null ? null : new Uint8Array(C(this, Gi));
  }
  /**
   *  The response body as a UTF-8 encoded string, or the empty
   *  string (i.e. ``""``) if there was no body.
   *
   *  An error is thrown if the body is invalid UTF-8 data.
   */
  get bodyText() {
    try {
      return C(this, Gi) == null ? "" : U2(C(this, Gi));
    } catch {
      Pe(!1, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
        operation: "bodyText",
        info: { response: this }
      });
    }
  }
  /**
   *  The response body, decoded as JSON.
   *
   *  An error is thrown if the body is invalid JSON-encoded data
   *  or if there was no body.
   */
  get bodyJson() {
    try {
      return JSON.parse(this.bodyText);
    } catch {
      Pe(!1, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
        operation: "bodyJson",
        info: { response: this }
      });
    }
  }
  [Symbol.iterator]() {
    const t = this.headers, n = Object.keys(t);
    let r = 0;
    return {
      next: () => {
        if (r < n.length) {
          const i = n[r++];
          return {
            value: [i, t[i]],
            done: !1
          };
        }
        return { value: void 0, done: !0 };
      }
    };
  }
  /**
   *  Return a Response with matching headers and body, but with
   *  an error status code (i.e. 599) and %%message%% with an
   *  optional %%error%%.
   */
  makeServerError(t, n) {
    let r;
    t ? r = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${t})` : (t = `${this.statusCode} ${this.statusMessage}`, r = `CLIENT ESCALATED SERVER ERROR (${t})`);
    const i = new BB(599, r, this.headers, this.body, C(this, xp) || void 0);
    return j(i, wd, { message: t, error: n }), i;
  }
  /**
   *  If called within a [request.processFunc](FetchRequest-processFunc)
   *  call, causes the request to retry as if throttled for %%stall%%
   *  milliseconds.
   */
  throwThrottleError(t, n) {
    n == null ? n = -1 : de(Number.isInteger(n) && n >= 0, "invalid stall timeout", "stall", n);
    const r = new Error(t || "throttling requests");
    throw ft(r, { stall: n, throttle: !0 }), r;
  }
  /**
   *  Get the header value for %%key%%, ignoring case.
   */
  getHeader(t) {
    return this.headers[t.toLowerCase()];
  }
  /**
   *  Returns true if the response has a body.
   */
  hasBody() {
    return C(this, Gi) != null;
  }
  /**
   *  The request made for this response.
   */
  get request() {
    return C(this, xp);
  }
  /**
   *  Returns true if this response was a success statusCode.
   */
  ok() {
    return C(this, wd).message === "" && this.statusCode >= 200 && this.statusCode < 300;
  }
  /**
   *  Throws a ``SERVER_ERROR`` if this response is not ok.
   */
  assertOk() {
    if (this.ok())
      return;
    let { message: t, error: n } = C(this, wd);
    t === "" && (t = `server response ${this.statusCode} ${this.statusMessage}`);
    let r = null;
    this.request && (r = this.request.url);
    let i = null;
    try {
      C(this, Gi) && (i = U2(C(this, Gi)));
    } catch {
    }
    Pe(!1, t, "SERVER_ERROR", {
      request: this.request || "unknown request",
      response: this,
      error: n,
      info: {
        requestUrl: r,
        responseBody: i,
        responseStatus: `${this.statusCode} ${this.statusMessage}`
      }
    });
  }
};
Fb = new WeakMap(), jb = new WeakMap(), Db = new WeakMap(), Gi = new WeakMap(), xp = new WeakMap(), wd = new WeakMap();
let Ql = BB;
function F9() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function APe(e) {
  return yc(e.replace(/%([0-9a-f][0-9a-f])/gi, (t, n) => String.fromCharCode(parseInt(n, 16))));
}
function EPe(e) {
  return new Promise((t) => setTimeout(t, e));
}
function _Pe(e) {
  let t = e.toString(16);
  for (; t.length < 2; )
    t = "0" + t;
  return "0x" + t;
}
function j9(e, t, n) {
  let r = 0;
  for (let i = 0; i < n; i++)
    r = r * 256 + e[t + i];
  return r;
}
function D9(e, t, n, r) {
  const i = [];
  for (; n < t + 1 + r; ) {
    const s = NQ(e, n);
    i.push(s.result), n += s.consumed, Pe(n <= t + 1 + r, "child data too short", "BUFFER_OVERRUN", {
      buffer: e,
      length: r,
      offset: t
    });
  }
  return { consumed: 1 + r, result: i };
}
function NQ(e, t) {
  Pe(e.length !== 0, "data too short", "BUFFER_OVERRUN", {
    buffer: e,
    length: 0,
    offset: 1
  });
  const n = (r) => {
    Pe(r <= e.length, "data short segment too short", "BUFFER_OVERRUN", {
      buffer: e,
      length: e.length,
      offset: r
    });
  };
  if (e[t] >= 248) {
    const r = e[t] - 247;
    n(t + 1 + r);
    const i = j9(e, t + 1, r);
    return n(t + 1 + r + i), D9(e, t, t + 1 + r, r + i);
  } else if (e[t] >= 192) {
    const r = e[t] - 192;
    return n(t + 1 + r), D9(e, t, t + 1, r);
  } else if (e[t] >= 184) {
    const r = e[t] - 183;
    n(t + 1 + r);
    const i = j9(e, t + 1, r);
    n(t + 1 + r + i);
    const s = Je(e.slice(t + 1 + r, t + 1 + r + i));
    return { consumed: 1 + r + i, result: s };
  } else if (e[t] >= 128) {
    const r = e[t] - 128;
    n(t + 1 + r);
    const i = Je(e.slice(t + 1, t + 1 + r));
    return { consumed: 1 + r, result: i };
  }
  return { consumed: 1, result: _Pe(e[t]) };
}
function ZE(e) {
  const t = Ht(e, "data"), n = NQ(t, 0);
  return de(n.consumed === t.length, "unexpected junk after rlp payload", "data", e), n.result;
}
function U9(e) {
  const t = [];
  for (; e; )
    t.unshift(e & 255), e >>= 8;
  return t;
}
function RQ(e) {
  if (Array.isArray(e)) {
    let r = [];
    if (e.forEach(function(s) {
      r = r.concat(RQ(s));
    }), r.length <= 55)
      return r.unshift(192 + r.length), r;
    const i = U9(r.length);
    return i.unshift(247 + i.length), i.concat(r);
  }
  const t = Array.prototype.slice.call(Ht(e, "object"));
  if (t.length === 1 && t[0] <= 127)
    return t;
  if (t.length <= 55)
    return t.unshift(128 + t.length), t;
  const n = U9(t.length);
  return n.unshift(183 + n.length), n.concat(t);
}
const L9 = "0123456789abcdef";
function vf(e) {
  let t = "0x";
  for (const n of RQ(e))
    t += L9[n >> 4], t += L9[n & 15];
  return t;
}
const li = 32, LT = new Uint8Array(li), SPe = ["then"], X1 = {};
function R0(e, t) {
  const n = new Error(`deferred error during ABI decoding triggered accessing ${e}`);
  throw n.error = t, n;
}
var Al;
const qu = class qu extends Array {
  /**
   *  @private
   */
  constructor(...n) {
    const r = n[0];
    let i = n[1], s = (n[2] || []).slice(), o = !0;
    r !== X1 && (i = n, s = [], o = !1);
    super(i.length);
    re(this, Al, void 0);
    i.forEach((c, l) => {
      this[l] = c;
    });
    const a = s.reduce((c, l) => (typeof l == "string" && c.set(l, (c.get(l) || 0) + 1), c), /* @__PURE__ */ new Map());
    if (j(this, Al, Object.freeze(i.map((c, l) => {
      const u = s[l];
      return u != null && a.get(u) === 1 ? u : null;
    }))), !!o)
      return Object.freeze(this), new Proxy(this, {
        get: (c, l, u) => {
          if (typeof l == "string") {
            if (l.match(/^[0-9]+$/)) {
              const f = Ot(l, "%index");
              if (f < 0 || f >= this.length)
                throw new RangeError("out of result range");
              const p = c[f];
              return p instanceof Error && R0(`index ${f}`, p), p;
            }
            if (SPe.indexOf(l) >= 0)
              return Reflect.get(c, l, u);
            const d = c[l];
            if (d instanceof Function)
              return function(...f) {
                return d.apply(this === u ? c : this, f);
              };
            if (!(l in c))
              return c.getValue.apply(this === u ? c : this, [l]);
          }
          return Reflect.get(c, l, u);
        }
      });
  }
  /**
   *  Returns the Result as a normal Array. If %%deep%%, any children
   *  which are Result objects are also converted to a normal Array.
   *
   *  This will throw if there are any outstanding deferred
   *  errors.
   */
  toArray(n) {
    const r = [];
    return this.forEach((i, s) => {
      i instanceof Error && R0(`index ${s}`, i), n && i instanceof qu && (i = i.toArray(n)), r.push(i);
    }), r;
  }
  /**
   *  Returns the Result as an Object with each name-value pair. If
   *  %%deep%%, any children which are Result objects are also
   *  converted to an Object.
   *
   *  This will throw if any value is unnamed, or if there are
   *  any outstanding deferred errors.
   */
  toObject(n) {
    return C(this, Al).reduce((r, i, s) => {
      if (Pe(i != null, "value at index ${ index } unnamed", "UNSUPPORTED_OPERATION", {
        operation: "toObject()"
      }), !(i in r)) {
        let o = this.getValue(i);
        n && o instanceof qu && (o = o.toObject(n)), r[i] = o;
      }
      return r;
    }, {});
  }
  /**
   *  @_ignore
   */
  slice(n, r) {
    n == null && (n = 0), n < 0 && (n += this.length, n < 0 && (n = 0)), r == null && (r = this.length), r < 0 && (r += this.length, r < 0 && (r = 0)), r > this.length && (r = this.length);
    const i = [], s = [];
    for (let o = n; o < r; o++)
      i.push(this[o]), s.push(C(this, Al)[o]);
    return new qu(X1, i, s);
  }
  /**
   *  @_ignore
   */
  filter(n, r) {
    const i = [], s = [];
    for (let o = 0; o < this.length; o++) {
      const a = this[o];
      a instanceof Error && R0(`index ${o}`, a), n.call(r, a, o, this) && (i.push(a), s.push(C(this, Al)[o]));
    }
    return new qu(X1, i, s);
  }
  /**
   *  @_ignore
   */
  map(n, r) {
    const i = [];
    for (let s = 0; s < this.length; s++) {
      const o = this[s];
      o instanceof Error && R0(`index ${s}`, o), i.push(n.call(r, o, s, this));
    }
    return i;
  }
  /**
   *  Returns the value for %%name%%.
   *
   *  Since it is possible to have a key whose name conflicts with
   *  a method on a [[Result]] or its superclass Array, or any
   *  JavaScript keyword, this ensures all named values are still
   *  accessible by name.
   */
  getValue(n) {
    const r = C(this, Al).indexOf(n);
    if (r === -1)
      return;
    const i = this[r];
    return i instanceof Error && R0(`property ${JSON.stringify(n)}`, i.error), i;
  }
  /**
   *  Creates a new [[Result]] for %%items%% with each entry
   *  also accessible by its corresponding name in %%keys%%.
   */
  static fromItems(n, r) {
    return new qu(X1, n, r);
  }
};
Al = new WeakMap();
let L2 = qu;
function z9(e) {
  let t = ci(e);
  return Pe(t.length <= li, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: t, length: li, offset: t.length }), t.length !== li && (t = si(Vn([LT.slice(t.length % li), t]))), t;
}
class Oc {
  constructor(t, n, r, i) {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    pe(this, "name");
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    pe(this, "type");
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    pe(this, "localName");
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    pe(this, "dynamic");
    ft(this, { name: t, type: n, localName: r, dynamic: i }, {
      name: "string",
      type: "string",
      localName: "string",
      dynamic: "boolean"
    });
  }
  _throwError(t, n) {
    de(!1, t, this.localName, n);
  }
}
var Wa, xd, Ap, ox;
class zT {
  constructor() {
    re(this, Ap);
    // An array of WordSize lengthed objects to concatenation
    re(this, Wa, void 0);
    re(this, xd, void 0);
    j(this, Wa, []), j(this, xd, 0);
  }
  get data() {
    return Vn(C(this, Wa));
  }
  get length() {
    return C(this, xd);
  }
  appendWriter(t) {
    return Se(this, Ap, ox).call(this, si(t.data));
  }
  // Arrayish item; pad on the right to *nearest* WordSize
  writeBytes(t) {
    let n = si(t);
    const r = n.length % li;
    return r && (n = si(Vn([n, LT.slice(r)]))), Se(this, Ap, ox).call(this, n);
  }
  // Numeric item; pad on the left *to* WordSize
  writeValue(t) {
    return Se(this, Ap, ox).call(this, z9(t));
  }
  // Inserts a numeric place-holder, returning a callback that can
  // be used to asjust the value later
  writeUpdatableValue() {
    const t = C(this, Wa).length;
    return C(this, Wa).push(LT), j(this, xd, C(this, xd) + li), (n) => {
      C(this, Wa)[t] = z9(n);
    };
  }
}
Wa = new WeakMap(), xd = new WeakMap(), Ap = new WeakSet(), ox = function(t) {
  return C(this, Wa).push(t), j(this, xd, C(this, xd) + t.length), t.length;
};
var wi, qi, Ad, Ed, El, Ub, HT, mA, MQ;
const IB = class IB {
  constructor(t, n, r) {
    re(this, Ub);
    re(this, mA);
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    pe(this, "allowLoose");
    re(this, wi, void 0);
    re(this, qi, void 0);
    re(this, Ad, void 0);
    re(this, Ed, void 0);
    re(this, El, void 0);
    ft(this, { allowLoose: !!n }), j(this, wi, si(t)), j(this, Ad, 0), j(this, Ed, null), j(this, El, r ?? 1024), j(this, qi, 0);
  }
  get data() {
    return Je(C(this, wi));
  }
  get dataLength() {
    return C(this, wi).length;
  }
  get consumed() {
    return C(this, qi);
  }
  get bytes() {
    return new Uint8Array(C(this, wi));
  }
  // Create a sub-reader with the same underlying data, but offset
  subReader(t) {
    const n = new IB(C(this, wi).slice(C(this, qi) + t), this.allowLoose, C(this, El));
    return j(n, Ed, this), n;
  }
  // Read bytes
  readBytes(t, n) {
    let r = Se(this, mA, MQ).call(this, 0, t, !!n);
    return Se(this, Ub, HT).call(this, t), j(this, qi, C(this, qi) + r.length), r.slice(0, t);
  }
  // Read a numeric values
  readValue() {
    return iB(this.readBytes(li));
  }
  readIndex() {
    return cPe(this.readBytes(li));
  }
};
wi = new WeakMap(), qi = new WeakMap(), Ad = new WeakMap(), Ed = new WeakMap(), El = new WeakMap(), Ub = new WeakSet(), HT = function(t) {
  var n;
  if (C(this, Ed))
    return Se(n = C(this, Ed), Ub, HT).call(n, t);
  j(this, Ad, C(this, Ad) + t), Pe(C(this, El) < 1 || C(this, Ad) <= C(this, El) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${C(this, El)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
    buffer: si(C(this, wi)),
    offset: C(this, qi),
    length: t,
    info: {
      bytesRead: C(this, Ad),
      dataLength: this.dataLength
    }
  });
}, mA = new WeakSet(), MQ = function(t, n, r) {
  let i = Math.ceil(n / li) * li;
  return C(this, qi) + i > C(this, wi).length && (this.allowLoose && r && C(this, qi) + n <= C(this, wi).length ? i = n : Pe(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
    buffer: si(C(this, wi)),
    length: C(this, wi).length,
    offset: C(this, qi) + i
  })), C(this, wi).slice(C(this, qi), C(this, qi) + i);
};
let VT = IB;
function z2(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function sB(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function CPe(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  z2(e.outputLen), z2(e.blockLen);
}
function Um(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function FQ(e, t) {
  sB(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const _6 = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const jQ = (e) => e instanceof Uint8Array, TPe = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), S6 = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Mo = (e, t) => e << 32 - t | e >>> t, kPe = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!kPe)
  throw new Error("Non little-endian hardware is not supported");
function BPe(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function JE(e) {
  if (typeof e == "string" && (e = BPe(e)), !jQ(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
function IPe(...e) {
  const t = new Uint8Array(e.reduce((r, i) => r + i.length, 0));
  let n = 0;
  return e.forEach((r) => {
    if (!jQ(r))
      throw new Error("Uint8Array expected");
    t.set(r, n), n += r.length;
  }), t;
}
let oB = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function aB(e) {
  const t = (r) => e().update(JE(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
function PPe(e = 32) {
  if (_6 && typeof _6.getRandomValues == "function")
    return _6.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
class DQ extends oB {
  constructor(t, n) {
    super(), this.finished = !1, this.destroyed = !1, CPe(t);
    const r = JE(n);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const i = this.blockLen, s = new Uint8Array(i);
    s.set(r.length > i ? t.create().update(r).digest() : r);
    for (let o = 0; o < s.length; o++)
      s[o] ^= 54;
    this.iHash.update(s), this.oHash = t.create();
    for (let o = 0; o < s.length; o++)
      s[o] ^= 106;
    this.oHash.update(s), s.fill(0);
  }
  update(t) {
    return Um(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    Um(this), sB(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: i, destroyed: s, blockLen: o, outputLen: a } = this;
    return t = t, t.finished = i, t.destroyed = s, t.blockLen = o, t.outputLen = a, t.oHash = n._cloneInto(t.oHash), t.iHash = r._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const UQ = (e, t, n) => new DQ(e, t).update(n).digest();
UQ.create = (e, t) => new DQ(e, t);
function OPe(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), s = BigInt(4294967295), o = Number(n >> i & s), a = Number(n & s), c = r ? 4 : 0, l = r ? 0 : 4;
  e.setUint32(t + c, o, r), e.setUint32(t + l, a, r);
}
class LQ extends oB {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = S6(this.buffer);
  }
  update(t) {
    Um(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = JE(t);
    const s = t.length;
    for (let o = 0; o < s; ) {
      const a = Math.min(i - this.pos, s - o);
      if (a === i) {
        const c = S6(t);
        for (; i <= s - o; o += i)
          this.process(c, o);
        continue;
      }
      r.set(t.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Um(this), FQ(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: s } = this;
    let { pos: o } = this;
    n[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > i - o && (this.process(r, 0), o = 0);
    for (let d = o; d < i; d++)
      n[d] = 0;
    OPe(r, i - 8, BigInt(this.length * 8), s), this.process(r, 0);
    const a = S6(t), c = this.outputLen;
    if (c % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let d = 0; d < l; d++)
      a.setUint32(4 * d, u[d], s);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: s, destroyed: o, pos: a } = this;
    return t.length = i, t.pos = a, t.finished = s, t.destroyed = o, i % n && t.buffer.set(r), t;
  }
}
const NPe = (e, t, n) => e & t ^ ~e & n, RPe = (e, t, n) => e & t ^ e & n ^ t & n, MPe = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Kc = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Yc = /* @__PURE__ */ new Uint32Array(64);
class FPe extends LQ {
  constructor() {
    super(64, 32, 8, !1), this.A = Kc[0] | 0, this.B = Kc[1] | 0, this.C = Kc[2] | 0, this.D = Kc[3] | 0, this.E = Kc[4] | 0, this.F = Kc[5] | 0, this.G = Kc[6] | 0, this.H = Kc[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: s, F: o, G: a, H: c } = this;
    return [t, n, r, i, s, o, a, c];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, a, c) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = s | 0, this.F = o | 0, this.G = a | 0, this.H = c | 0;
  }
  process(t, n) {
    for (let d = 0; d < 16; d++, n += 4)
      Yc[d] = t.getUint32(n, !1);
    for (let d = 16; d < 64; d++) {
      const f = Yc[d - 15], p = Yc[d - 2], m = Mo(f, 7) ^ Mo(f, 18) ^ f >>> 3, h = Mo(p, 17) ^ Mo(p, 19) ^ p >>> 10;
      Yc[d] = h + Yc[d - 7] + m + Yc[d - 16] | 0;
    }
    let { A: r, B: i, C: s, D: o, E: a, F: c, G: l, H: u } = this;
    for (let d = 0; d < 64; d++) {
      const f = Mo(a, 6) ^ Mo(a, 11) ^ Mo(a, 25), p = u + f + NPe(a, c, l) + MPe[d] + Yc[d] | 0, h = (Mo(r, 2) ^ Mo(r, 13) ^ Mo(r, 22)) + RPe(r, i, s) | 0;
      u = l, l = c, c = a, a = o + p | 0, o = s, s = i, i = r, r = p + h | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, s = s + this.C | 0, o = o + this.D | 0, a = a + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(r, i, s, o, a, c, l, u);
  }
  roundClean() {
    Yc.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const zQ = /* @__PURE__ */ aB(() => new FPe()), ew = /* @__PURE__ */ BigInt(2 ** 32 - 1), WT = /* @__PURE__ */ BigInt(32);
function VQ(e, t = !1) {
  return t ? { h: Number(e & ew), l: Number(e >> WT & ew) } : { h: Number(e >> WT & ew) | 0, l: Number(e & ew) | 0 };
}
function HQ(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: s, l: o } = VQ(e[i], t);
    [n[i], r[i]] = [s, o];
  }
  return [n, r];
}
const jPe = (e, t) => BigInt(e >>> 0) << WT | BigInt(t >>> 0), DPe = (e, t, n) => e >>> n, UPe = (e, t, n) => e << 32 - n | t >>> n, LPe = (e, t, n) => e >>> n | t << 32 - n, zPe = (e, t, n) => e << 32 - n | t >>> n, VPe = (e, t, n) => e << 64 - n | t >>> n - 32, HPe = (e, t, n) => e >>> n - 32 | t << 64 - n, WPe = (e, t) => t, GPe = (e, t) => e, WQ = (e, t, n) => e << n | t >>> 32 - n, GQ = (e, t, n) => t << n | e >>> 32 - n, qQ = (e, t, n) => t << n - 32 | e >>> 64 - n, $Q = (e, t, n) => e << n - 32 | t >>> 64 - n;
function qPe(e, t, n, r) {
  const i = (t >>> 0) + (r >>> 0);
  return { h: e + n + (i / 2 ** 32 | 0) | 0, l: i | 0 };
}
const $Pe = (e, t, n) => (e >>> 0) + (t >>> 0) + (n >>> 0), QPe = (e, t, n, r) => t + n + r + (e / 2 ** 32 | 0) | 0, KPe = (e, t, n, r) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0), YPe = (e, t, n, r, i) => t + n + r + i + (e / 2 ** 32 | 0) | 0, ZPe = (e, t, n, r, i) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0) + (i >>> 0), JPe = (e, t, n, r, i, s) => t + n + r + i + s + (e / 2 ** 32 | 0) | 0, St = {
  fromBig: VQ,
  split: HQ,
  toBig: jPe,
  shrSH: DPe,
  shrSL: UPe,
  rotrSH: LPe,
  rotrSL: zPe,
  rotrBH: VPe,
  rotrBL: HPe,
  rotr32H: WPe,
  rotr32L: GPe,
  rotlSH: WQ,
  rotlSL: GQ,
  rotlBH: qQ,
  rotlBL: $Q,
  add: qPe,
  add3L: $Pe,
  add3H: QPe,
  add4L: KPe,
  add4H: YPe,
  add5H: JPe,
  add5L: ZPe
}, [XPe, eOe] = St.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), Zc = /* @__PURE__ */ new Uint32Array(80), Jc = /* @__PURE__ */ new Uint32Array(80);
class tOe extends LQ {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: n, Bh: r, Bl: i, Ch: s, Cl: o, Dh: a, Dl: c, Eh: l, El: u, Fh: d, Fl: f, Gh: p, Gl: m, Hh: h, Hl: g } = this;
    return [t, n, r, i, s, o, a, c, l, u, d, f, p, m, h, g];
  }
  // prettier-ignore
  set(t, n, r, i, s, o, a, c, l, u, d, f, p, m, h, g) {
    this.Ah = t | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = i | 0, this.Ch = s | 0, this.Cl = o | 0, this.Dh = a | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = d | 0, this.Fl = f | 0, this.Gh = p | 0, this.Gl = m | 0, this.Hh = h | 0, this.Hl = g | 0;
  }
  process(t, n) {
    for (let b = 0; b < 16; b++, n += 4)
      Zc[b] = t.getUint32(n), Jc[b] = t.getUint32(n += 4);
    for (let b = 16; b < 80; b++) {
      const w = Zc[b - 15] | 0, A = Jc[b - 15] | 0, E = St.rotrSH(w, A, 1) ^ St.rotrSH(w, A, 8) ^ St.shrSH(w, A, 7), x = St.rotrSL(w, A, 1) ^ St.rotrSL(w, A, 8) ^ St.shrSL(w, A, 7), S = Zc[b - 2] | 0, P = Jc[b - 2] | 0, I = St.rotrSH(S, P, 19) ^ St.rotrBH(S, P, 61) ^ St.shrSH(S, P, 6), R = St.rotrSL(S, P, 19) ^ St.rotrBL(S, P, 61) ^ St.shrSL(S, P, 6), Q = St.add4L(x, R, Jc[b - 7], Jc[b - 16]), J = St.add4H(Q, E, I, Zc[b - 7], Zc[b - 16]);
      Zc[b] = J | 0, Jc[b] = Q | 0;
    }
    let { Ah: r, Al: i, Bh: s, Bl: o, Ch: a, Cl: c, Dh: l, Dl: u, Eh: d, El: f, Fh: p, Fl: m, Gh: h, Gl: g, Hh: y, Hl: v } = this;
    for (let b = 0; b < 80; b++) {
      const w = St.rotrSH(d, f, 14) ^ St.rotrSH(d, f, 18) ^ St.rotrBH(d, f, 41), A = St.rotrSL(d, f, 14) ^ St.rotrSL(d, f, 18) ^ St.rotrBL(d, f, 41), E = d & p ^ ~d & h, x = f & m ^ ~f & g, S = St.add5L(v, A, x, eOe[b], Jc[b]), P = St.add5H(S, y, w, E, XPe[b], Zc[b]), I = S | 0, R = St.rotrSH(r, i, 28) ^ St.rotrBH(r, i, 34) ^ St.rotrBH(r, i, 39), Q = St.rotrSL(r, i, 28) ^ St.rotrBL(r, i, 34) ^ St.rotrBL(r, i, 39), J = r & s ^ r & a ^ s & a, we = i & o ^ i & c ^ o & c;
      y = h | 0, v = g | 0, h = p | 0, g = m | 0, p = d | 0, m = f | 0, { h: d, l: f } = St.add(l | 0, u | 0, P | 0, I | 0), l = a | 0, u = c | 0, a = s | 0, c = o | 0, s = r | 0, o = i | 0;
      const V = St.add3L(I, Q, we);
      r = St.add3H(V, P, R, J), i = V | 0;
    }
    ({ h: r, l: i } = St.add(this.Ah | 0, this.Al | 0, r | 0, i | 0)), { h: s, l: o } = St.add(this.Bh | 0, this.Bl | 0, s | 0, o | 0), { h: a, l: c } = St.add(this.Ch | 0, this.Cl | 0, a | 0, c | 0), { h: l, l: u } = St.add(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h: d, l: f } = St.add(this.Eh | 0, this.El | 0, d | 0, f | 0), { h: p, l: m } = St.add(this.Fh | 0, this.Fl | 0, p | 0, m | 0), { h, l: g } = St.add(this.Gh | 0, this.Gl | 0, h | 0, g | 0), { h: y, l: v } = St.add(this.Hh | 0, this.Hl | 0, y | 0, v | 0), this.set(r, i, s, o, a, c, l, u, d, f, p, m, h, g, y, v);
  }
  roundClean() {
    Zc.fill(0), Jc.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const nOe = /* @__PURE__ */ aB(() => new tOe());
function rOe() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u" || typeof window < "u")
    return window;
  throw new Error("unable to locate global object");
}
const V9 = rOe();
V9.crypto || V9.msCrypto;
function iOe(e) {
  switch (e) {
    case "sha256":
      return zQ.create();
    case "sha512":
      return nOe.create();
  }
  de(!1, "invalid hashing algorithm name", "algorithm", e);
}
const [QQ, KQ, YQ] = [[], [], []], sOe = /* @__PURE__ */ BigInt(0), M0 = /* @__PURE__ */ BigInt(1), oOe = /* @__PURE__ */ BigInt(2), aOe = /* @__PURE__ */ BigInt(7), cOe = /* @__PURE__ */ BigInt(256), lOe = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = M0, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], QQ.push(2 * (5 * r + n)), KQ.push((e + 1) * (e + 2) / 2 % 64);
  let i = sOe;
  for (let s = 0; s < 7; s++)
    t = (t << M0 ^ (t >> aOe) * lOe) % cOe, t & oOe && (i ^= M0 << (M0 << /* @__PURE__ */ BigInt(s)) - M0);
  YQ.push(i);
}
const [uOe, dOe] = /* @__PURE__ */ HQ(YQ, !0), H9 = (e, t, n) => n > 32 ? qQ(e, t, n) : WQ(e, t, n), W9 = (e, t, n) => n > 32 ? $Q(e, t, n) : GQ(e, t, n);
function fOe(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      n[o] = e[o] ^ e[o + 10] ^ e[o + 20] ^ e[o + 30] ^ e[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const a = (o + 8) % 10, c = (o + 2) % 10, l = n[c], u = n[c + 1], d = H9(l, u, 1) ^ n[a], f = W9(l, u, 1) ^ n[a + 1];
      for (let p = 0; p < 50; p += 10)
        e[o + p] ^= d, e[o + p + 1] ^= f;
    }
    let i = e[2], s = e[3];
    for (let o = 0; o < 24; o++) {
      const a = KQ[o], c = H9(i, s, a), l = W9(i, s, a), u = QQ[o];
      i = e[u], s = e[u + 1], e[u] = c, e[u + 1] = l;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let a = 0; a < 10; a++)
        n[a] = e[o + a];
      for (let a = 0; a < 10; a++)
        e[o + a] ^= ~n[(a + 2) % 10] & n[(a + 4) % 10];
    }
    e[0] ^= uOe[r], e[1] ^= dOe[r];
  }
  n.fill(0);
}
let hOe = class ZQ extends oB {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, i = !1, s = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, z2(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = TPe(this.state);
  }
  keccak() {
    fOe(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    Um(this);
    const { blockLen: n, state: r } = this;
    t = JE(t);
    const i = t.length;
    for (let s = 0; s < i; ) {
      const o = Math.min(n - this.pos, i - s);
      for (let a = 0; a < o; a++)
        r[this.pos++] ^= t[s++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: i } = this;
    t[r] ^= n, n & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    Um(this, !1), sB(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, s = t.length; i < s; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, s - i);
      t.set(n.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return z2(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (FQ(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: s, enableXOF: o } = this;
    return t || (t = new ZQ(n, r, i, o, s)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = s, t.suffix = r, t.outputLen = i, t.enableXOF = o, t.destroyed = this.destroyed, t;
  }
};
const pOe = (e, t, n) => aB(() => new hOe(t, e, n)), mOe = /* @__PURE__ */ pOe(1, 136, 256 / 8);
let JQ = !1;
const XQ = function(e) {
  return mOe(e);
};
let eK = XQ;
function Yn(e) {
  const t = Ht(e, "data");
  return Je(eK(t));
}
Yn._ = XQ;
Yn.lock = function() {
  JQ = !0;
};
Yn.register = function(e) {
  if (JQ)
    throw new TypeError("keccak256 is locked");
  eK = e;
};
Object.freeze(Yn);
const tK = function(e) {
  return iOe("sha256").update(e).digest();
};
let nK = tK, rK = !1;
function l0(e) {
  const t = Ht(e, "data");
  return Je(nK(t));
}
l0._ = tK;
l0.lock = function() {
  rK = !0;
};
l0.register = function(e) {
  if (rK)
    throw new Error("sha256 is locked");
  nK = e;
};
Object.freeze(l0);
Object.freeze(l0);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const iK = BigInt(0), XE = BigInt(1), gOe = BigInt(2), e3 = (e) => e instanceof Uint8Array, yOe = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Lm(e) {
  if (!e3(e))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += yOe[e[n]];
  return t;
}
function sK(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function cB(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
function zm(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(t / 2);
  for (let r = 0; r < n.length; r++) {
    const i = r * 2, s = e.slice(i, i + 2), o = Number.parseInt(s, 16);
    if (Number.isNaN(o) || o < 0)
      throw new Error("Invalid byte sequence");
    n[r] = o;
  }
  return n;
}
function Zd(e) {
  return cB(Lm(e));
}
function lB(e) {
  if (!e3(e))
    throw new Error("Uint8Array expected");
  return cB(Lm(Uint8Array.from(e).reverse()));
}
function Vm(e, t) {
  return zm(e.toString(16).padStart(t * 2, "0"));
}
function uB(e, t) {
  return Vm(e, t).reverse();
}
function bOe(e) {
  return zm(sK(e));
}
function Qs(e, t, n) {
  let r;
  if (typeof t == "string")
    try {
      r = zm(t);
    } catch (s) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${s}`);
    }
  else if (e3(t))
    r = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const i = r.length;
  if (typeof n == "number" && i !== n)
    throw new Error(`${e} expected ${n} bytes, got ${i}`);
  return r;
}
function cb(...e) {
  const t = new Uint8Array(e.reduce((r, i) => r + i.length, 0));
  let n = 0;
  return e.forEach((r) => {
    if (!e3(r))
      throw new Error("Uint8Array expected");
    t.set(r, n), n += r.length;
  }), t;
}
function vOe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function wOe(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function xOe(e) {
  let t;
  for (t = 0; e > iK; e >>= XE, t += 1)
    ;
  return t;
}
function AOe(e, t) {
  return e >> BigInt(t) & XE;
}
const EOe = (e, t, n) => e | (n ? XE : iK) << BigInt(t), dB = (e) => (gOe << BigInt(e - 1)) - XE, C6 = (e) => new Uint8Array(e), G9 = (e) => Uint8Array.from(e);
function oK(e, t, n) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof n != "function")
    throw new Error("hmacFn must be a function");
  let r = C6(e), i = C6(e), s = 0;
  const o = () => {
    r.fill(1), i.fill(0), s = 0;
  }, a = (...d) => n(i, r, ...d), c = (d = C6()) => {
    i = a(G9([0]), d), r = a(), d.length !== 0 && (i = a(G9([1]), d), r = a());
  }, l = () => {
    if (s++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let d = 0;
    const f = [];
    for (; d < t; ) {
      r = a();
      const p = r.slice();
      f.push(p), d += r.length;
    }
    return cb(...f);
  };
  return (d, f) => {
    o(), c(d);
    let p;
    for (; !(p = f(l())); )
      c();
    return o(), p;
  };
}
const _Oe = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || e instanceof Uint8Array,
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function jv(e, t, n = {}) {
  const r = (i, s, o) => {
    const a = _Oe[s];
    if (typeof a != "function")
      throw new Error(`Invalid validator "${s}", expected function`);
    const c = e[i];
    if (!(o && c === void 0) && !a(c, e))
      throw new Error(`Invalid param ${String(i)}=${c} (${typeof c}), expected ${s}`);
  };
  for (const [i, s] of Object.entries(t))
    r(i, s, !1);
  for (const [i, s] of Object.entries(n))
    r(i, s, !0);
  return e;
}
const SOe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: AOe,
  bitLen: xOe,
  bitMask: dB,
  bitSet: EOe,
  bytesToHex: Lm,
  bytesToNumberBE: Zd,
  bytesToNumberLE: lB,
  concatBytes: cb,
  createHmacDrbg: oK,
  ensureBytes: Qs,
  equalBytes: vOe,
  hexToBytes: zm,
  hexToNumber: cB,
  numberToBytesBE: Vm,
  numberToBytesLE: uB,
  numberToHexUnpadded: sK,
  numberToVarBytesBE: bOe,
  utf8ToBytes: wOe,
  validateObject: jv
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const mr = BigInt(0), Un = BigInt(1), Gu = BigInt(2), COe = BigInt(3), GT = BigInt(4), q9 = BigInt(5), $9 = BigInt(8);
BigInt(9);
BigInt(16);
function Si(e, t) {
  const n = e % t;
  return n >= mr ? n : t + n;
}
function TOe(e, t, n) {
  if (n <= mr || t < mr)
    throw new Error("Expected power/modulo > 0");
  if (n === Un)
    return mr;
  let r = Un;
  for (; t > mr; )
    t & Un && (r = r * e % n), e = e * e % n, t >>= Un;
  return r;
}
function as(e, t, n) {
  let r = e;
  for (; t-- > mr; )
    r *= r, r %= n;
  return r;
}
function qT(e, t) {
  if (e === mr || t <= mr)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let n = Si(e, t), r = t, i = mr, s = Un;
  for (; n !== mr; ) {
    const a = r / n, c = r % n, l = i - s * a;
    r = n, n = c, i = s, s = l;
  }
  if (r !== Un)
    throw new Error("invert: does not exist");
  return Si(i, t);
}
function kOe(e) {
  const t = (e - Un) / Gu;
  let n, r, i;
  for (n = e - Un, r = 0; n % Gu === mr; n /= Gu, r++)
    ;
  for (i = Gu; i < e && TOe(i, t, e) !== e - Un; i++)
    ;
  if (r === 1) {
    const o = (e + Un) / GT;
    return function(c, l) {
      const u = c.pow(l, o);
      if (!c.eql(c.sqr(u), l))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  const s = (n + Un) / Gu;
  return function(a, c) {
    if (a.pow(c, t) === a.neg(a.ONE))
      throw new Error("Cannot find square root");
    let l = r, u = a.pow(a.mul(a.ONE, i), n), d = a.pow(c, s), f = a.pow(c, n);
    for (; !a.eql(f, a.ONE); ) {
      if (a.eql(f, a.ZERO))
        return a.ZERO;
      let p = 1;
      for (let h = a.sqr(f); p < l && !a.eql(h, a.ONE); p++)
        h = a.sqr(h);
      const m = a.pow(u, Un << BigInt(l - p - 1));
      u = a.sqr(m), d = a.mul(d, m), f = a.mul(f, u), l = p;
    }
    return d;
  };
}
function BOe(e) {
  if (e % GT === COe) {
    const t = (e + Un) / GT;
    return function(r, i) {
      const s = r.pow(i, t);
      if (!r.eql(r.sqr(s), i))
        throw new Error("Cannot find square root");
      return s;
    };
  }
  if (e % $9 === q9) {
    const t = (e - q9) / $9;
    return function(r, i) {
      const s = r.mul(i, Gu), o = r.pow(s, t), a = r.mul(i, o), c = r.mul(r.mul(a, Gu), o), l = r.mul(a, r.sub(c, r.ONE));
      if (!r.eql(r.sqr(l), i))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return kOe(e);
}
const IOe = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function POe(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, n = IOe.reduce((r, i) => (r[i] = "function", r), t);
  return jv(e, n);
}
function OOe(e, t, n) {
  if (n < mr)
    throw new Error("Expected power > 0");
  if (n === mr)
    return e.ONE;
  if (n === Un)
    return t;
  let r = e.ONE, i = t;
  for (; n > mr; )
    n & Un && (r = e.mul(r, i)), i = e.sqr(i), n >>= Un;
  return r;
}
function NOe(e, t) {
  const n = new Array(t.length), r = t.reduce((s, o, a) => e.is0(o) ? s : (n[a] = s, e.mul(s, o)), e.ONE), i = e.inv(r);
  return t.reduceRight((s, o, a) => e.is0(o) ? s : (n[a] = e.mul(s, n[a]), e.mul(s, o)), i), n;
}
function aK(e, t) {
  const n = t !== void 0 ? t : e.toString(2).length, r = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: r };
}
function ROe(e, t, n = !1, r = {}) {
  if (e <= mr)
    throw new Error(`Expected Field ORDER > 0, got ${e}`);
  const { nBitLength: i, nByteLength: s } = aK(e, t);
  if (s > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const o = BOe(e), a = Object.freeze({
    ORDER: e,
    BITS: i,
    BYTES: s,
    MASK: dB(i),
    ZERO: mr,
    ONE: Un,
    create: (c) => Si(c, e),
    isValid: (c) => {
      if (typeof c != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof c}`);
      return mr <= c && c < e;
    },
    is0: (c) => c === mr,
    isOdd: (c) => (c & Un) === Un,
    neg: (c) => Si(-c, e),
    eql: (c, l) => c === l,
    sqr: (c) => Si(c * c, e),
    add: (c, l) => Si(c + l, e),
    sub: (c, l) => Si(c - l, e),
    mul: (c, l) => Si(c * l, e),
    pow: (c, l) => OOe(a, c, l),
    div: (c, l) => Si(c * qT(l, e), e),
    // Same as above, but doesn't normalize
    sqrN: (c) => c * c,
    addN: (c, l) => c + l,
    subN: (c, l) => c - l,
    mulN: (c, l) => c * l,
    inv: (c) => qT(c, e),
    sqrt: r.sqrt || ((c) => o(a, c)),
    invertBatch: (c) => NOe(a, c),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (c, l, u) => u ? l : c,
    toBytes: (c) => n ? uB(c, s) : Vm(c, s),
    fromBytes: (c) => {
      if (c.length !== s)
        throw new Error(`Fp.fromBytes: expected ${s}, got ${c.length}`);
      return n ? lB(c) : Zd(c);
    }
  });
  return Object.freeze(a);
}
function cK(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function lK(e) {
  const t = cK(e);
  return t + Math.ceil(t / 2);
}
function MOe(e, t, n = !1) {
  const r = e.length, i = cK(t), s = lK(t);
  if (r < 16 || r < s || r > 1024)
    throw new Error(`expected ${s}-1024 bytes of input, got ${r}`);
  const o = n ? Zd(e) : lB(e), a = Si(o, t - Un) + Un;
  return n ? uB(a, i) : Vm(a, i);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const FOe = BigInt(0), T6 = BigInt(1);
function jOe(e, t) {
  const n = (i, s) => {
    const o = s.negate();
    return i ? o : s;
  }, r = (i) => {
    const s = Math.ceil(t / i) + 1, o = 2 ** (i - 1);
    return { windows: s, windowSize: o };
  };
  return {
    constTimeNegate: n,
    // non-const time multiplication ladder
    unsafeLadder(i, s) {
      let o = e.ZERO, a = i;
      for (; s > FOe; )
        s & T6 && (o = o.add(a)), a = a.double(), s >>= T6;
      return o;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(i, s) {
      const { windows: o, windowSize: a } = r(s), c = [];
      let l = i, u = l;
      for (let d = 0; d < o; d++) {
        u = l, c.push(u);
        for (let f = 1; f < a; f++)
          u = u.add(l), c.push(u);
        l = u.double();
      }
      return c;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(i, s, o) {
      const { windows: a, windowSize: c } = r(i);
      let l = e.ZERO, u = e.BASE;
      const d = BigInt(2 ** i - 1), f = 2 ** i, p = BigInt(i);
      for (let m = 0; m < a; m++) {
        const h = m * c;
        let g = Number(o & d);
        o >>= p, g > c && (g -= f, o += T6);
        const y = h, v = h + Math.abs(g) - 1, b = m % 2 !== 0, w = g < 0;
        g === 0 ? u = u.add(n(b, s[y])) : l = l.add(n(w, s[v]));
      }
      return { p: l, f: u };
    },
    wNAFCached(i, s, o, a) {
      const c = i._WINDOW_SIZE || 1;
      let l = s.get(i);
      return l || (l = this.precomputeWindow(i, c), c !== 1 && s.set(i, a(l))), this.wNAF(c, l, o);
    }
  };
}
function uK(e) {
  return POe(e.Fp), jv(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...aK(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function DOe(e) {
  const t = uK(e);
  jv(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: n, Fp: r, a: i } = t;
  if (n) {
    if (!r.eql(i, r.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: UOe, hexToBytes: LOe } = SOe, nd = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(e) {
    const { Err: t } = nd;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const n = e[1], r = e.subarray(2, n + 2);
    if (!n || r.length !== n)
      throw new t("Invalid signature integer: wrong length");
    if (r[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (r[0] === 0 && !(r[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: UOe(r), l: e.subarray(n + 2) };
  },
  toSig(e) {
    const { Err: t } = nd, n = typeof e == "string" ? LOe(e) : e;
    if (!(n instanceof Uint8Array))
      throw new Error("ui8a expected");
    let r = n.length;
    if (r < 2 || n[0] != 48)
      throw new t("Invalid signature tag");
    if (n[1] !== r - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: i, l: s } = nd._parseInt(n.subarray(2)), { d: o, l: a } = nd._parseInt(s);
    if (a.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: i, s: o };
  },
  hexFromSig(e) {
    const t = (l) => Number.parseInt(l[0], 16) & 8 ? "00" + l : l, n = (l) => {
      const u = l.toString(16);
      return u.length & 1 ? `0${u}` : u;
    }, r = t(n(e.s)), i = t(n(e.r)), s = r.length / 2, o = i.length / 2, a = n(s), c = n(o);
    return `30${n(o + s + 4)}02${c}${i}02${a}${r}`;
  }
}, rc = BigInt(0), As = BigInt(1);
BigInt(2);
const Q9 = BigInt(3);
BigInt(4);
function zOe(e) {
  const t = DOe(e), { Fp: n } = t, r = t.toBytes || ((m, h, g) => {
    const y = h.toAffine();
    return cb(Uint8Array.from([4]), n.toBytes(y.x), n.toBytes(y.y));
  }), i = t.fromBytes || ((m) => {
    const h = m.subarray(1), g = n.fromBytes(h.subarray(0, n.BYTES)), y = n.fromBytes(h.subarray(n.BYTES, 2 * n.BYTES));
    return { x: g, y };
  });
  function s(m) {
    const { a: h, b: g } = t, y = n.sqr(m), v = n.mul(y, m);
    return n.add(n.add(v, n.mul(m, h)), g);
  }
  if (!n.eql(n.sqr(t.Gy), s(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function o(m) {
    return typeof m == "bigint" && rc < m && m < t.n;
  }
  function a(m) {
    if (!o(m))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function c(m) {
    const { allowedPrivateKeyLengths: h, nByteLength: g, wrapPrivateKey: y, n: v } = t;
    if (h && typeof m != "bigint") {
      if (m instanceof Uint8Array && (m = Lm(m)), typeof m != "string" || !h.includes(m.length))
        throw new Error("Invalid key");
      m = m.padStart(g * 2, "0");
    }
    let b;
    try {
      b = typeof m == "bigint" ? m : Zd(Qs("private key", m, g));
    } catch {
      throw new Error(`private key must be ${g} bytes, hex or bigint, not ${typeof m}`);
    }
    return y && (b = Si(b, v)), a(b), b;
  }
  const l = /* @__PURE__ */ new Map();
  function u(m) {
    if (!(m instanceof d))
      throw new Error("ProjectivePoint expected");
  }
  class d {
    constructor(h, g, y) {
      if (this.px = h, this.py = g, this.pz = y, h == null || !n.isValid(h))
        throw new Error("x required");
      if (g == null || !n.isValid(g))
        throw new Error("y required");
      if (y == null || !n.isValid(y))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(h) {
      const { x: g, y } = h || {};
      if (!h || !n.isValid(g) || !n.isValid(y))
        throw new Error("invalid affine point");
      if (h instanceof d)
        throw new Error("projective point not allowed");
      const v = (b) => n.eql(b, n.ZERO);
      return v(g) && v(y) ? d.ZERO : new d(g, y, n.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(h) {
      const g = n.invertBatch(h.map((y) => y.pz));
      return h.map((y, v) => y.toAffine(g[v])).map(d.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(h) {
      const g = d.fromAffine(i(Qs("pointHex", h)));
      return g.assertValidity(), g;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(h) {
      return d.BASE.multiply(c(h));
    }
    // "Private method", don't use it directly
    _setWindowSize(h) {
      this._WINDOW_SIZE = h, l.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !n.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: h, y: g } = this.toAffine();
      if (!n.isValid(h) || !n.isValid(g))
        throw new Error("bad point: x or y not FE");
      const y = n.sqr(g), v = s(h);
      if (!n.eql(y, v))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: h } = this.toAffine();
      if (n.isOdd)
        return !n.isOdd(h);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(h) {
      u(h);
      const { px: g, py: y, pz: v } = this, { px: b, py: w, pz: A } = h, E = n.eql(n.mul(g, A), n.mul(b, v)), x = n.eql(n.mul(y, A), n.mul(w, v));
      return E && x;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new d(this.px, n.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: h, b: g } = t, y = n.mul(g, Q9), { px: v, py: b, pz: w } = this;
      let A = n.ZERO, E = n.ZERO, x = n.ZERO, S = n.mul(v, v), P = n.mul(b, b), I = n.mul(w, w), R = n.mul(v, b);
      return R = n.add(R, R), x = n.mul(v, w), x = n.add(x, x), A = n.mul(h, x), E = n.mul(y, I), E = n.add(A, E), A = n.sub(P, E), E = n.add(P, E), E = n.mul(A, E), A = n.mul(R, A), x = n.mul(y, x), I = n.mul(h, I), R = n.sub(S, I), R = n.mul(h, R), R = n.add(R, x), x = n.add(S, S), S = n.add(x, S), S = n.add(S, I), S = n.mul(S, R), E = n.add(E, S), I = n.mul(b, w), I = n.add(I, I), S = n.mul(I, R), A = n.sub(A, S), x = n.mul(I, P), x = n.add(x, x), x = n.add(x, x), new d(A, E, x);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(h) {
      u(h);
      const { px: g, py: y, pz: v } = this, { px: b, py: w, pz: A } = h;
      let E = n.ZERO, x = n.ZERO, S = n.ZERO;
      const P = t.a, I = n.mul(t.b, Q9);
      let R = n.mul(g, b), Q = n.mul(y, w), J = n.mul(v, A), we = n.add(g, y), V = n.add(b, w);
      we = n.mul(we, V), V = n.add(R, Q), we = n.sub(we, V), V = n.add(g, v);
      let L = n.add(b, A);
      return V = n.mul(V, L), L = n.add(R, J), V = n.sub(V, L), L = n.add(y, v), E = n.add(w, A), L = n.mul(L, E), E = n.add(Q, J), L = n.sub(L, E), S = n.mul(P, V), E = n.mul(I, J), S = n.add(E, S), E = n.sub(Q, S), S = n.add(Q, S), x = n.mul(E, S), Q = n.add(R, R), Q = n.add(Q, R), J = n.mul(P, J), V = n.mul(I, V), Q = n.add(Q, J), J = n.sub(R, J), J = n.mul(P, J), V = n.add(V, J), R = n.mul(Q, V), x = n.add(x, R), R = n.mul(L, V), E = n.mul(we, E), E = n.sub(E, R), R = n.mul(we, Q), S = n.mul(L, S), S = n.add(S, R), new d(E, x, S);
    }
    subtract(h) {
      return this.add(h.negate());
    }
    is0() {
      return this.equals(d.ZERO);
    }
    wNAF(h) {
      return p.wNAFCached(this, l, h, (g) => {
        const y = n.invertBatch(g.map((v) => v.pz));
        return g.map((v, b) => v.toAffine(y[b])).map(d.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(h) {
      const g = d.ZERO;
      if (h === rc)
        return g;
      if (a(h), h === As)
        return this;
      const { endo: y } = t;
      if (!y)
        return p.unsafeLadder(this, h);
      let { k1neg: v, k1: b, k2neg: w, k2: A } = y.splitScalar(h), E = g, x = g, S = this;
      for (; b > rc || A > rc; )
        b & As && (E = E.add(S)), A & As && (x = x.add(S)), S = S.double(), b >>= As, A >>= As;
      return v && (E = E.negate()), w && (x = x.negate()), x = new d(n.mul(x.px, y.beta), x.py, x.pz), E.add(x);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(h) {
      a(h);
      let g = h, y, v;
      const { endo: b } = t;
      if (b) {
        const { k1neg: w, k1: A, k2neg: E, k2: x } = b.splitScalar(g);
        let { p: S, f: P } = this.wNAF(A), { p: I, f: R } = this.wNAF(x);
        S = p.constTimeNegate(w, S), I = p.constTimeNegate(E, I), I = new d(n.mul(I.px, b.beta), I.py, I.pz), y = S.add(I), v = P.add(R);
      } else {
        const { p: w, f: A } = this.wNAF(g);
        y = w, v = A;
      }
      return d.normalizeZ([y, v])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(h, g, y) {
      const v = d.BASE, b = (A, E) => E === rc || E === As || !A.equals(v) ? A.multiplyUnsafe(E) : A.multiply(E), w = b(this, g).add(b(h, y));
      return w.is0() ? void 0 : w;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(h) {
      const { px: g, py: y, pz: v } = this, b = this.is0();
      h == null && (h = b ? n.ONE : n.inv(v));
      const w = n.mul(g, h), A = n.mul(y, h), E = n.mul(v, h);
      if (b)
        return { x: n.ZERO, y: n.ZERO };
      if (!n.eql(E, n.ONE))
        throw new Error("invZ was invalid");
      return { x: w, y: A };
    }
    isTorsionFree() {
      const { h, isTorsionFree: g } = t;
      if (h === As)
        return !0;
      if (g)
        return g(d, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h, clearCofactor: g } = t;
      return h === As ? this : g ? g(d, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(h = !0) {
      return this.assertValidity(), r(d, this, h);
    }
    toHex(h = !0) {
      return Lm(this.toRawBytes(h));
    }
  }
  d.BASE = new d(t.Gx, t.Gy, n.ONE), d.ZERO = new d(n.ZERO, n.ONE, n.ZERO);
  const f = t.nBitLength, p = jOe(d, t.endo ? Math.ceil(f / 2) : f);
  return {
    CURVE: t,
    ProjectivePoint: d,
    normPrivateKeyToScalar: c,
    weierstrassEquation: s,
    isWithinCurveOrder: o
  };
}
function VOe(e) {
  const t = uK(e);
  return jv(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function HOe(e) {
  const t = VOe(e), { Fp: n, n: r } = t, i = n.BYTES + 1, s = 2 * n.BYTES + 1;
  function o(V) {
    return rc < V && V < n.ORDER;
  }
  function a(V) {
    return Si(V, r);
  }
  function c(V) {
    return qT(V, r);
  }
  const { ProjectivePoint: l, normPrivateKeyToScalar: u, weierstrassEquation: d, isWithinCurveOrder: f } = zOe({
    ...t,
    toBytes(V, L, U) {
      const q = L.toAffine(), G = n.toBytes(q.x), ae = cb;
      return U ? ae(Uint8Array.from([L.hasEvenY() ? 2 : 3]), G) : ae(Uint8Array.from([4]), G, n.toBytes(q.y));
    },
    fromBytes(V) {
      const L = V.length, U = V[0], q = V.subarray(1);
      if (L === i && (U === 2 || U === 3)) {
        const G = Zd(q);
        if (!o(G))
          throw new Error("Point is not on curve");
        const ae = d(G);
        let ge = n.sqrt(ae);
        const Ae = (ge & As) === As;
        return (U & 1) === 1 !== Ae && (ge = n.neg(ge)), { x: G, y: ge };
      } else if (L === s && U === 4) {
        const G = n.fromBytes(q.subarray(0, n.BYTES)), ae = n.fromBytes(q.subarray(n.BYTES, 2 * n.BYTES));
        return { x: G, y: ae };
      } else
        throw new Error(`Point of length ${L} was invalid. Expected ${i} compressed bytes or ${s} uncompressed bytes`);
    }
  }), p = (V) => Lm(Vm(V, t.nByteLength));
  function m(V) {
    const L = r >> As;
    return V > L;
  }
  function h(V) {
    return m(V) ? a(-V) : V;
  }
  const g = (V, L, U) => Zd(V.slice(L, U));
  class y {
    constructor(L, U, q) {
      this.r = L, this.s = U, this.recovery = q, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(L) {
      const U = t.nByteLength;
      return L = Qs("compactSignature", L, U * 2), new y(g(L, 0, U), g(L, U, 2 * U));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(L) {
      const { r: U, s: q } = nd.toSig(Qs("DER", L));
      return new y(U, q);
    }
    assertValidity() {
      if (!f(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!f(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(L) {
      return new y(this.r, this.s, L);
    }
    recoverPublicKey(L) {
      const { r: U, s: q, recovery: G } = this, ae = x(Qs("msgHash", L));
      if (G == null || ![0, 1, 2, 3].includes(G))
        throw new Error("recovery id invalid");
      const ge = G === 2 || G === 3 ? U + t.n : U;
      if (ge >= n.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Ae = G & 1 ? "03" : "02", he = l.fromHex(Ae + p(ge)), B = c(ge), be = a(-ae * B), Be = a(q * B), Ne = l.BASE.multiplyAndAddUnsafe(he, be, Be);
      if (!Ne)
        throw new Error("point at infinify");
      return Ne.assertValidity(), Ne;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return m(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new y(this.r, a(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return zm(this.toDERHex());
    }
    toDERHex() {
      return nd.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return zm(this.toCompactHex());
    }
    toCompactHex() {
      return p(this.r) + p(this.s);
    }
  }
  const v = {
    isValidPrivateKey(V) {
      try {
        return u(V), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: u,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const V = lK(t.n);
      return MOe(t.randomBytes(V), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(V = 8, L = l.BASE) {
      return L._setWindowSize(V), L.multiply(BigInt(3)), L;
    }
  };
  function b(V, L = !0) {
    return l.fromPrivateKey(V).toRawBytes(L);
  }
  function w(V) {
    const L = V instanceof Uint8Array, U = typeof V == "string", q = (L || U) && V.length;
    return L ? q === i || q === s : U ? q === 2 * i || q === 2 * s : V instanceof l;
  }
  function A(V, L, U = !0) {
    if (w(V))
      throw new Error("first arg must be private key");
    if (!w(L))
      throw new Error("second arg must be public key");
    return l.fromHex(L).multiply(u(V)).toRawBytes(U);
  }
  const E = t.bits2int || function(V) {
    const L = Zd(V), U = V.length * 8 - t.nBitLength;
    return U > 0 ? L >> BigInt(U) : L;
  }, x = t.bits2int_modN || function(V) {
    return a(E(V));
  }, S = dB(t.nBitLength);
  function P(V) {
    if (typeof V != "bigint")
      throw new Error("bigint expected");
    if (!(rc <= V && V < S))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return Vm(V, t.nByteLength);
  }
  function I(V, L, U = R) {
    if (["recovered", "canonical"].some((Ce) => Ce in U))
      throw new Error("sign() legacy options not supported");
    const { hash: q, randomBytes: G } = t;
    let { lowS: ae, prehash: ge, extraEntropy: Ae } = U;
    ae == null && (ae = !0), V = Qs("msgHash", V), ge && (V = Qs("prehashed msgHash", q(V)));
    const he = x(V), B = u(L), be = [P(B), P(he)];
    if (Ae != null) {
      const Ce = Ae === !0 ? G(n.BYTES) : Ae;
      be.push(Qs("extraEntropy", Ce));
    }
    const Be = cb(...be), Ne = he;
    function _e(Ce) {
      const N = E(Ce);
      if (!f(N))
        return;
      const F = c(N), z = l.BASE.multiply(N).toAffine(), ne = a(z.x);
      if (ne === rc)
        return;
      const ee = a(F * a(Ne + ne * B));
      if (ee === rc)
        return;
      let Y = (z.x === ne ? 0 : 2) | Number(z.y & As), X = ee;
      return ae && m(ee) && (X = h(ee), Y ^= 1), new y(ne, X, Y);
    }
    return { seed: Be, k2sig: _e };
  }
  const R = { lowS: t.lowS, prehash: !1 }, Q = { lowS: t.lowS, prehash: !1 };
  function J(V, L, U = R) {
    const { seed: q, k2sig: G } = I(V, L, U), ae = t;
    return oK(ae.hash.outputLen, ae.nByteLength, ae.hmac)(q, G);
  }
  l.BASE._setWindowSize(8);
  function we(V, L, U, q = Q) {
    var z;
    const G = V;
    if (L = Qs("msgHash", L), U = Qs("publicKey", U), "strict" in q)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: ae, prehash: ge } = q;
    let Ae, he;
    try {
      if (typeof G == "string" || G instanceof Uint8Array)
        try {
          Ae = y.fromDER(G);
        } catch (ne) {
          if (!(ne instanceof nd.Err))
            throw ne;
          Ae = y.fromCompact(G);
        }
      else if (typeof G == "object" && typeof G.r == "bigint" && typeof G.s == "bigint") {
        const { r: ne, s: ee } = G;
        Ae = new y(ne, ee);
      } else
        throw new Error("PARSE");
      he = l.fromHex(U);
    } catch (ne) {
      if (ne.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (ae && Ae.hasHighS())
      return !1;
    ge && (L = t.hash(L));
    const { r: B, s: be } = Ae, Be = x(L), Ne = c(be), _e = a(Be * Ne), Ce = a(B * Ne), N = (z = l.BASE.multiplyAndAddUnsafe(he, _e, Ce)) == null ? void 0 : z.toAffine();
    return N ? a(N.x) === B : !1;
  }
  return {
    CURVE: t,
    getPublicKey: b,
    getSharedSecret: A,
    sign: J,
    verify: we,
    ProjectivePoint: l,
    Signature: y,
    utils: v
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function WOe(e) {
  return {
    hash: e,
    hmac: (t, ...n) => UQ(e, t, IPe(...n)),
    randomBytes: PPe
  };
}
function GOe(e, t) {
  const n = (r) => HOe({ ...e, ...WOe(r) });
  return Object.freeze({ ...n(t), create: n });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const dK = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), K9 = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), qOe = BigInt(1), $T = BigInt(2), Y9 = (e, t) => (e + t / $T) / t;
function $Oe(e) {
  const t = dK, n = BigInt(3), r = BigInt(6), i = BigInt(11), s = BigInt(22), o = BigInt(23), a = BigInt(44), c = BigInt(88), l = e * e * e % t, u = l * l * e % t, d = as(u, n, t) * u % t, f = as(d, n, t) * u % t, p = as(f, $T, t) * l % t, m = as(p, i, t) * p % t, h = as(m, s, t) * m % t, g = as(h, a, t) * h % t, y = as(g, c, t) * g % t, v = as(y, a, t) * h % t, b = as(v, n, t) * u % t, w = as(b, o, t) * m % t, A = as(w, r, t) * l % t, E = as(A, $T, t);
  if (!QT.eql(QT.sqr(E), e))
    throw new Error("Cannot find square root");
  return E;
}
const QT = ROe(dK, void 0, void 0, { sqrt: $Oe }), rl = GOe({
  a: BigInt(0),
  b: BigInt(7),
  Fp: QT,
  n: K9,
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = K9, n = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), r = -qOe * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), s = n, o = BigInt("0x100000000000000000000000000000000"), a = Y9(s * e, t), c = Y9(-r * e, t);
      let l = Si(e - a * n - c * i, t), u = Si(-a * r - c * s, t);
      const d = l > o, f = u > o;
      if (d && (l = t - l), f && (u = t - u), l > o || u > o)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: d, k1: l, k2neg: f, k2: u };
    }
  }
}, zQ);
BigInt(0);
rl.ProjectivePoint;
const lb = "0x0000000000000000000000000000000000000000", Z9 = "0x0000000000000000000000000000000000000000000000000000000000000000", J9 = BigInt(0), X9 = BigInt(1), eM = BigInt(2), tM = BigInt(27), nM = BigInt(28), tw = BigInt(35), rh = {};
function rM(e) {
  return bf(ci(e), 32);
}
var Ep, _p, Sp, _d;
const Hs = class Hs {
  /**
   *  @private
   */
  constructor(t, n, r, i) {
    re(this, Ep, void 0);
    re(this, _p, void 0);
    re(this, Sp, void 0);
    re(this, _d, void 0);
    QE(t, rh, "Signature"), j(this, Ep, n), j(this, _p, r), j(this, Sp, i), j(this, _d, null);
  }
  /**
   *  The ``r`` value for a signautre.
   *
   *  This represents the ``x`` coordinate of a "reference" or
   *  challenge point, from which the ``y`` can be computed.
   */
  get r() {
    return C(this, Ep);
  }
  set r(t) {
    de(Jh(t) === 32, "invalid r", "value", t), j(this, Ep, Je(t));
  }
  /**
   *  The ``s`` value for a signature.
   */
  get s() {
    return C(this, _p);
  }
  set s(t) {
    de(Jh(t) === 32, "invalid s", "value", t);
    const n = Je(t);
    de(parseInt(n.substring(0, 3)) < 8, "non-canonical s", "value", n), j(this, _p, n);
  }
  /**
   *  The ``v`` value for a signature.
   *
   *  Since a given ``x`` value for ``r`` has two possible values for
   *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
   *  values to use.
   *
   *  It is normalized to the values ``27`` or ``28`` for legacy
   *  purposes.
   */
  get v() {
    return C(this, Sp);
  }
  set v(t) {
    const n = Ot(t, "value");
    de(n === 27 || n === 28, "invalid v", "v", t), j(this, Sp, n);
  }
  /**
   *  The EIP-155 ``v`` for legacy transactions. For non-legacy
   *  transactions, this value is ``null``.
   */
  get networkV() {
    return C(this, _d);
  }
  /**
   *  The chain ID for EIP-155 legacy transactions. For non-legacy
   *  transactions, this value is ``null``.
   */
  get legacyChainId() {
    const t = this.networkV;
    return t == null ? null : Hs.getChainId(t);
  }
  /**
   *  The ``yParity`` for the signature.
   *
   *  See ``v`` for more details on how this value is used.
   */
  get yParity() {
    return this.v === 27 ? 0 : 1;
  }
  /**
   *  The [[link-eip-2098]] compact representation of the ``yParity``
   *  and ``s`` compacted into a single ``bytes32``.
   */
  get yParityAndS() {
    const t = Ht(this.s);
    return this.yParity && (t[0] |= 128), Je(t);
  }
  /**
   *  The [[link-eip-2098]] compact representation.
   */
  get compactSerialized() {
    return Vn([this.r, this.yParityAndS]);
  }
  /**
   *  The serialized representation.
   */
  get serialized() {
    return Vn([this.r, this.s, this.yParity ? "0x1c" : "0x1b"]);
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
  }
  /**
   *  Returns a new identical [[Signature]].
   */
  clone() {
    const t = new Hs(rh, this.r, this.s, this.v);
    return this.networkV && j(t, _d, this.networkV), t;
  }
  /**
   *  Returns a representation that is compatible with ``JSON.stringify``.
   */
  toJSON() {
    const t = this.networkV;
    return {
      _type: "signature",
      networkV: t != null ? t.toString() : null,
      r: this.r,
      s: this.s,
      v: this.v
    };
  }
  /**
   *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
   *
   *  @example:
   *    Signature.getChainId(45)
   *    //_result:
   *
   *    Signature.getChainId(46)
   *    //_result:
   */
  static getChainId(t) {
    const n = nt(t, "v");
    return n == tM || n == nM ? J9 : (de(n >= tw, "invalid EIP-155 v", "v", t), (n - tw) / eM);
  }
  /**
   *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
   *
   *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
   *  property to include the chain ID.
   *
   *  @example:
   *    Signature.getChainIdV(5, 27)
   *    //_result:
   *
   *    Signature.getChainIdV(5, 28)
   *    //_result:
   *
   */
  static getChainIdV(t, n) {
    return nt(t) * eM + BigInt(35 + n - 27);
  }
  /**
   *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
   *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
   *
   *  @example:
   *    // The values 0 and 1 imply v is actually yParity
   *    Signature.getNormalizedV(0)
   *    //_result:
   *
   *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
   *    Signature.getNormalizedV(27)
   *    //_result:
   *
   *    // Legacy EIP-155 transaction (i.e. >= 35)
   *    Signature.getNormalizedV(46)
   *    //_result:
   *
   *    // Invalid values throw
   *    Signature.getNormalizedV(5)
   *    //_error:
   */
  static getNormalizedV(t) {
    const n = nt(t);
    return n === J9 || n === tM ? 27 : n === X9 || n === nM ? 28 : (de(n >= tw, "invalid v", "v", t), n & X9 ? 27 : 28);
  }
  /**
   *  Creates a new [[Signature]].
   *
   *  If no %%sig%% is provided, a new [[Signature]] is created
   *  with default values.
   *
   *  If %%sig%% is a string, it is parsed.
   */
  static from(t) {
    function n(l, u) {
      de(l, u, "signature", t);
    }
    if (t == null)
      return new Hs(rh, Z9, Z9, 27);
    if (typeof t == "string") {
      const l = Ht(t, "signature");
      if (l.length === 64) {
        const u = Je(l.slice(0, 32)), d = l.slice(32, 64), f = d[0] & 128 ? 28 : 27;
        return d[0] &= 127, new Hs(rh, u, Je(d), f);
      }
      if (l.length === 65) {
        const u = Je(l.slice(0, 32)), d = l.slice(32, 64);
        n((d[0] & 128) === 0, "non-canonical s");
        const f = Hs.getNormalizedV(l[64]);
        return new Hs(rh, u, Je(d), f);
      }
      n(!1, "invalid raw signature length");
    }
    if (t instanceof Hs)
      return t.clone();
    const r = t.r;
    n(r != null, "missing r");
    const i = rM(r), s = function(l, u) {
      if (l != null)
        return rM(l);
      if (u != null) {
        n(mn(u, 32), "invalid yParityAndS");
        const d = Ht(u);
        return d[0] &= 127, Je(d);
      }
      n(!1, "missing s");
    }(t.s, t.yParityAndS);
    n((Ht(s)[0] & 128) == 0, "non-canonical s");
    const { networkV: o, v: a } = function(l, u, d) {
      if (l != null) {
        const f = nt(l);
        return {
          networkV: f >= tw ? f : void 0,
          v: Hs.getNormalizedV(f)
        };
      }
      if (u != null)
        return n(mn(u, 32), "invalid yParityAndS"), { v: Ht(u)[0] & 128 ? 28 : 27 };
      if (d != null) {
        switch (Ot(d, "sig.yParity")) {
          case 0:
            return { v: 27 };
          case 1:
            return { v: 28 };
        }
        n(!1, "invalid yParity");
      }
      n(!1, "missing v");
    }(t.v, t.yParityAndS, t.yParity), c = new Hs(rh, i, s, a);
    return o && j(c, _d, o), n(t.yParity == null || Ot(t.yParity, "sig.yParity") === c.yParity, "yParity mismatch"), n(t.yParityAndS == null || t.yParityAndS === c.yParityAndS, "yParityAndS mismatch"), c;
  }
};
Ep = new WeakMap(), _p = new WeakMap(), Sp = new WeakMap(), _d = new WeakMap();
let bo = Hs;
var Ga;
const $u = class $u {
  /**
   *  Creates a new **SigningKey** for %%privateKey%%.
   */
  constructor(t) {
    re(this, Ga, void 0);
    de(Jh(t) === 32, "invalid private key", "privateKey", "[REDACTED]"), j(this, Ga, Je(t));
  }
  /**
   *  The private key.
   */
  get privateKey() {
    return C(this, Ga);
  }
  /**
   *  The uncompressed public key.
   *
   * This will always begin with the prefix ``0x04`` and be 132
   * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
   */
  get publicKey() {
    return $u.computePublicKey(C(this, Ga));
  }
  /**
   *  The compressed public key.
   *
   *  This will always begin with either the prefix ``0x02`` or ``0x03``
   *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
   *  nibbles)
   */
  get compressedPublicKey() {
    return $u.computePublicKey(C(this, Ga), !0);
  }
  /**
   *  Return the signature of the signed %%digest%%.
   */
  sign(t) {
    de(Jh(t) === 32, "invalid digest length", "digest", t);
    const n = rl.sign(si(t), si(C(this, Ga)), {
      lowS: !0
    });
    return bo.from({
      r: hu(n.r, 32),
      s: hu(n.s, 32),
      v: n.recovery ? 28 : 27
    });
  }
  /**
   *  Returns the [[link-wiki-ecdh]] shared secret between this
   *  private key and the %%other%% key.
   *
   *  The %%other%% key may be any type of key, a raw public key,
   *  a compressed/uncompressed pubic key or aprivate key.
   *
   *  Best practice is usually to use a cryptographic hash on the
   *  returned value before using it as a symetric secret.
   *
   *  @example:
   *    sign1 = new SigningKey(id("some-secret-1"))
   *    sign2 = new SigningKey(id("some-secret-2"))
   *
   *    // Notice that privA.computeSharedSecret(pubB)...
   *    sign1.computeSharedSecret(sign2.publicKey)
   *    //_result:
   *
   *    // ...is equal to privB.computeSharedSecret(pubA).
   *    sign2.computeSharedSecret(sign1.publicKey)
   *    //_result:
   */
  computeSharedSecret(t) {
    const n = $u.computePublicKey(t);
    return Je(rl.getSharedSecret(si(C(this, Ga)), Ht(n), !1));
  }
  /**
   *  Compute the public key for %%key%%, optionally %%compressed%%.
   *
   *  The %%key%% may be any type of key, a raw public key, a
   *  compressed/uncompressed public key or private key.
   *
   *  @example:
   *    sign = new SigningKey(id("some-secret"));
   *
   *    // Compute the uncompressed public key for a private key
   *    SigningKey.computePublicKey(sign.privateKey)
   *    //_result:
   *
   *    // Compute the compressed public key for a private key
   *    SigningKey.computePublicKey(sign.privateKey, true)
   *    //_result:
   *
   *    // Compute the uncompressed public key
   *    SigningKey.computePublicKey(sign.publicKey, false);
   *    //_result:
   *
   *    // Compute the Compressed a public key
   *    SigningKey.computePublicKey(sign.publicKey, true);
   *    //_result:
   */
  static computePublicKey(t, n) {
    let r = Ht(t, "key");
    if (r.length === 32) {
      const s = rl.getPublicKey(r, !!n);
      return Je(s);
    }
    if (r.length === 64) {
      const s = new Uint8Array(65);
      s[0] = 4, s.set(r, 1), r = s;
    }
    const i = rl.ProjectivePoint.fromHex(r);
    return Je(i.toRawBytes(n));
  }
  /**
   *  Returns the public key for the private key which produced the
   *  %%signature%% for the given %%digest%%.
   *
   *  @example:
   *    key = new SigningKey(id("some-secret"))
   *    digest = id("hello world")
   *    sig = key.sign(digest)
   *
   *    // Notice the signer public key...
   *    key.publicKey
   *    //_result:
   *
   *    // ...is equal to the recovered public key
   *    SigningKey.recoverPublicKey(digest, sig)
   *    //_result:
   *
   */
  static recoverPublicKey(t, n) {
    de(Jh(t) === 32, "invalid digest length", "digest", t);
    const r = bo.from(n);
    let i = rl.Signature.fromCompact(si(Vn([r.r, r.s])));
    i = i.addRecoveryBit(r.yParity);
    const s = i.recoverPublicKey(si(t));
    return de(s != null, "invalid signautre for digest", "signature", n), "0x" + s.toHex(!1);
  }
  /**
   *  Returns the point resulting from adding the ellipic curve points
   *  %%p0%% and %%p1%%.
   *
   *  This is not a common function most developers should require, but
   *  can be useful for certain privacy-specific techniques.
   *
   *  For example, it is used by [[HDNodeWallet]] to compute child
   *  addresses from parent public keys and chain codes.
   */
  static addPoints(t, n, r) {
    const i = rl.ProjectivePoint.fromHex($u.computePublicKey(t).substring(2)), s = rl.ProjectivePoint.fromHex($u.computePublicKey(n).substring(2));
    return "0x" + i.add(s).toHex(!!r);
  }
};
Ga = new WeakMap();
let ub = $u;
const QOe = BigInt(0), KOe = BigInt(36);
function iM(e) {
  e = e.toLowerCase();
  const t = e.substring(2).split(""), n = new Uint8Array(40);
  for (let i = 0; i < 40; i++)
    n[i] = t[i].charCodeAt(0);
  const r = Ht(Yn(n));
  for (let i = 0; i < 40; i += 2)
    r[i >> 1] >> 4 >= 8 && (t[i] = t[i].toUpperCase()), (r[i >> 1] & 15) >= 8 && (t[i + 1] = t[i + 1].toUpperCase());
  return "0x" + t.join("");
}
const fB = {};
for (let e = 0; e < 10; e++)
  fB[String(e)] = String(e);
for (let e = 0; e < 26; e++)
  fB[String.fromCharCode(65 + e)] = String(10 + e);
const sM = 15;
function YOe(e) {
  e = e.toUpperCase(), e = e.substring(4) + e.substring(0, 2) + "00";
  let t = e.split("").map((r) => fB[r]).join("");
  for (; t.length >= sM; ) {
    let r = t.substring(0, sM);
    t = parseInt(r, 10) % 97 + t.substring(r.length);
  }
  let n = String(98 - parseInt(t, 10) % 97);
  for (; n.length < 2; )
    n = "0" + n;
  return n;
}
const ZOe = function() {
  const e = {};
  for (let t = 0; t < 36; t++) {
    const n = "0123456789abcdefghijklmnopqrstuvwxyz"[t];
    e[n] = BigInt(t);
  }
  return e;
}();
function JOe(e) {
  e = e.toLowerCase();
  let t = QOe;
  for (let n = 0; n < e.length; n++)
    t = t * KOe + ZOe[e[n]];
  return t;
}
function ln(e) {
  if (de(typeof e == "string", "invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    e.startsWith("0x") || (e = "0x" + e);
    const t = iM(e);
    return de(!e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || t === e, "bad address checksum", "address", e), t;
  }
  if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    de(e.substring(2, 4) === YOe(e), "bad icap checksum", "address", e);
    let t = JOe(e.substring(4)).toString(16);
    for (; t.length < 40; )
      t = "0" + t;
    return iM("0x" + t);
  }
  de(!1, "invalid address", "address", e);
}
function XOe(e) {
  const t = ln(e.from);
  let r = nt(e.nonce, "tx.nonce").toString(16);
  return r === "0" ? r = "0x" : r.length % 2 ? r = "0x0" + r : r = "0x" + r, ln(Pn(Yn(vf([t, r])), 12));
}
function fK(e) {
  return e && typeof e.getAddress == "function";
}
async function k6(e, t) {
  const n = await t;
  return (n == null || n === "0x0000000000000000000000000000000000000000") && (Pe(typeof e != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: e }), de(!1, "invalid AddressLike value; did not resolve to a value address", "target", e)), ln(n);
}
function ui(e, t) {
  if (typeof e == "string")
    return e.match(/^0x[0-9a-f]{40}$/i) ? ln(e) : (Pe(t != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), k6(e, t.resolveName(e)));
  if (fK(e))
    return k6(e, e.getAddress());
  if (e && typeof e.then == "function")
    return k6(e, e);
  de(!1, "unsupported addressable value", "target", e);
}
const ja = {};
function Ze(e, t) {
  let n = !1;
  return t < 0 && (n = !0, t *= -1), new qr(ja, `${n ? "" : "u"}int${t}`, e, { signed: n, width: t });
}
function qt(e, t) {
  return new qr(ja, `bytes${t || ""}`, e, { size: t });
}
const oM = Symbol.for("_ethers_typed");
var Sd;
const Da = class Da {
  /**
   *  @_ignore:
   */
  constructor(t, n, r, i) {
    /**
     *  The type, as a Solidity-compatible type.
     */
    pe(this, "type");
    /**
     *  The actual value.
     */
    pe(this, "value");
    re(this, Sd, void 0);
    /**
     *  @_ignore:
     */
    pe(this, "_typedSymbol");
    i == null && (i = null), QE(ja, t, "Typed"), ft(this, { _typedSymbol: oM, type: n, value: r }), j(this, Sd, i), this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  format() {
    if (this.type === "array")
      throw new Error("");
    if (this.type === "dynamicArray")
      throw new Error("");
    return this.type === "tuple" ? `tuple(${this.value.map((t) => t.format()).join(",")})` : this.type;
  }
  /**
   *  The default value returned by this type.
   */
  defaultValue() {
    return 0;
  }
  /**
   *  The minimum value for numeric types.
   */
  minValue() {
    return 0;
  }
  /**
   *  The maximum value for numeric types.
   */
  maxValue() {
    return 0;
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
   */
  isBigInt() {
    return !!this.type.match(/^u?int[0-9]+$/);
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
   */
  isData() {
    return this.type.startsWith("bytes");
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
   */
  isString() {
    return this.type === "string";
  }
  /**
   *  Returns the tuple name, if this is a tuple. Throws otherwise.
   */
  get tupleName() {
    if (this.type !== "tuple")
      throw TypeError("not a tuple");
    return C(this, Sd);
  }
  // Returns the length of this type as an array
  // - `null` indicates the length is unforced, it could be dynamic
  // - `-1` indicates the length is dynamic
  // - any other value indicates it is a static array and is its length
  /**
   *  Returns the length of the array type or ``-1`` if it is dynamic.
   *
   *  Throws if the type is not an array.
   */
  get arrayLength() {
    if (this.type !== "array")
      throw TypeError("not an array");
    return C(this, Sd) === !0 ? -1 : C(this, Sd) === !1 ? this.value.length : null;
  }
  /**
   *  Returns a new **Typed** of %%type%% with the %%value%%.
   */
  static from(t, n) {
    return new Da(ja, t, n);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static uint8(t) {
    return Ze(t, 8);
  }
  /**
   *  Return a new ``uint16`` type for %%v%%.
   */
  static uint16(t) {
    return Ze(t, 16);
  }
  /**
   *  Return a new ``uint24`` type for %%v%%.
   */
  static uint24(t) {
    return Ze(t, 24);
  }
  /**
   *  Return a new ``uint32`` type for %%v%%.
   */
  static uint32(t) {
    return Ze(t, 32);
  }
  /**
   *  Return a new ``uint40`` type for %%v%%.
   */
  static uint40(t) {
    return Ze(t, 40);
  }
  /**
   *  Return a new ``uint48`` type for %%v%%.
   */
  static uint48(t) {
    return Ze(t, 48);
  }
  /**
   *  Return a new ``uint56`` type for %%v%%.
   */
  static uint56(t) {
    return Ze(t, 56);
  }
  /**
   *  Return a new ``uint64`` type for %%v%%.
   */
  static uint64(t) {
    return Ze(t, 64);
  }
  /**
   *  Return a new ``uint72`` type for %%v%%.
   */
  static uint72(t) {
    return Ze(t, 72);
  }
  /**
   *  Return a new ``uint80`` type for %%v%%.
   */
  static uint80(t) {
    return Ze(t, 80);
  }
  /**
   *  Return a new ``uint88`` type for %%v%%.
   */
  static uint88(t) {
    return Ze(t, 88);
  }
  /**
   *  Return a new ``uint96`` type for %%v%%.
   */
  static uint96(t) {
    return Ze(t, 96);
  }
  /**
   *  Return a new ``uint104`` type for %%v%%.
   */
  static uint104(t) {
    return Ze(t, 104);
  }
  /**
   *  Return a new ``uint112`` type for %%v%%.
   */
  static uint112(t) {
    return Ze(t, 112);
  }
  /**
   *  Return a new ``uint120`` type for %%v%%.
   */
  static uint120(t) {
    return Ze(t, 120);
  }
  /**
   *  Return a new ``uint128`` type for %%v%%.
   */
  static uint128(t) {
    return Ze(t, 128);
  }
  /**
   *  Return a new ``uint136`` type for %%v%%.
   */
  static uint136(t) {
    return Ze(t, 136);
  }
  /**
   *  Return a new ``uint144`` type for %%v%%.
   */
  static uint144(t) {
    return Ze(t, 144);
  }
  /**
   *  Return a new ``uint152`` type for %%v%%.
   */
  static uint152(t) {
    return Ze(t, 152);
  }
  /**
   *  Return a new ``uint160`` type for %%v%%.
   */
  static uint160(t) {
    return Ze(t, 160);
  }
  /**
   *  Return a new ``uint168`` type for %%v%%.
   */
  static uint168(t) {
    return Ze(t, 168);
  }
  /**
   *  Return a new ``uint176`` type for %%v%%.
   */
  static uint176(t) {
    return Ze(t, 176);
  }
  /**
   *  Return a new ``uint184`` type for %%v%%.
   */
  static uint184(t) {
    return Ze(t, 184);
  }
  /**
   *  Return a new ``uint192`` type for %%v%%.
   */
  static uint192(t) {
    return Ze(t, 192);
  }
  /**
   *  Return a new ``uint200`` type for %%v%%.
   */
  static uint200(t) {
    return Ze(t, 200);
  }
  /**
   *  Return a new ``uint208`` type for %%v%%.
   */
  static uint208(t) {
    return Ze(t, 208);
  }
  /**
   *  Return a new ``uint216`` type for %%v%%.
   */
  static uint216(t) {
    return Ze(t, 216);
  }
  /**
   *  Return a new ``uint224`` type for %%v%%.
   */
  static uint224(t) {
    return Ze(t, 224);
  }
  /**
   *  Return a new ``uint232`` type for %%v%%.
   */
  static uint232(t) {
    return Ze(t, 232);
  }
  /**
   *  Return a new ``uint240`` type for %%v%%.
   */
  static uint240(t) {
    return Ze(t, 240);
  }
  /**
   *  Return a new ``uint248`` type for %%v%%.
   */
  static uint248(t) {
    return Ze(t, 248);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint256(t) {
    return Ze(t, 256);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint(t) {
    return Ze(t, 256);
  }
  /**
   *  Return a new ``int8`` type for %%v%%.
   */
  static int8(t) {
    return Ze(t, -8);
  }
  /**
   *  Return a new ``int16`` type for %%v%%.
   */
  static int16(t) {
    return Ze(t, -16);
  }
  /**
   *  Return a new ``int24`` type for %%v%%.
   */
  static int24(t) {
    return Ze(t, -24);
  }
  /**
   *  Return a new ``int32`` type for %%v%%.
   */
  static int32(t) {
    return Ze(t, -32);
  }
  /**
   *  Return a new ``int40`` type for %%v%%.
   */
  static int40(t) {
    return Ze(t, -40);
  }
  /**
   *  Return a new ``int48`` type for %%v%%.
   */
  static int48(t) {
    return Ze(t, -48);
  }
  /**
   *  Return a new ``int56`` type for %%v%%.
   */
  static int56(t) {
    return Ze(t, -56);
  }
  /**
   *  Return a new ``int64`` type for %%v%%.
   */
  static int64(t) {
    return Ze(t, -64);
  }
  /**
   *  Return a new ``int72`` type for %%v%%.
   */
  static int72(t) {
    return Ze(t, -72);
  }
  /**
   *  Return a new ``int80`` type for %%v%%.
   */
  static int80(t) {
    return Ze(t, -80);
  }
  /**
   *  Return a new ``int88`` type for %%v%%.
   */
  static int88(t) {
    return Ze(t, -88);
  }
  /**
   *  Return a new ``int96`` type for %%v%%.
   */
  static int96(t) {
    return Ze(t, -96);
  }
  /**
   *  Return a new ``int104`` type for %%v%%.
   */
  static int104(t) {
    return Ze(t, -104);
  }
  /**
   *  Return a new ``int112`` type for %%v%%.
   */
  static int112(t) {
    return Ze(t, -112);
  }
  /**
   *  Return a new ``int120`` type for %%v%%.
   */
  static int120(t) {
    return Ze(t, -120);
  }
  /**
   *  Return a new ``int128`` type for %%v%%.
   */
  static int128(t) {
    return Ze(t, -128);
  }
  /**
   *  Return a new ``int136`` type for %%v%%.
   */
  static int136(t) {
    return Ze(t, -136);
  }
  /**
   *  Return a new ``int144`` type for %%v%%.
   */
  static int144(t) {
    return Ze(t, -144);
  }
  /**
   *  Return a new ``int52`` type for %%v%%.
   */
  static int152(t) {
    return Ze(t, -152);
  }
  /**
   *  Return a new ``int160`` type for %%v%%.
   */
  static int160(t) {
    return Ze(t, -160);
  }
  /**
   *  Return a new ``int168`` type for %%v%%.
   */
  static int168(t) {
    return Ze(t, -168);
  }
  /**
   *  Return a new ``int176`` type for %%v%%.
   */
  static int176(t) {
    return Ze(t, -176);
  }
  /**
   *  Return a new ``int184`` type for %%v%%.
   */
  static int184(t) {
    return Ze(t, -184);
  }
  /**
   *  Return a new ``int92`` type for %%v%%.
   */
  static int192(t) {
    return Ze(t, -192);
  }
  /**
   *  Return a new ``int200`` type for %%v%%.
   */
  static int200(t) {
    return Ze(t, -200);
  }
  /**
   *  Return a new ``int208`` type for %%v%%.
   */
  static int208(t) {
    return Ze(t, -208);
  }
  /**
   *  Return a new ``int216`` type for %%v%%.
   */
  static int216(t) {
    return Ze(t, -216);
  }
  /**
   *  Return a new ``int224`` type for %%v%%.
   */
  static int224(t) {
    return Ze(t, -224);
  }
  /**
   *  Return a new ``int232`` type for %%v%%.
   */
  static int232(t) {
    return Ze(t, -232);
  }
  /**
   *  Return a new ``int240`` type for %%v%%.
   */
  static int240(t) {
    return Ze(t, -240);
  }
  /**
   *  Return a new ``int248`` type for %%v%%.
   */
  static int248(t) {
    return Ze(t, -248);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int256(t) {
    return Ze(t, -256);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int(t) {
    return Ze(t, -256);
  }
  /**
   *  Return a new ``bytes1`` type for %%v%%.
   */
  static bytes1(t) {
    return qt(t, 1);
  }
  /**
   *  Return a new ``bytes2`` type for %%v%%.
   */
  static bytes2(t) {
    return qt(t, 2);
  }
  /**
   *  Return a new ``bytes3`` type for %%v%%.
   */
  static bytes3(t) {
    return qt(t, 3);
  }
  /**
   *  Return a new ``bytes4`` type for %%v%%.
   */
  static bytes4(t) {
    return qt(t, 4);
  }
  /**
   *  Return a new ``bytes5`` type for %%v%%.
   */
  static bytes5(t) {
    return qt(t, 5);
  }
  /**
   *  Return a new ``bytes6`` type for %%v%%.
   */
  static bytes6(t) {
    return qt(t, 6);
  }
  /**
   *  Return a new ``bytes7`` type for %%v%%.
   */
  static bytes7(t) {
    return qt(t, 7);
  }
  /**
   *  Return a new ``bytes8`` type for %%v%%.
   */
  static bytes8(t) {
    return qt(t, 8);
  }
  /**
   *  Return a new ``bytes9`` type for %%v%%.
   */
  static bytes9(t) {
    return qt(t, 9);
  }
  /**
   *  Return a new ``bytes10`` type for %%v%%.
   */
  static bytes10(t) {
    return qt(t, 10);
  }
  /**
   *  Return a new ``bytes11`` type for %%v%%.
   */
  static bytes11(t) {
    return qt(t, 11);
  }
  /**
   *  Return a new ``bytes12`` type for %%v%%.
   */
  static bytes12(t) {
    return qt(t, 12);
  }
  /**
   *  Return a new ``bytes13`` type for %%v%%.
   */
  static bytes13(t) {
    return qt(t, 13);
  }
  /**
   *  Return a new ``bytes14`` type for %%v%%.
   */
  static bytes14(t) {
    return qt(t, 14);
  }
  /**
   *  Return a new ``bytes15`` type for %%v%%.
   */
  static bytes15(t) {
    return qt(t, 15);
  }
  /**
   *  Return a new ``bytes16`` type for %%v%%.
   */
  static bytes16(t) {
    return qt(t, 16);
  }
  /**
   *  Return a new ``bytes17`` type for %%v%%.
   */
  static bytes17(t) {
    return qt(t, 17);
  }
  /**
   *  Return a new ``bytes18`` type for %%v%%.
   */
  static bytes18(t) {
    return qt(t, 18);
  }
  /**
   *  Return a new ``bytes19`` type for %%v%%.
   */
  static bytes19(t) {
    return qt(t, 19);
  }
  /**
   *  Return a new ``bytes20`` type for %%v%%.
   */
  static bytes20(t) {
    return qt(t, 20);
  }
  /**
   *  Return a new ``bytes21`` type for %%v%%.
   */
  static bytes21(t) {
    return qt(t, 21);
  }
  /**
   *  Return a new ``bytes22`` type for %%v%%.
   */
  static bytes22(t) {
    return qt(t, 22);
  }
  /**
   *  Return a new ``bytes23`` type for %%v%%.
   */
  static bytes23(t) {
    return qt(t, 23);
  }
  /**
   *  Return a new ``bytes24`` type for %%v%%.
   */
  static bytes24(t) {
    return qt(t, 24);
  }
  /**
   *  Return a new ``bytes25`` type for %%v%%.
   */
  static bytes25(t) {
    return qt(t, 25);
  }
  /**
   *  Return a new ``bytes26`` type for %%v%%.
   */
  static bytes26(t) {
    return qt(t, 26);
  }
  /**
   *  Return a new ``bytes27`` type for %%v%%.
   */
  static bytes27(t) {
    return qt(t, 27);
  }
  /**
   *  Return a new ``bytes28`` type for %%v%%.
   */
  static bytes28(t) {
    return qt(t, 28);
  }
  /**
   *  Return a new ``bytes29`` type for %%v%%.
   */
  static bytes29(t) {
    return qt(t, 29);
  }
  /**
   *  Return a new ``bytes30`` type for %%v%%.
   */
  static bytes30(t) {
    return qt(t, 30);
  }
  /**
   *  Return a new ``bytes31`` type for %%v%%.
   */
  static bytes31(t) {
    return qt(t, 31);
  }
  /**
   *  Return a new ``bytes32`` type for %%v%%.
   */
  static bytes32(t) {
    return qt(t, 32);
  }
  /**
   *  Return a new ``address`` type for %%v%%.
   */
  static address(t) {
    return new Da(ja, "address", t);
  }
  /**
   *  Return a new ``bool`` type for %%v%%.
   */
  static bool(t) {
    return new Da(ja, "bool", !!t);
  }
  /**
   *  Return a new ``bytes`` type for %%v%%.
   */
  static bytes(t) {
    return new Da(ja, "bytes", t);
  }
  /**
   *  Return a new ``string`` type for %%v%%.
   */
  static string(t) {
    return new Da(ja, "string", t);
  }
  /**
   *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
   */
  static array(t, n) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
   */
  static tuple(t, n) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static overrides(t) {
    return new Da(ja, "overrides", Object.assign({}, t));
  }
  /**
   *  Returns true only if %%value%% is a [[Typed]] instance.
   */
  static isTyped(t) {
    return t && typeof t == "object" && "_typedSymbol" in t && t._typedSymbol === oM;
  }
  /**
   *  If the value is a [[Typed]] instance, validates the underlying value
   *  and returns it, otherwise returns value directly.
   *
   *  This is useful for functions that with to accept either a [[Typed]]
   *  object or values.
   */
  static dereference(t, n) {
    if (Da.isTyped(t)) {
      if (t.type !== n)
        throw new Error(`invalid type: expecetd ${n}, got ${t.type}`);
      return t.value;
    }
    return t;
  }
};
Sd = new WeakMap();
let qr = Da;
class e7e extends Oc {
  constructor(t) {
    super("address", "address", t, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(t, n) {
    let r = qr.dereference(n, "string");
    try {
      r = ln(r);
    } catch (i) {
      return this._throwError(i.message, n);
    }
    return t.writeValue(r);
  }
  decode(t) {
    return ln(hu(t.readValue(), 20));
  }
}
class t7e extends Oc {
  constructor(n) {
    super(n.name, n.type, "_", n.dynamic);
    pe(this, "coder");
    this.coder = n;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(n, r) {
    return this.coder.encode(n, r);
  }
  decode(n) {
    return this.coder.decode(n);
  }
}
function hK(e, t, n) {
  let r = [];
  if (Array.isArray(n))
    r = n;
  else if (n && typeof n == "object") {
    let c = {};
    r = t.map((l) => {
      const u = l.localName;
      return Pe(u, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: l }, value: n }), Pe(!c[u], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: l }, value: n }), c[u] = !0, n[u];
    });
  } else
    de(!1, "invalid tuple value", "tuple", n);
  de(t.length === r.length, "types/value length mismatch", "tuple", n);
  let i = new zT(), s = new zT(), o = [];
  t.forEach((c, l) => {
    let u = r[l];
    if (c.dynamic) {
      let d = s.length;
      c.encode(s, u);
      let f = i.writeUpdatableValue();
      o.push((p) => {
        f(p + d);
      });
    } else
      c.encode(i, u);
  }), o.forEach((c) => {
    c(i.length);
  });
  let a = e.appendWriter(i);
  return a += e.appendWriter(s), a;
}
function pK(e, t) {
  let n = [], r = [], i = e.subReader(0);
  return t.forEach((s) => {
    let o = null;
    if (s.dynamic) {
      let a = e.readIndex(), c = i.subReader(a);
      try {
        o = s.decode(c);
      } catch (l) {
        if (Wr(l, "BUFFER_OVERRUN"))
          throw l;
        o = l, o.baseType = s.name, o.name = s.localName, o.type = s.type;
      }
    } else
      try {
        o = s.decode(e);
      } catch (a) {
        if (Wr(a, "BUFFER_OVERRUN"))
          throw a;
        o = a, o.baseType = s.name, o.name = s.localName, o.type = s.type;
      }
    if (o == null)
      throw new Error("investigate");
    n.push(o), r.push(s.localName || null);
  }), L2.fromItems(n, r);
}
class n7e extends Oc {
  constructor(n, r, i) {
    const s = n.type + "[" + (r >= 0 ? r : "") + "]", o = r === -1 || n.dynamic;
    super("array", s, i, o);
    pe(this, "coder");
    pe(this, "length");
    ft(this, { coder: n, length: r });
  }
  defaultValue() {
    const n = this.coder.defaultValue(), r = [];
    for (let i = 0; i < this.length; i++)
      r.push(n);
    return r;
  }
  encode(n, r) {
    const i = qr.dereference(r, "array");
    Array.isArray(i) || this._throwError("expected array value", i);
    let s = this.length;
    s === -1 && (s = i.length, n.writeValue(i.length)), EQ(i.length, s, "coder array" + (this.localName ? " " + this.localName : ""));
    let o = [];
    for (let a = 0; a < i.length; a++)
      o.push(this.coder);
    return hK(n, o, i);
  }
  decode(n) {
    let r = this.length;
    r === -1 && (r = n.readIndex(), Pe(r * li <= n.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: n.bytes, offset: r * li, length: n.dataLength }));
    let i = [];
    for (let s = 0; s < r; s++)
      i.push(new t7e(this.coder));
    return pK(n, i);
  }
}
class r7e extends Oc {
  constructor(t) {
    super("bool", "bool", t, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(t, n) {
    const r = qr.dereference(n, "bool");
    return t.writeValue(r ? 1 : 0);
  }
  decode(t) {
    return !!t.readValue();
  }
}
class mK extends Oc {
  constructor(t, n) {
    super(t, t, n, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(t, n) {
    n = si(n);
    let r = t.writeValue(n.length);
    return r += t.writeBytes(n), r;
  }
  decode(t) {
    return t.readBytes(t.readIndex(), !0);
  }
}
class i7e extends mK {
  constructor(t) {
    super("bytes", t);
  }
  decode(t) {
    return Je(super.decode(t));
  }
}
class s7e extends Oc {
  constructor(n, r) {
    let i = "bytes" + String(n);
    super(i, i, r, !1);
    pe(this, "size");
    ft(this, { size: n }, { size: "number" });
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(n, r) {
    let i = si(qr.dereference(r, this.type));
    return i.length !== this.size && this._throwError("incorrect data length", r), n.writeBytes(i);
  }
  decode(n) {
    return Je(n.readBytes(this.size));
  }
}
const o7e = new Uint8Array([]);
class a7e extends Oc {
  constructor(t) {
    super("null", "", t, !1);
  }
  defaultValue() {
    return null;
  }
  encode(t, n) {
    return n != null && this._throwError("not null", n), t.writeBytes(o7e);
  }
  decode(t) {
    return t.readBytes(0), null;
  }
}
const c7e = BigInt(0), l7e = BigInt(1), u7e = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class d7e extends Oc {
  constructor(n, r, i) {
    const s = (r ? "int" : "uint") + n * 8;
    super(s, s, i, !1);
    pe(this, "size");
    pe(this, "signed");
    ft(this, { size: n, signed: r }, { size: "number", signed: "boolean" });
  }
  defaultValue() {
    return 0;
  }
  encode(n, r) {
    let i = nt(qr.dereference(r, this.type)), s = rg(u7e, li * 8);
    if (this.signed) {
      let o = rg(s, this.size * 8 - 1);
      (i > o || i < -(o + l7e)) && this._throwError("value out-of-bounds", r), i = CQ(i, 8 * li);
    } else
      (i < c7e || i > rg(s, this.size * 8)) && this._throwError("value out-of-bounds", r);
    return n.writeValue(i);
  }
  decode(n) {
    let r = rg(n.readValue(), this.size * 8);
    return this.signed && (r = aPe(r, this.size * 8)), r;
  }
}
class f7e extends mK {
  constructor(t) {
    super("string", t);
  }
  defaultValue() {
    return "";
  }
  encode(t, n) {
    return super.encode(t, yc(qr.dereference(n, "string")));
  }
  decode(t) {
    return U2(super.decode(t));
  }
}
class nw extends Oc {
  constructor(n, r) {
    let i = !1;
    const s = [];
    n.forEach((a) => {
      a.dynamic && (i = !0), s.push(a.type);
    });
    const o = "tuple(" + s.join(",") + ")";
    super("tuple", o, r, i);
    pe(this, "coders");
    ft(this, { coders: Object.freeze(n.slice()) });
  }
  defaultValue() {
    const n = [];
    this.coders.forEach((i) => {
      n.push(i.defaultValue());
    });
    const r = this.coders.reduce((i, s) => {
      const o = s.localName;
      return o && (i[o] || (i[o] = 0), i[o]++), i;
    }, {});
    return this.coders.forEach((i, s) => {
      let o = i.localName;
      !o || r[o] !== 1 || (o === "length" && (o = "_length"), n[o] == null && (n[o] = n[s]));
    }), Object.freeze(n);
  }
  encode(n, r) {
    const i = qr.dereference(r, "tuple");
    return hK(n, this.coders, i);
  }
  decode(n) {
    return pK(n, this.coders);
  }
}
function wf(e) {
  return Yn(yc(e));
}
var h7e = "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";
const aM = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]), cM = 4;
function p7e(e) {
  let t = 0;
  function n() {
    return e[t++] << 8 | e[t++];
  }
  let r = n(), i = 1, s = [0, 1];
  for (let A = 1; A < r; A++)
    s.push(i += n());
  let o = n(), a = t;
  t += o;
  let c = 0, l = 0;
  function u() {
    return c == 0 && (l = l << 8 | e[t++], c = 8), l >> --c & 1;
  }
  const d = 31, f = 2 ** d, p = f >>> 1, m = p >> 1, h = f - 1;
  let g = 0;
  for (let A = 0; A < d; A++)
    g = g << 1 | u();
  let y = [], v = 0, b = f;
  for (; ; ) {
    let A = Math.floor(((g - v + 1) * i - 1) / b), E = 0, x = r;
    for (; x - E > 1; ) {
      let I = E + x >>> 1;
      A < s[I] ? x = I : E = I;
    }
    if (E == 0)
      break;
    y.push(E);
    let S = v + Math.floor(b * s[E] / i), P = v + Math.floor(b * s[E + 1] / i) - 1;
    for (; !((S ^ P) & p); )
      g = g << 1 & h | u(), S = S << 1 & h, P = P << 1 & h | 1;
    for (; S & ~P & m; )
      g = g & p | g << 1 & h >>> 1 | u(), S = S << 1 ^ p, P = (P ^ p) << 1 | p | 1;
    v = S, b = 1 + P - S;
  }
  let w = r - 4;
  return y.map((A) => {
    switch (A - w) {
      case 3:
        return w + 65792 + (e[a++] << 16 | e[a++] << 8 | e[a++]);
      case 2:
        return w + 256 + (e[a++] << 8 | e[a++]);
      case 1:
        return w + e[a++];
      default:
        return A - 1;
    }
  });
}
function m7e(e) {
  let t = 0;
  return () => e[t++];
}
function gK(e) {
  return m7e(p7e(g7e(e)));
}
function g7e(e) {
  let t = [];
  [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((i, s) => t[i.charCodeAt(0)] = s);
  let n = e.length, r = new Uint8Array(6 * n >> 3);
  for (let i = 0, s = 0, o = 0, a = 0; i < n; i++)
    a = a << 6 | t[e.charCodeAt(i)], o += 6, o >= 8 && (r[s++] = a >> (o -= 8));
  return r;
}
function y7e(e) {
  return e & 1 ? ~e >> 1 : e >> 1;
}
function b7e(e, t) {
  let n = Array(e);
  for (let r = 0, i = 0; r < e; r++)
    n[r] = i += y7e(t());
  return n;
}
function db(e, t = 0) {
  let n = [];
  for (; ; ) {
    let r = e(), i = e();
    if (!i)
      break;
    t += r;
    for (let s = 0; s < i; s++)
      n.push(t + s);
    t += i + 1;
  }
  return n;
}
function yK(e) {
  return fb(() => {
    let t = db(e);
    if (t.length)
      return t;
  });
}
function bK(e) {
  let t = [];
  for (; ; ) {
    let n = e();
    if (n == 0)
      break;
    t.push(v7e(n, e));
  }
  for (; ; ) {
    let n = e() - 1;
    if (n < 0)
      break;
    t.push(w7e(n, e));
  }
  return t.flat();
}
function fb(e) {
  let t = [];
  for (; ; ) {
    let n = e(t.length);
    if (!n)
      break;
    t.push(n);
  }
  return t;
}
function vK(e, t, n) {
  let r = Array(e).fill().map(() => []);
  for (let i = 0; i < t; i++)
    b7e(e, n).forEach((s, o) => r[o].push(s));
  return r;
}
function v7e(e, t) {
  let n = 1 + t(), r = t(), i = fb(t);
  return vK(i.length, 1 + e, t).flatMap((o, a) => {
    let [c, ...l] = o;
    return Array(i[a]).fill().map((u, d) => {
      let f = d * r;
      return [c + d * n, l.map((p) => p + f)];
    });
  });
}
function w7e(e, t) {
  let n = 1 + t();
  return vK(n, 1 + e, t).map((i) => [i[0], i.slice(1)]);
}
function x7e(e) {
  let t = [], n = db(e);
  return i(r([]), []), t;
  function r(s) {
    let o = e(), a = fb(() => {
      let c = db(e).map((l) => n[l]);
      if (c.length)
        return r(c);
    });
    return { S: o, B: a, Q: s };
  }
  function i({ S: s, B: o }, a, c) {
    if (!(s & 4 && c === a[a.length - 1])) {
      s & 2 && (c = a[a.length - 1]), s & 1 && t.push(a);
      for (let l of o)
        for (let u of l.Q)
          i(l, [...a, u], c);
    }
  }
}
function A7e(e) {
  return e.toString(16).toUpperCase().padStart(2, "0");
}
function wK(e) {
  return `{${A7e(e)}}`;
}
function E7e(e) {
  let t = [];
  for (let n = 0, r = e.length; n < r; ) {
    let i = e.codePointAt(n);
    n += i < 65536 ? 1 : 2, t.push(i);
  }
  return t;
}
function Hm(e) {
  let n = e.length;
  if (n < 4096)
    return String.fromCodePoint(...e);
  let r = [];
  for (let i = 0; i < n; )
    r.push(String.fromCodePoint(...e.slice(i, i += 4096)));
  return r.join("");
}
function _7e(e, t) {
  let n = e.length, r = n - t.length;
  for (let i = 0; r == 0 && i < n; i++)
    r = e[i] - t[i];
  return r;
}
var S7e = "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";
const hb = 44032, V2 = 4352, H2 = 4449, W2 = 4519, xK = 19, AK = 21, Wm = 28, G2 = AK * Wm, C7e = xK * G2, T7e = hb + C7e, k7e = V2 + xK, B7e = H2 + AK, I7e = W2 + Wm;
function sg(e) {
  return e >> 24 & 255;
}
function EK(e) {
  return e & 16777215;
}
let KT, lM, YT, ax;
function P7e() {
  let e = gK(S7e);
  KT = new Map(yK(e).flatMap((t, n) => t.map((r) => [r, n + 1 << 24]))), lM = new Set(db(e)), YT = /* @__PURE__ */ new Map(), ax = /* @__PURE__ */ new Map();
  for (let [t, n] of bK(e)) {
    if (!lM.has(t) && n.length == 2) {
      let [r, i] = n, s = ax.get(r);
      s || (s = /* @__PURE__ */ new Map(), ax.set(r, s)), s.set(i, t);
    }
    YT.set(t, n.reverse());
  }
}
function _K(e) {
  return e >= hb && e < T7e;
}
function O7e(e, t) {
  if (e >= V2 && e < k7e && t >= H2 && t < B7e)
    return hb + (e - V2) * G2 + (t - H2) * Wm;
  if (_K(e) && t > W2 && t < I7e && (e - hb) % Wm == 0)
    return e + (t - W2);
  {
    let n = ax.get(e);
    return n && (n = n.get(t), n) ? n : -1;
  }
}
function SK(e) {
  KT || P7e();
  let t = [], n = [], r = !1;
  function i(s) {
    let o = KT.get(s);
    o && (r = !0, s |= o), t.push(s);
  }
  for (let s of e)
    for (; ; ) {
      if (s < 128)
        t.push(s);
      else if (_K(s)) {
        let o = s - hb, a = o / G2 | 0, c = o % G2 / Wm | 0, l = o % Wm;
        i(V2 + a), i(H2 + c), l > 0 && i(W2 + l);
      } else {
        let o = YT.get(s);
        o ? n.push(...o) : i(s);
      }
      if (!n.length)
        break;
      s = n.pop();
    }
  if (r && t.length > 1) {
    let s = sg(t[0]);
    for (let o = 1; o < t.length; o++) {
      let a = sg(t[o]);
      if (a == 0 || s <= a) {
        s = a;
        continue;
      }
      let c = o - 1;
      for (; ; ) {
        let l = t[c + 1];
        if (t[c + 1] = t[c], t[c] = l, !c || (s = sg(t[--c]), s <= a))
          break;
      }
      s = sg(t[o]);
    }
  }
  return t;
}
function N7e(e) {
  let t = [], n = [], r = -1, i = 0;
  for (let s of e) {
    let o = sg(s), a = EK(s);
    if (r == -1)
      o == 0 ? r = a : t.push(a);
    else if (i > 0 && i >= o)
      o == 0 ? (t.push(r, ...n), n.length = 0, r = a) : n.push(a), i = o;
    else {
      let c = O7e(r, a);
      c >= 0 ? r = c : i == 0 && o == 0 ? (t.push(r), r = a) : (n.push(a), i = o);
    }
  }
  return r >= 0 && t.push(r, ...n), t;
}
function CK(e) {
  return SK(e).map(EK);
}
function R7e(e) {
  return N7e(SK(e));
}
const uM = 45, TK = ".", kK = 65039, BK = 1, q2 = (e) => Array.from(e);
function pb(e, t) {
  return e.P.has(t) || e.Q.has(t);
}
class M7e extends Array {
  get is_emoji() {
    return !0;
  }
  // free tagging system
}
let ZT, IK, rd, JT, PK, Xh, B6, fh, Mu, dM, XT;
function hB() {
  if (ZT)
    return;
  let e = gK(h7e);
  const t = () => db(e), n = () => new Set(t()), r = (u, d) => d.forEach((f) => u.add(f));
  ZT = new Map(bK(e)), IK = n(), rd = t(), JT = new Set(t().map((u) => rd[u])), rd = new Set(rd), PK = n(), n();
  let i = yK(e), s = e();
  const o = () => {
    let u = /* @__PURE__ */ new Set();
    return t().forEach((d) => r(u, i[d])), r(u, t()), u;
  };
  Xh = fb((u) => {
    let d = fb(e).map((f) => f + 96);
    if (d.length) {
      let f = u >= s;
      d[0] -= 32, d = Hm(d), f && (d = `Restricted[${d}]`);
      let p = o(), m = o(), h = !e();
      return { N: d, P: p, Q: m, M: h, R: f };
    }
  }), B6 = n(), fh = /* @__PURE__ */ new Map();
  let a = t().concat(q2(B6)).sort((u, d) => u - d);
  a.forEach((u, d) => {
    let f = e(), p = a[d] = f ? a[d - f] : { V: [], M: /* @__PURE__ */ new Map() };
    p.V.push(u), B6.has(u) || fh.set(u, p);
  });
  for (let { V: u, M: d } of new Set(fh.values())) {
    let f = [];
    for (let m of u) {
      let h = Xh.filter((y) => pb(y, m)), g = f.find(({ G: y }) => h.some((v) => y.has(v)));
      g || (g = { G: /* @__PURE__ */ new Set(), V: [] }, f.push(g)), g.V.push(m), r(g.G, h);
    }
    let p = f.flatMap((m) => q2(m.G));
    for (let { G: m, V: h } of f) {
      let g = new Set(p.filter((y) => !m.has(y)));
      for (let y of h)
        d.set(y, g);
    }
  }
  Mu = /* @__PURE__ */ new Set();
  let c = /* @__PURE__ */ new Set();
  const l = (u) => Mu.has(u) ? c.add(u) : Mu.add(u);
  for (let u of Xh) {
    for (let d of u.P)
      l(d);
    for (let d of u.Q)
      l(d);
  }
  for (let u of Mu)
    !fh.has(u) && !c.has(u) && fh.set(u, BK);
  r(Mu, CK(Mu)), dM = x7e(e).map((u) => M7e.from(u)).sort(_7e), XT = /* @__PURE__ */ new Map();
  for (let u of dM) {
    let d = [XT];
    for (let f of u) {
      let p = d.map((m) => {
        let h = m.get(f);
        return h || (h = /* @__PURE__ */ new Map(), m.set(f, h)), h;
      });
      f === kK ? d.push(...p) : d = p;
    }
    for (let f of d)
      f.V = u;
  }
}
function pB(e) {
  return (OK(e) ? "" : `${mB(t3([e]))} `) + wK(e);
}
function mB(e) {
  return `"${e}"‎`;
}
function F7e(e) {
  if (e.length >= 4 && e[2] == uM && e[3] == uM)
    throw new Error(`invalid label extension: "${Hm(e.slice(0, 4))}"`);
}
function j7e(e) {
  for (let n = e.lastIndexOf(95); n > 0; )
    if (e[--n] !== 95)
      throw new Error("underscore allowed only at start");
}
function D7e(e) {
  let t = e[0], n = aM.get(t);
  if (n)
    throw zg(`leading ${n}`);
  let r = e.length, i = -1;
  for (let s = 1; s < r; s++) {
    t = e[s];
    let o = aM.get(t);
    if (o) {
      if (i == s)
        throw zg(`${n} + ${o}`);
      i = s + 1, n = o;
    }
  }
  if (i == r)
    throw zg(`trailing ${n}`);
}
function t3(e, t = 1 / 0, n = wK) {
  let r = [];
  U7e(e[0]) && r.push("◌"), e.length > t && (t >>= 1, e = [...e.slice(0, t), 8230, ...e.slice(-t)]);
  let i = 0, s = e.length;
  for (let o = 0; o < s; o++) {
    let a = e[o];
    OK(a) && (r.push(Hm(e.slice(i, o))), r.push(n(a)), i = o + 1);
  }
  return r.push(Hm(e.slice(i, s))), r.join("");
}
function U7e(e) {
  return hB(), rd.has(e);
}
function OK(e) {
  return hB(), PK.has(e);
}
function L7e(e) {
  return W7e(z7e(e, R7e, $7e));
}
function z7e(e, t, n) {
  if (!e)
    return [];
  hB();
  let r = 0;
  return e.split(TK).map((i) => {
    let s = E7e(i), o = {
      input: s,
      offset: r
      // codepoint, not substring!
    };
    r += s.length + 1;
    try {
      let a = o.tokens = q7e(s, t, n), c = a.length, l;
      if (!c)
        throw new Error("empty label");
      let u = o.output = a.flat();
      if (j7e(u), !(o.emoji = c > 1 || a[0].is_emoji) && u.every((f) => f < 128))
        F7e(u), l = "ASCII";
      else {
        let f = a.flatMap((p) => p.is_emoji ? [] : p);
        if (!f.length)
          l = "Emoji";
        else {
          if (rd.has(u[0]))
            throw zg("leading combining mark");
          for (let h = 1; h < c; h++) {
            let g = a[h];
            if (!g.is_emoji && rd.has(g[0]))
              throw zg(`emoji + combining mark: "${Hm(a[h - 1])} + ${t3([g[0]])}"`);
          }
          D7e(u);
          let p = q2(new Set(f)), [m] = H7e(p);
          G7e(m, f), V7e(m, p), l = m.N;
        }
      }
      o.type = l;
    } catch (a) {
      o.error = a;
    }
    return o;
  });
}
function V7e(e, t) {
  let n, r = [];
  for (let i of t) {
    let s = fh.get(i);
    if (s === BK)
      return;
    if (s) {
      let o = s.M.get(i);
      if (n = n ? n.filter((a) => o.has(a)) : q2(o), !n.length)
        return;
    } else
      r.push(i);
  }
  if (n) {
    for (let i of n)
      if (r.every((s) => pb(i, s)))
        throw new Error(`whole-script confusable: ${e.N}/${i.N}`);
  }
}
function H7e(e) {
  let t = Xh;
  for (let n of e) {
    let r = t.filter((i) => pb(i, n));
    if (!r.length)
      throw Xh.some((i) => pb(i, n)) ? RK(t[0], n) : NK(n);
    if (t = r, r.length == 1)
      break;
  }
  return t;
}
function W7e(e) {
  return e.map(({ input: t, error: n, output: r }) => {
    if (n) {
      let i = n.message;
      throw new Error(e.length == 1 ? i : `Invalid label ${mB(t3(t, 63))}: ${i}`);
    }
    return Hm(r);
  }).join(TK);
}
function NK(e) {
  return new Error(`disallowed character: ${pB(e)}`);
}
function RK(e, t) {
  let n = pB(t), r = Xh.find((i) => i.P.has(t));
  return r && (n = `${r.N} ${n}`), new Error(`illegal mixture: ${e.N} + ${n}`);
}
function zg(e) {
  return new Error(`illegal placement: ${e}`);
}
function G7e(e, t) {
  for (let n of t)
    if (!pb(e, n))
      throw RK(e, n);
  if (e.M) {
    let n = CK(t);
    for (let r = 1, i = n.length; r < i; r++)
      if (JT.has(n[r])) {
        let s = r + 1;
        for (let o; s < i && JT.has(o = n[s]); s++)
          for (let a = r; a < s; a++)
            if (n[a] == o)
              throw new Error(`duplicate non-spacing marks: ${pB(o)}`);
        if (s - r > cM)
          throw new Error(`excessive non-spacing marks: ${mB(t3(n.slice(r - 1, s)))} (${s - r}/${cM})`);
        r = s;
      }
  }
}
function q7e(e, t, n) {
  let r = [], i = [];
  for (e = e.slice().reverse(); e.length; ) {
    let s = Q7e(e);
    if (s)
      i.length && (r.push(t(i)), i = []), r.push(n(s));
    else {
      let o = e.pop();
      if (Mu.has(o))
        i.push(o);
      else {
        let a = ZT.get(o);
        if (a)
          i.push(...a);
        else if (!IK.has(o))
          throw NK(o);
      }
    }
  }
  return i.length && r.push(t(i)), r;
}
function $7e(e) {
  return e.filter((t) => t != kK);
}
function Q7e(e, t) {
  let n = XT, r, i = e.length;
  for (; i && (n = n.get(e[--i]), !!n); ) {
    let { V: s } = n;
    s && (r = s, e.length = i);
  }
  return r;
}
const MK = new Uint8Array(32);
MK.fill(0);
function fM(e) {
  return de(e.length !== 0, "invalid ENS name; empty component", "comp", e), e;
}
function FK(e) {
  const t = yc(K7e(e)), n = [];
  if (e.length === 0)
    return n;
  let r = 0;
  for (let i = 0; i < t.length; i++)
    t[i] === 46 && (n.push(fM(t.slice(r, i))), r = i + 1);
  return de(r < t.length, "invalid ENS name; empty component", "name", e), n.push(fM(t.slice(r))), n;
}
function K7e(e) {
  try {
    if (e.length === 0)
      throw new Error("empty label");
    return L7e(e);
  } catch (t) {
    de(!1, `invalid ENS name (${t.message})`, "name", e);
  }
}
function ek(e) {
  de(typeof e == "string", "invalid ENS name; not a string", "name", e), de(e.length, "invalid ENS name (empty label)", "name", e);
  let t = MK;
  const n = FK(e);
  for (; n.length; )
    t = Yn(Vn([t, Yn(n.pop())]));
  return Je(t);
}
function Y7e(e, t) {
  const n = t;
  return de(n <= 255, "DNS encoded label cannot exceed 255", "length", n), Je(Vn(FK(e).map((r) => {
    de(r.length <= n, `label ${JSON.stringify(e)} exceeds ${n} bytes`, "name", e);
    const i = new Uint8Array(r.length + 1);
    return i.set(r, 1), i[0] = i.length - 1, i;
  }))) + "00";
}
function I6(e, t) {
  return {
    address: ln(e),
    storageKeys: t.map((n, r) => (de(mn(n, 32), "invalid slot", `storageKeys[${r}]`, n), n.toLowerCase()))
  };
}
function Of(e) {
  if (Array.isArray(e))
    return e.map((n, r) => Array.isArray(n) ? (de(n.length === 2, "invalid slot set", `value[${r}]`, n), I6(n[0], n[1])) : (de(n != null && typeof n == "object", "invalid address-slot set", "value", e), I6(n.address, n.storageKeys)));
  de(e != null && typeof e == "object", "invalid access list", "value", e);
  const t = Object.keys(e).map((n) => {
    const r = e[n].reduce((i, s) => (i[s] = !0, i), {});
    return I6(n, Object.keys(r).sort());
  });
  return t.sort((n, r) => n.address.localeCompare(r.address)), t;
}
function Z7e(e) {
  let t;
  return typeof e == "string" ? t = ub.computePublicKey(e, !1) : t = e.publicKey, ln(Yn("0x" + t.substring(4)).substring(26));
}
function J7e(e, t) {
  return Z7e(ub.recoverPublicKey(e, t));
}
const fr = BigInt(0), X7e = BigInt(2), eNe = BigInt(27), tNe = BigInt(28), nNe = BigInt(35), rNe = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), P6 = 4096 * 32;
function hM(e, t) {
  let n = e.toString(16);
  for (; n.length < 2; )
    n = "0" + n;
  return n += l0(t).substring(4), "0x" + n;
}
function n3(e) {
  return e === "0x" ? null : ln(e);
}
function gB(e, t) {
  try {
    return Of(e);
  } catch (n) {
    de(!1, n.message, t, e);
  }
}
function Dv(e, t) {
  return e === "0x" ? 0 : Ot(e, t);
}
function Ln(e, t) {
  if (e === "0x")
    return fr;
  const n = nt(e, t);
  return de(n <= rNe, "value exceeds uint size", t, n), n;
}
function wn(e, t) {
  const n = nt(e, "value"), r = ci(n);
  return de(r.length <= 32, "value too large", `tx.${t}`, n), r;
}
function yB(e) {
  return Of(e).map((t) => [t.address, t.storageKeys]);
}
function iNe(e, t) {
  de(Array.isArray(e), `invalid ${t}`, "value", e);
  for (let n = 0; n < e.length; n++)
    de(mn(e[n], 32), "invalid ${ param } hash", `value[${n}]`, e[n]);
  return e;
}
function sNe(e) {
  const t = ZE(e);
  de(Array.isArray(t) && (t.length === 9 || t.length === 6), "invalid field count for legacy transaction", "data", e);
  const n = {
    type: 0,
    nonce: Dv(t[0], "nonce"),
    gasPrice: Ln(t[1], "gasPrice"),
    gasLimit: Ln(t[2], "gasLimit"),
    to: n3(t[3]),
    value: Ln(t[4], "value"),
    data: Je(t[5]),
    chainId: fr
  };
  if (t.length === 6)
    return n;
  const r = Ln(t[6], "v"), i = Ln(t[7], "r"), s = Ln(t[8], "s");
  if (i === fr && s === fr)
    n.chainId = r;
  else {
    let o = (r - nNe) / X7e;
    o < fr && (o = fr), n.chainId = o, de(o !== fr || r === eNe || r === tNe, "non-canonical legacy v", "v", t[6]), n.signature = bo.from({
      r: bf(t[7], 32),
      s: bf(t[8], 32),
      v: r
    });
  }
  return n;
}
function oNe(e, t) {
  const n = [
    wn(e.nonce, "nonce"),
    wn(e.gasPrice || 0, "gasPrice"),
    wn(e.gasLimit, "gasLimit"),
    e.to || "0x",
    wn(e.value, "value"),
    e.data
  ];
  let r = fr;
  if (e.chainId != fr)
    r = nt(e.chainId, "tx.chainId"), de(!t || t.networkV == null || t.legacyChainId === r, "tx.chainId/sig.v mismatch", "sig", t);
  else if (e.signature) {
    const s = e.signature.legacyChainId;
    s != null && (r = s);
  }
  if (!t)
    return r !== fr && (n.push(ci(r)), n.push("0x"), n.push("0x")), vf(n);
  let i = BigInt(27 + t.yParity);
  return r !== fr ? i = bo.getChainIdV(r, t.v) : BigInt(t.v) !== i && de(!1, "tx.chainId/sig.v mismatch", "sig", t), n.push(ci(i)), n.push(ci(t.r)), n.push(ci(t.s)), vf(n);
}
function bB(e, t) {
  let n;
  try {
    if (n = Dv(t[0], "yParity"), n !== 0 && n !== 1)
      throw new Error("bad yParity");
  } catch {
    de(!1, "invalid yParity", "yParity", t[0]);
  }
  const r = bf(t[1], 32), i = bf(t[2], 32), s = bo.from({ r, s: i, yParity: n });
  e.signature = s;
}
function aNe(e) {
  const t = ZE(Ht(e).slice(1));
  de(Array.isArray(t) && (t.length === 9 || t.length === 12), "invalid field count for transaction type: 2", "data", Je(e));
  const n = {
    type: 2,
    chainId: Ln(t[0], "chainId"),
    nonce: Dv(t[1], "nonce"),
    maxPriorityFeePerGas: Ln(t[2], "maxPriorityFeePerGas"),
    maxFeePerGas: Ln(t[3], "maxFeePerGas"),
    gasPrice: null,
    gasLimit: Ln(t[4], "gasLimit"),
    to: n3(t[5]),
    value: Ln(t[6], "value"),
    data: Je(t[7]),
    accessList: gB(t[8], "accessList")
  };
  return t.length === 9 || bB(n, t.slice(9)), n;
}
function cNe(e, t) {
  const n = [
    wn(e.chainId, "chainId"),
    wn(e.nonce, "nonce"),
    wn(e.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    wn(e.maxFeePerGas || 0, "maxFeePerGas"),
    wn(e.gasLimit, "gasLimit"),
    e.to || "0x",
    wn(e.value, "value"),
    e.data,
    yB(e.accessList || [])
  ];
  return t && (n.push(wn(t.yParity, "yParity")), n.push(ci(t.r)), n.push(ci(t.s))), Vn(["0x02", vf(n)]);
}
function lNe(e) {
  const t = ZE(Ht(e).slice(1));
  de(Array.isArray(t) && (t.length === 8 || t.length === 11), "invalid field count for transaction type: 1", "data", Je(e));
  const n = {
    type: 1,
    chainId: Ln(t[0], "chainId"),
    nonce: Dv(t[1], "nonce"),
    gasPrice: Ln(t[2], "gasPrice"),
    gasLimit: Ln(t[3], "gasLimit"),
    to: n3(t[4]),
    value: Ln(t[5], "value"),
    data: Je(t[6]),
    accessList: gB(t[7], "accessList")
  };
  return t.length === 8 || bB(n, t.slice(8)), n;
}
function uNe(e, t) {
  const n = [
    wn(e.chainId, "chainId"),
    wn(e.nonce, "nonce"),
    wn(e.gasPrice || 0, "gasPrice"),
    wn(e.gasLimit, "gasLimit"),
    e.to || "0x",
    wn(e.value, "value"),
    e.data,
    yB(e.accessList || [])
  ];
  return t && (n.push(wn(t.yParity, "recoveryParam")), n.push(ci(t.r)), n.push(ci(t.s))), Vn(["0x01", vf(n)]);
}
function dNe(e) {
  let t = ZE(Ht(e).slice(1)), n = "3", r = null;
  if (t.length === 4 && Array.isArray(t[0])) {
    n = "3 (network format)";
    const s = t[1], o = t[2], a = t[3];
    de(Array.isArray(s), "invalid network format: blobs not an array", "fields[1]", s), de(Array.isArray(o), "invalid network format: commitments not an array", "fields[2]", o), de(Array.isArray(a), "invalid network format: proofs not an array", "fields[3]", a), de(s.length === o.length, "invalid network format: blobs/commitments length mismatch", "fields", t), de(s.length === a.length, "invalid network format: blobs/proofs length mismatch", "fields", t), r = [];
    for (let c = 0; c < t[1].length; c++)
      r.push({
        data: s[c],
        commitment: o[c],
        proof: a[c]
      });
    t = t[0];
  }
  de(Array.isArray(t) && (t.length === 11 || t.length === 14), `invalid field count for transaction type: ${n}`, "data", Je(e));
  const i = {
    type: 3,
    chainId: Ln(t[0], "chainId"),
    nonce: Dv(t[1], "nonce"),
    maxPriorityFeePerGas: Ln(t[2], "maxPriorityFeePerGas"),
    maxFeePerGas: Ln(t[3], "maxFeePerGas"),
    gasPrice: null,
    gasLimit: Ln(t[4], "gasLimit"),
    to: n3(t[5]),
    value: Ln(t[6], "value"),
    data: Je(t[7]),
    accessList: gB(t[8], "accessList"),
    maxFeePerBlobGas: Ln(t[9], "maxFeePerBlobGas"),
    blobVersionedHashes: t[10]
  };
  r && (i.blobs = r), de(i.to != null, `invalid address for transaction type: ${n}`, "data", e), de(Array.isArray(i.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", e);
  for (let s = 0; s < i.blobVersionedHashes.length; s++)
    de(mn(i.blobVersionedHashes[s], 32), `invalid blobVersionedHash at index ${s}: must be length 32`, "data", e);
  return t.length === 11 || bB(i, t.slice(11)), i;
}
function fNe(e, t, n) {
  const r = [
    wn(e.chainId, "chainId"),
    wn(e.nonce, "nonce"),
    wn(e.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    wn(e.maxFeePerGas || 0, "maxFeePerGas"),
    wn(e.gasLimit, "gasLimit"),
    e.to || lb,
    wn(e.value, "value"),
    e.data,
    yB(e.accessList || []),
    wn(e.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
    iNe(e.blobVersionedHashes || [], "blobVersionedHashes")
  ];
  return t && (r.push(wn(t.yParity, "yParity")), r.push(ci(t.r)), r.push(ci(t.s)), n) ? Vn([
    "0x03",
    vf([
      r,
      n.map((i) => i.data),
      n.map((i) => i.commitment),
      n.map((i) => i.proof)
    ])
  ]) : Vn(["0x03", vf(r)]);
}
var $o, Cp, Tp, kp, Bp, Ip, Pp, Op, Np, Rp, Mp, Fp, Cd, _l, qa, Sl, jp, cx;
const Ua = class Ua {
  /**
   *  Creates a new Transaction with default values.
   */
  constructor() {
    re(this, jp);
    re(this, $o, void 0);
    re(this, Cp, void 0);
    re(this, Tp, void 0);
    re(this, kp, void 0);
    re(this, Bp, void 0);
    re(this, Ip, void 0);
    re(this, Pp, void 0);
    re(this, Op, void 0);
    re(this, Np, void 0);
    re(this, Rp, void 0);
    re(this, Mp, void 0);
    re(this, Fp, void 0);
    re(this, Cd, void 0);
    re(this, _l, void 0);
    re(this, qa, void 0);
    re(this, Sl, void 0);
    j(this, $o, null), j(this, Cp, null), j(this, kp, 0), j(this, Bp, fr), j(this, Ip, null), j(this, Pp, null), j(this, Op, null), j(this, Tp, "0x"), j(this, Np, fr), j(this, Rp, fr), j(this, Mp, null), j(this, Fp, null), j(this, Cd, null), j(this, _l, null), j(this, Sl, null), j(this, qa, null);
  }
  /**
   *  The transaction type.
   *
   *  If null, the type will be automatically inferred based on
   *  explicit properties.
   */
  get type() {
    return C(this, $o);
  }
  set type(t) {
    switch (t) {
      case null:
        j(this, $o, null);
        break;
      case 0:
      case "legacy":
        j(this, $o, 0);
        break;
      case 1:
      case "berlin":
      case "eip-2930":
        j(this, $o, 1);
        break;
      case 2:
      case "london":
      case "eip-1559":
        j(this, $o, 2);
        break;
      case 3:
      case "cancun":
      case "eip-4844":
        j(this, $o, 3);
        break;
      default:
        de(!1, "unsupported transaction type", "type", t);
    }
  }
  /**
   *  The name of the transaction type.
   */
  get typeName() {
    switch (this.type) {
      case 0:
        return "legacy";
      case 1:
        return "eip-2930";
      case 2:
        return "eip-1559";
      case 3:
        return "eip-4844";
    }
    return null;
  }
  /**
   *  The ``to`` address for the transaction or ``null`` if the
   *  transaction is an ``init`` transaction.
   */
  get to() {
    const t = C(this, Cp);
    return t == null && this.type === 3 ? lb : t;
  }
  set to(t) {
    j(this, Cp, t == null ? null : ln(t));
  }
  /**
   *  The transaction nonce.
   */
  get nonce() {
    return C(this, kp);
  }
  set nonce(t) {
    j(this, kp, Ot(t, "value"));
  }
  /**
   *  The gas limit.
   */
  get gasLimit() {
    return C(this, Bp);
  }
  set gasLimit(t) {
    j(this, Bp, nt(t));
  }
  /**
   *  The gas price.
   *
   *  On legacy networks this defines the fee that will be paid. On
   *  EIP-1559 networks, this should be ``null``.
   */
  get gasPrice() {
    const t = C(this, Ip);
    return t == null && (this.type === 0 || this.type === 1) ? fr : t;
  }
  set gasPrice(t) {
    j(this, Ip, t == null ? null : nt(t, "gasPrice"));
  }
  /**
   *  The maximum priority fee per unit of gas to pay. On legacy
   *  networks this should be ``null``.
   */
  get maxPriorityFeePerGas() {
    const t = C(this, Pp);
    return t ?? (this.type === 2 || this.type === 3 ? fr : null);
  }
  set maxPriorityFeePerGas(t) {
    j(this, Pp, t == null ? null : nt(t, "maxPriorityFeePerGas"));
  }
  /**
   *  The maximum total fee per unit of gas to pay. On legacy
   *  networks this should be ``null``.
   */
  get maxFeePerGas() {
    const t = C(this, Op);
    return t ?? (this.type === 2 || this.type === 3 ? fr : null);
  }
  set maxFeePerGas(t) {
    j(this, Op, t == null ? null : nt(t, "maxFeePerGas"));
  }
  /**
   *  The transaction data. For ``init`` transactions this is the
   *  deployment code.
   */
  get data() {
    return C(this, Tp);
  }
  set data(t) {
    j(this, Tp, Je(t));
  }
  /**
   *  The amount of ether (in wei) to send in this transactions.
   */
  get value() {
    return C(this, Np);
  }
  set value(t) {
    j(this, Np, nt(t, "value"));
  }
  /**
   *  The chain ID this transaction is valid on.
   */
  get chainId() {
    return C(this, Rp);
  }
  set chainId(t) {
    j(this, Rp, nt(t));
  }
  /**
   *  If signed, the signature for this transaction.
   */
  get signature() {
    return C(this, Mp) || null;
  }
  set signature(t) {
    j(this, Mp, t == null ? null : bo.from(t));
  }
  /**
   *  The access list.
   *
   *  An access list permits discounted (but pre-paid) access to
   *  bytecode and state variable access within contract execution.
   */
  get accessList() {
    const t = C(this, Fp) || null;
    return t ?? (this.type === 1 || this.type === 2 || this.type === 3 ? [] : null);
  }
  set accessList(t) {
    j(this, Fp, t == null ? null : Of(t));
  }
  /**
   *  The max fee per blob gas for Cancun transactions.
   */
  get maxFeePerBlobGas() {
    const t = C(this, Cd);
    return t == null && this.type === 3 ? fr : t;
  }
  set maxFeePerBlobGas(t) {
    j(this, Cd, t == null ? null : nt(t, "maxFeePerBlobGas"));
  }
  /**
   *  The BLOb versioned hashes for Cancun transactions.
   */
  get blobVersionedHashes() {
    let t = C(this, _l);
    return t == null && this.type === 3 ? [] : t;
  }
  set blobVersionedHashes(t) {
    if (t != null) {
      de(Array.isArray(t), "blobVersionedHashes must be an Array", "value", t), t = t.slice();
      for (let n = 0; n < t.length; n++)
        de(mn(t[n], 32), "invalid blobVersionedHash", `value[${n}]`, t[n]);
    }
    j(this, _l, t);
  }
  /**
   *  The BLObs for the Transaction, if any.
   *
   *  If ``blobs`` is non-``null``, then the [[seriailized]]
   *  will return the network formatted sidecar, otherwise it
   *  will return the standard [[link-eip-2718]] payload. The
   *  [[unsignedSerialized]] is unaffected regardless.
   *
   *  When setting ``blobs``, either fully valid [[Blob]] objects
   *  may be specified (i.e. correctly padded, with correct
   *  committments and proofs) or a raw [[BytesLike]] may
   *  be provided.
   *
   *  If raw [[BytesLike]] are provided, the [[kzg]] property **must**
   *  be already set. The blob will be correctly padded and the
   *  [[KzgLibrary]] will be used to compute the committment and
   *  proof for the blob.
   *
   *  A BLOb is a sequence of field elements, each of which must
   *  be within the BLS field modulo, so some additional processing
   *  may be required to encode arbitrary data to ensure each 32 byte
   *  field is within the valid range.
   *
   *  Setting this automatically populates [[blobVersionedHashes]],
   *  overwriting any existing values. Setting this to ``null``
   *  does **not** remove the [[blobVersionedHashes]], leaving them
   *  present.
   */
  get blobs() {
    return C(this, Sl) == null ? null : C(this, Sl).map((t) => Object.assign({}, t));
  }
  set blobs(t) {
    if (t == null) {
      j(this, Sl, null);
      return;
    }
    const n = [], r = [];
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (rB(s)) {
        Pe(C(this, qa), "adding a raw blob requires a KZG library", "UNSUPPORTED_OPERATION", {
          operation: "set blobs()"
        });
        let o = Ht(s);
        if (de(o.length <= P6, "blob is too large", `blobs[${i}]`, s), o.length !== P6) {
          const l = new Uint8Array(P6);
          l.set(o), o = l;
        }
        const a = C(this, qa).blobToKzgCommitment(o), c = Je(C(this, qa).computeBlobKzgProof(o, a));
        n.push({
          data: Je(o),
          commitment: Je(a),
          proof: c
        }), r.push(hM(1, a));
      } else {
        const o = Je(s.commitment);
        n.push({
          data: Je(s.data),
          commitment: o,
          proof: Je(s.proof)
        }), r.push(hM(1, o));
      }
    }
    j(this, Sl, n), j(this, _l, r);
  }
  get kzg() {
    return C(this, qa);
  }
  set kzg(t) {
    j(this, qa, t);
  }
  /**
   *  The transaction hash, if signed. Otherwise, ``null``.
   */
  get hash() {
    return this.signature == null ? null : Yn(Se(this, jp, cx).call(this, !0, !1));
  }
  /**
   *  The pre-image hash of this transaction.
   *
   *  This is the digest that a [[Signer]] must sign to authorize
   *  this transaction.
   */
  get unsignedHash() {
    return Yn(this.unsignedSerialized);
  }
  /**
   *  The sending address, if signed. Otherwise, ``null``.
   */
  get from() {
    return this.signature == null ? null : J7e(this.unsignedHash, this.signature);
  }
  /**
   *  The public key of the sender, if signed. Otherwise, ``null``.
   */
  get fromPublicKey() {
    return this.signature == null ? null : ub.recoverPublicKey(this.unsignedHash, this.signature);
  }
  /**
   *  Returns true if signed.
   *
   *  This provides a Type Guard that properties requiring a signed
   *  transaction are non-null.
   */
  isSigned() {
    return this.signature != null;
  }
  /**
   *  The serialized transaction.
   *
   *  This throws if the transaction is unsigned. For the pre-image,
   *  use [[unsignedSerialized]].
   */
  get serialized() {
    return Se(this, jp, cx).call(this, !0, !0);
  }
  /**
   *  The transaction pre-image.
   *
   *  The hash of this is the digest which needs to be signed to
   *  authorize this transaction.
   */
  get unsignedSerialized() {
    return Se(this, jp, cx).call(this, !1, !1);
  }
  /**
   *  Return the most "likely" type; currently the highest
   *  supported transaction type.
   */
  inferType() {
    const t = this.inferTypes();
    return t.indexOf(2) >= 0 ? 2 : t.pop();
  }
  /**
   *  Validates the explicit properties and returns a list of compatible
   *  transaction types.
   */
  inferTypes() {
    const t = this.gasPrice != null, n = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null, r = this.accessList != null, i = C(this, Cd) != null || C(this, _l);
    this.maxFeePerGas != null && this.maxPriorityFeePerGas != null && Pe(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", { value: this }), Pe(!n || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", { value: this }), Pe(this.type !== 0 || !r, "legacy transaction cannot have accessList", "BAD_DATA", { value: this });
    const s = [];
    return this.type != null ? s.push(this.type) : n ? s.push(2) : t ? (s.push(1), r || s.push(0)) : r ? (s.push(1), s.push(2)) : (i && this.to || (s.push(0), s.push(1), s.push(2)), s.push(3)), s.sort(), s;
  }
  /**
   *  Returns true if this transaction is a legacy transaction (i.e.
   *  ``type === 0``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if this transaction is berlin hardform transaction (i.e.
   *  ``type === 1``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if this transaction is london hardform transaction (i.e.
   *  ``type === 2``).
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if this transaction is an [[link-eip-4844]] BLOB
   *  transaction.
   *
   *  This provides a Type Guard that the related properties are
   *  non-null.
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Create a copy of this transaciton.
   */
  clone() {
    return Ua.from(this);
  }
  /**
   *  Return a JSON-friendly object.
   */
  toJSON() {
    const t = (n) => n == null ? null : n.toString();
    return {
      type: this.type,
      to: this.to,
      //            from: this.from,
      data: this.data,
      nonce: this.nonce,
      gasLimit: t(this.gasLimit),
      gasPrice: t(this.gasPrice),
      maxPriorityFeePerGas: t(this.maxPriorityFeePerGas),
      maxFeePerGas: t(this.maxFeePerGas),
      value: t(this.value),
      chainId: t(this.chainId),
      sig: this.signature ? this.signature.toJSON() : null,
      accessList: this.accessList
    };
  }
  /**
   *  Create a **Transaction** from a serialized transaction or a
   *  Transaction-like object.
   */
  static from(t) {
    if (t == null)
      return new Ua();
    if (typeof t == "string") {
      const r = Ht(t);
      if (r[0] >= 127)
        return Ua.from(sNe(r));
      switch (r[0]) {
        case 1:
          return Ua.from(lNe(r));
        case 2:
          return Ua.from(aNe(r));
        case 3:
          return Ua.from(dNe(r));
      }
      Pe(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: "from" });
    }
    const n = new Ua();
    return t.type != null && (n.type = t.type), t.to != null && (n.to = t.to), t.nonce != null && (n.nonce = t.nonce), t.gasLimit != null && (n.gasLimit = t.gasLimit), t.gasPrice != null && (n.gasPrice = t.gasPrice), t.maxPriorityFeePerGas != null && (n.maxPriorityFeePerGas = t.maxPriorityFeePerGas), t.maxFeePerGas != null && (n.maxFeePerGas = t.maxFeePerGas), t.maxFeePerBlobGas != null && (n.maxFeePerBlobGas = t.maxFeePerBlobGas), t.data != null && (n.data = t.data), t.value != null && (n.value = t.value), t.chainId != null && (n.chainId = t.chainId), t.signature != null && (n.signature = bo.from(t.signature)), t.accessList != null && (n.accessList = t.accessList), t.blobVersionedHashes != null && (n.blobVersionedHashes = t.blobVersionedHashes), t.kzg != null && (n.kzg = t.kzg), t.blobs != null && (n.blobs = t.blobs), t.hash != null && (de(n.isSigned(), "unsigned transaction cannot define '.hash'", "tx", t), de(n.hash === t.hash, "hash mismatch", "tx", t)), t.from != null && (de(n.isSigned(), "unsigned transaction cannot define '.from'", "tx", t), de(n.from.toLowerCase() === (t.from || "").toLowerCase(), "from mismatch", "tx", t)), n;
  }
};
$o = new WeakMap(), Cp = new WeakMap(), Tp = new WeakMap(), kp = new WeakMap(), Bp = new WeakMap(), Ip = new WeakMap(), Pp = new WeakMap(), Op = new WeakMap(), Np = new WeakMap(), Rp = new WeakMap(), Mp = new WeakMap(), Fp = new WeakMap(), Cd = new WeakMap(), _l = new WeakMap(), qa = new WeakMap(), Sl = new WeakMap(), jp = new WeakSet(), cx = function(t, n) {
  Pe(!t || this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
  const r = t ? this.signature : null;
  switch (this.inferType()) {
    case 0:
      return oNe(this, r);
    case 1:
      return uNe(this, r);
    case 2:
      return cNe(this, r);
    case 3:
      return fNe(this, r, n ? this.blobs : null);
  }
  Pe(!1, "unsupported transaction type", "UNSUPPORTED_OPERATION", { operation: ".serialized" });
};
let $2 = Ua;
const jK = new Uint8Array(32);
jK.fill(0);
const hNe = BigInt(-1), DK = BigInt(0), UK = BigInt(1), pNe = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function mNe(e) {
  const t = Ht(e), n = t.length % 32;
  return n ? Vn([t, jK.slice(n)]) : Je(t);
}
const gNe = hu(UK, 32), yNe = hu(DK, 32), pM = {
  name: "string",
  version: "string",
  chainId: "uint256",
  verifyingContract: "address",
  salt: "bytes32"
}, O6 = [
  "name",
  "version",
  "chainId",
  "verifyingContract",
  "salt"
];
function mM(e) {
  return function(t) {
    return de(typeof t == "string", `invalid domain value for ${JSON.stringify(e)}`, `domain.${e}`, t), t;
  };
}
const bNe = {
  name: mM("name"),
  version: mM("version"),
  chainId: function(e) {
    const t = nt(e, "domain.chainId");
    return de(t >= 0, "invalid chain ID", "domain.chainId", e), Number.isSafeInteger(t) ? Number(t) : Oh(t);
  },
  verifyingContract: function(e) {
    try {
      return ln(e).toLowerCase();
    } catch {
    }
    de(!1, 'invalid domain value "verifyingContract"', "domain.verifyingContract", e);
  },
  salt: function(e) {
    const t = Ht(e, "domain.salt");
    return de(t.length === 32, 'invalid domain value "salt"', "domain.salt", e), Je(t);
  }
};
function N6(e) {
  {
    const t = e.match(/^(u?)int(\d+)$/);
    if (t) {
      const n = t[1] === "", r = parseInt(t[2]);
      de(r % 8 === 0 && r !== 0 && r <= 256 && t[2] === String(r), "invalid numeric width", "type", e);
      const i = rg(pNe, n ? r - 1 : r), s = n ? (i + UK) * hNe : DK;
      return function(o) {
        const a = nt(o, "value");
        return de(a >= s && a <= i, `value out-of-bounds for ${e}`, "value", a), hu(n ? CQ(a, 256) : a, 32);
      };
    }
  }
  {
    const t = e.match(/^bytes(\d+)$/);
    if (t) {
      const n = parseInt(t[1]);
      return de(n !== 0 && n <= 32 && t[1] === String(n), "invalid bytes width", "type", e), function(r) {
        const i = Ht(r);
        return de(i.length === n, `invalid length for ${e}`, "value", r), mNe(r);
      };
    }
  }
  switch (e) {
    case "address":
      return function(t) {
        return bf(ln(t), 32);
      };
    case "bool":
      return function(t) {
        return t ? gNe : yNe;
      };
    case "bytes":
      return function(t) {
        return Yn(t);
      };
    case "string":
      return function(t) {
        return wf(t);
      };
  }
  return null;
}
function gM(e, t) {
  return `${e}(${t.map(({ name: n, type: r }) => r + " " + n).join(",")})`;
}
function rw(e) {
  const t = e.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
  return t ? {
    base: t[1],
    index: t[2] + t[4],
    array: {
      base: t[1],
      prefix: t[1] + t[2],
      count: t[5] ? parseInt(t[5]) : -1
    }
  } : { base: e };
}
var Lb, $a, Dp, gA, LK;
const us = class us {
  /**
   *  Create a new **TypedDataEncoder** for %%types%%.
   *
   *  This performs all necessary checking that types are valid and
   *  do not violate the [[link-eip-712]] structural constraints as
   *  well as computes the [[primaryType]].
   */
  constructor(t) {
    re(this, gA);
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */
    pe(this, "primaryType");
    re(this, Lb, void 0);
    re(this, $a, void 0);
    re(this, Dp, void 0);
    j(this, $a, /* @__PURE__ */ new Map()), j(this, Dp, /* @__PURE__ */ new Map());
    const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = {};
    Object.keys(t).forEach((c) => {
      s[c] = t[c].map(({ name: l, type: u }) => {
        let { base: d, index: f } = rw(u);
        return d === "int" && !t.int && (d = "int256"), d === "uint" && !t.uint && (d = "uint256"), { name: l, type: d + (f || "") };
      }), n.set(c, /* @__PURE__ */ new Set()), r.set(c, []), i.set(c, /* @__PURE__ */ new Set());
    }), j(this, Lb, JSON.stringify(s));
    for (const c in s) {
      const l = /* @__PURE__ */ new Set();
      for (const u of s[c]) {
        de(!l.has(u.name), `duplicate variable name ${JSON.stringify(u.name)} in ${JSON.stringify(c)}`, "types", t), l.add(u.name);
        const d = rw(u.type).base;
        de(d !== c, `circular type reference to ${JSON.stringify(d)}`, "types", t), !N6(d) && (de(r.has(d), `unknown type ${JSON.stringify(d)}`, "types", t), r.get(d).push(c), n.get(c).add(d));
      }
    }
    const o = Array.from(r.keys()).filter((c) => r.get(c).length === 0);
    de(o.length !== 0, "missing primary type", "types", t), de(o.length === 1, `ambiguous primary types or unused types: ${o.map((c) => JSON.stringify(c)).join(", ")}`, "types", t), ft(this, { primaryType: o[0] });
    function a(c, l) {
      de(!l.has(c), `circular type reference to ${JSON.stringify(c)}`, "types", t), l.add(c);
      for (const u of n.get(c))
        if (r.has(u)) {
          a(u, l);
          for (const d of l)
            i.get(d).add(u);
        }
      l.delete(c);
    }
    a(this.primaryType, /* @__PURE__ */ new Set());
    for (const [c, l] of i) {
      const u = Array.from(l);
      u.sort(), C(this, $a).set(c, gM(c, s[c]) + u.map((d) => gM(d, s[d])).join(""));
    }
  }
  /**
   *  The types.
   */
  get types() {
    return JSON.parse(C(this, Lb));
  }
  /**
   *  Returnthe encoder for the specific %%type%%.
   */
  getEncoder(t) {
    let n = C(this, Dp).get(t);
    return n || (n = Se(this, gA, LK).call(this, t), C(this, Dp).set(t, n)), n;
  }
  /**
   *  Return the full type for %%name%%.
   */
  encodeType(t) {
    const n = C(this, $a).get(t);
    return de(n, `unknown type: ${JSON.stringify(t)}`, "name", t), n;
  }
  /**
   *  Return the encoded %%value%% for the %%type%%.
   */
  encodeData(t, n) {
    return this.getEncoder(t)(n);
  }
  /**
   *  Returns the hash of %%value%% for the type of %%name%%.
   */
  hashStruct(t, n) {
    return Yn(this.encodeData(t, n));
  }
  /**
   *  Return the fulled encoded %%value%% for the [[types]].
   */
  encode(t) {
    return this.encodeData(this.primaryType, t);
  }
  /**
   *  Return the hash of the fully encoded %%value%% for the [[types]].
   */
  hash(t) {
    return this.hashStruct(this.primaryType, t);
  }
  /**
   *  @_ignore:
   */
  _visit(t, n, r) {
    if (N6(t))
      return r(t, n);
    const i = rw(t).array;
    if (i)
      return de(i.count === -1 || i.count === n.length, `array length mismatch; expected length ${i.count}`, "value", n), n.map((o) => this._visit(i.prefix, o, r));
    const s = this.types[t];
    if (s)
      return s.reduce((o, { name: a, type: c }) => (o[a] = this._visit(c, n[a], r), o), {});
    de(!1, `unknown type: ${t}`, "type", t);
  }
  /**
   *  Call %%calback%% for each value in %%value%%, passing the type and
   *  component within %%value%%.
   *
   *  This is useful for replacing addresses or other transformation that
   *  may be desired on each component, based on its type.
   */
  visit(t, n) {
    return this._visit(this.primaryType, t, n);
  }
  /**
   *  Create a new **TypedDataEncoder** for %%types%%.
   */
  static from(t) {
    return new us(t);
  }
  /**
   *  Return the primary type for %%types%%.
   */
  static getPrimaryType(t) {
    return us.from(t).primaryType;
  }
  /**
   *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
   */
  static hashStruct(t, n, r) {
    return us.from(n).hashStruct(t, r);
  }
  /**
   *  Return the domain hash for %%domain%%.
   */
  static hashDomain(t) {
    const n = [];
    for (const r in t) {
      if (t[r] == null)
        continue;
      const i = pM[r];
      de(i, `invalid typed-data domain key: ${JSON.stringify(r)}`, "domain", t), n.push({ name: r, type: i });
    }
    return n.sort((r, i) => O6.indexOf(r.name) - O6.indexOf(i.name)), us.hashStruct("EIP712Domain", { EIP712Domain: n }, t);
  }
  /**
   *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
   */
  static encode(t, n, r) {
    return Vn([
      "0x1901",
      us.hashDomain(t),
      us.from(n).hash(r)
    ]);
  }
  /**
   *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
   */
  static hash(t, n, r) {
    return Yn(us.encode(t, n, r));
  }
  // Replaces all address types with ENS names with their looked up address
  /**
   * Resolves to the value from resolving all addresses in %%value%% for
   * %%types%% and the %%domain%%.
   */
  static async resolveNames(t, n, r, i) {
    t = Object.assign({}, t);
    for (const a in t)
      t[a] == null && delete t[a];
    const s = {};
    t.verifyingContract && !mn(t.verifyingContract, 20) && (s[t.verifyingContract] = "0x");
    const o = us.from(n);
    o.visit(r, (a, c) => (a === "address" && !mn(c, 20) && (s[c] = "0x"), c));
    for (const a in s)
      s[a] = await i(a);
    return t.verifyingContract && s[t.verifyingContract] && (t.verifyingContract = s[t.verifyingContract]), r = o.visit(r, (a, c) => a === "address" && s[c] ? s[c] : c), { domain: t, value: r };
  }
  /**
   *  Returns the JSON-encoded payload expected by nodes which implement
   *  the JSON-RPC [[link-eip-712]] method.
   */
  static getPayload(t, n, r) {
    us.hashDomain(t);
    const i = {}, s = [];
    O6.forEach((c) => {
      const l = t[c];
      l != null && (i[c] = bNe[c](l), s.push({ name: c, type: pM[c] }));
    });
    const o = us.from(n);
    n = o.types;
    const a = Object.assign({}, n);
    return de(a.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", n), a.EIP712Domain = s, o.encode(r), {
      types: a,
      domain: i,
      primaryType: o.primaryType,
      message: o.visit(r, (c, l) => {
        if (c.match(/^bytes(\d*)/))
          return Je(Ht(l));
        if (c.match(/^u?int/))
          return nt(l).toString();
        switch (c) {
          case "address":
            return l.toLowerCase();
          case "bool":
            return !!l;
          case "string":
            return de(typeof l == "string", "invalid string", "value", l), l;
        }
        de(!1, "unsupported type", "type", c);
      })
    };
  }
};
Lb = new WeakMap(), $a = new WeakMap(), Dp = new WeakMap(), gA = new WeakSet(), LK = function(t) {
  {
    const i = N6(t);
    if (i)
      return i;
  }
  const n = rw(t).array;
  if (n) {
    const i = n.prefix, s = this.getEncoder(i);
    return (o) => {
      de(n.count === -1 || n.count === o.length, `array length mismatch; expected length ${n.count}`, "value", o);
      let a = o.map(s);
      return C(this, $a).has(i) && (a = a.map(Yn)), Yn(Vn(a));
    };
  }
  const r = this.types[t];
  if (r) {
    const i = wf(C(this, $a).get(t));
    return (s) => {
      const o = r.map(({ name: a, type: c }) => {
        const l = this.getEncoder(c)(s[a]);
        return C(this, $a).has(c) ? Yn(l) : l;
      });
      return o.unshift(i), Vn(o);
    };
  }
  de(!1, `unknown type: ${t}`, "type", t);
};
let Q2 = us;
function di(e) {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => t.add(n)), Object.freeze(t);
}
const vNe = "external public payable override", wNe = di(vNe.split(" ")), zK = "constant external internal payable private public pure view override", xNe = di(zK.split(" ")), VK = "constructor error event fallback function receive struct", HK = di(VK.split(" ")), WK = "calldata memory storage payable indexed", ANe = di(WK.split(" ")), ENe = "tuple returns", _Ne = [VK, WK, ENe, zK].join(" "), SNe = di(_Ne.split(" ")), CNe = {
  "(": "OPEN_PAREN",
  ")": "CLOSE_PAREN",
  "[": "OPEN_BRACKET",
  "]": "CLOSE_BRACKET",
  ",": "COMMA",
  "@": "AT"
}, TNe = new RegExp("^(\\s*)"), kNe = new RegExp("^([0-9]+)"), BNe = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), GK = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), qK = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
var wr, Xs, zb, tk;
const yA = class yA {
  constructor(t) {
    re(this, zb);
    re(this, wr, void 0);
    re(this, Xs, void 0);
    j(this, wr, 0), j(this, Xs, t.slice());
  }
  get offset() {
    return C(this, wr);
  }
  get length() {
    return C(this, Xs).length - C(this, wr);
  }
  clone() {
    return new yA(C(this, Xs));
  }
  reset() {
    j(this, wr, 0);
  }
  // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
  popKeyword(t) {
    const n = this.peek();
    if (n.type !== "KEYWORD" || !t.has(n.text))
      throw new Error(`expected keyword ${n.text}`);
    return this.pop().text;
  }
  // Pops and returns the value of the next token if it is `type`; throws if out of tokens
  popType(t) {
    if (this.peek().type !== t) {
      const n = this.peek();
      throw new Error(`expected ${t}; got ${n.type} ${JSON.stringify(n.text)}`);
    }
    return this.pop().text;
  }
  // Pops and returns a "(" TOKENS ")"
  popParen() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const n = Se(this, zb, tk).call(this, C(this, wr) + 1, t.match + 1);
    return j(this, wr, t.match + 1), n;
  }
  // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
  popParams() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const n = [];
    for (; C(this, wr) < t.match - 1; ) {
      const r = this.peek().linkNext;
      n.push(Se(this, zb, tk).call(this, C(this, wr) + 1, r)), j(this, wr, r);
    }
    return j(this, wr, t.match + 1), n;
  }
  // Returns the top Token, throwing if out of tokens
  peek() {
    if (C(this, wr) >= C(this, Xs).length)
      throw new Error("out-of-bounds");
    return C(this, Xs)[C(this, wr)];
  }
  // Returns the next value, if it is a keyword in `allowed`
  peekKeyword(t) {
    const n = this.peekType("KEYWORD");
    return n != null && t.has(n) ? n : null;
  }
  // Returns the value of the next token if it is `type`
  peekType(t) {
    if (this.length === 0)
      return null;
    const n = this.peek();
    return n.type === t ? n.text : null;
  }
  // Returns the next token; throws if out of tokens
  pop() {
    const t = this.peek();
    return Rc(this, wr)._++, t;
  }
  toString() {
    const t = [];
    for (let n = C(this, wr); n < C(this, Xs).length; n++) {
      const r = C(this, Xs)[n];
      t.push(`${r.type}:${r.text}`);
    }
    return `<TokenString ${t.join(" ")}>`;
  }
};
wr = new WeakMap(), Xs = new WeakMap(), zb = new WeakSet(), tk = function(t = 0, n = 0) {
  return new yA(C(this, Xs).slice(t, n).map((r) => Object.freeze(Object.assign({}, r, {
    match: r.match - t,
    linkBack: r.linkBack - t,
    linkNext: r.linkNext - t
  }))));
};
let vo = yA;
function Eu(e) {
  const t = [], n = (o) => {
    const a = s < e.length ? JSON.stringify(e[s]) : "$EOI";
    throw new Error(`invalid token ${a} at ${s}: ${o}`);
  };
  let r = [], i = [], s = 0;
  for (; s < e.length; ) {
    let o = e.substring(s), a = o.match(TNe);
    a && (s += a[1].length, o = e.substring(s));
    const c = { depth: r.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: s, value: -1 };
    t.push(c);
    let l = CNe[o[0]] || "";
    if (l) {
      if (c.type = l, c.text = o[0], s++, l === "OPEN_PAREN")
        r.push(t.length - 1), i.push(t.length - 1);
      else if (l == "CLOSE_PAREN")
        r.length === 0 && n("no matching open bracket"), c.match = r.pop(), t[c.match].match = t.length - 1, c.depth--, c.linkBack = i.pop(), t[c.linkBack].linkNext = t.length - 1;
      else if (l === "COMMA")
        c.linkBack = i.pop(), t[c.linkBack].linkNext = t.length - 1, i.push(t.length - 1);
      else if (l === "OPEN_BRACKET")
        c.type = "BRACKET";
      else if (l === "CLOSE_BRACKET") {
        let u = t.pop().text;
        if (t.length > 0 && t[t.length - 1].type === "NUMBER") {
          const d = t.pop().text;
          u = d + u, t[t.length - 1].value = Ot(d);
        }
        if (t.length === 0 || t[t.length - 1].type !== "BRACKET")
          throw new Error("missing opening bracket");
        t[t.length - 1].text += u;
      }
      continue;
    }
    if (a = o.match(BNe), a) {
      if (c.text = a[1], s += c.text.length, SNe.has(c.text)) {
        c.type = "KEYWORD";
        continue;
      }
      if (c.text.match(qK)) {
        c.type = "TYPE";
        continue;
      }
      c.type = "ID";
      continue;
    }
    if (a = o.match(kNe), a) {
      c.text = a[1], c.type = "NUMBER", s += c.text.length;
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(o[0])} at position ${s}`);
  }
  return new vo(t.map((o) => Object.freeze(o)));
}
function yM(e, t) {
  let n = [];
  for (const r in t.keys())
    e.has(r) && n.push(r);
  if (n.length > 1)
    throw new Error(`conflicting types: ${n.join(", ")}`);
}
function r3(e, t) {
  if (t.peekKeyword(HK)) {
    const n = t.pop().text;
    if (n !== e)
      throw new Error(`expected ${e}, got ${n}`);
  }
  return t.popType("ID");
}
function kc(e, t) {
  const n = /* @__PURE__ */ new Set();
  for (; ; ) {
    const r = e.peekType("KEYWORD");
    if (r == null || t && !t.has(r))
      break;
    if (e.pop(), n.has(r))
      throw new Error(`duplicate keywords: ${JSON.stringify(r)}`);
    n.add(r);
  }
  return Object.freeze(n);
}
function $K(e) {
  let t = kc(e, xNe);
  return yM(t, di("constant payable nonpayable".split(" "))), yM(t, di("pure view payable nonpayable".split(" "))), t.has("view") ? "view" : t.has("pure") ? "pure" : t.has("payable") ? "payable" : t.has("nonpayable") ? "nonpayable" : t.has("constant") ? "view" : "nonpayable";
}
function bc(e, t) {
  return e.popParams().map((n) => Cr.from(n, t));
}
function QK(e) {
  if (e.peekType("AT")) {
    if (e.pop(), e.peekType("NUMBER"))
      return nt(e.pop().text);
    throw new Error("invalid gas");
  }
  return null;
}
function xf(e) {
  if (e.length)
    throw new Error(`unexpected tokens at offset ${e.offset}: ${e.toString()}`);
}
const INe = new RegExp(/^(.*)\[([0-9]*)\]$/);
function bM(e) {
  const t = e.match(qK);
  if (de(t, "invalid type", "type", e), e === "uint")
    return "uint256";
  if (e === "int")
    return "int256";
  if (t[2]) {
    const n = parseInt(t[2]);
    de(n !== 0 && n <= 32, "invalid bytes length", "type", e);
  } else if (t[3]) {
    const n = parseInt(t[3]);
    de(n !== 0 && n <= 256 && n % 8 === 0, "invalid numeric width", "type", e);
  }
  return e;
}
const Cn = {}, Fi = Symbol.for("_ethers_internal"), vM = "_ParamTypeInternal", wM = "_ErrorInternal", xM = "_EventInternal", AM = "_ConstructorInternal", EM = "_FallbackInternal", _M = "_FunctionInternal", SM = "_StructInternal";
var Up, lx;
const ds = class ds {
  /**
   *  @private
   */
  constructor(t, n, r, i, s, o, a, c) {
    re(this, Up);
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */
    pe(this, "name");
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */
    pe(this, "type");
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */
    pe(this, "baseType");
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */
    pe(this, "indexed");
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */
    pe(this, "components");
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */
    pe(this, "arrayLength");
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */
    pe(this, "arrayChildren");
    if (QE(t, Cn, "ParamType"), Object.defineProperty(this, Fi, { value: vM }), o && (o = Object.freeze(o.slice())), i === "array") {
      if (a == null || c == null)
        throw new Error("");
    } else if (a != null || c != null)
      throw new Error("");
    if (i === "tuple") {
      if (o == null)
        throw new Error("");
    } else if (o != null)
      throw new Error("");
    ft(this, {
      name: n,
      type: r,
      baseType: i,
      indexed: s,
      components: o,
      arrayLength: a,
      arrayChildren: c
    });
  }
  /**
   *  Return a string representation of this type.
   *
   *  For example,
   *
   *  ``sighash" => "(uint256,address)"``
   *
   *  ``"minimal" => "tuple(uint256,address) indexed"``
   *
   *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json") {
      const r = this.name || "";
      if (this.isArray()) {
        const s = JSON.parse(this.arrayChildren.format("json"));
        return s.name = r, s.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(s);
      }
      const i = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: r
      };
      return typeof this.indexed == "boolean" && (i.indexed = this.indexed), this.isTuple() && (i.components = this.components.map((s) => JSON.parse(s.format(t)))), JSON.stringify(i);
    }
    let n = "";
    return this.isArray() ? (n += this.arrayChildren.format(t), n += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? n += "(" + this.components.map((r) => r.format(t)).join(t === "full" ? ", " : ",") + ")" : n += this.type, t !== "sighash" && (this.indexed === !0 && (n += " indexed"), t === "full" && this.name && (n += " " + this.name)), n;
  }
  /**
   *  Returns true if %%this%% is an Array type.
   *
   *  This provides a type gaurd ensuring that [[arrayChildren]]
   *  and [[arrayLength]] are non-null.
   */
  isArray() {
    return this.baseType === "array";
  }
  /**
   *  Returns true if %%this%% is a Tuple type.
   *
   *  This provides a type gaurd ensuring that [[components]]
   *  is non-null.
   */
  isTuple() {
    return this.baseType === "tuple";
  }
  /**
   *  Returns true if %%this%% is an Indexable type.
   *
   *  This provides a type gaurd ensuring that [[indexed]]
   *  is non-null.
   */
  isIndexable() {
    return this.indexed != null;
  }
  /**
   *  Walks the **ParamType** with %%value%%, calling %%process%%
   *  on each type, destructing the %%value%% recursively.
   */
  walk(t, n) {
    if (this.isArray()) {
      if (!Array.isArray(t))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && t.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const r = this;
      return t.map((i) => r.arrayChildren.walk(i, n));
    }
    if (this.isTuple()) {
      if (!Array.isArray(t))
        throw new Error("invalid tuple value");
      if (t.length !== this.components.length)
        throw new Error("array is wrong length");
      const r = this;
      return t.map((i, s) => r.components[s].walk(i, n));
    }
    return n(this.type, t);
  }
  /**
   *  Walks the **ParamType** with %%value%%, asynchronously calling
   *  %%process%% on each type, destructing the %%value%% recursively.
   *
   *  This can be used to resolve ENS naes by walking and resolving each
   *  ``"address"`` type.
   */
  async walkAsync(t, n) {
    const r = [], i = [t];
    return Se(this, Up, lx).call(this, r, t, n, (s) => {
      i[0] = s;
    }), r.length && await Promise.all(r), i[0];
  }
  /**
   *  Creates a new **ParamType** for %%obj%%.
   *
   *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
   *  otherwise the ``indexed`` keyword will throw an error.
   */
  static from(t, n) {
    if (ds.isParamType(t))
      return t;
    if (typeof t == "string")
      try {
        return ds.from(Eu(t), n);
      } catch {
        de(!1, "invalid param type", "obj", t);
      }
    else if (t instanceof vo) {
      let a = "", c = "", l = null;
      kc(t, di(["tuple"])).has("tuple") || t.peekType("OPEN_PAREN") ? (c = "tuple", l = t.popParams().map((h) => ds.from(h)), a = `tuple(${l.map((h) => h.format()).join(",")})`) : (a = bM(t.popType("TYPE")), c = a);
      let u = null, d = null;
      for (; t.length && t.peekType("BRACKET"); ) {
        const h = t.pop();
        u = new ds(Cn, "", a, c, null, l, d, u), d = h.value, a += h.text, c = "array", l = null;
      }
      let f = null;
      if (kc(t, ANe).has("indexed")) {
        if (!n)
          throw new Error("");
        f = !0;
      }
      const m = t.peekType("ID") ? t.pop().text : "";
      if (t.length)
        throw new Error("leftover tokens");
      return new ds(Cn, m, a, c, f, l, d, u);
    }
    const r = t.name;
    de(!r || typeof r == "string" && r.match(GK), "invalid name", "obj.name", r);
    let i = t.indexed;
    i != null && (de(n, "parameter cannot be indexed", "obj.indexed", t.indexed), i = !!i);
    let s = t.type, o = s.match(INe);
    if (o) {
      const a = parseInt(o[2] || "-1"), c = ds.from({
        type: o[1],
        components: t.components
      });
      return new ds(Cn, r || "", s, "array", i, null, a, c);
    }
    if (s === "tuple" || s.startsWith(
      "tuple("
      /* fix: ) */
    ) || s.startsWith(
      "("
      /* fix: ) */
    )) {
      const a = t.components != null ? t.components.map((l) => ds.from(l)) : null;
      return new ds(Cn, r || "", s, "tuple", i, a, null, null);
    }
    return s = bM(t.type), new ds(Cn, r || "", s, s, i, null, null, null);
  }
  /**
   *  Returns true if %%value%% is a **ParamType**.
   */
  static isParamType(t) {
    return t && t[Fi] === vM;
  }
};
Up = new WeakSet(), lx = function(t, n, r, i) {
  if (this.isArray()) {
    if (!Array.isArray(n))
      throw new Error("invalid array value");
    if (this.arrayLength !== -1 && n.length !== this.arrayLength)
      throw new Error("array is wrong length");
    const o = this.arrayChildren, a = n.slice();
    a.forEach((c, l) => {
      var u;
      Se(u = o, Up, lx).call(u, t, c, r, (d) => {
        a[l] = d;
      });
    }), i(a);
    return;
  }
  if (this.isTuple()) {
    const o = this.components;
    let a;
    if (Array.isArray(n))
      a = n.slice();
    else {
      if (n == null || typeof n != "object")
        throw new Error("invalid tuple value");
      a = o.map((c) => {
        if (!c.name)
          throw new Error("cannot use object value with unnamed components");
        if (!(c.name in n))
          throw new Error(`missing value for component ${c.name}`);
        return n[c.name];
      });
    }
    if (a.length !== this.components.length)
      throw new Error("array is wrong length");
    a.forEach((c, l) => {
      var u;
      Se(u = o[l], Up, lx).call(u, t, c, r, (d) => {
        a[l] = d;
      });
    }), i(a);
    return;
  }
  const s = r(this.type, n);
  s.then ? t.push(async function() {
    i(await s);
  }()) : i(s);
};
let Cr = ds;
class Af {
  /**
   *  @private
   */
  constructor(t, n, r) {
    /**
     *  The type of the fragment.
     */
    pe(this, "type");
    /**
     *  The inputs for the fragment.
     */
    pe(this, "inputs");
    QE(t, Cn, "Fragment"), r = Object.freeze(r.slice()), ft(this, { type: n, inputs: r });
  }
  /**
   *  Creates a new **Fragment** for %%obj%%, wich can be any supported
   *  ABI frgament type.
   */
  static from(t) {
    if (typeof t == "string") {
      try {
        Af.from(JSON.parse(t));
      } catch {
      }
      return Af.from(Eu(t));
    }
    if (t instanceof vo)
      switch (t.peekKeyword(HK)) {
        case "constructor":
          return lc.from(t);
        case "error":
          return Ci.from(t);
        case "event":
          return ca.from(t);
        case "fallback":
        case "receive":
          return La.from(t);
        case "function":
          return la.from(t);
        case "struct":
          return Jd.from(t);
      }
    else if (typeof t == "object") {
      switch (t.type) {
        case "constructor":
          return lc.from(t);
        case "error":
          return Ci.from(t);
        case "event":
          return ca.from(t);
        case "fallback":
        case "receive":
          return La.from(t);
        case "function":
          return la.from(t);
        case "struct":
          return Jd.from(t);
      }
      Pe(!1, `unsupported type: ${t.type}`, "UNSUPPORTED_OPERATION", {
        operation: "Fragment.from"
      });
    }
    de(!1, "unsupported frgament object", "obj", t);
  }
  /**
   *  Returns true if %%value%% is a [[ConstructorFragment]].
   */
  static isConstructor(t) {
    return lc.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is an [[ErrorFragment]].
   */
  static isError(t) {
    return Ci.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is an [[EventFragment]].
   */
  static isEvent(t) {
    return ca.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is a [[FunctionFragment]].
   */
  static isFunction(t) {
    return la.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is a [[StructFragment]].
   */
  static isStruct(t) {
    return Jd.isFragment(t);
  }
}
class i3 extends Af {
  /**
   *  @private
   */
  constructor(n, r, i, s) {
    super(n, r, s);
    /**
     *  The name of the fragment.
     */
    pe(this, "name");
    de(typeof i == "string" && i.match(GK), "invalid identifier", "name", i), s = Object.freeze(s.slice()), ft(this, { name: i });
  }
}
function mb(e, t) {
  return "(" + t.map((n) => n.format(e)).join(e === "full" ? ", " : ",") + ")";
}
class Ci extends i3 {
  /**
   *  @private
   */
  constructor(t, n, r) {
    super(t, "error", n, r), Object.defineProperty(this, Fi, { value: wM });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return wf(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json")
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((r) => JSON.parse(r.format(t)))
      });
    const n = [];
    return t !== "sighash" && n.push("error"), n.push(this.name + mb(t, this.inputs)), n.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(t) {
    if (Ci.isFragment(t))
      return t;
    if (typeof t == "string")
      return Ci.from(Eu(t));
    if (t instanceof vo) {
      const n = r3("error", t), r = bc(t);
      return xf(t), new Ci(Cn, n, r);
    }
    return new Ci(Cn, t.name, t.inputs ? t.inputs.map(Cr.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(t) {
    return t && t[Fi] === wM;
  }
}
class ca extends i3 {
  /**
   *  @private
   */
  constructor(n, r, i, s) {
    super(n, "event", r, i);
    /**
     *  Whether this event is anonymous.
     */
    pe(this, "anonymous");
    Object.defineProperty(this, Fi, { value: xM }), ft(this, { anonymous: s });
  }
  /**
   *  The Event topic hash.
   */
  get topicHash() {
    return wf(this.format("sighash"));
  }
  /**
   *  Returns a string representation of this event as %%format%%.
   */
  format(n) {
    if (n == null && (n = "sighash"), n === "json")
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((i) => JSON.parse(i.format(n)))
      });
    const r = [];
    return n !== "sighash" && r.push("event"), r.push(this.name + mb(n, this.inputs)), n !== "sighash" && this.anonymous && r.push("anonymous"), r.join(" ");
  }
  /**
   *  Return the topic hash for an event with %%name%% and %%params%%.
   */
  static getTopicHash(n, r) {
    return r = (r || []).map((s) => Cr.from(s)), new ca(Cn, n, r, !1).topicHash;
  }
  /**
   *  Returns a new **EventFragment** for %%obj%%.
   */
  static from(n) {
    if (ca.isFragment(n))
      return n;
    if (typeof n == "string")
      try {
        return ca.from(Eu(n));
      } catch {
        de(!1, "invalid event fragment", "obj", n);
      }
    else if (n instanceof vo) {
      const r = r3("event", n), i = bc(n, !0), s = !!kc(n, di(["anonymous"])).has("anonymous");
      return xf(n), new ca(Cn, r, i, s);
    }
    return new ca(Cn, n.name, n.inputs ? n.inputs.map((r) => Cr.from(r, !0)) : [], !!n.anonymous);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **EventFragment**.
   */
  static isFragment(n) {
    return n && n[Fi] === xM;
  }
}
class lc extends Af {
  /**
   *  @private
   */
  constructor(n, r, i, s, o) {
    super(n, r, i);
    /**
     *  Whether the constructor can receive an endowment.
     */
    pe(this, "payable");
    /**
     *  The recommended gas limit for deployment or ``null``.
     */
    pe(this, "gas");
    Object.defineProperty(this, Fi, { value: AM }), ft(this, { payable: s, gas: o });
  }
  /**
   *  Returns a string representation of this constructor as %%format%%.
   */
  format(n) {
    if (Pe(n != null && n !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), n === "json")
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.payable ? "payable" : "undefined",
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(n)))
      });
    const r = [`constructor${mb(n, this.inputs)}`];
    return this.payable && r.push("payable"), this.gas != null && r.push(`@${this.gas.toString()}`), r.join(" ");
  }
  /**
   *  Returns a new **ConstructorFragment** for %%obj%%.
   */
  static from(n) {
    if (lc.isFragment(n))
      return n;
    if (typeof n == "string")
      try {
        return lc.from(Eu(n));
      } catch {
        de(!1, "invalid constuctor fragment", "obj", n);
      }
    else if (n instanceof vo) {
      kc(n, di(["constructor"]));
      const r = bc(n), i = !!kc(n, wNe).has("payable"), s = QK(n);
      return xf(n), new lc(Cn, "constructor", r, i, s);
    }
    return new lc(Cn, "constructor", n.inputs ? n.inputs.map(Cr.from) : [], !!n.payable, n.gas != null ? n.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **ConstructorFragment**.
   */
  static isFragment(n) {
    return n && n[Fi] === AM;
  }
}
class La extends Af {
  constructor(n, r, i) {
    super(n, "fallback", r);
    /**
     *  If the function can be sent value during invocation.
     */
    pe(this, "payable");
    Object.defineProperty(this, Fi, { value: EM }), ft(this, { payable: i });
  }
  /**
   *  Returns a string representation of this fallback as %%format%%.
   */
  format(n) {
    const r = this.inputs.length === 0 ? "receive" : "fallback";
    if (n === "json") {
      const i = this.payable ? "payable" : "nonpayable";
      return JSON.stringify({ type: r, stateMutability: i });
    }
    return `${r}()${this.payable ? " payable" : ""}`;
  }
  /**
   *  Returns a new **FallbackFragment** for %%obj%%.
   */
  static from(n) {
    if (La.isFragment(n))
      return n;
    if (typeof n == "string")
      try {
        return La.from(Eu(n));
      } catch {
        de(!1, "invalid fallback fragment", "obj", n);
      }
    else if (n instanceof vo) {
      const r = n.toString(), i = n.peekKeyword(di(["fallback", "receive"]));
      if (de(i, "type must be fallback or receive", "obj", r), n.popKeyword(di(["fallback", "receive"])) === "receive") {
        const c = bc(n);
        return de(c.length === 0, "receive cannot have arguments", "obj.inputs", c), kc(n, di(["payable"])), xf(n), new La(Cn, [], !0);
      }
      let o = bc(n);
      o.length ? de(o.length === 1 && o[0].type === "bytes", "invalid fallback inputs", "obj.inputs", o.map((c) => c.format("minimal")).join(", ")) : o = [Cr.from("bytes")];
      const a = $K(n);
      if (de(a === "nonpayable" || a === "payable", "fallback cannot be constants", "obj.stateMutability", a), kc(n, di(["returns"])).has("returns")) {
        const c = bc(n);
        de(c.length === 1 && c[0].type === "bytes", "invalid fallback outputs", "obj.outputs", c.map((l) => l.format("minimal")).join(", "));
      }
      return xf(n), new La(Cn, o, a === "payable");
    }
    if (n.type === "receive")
      return new La(Cn, [], !0);
    if (n.type === "fallback") {
      const r = [Cr.from("bytes")], i = n.stateMutability === "payable";
      return new La(Cn, r, i);
    }
    de(!1, "invalid fallback description", "obj", n);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FallbackFragment**.
   */
  static isFragment(n) {
    return n && n[Fi] === EM;
  }
}
class la extends i3 {
  /**
   *  @private
   */
  constructor(n, r, i, s, o, a) {
    super(n, "function", r, s);
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */
    pe(this, "constant");
    /**
     *  The returned types for the result of calling this function.
     */
    pe(this, "outputs");
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */
    pe(this, "stateMutability");
    /**
     *  If the function can be sent value during invocation.
     */
    pe(this, "payable");
    /**
     *  The recommended gas limit to send when calling this function.
     */
    pe(this, "gas");
    Object.defineProperty(this, Fi, { value: _M }), o = Object.freeze(o.slice()), ft(this, { constant: i === "view" || i === "pure", gas: a, outputs: o, payable: i === "payable", stateMutability: i });
  }
  /**
   *  The Function selector.
   */
  get selector() {
    return wf(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this function as %%format%%.
   */
  format(n) {
    if (n == null && (n = "sighash"), n === "json")
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(n))),
        outputs: this.outputs.map((i) => JSON.parse(i.format(n)))
      });
    const r = [];
    return n !== "sighash" && r.push("function"), r.push(this.name + mb(n, this.inputs)), n !== "sighash" && (this.stateMutability !== "nonpayable" && r.push(this.stateMutability), this.outputs && this.outputs.length && (r.push("returns"), r.push(mb(n, this.outputs))), this.gas != null && r.push(`@${this.gas.toString()}`)), r.join(" ");
  }
  /**
   *  Return the selector for a function with %%name%% and %%params%%.
   */
  static getSelector(n, r) {
    return r = (r || []).map((s) => Cr.from(s)), new la(Cn, n, "view", r, [], null).selector;
  }
  /**
   *  Returns a new **FunctionFragment** for %%obj%%.
   */
  static from(n) {
    if (la.isFragment(n))
      return n;
    if (typeof n == "string")
      try {
        return la.from(Eu(n));
      } catch {
        de(!1, "invalid function fragment", "obj", n);
      }
    else if (n instanceof vo) {
      const i = r3("function", n), s = bc(n), o = $K(n);
      let a = [];
      kc(n, di(["returns"])).has("returns") && (a = bc(n));
      const c = QK(n);
      return xf(n), new la(Cn, i, o, s, a, c);
    }
    let r = n.stateMutability;
    return r == null && (r = "payable", typeof n.constant == "boolean" ? (r = "view", n.constant || (r = "payable", typeof n.payable == "boolean" && !n.payable && (r = "nonpayable"))) : typeof n.payable == "boolean" && !n.payable && (r = "nonpayable")), new la(Cn, n.name, r, n.inputs ? n.inputs.map(Cr.from) : [], n.outputs ? n.outputs.map(Cr.from) : [], n.gas != null ? n.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FunctionFragment**.
   */
  static isFragment(n) {
    return n && n[Fi] === _M;
  }
}
class Jd extends i3 {
  /**
   *  @private
   */
  constructor(t, n, r) {
    super(t, "struct", n, r), Object.defineProperty(this, Fi, { value: SM });
  }
  /**
   *  Returns a string representation of this struct as %%format%%.
   */
  format() {
    throw new Error("@TODO");
  }
  /**
   *  Returns a new **StructFragment** for %%obj%%.
   */
  static from(t) {
    if (typeof t == "string")
      try {
        return Jd.from(Eu(t));
      } catch {
        de(!1, "invalid struct fragment", "obj", t);
      }
    else if (t instanceof vo) {
      const n = r3("struct", t), r = bc(t);
      return xf(t), new Jd(Cn, n, r);
    }
    return new Jd(Cn, t.name, t.inputs ? t.inputs.map(Cr.from) : []);
  }
  // @TODO: fix this return type
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **StructFragment**.
   */
  static isFragment(t) {
    return t && t[Fi] === SM;
  }
}
const Eo = /* @__PURE__ */ new Map();
Eo.set(0, "GENERIC_PANIC");
Eo.set(1, "ASSERT_FALSE");
Eo.set(17, "OVERFLOW");
Eo.set(18, "DIVIDE_BY_ZERO");
Eo.set(33, "ENUM_RANGE_ERROR");
Eo.set(34, "BAD_STORAGE_DATA");
Eo.set(49, "STACK_UNDERFLOW");
Eo.set(50, "ARRAY_RANGE_ERROR");
Eo.set(65, "OUT_OF_MEMORY");
Eo.set(81, "UNINITIALIZED_FUNCTION_CALL");
const PNe = new RegExp(/^bytes([0-9]*)$/), ONe = new RegExp(/^(u?int)([0-9]*)$/);
let R6 = null, CM = 1024;
function NNe(e, t, n, r) {
  let i = "missing revert data", s = null;
  const o = null;
  let a = null;
  if (n) {
    i = "execution reverted";
    const l = Ht(n);
    if (n = Je(n), l.length === 0)
      i += " (no data present; likely require(false) occurred", s = "require(false)";
    else if (l.length % 32 !== 4)
      i += " (could not decode reason; invalid data length)";
    else if (Je(l.slice(0, 4)) === "0x08c379a0")
      try {
        s = r.decode(["string"], l.slice(4))[0], a = {
          signature: "Error(string)",
          name: "Error",
          args: [s]
        }, i += `: ${JSON.stringify(s)}`;
      } catch {
        i += " (could not decode reason; invalid string data)";
      }
    else if (Je(l.slice(0, 4)) === "0x4e487b71")
      try {
        const u = Number(r.decode(["uint256"], l.slice(4))[0]);
        a = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [u]
        }, s = `Panic due to ${Eo.get(u) || "UNKNOWN"}(${u})`, i += `: ${s}`;
      } catch {
        i += " (could not decode panic code)";
      }
    else
      i += " (unknown custom error)";
  }
  const c = {
    to: t.to ? ln(t.to) : null,
    data: t.data || "0x"
  };
  return t.from && (c.from = ln(t.from)), qn(i, "CALL_EXCEPTION", {
    action: e,
    data: n,
    reason: s,
    transaction: c,
    invocation: o,
    revert: a
  });
}
var Cl, hh;
const bA = class bA {
  constructor() {
    re(this, Cl);
  }
  /**
   *  Get the default values for the given %%types%%.
   *
   *  For example, a ``uint`` is by default ``0`` and ``bool``
   *  is by default ``false``.
   */
  getDefaultValue(t) {
    const n = t.map((i) => Se(this, Cl, hh).call(this, Cr.from(i)));
    return new nw(n, "_").defaultValue();
  }
  /**
   *  Encode the %%values%% as the %%types%% into ABI data.
   *
   *  @returns DataHexstring
   */
  encode(t, n) {
    EQ(n.length, t.length, "types/values length mismatch");
    const r = t.map((o) => Se(this, Cl, hh).call(this, Cr.from(o))), i = new nw(r, "_"), s = new zT();
    return i.encode(s, n), s.data;
  }
  /**
   *  Decode the ABI %%data%% as the %%types%% into values.
   *
   *  If %%loose%% decoding is enabled, then strict padding is
   *  not enforced. Some older versions of Solidity incorrectly
   *  padded event data emitted from ``external`` functions.
   */
  decode(t, n, r) {
    const i = t.map((o) => Se(this, Cl, hh).call(this, Cr.from(o)));
    return new nw(i, "_").decode(new VT(n, r, CM));
  }
  static _setDefaultMaxInflation(t) {
    de(typeof t == "number" && Number.isInteger(t), "invalid defaultMaxInflation factor", "value", t), CM = t;
  }
  /**
   *  Returns the shared singleton instance of a default [[AbiCoder]].
   *
   *  On the first call, the instance is created internally.
   */
  static defaultAbiCoder() {
    return R6 == null && (R6 = new bA()), R6;
  }
  /**
   *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
   *  result %%data%% for the [[CallExceptionAction]] %%action%% against
   *  the Transaction %%tx%%.
   */
  static getBuiltinCallException(t, n, r) {
    return NNe(t, n, r, bA.defaultAbiCoder());
  }
};
Cl = new WeakSet(), hh = function(t) {
  if (t.isArray())
    return new n7e(Se(this, Cl, hh).call(this, t.arrayChildren), t.arrayLength, t.name);
  if (t.isTuple())
    return new nw(t.components.map((r) => Se(this, Cl, hh).call(this, r)), t.name);
  switch (t.baseType) {
    case "address":
      return new e7e(t.name);
    case "bool":
      return new r7e(t.name);
    case "string":
      return new f7e(t.name);
    case "bytes":
      return new i7e(t.name);
    case "":
      return new a7e(t.name);
  }
  let n = t.type.match(ONe);
  if (n) {
    let r = parseInt(n[2] || "256");
    return de(r !== 0 && r <= 256 && r % 8 === 0, "invalid " + n[1] + " bit length", "param", t), new d7e(r / 8, n[1] === "int", t.name);
  }
  if (n = t.type.match(PNe), n) {
    let r = parseInt(n[1]);
    return de(r !== 0 && r <= 32, "invalid bytes length", "param", t), new s7e(r, t.name);
  }
  de(!1, "invalid type", "type", t.type);
};
let gb = bA;
class RNe {
  /**
   *  @_ignore:
   */
  constructor(t, n, r) {
    /**
     *  The matching fragment for the ``topic0``.
     */
    pe(this, "fragment");
    /**
     *  The name of the Event.
     */
    pe(this, "name");
    /**
     *  The full Event signature.
     */
    pe(this, "signature");
    /**
     *  The topic hash for the Event.
     */
    pe(this, "topic");
    /**
     *  The arguments passed into the Event with ``emit``.
     */
    pe(this, "args");
    const i = t.name, s = t.format();
    ft(this, {
      fragment: t,
      name: i,
      signature: s,
      topic: n,
      args: r
    });
  }
}
class MNe {
  /**
   *  @_ignore:
   */
  constructor(t, n, r, i) {
    /**
     *  The matching fragment from the transaction ``data``.
     */
    pe(this, "fragment");
    /**
     *  The name of the Function from the transaction ``data``.
     */
    pe(this, "name");
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */
    pe(this, "args");
    /**
     *  The full Function signature from the transaction ``data``.
     */
    pe(this, "signature");
    /**
     *  The selector for the Function from the transaction ``data``.
     */
    pe(this, "selector");
    /**
     *  The ``value`` (in wei) from the transaction.
     */
    pe(this, "value");
    const s = t.name, o = t.format();
    ft(this, {
      fragment: t,
      name: s,
      args: r,
      signature: o,
      selector: n,
      value: i
    });
  }
}
class FNe {
  /**
   *  @_ignore:
   */
  constructor(t, n, r) {
    /**
     *  The matching fragment.
     */
    pe(this, "fragment");
    /**
     *  The name of the Error.
     */
    pe(this, "name");
    /**
     *  The arguments passed to the Error with ``revert``.
     */
    pe(this, "args");
    /**
     *  The full Error signature.
     */
    pe(this, "signature");
    /**
     *  The selector for the Error.
     */
    pe(this, "selector");
    const i = t.name, s = t.format();
    ft(this, {
      fragment: t,
      name: i,
      args: r,
      signature: s,
      selector: n
    });
  }
}
class TM {
  /**
   *  @_ignore:
   */
  constructor(t) {
    /**
     *  The ``keccak256`` of the value logged.
     */
    pe(this, "hash");
    /**
     *  @_ignore:
     */
    pe(this, "_isIndexed");
    ft(this, { hash: t, _isIndexed: !0 });
  }
  /**
   *  Returns ``true`` if %%value%% is an **Indexed**.
   *
   *  This provides a Type Guard for property access.
   */
  static isIndexed(t) {
    return !!(t && t._isIndexed);
  }
}
const kM = {
  0: "generic panic",
  1: "assert(false)",
  17: "arithmetic overflow",
  18: "division or modulo by zero",
  33: "enum overflow",
  34: "invalid encoded storage byte array accessed",
  49: "out-of-bounds array access; popping on an empty array",
  50: "out-of-bounds access of an array or bytesN",
  65: "out of memory",
  81: "uninitialized function"
}, BM = {
  "0x08c379a0": {
    signature: "Error(string)",
    name: "Error",
    inputs: ["string"],
    reason: (e) => `reverted with reason string ${JSON.stringify(e)}`
  },
  "0x4e487b71": {
    signature: "Panic(uint256)",
    name: "Panic",
    inputs: ["uint256"],
    reason: (e) => {
      let t = "unknown panic code";
      return e >= 0 && e <= 255 && kM[e.toString()] && (t = kM[e.toString()]), `reverted with panic code 0x${e.toString(16)} (${t})`;
    }
  }
};
var Qo, Ko, Yo, Mr, Lp, ux, zp, dx;
const Qu = class Qu {
  /**
   *  Create a new Interface for the %%fragments%%.
   */
  constructor(t) {
    // Find a function definition by any means necessary (unless it is ambiguous)
    re(this, Lp);
    // Find an event definition by any means necessary (unless it is ambiguous)
    re(this, zp);
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */
    pe(this, "fragments");
    /**
     *  The Contract constructor.
     */
    pe(this, "deploy");
    /**
     *  The Fallback method, if any.
     */
    pe(this, "fallback");
    /**
     *  If receiving ether is supported.
     */
    pe(this, "receive");
    re(this, Qo, void 0);
    re(this, Ko, void 0);
    re(this, Yo, void 0);
    //    #structs: Map<string, StructFragment>;
    re(this, Mr, void 0);
    let n = [];
    typeof t == "string" ? n = JSON.parse(t) : n = t, j(this, Yo, /* @__PURE__ */ new Map()), j(this, Qo, /* @__PURE__ */ new Map()), j(this, Ko, /* @__PURE__ */ new Map());
    const r = [];
    for (const o of n)
      try {
        r.push(Af.from(o));
      } catch (a) {
        console.log(`[Warning] Invalid Fragment ${JSON.stringify(o)}:`, a.message);
      }
    ft(this, {
      fragments: Object.freeze(r)
    });
    let i = null, s = !1;
    j(this, Mr, this.getAbiCoder()), this.fragments.forEach((o, a) => {
      let c;
      switch (o.type) {
        case "constructor":
          if (this.deploy) {
            console.log("duplicate definition - constructor");
            return;
          }
          ft(this, { deploy: o });
          return;
        case "fallback":
          o.inputs.length === 0 ? s = !0 : (de(!i || o.payable !== i.payable, "conflicting fallback fragments", `fragments[${a}]`, o), i = o, s = i.payable);
          return;
        case "function":
          c = C(this, Yo);
          break;
        case "event":
          c = C(this, Ko);
          break;
        case "error":
          c = C(this, Qo);
          break;
        default:
          return;
      }
      const l = o.format();
      c.has(l) || c.set(l, o);
    }), this.deploy || ft(this, {
      deploy: lc.from("constructor()")
    }), ft(this, { fallback: i, receive: s });
  }
  /**
   *  Returns the entire Human-Readable ABI, as an array of
   *  signatures, optionally as %%minimal%% strings, which
   *  removes parameter names and unneceesary spaces.
   */
  format(t) {
    const n = t ? "minimal" : "full";
    return this.fragments.map((i) => i.format(n));
  }
  /**
   *  Return the JSON-encoded ABI. This is the format Solidiy
   *  returns.
   */
  formatJson() {
    const t = this.fragments.map((n) => n.format("json"));
    return JSON.stringify(t.map((n) => JSON.parse(n)));
  }
  /**
   *  The ABI coder that will be used to encode and decode binary
   *  data.
   */
  getAbiCoder() {
    return gb.defaultAbiCoder();
  }
  /**
   *  Get the function name for %%key%%, which may be a function selector,
   *  function name or function signature that belongs to the ABI.
   */
  getFunctionName(t) {
    const n = Se(this, Lp, ux).call(this, t, null, !1);
    return de(n, "no matching function", "key", t), n.name;
  }
  /**
   *  Returns true if %%key%% (a function selector, function name or
   *  function signature) is present in the ABI.
   *
   *  In the case of a function name, the name may be ambiguous, so
   *  accessing the [[FunctionFragment]] may require refinement.
   */
  hasFunction(t) {
    return !!Se(this, Lp, ux).call(this, t, null, !1);
  }
  /**
   *  Get the [[FunctionFragment]] for %%key%%, which may be a function
   *  selector, function name or function signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple functions match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single function in
   *  the ABI, this will throw.
   */
  getFunction(t, n) {
    return Se(this, Lp, ux).call(this, t, n || null, !0);
  }
  /**
   *  Iterate over all functions, calling %%callback%%, sorted by their name.
   */
  forEachFunction(t) {
    const n = Array.from(C(this, Yo).keys());
    n.sort((r, i) => r.localeCompare(i));
    for (let r = 0; r < n.length; r++) {
      const i = n[r];
      t(C(this, Yo).get(i), r);
    }
  }
  /**
   *  Get the event name for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   */
  getEventName(t) {
    const n = Se(this, zp, dx).call(this, t, null, !1);
    return de(n, "no matching event", "key", t), n.name;
  }
  /**
   *  Returns true if %%key%% (an event topic hash, event name or
   *  event signature) is present in the ABI.
   *
   *  In the case of an event name, the name may be ambiguous, so
   *  accessing the [[EventFragment]] may require refinement.
   */
  hasEvent(t) {
    return !!Se(this, zp, dx).call(this, t, null, !1);
  }
  /**
   *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple events match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single event in
   *  the ABI, this will throw.
   */
  getEvent(t, n) {
    return Se(this, zp, dx).call(this, t, n || null, !0);
  }
  /**
   *  Iterate over all events, calling %%callback%%, sorted by their name.
   */
  forEachEvent(t) {
    const n = Array.from(C(this, Ko).keys());
    n.sort((r, i) => r.localeCompare(i));
    for (let r = 0; r < n.length; r++) {
      const i = n[r];
      t(C(this, Ko).get(i), r);
    }
  }
  /**
   *  Get the [[ErrorFragment]] for %%key%%, which may be an error
   *  selector, error name or error signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple errors match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single error in
   *  the ABI, this will throw.
   */
  getError(t, n) {
    if (mn(t)) {
      const i = t.toLowerCase();
      if (BM[i])
        return Ci.from(BM[i].signature);
      for (const s of C(this, Qo).values())
        if (i === s.selector)
          return s;
      return null;
    }
    if (t.indexOf("(") === -1) {
      const i = [];
      for (const [s, o] of C(this, Qo))
        s.split(
          "("
          /* fix:) */
        )[0] === t && i.push(o);
      if (i.length === 0)
        return t === "Error" ? Ci.from("error Error(string)") : t === "Panic" ? Ci.from("error Panic(uint256)") : null;
      if (i.length > 1) {
        const s = i.map((o) => JSON.stringify(o.format())).join(", ");
        de(!1, `ambiguous error description (i.e. ${s})`, "name", t);
      }
      return i[0];
    }
    if (t = Ci.from(t).format(), t === "Error(string)")
      return Ci.from("error Error(string)");
    if (t === "Panic(uint256)")
      return Ci.from("error Panic(uint256)");
    const r = C(this, Qo).get(t);
    return r || null;
  }
  /**
   *  Iterate over all errors, calling %%callback%%, sorted by their name.
   */
  forEachError(t) {
    const n = Array.from(C(this, Qo).keys());
    n.sort((r, i) => r.localeCompare(i));
    for (let r = 0; r < n.length; r++) {
      const i = n[r];
      t(C(this, Qo).get(i), r);
    }
  }
  // Get the 4-byte selector used by Solidity to identify a function
  /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];
  
          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }
  
          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }
  
          fragment = matches[0];
      }
  
      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
  // Get the 32-byte topic hash used by Solidity to identify an event
  /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
  _decodeParams(t, n) {
    return C(this, Mr).decode(t, n);
  }
  _encodeParams(t, n) {
    return C(this, Mr).encode(t, n);
  }
  /**
   *  Encodes a ``tx.data`` object for deploying the Contract with
   *  the %%values%% as the constructor arguments.
   */
  encodeDeploy(t) {
    return this._encodeParams(this.deploy.inputs, t || []);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified error (see [[getError]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeErrorResult(t, n) {
    if (typeof t == "string") {
      const r = this.getError(t);
      de(r, "unknown error", "fragment", t), t = r;
    }
    return de(Pn(n, 0, 4) === t.selector, `data signature does not match error ${t.name}.`, "data", n), this._decodeParams(t.inputs, Pn(n, 4));
  }
  /**
   *  Encodes the transaction revert data for a call result that
   *  reverted from the the Contract with the sepcified %%error%%
   *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeErrorResult(t, n) {
    if (typeof t == "string") {
      const r = this.getError(t);
      de(r, "unknown error", "fragment", t), t = r;
    }
    return Vn([
      t.selector,
      this._encodeParams(t.inputs, n || [])
    ]);
  }
  /**
   *  Decodes the %%data%% from a transaction ``tx.data`` for
   *  the function specified (see [[getFunction]] for valid values
   *  for %%fragment%%).
   *
   *  Most developers should prefer the [[parseTransaction]] method
   *  instead, which will automatically detect the fragment.
   */
  decodeFunctionData(t, n) {
    if (typeof t == "string") {
      const r = this.getFunction(t);
      de(r, "unknown function", "fragment", t), t = r;
    }
    return de(Pn(n, 0, 4) === t.selector, `data signature does not match function ${t.name}.`, "data", n), this._decodeParams(t.inputs, Pn(n, 4));
  }
  /**
   *  Encodes the ``tx.data`` for a transaction that calls the function
   *  specified (see [[getFunction]] for valid values for %%fragment%%) with
   *  the %%values%%.
   */
  encodeFunctionData(t, n) {
    if (typeof t == "string") {
      const r = this.getFunction(t);
      de(r, "unknown function", "fragment", t), t = r;
    }
    return Vn([
      t.selector,
      this._encodeParams(t.inputs, n || [])
    ]);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeFunctionResult(t, n) {
    if (typeof t == "string") {
      const s = this.getFunction(t);
      de(s, "unknown function", "fragment", t), t = s;
    }
    let r = "invalid length for result data";
    const i = si(n);
    if (i.length % 32 === 0)
      try {
        return C(this, Mr).decode(t.outputs, i);
      } catch {
        r = "could not decode result data";
      }
    Pe(!1, r, "BAD_DATA", {
      value: Je(i),
      info: { method: t.name, signature: t.format() }
    });
  }
  makeError(t, n) {
    const r = Ht(t, "data"), i = gb.getBuiltinCallException("call", n, r);
    if (i.message.startsWith("execution reverted (unknown custom error)")) {
      const a = Je(r.slice(0, 4)), c = this.getError(a);
      if (c)
        try {
          const l = C(this, Mr).decode(c.inputs, r.slice(4));
          i.revert = {
            name: c.name,
            signature: c.format(),
            args: l
          }, i.reason = i.revert.signature, i.message = `execution reverted: ${i.reason}`;
        } catch {
          i.message = "execution reverted (coult not decode custom error)";
        }
    }
    const o = this.parseTransaction(n);
    return o && (i.invocation = {
      method: o.name,
      signature: o.signature,
      args: o.args
    }), i;
  }
  /**
   *  Encodes the result data (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values
   *  for %%fragment%%) with %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeFunctionResult(t, n) {
    if (typeof t == "string") {
      const r = this.getFunction(t);
      de(r, "unknown function", "fragment", t), t = r;
    }
    return Je(C(this, Mr).encode(t.outputs, n || []));
  }
  /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };
  
          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }
              
          };
  
          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(t, n) {
    if (typeof t == "string") {
      const s = this.getEvent(t);
      de(s, "unknown event", "eventFragment", t), t = s;
    }
    Pe(n.length <= t.inputs.length, `too many arguments for ${t.format()}`, "UNEXPECTED_ARGUMENT", { count: n.length, expectedCount: t.inputs.length });
    const r = [];
    t.anonymous || r.push(t.topicHash);
    const i = (s, o) => s.type === "string" ? wf(o) : s.type === "bytes" ? Yn(Je(o)) : (s.type === "bool" && typeof o == "boolean" ? o = o ? "0x01" : "0x00" : s.type.match(/^u?int/) ? o = hu(o) : s.type.match(/^bytes/) ? o = oPe(o, 32) : s.type === "address" && C(this, Mr).encode(["address"], [o]), bf(Je(o), 32));
    for (n.forEach((s, o) => {
      const a = t.inputs[o];
      if (!a.indexed) {
        de(s == null, "cannot filter non-indexed parameters; must be null", "contract." + a.name, s);
        return;
      }
      s == null ? r.push(null) : a.baseType === "array" || a.baseType === "tuple" ? de(!1, "filtering with tuples or arrays not supported", "contract." + a.name, s) : Array.isArray(s) ? r.push(s.map((c) => i(a, c))) : r.push(i(a, s));
    }); r.length && r[r.length - 1] === null; )
      r.pop();
    return r;
  }
  encodeEventLog(t, n) {
    if (typeof t == "string") {
      const o = this.getEvent(t);
      de(o, "unknown event", "eventFragment", t), t = o;
    }
    const r = [], i = [], s = [];
    return t.anonymous || r.push(t.topicHash), de(n.length === t.inputs.length, "event arguments/values mismatch", "values", n), t.inputs.forEach((o, a) => {
      const c = n[a];
      if (o.indexed)
        if (o.type === "string")
          r.push(wf(c));
        else if (o.type === "bytes")
          r.push(Yn(c));
        else {
          if (o.baseType === "tuple" || o.baseType === "array")
            throw new Error("not implemented");
          r.push(C(this, Mr).encode([o.type], [c]));
        }
      else
        i.push(o), s.push(c);
    }), {
      data: C(this, Mr).encode(i, s),
      topics: r
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(t, n, r) {
    if (typeof t == "string") {
      const p = this.getEvent(t);
      de(p, "unknown event", "eventFragment", t), t = p;
    }
    if (r != null && !t.anonymous) {
      const p = t.topicHash;
      de(mn(r[0], 32) && r[0].toLowerCase() === p, "fragment/topic mismatch", "topics[0]", r[0]), r = r.slice(1);
    }
    const i = [], s = [], o = [];
    t.inputs.forEach((p, m) => {
      p.indexed ? p.type === "string" || p.type === "bytes" || p.baseType === "tuple" || p.baseType === "array" ? (i.push(Cr.from({ type: "bytes32", name: p.name })), o.push(!0)) : (i.push(p), o.push(!1)) : (s.push(p), o.push(!1));
    });
    const a = r != null ? C(this, Mr).decode(i, Vn(r)) : null, c = C(this, Mr).decode(s, n, !0), l = [], u = [];
    let d = 0, f = 0;
    return t.inputs.forEach((p, m) => {
      let h = null;
      if (p.indexed)
        if (a == null)
          h = new TM(null);
        else if (o[m])
          h = new TM(a[f++]);
        else
          try {
            h = a[f++];
          } catch (g) {
            h = g;
          }
      else
        try {
          h = c[d++];
        } catch (g) {
          h = g;
        }
      l.push(h), u.push(p.name || null);
    }), L2.fromItems(l, u);
  }
  /**
   *  Parses a transaction, finding the matching function and extracts
   *  the parameter values along with other useful function details.
   *
   *  If the matching function cannot be found, return null.
   */
  parseTransaction(t) {
    const n = Ht(t.data, "tx.data"), r = nt(t.value != null ? t.value : 0, "tx.value"), i = this.getFunction(Je(n.slice(0, 4)));
    if (!i)
      return null;
    const s = C(this, Mr).decode(i.inputs, n.slice(4));
    return new MNe(i, i.selector, s, r);
  }
  parseCallResult(t) {
    throw new Error("@TODO");
  }
  /**
   *  Parses a receipt log, finding the matching event and extracts
   *  the parameter values along with other useful event details.
   *
   *  If the matching event cannot be found, returns null.
   */
  parseLog(t) {
    const n = this.getEvent(t.topics[0]);
    return !n || n.anonymous ? null : new RNe(n, n.topicHash, this.decodeEventLog(n, t.data, t.topics));
  }
  /**
   *  Parses a revert data, finding the matching error and extracts
   *  the parameter values along with other useful error details.
   *
   *  If the matching error cannot be found, returns null.
   */
  parseError(t) {
    const n = Je(t), r = this.getError(Pn(n, 0, 4));
    if (!r)
      return null;
    const i = C(this, Mr).decode(r.inputs, Pn(n, 4));
    return new FNe(r, r.selector, i);
  }
  /**
   *  Creates a new [[Interface]] from the ABI %%value%%.
   *
   *  The %%value%% may be provided as an existing [[Interface]] object,
   *  a JSON-encoded ABI or any Human-Readable ABI format.
   */
  static from(t) {
    return t instanceof Qu ? t : typeof t == "string" ? new Qu(JSON.parse(t)) : typeof t.formatJson == "function" ? new Qu(t.formatJson()) : typeof t.format == "function" ? new Qu(t.format("json")) : new Qu(t);
  }
};
Qo = new WeakMap(), Ko = new WeakMap(), Yo = new WeakMap(), Mr = new WeakMap(), Lp = new WeakSet(), ux = function(t, n, r) {
  if (mn(t)) {
    const s = t.toLowerCase();
    for (const o of C(this, Yo).values())
      if (s === o.selector)
        return o;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const s = [];
    for (const [o, a] of C(this, Yo))
      o.split(
        "("
        /* fix:) */
      )[0] === t && s.push(a);
    if (n) {
      const o = n.length > 0 ? n[n.length - 1] : null;
      let a = n.length, c = !0;
      qr.isTyped(o) && o.type === "overrides" && (c = !1, a--);
      for (let l = s.length - 1; l >= 0; l--) {
        const u = s[l].inputs.length;
        u !== a && (!c || u !== a - 1) && s.splice(l, 1);
      }
      for (let l = s.length - 1; l >= 0; l--) {
        const u = s[l].inputs;
        for (let d = 0; d < n.length; d++)
          if (qr.isTyped(n[d])) {
            if (d >= u.length) {
              if (n[d].type === "overrides")
                continue;
              s.splice(l, 1);
              break;
            }
            if (n[d].type !== u[d].baseType) {
              s.splice(l, 1);
              break;
            }
          }
      }
    }
    if (s.length === 1 && n && n.length !== s[0].inputs.length) {
      const o = n[n.length - 1];
      (o == null || Array.isArray(o) || typeof o != "object") && s.splice(0, 1);
    }
    if (s.length === 0)
      return null;
    if (s.length > 1 && r) {
      const o = s.map((a) => JSON.stringify(a.format())).join(", ");
      de(!1, `ambiguous function description (i.e. matches ${o})`, "key", t);
    }
    return s[0];
  }
  const i = C(this, Yo).get(la.from(t).format());
  return i || null;
}, zp = new WeakSet(), dx = function(t, n, r) {
  if (mn(t)) {
    const s = t.toLowerCase();
    for (const o of C(this, Ko).values())
      if (s === o.topicHash)
        return o;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const s = [];
    for (const [o, a] of C(this, Ko))
      o.split(
        "("
        /* fix:) */
      )[0] === t && s.push(a);
    if (n) {
      for (let o = s.length - 1; o >= 0; o--)
        s[o].inputs.length < n.length && s.splice(o, 1);
      for (let o = s.length - 1; o >= 0; o--) {
        const a = s[o].inputs;
        for (let c = 0; c < n.length; c++)
          if (qr.isTyped(n[c]) && n[c].type !== a[c].baseType) {
            s.splice(o, 1);
            break;
          }
      }
    }
    if (s.length === 0)
      return null;
    if (s.length > 1 && r) {
      const o = s.map((a) => JSON.stringify(a.format())).join(", ");
      de(!1, `ambiguous event description (i.e. matches ${o})`, "key", t);
    }
    return s[0];
  }
  const i = C(this, Ko).get(ca.from(t).format());
  return i || null;
};
let nk = Qu;
const KK = BigInt(0);
function ep(e) {
  return e ?? null;
}
function jn(e) {
  return e == null ? null : e.toString();
}
class IM {
  /**
   *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
   *  %%maxPriorityFeePerGas%%.
   */
  constructor(t, n, r) {
    /**
     *  The gas price for legacy networks.
     */
    pe(this, "gasPrice");
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */
    pe(this, "maxFeePerGas");
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */
    pe(this, "maxPriorityFeePerGas");
    ft(this, {
      gasPrice: ep(t),
      maxFeePerGas: ep(n),
      maxPriorityFeePerGas: ep(r)
    });
  }
  /**
   *  Returns a JSON-friendly value.
   */
  toJSON() {
    const { gasPrice: t, maxFeePerGas: n, maxPriorityFeePerGas: r } = this;
    return {
      _type: "FeeData",
      gasPrice: jn(t),
      maxFeePerGas: jn(n),
      maxPriorityFeePerGas: jn(r)
    };
  }
}
function K2(e) {
  const t = {};
  e.to && (t.to = e.to), e.from && (t.from = e.from), e.data && (t.data = Je(e.data));
  const n = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const i of n)
    !(i in e) || e[i] == null || (t[i] = nt(e[i], `request.${i}`));
  const r = "type,nonce".split(/,/);
  for (const i of r)
    !(i in e) || e[i] == null || (t[i] = Ot(e[i], `request.${i}`));
  return e.accessList && (t.accessList = Of(e.accessList)), "blockTag" in e && (t.blockTag = e.blockTag), "enableCcipRead" in e && (t.enableCcipRead = !!e.enableCcipRead), "customData" in e && (t.customData = e.customData), "blobVersionedHashes" in e && e.blobVersionedHashes && (t.blobVersionedHashes = e.blobVersionedHashes.slice()), "kzg" in e && (t.kzg = e.kzg), "blobs" in e && e.blobs && (t.blobs = e.blobs.map((i) => rB(i) ? Je(i) : Object.assign({}, i))), t;
}
var Qa;
class jNe {
  /**
   *  Create a new **Block** object.
   *
   *  This should generally not be necessary as the unless implementing a
   *  low-level library.
   */
  constructor(t, n) {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */
    pe(this, "provider");
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */
    pe(this, "number");
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */
    pe(this, "hash");
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */
    pe(this, "timestamp");
    /**
     *  The block hash of the parent block.
     */
    pe(this, "parentHash");
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */
    pe(this, "parentBeaconBlockRoot");
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */
    pe(this, "nonce");
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */
    pe(this, "difficulty");
    /**
     *  The total gas limit for this block.
     */
    pe(this, "gasLimit");
    /**
     *  The total gas used in this block.
     */
    pe(this, "gasUsed");
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */
    pe(this, "stateRoot");
    /**
     *  The hash of the transaction receipts trie.
     */
    pe(this, "receiptsRoot");
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */
    pe(this, "blobGasUsed");
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */
    pe(this, "excessBlobGas");
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */
    pe(this, "miner");
    /**
     *  The latest RANDAO mix of the post beacon state of
     *  the previous block.
     */
    pe(this, "prevRandao");
    /**
     *  Any extra data the validator wished to include.
     */
    pe(this, "extraData");
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */
    pe(this, "baseFeePerGas");
    re(this, Qa, void 0);
    j(this, Qa, t.transactions.map((r) => typeof r != "string" ? new yb(r, n) : r)), ft(this, {
      provider: n,
      hash: ep(t.hash),
      number: t.number,
      timestamp: t.timestamp,
      parentHash: t.parentHash,
      parentBeaconBlockRoot: t.parentBeaconBlockRoot,
      nonce: t.nonce,
      difficulty: t.difficulty,
      gasLimit: t.gasLimit,
      gasUsed: t.gasUsed,
      blobGasUsed: t.blobGasUsed,
      excessBlobGas: t.excessBlobGas,
      miner: t.miner,
      prevRandao: ep(t.prevRandao),
      extraData: t.extraData,
      baseFeePerGas: ep(t.baseFeePerGas),
      stateRoot: t.stateRoot,
      receiptsRoot: t.receiptsRoot
    });
  }
  /**
   *  Returns the list of transaction hashes, in the order
   *  they were executed within the block.
   */
  get transactions() {
    return C(this, Qa).map((t) => typeof t == "string" ? t : t.hash);
  }
  /**
   *  Returns the complete transactions, in the order they
   *  were executed within the block.
   *
   *  This is only available for blocks which prefetched
   *  transactions, by passing ``true`` to %%prefetchTxs%%
   *  into [[Provider-getBlock]].
   */
  get prefetchedTransactions() {
    const t = C(this, Qa).slice();
    return t.length === 0 ? [] : (Pe(typeof t[0] == "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
      operation: "transactionResponses()"
    }), t);
  }
  /**
   *  Returns a JSON-friendly value.
   */
  toJSON() {
    const { baseFeePerGas: t, difficulty: n, extraData: r, gasLimit: i, gasUsed: s, hash: o, miner: a, prevRandao: c, nonce: l, number: u, parentHash: d, parentBeaconBlockRoot: f, stateRoot: p, receiptsRoot: m, timestamp: h, transactions: g } = this;
    return {
      _type: "Block",
      baseFeePerGas: jn(t),
      difficulty: jn(n),
      extraData: r,
      gasLimit: jn(i),
      gasUsed: jn(s),
      blobGasUsed: jn(this.blobGasUsed),
      excessBlobGas: jn(this.excessBlobGas),
      hash: o,
      miner: a,
      prevRandao: c,
      nonce: l,
      number: u,
      parentHash: d,
      timestamp: h,
      parentBeaconBlockRoot: f,
      stateRoot: p,
      receiptsRoot: m,
      transactions: g
    };
  }
  [Symbol.iterator]() {
    let t = 0;
    const n = this.transactions;
    return {
      next: () => t < this.length ? {
        value: n[t++],
        done: !1
      } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The number of transactions in this block.
   */
  get length() {
    return C(this, Qa).length;
  }
  /**
   *  The [[link-js-date]] this block was included at.
   */
  get date() {
    return this.timestamp == null ? null : new Date(this.timestamp * 1e3);
  }
  /**
   *  Get the transaction at %%indexe%% within this block.
   */
  async getTransaction(t) {
    let n;
    if (typeof t == "number")
      n = C(this, Qa)[t];
    else {
      const r = t.toLowerCase();
      for (const i of C(this, Qa))
        if (typeof i == "string") {
          if (i !== r)
            continue;
          n = i;
          break;
        } else {
          if (i.hash === r)
            continue;
          n = i;
          break;
        }
    }
    if (n == null)
      throw new Error("no such tx");
    return typeof n == "string" ? await this.provider.getTransaction(n) : n;
  }
  /**
   *  If a **Block** was fetched with a request to include the transactions
   *  this will allow synchronous access to those transactions.
   *
   *  If the transactions were not prefetched, this will throw.
   */
  getPrefetchedTransaction(t) {
    const n = this.prefetchedTransactions;
    if (typeof t == "number")
      return n[t];
    t = t.toLowerCase();
    for (const r of n)
      if (r.hash === t)
        return r;
    de(!1, "no matching transaction", "indexOrHash", t);
  }
  /**
   *  Returns true if this block been mined. This provides a type guard
   *  for all properties on a [[MinedBlock]].
   */
  isMined() {
    return !!this.hash;
  }
  /**
   *  Returns true if this block is an [[link-eip-2930]] block.
   */
  isLondon() {
    return !!this.baseFeePerGas;
  }
  /**
   *  @_ignore:
   */
  orphanedEvent() {
    if (!this.isMined())
      throw new Error("");
    return DNe(this);
  }
}
Qa = new WeakMap();
class Uv {
  /**
   *  @_ignore:
   */
  constructor(t, n) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    pe(this, "provider");
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */
    pe(this, "transactionHash");
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */
    pe(this, "blockHash");
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */
    pe(this, "blockNumber");
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */
    pe(this, "removed");
    /**
     *  The address of the contract that emitted this log.
     */
    pe(this, "address");
    /**
     *  The data included in this log when it was emitted.
     */
    pe(this, "data");
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */
    pe(this, "topics");
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */
    pe(this, "index");
    /**
     *  The index within the transaction of this log.
     */
    pe(this, "transactionIndex");
    this.provider = n;
    const r = Object.freeze(t.topics.slice());
    ft(this, {
      transactionHash: t.transactionHash,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      removed: t.removed,
      address: t.address,
      data: t.data,
      topics: r,
      index: t.index,
      transactionIndex: t.transactionIndex
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const { address: t, blockHash: n, blockNumber: r, data: i, index: s, removed: o, topics: a, transactionHash: c, transactionIndex: l } = this;
    return {
      _type: "log",
      address: t,
      blockHash: n,
      blockNumber: r,
      data: i,
      index: s,
      removed: o,
      topics: a,
      transactionHash: c,
      transactionIndex: l
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const t = await this.provider.getBlock(this.blockHash);
    return Pe(!!t, "failed to find transaction", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const t = await this.provider.getTransaction(this.transactionHash);
    return Pe(!!t, "failed to find transaction", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const t = await this.provider.getTransactionReceipt(this.transactionHash);
    return Pe(!!t, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return UNe(this);
  }
}
var Vb;
class YK {
  /**
   *  @_ignore:
   */
  constructor(t, n) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    pe(this, "provider");
    /**
     *  The address the transaction was sent to.
     */
    pe(this, "to");
    /**
     *  The sender of the transaction.
     */
    pe(this, "from");
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */
    pe(this, "contractAddress");
    /**
     *  The transaction hash.
     */
    pe(this, "hash");
    /**
     *  The index of this transaction within the block transactions.
     */
    pe(this, "index");
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */
    pe(this, "blockHash");
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */
    pe(this, "blockNumber");
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */
    pe(this, "logsBloom");
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */
    pe(this, "gasUsed");
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */
    pe(this, "blobGasUsed");
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */
    pe(this, "cumulativeGasUsed");
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */
    pe(this, "gasPrice");
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */
    pe(this, "blobGasPrice");
    /**
     *  The [[link-eip-2718]] transaction type.
     */
    pe(this, "type");
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */
    pe(this, "status");
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */
    pe(this, "root");
    re(this, Vb, void 0);
    j(this, Vb, Object.freeze(t.logs.map((i) => new Uv(i, n))));
    let r = KK;
    t.effectiveGasPrice != null ? r = t.effectiveGasPrice : t.gasPrice != null && (r = t.gasPrice), ft(this, {
      provider: n,
      to: t.to,
      from: t.from,
      contractAddress: t.contractAddress,
      hash: t.hash,
      index: t.index,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      logsBloom: t.logsBloom,
      gasUsed: t.gasUsed,
      cumulativeGasUsed: t.cumulativeGasUsed,
      blobGasUsed: t.blobGasUsed,
      gasPrice: r,
      blobGasPrice: t.blobGasPrice,
      type: t.type,
      //byzantium: tx.byzantium,
      status: t.status,
      root: t.root
    });
  }
  /**
   *  The logs for this transaction.
   */
  get logs() {
    return C(this, Vb);
  }
  /**
   *  Returns a JSON-compatible representation.
   */
  toJSON() {
    const {
      to: t,
      from: n,
      contractAddress: r,
      hash: i,
      index: s,
      blockHash: o,
      blockNumber: a,
      logsBloom: c,
      logs: l,
      //byzantium, 
      status: u,
      root: d
    } = this;
    return {
      _type: "TransactionReceipt",
      blockHash: o,
      blockNumber: a,
      //byzantium, 
      contractAddress: r,
      cumulativeGasUsed: jn(this.cumulativeGasUsed),
      from: n,
      gasPrice: jn(this.gasPrice),
      blobGasUsed: jn(this.blobGasUsed),
      blobGasPrice: jn(this.blobGasPrice),
      gasUsed: jn(this.gasUsed),
      hash: i,
      index: s,
      logs: l,
      logsBloom: c,
      root: d,
      status: u,
      to: t
    };
  }
  /**
   *  @_ignore:
   */
  get length() {
    return this.logs.length;
  }
  [Symbol.iterator]() {
    let t = 0;
    return {
      next: () => t < this.length ? { value: this.logs[t++], done: !1 } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The total fee for this transaction, in wei.
   */
  get fee() {
    return this.gasUsed * this.gasPrice;
  }
  /**
   *  Resolves to the block this transaction occurred in.
   */
  async getBlock() {
    const t = await this.provider.getBlock(this.blockHash);
    if (t == null)
      throw new Error("TODO");
    return t;
  }
  /**
   *  Resolves to the transaction this transaction occurred in.
   */
  async getTransaction() {
    const t = await this.provider.getTransaction(this.hash);
    if (t == null)
      throw new Error("TODO");
    return t;
  }
  /**
   *  Resolves to the return value of the execution of this transaction.
   *
   *  Support for this feature is limited, as it requires an archive node
   *  with the ``debug_`` or ``trace_`` API enabled.
   */
  async getResult() {
    return await this.provider.getTransactionResult(this.hash);
  }
  /**
   *  Resolves to the number of confirmations this transaction has.
   */
  async confirmations() {
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return JK(this);
  }
  /**
   *  @_ignore:
   */
  reorderedEvent(t) {
    return Pe(!t || t.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), ZK(this, t);
  }
}
Vb = new WeakMap();
var Tl;
const PB = class PB {
  /**
   *  @_ignore:
   */
  constructor(t, n) {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */
    pe(this, "provider");
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    pe(this, "blockNumber");
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    pe(this, "blockHash");
    /**
     *  The index within the block that this transaction resides at.
     */
    pe(this, "index");
    /**
     *  The transaction hash.
     */
    pe(this, "hash");
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */
    pe(this, "type");
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */
    pe(this, "to");
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */
    pe(this, "from");
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */
    pe(this, "nonce");
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */
    pe(this, "gasLimit");
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */
    pe(this, "gasPrice");
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */
    pe(this, "maxPriorityFeePerGas");
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */
    pe(this, "maxFeePerGas");
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */
    pe(this, "maxFeePerBlobGas");
    /**
     *  The data.
     */
    pe(this, "data");
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */
    pe(this, "value");
    /**
     *  The chain ID.
     */
    pe(this, "chainId");
    /**
     *  The signature.
     */
    pe(this, "signature");
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */
    pe(this, "accessList");
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */
    pe(this, "blobVersionedHashes");
    re(this, Tl, void 0);
    this.provider = n, this.blockNumber = t.blockNumber != null ? t.blockNumber : null, this.blockHash = t.blockHash != null ? t.blockHash : null, this.hash = t.hash, this.index = t.index, this.type = t.type, this.from = t.from, this.to = t.to || null, this.gasLimit = t.gasLimit, this.nonce = t.nonce, this.data = t.data, this.value = t.value, this.gasPrice = t.gasPrice, this.maxPriorityFeePerGas = t.maxPriorityFeePerGas != null ? t.maxPriorityFeePerGas : null, this.maxFeePerGas = t.maxFeePerGas != null ? t.maxFeePerGas : null, this.maxFeePerBlobGas = t.maxFeePerBlobGas != null ? t.maxFeePerBlobGas : null, this.chainId = t.chainId, this.signature = t.signature, this.accessList = t.accessList != null ? t.accessList : null, this.blobVersionedHashes = t.blobVersionedHashes != null ? t.blobVersionedHashes : null, j(this, Tl, -1);
  }
  /**
   *  Returns a JSON-compatible representation of this transaction.
   */
  toJSON() {
    const { blockNumber: t, blockHash: n, index: r, hash: i, type: s, to: o, from: a, nonce: c, data: l, signature: u, accessList: d, blobVersionedHashes: f } = this;
    return {
      _type: "TransactionResponse",
      accessList: d,
      blockNumber: t,
      blockHash: n,
      blobVersionedHashes: f,
      chainId: jn(this.chainId),
      data: l,
      from: a,
      gasLimit: jn(this.gasLimit),
      gasPrice: jn(this.gasPrice),
      hash: i,
      maxFeePerGas: jn(this.maxFeePerGas),
      maxPriorityFeePerGas: jn(this.maxPriorityFeePerGas),
      maxFeePerBlobGas: jn(this.maxFeePerBlobGas),
      nonce: c,
      signature: u,
      to: o,
      index: r,
      type: s,
      value: jn(this.value)
    };
  }
  /**
   *  Resolves to the Block that this transaction was included in.
   *
   *  This will return null if the transaction has not been included yet.
   */
  async getBlock() {
    let t = this.blockNumber;
    if (t == null) {
      const r = await this.getTransaction();
      r && (t = r.blockNumber);
    }
    if (t == null)
      return null;
    const n = this.provider.getBlock(t);
    if (n == null)
      throw new Error("TODO");
    return n;
  }
  /**
   *  Resolves to this transaction being re-requested from the
   *  provider. This can be used if you have an unmined transaction
   *  and wish to get an up-to-date populated instance.
   */
  async getTransaction() {
    return this.provider.getTransaction(this.hash);
  }
  /**
   *  Resolve to the number of confirmations this transaction has.
   */
  async confirmations() {
    if (this.blockNumber == null) {
      const { tx: n, blockNumber: r } = await ri({
        tx: this.getTransaction(),
        blockNumber: this.provider.getBlockNumber()
      });
      return n == null || n.blockNumber == null ? 0 : r - n.blockNumber + 1;
    }
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(t, n) {
    const r = t ?? 1, i = n ?? 0;
    let s = C(this, Tl), o = -1, a = s === -1;
    const c = async () => {
      if (a)
        return null;
      const { blockNumber: f, nonce: p } = await ri({
        blockNumber: this.provider.getBlockNumber(),
        nonce: this.provider.getTransactionCount(this.from)
      });
      if (p < this.nonce) {
        s = f;
        return;
      }
      if (a)
        return null;
      const m = await this.getTransaction();
      if (!(m && m.blockNumber != null))
        for (o === -1 && (o = s - 3, o < C(this, Tl) && (o = C(this, Tl))); o <= f; ) {
          if (a)
            return null;
          const h = await this.provider.getBlock(o, !0);
          if (h == null)
            return;
          for (const g of h)
            if (g === this.hash)
              return;
          for (let g = 0; g < h.length; g++) {
            const y = await h.getTransaction(g);
            if (y.from === this.from && y.nonce === this.nonce) {
              if (a)
                return null;
              const v = await this.provider.getTransactionReceipt(y.hash);
              if (v == null || f - v.blockNumber + 1 < r)
                return;
              let b = "replaced";
              y.data === this.data && y.to === this.to && y.value === this.value ? b = "repriced" : y.data === "0x" && y.from === y.to && y.value === KK && (b = "cancelled"), Pe(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                cancelled: b === "replaced" || b === "cancelled",
                reason: b,
                replacement: y.replaceableTransaction(s),
                hash: y.hash,
                receipt: v
              });
            }
          }
          o++;
        }
    }, l = (f) => {
      if (f == null || f.status !== 0)
        return f;
      Pe(!1, "transaction execution reverted", "CALL_EXCEPTION", {
        action: "sendTransaction",
        data: null,
        reason: null,
        invocation: null,
        revert: null,
        transaction: {
          to: f.to,
          from: f.from,
          data: ""
          // @TODO: in v7, split out sendTransaction properties
        },
        receipt: f
      });
    }, u = await this.provider.getTransactionReceipt(this.hash);
    if (r === 0)
      return l(u);
    if (u) {
      if (await u.confirmations() >= r)
        return l(u);
    } else if (await c(), r === 0)
      return null;
    return await new Promise((f, p) => {
      const m = [], h = () => {
        m.forEach((y) => y());
      };
      if (m.push(() => {
        a = !0;
      }), i > 0) {
        const y = setTimeout(() => {
          h(), p(qn("wait for transaction timeout", "TIMEOUT"));
        }, i);
        m.push(() => {
          clearTimeout(y);
        });
      }
      const g = async (y) => {
        if (await y.confirmations() >= r) {
          h();
          try {
            f(l(y));
          } catch (v) {
            p(v);
          }
        }
      };
      if (m.push(() => {
        this.provider.off(this.hash, g);
      }), this.provider.on(this.hash, g), s >= 0) {
        const y = async () => {
          try {
            await c();
          } catch (v) {
            if (Wr(v, "TRANSACTION_REPLACED")) {
              h(), p(v);
              return;
            }
          }
          a || this.provider.once("block", y);
        };
        m.push(() => {
          this.provider.off("block", y);
        }), this.provider.once("block", y);
      }
    });
  }
  /**
   *  Returns ``true`` if this transaction has been included.
   *
   *  This is effective only as of the time the TransactionResponse
   *  was instantiated. To get up-to-date information, use
   *  [[getTransaction]].
   *
   *  This provides a Type Guard that this transaction will have
   *  non-null property values for properties that are null for
   *  unmined transactions.
   */
  isMined() {
    return this.blockHash != null;
  }
  /**
   *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
   *  transaction.
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
   *  transaction. See [[link-eip-2070]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if the transaction is a London (i.e. ``type == 2``)
   *  transaction. See [[link-eip-1559]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
   *  transaction. See [[link-eip-4844]].
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that evict this transaction.
   */
  removedEvent() {
    return Pe(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), JK(this);
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that re-order this event against %%other%%.
   */
  reorderedEvent(t) {
    return Pe(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), Pe(!t || t.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), ZK(this, t);
  }
  /**
   *  Returns a new TransactionResponse instance which has the ability to
   *  detect (and throw an error) if the transaction is replaced, which
   *  will begin scanning at %%startBlock%%.
   *
   *  This should generally not be used by developers and is intended
   *  primarily for internal use. Setting an incorrect %%startBlock%% can
   *  have devastating performance consequences if used incorrectly.
   */
  replaceableTransaction(t) {
    de(Number.isInteger(t) && t >= 0, "invalid startBlock", "startBlock", t);
    const n = new PB(this, this.provider);
    return j(n, Tl, t), n;
  }
};
Tl = new WeakMap();
let yb = PB;
function DNe(e) {
  return { orphan: "drop-block", hash: e.hash, number: e.number };
}
function ZK(e, t) {
  return { orphan: "reorder-transaction", tx: e, other: t };
}
function JK(e) {
  return { orphan: "drop-transaction", tx: e };
}
function UNe(e) {
  return { orphan: "drop-log", log: {
    transactionHash: e.transactionHash,
    blockHash: e.blockHash,
    blockNumber: e.blockNumber,
    address: e.address,
    data: e.data,
    topics: Object.freeze(e.topics.slice()),
    index: e.index
  } };
}
class vB extends Uv {
  /**
   * @_ignore:
   */
  constructor(n, r, i) {
    super(n, n.provider);
    /**
     *  The Contract Interface.
     */
    pe(this, "interface");
    /**
     *  The matching event.
     */
    pe(this, "fragment");
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */
    pe(this, "args");
    const s = r.decodeEventLog(i, n.data, n.topics);
    ft(this, { args: s, fragment: i, interface: r });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
class XK extends Uv {
  /**
   * @_ignore:
   */
  constructor(n, r) {
    super(n, n.provider);
    /**
     *  The error encounted when trying to decode the log.
     */
    pe(this, "error");
    ft(this, { error: r });
  }
}
var Vp;
class LNe extends YK {
  /**
   *  @_ignore:
   */
  constructor(n, r, i) {
    super(i, r);
    re(this, Vp, void 0);
    j(this, Vp, n);
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  get logs() {
    return super.logs.map((n) => {
      const r = n.topics.length ? C(this, Vp).getEvent(n.topics[0]) : null;
      if (r)
        try {
          return new vB(n, C(this, Vp), r);
        } catch (i) {
          return new XK(n, i);
        }
      return n;
    });
  }
}
Vp = new WeakMap();
var Hb;
class wB extends yb {
  /**
   *  @_ignore:
   */
  constructor(n, r, i) {
    super(i, r);
    re(this, Hb, void 0);
    j(this, Hb, n);
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(n, r) {
    const i = await super.wait(n, r);
    return i == null ? null : new LNe(C(this, Hb), this.provider, i);
  }
}
Hb = new WeakMap();
class eY extends TQ {
  /**
   *  @_event:
   */
  constructor(n, r, i, s) {
    super(n, r, i);
    /**
     *  The log with no matching events.
     */
    pe(this, "log");
    ft(this, { log: s });
  }
  /**
   *  Resolves to the block the event occured in.
   */
  async getBlock() {
    return await this.log.getBlock();
  }
  /**
   *  Resolves to the transaction the event occured in.
   */
  async getTransaction() {
    return await this.log.getTransaction();
  }
  /**
   *  Resolves to the transaction receipt the event occured in.
   */
  async getTransactionReceipt() {
    return await this.log.getTransactionReceipt();
  }
}
class zNe extends eY {
  /**
   *  @_ignore:
   */
  constructor(t, n, r, i, s) {
    super(t, n, r, new vB(s, t.interface, i));
    const o = t.interface.decodeEventLog(i, this.log.data, this.log.topics);
    ft(this, { args: o, fragment: i });
  }
  /**
   *  The event name.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The event signature.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
const PM = BigInt(0);
function tY(e) {
  return e && typeof e.call == "function";
}
function nY(e) {
  return e && typeof e.estimateGas == "function";
}
function s3(e) {
  return e && typeof e.resolveName == "function";
}
function rY(e) {
  return e && typeof e.sendTransaction == "function";
}
function iY(e) {
  if (e != null) {
    if (s3(e))
      return e;
    if (e.provider)
      return e.provider;
  }
}
var Wb;
class VNe {
  constructor(t, n, r) {
    re(this, Wb, void 0);
    pe(this, "fragment");
    if (ft(this, { fragment: n }), n.inputs.length < r.length)
      throw new Error("too many arguments");
    const i = Ef(t.runner, "resolveName"), s = s3(i) ? i : null;
    j(this, Wb, async function() {
      const o = await Promise.all(n.inputs.map((a, c) => r[c] == null ? null : a.walkAsync(r[c], (u, d) => u === "address" ? Array.isArray(d) ? Promise.all(d.map((f) => ui(f, s))) : ui(d, s) : d)));
      return t.interface.encodeFilterTopics(n, o);
    }());
  }
  getTopicFilter() {
    return C(this, Wb);
  }
}
Wb = new WeakMap();
function Ef(e, t) {
  return e == null ? null : typeof e[t] == "function" ? e : e.provider && typeof e.provider[t] == "function" ? e.provider : null;
}
function id(e) {
  return e == null ? null : e.provider || null;
}
async function sY(e, t) {
  const n = qr.dereference(e, "overrides");
  de(typeof n == "object", "invalid overrides parameter", "overrides", e);
  const r = K2(n);
  return de(r.to == null || (t || []).indexOf("to") >= 0, "cannot override to", "overrides.to", r.to), de(r.data == null || (t || []).indexOf("data") >= 0, "cannot override data", "overrides.data", r.data), r.from && (r.from = r.from), r;
}
async function HNe(e, t, n) {
  const r = Ef(e, "resolveName"), i = s3(r) ? r : null;
  return await Promise.all(t.map((s, o) => s.walkAsync(n[o], (a, c) => (c = qr.dereference(c, a), a === "address" ? ui(c, i) : c))));
}
function WNe(e) {
  const t = async function(o) {
    const a = await sY(o, ["data"]);
    a.to = await e.getAddress(), a.from && (a.from = await ui(a.from, iY(e.runner)));
    const c = e.interface, l = nt(a.value || PM, "overrides.value") === PM, u = (a.data || "0x") === "0x";
    c.fallback && !c.fallback.payable && c.receive && !u && !l && de(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", o), de(c.fallback || u, "cannot send data to receive-only contract", "overrides.data", a.data);
    const d = c.receive || c.fallback && c.fallback.payable;
    return de(d || l, "cannot send value to non-payable fallback", "overrides.value", a.value), de(c.fallback || u, "cannot send data to receive-only contract", "overrides.data", a.data), a;
  }, n = async function(o) {
    const a = Ef(e.runner, "call");
    Pe(tY(a), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const c = await t(o);
    try {
      return await a.call(c);
    } catch (l) {
      throw nB(l) && l.data ? e.interface.makeError(l.data, c) : l;
    }
  }, r = async function(o) {
    const a = e.runner;
    Pe(rY(a), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const c = await a.sendTransaction(await t(o)), l = id(e.runner);
    return new wB(e.interface, l, c);
  }, i = async function(o) {
    const a = Ef(e.runner, "estimateGas");
    return Pe(nY(a), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await a.estimateGas(await t(o));
  }, s = async (o) => await r(o);
  return ft(s, {
    _contract: e,
    estimateGas: i,
    populateTransaction: t,
    send: r,
    staticCall: n
  }), s;
}
function GNe(e, t) {
  const n = function(...l) {
    const u = e.interface.getFunction(t, l);
    return Pe(u, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: t, args: l }
    }), u;
  }, r = async function(...l) {
    const u = n(...l);
    let d = {};
    if (u.inputs.length + 1 === l.length && (d = await sY(l.pop()), d.from && (d.from = await ui(d.from, iY(e.runner)))), u.inputs.length !== l.length)
      throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
    const f = await HNe(e.runner, u.inputs, l);
    return Object.assign({}, d, await ri({
      to: e.getAddress(),
      data: e.interface.encodeFunctionData(u, f)
    }));
  }, i = async function(...l) {
    const u = await a(...l);
    return u.length === 1 ? u[0] : u;
  }, s = async function(...l) {
    const u = e.runner;
    Pe(rY(u), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const d = await u.sendTransaction(await r(...l)), f = id(e.runner);
    return new wB(e.interface, f, d);
  }, o = async function(...l) {
    const u = Ef(e.runner, "estimateGas");
    return Pe(nY(u), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await u.estimateGas(await r(...l));
  }, a = async function(...l) {
    const u = Ef(e.runner, "call");
    Pe(tY(u), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const d = await r(...l);
    let f = "0x";
    try {
      f = await u.call(d);
    } catch (m) {
      throw nB(m) && m.data ? e.interface.makeError(m.data, d) : m;
    }
    const p = n(...l);
    return e.interface.decodeFunctionResult(p, f);
  }, c = async (...l) => n(...l).constant ? await i(...l) : await s(...l);
  return ft(c, {
    name: e.interface.getFunctionName(t),
    _contract: e,
    _key: t,
    getFragment: n,
    estimateGas: o,
    populateTransaction: r,
    send: s,
    staticCall: i,
    staticCallResult: a
  }), Object.defineProperty(c, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const l = e.interface.getFunction(t);
      return Pe(l, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: t }
      }), l;
    }
  }), c;
}
function qNe(e, t) {
  const n = function(...i) {
    const s = e.interface.getEvent(t, i);
    return Pe(s, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: t, args: i }
    }), s;
  }, r = function(...i) {
    return new VNe(e, n(...i), i);
  };
  return ft(r, {
    name: e.interface.getEventName(t),
    _contract: e,
    _key: t,
    getFragment: n
  }), Object.defineProperty(r, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const i = e.interface.getEvent(t);
      return Pe(i, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: t }
      }), i;
    }
  }), r;
}
const Y2 = Symbol.for("_ethersInternal_contract"), oY = /* @__PURE__ */ new WeakMap();
function $Ne(e, t) {
  oY.set(e[Y2], t);
}
function zi(e) {
  return oY.get(e[Y2]);
}
function QNe(e) {
  return e && typeof e == "object" && "getTopicFilter" in e && typeof e.getTopicFilter == "function" && e.fragment;
}
async function xB(e, t) {
  let n, r = null;
  if (Array.isArray(t)) {
    const s = function(o) {
      if (mn(o, 32))
        return o;
      const a = e.interface.getEvent(o);
      return de(a, "unknown fragment", "name", o), a.topicHash;
    };
    n = t.map((o) => o == null ? null : Array.isArray(o) ? o.map(s) : s(o));
  } else
    t === "*" ? n = [null] : typeof t == "string" ? mn(t, 32) ? n = [t] : (r = e.interface.getEvent(t), de(r, "unknown fragment", "event", t), n = [r.topicHash]) : QNe(t) ? n = await t.getTopicFilter() : "fragment" in t ? (r = t.fragment, n = [r.topicHash]) : de(!1, "unknown event name", "event", t);
  n = n.map((s) => {
    if (s == null)
      return null;
    if (Array.isArray(s)) {
      const o = Array.from(new Set(s.map((a) => a.toLowerCase())).values());
      return o.length === 1 ? o[0] : (o.sort(), o);
    }
    return s.toLowerCase();
  });
  const i = n.map((s) => s == null ? "null" : Array.isArray(s) ? s.join("|") : s).join("&");
  return { fragment: r, tag: i, topics: n };
}
async function og(e, t) {
  const { subs: n } = zi(e);
  return n.get((await xB(e, t)).tag) || null;
}
async function OM(e, t, n) {
  const r = id(e.runner);
  Pe(r, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: t });
  const { fragment: i, tag: s, topics: o } = await xB(e, n), { addr: a, subs: c } = zi(e);
  let l = c.get(s);
  if (!l) {
    const d = { address: a || e, topics: o }, f = (g) => {
      let y = i;
      if (y == null)
        try {
          y = e.interface.getEvent(g.topics[0]);
        } catch {
        }
      if (y) {
        const v = y, b = i ? e.interface.decodeEventLog(i, g.data, g.topics) : [];
        ik(e, n, b, (w) => new zNe(e, w, n, v, g));
      } else
        ik(e, n, [], (v) => new eY(e, v, n, g));
    };
    let p = [];
    l = { tag: s, listeners: [], start: () => {
      p.length || p.push(r.on(d, f));
    }, stop: async () => {
      if (p.length == 0)
        return;
      let g = p;
      p = [], await Promise.all(g), r.off(d, f);
    } }, c.set(s, l);
  }
  return l;
}
let rk = Promise.resolve();
async function KNe(e, t, n, r) {
  await rk;
  const i = await og(e, t);
  if (!i)
    return !1;
  const s = i.listeners.length;
  return i.listeners = i.listeners.filter(({ listener: o, once: a }) => {
    const c = Array.from(n);
    r && c.push(r(a ? null : o));
    try {
      o.call(e, ...c);
    } catch {
    }
    return !a;
  }), i.listeners.length === 0 && (i.stop(), zi(e).subs.delete(i.tag)), s > 0;
}
async function ik(e, t, n, r) {
  try {
    await rk;
  } catch {
  }
  const i = KNe(e, t, n, r);
  return rk = i, await i;
}
const iw = ["then"];
var cFe;
const Vg = class Vg {
  /**
   *  Creates a new contract connected to %%target%% with the %%abi%% and
   *  optionally connected to a %%runner%% to perform operations on behalf
   *  of.
   */
  constructor(t, n, r, i) {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */
    pe(this, "target");
    /**
     *  The contract Interface.
     */
    pe(this, "interface");
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */
    pe(this, "runner");
    /**
     *  All the Events available on this contract.
     */
    pe(this, "filters");
    /**
     *  @_ignore:
     */
    pe(this, cFe);
    /**
     *  The fallback or receive function if any.
     */
    pe(this, "fallback");
    de(typeof t == "string" || fK(t), "invalid value for Contract target", "target", t), r == null && (r = null);
    const s = nk.from(n);
    ft(this, { target: t, runner: r, interface: s }), Object.defineProperty(this, Y2, { value: {} });
    let o, a = null, c = null;
    if (i) {
      const d = id(r);
      c = new wB(this.interface, d, i);
    }
    let l = /* @__PURE__ */ new Map();
    if (typeof t == "string")
      if (mn(t))
        a = t, o = Promise.resolve(t);
      else {
        const d = Ef(r, "resolveName");
        if (!s3(d))
          throw qn("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
          });
        o = d.resolveName(t).then((f) => {
          if (f == null)
            throw qn("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
              value: t
            });
          return zi(this).addr = f, f;
        });
      }
    else
      o = t.getAddress().then((d) => {
        if (d == null)
          throw new Error("TODO");
        return zi(this).addr = d, d;
      });
    $Ne(this, { addrPromise: o, addr: a, deployTx: c, subs: l });
    const u = new Proxy({}, {
      get: (d, f, p) => {
        if (typeof f == "symbol" || iw.indexOf(f) >= 0)
          return Reflect.get(d, f, p);
        try {
          return this.getEvent(f);
        } catch (m) {
          if (!Wr(m, "INVALID_ARGUMENT") || m.argument !== "key")
            throw m;
        }
      },
      has: (d, f) => iw.indexOf(f) >= 0 ? Reflect.has(d, f) : Reflect.has(d, f) || this.interface.hasEvent(String(f))
    });
    return ft(this, { filters: u }), ft(this, {
      fallback: s.receive || s.fallback ? WNe(this) : null
    }), new Proxy(this, {
      get: (d, f, p) => {
        if (typeof f == "symbol" || f in d || iw.indexOf(f) >= 0)
          return Reflect.get(d, f, p);
        try {
          return d.getFunction(f);
        } catch (m) {
          if (!Wr(m, "INVALID_ARGUMENT") || m.argument !== "key")
            throw m;
        }
      },
      has: (d, f) => typeof f == "symbol" || f in d || iw.indexOf(f) >= 0 ? Reflect.has(d, f) : d.interface.hasFunction(f)
    });
  }
  /**
   *  Return a new Contract instance with the same target and ABI, but
   *  a different %%runner%%.
   */
  connect(t) {
    return new Vg(this.target, this.interface, t);
  }
  /**
   *  Return a new Contract instance with the same ABI and runner, but
   *  a different %%target%%.
   */
  attach(t) {
    return new Vg(t, this.interface, this.runner);
  }
  /**
   *  Return the resolved address of this Contract.
   */
  async getAddress() {
    return await zi(this).addrPromise;
  }
  /**
   *  Return the deployed bytecode or null if no bytecode is found.
   */
  async getDeployedCode() {
    const t = id(this.runner);
    Pe(t, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
    const n = await t.getCode(await this.getAddress());
    return n === "0x" ? null : n;
  }
  /**
   *  Resolve to this Contract once the bytecode has been deployed, or
   *  resolve immediately if already deployed.
   */
  async waitForDeployment() {
    const t = this.deploymentTransaction();
    if (t)
      return await t.wait(), this;
    if (await this.getDeployedCode() != null)
      return this;
    const r = id(this.runner);
    return Pe(r != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((i, s) => {
      const o = async () => {
        try {
          if (await this.getDeployedCode() != null)
            return i(this);
          r.once("block", o);
        } catch (a) {
          s(a);
        }
      };
      o();
    });
  }
  /**
   *  Return the transaction used to deploy this contract.
   *
   *  This is only available if this instance was returned from a
   *  [[ContractFactory]].
   */
  deploymentTransaction() {
    return zi(this).deployTx;
  }
  /**
   *  Return the function for a given name. This is useful when a contract
   *  method name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getFunction(t) {
    return typeof t != "string" && (t = t.format()), GNe(this, t);
  }
  /**
   *  Return the event for a given name. This is useful when a contract
   *  event name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getEvent(t) {
    return typeof t != "string" && (t = t.format()), qNe(this, t);
  }
  /**
   *  @_ignore:
   */
  async queryTransaction(t) {
    throw new Error("@TODO");
  }
  /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
  
          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }
  
          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
  /**
   *  Provide historic access to event data for %%event%% in the range
   *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
   *  inclusive.
   */
  async queryFilter(t, n, r) {
    n == null && (n = 0), r == null && (r = "latest");
    const { addr: i, addrPromise: s } = zi(this), o = i || await s, { fragment: a, topics: c } = await xB(this, t), l = { address: o, topics: c, fromBlock: n, toBlock: r }, u = id(this.runner);
    return Pe(u, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await u.getLogs(l)).map((d) => {
      let f = a;
      if (f == null)
        try {
          f = this.interface.getEvent(d.topics[0]);
        } catch {
        }
      if (f)
        try {
          return new vB(d, this.interface, f);
        } catch (p) {
          return new XK(d, p);
        }
      return new Uv(d, u);
    });
  }
  /**
   *  Add an event %%listener%% for the %%event%%.
   */
  async on(t, n) {
    const r = await OM(this, "on", t);
    return r.listeners.push({ listener: n, once: !1 }), r.start(), this;
  }
  /**
   *  Add an event %%listener%% for the %%event%%, but remove the listener
   *  after it is fired once.
   */
  async once(t, n) {
    const r = await OM(this, "once", t);
    return r.listeners.push({ listener: n, once: !0 }), r.start(), this;
  }
  /**
   *  Emit an %%event%% calling all listeners with %%args%%.
   *
   *  Resolves to ``true`` if any listeners were called.
   */
  async emit(t, ...n) {
    return await ik(this, t, n, null);
  }
  /**
   *  Resolves to the number of listeners of %%event%% or the total number
   *  of listeners if unspecified.
   */
  async listenerCount(t) {
    if (t) {
      const i = await og(this, t);
      return i ? i.listeners.length : 0;
    }
    const { subs: n } = zi(this);
    let r = 0;
    for (const { listeners: i } of n.values())
      r += i.length;
    return r;
  }
  /**
   *  Resolves to the listeners subscribed to %%event%% or all listeners
   *  if unspecified.
   */
  async listeners(t) {
    if (t) {
      const i = await og(this, t);
      return i ? i.listeners.map(({ listener: s }) => s) : [];
    }
    const { subs: n } = zi(this);
    let r = [];
    for (const { listeners: i } of n.values())
      r = r.concat(i.map(({ listener: s }) => s));
    return r;
  }
  /**
   *  Remove the %%listener%% from the listeners for %%event%% or remove
   *  all listeners if unspecified.
   */
  async off(t, n) {
    const r = await og(this, t);
    if (!r)
      return this;
    if (n) {
      const i = r.listeners.map(({ listener: s }) => s).indexOf(n);
      i >= 0 && r.listeners.splice(i, 1);
    }
    return (n == null || r.listeners.length === 0) && (r.stop(), zi(this).subs.delete(r.tag)), this;
  }
  /**
   *  Remove all the listeners for %%event%% or remove all listeners if
   *  unspecified.
   */
  async removeAllListeners(t) {
    if (t) {
      const n = await og(this, t);
      if (!n)
        return this;
      n.stop(), zi(this).subs.delete(n.tag);
    } else {
      const { subs: n } = zi(this);
      for (const { tag: r, stop: i } of n.values())
        i(), n.delete(r);
    }
    return this;
  }
  /**
   *  Alias for [on].
   */
  async addListener(t, n) {
    return await this.on(t, n);
  }
  /**
   *  Alias for [off].
   */
  async removeListener(t, n) {
    return await this.off(t, n);
  }
  /**
   *  Create a new Class for the %%abi%%.
   */
  static buildClass(t) {
    class n extends Vg {
      constructor(i, s = null) {
        super(i, t, s);
      }
    }
    return n;
  }
  /**
   *  Create a new BaseContract with a specified Interface.
   */
  static from(t, n, r) {
    return r == null && (r = null), new this(t, n, r);
  }
};
cFe = Y2;
let sk = Vg;
function YNe() {
  return sk;
}
class Kl extends YNe() {
}
function M6(e) {
  return e.match(/^ipfs:\/\/ipfs\//i) ? e = e.substring(12) : e.match(/^ipfs:\/\//i) ? e = e.substring(7) : de(!1, "unsupported IPFS format", "link", e), `https://gateway.ipfs.io/ipfs/${e}`;
}
class ZNe {
  /**
   *  Creates a new **MulticoinProviderPluing** for %%name%%.
   */
  constructor(t) {
    /**
     *  The name.
     */
    pe(this, "name");
    ft(this, { name: t });
  }
  connect(t) {
    return this;
  }
  /**
   *  Returns ``true`` if %%coinType%% is supported by this plugin.
   */
  supportsCoinType(t) {
    return !1;
  }
  /**
   *  Resolves to the encoded %%address%% for %%coinType%%.
   */
  async encodeAddress(t, n) {
    throw new Error("unsupported coin");
  }
  /**
   *  Resolves to the decoded %%data%% for %%coinType%%.
   */
  async decodeAddress(t, n) {
    throw new Error("unsupported coin");
  }
}
const aY = new RegExp("^(ipfs)://(.*)$", "i"), NM = [
  new RegExp("^(https)://(.*)$", "i"),
  new RegExp("^(data):(.*)$", "i"),
  aY,
  new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
var kl, Td, Bl, ph, vA, cY;
const Nh = class Nh {
  constructor(t, n, r) {
    re(this, Bl);
    /**
     *  The connected provider.
     */
    pe(this, "provider");
    /**
     *  The address of the resolver.
     */
    pe(this, "address");
    /**
     *  The name this resolver was resolved against.
     */
    pe(this, "name");
    // For EIP-2544 names, the ancestor that provided the resolver
    re(this, kl, void 0);
    re(this, Td, void 0);
    ft(this, { provider: t, address: n, name: r }), j(this, kl, null), j(this, Td, new Kl(n, [
      "function supportsInterface(bytes4) view returns (bool)",
      "function resolve(bytes, bytes) view returns (bytes)",
      "function addr(bytes32) view returns (address)",
      "function addr(bytes32, uint) view returns (bytes)",
      "function text(bytes32, string) view returns (string)",
      "function contenthash(bytes32) view returns (bytes)"
    ], t));
  }
  /**
   *  Resolves to true if the resolver supports wildcard resolution.
   */
  async supportsWildcard() {
    return C(this, kl) == null && j(this, kl, (async () => {
      try {
        return await C(this, Td).supportsInterface("0x9061b923");
      } catch (t) {
        if (Wr(t, "CALL_EXCEPTION"))
          return !1;
        throw j(this, kl, null), t;
      }
    })()), await C(this, kl);
  }
  /**
   *  Resolves to the address for %%coinType%% or null if the
   *  provided %%coinType%% has not been configured.
   */
  async getAddress(t) {
    if (t == null && (t = 60), t === 60)
      try {
        const s = await Se(this, Bl, ph).call(this, "addr(bytes32)");
        return s == null || s === lb ? null : s;
      } catch (s) {
        if (Wr(s, "CALL_EXCEPTION"))
          return null;
        throw s;
      }
    if (t >= 0 && t < 2147483648) {
      let s = t + 2147483648;
      const o = await Se(this, Bl, ph).call(this, "addr(bytes32,uint)", [s]);
      if (mn(o, 20))
        return ln(o);
    }
    let n = null;
    for (const s of this.provider.plugins)
      if (s instanceof ZNe && s.supportsCoinType(t)) {
        n = s;
        break;
      }
    if (n == null)
      return null;
    const r = await Se(this, Bl, ph).call(this, "addr(bytes32,uint)", [t]);
    if (r == null || r === "0x")
      return null;
    const i = await n.decodeAddress(t, r);
    if (i != null)
      return i;
    Pe(!1, "invalid coin data", "UNSUPPORTED_OPERATION", {
      operation: `getAddress(${t})`,
      info: { coinType: t, data: r }
    });
  }
  /**
   *  Resolves to the EIP-634 text record for %%key%%, or ``null``
   *  if unconfigured.
   */
  async getText(t) {
    const n = await Se(this, Bl, ph).call(this, "text(bytes32,string)", [t]);
    return n == null || n === "0x" ? null : n;
  }
  /**
   *  Rsolves to the content-hash or ``null`` if unconfigured.
   */
  async getContentHash() {
    const t = await Se(this, Bl, ph).call(this, "contenthash(bytes32)");
    if (t == null || t === "0x")
      return null;
    const n = t.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
    if (n) {
      const i = n[1] === "e3010170" ? "ipfs" : "ipns", s = parseInt(n[4], 16);
      if (n[5].length === s * 2)
        return `${i}://${lPe("0x" + n[2])}`;
    }
    const r = t.match(/^0xe40101fa011b20([0-9a-f]*)$/);
    if (r && r[1].length === 64)
      return `bzz://${r[1]}`;
    Pe(!1, "invalid or unsupported content hash data", "UNSUPPORTED_OPERATION", {
      operation: "getContentHash()",
      info: { data: t }
    });
  }
  /**
   *  Resolves to the avatar url or ``null`` if the avatar is either
   *  unconfigured or incorrectly configured (e.g. references an NFT
   *  not owned by the address).
   *
   *  If diagnosing issues with configurations, the [[_getAvatar]]
   *  method may be useful.
   */
  async getAvatar() {
    return (await this._getAvatar()).url;
  }
  /**
   *  When resolving an avatar, there are many steps involved, such
   *  fetching metadata and possibly validating ownership of an
   *  NFT.
   *
   *  This method can be used to examine each step and the value it
   *  was working from.
   */
  async _getAvatar() {
    const t = [{ type: "name", value: this.name }];
    try {
      const n = await this.getText("avatar");
      if (n == null)
        return t.push({ type: "!avatar", value: "" }), { url: null, linkage: t };
      t.push({ type: "avatar", value: n });
      for (let r = 0; r < NM.length; r++) {
        const i = n.match(NM[r]);
        if (i == null)
          continue;
        const s = i[1].toLowerCase();
        switch (s) {
          case "https":
          case "data":
            return t.push({ type: "url", value: n }), { linkage: t, url: n };
          case "ipfs": {
            const o = M6(n);
            return t.push({ type: "ipfs", value: n }), t.push({ type: "url", value: o }), { linkage: t, url: o };
          }
          case "erc721":
          case "erc1155": {
            const o = s === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
            t.push({ type: s, value: n });
            const a = await this.getAddress();
            if (a == null)
              return t.push({ type: "!owner", value: "" }), { url: null, linkage: t };
            const c = (i[2] || "").split("/");
            if (c.length !== 2)
              return t.push({ type: `!${s}caip`, value: i[2] || "" }), { url: null, linkage: t };
            const l = c[1], u = new Kl(c[0], [
              // ERC-721
              "function tokenURI(uint) view returns (string)",
              "function ownerOf(uint) view returns (address)",
              // ERC-1155
              "function uri(uint) view returns (string)",
              "function balanceOf(address, uint256) view returns (uint)"
            ], this.provider);
            if (s === "erc721") {
              const h = await u.ownerOf(l);
              if (a !== h)
                return t.push({ type: "!owner", value: h }), { url: null, linkage: t };
              t.push({ type: "owner", value: h });
            } else if (s === "erc1155") {
              const h = await u.balanceOf(a, l);
              if (!h)
                return t.push({ type: "!balance", value: "0" }), { url: null, linkage: t };
              t.push({ type: "balance", value: h.toString() });
            }
            let d = await u[o](l);
            if (d == null || d === "0x")
              return t.push({ type: "!metadata-url", value: "" }), { url: null, linkage: t };
            t.push({ type: "metadata-url-base", value: d }), s === "erc1155" && (d = d.replace("{id}", hu(l, 32).substring(2)), t.push({ type: "metadata-url-expanded", value: d })), d.match(/^ipfs:/i) && (d = M6(d)), t.push({ type: "metadata-url", value: d });
            let f = {};
            const p = await new pu(d).send();
            p.assertOk();
            try {
              f = p.bodyJson;
            } catch {
              try {
                t.push({ type: "!metadata", value: p.bodyText });
              } catch {
                const y = p.body;
                return y && t.push({ type: "!metadata", value: Je(y) }), { url: null, linkage: t };
              }
              return { url: null, linkage: t };
            }
            if (!f)
              return t.push({ type: "!metadata", value: "" }), { url: null, linkage: t };
            t.push({ type: "metadata", value: JSON.stringify(f) });
            let m = f.image;
            if (typeof m != "string")
              return t.push({ type: "!imageUrl", value: "" }), { url: null, linkage: t };
            if (!m.match(/^(https:\/\/|data:)/i)) {
              if (m.match(aY) == null)
                return t.push({ type: "!imageUrl-ipfs", value: m }), { url: null, linkage: t };
              t.push({ type: "imageUrl-ipfs", value: m }), m = M6(m);
            }
            return t.push({ type: "url", value: m }), { linkage: t, url: m };
          }
        }
      }
    } catch {
    }
    return { linkage: t, url: null };
  }
  static async getEnsAddress(t) {
    const n = await t.getNetwork(), r = n.getPlugin("org.ethers.plugins.network.Ens");
    return Pe(r, "network does not support ENS", "UNSUPPORTED_OPERATION", {
      operation: "getEnsAddress",
      info: { network: n }
    }), r.address;
  }
  /**
   *  Resolve to the ENS resolver for %%name%% using %%provider%% or
   *  ``null`` if unconfigured.
   */
  static async fromName(t, n) {
    var i;
    let r = n;
    for (; ; ) {
      if (r === "" || r === "." || n !== "eth" && r === "eth")
        return null;
      const s = await Se(i = Nh, vA, cY).call(i, t, r);
      if (s != null) {
        const o = new Nh(t, s, n);
        return r !== n && !await o.supportsWildcard() ? null : o;
      }
      r = r.split(".").slice(1).join(".");
    }
  }
};
kl = new WeakMap(), Td = new WeakMap(), Bl = new WeakSet(), ph = async function(t, n) {
  n = (n || []).slice();
  const r = C(this, Td).interface;
  n.unshift(ek(this.name));
  let i = null;
  await this.supportsWildcard() && (i = r.getFunction(t), Pe(i, "missing fragment", "UNKNOWN_ERROR", {
    info: { funcName: t }
  }), n = [
    Y7e(this.name, 255),
    r.encodeFunctionData(i, n)
  ], t = "resolve(bytes,bytes)"), n.push({
    enableCcipRead: !0
  });
  try {
    const s = await C(this, Td)[t](...n);
    return i ? r.decodeFunctionResult(i, s)[0] : s;
  } catch (s) {
    if (!Wr(s, "CALL_EXCEPTION"))
      throw s;
  }
  return null;
}, vA = new WeakSet(), cY = async function(t, n) {
  const r = await Nh.getEnsAddress(t);
  try {
    const s = await new Kl(r, [
      "function resolver(bytes32) view returns (address)"
    ], t).resolver(ek(n), {
      enableCcipRead: !0
    });
    return s === lb ? null : s;
  } catch (i) {
    throw i;
  }
  return null;
}, re(Nh, vA);
let Z2 = Nh;
const RM = BigInt(0);
function Lt(e, t) {
  return function(n) {
    return n == null ? t : e(n);
  };
}
function o3(e, t) {
  return (n) => {
    if (t && n == null)
      return null;
    if (!Array.isArray(n))
      throw new Error("not an array");
    return n.map((r) => e(r));
  };
}
function Lv(e, t) {
  return (n) => {
    const r = {};
    for (const i in e) {
      let s = i;
      if (t && i in t && !(s in n)) {
        for (const o of t[i])
          if (o in n) {
            s = o;
            break;
          }
      }
      try {
        const o = e[i](n[s]);
        o !== void 0 && (r[i] = o);
      } catch (o) {
        const a = o instanceof Error ? o.message : "not-an-error";
        Pe(!1, `invalid value for value.${i} (${a})`, "BAD_DATA", { value: n });
      }
    }
    return r;
  };
}
function JNe(e) {
  switch (e) {
    case !0:
    case "true":
      return !0;
    case !1:
    case "false":
      return !1;
  }
  de(!1, `invalid boolean; ${JSON.stringify(e)}`, "value", e);
}
function Gm(e) {
  return de(mn(e, !0), "invalid data", "value", e), e;
}
function Sr(e) {
  return de(mn(e, 32), "invalid hash", "value", e), e;
}
const XNe = Lv({
  address: ln,
  blockHash: Sr,
  blockNumber: Ot,
  data: Gm,
  index: Ot,
  removed: Lt(JNe, !1),
  topics: o3(Sr),
  transactionHash: Sr,
  transactionIndex: Ot
}, {
  index: ["logIndex"]
});
function eRe(e) {
  return XNe(e);
}
const tRe = Lv({
  hash: Lt(Sr),
  parentHash: Sr,
  parentBeaconBlockRoot: Lt(Sr, null),
  number: Ot,
  timestamp: Ot,
  nonce: Lt(Gm),
  difficulty: nt,
  gasLimit: nt,
  gasUsed: nt,
  stateRoot: Lt(Sr, null),
  receiptsRoot: Lt(Sr, null),
  blobGasUsed: Lt(nt, null),
  excessBlobGas: Lt(nt, null),
  miner: Lt(ln),
  prevRandao: Lt(Sr, null),
  extraData: Gm,
  baseFeePerGas: Lt(nt)
}, {
  prevRandao: ["mixHash"]
});
function nRe(e) {
  const t = tRe(e);
  return t.transactions = e.transactions.map((n) => typeof n == "string" ? n : lY(n)), t;
}
const rRe = Lv({
  transactionIndex: Ot,
  blockNumber: Ot,
  transactionHash: Sr,
  address: ln,
  topics: o3(Sr),
  data: Gm,
  index: Ot,
  blockHash: Sr
}, {
  index: ["logIndex"]
});
function iRe(e) {
  return rRe(e);
}
const sRe = Lv({
  to: Lt(ln, null),
  from: Lt(ln, null),
  contractAddress: Lt(ln, null),
  // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
  index: Ot,
  root: Lt(Je),
  gasUsed: nt,
  blobGasUsed: Lt(nt, null),
  logsBloom: Lt(Gm),
  blockHash: Sr,
  hash: Sr,
  logs: o3(iRe),
  blockNumber: Ot,
  //confirmations: allowNull(getNumber, null),
  cumulativeGasUsed: nt,
  effectiveGasPrice: Lt(nt),
  blobGasPrice: Lt(nt, null),
  status: Lt(Ot),
  type: Lt(Ot, 0)
}, {
  effectiveGasPrice: ["gasPrice"],
  hash: ["transactionHash"],
  index: ["transactionIndex"]
});
function oRe(e) {
  return sRe(e);
}
function lY(e) {
  e.to && nt(e.to) === RM && (e.to = "0x0000000000000000000000000000000000000000");
  const t = Lv({
    hash: Sr,
    // Some nodes do not return this, usually test nodes (like Ganache)
    index: Lt(Ot, void 0),
    type: (n) => n === "0x" || n == null ? 0 : Ot(n),
    accessList: Lt(Of, null),
    blobVersionedHashes: Lt(o3(Sr, !0), null),
    blockHash: Lt(Sr, null),
    blockNumber: Lt(Ot, null),
    transactionIndex: Lt(Ot, null),
    from: ln,
    // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
    gasPrice: Lt(nt),
    maxPriorityFeePerGas: Lt(nt),
    maxFeePerGas: Lt(nt),
    maxFeePerBlobGas: Lt(nt, null),
    gasLimit: nt,
    to: Lt(ln, null),
    value: nt,
    nonce: Ot,
    data: Gm,
    creates: Lt(ln, null),
    chainId: Lt(nt, null)
  }, {
    data: ["input"],
    gasLimit: ["gas"],
    index: ["transactionIndex"]
  })(e);
  if (t.to == null && t.creates == null && (t.creates = XOe(t)), (e.type === 1 || e.type === 2) && e.accessList == null && (t.accessList = []), e.signature ? t.signature = bo.from(e.signature) : t.signature = bo.from(e), t.chainId == null) {
    const n = t.signature.legacyChainId;
    n != null && (t.chainId = n);
  }
  return t.blockHash && nt(t.blockHash) === RM && (t.blockHash = null), t;
}
const aRe = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class zv {
  /**
   *  Creates a new **NetworkPlugin**.
   */
  constructor(t) {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */
    pe(this, "name");
    ft(this, { name: t });
  }
  /**
   *  Creates a copy of this plugin.
   */
  clone() {
    return new zv(this.name);
  }
}
class a3 extends zv {
  /**
   *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
   *  latest block or another GasCostPlugin supercedes that block number,
   *  with the associated %%costs%%.
   */
  constructor(n, r) {
    n == null && (n = 0);
    super(`org.ethers.network.plugins.GasCost#${n || 0}`);
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */
    pe(this, "effectiveBlock");
    /**
     *  The transactions base fee.
     */
    pe(this, "txBase");
    /**
     *  The fee for creating a new account.
     */
    pe(this, "txCreate");
    /**
     *  The fee per zero-byte in the data.
     */
    pe(this, "txDataZero");
    /**
     *  The fee per non-zero-byte in the data.
     */
    pe(this, "txDataNonzero");
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */
    pe(this, "txAccessListStorageKey");
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */
    pe(this, "txAccessListAddress");
    const i = { effectiveBlock: n };
    function s(o, a) {
      let c = (r || {})[o];
      c == null && (c = a), de(typeof c == "number", `invalud value for ${o}`, "costs", r), i[o] = c;
    }
    s("txBase", 21e3), s("txCreate", 32e3), s("txDataZero", 4), s("txDataNonzero", 16), s("txAccessListStorageKey", 1900), s("txAccessListAddress", 2400), ft(this, i);
  }
  clone() {
    return new a3(this.effectiveBlock, this);
  }
}
class c3 extends zv {
  /**
   *  Creates a new **EnsPlugin** connected to %%address%% on the
   *  %%targetNetwork%%. The default ENS address and mainnet is used
   *  if unspecified.
   */
  constructor(n, r) {
    super("org.ethers.plugins.network.Ens");
    /**
     *  The ENS Registrty Contract address.
     */
    pe(this, "address");
    /**
     *  The chain ID that the ENS contract lives on.
     */
    pe(this, "targetNetwork");
    ft(this, {
      address: n || aRe,
      targetNetwork: r ?? 1
    });
  }
  clone() {
    return new c3(this.address, this.targetNetwork);
  }
}
var Gb, qb;
class cRe extends zv {
  /**
   *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
   *  be used when computing the fee data for the network.
   */
  constructor(n, r) {
    super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
    re(this, Gb, void 0);
    re(this, qb, void 0);
    j(this, Gb, n), j(this, qb, r);
  }
  /**
   *  The URL to initialize the FetchRequest with in %%processFunc%%.
   */
  get url() {
    return C(this, Gb);
  }
  /**
   *  The callback to use when computing the FeeData.
   */
  get processFunc() {
    return C(this, qb);
  }
  // We are immutable, so we can serve as our own clone
  clone() {
    return this;
  }
}
Gb = new WeakMap(), qb = new WeakMap();
const F6 = /* @__PURE__ */ new Map();
var Hp, Wp, Il;
const Rh = class Rh {
  /**
   *  Creates a new **Network** for %%name%% and %%chainId%%.
   */
  constructor(t, n) {
    re(this, Hp, void 0);
    re(this, Wp, void 0);
    re(this, Il, void 0);
    j(this, Hp, t), j(this, Wp, nt(n)), j(this, Il, /* @__PURE__ */ new Map());
  }
  /**
   *  Returns a JSON-compatible representation of a Network.
   */
  toJSON() {
    return { name: this.name, chainId: String(this.chainId) };
  }
  /**
   *  The network common name.
   *
   *  This is the canonical name, as networks migh have multiple
   *  names.
   */
  get name() {
    return C(this, Hp);
  }
  set name(t) {
    j(this, Hp, t);
  }
  /**
   *  The network chain ID.
   */
  get chainId() {
    return C(this, Wp);
  }
  set chainId(t) {
    j(this, Wp, nt(t, "chainId"));
  }
  /**
   *  Returns true if %%other%% matches this network. Any chain ID
   *  must match, and if no chain ID is present, the name must match.
   *
   *  This method does not currently check for additional properties,
   *  such as ENS address or plug-in compatibility.
   */
  matches(t) {
    if (t == null)
      return !1;
    if (typeof t == "string") {
      try {
        return this.chainId === nt(t);
      } catch {
      }
      return this.name === t;
    }
    if (typeof t == "number" || typeof t == "bigint") {
      try {
        return this.chainId === nt(t);
      } catch {
      }
      return !1;
    }
    if (typeof t == "object") {
      if (t.chainId != null) {
        try {
          return this.chainId === nt(t.chainId);
        } catch {
        }
        return !1;
      }
      return t.name != null ? this.name === t.name : !1;
    }
    return !1;
  }
  /**
   *  Returns the list of plugins currently attached to this Network.
   */
  get plugins() {
    return Array.from(C(this, Il).values());
  }
  /**
   *  Attach a new %%plugin%% to this Network. The network name
   *  must be unique, excluding any fragment.
   */
  attachPlugin(t) {
    if (C(this, Il).get(t.name))
      throw new Error(`cannot replace existing plugin: ${t.name} `);
    return C(this, Il).set(t.name, t.clone()), this;
  }
  /**
   *  Return the plugin, if any, matching %%name%% exactly. Plugins
   *  with fragments will not be returned unless %%name%% includes
   *  a fragment.
   */
  getPlugin(t) {
    return C(this, Il).get(t) || null;
  }
  /**
   *  Gets a list of all plugins that match %%name%%, with otr without
   *  a fragment.
   */
  getPlugins(t) {
    return this.plugins.filter((n) => n.name.split("#")[0] === t);
  }
  /**
   *  Create a copy of this Network.
   */
  clone() {
    const t = new Rh(this.name, this.chainId);
    return this.plugins.forEach((n) => {
      t.attachPlugin(n.clone());
    }), t;
  }
  /**
   *  Compute the intrinsic gas required for a transaction.
   *
   *  A GasCostPlugin can be attached to override the default
   *  values.
   */
  computeIntrinsicGas(t) {
    const n = this.getPlugin("org.ethers.plugins.network.GasCost") || new a3();
    let r = n.txBase;
    if (t.to == null && (r += n.txCreate), t.data)
      for (let i = 2; i < t.data.length; i += 2)
        t.data.substring(i, i + 2) === "00" ? r += n.txDataZero : r += n.txDataNonzero;
    if (t.accessList) {
      const i = Of(t.accessList);
      for (const s in i)
        r += n.txAccessListAddress + n.txAccessListStorageKey * i[s].storageKeys.length;
    }
    return r;
  }
  /**
   *  Returns a new Network for the %%network%% name or chainId.
   */
  static from(t) {
    if (lRe(), t == null)
      return Rh.from("mainnet");
    if (typeof t == "number" && (t = BigInt(t)), typeof t == "string" || typeof t == "bigint") {
      const n = F6.get(t);
      if (n)
        return n();
      if (typeof t == "bigint")
        return new Rh("unknown", t);
      de(!1, "unknown network", "network", t);
    }
    if (typeof t.clone == "function")
      return t.clone();
    if (typeof t == "object") {
      de(typeof t.name == "string" && typeof t.chainId == "number", "invalid network object name or chainId", "network", t);
      const n = new Rh(t.name, t.chainId);
      return (t.ensAddress || t.ensNetwork != null) && n.attachPlugin(new c3(t.ensAddress, t.ensNetwork)), n;
    }
    de(!1, "invalid network", "network", t);
  }
  /**
   *  Register %%nameOrChainId%% with a function which returns
   *  an instance of a Network representing that chain.
   */
  static register(t, n) {
    typeof t == "number" && (t = BigInt(t));
    const r = F6.get(t);
    r && de(!1, `conflicting network for ${JSON.stringify(r.name)}`, "nameOrChainId", t), F6.set(t, n);
  }
};
Hp = new WeakMap(), Wp = new WeakMap(), Il = new WeakMap();
let ua = Rh;
function MM(e, t) {
  const n = String(e);
  if (!n.match(/^[0-9.]+$/))
    throw new Error(`invalid gwei value: ${e}`);
  const r = n.split(".");
  if (r.length === 1 && r.push(""), r.length !== 2)
    throw new Error(`invalid gwei value: ${e}`);
  for (; r[1].length < t; )
    r[1] += "0";
  if (r[1].length > 9) {
    let i = BigInt(r[1].substring(0, 9));
    r[1].substring(9).match(/^0+$/) || i++, r[1] = i.toString();
  }
  return BigInt(r[0] + r[1]);
}
function FM(e) {
  return new cRe(e, async (t, n, r) => {
    r.setHeader("User-Agent", "ethers");
    let i;
    try {
      const [s, o] = await Promise.all([
        r.send(),
        t()
      ]);
      i = s;
      const a = i.bodyJson.standard;
      return {
        gasPrice: o.gasPrice,
        maxFeePerGas: MM(a.maxFee, 9),
        maxPriorityFeePerGas: MM(a.maxPriorityFee, 9)
      };
    } catch (s) {
      Pe(!1, `error encountered with polygon gas station (${JSON.stringify(r.url)})`, "SERVER_ERROR", { request: r, response: i, error: s });
    }
  });
}
let jM = !1;
function lRe() {
  if (jM)
    return;
  jM = !0;
  function e(t, n, r) {
    const i = function() {
      const s = new ua(t, n);
      return r.ensNetwork != null && s.attachPlugin(new c3(null, r.ensNetwork)), s.attachPlugin(new a3()), (r.plugins || []).forEach((o) => {
        s.attachPlugin(o);
      }), s;
    };
    ua.register(t, i), ua.register(n, i), r.altNames && r.altNames.forEach((s) => {
      ua.register(s, i);
    });
  }
  e("mainnet", 1, { ensNetwork: 1, altNames: ["homestead"] }), e("ropsten", 3, { ensNetwork: 3 }), e("rinkeby", 4, { ensNetwork: 4 }), e("goerli", 5, { ensNetwork: 5 }), e("kovan", 42, { ensNetwork: 42 }), e("sepolia", 11155111, { ensNetwork: 11155111 }), e("holesky", 17e3, { ensNetwork: 17e3 }), e("classic", 61, {}), e("classicKotti", 6, {}), e("arbitrum", 42161, {
    ensNetwork: 1
  }), e("arbitrum-goerli", 421613, {}), e("arbitrum-sepolia", 421614, {}), e("base", 8453, { ensNetwork: 1 }), e("base-goerli", 84531, {}), e("base-sepolia", 84532, {}), e("bnb", 56, { ensNetwork: 1 }), e("bnbt", 97, {}), e("linea", 59144, { ensNetwork: 1 }), e("linea-goerli", 59140, {}), e("linea-sepolia", 59141, {}), e("matic", 137, {
    ensNetwork: 1,
    plugins: [
      FM("https://gasstation.polygon.technology/v2")
    ]
  }), e("matic-amoy", 80002, {}), e("matic-mumbai", 80001, {
    altNames: ["maticMumbai", "maticmum"],
    plugins: [
      FM("https://gasstation-testnet.polygon.technology/v2")
    ]
  }), e("optimism", 10, {
    ensNetwork: 1,
    plugins: []
  }), e("optimism-goerli", 420, {}), e("optimism-sepolia", 11155420, {}), e("xdai", 100, { ensNetwork: 1 });
}
function ok(e) {
  return JSON.parse(JSON.stringify(e));
}
var Ka, ps, Pl, Zo, Gp, fx;
class uRe {
  /**
   *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
   */
  constructor(t) {
    re(this, Gp);
    re(this, Ka, void 0);
    re(this, ps, void 0);
    re(this, Pl, void 0);
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    re(this, Zo, void 0);
    j(this, Ka, t), j(this, ps, null), j(this, Pl, 4e3), j(this, Zo, -2);
  }
  /**
   *  The polling interval.
   */
  get pollingInterval() {
    return C(this, Pl);
  }
  set pollingInterval(t) {
    j(this, Pl, t);
  }
  start() {
    C(this, ps) || (j(this, ps, C(this, Ka)._setTimeout(Se(this, Gp, fx).bind(this), C(this, Pl))), Se(this, Gp, fx).call(this));
  }
  stop() {
    C(this, ps) && (C(this, Ka)._clearTimeout(C(this, ps)), j(this, ps, null));
  }
  pause(t) {
    this.stop(), t && j(this, Zo, -2);
  }
  resume() {
    this.start();
  }
}
Ka = new WeakMap(), ps = new WeakMap(), Pl = new WeakMap(), Zo = new WeakMap(), Gp = new WeakSet(), fx = async function() {
  try {
    const t = await C(this, Ka).getBlockNumber();
    if (C(this, Zo) === -2) {
      j(this, Zo, t);
      return;
    }
    if (t !== C(this, Zo)) {
      for (let n = C(this, Zo) + 1; n <= t; n++) {
        if (C(this, ps) == null)
          return;
        await C(this, Ka).emit("block", n);
      }
      j(this, Zo, t);
    }
  } catch {
  }
  C(this, ps) != null && j(this, ps, C(this, Ka)._setTimeout(Se(this, Gp, fx).bind(this), C(this, Pl)));
};
var kd, Bd, Ol;
class AB {
  /**
   *  Create a new **OnBlockSubscriber** attached to %%provider%%.
   */
  constructor(t) {
    re(this, kd, void 0);
    re(this, Bd, void 0);
    re(this, Ol, void 0);
    j(this, kd, t), j(this, Ol, !1), j(this, Bd, (n) => {
      this._poll(n, C(this, kd));
    });
  }
  /**
   *  Called on every new block.
   */
  async _poll(t, n) {
    throw new Error("sub-classes must override this");
  }
  start() {
    C(this, Ol) || (j(this, Ol, !0), C(this, Bd).call(this, -2), C(this, kd).on("block", C(this, Bd)));
  }
  stop() {
    C(this, Ol) && (j(this, Ol, !1), C(this, kd).off("block", C(this, Bd)));
  }
  pause(t) {
    this.stop();
  }
  resume() {
    this.start();
  }
}
kd = new WeakMap(), Bd = new WeakMap(), Ol = new WeakMap();
var qp, Ya;
class dRe extends AB {
  constructor(n, r) {
    super(n);
    re(this, qp, void 0);
    re(this, Ya, void 0);
    j(this, qp, r), j(this, Ya, -2);
  }
  pause(n) {
    n && j(this, Ya, -2), super.pause(n);
  }
  async _poll(n, r) {
    const i = await r.getBlock(C(this, qp));
    i != null && (C(this, Ya) === -2 ? j(this, Ya, i.number) : i.number > C(this, Ya) && (r.emit(C(this, qp), i.number), j(this, Ya, i.number)));
  }
}
qp = new WeakMap(), Ya = new WeakMap();
var wA;
class fRe extends AB {
  constructor(n, r) {
    super(n);
    re(this, wA, void 0);
    j(this, wA, ok(r));
  }
  async _poll(n, r) {
    throw new Error("@TODO");
  }
}
wA = new WeakMap();
var $p;
class hRe extends AB {
  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%hash%%.
   */
  constructor(n, r) {
    super(n);
    re(this, $p, void 0);
    j(this, $p, r);
  }
  async _poll(n, r) {
    const i = await r.getTransactionReceipt(C(this, $p));
    i && r.emit(C(this, $p), i);
  }
}
$p = new WeakMap();
var Za, Qp, Kp, Nl, ms, xA, uY;
class EB {
  /**
   *  Create a new **PollingTransactionSubscriber** attached to
   *  %%provider%%, listening for %%filter%%.
   */
  constructor(t, n) {
    re(this, xA);
    re(this, Za, void 0);
    re(this, Qp, void 0);
    re(this, Kp, void 0);
    re(this, Nl, void 0);
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    re(this, ms, void 0);
    j(this, Za, t), j(this, Qp, ok(n)), j(this, Kp, Se(this, xA, uY).bind(this)), j(this, Nl, !1), j(this, ms, -2);
  }
  start() {
    C(this, Nl) || (j(this, Nl, !0), C(this, ms) === -2 && C(this, Za).getBlockNumber().then((t) => {
      j(this, ms, t);
    }), C(this, Za).on("block", C(this, Kp)));
  }
  stop() {
    C(this, Nl) && (j(this, Nl, !1), C(this, Za).off("block", C(this, Kp)));
  }
  pause(t) {
    this.stop(), t && j(this, ms, -2);
  }
  resume() {
    this.start();
  }
}
Za = new WeakMap(), Qp = new WeakMap(), Kp = new WeakMap(), Nl = new WeakMap(), ms = new WeakMap(), xA = new WeakSet(), uY = async function(t) {
  if (C(this, ms) === -2)
    return;
  const n = ok(C(this, Qp));
  n.fromBlock = C(this, ms) + 1, n.toBlock = t;
  const r = await C(this, Za).getLogs(n);
  if (r.length === 0) {
    C(this, ms) < t - 60 && j(this, ms, t - 60);
    return;
  }
  for (const i of r)
    C(this, Za).emit(C(this, Qp), i), j(this, ms, i.blockNumber);
};
const pRe = BigInt(2), mRe = 10;
function sw(e) {
  return e && typeof e.then == "function";
}
function hx(e, t) {
  return e + ":" + JSON.stringify(t, (n, r) => {
    if (r == null)
      return "null";
    if (typeof r == "bigint")
      return `bigint:${r.toString()}`;
    if (typeof r == "string")
      return r.toLowerCase();
    if (typeof r == "object" && !Array.isArray(r)) {
      const i = Object.keys(r);
      return i.sort(), i.reduce((s, o) => (s[o] = r[o], s), {});
    }
    return r;
  });
}
class dY {
  /**
   *  Create a new UnmanagedSubscriber with %%name%%.
   */
  constructor(t) {
    /**
     *  The name fof the event.
     */
    pe(this, "name");
    ft(this, { name: t });
  }
  start() {
  }
  stop() {
  }
  pause(t) {
  }
  resume() {
  }
}
function gRe(e) {
  return JSON.parse(JSON.stringify(e));
}
function ak(e) {
  return e = Array.from(new Set(e).values()), e.sort(), e;
}
async function j6(e, t) {
  if (e == null)
    throw new Error("invalid event");
  if (Array.isArray(e) && (e = { topics: e }), typeof e == "string")
    switch (e) {
      case "block":
      case "debug":
      case "error":
      case "finalized":
      case "network":
      case "pending":
      case "safe":
        return { type: e, tag: e };
    }
  if (mn(e, 32)) {
    const n = e.toLowerCase();
    return { type: "transaction", tag: hx("tx", { hash: n }), hash: n };
  }
  if (e.orphan) {
    const n = e;
    return { type: "orphan", tag: hx("orphan", n), filter: gRe(n) };
  }
  if (e.address || e.topics) {
    const n = e, r = {
      topics: (n.topics || []).map((i) => i == null ? null : Array.isArray(i) ? ak(i.map((s) => s.toLowerCase())) : i.toLowerCase())
    };
    if (n.address) {
      const i = [], s = [], o = (a) => {
        mn(a) ? i.push(a) : s.push((async () => {
          i.push(await ui(a, t));
        })());
      };
      Array.isArray(n.address) ? n.address.forEach(o) : o(n.address), s.length && await Promise.all(s), r.address = ak(i.map((a) => a.toLowerCase()));
    }
    return { filter: r, tag: hx("event", r), type: "event" };
  }
  de(!1, "unknown ProviderEvent", "event", e);
}
function D6() {
  return (/* @__PURE__ */ new Date()).getTime();
}
const yRe = {
  cacheTimeout: 250,
  pollingInterval: 4e3
};
var Fr, Rl, jr, Yp, $i, Id, Ml, Ja, $b, gs, Zp, Jp, ti, Li, Qb, ck, Kb, lk, Pd, ag, Yb, uk, Od, cg, Xp, px;
class bRe {
  /**
   *  Create a new **AbstractProvider** connected to %%network%%, or
   *  use the various network detection capabilities to discover the
   *  [[Network]] if necessary.
   */
  constructor(t, n) {
    // Shares multiple identical requests made during the same 250ms
    re(this, ti);
    re(this, Qb);
    re(this, Kb);
    // Account
    re(this, Pd);
    re(this, Yb);
    re(this, Od);
    re(this, Xp);
    re(this, Fr, void 0);
    re(this, Rl, void 0);
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    re(this, jr, void 0);
    re(this, Yp, void 0);
    re(this, $i, void 0);
    re(this, Id, void 0);
    re(this, Ml, void 0);
    // The most recent block number if running an event or -1 if no "block" event
    re(this, Ja, void 0);
    re(this, $b, void 0);
    re(this, gs, void 0);
    re(this, Zp, void 0);
    re(this, Jp, void 0);
    if (j(this, Jp, Object.assign({}, yRe, n || {})), t === "any")
      j(this, Id, !0), j(this, $i, null);
    else if (t) {
      const r = ua.from(t);
      j(this, Id, !1), j(this, $i, Promise.resolve(r)), setTimeout(() => {
        this.emit("network", r, null);
      }, 0);
    } else
      j(this, Id, !1), j(this, $i, null);
    j(this, Ja, -1), j(this, Ml, /* @__PURE__ */ new Map()), j(this, Fr, /* @__PURE__ */ new Map()), j(this, Rl, /* @__PURE__ */ new Map()), j(this, jr, null), j(this, Yp, !1), j(this, $b, 1), j(this, gs, /* @__PURE__ */ new Map()), j(this, Zp, !1);
  }
  get pollingInterval() {
    return C(this, Jp).pollingInterval;
  }
  /**
   *  Returns ``this``, to allow an **AbstractProvider** to implement
   *  the [[ContractRunner]] interface.
   */
  get provider() {
    return this;
  }
  /**
   *  Returns all the registered plug-ins.
   */
  get plugins() {
    return Array.from(C(this, Rl).values());
  }
  /**
   *  Attach a new plug-in.
   */
  attachPlugin(t) {
    if (C(this, Rl).get(t.name))
      throw new Error(`cannot replace existing plugin: ${t.name} `);
    return C(this, Rl).set(t.name, t.connect(this)), this;
  }
  /**
   *  Get a plugin by name.
   */
  getPlugin(t) {
    return C(this, Rl).get(t) || null;
  }
  /**
   *  Prevent any CCIP-read operation, regardless of whether requested
   *  in a [[call]] using ``enableCcipRead``.
   */
  get disableCcipRead() {
    return C(this, Zp);
  }
  set disableCcipRead(t) {
    j(this, Zp, !!t);
  }
  /**
   *  Resolves to the data for executing the CCIP-read operations.
   */
  async ccipReadFetch(t, n, r) {
    if (this.disableCcipRead || r.length === 0 || t.to == null)
      return null;
    const i = t.to.toLowerCase(), s = n.toLowerCase(), o = [];
    for (let a = 0; a < r.length; a++) {
      const c = r[a], l = c.replace("{sender}", i).replace("{data}", s), u = new pu(l);
      c.indexOf("{data}") === -1 && (u.body = { data: s, sender: i }), this.emit("debug", { action: "sendCcipReadFetchRequest", request: u, index: a, urls: r });
      let d = "unknown error";
      const f = await u.send();
      try {
        const p = f.bodyJson;
        if (p.data)
          return this.emit("debug", { action: "receiveCcipReadFetchResult", request: u, result: p }), p.data;
        p.message && (d = p.message), this.emit("debug", { action: "receiveCcipReadFetchError", request: u, result: p });
      } catch {
      }
      Pe(f.statusCode < 400 || f.statusCode >= 500, `response not found during CCIP fetch: ${d}`, "OFFCHAIN_FAULT", { reason: "404_MISSING_RESOURCE", transaction: t, info: { url: c, errorMessage: d } }), o.push(d);
    }
    Pe(!1, `error encountered during CCIP fetch: ${o.map((a) => JSON.stringify(a)).join(", ")}`, "OFFCHAIN_FAULT", {
      reason: "500_SERVER_ERROR",
      transaction: t,
      info: { urls: r, errorMessages: o }
    });
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a block before
   *  returning it, to add additional properties or an alternate
   *  sub-class of [[Block]].
   */
  _wrapBlock(t, n) {
    return new jNe(nRe(t), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a log before
   *  returning it, to add additional properties or an alternate
   *  sub-class of [[Log]].
   */
  _wrapLog(t, n) {
    return new Uv(eRe(t), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a transaction
   *  receipt before returning it, to add additional properties or an
   *  alternate sub-class of [[TransactionReceipt]].
   */
  _wrapTransactionReceipt(t, n) {
    return new YK(oRe(t), this);
  }
  /**
   *  Provides the opportunity for a sub-class to wrap a transaction
   *  response before returning it, to add additional properties or an
   *  alternate sub-class of [[TransactionResponse]].
   */
  _wrapTransactionResponse(t, n) {
    return new yb(lY(t), this);
  }
  /**
   *  Resolves to the Network, forcing a network detection using whatever
   *  technique the sub-class requires.
   *
   *  Sub-classes **must** override this.
   */
  _detectNetwork() {
    Pe(!1, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
      operation: "_detectNetwork"
    });
  }
  /**
   *  Sub-classes should use this to perform all built-in operations. All
   *  methods sanitizes and normalizes the values passed into this.
   *
   *  Sub-classes **must** override this.
   */
  async _perform(t) {
    Pe(!1, `unsupported method: ${t.method}`, "UNSUPPORTED_OPERATION", {
      operation: t.method,
      info: t
    });
  }
  // State
  async getBlockNumber() {
    const t = Ot(await Se(this, ti, Li).call(this, { method: "getBlockNumber" }), "%response");
    return C(this, Ja) >= 0 && j(this, Ja, t), t;
  }
  /**
   *  Returns or resolves to the address for %%address%%, resolving ENS
   *  names and [[Addressable]] objects and returning if already an
   *  address.
   */
  _getAddress(t) {
    return ui(t, this);
  }
  /**
   *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
   *  negative values and returning if already a valid block tag.
   */
  _getBlockTag(t) {
    if (t == null)
      return "latest";
    switch (t) {
      case "earliest":
        return "0x0";
      case "finalized":
      case "latest":
      case "pending":
      case "safe":
        return t;
    }
    if (mn(t))
      return mn(t, 32) ? t : Oh(t);
    if (typeof t == "bigint" && (t = Ot(t, "blockTag")), typeof t == "number")
      return t >= 0 ? Oh(t) : C(this, Ja) >= 0 ? Oh(C(this, Ja) + t) : this.getBlockNumber().then((n) => Oh(n + t));
    de(!1, "invalid blockTag", "blockTag", t);
  }
  /**
   *  Returns or resolves to a filter for %%filter%%, resolving any ENS
   *  names or [[Addressable]] object and returning if already a valid
   *  filter.
   */
  _getFilter(t) {
    const n = (t.topics || []).map((c) => c == null ? null : Array.isArray(c) ? ak(c.map((l) => l.toLowerCase())) : c.toLowerCase()), r = "blockHash" in t ? t.blockHash : void 0, i = (c, l, u) => {
      let d;
      switch (c.length) {
        case 0:
          break;
        case 1:
          d = c[0];
          break;
        default:
          c.sort(), d = c;
      }
      if (r && (l != null || u != null))
        throw new Error("invalid filter");
      const f = {};
      return d && (f.address = d), n.length && (f.topics = n), l && (f.fromBlock = l), u && (f.toBlock = u), r && (f.blockHash = r), f;
    };
    let s = [];
    if (t.address)
      if (Array.isArray(t.address))
        for (const c of t.address)
          s.push(this._getAddress(c));
      else
        s.push(this._getAddress(t.address));
    let o;
    "fromBlock" in t && (o = this._getBlockTag(t.fromBlock));
    let a;
    return "toBlock" in t && (a = this._getBlockTag(t.toBlock)), s.filter((c) => typeof c != "string").length || o != null && typeof o != "string" || a != null && typeof a != "string" ? Promise.all([Promise.all(s), o, a]).then((c) => i(c[0], c[1], c[2])) : i(s, o, a);
  }
  /**
   *  Returns or resolves to a transaction for %%request%%, resolving
   *  any ENS names or [[Addressable]] and returning if already a valid
   *  transaction.
   */
  _getTransactionRequest(t) {
    const n = K2(t), r = [];
    if (["to", "from"].forEach((i) => {
      if (n[i] == null)
        return;
      const s = ui(n[i], this);
      sw(s) ? r.push(async function() {
        n[i] = await s;
      }()) : n[i] = s;
    }), n.blockTag != null) {
      const i = this._getBlockTag(n.blockTag);
      sw(i) ? r.push(async function() {
        n.blockTag = await i;
      }()) : n.blockTag = i;
    }
    return r.length ? async function() {
      return await Promise.all(r), n;
    }() : n;
  }
  async getNetwork() {
    if (C(this, $i) == null) {
      const i = (async () => {
        try {
          const s = await this._detectNetwork();
          return this.emit("network", s, null), s;
        } catch (s) {
          throw C(this, $i) === i && j(this, $i, null), s;
        }
      })();
      return j(this, $i, i), (await i).clone();
    }
    const t = C(this, $i), [n, r] = await Promise.all([
      t,
      this._detectNetwork()
      // The actual connected network
    ]);
    return n.chainId !== r.chainId && (C(this, Id) ? (this.emit("network", r, n), C(this, $i) === t && j(this, $i, Promise.resolve(r))) : Pe(!1, `network changed: ${n.chainId} => ${r.chainId} `, "NETWORK_ERROR", {
      event: "changed"
    })), n.clone();
  }
  async getFeeData() {
    const t = await this.getNetwork(), n = async () => {
      const { _block: i, gasPrice: s, priorityFee: o } = await ri({
        _block: Se(this, Yb, uk).call(this, "latest", !1),
        gasPrice: (async () => {
          try {
            const u = await Se(this, ti, Li).call(this, { method: "getGasPrice" });
            return nt(u, "%response");
          } catch {
          }
          return null;
        })(),
        priorityFee: (async () => {
          try {
            const u = await Se(this, ti, Li).call(this, { method: "getPriorityFee" });
            return nt(u, "%response");
          } catch {
          }
          return null;
        })()
      });
      let a = null, c = null;
      const l = this._wrapBlock(i, t);
      return l && l.baseFeePerGas && (c = o ?? BigInt("1000000000"), a = l.baseFeePerGas * pRe + c), new IM(s, a, c);
    }, r = t.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
    if (r) {
      const i = new pu(r.url), s = await r.processFunc(n, this, i);
      return new IM(s.gasPrice, s.maxFeePerGas, s.maxPriorityFeePerGas);
    }
    return await n();
  }
  async estimateGas(t) {
    let n = this._getTransactionRequest(t);
    return sw(n) && (n = await n), nt(await Se(this, ti, Li).call(this, {
      method: "estimateGas",
      transaction: n
    }), "%response");
  }
  async call(t) {
    const { tx: n, blockTag: r } = await ri({
      tx: this._getTransactionRequest(t),
      blockTag: this._getBlockTag(t.blockTag)
    });
    return await Se(this, Kb, lk).call(this, Se(this, Qb, ck).call(this, n, r, t.enableCcipRead ? 0 : -1));
  }
  async getBalance(t, n) {
    return nt(await Se(this, Pd, ag).call(this, { method: "getBalance" }, t, n), "%response");
  }
  async getTransactionCount(t, n) {
    return Ot(await Se(this, Pd, ag).call(this, { method: "getTransactionCount" }, t, n), "%response");
  }
  async getCode(t, n) {
    return Je(await Se(this, Pd, ag).call(this, { method: "getCode" }, t, n));
  }
  async getStorage(t, n, r) {
    const i = nt(n, "position");
    return Je(await Se(this, Pd, ag).call(this, { method: "getStorage", position: i }, t, r));
  }
  // Write
  async broadcastTransaction(t) {
    const { blockNumber: n, hash: r, network: i } = await ri({
      blockNumber: this.getBlockNumber(),
      hash: this._perform({
        method: "broadcastTransaction",
        signedTransaction: t
      }),
      network: this.getNetwork()
    }), s = $2.from(t);
    if (s.hash !== r)
      throw new Error("@TODO: the returned hash did not match");
    return this._wrapTransactionResponse(s, i).replaceableTransaction(n);
  }
  // Queries
  async getBlock(t, n) {
    const { network: r, params: i } = await ri({
      network: this.getNetwork(),
      params: Se(this, Yb, uk).call(this, t, !!n)
    });
    return i == null ? null : this._wrapBlock(i, r);
  }
  async getTransaction(t) {
    const { network: n, params: r } = await ri({
      network: this.getNetwork(),
      params: Se(this, ti, Li).call(this, { method: "getTransaction", hash: t })
    });
    return r == null ? null : this._wrapTransactionResponse(r, n);
  }
  async getTransactionReceipt(t) {
    const { network: n, params: r } = await ri({
      network: this.getNetwork(),
      params: Se(this, ti, Li).call(this, { method: "getTransactionReceipt", hash: t })
    });
    if (r == null)
      return null;
    if (r.gasPrice == null && r.effectiveGasPrice == null) {
      const i = await Se(this, ti, Li).call(this, { method: "getTransaction", hash: t });
      if (i == null)
        throw new Error("report this; could not find tx or effectiveGasPrice");
      r.effectiveGasPrice = i.gasPrice;
    }
    return this._wrapTransactionReceipt(r, n);
  }
  async getTransactionResult(t) {
    const { result: n } = await ri({
      network: this.getNetwork(),
      result: Se(this, ti, Li).call(this, { method: "getTransactionResult", hash: t })
    });
    return n == null ? null : Je(n);
  }
  // Bloom-filter Queries
  async getLogs(t) {
    let n = this._getFilter(t);
    sw(n) && (n = await n);
    const { network: r, params: i } = await ri({
      network: this.getNetwork(),
      params: Se(this, ti, Li).call(this, { method: "getLogs", filter: n })
    });
    return i.map((s) => this._wrapLog(s, r));
  }
  // ENS
  _getProvider(t) {
    Pe(!1, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
      operation: "_getProvider()"
    });
  }
  async getResolver(t) {
    return await Z2.fromName(this, t);
  }
  async getAvatar(t) {
    const n = await this.getResolver(t);
    return n ? await n.getAvatar() : null;
  }
  async resolveName(t) {
    const n = await this.getResolver(t);
    return n ? await n.getAddress() : null;
  }
  async lookupAddress(t) {
    t = ln(t);
    const n = ek(t.substring(2).toLowerCase() + ".addr.reverse");
    try {
      const r = await Z2.getEnsAddress(this), s = await new Kl(r, [
        "function resolver(bytes32) view returns (address)"
      ], this).resolver(n);
      if (s == null || s === lb)
        return null;
      const a = await new Kl(s, [
        "function name(bytes32) view returns (string)"
      ], this).name(n);
      return await this.resolveName(a) !== t ? null : a;
    } catch (r) {
      if (Wr(r, "BAD_DATA") && r.value === "0x" || Wr(r, "CALL_EXCEPTION"))
        return null;
      throw r;
    }
    return null;
  }
  async waitForTransaction(t, n, r) {
    const i = n ?? 1;
    return i === 0 ? this.getTransactionReceipt(t) : new Promise(async (s, o) => {
      let a = null;
      const c = async (l) => {
        try {
          const u = await this.getTransactionReceipt(t);
          if (u != null && l - u.blockNumber + 1 >= i) {
            s(u), a && (clearTimeout(a), a = null);
            return;
          }
        } catch (u) {
          console.log("EEE", u);
        }
        this.once("block", c);
      };
      r != null && (a = setTimeout(() => {
        a != null && (a = null, this.off("block", c), o(qn("timeout", "TIMEOUT", { reason: "timeout" })));
      }, r)), c(await this.getBlockNumber());
    });
  }
  async waitForBlock(t) {
    Pe(!1, "not implemented yet", "NOT_IMPLEMENTED", {
      operation: "waitForBlock"
    });
  }
  /**
   *  Clear a timer created using the [[_setTimeout]] method.
   */
  _clearTimeout(t) {
    const n = C(this, gs).get(t);
    n && (n.timer && clearTimeout(n.timer), C(this, gs).delete(t));
  }
  /**
   *  Create a timer that will execute %%func%% after at least %%timeout%%
   *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
   *  in the next event loop.
   *
   *  [Pausing](AbstractProvider-paused) the provider will pause any
   *  associated timers.
   */
  _setTimeout(t, n) {
    n == null && (n = 0);
    const r = Rc(this, $b)._++, i = () => {
      C(this, gs).delete(r), t();
    };
    if (this.paused)
      C(this, gs).set(r, { timer: null, func: i, time: n });
    else {
      const s = setTimeout(i, n);
      C(this, gs).set(r, { timer: s, func: i, time: D6() });
    }
    return r;
  }
  /**
   *  Perform %%func%% on each subscriber.
   */
  _forEachSubscriber(t) {
    for (const n of C(this, Fr).values())
      t(n.subscriber);
  }
  /**
   *  Sub-classes may override this to customize subscription
   *  implementations.
   */
  _getSubscriber(t) {
    switch (t.type) {
      case "debug":
      case "error":
      case "network":
        return new dY(t.type);
      case "block": {
        const n = new uRe(this);
        return n.pollingInterval = this.pollingInterval, n;
      }
      case "safe":
      case "finalized":
        return new dRe(this, t.type);
      case "event":
        return new EB(this, t.filter);
      case "transaction":
        return new hRe(this, t.hash);
      case "orphan":
        return new fRe(this, t.filter);
    }
    throw new Error(`unsupported event: ${t.type}`);
  }
  /**
   *  If a [[Subscriber]] fails and needs to replace itself, this
   *  method may be used.
   *
   *  For example, this is used for providers when using the
   *  ``eth_getFilterChanges`` method, which can return null if state
   *  filters are not supported by the backend, allowing the Subscriber
   *  to swap in a [[PollingEventSubscriber]].
   */
  _recoverSubscriber(t, n) {
    for (const r of C(this, Fr).values())
      if (r.subscriber === t) {
        r.started && r.subscriber.stop(), r.subscriber = n, r.started && n.start(), C(this, jr) != null && n.pause(C(this, jr));
        break;
      }
  }
  async on(t, n) {
    const r = await Se(this, Xp, px).call(this, t);
    return r.listeners.push({ listener: n, once: !1 }), r.started || (r.subscriber.start(), r.started = !0, C(this, jr) != null && r.subscriber.pause(C(this, jr))), this;
  }
  async once(t, n) {
    const r = await Se(this, Xp, px).call(this, t);
    return r.listeners.push({ listener: n, once: !0 }), r.started || (r.subscriber.start(), r.started = !0, C(this, jr) != null && r.subscriber.pause(C(this, jr))), this;
  }
  async emit(t, ...n) {
    const r = await Se(this, Od, cg).call(this, t, n);
    if (!r || r.listeners.length === 0)
      return !1;
    const i = r.listeners.length;
    return r.listeners = r.listeners.filter(({ listener: s, once: o }) => {
      const a = new TQ(this, o ? null : s, t);
      try {
        s.call(this, ...n, a);
      } catch {
      }
      return !o;
    }), r.listeners.length === 0 && (r.started && r.subscriber.stop(), C(this, Fr).delete(r.tag)), i > 0;
  }
  async listenerCount(t) {
    if (t) {
      const r = await Se(this, Od, cg).call(this, t);
      return r ? r.listeners.length : 0;
    }
    let n = 0;
    for (const { listeners: r } of C(this, Fr).values())
      n += r.length;
    return n;
  }
  async listeners(t) {
    if (t) {
      const r = await Se(this, Od, cg).call(this, t);
      return r ? r.listeners.map(({ listener: i }) => i) : [];
    }
    let n = [];
    for (const { listeners: r } of C(this, Fr).values())
      n = n.concat(r.map(({ listener: i }) => i));
    return n;
  }
  async off(t, n) {
    const r = await Se(this, Od, cg).call(this, t);
    if (!r)
      return this;
    if (n) {
      const i = r.listeners.map(({ listener: s }) => s).indexOf(n);
      i >= 0 && r.listeners.splice(i, 1);
    }
    return (!n || r.listeners.length === 0) && (r.started && r.subscriber.stop(), C(this, Fr).delete(r.tag)), this;
  }
  async removeAllListeners(t) {
    if (t) {
      const { tag: n, started: r, subscriber: i } = await Se(this, Xp, px).call(this, t);
      r && i.stop(), C(this, Fr).delete(n);
    } else
      for (const [n, { started: r, subscriber: i }] of C(this, Fr))
        r && i.stop(), C(this, Fr).delete(n);
    return this;
  }
  // Alias for "on"
  async addListener(t, n) {
    return await this.on(t, n);
  }
  // Alias for "off"
  async removeListener(t, n) {
    return this.off(t, n);
  }
  /**
   *  If this provider has been destroyed using the [[destroy]] method.
   *
   *  Once destroyed, all resources are reclaimed, internal event loops
   *  and timers are cleaned up and no further requests may be sent to
   *  the provider.
   */
  get destroyed() {
    return C(this, Yp);
  }
  /**
   *  Sub-classes may use this to shutdown any sockets or release their
   *  resources and reject any pending requests.
   *
   *  Sub-classes **must** call ``super.destroy()``.
   */
  destroy() {
    this.removeAllListeners();
    for (const t of C(this, gs).keys())
      this._clearTimeout(t);
    j(this, Yp, !0);
  }
  /**
   *  Whether the provider is currently paused.
   *
   *  A paused provider will not emit any events, and generally should
   *  not make any requests to the network, but that is up to sub-classes
   *  to manage.
   *
   *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
   *  which will buffer any events that occur while paused until the
   *  provider is unpaused.
   */
  get paused() {
    return C(this, jr) != null;
  }
  set paused(t) {
    !!t !== this.paused && (this.paused ? this.resume() : this.pause(!1));
  }
  /**
   *  Pause the provider. If %%dropWhilePaused%%, any events that occur
   *  while paused are dropped, otherwise all events will be emitted once
   *  the provider is unpaused.
   */
  pause(t) {
    if (j(this, Ja, -1), C(this, jr) != null) {
      if (C(this, jr) == !!t)
        return;
      Pe(!1, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
        operation: "pause"
      });
    }
    this._forEachSubscriber((n) => n.pause(t)), j(this, jr, !!t);
    for (const n of C(this, gs).values())
      n.timer && clearTimeout(n.timer), n.time = D6() - n.time;
  }
  /**
   *  Resume the provider.
   */
  resume() {
    if (C(this, jr) != null) {
      this._forEachSubscriber((t) => t.resume()), j(this, jr, null);
      for (const t of C(this, gs).values()) {
        let n = t.time;
        n < 0 && (n = 0), t.time = D6(), setTimeout(t.func, n);
      }
    }
  }
}
Fr = new WeakMap(), Rl = new WeakMap(), jr = new WeakMap(), Yp = new WeakMap(), $i = new WeakMap(), Id = new WeakMap(), Ml = new WeakMap(), Ja = new WeakMap(), $b = new WeakMap(), gs = new WeakMap(), Zp = new WeakMap(), Jp = new WeakMap(), ti = new WeakSet(), Li = async function(t) {
  const n = C(this, Jp).cacheTimeout;
  if (n < 0)
    return await this._perform(t);
  const r = hx(t.method, t);
  let i = C(this, Ml).get(r);
  return i || (i = this._perform(t), C(this, Ml).set(r, i), setTimeout(() => {
    C(this, Ml).get(r) === i && C(this, Ml).delete(r);
  }, n)), await i;
}, Qb = new WeakSet(), ck = async function(t, n, r) {
  Pe(r < mRe, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
    reason: "TOO_MANY_REDIRECTS",
    transaction: Object.assign({}, t, { blockTag: n, enableCcipRead: !0 })
  });
  const i = K2(t);
  try {
    return Je(await this._perform({ method: "call", transaction: i, blockTag: n }));
  } catch (s) {
    if (!this.disableCcipRead && nB(s) && s.data && r >= 0 && n === "latest" && i.to != null && Pn(s.data, 0, 4) === "0x556f1830") {
      const o = s.data, a = await ui(i.to, this);
      let c;
      try {
        c = ERe(Pn(s.data, 4));
      } catch (d) {
        Pe(!1, d.message, "OFFCHAIN_FAULT", {
          reason: "BAD_DATA",
          transaction: i,
          info: { data: o }
        });
      }
      Pe(c.sender.toLowerCase() === a.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
        action: "call",
        data: o,
        reason: "OffchainLookup",
        transaction: i,
        invocation: null,
        revert: {
          signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
          name: "OffchainLookup",
          args: c.errorArgs
        }
      });
      const l = await this.ccipReadFetch(i, c.calldata, c.urls);
      Pe(l != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
        reason: "FETCH_FAILED",
        transaction: i,
        info: { data: s.data, errorArgs: c.errorArgs }
      });
      const u = {
        to: a,
        data: Vn([c.selector, ARe([l, c.extraData])])
      };
      this.emit("debug", { action: "sendCcipReadCall", transaction: u });
      try {
        const d = await Se(this, Qb, ck).call(this, u, n, r + 1);
        return this.emit("debug", { action: "receiveCcipReadCallResult", transaction: Object.assign({}, u), result: d }), d;
      } catch (d) {
        throw this.emit("debug", { action: "receiveCcipReadCallError", transaction: Object.assign({}, u), error: d }), d;
      }
    }
    throw s;
  }
}, Kb = new WeakSet(), lk = async function(t) {
  const { value: n } = await ri({
    network: this.getNetwork(),
    value: t
  });
  return n;
}, Pd = new WeakSet(), ag = async function(t, n, r) {
  let i = this._getAddress(n), s = this._getBlockTag(r);
  return (typeof i != "string" || typeof s != "string") && ([i, s] = await Promise.all([i, s])), await Se(this, Kb, lk).call(this, Se(this, ti, Li).call(this, Object.assign(t, { address: i, blockTag: s })));
}, Yb = new WeakSet(), uk = async function(t, n) {
  if (mn(t, 32))
    return await Se(this, ti, Li).call(this, {
      method: "getBlock",
      blockHash: t,
      includeTransactions: n
    });
  let r = this._getBlockTag(t);
  return typeof r != "string" && (r = await r), await Se(this, ti, Li).call(this, {
    method: "getBlock",
    blockTag: r,
    includeTransactions: n
  });
}, Od = new WeakSet(), cg = async function(t, n) {
  let r = await j6(t, this);
  return r.type === "event" && n && n.length > 0 && n[0].removed === !0 && (r = await j6({ orphan: "drop-log", log: n[0] }, this)), C(this, Fr).get(r.tag) || null;
}, Xp = new WeakSet(), px = async function(t) {
  const n = await j6(t, this), r = n.tag;
  let i = C(this, Fr).get(r);
  return i || (i = { subscriber: this._getSubscriber(n), tag: r, addressableMap: /* @__PURE__ */ new WeakMap(), nameMap: /* @__PURE__ */ new Map(), started: !1, listeners: [] }, C(this, Fr).set(r, i)), i;
};
function vRe(e, t) {
  try {
    const n = dk(e, t);
    if (n)
      return U2(n);
  } catch {
  }
  return null;
}
function dk(e, t) {
  if (e === "0x")
    return null;
  try {
    const n = Ot(Pn(e, t, t + 32)), r = Ot(Pn(e, n, n + 32));
    return Pn(e, n + 32, n + 32 + r);
  } catch {
  }
  return null;
}
function DM(e) {
  const t = ci(e);
  if (t.length > 32)
    throw new Error("internal; should not happen");
  const n = new Uint8Array(32);
  return n.set(t, 32 - t.length), n;
}
function wRe(e) {
  if (e.length % 32 === 0)
    return e;
  const t = new Uint8Array(Math.ceil(e.length / 32) * 32);
  return t.set(e), t;
}
const xRe = new Uint8Array([]);
function ARe(e) {
  const t = [];
  let n = 0;
  for (let r = 0; r < e.length; r++)
    t.push(xRe), n += 32;
  for (let r = 0; r < e.length; r++) {
    const i = Ht(e[r]);
    t[r] = DM(n), t.push(DM(i.length)), t.push(wRe(i)), n += 32 + Math.ceil(i.length / 32) * 32;
  }
  return Vn(t);
}
const UM = "0x0000000000000000000000000000000000000000000000000000000000000000";
function ERe(e) {
  const t = {
    sender: "",
    urls: [],
    calldata: "",
    selector: "",
    extraData: "",
    errorArgs: []
  };
  Pe(Jh(e) >= 5 * 32, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
    reason: "insufficient OffchainLookup data"
  });
  const n = Pn(e, 0, 32);
  Pe(Pn(n, 0, 12) === Pn(UM, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
    reason: "corrupt OffchainLookup sender"
  }), t.sender = Pn(n, 12);
  try {
    const r = [], i = Ot(Pn(e, 32, 64)), s = Ot(Pn(e, i, i + 32)), o = Pn(e, i + 32);
    for (let a = 0; a < s; a++) {
      const c = vRe(o, a * 32);
      if (c == null)
        throw new Error("abort");
      r.push(c);
    }
    t.urls = r;
  } catch {
    Pe(!1, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup urls"
    });
  }
  try {
    const r = dk(e, 64);
    if (r == null)
      throw new Error("abort");
    t.calldata = r;
  } catch {
    Pe(!1, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup calldata"
    });
  }
  Pe(Pn(e, 100, 128) === Pn(UM, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
    reason: "corrupt OffchainLookup callbaackSelector"
  }), t.selector = Pn(e, 96, 100);
  try {
    const r = dk(e, 128);
    if (r == null)
      throw new Error("abort");
    t.extraData = r;
  } catch {
    Pe(!1, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
      reason: "corrupt OffchainLookup extraData"
    });
  }
  return t.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((r) => t[r]), t;
}
function ih(e, t) {
  if (e.provider)
    return e.provider;
  Pe(!1, "missing provider", "UNSUPPORTED_OPERATION", { operation: t });
}
async function LM(e, t) {
  let n = K2(t);
  if (n.to != null && (n.to = ui(n.to, e)), n.from != null) {
    const r = n.from;
    n.from = Promise.all([
      e.getAddress(),
      ui(r, e)
    ]).then(([i, s]) => (de(i.toLowerCase() === s.toLowerCase(), "transaction from mismatch", "tx.from", s), i));
  } else
    n.from = e.getAddress();
  return await ri(n);
}
class _Re {
  /**
   *  Creates a new Signer connected to %%provider%%.
   */
  constructor(t) {
    /**
     *  The provider this signer is connected to.
     */
    pe(this, "provider");
    ft(this, { provider: t || null });
  }
  async getNonce(t) {
    return ih(this, "getTransactionCount").getTransactionCount(await this.getAddress(), t);
  }
  async populateCall(t) {
    return await LM(this, t);
  }
  async populateTransaction(t) {
    const n = ih(this, "populateTransaction"), r = await LM(this, t);
    r.nonce == null && (r.nonce = await this.getNonce("pending")), r.gasLimit == null && (r.gasLimit = await this.estimateGas(r));
    const i = await this.provider.getNetwork();
    if (r.chainId != null) {
      const o = nt(r.chainId);
      de(o === i.chainId, "transaction chainId mismatch", "tx.chainId", t.chainId);
    } else
      r.chainId = i.chainId;
    const s = r.maxFeePerGas != null || r.maxPriorityFeePerGas != null;
    if (r.gasPrice != null && (r.type === 2 || s) ? de(!1, "eip-1559 transaction do not support gasPrice", "tx", t) : (r.type === 0 || r.type === 1) && s && de(!1, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", t), (r.type === 2 || r.type == null) && r.maxFeePerGas != null && r.maxPriorityFeePerGas != null)
      r.type = 2;
    else if (r.type === 0 || r.type === 1) {
      const o = await n.getFeeData();
      Pe(o.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
        operation: "getGasPrice"
      }), r.gasPrice == null && (r.gasPrice = o.gasPrice);
    } else {
      const o = await n.getFeeData();
      if (r.type == null)
        if (o.maxFeePerGas != null && o.maxPriorityFeePerGas != null)
          if (r.type = 2, r.gasPrice != null) {
            const a = r.gasPrice;
            delete r.gasPrice, r.maxFeePerGas = a, r.maxPriorityFeePerGas = a;
          } else
            r.maxFeePerGas == null && (r.maxFeePerGas = o.maxFeePerGas), r.maxPriorityFeePerGas == null && (r.maxPriorityFeePerGas = o.maxPriorityFeePerGas);
        else
          o.gasPrice != null ? (Pe(!s, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
            operation: "populateTransaction"
          }), r.gasPrice == null && (r.gasPrice = o.gasPrice), r.type = 0) : Pe(!1, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
            operation: "signer.getFeeData"
          });
      else
        (r.type === 2 || r.type === 3) && (r.maxFeePerGas == null && (r.maxFeePerGas = o.maxFeePerGas), r.maxPriorityFeePerGas == null && (r.maxPriorityFeePerGas = o.maxPriorityFeePerGas));
    }
    return await ri(r);
  }
  async estimateGas(t) {
    return ih(this, "estimateGas").estimateGas(await this.populateCall(t));
  }
  async call(t) {
    return ih(this, "call").call(await this.populateCall(t));
  }
  async resolveName(t) {
    return await ih(this, "resolveName").resolveName(t);
  }
  async sendTransaction(t) {
    const n = ih(this, "sendTransaction"), r = await this.populateTransaction(t);
    delete r.from;
    const i = $2.from(r);
    return await n.broadcastTransaction(await this.signTransaction(i));
  }
}
function SRe(e) {
  return JSON.parse(JSON.stringify(e));
}
var ni, Jo, Nd, Fl, Rd, em, Zb, fk, Jb, hk;
class fY {
  /**
   *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
   *  and [[_emitResults]] to setup the subscription and provide the event
   *  to the %%provider%%.
   */
  constructor(t) {
    re(this, Zb);
    re(this, Jb);
    re(this, ni, void 0);
    re(this, Jo, void 0);
    re(this, Nd, void 0);
    re(this, Fl, void 0);
    re(this, Rd, void 0);
    re(this, em, void 0);
    j(this, ni, t), j(this, Jo, null), j(this, Nd, Se(this, Zb, fk).bind(this)), j(this, Fl, !1), j(this, Rd, null), j(this, em, !1);
  }
  /**
   *  Sub-classes **must** override this to begin the subscription.
   */
  _subscribe(t) {
    throw new Error("subclasses must override this");
  }
  /**
   *  Sub-classes **must** override this handle the events.
   */
  _emitResults(t, n) {
    throw new Error("subclasses must override this");
  }
  /**
   *  Sub-classes **must** override this handle recovery on errors.
   */
  _recover(t) {
    throw new Error("subclasses must override this");
  }
  start() {
    C(this, Fl) || (j(this, Fl, !0), Se(this, Zb, fk).call(this, -2));
  }
  stop() {
    C(this, Fl) && (j(this, Fl, !1), j(this, em, !0), Se(this, Jb, hk).call(this), C(this, ni).off("block", C(this, Nd)));
  }
  pause(t) {
    t && Se(this, Jb, hk).call(this), C(this, ni).off("block", C(this, Nd));
  }
  resume() {
    this.start();
  }
}
ni = new WeakMap(), Jo = new WeakMap(), Nd = new WeakMap(), Fl = new WeakMap(), Rd = new WeakMap(), em = new WeakMap(), Zb = new WeakSet(), fk = async function(t) {
  try {
    C(this, Jo) == null && j(this, Jo, this._subscribe(C(this, ni)));
    let n = null;
    try {
      n = await C(this, Jo);
    } catch (s) {
      if (!Wr(s, "UNSUPPORTED_OPERATION") || s.operation !== "eth_newFilter")
        throw s;
    }
    if (n == null) {
      j(this, Jo, null), C(this, ni)._recoverSubscriber(this, this._recover(C(this, ni)));
      return;
    }
    const r = await C(this, ni).getNetwork();
    if (C(this, Rd) || j(this, Rd, r), C(this, Rd).chainId !== r.chainId)
      throw new Error("chaid changed");
    if (C(this, em))
      return;
    const i = await C(this, ni).send("eth_getFilterChanges", [n]);
    await this._emitResults(C(this, ni), i);
  } catch (n) {
    console.log("@TODO", n);
  }
  C(this, ni).once("block", C(this, Nd));
}, Jb = new WeakSet(), hk = function() {
  const t = C(this, Jo);
  t && (j(this, Jo, null), t.then((n) => {
    C(this, ni).destroyed || C(this, ni).send("eth_uninstallFilter", [n]);
  }));
};
var Md;
class CRe extends fY {
  /**
   *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
   *  listening for %%filter%%.
   */
  constructor(n, r) {
    super(n);
    re(this, Md, void 0);
    j(this, Md, SRe(r));
  }
  _recover(n) {
    return new EB(n, C(this, Md));
  }
  async _subscribe(n) {
    return await n.send("eth_newFilter", [C(this, Md)]);
  }
  async _emitResults(n, r) {
    for (const i of r)
      n.emit(C(this, Md), n._wrapLog(i, n._network));
  }
}
Md = new WeakMap();
class TRe extends fY {
  async _subscribe(t) {
    return await t.send("eth_newPendingTransactionFilter", []);
  }
  async _emitResults(t, n) {
    for (const r of n)
      t.emit("pending", r);
  }
}
const kRe = "bigint,boolean,function,number,string,symbol".split(/,/g);
function mx(e) {
  if (e == null || kRe.indexOf(typeof e) >= 0 || typeof e.getAddress == "function")
    return e;
  if (Array.isArray(e))
    return e.map(mx);
  if (typeof e == "object")
    return Object.keys(e).reduce((t, n) => (t[n] = e[n], t), {});
  throw new Error(`should not happen: ${e} (${typeof e})`);
}
function BRe(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function sh(e) {
  return e && e.toLowerCase();
}
function zM(e) {
  return e && typeof e.pollingInterval == "number";
}
const hY = {
  polling: !1,
  staticNetwork: null,
  batchStallTime: 10,
  batchMaxSize: 1 << 20,
  batchMaxCount: 100,
  cacheTimeout: 250,
  pollingInterval: 4e3
};
class U6 extends _Re {
  constructor(n, r) {
    super(n);
    pe(this, "address");
    r = ln(r), ft(this, { address: r });
  }
  connect(n) {
    Pe(!1, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
      operation: "signer.connect"
    });
  }
  async getAddress() {
    return this.address;
  }
  // JSON-RPC will automatially fill in nonce, etc. so we just check from
  async populateTransaction(n) {
    return await this.populateCall(n);
  }
  // Returns just the hash of the transaction after sent, which is what
  // the bare JSON-RPC API does;
  async sendUncheckedTransaction(n) {
    const r = mx(n), i = [];
    if (r.from) {
      const o = r.from;
      i.push((async () => {
        const a = await ui(o, this.provider);
        de(a != null && a.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", n), r.from = a;
      })());
    } else
      r.from = this.address;
    if (r.gasLimit == null && i.push((async () => {
      r.gasLimit = await this.provider.estimateGas({ ...r, from: this.address });
    })()), r.to != null) {
      const o = r.to;
      i.push((async () => {
        r.to = await ui(o, this.provider);
      })());
    }
    i.length && await Promise.all(i);
    const s = this.provider.getRpcTransaction(r);
    return this.provider.send("eth_sendTransaction", [s]);
  }
  async sendTransaction(n) {
    const r = await this.provider.getBlockNumber(), i = await this.sendUncheckedTransaction(n);
    return await new Promise((s, o) => {
      const a = [1e3, 100];
      let c = 0;
      const l = async () => {
        try {
          const u = await this.provider.getTransaction(i);
          if (u != null) {
            s(u.replaceableTransaction(r));
            return;
          }
        } catch (u) {
          if (Wr(u, "CANCELLED") || Wr(u, "BAD_DATA") || Wr(u, "NETWORK_ERROR")) {
            u.info == null && (u.info = {}), u.info.sendTransactionHash = i, o(u);
            return;
          }
          if (Wr(u, "INVALID_ARGUMENT") && (c++, u.info == null && (u.info = {}), u.info.sendTransactionHash = i, c > 10)) {
            o(u);
            return;
          }
          this.provider.emit("error", qn("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", { error: u }));
        }
        this.provider._setTimeout(() => {
          l();
        }, a.pop() || 4e3);
      };
      l();
    });
  }
  async signTransaction(n) {
    const r = mx(n);
    if (r.from) {
      const s = await ui(r.from, this.provider);
      de(s != null && s.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", n), r.from = s;
    } else
      r.from = this.address;
    const i = this.provider.getRpcTransaction(r);
    return await this.provider.send("eth_signTransaction", [i]);
  }
  async signMessage(n) {
    const r = typeof n == "string" ? yc(n) : n;
    return await this.provider.send("personal_sign", [
      Je(r),
      this.address.toLowerCase()
    ]);
  }
  async signTypedData(n, r, i) {
    const s = mx(i), o = await Q2.resolveNames(n, r, s, async (a) => {
      const c = await ui(a);
      return de(c != null, "TypedData does not support null address", "value", a), c;
    });
    return await this.provider.send("eth_signTypedData_v4", [
      this.address.toLowerCase(),
      JSON.stringify(Q2.getPayload(o.domain, r, o.value))
    ]);
  }
  async unlock(n) {
    return this.provider.send("personal_unlockAccount", [
      this.address.toLowerCase(),
      n,
      null
    ]);
  }
  // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
  async _legacySignMessage(n) {
    const r = typeof n == "string" ? yc(n) : n;
    return await this.provider.send("eth_sign", [
      this.address.toLowerCase(),
      Je(r)
    ]);
  }
}
var Fd, tm, Xa, Xo, eo, ys, xi, Xb, pk;
class IRe extends bRe {
  constructor(n, r) {
    super(n, r);
    re(this, Xb);
    re(this, Fd, void 0);
    // The next ID to use for the JSON-RPC ID field
    re(this, tm, void 0);
    // Payloads are queued and triggered in batches using the drainTimer
    re(this, Xa, void 0);
    re(this, Xo, void 0);
    re(this, eo, void 0);
    re(this, ys, void 0);
    re(this, xi, void 0);
    j(this, tm, 1), j(this, Fd, Object.assign({}, hY, r || {})), j(this, Xa, []), j(this, Xo, null), j(this, ys, null), j(this, xi, null);
    {
      let s = null;
      const o = new Promise((a) => {
        s = a;
      });
      j(this, eo, { promise: o, resolve: s });
    }
    const i = this._getOption("staticNetwork");
    typeof i == "boolean" ? (de(!i || n !== "any", "staticNetwork cannot be used on special network 'any'", "options", r), i && n != null && j(this, ys, ua.from(n))) : i && (de(n == null || i.matches(n), "staticNetwork MUST match network object", "options", r), j(this, ys, i));
  }
  /**
   *  Returns the value associated with the option %%key%%.
   *
   *  Sub-classes can use this to inquire about configuration options.
   */
  _getOption(n) {
    return C(this, Fd)[n];
  }
  /**
   *  Gets the [[Network]] this provider has committed to. On each call, the network
   *  is detected, and if it has changed, the call will reject.
   */
  get _network() {
    return Pe(C(this, ys), "network is not available yet", "NETWORK_ERROR"), C(this, ys);
  }
  /**
   *  Resolves to the non-normalized value by performing %%req%%.
   *
   *  Sub-classes may override this to modify behavior of actions,
   *  and should generally call ``super._perform`` as a fallback.
   */
  async _perform(n) {
    if (n.method === "call" || n.method === "estimateGas") {
      let i = n.transaction;
      if (i && i.type != null && nt(i.type) && i.maxFeePerGas == null && i.maxPriorityFeePerGas == null) {
        const s = await this.getFeeData();
        s.maxFeePerGas == null && s.maxPriorityFeePerGas == null && (n = Object.assign({}, n, {
          transaction: Object.assign({}, i, { type: void 0 })
        }));
      }
    }
    const r = this.getRpcRequest(n);
    return r != null ? await this.send(r.method, r.args) : super._perform(n);
  }
  /**
   *  Sub-classes may override this; it detects the *actual* network that
   *  we are **currently** connected to.
   *
   *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
   *  _send primitive must be used instead.
   */
  async _detectNetwork() {
    const n = this._getOption("staticNetwork");
    if (n)
      if (n === !0) {
        if (C(this, ys))
          return C(this, ys);
      } else
        return n;
    return C(this, xi) ? await C(this, xi) : this.ready ? (j(this, xi, (async () => {
      try {
        const r = ua.from(nt(await this.send("eth_chainId", [])));
        return j(this, xi, null), r;
      } catch (r) {
        throw j(this, xi, null), r;
      }
    })()), await C(this, xi)) : (j(this, xi, (async () => {
      const r = {
        id: Rc(this, tm)._++,
        method: "eth_chainId",
        params: [],
        jsonrpc: "2.0"
      };
      this.emit("debug", { action: "sendRpcPayload", payload: r });
      let i;
      try {
        i = (await this._send(r))[0], j(this, xi, null);
      } catch (s) {
        throw j(this, xi, null), this.emit("debug", { action: "receiveRpcError", error: s }), s;
      }
      if (this.emit("debug", { action: "receiveRpcResult", result: i }), "result" in i)
        return ua.from(nt(i.result));
      throw this.getRpcError(r, i);
    })()), await C(this, xi));
  }
  /**
   *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
   *  will be passed to [[_send]] from [[send]]. If it is overridden, then
   *  ``super._start()`` **MUST** be called.
   *
   *  Calling it multiple times is safe and has no effect.
   */
  _start() {
    C(this, eo) == null || C(this, eo).resolve == null || (C(this, eo).resolve(), j(this, eo, null), (async () => {
      for (; C(this, ys) == null && !this.destroyed; )
        try {
          j(this, ys, await this._detectNetwork());
        } catch (n) {
          if (this.destroyed)
            break;
          console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)"), this.emit("error", qn("failed to bootstrap network detection", "NETWORK_ERROR", { event: "initial-network-discovery", info: { error: n } })), await BRe(1e3);
        }
      Se(this, Xb, pk).call(this);
    })());
  }
  /**
   *  Resolves once the [[_start]] has been called. This can be used in
   *  sub-classes to defer sending data until the connection has been
   *  established.
   */
  async _waitUntilReady() {
    if (C(this, eo) != null)
      return await C(this, eo).promise;
  }
  /**
   *  Return a Subscriber that will manage the %%sub%%.
   *
   *  Sub-classes may override this to modify the behavior of
   *  subscription management.
   */
  _getSubscriber(n) {
    return n.type === "pending" ? new TRe(this) : n.type === "event" ? this._getOption("polling") ? new EB(this, n.filter) : new CRe(this, n.filter) : n.type === "orphan" && n.filter.orphan === "drop-log" ? new dY("orphan") : super._getSubscriber(n);
  }
  /**
   *  Returns true only if the [[_start]] has been called.
   */
  get ready() {
    return C(this, eo) == null;
  }
  /**
   *  Returns %%tx%% as a normalized JSON-RPC transaction request,
   *  which has all values hexlified and any numeric values converted
   *  to Quantity values.
   */
  getRpcTransaction(n) {
    const r = {};
    return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach((i) => {
      if (n[i] == null)
        return;
      let s = i;
      i === "gasLimit" && (s = "gas"), r[s] = Oh(nt(n[i], `tx.${i}`));
    }), ["from", "to", "data"].forEach((i) => {
      n[i] != null && (r[i] = Je(n[i]));
    }), n.accessList && (r.accessList = Of(n.accessList)), r;
  }
  /**
   *  Returns the request method and arguments required to perform
   *  %%req%%.
   */
  getRpcRequest(n) {
    switch (n.method) {
      case "chainId":
        return { method: "eth_chainId", args: [] };
      case "getBlockNumber":
        return { method: "eth_blockNumber", args: [] };
      case "getGasPrice":
        return { method: "eth_gasPrice", args: [] };
      case "getPriorityFee":
        return { method: "eth_maxPriorityFeePerGas", args: [] };
      case "getBalance":
        return {
          method: "eth_getBalance",
          args: [sh(n.address), n.blockTag]
        };
      case "getTransactionCount":
        return {
          method: "eth_getTransactionCount",
          args: [sh(n.address), n.blockTag]
        };
      case "getCode":
        return {
          method: "eth_getCode",
          args: [sh(n.address), n.blockTag]
        };
      case "getStorage":
        return {
          method: "eth_getStorageAt",
          args: [
            sh(n.address),
            "0x" + n.position.toString(16),
            n.blockTag
          ]
        };
      case "broadcastTransaction":
        return {
          method: "eth_sendRawTransaction",
          args: [n.signedTransaction]
        };
      case "getBlock":
        if ("blockTag" in n)
          return {
            method: "eth_getBlockByNumber",
            args: [n.blockTag, !!n.includeTransactions]
          };
        if ("blockHash" in n)
          return {
            method: "eth_getBlockByHash",
            args: [n.blockHash, !!n.includeTransactions]
          };
        break;
      case "getTransaction":
        return {
          method: "eth_getTransactionByHash",
          args: [n.hash]
        };
      case "getTransactionReceipt":
        return {
          method: "eth_getTransactionReceipt",
          args: [n.hash]
        };
      case "call":
        return {
          method: "eth_call",
          args: [this.getRpcTransaction(n.transaction), n.blockTag]
        };
      case "estimateGas":
        return {
          method: "eth_estimateGas",
          args: [this.getRpcTransaction(n.transaction)]
        };
      case "getLogs":
        return n.filter && n.filter.address != null && (Array.isArray(n.filter.address) ? n.filter.address = n.filter.address.map(sh) : n.filter.address = sh(n.filter.address)), { method: "eth_getLogs", args: [n.filter] };
    }
    return null;
  }
  /**
   *  Returns an ethers-style Error for the given JSON-RPC error
   *  %%payload%%, coalescing the various strings and error shapes
   *  that different nodes return, coercing them into a machine-readable
   *  standardized error.
   */
  getRpcError(n, r) {
    const { method: i } = n, { error: s } = r;
    if (i === "eth_estimateGas" && s.message) {
      const c = s.message;
      if (!c.match(/revert/i) && c.match(/insufficient funds/i))
        return qn("insufficient funds", "INSUFFICIENT_FUNDS", {
          transaction: n.params[0],
          info: { payload: n, error: s }
        });
    }
    if (i === "eth_call" || i === "eth_estimateGas") {
      const c = mk(s), l = gb.getBuiltinCallException(i === "eth_call" ? "call" : "estimateGas", n.params[0], c ? c.data : null);
      return l.info = { error: s, payload: n }, l;
    }
    const o = JSON.stringify(ORe(s));
    if (typeof s.message == "string" && s.message.match(/user denied|ethers-user-denied/i))
      return qn("user rejected action", "ACTION_REJECTED", {
        action: {
          eth_sign: "signMessage",
          personal_sign: "signMessage",
          eth_signTypedData_v4: "signTypedData",
          eth_signTransaction: "signTransaction",
          eth_sendTransaction: "sendTransaction",
          eth_requestAccounts: "requestAccess",
          wallet_requestAccounts: "requestAccess"
        }[i] || "unknown",
        reason: "rejected",
        info: { payload: n, error: s }
      });
    if (i === "eth_sendRawTransaction" || i === "eth_sendTransaction") {
      const c = n.params[0];
      if (o.match(/insufficient funds|base fee exceeds gas limit/i))
        return qn("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
          transaction: c,
          info: { error: s }
        });
      if (o.match(/nonce/i) && o.match(/too low/i))
        return qn("nonce has already been used", "NONCE_EXPIRED", { transaction: c, info: { error: s } });
      if (o.match(/replacement transaction/i) && o.match(/underpriced/i))
        return qn("replacement fee too low", "REPLACEMENT_UNDERPRICED", { transaction: c, info: { error: s } });
      if (o.match(/only replay-protected/i))
        return qn("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
          operation: i,
          info: { transaction: c, info: { error: s } }
        });
    }
    let a = !!o.match(/the method .* does not exist/i);
    return a || s && s.details && s.details.startsWith("Unauthorized method:") && (a = !0), a ? qn("unsupported operation", "UNSUPPORTED_OPERATION", {
      operation: n.method,
      info: { error: s, payload: n }
    }) : qn("could not coalesce error", "UNKNOWN_ERROR", { error: s, payload: n });
  }
  /**
   *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
   *  over the underlying channel. This can be used to call methods
   *  on the backend that do not have a high-level API within the Provider
   *  API.
   *
   *  This method queues requests according to the batch constraints
   *  in the options, assigns the request a unique ID.
   *
   *  **Do NOT override** this method in sub-classes; instead
   *  override [[_send]] or force the options values in the
   *  call to the constructor to modify this method's behavior.
   */
  send(n, r) {
    if (this.destroyed)
      return Promise.reject(qn("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: n }));
    const i = Rc(this, tm)._++, s = new Promise((o, a) => {
      C(this, Xa).push({
        resolve: o,
        reject: a,
        payload: { method: n, params: r, id: i, jsonrpc: "2.0" }
      });
    });
    return Se(this, Xb, pk).call(this), s;
  }
  /**
   *  Resolves to the [[Signer]] account for  %%address%% managed by
   *  the client.
   *
   *  If the %%address%% is a number, it is used as an index in the
   *  the accounts from [[listAccounts]].
   *
   *  This can only be used on clients which manage accounts (such as
   *  Geth with imported account or MetaMask).
   *
   *  Throws if the account doesn't exist.
   */
  async getSigner(n) {
    n == null && (n = 0);
    const r = this.send("eth_accounts", []);
    if (typeof n == "number") {
      const s = await r;
      if (n >= s.length)
        throw new Error("no such account");
      return new U6(this, s[n]);
    }
    const { accounts: i } = await ri({
      network: this.getNetwork(),
      accounts: r
    });
    n = ln(n);
    for (const s of i)
      if (ln(s) === n)
        return new U6(this, n);
    throw new Error("invalid account");
  }
  async listAccounts() {
    return (await this.send("eth_accounts", [])).map((r) => new U6(this, r));
  }
  destroy() {
    C(this, Xo) && (clearTimeout(C(this, Xo)), j(this, Xo, null));
    for (const { payload: n, reject: r } of C(this, Xa))
      r(qn("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: n.method }));
    j(this, Xa, []), super.destroy();
  }
}
Fd = new WeakMap(), tm = new WeakMap(), Xa = new WeakMap(), Xo = new WeakMap(), eo = new WeakMap(), ys = new WeakMap(), xi = new WeakMap(), Xb = new WeakSet(), pk = function() {
  if (C(this, Xo))
    return;
  const n = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
  j(this, Xo, setTimeout(() => {
    j(this, Xo, null);
    const r = C(this, Xa);
    for (j(this, Xa, []); r.length; ) {
      const i = [r.shift()];
      for (; r.length && i.length !== C(this, Fd).batchMaxCount; )
        if (i.push(r.shift()), JSON.stringify(i.map((o) => o.payload)).length > C(this, Fd).batchMaxSize) {
          r.unshift(i.pop());
          break;
        }
      (async () => {
        const s = i.length === 1 ? i[0].payload : i.map((o) => o.payload);
        this.emit("debug", { action: "sendRpcPayload", payload: s });
        try {
          const o = await this._send(s);
          this.emit("debug", { action: "receiveRpcResult", result: o });
          for (const { resolve: a, reject: c, payload: l } of i) {
            if (this.destroyed) {
              c(qn("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", { operation: l.method }));
              continue;
            }
            const u = o.filter((d) => d.id === l.id)[0];
            if (u == null) {
              const d = qn("missing response for request", "BAD_DATA", {
                value: o,
                info: { payload: l }
              });
              this.emit("error", d), c(d);
              continue;
            }
            if ("error" in u) {
              c(this.getRpcError(l, u));
              continue;
            }
            a(u.result);
          }
        } catch (o) {
          this.emit("debug", { action: "receiveRpcError", error: o });
          for (const { reject: a } of i)
            a(o);
        }
      })();
    }
  }, n));
};
var jl;
class PRe extends IRe {
  constructor(n, r) {
    super(n, r);
    re(this, jl, void 0);
    let i = this._getOption("pollingInterval");
    i == null && (i = hY.pollingInterval), j(this, jl, i);
  }
  _getSubscriber(n) {
    const r = super._getSubscriber(n);
    return zM(r) && (r.pollingInterval = C(this, jl)), r;
  }
  /**
   *  The polling interval (default: 4000 ms)
   */
  get pollingInterval() {
    return C(this, jl);
  }
  set pollingInterval(n) {
    if (!Number.isInteger(n) || n < 0)
      throw new Error("invalid interval");
    j(this, jl, n), this._forEachSubscriber((r) => {
      zM(r) && (r.pollingInterval = C(this, jl));
    });
  }
}
jl = new WeakMap();
function mk(e) {
  if (e == null)
    return null;
  if (typeof e.message == "string" && e.message.match(/revert/i) && mn(e.data))
    return { message: e.message, data: e.data };
  if (typeof e == "object") {
    for (const t in e) {
      const n = mk(e[t]);
      if (n)
        return n;
    }
    return null;
  }
  if (typeof e == "string")
    try {
      return mk(JSON.parse(e));
    } catch {
    }
  return null;
}
function gk(e, t) {
  if (e != null) {
    if (typeof e.message == "string" && t.push(e.message), typeof e == "object")
      for (const n in e)
        gk(e[n], t);
    if (typeof e == "string")
      try {
        return gk(JSON.parse(e), t);
      } catch {
      }
  }
}
function ORe(e) {
  const t = [];
  return gk(e, t), t;
}
var nm;
class NRe extends PRe {
  /**
   *  Connnect to the %%ethereum%% provider, optionally forcing the
   *  %%network%%.
   */
  constructor(n, r) {
    de(n && n.request, "invalid EIP-1193 provider", "ethereum", n);
    super(r, { batchMaxCount: 1 });
    re(this, nm, void 0);
    j(this, nm, async (i, s) => {
      const o = { method: i, params: s };
      this.emit("debug", { action: "sendEip1193Request", payload: o });
      try {
        const a = await n.request(o);
        return this.emit("debug", { action: "receiveEip1193Result", result: a }), a;
      } catch (a) {
        const c = new Error(a.message);
        throw c.code = a.code, c.data = a.data, c.payload = o, this.emit("debug", { action: "receiveEip1193Error", error: c }), c;
      }
    });
  }
  async send(n, r) {
    return await this._start(), await super.send(n, r);
  }
  async _send(n) {
    de(!Array.isArray(n), "EIP-1193 does not support batch request", "payload", n);
    try {
      const r = await C(this, nm).call(this, n.method, n.params || []);
      return [{ id: n.id, result: r }];
    } catch (r) {
      return [{
        id: n.id,
        error: { code: r.code, data: r.data, message: r.message }
      }];
    }
  }
  getRpcError(n, r) {
    switch (r = JSON.parse(JSON.stringify(r)), r.error.code || -1) {
      case 4001:
        r.error.message = `ethers-user-denied: ${r.error.message}`;
        break;
      case 4200:
        r.error.message = `ethers-unsupported: ${r.error.message}`;
        break;
    }
    return super.getRpcError(n, r);
  }
  /**
   *  Resolves to ``true`` if the provider manages the %%address%%.
   */
  async hasSigner(n) {
    n == null && (n = 0);
    const r = await this.send("eth_accounts", []);
    return typeof n == "number" ? r.length > n : (n = n.toLowerCase(), r.filter((i) => i.toLowerCase() === n).length !== 0);
  }
  async getSigner(n) {
    if (n == null && (n = 0), !await this.hasSigner(n))
      try {
        await C(this, nm).call(this, "eth_requestAccounts", []);
      } catch (r) {
        const i = r.payload;
        throw this.getRpcError(i, { id: i.id, error: r });
      }
    return await super.getSigner(n);
  }
}
nm = new WeakMap();
const RRe = 4001, MRe = 4100, FRe = 4200, jRe = 4900, DRe = 4901, J2 = -32700, X2 = -32600, eA = -32601, tA = -32602, nA = -32603, rA = -32e3, iA = -32001, sA = -32002, oA = -32003, aA = -32004, cA = -32005, lA = -32006;
class URe extends Error {
  constructor(t, n) {
    super(t), this.innerError = n, this.name = this.constructor.name, typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(new.target.constructor) : this.stack = new Error().stack;
  }
  static convertToString(t, n = !1) {
    if (t == null)
      return "undefined";
    const r = JSON.stringify(t, (i, s) => typeof s == "bigint" ? s.toString() : s);
    return n && ["bigint", "string"].includes(typeof t) ? r.replace(/['\\"]+/g, "") : r;
  }
  toJSON() {
    return {
      name: this.name,
      code: this.code,
      message: this.message,
      innerError: this.innerError
    };
  }
}
const LRe = "An Rpc error has occured with a code of *code*", Rs = {
  //  EIP-1474 & JSON RPC 2.0
  // https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1474.md
  [J2]: {
    message: "Parse error",
    description: "Invalid JSON"
  },
  [X2]: {
    message: "Invalid request",
    description: "JSON is not a valid request object	"
  },
  [eA]: {
    message: "Method not found",
    description: "Method does not exist	"
  },
  [tA]: {
    message: "Invalid params",
    description: "Invalid method parameters"
  },
  [nA]: {
    message: "Internal error",
    description: "Internal JSON-RPC error"
  },
  [rA]: {
    message: "Invalid input",
    description: "Missing or invalid parameters"
  },
  [iA]: {
    message: "Resource not found",
    description: "Requested resource not found"
  },
  [sA]: {
    message: "Resource unavailable",
    description: "Requested resource not available"
  },
  [oA]: {
    message: "Transaction rejected",
    description: "Transaction creation failed"
  },
  [aA]: {
    message: "Method not supported",
    description: "Method is not implemented"
  },
  [cA]: {
    message: "Limit exceeded",
    description: "Request exceeds defined limit"
  },
  [lA]: {
    message: "JSON-RPC version not supported",
    description: "Version of JSON-RPC protocol is not supported"
  },
  // EIP-1193
  // https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1193.md#provider-errors
  [RRe]: {
    name: "User Rejected Request",
    message: "The user rejected the request."
  },
  [MRe]: {
    name: "Unauthorized",
    message: "The requested method and/or account has not been authorized by the user."
  },
  [FRe]: {
    name: "Unsupported Method",
    message: "The Provider does not support the requested method."
  },
  [jRe]: {
    name: "Disconnected",
    message: "The Provider is disconnected from all chains."
  },
  [DRe]: {
    name: "Chain Disconnected",
    message: "The Provider is not connected to the requested chain."
  },
  // EIP-1193 - CloseEvent
  // https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
  "0-999": {
    name: "",
    message: "Not used."
  },
  1e3: {
    name: "Normal Closure",
    message: "The connection successfully completed the purpose for which it was created."
  },
  1001: {
    name: "Going Away",
    message: "The endpoint is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection."
  },
  1002: {
    name: "Protocol error",
    message: "The endpoint is terminating the connection due to a protocol error."
  },
  1003: {
    name: "Unsupported Data",
    message: "The connection is being terminated because the endpoint received data of a type it cannot accept. (For example, a text-only endpoint received binary data.)"
  },
  1004: {
    name: "Reserved",
    message: "Reserved. A meaning might be defined in the future."
  },
  1005: {
    name: "No Status Rcvd",
    message: "Reserved. Indicates that no status code was provided even though one was expected."
  },
  1006: {
    name: "Abnormal Closure",
    message: "Reserved. Indicates that a connection was closed abnormally (that is, with no close frame being sent) when a status code is expected."
  },
  1007: {
    name: "Invalid frame payload data",
    message: "The endpoint is terminating the connection because a message was received that contained inconsistent data (e.g., non-UTF-8 data within a text message)."
  },
  1008: {
    name: "Policy Violation",
    message: "The endpoint is terminating the connection because it received a message that violates its policy. This is a generic status code, used when codes 1003 and 1009 are not suitable."
  },
  1009: {
    name: "Message Too Big",
    message: "The endpoint is terminating the connection because a data frame was received that is too large."
  },
  1010: {
    name: "Mandatory Ext.",
    message: "The client is terminating the connection because it expected the server to negotiate one or more extension, but the server didn't."
  },
  1011: {
    name: "Internal Error",
    message: "The server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request."
  },
  1012: {
    name: "Service Restart",
    message: "The server is terminating the connection because it is restarting."
  },
  1013: {
    name: "Try Again Later",
    message: "The server is terminating the connection due to a temporary condition, e.g. it is overloaded and is casting off some of its clients."
  },
  1014: {
    name: "Bad Gateway",
    message: "The server was acting as a gateway or proxy and received an invalid response from the upstream server. This is similar to 502 HTTP Status Code."
  },
  1015: {
    name: "TLS handshake",
    message: "Reserved. Indicates that the connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified)."
  },
  "1016-2999": {
    name: "",
    message: "For definition by future revisions of the WebSocket Protocol specification, and for definition by extension specifications."
  },
  "3000-3999": {
    name: "",
    message: "For use by libraries, frameworks, and applications. These status codes are registered directly with IANA. The interpretation of these codes is undefined by the WebSocket protocol."
  },
  "4000-4999": {
    name: "",
    message: "For private use, and thus can't be registered. Such codes can be used by prior agreements between WebSocket applications. The interpretation of these codes is undefined by the WebSocket protocol."
  }
};
class Ms extends URe {
  constructor(t, n) {
    super(n ?? LRe.replace("*code*", t.error.code.toString())), this.code = t.error.code, this.id = t.id, this.jsonrpc = t.jsonrpc, this.jsonRpcError = t.error;
  }
  toJSON() {
    return Object.assign(Object.assign({}, super.toJSON()), { error: this.jsonRpcError, id: this.id, jsonRpc: this.jsonrpc });
  }
}
class zRe extends Ms {
  constructor(t) {
    super(t, Rs[J2].message), this.code = J2;
  }
}
class VRe extends Ms {
  constructor(t) {
    super(t, Rs[X2].message), this.code = X2;
  }
}
class HRe extends Ms {
  constructor(t) {
    super(t, Rs[eA].message), this.code = eA;
  }
}
class WRe extends Ms {
  constructor(t) {
    super(t, Rs[tA].message), this.code = tA;
  }
}
class GRe extends Ms {
  constructor(t) {
    super(t, Rs[nA].message), this.code = nA;
  }
}
class qRe extends Ms {
  constructor(t) {
    super(t, Rs[rA].message), this.code = rA;
  }
}
class $Re extends Ms {
  constructor(t) {
    super(t, Rs[aA].message), this.code = aA;
  }
}
class QRe extends Ms {
  constructor(t) {
    super(t, Rs[sA].message), this.code = sA;
  }
}
class KRe extends Ms {
  constructor(t) {
    super(t, Rs[iA].message), this.code = iA;
  }
}
class YRe extends Ms {
  constructor(t) {
    super(t, Rs[lA].message), this.code = lA;
  }
}
class ZRe extends Ms {
  constructor(t) {
    super(t, Rs[oA].message), this.code = oA;
  }
}
class JRe extends Ms {
  constructor(t) {
    super(t, Rs[cA].message), this.code = cA;
  }
}
const Fs = /* @__PURE__ */ new Map();
Fs.set(J2, { error: zRe });
Fs.set(X2, {
  error: VRe
});
Fs.set(eA, {
  error: HRe
});
Fs.set(tA, { error: WRe });
Fs.set(nA, { error: GRe });
Fs.set(rA, { error: qRe });
Fs.set(aA, {
  error: $Re
});
Fs.set(sA, {
  error: QRe
});
Fs.set(oA, {
  error: ZRe
});
Fs.set(iA, {
  error: KRe
});
Fs.set(lA, {
  error: YRe
});
Fs.set(cA, { error: JRe });
function bb(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function XRe(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function e9e(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function _B(e, ...t) {
  if (!e9e(e))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function t9e(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  bb(e.outputLen), bb(e.blockLen);
}
function yk(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function pY(e, t) {
  _B(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const n9e = { number: bb, bool: XRe, bytes: _B, hash: t9e, exists: yk, output: pY }, ow = /* @__PURE__ */ BigInt(2 ** 32 - 1), VM = /* @__PURE__ */ BigInt(32);
function r9e(e, t = !1) {
  return t ? { h: Number(e & ow), l: Number(e >> VM & ow) } : { h: Number(e >> VM & ow) | 0, l: Number(e & ow) | 0 };
}
function i9e(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: s, l: o } = r9e(e[i], t);
    [n[i], r[i]] = [s, o];
  }
  return [n, r];
}
const s9e = (e, t, n) => e << n | t >>> 32 - n, o9e = (e, t, n) => t << n | e >>> 32 - n, a9e = (e, t, n) => t << n - 32 | e >>> 64 - n, c9e = (e, t, n) => e << n - 32 | t >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const l9e = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
function u9e(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
const d9e = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!d9e)
  throw new Error("Non little-endian hardware is not supported");
function mY(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function gY(e) {
  if (typeof e == "string" && (e = mY(e)), !u9e(e))
    throw new Error(`expected Uint8Array, got ${typeof e}`);
  return e;
}
class f9e {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function h9e(e) {
  const t = (r) => e().update(gY(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
const [yY, bY, vY] = [[], [], []], p9e = /* @__PURE__ */ BigInt(0), F0 = /* @__PURE__ */ BigInt(1), m9e = /* @__PURE__ */ BigInt(2), g9e = /* @__PURE__ */ BigInt(7), y9e = /* @__PURE__ */ BigInt(256), b9e = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = F0, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], yY.push(2 * (5 * r + n)), bY.push((e + 1) * (e + 2) / 2 % 64);
  let i = p9e;
  for (let s = 0; s < 7; s++)
    t = (t << F0 ^ (t >> g9e) * b9e) % y9e, t & m9e && (i ^= F0 << (F0 << /* @__PURE__ */ BigInt(s)) - F0);
  vY.push(i);
}
const [v9e, w9e] = /* @__PURE__ */ i9e(vY, !0), HM = (e, t, n) => n > 32 ? a9e(e, t, n) : s9e(e, t, n), WM = (e, t, n) => n > 32 ? c9e(e, t, n) : o9e(e, t, n);
function x9e(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      n[o] = e[o] ^ e[o + 10] ^ e[o + 20] ^ e[o + 30] ^ e[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const a = (o + 8) % 10, c = (o + 2) % 10, l = n[c], u = n[c + 1], d = HM(l, u, 1) ^ n[a], f = WM(l, u, 1) ^ n[a + 1];
      for (let p = 0; p < 50; p += 10)
        e[o + p] ^= d, e[o + p + 1] ^= f;
    }
    let i = e[2], s = e[3];
    for (let o = 0; o < 24; o++) {
      const a = bY[o], c = HM(i, s, a), l = WM(i, s, a), u = yY[o];
      i = e[u], s = e[u + 1], e[u] = c, e[u + 1] = l;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let a = 0; a < 10; a++)
        n[a] = e[o + a];
      for (let a = 0; a < 10; a++)
        e[o + a] ^= ~n[(a + 2) % 10] & n[(a + 4) % 10];
    }
    e[0] ^= v9e[r], e[1] ^= w9e[r];
  }
  n.fill(0);
}
class SB extends f9e {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, i = !1, s = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, bb(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = l9e(this.state);
  }
  keccak() {
    x9e(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    yk(this);
    const { blockLen: n, state: r } = this;
    t = gY(t);
    const i = t.length;
    for (let s = 0; s < i; ) {
      const o = Math.min(n - this.pos, i - s);
      for (let a = 0; a < o; a++)
        r[this.pos++] ^= t[s++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: i } = this;
    t[r] ^= n, n & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    yk(this, !1), _B(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, s = t.length; i < s; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, s - i);
      t.set(n.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return bb(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (pY(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: s, enableXOF: o } = this;
    return t || (t = new SB(n, r, i, o, s)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = s, t.suffix = r, t.outputLen = i, t.enableXOF = o, t.destroyed = this.destroyed, t;
  }
}
const A9e = (e, t, n) => h9e(() => new SB(t, e, n)), GM = /* @__PURE__ */ A9e(1, 136, 256 / 8);
function E9e(e) {
  return (t) => (n9e.bytes(t), e(t));
}
(() => {
  const e = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0, t = typeof module < "u" && typeof module.require == "function" && module.require.bind(module);
  return {
    node: t && !e ? t("crypto") : void 0,
    web: e
  };
})();
const _9e = (() => {
  const e = E9e(GM);
  return e.create = GM.create, e;
})(), S9e = (e) => typeof e == "string" && /^((-)?0x[0-9a-f]+|(0x))$/i.test(e);
function wY(e) {
  let t = "0x";
  for (const n of e) {
    const r = n.toString(16);
    t += r.length === 1 ? `0${r}` : r;
  }
  return t;
}
function C9e(e) {
  var t;
  return !(e instanceof Uint8Array) && ((t = e == null ? void 0 : e.constructor) === null || t === void 0 ? void 0 : t.name) === "Uint8Array" ? Uint8Array.from(e) : e;
}
const qM = (e) => {
  var t;
  return e instanceof Uint8Array || ((t = e == null ? void 0 : e.constructor) === null || t === void 0 ? void 0 : t.name) === "Uint8Array";
}, T9e = (e) => {
  if (!/^(0x)?[0-9a-f]{40}$/i.test(e))
    return !1;
  const t = e.slice(2), n = mY(t.toLowerCase()), r = wY(_9e(C9e(n))).slice(2);
  for (let i = 0; i < 40; i += 1)
    if (parseInt(r[i], 16) > 7 && t[i].toUpperCase() !== t[i] || parseInt(r[i], 16) <= 7 && t[i].toLowerCase() !== t[i])
      return !1;
  return !0;
}, k9e = (e, t = !0) => {
  if (typeof e != "string" && !qM(e))
    return !1;
  let n;
  return qM(e) ? n = wY(e) : typeof e == "string" && !S9e(e) ? n = e.toLowerCase().startsWith("0x") ? e : `0x${e}` : n = e, /^(0x)?[0-9a-f]{40}$/i.test(n) ? /^(0x|0X)?[0-9a-f]{40}$/.test(n) || /^(0x|0X)?[0-9A-F]{40}$/.test(n) ? !0 : t ? T9e(n) : !0 : !1;
};
var uA;
(function(e) {
  e.NUMBER = "NUMBER_NUMBER", e.HEX = "NUMBER_HEX", e.STR = "NUMBER_STR", e.BIGINT = "NUMBER_BIGINT";
})(uA || (uA = {}));
var dA;
(function(e) {
  e.HEX = "BYTES_HEX", e.UINT8ARRAY = "BYTES_UINT8ARRAY";
})(dA || (dA = {}));
uA.BIGINT, dA.HEX;
uA.HEX, dA.HEX;
var $M;
(function(e) {
  e.EARLIEST = "earliest", e.LATEST = "latest", e.PENDING = "pending", e.SAFE = "safe", e.FINALIZED = "finalized";
})($M || ($M = {}));
var QM;
(function(e) {
  e.chainstart = "chainstart", e.frontier = "frontier", e.homestead = "homestead", e.dao = "dao", e.tangerineWhistle = "tangerineWhistle", e.spuriousDragon = "spuriousDragon", e.byzantium = "byzantium", e.constantinople = "constantinople", e.petersburg = "petersburg", e.istanbul = "istanbul", e.muirGlacier = "muirGlacier", e.berlin = "berlin", e.london = "london", e.altair = "altair", e.arrowGlacier = "arrowGlacier", e.grayGlacier = "grayGlacier", e.bellatrix = "bellatrix", e.merge = "merge", e.capella = "capella", e.shanghai = "shanghai";
})(QM || (QM = {}));
var bk = class {
  getAddress() {
    return this.address;
  }
  addressAsBuffer() {
    return T5.from(this.address.replace("0x", ""), "hex");
  }
  isZero() {
    return parseInt(this.address, 16) === 0;
  }
  constructor(e) {
    if (!k9e(e))
      throw Error("Not a valid address");
    this.address = e;
  }
}, B9e = class extends bk {
  getChainID() {
    return this.chainID;
  }
  constructor(e, t) {
    super(e), this.chainID = t;
  }
}, gx = class il {
  static chainIdFromId256(t) {
    return t.readUIntBE(0, 1) !== il.EVM_ADDRESS_MARK ? 0 : t.readUInt32BE(1);
  }
  static toPrincipal(t) {
    if (t[0] !== il.PRINCIPAL_MARK)
      throw Error("Wrong principal mark in Id256");
    return gt.fromUint8Array(t.slice(2, 2 + t[1]));
  }
  static toEvmAddress(t) {
    if (t[0] !== il.EVM_ADDRESS_MARK)
      throw Error("Wrong evm address mark in Id256");
    if (t.slice(1, 5).byteLength !== 4)
      throw new Error("Unexpected chain id length, must be 4 bytes");
    return [t.slice(1, 5).readUInt32BE(), `0x${t.slice(5, 25).toString("hex")}`];
  }
  static toBtcTxIndex(t) {
    if (t[0] !== il.BTC_TX_MARK)
      throw Error("Wrong rune id mark in Id256");
    if (t.slice(1, 9).byteLength !== 8)
      throw new Error("Unexpected tx id length, must be 8 bytes");
    return [t.slice(1, 9).readBigInt64BE(), t.slice(9, 14).readUInt32BE()];
  }
  static fromPrincipal(t) {
    let n = Qi.alloc(32);
    n[0] = il.PRINCIPAL_MARK;
    let r = t.toUint8Array();
    n[1] = r.length;
    let i = Qi.from(r);
    return n.set(i, 2), n;
  }
  static fromBtcTxIndex(t, n) {
    let r = Qi.alloc(32);
    r[0] = il.BTC_TX_MARK;
    let i = Qi.alloc(8);
    i.writeBigUInt64BE(t), i.copy(r, 1, 0, 8);
    let s = Qi.alloc(4);
    return s.writeUInt32BE(n), s.copy(r, 9, 0, 4), r;
  }
  static fromAddress(t) {
    let n = Qi.alloc(32);
    n[0] = il.EVM_ADDRESS_MARK;
    let r = Qi.alloc(4);
    return r.writeUInt32BE(Number(t.getChainID())), r.copy(n, 1, 0, 4), t.addressAsBuffer().copy(n, 5), n;
  }
  static from(t) {
    return t instanceof B9e ? this.fromAddress(t) : this.fromPrincipal(t);
  }
};
gx.PRINCIPAL_MARK = 0, gx.EVM_ADDRESS_MARK = 1, gx.BTC_TX_MARK = 2;
var Fu = gx, I9e = [{ inputs: [], stateMutability: "nonpayable", type: "constructor" }, { inputs: [{ internalType: "address", name: "target", type: "address" }], name: "AddressEmptyCode", type: "error" }, { inputs: [{ internalType: "address", name: "account", type: "address" }], name: "AddressInsufficientBalance", type: "error" }, { inputs: [], name: "ECDSAInvalidSignature", type: "error" }, { inputs: [{ internalType: "uint256", name: "length", type: "uint256" }], name: "ECDSAInvalidSignatureLength", type: "error" }, { inputs: [{ internalType: "bytes32", name: "s", type: "bytes32" }], name: "ECDSAInvalidSignatureS", type: "error" }, { inputs: [{ internalType: "address", name: "implementation", type: "address" }], name: "ERC1967InvalidImplementation", type: "error" }, { inputs: [], name: "ERC1967NonPayable", type: "error" }, { inputs: [], name: "EnforcedPause", type: "error" }, { inputs: [], name: "ExpectedPause", type: "error" }, { inputs: [], name: "FailedInnerCall", type: "error" }, { inputs: [], name: "InvalidInitialization", type: "error" }, { inputs: [], name: "NotInitializing", type: "error" }, { inputs: [{ internalType: "address", name: "owner", type: "address" }], name: "OwnableInvalidOwner", type: "error" }, { inputs: [{ internalType: "address", name: "account", type: "address" }], name: "OwnableUnauthorizedAccount", type: "error" }, { inputs: [{ internalType: "address", name: "token", type: "address" }], name: "SafeERC20FailedOperation", type: "error" }, { inputs: [], name: "UUPSUnauthorizedCallContext", type: "error" }, { inputs: [{ internalType: "bytes32", name: "slot", type: "bytes32" }], name: "UUPSUnsupportedProxiableUUID", type: "error" }, { anonymous: !1, inputs: [{ indexed: !1, internalType: "address", name: "sender", type: "address" }, { indexed: !1, internalType: "uint256", name: "amount", type: "uint256" }, { indexed: !1, internalType: "address", name: "fromERC20", type: "address" }, { indexed: !1, internalType: "bytes", name: "recipientID", type: "bytes" }, { indexed: !1, internalType: "bytes32", name: "toToken", type: "bytes32" }, { indexed: !1, internalType: "uint32", name: "operationID", type: "uint32" }, { indexed: !1, internalType: "bytes32", name: "name", type: "bytes32" }, { indexed: !1, internalType: "bytes16", name: "symbol", type: "bytes16" }, { indexed: !1, internalType: "uint8", name: "decimals", type: "uint8" }], name: "BurnTokenEvent", type: "event" }, { anonymous: !1, inputs: [{ indexed: !1, internalType: "uint64", name: "version", type: "uint64" }], name: "Initialized", type: "event" }, { anonymous: !1, inputs: [{ indexed: !1, internalType: "uint256", name: "amount", type: "uint256" }, { indexed: !1, internalType: "bytes32", name: "fromToken", type: "bytes32" }, { indexed: !1, internalType: "bytes32", name: "senderID", type: "bytes32" }, { indexed: !1, internalType: "address", name: "toERC20", type: "address" }, { indexed: !1, internalType: "address", name: "recipient", type: "address" }, { indexed: !1, internalType: "uint32", name: "nonce", type: "uint32" }], name: "MintTokenEvent", type: "event" }, { anonymous: !1, inputs: [{ indexed: !1, internalType: "uint32", name: "notificationType", type: "uint32" }, { indexed: !1, internalType: "address", name: "txSender", type: "address" }, { indexed: !1, internalType: "bytes", name: "userData", type: "bytes" }], name: "NotifyMinterEvent", type: "event" }, { anonymous: !1, inputs: [{ indexed: !0, internalType: "address", name: "previousOwner", type: "address" }, { indexed: !0, internalType: "address", name: "newOwner", type: "address" }], name: "OwnershipTransferred", type: "event" }, { anonymous: !1, inputs: [{ indexed: !1, internalType: "address", name: "account", type: "address" }], name: "Paused", type: "event" }, { anonymous: !1, inputs: [{ indexed: !1, internalType: "address", name: "account", type: "address" }], name: "Unpaused", type: "event" }, { anonymous: !1, inputs: [{ indexed: !0, internalType: "address", name: "implementation", type: "address" }], name: "Upgraded", type: "event" }, { anonymous: !1, inputs: [{ indexed: !1, internalType: "string", name: "name", type: "string" }, { indexed: !1, internalType: "string", name: "symbol", type: "string" }, { indexed: !1, internalType: "bytes32", name: "baseTokenID", type: "bytes32" }, { indexed: !1, internalType: "address", name: "wrappedERC20", type: "address" }], name: "WrappedTokenDeployedEvent", type: "event" }, { inputs: [], name: "UPGRADE_INTERFACE_VERSION", outputs: [{ internalType: "string", name: "", type: "string" }], stateMutability: "view", type: "function" }, { inputs: [], name: "__BridgeV2_init", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [{ internalType: "bytes32", name: "bytecodeHash", type: "bytes32" }], name: "addAllowedImplementation", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [{ internalType: "address", name: "controller", type: "address" }], name: "addController", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }], name: "allowedImplementations", outputs: [{ internalType: "bool", name: "", type: "bool" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }, { internalType: "address", name: "fromERC20", type: "address" }, { internalType: "bytes32", name: "toTokenID", type: "bytes32" }, { internalType: "bytes", name: "recipientID", type: "bytes" }], name: "burn", outputs: [{ internalType: "uint32", name: "", type: "uint32" }], stateMutability: "nonpayable", type: "function" }, { inputs: [{ internalType: "address", name: "", type: "address" }], name: "controllerAccessList", outputs: [{ internalType: "bool", name: "", type: "bool" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "string", name: "name", type: "string" }, { internalType: "string", name: "symbol", type: "string" }, { internalType: "uint8", name: "decimals", type: "uint8" }, { internalType: "bytes32", name: "baseTokenID", type: "bytes32" }], name: "deployERC20", outputs: [{ internalType: "address", name: "", type: "address" }], stateMutability: "nonpayable", type: "function" }, { inputs: [], name: "feeChargeContract", outputs: [{ internalType: "contract IFeeCharge", name: "", type: "address" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "address", name: "wrappedTokenAddress", type: "address" }], name: "getBaseToken", outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }], stateMutability: "view", type: "function" }, { inputs: [], name: "getDepositBlocks", outputs: [{ internalType: "uint32[]", name: "blockNumbers", type: "uint32[]" }], stateMutability: "view", type: "function" }, { inputs: [], name: "getMinterAddress", outputs: [{ internalType: "address", name: "", type: "address" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "bytes32", name: "baseTokenID", type: "bytes32" }], name: "getWrappedToken", outputs: [{ internalType: "address", name: "", type: "address" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "address", name: "minterAddress", type: "address" }, { internalType: "address", name: "feeChargeAddress", type: "address" }, { internalType: "bool", name: "isWrappedSide", type: "bool" }], name: "initialize", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [], name: "isWrappedSide", outputs: [{ internalType: "bool", name: "", type: "bool" }], stateMutability: "view", type: "function" }, { inputs: [], name: "listTokenPairs", outputs: [{ internalType: "address[]", name: "wrapped", type: "address[]" }, { internalType: "bytes32[]", name: "base", type: "bytes32[]" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "bytes", name: "encodedOrder", type: "bytes" }], name: "mint", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [], name: "minterCanisterAddress", outputs: [{ internalType: "address", name: "", type: "address" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "uint32", name: "notificationType", type: "uint32" }, { internalType: "bytes", name: "userData", type: "bytes" }], name: "notifyMinter", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [], name: "operationIDCounter", outputs: [{ internalType: "uint32", name: "", type: "uint32" }], stateMutability: "view", type: "function" }, { inputs: [], name: "owner", outputs: [{ internalType: "address", name: "", type: "address" }], stateMutability: "view", type: "function" }, { inputs: [], name: "pause", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [], name: "paused", outputs: [{ internalType: "bool", name: "", type: "bool" }], stateMutability: "view", type: "function" }, { inputs: [], name: "proxiableUUID", outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }], stateMutability: "view", type: "function" }, { inputs: [{ internalType: "address", name: "controller", type: "address" }], name: "removeController", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [], name: "renounceOwnership", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [{ internalType: "address", name: "newOwner", type: "address" }], name: "transferOwnership", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [], name: "unpause", outputs: [], stateMutability: "nonpayable", type: "function" }, { inputs: [{ internalType: "address", name: "newImplementation", type: "address" }, { internalType: "bytes", name: "data", type: "bytes" }], name: "upgradeToAndCall", outputs: [], stateMutability: "payable", type: "function" }], P9e = I9e, O9e = class {
  constructor({ address: e, wallet: t }) {
    this.eth = {}, this.address = e, this.wallet = t;
  }
  get bftBridge() {
    return this.eth.bft || (this.eth.bft = new Kl(this.address, P9e, this.wallet)), this.eth.bft;
  }
  idFromCanister(e) {
    return Fu.fromPrincipal(gt.fromText(e));
  }
  idFromRune(e) {
    let [t, n] = e.split(":");
    return Fu.fromBtcTxIndex(BigInt(t), parseInt(n, 10));
  }
  async getTokensPairs() {
    let e = await this.bftBridge.listTokenPairs();
    return e && e.length > 1 ? e[0].map((t, n) => ({ eth: t, id256: e[1][n] })) : [];
  }
  async getIcrcTokensPairs() {
    return (await this.getTokensPairs()).map(({ eth: e, id256: t }) => {
      try {
        let n = Qi.from(t.replace(/^0x/, ""), "hex");
        return { wrapped: e, base: Fu.toPrincipal(n).toText() };
      } catch {
        return;
      }
    }).filter((e) => !!e);
  }
  async getBtcTokensPairs() {
    return (await this.getTokensPairs()).map(({ eth: e, id256: t }) => {
      let [n, r] = Fu.toBtcTxIndex(Qi.from(t.replace(/^0x/, ""), "hex"));
      return { wrapped: e, base: `${n}:${r}` };
    });
  }
  async getRuneTokensPairs() {
    return (await this.getTokensPairs()).map(({ eth: e, id256: t }) => {
      let [n, r] = Fu.toBtcTxIndex(Qi.from(t.replace(/^0x/, ""), "hex"));
      return { wrapped: e, base: `${n}:${r}` };
    });
  }
  async deployIcrcWrappedToken(e, t, n, r) {
    let i = await this.getWrappedTokenAddress(e);
    if (i && new bk(i).isZero()) {
      let s = this.idFromCanister(e);
      await (await this.bftBridge.deployERC20(t, n, r, s)).wait(2);
    }
    return await this.getWrappedTokenAddress(e);
  }
  async deployRuneWrappedToken(e, t) {
    let n = await this.getWrappedTokenAddress(e);
    if (n && new bk(n).isZero()) {
      let r = this.idFromRune(e);
      await (await this.bftBridge.deployERC20(t, t, r)).wait(2);
    }
    return await this.getWrappedTokenAddress(e);
  }
  async getWrappedTokenAddress(e) {
    return await this.bftBridge.getWrappedToken(e.includes(":") ? this.idFromRune(e) : this.idFromCanister(e));
  }
  async burnIcrc(e, t, n, r) {
    let i = await this.getWrappedTokenAddress(t), s = N8({ sender: w2, amount: kh, erc20_token_address: kh, icrc2_token_principal: w2, from_subaccount: jg(x2(v2)), recipient_address: kh, fee_payer: jg(kh), approve_after_mint: jg(x2(v2)) }), o = b2([s], [{ sender: gt.fromText(e), from_subaccount: [], amount: `0x${BigInt(r).toString(16)}`, erc20_token_address: i, icrc2_token_principal: gt.fromText(t), recipient_address: n, fee_payer: [n], approve_after_mint: [] }]);
    await (await this.bftBridge.notifyMinter(0, o)).wait(2);
  }
  async burn(e, t, n) {
    let r;
    try {
      gt.fromText(e), r = Fu.fromPrincipal(gt.fromText(e));
    } catch {
    }
    r || (r = `0x${Qi.from(e, "utf8").toString("hex")}`);
    let i = await this.bftBridge.burn(n, t, r);
    return await i.wait(2), i;
  }
}, N9e = [{ type: "constructor", inputs: [{ name: "canChargeFee", type: "address[]", internalType: "address[]" }], stateMutability: "nonpayable" }, { type: "function", name: "chargeFee", inputs: [{ name: "from", type: "address", internalType: "address" }, { name: "to", type: "address", internalType: "address payable" }, { name: "senderID", type: "bytes32", internalType: "bytes32" }, { name: "amount", type: "uint256", internalType: "uint256" }], outputs: [], stateMutability: "nonpayable" }, { type: "function", name: "nativeTokenBalance", inputs: [{ name: "user", type: "address", internalType: "address" }], outputs: [{ name: "balance", type: "uint256", internalType: "uint256" }], stateMutability: "view" }, { type: "function", name: "nativeTokenDeposit", inputs: [{ name: "approvedSenderIDs", type: "bytes32[]", internalType: "bytes32[]" }], outputs: [{ name: "balance", type: "uint256", internalType: "uint256" }], stateMutability: "payable" }, { type: "function", name: "nativeTokenWithdraw", inputs: [{ name: "amount", type: "uint256", internalType: "uint256" }], outputs: [{ name: "balance", type: "uint256", internalType: "uint256" }], stateMutability: "payable" }, { type: "function", name: "removeApprovedSenderIDs", inputs: [{ name: "approvedSenderIDs", type: "bytes32[]", internalType: "bytes32[]" }], outputs: [], stateMutability: "nonpayable" }], R9e = N9e, M9e = class {
  constructor({ address: e, wallet: t }) {
    this.eth = {}, this.address = e, this.wallet = t;
  }
  get feeCharge() {
    return this.eth.feeCharge || (this.eth.feeCharge = new Kl(this.address, R9e, this.wallet)), this.eth.feeCharge;
  }
  async depositNativeTokens(e) {
    let t = this.feeCharge.interface.encodeFunctionData("nativeTokenDeposit", [[Fu.fromPrincipal(gt.fromText(e))]]), n = { nonce: await this.wallet.getNonce(), to: await this.feeCharge.getAddress(), value: BigInt(Math.pow(10, 14)), data: t };
    await (await this.wallet.sendTransaction(n)).wait(2);
  }
  async checkAndDeposit(e, t) {
    if (await this.feeCharge.nativeTokenBalance(t) <= 0 && (await this.depositNativeTokens(e), await this.feeCharge.nativeTokenBalance(t) <= 0))
      throw new Error("No native tokens deposited");
  }
}, F9e = [{ type: "constructor", inputs: [{ name: "name_", type: "string", internalType: "string" }, { name: "symbol_", type: "string", internalType: "string" }, { name: "_owner", type: "address", internalType: "address" }], stateMutability: "nonpayable" }, { type: "function", name: "allowance", inputs: [{ name: "owner", type: "address", internalType: "address" }, { name: "spender", type: "address", internalType: "address" }], outputs: [{ name: "", type: "uint256", internalType: "uint256" }], stateMutability: "view" }, { type: "function", name: "approve", inputs: [{ name: "spender", type: "address", internalType: "address" }, { name: "value", type: "uint256", internalType: "uint256" }], outputs: [{ name: "", type: "bool", internalType: "bool" }], stateMutability: "nonpayable" }, { type: "function", name: "approveByOwner", inputs: [{ name: "from", type: "address", internalType: "address" }, { name: "spender", type: "address", internalType: "address" }, { name: "value", type: "uint256", internalType: "uint256" }], outputs: [{ name: "", type: "bool", internalType: "bool" }], stateMutability: "nonpayable" }, { type: "function", name: "balanceOf", inputs: [{ name: "account", type: "address", internalType: "address" }], outputs: [{ name: "", type: "uint256", internalType: "uint256" }], stateMutability: "view" }, { type: "function", name: "decimals", inputs: [], outputs: [{ name: "", type: "uint8", internalType: "uint8" }], stateMutability: "view" }, { type: "function", name: "name", inputs: [], outputs: [{ name: "", type: "string", internalType: "string" }], stateMutability: "view" }, { type: "function", name: "owner", inputs: [], outputs: [{ name: "", type: "address", internalType: "address" }], stateMutability: "view" }, { type: "function", name: "setMetaData", inputs: [{ name: "name_", type: "bytes32", internalType: "bytes32" }, { name: "symbol_", type: "bytes16", internalType: "bytes16" }, { name: "decimals_", type: "uint8", internalType: "uint8" }], outputs: [], stateMutability: "nonpayable" }, { type: "function", name: "symbol", inputs: [], outputs: [{ name: "", type: "string", internalType: "string" }], stateMutability: "view" }, { type: "function", name: "totalSupply", inputs: [], outputs: [{ name: "", type: "uint256", internalType: "uint256" }], stateMutability: "view" }, { type: "function", name: "transfer", inputs: [{ name: "to", type: "address", internalType: "address" }, { name: "value", type: "uint256", internalType: "uint256" }], outputs: [{ name: "", type: "bool", internalType: "bool" }], stateMutability: "nonpayable" }, { type: "function", name: "transferFrom", inputs: [{ name: "sender", type: "address", internalType: "address" }, { name: "recipient", type: "address", internalType: "address" }, { name: "amount", type: "uint256", internalType: "uint256" }], outputs: [{ name: "", type: "bool", internalType: "bool" }], stateMutability: "nonpayable" }, { type: "event", name: "Approval", inputs: [{ name: "owner", type: "address", indexed: !0, internalType: "address" }, { name: "spender", type: "address", indexed: !0, internalType: "address" }, { name: "value", type: "uint256", indexed: !1, internalType: "uint256" }], anonymous: !1 }, { type: "event", name: "Transfer", inputs: [{ name: "from", type: "address", indexed: !0, internalType: "address" }, { name: "to", type: "address", indexed: !0, internalType: "address" }, { name: "value", type: "uint256", indexed: !1, internalType: "uint256" }], anonymous: !1 }, { type: "error", name: "ERC20InsufficientAllowance", inputs: [{ name: "spender", type: "address", internalType: "address" }, { name: "allowance", type: "uint256", internalType: "uint256" }, { name: "needed", type: "uint256", internalType: "uint256" }] }, { type: "error", name: "ERC20InsufficientBalance", inputs: [{ name: "sender", type: "address", internalType: "address" }, { name: "balance", type: "uint256", internalType: "uint256" }, { name: "needed", type: "uint256", internalType: "uint256" }] }, { type: "error", name: "ERC20InvalidApprover", inputs: [{ name: "approver", type: "address", internalType: "address" }] }, { type: "error", name: "ERC20InvalidReceiver", inputs: [{ name: "receiver", type: "address", internalType: "address" }] }, { type: "error", name: "ERC20InvalidSender", inputs: [{ name: "sender", type: "address", internalType: "address" }] }, { type: "error", name: "ERC20InvalidSpender", inputs: [{ name: "spender", type: "address", internalType: "address" }] }], j9e = F9e, D9e = class {
  constructor() {
    this.wallets = {}, this.tokens = {}, this.walletActors = {}, this.actors = {}, this.bfts = {}, this.feeCharge = {};
  }
  get eth() {
    if (!this.wallets.eth)
      throw new Error("ETH wallet not connected yet");
    return this.wallets.eth;
  }
  get ic() {
    if (!this.wallets.bitfinityWallet)
      throw new Error("Bitfinity wallet not connected yet");
    return this.wallets.bitfinityWallet;
  }
  connectEthWallet(e) {
    this.wallets.eth !== e && (this.wallets.eth = e, this.tokens = {}, this.bfts = {});
  }
  connectBitfinityWallet(e) {
    this.wallets.bitfinityWallet !== e && (this.wallets.bitfinityWallet = e, this.walletActors = {});
  }
  getWrappedTokenContract(e) {
    return this.tokens[e] ? this.tokens[e] : (this.tokens[e] = new Kl(e, j9e, this.eth), this.tokens[e]);
  }
  async getWrappedTokenInfo(e) {
    let t = this.getWrappedTokenContract(e), [n, r, i] = await Promise.all([t.name(), t.symbol(), t.decimals()]);
    return { name: n, symbol: r, decimals: i };
  }
  async getWrappedTokenBalance(e, t) {
    return await this.getWrappedTokenContract(e).balanceOf(t);
  }
  getBft(e) {
    return this.bfts[e] ? this.bfts[e] : (this.bfts[e] = new O9e({ address: e, wallet: this.eth }), this.bfts[e]);
  }
  getFeeCharge(e) {
    return this.feeCharge[e] ? this.feeCharge[e] : (this.feeCharge[e] = new M9e({ address: e, wallet: this.eth }), this.feeCharge[e]);
  }
  getActor(e, t, n) {
    if (this.actors[t])
      return this.actors[t];
    let r = new Pf({ host: e });
    return (e.includes("localhost") || e.includes("127.0.0.1")) && r.fetchRootKey(), this.actors[t] = Pc.createActor(n, { canisterId: t, agent: r }), this.actors[t];
  }
  async getWalletActor(e, t) {
    return this.walletActors[e] ? this.walletActors[e] : (this.walletActors[e] = await this.ic.createActor({ canisterId: e, interfaceFactory: t }), this.walletActors[e]);
  }
}, or = { npm_package_exports___require: "./dist/index.cjs", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.22 npm/? node/v20.15.1 linux x64", CI: "true", npm_package_bugs_url: "https://github.com/bitfinity-network/bitbridge/issues", npm_config_bin_links: "true", npm_node_execpath: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", npm_package_devDependencies_vite: "^5.2.0", npm_config_init_version: "1.0.0", npm_package_peerDependencies_react: "^18.2.0", npm_package_devDependencies__tanstack_react_query_devtools: "^5.24.0", npm_package_dependencies_wagmi: "^2.8.1", npm_package_files_0: "dist", npm_package_publishConfig_access: "public", HOME: "/home/runner", npm_package_devDependencies__typescript_eslint_parser: "^7.2.0", npm_package_dependencies_ethers: "^6.12.1", npm_package_dependencies_framer_motion: "^11.1.9", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_dependencies__rainbow_me_rainbowkit: "^2.0.7", npm_config_version_tag_prefix: "v", npm_package_devDependencies_vite_plugin_dts: "^3.9.1", npm_package_dependencies_react_icons: "^5.2.1", npm_package_devDependencies_eslint_plugin_react_hooks: "^4.6.0", npm_package_dependencies_dotenv: "^16.4.5", npm_package_devDependencies_typescript: "^5.2.2", npm_package_dependencies__dfinity_agent: "^1.2.0", npm_package_description: "The React UI for the Bitfinity EVM bridge", npm_package_readmeFilename: "README.md", npm_package_devDependencies__types_react_dom: "^18.2.22", npm_package_devDependencies_vite_plugin_mix: "^0.4.0", npm_package_types: "./dist/index.d.ts", npm_package_homepage: "https://github.com/bitfinity-network/bitbridge", npm_package_scripts_dev: "vite", npm_package_devDependencies__vitejs_plugin_react: "^4.2.1", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "^0.22.0", npm_package_dependencies__tanstack_query_sync_storage_persister: "^5.22.2", npm_package_dependencies__emotion_react: "^11.11.4", npm_package_module: "./dist/index.js", npm_package_devDependencies__typescript_eslint_eslint_plugin: "^7.2.0", npm_package_scripts_lint: "eslint . --ext ts,tsx --report-unused-disable-directives --max-warnings 0", npm_config_registry: "https://registry.yarnpkg.com", npm_package_devDependencies_eslint_plugin_react_refresh: "^0.4.6", npm_package_exports___import: "./dist/index.js", npm_config_ignore_scripts: "", npm_package_dependencies__bitfinity_network_bitfinitywallet: "^0.3.0", npm_package_author_email: "support@infinityswap.one", PATH: "/tmp/yarn--1722436032859-0.7268831613784328:/home/runner/work/bitbridge/bitbridge/packages/widget/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1722436018550-0.027432302051107138:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin:/snap/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", NODE: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", TURBO_HASH: "4c69888b02b3c09f", npm_package_name: "@bitfinity-network/bridge-widget", npm_package_dependencies_viem: "2.x", npm_package_dependencies__particle_network_btc_connectkit: "^1.0.0-alpha.25", LANG: "C.UTF-8", npm_package_devDependencies_eslint: "^8.57.0", npm_lifecycle_script: "tsc && vite build", npm_package_main: "./dist/index.cjs", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_devDependencies__types_react: "^18.2.66", npm_package_version: "1.3.0", npm_config_argv: '{"remain":[],"cooked":["run","build"],"original":["run","build"]}', npm_package_dependencies__bitfinity_network_bridge: "*", npm_package_scripts_build: "tsc && vite build", npm_package_peerDependencies_react_dom: "^18.2.0", npm_package_dependencies__tanstack_react_query: "^5.35.1", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "MIT", npm_config_strict_ssl: "true", npm_package_dependencies__chakra_ui_react: "^2.8.2", PWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_execpath: "/usr/local/lib/node_modules/yarn/bin/yarn.js", npm_package_dependencies__emotion_styled: "^11.11.5", npm_package_author_url: "https://bitfinity.network/", npm_package_author_name: "Bitfinity", npm_package_dependencies_react_spring_bottom_sheet: "3.5.0-alpha.0", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_scripts_preview: "vite preview", npm_package_dependencies_vite_plugin_svgr: "^4.2.0", INIT_CWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_package_dependencies__tanstack_react_query_persist_client: "^5.22.2", NODE_ENV: "production" }, U9e = ({ IDL: e }) => {
  let t = e.Variant({ ReadLogs: e.Null, Admin: e.Null, UpdateLogsConfiguration: e.Null, UpdateBlockchain: e.Null }), n = e.Record({ secs: e.Nat64, nanos: e.Nat32 }), r = e.Record({ log_filter: e.Opt(e.Text), in_memory_records: e.Opt(e.Nat64), enable_console: e.Bool });
  e.Record({ permissions: e.Opt(e.Vec(e.Tuple(e.Principal, e.Vec(t)))), owner: e.Principal, min_gas_price: e.Nat, chain_id: e.Nat64, signature_verification_principal: e.Principal, reserve_memory_pages: e.Opt(e.Nat64), genesis_accounts: e.Vec(e.Tuple(e.Text, e.Opt(e.Text))), coinbase: e.Text, transaction_processing_interval: e.Opt(n), log_settings: e.Opt(r) });
  let i = e.Record({ balance: e.Text, nonce: e.Text }), s = e.Variant({ InvalidNonce: e.Record({ actual: e.Text, expected: e.Text }), TransactionAlreadyExists: e.Null, TxReplacementUnderpriced: e.Null, TooManyTransactions: e.Null }), o = e.Variant({ DesignatedInvalid: e.Null, OutOfOffset: e.Null, Continue: e.Null, PriorityFeeGreaterThanMaxFee: e.Null, CallGasCostMoreThanGasLimit: e.Null, InvalidChainId: e.Null, Revert: e.Opt(e.Text), InvalidRange: e.Null, CreateContractLimit: e.Null, CallerGasLimitMoreThanBlock: e.Null, InvalidOpcode: e.Null, StateChangeDuringStaticCall: e.Null, LackOfFundForMaxFee: e.Record({ fee: e.Text, balance: e.Text }), CreateEmpty: e.Null, InvalidCode: e.Nat8, GasPriceLessThanBasefee: e.Null, InvalidJump: e.Null, OutOfFund: e.Null, NonceTooLow: e.Record({ tx: e.Nat64, state: e.Nat64 }), PrecompileError: e.Null, OpcodeNotFound: e.Null, NotActivated: e.Null, PCUnderflow: e.Null, OverflowPayment: e.Null, PrevrandaoNotSet: e.Null, OutOfGas: e.Null, Other: e.Text, CallNotAllowedInsideStatic: e.Null, NonceTooHigh: e.Record({ tx: e.Nat64, state: e.Nat64 }), RejectCallerWithCode: e.Null, CallTooDeep: e.Null, NonceOverflow: e.Null, FatalExternalError: e.Null, CreateContractWithEF: e.Null, CreateCollision: e.Null, StackOverflow: e.Null, CreateInitcodeSizeLimit: e.Null, StackUnderflow: e.Null }), a = e.Variant({ UnhandledInterrupt: e.Null, NotSupported: e.Null, Other: e.Text, CallErrorAsFatal: o }), c = e.Variant({ Internal: e.Text, TransactionSignature: e.Text, StableStorageError: e.Text, InsufficientBalance: e.Record({ actual: e.Text, expected: e.Text }), TransactionPool: s, NotAuthorized: e.Null, AnonymousPrincipal: e.Null, GasTooLow: e.Record({ minimum: e.Text }), BlockDoesNotExist: e.Text, NoHistoryDataForBlock: e.Text, TransactionReverted: e.Text, InvalidGasPrice: e.Text, NotProcessableTransactionError: o, ReservationFailed: e.Text, BadRequest: e.Text, FatalEvmExecutorError: a }), l = e.Variant({ Ok: e.Null, Err: c }), u = e.Record({ permissions: e.Vec(t) }), d = e.Variant({ Ok: u, Err: c }), f = e.Record({ receipts_bytes_limit: e.Nat64, blocks_and_transactions_bytes_limit: e.Nat64 }), p = e.Record({ miner: e.Text, totalDifficulty: e.Text, receiptsRoot: e.Text, stateRoot: e.Text, hash: e.Text, difficulty: e.Text, size: e.Opt(e.Text), uncles: e.Vec(e.Text), baseFeePerGas: e.Opt(e.Text), extraData: e.Text, sealFields: e.Vec(e.Text), transactionsRoot: e.Text, sha3Uncles: e.Text, nonce: e.Text, number: e.Text, timestamp: e.Text, transactions: e.Vec(e.Text), gasLimit: e.Text, logsBloom: e.Text, parentHash: e.Text, gasUsed: e.Text, mixHash: e.Text }), m = e.Record({ storageKeys: e.Vec(e.Text), address: e.Text }), h = e.Record({ r: e.Text, s: e.Text, v: e.Text, to: e.Opt(e.Text), gas: e.Text, maxFeePerGas: e.Opt(e.Text), gasPrice: e.Opt(e.Text), value: e.Text, blockNumber: e.Opt(e.Text), from: e.Text, hash: e.Text, blockHash: e.Opt(e.Text), type: e.Opt(e.Text), accessList: e.Opt(e.Vec(m)), transactionIndex: e.Opt(e.Text), nonce: e.Text, maxPriorityFeePerGas: e.Opt(e.Text), input: e.Text, chainId: e.Opt(e.Text) }), g = e.Variant({ Call: e.Vec(e.Nat8), None: e.Null, Create: e.Tuple(e.Vec(e.Nat8), e.Opt(e.Text)) }), y = e.Record({ data: e.Text, topics: e.Vec(e.Text), address: e.Text }), v = e.Variant({ Halt: e.Record({ error: o, gas_used: e.Text }), Revert: e.Record({ output: e.Text, revert_message: e.Opt(e.Text), gas_used: e.Text }), Success: e.Record({ output: g, logs: e.Vec(y), gas_used: e.Text, logs_bloom: e.Text }) }), b = e.Variant({ Replace: e.Record({ key: e.Tuple(e.Nat64, e.Text), value: e.Null }), Removed: e.Record({ key: e.Tuple(e.Nat64, e.Text) }) }), w = e.Record({ data: e.Vec(e.Nat8), ref_count: e.Nat32, removed_at_block: e.Nat64 }), A = e.Variant({ Replace: e.Record({ key: e.Text, value: w }), Removed: e.Record({ key: e.Text }) }), E = e.Variant({ Ok: e.Text, Err: c }), x = e.Record({ to: e.Opt(e.Text), gas: e.Opt(e.Text), maxFeePerGas: e.Opt(e.Text), gasPrice: e.Opt(e.Text), value: e.Opt(e.Text), data: e.Opt(e.Text), from: e.Opt(e.Text), accessList: e.Opt(e.Vec(m)), nonce: e.Opt(e.Text), maxPriorityFeePerGas: e.Opt(e.Text), chainId: e.Opt(e.Text) }), S = e.Variant({ Ok: e.Text, Err: c }), P = e.Record({ reward: e.Opt(e.Vec(e.Vec(e.Text))), base_fee_per_gas: e.Vec(e.Text), oldest_block: e.Text, gas_used_ratio: e.Vec(e.Float64) }), I = e.Variant({ Ok: P, Err: c }), R = e.Record({ miner: e.Text, totalDifficulty: e.Text, receiptsRoot: e.Text, stateRoot: e.Text, hash: e.Text, difficulty: e.Text, size: e.Opt(e.Text), uncles: e.Vec(e.Text), baseFeePerGas: e.Opt(e.Text), extraData: e.Text, sealFields: e.Vec(e.Text), transactionsRoot: e.Text, sha3Uncles: e.Text, nonce: e.Text, number: e.Text, timestamp: e.Text, transactions: e.Vec(h), gasLimit: e.Text, logsBloom: e.Text, parentHash: e.Text, gasUsed: e.Text, mixHash: e.Text }), Q = e.Variant({ NoBlockFound: e.Null, WithHash: p, WithTransaction: R }), J = e.Variant({ Ok: Q, Err: c }), we = e.Variant({ Ok: e.Nat64, Err: c }), V = e.Variant({ Ok: e.Vec(Q), Err: c }), L = e.Variant({ Ok: e.Opt(h), Err: c }), U = e.Record({ transactionHash: e.Text, blockNumber: e.Text, data: e.Text, blockHash: e.Text, transactionIndex: e.Text, topics: e.Vec(e.Text), address: e.Text, logIndex: e.Text, removed: e.Bool }), q = e.Record({ to: e.Opt(e.Text), status: e.Opt(e.Text), output: e.Opt(e.Vec(e.Nat8)), transactionHash: e.Text, cumulativeGasUsed: e.Text, blockNumber: e.Text, from: e.Text, logs: e.Vec(U), blockHash: e.Text, root: e.Opt(e.Text), type: e.Opt(e.Text), transactionIndex: e.Text, effectiveGasPrice: e.Opt(e.Text), logsBloom: e.Text, contractAddress: e.Opt(e.Text), gasUsed: e.Opt(e.Text) }), G = e.Variant({ Ok: e.Opt(q), Err: c }), ae = e.Record({ rustc_semver: e.Text, git_branch: e.Text, pkg_version: e.Text, cargo_target_triple: e.Text, cargo_debug: e.Text, pkg_name: e.Text, cargo_features: e.Text, build_timestamp: e.Text, git_sha: e.Text, git_commit_timestamp: e.Text }), ge = e.Variant({ Ok: e.Vec(e.Tuple(e.Nat64, e.Text)), Err: c }), Ae = e.Record({ stable_memory_size: e.Nat64, cycles: e.Nat64, heap_memory_size: e.Nat64 }), he = e.Variant({ PerHour: e.Null, PerWeek: e.Null, PerDay: e.Null, Period: e.Record({ seconds: e.Nat64 }), PerMinute: e.Null }), B = e.Record({ map: e.Vec(e.Tuple(e.Nat64, Ae)), interval: he, history_length_nanos: e.Nat64 }), be = e.Record({ metrics: B }), Be = e.Variant({ Ok: e.Vec(e.Tuple(e.Text, e.Nat)), Err: c }), Ne = e.Record({ to: e.Opt(e.Text), transaction_hash: e.Text, transaction_type: e.Opt(e.Text), block_hash: e.Text, max_priority_fee_per_gas: e.Opt(e.Text), from: e.Text, transaction_index: e.Text, max_fee_per_gas: e.Opt(e.Text), block_number: e.Text, cumulative_gas_used: e.Text, timestamp: e.Nat64, exe_result: v, gas_price: e.Opt(e.Text) }), _e = e.Record({ url: e.Text, method: e.Text, body: e.Vec(e.Nat8), headers: e.Vec(e.Tuple(e.Text, e.Text)) }), Ce = e.Record({ body: e.Vec(e.Nat8), headers: e.Vec(e.Tuple(e.Text, e.Text)), upgrade: e.Opt(e.Bool), status_code: e.Nat16 }), N = e.Record({ log: e.Text, offset: e.Nat64 }), F = e.Record({ logs: e.Vec(N), all_logs_count: e.Nat64 }), z = e.Variant({ Ok: F, Err: c }), ne = e.Record({ block_number: e.Nat64, cycles: e.Nat, chain_id: e.Nat64, pending_transactions: e.Vec(e.Text), pending_transactions_count: e.Nat64, block_gas_limit: e.Nat64, state_root: e.Text }), ee = e.Variant({ Ok: ne, Err: c }), Y = e.Variant({ Ok: e.Tuple(e.Text, e.Text), Err: c }), X = e.Variant({ Ok: e.Nat64, Err: c }), $ = e.Record({ history_size: e.Nat64, pending_block: e.Nat64 });
  return e.Service({ account_basic: e.Func([e.Text], [i], ["query"]), admin_allow_empty_blocks: e.Func([e.Bool], [l], []), admin_disable_evm: e.Func([e.Bool], [l], []), admin_ic_permissions_add: e.Func([e.Principal, e.Vec(t)], [d], []), admin_ic_permissions_get: e.Func([e.Principal], [d], ["query"]), admin_ic_permissions_remove: e.Func([e.Principal, e.Vec(t)], [d], []), admin_reserve_stable_storage_pages: e.Func([e.Nat64], [l], []), admin_set_block_gas_limit: e.Func([e.Nat64], [l], []), admin_set_block_size_limit: e.Func([e.Nat64], [l], []), admin_set_blockchain_size_limit: e.Func([f], [l], []), admin_set_coinbase: e.Func([e.Text], [l], []), admin_set_evm_state_history_size: e.Func([e.Nat64], [l], []), admin_set_max_batch_requests: e.Func([e.Nat32], [l], []), admin_set_max_tx_pool_size: e.Func([e.Nat64], [l], []), admin_set_min_gas_price: e.Func([e.Text], [l], []), admin_set_panic_transaction_from: e.Func([e.Opt(e.Text)], [l], []), append_blockchain_blocks: e.Func([e.Vec(e.Tuple(p, e.Vec(e.Tuple(h, v))))], [l], []), apply_clear_info_changes: e.Func([e.Vec(b)], [l], []), apply_state_storage_changes: e.Func([e.Vec(A)], [l], []), blocks_and_transactions_history_total_bytes: e.Func([], [e.Nat64], ["query"]), eth_accounts: e.Func([], [e.Vec(e.Text)], ["query"]), eth_block_number: e.Func([], [e.Nat64], ["query"]), eth_call: e.Func([e.Opt(e.Text), e.Opt(e.Text), e.Opt(e.Text), e.Nat64, e.Opt(e.Text), e.Opt(e.Text)], [E], ["query"]), eth_chain_id: e.Func([], [e.Nat64], ["query"]), eth_estimate_gas: e.Func([x], [S], ["query"]), eth_fee_history: e.Func([e.Nat64, e.Text, e.Opt(e.Vec(e.Float64))], [I], ["query"]), eth_gas_price: e.Func([], [S], ["query"]), eth_get_balance: e.Func([e.Text, e.Text], [S], ["query"]), eth_get_block_by_hash: e.Func([e.Text, e.Bool], [J], ["query"]), eth_get_block_by_number: e.Func([e.Text, e.Bool], [J], ["query"]), eth_get_block_transaction_count_by_block_number: e.Func([e.Text], [we], ["query"]), eth_get_block_transaction_count_by_hash: e.Func([e.Text], [e.Nat64], ["query"]), eth_get_block_transaction_count_by_number: e.Func([e.Text], [we], ["query"]), eth_get_blocks_by_number: e.Func([e.Text, e.Text, e.Bool], [V], ["query"]), eth_get_code: e.Func([e.Text, e.Text], [S], ["query"]), eth_get_storage_at: e.Func([e.Text, e.Text, e.Text], [S], ["query"]), eth_get_transaction_by_block_hash_and_index: e.Func([e.Text, e.Nat64], [e.Opt(h)], ["query"]), eth_get_transaction_by_block_number_and_index: e.Func([e.Text, e.Nat64], [L], ["query"]), eth_get_transaction_by_hash: e.Func([e.Text], [e.Opt(h)], ["query"]), eth_get_transaction_count: e.Func([e.Text, e.Text], [S], ["query"]), eth_get_transaction_receipt: e.Func([e.Text], [G], ["query"]), eth_hashrate: e.Func([], [e.Nat64], ["query"]), eth_max_priority_fee_per_gas: e.Func([], [S], ["query"]), eth_mining: e.Func([], [e.Bool], ["query"]), eth_protocol_version: e.Func([], [e.Nat64], ["query"]), eth_syncing: e.Func([], [e.Bool], ["query"]), get_block_gas_limit: e.Func([], [e.Nat64], ["query"]), get_block_size_limit: e.Func([], [e.Nat64], ["query"]), get_blockchain_size_limit: e.Func([], [f], ["query"]), get_canister_build_data: e.Func([], [ae], ["query"]), get_clear_info_entries: e.Func([e.Opt(e.Tuple(e.Nat64, e.Text)), e.Nat32], [ge], ["query"]), get_curr_metrics: e.Func([], [Ae], ["query"]), get_evm_state_history_size: e.Func([], [e.Nat64], ["query"]), get_genesis_accounts: e.Func([], [e.Vec(e.Tuple(e.Text, e.Text))], ["query"]), get_max_batch_requests: e.Func([], [e.Nat32], ["query"]), get_max_tx_pool_size: e.Func([], [e.Nat64], ["query"]), get_metrics: e.Func([], [be], ["query"]), get_min_gas_price: e.Func([], [e.Text], ["query"]), get_state_storage_item_hashes: e.Func([e.Opt(e.Text), e.Nat32], [Be], ["query"]), get_tx_execution_result_by_hash: e.Func([e.Text], [e.Opt(Ne)], ["query"]), http_request: e.Func([_e], [Ce], ["query"]), http_request_update: e.Func([_e], [Ce], []), ic_logs: e.Func([e.Nat64, e.Nat64], [z], ["query"]), ic_stats: e.Func([], [ee], ["query"]), is_address_reserved: e.Func([e.Principal, e.Text], [e.Bool], ["query"]), is_empty_block_enabled: e.Func([], [e.Bool], ["query"]), is_evm_disabled: e.Func([], [e.Bool], ["query"]), memory_pages_allocated_for_id: e.Func([e.Nat8], [e.Nat64], ["query"]), mint_native_tokens: e.Func([e.Text, e.Text], [Y], []), net_listening: e.Func([], [e.Bool], ["query"]), net_peer_count: e.Func([], [e.Nat64], ["query"]), net_version: e.Func([], [e.Nat64], ["query"]), receipts_history_total_bytes: e.Func([], [e.Nat64], ["query"]), reserve_address: e.Func([e.Principal, e.Text], [l], []), revert_blockchain_to_block: e.Func([e.Nat64], [X], []), send_raw_transaction: e.Func([h], [S], []), set_logger_filter: e.Func([e.Text], [l], []), set_state_root: e.Func([e.Text], [l], []), set_storage_indices: e.Func([$], [l], []), web3_client_version: e.Func([], [e.Text], ["query"]), web3_sha3: e.Func([e.Text], [S], ["query"]) });
}, KM = or.EVM_CANISTER_ID, L9e = (e, t = {}) => {
  let n = t.agent || new Pf({ ...t.agentOptions });
  return t.agent && t.agentOptions && console.warn("Detected both agent and agentOptions passed to createActor. Ignoring agentOptions and proceeding with the provided agent."), or.DFX_NETWORK !== "ic" && n.fetchRootKey().catch((r) => {
    console.warn("Unable to fetch root key. Check to ensure that your local replica is running"), console.error(r);
  }), Pc.createActor(U9e, { agent: n, canisterId: e, ...t.actorOptions });
};
KM && L9e(KM);
var z9e = ({ IDL: e }) => {
  let t = e.Variant({ GenericError: e.Record({ message: e.Text, error_code: e.Nat }), TemporarilyUnavailable: e.Null, InsufficientAllowance: e.Record({ allowance: e.Nat }), BadBurn: e.Record({ min_burn_amount: e.Nat }), Duplicate: e.Record({ duplicate_of: e.Nat }), BadFee: e.Record({ expected_fee: e.Nat }), CreatedInFuture: e.Record({ ledger_time: e.Nat64 }), TooOld: e.Null, InsufficientFunds: e.Record({ balance: e.Nat }) }), n = e.Variant({ Ok: e.Nat, Err: t }), r = e.Record({ stable_memory_size: e.Nat64, cycles: e.Nat64, heap_memory_size: e.Nat64 }), i = e.Variant({ PerHour: e.Null, PerWeek: e.Null, PerDay: e.Null, Period: e.Record({ seconds: e.Nat64 }), PerMinute: e.Null }), s = e.Record({ map: e.Vec(e.Tuple(e.Nat64, r)), interval: i, history_length_nanos: e.Nat64 }), o = e.Record({ metrics: s });
  return e.Service({ finish_icrc2_mint: e.Func([e.Principal, e.Principal, e.Vec(e.Nat8), e.Nat, e.Nat], [n], []), get_curr_metrics: e.Func([], [r], ["query"]), get_metrics: e.Func([], [o], ["query"]) });
}, YM = or.SPENDER_CANISTER_ID, V9e = (e, t = {}) => {
  let n = t.agent || new Pf({ ...t.agentOptions });
  return t.agent && t.agentOptions && console.warn("Detected both agent and agentOptions passed to createActor. Ignoring agentOptions and proceeding with the provided agent."), or.DFX_NETWORK !== "ic" && n.fetchRootKey().catch((r) => {
    console.warn("Unable to fetch root key. Check to ensure that your local replica is running"), console.error(r);
  }), Pc.createActor(z9e, { agent: n, canisterId: e, ...t.actorOptions });
};
YM && V9e(YM);
var H9e = ({ IDL: e }) => {
  let t = e.Rec(), n = e.Variant({ Int: e.Int, Nat: e.Nat, Blob: e.Vec(e.Nat8), Text: e.Text }), r = e.Vec(e.Nat8), i = e.Record({ owner: e.Principal, subaccount: e.Opt(r) }), s = e.Variant({ SetTo: i, Unset: e.Null }), o = e.Record({ icrc2: e.Bool }), a = e.Record({ token_symbol: e.Opt(e.Text), transfer_fee: e.Opt(e.Nat), metadata: e.Opt(e.Vec(e.Tuple(e.Text, n))), maximum_number_of_accounts: e.Opt(e.Nat64), accounts_overflow_trim_quantity: e.Opt(e.Nat64), change_fee_collector: e.Opt(s), max_memo_length: e.Opt(e.Nat16), token_name: e.Opt(e.Text), feature_flags: e.Opt(o) }), c = e.Record({ decimals: e.Opt(e.Nat8), token_symbol: e.Text, transfer_fee: e.Nat, metadata: e.Vec(e.Tuple(e.Text, n)), minting_account: i, initial_balances: e.Vec(e.Tuple(i, e.Nat)), maximum_number_of_accounts: e.Opt(e.Nat64), accounts_overflow_trim_quantity: e.Opt(e.Nat64), fee_collector_account: e.Opt(i), archive_options: e.Record({ num_blocks_to_archive: e.Nat64, max_transactions_per_response: e.Opt(e.Nat64), trigger_threshold: e.Nat64, more_controller_ids: e.Opt(e.Vec(e.Principal)), max_message_size_bytes: e.Opt(e.Nat64), cycles_for_archive_creation: e.Opt(e.Nat64), node_max_memory_size_bytes: e.Opt(e.Nat64), controller_id: e.Principal }), max_memo_length: e.Opt(e.Nat16), token_name: e.Text, feature_flags: e.Opt(o) });
  e.Variant({ Upgrade: e.Opt(a), Init: c });
  let l = e.Nat, u = e.Record({ block_range_end: l, canister_id: e.Principal, block_range_start: l }), d = e.Record({ start: l, length: e.Nat }), f = e.Vec(e.Tuple(e.Text, t));
  t.fill(e.Variant({ Int: e.Int, Map: f, Nat: e.Nat, Nat64: e.Nat64, Blob: e.Vec(e.Nat8), Text: e.Text, Array: e.Vec(t) }));
  let p = t, m = e.Record({ blocks: e.Vec(p) }), h = e.Func([d], [m], ["query"]), g = e.Record({ certificate: e.Opt(e.Vec(e.Nat8)), first_index: l, blocks: e.Vec(p), chain_length: e.Nat64, archived_blocks: e.Vec(e.Record({ callback: h, start: l, length: e.Nat })) }), y = e.Record({ certificate: e.Opt(e.Vec(e.Nat8)), hash_tree: e.Vec(e.Nat8) }), v = e.Nat, b = e.Record({ start: v, length: e.Nat }), w = e.Nat64, A = e.Record({ from: i, memo: e.Opt(e.Vec(e.Nat8)), created_at_time: e.Opt(w), amount: e.Nat, spender: e.Opt(i) }), E = e.Record({ to: i, memo: e.Opt(e.Vec(e.Nat8)), created_at_time: e.Opt(w), amount: e.Nat }), x = e.Record({ fee: e.Opt(e.Nat), from: i, memo: e.Opt(e.Vec(e.Nat8)), created_at_time: e.Opt(w), amount: e.Nat, expected_allowance: e.Opt(e.Nat), expires_at: e.Opt(w), spender: i }), S = e.Record({ to: i, fee: e.Opt(e.Nat), from: i, memo: e.Opt(e.Vec(e.Nat8)), created_at_time: e.Opt(w), amount: e.Nat, spender: e.Opt(i) }), P = e.Record({ burn: e.Opt(A), kind: e.Text, mint: e.Opt(E), approve: e.Opt(x), timestamp: w, transfer: e.Opt(S) }), I = e.Record({ transactions: e.Vec(P) }), R = e.Func([b], [I], ["query"]), Q = e.Record({ first_index: v, log_length: e.Nat, transactions: e.Vec(P), archived_transactions: e.Vec(e.Record({ callback: R, start: v, length: e.Nat })) }), J = e.Nat, we = e.Record({ url: e.Text, name: e.Text }), V = e.Record({ to: i, fee: e.Opt(J), memo: e.Opt(e.Vec(e.Nat8)), from_subaccount: e.Opt(r), created_at_time: e.Opt(w), amount: J }), L = e.Variant({ GenericError: e.Record({ message: e.Text, error_code: e.Nat }), TemporarilyUnavailable: e.Null, BadBurn: e.Record({ min_burn_amount: J }), Duplicate: e.Record({ duplicate_of: l }), BadFee: e.Record({ expected_fee: J }), CreatedInFuture: e.Record({ ledger_time: w }), TooOld: e.Null, InsufficientFunds: e.Record({ balance: J }) }), U = e.Variant({ Ok: l, Err: L }), q = e.Record({ account: i, spender: i }), G = e.Record({ allowance: e.Nat, expires_at: e.Opt(w) }), ae = e.Record({ fee: e.Opt(e.Nat), memo: e.Opt(e.Vec(e.Nat8)), from_subaccount: e.Opt(e.Vec(e.Nat8)), created_at_time: e.Opt(w), amount: e.Nat, expected_allowance: e.Opt(e.Nat), expires_at: e.Opt(w), spender: i }), ge = e.Variant({ GenericError: e.Record({ message: e.Text, error_code: e.Nat }), TemporarilyUnavailable: e.Null, Duplicate: e.Record({ duplicate_of: l }), BadFee: e.Record({ expected_fee: e.Nat }), AllowanceChanged: e.Record({ current_allowance: e.Nat }), CreatedInFuture: e.Record({ ledger_time: w }), TooOld: e.Null, Expired: e.Record({ ledger_time: w }), InsufficientFunds: e.Record({ balance: e.Nat }) }), Ae = e.Variant({ Ok: l, Err: ge }), he = e.Record({ to: i, fee: e.Opt(J), spender_subaccount: e.Opt(r), from: i, memo: e.Opt(e.Vec(e.Nat8)), created_at_time: e.Opt(w), amount: J }), B = e.Variant({ GenericError: e.Record({ message: e.Text, error_code: e.Nat }), TemporarilyUnavailable: e.Null, InsufficientAllowance: e.Record({ allowance: J }), BadBurn: e.Record({ min_burn_amount: J }), Duplicate: e.Record({ duplicate_of: l }), BadFee: e.Record({ expected_fee: J }), CreatedInFuture: e.Record({ ledger_time: w }), TooOld: e.Null, InsufficientFunds: e.Record({ balance: J }) }), be = e.Variant({ Ok: l, Err: B });
  return e.Service({ archives: e.Func([], [e.Vec(u)], ["query"]), get_blocks: e.Func([d], [g], ["query"]), get_data_certificate: e.Func([], [y], ["query"]), get_transactions: e.Func([b], [Q], ["query"]), icrc1_balance_of: e.Func([i], [J], ["query"]), icrc1_decimals: e.Func([], [e.Nat8], ["query"]), icrc1_fee: e.Func([], [J], ["query"]), icrc1_metadata: e.Func([], [e.Vec(e.Tuple(e.Text, n))], ["query"]), icrc1_minting_account: e.Func([], [e.Opt(i)], ["query"]), icrc1_name: e.Func([], [e.Text], ["query"]), icrc1_supported_standards: e.Func([], [e.Vec(we)], ["query"]), icrc1_symbol: e.Func([], [e.Text], ["query"]), icrc1_total_supply: e.Func([], [J], ["query"]), icrc1_transfer: e.Func([V], [U], []), icrc2_allowance: e.Func([q], [G], ["query"]), icrc2_approve: e.Func([ae], [Ae], []), icrc2_transfer_from: e.Func([he], [be], []) });
}, W9e = ({ IDL: e }) => {
  let t = e.Variant({ Dfx: e.Null, Production: e.Null, Test: e.Null, PocketIc: e.Null, Custom: e.Text }), n = e.Variant({ Local: e.Record({ private_key: e.Vec(e.Nat8) }), ManagementCanister: e.Record({ key_id: t }) }), r = e.Variant({ Ic: e.Principal, Http: e.Text }), i = e.Variant({ mainnet: e.Null, regtest: e.Null, testnet: e.Null }), s = e.Record({ log_filter: e.Opt(e.Text), in_memory_records: e.Opt(e.Nat64), enable_console: e.Bool });
  e.Record({ admin: e.Principal, signing_strategy: n, ck_btc_ledger_fee: e.Nat64, evm_link: r, ck_btc_minter: e.Principal, network: i, ck_btc_ledger: e.Principal, log_settings: s });
  let o = e.Record({ decimals: e.Nat8, token_symbol: e.Vec(e.Nat8), token_address: e.Text, bridge_address: e.Text, erc20_chain_id: e.Nat32, token_name: e.Vec(e.Nat8) }), a = e.Record({ txid: e.Vec(e.Nat8), vout: e.Nat32 }), c = e.Record({ confirmations: e.Nat32, value: e.Nat64, outpoint: a }), l = e.Variant({ Minted: e.Record({ tx_id: e.Text, amount: e.Nat64 }), Scheduled: e.Record({ required_confirmations: e.Nat32, pending_utxos: e.Opt(e.Vec(c)), current_confirmations: e.Nat32 }), Signed: e.Vec(e.Nat8) }), u = e.Variant({ GenericError: e.Record({ error_message: e.Text, error_code: e.Nat64 }), TemporarilyUnavailable: e.Text, AlreadyProcessing: e.Null, NoNewUtxos: e.Record({ required_confirmations: e.Nat32, pending_utxos: e.Opt(e.Vec(c)), current_confirmations: e.Opt(e.Nat32) }) }), d = e.Record({ height: e.Nat32, value: e.Nat64, outpoint: a }), f = e.Variant({ GenericError: e.Record({ message: e.Text, error_code: e.Nat }), TemporarilyUnavailable: e.Null, BadBurn: e.Record({ min_burn_amount: e.Nat }), Duplicate: e.Record({ duplicate_of: e.Nat }), BadFee: e.Record({ expected_fee: e.Nat }), CreatedInFuture: e.Record({ ledger_time: e.Nat64 }), TooOld: e.Null, InsufficientFunds: e.Record({ balance: e.Nat }) }), p = e.Variant({ Evm: e.Text, CkBtcMinter: u, ValueTooSmall: e.Null, Tainted: d, Sign: e.Text, CkBtcLedger: f, NotInitialized: e.Null, NothingToMint: e.Null }), m = e.Variant({ Ok: l, Err: p }), h = e.Record({ owner: e.Opt(e.Principal), subaccount: e.Opt(e.Vec(e.Nat8)) }), g = e.Record({ stable_memory_size: e.Nat64, cycles: e.Nat64, heap_memory_size: e.Nat64 }), y = e.Variant({ PerHour: e.Null, PerWeek: e.Null, PerDay: e.Null, Period: e.Record({ seconds: e.Nat64 }), PerMinute: e.Null }), v = e.Record({ map: e.Vec(e.Tuple(e.Nat64, g)), interval: y, history_length_nanos: e.Nat64 }), b = e.Record({ metrics: v });
  return e.Service({ admin_configure_bft_bridge: e.Func([o], [], []), btc_to_erc20: e.Func([e.Text], [e.Vec(m)], []), get_bft_bridge_contract: e.Func([], [e.Opt(e.Text)], ["query"]), get_btc_address: e.Func([h], [e.Text], []), get_curr_metrics: e.Func([], [g], ["query"]), get_evm_address: e.Func([], [e.Opt(e.Text)], []), get_metrics: e.Func([], [b], ["query"]) });
}, G9e = ({ IDL: e }) => {
  let t = e.Variant({ Dfx: e.Null, Production: e.Null, Test: e.Null, PocketIc: e.Null, Custom: e.Text }), n = e.Variant({ Local: e.Record({ private_key: e.Vec(e.Nat8) }), ManagementCanister: e.Record({ key_id: t }) }), r = e.Variant({ Ic: e.Principal, Http: e.Text }), i = e.Record({ log_filter: e.Opt(e.Text), in_memory_records: e.Opt(e.Nat64), enable_console: e.Bool });
  e.Record({ signing_strategy: n, base_bridge_contract: e.Text, wrapped_bridge_contract: e.Text, wrapped_evm_link: r, log_settings: e.Opt(i), base_evm_link: r });
  let s = e.Variant({ Base: e.Null, Wrapped: e.Null }), o = e.Record({ stable_memory_size: e.Nat64, cycles: e.Nat64, heap_memory_size: e.Nat64 }), a = e.Variant({ PerHour: e.Null, PerWeek: e.Null, PerDay: e.Null, Period: e.Record({ seconds: e.Nat64 }), PerMinute: e.Null }), c = e.Record({ map: e.Vec(e.Tuple(e.Nat64, o)), interval: a, history_length_nanos: e.Nat64 }), l = e.Record({ metrics: c });
  return e.Service({ admin_set_bft_bridge_address: e.Func([s, e.Text], [e.Opt(e.Null)], []), get_curr_metrics: e.Func([], [o], ["query"]), get_evm_address: e.Func([], [e.Opt(e.Text)], []), get_metrics: e.Func([], [l], ["query"]), get_mint_order: e.Func([e.Vec(e.Nat8), e.Vec(e.Nat8), e.Nat32], [e.Opt(e.Vec(e.Nat8))], ["query"]), list_mint_orders: e.Func([e.Vec(e.Nat8), e.Vec(e.Nat8)], [e.Vec(e.Tuple(e.Nat32, e.Vec(e.Nat8)))], ["query"]) });
}, ZM = or.ERC20_MINTER_CANISTER_ID, q9e = (e, t = {}) => {
  let n = t.agent || new Pf({ ...t.agentOptions });
  return t.agent && t.agentOptions && console.warn("Detected both agent and agentOptions passed to createActor. Ignoring agentOptions and proceeding with the provided agent."), or.DFX_NETWORK !== "ic" && n.fetchRootKey().catch((r) => {
    console.warn("Unable to fetch root key. Check to ensure that your local replica is running"), console.error(r);
  }), Pc.createActor(G9e, { agent: n, canisterId: e, ...t.actorOptions });
};
ZM && q9e(ZM);
var $9e = ({ IDL: e }) => {
  let t = e.Variant({ RecoveryError: e.Record({ recovered: e.Text, expected: e.Text }), Unauthorized: e.Null, InternalError: e.Text }), n = e.Variant({ Ok: e.Null, Err: t }), r = e.Record({ rustc_semver: e.Text, git_branch: e.Text, pkg_version: e.Text, cargo_target_triple: e.Text, cargo_debug: e.Text, pkg_name: e.Text, cargo_features: e.Text, build_timestamp: e.Text, git_sha: e.Text, git_commit_timestamp: e.Text }), i = e.Record({ stable_memory_size: e.Nat64, cycles: e.Nat64, heap_memory_size: e.Nat64 }), s = e.Variant({ PerHour: e.Null, PerWeek: e.Null, PerDay: e.Null, Period: e.Record({ seconds: e.Nat64 }), PerMinute: e.Null }), o = e.Record({ map: e.Vec(e.Tuple(e.Nat64, i)), interval: s, history_length_nanos: e.Nat64 }), a = e.Record({ metrics: o }), c = e.Record({ storageKeys: e.Vec(e.Text), address: e.Text }), l = e.Record({ r: e.Text, s: e.Text, v: e.Text, to: e.Opt(e.Text), gas: e.Text, maxFeePerGas: e.Opt(e.Text), gasPrice: e.Opt(e.Text), value: e.Text, blockNumber: e.Opt(e.Text), from: e.Text, hash: e.Text, blockHash: e.Opt(e.Text), type: e.Opt(e.Text), accessList: e.Opt(e.Vec(c)), transactionIndex: e.Opt(e.Text), nonce: e.Text, maxPriorityFeePerGas: e.Opt(e.Text), input: e.Text, chainId: e.Opt(e.Text) }), u = e.Variant({ Ok: e.Text, Err: t });
  return e.Service({ add_access: e.Func([e.Principal], [n], []), get_access_list: e.Func([], [e.Vec(e.Principal)], ["query"]), get_canister_build_data: e.Func([], [r], ["query"]), get_curr_metrics: e.Func([], [i], ["query"]), get_metrics: e.Func([], [a], ["query"]), get_owner: e.Func([], [e.Principal], ["query"]), remove_access: e.Func([e.Principal], [n], []), set_owner: e.Func([e.Principal], [n], []), verify_signature: e.Func([l], [u], ["query"]) });
}, JM = or.SIGNATURE_VERIFICATION_CANISTER_ID, Q9e = (e, t = {}) => {
  let n = t.agent || new Pf({ ...t.agentOptions });
  return t.agent && t.agentOptions && console.warn("Detected both agent and agentOptions passed to createActor. Ignoring agentOptions and proceeding with the provided agent."), or.DFX_NETWORK !== "ic" && n.fetchRootKey().catch((r) => {
    console.warn("Unable to fetch root key. Check to ensure that your local replica is running"), console.error(r);
  }), Pc.createActor($9e, { agent: n, canisterId: e, ...t.actorOptions });
};
JM && Q9e(JM);
var K9e = ({ IDL: e }) => {
  let t = e.Variant({ Dfx: e.Null, Production: e.Null, Test: e.Null, PocketIc: e.Null, Custom: e.Text }), n = e.Variant({ Local: e.Record({ private_key: e.Vec(e.Nat8) }), ManagementCanister: e.Record({ key_id: t }) }), r = e.Variant({ Ic: e.Principal, Http: e.Text }), i = e.Variant({ mainnet: e.Null, regtest: e.Null, testnet: e.Null }), s = e.Record({ log_filter: e.Opt(e.Text), in_memory_records: e.Opt(e.Nat64), enable_console: e.Bool });
  e.Record({ admin: e.Principal, signing_strategy: n, indexer_url: e.Text, evm_link: r, network: i, min_confirmations: e.Nat32, log_settings: s, deposit_fee: e.Nat64 });
  let o = e.Record({ bridge_address: e.Text, erc20_chain_id: e.Nat32 }), a = e.Record({ destination: e.Text, rune_name: e.Text, change_address: e.Opt(e.Text), from_address: e.Text, amount: e.Nat }), c = e.Variant({ Minted: e.Record({ tx_id: e.Text, amount: e.Nat }), Scheduled: e.Record({ required_confirmations: e.Nat32, pending_utxos: e.Opt(e.Vec(e.Record({}))), current_confirmations: e.Nat32 }), Signed: e.Vec(e.Nat8) }), l = e.Variant({ Evm: e.Text, Sign: e.Text, NoRunesToDeposit: e.Null, NotingToDeposit: e.Null, NotInitialized: e.Null, NotEnoughBtc: e.Record({ minimum: e.Nat64, received: e.Nat64 }), Unavailable: e.Text, Pending: e.Record({ current_confirmations: e.Nat32, min_confirmations: e.Nat32 }) }), u = e.Variant({ Ok: e.Vec(c), Err: l }), d = e.Record({ stable_memory_size: e.Nat64, cycles: e.Nat64, heap_memory_size: e.Nat64 }), f = e.Variant({ Derivation: e.Null }), p = e.Variant({ Ok: e.Text, Err: f }), m = e.Variant({ PerHour: e.Null, PerWeek: e.Null, PerDay: e.Null, Period: e.Record({ seconds: e.Nat64 }), PerMinute: e.Null }), h = e.Record({ map: e.Vec(e.Tuple(e.Nat64, d)), interval: m, history_length_nanos: e.Nat64 }), g = e.Record({ metrics: h });
  return e.Service({ admin_configure_bft_bridge: e.Func([o], [], []), admin_configure_ecdsa: e.Func([], [], []), create_edict_tx: e.Func([a], [e.Vec(e.Nat8)], []), deposit: e.Func([e.Text], [u], []), get_curr_metrics: e.Func([], [d], ["query"]), get_deposit_address: e.Func([e.Text], [p], ["query"]), get_evm_address: e.Func([], [e.Opt(e.Text)], []), get_metrics: e.Func([], [g], ["query"]), get_rune_balances: e.Func([e.Text], [e.Vec(e.Tuple(e.Text, e.Nat))], []) });
}, xY = (e) => {
  e = e.replace(/^0x/, "");
  let t = tke(e), n = new Uint8Array(32);
  return n.set(new Uint8Array(t), 0), n;
}, Y9e = (e) => new Promise((t) => setTimeout(t, e)), XM = class {
  constructor({ network: e, wallets: t, networks: n }) {
    this.networkName = e, this.networks = n, this.wallets = t;
  }
  get icHost() {
    return this.networks.get(this.networkName).icHost;
  }
  get network() {
    return this.networks.getBridge(this.networkName, "btc_evm");
  }
  get btcActor() {
    return this.wallets.getActor(this.icHost, this.network.btcBridgeCanisterId, W9e);
  }
  get bftBridge() {
    return this.wallets.getBft(this.network.bftAddress);
  }
  icWhitelist() {
    return [this.network.btcBridgeCanisterId];
  }
  async getTokensPairs() {
    return await this.bftBridge.getRuneTokensPairs();
  }
  async getBaseTokenBalance() {
    return 0n;
  }
  async getWrappedTokenInfo(e) {
    return await this.wallets.getWrappedTokenInfo(e);
  }
  async getWrappedTokenBalance(e, t) {
    return await this.wallets.getWrappedTokenBalance(e, t);
  }
  async deployWrappedToken({ id: e, name: t }) {
    return await this.bftBridge.deployRuneWrappedToken(e, t);
  }
  async getDepositAddress(e) {
    return await this.btcActor.get_btc_address({ owner: [gt.fromText(Pc.canisterIdOf(this.btcActor).toText())], subaccount: [xY(e)] });
  }
  async bridgeToEvmc({ recipient: e }) {
    return await this.btcActor.btc_to_erc20(e);
  }
  async bridgeFromEvmc({ wrappedToken: e, recipient: t, amount: n }) {
    await (await this.wallets.getWrappedTokenContract(e).approve(this.network.bftAddress, n)).wait(2), await this.bftBridge.burn(t, e, BigInt(n));
  }
}, eF = class {
  constructor({ network: e, networks: t, wallets: n }) {
    this.ic = {}, this.networkName = e, this.networks = t, this.wallets = n;
  }
  get network() {
    return this.networks.getBridge(this.networkName, "icrc_evm");
  }
  get bftBridge() {
    return this.wallets.getBft(this.network.bftAddress);
  }
  get feeCharge() {
    return this.wallets.getFeeCharge(this.network.feeChargeAddress);
  }
  async getTokensPairs() {
    return await this.bftBridge.getIcrcTokensPairs();
  }
  async getWrappedTokenAddress(e) {
    return await this.bftBridge.getWrappedTokenAddress(e);
  }
  async deployWrappedToken({ id: e, name: t, symbol: n, decimals: r }) {
    return await this.bftBridge.deployIcrcWrappedToken(e, t, n, r);
  }
  baseToken(e) {
    return this.wallets.getWalletActor(e, H9e);
  }
  async getBaseTokenBalance(e, t) {
    return (await this.baseToken(e)).icrc1_balance_of({ owner: gt.fromText(t), subaccount: [] });
  }
  async getWrappedTokenInfo(e) {
    return await this.wallets.getWrappedTokenInfo(e);
  }
  async getWrappedTokenBalance(e, t) {
    return await this.wallets.getWrappedTokenBalance(e, t);
  }
  icWhitelist() {
    return [this.network.iCRC2MinterCanisterId];
  }
  async bridgeToEvmc({ token: e, owner: t, recipient: n, amount: r }) {
    await this.feeCharge.checkAndDeposit(t, n);
    let i = await this.baseToken(e), s = await i.icrc1_fee();
    await i.icrc2_approve({ fee: [], memo: [], from_subaccount: [], created_at_time: [], amount: r + s * 2n, expected_allowance: [], expires_at: [], spender: { owner: gt.fromText(this.network.iCRC2MinterCanisterId), subaccount: [xY(n)] } }), await this.bftBridge.burnIcrc(t, e, n, r);
  }
  async bridgeFromEvmc({ wrappedToken: e, recipient: t, amount: n }) {
    await (await this.wallets.getWrappedTokenContract(e).approve(this.network.bftAddress, n)).wait(2), await this.bftBridge.burn(t, e, n);
  }
}, tF = class {
  constructor({ network: e, wallets: t, networks: n }) {
    this.networkName = e, this.networks = n, this.wallets = t;
  }
  get icHost() {
    return this.networks.get(this.networkName).icHost;
  }
  get network() {
    return this.networks.getBridge(this.networkName, "rune_evm");
  }
  get runeActor() {
    return this.wallets.getActor(this.icHost, this.network.runeBridgeCanisterId, K9e);
  }
  get bftBridge() {
    return this.wallets.getBft(this.network.bftAddress);
  }
  icWhitelist() {
    return [this.network.runeBridgeCanisterId];
  }
  async getTokensPairs() {
    return await this.bftBridge.getRuneTokensPairs();
  }
  async deployWrappedToken({ id: e, name: t }) {
    return await this.bftBridge.deployRuneWrappedToken(e, t);
  }
  async getDepositAddress(e) {
    let t = this.runeActor.get_deposit_address(e);
    if (!("Ok" in t))
      throw new Error("Err");
    return t.Ok;
  }
  async getBaseTokenBalance() {
    return 0n;
  }
  async getWrappedTokenInfo(e) {
    return await this.wallets.getWrappedTokenInfo(e);
  }
  async getWrappedTokenBalance(e, t) {
    return await this.wallets.getWrappedTokenBalance(e, t);
  }
  async bridgeToEvmc({ recipient: e }) {
    for (let t = 0; t < 3; t++) {
      let n = await this.runeActor.deposit(e);
      if ("Ok" in n)
        return n.Ok;
      await Y9e(7e3);
    }
  }
  async bridgeFromEvmc({ wrappedToken: e, amount: t, recipient: n }) {
    await (await this.wallets.getWrappedTokenContract(e).approve(this.network.bftAddress, t)).wait(2), await this.bftBridge.burn(n, e, BigInt(t));
  }
}, AY = Pt.enum(["icrc_evm", "btc_evm", "rune_evm"]), CB = Pt.object({ type: AY, bftAddress: Pt.string(), feeChargeAddress: Pt.string() }), Z9e = CB.extend({ type: Pt.literal("icrc_evm").default("icrc_evm"), iCRC2MinterCanisterId: Pt.string() }), J9e = CB.extend({ type: Pt.literal("btc_evm").default("btc_evm"), btcBridgeCanisterId: Pt.string() }), X9e = CB.extend({ type: Pt.literal("rune_evm").default("rune_evm"), runeBridgeCanisterId: Pt.string() }), eMe = Pt.discriminatedUnion("type", [Z9e, J9e, X9e]), tMe = Pt.object({ name: Pt.string(), icHost: Pt.string(), ethChain: Pt.number(), bridges: Pt.array(eMe) }), nMe = Pt.object({ url: Pt.string(), ttl: Pt.number().default(3 * 60 * 60 * 1e3) }), rMe = Pt.object({ networks: Pt.array(tMe) }), iMe = class {
  constructor() {
    this.networks = [];
    let e = Jn.create();
    this.axios = nPe(e, { storage: typeof localStorage < "u" ? rPe(localStorage, "axios-cache") : AQ() });
  }
  add(e) {
    let t = this.networks.findIndex((n) => n.name === e.name);
    t !== -1 ? this.networks[t] = e : this.networks.push(e);
  }
  get(e) {
    let t = this.networks.find((n) => n.name === e);
    if (!t)
      throw new Error("Network not found");
    return t;
  }
  getBridge(e, t) {
    let n = this.get(e).bridges.find((r) => r.type === t);
    if (!n)
      throw new Error("Bridge not found");
    return n;
  }
  all() {
    return this.networks;
  }
  async fetch(e) {
    await Promise.all(e.map(async ({ url: t, ttl: n }) => {
      try {
        let r = await this.axios.get(t, { cache: { ttl: n, interpretHeader: !0 } }), { networks: i } = rMe.parse(r.data);
        i.forEach((s) => this.add(s));
      } catch (r) {
        console.error(`Error fetching tokens url: ${t}`, r instanceof Pt.ZodError ? r.issues : r);
      }
    }));
  }
}, sMe = class {
  constructor({ networks: e }) {
    this.bridges = {}, this.networks = e, this.wallets = new D9e();
  }
  connectEthWallet(e) {
    this.wallets.connectEthWallet(e);
  }
  connectBitfinityWallet(e) {
    this.wallets.connectBitfinityWallet(e);
  }
  createBridge(e) {
    this.bridges[e.name] || (this.bridges[e.name] = [], e.bridges.forEach((t) => {
      let n;
      t.type === "icrc_evm" ? n = new eF({ network: e.name, networks: this.networks, wallets: this.wallets }) : t.type === "btc_evm" ? n = new XM({ network: e.name, networks: this.networks, wallets: this.wallets }) : t.type === "rune_evm" && (n = new tF({ network: e.name, networks: this.networks, wallets: this.wallets })), n && this.bridges[e.name].push(n);
    }));
  }
  createBridges() {
    this.networks.all().forEach((e) => this.createBridge(e));
  }
  getBridge(e, t) {
    let n = Object.entries(this.bridges).find(([i]) => i === e);
    if (!n)
      throw new Error("Bridge not found");
    let r = n[1].find((i) => {
      if (t === "icrc_evm")
        return i instanceof eF;
      if (t === "btc_evm")
        return i instanceof XM;
      if (t === "rune_evm")
        return i instanceof tF;
      throw new Error("Unknown bridge type");
    });
    if (!r)
      throw new Error("Bridge not found");
    return r;
  }
  icWhiteList() {
    return Object.entries(this.bridges).map(([, e]) => e.map((t) => t.icWhitelist())).flat(2).filter((e, t, n) => n.indexOf(e) === t);
  }
}, oMe = class EY {
  constructor() {
    this.networks = new iMe(), this.bridger = new sMe({ networks: this.networks });
  }
  addNetwork(t) {
    this.networks.add(t), this.bridger.createBridges();
  }
  addNetworks(t) {
    t.forEach((n) => this.addNetwork(n));
  }
  getNetworks() {
    return this.networks.all();
  }
  async fetch(t) {
    await this.networks.fetch(t), this.bridger.createBridges();
  }
  connectEthWallet(t) {
    this.wallet = t, this.bridger.connectEthWallet(t);
  }
  disconnectEthWallet() {
    this.wallet = void 0, this.bridger.connectEthWallet(void 0);
  }
  connectBitfinityWallet(t) {
    this.bitfinityWallet = t, this.bridger.connectBitfinityWallet(t);
  }
  disconnectBitfinityWallet() {
    this.bitfinityWallet = void 0, this.bridger.connectBitfinityWallet(void 0);
  }
  static create() {
    return new EY();
  }
  icWhiteList() {
    return this.bridger.icWhiteList();
  }
  getBridge(t, n) {
    return this.bridger.getBridge(t, n);
  }
}, Ca = Pt.string();
Pt.number().parse(or.CHAIN_ID || 355113);
Ca.parse(or.RPC_URL || "http://127.0.0.1:8545");
Ca.parse(or.IC_HOST || "http://127.0.0.1:4943");
Ca.optional().parse(or.FEE_CHARGE_ADDRESS);
Ca.optional().parse(or.ICRC2_MINTER_CANISTER_ID);
Ca.optional().parse(or.ICRC2_TOKEN_CANISTER_ID);
Ca.optional().parse(or.BTC_BRIDGE_CANISTER_ID);
Ca.optional().parse(or.RUNE_BRIDGE_CANISTER_ID);
Ca.optional().parse(or.RUNE_TOKEN_ID);
Ca.optional().parse(or.BFT_ETH_ADDRESS);
Ca.optional().parse(or.BTC_TOKEN_WRAPPED_ADDRESS);
var TB = { npm_package_exports___require: "./dist/index.cjs", npm_config_version_commit_hooks: "true", npm_config_user_agent: "yarn/1.22.22 npm/? node/v20.15.1 linux x64", CI: "true", npm_package_bugs_url: "https://github.com/bitfinity-network/bitbridge/issues", npm_config_bin_links: "true", npm_node_execpath: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", npm_package_devDependencies_vite: "^5.2.0", npm_config_init_version: "1.0.0", npm_package_peerDependencies_react: "^18.2.0", npm_package_devDependencies__tanstack_react_query_devtools: "^5.24.0", npm_package_dependencies_wagmi: "^2.8.1", npm_package_files_0: "dist", npm_package_publishConfig_access: "public", HOME: "/home/runner", npm_package_devDependencies__typescript_eslint_parser: "^7.2.0", npm_package_dependencies_ethers: "^6.12.1", npm_package_dependencies_framer_motion: "^11.1.9", npm_config_init_license: "MIT", YARN_WRAP_OUTPUT: "false", npm_package_dependencies__rainbow_me_rainbowkit: "^2.0.7", npm_config_version_tag_prefix: "v", npm_package_devDependencies_vite_plugin_dts: "^3.9.1", npm_package_dependencies_react_icons: "^5.2.1", npm_package_devDependencies_eslint_plugin_react_hooks: "^4.6.0", npm_package_dependencies_dotenv: "^16.4.5", npm_package_devDependencies_typescript: "^5.2.2", npm_package_dependencies__dfinity_agent: "^1.2.0", npm_package_description: "The React UI for the Bitfinity EVM bridge", npm_package_readmeFilename: "README.md", npm_package_devDependencies__types_react_dom: "^18.2.22", npm_package_devDependencies_vite_plugin_mix: "^0.4.0", npm_package_types: "./dist/index.d.ts", npm_package_homepage: "https://github.com/bitfinity-network/bitbridge", npm_package_scripts_dev: "vite", npm_package_devDependencies__vitejs_plugin_react: "^4.2.1", npm_package_type: "module", npm_package_devDependencies_vite_plugin_node_polyfills: "^0.22.0", npm_package_dependencies__tanstack_query_sync_storage_persister: "^5.22.2", npm_package_dependencies__emotion_react: "^11.11.4", npm_package_module: "./dist/index.js", npm_package_devDependencies__typescript_eslint_eslint_plugin: "^7.2.0", npm_package_scripts_lint: "eslint . --ext ts,tsx --report-unused-disable-directives --max-warnings 0", npm_config_registry: "https://registry.yarnpkg.com", npm_package_devDependencies_eslint_plugin_react_refresh: "^0.4.6", npm_package_exports___import: "./dist/index.js", npm_config_ignore_scripts: "", npm_package_dependencies__bitfinity_network_bitfinitywallet: "^0.3.0", npm_package_author_email: "support@infinityswap.one", PATH: "/tmp/yarn--1722436032859-0.7268831613784328:/home/runner/work/bitbridge/bitbridge/packages/widget/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/tmp/yarn--1722436018550-0.027432302051107138:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/home/runner/work/bitbridge/bitbridge/node_modules/.bin:/opt/hostedtoolcache/node/20.15.1/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/20.15.1/x64/bin:/snap/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", NODE: "/opt/hostedtoolcache/node/20.15.1/x64/bin/node", TURBO_HASH: "4c69888b02b3c09f", npm_package_name: "@bitfinity-network/bridge-widget", npm_package_dependencies_viem: "2.x", npm_package_dependencies__particle_network_btc_connectkit: "^1.0.0-alpha.25", LANG: "C.UTF-8", npm_package_devDependencies_eslint: "^8.57.0", npm_lifecycle_script: "tsc && vite build", npm_package_main: "./dist/index.cjs", npm_config_version_git_message: "v%s", npm_lifecycle_event: "build", npm_package_devDependencies__types_react: "^18.2.66", npm_package_version: "1.3.0", npm_config_argv: '{"remain":[],"cooked":["run","build"],"original":["run","build"]}', npm_package_dependencies__bitfinity_network_bridge: "*", npm_package_scripts_build: "tsc && vite build", npm_package_peerDependencies_react_dom: "^18.2.0", npm_package_dependencies__tanstack_react_query: "^5.35.1", npm_config_version_git_tag: "true", npm_config_version_git_sign: "", npm_package_license: "MIT", npm_config_strict_ssl: "true", npm_package_dependencies__chakra_ui_react: "^2.8.2", PWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_execpath: "/usr/local/lib/node_modules/yarn/bin/yarn.js", npm_package_dependencies__emotion_styled: "^11.11.5", npm_package_author_url: "https://bitfinity.network/", npm_package_author_name: "Bitfinity", npm_package_dependencies_react_spring_bottom_sheet: "3.5.0-alpha.0", npm_config_save_prefix: "^", npm_config_ignore_optional: "", npm_package_scripts_preview: "vite preview", npm_package_dependencies_vite_plugin_svgr: "^4.2.0", INIT_CWD: "/home/runner/work/bitbridge/bitbridge/packages/widget", npm_package_dependencies__tanstack_react_query_persist_client: "^5.22.2", NODE_ENV: "production" };
const aMe = "https://chromewebstore.google.com/detail/bitfinity-wallet/jnldfbidonfeldmalbflbmlebbipcnle", Ki = Pt.coerce.boolean().default(!1).parse(TB.IS_DEV), cMe = Ki ? "" : "https://raw.githubusercontent.com/infinity-swap/token-lists/main/src", lMe = [
  nMe.parse({
    url: `${cMe}/networks.json`,
    ttl: Ki ? 0 : void 0
  })
], l3 = "https://raw.githubusercontent.com/infinity-swap/token-lists/main/src", uMe = `${l3}/tokenlist.json`, dMe = `${l3}/tokenlist.testnet.json`, fMe = `${l3}/evm.tokenlist.json`, hMe = `${l3}/evm.tokenlist.testnet.json`, pMe = Ki ? [
  {
    name: "devnet",
    icUrl: "/tokenlist.json",
    ethUrl: "/evm.tokenlist.json"
  }
] : [
  {
    name: "mainnet",
    icUrl: uMe,
    ethUrl: fMe
  },
  {
    name: "testnet",
    icUrl: dMe,
    ethUrl: hMe
  }
], mMe = Pt.string().default("http://127.0.0.1:4943").parse(TB.IC_HOST), gMe = Pt.string().default("http://127.0.0.1:8545").parse(TB.RPC_URL), L6 = {
  name: "Bitfinity",
  symbol: "BFT",
  decimals: 18
}, OFe = Ki ? [
  {
    id: 355113,
    name: "Bitfinity Devnet",
    nativeCurrency: L6,
    rpcUrls: {
      public: { http: [mMe] },
      default: { http: [gMe] }
    }
  }
] : [
  {
    id: 355113,
    name: "Bitfinity Testnet",
    nativeCurrency: L6,
    rpcUrls: {
      public: { http: ["https://testnet.bitfinity.network"] },
      default: { http: ["https://testnet.bitfinity.network"] }
    }
  },
  {
    id: 355110,
    name: "Bitfinity Mainnet",
    nativeCurrency: L6,
    rpcUrls: {
      public: { http: ["https://mainnet.bitfinity.network"] },
      default: { http: ["https://mainnet.bitfinity.network"] }
    }
  }
], _Y = (e, t = 4, n = 4) => {
  if (e) {
    const r = e.slice(0, t), i = e.slice(-n);
    return `${r}...${i}`;
  }
  return "";
}, SY = (e, t) => BigInt(Math.round(Number(e) * 10 ** Number(t ?? 0))), yMe = (e) => {
  const t = (r) => {
    const i = n();
    localStorage.setItem(e, JSON.stringify({ ...i, ...r }));
  }, n = () => {
    if (typeof localStorage > "u")
      return {};
    try {
      return JSON.parse(localStorage.getItem(e) || "{}");
    } catch {
      return {};
    }
  };
  return {
    setStorageItems: t,
    getStorage: n
  };
}, { setStorageItems: yx, getStorage: CY } = yMe("bitbridge"), TY = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='100%25'%20height='100%25'%20fill='url(%23pattern0)'/%3e%3cdefs%3e%3cpattern%20id='pattern0'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_229_2'%20transform='scale(0.00362319)'/%3e%3c/pattern%3e%3cimage%20id='image0_229_2'%20width='276'%20height='276'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", vk = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M23.6397%2014.9029C22.0371%2021.3315%2015.5259%2025.2438%209.0965%2023.6407C2.6698%2022.038%20-1.24254%2015.5265%200.360847%209.09837C1.96283%202.66903%208.47399%20-1.24361%2014.9014%200.359081C21.3303%201.96177%2025.2424%208.47404%2023.6396%2014.903L23.6397%2014.9029H23.6397Z'%20fill='%23F7931A'/%3e%3cpath%20d='M17.2915%2010.2903C17.5304%208.6934%2016.3146%207.83498%2014.6521%207.26233L15.1914%205.09914L13.8746%204.77103L13.3496%206.87726C13.0034%206.79092%2012.6479%206.70957%2012.2945%206.62892L12.8234%204.50878L11.5074%204.18066L10.9678%206.34315C10.6813%206.27793%2010.3999%206.21347%2010.1269%206.14554L10.1285%206.13874L8.31258%205.68528L7.96229%207.09171C7.96229%207.09171%208.93925%207.31565%208.91866%207.32943C9.45189%207.46252%209.54832%207.81551%209.53231%208.09529L8.91796%2010.5597C8.95467%2010.569%209.0023%2010.5825%209.05486%2010.6036C9.01092%2010.5927%208.96417%2010.5808%208.91567%2010.5692L8.05455%2014.0214C7.98939%2014.1834%207.82398%2014.4266%207.45117%2014.3342C7.46437%2014.3534%206.4941%2014.0954%206.4941%2014.0954L5.84033%2015.6027L7.55394%2016.0299C7.87272%2016.1098%208.18512%2016.1935%208.49277%2016.2721L7.94786%2018.4601L9.26314%2018.7883L9.80276%2016.6235C10.1621%2016.721%2010.5108%2016.811%2010.8522%2016.8958L10.3144%2019.0504L11.6312%2019.3785L12.1761%2017.1946C14.4215%2017.6196%2016.1099%2017.4482%2016.8205%2015.4172C17.3932%2013.7821%2016.792%2012.8389%2015.6107%2012.2238C16.4711%2012.0254%2017.1192%2011.4595%2017.292%2010.2905L17.2916%2010.2902L17.2915%2010.2903ZM14.2829%2014.5091C13.876%2016.1443%2011.1229%2015.2604%2010.2302%2015.0387L10.9533%2012.14C11.8459%2012.3628%2014.7083%2012.8038%2014.283%2014.5091H14.2829ZM14.6902%2010.2666C14.319%2011.754%2012.0275%2010.9984%2011.2842%2010.8131L11.9397%208.1841C12.6831%208.36939%2015.0769%208.71522%2014.6903%2010.2666H14.6902Z'%20fill='white'/%3e%3c/svg%3e", bMe = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_140_1173)'%3e%3cpath%20d='M23.6397%2014.9029C22.0371%2021.3315%2015.5259%2025.2438%209.0965%2023.6407C2.6698%2022.038%20-1.24254%2015.5265%200.360847%209.09837C1.96283%202.66903%208.47399%20-1.24361%2014.9014%200.359081C21.3303%201.96177%2025.2424%208.47404%2023.6396%2014.903L23.6397%2014.9029H23.6397Z'%20fill='%23343D4B'/%3e%3cpath%20d='M17.1421%206.99902C16.0266%206.99902%2014.8051%207.60697%2013.5167%208.80613C12.9088%209.36945%2012.3733%209.98298%2011.9829%2010.4682C11.9829%2010.4682%2012.6076%2011.1877%2013.2936%2011.963C13.6673%2011.4945%2014.1972%2010.8586%2014.8163%2010.2842C15.9597%209.21328%2016.707%208.99576%2017.1365%208.99576C18.7428%208.99576%2020.0479%2010.3455%2020.0479%2012.0132C20.0479%2013.6641%2018.7428%2015.0139%2017.1365%2015.0306C17.0584%2015.0306%2016.9692%2015.0194%2016.8576%2014.9971C17.3261%2015.2147%2017.8337%2015.3708%2018.3078%2015.3708C21.2527%2015.3708%2021.8327%2013.335%2021.8662%2013.19C21.9499%2012.8163%2022.0001%2012.4259%2022.0001%2012.0243C21.9945%209.25233%2019.8193%206.99902%2017.1421%206.99902Z'%20fill='url(%23paint0_linear_140_1173)'/%3e%3cpath%20d='M6.85139%2017.0273C7.96689%2017.0273%209.18836%2016.4194%2010.4768%2015.2202C11.0847%2014.6569%2011.6201%2014.0434%2012.0106%2013.5581C12.0106%2013.5581%2011.3859%2012.8386%2010.6999%2012.0634C10.3262%2012.5319%209.7963%2013.1677%209.1772%2013.7422C8.03382%2014.8019%207.28086%2015.0306%206.85697%2015.0306C5.25066%2015.0306%203.94553%2013.6808%203.94553%2012.0132C3.94553%2010.3622%205.25066%209.01249%206.85697%208.99576C6.93506%208.99576%207.02429%209.00691%207.13584%209.02922C6.66734%208.8117%206.15979%208.65553%205.6857%208.65553C2.74079%208.64995%202.16073%2010.6857%202.12727%2010.8363C2.04361%2011.21%201.99341%2011.6004%201.99341%2012.002C1.99341%2014.774%204.16863%2017.0273%206.85139%2017.0273Z'%20fill='url(%23paint1_linear_140_1173)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.09358%2010.3288C8.77009%2010.0164%207.19724%208.7392%205.69132%208.69458C3.00297%208.62765%202.21655%2010.5798%202.14404%2010.8308C2.66275%208.64438%204.5814%207.01018%206.85701%206.99902C8.71431%206.99902%2010.5939%208.82286%2011.9827%2010.4682L11.9883%2010.4626C11.9883%2010.4626%2012.613%2011.1821%2013.299%2011.9574C13.299%2011.9574%2014.0799%2012.8777%2014.9053%2013.6864C15.2288%2013.9988%2016.7961%2015.2593%2018.302%2015.3039C21.0629%2015.382%2021.827%2013.3183%2021.866%2013.1621C21.3585%2015.3652%2019.4342%2017.005%2017.1475%2017.0162C15.2902%2017.0162%2013.4106%2015.1923%2012.0162%2013.547C12.0162%2013.5526%2012.0106%2013.5526%2012.0106%2013.5581C12.0106%2013.5581%2011.3859%2012.8386%2010.6999%2012.0634C10.7055%2012.0634%209.92463%2011.1375%209.09358%2010.3288ZM2.14404%2010.8531C2.14404%2010.8475%202.14404%2010.8419%202.14962%2010.8363C2.14404%2010.8419%202.14404%2010.8475%202.14404%2010.8531Z'%20fill='%2329ABE2'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_140_1173'%20x1='14.531'%20y1='7.79361'%20x2='21.407'%20y2='14.7262'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.21'%20stop-color='%23F15A24'/%3e%3cstop%20offset='0.6841'%20stop-color='%23FBB03B'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_140_1173'%20x1='9.46423'%20y1='16.2339'%20x2='2.58826'%20y2='9.30132'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.21'%20stop-color='%23ED1E79'/%3e%3cstop%20offset='0.8929'%20stop-color='%23522785'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_140_1173'%3e%3crect%20width='24'%20height='24'%20rx='12'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", vMe = {
  tokensListed: [],
  tokensListsPending: !1,
  tokensListsError: !1
}, kY = dn(vMe), BY = Pt.object({
  logo: Pt.string(),
  decimals: Pt.coerce.number(),
  name: Pt.string(),
  symbol: Pt.string()
}), wMe = BY.extend({
  id: Pt.string(),
  fee: Pt.coerce.number(),
  standard: Pt.string()
}), xMe = BY.extend({
  address: Pt.string()
}), AMe = Pt.union([wMe, xMe]), EMe = Pt.object({
  tokens: Pt.array(AMe)
});
async function IY(e) {
  const t = await fetch(e);
  if (!t.ok)
    throw new Error(`Http error: ${t.status}`);
  const n = await t.json();
  return EMe.parse(n).tokens;
}
const _Me = async (e) => {
  const t = await IY(e), n = ["icrc1", "icrc2", "icp"];
  return t.filter(({ standard: r }) => n.includes(r.toLowerCase())).map((r) => ({
    id: r.id,
    name: r.name,
    symbol: r.symbol,
    decimals: r.decimals,
    fee: r.fee,
    type: "icrc",
    logo: r.logo
  }));
}, SMe = async (e) => (await IY(e)).map((n) => ({
  id: n.address,
  name: n.name,
  symbol: n.symbol,
  decimals: n.decimals,
  fee: 0,
  type: "evmc",
  logo: n.logo
})), CMe = ({
  children: e,
  tokensListed: t,
  network: n,
  listsUrls: r
}) => {
  const i = uw({
    queries: r.filter(({ name: l }) => l === n).flatMap((l) => [
      { type: "ic", url: l.icUrl },
      { type: "eth", url: l.ethUrl }
    ]).map(({ url: l, type: u }) => ({
      queryKey: ["token-lists", l],
      queryFn: () => u === "ic" ? _Me(l) : SMe(l),
      staleTime: Ki ? 0 : 6e4,
      gcTime: Ki ? 0 : void 0
    }))
  }), s = i.map((l) => l.data).filter((l) => !!l).flat(), o = i.some((l) => l.isLoading), a = i.some((l) => l.isError), c = ot(() => ({
    tokensListed: s.concat(t),
    tokensListsPending: o,
    tokensListsError: a
  }), [s, o, a, t]);
  return /* @__PURE__ */ D.jsx(kY.Provider, { value: c, children: e });
}, PY = () => $e(kY), z6 = Object.values(AY.enum), TMe = ["eth", "btc", "ic"], Cs = {
  eth: {
    name: "BITFINITY EVM",
    logo: TY,
    symbol: "evmc"
  },
  btc: {
    name: "BITCOIN",
    logo: vk,
    symbol: "btc"
  },
  ic: {
    name: "INTERNET COMPUTER",
    logo: bMe,
    symbol: "ic"
  }
}, kMe = {
  icrc_evm: {
    logo: TY
  },
  btc_evm: {
    logo: vk
  },
  rune_evm: {
    logo: vk
  }
}, OY = {
  bridgesReady: {},
  wallets: [],
  bridges: [],
  bridgeNetworks: []
}, NY = dn(OY), BMe = async (e) => {
  const { addedAssets: t = [] } = CY();
  if (!t.some((n) => n === e.address))
    try {
      await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: e
        }
      }), t.push(e.address), yx({ addedAssets: t });
    } catch {
    }
}, IMe = ({
  onConnect: e,
  onDisconnect: t,
  onChain: n
}) => {
  const r = mi(), i = r.status, { connect: s } = vD(), { disconnect: o } = DA(), { openConnectModal: a, connectModalOpen: c } = gL(), l = Ie(() => {
    var d;
    (d = window.ethereum) != null && d.isBitfinityWallet ? s({ connector: t5() }) : a == null || a();
  }, [a, s]), u = Ie(() => {
    o();
  }, [o]);
  return We(() => {
    if (i !== "connecting") {
      if (i === "disconnected") {
        t();
        return;
      }
      i === "connected" && (async () => {
        const d = new NRe(
          await r.connector.getProvider()
        ), f = await d.getSigner();
        e(f, d, r.address, r.chainId);
      })();
    }
  }, [
    i,
    r.address,
    r.chainId,
    r.connector,
    e,
    t
  ]), We(() => {
    i === "connected" && r.chainId && n(r.chainId);
  }, [i, r.chainId, n]), {
    ethWalletConnect: l,
    ethWalletDisconnect: u,
    ethPending: c
  };
}, PMe = (e, {
  onConnect: t,
  onDisconnect: n
}) => {
  const r = Le(!1), [i, s] = qe(!1), o = Ie(async () => {
    if (!(window.ic && window.ic.bitfinityWallet)) {
      window.open(aMe);
      return;
    }
    s(!0), await t(window.ic.bitfinityWallet), yx({ icConnected: !0 }), s(!1);
  }, [t]), a = Ie(async () => {
    await window.ic.bitfinityWallet.disconnect(), await n(), yx({ icConnected: !1 });
  }, [n]);
  return We(() => {
    if (!e || r.current)
      return;
    r.current = !0;
    const { icConnected: c } = CY();
    window.ic ? c && t(window.ic.bitfinityWallet).then(() => {
    }) : yx({ icConnected: !1 });
  }, [e, t]), {
    icWalletConnect: o,
    icWalletDisconnect: a,
    icPending: i
  };
}, OMe = ({
  onConnect: e,
  onDisconnect: t
}) => {
  const { openConnectModal: n, disconnect: r } = gZ(), { accounts: i } = yZ(), s = Le(!1);
  return We(() => {
    if (i.length) {
      if (s.current)
        return;
      s.current = !0, e(i[0]);
    }
  }, [i, e]), {
    btcWalletConnect: () => {
      s.current = !1, n();
    },
    btcWalletDisconnect: () => {
      r(), t();
    },
    btcPending: !1
  };
}, NMe = ({
  network: e,
  networks: t,
  networkUrls: n,
  children: r
}) => {
  const { tokensListed: i } = PY(), [s, o] = qe(!1), [a, c] = qe(
    {}
  ), l = Le(!1), [u, d] = qe(!1), [f, p] = qe(e), m = ot(() => {
    const U = oMe.create();
    return U.addNetworks(t), U;
  }, [t]), [h, g] = qe(!1), [y, v] = qe([]), { ethWalletConnect: b, ethWalletDisconnect: w, ethPending: A } = IMe(
    ot(() => ({
      onConnect(U, q, G, ae) {
        c((ge) => ({
          ...ge,
          eth: {
            wallet: U,
            provider: q,
            address: G,
            watchAsset: BMe,
            chain: ae
          }
        })), m.connectEthWallet(U);
      },
      onDisconnect() {
        c((U) => ({ ...U, eth: void 0 })), m.disconnectEthWallet();
      },
      onChain(U) {
        c((q) => !q.eth || q.eth.chain === U ? q : { ...q, eth: { ...q.eth, chain: U } });
      }
    }), [m])
  ), { icWalletConnect: E, icWalletDisconnect: x, icPending: S } = PMe(
    !!i.length && u,
    ot(() => ({
      async onConnect(U) {
        const q = i.map((ae) => {
          if (ae.type === "icrc")
            return ae.id;
        }).filter((ae) => !!ae).concat(m.icWhiteList()).filter((ae, ge, Ae) => Ae.indexOf(ae) === ge);
        await U.requestConnect({ whitelist: q });
        const G = await U.getPrincipal();
        c((ae) => ({
          ...ae,
          ic: { wallet: U, address: G.toText() }
        })), m.connectBitfinityWallet(U);
      },
      async onDisconnect() {
        m.disconnectBitfinityWallet(), c((U) => ({ ...U, ic: void 0 }));
      }
    }), [m, i])
  ), { btcWalletConnect: P, btcWalletDisconnect: I, btcPending: R } = OMe(
    ot(() => ({
      onConnect(U) {
        c((q) => ({
          ...q,
          btc: {
            wallet: !0,
            address: U
          }
        }));
      },
      onDisconnect() {
        c((U) => ({ ...U, btc: void 0 }));
      }
    }), [])
  ), Q = ot(() => TMe.map((U) => {
    var _e;
    const q = !!a[U], G = a[U], ae = (G == null ? void 0 : G.address) || "", ge = Cs[U], Ae = () => {
      U === "eth" ? a.eth ? w() : b() : U === "ic" ? a.ic ? x().then(() => {
      }) : E().then(() => {
      }) : U === "btc" && (a.btc ? I() : P());
    }, he = G && "provider" in G ? G.provider : void 0, B = G && "watchAsset" in G ? G.watchAsset : void 0, be = (_e = y.find(
      ({ name: Ce }) => Ce === f
    )) == null ? void 0 : _e.ethChain, Be = G && "chain" in G ? G.chain : void 0, Ne = U === "eth" ? be === Be ? void 0 : be : void 0;
    return {
      type: U,
      connected: q,
      wallet: G == null ? void 0 : G.wallet,
      provider: he,
      watchAsset: B,
      chainMatch: Ne,
      address: ae,
      toggle: Ae,
      ...ge
    };
  }), [
    a,
    b,
    w,
    E,
    x,
    P,
    I,
    y,
    f
  ]), J = ot(() => {
    const U = y.find((G) => G.name === f), q = [];
    if (!U)
      return q;
    if (a.ic && a.eth) {
      const G = a.eth.chain;
      if (U.ethChain === G) {
        const ae = m.getBridge(f, "icrc_evm");
        q.push({ type: "icrc_evm", bridge: ae, ...kMe.icrc_evm });
      }
    }
    return a.btc && a.eth, a.btc && a.eth, q;
  }, [m, y, a, f]), we = Ie((U) => {
    p(U);
  }, []), V = S || A || R;
  We(() => {
    l.current || (l.current = !0, (async () => (await m.fetch(n), v(m.getNetworks()), d(!0)))());
  }, [m, l, n]);
  const L = ot(() => ({
    ...OY,
    bridges: J,
    networkName: f,
    walletsConnected: a,
    wallets: Q,
    walletsOpen: s,
    networksOpen: h,
    isWalletConnectionPending: V,
    bridgeNetworks: y,
    switchNetwork: we,
    setWalletsOpen: o,
    setNetworksOpen: g
  }), [
    J,
    f,
    a,
    Q,
    s,
    h,
    y,
    we,
    V
  ]);
  return /* @__PURE__ */ D.jsx(NY.Provider, { value: L, children: r });
}, Vv = () => $e(NY);
var RMe = ["added", "removed", "updated"];
function nF(e) {
  return RMe.includes(e);
}
async function MMe({
  queryClient: e,
  persister: t,
  maxAge: n = 1e3 * 60 * 60 * 24,
  buster: r = "",
  hydrateOptions: i
}) {
  try {
    const s = await t.restoreClient();
    if (s)
      if (s.timestamp) {
        const o = Date.now() - s.timestamp > n, a = s.buster !== r;
        o || a ? t.removeClient() : Vne(e, s.clientState, i);
      } else
        t.removeClient();
  } catch {
    t.removeClient();
  }
}
async function rF({
  queryClient: e,
  persister: t,
  buster: n = "",
  dehydrateOptions: r
}) {
  const i = {
    buster: n,
    timestamp: Date.now(),
    clientState: zne(e, r)
  };
  await t.persistClient(i);
}
function FMe(e) {
  const t = e.queryClient.getQueryCache().subscribe((r) => {
    nF(r.type) && rF(e);
  }), n = e.queryClient.getMutationCache().subscribe((r) => {
    nF(r.type) && rF(e);
  });
  return () => {
    t(), n();
  };
}
var jMe = ({
  client: e,
  children: t,
  persistOptions: n,
  onSuccess: r,
  ...i
}) => {
  const [s, o] = ye.useState(!0), a = ye.useRef({ persistOptions: n, onSuccess: r }), c = ye.useRef(!1);
  return ye.useEffect(() => {
    a.current = { persistOptions: n, onSuccess: r };
  }), ye.useEffect(() => {
    const l = {
      ...a.current.persistOptions,
      queryClient: e
    };
    return c.current || (c.current = !0, o(!0), MMe(l).then(async () => {
      var u, d;
      try {
        await ((d = (u = a.current).onSuccess) == null ? void 0 : d.call(u));
      } finally {
        o(!1);
      }
    })), s ? void 0 : FMe(l);
  }, [e, s]), /* @__PURE__ */ D.jsx(Hne, { client: e, ...i, children: /* @__PURE__ */ D.jsx(Wne, { value: s, children: t }) });
};
function iF() {
}
function DMe({
  storage: e,
  key: t = "REACT_QUERY_OFFLINE_CACHE",
  throttleTime: n = 1e3,
  serialize: r = JSON.stringify,
  deserialize: i = JSON.parse,
  retry: s
}) {
  if (e) {
    const o = (a) => {
      try {
        e.setItem(t, r(a));
        return;
      } catch (c) {
        return c;
      }
    };
    return {
      persistClient: UMe((a) => {
        let c = a, l = o(c), u = 0;
        for (; l && c; )
          u++, c = s == null ? void 0 : s({
            persistedClient: c,
            error: l,
            errorCount: u
          }), c && (l = o(c));
      }, n),
      restoreClient: () => {
        const a = e.getItem(t);
        if (a)
          return i(a);
      },
      removeClient: () => {
        e.removeItem(t);
      }
    };
  }
  return {
    persistClient: iF,
    restoreClient: () => {
    },
    removeClient: iF
  };
}
function UMe(e, t = 100) {
  let n = null, r;
  return function(...i) {
    r = i, n === null && (n = setTimeout(() => {
      e(...r), n = null;
    }, t));
  };
}
var LMe = function() {
  return null;
};
const zMe = {
  persister: DMe({
    storage: window.localStorage
  })
}, bx = 1e3 * 60 * 8, wk = new Pne({
  defaultOptions: {
    queries: {
      gcTime: bx,
      staleTime: 1 / 0,
      refetchOnWindowFocus: !1
    }
  }
}), VMe = ({ children: e }) => /* @__PURE__ */ D.jsxs(
  jMe,
  {
    client: wk,
    persistOptions: zMe,
    children: [
      e,
      Ki ? /* @__PURE__ */ D.jsx(LMe, {}) : null
    ]
  }
), HMe = {
  tokens: [],
  async bridge() {
    return { status: "err" };
  },
  isBridgingInProgress: !1,
  nativeEthBalance: 0n,
  selectedToken: void 0,
  setSelectedToken() {
  }
}, RY = dn(HMe), V6 = {
  tokensPairs: {
    staleTime: Ki ? 0 : 60 * 1e3,
    gcTime: Ki ? 0 : bx
  },
  tokensUnlistedInfo: {
    staleTime: Ki ? 0 : 60 * 1e3,
    gcTime: Ki ? 0 : bx
  },
  tokensBalances: {
    refetchOnWindowFocus: !0,
    refetchInterval: 5 * 1e3,
    staleTime: Ki ? 0 : 1e3,
    gcTime: Ki ? 0 : bx
  }
}, WMe = ({ children: e }) => {
  const [t, n] = qe(), { wallets: r, bridges: i } = Vv(), { tokensListed: s } = PY(), [o, a] = qe(!1), c = r.find(({ type: x }) => x === "eth"), l = r.find(({ type: x }) => x === "ic"), [u, d] = qe(0n), f = uw({
    queries: z6.map((x) => ({
      enabled: !!i.find((S) => S.type === x),
      queryKey: ["tokens", "pairs", x],
      queryFn: () => {
        var S;
        return (S = i.find((P) => P.type === x)) == null ? void 0 : S.bridge.getTokensPairs();
      },
      ...V6.tokensPairs
    }))
  }), p = ot(() => z6.map((x) => ({
    type: x,
    tokens: f[z6.indexOf(x)].data ?? []
  })), [f]), m = ot(() => {
    const x = p.reduce(
      (P, { tokens: I }) => P.concat(I.map((R) => R.wrapped)),
      []
    ), S = s.filter((P) => P.type === "evmc").map((P) => P.id);
    return x.filter(
      (P) => !S.some((I) => P === I)
    );
  }, [s, p]), g = uw({
    queries: m.map((x) => ({
      queryKey: ["tokens", "unlisted", "info", x],
      enabled: !!i.find(
        ({ type: S }) => {
          var P;
          return S === ((P = p.find(
            ({ tokens: I }) => I.find(({ wrapped: R }) => R === x)
          )) == null ? void 0 : P.type);
        }
      ),
      queryFn: async () => {
        const S = p.find(
          ({ tokens: J }) => J.find(({ wrapped: we }) => we === x)
        );
        if (!S)
          throw new Error("Unreached");
        const P = i.find(({ type: J }) => J === S.type);
        if (!P)
          throw new Error("Unreached");
        const { name: I, symbol: R, decimals: Q } = await P.bridge.getWrappedTokenInfo(x);
        return {
          id: x,
          name: I,
          symbol: R,
          decimals: Q,
          type: "evmc",
          fee: 0
        };
      },
      ...V6.tokensUnlistedInfo
    }))
  }).map((x) => x.data).filter((x) => !!x), y = ot(() => {
    const x = [];
    return s.concat(g).map((S) => {
      var P;
      if (S.type === "evmc") {
        const I = p.find(({ tokens: R }) => R.some(({ wrapped: Q }) => Q === S.id));
        if (I) {
          const R = I.tokens.find(
            ({ wrapped: J }) => J === S.id
          );
          let Q;
          S.logo || (Q = (P = s.find(({ id: J }) => J === (R == null ? void 0 : R.base))) == null ? void 0 : P.logo), x.push({
            ...S,
            type: "evmc",
            wallet: "eth",
            bridge: I.type,
            id: S.id,
            wrapped: R ? R.base : void 0,
            balance: 0n,
            logo: Q
          });
        }
      }
      if (S.type === "icrc") {
        const I = p.filter(({ type: R }) => R === "icrc_evm").map(({ tokens: R }) => R).flat().find(({ base: R }) => R === S.id);
        x.push({
          ...S,
          type: "icrc",
          wallet: "ic",
          bridge: "icrc_evm",
          id: S.id,
          wrapped: I ? I.wrapped : void 0,
          balance: 0n
        });
      }
    }), x;
  }, [s, g, p]), b = uw({
    queries: y.filter((x) => x.id === t).map((x) => ({
      enabled: !!t && !!i.find((S) => S.type === x.bridge) && !!(c || l),
      queryKey: ["tokens", "balance", x.type, x.id],
      queryFn: async () => {
        var I;
        const S = (I = i.find(
          (R) => R.type === x.bridge
        )) == null ? void 0 : I.bridge;
        let P = 0n;
        return S && (x.type === "evmc" && c && (P = await S.getWrappedTokenBalance(
          x.id,
          c.address
        )), x.type === "icrc" && l && (P = await S.getBaseTokenBalance(
          x.id,
          l.address
        ))), {
          id: x.id,
          balance: P
        };
      },
      placeholder: { id: x.id, balance: 0n },
      ...V6.tokensBalances
    }))
  }).map((x) => x.data).filter((x) => !!x), w = ot(() => y.map((x) => {
    const S = b.find(
      (P) => P.id === x.id
    ) ?? {
      id: x.id,
      balance: 0n
    };
    return {
      ...x,
      ...S
    };
  }).filter((x) => !!x), [y, b]);
  We(() => {
    var S;
    const x = async () => {
      var P;
      try {
        const I = await ((P = c == null ? void 0 : c.provider) == null ? void 0 : P.getBalance(c == null ? void 0 : c.address)) ?? 0n;
        d(I);
      } catch {
        d(0n);
      }
    };
    return x(), (S = c == null ? void 0 : c.provider) == null || S.on("block", x), () => {
      var P;
      (P = c == null ? void 0 : c.provider) == null || P.off("block", x);
    };
  }, [c, c == null ? void 0 : c.provider, c == null ? void 0 : c.chainMatch]);
  const A = Ie(
    async (x, S) => {
      if (u <= 0)
        return { status: "err" };
      const P = x.type === "evmc", I = i.find((L) => L.type === x.bridge);
      if (!I)
        return { status: "err" };
      const { bridge: R } = I, Q = SY(S, x.decimals);
      if (x.balance <= Q)
        return { status: "err" };
      let J, we;
      if (x.type === "icrc" ? we = c == null ? void 0 : c.address : x.type === "evmc" && (we = l == null ? void 0 : l.address), x.type === "icrc" ? J = l == null ? void 0 : l.address : x.type === "evmc" && (J = c == null ? void 0 : c.address), !(we && J))
        return { status: "err" };
      a(!0);
      let V;
      try {
        if (P)
          await R.bridgeFromEvmc({
            wrappedToken: x.id,
            recipient: we,
            amount: Q
          });
        else {
          let L;
          if (x.wrapped || (L = await R.deployWrappedToken({
            id: x.id,
            name: x.name,
            symbol: x.symbol,
            decimals: x.decimals
          })), await R.bridgeToEvmc({
            token: x.id,
            recipient: we,
            owner: J,
            amount: Q
          }), c != null && c.watchAsset) {
            const U = w.find(({ id: G }) => G === x.wrapped);
            let q;
            U ? q = {
              address: U.id,
              symbol: U.symbol,
              image: U.logo || x.logo || "",
              decimals: Number(U.decimals)
            } : L && (q = {
              address: L,
              symbol: x.symbol,
              image: x.logo || "",
              decimals: Number(x.decimals)
            }), q && await c.watchAsset(q);
          }
          x.wrapped || await wk.invalidateQueries({
            queryKey: ["tokens", "pairs"]
          });
        }
      } catch (L) {
        console.error("Error while bridging", L), V = L;
      }
      return await wk.invalidateQueries({
        queryKey: ["tokens", "balance", x.type, x.id]
      }), a(!1), V ? { status: "err" } : { status: "ok" };
    },
    [c, l, i, u, w]
  ), E = ot(() => ({
    tokens: w,
    bridge: A,
    isBridgingInProgress: o,
    nativeEthBalance: u,
    selectedToken: t,
    setSelectedToken: n
  }), [
    w,
    A,
    o,
    u,
    t,
    n
  ]);
  return /* @__PURE__ */ D.jsx(RY.Provider, { value: E, children: e });
}, kB = () => $e(RY), H6 = {
  sm: {
    size: "24px",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "full"
  },
  lg: {
    size: "32px",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    borderRadius: "full"
  }
}, GMe = ({
  token: e,
  variant: t = "lg",
  isTruncated: n = !1,
  ...r
}) => {
  const i = `https://api.dicebear.com/7.x/initials/svg?seed=${e.name}`;
  return /* @__PURE__ */ D.jsxs(kn, { alignItems: "center", gap: "12px", ...r, children: [
    /* @__PURE__ */ D.jsx(
      ou,
      {
        src: e.logo || i,
        fallbackSrc: i,
        alt: e.name,
        h: H6[t].size,
        w: H6[t].size
      }
    ),
    /* @__PURE__ */ D.jsx(pi, { as: "span", isTruncated: n, ...H6[t], children: e.name.toLocaleUpperCase() })
  ] });
}, qMe = {
  icrc: "ic",
  btc: "btc",
  evmc: "eth",
  rune: "btc"
}, sF = (e) => e.trim().toLowerCase().replace(/-/g, "").replace(/^0x/, "");
function $Me({ isOpen: e, onClose: t }) {
  const [n, r] = qe(0), { tokens: i, setSelectedToken: s } = kB(), [o, a] = qe({}), c = ot(() => i.filter(({ type: m }) => qMe[m] === Object.keys(Cs)[n]), [i, n]), [l, u] = qe(""), d = ot(() => l.length ? c.filter(({ name: m, symbol: h, id: g }) => [m, h, g].some(
    (y) => sF(y).includes(sF(l))
  )) : c, [l, c]), f = Object.values(Cs).map(({ logo: m, symbol: h }) => /* @__PURE__ */ D.jsx(vW, { _selected: { color: "primary.main" }, children: /* @__PURE__ */ D.jsxs(kn, { gap: "12px", children: [
    /* @__PURE__ */ D.jsx(ou, { src: m, width: "24px", height: "24px", flexShrink: "0" }),
    /* @__PURE__ */ D.jsx(pi, { children: h.toUpperCase() })
  ] }) }, h)), p = Object.keys(Cs).map((m) => /* @__PURE__ */ D.jsxs(
    yW,
    {
      paddingX: "0",
      paddingY: 4,
      height: "300px",
      overflowY: "auto",
      children: [
        /* @__PURE__ */ D.jsx(
          NTe,
          {
            placeholder: "Search token",
            value: l,
            onChange: (h) => u(h.target.value),
            size: "xs",
            sx: {
              borderRadius: "12px",
              borderWidth: 1,
              borderColor: "bg.border",
              bg: "bg.module"
            }
          }
        ),
        /* @__PURE__ */ D.jsx(ks, { paddingTop: 4, children: /* @__PURE__ */ D.jsx(Q4, { gap: 2, flexWrap: "wrap", children: d.map(({ id: h, ...g }) => {
          const y = `https://api.dicebear.com/7.x/initials/svg?seed=${g.name}`;
          return /* @__PURE__ */ D.jsxs(
            oW,
            {
              isOpen: o[h] || !1,
              trigger: "hover",
              onClose: () => a((v) => ({ ...v, [h]: !1 })),
              onOpen: () => a((v) => ({ ...v, [h]: !0 })),
              children: [
                /* @__PURE__ */ D.jsx(sW, { children: /* @__PURE__ */ D.jsx(
                  ks,
                  {
                    borderWidth: 1,
                    borderColor: "secondary.alpha12",
                    borderRadius: "8px",
                    cursor: "pointer",
                    py: 3,
                    px: 3,
                    onClick: () => {
                      s(h), t();
                    },
                    _hover: {
                      bg: "bg.border"
                    },
                    children: /* @__PURE__ */ D.jsx(GMe, { token: { id: h, ...g }, variant: "sm" })
                  }
                ) }),
                /* @__PURE__ */ D.jsxs(uW, { width: "auto", children: [
                  /* @__PURE__ */ D.jsx(aW, { bg: "bg.popover" }),
                  /* @__PURE__ */ D.jsx(
                    cW,
                    {
                      bg: "bg.popover",
                      width: "auto",
                      borderRadius: "8px",
                      children: /* @__PURE__ */ D.jsxs(kn, { alignItems: "center", gap: "16px", padding: "8px", children: [
                        /* @__PURE__ */ D.jsx(
                          ou,
                          {
                            src: g.logo || y,
                            fallbackSrc: y,
                            alt: g.name,
                            h: "20px",
                            w: "20px"
                          }
                        ),
                        /* @__PURE__ */ D.jsx(pi, { as: "span", isTruncated: !0, color: "text.popover", children: _Y(h, 7, 5) }),
                        /* @__PURE__ */ D.jsx(
                          kn,
                          {
                            as: "button",
                            onClick: () => {
                              navigator.clipboard.writeText(h), a((v) => ({
                                ...v,
                                [h]: !1
                              }));
                            },
                            background: "bg.main",
                            width: "24px",
                            height: "24px",
                            padding: "8px",
                            borderRadius: "8px",
                            alignItems: "center",
                            justifyContent: "center",
                            _hover: {
                              bg: "bg.module"
                            },
                            children: /* @__PURE__ */ D.jsx(Pi, { as: u_e, color: "text.primary" })
                          }
                        )
                      ] })
                    }
                  )
                ] })
              ]
            },
            h
          );
        }) }) })
      ]
    },
    m
  ));
  return /* @__PURE__ */ D.jsx(
    kE,
    {
      modalHeaderProps: {
        title: "Select Token",
        iconPrefix: [MTe],
        onIconPrefixClick: [t],
        showCloseIcon: !1
      },
      isOpen: e,
      onClose: t,
      size: "lg",
      modalContentProps: {
        width: "500px",
        height: "auto",
        borderRadius: "20px",
        overflowY: "hidden"
      },
      children: /* @__PURE__ */ D.jsx(ks, { children: /* @__PURE__ */ D.jsx(ks, { py: 2, children: /* @__PURE__ */ D.jsxs(pW, { index: n, onChange: r, children: [
        /* @__PURE__ */ D.jsx(gW, { children: f }),
        /* @__PURE__ */ D.jsx(
          mW,
          {
            mt: "-1.5px",
            height: "2px",
            bg: "primary.main",
            borderRadius: "1px"
          }
        ),
        /* @__PURE__ */ D.jsx(bW, { padding: "0", children: p })
      ] }) }) })
    }
  );
}
const QMe = ({ token: e }) => {
  let t = Cs[e.wallet].logo, n = e.name;
  switch (e.type) {
    case "icrc":
      t = Cs.eth.logo, n = "ETH";
      break;
    case "evmc":
      t = Cs.ic.logo, n = "IC";
      break;
  }
  return /* @__PURE__ */ D.jsxs(kn, { gap: "8px", alignItems: "center", justifyContent: "space-between", children: [
    /* @__PURE__ */ D.jsx(ou, { src: t, width: "18px", height: "18px", flexShrink: "0" }),
    /* @__PURE__ */ D.jsx(pi, { textStyle: "body2", fontWeight: "bold", color: "secondary.white", children: n })
  ] });
}, KMe = ({ token: e, target: t }) => {
  let n = e.name, r = Cs[e.wallet].logo;
  switch (e.type) {
    case "icrc":
      n = "IC", r = t === "from" ? Cs.ic.logo : Cs.eth.logo;
      break;
    case "evmc":
      n = "ETH", r = t === "from" ? Cs.eth.logo : Cs.ic.logo;
      break;
  }
  return /* @__PURE__ */ D.jsxs(kn, { gap: "8px", alignItems: "center", justifyContent: "space-between", children: [
    /* @__PURE__ */ D.jsx(ou, { src: r, width: "18px", height: "18px", flexShrink: "0" }),
    /* @__PURE__ */ D.jsx(ks, { paddingRight: "8px", children: /* @__PURE__ */ D.jsx(pi, { textStyle: "body2", fontWeight: "bold", color: "secondary.white", children: n }) })
  ] });
}, oF = () => {
  const e = fxe(), { wallets: t, bridges: n, isWalletConnectionPending: r } = Vv(), {
    bridge: i,
    isBridgingInProgress: s,
    nativeEthBalance: o,
    tokens: a,
    selectedToken: c
  } = kB(), [l, u] = qe(!1), [d, f] = qe(""), p = a.find(({ id: A }) => A === c), m = n.length > 0, h = s || r, g = Ie(() => {
    u((A) => !A);
  }, []), y = ot(
    () => t.find((A) => A.type === "eth"),
    [t]
  ), v = ot(
    () => t.find((A) => A.type === "ic"),
    [t]
  ), b = Ie(async () => {
    if (!h && y) {
      if (!y.connected) {
        y.toggle();
        return;
      }
      if (!p) {
        e({
          title: "No tokens selected",
          description: "Please select a token to bridge",
          status: "error",
          duration: 9e3,
          isClosable: !0
        });
        return;
      }
      if (m) {
        const A = Number(d);
        if (o <= 0) {
          e({
            title: "You don't have enough BFT balance",
            description: "Please top up your balance",
            status: "error",
            duration: 9e3,
            isClosable: !0
          });
          return;
        }
        if (p.balance <= SY(A, p.decimals)) {
          e({
            title: "You don't have enough token balance",
            description: "Please top up your balance",
            status: "error",
            duration: 9e3,
            isClosable: !0
          });
          return;
        }
        if (A <= 0) {
          e({
            title: "Insufficient bridge amount",
            description: "Please select an amount to bridge",
            status: "error",
            duration: 9e3,
            isClosable: !0
          });
          return;
        }
        (await i(p, A)).status === "ok" ? e({
          title: "Bridged successfully",
          description: "You received your tokens!",
          status: "success",
          duration: 9e3,
          isClosable: !0
        }) : e({
          title: "Bridge error",
          description: "Your tokens was not bridged over",
          status: "error",
          duration: 9e3,
          isClosable: !0
        }), f("");
      } else
        p.type === "icrc" && !(v != null && v.connected) && (v == null || v.toggle());
    }
  }, [
    h,
    m,
    d,
    o,
    p,
    y,
    v,
    i,
    e
  ]), w = ot(() => {
    const A = {
      isDisabled: h,
      label: "Bridge"
    };
    return y && (y.connected ? p && p.type === "icrc" && !(v != null && v.connected) && (A.label = "Connect IC wallet") : A.label = "Connect to Bitfinity"), A;
  }, [h, y, v, p]);
  return /* @__PURE__ */ D.jsxs(ks, { minW: "auto", children: [
    /* @__PURE__ */ D.jsxs("form", { children: [
      /* @__PURE__ */ D.jsx(RTe, { children: /* @__PURE__ */ D.jsxs(kn, { width: "full", padding: 4, borderRadius: "9px", children: [
        /* @__PURE__ */ D.jsx(
          pE,
          {
            placeholder: "0.00",
            variant: "unstyled",
            type: "number",
            disabled: h || !m,
            value: d,
            onChange: (A) => f(A.target.value),
            size: "lg",
            maxWidth: "200px",
            bg: "bg.module",
            height: "36px",
            fontSize: "24px"
          }
        ),
        p ? /* @__PURE__ */ D.jsxs(
          kn,
          {
            gap: 4,
            flexShrink: "0",
            bg: "bg.main",
            paddingX: "8px",
            paddingY: "6px",
            borderRadius: "8px",
            onClick: g,
            cursor: "pointer",
            _hover: { bg: "misc.icon.hover" },
            children: [
              /* @__PURE__ */ D.jsxs(kn, { gap: 2, children: [
                /* @__PURE__ */ D.jsx(
                  ou,
                  {
                    src: p.logo,
                    width: "24px",
                    height: "24px",
                    flexShrink: "0"
                  }
                ),
                /* @__PURE__ */ D.jsx(
                  pi,
                  {
                    maxW: "50px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    children: p.symbol
                  }
                )
              ] }),
              /* @__PURE__ */ D.jsx(
                FH,
                {
                  orientation: "vertical",
                  width: "1.5px",
                  height: "20px",
                  bg: "bg.border"
                }
              ),
              /* @__PURE__ */ D.jsxs(
                kn,
                {
                  bg: "bg.module",
                  paddingX: "8px",
                  paddingY: "4px",
                  borderRadius: "6px",
                  children: [
                    /* @__PURE__ */ D.jsx(KMe, { token: p, target: "from" }),
                    /* @__PURE__ */ D.jsx(
                      Pi,
                      {
                        as: d_e,
                        fontSize: "16px",
                        color: "primary.main"
                      }
                    ),
                    /* @__PURE__ */ D.jsx(QMe, { token: p })
                  ]
                }
              )
            ]
          }
        ) : /* @__PURE__ */ D.jsx(
          _m,
          {
            onClick: g,
            variant: "outline",
            width: "auto",
            size: "sm",
            paddingX: "12px",
            paddingY: "8px",
            textTransform: "none",
            rightIcon: /* @__PURE__ */ D.jsx(
              Pi,
              {
                as: f_e,
                fontSize: "18px",
                color: "misc.icon.main"
              }
            ),
            children: "Select Token"
          }
        )
      ] }) }),
      s && /* @__PURE__ */ D.jsxs(
        kn,
        {
          width: "full",
          gap: "8px",
          padding: "12px",
          borderRadius: "12px",
          bg: "bg.module",
          marginBottom: "8px",
          children: [
            /* @__PURE__ */ D.jsx(fE, { color: "primary.main", size: "sm" }),
            /* @__PURE__ */ D.jsx(pi, { textStyle: "body", children: "Processing transaction..." })
          ]
        }
      ),
      /* @__PURE__ */ D.jsx(ks, { width: "full", pt: 2, children: /* @__PURE__ */ D.jsx(
        _m,
        {
          w: "full",
          isDisabled: w.isDisabled,
          onClick: b,
          size: "lg",
          children: w.label
        }
      ) })
    ] }),
    /* @__PURE__ */ D.jsx(
      $Me,
      {
        isOpen: l,
        onClose: () => u(!1)
      }
    )
  ] });
}, YMe = k.memo(({ wallet: e }) => {
  const { connected: t, logo: n, name: r, address: i, chainMatch: s, toggle: o } = e;
  return /* @__PURE__ */ D.jsxs(
    kn,
    {
      width: "full",
      paddingX: 4,
      paddingY: 2,
      justifyContent: "space-between",
      borderRadius: "8px",
      bg: "light.secondary.alpha4",
      children: [
        /* @__PURE__ */ D.jsxs(kn, { alignItems: "center", paddingY: 2, w: "full", children: [
          /* @__PURE__ */ D.jsx(ou, { src: n, alt: r, width: 10, height: 10 }),
          /* @__PURE__ */ D.jsxs(au, { alignItems: "flex-start", gap: "0", children: [
            /* @__PURE__ */ D.jsx(pi, { isTruncated: !0, textStyle: "h6", children: r }),
            t && s ? /* @__PURE__ */ D.jsxs(pi, { color: "error.500", textStyle: "body", children: [
              "Wrong chain, must be: ",
              e.chainMatch
            ] }) : /* @__PURE__ */ D.jsxs(pi, { color: "secondary.alpha72", textStyle: "body", children: [
              _Y(i),
              " "
            ] })
          ] })
        ] }),
        /* @__PURE__ */ D.jsx(
          _m,
          {
            variant: t ? "outline" : "solid",
            size: "md",
            onClick: o,
            disabled: t,
            children: t ? "Disconnect" : "Connect"
          }
        )
      ]
    }
  );
}), ZMe = () => {
  const { wallets: e, walletsOpen: t, setWalletsOpen: n } = Vv();
  return /* @__PURE__ */ D.jsx(
    kE,
    {
      modalHeaderProps: { title: "Manage Wallets" },
      isOpen: t,
      onClose: () => n(!1),
      size: "lg",
      modalContentProps: {
        width: "500px",
        height: "auto",
        borderRadius: "20px",
        overflowY: "hidden"
      },
      children: /* @__PURE__ */ D.jsx(
        au,
        {
          w: "full",
          paddingY: 4,
          gap: 4,
          marginTop: 4,
          borderTop: "1px solid",
          borderColor: "bg.border",
          children: /* @__PURE__ */ D.jsx(au, { width: "full", gap: "8px", children: e.map((r) => /* @__PURE__ */ D.jsx(YMe, { wallet: r }, r.type)) })
        }
      )
    }
  );
}, JMe = k.memo(
  ({ network: e, current: t, onSelect: n }) => {
    const r = Ie(
      () => n(e.name),
      [n, e.name]
    );
    return /* @__PURE__ */ D.jsxs(
      kn,
      {
        width: "full",
        paddingX: 4,
        paddingY: 2,
        justifyContent: "space-between",
        borderRadius: "8px",
        bg: "light.secondary.alpha4",
        children: [
          /* @__PURE__ */ D.jsx(kn, { alignItems: "center", paddingY: 2, w: "full", children: /* @__PURE__ */ D.jsx(au, { alignItems: "flex-start", gap: "0", children: /* @__PURE__ */ D.jsxs(kn, { children: [
            /* @__PURE__ */ D.jsx(ks, { w: "12px", h: "12px", bg: "primary.main", borderRadius: "full" }),
            /* @__PURE__ */ D.jsx(pi, { isTruncated: !0, textStyle: "h6", fontWeight: "bold", children: e.name })
          ] }) }) }),
          /* @__PURE__ */ D.jsx(
            _m,
            {
              variant: t ? "solid" : "outline",
              size: "md",
              onClick: r,
              disabled: t,
              children: t ? "Connected" : "Select"
            }
          )
        ]
      }
    );
  }
), XMe = () => {
  const {
    bridgeNetworks: e,
    networksOpen: t,
    setNetworksOpen: n,
    switchNetwork: r,
    networkName: i
  } = Vv();
  return /* @__PURE__ */ D.jsx(
    kE,
    {
      modalHeaderProps: { title: "Manage Networks" },
      isOpen: t,
      onClose: () => n(!1),
      size: "lg",
      modalContentProps: {
        width: "500px",
        height: "auto",
        borderRadius: "20px",
        overflowY: "hidden"
      },
      children: /* @__PURE__ */ D.jsx(
        au,
        {
          w: "full",
          paddingY: 4,
          gap: 4,
          marginTop: 4,
          borderTop: "1px solid",
          borderColor: "bg.border",
          children: /* @__PURE__ */ D.jsx(au, { width: "full", gap: "8px", children: e.map((s) => /* @__PURE__ */ D.jsx(
            JMe,
            {
              network: s,
              current: i === s.name,
              onSelect: r
            },
            s.name
          )) })
        }
      )
    }
  );
};
function eFe({ showWidgetModal: e }) {
  const [t, n] = qe(!1), {
    walletsOpen: r,
    setWalletsOpen: i,
    networksOpen: s,
    setNetworksOpen: o,
    isWalletConnectionPending: a
  } = Vv(), { isBridgingInProgress: c } = kB(), l = Ie(() => {
    n(!1);
  }, []), u = Ie(() => {
    n(!0);
  }, []), d = Ie(() => {
    o(!s);
  }, [s, o]), f = Ie(() => {
    i(!r);
  }, [r, i]), p = c || a;
  return /* @__PURE__ */ D.jsxs(Xd, { children: [
    /* @__PURE__ */ D.jsx(Q4, { justifyContent: "center", alignItems: "center", h: "90vh", children: e ? /* @__PURE__ */ D.jsxs(Xd, { children: [
      /* @__PURE__ */ D.jsx(_m, { onClick: u, children: "Bridge Now" }),
      /* @__PURE__ */ D.jsx(
        kE,
        {
          modalHeaderProps: {
            title: "Bridge Token",
            disableClose: p,
            iconSuffix: [dN, uN],
            onIconSuffixClick: [f, d]
          },
          isOpen: t,
          onClose: l,
          size: "lg",
          blockScrollOnMount: !0,
          closeOnOverlayClick: !1,
          modalContentProps: {
            width: "auto",
            height: "auto",
            borderRadius: "20px",
            overflowY: "hidden"
          },
          children: /* @__PURE__ */ D.jsx(oF, {})
        }
      )
    ] }) : /* @__PURE__ */ D.jsxs(
      au,
      {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "24px",
        border: "2px solid",
        borderColor: "bg.border",
        padding: "20px",
        children: [
          /* @__PURE__ */ D.jsxs(kn, { width: "full", justifyContent: "space-between", children: [
            /* @__PURE__ */ D.jsx(pi, { color: "brand.100", fontWeight: 600, fontSize: "20px", children: "Bridge Token" }),
            /* @__PURE__ */ D.jsxs(kn, { gap: "16px", children: [
              /* @__PURE__ */ D.jsx(
                Pi,
                {
                  height: "24px",
                  width: "24px",
                  onClick: f,
                  cursor: "pointer",
                  size: "48px",
                  as: dN,
                  color: "misc.icon.main",
                  _hover: {
                    color: "misc.icon.hover"
                  }
                }
              ),
              /* @__PURE__ */ D.jsx(
                Pi,
                {
                  height: "24px",
                  width: "24px",
                  onClick: d,
                  cursor: "pointer",
                  size: "48px",
                  as: uN,
                  color: "misc.icon.main",
                  _hover: {
                    color: "misc.icon.hover"
                  }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ D.jsx(oF, {})
        ]
      }
    ) }),
    /* @__PURE__ */ D.jsx(ZMe, {}),
    /* @__PURE__ */ D.jsx(XMe, {})
  ] });
}
const xk = {
  primary: {
    main: {
      default: "#247dfc",
      _dark: "#247dfc"
    },
    hover: {
      default: "#0a6fff",
      _dark: "#3186ff"
    },
    500: { default: "#3182CE", _dark: "#03FEFF" },
    alpha4: { default: "rgba(255, 255, 255, 0.04)" },
    alpha8: { default: "rgba(255, 255, 255, 0.08)" },
    alpha12: { default: "rgba(255, 255, 255, 0.12)" },
    alpha20: { default: "rgba(255, 255, 255, 0.20)" },
    alpha26: { default: "rgba(255, 255, 255, 0.26)" },
    alpha32: { default: "rgba(255, 255, 255, 0.32)" },
    alpha40: { default: "rgba(255, 255, 255, 0.40)" },
    alpha60: { default: "rgba(255, 255, 255, 0.60)" },
    alpha72: { default: "rgba(255, 255, 255, 0.72)" }
  },
  secondary: {
    main: { default: "#FFFFFF", _dark: "#FFFFFF" },
    alpha0: { default: "rgba(0, 0, 0, 0)", _dark: "rgba(255, 255, 255, 0)" },
    alpha4: {
      default: "rgba(0, 0, 0, 0.04)",
      _dark: "rgba(255, 255, 255, 0.04)"
    },
    alpha8: {
      default: "rgba(0, 0, 0, 0.08)",
      _dark: "rgba(255, 255, 255, 0.08)"
    },
    alpha12: {
      default: "rgba(0, 0, 0, 0.12)",
      _dark: "rgba(255, 255, 255, 0.12)"
    },
    alpha16: {
      default: "rgba(0, 0, 0, 0.16)",
      _dark: "rgba(255, 255, 255, 0.16)"
    },
    alpha20: {
      default: "rgba(0, 0, 0, 0.20)",
      _dark: "rgba(255, 255, 255, 0.20)"
    },
    alpha24: {
      default: "rgba(0, 0, 0, 0.24)",
      _dark: "rgba(255, 255, 255, 0.24)"
    },
    alpha32: {
      default: "rgba(0, 0, 0, 0.32)",
      _dark: "rgba(255, 255, 255, 0.32)"
    },
    alpha40: {
      default: "rgba(0, 0, 0, 0.40)",
      _dark: "rgba(255, 255, 255, 0.40)"
    },
    alpha60: {
      default: "rgba(0, 0, 0, 0.60)",
      _dark: "rgba(255, 255, 255, 0.60)"
    },
    alpha72: {
      default: "rgba(0, 0, 0, 0.72)",
      _dark: "rgba(255, 255, 255, 0.72)"
    }
  },
  success: {
    500: { default: "#05D7B7", _dark: "#05D7B7" }
  },
  error: {
    500: { default: "#fd4084", _dark: "#fd4084" }
  },
  gradients: {
    primary: {
      default: "linear-gradient(0deg, #03FEFF 0%, rgba(99, 179, 237, 0.04) 100%)"
    },
    secondary: {
      default: "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0.08) 100%)"
    }
  },
  bg: {
    main: { default: "#FFFFFF", _dark: "#0A131F" },
    modal: {
      default: "rgba(255, 255, 255, 0.40)",
      _dark: "rgba(24, 24, 24, 0.40)"
    },
    border: { default: "#f4f5f8", _dark: "#f4f5f8" },
    module: {
      default: "#eff1f4",
      _dark: "#323741"
    },
    popover: {
      default: "#00013a",
      _dark: "#ffffff"
    },
    interactive: {
      main: { default: "#d7d9e0", _dark: "#494e5a" },
      hover: { default: "#c6c8d2", _dark: "#525967" }
    }
  },
  text: {
    primary: { default: "#00013A", _dark: "#FFFFFF" },
    secondary: {
      default: "#606775",
      _dark: "#9AA1AF"
    },
    white: { default: "#FFFFFF", _dark: "#FFFFFF" },
    white60: {
      default: "rgba(255, 255, 255, 0.60)",
      _dark: "rgba(255, 255, 255, 0.60)"
    },
    black: { default: "#010302", _dark: "#010302" },
    disabled: {
      default: "rgba(0, 0, 0, 0.16)",
      _dark: "rgba(255, 255, 255, 0.72)"
    },
    popover: {
      default: "#FFFFFF",
      _dark: "#00013a"
    }
  },
  misc: {
    red: { default: "#fd4084" },
    yellow: { default: "#ffdb42" },
    green: { default: "#05d7b7" },
    greenGradient: {
      default: "linear-gradient(to bottom, #05d7b7 0%, #a7ffc5)"
    },
    icon: {
      main: {
        default: "#606775",
        _dark: "#9AA1AF"
      },
      hover: {
        default: "#b8bfcd",
        _dark: "#b8bfcd"
      }
    }
  }
}, tFe = {
  Button: {
    baseStyle: {
      fontWeight: "bold",
      textTransform: "none",
      borderRadius: "8px",
      minW: "auto",
      _disabled: {
        pointerEvents: "none",
        cursor: "not-allowed",
        opacity: 0.4,
        _hover: {
          opacity: 0.4
        }
      }
    },
    sizes: {
      xs: {
        paddingX: "8px",
        paddingY: "6px",
        fontSize: "12px",
        lineHeight: "16px",
        minW: "auto"
      },
      sm: {
        paddingX: "24px",
        paddingY: "12px",
        fontSize: "12px",
        lineHeight: "16px",
        minW: "auto"
      },
      md: {
        paddingX: "16px",
        paddingY: "10px",
        fontSize: "14px",
        lineHeight: "20px",
        minW: "auto"
      },
      lg: {
        paddingX: "20px",
        paddingY: "14px",
        fontSize: "18px",
        lineHeight: "24px",
        minW: "auto"
      },
      xl: {
        paddingX: "24px",
        paddingY: "16px",
        fontSize: "12px",
        lineHeight: "16px",
        minW: "auto"
      },
      jumbo: {
        paddingX: "48px",
        paddingY: "16px",
        fontSize: "24px",
        lineHeight: "32px",
        minW: "auto"
      }
    },
    variants: {
      solid: ({ isDisabled: e, colorScheme: t }) => ({
        bg: `${t}.main`,
        color: "text.white",
        boxShadow: "inset 0 -4px 1px 0 rgba(0, 0, 0, 0.16), inset 0 3px 3px 0 rgba(255, 255, 255, 0.12)",
        _hover: e ? {
          bg: "secondary.alpha40",
          cursor: "not-allowed"
        } : {
          bg: `${t}.hover`
        },
        _disabled: {
          cursor: "not-allowed"
        }
      }),
      secondary: ({ isDisabled: e, colorScheme: t }) => ({
        bg: `${t}.alpha16`,
        color: "secondary.alpha40",
        _hover: e ? {} : {
          bg: `${t}.hover`
        },
        _disabled: {
          bg: `${t}.alpha16`
        }
      }),
      outline: ({ isDisabled: e, colorScheme: t }) => ({
        bg: `${t}.alpha72`,
        borderColor: e ? `${t}.alpha16` : "bg.border",
        color: "text.black",
        _hover: e ? {} : {
          bg: `${t}.alpha12`
        },
        _disabled: {
          bg: `${t}.alpha16`
        }
      })
    },
    defaultProps: {
      colorScheme: "primary"
    }
  },
  PinInputField: {
    baseStyle: {
      fontWeight: "bold"
    }
  },
  FormLabel: {
    baseStyle: ({ colorScheme: e }) => ({
      fontWeight: "bold",
      color: `${e}.main`
    })
  },
  Link: {
    baseStyle: ({ colorScheme: e }) => ({
      fontWeight: "bold",
      color: `${e}.main`
    })
  },
  Input: {
    baseStyle: {
      field: {
        width: "100%",
        height: "48px"
      }
    },
    variants: {
      unstyled: ({ colorScheme: e }) => ({
        field: {
          bg: `${e}.alpha8`,
          borderRadius: "0px",
          height: "48px",
          px: 3,
          _placeholder: {
            fontWeight: 600,
            color: `${e}.alpha60`
          }
        }
      })
    }
  }
}, nFe = {
  body: {
    bg: xk.bg.main,
    color: xk.text.primary,
    top: "0px !important"
  }
}, rFe = {
  bodySmall: {
    fontSize: "11px",
    lineHeight: "11px"
  },
  body2: {
    fontSize: "12px",
    lineHeight: "16px"
  },
  body: {
    fontSize: "14px",
    lineHeight: "20px"
  },
  h6: {
    fontSize: "16px",
    lineHeight: "24px"
  },
  h5: {
    fontSize: "18px",
    lineHeight: "24px"
  },
  h4: {
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: "medium"
  },
  h3: {
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: "semibold"
  },
  h2: {
    fontSize: "28px",
    lineHeight: "32px",
    fontWeight: "bold"
  },
  h1: {
    fontSize: "32px",
    lineHeight: "40px",
    fontWeight: "bold"
  }
}, ju = {
  styles: {
    global: nFe
  },
  semanticTokens: {
    colors: xk
  },
  textStyles: rFe,
  components: tFe,
  config: {
    initialColorMode: "light",
    useSystemColorMode: !0,
    cssVarPrefix: "bitbridge"
  }
};
az(ju);
const iFe = (e, t, n) => {
  Object.entries(t[n] || {}).forEach(([r, i]) => {
    if (i && r in e) {
      const s = e[r];
      s && (s[n] = i);
    }
  });
}, sFe = (e) => {
  if (!e)
    return ju;
  const { colors: t, config: n } = e, r = ju.semanticTokens.colors, i = (n == null ? void 0 : n.colorMode) === "dark" ? "_dark" : "main";
  t && iFe(r, t, i);
  const s = {
    ...ju.config,
    ...n,
    initialColorMode: (n == null ? void 0 : n.colorMode) ?? ju.config.initialColorMode,
    useSystemColorMode: (n == null ? void 0 : n.useSystemColorMode) ?? ju.config.useSystemColorMode
  };
  return {
    ...ju,
    semanticTokens: {
      colors: r
    },
    config: s
  };
}, oFe = (e) => {
  const t = sFe(e);
  return az(t);
}, aFe = ({
  theme: e,
  networks: t = [],
  network: n = "devnet",
  tokensListed: r = [],
  networkUrls: i = lMe,
  listsUrls: s = pMe,
  showWidgetModal: o = !1
}) => {
  const a = oFe(e);
  return /* @__PURE__ */ D.jsx(pxe, { theme: a, children: /* @__PURE__ */ D.jsx(
    CMe,
    {
      tokensListed: r,
      network: n,
      listsUrls: s,
      children: /* @__PURE__ */ D.jsx(
        NMe,
        {
          network: n,
          networks: t,
          networkUrls: i,
          children: /* @__PURE__ */ D.jsx(WMe, { children: /* @__PURE__ */ D.jsx(eFe, { showWidgetModal: o }) })
        }
      )
    }
  ) });
}, NFe = ({
  config: e,
  btcOptions: t,
  btcConnectors: n,
  ...r
}) => /* @__PURE__ */ D.jsx(bZ, { options: t, connectors: n, children: /* @__PURE__ */ D.jsx(dne, { config: e, children: /* @__PURE__ */ D.jsx(VMe, { children: /* @__PURE__ */ D.jsx(Iae, { children: /* @__PURE__ */ D.jsx(aFe, { ...r }) }) }) }) });
export {
  ze as B,
  VF as H,
  om as I,
  wc as a,
  tv as b,
  PA as c,
  PX as d,
  MI as e,
  ya as f,
  wF as g,
  NFe as h,
  xc as i,
  aFe as j,
  OFe as k,
  po as s
};
